/* eslint-disable */

var version = (function (exports) {
  'use strict';

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct.bind();
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }
  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }
    return object;
  }
  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get.apply(this, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  /**
   * True if the custom elements polyfill is in use.
   */
  const isCEPolyfill = typeof window !== 'undefined' && window.customElements != null && window.customElements.polyfillWrapFlushCallback !== undefined;
  /**
   * Removes nodes, starting from `start` (inclusive) to `end` (exclusive), from
   * `container`.
   */
  const removeNodes = function (container, start) {
    let end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    while (start !== end) {
      const n = start.nextSibling;
      container.removeChild(start);
      start = n;
    }
  };

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  /**
   * An expression marker with embedded unique key to avoid collision with
   * possible text in templates.
   */
  const marker = `{{lit-${String(Math.random()).slice(2)}}}`;
  /**
   * An expression marker used text-positions, multi-binding attributes, and
   * attributes with markup-like text values.
   */
  const nodeMarker = `<!--${marker}-->`;
  const markerRegex = new RegExp(`${marker}|${nodeMarker}`);
  /**
   * Suffix appended to all bound attribute names.
   */
  const boundAttributeSuffix = '$lit$';
  /**
   * An updatable Template that tracks the location of dynamic parts.
   */
  let Template = /*#__PURE__*/_createClass(function Template(result, element) {
    _classCallCheck(this, Template);
    this.parts = [];
    this.element = element;
    const nodesToRemove = [];
    const stack = [];
    // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
    const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */, null, false);
    // Keeps track of the last index associated with a part. We try to delete
    // unnecessary nodes, but we never want to associate two different parts
    // to the same index. They must have a constant node between.
    let lastPartIndex = 0;
    let index = -1;
    let partIndex = 0;
    const {
      strings,
      values: {
        length
      }
    } = result;
    while (partIndex < length) {
      const node = walker.nextNode();
      if (node === null) {
        // We've exhausted the content inside a nested template element.
        // Because we still have parts (the outer for-loop), we know:
        // - There is a template in the stack
        // - The walker will find a nextNode outside the template
        walker.currentNode = stack.pop();
        continue;
      }
      index++;
      if (node.nodeType === 1 /* Node.ELEMENT_NODE */) {
        if (node.hasAttributes()) {
          const attributes = node.attributes;
          const {
            length
          } = attributes;
          // Per
          // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
          // attributes are not guaranteed to be returned in document order.
          // In particular, Edge/IE can return them out of order, so we cannot
          // assume a correspondence between part index and attribute index.
          let count = 0;
          for (let i = 0; i < length; i++) {
            if (endsWith(attributes[i].name, boundAttributeSuffix)) {
              count++;
            }
          }
          while (count-- > 0) {
            // Get the template literal section leading up to the first
            // expression in this attribute
            const stringForPart = strings[partIndex];
            // Find the attribute name
            const name = lastAttributeNameRegex.exec(stringForPart)[2];
            // Find the corresponding attribute
            // All bound attributes have had a suffix added in
            // TemplateResult#getHTML to opt out of special attribute
            // handling. To look up the attribute value we also need to add
            // the suffix.
            const attributeLookupName = name.toLowerCase() + boundAttributeSuffix;
            const attributeValue = node.getAttribute(attributeLookupName);
            node.removeAttribute(attributeLookupName);
            const statics = attributeValue.split(markerRegex);
            this.parts.push({
              type: 'attribute',
              index,
              name,
              strings: statics
            });
            partIndex += statics.length - 1;
          }
        }
        if (node.tagName === 'TEMPLATE') {
          stack.push(node);
          walker.currentNode = node.content;
        }
      } else if (node.nodeType === 3 /* Node.TEXT_NODE */) {
        const data = node.data;
        if (data.indexOf(marker) >= 0) {
          const parent = node.parentNode;
          const strings = data.split(markerRegex);
          const lastIndex = strings.length - 1;
          // Generate a new text node for each literal section
          // These nodes are also used as the markers for node parts
          for (let i = 0; i < lastIndex; i++) {
            let insert;
            let s = strings[i];
            if (s === '') {
              insert = createMarker();
            } else {
              const match = lastAttributeNameRegex.exec(s);
              if (match !== null && endsWith(match[2], boundAttributeSuffix)) {
                s = s.slice(0, match.index) + match[1] + match[2].slice(0, -boundAttributeSuffix.length) + match[3];
              }
              insert = document.createTextNode(s);
            }
            parent.insertBefore(insert, node);
            this.parts.push({
              type: 'node',
              index: ++index
            });
          }
          // If there's no text, we must insert a comment to mark our place.
          // Else, we can trust it will stick around after cloning.
          if (strings[lastIndex] === '') {
            parent.insertBefore(createMarker(), node);
            nodesToRemove.push(node);
          } else {
            node.data = strings[lastIndex];
          }
          // We have a part for each match found
          partIndex += lastIndex;
        }
      } else if (node.nodeType === 8 /* Node.COMMENT_NODE */) {
        if (node.data === marker) {
          const parent = node.parentNode;
          // Add a new marker node to be the startNode of the Part if any of
          // the following are true:
          //  * We don't have a previousSibling
          //  * The previousSibling is already the start of a previous part
          if (node.previousSibling === null || index === lastPartIndex) {
            index++;
            parent.insertBefore(createMarker(), node);
          }
          lastPartIndex = index;
          this.parts.push({
            type: 'node',
            index
          });
          // If we don't have a nextSibling, keep this node so we have an end.
          // Else, we can remove it to save future costs.
          if (node.nextSibling === null) {
            node.data = '';
          } else {
            nodesToRemove.push(node);
            index--;
          }
          partIndex++;
        } else {
          let i = -1;
          while ((i = node.data.indexOf(marker, i + 1)) !== -1) {
            // Comment node has a binding marker inside, make an inactive part
            // The binding won't work, but subsequent bindings will
            // TODO (justinfagnani): consider whether it's even worth it to
            // make bindings in comments work
            this.parts.push({
              type: 'node',
              index: -1
            });
            partIndex++;
          }
        }
      }
    }
    // Remove text binding nodes after the walk to not disturb the TreeWalker
    for (const n of nodesToRemove) {
      n.parentNode.removeChild(n);
    }
  });
  const endsWith = (str, suffix) => {
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
  };
  const isTemplatePartActive = part => part.index !== -1;
  // Allows `document.createComment('')` to be renamed for a
  // small manual size-savings.
  const createMarker = () => document.createComment('');
  /**
   * This regex extracts the attribute name preceding an attribute-position
   * expression. It does this by matching the syntax allowed for attributes
   * against the string literal directly preceding the expression, assuming that
   * the expression is in an attribute-value position.
   *
   * See attributes in the HTML spec:
   * https://www.w3.org/TR/html5/syntax.html#elements-attributes
   *
   * " \x09\x0a\x0c\x0d" are HTML space characters:
   * https://www.w3.org/TR/html5/infrastructure.html#space-characters
   *
   * "\0-\x1F\x7F-\x9F" are Unicode control characters, which includes every
   * space character except " ".
   *
   * So an attribute is:
   *  * The name: any character except a control character, space character, ('),
   *    ("), ">", "=", or "/"
   *  * Followed by zero or more space characters
   *  * Followed by "="
   *  * Followed by zero or more space characters
   *  * Followed by:
   *    * Any character except space, ('), ("), "<", ">", "=", (`), or
   *    * (") then any non-("), or
   *    * (') then any non-(')
   */
  const lastAttributeNameRegex =
  // eslint-disable-next-line no-control-regex
  /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  const walkerNodeFilter = 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */;
  /**
   * Removes the list of nodes from a Template safely. In addition to removing
   * nodes from the Template, the Template part indices are updated to match
   * the mutated Template DOM.
   *
   * As the template is walked the removal state is tracked and
   * part indices are adjusted as needed.
   *
   * div
   *   div#1 (remove) <-- start removing (removing node is div#1)
   *     div
   *       div#2 (remove)  <-- continue removing (removing node is still div#1)
   *         div
   * div <-- stop removing since previous sibling is the removing node (div#1,
   * removed 4 nodes)
   */
  function removeNodesFromTemplate(template, nodesToRemove) {
    const {
      element: {
        content
      },
      parts
    } = template;
    const walker = document.createTreeWalker(content, walkerNodeFilter, null, false);
    let partIndex = nextActiveIndexInTemplateParts(parts);
    let part = parts[partIndex];
    let nodeIndex = -1;
    let removeCount = 0;
    const nodesToRemoveInTemplate = [];
    let currentRemovingNode = null;
    while (walker.nextNode()) {
      nodeIndex++;
      const node = walker.currentNode;
      // End removal if stepped past the removing node
      if (node.previousSibling === currentRemovingNode) {
        currentRemovingNode = null;
      }
      // A node to remove was found in the template
      if (nodesToRemove.has(node)) {
        nodesToRemoveInTemplate.push(node);
        // Track node we're removing
        if (currentRemovingNode === null) {
          currentRemovingNode = node;
        }
      }
      // When removing, increment count by which to adjust subsequent part indices
      if (currentRemovingNode !== null) {
        removeCount++;
      }
      while (part !== undefined && part.index === nodeIndex) {
        // If part is in a removed node deactivate it by setting index to -1 or
        // adjust the index as needed.
        part.index = currentRemovingNode !== null ? -1 : part.index - removeCount;
        // go to the next active part.
        partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
        part = parts[partIndex];
      }
    }
    nodesToRemoveInTemplate.forEach(n => n.parentNode.removeChild(n));
  }
  const countNodes = node => {
    let count = node.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */ ? 0 : 1;
    const walker = document.createTreeWalker(node, walkerNodeFilter, null, false);
    while (walker.nextNode()) {
      count++;
    }
    return count;
  };
  const nextActiveIndexInTemplateParts = function (parts) {
    let startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    for (let i = startIndex + 1; i < parts.length; i++) {
      const part = parts[i];
      if (isTemplatePartActive(part)) {
        return i;
      }
    }
    return -1;
  };
  /**
   * Inserts the given node into the Template, optionally before the given
   * refNode. In addition to inserting the node into the Template, the Template
   * part indices are updated to match the mutated Template DOM.
   */
  function insertNodeIntoTemplate(template, node) {
    let refNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const {
      element: {
        content
      },
      parts
    } = template;
    // If there's no refNode, then put node at end of template.
    // No part indices need to be shifted in this case.
    if (refNode === null || refNode === undefined) {
      content.appendChild(node);
      return;
    }
    const walker = document.createTreeWalker(content, walkerNodeFilter, null, false);
    let partIndex = nextActiveIndexInTemplateParts(parts);
    let insertCount = 0;
    let walkerIndex = -1;
    while (walker.nextNode()) {
      walkerIndex++;
      const walkerNode = walker.currentNode;
      if (walkerNode === refNode) {
        insertCount = countNodes(node);
        refNode.parentNode.insertBefore(node, refNode);
      }
      while (partIndex !== -1 && parts[partIndex].index === walkerIndex) {
        // If we've inserted the node, simply adjust all subsequent parts
        if (insertCount > 0) {
          while (partIndex !== -1) {
            parts[partIndex].index += insertCount;
            partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
          }
          return;
        }
        partIndex = nextActiveIndexInTemplateParts(parts, partIndex);
      }
    }
  }

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  const directives = new WeakMap();
  /**
   * Brands a function as a directive factory function so that lit-html will call
   * the function during template rendering, rather than passing as a value.
   *
   * A _directive_ is a function that takes a Part as an argument. It has the
   * signature: `(part: Part) => void`.
   *
   * A directive _factory_ is a function that takes arguments for data and
   * configuration and returns a directive. Users of directive usually refer to
   * the directive factory as the directive. For example, "The repeat directive".
   *
   * Usually a template author will invoke a directive factory in their template
   * with relevant arguments, which will then return a directive function.
   *
   * Here's an example of using the `repeat()` directive factory that takes an
   * array and a function to render an item:
   *
   * ```js
   * html`<ul><${repeat(items, (item) => html`<li>${item}</li>`)}</ul>`
   * ```
   *
   * When `repeat` is invoked, it returns a directive function that closes over
   * `items` and the template function. When the outer template is rendered, the
   * return directive function is called with the Part for the expression.
   * `repeat` then performs it's custom logic to render multiple items.
   *
   * @param f The directive factory function. Must be a function that returns a
   * function of the signature `(part: Part) => void`. The returned function will
   * be called with the part object.
   *
   * @example
   *
   * import {directive, html} from 'lit-html';
   *
   * const immutable = directive((v) => (part) => {
   *   if (part.value !== v) {
   *     part.setValue(v)
   *   }
   * });
   */
  const directive = f => function () {
    const d = f.apply(void 0, arguments);
    directives.set(d, true);
    return d;
  };
  const isDirective = o => {
    return typeof o === 'function' && directives.has(o);
  };

  /**
   * @license
   * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  /**
   * A sentinel value that signals that a value was handled by a directive and
   * should not be written to the DOM.
   */
  const noChange = {};
  /**
   * A sentinel value that signals a NodePart to fully clear its content.
   */
  const nothing = {};

  /**
   * An instance of a `Template` that can be attached to the DOM and updated
   * with new values.
   */
  let TemplateInstance = /*#__PURE__*/function () {
    function TemplateInstance(template, processor, options) {
      _classCallCheck(this, TemplateInstance);
      this.__parts = [];
      this.template = template;
      this.processor = processor;
      this.options = options;
    }
    _createClass(TemplateInstance, [{
      key: "update",
      value: function update(values) {
        let i = 0;
        for (const part of this.__parts) {
          if (part !== undefined) {
            part.setValue(values[i]);
          }
          i++;
        }
        for (const part of this.__parts) {
          if (part !== undefined) {
            part.commit();
          }
        }
      }
    }, {
      key: "_clone",
      value: function _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = isCEPolyfill ? this.template.element.content.cloneNode(true) : document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */, null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while (partIndex < parts.length) {
          part = parts[partIndex];
          if (!isTemplatePartActive(part)) {
            this.__parts.push(undefined);
            partIndex++;
            continue;
          }
          // Progress the tree walker until we find our next part's node.
          // Note that multiple parts may share the same node (attribute parts
          // on a single element), so this loop may not run at all.
          while (nodeIndex < part.index) {
            nodeIndex++;
            if (node.nodeName === 'TEMPLATE') {
              stack.push(node);
              walker.currentNode = node.content;
            }
            if ((node = walker.nextNode()) === null) {
              // We've exhausted the content inside a nested template element.
              // Because we still have parts (the outer for-loop), we know:
              // - There is a template in the stack
              // - The walker will find a nextNode outside the template
              walker.currentNode = stack.pop();
              node = walker.nextNode();
            }
          }
          // We've arrived at our part's node.
          if (part.type === 'node') {
            const part = this.processor.handleTextExpression(this.options);
            part.insertAfterNode(node.previousSibling);
            this.__parts.push(part);
          } else {
            var _this$__parts;
            (_this$__parts = this.__parts).push.apply(_this$__parts, _toConsumableArray(this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options)));
          }
          partIndex++;
        }
        if (isCEPolyfill) {
          document.adoptNode(fragment);
          customElements.upgrade(fragment);
        }
        return fragment;
      }
    }]);
    return TemplateInstance;
  }();

  /**
   * Our TrustedTypePolicy for HTML which is declared using the html template
   * tag function.
   *
   * That HTML is a developer-authored constant, and is parsed with innerHTML
   * before any untrusted expressions have been mixed in. Therefor it is
   * considered safe by construction.
   */
  const policy$1 = window.trustedTypes && trustedTypes.createPolicy('lit-html', {
    createHTML: s => s
  });
  const commentMarker = ` ${marker} `;
  /**
   * The return type of `html`, which holds a Template and the values from
   * interpolated expressions.
   */
  let TemplateResult = /*#__PURE__*/function () {
    function TemplateResult(strings, values, type, processor) {
      _classCallCheck(this, TemplateResult);
      this.strings = strings;
      this.values = values;
      this.type = type;
      this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */
    _createClass(TemplateResult, [{
      key: "getHTML",
      value: function getHTML() {
        const l = this.strings.length - 1;
        let html = '';
        let isCommentBinding = false;
        for (let i = 0; i < l; i++) {
          const s = this.strings[i];
          // For each binding we want to determine the kind of marker to insert
          // into the template source before it's parsed by the browser's HTML
          // parser. The marker type is based on whether the expression is in an
          // attribute, text, or comment position.
          //   * For node-position bindings we insert a comment with the marker
          //     sentinel as its text content, like <!--{{lit-guid}}-->.
          //   * For attribute bindings we insert just the marker sentinel for the
          //     first binding, so that we support unquoted attribute bindings.
          //     Subsequent bindings can use a comment marker because multi-binding
          //     attributes must be quoted.
          //   * For comment bindings we insert just the marker sentinel so we don't
          //     close the comment.
          //
          // The following code scans the template source, but is *not* an HTML
          // parser. We don't need to track the tree structure of the HTML, only
          // whether a binding is inside a comment, and if not, if it appears to be
          // the first binding in an attribute.
          const commentOpen = s.lastIndexOf('<!--');
          // We're in comment position if we have a comment open with no following
          // comment close. Because <-- can appear in an attribute value there can
          // be false positives.
          isCommentBinding = (commentOpen > -1 || isCommentBinding) && s.indexOf('-->', commentOpen + 1) === -1;
          // Check to see if we have an attribute-like sequence preceding the
          // expression. This can match "name=value" like structures in text,
          // comments, and attribute values, so there can be false-positives.
          const attributeMatch = lastAttributeNameRegex.exec(s);
          if (attributeMatch === null) {
            // We're only in this branch if we don't have a attribute-like
            // preceding sequence. For comments, this guards against unusual
            // attribute values like <div foo="<!--${'bar'}">. Cases like
            // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
            // below.
            html += s + (isCommentBinding ? commentMarker : nodeMarker);
          } else {
            // For attributes we use just a marker sentinel, and also append a
            // $lit$ suffix to the name to opt-out of attribute-specific parsing
            // that IE and Edge do for style and certain SVG attributes.
            html += s.substr(0, attributeMatch.index) + attributeMatch[1] + attributeMatch[2] + boundAttributeSuffix + attributeMatch[3] + marker;
          }
        }
        html += this.strings[l];
        return html;
      }
    }, {
      key: "getTemplateElement",
      value: function getTemplateElement() {
        const template = document.createElement('template');
        let value = this.getHTML();
        if (policy$1 !== undefined) {
          // this is secure because `this.strings` is a TemplateStringsArray.
          // TODO: validate this when
          // https://github.com/tc39/proposal-array-is-template-object is
          // implemented.
          value = policy$1.createHTML(value);
        }
        template.innerHTML = value;
        return template;
      }
    }]);
    return TemplateResult;
  }();

  const isPrimitive = value => {
    return value === null || !(typeof value === 'object' || typeof value === 'function');
  };
  const isIterable = value => {
    return Array.isArray(value) ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(value && value[Symbol.iterator]);
  };
  /**
   * Writes attribute values to the DOM for a group of AttributeParts bound to a
   * single attribute. The value is only set once even if there are multiple parts
   * for an attribute.
   */
  let AttributeCommitter = /*#__PURE__*/function () {
    function AttributeCommitter(element, name, strings) {
      _classCallCheck(this, AttributeCommitter);
      this.dirty = true;
      this.element = element;
      this.name = name;
      this.strings = strings;
      this.parts = [];
      for (let i = 0; i < strings.length - 1; i++) {
        this.parts[i] = this._createPart();
      }
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */
    _createClass(AttributeCommitter, [{
      key: "_createPart",
      value: function _createPart() {
        return new AttributePart(this);
      }
    }, {
      key: "_getValue",
      value: function _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === '' && strings[1] === '') {
          const v = parts[0].value;
          if (typeof v === 'symbol') {
            return String(v);
          }
          if (typeof v === 'string' || !isIterable(v)) {
            return v;
          }
        }
        let text = '';
        for (let i = 0; i < l; i++) {
          text += strings[i];
          const part = parts[i];
          if (part !== undefined) {
            const v = part.value;
            if (isPrimitive(v) || !isIterable(v)) {
              text += typeof v === 'string' ? v : String(v);
            } else {
              for (const t of v) {
                text += typeof t === 'string' ? t : String(t);
              }
            }
          }
        }
        text += strings[l];
        return text;
      }
    }, {
      key: "commit",
      value: function commit() {
        if (this.dirty) {
          this.dirty = false;
          this.element.setAttribute(this.name, this._getValue());
        }
      }
    }]);
    return AttributeCommitter;
  }();
  /**
   * A Part that controls all or part of an attribute value.
   */
  let AttributePart = /*#__PURE__*/function () {
    function AttributePart(committer) {
      _classCallCheck(this, AttributePart);
      this.value = undefined;
      this.committer = committer;
    }
    _createClass(AttributePart, [{
      key: "setValue",
      value: function setValue(value) {
        if (value !== noChange && (!isPrimitive(value) || value !== this.value)) {
          this.value = value;
          // If the value is a not a directive, dirty the committer so that it'll
          // call setAttribute. If the value is a directive, it'll dirty the
          // committer if it calls setValue().
          if (!isDirective(value)) {
            this.committer.dirty = true;
          }
        }
      }
    }, {
      key: "commit",
      value: function commit() {
        while (isDirective(this.value)) {
          const directive = this.value;
          this.value = noChange;
          directive(this);
        }
        if (this.value === noChange) {
          return;
        }
        this.committer.commit();
      }
    }]);
    return AttributePart;
  }();
  /**
   * A Part that controls a location within a Node tree. Like a Range, NodePart
   * has start and end locations and can set and update the Nodes between those
   * locations.
   *
   * NodeParts support several value types: primitives, Nodes, TemplateResults,
   * as well as arrays and iterables of those types.
   */
  let NodePart = /*#__PURE__*/function () {
    function NodePart(options) {
      _classCallCheck(this, NodePart);
      this.value = undefined;
      this.__pendingValue = undefined;
      this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */
    _createClass(NodePart, [{
      key: "appendInto",
      value: function appendInto(container) {
        this.startNode = container.appendChild(createMarker());
        this.endNode = container.appendChild(createMarker());
      }
      /**
       * Inserts this part after the `ref` node (between `ref` and `ref`'s next
       * sibling). Both `ref` and its next sibling must be static, unchanging nodes
       * such as those that appear in a literal section of a template.
       *
       * This part must be empty, as its contents are not automatically moved.
       */
    }, {
      key: "insertAfterNode",
      value: function insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
      }
      /**
       * Appends this part into a parent part.
       *
       * This part must be empty, as its contents are not automatically moved.
       */
    }, {
      key: "appendIntoPart",
      value: function appendIntoPart(part) {
        part.__insert(this.startNode = createMarker());
        part.__insert(this.endNode = createMarker());
      }
      /**
       * Inserts this part after the `ref` part.
       *
       * This part must be empty, as its contents are not automatically moved.
       */
    }, {
      key: "insertAfterPart",
      value: function insertAfterPart(ref) {
        ref.__insert(this.startNode = createMarker());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
      }
    }, {
      key: "setValue",
      value: function setValue(value) {
        this.__pendingValue = value;
      }
    }, {
      key: "commit",
      value: function commit() {
        if (this.startNode.parentNode === null) {
          return;
        }
        while (isDirective(this.__pendingValue)) {
          const directive = this.__pendingValue;
          this.__pendingValue = noChange;
          directive(this);
        }
        const value = this.__pendingValue;
        if (value === noChange) {
          return;
        }
        if (isPrimitive(value)) {
          if (value !== this.value) {
            this.__commitText(value);
          }
        } else if (value instanceof TemplateResult) {
          this.__commitTemplateResult(value);
        } else if (value instanceof Node) {
          this.__commitNode(value);
        } else if (isIterable(value)) {
          this.__commitIterable(value);
        } else if (value === nothing) {
          this.value = nothing;
          this.clear();
        } else {
          // Fallback, will render the string representation
          this.__commitText(value);
        }
      }
    }, {
      key: "__insert",
      value: function __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
      }
    }, {
      key: "__commitNode",
      value: function __commitNode(value) {
        if (this.value === value) {
          return;
        }
        this.clear();
        this.__insert(value);
        this.value = value;
      }
    }, {
      key: "__commitText",
      value: function __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? '' : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === 'string' ? value : String(value);
        if (node === this.endNode.previousSibling && node.nodeType === 3 /* Node.TEXT_NODE */) {
          // If we only have a single text node between the markers, we can just
          // set its value, rather than replacing it.
          // TODO(justinfagnani): Can we just check if this.value is primitive?
          node.data = valueAsString;
        } else {
          this.__commitNode(document.createTextNode(valueAsString));
        }
        this.value = value;
      }
    }, {
      key: "__commitTemplateResult",
      value: function __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof TemplateInstance && this.value.template === template) {
          this.value.update(value.values);
        } else {
          // Make sure we propagate the template processor from the TemplateResult
          // so that we use its syntax extension, etc. The template factory comes
          // from the render function options so that it can control template
          // caching and preprocessing.
          const instance = new TemplateInstance(template, value.processor, this.options);
          const fragment = instance._clone();
          instance.update(value.values);
          this.__commitNode(fragment);
          this.value = instance;
        }
      }
    }, {
      key: "__commitIterable",
      value: function __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
          this.value = [];
          this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value) {
          // Try to reuse an existing part
          itemPart = itemParts[partIndex];
          // If no existing part, create a new one
          if (itemPart === undefined) {
            itemPart = new NodePart(this.options);
            itemParts.push(itemPart);
            if (partIndex === 0) {
              itemPart.appendIntoPart(this);
            } else {
              itemPart.insertAfterPart(itemParts[partIndex - 1]);
            }
          }
          itemPart.setValue(item);
          itemPart.commit();
          partIndex++;
        }
        if (partIndex < itemParts.length) {
          // Truncate the parts array so _value reflects the current state
          itemParts.length = partIndex;
          this.clear(itemPart && itemPart.endNode);
        }
      }
    }, {
      key: "clear",
      value: function clear() {
        let startNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startNode;
        removeNodes(this.startNode.parentNode, startNode.nextSibling, this.endNode);
      }
    }]);
    return NodePart;
  }();
  /**
   * Implements a boolean attribute, roughly as defined in the HTML
   * specification.
   *
   * If the value is truthy, then the attribute is present with a value of
   * ''. If the value is falsey, the attribute is removed.
   */
  let BooleanAttributePart = /*#__PURE__*/function () {
    function BooleanAttributePart(element, name, strings) {
      _classCallCheck(this, BooleanAttributePart);
      this.value = undefined;
      this.__pendingValue = undefined;
      if (strings.length !== 2 || strings[0] !== '' || strings[1] !== '') {
        throw new Error('Boolean attributes can only contain a single expression');
      }
      this.element = element;
      this.name = name;
      this.strings = strings;
    }
    _createClass(BooleanAttributePart, [{
      key: "setValue",
      value: function setValue(value) {
        this.__pendingValue = value;
      }
    }, {
      key: "commit",
      value: function commit() {
        while (isDirective(this.__pendingValue)) {
          const directive = this.__pendingValue;
          this.__pendingValue = noChange;
          directive(this);
        }
        if (this.__pendingValue === noChange) {
          return;
        }
        const value = !!this.__pendingValue;
        if (this.value !== value) {
          if (value) {
            this.element.setAttribute(this.name, '');
          } else {
            this.element.removeAttribute(this.name);
          }
          this.value = value;
        }
        this.__pendingValue = noChange;
      }
    }]);
    return BooleanAttributePart;
  }();
  /**
   * Sets attribute values for PropertyParts, so that the value is only set once
   * even if there are multiple parts for a property.
   *
   * If an expression controls the whole property value, then the value is simply
   * assigned to the property under control. If there are string literals or
   * multiple expressions, then the strings are expressions are interpolated into
   * a string first.
   */
  let PropertyCommitter = /*#__PURE__*/function (_AttributeCommitter) {
    _inherits(PropertyCommitter, _AttributeCommitter);
    var _super = _createSuper(PropertyCommitter);
    function PropertyCommitter(element, name, strings) {
      var _this;
      _classCallCheck(this, PropertyCommitter);
      _this = _super.call(this, element, name, strings);
      _this.single = strings.length === 2 && strings[0] === '' && strings[1] === '';
      return _this;
    }
    _createClass(PropertyCommitter, [{
      key: "_createPart",
      value: function _createPart() {
        return new PropertyPart(this);
      }
    }, {
      key: "_getValue",
      value: function _getValue() {
        if (this.single) {
          return this.parts[0].value;
        }
        return _get(_getPrototypeOf(PropertyCommitter.prototype), "_getValue", this).call(this);
      }
    }, {
      key: "commit",
      value: function commit() {
        if (this.dirty) {
          this.dirty = false;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.element[this.name] = this._getValue();
        }
      }
    }]);
    return PropertyCommitter;
  }(AttributeCommitter);
  let PropertyPart = /*#__PURE__*/function (_AttributePart) {
    _inherits(PropertyPart, _AttributePart);
    var _super2 = _createSuper(PropertyPart);
    function PropertyPart() {
      _classCallCheck(this, PropertyPart);
      return _super2.apply(this, arguments);
    }
    return _createClass(PropertyPart);
  }(AttributePart);
  // Detect event listener options support. If the `capture` property is read
  // from the options object, then options are supported. If not, then the third
  // argument to add/removeEventListener is interpreted as the boolean capture
  // value so we should only pass the `capture` property.
  let eventOptionsSupported = false;
  // Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
  // blocks right into the body of a module
  (() => {
    try {
      const options = {
        get capture() {
          eventOptionsSupported = true;
          return false;
        }
      };
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.addEventListener('test', options, options);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.removeEventListener('test', options, options);
    } catch (_e) {
      // event options not supported
    }
  })();
  let EventPart = /*#__PURE__*/function () {
    function EventPart(element, eventName, eventContext) {
      _classCallCheck(this, EventPart);
      this.value = undefined;
      this.__pendingValue = undefined;
      this.element = element;
      this.eventName = eventName;
      this.eventContext = eventContext;
      this.__boundHandleEvent = e => this.handleEvent(e);
    }
    _createClass(EventPart, [{
      key: "setValue",
      value: function setValue(value) {
        this.__pendingValue = value;
      }
    }, {
      key: "commit",
      value: function commit() {
        while (isDirective(this.__pendingValue)) {
          const directive = this.__pendingValue;
          this.__pendingValue = noChange;
          directive(this);
        }
        if (this.__pendingValue === noChange) {
          return;
        }
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null || oldListener != null && (newListener.capture !== oldListener.capture || newListener.once !== oldListener.once || newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) {
          this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        if (shouldAddListener) {
          this.__options = getOptions(newListener);
          this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = noChange;
      }
    }, {
      key: "handleEvent",
      value: function handleEvent(event) {
        if (typeof this.value === 'function') {
          this.value.call(this.eventContext || this.element, event);
        } else {
          this.value.handleEvent(event);
        }
      }
    }]);
    return EventPart;
  }();
  // We copy options because of the inconsistent behavior of browsers when reading
  // the third argument of add/removeEventListener. IE11 doesn't support options
  // at all. Chrome 41 only reads `capture` if the argument is an object.
  const getOptions = o => o && (eventOptionsSupported ? {
    capture: o.capture,
    passive: o.passive,
    once: o.once
  } : o.capture);

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  /**
   * The default TemplateFactory which caches Templates keyed on
   * result.type and result.strings.
   */
  function templateFactory(result) {
    let templateCache = templateCaches.get(result.type);
    if (templateCache === undefined) {
      templateCache = {
        stringsArray: new WeakMap(),
        keyString: new Map()
      };
      templateCaches.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
      return template;
    }
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join(marker);
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
      // If we have not seen this key before, create a new Template
      template = new Template(result, result.getTemplateElement());
      // Cache the Template for this key
      templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
  }
  const templateCaches = new Map();

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  const parts = new WeakMap();
  /**
   * Renders a template result or other value to a container.
   *
   * To update a container with new values, reevaluate the template literal and
   * call `render` with the new result.
   *
   * @param result Any value renderable by NodePart - typically a TemplateResult
   *     created by evaluating a template tag like `html` or `svg`.
   * @param container A DOM parent to render to. The entire contents are either
   *     replaced, or efficiently updated if the same result type was previous
   *     rendered there.
   * @param options RenderOptions for the entire render tree rendered to this
   *     container. Render options must *not* change between renders to the same
   *     container, as those changes will not effect previously rendered DOM.
   */
  const render$1 = (result, container, options) => {
    let part = parts.get(container);
    if (part === undefined) {
      removeNodes(container, container.firstChild);
      parts.set(container, part = new NodePart(Object.assign({
        templateFactory
      }, options)));
      part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
  };

  /**
   * Creates Parts when a template is instantiated.
   */
  let DefaultTemplateProcessor = /*#__PURE__*/function () {
    function DefaultTemplateProcessor() {
      _classCallCheck(this, DefaultTemplateProcessor);
    }
    _createClass(DefaultTemplateProcessor, [{
      key: "handleAttributeExpressions",
      value:
      /**
       * Create parts for an attribute-position binding, given the event, attribute
       * name, and string literals.
       *
       * @param element The element containing the binding
       * @param name  The attribute name
       * @param strings The string literals. There are always at least two strings,
       *   event for fully-controlled bindings with a single expression.
       */
      function handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === '.') {
          const committer = new PropertyCommitter(element, name.slice(1), strings);
          return committer.parts;
        }
        if (prefix === '@') {
          return [new EventPart(element, name.slice(1), options.eventContext)];
        }
        if (prefix === '?') {
          return [new BooleanAttributePart(element, name.slice(1), strings)];
        }
        const committer = new AttributeCommitter(element, name, strings);
        return committer.parts;
      }
      /**
       * Create parts for a text-position binding.
       * @param templateFactory
       */
    }, {
      key: "handleTextExpression",
      value: function handleTextExpression(options) {
        return new NodePart(options);
      }
    }]);
    return DefaultTemplateProcessor;
  }();
  const defaultTemplateProcessor = new DefaultTemplateProcessor();

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  // IMPORTANT: do not change the property name or the assignment expression.
  // This line will be used in regexes to search for lit-html usage.
  // TODO(justinfagnani): inject version number at build time
  if (typeof window !== 'undefined') {
    (window['litHtmlVersions'] || (window['litHtmlVersions'] = [])).push('1.4.1');
  }
  /**
   * Interprets a template literal as an HTML template that can efficiently
   * render to and update a container.
   */
  const html$1 = function (strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    return new TemplateResult(strings, values, 'html', defaultTemplateProcessor);
  };

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  // Get a key to lookup in `templateCaches`.
  const getTemplateCacheKey = (type, scopeName) => `${type}--${scopeName}`;
  let compatibleShadyCSSVersion = true;
  if (typeof window.ShadyCSS === 'undefined') {
    compatibleShadyCSSVersion = false;
  } else if (typeof window.ShadyCSS.prepareTemplateDom === 'undefined') {
    console.warn(`Incompatible ShadyCSS version detected. ` + `Please update to at least @webcomponents/webcomponentsjs@2.0.2 and ` + `@webcomponents/shadycss@1.3.1.`);
    compatibleShadyCSSVersion = false;
  }
  /**
   * Template factory which scopes template DOM using ShadyCSS.
   * @param scopeName {string}
   */
  const shadyTemplateFactory = scopeName => result => {
    const cacheKey = getTemplateCacheKey(result.type, scopeName);
    let templateCache = templateCaches.get(cacheKey);
    if (templateCache === undefined) {
      templateCache = {
        stringsArray: new WeakMap(),
        keyString: new Map()
      };
      templateCaches.set(cacheKey, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) {
      return template;
    }
    const key = result.strings.join(marker);
    template = templateCache.keyString.get(key);
    if (template === undefined) {
      const element = result.getTemplateElement();
      if (compatibleShadyCSSVersion) {
        window.ShadyCSS.prepareTemplateDom(element, scopeName);
      }
      template = new Template(result, element);
      templateCache.keyString.set(key, template);
    }
    templateCache.stringsArray.set(result.strings, template);
    return template;
  };
  const TEMPLATE_TYPES = ['html', 'svg'];
  /**
   * Removes all style elements from Templates for the given scopeName.
   */
  const removeStylesFromLitTemplates = scopeName => {
    TEMPLATE_TYPES.forEach(type => {
      const templates = templateCaches.get(getTemplateCacheKey(type, scopeName));
      if (templates !== undefined) {
        templates.keyString.forEach(template => {
          const {
            element: {
              content
            }
          } = template;
          // IE 11 doesn't support the iterable param Set constructor
          const styles = new Set();
          Array.from(content.querySelectorAll('style')).forEach(s => {
            styles.add(s);
          });
          removeNodesFromTemplate(template, styles);
        });
      }
    });
  };
  const shadyRenderSet = new Set();
  /**
   * For the given scope name, ensures that ShadyCSS style scoping is performed.
   * This is done just once per scope name so the fragment and template cannot
   * be modified.
   * (1) extracts styles from the rendered fragment and hands them to ShadyCSS
   * to be scoped and appended to the document
   * (2) removes style elements from all lit-html Templates for this scope name.
   *
   * Note, <style> elements can only be placed into templates for the
   * initial rendering of the scope. If <style> elements are included in templates
   * dynamically rendered to the scope (after the first scope render), they will
   * not be scoped and the <style> will be left in the template and rendered
   * output.
   */
  const prepareTemplateStyles = (scopeName, renderedDOM, template) => {
    shadyRenderSet.add(scopeName);
    // If `renderedDOM` is stamped from a Template, then we need to edit that
    // Template's underlying template element. Otherwise, we create one here
    // to give to ShadyCSS, which still requires one while scoping.
    const templateElement = !!template ? template.element : document.createElement('template');
    // Move styles out of rendered DOM and store.
    const styles = renderedDOM.querySelectorAll('style');
    const {
      length
    } = styles;
    // If there are no styles, skip unnecessary work
    if (length === 0) {
      // Ensure prepareTemplateStyles is called to support adding
      // styles via `prepareAdoptedCssText` since that requires that
      // `prepareTemplateStyles` is called.
      //
      // ShadyCSS will only update styles containing @apply in the template
      // given to `prepareTemplateStyles`. If no lit Template was given,
      // ShadyCSS will not be able to update uses of @apply in any relevant
      // template. However, this is not a problem because we only create the
      // template for the purpose of supporting `prepareAdoptedCssText`,
      // which doesn't support @apply at all.
      window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
      return;
    }
    const condensedStyle = document.createElement('style');
    // Collect styles into a single style. This helps us make sure ShadyCSS
    // manipulations will not prevent us from being able to fix up template
    // part indices.
    // NOTE: collecting styles is inefficient for browsers but ShadyCSS
    // currently does this anyway. When it does not, this should be changed.
    for (let i = 0; i < length; i++) {
      const style = styles[i];
      style.parentNode.removeChild(style);
      condensedStyle.textContent += style.textContent;
    }
    // Remove styles from nested templates in this scope.
    removeStylesFromLitTemplates(scopeName);
    // And then put the condensed style into the "root" template passed in as
    // `template`.
    const content = templateElement.content;
    if (!!template) {
      insertNodeIntoTemplate(template, condensedStyle, content.firstChild);
    } else {
      content.insertBefore(condensedStyle, content.firstChild);
    }
    // Note, it's important that ShadyCSS gets the template that `lit-html`
    // will actually render so that it can update the style inside when
    // needed (e.g. @apply native Shadow DOM case).
    window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
    const style = content.querySelector('style');
    if (window.ShadyCSS.nativeShadow && style !== null) {
      // When in native Shadow DOM, ensure the style created by ShadyCSS is
      // included in initially rendered output (`renderedDOM`).
      renderedDOM.insertBefore(style.cloneNode(true), renderedDOM.firstChild);
    } else if (!!template) {
      // When no style is left in the template, parts will be broken as a
      // result. To fix this, we put back the style node ShadyCSS removed
      // and then tell lit to remove that node from the template.
      // There can be no style in the template in 2 cases (1) when Shady DOM
      // is in use, ShadyCSS removes all styles, (2) when native Shadow DOM
      // is in use ShadyCSS removes the style if it contains no content.
      // NOTE, ShadyCSS creates its own style so we can safely add/remove
      // `condensedStyle` here.
      content.insertBefore(condensedStyle, content.firstChild);
      const removes = new Set();
      removes.add(condensedStyle);
      removeNodesFromTemplate(template, removes);
    }
  };
  /**
   * Extension to the standard `render` method which supports rendering
   * to ShadowRoots when the ShadyDOM (https://github.com/webcomponents/shadydom)
   * and ShadyCSS (https://github.com/webcomponents/shadycss) polyfills are used
   * or when the webcomponentsjs
   * (https://github.com/webcomponents/webcomponentsjs) polyfill is used.
   *
   * Adds a `scopeName` option which is used to scope element DOM and stylesheets
   * when native ShadowDOM is unavailable. The `scopeName` will be added to
   * the class attribute of all rendered DOM. In addition, any style elements will
   * be automatically re-written with this `scopeName` selector and moved out
   * of the rendered DOM and into the document `<head>`.
   *
   * It is common to use this render method in conjunction with a custom element
   * which renders a shadowRoot. When this is done, typically the element's
   * `localName` should be used as the `scopeName`.
   *
   * In addition to DOM scoping, ShadyCSS also supports a basic shim for css
   * custom properties (needed only on older browsers like IE11) and a shim for
   * a deprecated feature called `@apply` that supports applying a set of css
   * custom properties to a given location.
   *
   * Usage considerations:
   *
   * * Part values in `<style>` elements are only applied the first time a given
   * `scopeName` renders. Subsequent changes to parts in style elements will have
   * no effect. Because of this, parts in style elements should only be used for
   * values that will never change, for example parts that set scope-wide theme
   * values or parts which render shared style elements.
   *
   * * Note, due to a limitation of the ShadyDOM polyfill, rendering in a
   * custom element's `constructor` is not supported. Instead rendering should
   * either done asynchronously, for example at microtask timing (for example
   * `Promise.resolve()`), or be deferred until the first time the element's
   * `connectedCallback` runs.
   *
   * Usage considerations when using shimmed custom properties or `@apply`:
   *
   * * Whenever any dynamic changes are made which affect
   * css custom properties, `ShadyCSS.styleElement(element)` must be called
   * to update the element. There are two cases when this is needed:
   * (1) the element is connected to a new parent, (2) a class is added to the
   * element that causes it to match different custom properties.
   * To address the first case when rendering a custom element, `styleElement`
   * should be called in the element's `connectedCallback`.
   *
   * * Shimmed custom properties may only be defined either for an entire
   * shadowRoot (for example, in a `:host` rule) or via a rule that directly
   * matches an element with a shadowRoot. In other words, instead of flowing from
   * parent to child as do native css custom properties, shimmed custom properties
   * flow only from shadowRoots to nested shadowRoots.
   *
   * * When using `@apply` mixing css shorthand property names with
   * non-shorthand names (for example `border` and `border-width`) is not
   * supported.
   */
  const render = (result, container, options) => {
    if (!options || typeof options !== 'object' || !options.scopeName) {
      throw new Error('The `scopeName` option is required.');
    }
    const scopeName = options.scopeName;
    const hasRendered = parts.has(container);
    const needsScoping = compatibleShadyCSSVersion && container.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */ && !!container.host;
    // Handle first render to a scope specially...
    const firstScopeRender = needsScoping && !shadyRenderSet.has(scopeName);
    // On first scope render, render into a fragment; this cannot be a single
    // fragment that is reused since nested renders can occur synchronously.
    const renderContainer = firstScopeRender ? document.createDocumentFragment() : container;
    render$1(result, renderContainer, Object.assign({
      templateFactory: shadyTemplateFactory(scopeName)
    }, options));
    // When performing first scope render,
    // (1) We've rendered into a fragment so that there's a chance to
    // `prepareTemplateStyles` before sub-elements hit the DOM
    // (which might cause them to render based on a common pattern of
    // rendering in a custom element's `connectedCallback`);
    // (2) Scope the template with ShadyCSS one time only for this scope.
    // (3) Render the fragment into the container and make sure the
    // container knows its `part` is the one we just rendered. This ensures
    // DOM will be re-used on subsequent renders.
    if (firstScopeRender) {
      const part = parts.get(renderContainer);
      parts.delete(renderContainer);
      // ShadyCSS might have style sheets (e.g. from `prepareAdoptedCssText`)
      // that should apply to `renderContainer` even if the rendered value is
      // not a TemplateInstance. However, it will only insert scoped styles
      // into the document if `prepareTemplateStyles` has already been called
      // for the given scope name.
      const template = part.value instanceof TemplateInstance ? part.value.template : undefined;
      prepareTemplateStyles(scopeName, renderContainer, template);
      removeNodes(container, container.firstChild);
      container.appendChild(renderContainer);
      parts.set(container, part);
    }
    // After elements have hit the DOM, update styling if this is the
    // initial render to this container.
    // This is needed whenever dynamic changes are made so it would be
    // safest to do every render; however, this would regress performance
    // so we leave it up to the user to call `ShadyCSS.styleElement`
    // for dynamic changes.
    if (!hasRendered && needsScoping) {
      window.ShadyCSS.styleElement(container.host);
    }
  };

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  var _a;
  /**
   * Use this module if you want to create your own base class extending
   * [[UpdatingElement]].
   * @packageDocumentation
   */
  /*
   * When using Closure Compiler, JSCompiler_renameProperty(property, object) is
   * replaced at compile time by the munged name for object[property]. We cannot
   * alias this function, so we have to use a small shim that has the same
   * behavior when not compiling.
   */
  window.JSCompiler_renameProperty = (prop, _obj) => prop;
  const defaultConverter = {
    toAttribute(value, type) {
      switch (type) {
        case Boolean:
          return value ? '' : null;
        case Object:
        case Array:
          // if the value is `null` or `undefined` pass this through
          // to allow removing/no change behavior.
          return value == null ? value : JSON.stringify(value);
      }
      return value;
    },
    fromAttribute(value, type) {
      switch (type) {
        case Boolean:
          return value !== null;
        case Number:
          return value === null ? null : Number(value);
        case Object:
        case Array:
          // Type assert to adhere to Bazel's "must type assert JSON parse" rule.
          return JSON.parse(value);
      }
      return value;
    }
  };
  /**
   * Change function that returns true if `value` is different from `oldValue`.
   * This method is used as the default for a property's `hasChanged` function.
   */
  const notEqual = (value, old) => {
    // This ensures (old==NaN, value==NaN) always returns false
    return old !== value && (old === old || value === value);
  };
  const defaultPropertyDeclaration = {
    attribute: true,
    type: String,
    converter: defaultConverter,
    reflect: false,
    hasChanged: notEqual
  };
  const STATE_HAS_UPDATED = 1;
  const STATE_UPDATE_REQUESTED = 1 << 2;
  const STATE_IS_REFLECTING_TO_ATTRIBUTE = 1 << 3;
  const STATE_IS_REFLECTING_TO_PROPERTY = 1 << 4;
  /**
   * The Closure JS Compiler doesn't currently have good support for static
   * property semantics where "this" is dynamic (e.g.
   * https://github.com/google/closure-compiler/issues/3177 and others) so we use
   * this hack to bypass any rewriting by the compiler.
   */
  const finalized = 'finalized';
  /**
   * Base element class which manages element properties and attributes. When
   * properties change, the `update` method is asynchronously called. This method
   * should be supplied by subclassers to render updates as desired.
   * @noInheritDoc
   */
  let UpdatingElement = /*#__PURE__*/function (_HTMLElement) {
    _inherits(UpdatingElement, _HTMLElement);
    var _super = _createSuper(UpdatingElement);
    function UpdatingElement() {
      var _this;
      _classCallCheck(this, UpdatingElement);
      _this = _super.call(this);
      _this.initialize();
      return _this;
    }
    /**
     * Returns a list of attributes corresponding to the registered properties.
     * @nocollapse
     */
    _createClass(UpdatingElement, [{
      key: "initialize",
      value:
      /**
       * Performs element initialization. By default captures any pre-set values for
       * registered properties.
       */
      function initialize() {
        this._updateState = 0;
        this._updatePromise = new Promise(res => this._enableUpdatingResolver = res);
        this._changedProperties = new Map();
        this._saveInstanceProperties();
        // ensures first update will be caught by an early access of
        // `updateComplete`
        this.requestUpdateInternal();
      }
      /**
       * Fixes any properties set on the instance before upgrade time.
       * Otherwise these would shadow the accessor and break these properties.
       * The properties are stored in a Map which is played back after the
       * constructor runs. Note, on very old versions of Safari (<=9) or Chrome
       * (<=41), properties created for native platform properties like (`id` or
       * `name`) may not have default values set in the element constructor. On
       * these browsers native properties appear on instances and therefore their
       * default value will overwrite any element default (e.g. if the element sets
       * this.id = 'id' in the constructor, the 'id' will become '' since this is
       * the native platform default).
       */
    }, {
      key: "_saveInstanceProperties",
      value: function _saveInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this.constructor._classProperties.forEach((_v, p) => {
          if (this.hasOwnProperty(p)) {
            const value = this[p];
            delete this[p];
            if (!this._instanceProperties) {
              this._instanceProperties = new Map();
            }
            this._instanceProperties.set(p, value);
          }
        });
      }
      /**
       * Applies previously saved instance properties.
       */
    }, {
      key: "_applyInstanceProperties",
      value: function _applyInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        // tslint:disable-next-line:no-any
        this._instanceProperties.forEach((v, p) => this[p] = v);
        this._instanceProperties = undefined;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        // Ensure first connection completes an update. Updates cannot complete
        // before connection.
        this.enableUpdating();
      }
    }, {
      key: "enableUpdating",
      value: function enableUpdating() {
        if (this._enableUpdatingResolver !== undefined) {
          this._enableUpdatingResolver();
          this._enableUpdatingResolver = undefined;
        }
      }
      /**
       * Allows for `super.disconnectedCallback()` in extensions while
       * reserving the possibility of making non-breaking feature additions
       * when disconnecting at some point in the future.
       */
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {}
      /**
       * Synchronizes property values when attributes change.
       */
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, old, value) {
        if (old !== value) {
          this._attributeToProperty(name, value);
        }
      }
    }, {
      key: "_propertyToAttribute",
      value: function _propertyToAttribute(name, value) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPropertyDeclaration;
        const ctor = this.constructor;
        const attr = ctor._attributeNameForProperty(name, options);
        if (attr !== undefined) {
          const attrValue = ctor._propertyValueToAttribute(value, options);
          // an undefined value does not change the attribute.
          if (attrValue === undefined) {
            return;
          }
          // Track if the property is being reflected to avoid
          // setting the property again via `attributeChangedCallback`. Note:
          // 1. this takes advantage of the fact that the callback is synchronous.
          // 2. will behave incorrectly if multiple attributes are in the reaction
          // stack at time of calling. However, since we process attributes
          // in `update` this should not be possible (or an extreme corner case
          // that we'd like to discover).
          // mark state reflecting
          this._updateState = this._updateState | STATE_IS_REFLECTING_TO_ATTRIBUTE;
          if (attrValue == null) {
            this.removeAttribute(attr);
          } else {
            this.setAttribute(attr, attrValue);
          }
          // mark state not reflecting
          this._updateState = this._updateState & ~STATE_IS_REFLECTING_TO_ATTRIBUTE;
        }
      }
    }, {
      key: "_attributeToProperty",
      value: function _attributeToProperty(name, value) {
        // Use tracking info to avoid deserializing attribute value if it was
        // just set from a property setter.
        if (this._updateState & STATE_IS_REFLECTING_TO_ATTRIBUTE) {
          return;
        }
        const ctor = this.constructor;
        // Note, hint this as an `AttributeMap` so closure clearly understands
        // the type; it has issues with tracking types through statics
        // tslint:disable-next-line:no-unnecessary-type-assertion
        const propName = ctor._attributeToPropertyMap.get(name);
        if (propName !== undefined) {
          const options = ctor.getPropertyOptions(propName);
          // mark state reflecting
          this._updateState = this._updateState | STATE_IS_REFLECTING_TO_PROPERTY;
          this[propName] =
          // tslint:disable-next-line:no-any
          ctor._propertyValueFromAttribute(value, options);
          // mark state not reflecting
          this._updateState = this._updateState & ~STATE_IS_REFLECTING_TO_PROPERTY;
        }
      }
      /**
       * This protected version of `requestUpdate` does not access or return the
       * `updateComplete` promise. This promise can be overridden and is therefore
       * not free to access.
       */
    }, {
      key: "requestUpdateInternal",
      value: function requestUpdateInternal(name, oldValue, options) {
        let shouldRequestUpdate = true;
        // If we have a property key, perform property update steps.
        if (name !== undefined) {
          const ctor = this.constructor;
          options = options || ctor.getPropertyOptions(name);
          if (ctor._valueHasChanged(this[name], oldValue, options.hasChanged)) {
            if (!this._changedProperties.has(name)) {
              this._changedProperties.set(name, oldValue);
            }
            // Add to reflecting properties set.
            // Note, it's important that every change has a chance to add the
            // property to `_reflectingProperties`. This ensures setting
            // attribute + property reflects correctly.
            if (options.reflect === true && !(this._updateState & STATE_IS_REFLECTING_TO_PROPERTY)) {
              if (this._reflectingProperties === undefined) {
                this._reflectingProperties = new Map();
              }
              this._reflectingProperties.set(name, options);
            }
          } else {
            // Abort the request if the property should not be considered changed.
            shouldRequestUpdate = false;
          }
        }
        if (!this._hasRequestedUpdate && shouldRequestUpdate) {
          this._updatePromise = this._enqueueUpdate();
        }
      }
      /**
       * Requests an update which is processed asynchronously. This should
       * be called when an element should update based on some state not triggered
       * by setting a property. In this case, pass no arguments. It should also be
       * called when manually implementing a property setter. In this case, pass the
       * property `name` and `oldValue` to ensure that any configured property
       * options are honored. Returns the `updateComplete` Promise which is resolved
       * when the update completes.
       *
       * @param name {PropertyKey} (optional) name of requesting property
       * @param oldValue {any} (optional) old value of requesting property
       * @returns {Promise} A Promise that is resolved when the update completes.
       */
    }, {
      key: "requestUpdate",
      value: function requestUpdate(name, oldValue) {
        this.requestUpdateInternal(name, oldValue);
        return this.updateComplete;
      }
      /**
       * Sets up the element to asynchronously update.
       */
    }, {
      key: "_enqueueUpdate",
      value: async function _enqueueUpdate() {
        this._updateState = this._updateState | STATE_UPDATE_REQUESTED;
        try {
          // Ensure any previous update has resolved before updating.
          // This `await` also ensures that property changes are batched.
          await this._updatePromise;
        } catch (e) {
          // Ignore any previous errors. We only care that the previous cycle is
          // done. Any error should have been handled in the previous update.
        }
        const result = this.performUpdate();
        // If `performUpdate` returns a Promise, we await it. This is done to
        // enable coordinating updates with a scheduler. Note, the result is
        // checked to avoid delaying an additional microtask unless we need to.
        if (result != null) {
          await result;
        }
        return !this._hasRequestedUpdate;
      }
    }, {
      key: "_hasRequestedUpdate",
      get: function () {
        return this._updateState & STATE_UPDATE_REQUESTED;
      }
    }, {
      key: "hasUpdated",
      get: function () {
        return this._updateState & STATE_HAS_UPDATED;
      }
      /**
       * Performs an element update. Note, if an exception is thrown during the
       * update, `firstUpdated` and `updated` will not be called.
       *
       * You can override this method to change the timing of updates. If this
       * method is overridden, `super.performUpdate()` must be called.
       *
       * For instance, to schedule updates to occur just before the next frame:
       *
       * ```
       * protected async performUpdate(): Promise<unknown> {
       *   await new Promise((resolve) => requestAnimationFrame(() => resolve()));
       *   super.performUpdate();
       * }
       * ```
       */
    }, {
      key: "performUpdate",
      value: function performUpdate() {
        // Abort any update if one is not pending when this is called.
        // This can happen if `performUpdate` is called early to "flush"
        // the update.
        if (!this._hasRequestedUpdate) {
          return;
        }
        // Mixin instance properties once, if they exist.
        if (this._instanceProperties) {
          this._applyInstanceProperties();
        }
        let shouldUpdate = false;
        const changedProperties = this._changedProperties;
        try {
          shouldUpdate = this.shouldUpdate(changedProperties);
          if (shouldUpdate) {
            this.update(changedProperties);
          } else {
            this._markUpdated();
          }
        } catch (e) {
          // Prevent `firstUpdated` and `updated` from running when there's an
          // update exception.
          shouldUpdate = false;
          // Ensure element can accept additional updates after an exception.
          this._markUpdated();
          throw e;
        }
        if (shouldUpdate) {
          if (!(this._updateState & STATE_HAS_UPDATED)) {
            this._updateState = this._updateState | STATE_HAS_UPDATED;
            this.firstUpdated(changedProperties);
          }
          this.updated(changedProperties);
        }
      }
    }, {
      key: "_markUpdated",
      value: function _markUpdated() {
        this._changedProperties = new Map();
        this._updateState = this._updateState & ~STATE_UPDATE_REQUESTED;
      }
      /**
       * Returns a Promise that resolves when the element has completed updating.
       * The Promise value is a boolean that is `true` if the element completed the
       * update without triggering another update. The Promise result is `false` if
       * a property was set inside `updated()`. If the Promise is rejected, an
       * exception was thrown during the update.
       *
       * To await additional asynchronous work, override the `_getUpdateComplete`
       * method. For example, it is sometimes useful to await a rendered element
       * before fulfilling this Promise. To do this, first await
       * `super._getUpdateComplete()`, then any subsequent state.
       *
       * @returns {Promise} The Promise returns a boolean that indicates if the
       * update resolved without triggering another update.
       */
    }, {
      key: "updateComplete",
      get: function () {
        return this._getUpdateComplete();
      }
      /**
       * Override point for the `updateComplete` promise.
       *
       * It is not safe to override the `updateComplete` getter directly due to a
       * limitation in TypeScript which means it is not possible to call a
       * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
       * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
       * This method should be overridden instead. For example:
       *
       *   class MyElement extends LitElement {
       *     async _getUpdateComplete() {
       *       await super._getUpdateComplete();
       *       await this._myChild.updateComplete;
       *     }
       *   }
       * @deprecated Override `getUpdateComplete()` instead for forward
       *     compatibility with `lit-element` 3.0 / `@lit/reactive-element`.
       */
    }, {
      key: "_getUpdateComplete",
      value: function _getUpdateComplete() {
        return this.getUpdateComplete();
      }
      /**
       * Override point for the `updateComplete` promise.
       *
       * It is not safe to override the `updateComplete` getter directly due to a
       * limitation in TypeScript which means it is not possible to call a
       * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
       * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
       * This method should be overridden instead. For example:
       *
       *   class MyElement extends LitElement {
       *     async getUpdateComplete() {
       *       await super.getUpdateComplete();
       *       await this._myChild.updateComplete;
       *     }
       *   }
       */
    }, {
      key: "getUpdateComplete",
      value: function getUpdateComplete() {
        return this._updatePromise;
      }
      /**
       * Controls whether or not `update` should be called when the element requests
       * an update. By default, this method always returns `true`, but this can be
       * customized to control when to update.
       *
       * @param _changedProperties Map of changed properties with old values
       */
    }, {
      key: "shouldUpdate",
      value: function shouldUpdate(_changedProperties) {
        return true;
      }
      /**
       * Updates the element. This method reflects property values to attributes.
       * It can be overridden to render and keep updated element DOM.
       * Setting properties inside this method will *not* trigger
       * another update.
       *
       * @param _changedProperties Map of changed properties with old values
       */
    }, {
      key: "update",
      value: function update(_changedProperties) {
        if (this._reflectingProperties !== undefined && this._reflectingProperties.size > 0) {
          // Use forEach so this works even if for/of loops are compiled to for
          // loops expecting arrays
          this._reflectingProperties.forEach((v, k) => this._propertyToAttribute(k, this[k], v));
          this._reflectingProperties = undefined;
        }
        this._markUpdated();
      }
      /**
       * Invoked whenever the element is updated. Implement to perform
       * post-updating tasks via DOM APIs, for example, focusing an element.
       *
       * Setting properties inside this method will trigger the element to update
       * again after this update cycle completes.
       *
       * @param _changedProperties Map of changed properties with old values
       */
    }, {
      key: "updated",
      value: function updated(_changedProperties) {}
      /**
       * Invoked when the element is first updated. Implement to perform one time
       * work on the element after update.
       *
       * Setting properties inside this method will trigger the element to update
       * again after this update cycle completes.
       *
       * @param _changedProperties Map of changed properties with old values
       */
    }, {
      key: "firstUpdated",
      value: function firstUpdated(_changedProperties) {}
    }], [{
      key: "observedAttributes",
      get: function () {
        // note: piggy backing on this to ensure we're finalized.
        this.finalize();
        const attributes = [];
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this._classProperties.forEach((v, p) => {
          const attr = this._attributeNameForProperty(p, v);
          if (attr !== undefined) {
            this._attributeToPropertyMap.set(attr, p);
            attributes.push(attr);
          }
        });
        return attributes;
      }
      /**
       * Ensures the private `_classProperties` property metadata is created.
       * In addition to `finalize` this is also called in `createProperty` to
       * ensure the `@property` decorator can add property metadata.
       */
      /** @nocollapse */
    }, {
      key: "_ensureClassProperties",
      value: function _ensureClassProperties() {
        // ensure private storage for property declarations.
        if (!this.hasOwnProperty(JSCompiler_renameProperty('_classProperties', this))) {
          this._classProperties = new Map();
          // NOTE: Workaround IE11 not supporting Map constructor argument.
          const superProperties = Object.getPrototypeOf(this)._classProperties;
          if (superProperties !== undefined) {
            superProperties.forEach((v, k) => this._classProperties.set(k, v));
          }
        }
      }
      /**
       * Creates a property accessor on the element prototype if one does not exist
       * and stores a PropertyDeclaration for the property with the given options.
       * The property setter calls the property's `hasChanged` property option
       * or uses a strict identity check to determine whether or not to request
       * an update.
       *
       * This method may be overridden to customize properties; however,
       * when doing so, it's important to call `super.createProperty` to ensure
       * the property is setup correctly. This method calls
       * `getPropertyDescriptor` internally to get a descriptor to install.
       * To customize what properties do when they are get or set, override
       * `getPropertyDescriptor`. To customize the options for a property,
       * implement `createProperty` like this:
       *
       * static createProperty(name, options) {
       *   options = Object.assign(options, {myOption: true});
       *   super.createProperty(name, options);
       * }
       *
       * @nocollapse
       */
    }, {
      key: "createProperty",
      value: function createProperty(name) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultPropertyDeclaration;
        // Note, since this can be called by the `@property` decorator which
        // is called before `finalize`, we ensure storage exists for property
        // metadata.
        this._ensureClassProperties();
        this._classProperties.set(name, options);
        // Do not generate an accessor if the prototype already has one, since
        // it would be lost otherwise and that would never be the user's intention;
        // Instead, we expect users to call `requestUpdate` themselves from
        // user-defined accessors. Note that if the super has an accessor we will
        // still overwrite it
        if (options.noAccessor || this.prototype.hasOwnProperty(name)) {
          return;
        }
        const key = typeof name === 'symbol' ? Symbol() : `__${name}`;
        const descriptor = this.getPropertyDescriptor(name, key, options);
        if (descriptor !== undefined) {
          Object.defineProperty(this.prototype, name, descriptor);
        }
      }
      /**
       * Returns a property descriptor to be defined on the given named property.
       * If no descriptor is returned, the property will not become an accessor.
       * For example,
       *
       *   class MyElement extends LitElement {
       *     static getPropertyDescriptor(name, key, options) {
       *       const defaultDescriptor =
       *           super.getPropertyDescriptor(name, key, options);
       *       const setter = defaultDescriptor.set;
       *       return {
       *         get: defaultDescriptor.get,
       *         set(value) {
       *           setter.call(this, value);
       *           // custom action.
       *         },
       *         configurable: true,
       *         enumerable: true
       *       }
       *     }
       *   }
       *
       * @nocollapse
       */
    }, {
      key: "getPropertyDescriptor",
      value: function getPropertyDescriptor(name, key, options) {
        return {
          // tslint:disable-next-line:no-any no symbol in index
          get() {
            return this[key];
          },
          set(value) {
            const oldValue = this[name];
            this[key] = value;
            this.requestUpdateInternal(name, oldValue, options);
          },
          configurable: true,
          enumerable: true
        };
      }
      /**
       * Returns the property options associated with the given property.
       * These options are defined with a PropertyDeclaration via the `properties`
       * object or the `@property` decorator and are registered in
       * `createProperty(...)`.
       *
       * Note, this method should be considered "final" and not overridden. To
       * customize the options for a given property, override `createProperty`.
       *
       * @nocollapse
       * @final
       */
    }, {
      key: "getPropertyOptions",
      value: function getPropertyOptions(name) {
        return this._classProperties && this._classProperties.get(name) || defaultPropertyDeclaration;
      }
      /**
       * Creates property accessors for registered properties and ensures
       * any superclasses are also finalized.
       * @nocollapse
       */
    }, {
      key: "finalize",
      value: function finalize() {
        // finalize any superclasses
        const superCtor = Object.getPrototypeOf(this);
        if (!superCtor.hasOwnProperty(finalized)) {
          superCtor.finalize();
        }
        this[finalized] = true;
        this._ensureClassProperties();
        // initialize Map populated in observedAttributes
        this._attributeToPropertyMap = new Map();
        // make any properties
        // Note, only process "own" properties since this element will inherit
        // any properties defined on the superClass, and finalization ensures
        // the entire prototype chain is finalized.
        if (this.hasOwnProperty(JSCompiler_renameProperty('properties', this))) {
          const props = this.properties;
          // support symbols in properties (IE11 does not support this)
          const propKeys = [].concat(_toConsumableArray(Object.getOwnPropertyNames(props)), _toConsumableArray(typeof Object.getOwnPropertySymbols === 'function' ? Object.getOwnPropertySymbols(props) : []));
          // This for/of is ok because propKeys is an array
          for (const p of propKeys) {
            // note, use of `any` is due to TypeSript lack of support for symbol in
            // index types
            // tslint:disable-next-line:no-any no symbol in index
            this.createProperty(p, props[p]);
          }
        }
      }
      /**
       * Returns the property name for the given attribute `name`.
       * @nocollapse
       */
    }, {
      key: "_attributeNameForProperty",
      value: function _attributeNameForProperty(name, options) {
        const attribute = options.attribute;
        return attribute === false ? undefined : typeof attribute === 'string' ? attribute : typeof name === 'string' ? name.toLowerCase() : undefined;
      }
      /**
       * Returns true if a property should request an update.
       * Called when a property value is set and uses the `hasChanged`
       * option for the property if present or a strict identity check.
       * @nocollapse
       */
    }, {
      key: "_valueHasChanged",
      value: function _valueHasChanged(value, old) {
        let hasChanged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : notEqual;
        return hasChanged(value, old);
      }
      /**
       * Returns the property value for the given attribute value.
       * Called via the `attributeChangedCallback` and uses the property's
       * `converter` or `converter.fromAttribute` property option.
       * @nocollapse
       */
    }, {
      key: "_propertyValueFromAttribute",
      value: function _propertyValueFromAttribute(value, options) {
        const type = options.type;
        const converter = options.converter || defaultConverter;
        const fromAttribute = typeof converter === 'function' ? converter : converter.fromAttribute;
        return fromAttribute ? fromAttribute(value, type) : value;
      }
      /**
       * Returns the attribute value for the given property value. If this
       * returns undefined, the property will *not* be reflected to an attribute.
       * If this returns null, the attribute will be removed, otherwise the
       * attribute will be set to the value.
       * This uses the property's `reflect` and `type.toAttribute` property options.
       * @nocollapse
       */
    }, {
      key: "_propertyValueToAttribute",
      value: function _propertyValueToAttribute(value, options) {
        if (options.reflect === undefined) {
          return;
        }
        const type = options.type;
        const converter = options.converter;
        const toAttribute = converter && converter.toAttribute || defaultConverter.toAttribute;
        return toAttribute(value, type);
      }
    }]);
    return UpdatingElement;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  _a = finalized;
  /**
   * Marks class as having finished creating properties.
   */
  UpdatingElement[_a] = true;

  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  const standardProperty = (options, element) => {
    // When decorating an accessor, pass it through and add property metadata.
    // Note, the `hasOwnProperty` check in `createProperty` ensures we don't
    // stomp over the user's accessor.
    if (element.kind === 'method' && element.descriptor && !('value' in element.descriptor)) {
      return Object.assign(Object.assign({}, element), {
        finisher(clazz) {
          clazz.createProperty(element.key, options);
        }
      });
    } else {
      // createProperty() takes care of defining the property, but we still
      // must return some kind of descriptor, so return a descriptor for an
      // unused prototype field. The finisher calls createProperty().
      return {
        kind: 'field',
        key: Symbol(),
        placement: 'own',
        descriptor: {},
        // When @babel/plugin-proposal-decorators implements initializers,
        // do this instead of the initializer below. See:
        // https://github.com/babel/babel/issues/9260 extras: [
        //   {
        //     kind: 'initializer',
        //     placement: 'own',
        //     initializer: descriptor.initializer,
        //   }
        // ],
        initializer() {
          if (typeof element.initializer === 'function') {
            this[element.key] = element.initializer.call(this);
          }
        },
        finisher(clazz) {
          clazz.createProperty(element.key, options);
        }
      };
    }
  };
  const legacyProperty = (options, proto, name) => {
    proto.constructor.createProperty(name, options);
  };
  /**
   * A property decorator which creates a LitElement property which reflects a
   * corresponding attribute value. A [[`PropertyDeclaration`]] may optionally be
   * supplied to configure property features.
   *
   * This decorator should only be used for public fields. Private or protected
   * fields should use the [[`internalProperty`]] decorator.
   *
   * @example
   * ```ts
   * class MyElement {
   *   @property({ type: Boolean })
   *   clicked = false;
   * }
   * ```
   * @category Decorator
   * @ExportDecoratedItems
   */
  function property(options) {
    // tslint:disable-next-line:no-any decorator
    return (protoOrDescriptor, name) => name !== undefined ? legacyProperty(options, protoOrDescriptor, name) : standardProperty(options, protoOrDescriptor);
  }
  /**
   * A property decorator that converts a class property into a getter that
   * executes a querySelector on the element's renderRoot.
   *
   * @param selector A DOMString containing one or more selectors to match.
   * @param cache An optional boolean which when true performs the DOM query only
   * once and caches the result.
   *
   * See: https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
   *
   * @example
   *
   * ```ts
   * class MyElement {
   *   @query('#first')
   *   first;
   *
   *   render() {
   *     return html`
   *       <div id="first"></div>
   *       <div id="second"></div>
   *     `;
   *   }
   * }
   * ```
   * @category Decorator
   */
  function query(selector, cache) {
    return (protoOrDescriptor,
    // tslint:disable-next-line:no-any decorator
    name) => {
      const descriptor = {
        get() {
          return this.renderRoot.querySelector(selector);
        },
        enumerable: true,
        configurable: true
      };
      if (cache) {
        const prop = name !== undefined ? name : protoOrDescriptor.key;
        const key = typeof prop === 'symbol' ? Symbol() : `__${prop}`;
        descriptor.get = function () {
          if (this[key] === undefined) {
            this[key] = this.renderRoot.querySelector(selector);
          }
          return this[key];
        };
      }
      return name !== undefined ? legacyQuery(descriptor, protoOrDescriptor, name) : standardQuery(descriptor, protoOrDescriptor);
    };
  }
  const legacyQuery = (descriptor, proto, name) => {
    Object.defineProperty(proto, name, descriptor);
  };
  const standardQuery = (descriptor, element) => ({
    kind: 'method',
    placement: 'prototype',
    key: element.key,
    descriptor
  });

  /**
  @license
  Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  /**
   * Whether the current browser supports `adoptedStyleSheets`.
   */
  const supportsAdoptingStyleSheets$1 = window.ShadowRoot && (window.ShadyCSS === undefined || window.ShadyCSS.nativeShadow) && 'adoptedStyleSheets' in Document.prototype && 'replace' in CSSStyleSheet.prototype;
  const constructionToken = Symbol();
  let CSSResult = /*#__PURE__*/function () {
    function CSSResult(cssText, safeToken) {
      _classCallCheck(this, CSSResult);
      if (safeToken !== constructionToken) {
        throw new Error('CSSResult is not constructable. Use `unsafeCSS` or `css` instead.');
      }
      this.cssText = cssText;
    }
    // Note, this is a getter so that it's lazy. In practice, this means
    // stylesheets are not created until the first element instance is made.
    _createClass(CSSResult, [{
      key: "styleSheet",
      get: function () {
        if (this._styleSheet === undefined) {
          // Note, if `supportsAdoptingStyleSheets` is true then we assume
          // CSSStyleSheet is constructable.
          if (supportsAdoptingStyleSheets$1) {
            this._styleSheet = new CSSStyleSheet();
            this._styleSheet.replaceSync(this.cssText);
          } else {
            this._styleSheet = null;
          }
        }
        return this._styleSheet;
      }
    }, {
      key: "toString",
      value: function toString() {
        return this.cssText;
      }
    }]);
    return CSSResult;
  }();
  /**
   * Wrap a value for interpolation in a [[`css`]] tagged template literal.
   *
   * This is unsafe because untrusted CSS text can be used to phone home
   * or exfiltrate data to an attacker controlled site. Take care to only use
   * this with trusted input.
   */
  const unsafeCSS = value => {
    return new CSSResult(String(value), constructionToken);
  };
  const textFromCSSResult = value => {
    if (value instanceof CSSResult) {
      return value.cssText;
    } else if (typeof value === 'number') {
      return value;
    } else {
      throw new Error(`Value passed to 'css' function must be a 'css' function result: ${value}. Use 'unsafeCSS' to pass non-literal values, but
            take care to ensure page security.`);
    }
  };
  /**
   * Template tag which which can be used with LitElement's [[LitElement.styles |
   * `styles`]] property to set element styles. For security reasons, only literal
   * string values may be used. To incorporate non-literal values [[`unsafeCSS`]]
   * may be used inside a template string part.
   */
  const css$1 = function (strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    const cssText = values.reduce((acc, v, idx) => acc + textFromCSSResult(v) + strings[idx + 1], strings[0]);
    return new CSSResult(cssText, constructionToken);
  };

  // IMPORTANT: do not change the property name or the assignment expression.
  // This line will be used in regexes to search for LitElement usage.
  // TODO(justinfagnani): inject version number at build time
  (window['litElementVersions'] || (window['litElementVersions'] = [])).push('2.5.1');
  /**
   * Sentinal value used to avoid calling lit-html's render function when
   * subclasses do not implement `render`
   */
  const renderNotImplemented = {};
  /**
   * Base element class that manages element properties and attributes, and
   * renders a lit-html template.
   *
   * To define a component, subclass `LitElement` and implement a
   * `render` method to provide the component's template. Define properties
   * using the [[`properties`]] property or the [[`property`]] decorator.
   */
  let LitElement = /*#__PURE__*/function (_UpdatingElement) {
    _inherits(LitElement, _UpdatingElement);
    var _super = _createSuper(LitElement);
    function LitElement() {
      _classCallCheck(this, LitElement);
      return _super.apply(this, arguments);
    }
    _createClass(LitElement, [{
      key: "initialize",
      value:
      /**
       * Performs element initialization. By default this calls
       * [[`createRenderRoot`]] to create the element [[`renderRoot`]] node and
       * captures any pre-set values for registered properties.
       */
      function initialize() {
        _get(_getPrototypeOf(LitElement.prototype), "initialize", this).call(this);
        this.constructor._getUniqueStyles();
        this.renderRoot = this.createRenderRoot();
        // Note, if renderRoot is not a shadowRoot, styles would/could apply to the
        // element's getRootNode(). While this could be done, we're choosing not to
        // support this now since it would require different logic around de-duping.
        if (window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot) {
          this.adoptStyles();
        }
      }
      /**
       * Returns the node into which the element should render and by default
       * creates and returns an open shadowRoot. Implement to customize where the
       * element's DOM is rendered. For example, to render into the element's
       * childNodes, return `this`.
       * @returns {Element|DocumentFragment} Returns a node into which to render.
       */
    }, {
      key: "createRenderRoot",
      value: function createRenderRoot() {
        return this.attachShadow(this.constructor.shadowRootOptions);
      }
      /**
       * Applies styling to the element shadowRoot using the [[`styles`]]
       * property. Styling will apply using `shadowRoot.adoptedStyleSheets` where
       * available and will fallback otherwise. When Shadow DOM is polyfilled,
       * ShadyCSS scopes styles and adds them to the document. When Shadow DOM
       * is available but `adoptedStyleSheets` is not, styles are appended to the
       * end of the `shadowRoot` to [mimic spec
       * behavior](https://wicg.github.io/construct-stylesheets/#using-constructed-stylesheets).
       */
    }, {
      key: "adoptStyles",
      value: function adoptStyles() {
        const styles = this.constructor._styles;
        if (styles.length === 0) {
          return;
        }
        // There are three separate cases here based on Shadow DOM support.
        // (1) shadowRoot polyfilled: use ShadyCSS
        // (2) shadowRoot.adoptedStyleSheets available: use it
        // (3) shadowRoot.adoptedStyleSheets polyfilled: append styles after
        // rendering
        if (window.ShadyCSS !== undefined && !window.ShadyCSS.nativeShadow) {
          window.ShadyCSS.ScopingShim.prepareAdoptedCssText(styles.map(s => s.cssText), this.localName);
        } else if (supportsAdoptingStyleSheets$1) {
          this.renderRoot.adoptedStyleSheets = styles.map(s => s instanceof CSSStyleSheet ? s : s.styleSheet);
        } else {
          // This must be done after rendering so the actual style insertion is done
          // in `update`.
          this._needsShimAdoptedStyleSheets = true;
        }
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(LitElement.prototype), "connectedCallback", this).call(this);
        // Note, first update/render handles styleElement so we only call this if
        // connected after first update.
        if (this.hasUpdated && window.ShadyCSS !== undefined) {
          window.ShadyCSS.styleElement(this);
        }
      }
      /**
       * Updates the element. This method reflects property values to attributes
       * and calls `render` to render DOM via lit-html. Setting properties inside
       * this method will *not* trigger another update.
       * @param _changedProperties Map of changed properties with old values
       */
    }, {
      key: "update",
      value: function update(changedProperties) {
        // Setting properties in `render` should not trigger an update. Since
        // updates are allowed after super.update, it's important to call `render`
        // before that.
        const templateResult = this.render();
        _get(_getPrototypeOf(LitElement.prototype), "update", this).call(this, changedProperties);
        // If render is not implemented by the component, don't call lit-html render
        if (templateResult !== renderNotImplemented) {
          this.constructor.render(templateResult, this.renderRoot, {
            scopeName: this.localName,
            eventContext: this
          });
        }
        // When native Shadow DOM is used but adoptedStyles are not supported,
        // insert styling after rendering to ensure adoptedStyles have highest
        // priority.
        if (this._needsShimAdoptedStyleSheets) {
          this._needsShimAdoptedStyleSheets = false;
          this.constructor._styles.forEach(s => {
            const style = document.createElement('style');
            style.textContent = s.cssText;
            this.renderRoot.appendChild(style);
          });
        }
      }
      /**
       * Invoked on each update to perform rendering tasks. This method may return
       * any value renderable by lit-html's `NodePart` - typically a
       * `TemplateResult`. Setting properties inside this method will *not* trigger
       * the element to update.
       */
    }, {
      key: "render",
      value: function render() {
        return renderNotImplemented;
      }
    }], [{
      key: "getStyles",
      value:
      /**
       * Return the array of styles to apply to the element.
       * Override this method to integrate into a style management system.
       *
       * @nocollapse
       */
      function getStyles() {
        return this.styles;
      }
      /** @nocollapse */
    }, {
      key: "_getUniqueStyles",
      value: function _getUniqueStyles() {
        // Only gather styles once per class
        if (this.hasOwnProperty(JSCompiler_renameProperty('_styles', this))) {
          return;
        }
        // Take care not to call `this.getStyles()` multiple times since this
        // generates new CSSResults each time.
        // TODO(sorvell): Since we do not cache CSSResults by input, any
        // shared styles will generate new stylesheet objects, which is wasteful.
        // This should be addressed when a browser ships constructable
        // stylesheets.
        const userStyles = this.getStyles();
        if (Array.isArray(userStyles)) {
          // De-duplicate styles preserving the _last_ instance in the set.
          // This is a performance optimization to avoid duplicated styles that can
          // occur especially when composing via subclassing.
          // The last item is kept to try to preserve the cascade order with the
          // assumption that it's most important that last added styles override
          // previous styles.
          const addStyles = (styles, set) => styles.reduceRight((set, s) =>
          // Note: On IE set.add() does not return the set
          Array.isArray(s) ? addStyles(s, set) : (set.add(s), set), set);
          // Array.from does not work on Set in IE, otherwise return
          // Array.from(addStyles(userStyles, new Set<CSSResult>())).reverse()
          const set = addStyles(userStyles, new Set());
          const styles = [];
          set.forEach(v => styles.unshift(v));
          this._styles = styles;
        } else {
          this._styles = userStyles === undefined ? [] : [userStyles];
        }
        // Ensure that there are no invalid CSSStyleSheet instances here. They are
        // invalid in two conditions.
        // (1) the sheet is non-constructible (`sheet` of a HTMLStyleElement), but
        //     this is impossible to check except via .replaceSync or use
        // (2) the ShadyCSS polyfill is enabled (:. supportsAdoptingStyleSheets is
        //     false)
        this._styles = this._styles.map(s => {
          if (s instanceof CSSStyleSheet && !supportsAdoptingStyleSheets$1) {
            // Flatten the cssText from the passed constructible stylesheet (or
            // undetectable non-constructible stylesheet). The user might have
            // expected to update their stylesheets over time, but the alternative
            // is a crash.
            const cssText = Array.prototype.slice.call(s.cssRules).reduce((css, rule) => css + rule.cssText, '');
            return unsafeCSS(cssText);
          }
          return s;
        });
      }
    }]);
    return LitElement;
  }(UpdatingElement);
  /**
   * Ensure this class is marked as `finalized` as an optimization ensuring
   * it will not needlessly try to `finalize`.
   *
   * Note this property name is a string to prevent breaking Closure JS Compiler
   * optimizations. See updating-element.ts for more information.
   */
  LitElement['finalized'] = true;
  /**
   * Reference to the underlying library method used to render the element's
   * DOM. By default, points to the `render` method from lit-html's shady-render
   * module.
   *
   * **Most users will never need to touch this property.**
   *
   * This  property should not be confused with the `render` instance method,
   * which should be overridden to define a template for the element.
   *
   * Advanced users creating a new base class based on LitElement can override
   * this property to point to a custom render method with a signature that
   * matches [shady-render's `render`
   * method](https://lit-html.polymer-project.org/api/modules/shady_render.html#render).
   *
   * @nocollapse
   */
  LitElement.render = render;
  /** @nocollapse */
  LitElement.shadowRootOptions = {
    mode: 'open'
  };

  const MIN_COL_WIDTH = 100;
  let TableCellBase = /*#__PURE__*/function (_LitElement) {
    _inherits(TableCellBase, _LitElement);
    var _super = _createSuper(TableCellBase);
    function TableCellBase() {
      var _this;
      _classCallCheck(this, TableCellBase);
      _this = _super.call(this);
      _this.width = MIN_COL_WIDTH;
      _this.resizable = false;
      _this.onResizeStart = () => {};
      _this.onResize = () => {};
      _this.onResizeComplete = () => {};
      return _this;
    }

    //TODO: start event listener to track mouse movement
    _createClass(TableCellBase, [{
      key: "handleMouseDown",
      value: function handleMouseDown(e) {
        this.startingX = e.clientX;
        this.mouseMoveListener = this.handleMouseMove.bind(this);
        this.mouseUpListener = this.handleMouseUp.bind(this);
        document.addEventListener('mousemove', this.mouseMoveListener);
        document.addEventListener('mouseup', this.mouseUpListener);
        this.onResizeStart();
      }

      //TODO: replace with document mouse move event listener
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        // this.currentX = e.clientX
        const deltaX = e.clientX - this.startingX;
        this.onResize(deltaX);
      }

      //clean up event listener
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp(e) {
        const deltaX = e.clientX - this.startingX;
        document.removeEventListener('mousemove', this.mouseMoveListener);
        document.removeEventListener('mouseup', this.mouseUpListener);
        this.onResizeComplete(deltaX);
      }
    }, {
      key: "render",
      value: function render() {
        return html$1`
      <div class="table-cell-base">
        <div class="content">
          <slot></slot>
        </div>
        ${this.resizable ? html$1`<div
              class="resize-handle"
              @mousedown="${this.handleMouseDown}"
            ></div>` : ''}
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          resizable: Boolean,
          width: Number,
          onResizeStart: Function,
          onResize: Function,
          onResizeComplete: Function
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [css$1`
        :host {
          flex: 1;
          min-width: 0;
          display: flex;
        }
        .table-cell-base {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: stretch;
          position: relative;
          min-width: 0;
        }
        .content {
          flex: 1;
          min-width: 0;
        }
        .resize-handle{
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          width: 8px;
          transform: translateX(50%);
          cursor: col-resize;
          z-index: 2;
        }
      `];
      }
    }]);
    return TableCellBase;
  }(LitElement);
  customElements.define('table-cell-base', TableCellBase);

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  const nativeShadow = !(window['ShadyDOM'] && window['ShadyDOM']['inUse']);
  let nativeCssVariables_;

  /**
   * @param {(ShadyCSSOptions | ShadyCSSInterface)=} settings
   */
  function calcCssVariables(settings) {
    if (settings && settings['shimcssproperties']) {
      nativeCssVariables_ = false;
    } else {
      // chrome 49 has semi-working css vars, check if box-shadow works
      // safari 9.1 has a recalc bug: https://bugs.webkit.org/show_bug.cgi?id=155782
      // However, shim css custom properties are only supported with ShadyDOM enabled,
      // so fall back on native if we do not detect ShadyDOM
      // Edge 15: custom properties used in ::before and ::after will also be used in the parent element
      // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12414257/
      nativeCssVariables_ = nativeShadow || Boolean(!navigator.userAgent.match(/AppleWebKit\/601|Edge\/15/) && window.CSS && CSS.supports && CSS.supports('box-shadow', '0 0 0 var(--foo)'));
    }
  }

  /** @type {string | undefined} */
  let cssBuild;
  if (window.ShadyCSS && window.ShadyCSS.cssBuild !== undefined) {
    cssBuild = window.ShadyCSS.cssBuild;
  }

  /** @type {boolean} */
  const disableRuntime = Boolean(window.ShadyCSS && window.ShadyCSS.disableRuntime);
  if (window.ShadyCSS && window.ShadyCSS.nativeCss !== undefined) {
    nativeCssVariables_ = window.ShadyCSS.nativeCss;
  } else if (window.ShadyCSS) {
    calcCssVariables(window.ShadyCSS);
    // reset window variable to let ShadyCSS API take its place
    window.ShadyCSS = undefined;
  } else {
    calcCssVariables(window['WebComponents'] && window['WebComponents']['flags']);
  }

  // Hack for type error under new type inference which doesn't like that
  // nativeCssVariables is updated in a function and assigns the type
  // `function(): ?` instead of `boolean`.
  const nativeCssVariables = /** @type {boolean} */nativeCssVariables_;

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  let StyleNode = /*#__PURE__*/_createClass(function StyleNode() {
    _classCallCheck(this, StyleNode);
    /** @type {number} */
    this['start'] = 0;
    /** @type {number} */
    this['end'] = 0;
    /** @type {StyleNode} */
    this['previous'] = null;
    /** @type {StyleNode} */
    this['parent'] = null;
    /** @type {Array<StyleNode>} */
    this['rules'] = null;
    /** @type {string} */
    this['parsedCssText'] = '';
    /** @type {string} */
    this['cssText'] = '';
    /** @type {boolean} */
    this['atRule'] = false;
    /** @type {number} */
    this['type'] = 0;
    /** @type {string} */
    this['keyframesName'] = '';
    /** @type {string} */
    this['selector'] = '';
    /** @type {string} */
    this['parsedSelector'] = '';
  });

  // given a string of css, return a simple rule tree
  /**
   * @param {string} text
   * @return {StyleNode}
   */
  function parse(text) {
    text = clean(text);
    return parseCss(lex(text), text);
  }

  // remove stuff we don't care about that may hinder parsing
  /**
   * @param {string} cssText
   * @return {string}
   */
  function clean(cssText) {
    return cssText.replace(RX.comments, '').replace(RX.port, '');
  }

  // super simple {...} lexer that returns a node tree
  /**
   * @param {string} text
   * @return {!StyleNode}
   */
  function lex(text) {
    let root = new StyleNode();
    root['start'] = 0;
    root['end'] = text.length;
    let n = root;
    for (let i = 0, l = text.length; i < l; i++) {
      if (text[i] === OPEN_BRACE) {
        if (!n['rules']) {
          n['rules'] = [];
        }
        let p = n;
        let previous = p['rules'][p['rules'].length - 1] || null;
        n = new StyleNode();
        n['start'] = i + 1;
        n['parent'] = p;
        n['previous'] = previous;
        p['rules'].push(n);
      } else if (text[i] === CLOSE_BRACE) {
        n['end'] = i + 1;
        n = n['parent'] || root;
      }
    }
    return root;
  }

  // add selectors/cssText to node tree
  /**
   * @param {StyleNode} node
   * @param {string} text
   * @return {!StyleNode}
   */
  function parseCss(node, text) {
    let t = text.substring(node['start'], node['end'] - 1);
    node['parsedCssText'] = node['cssText'] = t.trim();
    if (node['parent']) {
      let ss = node['previous'] ? node['previous']['end'] : node['parent']['start'];
      t = text.substring(ss, node['start'] - 1);
      t = _expandUnicodeEscapes(t);
      t = t.replace(RX.multipleSpaces, ' ');
      // TODO(sorvell): ad hoc; make selector include only after last ;
      // helps with mixin syntax
      t = t.substring(t.lastIndexOf(';') + 1);
      let s = node['parsedSelector'] = node['selector'] = t.trim();
      node['atRule'] = s.indexOf(AT_START) === 0;
      // note, support a subset of rule types...
      if (node['atRule']) {
        if (s.indexOf(MEDIA_START) === 0) {
          node['type'] = types.MEDIA_RULE;
        } else if (s.match(RX.keyframesRule)) {
          node['type'] = types.KEYFRAMES_RULE;
          node['keyframesName'] = node['selector'].split(RX.multipleSpaces).pop();
        }
      } else {
        if (s.indexOf(VAR_START) === 0) {
          node['type'] = types.MIXIN_RULE;
        } else {
          node['type'] = types.STYLE_RULE;
        }
      }
    }
    let r$ = node['rules'];
    if (r$) {
      for (let i = 0, l = r$.length, r; i < l && (r = r$[i]); i++) {
        parseCss(r, text);
      }
    }
    return node;
  }

  /**
   * conversion of sort unicode escapes with spaces like `\33 ` (and longer) into
   * expanded form that doesn't require trailing space `\000033`
   * @param {string} s
   * @return {string}
   */
  function _expandUnicodeEscapes(s) {
    return s.replace(/\\([0-9a-f]{1,6})\s/gi, function () {
      let code = arguments[1],
        repeat = 6 - code.length;
      while (repeat--) {
        code = '0' + code;
      }
      return '\\' + code;
    });
  }

  /**
   * stringify parsed css.
   * @param {StyleNode} node
   * @param {boolean=} preserveProperties
   * @param {string=} text
   * @return {string}
   */
  function stringify(node, preserveProperties) {
    let text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    // calc rule cssText
    let cssText = '';
    if (node['cssText'] || node['rules']) {
      let r$ = node['rules'];
      if (r$ && !_hasMixinRules(r$)) {
        for (let i = 0, l = r$.length, r; i < l && (r = r$[i]); i++) {
          cssText = stringify(r, preserveProperties, cssText);
        }
      } else {
        cssText = preserveProperties ? node['cssText'] : removeCustomProps(node['cssText']);
        cssText = cssText.trim();
        if (cssText) {
          cssText = '  ' + cssText + '\n';
        }
      }
    }
    // emit rule if there is cssText
    if (cssText) {
      if (node['selector']) {
        text += node['selector'] + ' ' + OPEN_BRACE + '\n';
      }
      text += cssText;
      if (node['selector']) {
        text += CLOSE_BRACE + '\n\n';
      }
    }
    return text;
  }

  /**
   * @param {Array<StyleNode>} rules
   * @return {boolean}
   */
  function _hasMixinRules(rules) {
    let r = rules[0];
    return Boolean(r) && Boolean(r['selector']) && r['selector'].indexOf(VAR_START) === 0;
  }

  /**
   * @param {string} cssText
   * @return {string}
   */
  function removeCustomProps(cssText) {
    cssText = removeCustomPropAssignment(cssText);
    return removeCustomPropApply(cssText);
  }

  /**
   * @param {string} cssText
   * @return {string}
   */
  function removeCustomPropAssignment(cssText) {
    return cssText.replace(RX.customProp, '').replace(RX.mixinProp, '');
  }

  /**
   * @param {string} cssText
   * @return {string}
   */
  function removeCustomPropApply(cssText) {
    return cssText.replace(RX.mixinApply, '').replace(RX.varApply, '');
  }

  /** @enum {number} */
  const types = {
    STYLE_RULE: 1,
    KEYFRAMES_RULE: 7,
    MEDIA_RULE: 4,
    MIXIN_RULE: 1000
  };
  const OPEN_BRACE = '{';
  const CLOSE_BRACE = '}';

  // helper regexp's
  const RX = {
    comments: /\/\*[^*]*\*+([^/*][^*]*\*+)*\//gim,
    port: /@import[^;]*;/gim,
    customProp: /(?:^[^;\-\s}]+)?--[^;{}]*?:[^{};]*?(?:[;\n]|$)/gim,
    mixinProp: /(?:^[^;\-\s}]+)?--[^;{}]*?:[^{};]*?{[^}]*?}(?:[;\n]|$)?/gim,
    mixinApply: /@apply\s*\(?[^);]*\)?\s*(?:[;\n]|$)?/gim,
    varApply: /[^;:]*?:[^;]*?var\([^;]*\)(?:[;\n]|$)?/gim,
    keyframesRule: /^@[^\s]*keyframes/,
    multipleSpaces: /\s+/g
  };
  const VAR_START = '--';
  const MEDIA_START = '@media';
  const AT_START = '@';

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  const VAR_ASSIGN = /(?:^|[;\s{]\s*)(--[\w-]*?)\s*:\s*(?:((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};{])+)|\{([^}]*)\}(?:(?=[;\s}])|$))/gi;
  const MIXIN_MATCH = /(?:^|\W+)@apply\s*\(?([^);\n]*)\)?/gi;
  const MEDIA_MATCH = /@media\s(.*)/;

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /** @type {!Set<string>} */
  const styleTextSet = new Set();
  const scopingAttribute = 'shady-unscoped';

  /**
   * Add a specifically-marked style to the document directly, and only one copy of that style.
   *
   * @param {!HTMLStyleElement} style
   * @return {undefined}
   */
  function processUnscopedStyle(style) {
    const text = style.textContent;
    if (!styleTextSet.has(text)) {
      styleTextSet.add(text);
      const newStyle = document.createElement('style');
      newStyle.setAttribute('shady-unscoped', '');
      newStyle.textContent = text;
      document.head.appendChild(newStyle);
    }
  }

  /**
   * Check if a style is supposed to be unscoped
   * @param {!HTMLStyleElement} style
   * @return {boolean} true if the style has the unscoping attribute
   */
  function isUnscopedStyle(style) {
    return style.hasAttribute(scopingAttribute);
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @param {string|StyleNode} rules
   * @param {function(StyleNode)=} callback
   * @return {string}
   */
  function toCssText(rules, callback) {
    if (!rules) {
      return '';
    }
    if (typeof rules === 'string') {
      rules = parse(rules);
    }
    if (callback) {
      forEachRule(rules, callback);
    }
    return stringify(rules, nativeCssVariables);
  }

  /**
   * @param {HTMLStyleElement} style
   * @return {StyleNode}
   */
  function rulesForStyle(style) {
    if (!style['__cssRules'] && style.textContent) {
      style['__cssRules'] = parse(style.textContent);
    }
    return style['__cssRules'] || null;
  }

  /**
   * @param {StyleNode} node
   * @param {Function=} styleRuleCallback
   * @param {Function=} keyframesRuleCallback
   * @param {boolean=} onlyActiveRules
   */
  function forEachRule(node, styleRuleCallback, keyframesRuleCallback, onlyActiveRules) {
    if (!node) {
      return;
    }
    let skipRules = false;
    let type = node['type'];
    if (onlyActiveRules) {
      if (type === types.MEDIA_RULE) {
        let matchMedia = node['selector'].match(MEDIA_MATCH);
        if (matchMedia) {
          // if rule is a non matching @media rule, skip subrules
          if (!window.matchMedia(matchMedia[1]).matches) {
            skipRules = true;
          }
        }
      }
    }
    if (type === types.STYLE_RULE) {
      styleRuleCallback(node);
    } else if (keyframesRuleCallback && type === types.KEYFRAMES_RULE) {
      keyframesRuleCallback(node);
    } else if (type === types.MIXIN_RULE) {
      skipRules = true;
    }
    let r$ = node['rules'];
    if (r$ && !skipRules) {
      for (let i = 0, l = r$.length, r; i < l && (r = r$[i]); i++) {
        forEachRule(r, styleRuleCallback, keyframesRuleCallback, onlyActiveRules);
      }
    }
  }

  /**
   * Walk from text[start] matching parens and
   * returns position of the outer end paren
   * @param {string} text
   * @param {number} start
   * @return {number}
   */
  function findMatchingParen(text, start) {
    let level = 0;
    for (let i = start, l = text.length; i < l; i++) {
      if (text[i] === '(') {
        level++;
      } else if (text[i] === ')') {
        if (--level === 0) {
          return i;
        }
      }
    }
    return -1;
  }

  /**
   * @param {string} str
   * @param {function(string, string, string, string)} callback
   */
  function processVariableAndFallback(str, callback) {
    // find 'var('
    let start = str.indexOf('var(');
    if (start === -1) {
      // no var?, everything is prefix
      return callback(str, '', '', '');
    }
    //${prefix}var(${inner})${suffix}
    let end = findMatchingParen(str, start + 3);
    let inner = str.substring(start + 4, end);
    let prefix = str.substring(0, start);
    // suffix may have other variables
    let suffix = processVariableAndFallback(str.substring(end + 1), callback);
    let comma = inner.indexOf(',');
    // value and fallback args should be trimmed to match in property lookup
    if (comma === -1) {
      // variable, no fallback
      return callback(prefix, inner.trim(), '', suffix);
    }
    // var(${value},${fallback})
    let value = inner.substring(0, comma).trim();
    let fallback = inner.substring(comma + 1).trim();
    return callback(prefix, value, fallback, suffix);
  }

  /**
   * @type {function(*):*}
   */
  window['ShadyDOM'] && window['ShadyDOM']['wrap'] || (node => node);

  /**
   * @param {Element | {is: string, extends: string}} element
   * @return {{is: string, typeExtension: string}}
   */
  function getIsExtends(element) {
    let localName = element['localName'];
    let is = '',
      typeExtension = '';
    /*
    NOTE: technically, this can be wrong for certain svg elements
    with `-` in the name like `<font-face>`
    */
    if (localName) {
      if (localName.indexOf('-') > -1) {
        is = localName;
      } else {
        typeExtension = localName;
        is = element.getAttribute && element.getAttribute('is') || '';
      }
    } else {
      is = /** @type {?} */element.is;
      typeExtension = /** @type {?} */element.extends;
    }
    return {
      is,
      typeExtension
    };
  }

  /**
   * @param {Element|DocumentFragment} element
   * @return {string}
   */
  function gatherStyleText(element) {
    /** @type {!Array<string>} */
    const styleTextParts = [];
    const styles = /** @type {!NodeList<!HTMLStyleElement>} */element.querySelectorAll('style');
    for (let i = 0; i < styles.length; i++) {
      const style = styles[i];
      if (isUnscopedStyle(style)) {
        if (!nativeShadow) {
          processUnscopedStyle(style);
          style.parentNode.removeChild(style);
        }
      } else {
        styleTextParts.push(style.textContent);
        style.parentNode.removeChild(style);
      }
    }
    return styleTextParts.join('').trim();
  }
  const CSS_BUILD_ATTR = 'css-build';

  /**
   * Return the polymer-css-build "build type" applied to this element
   *
   * @param {!HTMLElement} element
   * @return {string} Can be "", "shady", or "shadow"
   */
  function getCssBuild(element) {
    if (cssBuild !== undefined) {
      return (/** @type {string} */cssBuild
      );
    }
    if (element.__cssBuild === undefined) {
      // try attribute first, as it is the common case
      const attrValue = element.getAttribute(CSS_BUILD_ATTR);
      if (attrValue) {
        element.__cssBuild = attrValue;
      } else {
        const buildComment = getBuildComment(element);
        if (buildComment !== '') {
          // remove build comment so it is not needlessly copied into every element instance
          removeBuildComment(element);
        }
        element.__cssBuild = buildComment;
      }
    }
    return element.__cssBuild || '';
  }

  /**
   * Check if the given element, either a <template> or <style>, has been processed
   * by polymer-css-build.
   *
   * If so, then we can make a number of optimizations:
   * - polymer-css-build will decompose mixins into individual CSS Custom Properties,
   * so the ApplyShim can be skipped entirely.
   * - Under native ShadowDOM, the style text can just be copied into each instance
   * without modification
   * - If the build is "shady" and ShadyDOM is in use, the styling does not need
   * scoping beyond the shimming of CSS Custom Properties
   *
   * @param {!HTMLElement} element
   * @return {boolean}
   */
  function elementHasBuiltCss(element) {
    return getCssBuild(element) !== '';
  }

  /**
   * For templates made with tagged template literals, polymer-css-build will
   * insert a comment of the form `<!--css-build:shadow-->`
   *
   * @param {!HTMLElement} element
   * @return {string}
   */
  function getBuildComment(element) {
    const buildComment = element.localName === 'template' ? /** @type {!HTMLTemplateElement} */element.content.firstChild : element.firstChild;
    if (buildComment instanceof Comment) {
      const commentParts = buildComment.textContent.trim().split(':');
      if (commentParts[0] === CSS_BUILD_ATTR) {
        return commentParts[1];
      }
    }
    return '';
  }

  /**
   * @param {!HTMLElement} element
   */
  function removeBuildComment(element) {
    const buildComment = element.localName === 'template' ? /** @type {!HTMLTemplateElement} */element.content.firstChild : element.firstChild;
    buildComment.parentNode.removeChild(buildComment);
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @param {Element} element
   * @param {Object=} properties
   */
  function updateNativeProperties(element, properties) {
    // remove previous properties
    for (let p in properties) {
      // NOTE: for bc with shim, don't apply null values.
      if (p === null) {
        element.style.removeProperty(p);
      } else {
        element.style.setProperty(p, properties[p]);
      }
    }
  }

  /**
   * @param {Element} element
   * @param {string} property
   * @return {string}
   */
  function getComputedStyleValue(element, property) {
    /**
     * @const {string}
     */
    const value = window.getComputedStyle(element).getPropertyValue(property);
    if (!value) {
      return '';
    } else {
      return value.trim();
    }
  }

  /**
   * return true if `cssText` contains a mixin definition or consumption
   * @param {string} cssText
   * @return {boolean}
   */
  function detectMixin(cssText) {
    const has = MIXIN_MATCH.test(cssText) || VAR_ASSIGN.test(cssText);
    // reset state of the regexes
    MIXIN_MATCH.lastIndex = 0;
    VAR_ASSIGN.lastIndex = 0;
    return has;
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  const APPLY_NAME_CLEAN = /;\s*/m;
  const INITIAL_INHERIT = /^\s*(initial)|(inherit)\s*$/;
  const IMPORTANT = /\s*!important/;

  // separator used between mixin-name and mixin-property-name when producing properties
  // NOTE: plain '-' may cause collisions in user styles
  const MIXIN_VAR_SEP = '_-_';

  // map of mixin to property names
  // --foo: {border: 2px} -> {properties: {(--foo, ['border'])}, dependants: {'element-name': proto}}
  let MixinMap = /*#__PURE__*/function () {
    function MixinMap() {
      _classCallCheck(this, MixinMap);
      /** @type {!Object<string, !MixinMapEntry>} */
      this._map = {};
    }
    /**
     * @param {string} name
     * @param {!PropertyEntry} props
     */
    _createClass(MixinMap, [{
      key: "set",
      value: function set(name, props) {
        name = name.trim();
        this._map[name] = {
          properties: props,
          dependants: {}
        };
      }
      /**
       * @param {string} name
       * @return {MixinMapEntry}
       */
    }, {
      key: "get",
      value: function get(name) {
        name = name.trim();
        return this._map[name] || null;
      }
    }]);
    return MixinMap;
  }(); /**
        * Callback for when an element is marked invalid
        * @type {?function(string)}
        */
  let invalidCallback = null;

  /** @unrestricted */
  let ApplyShim = /*#__PURE__*/function () {
    function ApplyShim() {
      _classCallCheck(this, ApplyShim);
      /** @type {?string} */
      this._currentElement = null;
      /** @type {HTMLMetaElement} */
      this._measureElement = null;
      this._map = new MixinMap();
    }
    /**
     * return true if `cssText` contains a mixin definition or consumption
     * @param {string} cssText
     * @return {boolean}
     */
    _createClass(ApplyShim, [{
      key: "detectMixin",
      value: function detectMixin$1(cssText) {
        return detectMixin(cssText);
      }

      /**
       * Gather styles into one style for easier processing
       * @param {!HTMLTemplateElement} template
       * @return {HTMLStyleElement}
       */
    }, {
      key: "gatherStyles",
      value: function gatherStyles(template) {
        const styleText = gatherStyleText(template.content);
        if (styleText) {
          const style = /** @type {!HTMLStyleElement} */document.createElement('style');
          style.textContent = styleText;
          template.content.insertBefore(style, template.content.firstChild);
          return style;
        }
        return null;
      }
      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       * @return {StyleNode}
       */
    }, {
      key: "transformTemplate",
      value: function transformTemplate(template, elementName) {
        if (template._gatheredStyle === undefined) {
          template._gatheredStyle = this.gatherStyles(template);
        }
        /** @type {HTMLStyleElement} */
        const style = template._gatheredStyle;
        return style ? this.transformStyle(style, elementName) : null;
      }
      /**
       * @param {!HTMLStyleElement} style
       * @param {string} elementName
       * @return {StyleNode}
       */
    }, {
      key: "transformStyle",
      value: function transformStyle(style) {
        let elementName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        let ast = rulesForStyle(style);
        this.transformRules(ast, elementName);
        style.textContent = toCssText(ast);
        return ast;
      }
      /**
       * @param {!HTMLStyleElement} style
       * @return {StyleNode}
       */
    }, {
      key: "transformCustomStyle",
      value: function transformCustomStyle(style) {
        let ast = rulesForStyle(style);
        forEachRule(ast, rule => {
          if (rule['selector'] === ':root') {
            rule['selector'] = 'html';
          }
          this.transformRule(rule);
        });
        style.textContent = toCssText(ast);
        return ast;
      }
      /**
       * @param {StyleNode} rules
       * @param {string} elementName
       */
    }, {
      key: "transformRules",
      value: function transformRules(rules, elementName) {
        this._currentElement = elementName;
        forEachRule(rules, r => {
          this.transformRule(r);
        });
        this._currentElement = null;
      }
      /**
       * @param {!StyleNode} rule
       */
    }, {
      key: "transformRule",
      value: function transformRule(rule) {
        rule['cssText'] = this.transformCssText(rule['parsedCssText'], rule);
        // :root was only used for variable assignment in property shim,
        // but generates invalid selectors with real properties.
        // replace with `:host > *`, which serves the same effect
        if (rule['selector'] === ':root') {
          rule['selector'] = ':host > *';
        }
      }
      /**
       * @param {string} cssText
       * @param {!StyleNode} rule
       * @return {string}
       */
    }, {
      key: "transformCssText",
      value: function transformCssText(cssText, rule) {
        // produce variables
        cssText = cssText.replace(VAR_ASSIGN, (matchText, propertyName, valueProperty, valueMixin) => this._produceCssProperties(matchText, propertyName, valueProperty, valueMixin, rule));
        // consume mixins
        return this._consumeCssProperties(cssText, rule);
      }
      /**
       * @param {string} property
       * @return {string}
       */
    }, {
      key: "_getInitialValueForProperty",
      value: function _getInitialValueForProperty(property) {
        if (!this._measureElement) {
          this._measureElement = /** @type {HTMLMetaElement} */document.createElement('meta');
          this._measureElement.setAttribute('apply-shim-measure', '');
          this._measureElement.style.all = 'initial';
          document.head.appendChild(this._measureElement);
        }
        return window.getComputedStyle(this._measureElement).getPropertyValue(property);
      }
      /**
       * Walk over all rules before this rule to find fallbacks for mixins
       *
       * @param {!StyleNode} startRule
       * @return {!Object}
       */
    }, {
      key: "_fallbacksFromPreviousRules",
      value: function _fallbacksFromPreviousRules(startRule) {
        // find the "top" rule
        let topRule = startRule;
        while (topRule['parent']) {
          topRule = topRule['parent'];
        }
        const fallbacks = {};
        let seenStartRule = false;
        forEachRule(topRule, r => {
          // stop when we hit the input rule
          seenStartRule = seenStartRule || r === startRule;
          if (seenStartRule) {
            return;
          }
          // NOTE: Only matching selectors are "safe" for this fallback processing
          // It would be prohibitive to run `matchesSelector()` on each selector,
          // so we cheat and only check if the same selector string is used, which
          // guarantees things like specificity matching
          if (r['selector'] === startRule['selector']) {
            Object.assign(fallbacks, this._cssTextToMap(r['parsedCssText']));
          }
        });
        return fallbacks;
      }
      /**
       * replace mixin consumption with variable consumption
       * @param {string} text
       * @param {!StyleNode=} rule
       * @return {string}
       */
    }, {
      key: "_consumeCssProperties",
      value: function _consumeCssProperties(text, rule) {
        /** @type {Array} */
        let m = null;
        // loop over text until all mixins with defintions have been applied
        while (m = MIXIN_MATCH.exec(text)) {
          let matchText = m[0];
          let mixinName = m[1];
          let idx = m.index;
          // collect properties before apply to be "defaults" if mixin might override them
          // match includes a "prefix", so find the start and end positions of @apply
          let applyPos = idx + matchText.indexOf('@apply');
          let afterApplyPos = idx + matchText.length;
          // find props defined before this @apply
          let textBeforeApply = text.slice(0, applyPos);
          let textAfterApply = text.slice(afterApplyPos);
          let defaults = rule ? this._fallbacksFromPreviousRules(rule) : {};
          Object.assign(defaults, this._cssTextToMap(textBeforeApply));
          let replacement = this._atApplyToCssProperties(mixinName, defaults);
          // use regex match position to replace mixin, keep linear processing time
          text = `${textBeforeApply}${replacement}${textAfterApply}`;
          // move regex search to _after_ replacement
          MIXIN_MATCH.lastIndex = idx + replacement.length;
        }
        return text;
      }
      /**
       * produce variable consumption at the site of mixin consumption
       * `@apply` --foo; -> for all props (${propname}: var(--foo_-_${propname}, ${fallback[propname]}}))
       * Example:
       *  border: var(--foo_-_border); padding: var(--foo_-_padding, 2px)
       *
       * @param {string} mixinName
       * @param {Object} fallbacks
       * @return {string}
       */
    }, {
      key: "_atApplyToCssProperties",
      value: function _atApplyToCssProperties(mixinName, fallbacks) {
        mixinName = mixinName.replace(APPLY_NAME_CLEAN, '');
        let vars = [];
        let mixinEntry = this._map.get(mixinName);
        // if we depend on a mixin before it is created
        // make a sentinel entry in the map to add this element as a dependency for when it is defined.
        if (!mixinEntry) {
          this._map.set(mixinName, {});
          mixinEntry = this._map.get(mixinName);
        }
        if (mixinEntry) {
          if (this._currentElement) {
            mixinEntry.dependants[this._currentElement] = true;
          }
          let p, parts, f;
          const properties = mixinEntry.properties;
          for (p in properties) {
            f = fallbacks && fallbacks[p];
            parts = [p, ': var(', mixinName, MIXIN_VAR_SEP, p];
            if (f) {
              parts.push(',', f.replace(IMPORTANT, ''));
            }
            parts.push(')');
            if (IMPORTANT.test(properties[p])) {
              parts.push(' !important');
            }
            vars.push(parts.join(''));
          }
        }
        return vars.join('; ');
      }

      /**
       * @param {string} property
       * @param {string} value
       * @return {string}
       */
    }, {
      key: "_replaceInitialOrInherit",
      value: function _replaceInitialOrInherit(property, value) {
        let match = INITIAL_INHERIT.exec(value);
        if (match) {
          if (match[1]) {
            // initial
            // replace `initial` with the concrete initial value for this property
            value = this._getInitialValueForProperty(property);
          } else {
            // inherit
            // with this purposfully illegal value, the variable will be invalid at
            // compute time (https://www.w3.org/TR/css-variables/#invalid-at-computed-value-time)
            // and for inheriting values, will behave similarly
            // we cannot support the same behavior for non inheriting values like 'border'
            value = 'apply-shim-inherit';
          }
        }
        return value;
      }

      /**
       * "parse" a mixin definition into a map of properties and values
       * cssTextToMap('border: 2px solid black') -> ('border', '2px solid black')
       * @param {string} text
       * @param {boolean=} replaceInitialOrInherit
       * @return {!Object<string, string>}
       */
    }, {
      key: "_cssTextToMap",
      value: function _cssTextToMap(text) {
        let replaceInitialOrInherit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let props = text.split(';');
        let property, value;
        let out = {};
        for (let i = 0, p, sp; i < props.length; i++) {
          p = props[i];
          if (p) {
            sp = p.split(':');
            // ignore lines that aren't definitions like @media
            if (sp.length > 1) {
              property = sp[0].trim();
              // some properties may have ':' in the value, like data urls
              value = sp.slice(1).join(':');
              if (replaceInitialOrInherit) {
                value = this._replaceInitialOrInherit(property, value);
              }
              out[property] = value;
            }
          }
        }
        return out;
      }

      /**
       * @param {MixinMapEntry} mixinEntry
       */
    }, {
      key: "_invalidateMixinEntry",
      value: function _invalidateMixinEntry(mixinEntry) {
        if (!invalidCallback) {
          return;
        }
        for (let elementName in mixinEntry.dependants) {
          if (elementName !== this._currentElement) {
            invalidCallback(elementName);
          }
        }
      }

      /**
       * @param {string} matchText
       * @param {string} propertyName
       * @param {?string} valueProperty
       * @param {?string} valueMixin
       * @param {!StyleNode} rule
       * @return {string}
       */
    }, {
      key: "_produceCssProperties",
      value: function _produceCssProperties(matchText, propertyName, valueProperty, valueMixin, rule) {
        // handle case where property value is a mixin
        if (valueProperty) {
          // form: --mixin2: var(--mixin1), where --mixin1 is in the map
          processVariableAndFallback(valueProperty, (prefix, value) => {
            if (value && this._map.get(value)) {
              valueMixin = `@apply ${value};`;
            }
          });
        }
        if (!valueMixin) {
          return matchText;
        }
        let mixinAsProperties = this._consumeCssProperties('' + valueMixin, rule);
        let prefix = matchText.slice(0, matchText.indexOf('--'));
        // `initial` and `inherit` as properties in a map should be replaced because
        // these keywords are eagerly evaluated when the mixin becomes CSS Custom Properties,
        // and would set the variable value, rather than carry the keyword to the `var()` usage.
        let mixinValues = this._cssTextToMap(mixinAsProperties, true);
        let combinedProps = mixinValues;
        let mixinEntry = this._map.get(propertyName);
        let oldProps = mixinEntry && mixinEntry.properties;
        if (oldProps) {
          // NOTE: since we use mixin, the map of properties is updated here
          // and this is what we want.
          combinedProps = Object.assign(Object.create(oldProps), mixinValues);
        } else {
          this._map.set(propertyName, combinedProps);
        }
        let out = [];
        let p, v;
        // set variables defined by current mixin
        let needToInvalidate = false;
        for (p in combinedProps) {
          v = mixinValues[p];
          // if property not defined by current mixin, set initial
          if (v === undefined) {
            v = 'initial';
          }
          if (oldProps && !(p in oldProps)) {
            needToInvalidate = true;
          }
          out.push(`${propertyName}${MIXIN_VAR_SEP}${p}: ${v}`);
        }
        if (needToInvalidate) {
          this._invalidateMixinEntry(mixinEntry);
        }
        if (mixinEntry) {
          mixinEntry.properties = combinedProps;
        }
        // because the mixinMap is global, the mixin might conflict with
        // a different scope's simple variable definition:
        // Example:
        // some style somewhere:
        // --mixin1:{ ... }
        // --mixin2: var(--mixin1);
        // some other element:
        // --mixin1: 10px solid red;
        // --foo: var(--mixin1);
        // In this case, we leave the original variable definition in place.
        if (valueProperty) {
          prefix = `${matchText};${prefix}`;
        }
        return `${prefix}${out.join('; ')};`;
      }
    }]);
    return ApplyShim;
  }();
  /* exports */
  /* eslint-disable no-self-assign */
  ApplyShim.prototype['detectMixin'] = ApplyShim.prototype.detectMixin;
  ApplyShim.prototype['transformStyle'] = ApplyShim.prototype.transformStyle;
  ApplyShim.prototype['transformCustomStyle'] = ApplyShim.prototype.transformCustomStyle;
  ApplyShim.prototype['transformRules'] = ApplyShim.prototype.transformRules;
  ApplyShim.prototype['transformRule'] = ApplyShim.prototype.transformRule;
  ApplyShim.prototype['transformTemplate'] = ApplyShim.prototype.transformTemplate;
  ApplyShim.prototype['_separator'] = MIXIN_VAR_SEP;
  /* eslint-enable no-self-assign */
  Object.defineProperty(ApplyShim.prototype, 'invalidCallback', {
    /** @return {?function(string)} */
    get() {
      return invalidCallback;
    },
    /** @param {?function(string)} cb */
    set(cb) {
      invalidCallback = cb;
    }
  });

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @const {!Object<string, !HTMLTemplateElement>}
   */
  const templateMap = {};

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /*
   * Utilities for handling invalidating apply-shim mixins for a given template.
   *
   * The invalidation strategy involves keeping track of the "current" version of a template's mixins, and updating that count when a mixin is invalidated.
   * The template
   */

  /** @const {string} */
  const CURRENT_VERSION = '_applyShimCurrentVersion';

  /** @const {string} */
  const NEXT_VERSION = '_applyShimNextVersion';

  /** @const {string} */
  const VALIDATING_VERSION = '_applyShimValidatingVersion';

  /**
   * @const {Promise<void>}
   */
  const promise = Promise.resolve();

  /**
   * @param {string} elementName
   */
  function invalidate(elementName) {
    let template = templateMap[elementName];
    if (template) {
      invalidateTemplate(template);
    }
  }

  /**
   * This function can be called multiple times to mark a template invalid
   * and signal that the style inside must be regenerated.
   *
   * Use `startValidatingTemplate` to begin an asynchronous validation cycle.
   * During that cycle, call `templateIsValidating` to see if the template must
   * be revalidated
   * @param {HTMLTemplateElement} template
   */
  function invalidateTemplate(template) {
    // default the current version to 0
    template[CURRENT_VERSION] = template[CURRENT_VERSION] || 0;
    // ensure the "validating for" flag exists
    template[VALIDATING_VERSION] = template[VALIDATING_VERSION] || 0;
    // increment the next version
    template[NEXT_VERSION] = (template[NEXT_VERSION] || 0) + 1;
  }

  /**
   * @param {HTMLTemplateElement} template
   * @return {boolean}
   */
  function templateIsValid(template) {
    return template[CURRENT_VERSION] === template[NEXT_VERSION];
  }

  /**
   * Returns true if the template is currently invalid and `startValidating` has been called since the last invalidation.
   * If false, the template must be validated.
   * @param {HTMLTemplateElement} template
   * @return {boolean}
   */
  function templateIsValidating(template) {
    return !templateIsValid(template) && template[VALIDATING_VERSION] === template[NEXT_VERSION];
  }

  /**
   * Begin an asynchronous invalidation cycle.
   * This should be called after every validation of a template
   *
   * After one microtask, the template will be marked as valid until the next call to `invalidateTemplate`
   * @param {HTMLTemplateElement} template
   */
  function startValidatingTemplate(template) {
    // remember that the current "next version" is the reason for this validation cycle
    template[VALIDATING_VERSION] = template[NEXT_VERSION];
    // however, there only needs to be one async task to clear the counters
    if (!template._validating) {
      template._validating = true;
      promise.then(function () {
        // sync the current version to let future invalidations cause a refresh cycle
        template[CURRENT_VERSION] = template[NEXT_VERSION];
        template._validating = false;
      });
    }
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /** @type {Promise<void>} */
  let readyPromise = null;

  /** @type {?function(?function())} */
  let whenReady = window['HTMLImports'] && window['HTMLImports']['whenReady'] || null;

  /** @type {function()} */
  let resolveFn;

  /**
   * @param {?function()} callback
   */
  function documentWait(callback) {
    requestAnimationFrame(function () {
      if (whenReady) {
        whenReady(callback);
      } else {
        if (!readyPromise) {
          readyPromise = new Promise(resolve => {
            resolveFn = resolve;
          });
          if (document.readyState === 'complete') {
            resolveFn();
          } else {
            document.addEventListener('readystatechange', () => {
              if (document.readyState === 'complete') {
                resolveFn();
              }
            });
          }
        }
        readyPromise.then(function () {
          callback && callback();
        });
      }
    });
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  const SEEN_MARKER = '__seenByShadyCSS';
  const CACHED_STYLE = '__shadyCSSCachedStyle';

  /** @type {?function(!HTMLStyleElement)} */
  let transformFn = null;

  /** @type {?function()} */
  let validateFn = null;

  /**
  This interface is provided to add document-level <style> elements to ShadyCSS for processing.
  These styles must be processed by ShadyCSS to simulate ShadowRoot upper-bound encapsulation from outside styles
  In addition, these styles may also need to be processed for @apply rules and CSS Custom Properties

  To add document-level styles to ShadyCSS, one can call `ShadyCSS.addDocumentStyle(styleElement)` or `ShadyCSS.addDocumentStyle({getStyle: () => styleElement})`

  In addition, if the process used to discover document-level styles can be synchronously flushed, one should set `ShadyCSS.documentStyleFlush`.
  This function will be called when calculating styles.

  An example usage of the document-level styling api can be found in `examples/document-style-lib.js`

  @unrestricted
  */
  let CustomStyleInterface$1 = /*#__PURE__*/function () {
    function CustomStyleInterface() {
      _classCallCheck(this, CustomStyleInterface);
      /** @type {!Array<!CustomStyleProvider>} */
      this['customStyles'] = [];
      this['enqueued'] = false;
      // NOTE(dfreedm): use quotes here to prevent closure inlining to `function(){}`;
      documentWait(() => {
        if (window['ShadyCSS']['flushCustomStyles']) {
          window['ShadyCSS']['flushCustomStyles']();
        }
      });
    }
    /**
     * Queue a validation for new custom styles to batch style recalculations
     */
    _createClass(CustomStyleInterface, [{
      key: "enqueueDocumentValidation",
      value: function enqueueDocumentValidation() {
        if (this['enqueued'] || !validateFn) {
          return;
        }
        this['enqueued'] = true;
        documentWait(validateFn);
      }
      /**
       * @param {!HTMLStyleElement} style
       */
    }, {
      key: "addCustomStyle",
      value: function addCustomStyle(style) {
        if (!style[SEEN_MARKER]) {
          style[SEEN_MARKER] = true;
          this['customStyles'].push(style);
          this.enqueueDocumentValidation();
        }
      }
      /**
       * @param {!CustomStyleProvider} customStyle
       * @return {HTMLStyleElement}
       */
    }, {
      key: "getStyleForCustomStyle",
      value: function getStyleForCustomStyle(customStyle) {
        if (customStyle[CACHED_STYLE]) {
          return customStyle[CACHED_STYLE];
        }
        let style;
        if (customStyle['getStyle']) {
          style = customStyle['getStyle']();
        } else {
          style = customStyle;
        }
        return style;
      }
      /**
       * @return {!Array<!CustomStyleProvider>}
       */
    }, {
      key: "processStyles",
      value: function processStyles() {
        const cs = this['customStyles'];
        for (let i = 0; i < cs.length; i++) {
          const customStyle = cs[i];
          if (customStyle[CACHED_STYLE]) {
            continue;
          }
          const style = this.getStyleForCustomStyle(customStyle);
          if (style) {
            // HTMLImports polyfill may have cloned the style into the main document,
            // which is referenced with __appliedElement.
            const styleToTransform = /** @type {!HTMLStyleElement} */style['__appliedElement'] || style;
            if (transformFn) {
              transformFn(styleToTransform);
            }
            customStyle[CACHED_STYLE] = styleToTransform;
          }
        }
        return cs;
      }
    }]);
    return CustomStyleInterface;
  }(); /* eslint-disable no-self-assign */
  CustomStyleInterface$1.prototype['addCustomStyle'] = CustomStyleInterface$1.prototype.addCustomStyle;
  CustomStyleInterface$1.prototype['getStyleForCustomStyle'] = CustomStyleInterface$1.prototype.getStyleForCustomStyle;
  CustomStyleInterface$1.prototype['processStyles'] = CustomStyleInterface$1.prototype.processStyles;
  /* eslint-enable no-self-assign */

  Object.defineProperties(CustomStyleInterface$1.prototype, {
    'transformCallback': {
      /** @return {?function(!HTMLStyleElement)} */
      get() {
        return transformFn;
      },
      /** @param {?function(!HTMLStyleElement)} fn */
      set(fn) {
        transformFn = fn;
      }
    },
    'validateCallback': {
      /** @return {?function()} */
      get() {
        return validateFn;
      },
      /**
       * @param {?function()} fn
       * @this {CustomStyleInterface}
       */
      set(fn) {
        let needsEnqueue = false;
        if (!validateFn) {
          needsEnqueue = true;
        }
        validateFn = fn;
        if (needsEnqueue) {
          this.enqueueDocumentValidation();
        }
      }
    }
  });

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /** @const {ApplyShim} */
  const applyShim = new ApplyShim();
  let ApplyShimInterface = /*#__PURE__*/function () {
    function ApplyShimInterface() {
      _classCallCheck(this, ApplyShimInterface);
      /** @type {?CustomStyleInterfaceInterface} */
      this.customStyleInterface = null;
      applyShim['invalidCallback'] = invalidate;
    }
    _createClass(ApplyShimInterface, [{
      key: "ensure",
      value: function ensure() {
        if (this.customStyleInterface) {
          return;
        }
        if (window.ShadyCSS.CustomStyleInterface) {
          this.customStyleInterface = /** @type {!CustomStyleInterfaceInterface} */window.ShadyCSS.CustomStyleInterface;
          this.customStyleInterface['transformCallback'] = style => {
            applyShim.transformCustomStyle(style);
          };
          this.customStyleInterface['validateCallback'] = () => {
            requestAnimationFrame(() => {
              if (this.customStyleInterface['enqueued']) {
                this.flushCustomStyles();
              }
            });
          };
        }
      }
      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       */
    }, {
      key: "prepareTemplate",
      value: function prepareTemplate(template, elementName) {
        this.ensure();
        if (elementHasBuiltCss(template)) {
          return;
        }
        templateMap[elementName] = template;
        let ast = applyShim.transformTemplate(template, elementName);
        // save original style ast to use for revalidating instances
        template['_styleAst'] = ast;
      }
    }, {
      key: "flushCustomStyles",
      value: function flushCustomStyles() {
        this.ensure();
        if (!this.customStyleInterface) {
          return;
        }
        let styles = this.customStyleInterface['processStyles']();
        if (!this.customStyleInterface['enqueued']) {
          return;
        }
        for (let i = 0; i < styles.length; i++) {
          let cs = styles[i];
          let style = this.customStyleInterface['getStyleForCustomStyle'](cs);
          if (style) {
            applyShim.transformCustomStyle(style);
          }
        }
        this.customStyleInterface['enqueued'] = false;
      }
      /**
       * @param {HTMLElement} element
       * @param {Object=} properties
       */
    }, {
      key: "styleSubtree",
      value: function styleSubtree(element, properties) {
        this.ensure();
        if (properties) {
          updateNativeProperties(element, properties);
        }
        if (element.shadowRoot) {
          this.styleElement(element);
          let shadowChildren = /** @type {!ParentNode} */element.shadowRoot.children || element.shadowRoot.childNodes;
          for (let i = 0; i < shadowChildren.length; i++) {
            this.styleSubtree( /** @type {HTMLElement} */shadowChildren[i]);
          }
        } else {
          let children = element.children || element.childNodes;
          for (let i = 0; i < children.length; i++) {
            this.styleSubtree( /** @type {HTMLElement} */children[i]);
          }
        }
      }
      /**
       * @param {HTMLElement} element
       */
    }, {
      key: "styleElement",
      value: function styleElement(element) {
        this.ensure();
        let {
          is
        } = getIsExtends(element);
        let template = templateMap[is];
        if (template && elementHasBuiltCss(template)) {
          return;
        }
        if (template && !templateIsValid(template)) {
          // only revalidate template once
          if (!templateIsValidating(template)) {
            this.prepareTemplate(template, is);
            startValidatingTemplate(template);
          }
          // update this element instance
          let root = element.shadowRoot;
          if (root) {
            let style = /** @type {HTMLStyleElement} */root.querySelector('style');
            if (style) {
              // reuse the template's style ast, it has all the original css text
              style['__cssRules'] = template['_styleAst'];
              style.textContent = toCssText(template['_styleAst']);
            }
          }
        }
      }
      /**
       * @param {Object=} properties
       */
    }, {
      key: "styleDocument",
      value: function styleDocument(properties) {
        this.ensure();
        this.styleSubtree(document.body, properties);
      }
    }]);
    return ApplyShimInterface;
  }();
  if (!window.ShadyCSS || !window.ShadyCSS.ScopingShim) {
    const applyShimInterface = new ApplyShimInterface();
    let CustomStyleInterface = window.ShadyCSS && window.ShadyCSS.CustomStyleInterface;

    /** @suppress {duplicate} */
    window.ShadyCSS = {
      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       * @param {string=} elementExtends
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      prepareTemplate(template, elementName, elementExtends) {
        applyShimInterface.flushCustomStyles();
        applyShimInterface.prepareTemplate(template, elementName);
      },
      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       * @param {string=} elementExtends
       */
      prepareTemplateStyles(template, elementName, elementExtends) {
        window.ShadyCSS.prepareTemplate(template, elementName, elementExtends);
      },
      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       */
      prepareTemplateDom(template, elementName) {},
      // eslint-disable-line @typescript-eslint/no-unused-vars

      /**
       * @param {!HTMLElement} element
       * @param {Object=} properties
       */
      styleSubtree(element, properties) {
        applyShimInterface.flushCustomStyles();
        applyShimInterface.styleSubtree(element, properties);
      },
      /**
       * @param {!HTMLElement} element
       */
      styleElement(element) {
        applyShimInterface.flushCustomStyles();
        applyShimInterface.styleElement(element);
      },
      /**
       * @param {Object=} properties
       */
      styleDocument(properties) {
        applyShimInterface.flushCustomStyles();
        applyShimInterface.styleDocument(properties);
      },
      /**
       * @param {Element} element
       * @param {string} property
       * @return {string}
       */
      getComputedStyleValue(element, property) {
        return getComputedStyleValue(element, property);
      },
      flushCustomStyles() {
        applyShimInterface.flushCustomStyles();
      },
      nativeCss: nativeCssVariables,
      nativeShadow: nativeShadow,
      cssBuild: cssBuild,
      disableRuntime: disableRuntime
    };
    if (CustomStyleInterface) {
      window.ShadyCSS.CustomStyleInterface = CustomStyleInterface;
    }
  }
  window.ShadyCSS.ApplyShim = applyShim;

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /* eslint-disable no-unused-vars */
  /**
   * When using Closure Compiler, JSCompiler_renameProperty(property, object) is replaced by the munged name for object[property]
   * We cannot alias this function, so we have to use a small shim that has the same behavior when not compiling.
   *
   * @param {?} prop Property name
   * @param {*} obj Reference object
   * @return {string} Potentially renamed property name
   */
  window.JSCompiler_renameProperty = function (prop, obj) {
    return prop;
  };

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  let CSS_URL_RX = /(url\()([^)]*)(\))/g;
  let ABS_URL = /(^\/[^\/])|(^#)|(^[\w-\d]*:)/;
  let workingURL;
  let resolveDoc;
  /**
   * Resolves the given URL against the provided `baseUri'.
   *
   * Note that this function performs no resolution for URLs that start
   * with `/` (absolute URLs) or `#` (hash identifiers).  For general purpose
   * URL resolution, use `window.URL`.
   *
   * @param {string} url Input URL to resolve
   * @param {?string=} baseURI Base URI to resolve the URL against
   * @return {string} resolved URL
   */
  function resolveUrl(url, baseURI) {
    if (url && ABS_URL.test(url)) {
      return url;
    }
    if (url === '//') {
      return url;
    }
    // Lazy feature detection.
    if (workingURL === undefined) {
      workingURL = false;
      try {
        const u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        workingURL = u.href === 'http://a/c%20d';
      } catch (e) {
        // silently fail
      }
    }
    if (!baseURI) {
      baseURI = document.baseURI || window.location.href;
    }
    if (workingURL) {
      try {
        return new URL(url, baseURI).href;
      } catch (e) {
        // Bad url or baseURI structure. Do not attempt to resolve.
        return url;
      }
    }
    // Fallback to creating an anchor into a disconnected document.
    if (!resolveDoc) {
      resolveDoc = document.implementation.createHTMLDocument('temp');
      resolveDoc.base = resolveDoc.createElement('base');
      resolveDoc.head.appendChild(resolveDoc.base);
      resolveDoc.anchor = resolveDoc.createElement('a');
      resolveDoc.body.appendChild(resolveDoc.anchor);
    }
    resolveDoc.base.href = baseURI;
    resolveDoc.anchor.href = url;
    return resolveDoc.anchor.href || url;
  }

  /**
   * Resolves any relative URL's in the given CSS text against the provided
   * `ownerDocument`'s `baseURI`.
   *
   * @param {string} cssText CSS text to process
   * @param {string} baseURI Base URI to resolve the URL against
   * @return {string} Processed CSS text with resolved URL's
   */
  function resolveCss(cssText, baseURI) {
    return cssText.replace(CSS_URL_RX, function (m, pre, url, post) {
      return pre + '\'' + resolveUrl(url.replace(/["']/g, ''), baseURI) + '\'' + post;
    });
  }

  /**
   * Returns a path from a given `url`. The path includes the trailing
   * `/` from the url.
   *
   * @param {string} url Input URL to transform
   * @return {string} resolved path
   */
  function pathFromUrl(url) {
    return url.substring(0, url.lastIndexOf('/') + 1);
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  const useShadow = !window.ShadyDOM || !window.ShadyDOM.inUse;
  Boolean(!window.ShadyCSS || window.ShadyCSS.nativeCss);
  const supportsAdoptingStyleSheets = useShadow && 'adoptedStyleSheets' in Document.prototype && 'replaceSync' in CSSStyleSheet.prototype &&
  // Since spec may change, feature detect exact API we need
  (() => {
    try {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync('');
      const host = document.createElement('div');
      host.attachShadow({
        mode: 'open'
      });
      host.shadowRoot.adoptedStyleSheets = [sheet];
      return host.shadowRoot.adoptedStyleSheets[0] === sheet;
    } catch (e) {
      return false;
    }
  })();

  /**
   * Globally settable property that is automatically assigned to
   * `ElementMixin` instances, useful for binding in templates to
   * make URL's relative to an application's root.  Defaults to the main
   * document URL, but can be overridden by users.  It may be useful to set
   * `rootPath` to provide a stable application mount path when
   * using client side routing.
   */
  let rootPath = window.Polymer && window.Polymer.rootPath || pathFromUrl(document.baseURI || window.location.href);

  /**
   * A global callback used to sanitize any value before inserting it into the DOM.
   * The callback signature is:
   *
   *  function sanitizeDOMValue(value, name, type, node) { ... }
   *
   * Where:
   *
   * `value` is the value to sanitize.
   * `name` is the name of an attribute or property (for example, href).
   * `type` indicates where the value is being inserted: one of property, attribute, or text.
   * `node` is the node where the value is being inserted.
   *
   * @type {(function(*,string,string,?Node):*)|undefined}
   */
  let sanitizeDOMValue = window.Polymer && window.Polymer.sanitizeDOMValue || undefined;

  /**
   * Globally settable property to make Polymer Gestures use passive TouchEvent listeners when recognizing gestures.
   * When set to `true`, gestures made from touch will not be able to prevent scrolling, allowing for smoother
   * scrolling performance.
   * Defaults to `false` for backwards compatibility.
   */
  let passiveTouchGestures = window.Polymer && window.Polymer.setPassiveTouchGestures || false;

  /**
   * Setting to ensure Polymer template evaluation only occurs based on tempates
   * defined in trusted script.  When true, `<dom-module>` re-registration is
   * disallowed, `<dom-bind>` is disabled, and `<dom-if>`/`<dom-repeat>`
   * templates will only evaluate in the context of a trusted element template.
   */
  let strictTemplatePolicy = window.Polymer && window.Polymer.strictTemplatePolicy || false;

  /**
   * Setting to enable dom-module lookup from Polymer.Element.  By default,
   * templates must be defined in script using the `static get template()`
   * getter and the `html` tag function.  To enable legacy loading of templates
   * via dom-module, set this flag to true.
   */
  let allowTemplateFromDomModule = window.Polymer && window.Polymer.allowTemplateFromDomModule || false;

  /**
   * Setting to skip processing style includes and re-writing urls in css styles.
   * Normally "included" styles are pulled into the element and all urls in styles
   * are re-written to be relative to the containing script url.
   * If no includes or relative urls are used in styles, these steps can be
   * skipped as an optimization.
   */
  let legacyOptimizations = window.Polymer && window.Polymer.legacyOptimizations || false;

  /**
   * Setting to add warnings useful when migrating from Polymer 1.x to 2.x.
   */
  let legacyWarnings = window.Polymer && window.Polymer.legacyWarnings || false;

  /**
   * Setting to perform initial rendering synchronously when running under ShadyDOM.
   * This matches the behavior of Polymer 1.
   */
  let syncInitialRender = window.Polymer && window.Polymer.syncInitialRender || false;

  /**
   * Setting to retain the legacy Polymer 1 behavior for multi-property
   * observers around undefined values. Observers and computed property methods
   * are not called until no argument is undefined.
   */
  let legacyUndefined = window.Polymer && window.Polymer.legacyUndefined || false;

  /**
   * Setting to ensure computed properties are computed in order to ensure
   * re-computation never occurs in a given turn.
   */
  let orderedComputed = window.Polymer && window.Polymer.orderedComputed || false;

  /**
   * Setting to remove nested templates inside `dom-if` and `dom-repeat` as
   * part of element template parsing.  This is a performance optimization that
   * eliminates most of the tax of needing two elements due to the loss of
   * type-extended templates as a result of the V1 specification changes.
   */
  let removeNestedTemplates = window.Polymer && window.Polymer.removeNestedTemplates || false;

  /**
   * Setting to place `dom-if` elements in a performance-optimized mode that takes
   * advantage of lighter-weight host runtime template stamping to eliminate the
   * need for an intermediate Templatizer `TemplateInstance` to mange the nodes
   * stamped by `dom-if`.  Under this setting, any Templatizer-provided API's
   * such as `modelForElement` will not be available for nodes stamped by
   * `dom-if`.
   */
  let fastDomIf = window.Polymer && window.Polymer.fastDomIf || false;

  /**
   * Setting to disable `dom-change` and `rendered-item-count` events from
   * `dom-if` and `dom-repeat`. Users can opt back into `dom-change` events by
   * setting the `notify-dom-change` attribute (`notifyDomChange: true` property)
   * to `dom-if`/`don-repeat` instances.
   */
  let suppressTemplateNotifications = window.Polymer && window.Polymer.suppressTemplateNotifications || false;

  /**
   * Setting to disable use of dynamic attributes. This is an optimization
   * to avoid setting `observedAttributes`. Instead attributes are read
   * once at create time and set/removeAttribute are patched.
   */
  let legacyNoObservedAttributes = window.Polymer && window.Polymer.legacyNoObservedAttributes || false;

  /**
   * Setting to enable use of `adoptedStyleSheets` for sharing style sheets
   * between component instances' shadow roots, if the app uses built Shady CSS
   * styles.
   */
  let useAdoptedStyleSheetsWithBuiltCSS = window.Polymer && window.Polymer.useAdoptedStyleSheetsWithBuiltCSS || false;

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  // unique global id for deduping mixins.
  let dedupeId$1 = 0;

  /* eslint-disable valid-jsdoc */
  /**
   * Wraps an ES6 class expression mixin such that the mixin is only applied
   * if it has not already been applied its base argument. Also memoizes mixin
   * applications.
   *
   * @template T
   * @param {T} mixin ES6 class expression mixin to wrap
   * @return {T}
   * @suppress {invalidCasts}
   */
  const dedupingMixin = function (mixin) {
    let mixinApplications = /** @type {!MixinFunction} */mixin.__mixinApplications;
    if (!mixinApplications) {
      mixinApplications = new WeakMap();
      /** @type {!MixinFunction} */
      mixin.__mixinApplications = mixinApplications;
    }
    // maintain a unique id for each mixin
    let mixinDedupeId = dedupeId$1++;
    function dedupingMixin(base) {
      let baseSet = /** @type {!MixinFunction} */base.__mixinSet;
      if (baseSet && baseSet[mixinDedupeId]) {
        return base;
      }
      let map = mixinApplications;
      let extended = map.get(base);
      if (!extended) {
        extended = /** @type {!Function} */mixin(base);
        map.set(base, extended);
        // copy inherited mixin set from the extended class, or the base class
        // NOTE: we avoid use of Set here because some browser (IE11)
        // cannot extend a base Set via the constructor.
        let mixinSet = Object.create( /** @type {!MixinFunction} */extended.__mixinSet || baseSet || null);
        mixinSet[mixinDedupeId] = true;
        /** @type {!MixinFunction} */
        extended.__mixinSet = mixinSet;
      }
      return extended;
    }
    return dedupingMixin;
  };
  /* eslint-enable valid-jsdoc */

  let modules = {};
  let lcModules = {};
  /**
   * Sets a dom-module into the global registry by id.
   *
   * @param {string} id dom-module id
   * @param {DomModule} module dom-module instance
   * @return {void}
   */
  function setModule(id, module) {
    // store id separate from lowercased id so that
    // in all cases mixedCase id will stored distinctly
    // and lowercase version is a fallback
    modules[id] = lcModules[id.toLowerCase()] = module;
  }
  /**
   * Retrieves a dom-module from the global registry by id.
   *
   * @param {string} id dom-module id
   * @return {DomModule!} dom-module instance
   */
  function findModule(id) {
    return modules[id] || lcModules[id.toLowerCase()];
  }
  function styleOutsideTemplateCheck(inst) {
    if (inst.querySelector('style')) {
      console.warn('dom-module %s has style outside template', inst.id);
    }
  }

  /**
   * The `dom-module` element registers the dom it contains to the name given
   * by the module's id attribute. It provides a unified database of dom
   * accessible via its static `import` API.
   *
   * A key use case of `dom-module` is for providing custom element `<template>`s
   * via HTML imports that are parsed by the native HTML parser, that can be
   * relocated during a bundling pass and still looked up by `id`.
   *
   * Example:
   *
   *     <dom-module id="foo">
   *       <img src="stuff.png">
   *     </dom-module>
   *
   * Then in code in some other location that cannot access the dom-module above
   *
   *     let img = customElements.get('dom-module').import('foo', 'img');
   *
   * @customElement
   * @extends HTMLElement
   * @summary Custom element that provides a registry of relocatable DOM content
   *   by `id` that is agnostic to bundling.
   * @unrestricted
   */
  let DomModule = /*#__PURE__*/function (_HTMLElement) {
    _inherits(DomModule, _HTMLElement);
    var _super = _createSuper(DomModule);
    function DomModule() {
      _classCallCheck(this, DomModule);
      return _super.apply(this, arguments);
    }
    _createClass(DomModule, [{
      key: "attributeChangedCallback",
      value: /* eslint-disable no-unused-vars */
      /**
       * @param {string} name Name of attribute.
       * @param {?string} old Old value of attribute.
       * @param {?string} value Current value of attribute.
       * @param {?string} namespace Attribute namespace.
       * @return {void}
       * @override
       */
      function attributeChangedCallback(name, old, value, namespace) {
        if (old !== value) {
          this.register();
        }
      }
      /* eslint-enable no-unused-args */

      /**
       * The absolute URL of the original location of this `dom-module`.
       *
       * This value will differ from this element's `ownerDocument` in the
       * following ways:
       * - Takes into account any `assetpath` attribute added during bundling
       *   to indicate the original location relative to the bundled location
       * - Uses the HTMLImports polyfill's `importForElement` API to ensure
       *   the path is relative to the import document's location since
       *   `ownerDocument` is not currently polyfilled
       */
    }, {
      key: "assetpath",
      get: function () {
        // Don't override existing assetpath.
        if (!this.__assetpath) {
          // note: assetpath set via an attribute must be relative to this
          // element's location; accommodate polyfilled HTMLImports
          const owner = window.HTMLImports && HTMLImports.importForElement ? HTMLImports.importForElement(this) || document : this.ownerDocument;
          const url = resolveUrl(this.getAttribute('assetpath') || '', owner.baseURI);
          this.__assetpath = pathFromUrl(url);
        }
        return this.__assetpath;
      }

      /**
       * Registers the dom-module at a given id. This method should only be called
       * when a dom-module is imperatively created. For
       * example, `document.createElement('dom-module').register('foo')`.
       * @param {string=} id The id at which to register the dom-module.
       * @return {void}
       */
    }, {
      key: "register",
      value: function register(id) {
        id = id || this.id;
        if (id) {
          // Under strictTemplatePolicy, reject and null out any re-registered
          // dom-module since it is ambiguous whether first-in or last-in is trusted
          if (strictTemplatePolicy && findModule(id) !== undefined) {
            setModule(id, null);
            throw new Error(`strictTemplatePolicy: dom-module ${id} re-registered`);
          }
          this.id = id;
          setModule(id, this);
          styleOutsideTemplateCheck(this);
        }
      }
    }], [{
      key: "observedAttributes",
      get: /** @override */
      function () {
        return ['id'];
      }

      /**
       * Retrieves the element specified by the css `selector` in the module
       * registered by `id`. For example, this.import('foo', 'img');
       * @param {string} id The id of the dom-module in which to search.
       * @param {string=} selector The css selector by which to find the element.
       * @return {Element} Returns the element which matches `selector` in the
       * module registered at the specified `id`.
       *
       * @export
       * @nocollapse Referred to indirectly in style-gather.js
       */
    }, {
      key: "import",
      value: function _import(id, selector) {
        if (id) {
          let m = findModule(id);
          if (m && selector) {
            return m.querySelector(selector);
          }
          return m;
        }
        return null;
      }
    }]);
    return DomModule;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  DomModule.prototype['modules'] = modules;
  // customElements.define('dom-module', DomModule);

  const MODULE_STYLE_LINK_SELECTOR = 'link[rel=import][type~=css]';
  const INCLUDE_ATTR = 'include';
  const SHADY_UNSCOPED_ATTR = 'shady-unscoped';

  /**
   * @param {string} moduleId .
   * @return {?DomModule} .
   */
  function importModule(moduleId) {
    return (/** @type {?DomModule} */DomModule.import(moduleId)
    );
  }
  function styleForImport(importDoc) {
    // NOTE: polyfill affordance.
    // under the HTMLImports polyfill, there will be no 'body',
    // but the import pseudo-doc can be used directly.
    let container = importDoc.body ? importDoc.body : importDoc;
    const importCss = resolveCss(container.textContent, importDoc.baseURI);
    const style = document.createElement('style');
    style.textContent = importCss;
    return style;
  }

  /**
   * Returns a list of <style> elements in a space-separated list of `dom-module`s.
   *
   * @function
   * @param {string} moduleIds List of dom-module id's within which to
   * search for css.
   * @return {!Array<!HTMLStyleElement>} Array of contained <style> elements
   */
  function stylesFromModules(moduleIds) {
    const modules = moduleIds.trim().split(/\s+/);
    const styles = [];
    for (let i = 0; i < modules.length; i++) {
      styles.push.apply(styles, _toConsumableArray(stylesFromModule(modules[i])));
    }
    return styles;
  }

  /**
   * Returns a list of <style> elements in a given `dom-module`.
   * Styles in a `dom-module` can come either from `<style>`s within the
   * first `<template>`, or else from one or more
   * `<link rel="import" type="css">` links outside the template.
   *
   * @param {string} moduleId dom-module id to gather styles from
   * @return {!Array<!HTMLStyleElement>} Array of contained styles.
   */
  function stylesFromModule(moduleId) {
    const m = importModule(moduleId);
    if (!m) {
      console.warn('Could not find style data in module named', moduleId);
      return [];
    }
    if (m._styles === undefined) {
      const styles = [];
      // module imports: <link rel="import" type="css">
      styles.push.apply(styles, _toConsumableArray(_stylesFromModuleImports(m)));
      // include css from the first template in the module
      const template = /** @type {?HTMLTemplateElement} */
      m.querySelector('template');
      if (template) {
        styles.push.apply(styles, _toConsumableArray(stylesFromTemplate(template, /** @type {templateWithAssetPath} */m.assetpath)));
      }
      m._styles = styles;
    }
    return m._styles;
  }

  /**
   * Returns the `<style>` elements within a given template.
   *
   * @param {!HTMLTemplateElement} template Template to gather styles from
   * @param {string=} baseURI baseURI for style content
   * @return {!Array<!HTMLStyleElement>} Array of styles
   */
  function stylesFromTemplate(template, baseURI) {
    if (!template._styles) {
      const styles = [];
      // if element is a template, get content from its .content
      const e$ = template.content.querySelectorAll('style');
      for (let i = 0; i < e$.length; i++) {
        let e = e$[i];
        // support style sharing by allowing styles to "include"
        // other dom-modules that contain styling
        let include = e.getAttribute(INCLUDE_ATTR);
        if (include) {
          styles.push.apply(styles, _toConsumableArray(stylesFromModules(include).filter(function (item, index, self) {
            return self.indexOf(item) === index;
          })));
        }
        if (baseURI) {
          e.textContent = resolveCss(e.textContent, /** @type {string} */baseURI);
        }
        styles.push(e);
      }
      template._styles = styles;
    }
    return template._styles;
  }

  /**
   * Returns a list of <style> elements  from stylesheets loaded via `<link rel="import" type="css">` links within the specified `dom-module`.
   *
   * @param {string} moduleId Id of `dom-module` to gather CSS from
   * @return {!Array<!HTMLStyleElement>} Array of contained styles.
   */
  function stylesFromModuleImports(moduleId) {
    let m = importModule(moduleId);
    return m ? _stylesFromModuleImports(m) : [];
  }

  /**
   * @param {!HTMLElement} module dom-module element that could contain `<link rel="import" type="css">` styles
   * @return {!Array<!HTMLStyleElement>} Array of contained styles
   */
  function _stylesFromModuleImports(module) {
    const styles = [];
    const p$ = module.querySelectorAll(MODULE_STYLE_LINK_SELECTOR);
    for (let i = 0; i < p$.length; i++) {
      let p = p$[i];
      if (p.import) {
        const importDoc = p.import;
        const unscoped = p.hasAttribute(SHADY_UNSCOPED_ATTR);
        if (unscoped && !importDoc._unscopedStyle) {
          const style = styleForImport(importDoc);
          style.setAttribute(SHADY_UNSCOPED_ATTR, '');
          importDoc._unscopedStyle = style;
        } else if (!importDoc._style) {
          importDoc._style = styleForImport(importDoc);
        }
        styles.push(unscoped ? importDoc._unscopedStyle : importDoc._style);
      }
    }
    return styles;
  }

  /**
   *
   * Returns CSS text of styles in a space-separated list of `dom-module`s.
   * Note: This method is deprecated, use `stylesFromModules` instead.
   *
   * @deprecated
   * @param {string} moduleIds List of dom-module id's within which to
   * search for css.
   * @return {string} Concatenated CSS content from specified `dom-module`s
   */
  function cssFromModules(moduleIds) {
    let modules = moduleIds.trim().split(/\s+/);
    let cssText = '';
    for (let i = 0; i < modules.length; i++) {
      cssText += cssFromModule(modules[i]);
    }
    return cssText;
  }

  /**
   * Returns CSS text of styles in a given `dom-module`.  CSS in a `dom-module`
   * can come either from `<style>`s within the first `<template>`, or else
   * from one or more `<link rel="import" type="css">` links outside the
   * template.
   *
   * Any `<styles>` processed are removed from their original location.
   * Note: This method is deprecated, use `styleFromModule` instead.
   *
   * @deprecated
   * @param {string} moduleId dom-module id to gather styles from
   * @return {string} Concatenated CSS content from specified `dom-module`
   */
  function cssFromModule(moduleId) {
    let m = importModule(moduleId);
    if (m && m._cssText === undefined) {
      // module imports: <link rel="import" type="css">
      let cssText = _cssFromModuleImports(m);
      // include css from the first template in the module
      let t = /** @type {?HTMLTemplateElement} */m.querySelector('template');
      if (t) {
        cssText += cssFromTemplate(t, /** @type {templateWithAssetPath} */m.assetpath);
      }
      m._cssText = cssText || null;
    }
    if (!m) {
      console.warn('Could not find style data in module named', moduleId);
    }
    return m && m._cssText || '';
  }

  /**
   * Returns CSS text of `<styles>` within a given template.
   *
   * Any `<styles>` processed are removed from their original location.
   * Note: This method is deprecated, use `styleFromTemplate` instead.
   *
   * @deprecated
   * @param {!HTMLTemplateElement} template Template to gather styles from
   * @param {string} baseURI Base URI to resolve the URL against
   * @return {string} Concatenated CSS content from specified template
   */
  function cssFromTemplate(template, baseURI) {
    let cssText = '';
    const e$ = stylesFromTemplate(template, baseURI);
    // if element is a template, get content from its .content
    for (let i = 0; i < e$.length; i++) {
      let e = e$[i];
      if (e.parentNode) {
        e.parentNode.removeChild(e);
      }
      cssText += e.textContent;
    }
    return cssText;
  }

  /**
   * @deprecated
   * @param {!HTMLElement} module dom-module element that could contain `<link rel="import" type="css">` styles
   * @return {string} Concatenated CSS content from links in the dom-module
   */
  function _cssFromModuleImports(module) {
    let cssText = '';
    let styles = _stylesFromModuleImports(module);
    for (let i = 0; i < styles.length; i++) {
      cssText += styles[i].textContent;
    }
    return cssText;
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /* eslint-disable valid-jsdoc */
  /**
   * Node wrapper to ensure ShadowDOM safe operation regardless of polyfill
   * presence or mode. Note that with the introduction of `ShadyDOM.noPatch`,
   * a node wrapper must be used to access ShadowDOM API.
   * This is similar to using `Polymer.dom` but relies exclusively
   * on the presence of the ShadyDOM polyfill rather than requiring the loading
   * of legacy (Polymer.dom) API.
   * @type {function(Node):Node}
   */
  const wrap = window['ShadyDOM'] && window['ShadyDOM']['noPatch'] && window['ShadyDOM']['wrap'] ? window['ShadyDOM']['wrap'] : window['ShadyDOM'] ? n => ShadyDOM['patch'](n) : n => n;

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Module with utilities for manipulating structured data path strings.
   *
   * @summary Module with utilities for manipulating structured data path strings.
   */

  /**
   * Returns true if the given string is a structured data path (has dots).
   *
   * Example:
   *
   * ```
   * isPath('foo.bar.baz') // true
   * isPath('foo')         // false
   * ```
   *
   * @param {string} path Path string
   * @return {boolean} True if the string contained one or more dots
   */
  function isPath(path) {
    return path.indexOf('.') >= 0;
  }

  /**
   * Returns the root property name for the given path.
   *
   * Example:
   *
   * ```
   * root('foo.bar.baz') // 'foo'
   * root('foo')         // 'foo'
   * ```
   *
   * @param {string} path Path string
   * @return {string} Root property name
   */
  function root(path) {
    let dotIndex = path.indexOf('.');
    if (dotIndex === -1) {
      return path;
    }
    return path.slice(0, dotIndex);
  }

  /**
   * Given `base` is `foo.bar`, `foo` is an ancestor, `foo.bar` is not
   * Returns true if the given path is an ancestor of the base path.
   *
   * Example:
   *
   * ```
   * isAncestor('foo.bar', 'foo')         // true
   * isAncestor('foo.bar', 'foo.bar')     // false
   * isAncestor('foo.bar', 'foo.bar.baz') // false
   * ```
   *
   * @param {string} base Path string to test against.
   * @param {string} path Path string to test.
   * @return {boolean} True if `path` is an ancestor of `base`.
   */
  function isAncestor(base, path) {
    //     base.startsWith(path + '.');
    return base.indexOf(path + '.') === 0;
  }

  /**
   * Given `base` is `foo.bar`, `foo.bar.baz` is an descendant
   *
   * Example:
   *
   * ```
   * isDescendant('foo.bar', 'foo.bar.baz') // true
   * isDescendant('foo.bar', 'foo.bar')     // false
   * isDescendant('foo.bar', 'foo')         // false
   * ```
   *
   * @param {string} base Path string to test against.
   * @param {string} path Path string to test.
   * @return {boolean} True if `path` is a descendant of `base`.
   */
  function isDescendant(base, path) {
    //     path.startsWith(base + '.');
    return path.indexOf(base + '.') === 0;
  }

  /**
   * Replaces a previous base path with a new base path, preserving the
   * remainder of the path.
   *
   * User must ensure `path` has a prefix of `base`.
   *
   * Example:
   *
   * ```
   * translate('foo.bar', 'zot', 'foo.bar.baz') // 'zot.baz'
   * ```
   *
   * @param {string} base Current base string to remove
   * @param {string} newBase New base string to replace with
   * @param {string} path Path to translate
   * @return {string} Translated string
   */
  function translate(base, newBase, path) {
    return newBase + path.slice(base.length);
  }

  /**
   * @param {string} base Path string to test against
   * @param {string} path Path string to test
   * @return {boolean} True if `path` is equal to `base`
   */
  function matches$2(base, path) {
    return base === path || isAncestor(base, path) || isDescendant(base, path);
  }

  /**
   * Converts array-based paths to flattened path.  String-based paths
   * are returned as-is.
   *
   * Example:
   *
   * ```
   * normalize(['foo.bar', 0, 'baz'])  // 'foo.bar.0.baz'
   * normalize('foo.bar.0.baz')        // 'foo.bar.0.baz'
   * ```
   *
   * @param {string | !Array<string|number>} path Input path
   * @return {string} Flattened path
   */
  function normalize(path) {
    if (Array.isArray(path)) {
      let parts = [];
      for (let i = 0; i < path.length; i++) {
        let args = path[i].toString().split('.');
        for (let j = 0; j < args.length; j++) {
          parts.push(args[j]);
        }
      }
      return parts.join('.');
    } else {
      return path;
    }
  }

  /**
   * Splits a path into an array of property names. Accepts either arrays
   * of path parts or strings.
   *
   * Example:
   *
   * ```
   * split(['foo.bar', 0, 'baz'])  // ['foo', 'bar', '0', 'baz']
   * split('foo.bar.0.baz')        // ['foo', 'bar', '0', 'baz']
   * ```
   *
   * @param {string | !Array<string|number>} path Input path
   * @return {!Array<string>} Array of path parts
   * @suppress {checkTypes}
   */
  function split(path) {
    if (Array.isArray(path)) {
      return normalize(path).split('.');
    }
    return path.toString().split('.');
  }

  /**
   * Reads a value from a path.  If any sub-property in the path is `undefined`,
   * this method returns `undefined` (will never throw.
   *
   * @param {Object} root Object from which to dereference path from
   * @param {string | !Array<string|number>} path Path to read
   * @param {Object=} info If an object is provided to `info`, the normalized
   *  (flattened) path will be set to `info.path`.
   * @return {*} Value at path, or `undefined` if the path could not be
   *  fully dereferenced.
   */
  function get(root, path, info) {
    let prop = root;
    let parts = split(path);
    // Loop over path parts[0..n-1] and dereference
    for (let i = 0; i < parts.length; i++) {
      if (!prop) {
        return;
      }
      let part = parts[i];
      prop = prop[part];
    }
    if (info) {
      info.path = parts.join('.');
    }
    return prop;
  }

  /**
   * Sets a value to a path.  If any sub-property in the path is `undefined`,
   * this method will no-op.
   *
   * @param {Object} root Object from which to dereference path from
   * @param {string | !Array<string|number>} path Path to set
   * @param {*} value Value to set to path
   * @return {string | undefined} The normalized version of the input path
   */
  function set(root, path, value) {
    let prop = root;
    let parts = split(path);
    let last = parts[parts.length - 1];
    if (parts.length > 1) {
      // Loop over path parts[0..n-2] and dereference
      for (let i = 0; i < parts.length - 1; i++) {
        let part = parts[i];
        prop = prop[part];
        if (!prop) {
          return;
        }
      }
      // Set value to object at end of path
      prop[last] = value;
    } else {
      // Simple property set
      prop[path] = value;
    }
    return parts.join('.');
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  const caseMap = {};
  const DASH_TO_CAMEL = /-[a-z]/g;
  const CAMEL_TO_DASH = /([A-Z])/g;

  /**
   * @fileoverview Module with utilities for converting between "dash-case" and
   * "camelCase" identifiers.
   */

  /**
   * Converts "dash-case" identifier (e.g. `foo-bar-baz`) to "camelCase"
   * (e.g. `fooBarBaz`).
   *
   * @param {string} dash Dash-case identifier
   * @return {string} Camel-case representation of the identifier
   */
  function dashToCamelCase(dash) {
    return caseMap[dash] || (caseMap[dash] = dash.indexOf('-') < 0 ? dash : dash.replace(DASH_TO_CAMEL, m => m[1].toUpperCase()));
  }

  /**
   * Converts "camelCase" identifier (e.g. `fooBarBaz`) to "dash-case"
   * (e.g. `foo-bar-baz`).
   *
   * @param {string} camel Camel-case identifier
   * @return {string} Dash-case representation of the identifier
   */
  function camelToDashCase(camel) {
    return caseMap[camel] || (caseMap[camel] = camel.replace(CAMEL_TO_DASH, '-$1').toLowerCase());
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  // Microtask implemented using Mutation Observer
  let microtaskCurrHandle = 0;
  let microtaskLastHandle = 0;
  let microtaskCallbacks = [];
  let microtaskNodeContent = 0;
  let microtaskScheduled = false;
  let microtaskNode = document.createTextNode('');
  new window.MutationObserver(microtaskFlush).observe(microtaskNode, {
    characterData: true
  });
  function microtaskFlush() {
    microtaskScheduled = false;
    const len = microtaskCallbacks.length;
    for (let i = 0; i < len; i++) {
      let cb = microtaskCallbacks[i];
      if (cb) {
        try {
          cb();
        } catch (e) {
          setTimeout(() => {
            throw e;
          });
        }
      }
    }
    microtaskCallbacks.splice(0, len);
    microtaskLastHandle += len;
  }

  /**
   * Async interface wrapper around `setTimeout`.
   *
   * @namespace
   * @summary Async interface wrapper around `setTimeout`.
   */
  const timeOut = {
    /**
     * Returns a sub-module with the async interface providing the provided
     * delay.
     *
     * @memberof timeOut
     * @param {number=} delay Time to wait before calling callbacks in ms
     * @return {!AsyncInterface} An async timeout interface
     */
    after(delay) {
      return {
        run(fn) {
          return window.setTimeout(fn, delay);
        },
        cancel(handle) {
          window.clearTimeout(handle);
        }
      };
    },
    /**
     * Enqueues a function called in the next task.
     *
     * @memberof timeOut
     * @param {!Function} fn Callback to run
     * @param {number=} delay Delay in milliseconds
     * @return {number} Handle used for canceling task
     */
    run(fn, delay) {
      return window.setTimeout(fn, delay);
    },
    /**
     * Cancels a previously enqueued `timeOut` callback.
     *
     * @memberof timeOut
     * @param {number} handle Handle returned from `run` of callback to cancel
     * @return {void}
     */
    cancel(handle) {
      window.clearTimeout(handle);
    }
  };

  /**
   * Async interface for enqueuing callbacks that run at microtask timing.
   *
   * Note that microtask timing is achieved via a single `MutationObserver`,
   * and thus callbacks enqueued with this API will all run in a single
   * batch, and not interleaved with other microtasks such as promises.
   * Promises are avoided as an implementation choice for the time being
   * due to Safari bugs that cause Promises to lack microtask guarantees.
   *
   * @namespace
   * @summary Async interface for enqueuing callbacks that run at microtask
   *   timing.
   */
  const microTask = {
    /**
     * Enqueues a function called at microtask timing.
     *
     * @memberof microTask
     * @param {!Function=} callback Callback to run
     * @return {number} Handle used for canceling task
     */
    run(callback) {
      if (!microtaskScheduled) {
        microtaskScheduled = true;
        microtaskNode.textContent = microtaskNodeContent++;
      }
      microtaskCallbacks.push(callback);
      return microtaskCurrHandle++;
    },
    /**
     * Cancels a previously enqueued `microTask` callback.
     *
     * @memberof microTask
     * @param {number} handle Handle returned from `run` of callback to cancel
     * @return {void}
     */
    cancel(handle) {
      const idx = handle - microtaskLastHandle;
      if (idx >= 0) {
        if (!microtaskCallbacks[idx]) {
          throw new Error('invalid async handle: ' + handle);
        }
        microtaskCallbacks[idx] = null;
      }
    }
  };

  /** @const {!AsyncInterface} */
  const microtask = microTask;

  /**
   * Element class mixin that provides basic meta-programming for creating one
   * or more property accessors (getter/setter pair) that enqueue an async
   * (batched) `_propertiesChanged` callback.
   *
   * For basic usage of this mixin, call `MyClass.createProperties(props)`
   * once at class definition time to create property accessors for properties
   * named in props, implement `_propertiesChanged` to react as desired to
   * property changes, and implement `static get observedAttributes()` and
   * include lowercase versions of any property names that should be set from
   * attributes. Last, call `this._enableProperties()` in the element's
   * `connectedCallback` to enable the accessors.
   *
   * @mixinFunction
   * @polymer
   * @summary Element class mixin for reacting to property changes from
   *   generated property accessors.
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const PropertiesChanged = dedupingMixin(
  /**
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  superClass => {
    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_PropertiesChanged}
     * @unrestricted
     */let PropertiesChanged = /*#__PURE__*/function (_superClass) {
      _inherits(PropertiesChanged, _superClass);
      var _super = _createSuper(PropertiesChanged);
      function PropertiesChanged() {
        var _this;
        _classCallCheck(this, PropertiesChanged);
        _this = _super.call(this);
        /** @type {boolean} */
        _this.__dataEnabled = false;
        _this.__dataReady = false;
        _this.__dataInvalid = false;
        _this.__data = {};
        _this.__dataPending = null;
        _this.__dataOld = null;
        _this.__dataInstanceProps = null;
        /** @type {number} */
        // NOTE: used to track re-entrant calls to `_flushProperties`
        _this.__dataCounter = 0;
        _this.__serializing = false;
        _this._initializeProperties();
        return _this;
      }

      /**
       * Lifecycle callback called when properties are enabled via
       * `_enableProperties`.
       *
       * Users may override this function to implement behavior that is
       * dependent on the element having its property data initialized, e.g.
       * from defaults (initialized from `constructor`, `_initializeProperties`),
       * `attributeChangedCallback`, or values propagated from host e.g. via
       * bindings.  `super.ready()` must be called to ensure the data system
       * becomes enabled.
       *
       * @return {void}
       * @public
       * @override
       */
      _createClass(PropertiesChanged, [{
        key: "_createPropertyAccessor",
        value:
        //eslint-disable-line no-unused-vars

        /**
         * Creates a setter/getter pair for the named property with its own
         * local storage.  The getter returns the value in the local storage,
         * and the setter calls `_setProperty`, which updates the local storage
         * for the property and enqueues a `_propertiesChanged` callback.
         *
         * This method may be called on a prototype or an instance.  Calling
         * this method may overwrite a property value that already exists on
         * the prototype/instance by creating the accessor.
         *
         * @param {string} property Name of the property
         * @param {boolean=} readOnly When true, no setter is created; the
         *   protected `_setProperty` function must be used to set the property
         * @return {void}
         * @protected
         * @override
         */
        function _createPropertyAccessor(property, readOnly) {
          this._addPropertyToAttributeMap(property);
          if (!this.hasOwnProperty(JSCompiler_renameProperty('__dataHasAccessor', this))) {
            this.__dataHasAccessor = Object.assign({}, this.__dataHasAccessor);
          }
          if (!this.__dataHasAccessor[property]) {
            this.__dataHasAccessor[property] = true;
            this._definePropertyAccessor(property, readOnly);
          }
        }

        /**
         * Adds the given `property` to a map matching attribute names
         * to property names, using `attributeNameForProperty`. This map is
         * used when deserializing attribute values to properties.
         *
         * @param {string} property Name of the property
         * @override
         */
      }, {
        key: "_addPropertyToAttributeMap",
        value: function _addPropertyToAttributeMap(property) {
          if (!this.hasOwnProperty(JSCompiler_renameProperty('__dataAttributes', this))) {
            this.__dataAttributes = Object.assign({}, this.__dataAttributes);
          }
          // This check is technically not correct; it's an optimization that
          // assumes that if a _property_ name is already in the map (note this is
          // an attr->property map), the property mapped directly to the attribute
          // and it has already been mapped.  This would fail if
          // `attributeNameForProperty` were overridden such that this was not the
          // case.
          let attr = this.__dataAttributes[property];
          if (!attr) {
            attr = this.constructor.attributeNameForProperty(property);
            this.__dataAttributes[attr] = property;
          }
          return attr;
        }

        /**
         * Defines a property accessor for the given property.
         * @param {string} property Name of the property
         * @param {boolean=} readOnly When true, no setter is created
         * @return {void}
         * @override
         */
      }, {
        key: "_definePropertyAccessor",
        value: function _definePropertyAccessor(property, readOnly) {
          Object.defineProperty(this, property, {
            /* eslint-disable valid-jsdoc */
            /** @this {PropertiesChanged} */
            get() {
              // Inline for perf instead of using `_getProperty`
              return this.__data[property];
            },
            /** @this {PropertiesChanged} */
            set: readOnly ? function () {} : function (value) {
              // Inline for perf instead of using `_setProperty`
              if (this._setPendingProperty(property, value, true)) {
                this._invalidateProperties();
              }
            }
            /* eslint-enable */
          });
        }
      }, {
        key: "ready",
        value: function ready() {
          this.__dataReady = true;
          this._flushProperties();
        }

        /**
         * Initializes the local storage for property accessors.
         *
         * Provided as an override point for performing any setup work prior
         * to initializing the property accessor system.
         *
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_initializeProperties",
        value: function _initializeProperties() {
          // Capture instance properties; these will be set into accessors
          // during first flush. Don't set them here, since we want
          // these to overwrite defaults/constructor assignments
          for (let p in this.__dataHasAccessor) {
            if (this.hasOwnProperty(p)) {
              this.__dataInstanceProps = this.__dataInstanceProps || {};
              this.__dataInstanceProps[p] = this[p];
              delete this[p];
            }
          }
        }

        /**
         * Called at ready time with bag of instance properties that overwrote
         * accessors when the element upgraded.
         *
         * The default implementation sets these properties back into the
         * setter at ready time.  This method is provided as an override
         * point for customizing or providing more efficient initialization.
         *
         * @param {Object} props Bag of property values that were overwritten
         *   when creating property accessors.
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_initializeInstanceProperties",
        value: function _initializeInstanceProperties(props) {
          Object.assign(this, props);
        }

        /**
         * Updates the local storage for a property (via `_setPendingProperty`)
         * and enqueues a `_proeprtiesChanged` callback.
         *
         * @param {string} property Name of the property
         * @param {*} value Value to set
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_setProperty",
        value: function _setProperty(property, value) {
          if (this._setPendingProperty(property, value)) {
            this._invalidateProperties();
          }
        }

        /**
         * Returns the value for the given property.
         * @param {string} property Name of property
         * @return {*} Value for the given property
         * @protected
         * @override
         */
      }, {
        key: "_getProperty",
        value: function _getProperty(property) {
          return this.__data[property];
        }

        /* eslint-disable no-unused-vars */
        /**
         * Updates the local storage for a property, records the previous value,
         * and adds it to the set of "pending changes" that will be passed to the
         * `_propertiesChanged` callback.  This method does not enqueue the
         * `_propertiesChanged` callback.
         *
         * @param {string} property Name of the property
         * @param {*} value Value to set
         * @param {boolean=} ext Not used here; affordance for closure
         * @return {boolean} Returns true if the property changed
         * @protected
         * @override
         */
      }, {
        key: "_setPendingProperty",
        value: function _setPendingProperty(property, value, ext) {
          let old = this.__data[property];
          let changed = this._shouldPropertyChange(property, value, old);
          if (changed) {
            if (!this.__dataPending) {
              this.__dataPending = {};
              this.__dataOld = {};
            }
            // Ensure old is captured from the last turn
            if (this.__dataOld && !(property in this.__dataOld)) {
              this.__dataOld[property] = old;
            }
            this.__data[property] = value;
            this.__dataPending[property] = value;
          }
          return changed;
        }
        /* eslint-enable */

        /**
         * @param {string} property Name of the property
         * @return {boolean} Returns true if the property is pending.
         */
      }, {
        key: "_isPropertyPending",
        value: function _isPropertyPending(property) {
          return !!(this.__dataPending && this.__dataPending.hasOwnProperty(property));
        }

        /**
         * Marks the properties as invalid, and enqueues an async
         * `_propertiesChanged` callback.
         *
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_invalidateProperties",
        value: function _invalidateProperties() {
          if (!this.__dataInvalid && this.__dataReady) {
            this.__dataInvalid = true;
            microtask.run(() => {
              if (this.__dataInvalid) {
                this.__dataInvalid = false;
                this._flushProperties();
              }
            });
          }
        }

        /**
         * Call to enable property accessor processing. Before this method is
         * called accessor values will be set but side effects are
         * queued. When called, any pending side effects occur immediately.
         * For elements, generally `connectedCallback` is a normal spot to do so.
         * It is safe to call this method multiple times as it only turns on
         * property accessors once.
         *
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_enableProperties",
        value: function _enableProperties() {
          if (!this.__dataEnabled) {
            this.__dataEnabled = true;
            if (this.__dataInstanceProps) {
              this._initializeInstanceProperties(this.__dataInstanceProps);
              this.__dataInstanceProps = null;
            }
            this.ready();
          }
        }

        /**
         * Calls the `_propertiesChanged` callback with the current set of
         * pending changes (and old values recorded when pending changes were
         * set), and resets the pending set of changes. Generally, this method
         * should not be called in user code.
         *
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_flushProperties",
        value: function _flushProperties() {
          this.__dataCounter++;
          const props = this.__data;
          const changedProps = this.__dataPending;
          const old = this.__dataOld;
          if (this._shouldPropertiesChange(props, changedProps, old)) {
            this.__dataPending = null;
            this.__dataOld = null;
            this._propertiesChanged(props, changedProps, old);
          }
          this.__dataCounter--;
        }

        /**
         * Called in `_flushProperties` to determine if `_propertiesChanged`
         * should be called. The default implementation returns true if
         * properties are pending. Override to customize when
         * `_propertiesChanged` is called.
         * @param {!Object} currentProps Bag of all current accessor values
         * @param {?Object} changedProps Bag of properties changed since the last
         *   call to `_propertiesChanged`
         * @param {?Object} oldProps Bag of previous values for each property
         *   in `changedProps`
         * @return {boolean} true if changedProps is truthy
         * @override
         */
      }, {
        key: "_shouldPropertiesChange",
        value: function _shouldPropertiesChange(currentProps, changedProps, oldProps) {
          // eslint-disable-line no-unused-vars
          return Boolean(changedProps);
        }

        /**
         * Callback called when any properties with accessors created via
         * `_createPropertyAccessor` have been set.
         *
         * @param {!Object} currentProps Bag of all current accessor values
         * @param {?Object} changedProps Bag of properties changed since the last
         *   call to `_propertiesChanged`
         * @param {?Object} oldProps Bag of previous values for each property
         *   in `changedProps`
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_propertiesChanged",
        value: function _propertiesChanged(currentProps, changedProps, oldProps) {// eslint-disable-line no-unused-vars
        }

        /**
         * Method called to determine whether a property value should be
         * considered as a change and cause the `_propertiesChanged` callback
         * to be enqueued.
         *
         * The default implementation returns `true` if a strict equality
         * check fails. The method always returns false for `NaN`.
         *
         * Override this method to e.g. provide stricter checking for
         * Objects/Arrays when using immutable patterns.
         *
         * @param {string} property Property name
         * @param {*} value New property value
         * @param {*} old Previous property value
         * @return {boolean} Whether the property should be considered a change
         *   and enqueue a `_proeprtiesChanged` callback
         * @protected
         * @override
         */
      }, {
        key: "_shouldPropertyChange",
        value: function _shouldPropertyChange(property, value, old) {
          return (
            // Strict equality check
            old !== value && (
            // This ensures (old==NaN, value==NaN) always returns false
            old === old || value === value)
          );
        }

        /**
         * Implements native Custom Elements `attributeChangedCallback` to
         * set an attribute value to a property via `_attributeToProperty`.
         *
         * @param {string} name Name of attribute that changed
         * @param {?string} old Old attribute value
         * @param {?string} value New attribute value
         * @param {?string} namespace Attribute namespace.
         * @return {void}
         * @suppress {missingProperties} Super may or may not implement the callback
         * @override
         */
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, old, value, namespace) {
          if (old !== value) {
            this._attributeToProperty(name, value);
          }
          if (_get(_getPrototypeOf(PropertiesChanged.prototype), "attributeChangedCallback", this)) {
            _get(_getPrototypeOf(PropertiesChanged.prototype), "attributeChangedCallback", this).call(this, name, old, value, namespace);
          }
        }

        /**
         * Deserializes an attribute to its associated property.
         *
         * This method calls the `_deserializeValue` method to convert the string to
         * a typed value.
         *
         * @param {string} attribute Name of attribute to deserialize.
         * @param {?string} value of the attribute.
         * @param {*=} type type to deserialize to, defaults to the value
         * returned from `typeForProperty`
         * @return {void}
         * @override
         */
      }, {
        key: "_attributeToProperty",
        value: function _attributeToProperty(attribute, value, type) {
          if (!this.__serializing) {
            const map = this.__dataAttributes;
            const property = map && map[attribute] || attribute;
            this[property] = this._deserializeValue(value, type || this.constructor.typeForProperty(property));
          }
        }

        /**
         * Serializes a property to its associated attribute.
         *
         * @suppress {invalidCasts} Closure can't figure out `this` is an element.
         *
         * @param {string} property Property name to reflect.
         * @param {string=} attribute Attribute name to reflect to.
         * @param {*=} value Property value to refect.
         * @return {void}
         * @override
         */
      }, {
        key: "_propertyToAttribute",
        value: function _propertyToAttribute(property, attribute, value) {
          this.__serializing = true;
          value = arguments.length < 3 ? this[property] : value;
          this._valueToNodeAttribute( /** @type {!HTMLElement} */this, value, attribute || this.constructor.attributeNameForProperty(property));
          this.__serializing = false;
        }

        /**
         * Sets a typed value to an HTML attribute on a node.
         *
         * This method calls the `_serializeValue` method to convert the typed
         * value to a string.  If the `_serializeValue` method returns `undefined`,
         * the attribute will be removed (this is the default for boolean
         * type `false`).
         *
         * @param {Element} node Element to set attribute to.
         * @param {*} value Value to serialize.
         * @param {string} attribute Attribute name to serialize to.
         * @return {void}
         * @override
         */
      }, {
        key: "_valueToNodeAttribute",
        value: function _valueToNodeAttribute(node, value, attribute) {
          const str = this._serializeValue(value);
          if (attribute === 'class' || attribute === 'name' || attribute === 'slot') {
            node = /** @type {?Element} */wrap(node);
          }
          if (str === undefined) {
            node.removeAttribute(attribute);
          } else {
            node.setAttribute(attribute,
            // Closure's type for `setAttribute`'s second parameter incorrectly
            // excludes `TrustedScript`.
            str === '' && window.trustedTypes ? /** @type {?} */window.trustedTypes.emptyScript : str);
          }
        }

        /**
         * Converts a typed JavaScript value to a string.
         *
         * This method is called when setting JS property values to
         * HTML attributes.  Users may override this method to provide
         * serialization for custom types.
         *
         * @param {*} value Property value to serialize.
         * @return {string | undefined} String serialized from the provided
         * property  value.
         * @override
         */
      }, {
        key: "_serializeValue",
        value: function _serializeValue(value) {
          switch (typeof value) {
            case 'boolean':
              return value ? '' : undefined;
            default:
              return value != null ? value.toString() : undefined;
          }
        }

        /**
         * Converts a string to a typed JavaScript value.
         *
         * This method is called when reading HTML attribute values to
         * JS properties.  Users may override this method to provide
         * deserialization for custom `type`s. Types for `Boolean`, `String`,
         * and `Number` convert attributes to the expected types.
         *
         * @param {?string} value Value to deserialize.
         * @param {*=} type Type to deserialize the string to.
         * @return {*} Typed value deserialized from the provided string.
         * @override
         */
      }, {
        key: "_deserializeValue",
        value: function _deserializeValue(value, type) {
          switch (type) {
            case Boolean:
              return value !== null;
            case Number:
              return Number(value);
            default:
              return value;
          }
        }
      }], [{
        key: "createProperties",
        value:
        /**
         * Creates property accessors for the given property names.
         * @param {!Object} props Object whose keys are names of accessors.
         * @return {void}
         * @protected
         * @nocollapse
         */
        function createProperties(props) {
          const proto = this.prototype;
          for (let prop in props) {
            // don't stomp an existing accessor
            if (!(prop in proto)) {
              proto._createPropertyAccessor(prop);
            }
          }
        }

        /**
         * Returns an attribute name that corresponds to the given property.
         * The attribute name is the lowercased property name. Override to
         * customize this mapping.
         * @param {string} property Property to convert
         * @return {string} Attribute name corresponding to the given property.
         *
         * @protected
         * @nocollapse
         */
      }, {
        key: "attributeNameForProperty",
        value: function attributeNameForProperty(property) {
          return property.toLowerCase();
        }

        /**
         * Override point to provide a type to which to deserialize a value to
         * a given property.
         * @param {string} name Name of property
         *
         * @protected
         * @nocollapse
         */
      }, {
        key: "typeForProperty",
        value: function typeForProperty(name) {}
      }]);
      return PropertiesChanged;
    }(superClass);
    return PropertiesChanged;
  });

  // Save map of native properties; this forms a blacklist or properties
  // that won't have their values "saved" by `saveAccessorValue`, since
  // reading from an HTMLElement accessor from the context of a prototype throws
  const nativeProperties = {};
  let proto = HTMLElement.prototype;
  while (proto) {
    let props = Object.getOwnPropertyNames(proto);
    for (let i = 0; i < props.length; i++) {
      nativeProperties[props[i]] = true;
    }
    proto = Object.getPrototypeOf(proto);
  }
  const isTrustedType = (() => {
    if (!window.trustedTypes) {
      return () => false;
    }
    return val => trustedTypes.isHTML(val) || trustedTypes.isScript(val) || trustedTypes.isScriptURL(val);
  })();

  /**
   * Used to save the value of a property that will be overridden with
   * an accessor. If the `model` is a prototype, the values will be saved
   * in `__dataProto`, and it's up to the user (or downstream mixin) to
   * decide how/when to set these values back into the accessors.
   * If `model` is already an instance (it has a `__data` property), then
   * the value will be set as a pending property, meaning the user should
   * call `_invalidateProperties` or `_flushProperties` to take effect
   *
   * @param {Object} model Prototype or instance
   * @param {string} property Name of property
   * @return {void}
   * @private
   */
  function saveAccessorValue(model, property) {
    // Don't read/store value for any native properties since they could throw
    if (!nativeProperties[property]) {
      let value = model[property];
      if (value !== undefined) {
        if (model.__data) {
          // Adding accessor to instance; update the property
          // It is the user's responsibility to call _flushProperties
          model._setPendingProperty(property, value);
        } else {
          // Adding accessor to proto; save proto's value for instance-time use
          if (!model.__dataProto) {
            model.__dataProto = {};
          } else if (!model.hasOwnProperty(JSCompiler_renameProperty('__dataProto', model))) {
            model.__dataProto = Object.create(model.__dataProto);
          }
          model.__dataProto[property] = value;
        }
      }
    }
  }

  /**
   * Element class mixin that provides basic meta-programming for creating one
   * or more property accessors (getter/setter pair) that enqueue an async
   * (batched) `_propertiesChanged` callback.
   *
   * For basic usage of this mixin:
   *
   * -   Declare attributes to observe via the standard `static get
   *     observedAttributes()`. Use `dash-case` attribute names to represent
   *     `camelCase` property names.
   * -   Implement the `_propertiesChanged` callback on the class.
   * -   Call `MyClass.createPropertiesForAttributes()` **once** on the class to
   *     generate property accessors for each observed attribute. This must be
   *     called before the first instance is created, for example, by calling it
   *     before calling `customElements.define`. It can also be called lazily from
   *     the element's `constructor`, as long as it's guarded so that the call is
   *     only made once, when the first instance is created.
   * -   Call `this._enableProperties()` in the element's `connectedCallback` to
   *     enable the accessors.
   *
   * Any `observedAttributes` will automatically be
   * deserialized via `attributeChangedCallback` and set to the associated
   * property using `dash-case`-to-`camelCase` convention.
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin PropertiesChanged
   * @summary Element class mixin for reacting to property changes from
   *   generated property accessors.
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const PropertyAccessors = dedupingMixin(superClass => {
    /**
     * @constructor
     * @implements {Polymer_PropertiesChanged}
     * @unrestricted
     * @private
     */
    const base = PropertiesChanged(superClass);

    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_PropertyAccessors}
     * @extends {base}
     * @unrestricted
     */
    let PropertyAccessors = /*#__PURE__*/function (_base) {
      _inherits(PropertyAccessors, _base);
      var _super = _createSuper(PropertyAccessors);
      function PropertyAccessors() {
        _classCallCheck(this, PropertyAccessors);
        return _super.apply(this, arguments);
      }
      _createClass(PropertyAccessors, [{
        key: "_initializeProperties",
        value:
        /**
         * Overrides PropertiesChanged implementation to initialize values for
         * accessors created for values that already existed on the element
         * prototype.
         *
         * @return {void}
         * @protected
         * @override
         */
        function _initializeProperties() {
          if (this.__dataProto) {
            this._initializeProtoProperties(this.__dataProto);
            this.__dataProto = null;
          }
          _get(_getPrototypeOf(PropertyAccessors.prototype), "_initializeProperties", this).call(this);
        }

        /**
         * Called at instance time with bag of properties that were overwritten
         * by accessors on the prototype when accessors were created.
         *
         * The default implementation sets these properties back into the
         * setter at instance time.  This method is provided as an override
         * point for customizing or providing more efficient initialization.
         *
         * @param {Object} props Bag of property values that were overwritten
         *   when creating property accessors.
         * @return {void}
         * @protected
         * @override
         */
      }, {
        key: "_initializeProtoProperties",
        value: function _initializeProtoProperties(props) {
          for (let p in props) {
            this._setProperty(p, props[p]);
          }
        }

        /**
         * Ensures the element has the given attribute. If it does not,
         * assigns the given value to the attribute.
         *
         * @suppress {invalidCasts} Closure can't figure out `this` is infact an
         *     element
         *
         * @param {string} attribute Name of attribute to ensure is set.
         * @param {string} value of the attribute.
         * @return {void}
         * @override
         */
      }, {
        key: "_ensureAttribute",
        value: function _ensureAttribute(attribute, value) {
          const el = /** @type {!HTMLElement} */this;
          if (!el.hasAttribute(attribute)) {
            this._valueToNodeAttribute(el, value, attribute);
          }
        }

        /**
         * Overrides PropertiesChanged implemention to serialize objects as JSON.
         *
         * @param {*} value Property value to serialize.
         * @return {string | undefined} String serialized from the provided property
         *     value.
         * @override
         */
      }, {
        key: "_serializeValue",
        value: function _serializeValue(value) {
          /* eslint-disable no-fallthrough */
          switch (typeof value) {
            case 'object':
              if (value instanceof Date) {
                return value.toString();
              } else if (value) {
                if (isTrustedType(value)) {
                  /**
                   * Here `value` isn't actually a string, but it should be
                   * passed into APIs that normally expect a string, like
                   * elem.setAttribute.
                   */
                  return (/** @type {?} */value
                  );
                }
                try {
                  return JSON.stringify(value);
                } catch (x) {
                  return '';
                }
              }
            default:
              return _get(_getPrototypeOf(PropertyAccessors.prototype), "_serializeValue", this).call(this, value);
          }
        }

        /**
         * Converts a string to a typed JavaScript value.
         *
         * This method is called by Polymer when reading HTML attribute values to
         * JS properties.  Users may override this method on Polymer element
         * prototypes to provide deserialization for custom `type`s.  Note,
         * the `type` argument is the value of the `type` field provided in the
         * `properties` configuration object for a given property, and is
         * by convention the constructor for the type to deserialize.
         *
         *
         * @param {?string} value Attribute value to deserialize.
         * @param {*=} type Type to deserialize the string to.
         * @return {*} Typed value deserialized from the provided string.
         * @override
         */
      }, {
        key: "_deserializeValue",
        value: function _deserializeValue(value, type) {
          /**
           * @type {*}
           */
          let outValue;
          switch (type) {
            case Object:
              try {
                outValue = JSON.parse( /** @type {string} */value);
              } catch (x) {
                // allow non-JSON literals like Strings and Numbers
                outValue = value;
              }
              break;
            case Array:
              try {
                outValue = JSON.parse( /** @type {string} */value);
              } catch (x) {
                outValue = null;
                console.warn(`Polymer::Attributes: couldn't decode Array as JSON: ${value}`);
              }
              break;
            case Date:
              outValue = isNaN(value) ? String(value) : Number(value);
              outValue = new Date(outValue);
              break;
            default:
              outValue = _get(_getPrototypeOf(PropertyAccessors.prototype), "_deserializeValue", this).call(this, value, type);
              break;
          }
          return outValue;
        }
        /* eslint-enable no-fallthrough */

        /**
         * Overrides PropertiesChanged implementation to save existing prototype
         * property value so that it can be reset.
         * @param {string} property Name of the property
         * @param {boolean=} readOnly When true, no setter is created
         *
         * When calling on a prototype, any overwritten values are saved in
         * `__dataProto`, and it is up to the subclasser to decide how/when
         * to set those properties back into the accessor.  When calling on an
         * instance, the overwritten value is set via `_setPendingProperty`,
         * and the user should call `_invalidateProperties` or `_flushProperties`
         * for the values to take effect.
         * @protected
         * @return {void}
         * @override
         */
      }, {
        key: "_definePropertyAccessor",
        value: function _definePropertyAccessor(property, readOnly) {
          saveAccessorValue(this, property);
          _get(_getPrototypeOf(PropertyAccessors.prototype), "_definePropertyAccessor", this).call(this, property, readOnly);
        }

        /**
         * Returns true if this library created an accessor for the given property.
         *
         * @param {string} property Property name
         * @return {boolean} True if an accessor was created
         * @override
         */
      }, {
        key: "_hasAccessor",
        value: function _hasAccessor(property) {
          return this.__dataHasAccessor && this.__dataHasAccessor[property];
        }

        /**
         * Returns true if the specified property has a pending change.
         *
         * @param {string} prop Property name
         * @return {boolean} True if property has a pending change
         * @protected
         * @override
         */
      }, {
        key: "_isPropertyPending",
        value: function _isPropertyPending(prop) {
          return Boolean(this.__dataPending && prop in this.__dataPending);
        }
      }], [{
        key: "createPropertiesForAttributes",
        value:
        /**
         * Generates property accessors for all attributes in the standard
         * static `observedAttributes` array.
         *
         * Attribute names are mapped to property names using the `dash-case` to
         * `camelCase` convention
         *
         * @return {void}
         * @nocollapse
         */
        function createPropertiesForAttributes() {
          let a$ = /** @type {?} */this.observedAttributes;
          for (let i = 0; i < a$.length; i++) {
            this.prototype._createPropertyAccessor(dashToCamelCase(a$[i]));
          }
        }

        /**
         * Returns an attribute name that corresponds to the given property.
         * By default, converts camel to dash case, e.g. `fooBar` to `foo-bar`.
         * @param {string} property Property to convert
         * @return {string} Attribute name corresponding to the given property.
         *
         * @protected
         * @nocollapse
         */
      }, {
        key: "attributeNameForProperty",
        value: function attributeNameForProperty(property) {
          return camelToDashCase(property);
        }
      }]);
      return PropertyAccessors;
    }(base);
    return PropertyAccessors;
  });

  // 1.x backwards-compatible auto-wrapper for template type extensions
  // This is a clear layering violation and gives favored-nation status to
  // dom-if and dom-repeat templates.  This is a conceit we're choosing to keep
  // a.) to ease 1.x backwards-compatibility due to loss of `is`, and
  // b.) to maintain if/repeat capability in parser-constrained elements
  //     (e.g. table, select) in lieu of native CE type extensions without
  //     massive new invention in this space (e.g. directive system)
  const templateExtensions = {
    'dom-if': true,
    'dom-repeat': true
  };
  let placeholderBugDetect = false;
  let placeholderBug = false;
  function hasPlaceholderBug() {
    if (!placeholderBugDetect) {
      placeholderBugDetect = true;
      const t = document.createElement('textarea');
      t.placeholder = 'a';
      placeholderBug = t.placeholder === t.textContent;
    }
    return placeholderBug;
  }

  /**
   * Some browsers have a bug with textarea, where placeholder text is copied as
   * a textnode child of the textarea.
   *
   * If the placeholder is a binding, this can break template stamping in two
   * ways.
   *
   * One issue is that when the `placeholder` attribute is removed when the
   * binding is processed, the textnode child of the textarea is deleted, and the
   * template info tries to bind into that node.
   *
   * With `legacyOptimizations` in use, when the template is stamped and the
   * `textarea.textContent` binding is processed, no corresponding node is found
   * because it was removed during parsing. An exception is generated when this
   * binding is updated.
   *
   * With `legacyOptimizations` not in use, the template is cloned before
   * processing and this changes the above behavior. The cloned template also has
   * a value property set to the placeholder and textContent. This prevents the
   * removal of the textContent when the placeholder attribute is removed.
   * Therefore the exception does not occur. However, there is an extra
   * unnecessary binding.
   *
   * @param {!Node} node Check node for placeholder bug
   * @return {void}
   */
  function fixPlaceholder(node) {
    if (hasPlaceholderBug() && node.localName === 'textarea' && node.placeholder && node.placeholder === node.textContent) {
      node.textContent = null;
    }
  }

  /**
   * Copies an attribute from one element to another, converting the value to a
   * `TrustedScript` if it is named like a Polymer template event listener.
   *
   * @param {!Element} dest The element to set the attribute on
   * @param {!Element} src The element to read the attribute from
   * @param {string} name The name of the attribute
   */
  const copyAttributeWithTemplateEventPolicy = (() => {
    /**
     * This `TrustedTypePolicy` is used to work around a Chrome bug in the Trusted
     * Types API where any attribute that starts with `on` may only be set to a
     * `TrustedScript` value, even if that attribute would not cause an event
     * listener to be created. (See https://crbug.com/993268 for details.)
     *
     * Polymer's template system allows `<dom-if>` and `<dom-repeat>` to be
     * written using the `<template is="...">` syntax, even if there is no UA
     * support for custom element extensions of built-in elements. In doing so, it
     * copies attributes from the original `<template>` to a newly created
     * `<dom-if>` or `<dom-repeat>`, which can trigger the bug mentioned above if
     * any of those attributes uses Polymer's `on-` syntax for event listeners.
     * (Note, the value of these `on-` listeners is not evaluated as script: it is
     * the name of a member function of a component that will be used as the event
     * listener.)
     *
     * @type {!TrustedTypePolicy|undefined}
     */
    const polymerTemplateEventAttributePolicy = window.trustedTypes && window.trustedTypes.createPolicy('polymer-template-event-attribute-policy', {
      createScript: x => x
    });
    return (dest, src, name) => {
      const value = src.getAttribute(name);
      if (polymerTemplateEventAttributePolicy && name.startsWith('on-')) {
        dest.setAttribute(name, polymerTemplateEventAttributePolicy.createScript(value, name));
        return;
      }
      dest.setAttribute(name, value);
    };
  })();
  function wrapTemplateExtension(node) {
    let is = node.getAttribute('is');
    if (is && templateExtensions[is]) {
      let t = node;
      t.removeAttribute('is');
      node = t.ownerDocument.createElement(is);
      t.parentNode.replaceChild(node, t);
      node.appendChild(t);
      while (t.attributes.length) {
        const {
          name
        } = t.attributes[0];
        copyAttributeWithTemplateEventPolicy(node, t, name);
        t.removeAttribute(name);
      }
    }
    return node;
  }
  function findTemplateNode(root, nodeInfo) {
    // recursively ascend tree until we hit root
    let parent = nodeInfo.parentInfo && findTemplateNode(root, nodeInfo.parentInfo);
    // unwind the stack, returning the indexed node at each level
    if (parent) {
      // note: marginally faster than indexing via childNodes
      // (http://jsperf.com/childnodes-lookup)
      for (let n = parent.firstChild, i = 0; n; n = n.nextSibling) {
        if (nodeInfo.parentIndex === i++) {
          return n;
        }
      }
    } else {
      return root;
    }
  }

  // construct `$` map (from id annotations)
  function applyIdToMap(inst, map, node, nodeInfo) {
    if (nodeInfo.id) {
      map[nodeInfo.id] = node;
    }
  }

  // install event listeners (from event annotations)
  function applyEventListener(inst, node, nodeInfo) {
    if (nodeInfo.events && nodeInfo.events.length) {
      for (let j = 0, e$ = nodeInfo.events, e; j < e$.length && (e = e$[j]); j++) {
        inst._addMethodEventListenerToNode(node, e.name, e.value, inst);
      }
    }
  }

  // push configuration references at configure time
  function applyTemplateInfo(inst, node, nodeInfo, parentTemplateInfo) {
    if (nodeInfo.templateInfo) {
      // Give the node an instance of this templateInfo and set its parent
      node._templateInfo = nodeInfo.templateInfo;
      node._parentTemplateInfo = parentTemplateInfo;
    }
  }
  function createNodeEventHandler(context, eventName, methodName) {
    // Instances can optionally have a _methodHost which allows redirecting where
    // to find methods. Currently used by `templatize`.
    context = context._methodHost || context;
    let handler = function (e) {
      if (context[methodName]) {
        context[methodName](e, e.detail);
      } else {
        console.warn('listener method `' + methodName + '` not defined');
      }
    };
    return handler;
  }

  /**
   * Element mixin that provides basic template parsing and stamping, including
   * the following template-related features for stamped templates:
   *
   * - Declarative event listeners (`on-eventname="listener"`)
   * - Map of node id's to stamped node instances (`this.$.id`)
   * - Nested template content caching/removal and re-installation (performance
   *   optimization)
   *
   * @mixinFunction
   * @polymer
   * @summary Element class mixin that provides basic template parsing and stamping
   */
  const TemplateStamp = dedupingMixin(
  /**
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  superClass => {
    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_TemplateStamp}
     */let TemplateStamp = /*#__PURE__*/function (_superClass) {
      _inherits(TemplateStamp, _superClass);
      var _super = _createSuper(TemplateStamp);
      function TemplateStamp() {
        _classCallCheck(this, TemplateStamp);
        return _super.apply(this, arguments);
      }
      _createClass(TemplateStamp, [{
        key: "_stampTemplate",
        value:
        /**
         * Clones the provided template content and returns a document fragment
         * containing the cloned dom.
         *
         * The template is parsed (once and memoized) using this library's
         * template parsing features, and provides the following value-added
         * features:
         * * Adds declarative event listeners for `on-event="handler"` attributes
         * * Generates an "id map" for all nodes with id's under `$` on returned
         *   document fragment
         * * Passes template info including `content` back to templates as
         *   `_templateInfo` (a performance optimization to avoid deep template
         *   cloning)
         *
         * Note that the memoized template parsing process is destructive to the
         * template: attributes for bindings and declarative event listeners are
         * removed after being noted in notes, and any nested `<template>.content`
         * is removed and stored in notes as well.
         *
         * @param {!HTMLTemplateElement} template Template to stamp
         * @param {TemplateInfo=} templateInfo Optional template info associated
         *   with the template to be stamped; if omitted the template will be
         *   automatically parsed.
         * @return {!StampedTemplate} Cloned template content
         * @override
         */
        function _stampTemplate(template, templateInfo) {
          // Polyfill support: bootstrap the template if it has not already been
          if (template && !template.content && window.HTMLTemplateElement && HTMLTemplateElement.decorate) {
            HTMLTemplateElement.decorate(template);
          }
          // Accepting the `templateInfo` via an argument allows for creating
          // instances of the `templateInfo` by the caller, useful for adding
          // instance-time information to the prototypical data
          templateInfo = templateInfo || this.constructor._parseTemplate(template);
          let nodeInfo = templateInfo.nodeInfoList;
          let content = templateInfo.content || template.content;
          let dom = /** @type {DocumentFragment} */document.importNode(content, true);
          // NOTE: ShadyDom optimization indicating there is an insertion point
          dom.__noInsertionPoint = !templateInfo.hasInsertionPoint;
          let nodes = dom.nodeList = new Array(nodeInfo.length);
          dom.$ = {};
          for (let i = 0, l = nodeInfo.length, info; i < l && (info = nodeInfo[i]); i++) {
            let node = nodes[i] = findTemplateNode(dom, info);
            applyIdToMap(this, dom.$, node, info);
            applyTemplateInfo(this, node, info, templateInfo);
            applyEventListener(this, node, info);
          }
          dom = /** @type {!StampedTemplate} */dom; // eslint-disable-line no-self-assign
          return dom;
        }

        /**
         * Adds an event listener by method name for the event provided.
         *
         * This method generates a handler function that looks up the method
         * name at handling time.
         *
         * @param {!EventTarget} node Node to add listener on
         * @param {string} eventName Name of event
         * @param {string} methodName Name of method
         * @param {*=} context Context the method will be called on (defaults
         *   to `node`)
         * @return {Function} Generated handler function
         * @override
         */
      }, {
        key: "_addMethodEventListenerToNode",
        value: function _addMethodEventListenerToNode(node, eventName, methodName, context) {
          context = context || node;
          let handler = createNodeEventHandler(context, eventName, methodName);
          this._addEventListenerToNode(node, eventName, handler);
          return handler;
        }

        /**
         * Override point for adding custom or simulated event handling.
         *
         * @param {!EventTarget} node Node to add event listener to
         * @param {string} eventName Name of event
         * @param {function(!Event):void} handler Listener function to add
         * @return {void}
         * @override
         */
      }, {
        key: "_addEventListenerToNode",
        value: function _addEventListenerToNode(node, eventName, handler) {
          node.addEventListener(eventName, handler);
        }

        /**
         * Override point for adding custom or simulated event handling.
         *
         * @param {!EventTarget} node Node to remove event listener from
         * @param {string} eventName Name of event
         * @param {function(!Event):void} handler Listener function to remove
         * @return {void}
         * @override
         */
      }, {
        key: "_removeEventListenerFromNode",
        value: function _removeEventListenerFromNode(node, eventName, handler) {
          node.removeEventListener(eventName, handler);
        }
      }], [{
        key: "_parseTemplate",
        value:
        /**
         * Scans a template to produce template metadata.
         *
         * Template-specific metadata are stored in the object returned, and node-
         * specific metadata are stored in objects in its flattened `nodeInfoList`
         * array.  Only nodes in the template that were parsed as nodes of
         * interest contain an object in `nodeInfoList`.  Each `nodeInfo` object
         * contains an `index` (`childNodes` index in parent) and optionally
         * `parent`, which points to node info of its parent (including its index).
         *
         * The template metadata object returned from this method has the following
         * structure (many fields optional):
         *
         * ```js
         *   {
         *     // Flattened list of node metadata (for nodes that generated metadata)
         *     nodeInfoList: [
         *       {
         *         // `id` attribute for any nodes with id's for generating `$` map
         *         id: {string},
         *         // `on-event="handler"` metadata
         *         events: [
         *           {
         *             name: {string},   // event name
         *             value: {string},  // handler method name
         *           }, ...
         *         ],
         *         // Notes when the template contained a `<slot>` for shady DOM
         *         // optimization purposes
         *         hasInsertionPoint: {boolean},
         *         // For nested `<template>`` nodes, nested template metadata
         *         templateInfo: {object}, // nested template metadata
         *         // Metadata to allow efficient retrieval of instanced node
         *         // corresponding to this metadata
         *         parentInfo: {number},   // reference to parent nodeInfo>
         *         parentIndex: {number},  // index in parent's `childNodes` collection
         *         infoIndex: {number},    // index of this `nodeInfo` in `templateInfo.nodeInfoList`
         *       },
         *       ...
         *     ],
         *     // When true, the template had the `strip-whitespace` attribute
         *     // or was nested in a template with that setting
         *     stripWhitespace: {boolean},
         *     // For nested templates, nested template content is moved into
         *     // a document fragment stored here; this is an optimization to
         *     // avoid the cost of nested template cloning
         *     content: {DocumentFragment}
         *   }
         * ```
         *
         * This method kicks off a recursive treewalk as follows:
         *
         * ```
         *    _parseTemplate <---------------------+
         *      _parseTemplateContent              |
         *        _parseTemplateNode  <------------|--+
         *          _parseTemplateNestedTemplate --+  |
         *          _parseTemplateChildNodes ---------+
         *          _parseTemplateNodeAttributes
         *            _parseTemplateNodeAttribute
         *
         * ```
         *
         * These methods may be overridden to add custom metadata about templates
         * to either `templateInfo` or `nodeInfo`.
         *
         * Note that this method may be destructive to the template, in that
         * e.g. event annotations may be removed after being noted in the
         * template metadata.
         *
         * @param {!HTMLTemplateElement} template Template to parse
         * @param {TemplateInfo=} outerTemplateInfo Template metadata from the outer
         *   template, for parsing nested templates
         * @return {!TemplateInfo} Parsed template metadata
         * @nocollapse
         */
        function _parseTemplate(template, outerTemplateInfo) {
          // since a template may be re-used, memo-ize metadata
          if (!template._templateInfo) {
            // TODO(rictic): fix typing
            let /** ? */templateInfo = template._templateInfo = {};
            templateInfo.nodeInfoList = [];
            templateInfo.nestedTemplate = Boolean(outerTemplateInfo);
            templateInfo.stripWhiteSpace = outerTemplateInfo && outerTemplateInfo.stripWhiteSpace || template.hasAttribute && template.hasAttribute('strip-whitespace');
            // TODO(rictic): fix typing
            this._parseTemplateContent(template, templateInfo, /** @type {?} */{
              parent: null
            });
          }
          return template._templateInfo;
        }

        /**
         * See docs for _parseTemplateNode.
         *
         * @param {!HTMLTemplateElement} template .
         * @param {!TemplateInfo} templateInfo .
         * @param {!NodeInfo} nodeInfo .
         * @return {boolean} .
         * @nocollapse
         */
      }, {
        key: "_parseTemplateContent",
        value: function _parseTemplateContent(template, templateInfo, nodeInfo) {
          return this._parseTemplateNode(template.content, templateInfo, nodeInfo);
        }

        /**
         * Parses template node and adds template and node metadata based on
         * the current node, and its `childNodes` and `attributes`.
         *
         * This method may be overridden to add custom node or template specific
         * metadata based on this node.
         *
         * @param {Node} node Node to parse
         * @param {!TemplateInfo} templateInfo Template metadata for current template
         * @param {!NodeInfo} nodeInfo Node metadata for current template.
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @nocollapse
         */
      }, {
        key: "_parseTemplateNode",
        value: function _parseTemplateNode(node, templateInfo, nodeInfo) {
          let noted = false;
          let element = /** @type {!HTMLTemplateElement} */node;
          if (element.localName == 'template' && !element.hasAttribute('preserve-content')) {
            noted = this._parseTemplateNestedTemplate(element, templateInfo, nodeInfo) || noted;
          } else if (element.localName === 'slot') {
            // For ShadyDom optimization, indicating there is an insertion point
            templateInfo.hasInsertionPoint = true;
          }
          fixPlaceholder(element);
          if (element.firstChild) {
            this._parseTemplateChildNodes(element, templateInfo, nodeInfo);
          }
          if (element.hasAttributes && element.hasAttributes()) {
            noted = this._parseTemplateNodeAttributes(element, templateInfo, nodeInfo) || noted;
          }
          // Checking `nodeInfo.noted` allows a child node of this node (who gets
          // access to `parentInfo`) to cause the parent to be noted, which
          // otherwise has no return path via `_parseTemplateChildNodes` (used by
          // some optimizations)
          return noted || nodeInfo.noted;
        }

        /**
         * Parses template child nodes for the given root node.
         *
         * This method also wraps whitelisted legacy template extensions
         * (`is="dom-if"` and `is="dom-repeat"`) with their equivalent element
         * wrappers, collapses text nodes, and strips whitespace from the template
         * if the `templateInfo.stripWhitespace` setting was provided.
         *
         * @param {Node} root Root node whose `childNodes` will be parsed
         * @param {!TemplateInfo} templateInfo Template metadata for current template
         * @param {!NodeInfo} nodeInfo Node metadata for current template.
         * @return {void}
         */
      }, {
        key: "_parseTemplateChildNodes",
        value: function _parseTemplateChildNodes(root, templateInfo, nodeInfo) {
          if (root.localName === 'script' || root.localName === 'style') {
            return;
          }
          for (let node = root.firstChild, parentIndex = 0, next; node; node = next) {
            // Wrap templates
            if (node.localName == 'template') {
              node = wrapTemplateExtension(node);
            }
            // collapse adjacent textNodes: fixes an IE issue that can cause
            // text nodes to be inexplicably split =(
            // note that root.normalize() should work but does not so we do this
            // manually.
            next = node.nextSibling;
            if (node.nodeType === Node.TEXT_NODE) {
              let /** Node */n = next;
              while (n && n.nodeType === Node.TEXT_NODE) {
                node.textContent += n.textContent;
                next = n.nextSibling;
                root.removeChild(n);
                n = next;
              }
              // optionally strip whitespace
              if (templateInfo.stripWhiteSpace && !node.textContent.trim()) {
                root.removeChild(node);
                continue;
              }
            }
            let childInfo = /** @type {!NodeInfo} */{
              parentIndex,
              parentInfo: nodeInfo
            };
            if (this._parseTemplateNode(node, templateInfo, childInfo)) {
              childInfo.infoIndex = templateInfo.nodeInfoList.push(childInfo) - 1;
            }
            // Increment if not removed
            if (node.parentNode) {
              parentIndex++;
            }
          }
        }

        /**
         * Parses template content for the given nested `<template>`.
         *
         * Nested template info is stored as `templateInfo` in the current node's
         * `nodeInfo`. `template.content` is removed and stored in `templateInfo`.
         * It will then be the responsibility of the host to set it back to the
         * template and for users stamping nested templates to use the
         * `_contentForTemplate` method to retrieve the content for this template
         * (an optimization to avoid the cost of cloning nested template content).
         *
         * @param {HTMLTemplateElement} node Node to parse (a <template>)
         * @param {TemplateInfo} outerTemplateInfo Template metadata for current template
         *   that includes the template `node`
         * @param {!NodeInfo} nodeInfo Node metadata for current template.
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @nocollapse
         */
      }, {
        key: "_parseTemplateNestedTemplate",
        value: function _parseTemplateNestedTemplate(node, outerTemplateInfo, nodeInfo) {
          // TODO(rictic): the type of node should be non-null
          let element = /** @type {!HTMLTemplateElement} */node;
          let templateInfo = this._parseTemplate(element, outerTemplateInfo);
          let content = templateInfo.content = element.content.ownerDocument.createDocumentFragment();
          content.appendChild(element.content);
          nodeInfo.templateInfo = templateInfo;
          return true;
        }

        /**
         * Parses template node attributes and adds node metadata to `nodeInfo`
         * for nodes of interest.
         *
         * @param {Element} node Node to parse
         * @param {!TemplateInfo} templateInfo Template metadata for current
         *     template
         * @param {!NodeInfo} nodeInfo Node metadata for current template.
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @nocollapse
         */
      }, {
        key: "_parseTemplateNodeAttributes",
        value: function _parseTemplateNodeAttributes(node, templateInfo, nodeInfo) {
          // Make copy of original attribute list, since the order may change
          // as attributes are added and removed
          let noted = false;
          let attrs = Array.from(node.attributes);
          for (let i = attrs.length - 1, a; a = attrs[i]; i--) {
            noted = this._parseTemplateNodeAttribute(node, templateInfo, nodeInfo, a.name, a.value) || noted;
          }
          return noted;
        }

        /**
         * Parses a single template node attribute and adds node metadata to
         * `nodeInfo` for attributes of interest.
         *
         * This implementation adds metadata for `on-event="handler"` attributes
         * and `id` attributes.
         *
         * @param {Element} node Node to parse
         * @param {!TemplateInfo} templateInfo Template metadata for current template
         * @param {!NodeInfo} nodeInfo Node metadata for current template.
         * @param {string} name Attribute name
         * @param {string} value Attribute value
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @nocollapse
         */
      }, {
        key: "_parseTemplateNodeAttribute",
        value: function _parseTemplateNodeAttribute(node, templateInfo, nodeInfo, name, value) {
          // events (on-*)
          if (name.slice(0, 3) === 'on-') {
            node.removeAttribute(name);
            nodeInfo.events = nodeInfo.events || [];
            nodeInfo.events.push({
              name: name.slice(3),
              value
            });
            return true;
          }
          // static id
          else if (name === 'id') {
            nodeInfo.id = value;
            return true;
          }
          return false;
        }

        /**
         * Returns the `content` document fragment for a given template.
         *
         * For nested templates, Polymer performs an optimization to cache nested
         * template content to avoid the cost of cloning deeply nested templates.
         * This method retrieves the cached content for a given template.
         *
         * @param {HTMLTemplateElement} template Template to retrieve `content` for
         * @return {DocumentFragment} Content fragment
         * @nocollapse
         */
      }, {
        key: "_contentForTemplate",
        value: function _contentForTemplate(template) {
          let templateInfo = /** @type {HTMLTemplateElementWithInfo} */template._templateInfo;
          return templateInfo && templateInfo.content || template.content;
        }
      }]);
      return TemplateStamp;
    }(superClass);
    return TemplateStamp;
  });

  // Monotonically increasing unique ID used for de-duping effects triggered
  // from multiple properties in the same turn
  let dedupeId = 0;
  const NOOP = [];

  /**
   * Property effect types; effects are stored on the prototype using these keys
   * @enum {string}
   */
  const TYPES = {
    COMPUTE: '__computeEffects',
    REFLECT: '__reflectEffects',
    NOTIFY: '__notifyEffects',
    PROPAGATE: '__propagateEffects',
    OBSERVE: '__observeEffects',
    READ_ONLY: '__readOnly'
  };
  const COMPUTE_INFO = '__computeInfo';

  /** @const {!RegExp} */
  const capitalAttributeRegex = /[A-Z]/;

  /**
   * Ensures that the model has an own-property map of effects for the given type.
   * The model may be a prototype or an instance.
   *
   * Property effects are stored as arrays of effects by property in a map,
   * by named type on the model. e.g.
   *
   *   __computeEffects: {
   *     foo: [ ... ],
   *     bar: [ ... ]
   *   }
   *
   * If the model does not yet have an effect map for the type, one is created
   * and returned.  If it does, but it is not an own property (i.e. the
   * prototype had effects), the the map is deeply cloned and the copy is
   * set on the model and returned, ready for new effects to be added.
   *
   * @param {Object} model Prototype or instance
   * @param {string} type Property effect type
   * @param {boolean=} cloneArrays Clone any arrays assigned to the map when
   *   extending a superclass map onto this subclass
   * @return {Object} The own-property map of effects for the given type
   * @private
   */
  function ensureOwnEffectMap(model, type, cloneArrays) {
    let effects = model[type];
    if (!effects) {
      effects = model[type] = {};
    } else if (!model.hasOwnProperty(type)) {
      effects = model[type] = Object.create(model[type]);
      if (cloneArrays) {
        for (let p in effects) {
          let protoFx = effects[p];
          // Perf optimization over Array.slice
          let instFx = effects[p] = Array(protoFx.length);
          for (let i = 0; i < protoFx.length; i++) {
            instFx[i] = protoFx[i];
          }
        }
      }
    }
    return effects;
  }

  // -- effects ----------------------------------------------

  /**
   * Runs all effects of a given type for the given set of property changes
   * on an instance.
   *
   * @param {!Polymer_PropertyEffects} inst The instance with effects to run
   * @param {?Object} effects Object map of property-to-Array of effects
   * @param {?Object} props Bag of current property changes
   * @param {?Object=} oldProps Bag of previous values for changed properties
   * @param {boolean=} hasPaths True with `props` contains one or more paths
   * @param {*=} extraArgs Additional metadata to pass to effect function
   * @return {boolean} True if an effect ran for this property
   * @private
   */
  function runEffects(inst, effects, props, oldProps, hasPaths, extraArgs) {
    if (effects) {
      let ran = false;
      const id = dedupeId++;
      for (let prop in props) {
        // Inline `runEffectsForProperty` for perf.
        let rootProperty = hasPaths ? root(prop) : prop;
        let fxs = effects[rootProperty];
        if (fxs) {
          for (let i = 0, l = fxs.length, fx; i < l && (fx = fxs[i]); i++) {
            if ((!fx.info || fx.info.lastRun !== id) && (!hasPaths || pathMatchesTrigger(prop, fx.trigger))) {
              if (fx.info) {
                fx.info.lastRun = id;
              }
              fx.fn(inst, prop, props, oldProps, fx.info, hasPaths, extraArgs);
              ran = true;
            }
          }
        }
      }
      return ran;
    }
    return false;
  }

  /**
   * Runs a list of effects for a given property.
   *
   * @param {!Polymer_PropertyEffects} inst The instance with effects to run
   * @param {!Object} effects Object map of property-to-Array of effects
   * @param {number} dedupeId Counter used for de-duping effects
   * @param {string} prop Name of changed property
   * @param {*} props Changed properties
   * @param {*} oldProps Old properties
   * @param {boolean=} hasPaths True with `props` contains one or more paths
   * @param {*=} extraArgs Additional metadata to pass to effect function
   * @return {boolean} True if an effect ran for this property
   * @private
   */
  function runEffectsForProperty(inst, effects, dedupeId, prop, props, oldProps, hasPaths, extraArgs) {
    let ran = false;
    let rootProperty = hasPaths ? root(prop) : prop;
    let fxs = effects[rootProperty];
    if (fxs) {
      for (let i = 0, l = fxs.length, fx; i < l && (fx = fxs[i]); i++) {
        if ((!fx.info || fx.info.lastRun !== dedupeId) && (!hasPaths || pathMatchesTrigger(prop, fx.trigger))) {
          if (fx.info) {
            fx.info.lastRun = dedupeId;
          }
          fx.fn(inst, prop, props, oldProps, fx.info, hasPaths, extraArgs);
          ran = true;
        }
      }
    }
    return ran;
  }

  /**
   * Determines whether a property/path that has changed matches the trigger
   * criteria for an effect.  A trigger is a descriptor with the following
   * structure, which matches the descriptors returned from `parseArg`.
   * e.g. for `foo.bar.*`:
   * ```
   * trigger: {
   *   name: 'a.b',
   *   structured: true,
   *   wildcard: true
   * }
   * ```
   * If no trigger is given, the path is deemed to match.
   *
   * @param {string} path Path or property that changed
   * @param {?DataTrigger} trigger Descriptor
   * @return {boolean} Whether the path matched the trigger
   */
  function pathMatchesTrigger(path, trigger) {
    if (trigger) {
      let triggerPath = /** @type {string} */trigger.name;
      return triggerPath == path || !!(trigger.structured && isAncestor(triggerPath, path)) || !!(trigger.wildcard && isDescendant(triggerPath, path));
    } else {
      return true;
    }
  }

  /**
   * Implements the "observer" effect.
   *
   * Calls the method with `info.methodName` on the instance, passing the
   * new and old values.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {string} property Name of property
   * @param {Object} props Bag of current property changes
   * @param {Object} oldProps Bag of previous values for changed properties
   * @param {?} info Effect metadata
   * @return {void}
   * @private
   */
  function runObserverEffect(inst, property, props, oldProps, info) {
    let fn = typeof info.method === "string" ? inst[info.method] : info.method;
    let changedProp = info.property;
    if (fn) {
      fn.call(inst, inst.__data[changedProp], oldProps[changedProp]);
    } else if (!info.dynamicFn) {
      console.warn('observer method `' + info.method + '` not defined');
    }
  }

  /**
   * Runs "notify" effects for a set of changed properties.
   *
   * This method differs from the generic `runEffects` method in that it
   * will dispatch path notification events in the case that the property
   * changed was a path and the root property for that path didn't have a
   * "notify" effect.  This is to maintain 1.0 behavior that did not require
   * `notify: true` to ensure object sub-property notifications were
   * sent.
   *
   * @param {!Polymer_PropertyEffects} inst The instance with effects to run
   * @param {Object} notifyProps Bag of properties to notify
   * @param {Object} props Bag of current property changes
   * @param {Object} oldProps Bag of previous values for changed properties
   * @param {boolean} hasPaths True with `props` contains one or more paths
   * @return {void}
   * @private
   */
  function runNotifyEffects(inst, notifyProps, props, oldProps, hasPaths) {
    // Notify
    let fxs = inst[TYPES.NOTIFY];
    let notified;
    let id = dedupeId++;
    // Try normal notify effects; if none, fall back to try path notification
    for (let prop in notifyProps) {
      if (notifyProps[prop]) {
        if (fxs && runEffectsForProperty(inst, fxs, id, prop, props, oldProps, hasPaths)) {
          notified = true;
        } else if (hasPaths && notifyPath(inst, prop, props)) {
          notified = true;
        }
      }
    }
    // Flush host if we actually notified and host was batching
    // And the host has already initialized clients; this prevents
    // an issue with a host observing data changes before clients are ready.
    let host;
    if (notified && (host = inst.__dataHost) && host._invalidateProperties) {
      host._invalidateProperties();
    }
  }

  /**
   * Dispatches {property}-changed events with path information in the detail
   * object to indicate a sub-path of the property was changed.
   *
   * @param {!Polymer_PropertyEffects} inst The element from which to fire the
   *     event
   * @param {string} path The path that was changed
   * @param {Object} props Bag of current property changes
   * @return {boolean} Returns true if the path was notified
   * @private
   */
  function notifyPath(inst, path, props) {
    let rootProperty = root(path);
    if (rootProperty !== path) {
      let eventName = camelToDashCase(rootProperty) + '-changed';
      dispatchNotifyEvent(inst, eventName, props[path], path);
      return true;
    }
    return false;
  }

  /**
   * Dispatches {property}-changed events to indicate a property (or path)
   * changed.
   *
   * @param {!Polymer_PropertyEffects} inst The element from which to fire the
   *     event
   * @param {string} eventName The name of the event to send
   *     ('{property}-changed')
   * @param {*} value The value of the changed property
   * @param {string | null | undefined} path If a sub-path of this property
   *     changed, the path that changed (optional).
   * @return {void}
   * @private
   * @suppress {invalidCasts}
   */
  function dispatchNotifyEvent(inst, eventName, value, path) {
    let detail = {
      value: value,
      queueProperty: true
    };
    if (path) {
      detail.path = path;
    }
    // As a performance optimization, we could elide the wrap here since notifying
    // events are non-bubbling and shouldn't need retargeting. However, a very
    // small number of internal tests failed in obscure ways, which may indicate
    // user code relied on timing differences resulting from ShadyDOM flushing
    // as a result of the wrapped `dispatchEvent`.
    wrap( /** @type {!HTMLElement} */inst).dispatchEvent(new CustomEvent(eventName, {
      detail
    }));
  }

  /**
   * Implements the "notify" effect.
   *
   * Dispatches a non-bubbling event named `info.eventName` on the instance
   * with a detail object containing the new `value`.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {string} property Name of property
   * @param {Object} props Bag of current property changes
   * @param {Object} oldProps Bag of previous values for changed properties
   * @param {?} info Effect metadata
   * @param {boolean} hasPaths True with `props` contains one or more paths
   * @return {void}
   * @private
   */
  function runNotifyEffect(inst, property, props, oldProps, info, hasPaths) {
    let rootProperty = hasPaths ? root(property) : property;
    let path = rootProperty != property ? property : null;
    let value = path ? get(inst, path) : inst.__data[property];
    if (path && value === undefined) {
      value = props[property]; // specifically for .splices
    }

    dispatchNotifyEvent(inst, info.eventName, value, path);
  }

  /**
   * Handler function for 2-way notification events. Receives context
   * information captured in the `addNotifyListener` closure from the
   * `__notifyListeners` metadata.
   *
   * Sets the value of the notified property to the host property or path.  If
   * the event contained path information, translate that path to the host
   * scope's name for that path first.
   *
   * @param {CustomEvent} event Notification event (e.g. '<property>-changed')
   * @param {!Polymer_PropertyEffects} inst Host element instance handling the
   *     notification event
   * @param {string} fromProp Child element property that was bound
   * @param {string} toPath Host property/path that was bound
   * @param {boolean} negate Whether the binding was negated
   * @return {void}
   * @private
   */
  function handleNotification(event, inst, fromProp, toPath, negate) {
    let value;
    let detail = /** @type {Object} */event.detail;
    let fromPath = detail && detail.path;
    if (fromPath) {
      toPath = translate(fromProp, toPath, fromPath);
      value = detail && detail.value;
    } else {
      value = event.currentTarget[fromProp];
    }
    value = negate ? !value : value;
    if (!inst[TYPES.READ_ONLY] || !inst[TYPES.READ_ONLY][toPath]) {
      if (inst._setPendingPropertyOrPath(toPath, value, true, Boolean(fromPath)) && (!detail || !detail.queueProperty)) {
        inst._invalidateProperties();
      }
    }
  }

  /**
   * Implements the "reflect" effect.
   *
   * Sets the attribute named `info.attrName` to the given property value.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {string} property Name of property
   * @param {Object} props Bag of current property changes
   * @param {Object} oldProps Bag of previous values for changed properties
   * @param {?} info Effect metadata
   * @return {void}
   * @private
   */
  function runReflectEffect(inst, property, props, oldProps, info) {
    let value = inst.__data[property];
    if (sanitizeDOMValue) {
      value = sanitizeDOMValue(value, info.attrName, 'attribute', /** @type {Node} */inst);
    }
    inst._propertyToAttribute(property, info.attrName, value);
  }

  /**
   * Runs "computed" effects for a set of changed properties.
   *
   * This method differs from the generic `runEffects` method in that it
   * continues to run computed effects based on the output of each pass until
   * there are no more newly computed properties.  This ensures that all
   * properties that will be computed by the initial set of changes are
   * computed before other effects (binding propagation, observers, and notify)
   * run.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {?Object} changedProps Bag of changed properties
   * @param {?Object} oldProps Bag of previous values for changed properties
   * @param {boolean} hasPaths True with `props` contains one or more paths
   * @return {void}
   * @private
   */
  function runComputedEffects(inst, changedProps, oldProps, hasPaths) {
    let computeEffects = inst[TYPES.COMPUTE];
    if (computeEffects) {
      if (orderedComputed) {
        // Runs computed effects in efficient order by keeping a topologically-
        // sorted queue of compute effects to run, and inserting subsequently
        // invalidated effects as they are run
        dedupeId++;
        const order = getComputedOrder(inst);
        const queue = [];
        for (let p in changedProps) {
          enqueueEffectsFor(p, computeEffects, queue, order, hasPaths);
        }
        let info;
        while (info = queue.shift()) {
          if (runComputedEffect(inst, '', changedProps, oldProps, info)) {
            enqueueEffectsFor(info.methodInfo, computeEffects, queue, order, hasPaths);
          }
        }
        Object.assign( /** @type {!Object} */oldProps, inst.__dataOld);
        Object.assign( /** @type {!Object} */changedProps, inst.__dataPending);
        inst.__dataPending = null;
      } else {
        // Original Polymer 2.x computed effects order, which continues running
        // effects until no further computed properties have been invalidated
        let inputProps = changedProps;
        while (runEffects(inst, computeEffects, inputProps, oldProps, hasPaths)) {
          Object.assign( /** @type {!Object} */oldProps, inst.__dataOld);
          Object.assign( /** @type {!Object} */changedProps, inst.__dataPending);
          inputProps = inst.__dataPending;
          inst.__dataPending = null;
        }
      }
    }
  }

  /**
   * Inserts a computed effect into a queue, given the specified order. Performs
   * the insert using a binary search.
   *
   * Used by `orderedComputed: true` computed property algorithm.
   *
   * @param {Object} info Property effects metadata
   * @param {Array<Object>} queue Ordered queue of effects
   * @param {Map<string,number>} order Map of computed property name->topological
   *   sort order
   */
  const insertEffect = (info, queue, order) => {
    let start = 0;
    let end = queue.length - 1;
    let idx = -1;
    while (start <= end) {
      const mid = start + end >> 1;
      // Note `methodInfo` is where the computed property name is stored in
      // the effect metadata
      const cmp = order.get(queue[mid].methodInfo) - order.get(info.methodInfo);
      if (cmp < 0) {
        start = mid + 1;
      } else if (cmp > 0) {
        end = mid - 1;
      } else {
        idx = mid;
        break;
      }
    }
    if (idx < 0) {
      idx = end + 1;
    }
    queue.splice(idx, 0, info);
  };

  /**
   * Inserts all downstream computed effects invalidated by the specified property
   * into the topologically-sorted queue of effects to be run.
   *
   * Used by `orderedComputed: true` computed property algorithm.
   *
   * @param {string} prop Property name
   * @param {Object} computeEffects Computed effects for this element
   * @param {Array<Object>} queue Topologically-sorted queue of computed effects
   *   to be run
   * @param {Map<string,number>} order Map of computed property name->topological
   *   sort order
   * @param {boolean} hasPaths True with `changedProps` contains one or more paths
   */
  const enqueueEffectsFor = (prop, computeEffects, queue, order, hasPaths) => {
    const rootProperty = hasPaths ? root(prop) : prop;
    const fxs = computeEffects[rootProperty];
    if (fxs) {
      for (let i = 0; i < fxs.length; i++) {
        const fx = fxs[i];
        if (fx.info.lastRun !== dedupeId && (!hasPaths || pathMatchesTrigger(prop, fx.trigger))) {
          fx.info.lastRun = dedupeId;
          insertEffect(fx.info, queue, order);
        }
      }
    }
  };

  /**
   * Generates and retrieves a memoized map of computed property name to its
   * topologically-sorted order.
   *
   * The map is generated by first assigning a "dependency count" to each property
   * (defined as number properties it depends on, including its method for
   * "dynamic functions"). Any properties that have no dependencies are added to
   * the `ready` queue, which are properties whose order can be added to the final
   * order map. Properties are popped off the `ready` queue one by one and a.) added as
   * the next property in the order map, and b.) each property that it is a
   * dependency for has its dep count decremented (and if that property's dep
   * count goes to zero, it is added to the `ready` queue), until all properties
   * have been visited and ordered.
   *
   * Used by `orderedComputed: true` computed property algorithm.
   *
   * @param {!Polymer_PropertyEffects} inst The instance to retrieve the computed
   *   effect order for.
   * @return {Map<string,number>} Map of computed property name->topological sort
   *   order
   */
  function getComputedOrder(inst) {
    let ordered = inst.constructor.__orderedComputedDeps;
    if (!ordered) {
      ordered = new Map();
      const effects = inst[TYPES.COMPUTE];
      let {
        counts,
        ready,
        total
      } = dependencyCounts(inst);
      let curr;
      while (curr = ready.shift()) {
        ordered.set(curr, ordered.size);
        const computedByCurr = effects[curr];
        if (computedByCurr) {
          computedByCurr.forEach(fx => {
            // Note `methodInfo` is where the computed property name is stored
            const computedProp = fx.info.methodInfo;
            --total;
            if (--counts[computedProp] === 0) {
              ready.push(computedProp);
            }
          });
        }
      }
      if (total !== 0) {
        const el = /** @type {HTMLElement} */inst;
        console.warn(`Computed graph for ${el.localName} incomplete; circular?`);
      }
      inst.constructor.__orderedComputedDeps = ordered;
    }
    return ordered;
  }

  /**
   * Generates a map of property-to-dependency count (`counts`, where "dependency
   * count" is the number of dependencies a given property has assuming it is a
   * computed property, otherwise 0).  It also returns a pre-populated list of
   * `ready` properties that have no dependencies and a `total` count, which is
   * used for error-checking the graph.
   *
   * Used by `orderedComputed: true` computed property algorithm.
   *
   * @param {!Polymer_PropertyEffects} inst The instance to generate dependency
   *   counts for.
   * @return {!Object} Object containing `counts` map (property-to-dependency
   *   count) and pre-populated `ready` array of properties that had zero
   *   dependencies.
   */
  function dependencyCounts(inst) {
    const infoForComputed = inst[COMPUTE_INFO];
    const counts = {};
    const computedDeps = inst[TYPES.COMPUTE];
    const ready = [];
    let total = 0;
    // Count dependencies for each computed property
    for (let p in infoForComputed) {
      const info = infoForComputed[p];
      // Be sure to add the method name itself in case of "dynamic functions"
      total += counts[p] = info.args.filter(a => !a.literal).length + (info.dynamicFn ? 1 : 0);
    }
    // Build list of ready properties (that aren't themselves computed)
    for (let p in computedDeps) {
      if (!infoForComputed[p]) {
        ready.push(p);
      }
    }
    return {
      counts,
      ready,
      total
    };
  }

  /**
   * Implements the "computed property" effect by running the method with the
   * values of the arguments specified in the `info` object and setting the
   * return value to the computed property specified.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {string} property Name of property
   * @param {?Object} changedProps Bag of current property changes
   * @param {?Object} oldProps Bag of previous values for changed properties
   * @param {?} info Effect metadata
   * @return {boolean} True when the property being computed changed
   * @private
   */
  function runComputedEffect(inst, property, changedProps, oldProps, info) {
    // Dirty check dependencies and run if any invalid
    let result = runMethodEffect(inst, property, changedProps, oldProps, info);
    // Abort if method returns a no-op result
    if (result === NOOP) {
      return false;
    }
    let computedProp = info.methodInfo;
    if (inst.__dataHasAccessor && inst.__dataHasAccessor[computedProp]) {
      return inst._setPendingProperty(computedProp, result, true);
    } else {
      inst[computedProp] = result;
      return false;
    }
  }

  /**
   * Computes path changes based on path links set up using the `linkPaths`
   * API.
   *
   * @param {!Polymer_PropertyEffects} inst The instance whose props are changing
   * @param {string} path Path that has changed
   * @param {*} value Value of changed path
   * @return {void}
   * @private
   */
  function computeLinkedPaths(inst, path, value) {
    let links = inst.__dataLinkedPaths;
    if (links) {
      let link;
      for (let a in links) {
        let b = links[a];
        if (isDescendant(a, path)) {
          link = translate(a, b, path);
          inst._setPendingPropertyOrPath(link, value, true, true);
        } else if (isDescendant(b, path)) {
          link = translate(b, a, path);
          inst._setPendingPropertyOrPath(link, value, true, true);
        }
      }
    }
  }

  // -- bindings ----------------------------------------------

  /**
   * Adds binding metadata to the current `nodeInfo`, and binding effects
   * for all part dependencies to `templateInfo`.
   *
   * @param {Function} constructor Class that `_parseTemplate` is currently
   *   running on
   * @param {TemplateInfo} templateInfo Template metadata for current template
   * @param {NodeInfo} nodeInfo Node metadata for current template node
   * @param {string} kind Binding kind, either 'property', 'attribute', or 'text'
   * @param {string} target Target property name
   * @param {!Array<!BindingPart>} parts Array of binding part metadata
   * @param {string=} literal Literal text surrounding binding parts (specified
   *   only for 'property' bindings, since these must be initialized as part
   *   of boot-up)
   * @return {void}
   * @private
   */
  function addBinding(constructor, templateInfo, nodeInfo, kind, target, parts, literal) {
    // Create binding metadata and add to nodeInfo
    nodeInfo.bindings = nodeInfo.bindings || [];
    let /** Binding */binding = {
      kind,
      target,
      parts,
      literal,
      isCompound: parts.length !== 1
    };
    nodeInfo.bindings.push(binding);
    // Add listener info to binding metadata
    if (shouldAddListener(binding)) {
      let {
        event,
        negate
      } = binding.parts[0];
      binding.listenerEvent = event || camelToDashCase(target) + '-changed';
      binding.listenerNegate = negate;
    }
    // Add "propagate" property effects to templateInfo
    let index = templateInfo.nodeInfoList.length;
    for (let i = 0; i < binding.parts.length; i++) {
      let part = binding.parts[i];
      part.compoundIndex = i;
      addEffectForBindingPart(constructor, templateInfo, binding, part, index);
    }
  }

  /**
   * Adds property effects to the given `templateInfo` for the given binding
   * part.
   *
   * @param {Function} constructor Class that `_parseTemplate` is currently
   *   running on
   * @param {TemplateInfo} templateInfo Template metadata for current template
   * @param {!Binding} binding Binding metadata
   * @param {!BindingPart} part Binding part metadata
   * @param {number} index Index into `nodeInfoList` for this node
   * @return {void}
   */
  function addEffectForBindingPart(constructor, templateInfo, binding, part, index) {
    if (!part.literal) {
      if (binding.kind === 'attribute' && binding.target[0] === '-') {
        console.warn('Cannot set attribute ' + binding.target + ' because "-" is not a valid attribute starting character');
      } else {
        let dependencies = part.dependencies;
        let info = {
          index,
          binding,
          part,
          evaluator: constructor
        };
        for (let j = 0; j < dependencies.length; j++) {
          let trigger = dependencies[j];
          if (typeof trigger == 'string') {
            trigger = parseArg(trigger);
            trigger.wildcard = true;
          }
          constructor._addTemplatePropertyEffect(templateInfo, trigger.rootProperty, {
            fn: runBindingEffect,
            info,
            trigger
          });
        }
      }
    }
  }

  /**
   * Implements the "binding" (property/path binding) effect.
   *
   * Note that binding syntax is overridable via `_parseBindings` and
   * `_evaluateBinding`.  This method will call `_evaluateBinding` for any
   * non-literal parts returned from `_parseBindings`.  However,
   * there is no support for _path_ bindings via custom binding parts,
   * as this is specific to Polymer's path binding syntax.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {string} path Name of property
   * @param {Object} props Bag of current property changes
   * @param {Object} oldProps Bag of previous values for changed properties
   * @param {?} info Effect metadata
   * @param {boolean} hasPaths True with `props` contains one or more paths
   * @param {Array} nodeList List of nodes associated with `nodeInfoList` template
   *   metadata
   * @return {void}
   * @private
   */
  function runBindingEffect(inst, path, props, oldProps, info, hasPaths, nodeList) {
    let node = nodeList[info.index];
    let binding = info.binding;
    let part = info.part;
    // Subpath notification: transform path and set to client
    // e.g.: foo="{{obj.sub}}", path: 'obj.sub.prop', set 'foo.prop'=obj.sub.prop
    if (hasPaths && part.source && path.length > part.source.length && binding.kind == 'property' && !binding.isCompound && node.__isPropertyEffectsClient && node.__dataHasAccessor && node.__dataHasAccessor[binding.target]) {
      let value = props[path];
      path = translate(part.source, binding.target, path);
      if (node._setPendingPropertyOrPath(path, value, false, true)) {
        inst._enqueueClient(node);
      }
    } else {
      let value = info.evaluator._evaluateBinding(inst, part, path, props, oldProps, hasPaths);
      // Propagate value to child
      // Abort if value is a no-op result
      if (value !== NOOP) {
        applyBindingValue(inst, node, binding, part, value);
      }
    }
  }

  /**
   * Sets the value for an "binding" (binding) effect to a node,
   * either as a property or attribute.
   *
   * @param {!Polymer_PropertyEffects} inst The instance owning the binding effect
   * @param {Node} node Target node for binding
   * @param {!Binding} binding Binding metadata
   * @param {!BindingPart} part Binding part metadata
   * @param {*} value Value to set
   * @return {void}
   * @private
   */
  function applyBindingValue(inst, node, binding, part, value) {
    value = computeBindingValue(node, value, binding, part);
    if (sanitizeDOMValue) {
      value = sanitizeDOMValue(value, binding.target, binding.kind, node);
    }
    if (binding.kind == 'attribute') {
      // Attribute binding
      inst._valueToNodeAttribute( /** @type {Element} */node, value, binding.target);
    } else {
      // Property binding
      let prop = binding.target;
      if (node.__isPropertyEffectsClient && node.__dataHasAccessor && node.__dataHasAccessor[prop]) {
        if (!node[TYPES.READ_ONLY] || !node[TYPES.READ_ONLY][prop]) {
          if (node._setPendingProperty(prop, value)) {
            inst._enqueueClient(node);
          }
        }
      } else {
        // In legacy no-batching mode, bindings applied before dataReady are
        // equivalent to the "apply config" phase, which only set managed props
        inst._setUnmanagedPropertyToNode(node, prop, value);
      }
    }
  }

  /**
   * Transforms an "binding" effect value based on compound & negation
   * effect metadata, as well as handling for special-case properties
   *
   * @param {Node} node Node the value will be set to
   * @param {*} value Value to set
   * @param {!Binding} binding Binding metadata
   * @param {!BindingPart} part Binding part metadata
   * @return {*} Transformed value to set
   * @private
   */
  function computeBindingValue(node, value, binding, part) {
    if (binding.isCompound) {
      let storage = node.__dataCompoundStorage[binding.target];
      storage[part.compoundIndex] = value;
      value = storage.join('');
    }
    if (binding.kind !== 'attribute') {
      // Some browsers serialize `undefined` to `"undefined"`
      if (binding.target === 'textContent' || binding.target === 'value' && (node.localName === 'input' || node.localName === 'textarea')) {
        value = value == undefined ? '' : value;
      }
    }
    return value;
  }

  /**
   * Returns true if a binding's metadata meets all the requirements to allow
   * 2-way binding, and therefore a `<property>-changed` event listener should be
   * added:
   * - used curly braces
   * - is a property (not attribute) binding
   * - is not a textContent binding
   * - is not compound
   *
   * @param {!Binding} binding Binding metadata
   * @return {boolean} True if 2-way listener should be added
   * @private
   */
  function shouldAddListener(binding) {
    return Boolean(binding.target) && binding.kind != 'attribute' && binding.kind != 'text' && !binding.isCompound && binding.parts[0].mode === '{';
  }

  /**
   * Setup compound binding storage structures, notify listeners, and dataHost
   * references onto the bound nodeList.
   *
   * @param {!Polymer_PropertyEffects} inst Instance that bas been previously
   *     bound
   * @param {TemplateInfo} templateInfo Template metadata
   * @return {void}
   * @private
   */
  function setupBindings(inst, templateInfo) {
    // Setup compound storage, dataHost, and notify listeners
    let {
      nodeList,
      nodeInfoList
    } = templateInfo;
    if (nodeInfoList.length) {
      for (let i = 0; i < nodeInfoList.length; i++) {
        let info = nodeInfoList[i];
        let node = nodeList[i];
        let bindings = info.bindings;
        if (bindings) {
          for (let i = 0; i < bindings.length; i++) {
            let binding = bindings[i];
            setupCompoundStorage(node, binding);
            addNotifyListener(node, inst, binding);
          }
        }
        // This ensures all bound elements have a host set, regardless
        // of whether they upgrade synchronous to creation
        node.__dataHost = inst;
      }
    }
  }

  /**
   * Initializes `__dataCompoundStorage` local storage on a bound node with
   * initial literal data for compound bindings, and sets the joined
   * literal parts to the bound property.
   *
   * When changes to compound parts occur, they are first set into the compound
   * storage array for that property, and then the array is joined to result in
   * the final value set to the property/attribute.
   *
   * @param {Node} node Bound node to initialize
   * @param {Binding} binding Binding metadata
   * @return {void}
   * @private
   */
  function setupCompoundStorage(node, binding) {
    if (binding.isCompound) {
      // Create compound storage map
      let storage = node.__dataCompoundStorage || (node.__dataCompoundStorage = {});
      let parts = binding.parts;
      // Copy literals from parts into storage for this binding
      let literals = new Array(parts.length);
      for (let j = 0; j < parts.length; j++) {
        literals[j] = parts[j].literal;
      }
      let target = binding.target;
      storage[target] = literals;
      // Configure properties with their literal parts
      if (binding.literal && binding.kind == 'property') {
        // Note, className needs style scoping so this needs wrapping.
        // We may also want to consider doing this for `textContent` and
        // `innerHTML`.
        if (target === 'className') {
          node = wrap(node);
        }
        node[target] = binding.literal;
      }
    }
  }

  /**
   * Adds a 2-way binding notification event listener to the node specified
   *
   * @param {Object} node Child element to add listener to
   * @param {!Polymer_PropertyEffects} inst Host element instance to handle
   *     notification event
   * @param {Binding} binding Binding metadata
   * @return {void}
   * @private
   */
  function addNotifyListener(node, inst, binding) {
    if (binding.listenerEvent) {
      let part = binding.parts[0];
      node.addEventListener(binding.listenerEvent, function (e) {
        handleNotification(e, inst, binding.target, part.source, part.negate);
      });
    }
  }

  // -- for method-based effects (complexObserver & computed) --------------

  /**
   * Adds property effects for each argument in the method signature (and
   * optionally, for the method name if `dynamic` is true) that calls the
   * provided effect function.
   *
   * @param {Element | Object} model Prototype or instance
   * @param {!MethodSignature} sig Method signature metadata
   * @param {string} type Type of property effect to add
   * @param {Function} effectFn Function to run when arguments change
   * @param {*=} methodInfo Effect-specific information to be included in
   *   method effect metadata
   * @param {boolean|Object=} dynamicFn Boolean or object map indicating whether
   *   method names should be included as a dependency to the effect. Note,
   *   defaults to true if the signature is static (sig.static is true).
   * @return {!Object} Effect metadata for this method effect
   * @private
   */
  function createMethodEffect(model, sig, type, effectFn, methodInfo, dynamicFn) {
    dynamicFn = sig.static || dynamicFn && (typeof dynamicFn !== 'object' || dynamicFn[sig.methodName]);
    let info = {
      methodName: sig.methodName,
      args: sig.args,
      methodInfo,
      dynamicFn
    };
    for (let i = 0, arg; i < sig.args.length && (arg = sig.args[i]); i++) {
      if (!arg.literal) {
        model._addPropertyEffect(arg.rootProperty, type, {
          fn: effectFn,
          info: info,
          trigger: arg
        });
      }
    }
    if (dynamicFn) {
      model._addPropertyEffect(sig.methodName, type, {
        fn: effectFn,
        info: info
      });
    }
    return info;
  }

  /**
   * Calls a method with arguments marshaled from properties on the instance
   * based on the method signature contained in the effect metadata.
   *
   * Multi-property observers, computed properties, and inline computing
   * functions call this function to invoke the method, then use the return
   * value accordingly.
   *
   * @param {!Polymer_PropertyEffects} inst The instance the effect will be run on
   * @param {string} property Name of property
   * @param {Object} props Bag of current property changes
   * @param {Object} oldProps Bag of previous values for changed properties
   * @param {?} info Effect metadata
   * @return {*} Returns the return value from the method invocation
   * @private
   */
  function runMethodEffect(inst, property, props, oldProps, info) {
    // Instances can optionally have a _methodHost which allows redirecting where
    // to find methods. Currently used by `templatize`.
    let context = inst._methodHost || inst;
    let fn = context[info.methodName];
    if (fn) {
      let args = inst._marshalArgs(info.args, property, props);
      return args === NOOP ? NOOP : fn.apply(context, args);
    } else if (!info.dynamicFn) {
      console.warn('method `' + info.methodName + '` not defined');
    }
  }
  const emptyArray = [];

  // Regular expressions used for binding
  const IDENT = '(?:' + '[a-zA-Z_$][\\w.:$\\-*]*' + ')';
  const NUMBER = '(?:' + '[-+]?[0-9]*\\.?[0-9]+(?:[eE][-+]?[0-9]+)?' + ')';
  const SQUOTE_STRING = '(?:' + '\'(?:[^\'\\\\]|\\\\.)*\'' + ')';
  const DQUOTE_STRING = '(?:' + '"(?:[^"\\\\]|\\\\.)*"' + ')';
  const STRING = '(?:' + SQUOTE_STRING + '|' + DQUOTE_STRING + ')';
  const ARGUMENT = '(?:(' + IDENT + '|' + NUMBER + '|' + STRING + ')\\s*' + ')';
  const ARGUMENTS = '(?:' + ARGUMENT + '(?:,\\s*' + ARGUMENT + ')*' + ')';
  const ARGUMENT_LIST = '(?:' + '\\(\\s*' + '(?:' + ARGUMENTS + '?' + ')' + '\\)\\s*' + ')';
  const BINDING = '(' + IDENT + '\\s*' + ARGUMENT_LIST + '?' + ')'; // Group 3
  const OPEN_BRACKET = '(\\[\\[|{{)' + '\\s*';
  const CLOSE_BRACKET = '(?:]]|}})';
  const NEGATE = '(?:(!)\\s*)?'; // Group 2
  const EXPRESSION = OPEN_BRACKET + NEGATE + BINDING + CLOSE_BRACKET;
  const bindingRegex = new RegExp(EXPRESSION, "g");

  /**
   * Create a string from binding parts of all the literal parts
   *
   * @param {!Array<BindingPart>} parts All parts to stringify
   * @return {string} String made from the literal parts
   */
  function literalFromParts(parts) {
    let s = '';
    for (let i = 0; i < parts.length; i++) {
      let literal = parts[i].literal;
      s += literal || '';
    }
    return s;
  }

  /**
   * Parses an expression string for a method signature, and returns a metadata
   * describing the method in terms of `methodName`, `static` (whether all the
   * arguments are literals), and an array of `args`
   *
   * @param {string} expression The expression to parse
   * @return {?MethodSignature} The method metadata object if a method expression was
   *   found, otherwise `undefined`
   * @private
   */
  function parseMethod(expression) {
    // tries to match valid javascript property names
    let m = expression.match(/([^\s]+?)\(([\s\S]*)\)/);
    if (m) {
      let methodName = m[1];
      let sig = {
        methodName,
        static: true,
        args: emptyArray
      };
      if (m[2].trim()) {
        // replace escaped commas with comma entity, split on un-escaped commas
        let args = m[2].replace(/\\,/g, '&comma;').split(',');
        return parseArgs(args, sig);
      } else {
        return sig;
      }
    }
    return null;
  }

  /**
   * Parses an array of arguments and sets the `args` property of the supplied
   * signature metadata object. Sets the `static` property to false if any
   * argument is a non-literal.
   *
   * @param {!Array<string>} argList Array of argument names
   * @param {!MethodSignature} sig Method signature metadata object
   * @return {!MethodSignature} The updated signature metadata object
   * @private
   */
  function parseArgs(argList, sig) {
    sig.args = argList.map(function (rawArg) {
      let arg = parseArg(rawArg);
      if (!arg.literal) {
        sig.static = false;
      }
      return arg;
    }, this);
    return sig;
  }

  /**
   * Parses an individual argument, and returns an argument metadata object
   * with the following fields:
   *
   *   {
   *     value: 'prop',        // property/path or literal value
   *     literal: false,       // whether argument is a literal
   *     structured: false,    // whether the property is a path
   *     rootProperty: 'prop', // the root property of the path
   *     wildcard: false       // whether the argument was a wildcard '.*' path
   *   }
   *
   * @param {string} rawArg The string value of the argument
   * @return {!MethodArg} Argument metadata object
   * @private
   */
  function parseArg(rawArg) {
    // clean up whitespace
    let arg = rawArg.trim()
    // replace comma entity with comma
    .replace(/&comma;/g, ',')
    // repair extra escape sequences; note only commas strictly need
    // escaping, but we allow any other char to be escaped since its
    // likely users will do this
    .replace(/\\(.)/g, '$1');
    // basic argument descriptor
    let a = {
      name: arg,
      value: '',
      literal: false
    };
    // detect literal value (must be String or Number)
    let fc = arg[0];
    if (fc === '-') {
      fc = arg[1];
    }
    if (fc >= '0' && fc <= '9') {
      fc = '#';
    }
    switch (fc) {
      case "'":
      case '"':
        a.value = arg.slice(1, -1);
        a.literal = true;
        break;
      case '#':
        a.value = Number(arg);
        a.literal = true;
        break;
    }
    // if not literal, look for structured path
    if (!a.literal) {
      a.rootProperty = root(arg);
      // detect structured path (has dots)
      a.structured = isPath(arg);
      if (a.structured) {
        a.wildcard = arg.slice(-2) == '.*';
        if (a.wildcard) {
          a.name = arg.slice(0, -2);
        }
      }
    }
    return a;
  }
  function getArgValue(data, props, path) {
    let value = get(data, path);
    // when data is not stored e.g. `splices`, get the value from changedProps
    // TODO(kschaaf): Note, this can cause a rare issue where the wildcard
    // info.value could pull a stale value out of changedProps during a reentrant
    // change that sets the value back to undefined.
    // https://github.com/Polymer/polymer/issues/5479
    if (value === undefined) {
      value = props[path];
    }
    return value;
  }

  // data api

  /**
   * Sends array splice notifications (`.splices` and `.length`)
   *
   * Note: this implementation only accepts normalized paths
   *
   * @param {!Polymer_PropertyEffects} inst Instance to send notifications to
   * @param {Array} array The array the mutations occurred on
   * @param {string} path The path to the array that was mutated
   * @param {Array} splices Array of splice records
   * @return {void}
   * @private
   */
  function _notifySplices(inst, array, path, splices) {
    const splicesData = {
      indexSplices: splices
    };
    // Legacy behavior stored splices in `__data__` so it was *not* ephemeral.
    // To match this behavior, we store splices directly on the array.
    if (legacyUndefined && !inst._overrideLegacyUndefined) {
      array.splices = splicesData;
    }
    inst.notifyPath(path + '.splices', splicesData);
    inst.notifyPath(path + '.length', array.length);
    // Clear splice data only when it's stored on the array.
    if (legacyUndefined && !inst._overrideLegacyUndefined) {
      splicesData.indexSplices = [];
    }
  }

  /**
   * Creates a splice record and sends an array splice notification for
   * the described mutation
   *
   * Note: this implementation only accepts normalized paths
   *
   * @param {!Polymer_PropertyEffects} inst Instance to send notifications to
   * @param {Array} array The array the mutations occurred on
   * @param {string} path The path to the array that was mutated
   * @param {number} index Index at which the array mutation occurred
   * @param {number} addedCount Number of added items
   * @param {Array} removed Array of removed items
   * @return {void}
   * @private
   */
  function notifySplice(inst, array, path, index, addedCount, removed) {
    _notifySplices(inst, array, path, [{
      index: index,
      addedCount: addedCount,
      removed: removed,
      object: array,
      type: 'splice'
    }]);
  }

  /**
   * Returns an upper-cased version of the string.
   *
   * @param {string} name String to uppercase
   * @return {string} Uppercased string
   * @private
   */
  function upper(name) {
    return name[0].toUpperCase() + name.substring(1);
  }

  /**
   * Element class mixin that provides meta-programming for Polymer's template
   * binding and data observation (collectively, "property effects") system.
   *
   * This mixin uses provides the following key static methods for adding
   * property effects to an element class:
   * - `addPropertyEffect`
   * - `createPropertyObserver`
   * - `createMethodObserver`
   * - `createNotifyingProperty`
   * - `createReadOnlyProperty`
   * - `createReflectedProperty`
   * - `createComputedProperty`
   * - `bindTemplate`
   *
   * Each method creates one or more property accessors, along with metadata
   * used by this mixin's implementation of `_propertiesChanged` to perform
   * the property effects.
   *
   * Underscored versions of the above methods also exist on the element
   * prototype for adding property effects on instances at runtime.
   *
   * Note that this mixin overrides several `PropertyAccessors` methods, in
   * many cases to maintain guarantees provided by the Polymer 1.x features;
   * notably it changes property accessors to be synchronous by default
   * whereas the default when using `PropertyAccessors` standalone is to be
   * async by default.
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin TemplateStamp
   * @appliesMixin PropertyAccessors
   * @summary Element class mixin that provides meta-programming for Polymer's
   * template binding and data observation system.
   */
  const PropertyEffects = dedupingMixin(superClass => {
    /**
     * @constructor
     * @implements {Polymer_PropertyAccessors}
     * @implements {Polymer_TemplateStamp}
     * @unrestricted
     * @private
     */
    const propertyEffectsBase = TemplateStamp(PropertyAccessors(superClass));

    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_PropertyEffects}
     * @extends {propertyEffectsBase}
     * @unrestricted
     */
    let PropertyEffects = /*#__PURE__*/function (_propertyEffectsBase) {
      _inherits(PropertyEffects, _propertyEffectsBase);
      var _super = _createSuper(PropertyEffects);
      function PropertyEffects() {
        var _this;
        _classCallCheck(this, PropertyEffects);
        _this = _super.call(this);
        /** @type {boolean} */
        // Used to identify users of this mixin, ala instanceof
        _this.__isPropertyEffectsClient = true;
        /** @type {boolean} */
        _this.__dataClientsReady;
        /** @type {Array} */
        _this.__dataPendingClients;
        /** @type {Object} */
        _this.__dataToNotify;
        /** @type {Object} */
        _this.__dataLinkedPaths;
        /** @type {boolean} */
        _this.__dataHasPaths;
        /** @type {Object} */
        _this.__dataCompoundStorage;
        /** @type {Polymer_PropertyEffects} */
        _this.__dataHost;
        /** @type {!Object} */
        _this.__dataTemp;
        /** @type {boolean} */
        _this.__dataClientsInitialized;
        /** @type {!Object} */
        _this.__data;
        /** @type {!Object|null} */
        _this.__dataPending;
        /** @type {!Object} */
        _this.__dataOld;
        /** @type {Object} */
        _this.__computeEffects;
        /** @type {Object} */
        _this.__computeInfo;
        /** @type {Object} */
        _this.__reflectEffects;
        /** @type {Object} */
        _this.__notifyEffects;
        /** @type {Object} */
        _this.__propagateEffects;
        /** @type {Object} */
        _this.__observeEffects;
        /** @type {Object} */
        _this.__readOnly;
        /** @type {!TemplateInfo} */
        _this.__templateInfo;
        /** @type {boolean} */
        _this._overrideLegacyUndefined;
        return _this;
      }
      _createClass(PropertyEffects, [{
        key: "PROPERTY_EFFECT_TYPES",
        get: function () {
          return TYPES;
        }

        /**
         * @override
         * @return {void}
         */
      }, {
        key: "_initializeProperties",
        value: function _initializeProperties() {
          _get(_getPrototypeOf(PropertyEffects.prototype), "_initializeProperties", this).call(this);
          this._registerHost();
          this.__dataClientsReady = false;
          this.__dataPendingClients = null;
          this.__dataToNotify = null;
          this.__dataLinkedPaths = null;
          this.__dataHasPaths = false;
          // May be set on instance prior to upgrade
          this.__dataCompoundStorage = this.__dataCompoundStorage || null;
          this.__dataHost = this.__dataHost || null;
          this.__dataTemp = {};
          this.__dataClientsInitialized = false;
        }
      }, {
        key: "_registerHost",
        value: function _registerHost() {
          if (hostStack.length) {
            let host = hostStack[hostStack.length - 1];
            host._enqueueClient(this);
            // This ensures even non-bound elements have a host set, as
            // long as they upgrade synchronously
            this.__dataHost = host;
          }
        }

        /**
         * Overrides `PropertyAccessors` implementation to provide a
         * more efficient implementation of initializing properties from
         * the prototype on the instance.
         *
         * @override
         * @param {Object} props Properties to initialize on the prototype
         * @return {void}
         */
      }, {
        key: "_initializeProtoProperties",
        value: function _initializeProtoProperties(props) {
          this.__data = Object.create(props);
          this.__dataPending = Object.create(props);
          this.__dataOld = {};
        }

        /**
         * Overrides `PropertyAccessors` implementation to avoid setting
         * `_setProperty`'s `shouldNotify: true`.
         *
         * @override
         * @param {Object} props Properties to initialize on the instance
         * @return {void}
         */
      }, {
        key: "_initializeInstanceProperties",
        value: function _initializeInstanceProperties(props) {
          let readOnly = this[TYPES.READ_ONLY];
          for (let prop in props) {
            if (!readOnly || !readOnly[prop]) {
              this.__dataPending = this.__dataPending || {};
              this.__dataOld = this.__dataOld || {};
              this.__data[prop] = this.__dataPending[prop] = props[prop];
            }
          }
        }

        // Prototype setup ----------------------------------------

        /**
         * Equivalent to static `addPropertyEffect` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} property Property that should trigger the effect
         * @param {string} type Effect type, from this.PROPERTY_EFFECT_TYPES
         * @param {Object=} effect Effect metadata object
         * @return {void}
         * @protected
         */
      }, {
        key: "_addPropertyEffect",
        value: function _addPropertyEffect(property, type, effect) {
          this._createPropertyAccessor(property, type == TYPES.READ_ONLY);
          // effects are accumulated into arrays per property based on type
          let effects = ensureOwnEffectMap(this, type, true)[property];
          if (!effects) {
            effects = this[type][property] = [];
          }
          effects.push(effect);
        }

        /**
         * Removes the given property effect.
         *
         * @override
         * @param {string} property Property the effect was associated with
         * @param {string} type Effect type, from this.PROPERTY_EFFECT_TYPES
         * @param {Object=} effect Effect metadata object to remove
         * @return {void}
         */
      }, {
        key: "_removePropertyEffect",
        value: function _removePropertyEffect(property, type, effect) {
          let effects = ensureOwnEffectMap(this, type, true)[property];
          let idx = effects.indexOf(effect);
          if (idx >= 0) {
            effects.splice(idx, 1);
          }
        }

        /**
         * Returns whether the current prototype/instance has a property effect
         * of a certain type.
         *
         * @override
         * @param {string} property Property name
         * @param {string=} type Effect type, from this.PROPERTY_EFFECT_TYPES
         * @return {boolean} True if the prototype/instance has an effect of this
         *     type
         * @protected
         */
      }, {
        key: "_hasPropertyEffect",
        value: function _hasPropertyEffect(property, type) {
          let effects = this[type];
          return Boolean(effects && effects[property]);
        }

        /**
         * Returns whether the current prototype/instance has a "read only"
         * accessor for the given property.
         *
         * @override
         * @param {string} property Property name
         * @return {boolean} True if the prototype/instance has an effect of this
         *     type
         * @protected
         */
      }, {
        key: "_hasReadOnlyEffect",
        value: function _hasReadOnlyEffect(property) {
          return this._hasPropertyEffect(property, TYPES.READ_ONLY);
        }

        /**
         * Returns whether the current prototype/instance has a "notify"
         * property effect for the given property.
         *
         * @override
         * @param {string} property Property name
         * @return {boolean} True if the prototype/instance has an effect of this
         *     type
         * @protected
         */
      }, {
        key: "_hasNotifyEffect",
        value: function _hasNotifyEffect(property) {
          return this._hasPropertyEffect(property, TYPES.NOTIFY);
        }

        /**
         * Returns whether the current prototype/instance has a "reflect to
         * attribute" property effect for the given property.
         *
         * @override
         * @param {string} property Property name
         * @return {boolean} True if the prototype/instance has an effect of this
         *     type
         * @protected
         */
      }, {
        key: "_hasReflectEffect",
        value: function _hasReflectEffect(property) {
          return this._hasPropertyEffect(property, TYPES.REFLECT);
        }

        /**
         * Returns whether the current prototype/instance has a "computed"
         * property effect for the given property.
         *
         * @override
         * @param {string} property Property name
         * @return {boolean} True if the prototype/instance has an effect of this
         *     type
         * @protected
         */
      }, {
        key: "_hasComputedEffect",
        value: function _hasComputedEffect(property) {
          return this._hasPropertyEffect(property, TYPES.COMPUTE);
        }

        // Runtime ----------------------------------------

        /**
         * Sets a pending property or path.  If the root property of the path in
         * question had no accessor, the path is set, otherwise it is enqueued
         * via `_setPendingProperty`.
         *
         * This function isolates relatively expensive functionality necessary
         * for the public API (`set`, `setProperties`, `notifyPath`, and property
         * change listeners via {{...}} bindings), such that it is only done
         * when paths enter the system, and not at every propagation step.  It
         * also sets a `__dataHasPaths` flag on the instance which is used to
         * fast-path slower path-matching code in the property effects host paths.
         *
         * `path` can be a path string or array of path parts as accepted by the
         * public API.
         *
         * @override
         * @param {string | !Array<number|string>} path Path to set
         * @param {*} value Value to set
         * @param {boolean=} shouldNotify Set to true if this change should
         *  cause a property notification event dispatch
         * @param {boolean=} isPathNotification If the path being set is a path
         *   notification of an already changed value, as opposed to a request
         *   to set and notify the change.  In the latter `false` case, a dirty
         *   check is performed and then the value is set to the path before
         *   enqueuing the pending property change.
         * @return {boolean} Returns true if the property/path was enqueued in
         *   the pending changes bag.
         * @protected
         */
      }, {
        key: "_setPendingPropertyOrPath",
        value: function _setPendingPropertyOrPath(path, value, shouldNotify, isPathNotification) {
          if (isPathNotification || root(Array.isArray(path) ? path[0] : path) !== path) {
            // Dirty check changes being set to a path against the actual object,
            // since this is the entry point for paths into the system; from here
            // the only dirty checks are against the `__dataTemp` cache to prevent
            // duplicate work in the same turn only. Note, if this was a notification
            // of a change already set to a path (isPathNotification: true),
            // we always let the change through and skip the `set` since it was
            // already dirty checked at the point of entry and the underlying
            // object has already been updated
            if (!isPathNotification) {
              let old = get(this, path);
              path = /** @type {string} */set(this, path, value);
              // Use property-accessor's simpler dirty check
              if (!path || !_get(_getPrototypeOf(PropertyEffects.prototype), "_shouldPropertyChange", this).call(this, path, value, old)) {
                return false;
              }
            }
            this.__dataHasPaths = true;
            if (this._setPendingProperty( /**@type{string}*/path, value, shouldNotify)) {
              computeLinkedPaths(this, /**@type{string}*/path, value);
              return true;
            }
          } else {
            if (this.__dataHasAccessor && this.__dataHasAccessor[path]) {
              return this._setPendingProperty( /**@type{string}*/path, value, shouldNotify);
            } else {
              this[path] = value;
            }
          }
          return false;
        }

        /**
         * Applies a value to a non-Polymer element/node's property.
         *
         * The implementation makes a best-effort at binding interop:
         * Some native element properties have side-effects when
         * re-setting the same value (e.g. setting `<input>.value` resets the
         * cursor position), so we do a dirty-check before setting the value.
         * However, for better interop with non-Polymer custom elements that
         * accept objects, we explicitly re-set object changes coming from the
         * Polymer world (which may include deep object changes without the
         * top reference changing), erring on the side of providing more
         * information.
         *
         * Users may override this method to provide alternate approaches.
         *
         * @override
         * @param {!Node} node The node to set a property on
         * @param {string} prop The property to set
         * @param {*} value The value to set
         * @return {void}
         * @protected
         */
      }, {
        key: "_setUnmanagedPropertyToNode",
        value: function _setUnmanagedPropertyToNode(node, prop, value) {
          // It is a judgment call that resetting primitives is
          // "bad" and resettings objects is also "good"; alternatively we could
          // implement a whitelist of tag & property values that should never
          // be reset (e.g. <input>.value && <select>.value)
          if (value !== node[prop] || typeof value == 'object') {
            // Note, className needs style scoping so this needs wrapping.
            if (prop === 'className') {
              node = /** @type {!Node} */wrap(node);
            }
            node[prop] = value;
          }
        }

        /**
         * Overrides the `PropertiesChanged` implementation to introduce special
         * dirty check logic depending on the property & value being set:
         *
         * 1. Any value set to a path (e.g. 'obj.prop': 42 or 'obj.prop': {...})
         *    Stored in `__dataTemp`, dirty checked against `__dataTemp`
         * 2. Object set to simple property (e.g. 'prop': {...})
         *    Stored in `__dataTemp` and `__data`, dirty checked against
         *    `__dataTemp` by default implementation of `_shouldPropertyChange`
         * 3. Primitive value set to simple property (e.g. 'prop': 42)
         *    Stored in `__data`, dirty checked against `__data`
         *
         * The dirty-check is important to prevent cycles due to two-way
         * notification, but paths and objects are only dirty checked against any
         * previous value set during this turn via a "temporary cache" that is
         * cleared when the last `_propertiesChanged` exits. This is so:
         * a. any cached array paths (e.g. 'array.3.prop') may be invalidated
         *    due to array mutations like shift/unshift/splice; this is fine
         *    since path changes are dirty-checked at user entry points like `set`
         * b. dirty-checking for objects only lasts one turn to allow the user
         *    to mutate the object in-place and re-set it with the same identity
         *    and have all sub-properties re-propagated in a subsequent turn.
         *
         * The temp cache is not necessarily sufficient to prevent invalid array
         * paths, since a splice can happen during the same turn (with pathological
         * user code); we could introduce a "fixup" for temporarily cached array
         * paths if needed: https://github.com/Polymer/polymer/issues/4227
         *
         * @override
         * @param {string} property Name of the property
         * @param {*} value Value to set
         * @param {boolean=} shouldNotify True if property should fire notification
         *   event (applies only for `notify: true` properties)
         * @return {boolean} Returns true if the property changed
         */
      }, {
        key: "_setPendingProperty",
        value: function _setPendingProperty(property, value, shouldNotify) {
          let propIsPath = this.__dataHasPaths && isPath(property);
          let prevProps = propIsPath ? this.__dataTemp : this.__data;
          if (this._shouldPropertyChange(property, value, prevProps[property])) {
            if (!this.__dataPending) {
              this.__dataPending = {};
              this.__dataOld = {};
            }
            // Ensure old is captured from the last turn
            if (!(property in this.__dataOld)) {
              this.__dataOld[property] = this.__data[property];
            }
            // Paths are stored in temporary cache (cleared at end of turn),
            // which is used for dirty-checking, all others stored in __data
            if (propIsPath) {
              this.__dataTemp[property] = value;
            } else {
              this.__data[property] = value;
            }
            // All changes go into pending property bag, passed to _propertiesChanged
            this.__dataPending[property] = value;
            // Track properties that should notify separately
            if (propIsPath || this[TYPES.NOTIFY] && this[TYPES.NOTIFY][property]) {
              this.__dataToNotify = this.__dataToNotify || {};
              this.__dataToNotify[property] = shouldNotify;
            }
            return true;
          }
          return false;
        }

        /**
         * Overrides base implementation to ensure all accessors set `shouldNotify`
         * to true, for per-property notification tracking.
         *
         * @override
         * @param {string} property Name of the property
         * @param {*} value Value to set
         * @return {void}
         */
      }, {
        key: "_setProperty",
        value: function _setProperty(property, value) {
          if (this._setPendingProperty(property, value, true)) {
            this._invalidateProperties();
          }
        }

        /**
         * Overrides `PropertyAccessor`'s default async queuing of
         * `_propertiesChanged`: if `__dataReady` is false (has not yet been
         * manually flushed), the function no-ops; otherwise flushes
         * `_propertiesChanged` synchronously.
         *
         * @override
         * @return {void}
         */
      }, {
        key: "_invalidateProperties",
        value: function _invalidateProperties() {
          if (this.__dataReady) {
            this._flushProperties();
          }
        }

        /**
         * Enqueues the given client on a list of pending clients, whose
         * pending property changes can later be flushed via a call to
         * `_flushClients`.
         *
         * @override
         * @param {Object} client PropertyEffects client to enqueue
         * @return {void}
         * @protected
         */
      }, {
        key: "_enqueueClient",
        value: function _enqueueClient(client) {
          this.__dataPendingClients = this.__dataPendingClients || [];
          if (client !== this) {
            this.__dataPendingClients.push(client);
          }
        }

        /**
         * Flushes any clients previously enqueued via `_enqueueClient`, causing
         * their `_flushProperties` method to run.
         *
         * @override
         * @return {void}
         * @protected
         */
      }, {
        key: "_flushClients",
        value: function _flushClients() {
          if (!this.__dataClientsReady) {
            this.__dataClientsReady = true;
            this._readyClients();
            // Override point where accessors are turned on; importantly,
            // this is after clients have fully readied, providing a guarantee
            // that any property effects occur only after all clients are ready.
            this.__dataReady = true;
          } else {
            this.__enableOrFlushClients();
          }
        }

        // NOTE: We ensure clients either enable or flush as appropriate. This
        // handles two corner cases:
        // (1) clients flush properly when connected/enabled before the host
        // enables; e.g.
        //   (a) Templatize stamps with no properties and does not flush and
        //   (b) the instance is inserted into dom and
        //   (c) then the instance flushes.
        // (2) clients enable properly when not connected/enabled when the host
        // flushes; e.g.
        //   (a) a template is runtime stamped and not yet connected/enabled
        //   (b) a host sets a property, causing stamped dom to flush
        //   (c) the stamped dom enables.
      }, {
        key: "__enableOrFlushClients",
        value: function __enableOrFlushClients() {
          let clients = this.__dataPendingClients;
          if (clients) {
            this.__dataPendingClients = null;
            for (let i = 0; i < clients.length; i++) {
              let client = clients[i];
              if (!client.__dataEnabled) {
                client._enableProperties();
              } else if (client.__dataPending) {
                client._flushProperties();
              }
            }
          }
        }

        /**
         * Perform any initial setup on client dom. Called before the first
         * `_flushProperties` call on client dom and before any element
         * observers are called.
         *
         * @override
         * @return {void}
         * @protected
         */
      }, {
        key: "_readyClients",
        value: function _readyClients() {
          this.__enableOrFlushClients();
        }

        /**
         * Sets a bag of property changes to this instance, and
         * synchronously processes all effects of the properties as a batch.
         *
         * Property names must be simple properties, not paths.  Batched
         * path propagation is not supported.
         *
         * @override
         * @param {Object} props Bag of one or more key-value pairs whose key is
         *   a property and value is the new value to set for that property.
         * @param {boolean=} setReadOnly When true, any private values set in
         *   `props` will be set. By default, `setProperties` will not set
         *   `readOnly: true` root properties.
         * @return {void}
         * @public
         */
      }, {
        key: "setProperties",
        value: function setProperties(props, setReadOnly) {
          for (let path in props) {
            if (setReadOnly || !this[TYPES.READ_ONLY] || !this[TYPES.READ_ONLY][path]) {
              //TODO(kschaaf): explicitly disallow paths in setProperty?
              // wildcard observers currently only pass the first changed path
              // in the `info` object, and you could do some odd things batching
              // paths, e.g. {'foo.bar': {...}, 'foo': null}
              this._setPendingPropertyOrPath(path, props[path], true);
            }
          }
          this._invalidateProperties();
        }

        /**
         * Overrides `PropertyAccessors` so that property accessor
         * side effects are not enabled until after client dom is fully ready.
         * Also calls `_flushClients` callback to ensure client dom is enabled
         * that was not enabled as a result of flushing properties.
         *
         * @override
         * @return {void}
         */
      }, {
        key: "ready",
        value: function ready() {
          // It is important that `super.ready()` is not called here as it
          // immediately turns on accessors. Instead, we wait until `readyClients`
          // to enable accessors to provide a guarantee that clients are ready
          // before processing any accessors side effects.
          this._flushProperties();
          // If no data was pending, `_flushProperties` will not `flushClients`
          // so ensure this is done.
          if (!this.__dataClientsReady) {
            this._flushClients();
          }
          // Before ready, client notifications do not trigger _flushProperties.
          // Therefore a flush is necessary here if data has been set.
          if (this.__dataPending) {
            this._flushProperties();
          }
        }

        /**
         * Implements `PropertyAccessors`'s properties changed callback.
         *
         * Runs each class of effects for the batch of changed properties in
         * a specific order (compute, propagate, reflect, observe, notify).
         *
         * @override
         * @param {!Object} currentProps Bag of all current accessor values
         * @param {?Object} changedProps Bag of properties changed since the last
         *   call to `_propertiesChanged`
         * @param {?Object} oldProps Bag of previous values for each property
         *   in `changedProps`
         * @return {void}
         */
      }, {
        key: "_propertiesChanged",
        value: function _propertiesChanged(currentProps, changedProps, oldProps) {
          // ----------------------------
          // let c = Object.getOwnPropertyNames(changedProps || {});
          // window.debug && console.group(this.localName + '#' + this.id + ': ' + c);
          // if (window.debug) { debugger; }
          // ----------------------------
          let hasPaths = this.__dataHasPaths;
          this.__dataHasPaths = false;
          let notifyProps;
          // Compute properties
          runComputedEffects(this, changedProps, oldProps, hasPaths);
          // Clear notify properties prior to possible reentry (propagate, observe),
          // but after computing effects have a chance to add to them
          notifyProps = this.__dataToNotify;
          this.__dataToNotify = null;
          // Propagate properties to clients
          this._propagatePropertyChanges(changedProps, oldProps, hasPaths);
          // Flush clients
          this._flushClients();
          // Reflect properties
          runEffects(this, this[TYPES.REFLECT], changedProps, oldProps, hasPaths);
          // Observe properties
          runEffects(this, this[TYPES.OBSERVE], changedProps, oldProps, hasPaths);
          // Notify properties to host
          if (notifyProps) {
            runNotifyEffects(this, notifyProps, changedProps, oldProps, hasPaths);
          }
          // Clear temporary cache at end of turn
          if (this.__dataCounter == 1) {
            this.__dataTemp = {};
          }
          // ----------------------------
          // window.debug && console.groupEnd(this.localName + '#' + this.id + ': ' + c);
          // ----------------------------
        }

        /**
         * Called to propagate any property changes to stamped template nodes
         * managed by this element.
         *
         * @override
         * @param {Object} changedProps Bag of changed properties
         * @param {Object} oldProps Bag of previous values for changed properties
         * @param {boolean} hasPaths True with `props` contains one or more paths
         * @return {void}
         * @protected
         */
      }, {
        key: "_propagatePropertyChanges",
        value: function _propagatePropertyChanges(changedProps, oldProps, hasPaths) {
          if (this[TYPES.PROPAGATE]) {
            runEffects(this, this[TYPES.PROPAGATE], changedProps, oldProps, hasPaths);
          }
          if (this.__templateInfo) {
            this._runEffectsForTemplate(this.__templateInfo, changedProps, oldProps, hasPaths);
          }
        }
      }, {
        key: "_runEffectsForTemplate",
        value: function _runEffectsForTemplate(templateInfo, changedProps, oldProps, hasPaths) {
          const baseRunEffects = (changedProps, hasPaths) => {
            runEffects(this, templateInfo.propertyEffects, changedProps, oldProps, hasPaths, templateInfo.nodeList);
            for (let info = templateInfo.firstChild; info; info = info.nextSibling) {
              this._runEffectsForTemplate(info, changedProps, oldProps, hasPaths);
            }
          };
          if (templateInfo.runEffects) {
            templateInfo.runEffects(baseRunEffects, changedProps, hasPaths);
          } else {
            baseRunEffects(changedProps, hasPaths);
          }
        }

        /**
         * Aliases one data path as another, such that path notifications from one
         * are routed to the other.
         *
         * @override
         * @param {string | !Array<string|number>} to Target path to link.
         * @param {string | !Array<string|number>} from Source path to link.
         * @return {void}
         * @public
         */
      }, {
        key: "linkPaths",
        value: function linkPaths(to, from) {
          to = normalize(to);
          from = normalize(from);
          this.__dataLinkedPaths = this.__dataLinkedPaths || {};
          this.__dataLinkedPaths[to] = from;
        }

        /**
         * Removes a data path alias previously established with `_linkPaths`.
         *
         * Note, the path to unlink should be the target (`to`) used when
         * linking the paths.
         *
         * @override
         * @param {string | !Array<string|number>} path Target path to unlink.
         * @return {void}
         * @public
         */
      }, {
        key: "unlinkPaths",
        value: function unlinkPaths(path) {
          path = normalize(path);
          if (this.__dataLinkedPaths) {
            delete this.__dataLinkedPaths[path];
          }
        }

        /**
         * Notify that an array has changed.
         *
         * Example:
         *
         *     this.items = [ {name: 'Jim'}, {name: 'Todd'}, {name: 'Bill'} ];
         *     ...
         *     this.items.splice(1, 1, {name: 'Sam'});
         *     this.items.push({name: 'Bob'});
         *     this.notifySplices('items', [
         *       { index: 1, removed: [{name: 'Todd'}], addedCount: 1,
         *         object: this.items, type: 'splice' },
         *       { index: 3, removed: [], addedCount: 1,
         *         object: this.items, type: 'splice'}
         *     ]);
         *
         * @param {string} path Path that should be notified.
         * @param {Array} splices Array of splice records indicating ordered
         *   changes that occurred to the array. Each record should have the
         *   following fields:
         *    * index: index at which the change occurred
         *    * removed: array of items that were removed from this index
         *    * addedCount: number of new items added at this index
         *    * object: a reference to the array in question
         *    * type: the string literal 'splice'
         *
         *   Note that splice records _must_ be normalized such that they are
         *   reported in index order (raw results from `Object.observe` are not
         *   ordered and must be normalized/merged before notifying).
         *
         * @override
         * @return {void}
         * @public
         */
      }, {
        key: "notifySplices",
        value: function notifySplices(path, splices) {
          let info = {
            path: ''
          };
          let array = /** @type {Array} */get(this, path, info);
          _notifySplices(this, array, info.path, splices);
        }

        /**
         * Convenience method for reading a value from a path.
         *
         * Note, if any part in the path is undefined, this method returns
         * `undefined` (this method does not throw when dereferencing undefined
         * paths).
         *
         * @override
         * @param {(string|!Array<(string|number)>)} path Path to the value
         *   to read.  The path may be specified as a string (e.g. `foo.bar.baz`)
         *   or an array of path parts (e.g. `['foo.bar', 'baz']`).  Note that
         *   bracketed expressions are not supported; string-based path parts
         *   *must* be separated by dots.  Note that when dereferencing array
         *   indices, the index may be used as a dotted part directly
         *   (e.g. `users.12.name` or `['users', 12, 'name']`).
         * @param {Object=} root Root object from which the path is evaluated.
         * @return {*} Value at the path, or `undefined` if any part of the path
         *   is undefined.
         * @public
         */
      }, {
        key: "get",
        value: function get$1(path, root) {
          return get(root || this, path);
        }

        /**
         * Convenience method for setting a value to a path and notifying any
         * elements bound to the same path.
         *
         * Note, if any part in the path except for the last is undefined,
         * this method does nothing (this method does not throw when
         * dereferencing undefined paths).
         *
         * @override
         * @param {(string|!Array<(string|number)>)} path Path to the value
         *   to write.  The path may be specified as a string (e.g. `'foo.bar.baz'`)
         *   or an array of path parts (e.g. `['foo.bar', 'baz']`).  Note that
         *   bracketed expressions are not supported; string-based path parts
         *   *must* be separated by dots.  Note that when dereferencing array
         *   indices, the index may be used as a dotted part directly
         *   (e.g. `'users.12.name'` or `['users', 12, 'name']`).
         * @param {*} value Value to set at the specified path.
         * @param {Object=} root Root object from which the path is evaluated.
         *   When specified, no notification will occur.
         * @return {void}
         * @public
         */
      }, {
        key: "set",
        value: function set$1(path, value, root) {
          if (root) {
            set(root, path, value);
          } else {
            if (!this[TYPES.READ_ONLY] || !this[TYPES.READ_ONLY][/** @type {string} */path]) {
              if (this._setPendingPropertyOrPath(path, value, true)) {
                this._invalidateProperties();
              }
            }
          }
        }

        /**
         * Adds items onto the end of the array at the path specified.
         *
         * The arguments after `path` and return value match that of
         * `Array.prototype.push`.
         *
         * This method notifies other paths to the same array that a
         * splice occurred to the array.
         *
         * @override
         * @param {string | !Array<string|number>} path Path to array.
         * @param {...*} items Items to push onto array
         * @return {number} New length of the array.
         * @public
         */
      }, {
        key: "push",
        value: function push(path) {
          let info = {
            path: ''
          };
          let array = /** @type {Array}*/get(this, path, info);
          let len = array.length;
          for (var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            items[_key - 1] = arguments[_key];
          }
          let ret = array.push.apply(array, items);
          if (items.length) {
            notifySplice(this, array, info.path, len, items.length, []);
          }
          return ret;
        }

        /**
         * Removes an item from the end of array at the path specified.
         *
         * The arguments after `path` and return value match that of
         * `Array.prototype.pop`.
         *
         * This method notifies other paths to the same array that a
         * splice occurred to the array.
         *
         * @override
         * @param {string | !Array<string|number>} path Path to array.
         * @return {*} Item that was removed.
         * @public
         */
      }, {
        key: "pop",
        value: function pop(path) {
          let info = {
            path: ''
          };
          let array = /** @type {Array} */get(this, path, info);
          let hadLength = Boolean(array.length);
          let ret = array.pop();
          if (hadLength) {
            notifySplice(this, array, info.path, array.length, 0, [ret]);
          }
          return ret;
        }

        /**
         * Starting from the start index specified, removes 0 or more items
         * from the array and inserts 0 or more new items in their place.
         *
         * The arguments after `path` and return value match that of
         * `Array.prototype.splice`.
         *
         * This method notifies other paths to the same array that a
         * splice occurred to the array.
         *
         * @override
         * @param {string | !Array<string|number>} path Path to array.
         * @param {number} start Index from which to start removing/inserting.
         * @param {number=} deleteCount Number of items to remove.
         * @param {...*} items Items to insert into array.
         * @return {!Array} Array of removed items.
         * @public
         */
      }, {
        key: "splice",
        value: function splice(path, start, deleteCount) {
          for (var _len2 = arguments.length, items = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
            items[_key2 - 3] = arguments[_key2];
          }
          let info = {
            path: ''
          };
          let array = /** @type {Array} */get(this, path, info);
          // Normalize fancy native splice handling of crazy start values
          if (start < 0) {
            start = array.length - Math.floor(-start);
          } else if (start) {
            start = Math.floor(start);
          }
          // array.splice does different things based on the number of arguments
          // you pass in. Therefore, array.splice(0) and array.splice(0, undefined)
          // do different things. In the former, the whole array is cleared. In the
          // latter, no items are removed.
          // This means that we need to detect whether 1. one of the arguments
          // is actually passed in and then 2. determine how many arguments
          // we should pass on to the native array.splice
          //
          let ret;
          // Omit any additional arguments if they were not passed in
          if (arguments.length === 2) {
            ret = array.splice(start);
            // Either start was undefined and the others were defined, but in this
            // case we can safely pass on all arguments
            //
            // Note: this includes the case where none of the arguments were passed in,
            // e.g. this.splice('array'). However, if both start and deleteCount
            // are undefined, array.splice will not modify the array (as expected)
          } else {
            ret = array.splice.apply(array, [start, deleteCount].concat(items));
          }
          // At the end, check whether any items were passed in (e.g. insertions)
          // or if the return array contains items (e.g. deletions).
          // Only notify if items were added or deleted.
          if (items.length || ret.length) {
            notifySplice(this, array, info.path, start, items.length, ret);
          }
          return ret;
        }

        /**
         * Removes an item from the beginning of array at the path specified.
         *
         * The arguments after `path` and return value match that of
         * `Array.prototype.pop`.
         *
         * This method notifies other paths to the same array that a
         * splice occurred to the array.
         *
         * @override
         * @param {string | !Array<string|number>} path Path to array.
         * @return {*} Item that was removed.
         * @public
         */
      }, {
        key: "shift",
        value: function shift(path) {
          let info = {
            path: ''
          };
          let array = /** @type {Array} */get(this, path, info);
          let hadLength = Boolean(array.length);
          let ret = array.shift();
          if (hadLength) {
            notifySplice(this, array, info.path, 0, 0, [ret]);
          }
          return ret;
        }

        /**
         * Adds items onto the beginning of the array at the path specified.
         *
         * The arguments after `path` and return value match that of
         * `Array.prototype.push`.
         *
         * This method notifies other paths to the same array that a
         * splice occurred to the array.
         *
         * @override
         * @param {string | !Array<string|number>} path Path to array.
         * @param {...*} items Items to insert info array
         * @return {number} New length of the array.
         * @public
         */
      }, {
        key: "unshift",
        value: function unshift(path) {
          let info = {
            path: ''
          };
          let array = /** @type {Array} */get(this, path, info);
          for (var _len3 = arguments.length, items = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            items[_key3 - 1] = arguments[_key3];
          }
          let ret = array.unshift.apply(array, items);
          if (items.length) {
            notifySplice(this, array, info.path, 0, items.length, []);
          }
          return ret;
        }

        /**
         * Notify that a path has changed.
         *
         * Example:
         *
         *     this.item.user.name = 'Bob';
         *     this.notifyPath('item.user.name');
         *
         * @override
         * @param {string} path Path that should be notified.
         * @param {*=} value Value at the path (optional).
         * @return {void}
         * @public
         */
      }, {
        key: "notifyPath",
        value: function notifyPath(path, value) {
          /** @type {string} */
          let propPath;
          if (arguments.length == 1) {
            // Get value if not supplied
            let info = {
              path: ''
            };
            value = get(this, path, info);
            propPath = info.path;
          } else if (Array.isArray(path)) {
            // Normalize path if needed
            propPath = normalize(path);
          } else {
            propPath = /** @type{string} */path;
          }
          if (this._setPendingPropertyOrPath(propPath, value, true, true)) {
            this._invalidateProperties();
          }
        }

        /**
         * Equivalent to static `createReadOnlyProperty` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} property Property name
         * @param {boolean=} protectedSetter Creates a custom protected setter
         *   when `true`.
         * @return {void}
         * @protected
         */
      }, {
        key: "_createReadOnlyProperty",
        value: function _createReadOnlyProperty(property, protectedSetter) {
          this._addPropertyEffect(property, TYPES.READ_ONLY);
          if (protectedSetter) {
            this['_set' + upper(property)] = /** @this {PropertyEffects} */function (value) {
              this._setProperty(property, value);
            };
          }
        }

        /**
         * Equivalent to static `createPropertyObserver` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} property Property name
         * @param {string|function(*,*)} method Function or name of observer method
         *     to call
         * @param {boolean=} dynamicFn Whether the method name should be included as
         *   a dependency to the effect.
         * @return {void}
         * @protected
         */
      }, {
        key: "_createPropertyObserver",
        value: function _createPropertyObserver(property, method, dynamicFn) {
          let info = {
            property,
            method,
            dynamicFn: Boolean(dynamicFn)
          };
          this._addPropertyEffect(property, TYPES.OBSERVE, {
            fn: runObserverEffect,
            info,
            trigger: {
              name: property
            }
          });
          if (dynamicFn) {
            this._addPropertyEffect( /** @type {string} */method, TYPES.OBSERVE, {
              fn: runObserverEffect,
              info,
              trigger: {
                name: method
              }
            });
          }
        }

        /**
         * Equivalent to static `createMethodObserver` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} expression Method expression
         * @param {boolean|Object=} dynamicFn Boolean or object map indicating
         *   whether method names should be included as a dependency to the effect.
         * @return {void}
         * @protected
         */
      }, {
        key: "_createMethodObserver",
        value: function _createMethodObserver(expression, dynamicFn) {
          let sig = parseMethod(expression);
          if (!sig) {
            throw new Error("Malformed observer expression '" + expression + "'");
          }
          createMethodEffect(this, sig, TYPES.OBSERVE, runMethodEffect, null, dynamicFn);
        }

        /**
         * Equivalent to static `createNotifyingProperty` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} property Property name
         * @return {void}
         * @protected
         */
      }, {
        key: "_createNotifyingProperty",
        value: function _createNotifyingProperty(property) {
          this._addPropertyEffect(property, TYPES.NOTIFY, {
            fn: runNotifyEffect,
            info: {
              eventName: camelToDashCase(property) + '-changed',
              property: property
            }
          });
        }

        /**
         * Equivalent to static `createReflectedProperty` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} property Property name
         * @return {void}
         * @protected
         * @suppress {missingProperties} go/missingfnprops
         */
      }, {
        key: "_createReflectedProperty",
        value: function _createReflectedProperty(property) {
          let attr = this.constructor.attributeNameForProperty(property);
          if (attr[0] === '-') {
            console.warn('Property ' + property + ' cannot be reflected to attribute ' + attr + ' because "-" is not a valid starting attribute name. Use a lowercase first letter for the property instead.');
          } else {
            this._addPropertyEffect(property, TYPES.REFLECT, {
              fn: runReflectEffect,
              info: {
                attrName: attr
              }
            });
          }
        }

        /**
         * Equivalent to static `createComputedProperty` API but can be called on
         * an instance to add effects at runtime.  See that method for
         * full API docs.
         *
         * @override
         * @param {string} property Name of computed property to set
         * @param {string} expression Method expression
         * @param {boolean|Object=} dynamicFn Boolean or object map indicating
         *   whether method names should be included as a dependency to the effect.
         * @return {void}
         * @protected
         */
      }, {
        key: "_createComputedProperty",
        value: function _createComputedProperty(property, expression, dynamicFn) {
          let sig = parseMethod(expression);
          if (!sig) {
            throw new Error("Malformed computed expression '" + expression + "'");
          }
          const info = createMethodEffect(this, sig, TYPES.COMPUTE, runComputedEffect, property, dynamicFn);
          // Effects are normally stored as map of dependency->effect, but for
          // ordered computation, we also need tree of computedProp->dependencies
          ensureOwnEffectMap(this, COMPUTE_INFO)[property] = info;
        }

        /**
         * Gather the argument values for a method specified in the provided array
         * of argument metadata.
         *
         * The `path` and `value` arguments are used to fill in wildcard descriptor
         * when the method is being called as a result of a path notification.
         *
         * @param {!Array<!MethodArg>} args Array of argument metadata
         * @param {string} path Property/path name that triggered the method effect
         * @param {Object} props Bag of current property changes
         * @return {!Array<*>} Array of argument values
         * @private
         */
      }, {
        key: "_marshalArgs",
        value: function _marshalArgs(args, path, props) {
          const data = this.__data;
          const values = [];
          for (let i = 0, l = args.length; i < l; i++) {
            let {
              name,
              structured,
              wildcard,
              value,
              literal
            } = args[i];
            if (!literal) {
              if (wildcard) {
                const matches = isDescendant(name, path);
                const pathValue = getArgValue(data, props, matches ? path : name);
                value = {
                  path: matches ? path : name,
                  value: pathValue,
                  base: matches ? get(data, name) : pathValue
                };
              } else {
                value = structured ? getArgValue(data, props, name) : data[name];
              }
            }
            // When the `legacyUndefined` flag is enabled, pass a no-op value
            // so that the observer, computed property, or compound binding is aborted.
            if (legacyUndefined && !this._overrideLegacyUndefined && value === undefined && args.length > 1) {
              return NOOP;
            }
            values[i] = value;
          }
          return values;
        }

        // -- static class methods ------------

        /**
         * Ensures an accessor exists for the specified property, and adds
         * to a list of "property effects" that will run when the accessor for
         * the specified property is set.  Effects are grouped by "type", which
         * roughly corresponds to a phase in effect processing.  The effect
         * metadata should be in the following form:
         *
         *     {
         *       fn: effectFunction, // Reference to function to call to perform effect
         *       info: { ... }       // Effect metadata passed to function
         *       trigger: {          // Optional triggering metadata; if not provided
         *         name: string      // the property is treated as a wildcard
         *         structured: boolean
         *         wildcard: boolean
         *       }
         *     }
         *
         * Effects are called from `_propertiesChanged` in the following order by
         * type:
         *
         * 1. COMPUTE
         * 2. PROPAGATE
         * 3. REFLECT
         * 4. OBSERVE
         * 5. NOTIFY
         *
         * Effect functions are called with the following signature:
         *
         *     effectFunction(inst, path, props, oldProps, info, hasPaths)
         *
         * @param {string} property Property that should trigger the effect
         * @param {string} type Effect type, from this.PROPERTY_EFFECT_TYPES
         * @param {Object=} effect Effect metadata object
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "_bindTemplate",
        value:
        // -- binding ----------------------------------------------

        /*
         * Overview of binding flow:
         *
         * During finalization (`instanceBinding==false`, `wasPreBound==false`):
         *  `_bindTemplate(t, false)` called directly during finalization - parses
         *  the template (for the first time), and then assigns that _prototypical_
         *  template info to `__preboundTemplateInfo` _on the prototype_; note in
         *  this case `wasPreBound` is false; this is the first time we're binding
         *  it, thus we create accessors.
         *
         * During first stamping (`instanceBinding==true`, `wasPreBound==true`):
         *   `_stampTemplate` calls `_bindTemplate(t, true)`: the `templateInfo`
         *   returned matches the prebound one, and so this is `wasPreBound == true`
         *   state; thus we _skip_ creating accessors, but _do_ create an instance
         *   of the template info to serve as the start of our linked list (needs to
         *   be an instance, not the prototypical one, so that we can add `nodeList`
         *   to it to contain the `nodeInfo`-ordered list of instance nodes for
         *   bindings, and so we can chain runtime-stamped template infos off of
         *   it). At this point, the call to `_stampTemplate` calls
         *   `applyTemplateInfo` for each nested `<template>` found during parsing
         *   to hand prototypical `_templateInfo` to them; we also pass the _parent_
         *   `templateInfo` to the `<template>` so that we have the instance-time
         *   parent to link the `templateInfo` under in the case it was
         *   runtime-stamped.
         *
         * During subsequent runtime stamping (`instanceBinding==true`,
         *   `wasPreBound==false`): `_stampTemplate` calls `_bindTemplate(t, true)`
         *   - here `templateInfo` is guaranteed to _not_ match the prebound one,
         *   because it was either a different template altogether, or even if it
         *   was the same template, the step above created a instance of the info;
         *   in this case `wasPreBound == false`, so we _do_ create accessors, _and_
         *   link a instance into the linked list.
         */

        /**
         * Equivalent to static `bindTemplate` API but can be called on an instance
         * to add effects at runtime.  See that method for full API docs.
         *
         * This method may be called on the prototype (for prototypical template
         * binding, to avoid creating accessors every instance) once per prototype,
         * and will be called with `runtimeBinding: true` by `_stampTemplate` to
         * create and link an instance of the template metadata associated with a
         * particular stamping.
         *
         * @override
         * @param {!HTMLTemplateElement} template Template containing binding
         * bindings
         * @param {boolean=} instanceBinding When false (default), performs
         * "prototypical" binding of the template and overwrites any previously
         * bound template for the class. When true (as passed from
         * `_stampTemplate`), the template info is instanced and linked into the
         * list of bound templates.
         * @return {!TemplateInfo} Template metadata object; for `runtimeBinding`,
         * this is an instance of the prototypical template info
         * @protected
         * @suppress {missingProperties} go/missingfnprops
         */
        function _bindTemplate(template, instanceBinding) {
          let templateInfo = this.constructor._parseTemplate(template);
          let wasPreBound = this.__preBoundTemplateInfo == templateInfo;
          // Optimization: since this is called twice for proto-bound templates,
          // don't attempt to recreate accessors if this template was pre-bound
          if (!wasPreBound) {
            for (let prop in templateInfo.propertyEffects) {
              this._createPropertyAccessor(prop);
            }
          }
          if (instanceBinding) {
            // For instance-time binding, create instance of template metadata
            // and link into tree of templates if necessary
            templateInfo = /** @type {!TemplateInfo} */Object.create(templateInfo);
            templateInfo.wasPreBound = wasPreBound;
            if (!this.__templateInfo) {
              // Set the info to the root of the tree
              this.__templateInfo = templateInfo;
            } else {
              // Append this template info onto the end of its parent template's
              // list, which will determine the tree structure via which property
              // effects are run; if this template was not nested in another
              // template, use the root template (the first stamped one) as the
              // parent. Note, `parent` is the `templateInfo` instance for this
              // template's parent (containing) template, which was set up in
              // `applyTemplateInfo`.  While a given template's `parent` is set
              // apriori, it is only added to the parent's child list at the point
              // that it is being bound, since a template may or may not ever be
              // stamped, and may be stamped more than once (in which case instances
              // of the template info will be in the tree under its parent more than
              // once).
              const parent = template._parentTemplateInfo || this.__templateInfo;
              const previous = parent.lastChild;
              templateInfo.parent = parent;
              parent.lastChild = templateInfo;
              templateInfo.previousSibling = previous;
              if (previous) {
                previous.nextSibling = templateInfo;
              } else {
                parent.firstChild = templateInfo;
              }
            }
          } else {
            this.__preBoundTemplateInfo = templateInfo;
          }
          return templateInfo;
        }

        /**
         * Adds a property effect to the given template metadata, which is run
         * at the "propagate" stage of `_propertiesChanged` when the template
         * has been bound to the element via `_bindTemplate`.
         *
         * The `effect` object should match the format in `_addPropertyEffect`.
         *
         * @param {Object} templateInfo Template metadata to add effect to
         * @param {string} prop Property that should trigger the effect
         * @param {Object=} effect Effect metadata object
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "_stampTemplate",
        value:
        /**
         * Stamps the provided template and performs instance-time setup for
         * Polymer template features, including data bindings, declarative event
         * listeners, and the `this.$` map of `id`'s to nodes.  A document fragment
         * is returned containing the stamped DOM, ready for insertion into the
         * DOM.
         *
         * This method may be called more than once; however note that due to
         * `shadycss` polyfill limitations, only styles from templates prepared
         * using `ShadyCSS.prepareTemplate` will be correctly polyfilled (scoped
         * to the shadow root and support CSS custom properties), and note that
         * `ShadyCSS.prepareTemplate` may only be called once per element. As such,
         * any styles required by in runtime-stamped templates must be included
         * in the main element template.
         *
         * @param {!HTMLTemplateElement} template Template to stamp
         * @param {TemplateInfo=} templateInfo Optional bound template info associated
         *   with the template to be stamped; if omitted the template will be
         *   automatically bound.
         * @return {!StampedTemplate} Cloned template content
         * @override
         * @protected
         */
        function _stampTemplate(template, templateInfo) {
          templateInfo = templateInfo || /** @type {!TemplateInfo} */this._bindTemplate(template, true);
          // Ensures that created dom is `_enqueueClient`'d to this element so
          // that it can be flushed on next call to `_flushProperties`
          hostStack.push(this);
          let dom = _get(_getPrototypeOf(PropertyEffects.prototype), "_stampTemplate", this).call(this, template, templateInfo);
          hostStack.pop();
          // Add template-instance-specific data to instanced templateInfo
          templateInfo.nodeList = dom.nodeList;
          // Capture child nodes to allow unstamping of non-prototypical templates
          if (!templateInfo.wasPreBound) {
            let nodes = templateInfo.childNodes = [];
            for (let n = dom.firstChild; n; n = n.nextSibling) {
              nodes.push(n);
            }
          }
          dom.templateInfo = templateInfo;
          // Setup compound storage, 2-way listeners, and dataHost for bindings
          setupBindings(this, templateInfo);
          // Flush properties into template nodes; the check on `__dataClientsReady`
          // ensures we don't needlessly run effects for an element's initial
          // prototypical template stamping since they will happen as a part of the
          // first call to `_propertiesChanged`. This flag is set to true
          // after running the initial propagate effects, and immediately before
          // flushing clients. Since downstream clients could cause stamping on
          // this host (e.g. a fastDomIf `dom-if` being forced to render
          // synchronously), this flag ensures effects for runtime-stamped templates
          // are run at this point during the initial element boot-up.
          if (this.__dataClientsReady) {
            this._runEffectsForTemplate(templateInfo, this.__data, null, false);
            this._flushClients();
          }
          return dom;
        }

        /**
         * Removes and unbinds the nodes previously contained in the provided
         * DocumentFragment returned from `_stampTemplate`.
         *
         * @override
         * @param {!StampedTemplate} dom DocumentFragment previously returned
         *   from `_stampTemplate` associated with the nodes to be removed
         * @return {void}
         * @protected
         */
      }, {
        key: "_removeBoundDom",
        value: function _removeBoundDom(dom) {
          // Unlink template info; Note that while the child is unlinked from its
          // parent list, a template's `parent` reference is never removed, since
          // this is is determined by the tree structure and applied at
          // `applyTemplateInfo` time.
          const templateInfo = dom.templateInfo;
          const {
            previousSibling,
            nextSibling,
            parent
          } = templateInfo;
          if (previousSibling) {
            previousSibling.nextSibling = nextSibling;
          } else if (parent) {
            parent.firstChild = nextSibling;
          }
          if (nextSibling) {
            nextSibling.previousSibling = previousSibling;
          } else if (parent) {
            parent.lastChild = previousSibling;
          }
          templateInfo.nextSibling = templateInfo.previousSibling = null;
          // Remove stamped nodes
          let nodes = templateInfo.childNodes;
          for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            wrap(wrap(node).parentNode).removeChild(node);
          }
        }

        /**
         * Overrides default `TemplateStamp` implementation to add support for
         * parsing bindings from `TextNode`'s' `textContent`.  A `bindings`
         * array is added to `nodeInfo` and populated with binding metadata
         * with information capturing the binding target, and a `parts` array
         * with one or more metadata objects capturing the source(s) of the
         * binding.
         *
         * @param {Node} node Node to parse
         * @param {TemplateInfo} templateInfo Template metadata for current template
         * @param {NodeInfo} nodeInfo Node metadata for current template node
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @protected
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
      }], [{
        key: "addPropertyEffect",
        value: function addPropertyEffect(property, type, effect) {
          this.prototype._addPropertyEffect(property, type, effect);
        }

        /**
         * Creates a single-property observer for the given property.
         *
         * @param {string} property Property name
         * @param {string|function(*,*)} method Function or name of observer method to call
         * @param {boolean=} dynamicFn Whether the method name should be included as
         *   a dependency to the effect.
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createPropertyObserver",
        value: function createPropertyObserver(property, method, dynamicFn) {
          this.prototype._createPropertyObserver(property, method, dynamicFn);
        }

        /**
         * Creates a multi-property "method observer" based on the provided
         * expression, which should be a string in the form of a normal JavaScript
         * function signature: `'methodName(arg1, [..., argn])'`.  Each argument
         * should correspond to a property or path in the context of this
         * prototype (or instance), or may be a literal string or number.
         *
         * @param {string} expression Method expression
         * @param {boolean|Object=} dynamicFn Boolean or object map indicating
         * @return {void}
         *   whether method names should be included as a dependency to the effect.
         * @protected
         * @nocollapse
         */
      }, {
        key: "createMethodObserver",
        value: function createMethodObserver(expression, dynamicFn) {
          this.prototype._createMethodObserver(expression, dynamicFn);
        }

        /**
         * Causes the setter for the given property to dispatch `<property>-changed`
         * events to notify of changes to the property.
         *
         * @param {string} property Property name
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createNotifyingProperty",
        value: function createNotifyingProperty(property) {
          this.prototype._createNotifyingProperty(property);
        }

        /**
         * Creates a read-only accessor for the given property.
         *
         * To set the property, use the protected `_setProperty` API.
         * To create a custom protected setter (e.g. `_setMyProp()` for
         * property `myProp`), pass `true` for `protectedSetter`.
         *
         * Note, if the property will have other property effects, this method
         * should be called first, before adding other effects.
         *
         * @param {string} property Property name
         * @param {boolean=} protectedSetter Creates a custom protected setter
         *   when `true`.
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createReadOnlyProperty",
        value: function createReadOnlyProperty(property, protectedSetter) {
          this.prototype._createReadOnlyProperty(property, protectedSetter);
        }

        /**
         * Causes the setter for the given property to reflect the property value
         * to a (dash-cased) attribute of the same name.
         *
         * @param {string} property Property name
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createReflectedProperty",
        value: function createReflectedProperty(property) {
          this.prototype._createReflectedProperty(property);
        }

        /**
         * Creates a computed property whose value is set to the result of the
         * method described by the given `expression` each time one or more
         * arguments to the method changes.  The expression should be a string
         * in the form of a normal JavaScript function signature:
         * `'methodName(arg1, [..., argn])'`
         *
         * @param {string} property Name of computed property to set
         * @param {string} expression Method expression
         * @param {boolean|Object=} dynamicFn Boolean or object map indicating whether
         *   method names should be included as a dependency to the effect.
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createComputedProperty",
        value: function createComputedProperty(property, expression, dynamicFn) {
          this.prototype._createComputedProperty(property, expression, dynamicFn);
        }

        /**
         * Parses the provided template to ensure binding effects are created
         * for them, and then ensures property accessors are created for any
         * dependent properties in the template.  Binding effects for bound
         * templates are stored in a linked list on the instance so that
         * templates can be efficiently stamped and unstamped.
         *
         * @param {!HTMLTemplateElement} template Template containing binding
         *   bindings
         * @return {!TemplateInfo} Template metadata object
         * @protected
         * @nocollapse
         */
      }, {
        key: "bindTemplate",
        value: function bindTemplate(template) {
          return this.prototype._bindTemplate(template);
        }
      }, {
        key: "_addTemplatePropertyEffect",
        value: function _addTemplatePropertyEffect(templateInfo, prop, effect) {
          let hostProps = templateInfo.hostProps = templateInfo.hostProps || {};
          hostProps[prop] = true;
          let effects = templateInfo.propertyEffects = templateInfo.propertyEffects || {};
          let propEffects = effects[prop] = effects[prop] || [];
          propEffects.push(effect);
        }
      }, {
        key: "_parseTemplateNode",
        value: function _parseTemplateNode(node, templateInfo, nodeInfo) {
          // TODO(https://github.com/google/closure-compiler/issues/3240):
          //     Change back to just super.methodCall()
          let noted = propertyEffectsBase._parseTemplateNode.call(this, node, templateInfo, nodeInfo);
          if (node.nodeType === Node.TEXT_NODE) {
            let parts = this._parseBindings(node.textContent, templateInfo);
            if (parts) {
              // Initialize the textContent with any literal parts
              // NOTE: default to a space here so the textNode remains; some browsers
              // (IE) omit an empty textNode following cloneNode/importNode.
              node.textContent = literalFromParts(parts) || ' ';
              addBinding(this, templateInfo, nodeInfo, 'text', 'textContent', parts);
              noted = true;
            }
          }
          return noted;
        }

        /**
         * Overrides default `TemplateStamp` implementation to add support for
         * parsing bindings from attributes.  A `bindings`
         * array is added to `nodeInfo` and populated with binding metadata
         * with information capturing the binding target, and a `parts` array
         * with one or more metadata objects capturing the source(s) of the
         * binding.
         *
         * @param {Element} node Node to parse
         * @param {TemplateInfo} templateInfo Template metadata for current template
         * @param {NodeInfo} nodeInfo Node metadata for current template node
         * @param {string} name Attribute name
         * @param {string} value Attribute value
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @protected
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
      }, {
        key: "_parseTemplateNodeAttribute",
        value: function _parseTemplateNodeAttribute(node, templateInfo, nodeInfo, name, value) {
          let parts = this._parseBindings(value, templateInfo);
          if (parts) {
            // Attribute or property
            let origName = name;
            let kind = 'property';
            // The only way we see a capital letter here is if the attr has
            // a capital letter in it per spec. In this case, to make sure
            // this binding works, we go ahead and make the binding to the attribute.
            if (capitalAttributeRegex.test(name)) {
              kind = 'attribute';
            } else if (name[name.length - 1] == '$') {
              name = name.slice(0, -1);
              kind = 'attribute';
            }
            // Initialize attribute bindings with any literal parts
            let literal = literalFromParts(parts);
            if (literal && kind == 'attribute') {
              // Ensure a ShadyCSS template scoped style is not removed
              // when a class$ binding's initial literal value is set.
              if (name == 'class' && node.hasAttribute('class')) {
                literal += ' ' + node.getAttribute(name);
              }
              node.setAttribute(name, literal);
            }
            // support disable-upgrade
            if (kind == 'attribute' && origName == 'disable-upgrade$') {
              node.setAttribute(name, '');
            }
            // Clear attribute before removing, since IE won't allow removing
            // `value` attribute if it previously had a value (can't
            // unconditionally set '' before removing since attributes with `$`
            // can't be set using setAttribute)
            if (node.localName === 'input' && origName === 'value') {
              node.setAttribute(origName, '');
            }
            // Remove annotation
            node.removeAttribute(origName);
            // Case hackery: attributes are lower-case, but bind targets
            // (properties) are case sensitive. Gambit is to map dash-case to
            // camel-case: `foo-bar` becomes `fooBar`.
            // Attribute bindings are excepted.
            if (kind === 'property') {
              name = dashToCamelCase(name);
            }
            addBinding(this, templateInfo, nodeInfo, kind, name, parts, literal);
            return true;
          } else {
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            return propertyEffectsBase._parseTemplateNodeAttribute.call(this, node, templateInfo, nodeInfo, name, value);
          }
        }

        /**
         * Overrides default `TemplateStamp` implementation to add support for
         * binding the properties that a nested template depends on to the template
         * as `_host_<property>`.
         *
         * @param {Node} node Node to parse
         * @param {TemplateInfo} templateInfo Template metadata for current template
         * @param {NodeInfo} nodeInfo Node metadata for current template node
         * @return {boolean} `true` if the visited node added node-specific
         *   metadata to `nodeInfo`
         * @protected
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
      }, {
        key: "_parseTemplateNestedTemplate",
        value: function _parseTemplateNestedTemplate(node, templateInfo, nodeInfo) {
          // TODO(https://github.com/google/closure-compiler/issues/3240):
          //     Change back to just super.methodCall()
          let noted = propertyEffectsBase._parseTemplateNestedTemplate.call(this, node, templateInfo, nodeInfo);
          const parent = node.parentNode;
          const nestedTemplateInfo = nodeInfo.templateInfo;
          const isDomIf = parent.localName === 'dom-if';
          const isDomRepeat = parent.localName === 'dom-repeat';
          // Remove nested template and redirect its host bindings & templateInfo
          // onto the parent (dom-if/repeat element)'s nodeInfo
          if (removeNestedTemplates && (isDomIf || isDomRepeat)) {
            parent.removeChild(node);
            // Use the parent's nodeInfo (for the dom-if/repeat) to record the
            // templateInfo, and use that for any host property bindings below
            nodeInfo = nodeInfo.parentInfo;
            nodeInfo.templateInfo = nestedTemplateInfo;
            // Ensure the parent dom-if/repeat is noted since it now may have host
            // bindings; it may not have been if it did not have its own bindings
            nodeInfo.noted = true;
            noted = false;
          }
          // Merge host props into outer template and add bindings
          let hostProps = nestedTemplateInfo.hostProps;
          if (fastDomIf && isDomIf) {
            // `fastDomIf` mode uses runtime-template stamping to add accessors/
            // effects to properties used in its template; as such we don't need to
            // tax the host element with `_host_` bindings for the `dom-if`.
            // However, in the event it is nested in a `dom-repeat`, it is still
            // important that its host properties are added to the
            // TemplateInstance's `hostProps` so that they are forwarded to the
            // TemplateInstance.
            if (hostProps) {
              templateInfo.hostProps = Object.assign(templateInfo.hostProps || {}, hostProps);
              // Ensure the dom-if is noted so that it has a __dataHost, since
              // `fastDomIf` uses the host for runtime template stamping; note this
              // was already ensured above in the `removeNestedTemplates` case
              if (!removeNestedTemplates) {
                nodeInfo.parentInfo.noted = true;
              }
            }
          } else {
            let mode = '{';
            for (let source in hostProps) {
              let parts = [{
                mode,
                source,
                dependencies: [source],
                hostProp: true
              }];
              addBinding(this, templateInfo, nodeInfo, 'property', '_host_' + source, parts);
            }
          }
          return noted;
        }

        /**
         * Called to parse text in a template (either attribute values or
         * textContent) into binding metadata.
         *
         * Any overrides of this method should return an array of binding part
         * metadata  representing one or more bindings found in the provided text
         * and any "literal" text in between.  Any non-literal parts will be passed
         * to `_evaluateBinding` when any dependencies change.  The only required
         * fields of each "part" in the returned array are as follows:
         *
         * - `dependencies` - Array containing trigger metadata for each property
         *   that should trigger the binding to update
         * - `literal` - String containing text if the part represents a literal;
         *   in this case no `dependencies` are needed
         *
         * Additional metadata for use by `_evaluateBinding` may be provided in
         * each part object as needed.
         *
         * The default implementation handles the following types of bindings
         * (one or more may be intermixed with literal strings):
         * - Property binding: `[[prop]]`
         * - Path binding: `[[object.prop]]`
         * - Negated property or path bindings: `[[!prop]]` or `[[!object.prop]]`
         * - Two-way property or path bindings (supports negation):
         *   `{{prop}}`, `{{object.prop}}`, `{{!prop}}` or `{{!object.prop}}`
         * - Inline computed method (supports negation):
         *   `[[compute(a, 'literal', b)]]`, `[[!compute(a, 'literal', b)]]`
         *
         * The default implementation uses a regular expression for best
         * performance. However, the regular expression uses a white-list of
         * allowed characters in a data-binding, which causes problems for
         * data-bindings that do use characters not in this white-list.
         *
         * Instead of updating the white-list with all allowed characters,
         * there is a StrictBindingParser (see lib/mixins/strict-binding-parser)
         * that uses a state machine instead. This state machine is able to handle
         * all characters. However, it is slightly less performant, therefore we
         * extracted it into a separate optional mixin.
         *
         * @param {string} text Text to parse from attribute or textContent
         * @param {Object} templateInfo Current template metadata
         * @return {Array<!BindingPart>} Array of binding part metadata
         * @protected
         * @nocollapse
         */
      }, {
        key: "_parseBindings",
        value: function _parseBindings(text, templateInfo) {
          let parts = [];
          let lastIndex = 0;
          let m;
          // Example: "literal1{{prop}}literal2[[!compute(foo,bar)]]final"
          // Regex matches:
          //        Iteration 1:  Iteration 2:
          // m[1]: '{{'          '[['
          // m[2]: ''            '!'
          // m[3]: 'prop'        'compute(foo,bar)'
          while ((m = bindingRegex.exec(text)) !== null) {
            // Add literal part
            if (m.index > lastIndex) {
              parts.push({
                literal: text.slice(lastIndex, m.index)
              });
            }
            // Add binding part
            let mode = m[1][0];
            let negate = Boolean(m[2]);
            let source = m[3].trim();
            let customEvent = false,
              notifyEvent = '',
              colon = -1;
            if (mode == '{' && (colon = source.indexOf('::')) > 0) {
              notifyEvent = source.substring(colon + 2);
              source = source.substring(0, colon);
              customEvent = true;
            }
            let signature = parseMethod(source);
            let dependencies = [];
            if (signature) {
              // Inline computed function
              let {
                args,
                methodName
              } = signature;
              for (let i = 0; i < args.length; i++) {
                let arg = args[i];
                if (!arg.literal) {
                  dependencies.push(arg);
                }
              }
              let dynamicFns = templateInfo.dynamicFns;
              if (dynamicFns && dynamicFns[methodName] || signature.static) {
                dependencies.push(methodName);
                signature.dynamicFn = true;
              }
            } else {
              // Property or path
              dependencies.push(source);
            }
            parts.push({
              source,
              mode,
              negate,
              customEvent,
              signature,
              dependencies,
              event: notifyEvent
            });
            lastIndex = bindingRegex.lastIndex;
          }
          // Add a final literal part
          if (lastIndex && lastIndex < text.length) {
            let literal = text.substring(lastIndex);
            if (literal) {
              parts.push({
                literal: literal
              });
            }
          }
          if (parts.length) {
            return parts;
          } else {
            return null;
          }
        }

        /**
         * Called to evaluate a previously parsed binding part based on a set of
         * one or more changed dependencies.
         *
         * @param {!Polymer_PropertyEffects} inst Element that should be used as
         *     scope for binding dependencies
         * @param {BindingPart} part Binding part metadata
         * @param {string} path Property/path that triggered this effect
         * @param {Object} props Bag of current property changes
         * @param {Object} oldProps Bag of previous values for changed properties
         * @param {boolean} hasPaths True with `props` contains one or more paths
         * @return {*} Value the binding part evaluated to
         * @protected
         * @nocollapse
         */
      }, {
        key: "_evaluateBinding",
        value: function _evaluateBinding(inst, part, path, props, oldProps, hasPaths) {
          let value;
          if (part.signature) {
            value = runMethodEffect(inst, path, props, oldProps, part.signature);
          } else if (path != part.source) {
            value = get(inst, part.source);
          } else {
            if (hasPaths && isPath(path)) {
              value = get(inst, path);
            } else {
              value = inst.__data[path];
            }
          }
          if (part.negate) {
            value = !value;
          }
          return value;
        }
      }]);
      return PropertyEffects;
    }(propertyEffectsBase);
    return PropertyEffects;
  });

  /**
   * Stack for enqueuing client dom created by a host element.
   *
   * By default elements are flushed via `_flushProperties` when
   * `connectedCallback` is called. Elements attach their client dom to
   * themselves at `ready` time which results from this first flush.
   * This provides an ordering guarantee that the client dom an element
   * creates is flushed before the element itself (i.e. client `ready`
   * fires before host `ready`).
   *
   * However, if `_flushProperties` is called *before* an element is connected,
   * as for example `Templatize` does, this ordering guarantee cannot be
   * satisfied because no elements are connected. (Note: Bound elements that
   * receive data do become enqueued clients and are properly ordered but
   * unbound elements are not.)
   *
   * To maintain the desired "client before host" ordering guarantee for this
   * case we rely on the "host stack. Client nodes registers themselves with
   * the creating host element when created. This ensures that all client dom
   * is readied in the proper order, maintaining the desired guarantee.
   *
   * @private
   */
  const hostStack = [];

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Registers a class prototype for telemetry purposes.
   * @param {!PolymerElementConstructor} prototype Element prototype to register
   * @protected
   */
  function register$1(prototype) {
  }

  /**
   * Creates a copy of `props` with each property normalized such that
   * upgraded it is an object with at least a type property { type: Type}.
   *
   * @param {!Object} props Properties to normalize
   * @return {!Object} Copy of input `props` with normalized properties that
   * are in the form {type: Type}
   * @private
   */
  function normalizeProperties(props) {
    const output = {};
    for (let p in props) {
      const o = props[p];
      output[p] = typeof o === 'function' ? {
        type: o
      } : o;
    }
    return output;
  }

  /**
   * Mixin that provides a minimal starting point to using the PropertiesChanged
   * mixin by providing a mechanism to declare properties in a static
   * getter (e.g. static get properties() { return { foo: String } }). Changes
   * are reported via the `_propertiesChanged` method.
   *
   * This mixin provides no specific support for rendering. Users are expected
   * to create a ShadowRoot and put content into it and update it in whatever
   * way makes sense. This can be done in reaction to properties changing by
   * implementing `_propertiesChanged`.
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin PropertiesChanged
   * @summary Mixin that provides a minimal starting point for using
   * the PropertiesChanged mixin by providing a declarative `properties` object.
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const PropertiesMixin = dedupingMixin(superClass => {
    /**
     * @constructor
     * @implements {Polymer_PropertiesChanged}
     * @private
     */
    const base = PropertiesChanged(superClass);

    /**
     * Returns the super class constructor for the given class, if it is an
     * instance of the PropertiesMixin.
     *
     * @param {!PropertiesMixinConstructor} constructor PropertiesMixin constructor
     * @return {?PropertiesMixinConstructor} Super class constructor
     */
    function superPropertiesClass(constructor) {
      const superCtor = Object.getPrototypeOf(constructor);

      // Note, the `PropertiesMixin` class below only refers to the class
      // generated by this call to the mixin; the instanceof test only works
      // because the mixin is deduped and guaranteed only to apply once, hence
      // all constructors in a proto chain will see the same `PropertiesMixin`
      return superCtor.prototype instanceof PropertiesMixin ? /** @type {!PropertiesMixinConstructor} */superCtor : null;
    }

    /**
     * Returns a memoized version of the `properties` object for the
     * given class. Properties not in object format are converted to at
     * least {type}.
     *
     * @param {PropertiesMixinConstructor} constructor PropertiesMixin constructor
     * @return {Object} Memoized properties object
     */
    function ownProperties(constructor) {
      if (!constructor.hasOwnProperty(JSCompiler_renameProperty('__ownProperties', constructor))) {
        let props = null;
        if (constructor.hasOwnProperty(JSCompiler_renameProperty('properties', constructor))) {
          const properties = constructor.properties;
          if (properties) {
            props = normalizeProperties(properties);
          }
        }
        constructor.__ownProperties = props;
      }
      return constructor.__ownProperties;
    }

    /**
     * @polymer
     * @mixinClass
     * @extends {base}
     * @implements {Polymer_PropertiesMixin}
     * @unrestricted
     */
    let PropertiesMixin = /*#__PURE__*/function (_base) {
      _inherits(PropertiesMixin, _base);
      var _super = _createSuper(PropertiesMixin);
      function PropertiesMixin() {
        _classCallCheck(this, PropertiesMixin);
        return _super.apply(this, arguments);
      }
      _createClass(PropertiesMixin, [{
        key: "_initializeProperties",
        value:
        /**
         * Overrides `PropertiesChanged` method and adds a call to
         * `finalize` which lazily configures the element's property accessors.
         * @override
         * @return {void}
         */
        function _initializeProperties() {
          this.constructor.finalize();
          _get(_getPrototypeOf(PropertiesMixin.prototype), "_initializeProperties", this).call(this);
        }

        /**
         * Called when the element is added to a document.
         * Calls `_enableProperties` to turn on property system from
         * `PropertiesChanged`.
         * @suppress {missingProperties} Super may or may not implement the callback
         * @return {void}
         * @override
         */
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          if (_get(_getPrototypeOf(PropertiesMixin.prototype), "connectedCallback", this)) {
            _get(_getPrototypeOf(PropertiesMixin.prototype), "connectedCallback", this).call(this);
          }
          this._enableProperties();
        }

        /**
         * Called when the element is removed from a document
         * @suppress {missingProperties} Super may or may not implement the callback
         * @return {void}
         * @override
         */
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          if (_get(_getPrototypeOf(PropertiesMixin.prototype), "disconnectedCallback", this)) {
            _get(_getPrototypeOf(PropertiesMixin.prototype), "disconnectedCallback", this).call(this);
          }
        }
      }], [{
        key: "observedAttributes",
        get:
        /**
         * Implements standard custom elements getter to observes the attributes
         * listed in `properties`.
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
        function () {
          if (!this.hasOwnProperty(JSCompiler_renameProperty('__observedAttributes', this))) {
            register$1(this.prototype);
            const props = this._properties;
            this.__observedAttributes = props ? Object.keys(props).map(p => this.prototype._addPropertyToAttributeMap(p)) : [];
          }
          return this.__observedAttributes;
        }

        /**
         * Finalizes an element definition, including ensuring any super classes
         * are also finalized. This includes ensuring property
         * accessors exist on the element prototype. This method calls
         * `_finalizeClass` to finalize each constructor in the prototype chain.
         * @return {void}
         * @nocollapse
         */
      }, {
        key: "finalize",
        value: function finalize() {
          if (!this.hasOwnProperty(JSCompiler_renameProperty('__finalized', this))) {
            const superCtor = superPropertiesClass( /** @type {!PropertiesMixinConstructor} */this);
            if (superCtor) {
              superCtor.finalize();
            }
            this.__finalized = true;
            this._finalizeClass();
          }
        }

        /**
         * Finalize an element class. This includes ensuring property
         * accessors exist on the element prototype. This method is called by
         * `finalize` and finalizes the class constructor.
         *
         * @protected
         * @nocollapse
         */
      }, {
        key: "_finalizeClass",
        value: function _finalizeClass() {
          const props = ownProperties( /** @type {!PropertiesMixinConstructor} */this);
          if (props) {
            /** @type {?} */this.createProperties(props);
          }
        }

        /**
         * Returns a memoized version of all properties, including those inherited
         * from super classes. Properties not in object format are converted to
         * at least {type}.
         *
         * @return {Object} Object containing properties for this class
         * @protected
         * @nocollapse
         */
      }, {
        key: "_properties",
        get: function () {
          if (!this.hasOwnProperty(JSCompiler_renameProperty('__properties', this))) {
            const superCtor = superPropertiesClass( /** @type {!PropertiesMixinConstructor} */this);
            this.__properties = Object.assign({}, superCtor && superCtor._properties, ownProperties( /** @type {PropertiesMixinConstructor} */this));
          }
          return this.__properties;
        }

        /**
         * Overrides `PropertiesChanged` method to return type specified in the
         * static `properties` object for the given property.
         * @param {string} name Name of property
         * @return {*} Type to which to deserialize attribute
         *
         * @protected
         * @nocollapse
         */
      }, {
        key: "typeForProperty",
        value: function typeForProperty(name) {
          const info = this._properties[name];
          return info && info.type;
        }
      }]);
      return PropertiesMixin;
    }(base);
    return PropertiesMixin;
  });

  /**
   * Current Polymer version in Semver notation.
   * @type {string} Semver notation of the current version of Polymer.
   */
  const version$1 = '3.5.1';
  const builtCSS = window.ShadyCSS && window.ShadyCSS['cssBuild'];

  /**
   * Element class mixin that provides the core API for Polymer's meta-programming
   * features including template stamping, data-binding, attribute deserialization,
   * and property change observation.
   *
   * Subclassers may provide the following static getters to return metadata
   * used to configure Polymer's features for the class:
   *
   * - `static get is()`: When the template is provided via a `dom-module`,
   *   users should return the `dom-module` id from a static `is` getter.  If
   *   no template is needed or the template is provided directly via the
   *   `template` getter, there is no need to define `is` for the element.
   *
   * - `static get template()`: Users may provide the template directly (as
   *   opposed to via `dom-module`) by implementing a static `template` getter.
   *   The getter must return an `HTMLTemplateElement`.
   *
   * - `static get properties()`: Should return an object describing
   *   property-related metadata used by Polymer features (key: property name
   *   value: object containing property metadata). Valid keys in per-property
   *   metadata include:
   *   - `type` (String|Number|Object|Array|...): Used by
   *     `attributeChangedCallback` to determine how string-based attributes
   *     are deserialized to JavaScript property values.
   *   - `notify` (boolean): Causes a change in the property to fire a
   *     non-bubbling event called `<property>-changed`. Elements that have
   *     enabled two-way binding to the property use this event to observe changes.
   *   - `readOnly` (boolean): Creates a getter for the property, but no setter.
   *     To set a read-only property, use the private setter method
   *     `_setProperty(property, value)`.
   *   - `observer` (string): Observer method name that will be called when
   *     the property changes. The arguments of the method are
   *     `(value, previousValue)`.
   *   - `computed` (string): String describing method and dependent properties
   *     for computing the value of this property (e.g. `'computeFoo(bar, zot)'`).
   *     Computed properties are read-only by default and can only be changed
   *     via the return value of the computing method.
   *
   * - `static get observers()`: Array of strings describing multi-property
   *   observer methods and their dependent properties (e.g.
   *   `'observeABC(a, b, c)'`).
   *
   * The base class provides default implementations for the following standard
   * custom element lifecycle callbacks; users may override these, but should
   * call the super method to ensure
   * - `constructor`: Run when the element is created or upgraded
   * - `connectedCallback`: Run each time the element is connected to the
   *   document
   * - `disconnectedCallback`: Run each time the element is disconnected from
   *   the document
   * - `attributeChangedCallback`: Run each time an attribute in
   *   `observedAttributes` is set or removed (note: this element's default
   *   `observedAttributes` implementation will automatically return an array
   *   of dash-cased attributes based on `properties`)
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin PropertyEffects
   * @appliesMixin PropertiesMixin
   * @property rootPath {string} Set to the value of `rootPath`,
   *   which defaults to the main document path
   * @property importPath {string} Set to the value of the class's static
   *   `importPath` property, which defaults to the path of this element's
   *   `dom-module` (when `is` is used), but can be overridden for other
   *   import strategies.
   * @summary Element class mixin that provides the core API for Polymer's
   * meta-programming features.
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const ElementMixin = dedupingMixin(base => {
    /**
     * @constructor
     * @implements {Polymer_PropertyEffects}
     * @implements {Polymer_PropertiesMixin}
     * @extends {HTMLElement}
     * @private
     */
    const polymerElementBase = PropertiesMixin(PropertyEffects(base));

    /**
     * Returns a list of properties with default values.
     * This list is created as an optimization since it is a subset of
     * the list returned from `_properties`.
     * This list is used in `_initializeProperties` to set property defaults.
     *
     * @param {PolymerElementConstructor} constructor Element class
     * @return {PolymerElementProperties} Flattened properties for this class
     *   that have default values
     * @private
     */
    function propertyDefaults(constructor) {
      if (!constructor.hasOwnProperty(JSCompiler_renameProperty('__propertyDefaults', constructor))) {
        constructor.__propertyDefaults = null;
        let props = constructor._properties;
        for (let p in props) {
          let info = props[p];
          if ('value' in info) {
            constructor.__propertyDefaults = constructor.__propertyDefaults || {};
            constructor.__propertyDefaults[p] = info;
          }
        }
      }
      return constructor.__propertyDefaults;
    }

    /**
     * Returns a memoized version of the `observers` array.
     * @param {PolymerElementConstructor} constructor Element class
     * @return {Array} Array containing own observers for the given class
     * @protected
     */
    function ownObservers(constructor) {
      if (!constructor.hasOwnProperty(JSCompiler_renameProperty('__ownObservers', constructor))) {
        constructor.__ownObservers = constructor.hasOwnProperty(JSCompiler_renameProperty('observers', constructor)) ? /** @type {PolymerElementConstructor} */constructor.observers : null;
      }
      return constructor.__ownObservers;
    }

    /**
     * Creates effects for a property.
     *
     * Note, once a property has been set to
     * `readOnly`, `computed`, `reflectToAttribute`, or `notify`
     * these values may not be changed. For example, a subclass cannot
     * alter these settings. However, additional `observers` may be added
     * by subclasses.
     *
     * The info object should contain property metadata as follows:
     *
     * * `type`: {function} type to which an attribute matching the property
     * is deserialized. Note the property is camel-cased from a dash-cased
     * attribute. For example, 'foo-bar' attribute is deserialized to a
     * property named 'fooBar'.
     *
     * * `readOnly`: {boolean} creates a readOnly property and
     * makes a private setter for the private of the form '_setFoo' for a
     * property 'foo',
     *
     * * `computed`: {string} creates a computed property. A computed property
     * is also automatically set to `readOnly: true`. The value is calculated
     * by running a method and arguments parsed from the given string. For
     * example 'compute(foo)' will compute a given property when the
     * 'foo' property changes by executing the 'compute' method. This method
     * must return the computed value.
     *
     * * `reflectToAttribute`: {boolean} If true, the property value is reflected
     * to an attribute of the same name. Note, the attribute is dash-cased
     * so a property named 'fooBar' is reflected as 'foo-bar'.
     *
     * * `notify`: {boolean} sends a non-bubbling notification event when
     * the property changes. For example, a property named 'foo' sends an
     * event named 'foo-changed' with `event.detail` set to the value of
     * the property.
     *
     * * observer: {string} name of a method that runs when the property
     * changes. The arguments of the method are (value, previousValue).
     *
     * Note: Users may want control over modifying property
     * effects via subclassing. For example, a user might want to make a
     * reflectToAttribute property not do so in a subclass. We've chosen to
     * disable this because it leads to additional complication.
     * For example, a readOnly effect generates a special setter. If a subclass
     * disables the effect, the setter would fail unexpectedly.
     * Based on feedback, we may want to try to make effects more malleable
     * and/or provide an advanced api for manipulating them.
     *
     * @param {!PolymerElement} proto Element class prototype to add accessors
     *   and effects to
     * @param {string} name Name of the property.
     * @param {Object} info Info object from which to create property effects.
     * Supported keys:
     * @param {Object} allProps Flattened map of all properties defined in this
     *   element (including inherited properties)
     * @return {void}
     * @private
     */
    function createPropertyFromConfig(proto, name, info, allProps) {
      // computed forces readOnly...
      if (info.computed) {
        info.readOnly = true;
      }
      // Note, since all computed properties are readOnly, this prevents
      // adding additional computed property effects (which leads to a confusing
      // setup where multiple triggers for setting a property)
      // While we do have `hasComputedEffect` this is set on the property's
      // dependencies rather than itself.
      if (info.computed) {
        if (proto._hasReadOnlyEffect(name)) {
          console.warn(`Cannot redefine computed property '${name}'.`);
        } else {
          proto._createComputedProperty(name, info.computed, allProps);
        }
      }
      if (info.readOnly && !proto._hasReadOnlyEffect(name)) {
        proto._createReadOnlyProperty(name, !info.computed);
      } else if (info.readOnly === false && proto._hasReadOnlyEffect(name)) {
        console.warn(`Cannot make readOnly property '${name}' non-readOnly.`);
      }
      if (info.reflectToAttribute && !proto._hasReflectEffect(name)) {
        proto._createReflectedProperty(name);
      } else if (info.reflectToAttribute === false && proto._hasReflectEffect(name)) {
        console.warn(`Cannot make reflected property '${name}' non-reflected.`);
      }
      if (info.notify && !proto._hasNotifyEffect(name)) {
        proto._createNotifyingProperty(name);
      } else if (info.notify === false && proto._hasNotifyEffect(name)) {
        console.warn(`Cannot make notify property '${name}' non-notify.`);
      }
      // always add observer
      if (info.observer) {
        proto._createPropertyObserver(name, info.observer, allProps[info.observer]);
      }
      // always create the mapping from attribute back to property for deserialization.
      proto._addPropertyToAttributeMap(name);
    }

    /**
     * Process all style elements in the element template. Styles with the
     * `include` attribute are processed such that any styles in
     * the associated "style modules" are included in the element template.
     * @param {PolymerElementConstructor} klass Element class
     * @param {!HTMLTemplateElement} template Template to process
     * @param {string} is Name of element
     * @param {string} baseURI Base URI for element
     * @private
     */
    function processElementStyles(klass, template, is, baseURI) {
      if (!builtCSS) {
        const templateStyles = template.content.querySelectorAll('style');
        const stylesWithImports = stylesFromTemplate(template);
        // insert styles from <link rel="import" type="css"> at the top of the template
        const linkedStyles = stylesFromModuleImports(is);
        const firstTemplateChild = template.content.firstElementChild;
        for (let idx = 0; idx < linkedStyles.length; idx++) {
          let s = linkedStyles[idx];
          s.textContent = klass._processStyleText(s.textContent, baseURI);
          template.content.insertBefore(s, firstTemplateChild);
        }
        // keep track of the last "concrete" style in the template we have encountered
        let templateStyleIndex = 0;
        // ensure all gathered styles are actually in this template.
        for (let i = 0; i < stylesWithImports.length; i++) {
          let s = stylesWithImports[i];
          let templateStyle = templateStyles[templateStyleIndex];
          // if the style is not in this template, it's been "included" and
          // we put a clone of it in the template before the style that included it
          if (templateStyle !== s) {
            s = s.cloneNode(true);
            templateStyle.parentNode.insertBefore(s, templateStyle);
          } else {
            templateStyleIndex++;
          }
          s.textContent = klass._processStyleText(s.textContent, baseURI);
        }
      }
      if (window.ShadyCSS) {
        window.ShadyCSS.prepareTemplate(template, is);
      }
      // Support for `adoptedStylesheets` relies on using native Shadow DOM
      // and built CSS. Built CSS is required because runtime transformation of
      // `@apply` is not supported. This is because ShadyCSS relies on being able
      // to update a `style` element in the element template and this is
      // removed when using `adoptedStyleSheets`.
      // Note, it would be more efficient to allow style includes to become
      // separate stylesheets; however, because of `@apply` these are
      // potentially not shareable and sharing the ones that could be shared
      // would require some coordination. To keep it simple, all the includes
      // and styles are collapsed into a single shareable stylesheet.
      if (useAdoptedStyleSheetsWithBuiltCSS && builtCSS && supportsAdoptingStyleSheets) {
        // Remove styles in template and make a shareable stylesheet
        const styles = template.content.querySelectorAll('style');
        if (styles) {
          let css = '';
          Array.from(styles).forEach(s => {
            css += s.textContent;
            s.parentNode.removeChild(s);
          });
          klass._styleSheet = new CSSStyleSheet();
          klass._styleSheet.replaceSync(css);
        }
      }
    }

    /**
     * Look up template from dom-module for element
     *
     * @param {string} is Element name to look up
     * @return {?HTMLTemplateElement|undefined} Template found in dom module, or
     *   undefined if not found
     * @protected
     */
    function getTemplateFromDomModule(is) {
      let template = null;
      // Under strictTemplatePolicy in 3.x+, dom-module lookup is only allowed
      // when opted-in via allowTemplateFromDomModule
      if (is && (!strictTemplatePolicy || allowTemplateFromDomModule)) {
        template = /** @type {?HTMLTemplateElement} */
        DomModule.import(is, 'template');
        // Under strictTemplatePolicy, require any element with an `is`
        // specified to have a dom-module
        if (strictTemplatePolicy && !template) {
          throw new Error(`strictTemplatePolicy: expecting dom-module or null template for ${is}`);
        }
      }
      return template;
    }

    /**
     * @polymer
     * @mixinClass
     * @unrestricted
     * @implements {Polymer_ElementMixin}
     * @extends {polymerElementBase}
     */
    let PolymerElement = /*#__PURE__*/function (_polymerElementBase) {
      _inherits(PolymerElement, _polymerElementBase);
      var _super = _createSuper(PolymerElement);
      function PolymerElement() {
        var _this;
        _classCallCheck(this, PolymerElement);
        _this = _super.call(this);
        /** @type {HTMLTemplateElement} */
        _this._template;
        /** @type {string} */
        _this._importPath;
        /** @type {string} */
        _this.rootPath;
        /** @type {string} */
        _this.importPath;
        /** @type {StampedTemplate | HTMLElement | ShadowRoot} */
        _this.root;
        /** @type {!Object<string, !Element>} */
        _this.$;
        return _this;
      }

      /**
       * Overrides the default `PropertyAccessors` to ensure class
       * metaprogramming related to property accessors and effects has
       * completed (calls `finalize`).
       *
       * It also initializes any property defaults provided via `value` in
       * `properties` metadata.
       *
       * @return {void}
       * @override
       * @suppress {invalidCasts,missingProperties} go/missingfnprops
       */
      _createClass(PolymerElement, [{
        key: "_initializeProperties",
        value: function _initializeProperties() {
          this.constructor.finalize();
          // note: finalize template when we have access to `localName` to
          // avoid dependence on `is` for polyfilling styling.
          this.constructor._finalizeTemplate( /** @type {!HTMLElement} */this.localName);
          _get(_getPrototypeOf(PolymerElement.prototype), "_initializeProperties", this).call(this);
          // set path defaults
          this.rootPath = rootPath;
          this.importPath = this.constructor.importPath;
          // apply property defaults...
          let p$ = propertyDefaults(this.constructor);
          if (!p$) {
            return;
          }
          for (let p in p$) {
            let info = p$[p];
            if (this._canApplyPropertyDefault(p)) {
              let value = typeof info.value == 'function' ? info.value.call(this) : info.value;
              // Set via `_setProperty` if there is an accessor, to enable
              // initializing readOnly property defaults
              if (this._hasAccessor(p)) {
                this._setPendingProperty(p, value, true);
              } else {
                this[p] = value;
              }
            }
          }
        }

        /**
         * Determines if a property dfeault can be applied. For example, this
         * prevents a default from being applied when a property that has no
         * accessor is overridden by its host before upgrade (e.g. via a binding).
         * @override
         * @param {string} property Name of the property
         * @return {boolean} Returns true if the property default can be applied.
         */
      }, {
        key: "_canApplyPropertyDefault",
        value: function _canApplyPropertyDefault(property) {
          return !this.hasOwnProperty(property);
        }

        /**
         * Gather style text for a style element in the template.
         *
         * @param {string} cssText Text containing styling to process
         * @param {string} baseURI Base URI to rebase CSS paths against
         * @return {string} The processed CSS text
         * @protected
         * @nocollapse
         */
      }, {
        key: "connectedCallback",
        value:
        /**
         * Provides a default implementation of the standard Custom Elements
         * `connectedCallback`.
         *
         * The default implementation enables the property effects system and
         * flushes any pending properties, and updates shimmed CSS properties
         * when using the ShadyCSS scoping/custom properties polyfill.
         *
         * @override
         * @suppress {missingProperties, invalidCasts} Super may or may not
         *     implement the callback
         * @return {void}
         */
        function connectedCallback() {
          if (window.ShadyCSS && this._template) {
            window.ShadyCSS.styleElement( /** @type {!HTMLElement} */this);
          }
          _get(_getPrototypeOf(PolymerElement.prototype), "connectedCallback", this).call(this);
        }

        /**
         * Stamps the element template.
         *
         * @return {void}
         * @override
         */
      }, {
        key: "ready",
        value: function ready() {
          if (this._template) {
            this.root = this._stampTemplate(this._template);
            this.$ = this.root.$;
          }
          _get(_getPrototypeOf(PolymerElement.prototype), "ready", this).call(this);
        }

        /**
         * Implements `PropertyEffects`'s `_readyClients` call. Attaches
         * element dom by calling `_attachDom` with the dom stamped from the
         * element's template via `_stampTemplate`. Note that this allows
         * client dom to be attached to the element prior to any observers
         * running.
         *
         * @return {void}
         * @override
         */
      }, {
        key: "_readyClients",
        value: function _readyClients() {
          if (this._template) {
            this.root = this._attachDom( /** @type {StampedTemplate} */this.root);
          }
          // The super._readyClients here sets the clients initialized flag.
          // We must wait to do this until after client dom is created/attached
          // so that this flag can be checked to prevent notifications fired
          // during this process from being handled before clients are ready.
          _get(_getPrototypeOf(PolymerElement.prototype), "_readyClients", this).call(this);
        }

        /**
         * Attaches an element's stamped dom to itself. By default,
         * this method creates a `shadowRoot` and adds the dom to it.
         * However, this method may be overridden to allow an element
         * to put its dom in another location.
         *
         * @override
         * @throws {Error}
         * @suppress {missingReturn}
         * @param {StampedTemplate} dom to attach to the element.
         * @return {ShadowRoot} node to which the dom has been attached.
         */
      }, {
        key: "_attachDom",
        value: function _attachDom(dom) {
          const n = wrap(this);
          if (n.attachShadow) {
            if (dom) {
              if (!n.shadowRoot) {
                n.attachShadow({
                  mode: 'open',
                  shadyUpgradeFragment: dom
                });
                n.shadowRoot.appendChild(dom);
                // When `adoptedStyleSheets` is supported a stylesheet is made
                // available on the element constructor.
                if (this.constructor._styleSheet) {
                  n.shadowRoot.adoptedStyleSheets = [this.constructor._styleSheet];
                }
              }
              if (syncInitialRender && window.ShadyDOM) {
                window.ShadyDOM.flushInitial(n.shadowRoot);
              }
              return n.shadowRoot;
            }
            return null;
          } else {
            throw new Error('ShadowDOM not available. ' +
            // TODO(sorvell): move to compile-time conditional when supported
            'PolymerElement can create dom as children instead of in ' + 'ShadowDOM by setting `this.root = this;\` before \`ready\`.');
          }
        }

        /**
         * When using the ShadyCSS scoping and custom property shim, causes all
         * shimmed styles in this element (and its subtree) to be updated
         * based on current custom property values.
         *
         * The optional parameter overrides inline custom property styles with an
         * object of properties where the keys are CSS properties, and the values
         * are strings.
         *
         * Example: `this.updateStyles({'--color': 'blue'})`
         *
         * These properties are retained unless a value of `null` is set.
         *
         * Note: This function does not support updating CSS mixins.
         * You can not dynamically change the value of an `@apply`.
         *
         * @override
         * @param {Object=} properties Bag of custom property key/values to
         *   apply to this element.
         * @return {void}
         * @suppress {invalidCasts}
         */
      }, {
        key: "updateStyles",
        value: function updateStyles(properties) {
          if (window.ShadyCSS) {
            window.ShadyCSS.styleSubtree( /** @type {!HTMLElement} */this, properties);
          }
        }

        /**
         * Rewrites a given URL relative to a base URL. The base URL defaults to
         * the original location of the document containing the `dom-module` for
         * this element. This method will return the same URL before and after
         * bundling.
         *
         * Note that this function performs no resolution for URLs that start
         * with `/` (absolute URLs) or `#` (hash identifiers).  For general purpose
         * URL resolution, use `window.URL`.
         *
         * @override
         * @param {string} url URL to resolve.
         * @param {string=} base Optional base URL to resolve against, defaults
         * to the element's `importPath`
         * @return {string} Rewritten URL relative to base
         */
      }, {
        key: "resolveUrl",
        value: function resolveUrl$1(url, base) {
          if (!base && this.importPath) {
            base = resolveUrl(this.importPath);
          }
          return resolveUrl(url, base);
        }

        /**
         * Overrides `PropertyEffects` to add map of dynamic functions on
         * template info, for consumption by `PropertyEffects` template binding
         * code. This map determines which method templates should have accessors
         * created for them.
         *
         * @param {!HTMLTemplateElement} template Template
         * @param {!TemplateInfo} templateInfo Template metadata for current template
         * @param {!NodeInfo} nodeInfo Node metadata for current template.
         * @return {boolean} .
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
      }], [{
        key: "polymerElementVersion",
        get:
        /**
         * Current Polymer version in Semver notation.
         * @type {string} Semver notation of the current version of Polymer.
         * @nocollapse
         */
        function () {
          return version$1;
        }

        /**
         * Override of PropertiesMixin _finalizeClass to create observers and
         * find the template.
         * @return {void}
         * @protected
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
      }, {
        key: "_finalizeClass",
        value: function _finalizeClass() {
          // TODO(https://github.com/google/closure-compiler/issues/3240):
          //     Change back to just super.methodCall()
          polymerElementBase._finalizeClass.call(this);
          const observers = ownObservers(this);
          if (observers) {
            this.createObservers(observers, this._properties);
          }
          this._prepareTemplate();
        }

        /** @nocollapse */
      }, {
        key: "_prepareTemplate",
        value: function _prepareTemplate() {
          // note: create "working" template that is finalized at instance time
          let template = /** @type {PolymerElementConstructor} */this.template;
          if (template) {
            if (typeof template === 'string') {
              console.error('template getter must return HTMLTemplateElement');
              template = null;
            } else if (!legacyOptimizations) {
              template = template.cloneNode(true);
            }
          }

          /** @override */
          this.prototype._template = template;
        }

        /**
         * Override of PropertiesChanged createProperties to create accessors
         * and property effects for all of the properties.
         * @param {!Object} props .
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createProperties",
        value: function createProperties(props) {
          for (let p in props) {
            createPropertyFromConfig( /** @type {?} */this.prototype, p, props[p], props);
          }
        }

        /**
         * Creates observers for the given `observers` array.
         * Leverages `PropertyEffects` to create observers.
         * @param {Object} observers Array of observer descriptors for
         *   this class
         * @param {Object} dynamicFns Object containing keys for any properties
         *   that are functions and should trigger the effect when the function
         *   reference is changed
         * @return {void}
         * @protected
         * @nocollapse
         */
      }, {
        key: "createObservers",
        value: function createObservers(observers, dynamicFns) {
          const proto = this.prototype;
          for (let i = 0; i < observers.length; i++) {
            proto._createMethodObserver(observers[i], dynamicFns);
          }
        }

        /**
         * Returns the template that will be stamped into this element's shadow root.
         *
         * If a `static get is()` getter is defined, the default implementation will
         * return the first `<template>` in a `dom-module` whose `id` matches this
         * element's `is` (note that a `_template` property on the class prototype
         * takes precedence over the `dom-module` template, to maintain legacy
         * element semantics; a subclass will subsequently fall back to its super
         * class template if neither a `prototype._template` or a `dom-module` for
         * the class's `is` was found).
         *
         * Users may override this getter to return an arbitrary template
         * (in which case the `is` getter is unnecessary). The template returned
         * must be an `HTMLTemplateElement`.
         *
         * Note that when subclassing, if the super class overrode the default
         * implementation and the subclass would like to provide an alternate
         * template via a `dom-module`, it should override this getter and
         * return `DomModule.import(this.is, 'template')`.
         *
         * If a subclass would like to modify the super class template, it should
         * clone it rather than modify it in place.  If the getter does expensive
         * work such as cloning/modifying a template, it should memoize the
         * template for maximum performance:
         *
         *   let memoizedTemplate;
         *   class MySubClass extends MySuperClass {
         *     static get template() {
         *       if (!memoizedTemplate) {
         *         memoizedTemplate = super.template.cloneNode(true);
         *         let subContent = document.createElement('div');
         *         subContent.textContent = 'This came from MySubClass';
         *         memoizedTemplate.content.appendChild(subContent);
         *       }
         *       return memoizedTemplate;
         *     }
         *   }
         *
         * @return {!HTMLTemplateElement|string} Template to be stamped
         * @nocollapse
         */
      }, {
        key: "template",
        get: function () {
          // Explanation of template-related properties:
          // - constructor.template (this getter): the template for the class.
          //     This can come from the prototype (for legacy elements), from a
          //     dom-module, or from the super class's template (or can be overridden
          //     altogether by the user)
          // - constructor._template: memoized version of constructor.template
          // - prototype._template: working template for the element, which will be
          //     parsed and modified in place. It is a cloned version of
          //     constructor.template, saved in _finalizeClass(). Note that before
          //     this getter is called, for legacy elements this could be from a
          //     _template field on the info object passed to Polymer(), a behavior,
          //     or set in registered(); once the static getter runs, a clone of it
          //     will overwrite it on the prototype as the working template.
          if (!this.hasOwnProperty(JSCompiler_renameProperty('_template', this))) {
            let protoTemplate = this.prototype.hasOwnProperty(JSCompiler_renameProperty('_template', this.prototype)) ? this.prototype._template : undefined;
            // Accept a function for the legacy Polymer({_template:...}) field for
            // lazy parsing
            if (typeof protoTemplate === 'function') {
              protoTemplate = protoTemplate();
            }
            this._template =
            // If user has put template on prototype (e.g. in legacy via registered
            // callback or info object), prefer that first. Note that `null` is
            // used as a sentinel to indicate "no template" and can be used to
            // override a super template, whereas `undefined` is used as a
            // sentinel to mean "fall-back to default template lookup" via
            // dom-module and/or super.template.
            protoTemplate !== undefined ? protoTemplate :
            // Look in dom-module associated with this element's is
            this.hasOwnProperty(JSCompiler_renameProperty('is', this)) && getTemplateFromDomModule( /** @type {PolymerElementConstructor}*/this.is) ||
            // Next look for superclass template (call the super impl this
            // way so that `this` points to the superclass)
            Object.getPrototypeOf( /** @type {PolymerElementConstructor}*/this.prototype).constructor.template;
          }
          return this._template;
        }

        /**
         * Set the template.
         *
         * @param {!HTMLTemplateElement|string} value Template to set.
         * @nocollapse
         */,
        set: function (value) {
          this._template = value;
        }

        /**
         * Path matching the url from which the element was imported.
         *
         * This path is used to resolve url's in template style cssText.
         * The `importPath` property is also set on element instances and can be
         * used to create bindings relative to the import path.
         *
         * For elements defined in ES modules, users should implement
         * `static get importMeta() { return import.meta; }`, and the default
         * implementation of `importPath` will  return `import.meta.url`'s path.
         * For elements defined in HTML imports, this getter will return the path
         * to the document containing a `dom-module` element matching this
         * element's static `is` property.
         *
         * Note, this path should contain a trailing `/`.
         *
         * @return {string} The import path for this element class
         * @suppress {missingProperties}
         * @nocollapse
         */
      }, {
        key: "importPath",
        get: function () {
          if (!this.hasOwnProperty(JSCompiler_renameProperty('_importPath', this))) {
            const meta = this.importMeta;
            if (meta) {
              this._importPath = pathFromUrl(meta.url);
            } else {
              const module = DomModule.import( /** @type {PolymerElementConstructor} */this.is);
              this._importPath = module && module.assetpath || Object.getPrototypeOf( /** @type {PolymerElementConstructor}*/this.prototype).constructor.importPath;
            }
          }
          return this._importPath;
        }
      }, {
        key: "_processStyleText",
        value: function _processStyleText(cssText, baseURI) {
          return resolveCss(cssText, baseURI);
        }

        /**
        * Configures an element `proto` to function with a given `template`.
        * The element name `is` and extends `ext` must be specified for ShadyCSS
        * style scoping.
        *
        * @param {string} is Tag name (or type extension name) for this element
        * @return {void}
        * @protected
        * @nocollapse
        */
      }, {
        key: "_finalizeTemplate",
        value: function _finalizeTemplate(is) {
          /** @const {HTMLTemplateElement} */
          const template = this.prototype._template;
          if (template && !template.__polymerFinalized) {
            template.__polymerFinalized = true;
            const importPath = this.importPath;
            const baseURI = importPath ? resolveUrl(importPath) : '';
            // e.g. support `include="module-name"`, and ShadyCSS
            processElementStyles(this, template, is, baseURI);
            this.prototype._bindTemplate(template);
          }
        }
      }, {
        key: "_parseTemplateContent",
        value: function _parseTemplateContent(template, templateInfo, nodeInfo) {
          templateInfo.dynamicFns = templateInfo.dynamicFns || this._properties;
          // TODO(https://github.com/google/closure-compiler/issues/3240):
          //     Change back to just super.methodCall()
          return polymerElementBase._parseTemplateContent.call(this, template, templateInfo, nodeInfo);
        }

        /**
         * Overrides `PropertyEffects` to warn on use of undeclared properties in
         * template.
         *
         * @param {Object} templateInfo Template metadata to add effect to
         * @param {string} prop Property that should trigger the effect
         * @param {Object=} effect Effect metadata object
         * @return {void}
         * @protected
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
      }, {
        key: "_addTemplatePropertyEffect",
        value: function _addTemplatePropertyEffect(templateInfo, prop, effect) {
          // Warn if properties are used in template without being declared.
          // Properties must be listed in `properties` to be included in
          // `observedAttributes` since CE V1 reads that at registration time, and
          // since we want to keep template parsing lazy, we can't automatically
          // add undeclared properties used in templates to `observedAttributes`.
          // The warning is only enabled in `legacyOptimizations` mode, since
          // we don't want to spam existing users who might have adopted the
          // shorthand when attribute deserialization is not important.
          if (legacyWarnings && !(prop in this._properties) &&
          // Methods used in templates with no dependencies (or only literal
          // dependencies) become accessors with template effects; ignore these
          !(effect.info.part.signature && effect.info.part.signature.static) &&
          // Warnings for bindings added to nested templates are handled by
          // templatizer so ignore both the host-to-template bindings
          // (`hostProp`) and TemplateInstance-to-child bindings
          // (`nestedTemplate`)
          !effect.info.part.hostProp && !templateInfo.nestedTemplate) {
            console.warn(`Property '${prop}' used in template but not declared in 'properties'; ` + `attribute will not be observed.`);
          }
          // TODO(https://github.com/google/closure-compiler/issues/3240):
          //     Change back to just super.methodCall()
          return polymerElementBase._addTemplatePropertyEffect.call(this, templateInfo, prop, effect);
        }
      }]);
      return PolymerElement;
    }(polymerElementBase);
    return PolymerElement;
  });

  /**
   * @summary Collapse multiple callbacks into one invocation after a timer.
   */
  let Debouncer = /*#__PURE__*/function () {
    function Debouncer() {
      _classCallCheck(this, Debouncer);
      this._asyncModule = null;
      this._callback = null;
      this._timer = null;
    }
    /**
     * Sets the scheduler; that is, a module with the Async interface,
     * a callback and optional arguments to be passed to the run function
     * from the async module.
     *
     * @param {!AsyncInterface} asyncModule Object with Async interface.
     * @param {function()} callback Callback to run.
     * @return {void}
     */
    _createClass(Debouncer, [{
      key: "setConfig",
      value: function setConfig(asyncModule, callback) {
        this._asyncModule = asyncModule;
        this._callback = callback;
        this._timer = this._asyncModule.run(() => {
          this._timer = null;
          debouncerQueue.delete(this);
          this._callback();
        });
      }
      /**
       * Cancels an active debouncer and returns a reference to itself.
       *
       * @return {void}
       */
    }, {
      key: "cancel",
      value: function cancel() {
        if (this.isActive()) {
          this._cancelAsync();
          // Canceling a debouncer removes its spot from the flush queue,
          // so if a debouncer is manually canceled and re-debounced, it
          // will reset its flush order (this is a very minor difference from 1.x)
          // Re-debouncing via the `debounce` API retains the 1.x FIFO flush order
          debouncerQueue.delete(this);
        }
      }
      /**
       * Cancels a debouncer's async callback.
       *
       * @return {void}
       */
    }, {
      key: "_cancelAsync",
      value: function _cancelAsync() {
        if (this.isActive()) {
          this._asyncModule.cancel( /** @type {number} */this._timer);
          this._timer = null;
        }
      }
      /**
       * Flushes an active debouncer and returns a reference to itself.
       *
       * @return {void}
       */
    }, {
      key: "flush",
      value: function flush() {
        if (this.isActive()) {
          this.cancel();
          this._callback();
        }
      }
      /**
       * Returns true if the debouncer is active.
       *
       * @return {boolean} True if active.
       */
    }, {
      key: "isActive",
      value: function isActive() {
        return this._timer != null;
      }
      /**
       * Creates a debouncer if no debouncer is passed as a parameter
       * or it cancels an active debouncer otherwise. The following
       * example shows how a debouncer can be called multiple times within a
       * microtask and "debounced" such that the provided callback function is
       * called once. Add this method to a custom element:
       *
       * ```js
       * import {microTask} from '@polymer/polymer/lib/utils/async.js';
       * import {Debouncer} from '@polymer/polymer/lib/utils/debounce.js';
       * // ...
       *
       * _debounceWork() {
       *   this._debounceJob = Debouncer.debounce(this._debounceJob,
       *       microTask, () => this._doWork());
       * }
       * ```
       *
       * If the `_debounceWork` method is called multiple times within the same
       * microtask, the `_doWork` function will be called only once at the next
       * microtask checkpoint.
       *
       * Note: In testing it is often convenient to avoid asynchrony. To accomplish
       * this with a debouncer, you can use `enqueueDebouncer` and
       * `flush`. For example, extend the above example by adding
       * `enqueueDebouncer(this._debounceJob)` at the end of the
       * `_debounceWork` method. Then in a test, call `flush` to ensure
       * the debouncer has completed.
       *
       * @param {Debouncer?} debouncer Debouncer object.
       * @param {!AsyncInterface} asyncModule Object with Async interface
       * @param {function()} callback Callback to run.
       * @return {!Debouncer} Returns a debouncer object.
       */
    }], [{
      key: "debounce",
      value: function debounce(debouncer, asyncModule, callback) {
        if (debouncer instanceof Debouncer) {
          // Cancel the async callback, but leave in debouncerQueue if it was
          // enqueued, to maintain 1.x flush order
          debouncer._cancelAsync();
        } else {
          debouncer = new Debouncer();
        }
        debouncer.setConfig(asyncModule, callback);
        return debouncer;
      }
    }]);
    return Debouncer;
  }();
  let debouncerQueue = new Set();

  /**
   * Adds a `Debouncer` to a list of globally flushable tasks.
   *
   * @param {!Debouncer} debouncer Debouncer to enqueue
   * @return {void}
   */
  const enqueueDebouncer = function (debouncer) {
    debouncerQueue.add(debouncer);
  };

  /**
   * Flushes any enqueued debouncers
   *
   * @return {boolean} Returns whether any debouncers were flushed
   */
  const flushDebouncers = function () {
    const didFlush = Boolean(debouncerQueue.size);
    // If new debouncers are added while flushing, Set.forEach will ensure
    // newly added ones are also flushed
    debouncerQueue.forEach(debouncer => {
      try {
        debouncer.flush();
      } catch (e) {
        setTimeout(() => {
          throw e;
        });
      }
    });
    return didFlush;
  };

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  // detect native touch action support
  let HAS_NATIVE_TA = typeof document.head.style.touchAction === 'string';
  let GESTURE_KEY = '__polymerGestures';
  let HANDLED_OBJ = '__polymerGesturesHandled';
  let TOUCH_ACTION = '__polymerGesturesTouchAction';
  // radius for tap and track
  let TAP_DISTANCE = 25;
  let TRACK_DISTANCE = 5;
  // number of last N track positions to keep
  let TRACK_LENGTH = 2;

  // Disabling "mouse" handlers for 2500ms is enough
  let MOUSE_TIMEOUT = 2500;
  let MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'click'];
  // an array of bitmask values for mapping MouseEvent.which to MouseEvent.buttons
  let MOUSE_WHICH_TO_BUTTONS = [0, 1, 4, 2];
  let MOUSE_HAS_BUTTONS = function () {
    try {
      return new MouseEvent('test', {
        buttons: 1
      }).buttons === 1;
    } catch (e) {
      return false;
    }
  }();

  /**
   * @param {string} name Possible mouse event name
   * @return {boolean} true if mouse event, false if not
   */
  function isMouseEvent(name) {
    return MOUSE_EVENTS.indexOf(name) > -1;
  }

  /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
  // check for passive event listeners
  let supportsPassive = false;
  (function () {
    try {
      let opts = Object.defineProperty({}, 'passive', {
        get() {
          supportsPassive = true;
        }
      });
      window.addEventListener('test', null, opts);
      window.removeEventListener('test', null, opts);
    } catch (e) {}
  })();

  /**
   * Generate settings for event listeners, dependant on `passiveTouchGestures`
   *
   * @param {string} eventName Event name to determine if `{passive}` option is
   *   needed
   * @return {{passive: boolean} | undefined} Options to use for addEventListener
   *   and removeEventListener
   */
  function PASSIVE_TOUCH(eventName) {
    if (isMouseEvent(eventName) || eventName === 'touchend') {
      return;
    }
    if (HAS_NATIVE_TA && supportsPassive && passiveTouchGestures) {
      return {
        passive: true
      };
    } else {
      return;
    }
  }

  // Check for touch-only devices
  let IS_TOUCH_ONLY = navigator.userAgent.match(/iP(?:[oa]d|hone)|Android/);

  // keep track of any labels hit by the mouseCanceller
  /** @type {!Array<!HTMLLabelElement>} */
  const clickedLabels = [];

  /** @type {!Object<boolean>} */
  const labellable = {
    'button': true,
    'input': true,
    'keygen': true,
    'meter': true,
    'output': true,
    'textarea': true,
    'progress': true,
    'select': true
  };

  // Defined at https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#enabling-and-disabling-form-controls:-the-disabled-attribute
  /** @type {!Object<boolean>} */
  const canBeDisabled = {
    'button': true,
    'command': true,
    'fieldset': true,
    'input': true,
    'keygen': true,
    'optgroup': true,
    'option': true,
    'select': true,
    'textarea': true
  };

  /**
   * @param {HTMLElement} el Element to check labelling status
   * @return {boolean} element can have labels
   */
  function canBeLabelled(el) {
    return labellable[el.localName] || false;
  }

  /**
   * @param {HTMLElement} el Element that may be labelled.
   * @return {!Array<!HTMLLabelElement>} Relevant label for `el`
   */
  function matchingLabels(el) {
    let labels = Array.prototype.slice.call( /** @type {HTMLInputElement} */el.labels || []);
    // IE doesn't have `labels` and Safari doesn't populate `labels`
    // if element is in a shadowroot.
    // In this instance, finding the non-ancestor labels is enough,
    // as the mouseCancellor code will handle ancstor labels
    if (!labels.length) {
      labels = [];
      try {
        let root = el.getRootNode();
        // if there is an id on `el`, check for all labels with a matching `for` attribute
        if (el.id) {
          let matching = root.querySelectorAll(`label[for = '${el.id}']`);
          for (let i = 0; i < matching.length; i++) {
            labels.push( /** @type {!HTMLLabelElement} */matching[i]);
          }
        }
      } catch (e) {
        // Either:
        // 1. el.getRootNode() failed.
        // 2. el.id cannot be used in `querySelectorAll`
        // In both cases, do nothing.
      }
    }
    return labels;
  }

  // touch will make synthetic mouse events
  // `preventDefault` on touchend will cancel them,
  // but this breaks `<input>` focus and link clicks
  // disable mouse handlers for MOUSE_TIMEOUT ms after
  // a touchend to ignore synthetic mouse events
  let mouseCanceller = function (mouseEvent) {
    // Check for sourceCapabilities, used to distinguish synthetic events
    // if mouseEvent did not come from a device that fires touch events,
    // it was made by a real mouse and should be counted
    // http://wicg.github.io/InputDeviceCapabilities/#dom-inputdevicecapabilities-firestouchevents
    let sc = mouseEvent.sourceCapabilities;
    if (sc && !sc.firesTouchEvents) {
      return;
    }
    // skip synthetic mouse events
    mouseEvent[HANDLED_OBJ] = {
      skip: true
    };
    // disable "ghost clicks"
    if (mouseEvent.type === 'click') {
      let clickFromLabel = false;
      let path = getComposedPath(mouseEvent);
      for (let i = 0; i < path.length; i++) {
        if (path[i].nodeType === Node.ELEMENT_NODE) {
          if (path[i].localName === 'label') {
            clickedLabels.push( /** @type {!HTMLLabelElement} */path[i]);
          } else if (canBeLabelled( /** @type {!HTMLElement} */path[i])) {
            let ownerLabels = matchingLabels( /** @type {!HTMLElement} */path[i]);
            // check if one of the clicked labels is labelling this element
            for (let j = 0; j < ownerLabels.length; j++) {
              clickFromLabel = clickFromLabel || clickedLabels.indexOf(ownerLabels[j]) > -1;
            }
          }
        }
        if (path[i] === POINTERSTATE.mouse.target) {
          return;
        }
      }
      // if one of the clicked labels was labelling the target element,
      // this is not a ghost click
      if (clickFromLabel) {
        return;
      }
      mouseEvent.preventDefault();
      mouseEvent.stopPropagation();
    }
  };

  /**
   * @param {boolean=} setup True to add, false to remove.
   * @return {void}
   */
  function setupTeardownMouseCanceller(setup) {
    let events = IS_TOUCH_ONLY ? ['click'] : MOUSE_EVENTS;
    for (let i = 0, en; i < events.length; i++) {
      en = events[i];
      if (setup) {
        // reset clickLabels array
        clickedLabels.length = 0;
        document.addEventListener(en, mouseCanceller, true);
      } else {
        document.removeEventListener(en, mouseCanceller, true);
      }
    }
  }
  function ignoreMouse(e) {
    if (!POINTERSTATE.mouse.mouseIgnoreJob) {
      setupTeardownMouseCanceller(true);
    }
    let unset = function () {
      setupTeardownMouseCanceller();
      POINTERSTATE.mouse.target = null;
      POINTERSTATE.mouse.mouseIgnoreJob = null;
    };
    POINTERSTATE.mouse.target = getComposedPath(e)[0];
    POINTERSTATE.mouse.mouseIgnoreJob = Debouncer.debounce(POINTERSTATE.mouse.mouseIgnoreJob, timeOut.after(MOUSE_TIMEOUT), unset);
  }

  /**
   * @param {MouseEvent} ev event to test for left mouse button down
   * @return {boolean} has left mouse button down
   */
  function hasLeftMouseButton(ev) {
    let type = ev.type;
    // exit early if the event is not a mouse event
    if (!isMouseEvent(type)) {
      return false;
    }
    // ev.button is not reliable for mousemove (0 is overloaded as both left button and no buttons)
    // instead we use ev.buttons (bitmask of buttons) or fall back to ev.which (deprecated, 0 for no buttons, 1 for left button)
    if (type === 'mousemove') {
      // allow undefined for testing events
      let buttons = ev.buttons === undefined ? 1 : ev.buttons;
      if (ev instanceof window.MouseEvent && !MOUSE_HAS_BUTTONS) {
        buttons = MOUSE_WHICH_TO_BUTTONS[ev.which] || 0;
      }
      // buttons is a bitmask, check that the left button bit is set (1)
      return Boolean(buttons & 1);
    } else {
      // allow undefined for testing events
      let button = ev.button === undefined ? 0 : ev.button;
      // ev.button is 0 in mousedown/mouseup/click for left button activation
      return button === 0;
    }
  }
  function isSyntheticClick(ev) {
    if (ev.type === 'click') {
      // ev.detail is 0 for HTMLElement.click in most browsers
      if (ev.detail === 0) {
        return true;
      }
      // in the worst case, check that the x/y position of the click is within
      // the bounding box of the target of the event
      // Thanks IE 10 >:(
      let t = _findOriginalTarget(ev);
      // make sure the target of the event is an element so we can use getBoundingClientRect,
      // if not, just assume it is a synthetic click
      if (!t.nodeType || /** @type {Element} */t.nodeType !== Node.ELEMENT_NODE) {
        return true;
      }
      let bcr = /** @type {Element} */t.getBoundingClientRect();
      // use page x/y to account for scrolling
      let x = ev.pageX,
        y = ev.pageY;
      // ev is a synthetic click if the position is outside the bounding box of the target
      return !(x >= bcr.left && x <= bcr.right && y >= bcr.top && y <= bcr.bottom);
    }
    return false;
  }
  let POINTERSTATE = {
    mouse: {
      target: null,
      mouseIgnoreJob: null
    },
    touch: {
      x: 0,
      y: 0,
      id: -1,
      scrollDecided: false
    }
  };
  function firstTouchAction(ev) {
    let ta = 'auto';
    let path = getComposedPath(ev);
    for (let i = 0, n; i < path.length; i++) {
      n = path[i];
      if (n[TOUCH_ACTION]) {
        ta = n[TOUCH_ACTION];
        break;
      }
    }
    return ta;
  }
  function trackDocument(stateObj, movefn, upfn) {
    stateObj.movefn = movefn;
    stateObj.upfn = upfn;
    document.addEventListener('mousemove', movefn);
    document.addEventListener('mouseup', upfn);
  }
  function untrackDocument(stateObj) {
    document.removeEventListener('mousemove', stateObj.movefn);
    document.removeEventListener('mouseup', stateObj.upfn);
    stateObj.movefn = null;
    stateObj.upfn = null;
  }
  {
    // use a document-wide touchend listener to start the ghost-click prevention mechanism
    // Use passive event listeners, if supported, to not affect scrolling performance
    document.addEventListener('touchend', ignoreMouse, supportsPassive ? {
      passive: true
    } : false);
  }

  /**
   * Returns the composedPath for the given event.
   * @param {Event} event to process
   * @return {!Array<!EventTarget>} Path of the event
   */
  const getComposedPath = window.ShadyDOM && window.ShadyDOM.noPatch ? window.ShadyDOM.composedPath : event => event.composedPath && event.composedPath() || [];

  /** @type {!Object<string, !GestureRecognizer>} */
  const gestures = {};

  /** @type {!Array<!GestureRecognizer>} */
  const recognizers = [];

  /**
   * Finds the element rendered on the screen at the provided coordinates.
   *
   * Similar to `document.elementFromPoint`, but pierces through
   * shadow roots.
   *
   * @param {number} x Horizontal pixel coordinate
   * @param {number} y Vertical pixel coordinate
   * @return {Element} Returns the deepest shadowRoot inclusive element
   * found at the screen position given.
   */
  function deepTargetFind(x, y) {
    let node = document.elementFromPoint(x, y);
    let next = node;
    // this code path is only taken when native ShadowDOM is used
    // if there is a shadowroot, it may have a node at x/y
    // if there is not a shadowroot, exit the loop
    while (next && next.shadowRoot && !window.ShadyDOM) {
      // if there is a node at x/y in the shadowroot, look deeper
      let oldNext = next;
      next = next.shadowRoot.elementFromPoint(x, y);
      // on Safari, elementFromPoint may return the shadowRoot host
      if (oldNext === next) {
        break;
      }
      if (next) {
        node = next;
      }
    }
    return node;
  }

  /**
   * a cheaper check than ev.composedPath()[0];
   *
   * @private
   * @param {Event|Touch} ev Event.
   * @return {EventTarget} Returns the event target.
   */
  function _findOriginalTarget(ev) {
    const path = getComposedPath( /** @type {?Event} */ev);
    // It shouldn't be, but sometimes path is empty (window on Safari).
    return path.length > 0 ? path[0] : ev.target;
  }

  /**
   * @private
   * @param {Event} ev Event.
   * @return {void}
   */
  function _handleNative(ev) {
    let handled;
    let type = ev.type;
    let node = ev.currentTarget;
    let gobj = node[GESTURE_KEY];
    if (!gobj) {
      return;
    }
    let gs = gobj[type];
    if (!gs) {
      return;
    }
    if (!ev[HANDLED_OBJ]) {
      ev[HANDLED_OBJ] = {};
      if (type.slice(0, 5) === 'touch') {
        ev = /** @type {TouchEvent} */ev; // eslint-disable-line no-self-assign
        let t = ev.changedTouches[0];
        if (type === 'touchstart') {
          // only handle the first finger
          if (ev.touches.length === 1) {
            POINTERSTATE.touch.id = t.identifier;
          }
        }
        if (POINTERSTATE.touch.id !== t.identifier) {
          return;
        }
        if (!HAS_NATIVE_TA) {
          if (type === 'touchstart' || type === 'touchmove') {
            _handleTouchAction(ev);
          }
        }
      }
    }
    handled = ev[HANDLED_OBJ];
    // used to ignore synthetic mouse events
    if (handled.skip) {
      return;
    }
    // reset recognizer state
    for (let i = 0, r; i < recognizers.length; i++) {
      r = recognizers[i];
      if (gs[r.name] && !handled[r.name]) {
        if (r.flow && r.flow.start.indexOf(ev.type) > -1 && r.reset) {
          r.reset();
        }
      }
    }
    // enforce gesture recognizer order
    for (let i = 0, r; i < recognizers.length; i++) {
      r = recognizers[i];
      if (gs[r.name] && !handled[r.name]) {
        handled[r.name] = true;
        r[type](ev);
      }
    }
  }

  /**
   * @private
   * @param {TouchEvent} ev Event.
   * @return {void}
   */
  function _handleTouchAction(ev) {
    let t = ev.changedTouches[0];
    let type = ev.type;
    if (type === 'touchstart') {
      POINTERSTATE.touch.x = t.clientX;
      POINTERSTATE.touch.y = t.clientY;
      POINTERSTATE.touch.scrollDecided = false;
    } else if (type === 'touchmove') {
      if (POINTERSTATE.touch.scrollDecided) {
        return;
      }
      POINTERSTATE.touch.scrollDecided = true;
      let ta = firstTouchAction(ev);
      let shouldPrevent = false;
      let dx = Math.abs(POINTERSTATE.touch.x - t.clientX);
      let dy = Math.abs(POINTERSTATE.touch.y - t.clientY);
      if (!ev.cancelable) ; else if (ta === 'none') {
        shouldPrevent = true;
      } else if (ta === 'pan-x') {
        shouldPrevent = dy > dx;
      } else if (ta === 'pan-y') {
        shouldPrevent = dx > dy;
      }
      if (shouldPrevent) {
        ev.preventDefault();
      } else {
        prevent('track');
      }
    }
  }

  /**
   * Adds an event listener to a node for the given gesture type.
   *
   * @param {!EventTarget} node Node to add listener on
   * @param {string} evType Gesture type: `down`, `up`, `track`, or `tap`
   * @param {!function(!Event):void} handler Event listener function to call
   * @return {boolean} Returns true if a gesture event listener was added.
   */
  function addListener(node, evType, handler) {
    if (gestures[evType]) {
      _add(node, evType, handler);
      return true;
    }
    return false;
  }

  /**
   * Removes an event listener from a node for the given gesture type.
   *
   * @param {!EventTarget} node Node to remove listener from
   * @param {string} evType Gesture type: `down`, `up`, `track`, or `tap`
   * @param {!function(!Event):void} handler Event listener function previously passed to
   *  `addListener`.
   * @return {boolean} Returns true if a gesture event listener was removed.
   */
  function removeListener(node, evType, handler) {
    if (gestures[evType]) {
      _remove(node, evType, handler);
      return true;
    }
    return false;
  }

  /**
   * automate the event listeners for the native events
   *
   * @private
   * @param {!EventTarget} node Node on which to add the event.
   * @param {string} evType Event type to add.
   * @param {function(!Event)} handler Event handler function.
   * @return {void}
   */
  function _add(node, evType, handler) {
    let recognizer = gestures[evType];
    let deps = recognizer.deps;
    let name = recognizer.name;
    let gobj = node[GESTURE_KEY];
    if (!gobj) {
      node[GESTURE_KEY] = gobj = {};
    }
    for (let i = 0, dep, gd; i < deps.length; i++) {
      dep = deps[i];
      // don't add mouse handlers on iOS because they cause gray selection overlays
      if (IS_TOUCH_ONLY && isMouseEvent(dep) && dep !== 'click') {
        continue;
      }
      gd = gobj[dep];
      if (!gd) {
        gobj[dep] = gd = {
          _count: 0
        };
      }
      if (gd._count === 0) {
        node.addEventListener(dep, _handleNative, PASSIVE_TOUCH(dep));
      }
      gd[name] = (gd[name] || 0) + 1;
      gd._count = (gd._count || 0) + 1;
    }
    node.addEventListener(evType, handler);
    if (recognizer.touchAction) {
      setTouchAction(node, recognizer.touchAction);
    }
  }

  /**
   * automate event listener removal for native events
   *
   * @private
   * @param {!EventTarget} node Node on which to remove the event.
   * @param {string} evType Event type to remove.
   * @param {function(!Event): void} handler Event handler function.
   * @return {void}
   */
  function _remove(node, evType, handler) {
    let recognizer = gestures[evType];
    let deps = recognizer.deps;
    let name = recognizer.name;
    let gobj = node[GESTURE_KEY];
    if (gobj) {
      for (let i = 0, dep, gd; i < deps.length; i++) {
        dep = deps[i];
        gd = gobj[dep];
        if (gd && gd[name]) {
          gd[name] = (gd[name] || 1) - 1;
          gd._count = (gd._count || 1) - 1;
          if (gd._count === 0) {
            node.removeEventListener(dep, _handleNative, PASSIVE_TOUCH(dep));
          }
        }
      }
    }
    node.removeEventListener(evType, handler);
  }

  /**
   * Registers a new gesture event recognizer for adding new custom
   * gesture event types.
   *
   * @param {!GestureRecognizer} recog Gesture recognizer descriptor
   * @return {void}
   */
  function register(recog) {
    recognizers.push(recog);
    for (let i = 0; i < recog.emits.length; i++) {
      gestures[recog.emits[i]] = recog;
    }
  }

  /**
   * @private
   * @param {string} evName Event name.
   * @return {Object} Returns the gesture for the given event name.
   */
  function _findRecognizerByEvent(evName) {
    for (let i = 0, r; i < recognizers.length; i++) {
      r = recognizers[i];
      for (let j = 0, n; j < r.emits.length; j++) {
        n = r.emits[j];
        if (n === evName) {
          return r;
        }
      }
    }
    return null;
  }

  /**
   * Sets scrolling direction on node.
   *
   * This value is checked on first move, thus it should be called prior to
   * adding event listeners.
   *
   * @param {!EventTarget} node Node to set touch action setting on
   * @param {string} value Touch action value
   * @return {void}
   */
  function setTouchAction(node, value) {
    if (HAS_NATIVE_TA && node instanceof HTMLElement) {
      // NOTE: add touchAction async so that events can be added in
      // custom element constructors. Otherwise we run afoul of custom
      // elements restriction against settings attributes (style) in the
      // constructor.
      microTask.run(() => {
        node.style.touchAction = value;
      });
    }
    node[TOUCH_ACTION] = value;
  }

  /**
   * Dispatches an event on the `target` element of `type` with the given
   * `detail`.
   * @private
   * @param {!EventTarget} target The element on which to fire an event.
   * @param {string} type The type of event to fire.
   * @param {!Object=} detail The detail object to populate on the event.
   * @return {void}
   */
  function _fire(target, type, detail) {
    let ev = new Event(type, {
      bubbles: true,
      cancelable: true,
      composed: true
    });
    ev.detail = detail;
    wrap( /** @type {!Node} */target).dispatchEvent(ev);
    // forward `preventDefault` in a clean way
    if (ev.defaultPrevented) {
      let preventer = detail.preventer || detail.sourceEvent;
      if (preventer && preventer.preventDefault) {
        preventer.preventDefault();
      }
    }
  }

  /**
   * Prevents the dispatch and default action of the given event name.
   *
   * @param {string} evName Event name.
   * @return {void}
   */
  function prevent(evName) {
    let recognizer = _findRecognizerByEvent(evName);
    if (recognizer.info) {
      recognizer.info.prevent = true;
    }
  }

  /* eslint-disable valid-jsdoc */

  register({
    name: 'downup',
    deps: ['mousedown', 'touchstart', 'touchend'],
    flow: {
      start: ['mousedown', 'touchstart'],
      end: ['mouseup', 'touchend']
    },
    emits: ['down', 'up'],
    info: {
      movefn: null,
      upfn: null
    },
    /**
     * @this {GestureRecognizer}
     * @return {void}
     */
    reset: function () {
      untrackDocument(this.info);
    },
    /**
     * @this {GestureRecognizer}
     * @param {MouseEvent} e
     * @return {void}
     */
    mousedown: function (e) {
      if (!hasLeftMouseButton(e)) {
        return;
      }
      let t = _findOriginalTarget(e);
      let self = this;
      let movefn = function movefn(e) {
        if (!hasLeftMouseButton(e)) {
          downupFire('up', t, e);
          untrackDocument(self.info);
        }
      };
      let upfn = function upfn(e) {
        if (hasLeftMouseButton(e)) {
          downupFire('up', t, e);
        }
        untrackDocument(self.info);
      };
      trackDocument(this.info, movefn, upfn);
      downupFire('down', t, e);
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchstart: function (e) {
      downupFire('down', _findOriginalTarget(e), e.changedTouches[0], e);
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchend: function (e) {
      downupFire('up', _findOriginalTarget(e), e.changedTouches[0], e);
    }
  });

  /**
   * @param {string} type
   * @param {EventTarget} target
   * @param {Event|Touch} event
   * @param {Event=} preventer
   * @return {void}
   */
  function downupFire(type, target, event, preventer) {
    if (!target) {
      return;
    }
    _fire(target, type, {
      x: event.clientX,
      y: event.clientY,
      sourceEvent: event,
      preventer: preventer,
      prevent: function (e) {
        return prevent(e);
      }
    });
  }
  register({
    name: 'track',
    touchAction: 'none',
    deps: ['mousedown', 'touchstart', 'touchmove', 'touchend'],
    flow: {
      start: ['mousedown', 'touchstart'],
      end: ['mouseup', 'touchend']
    },
    emits: ['track'],
    info: {
      x: 0,
      y: 0,
      state: 'start',
      started: false,
      moves: [],
      /** @this {GestureInfo} */
      addMove: function (move) {
        if (this.moves.length > TRACK_LENGTH) {
          this.moves.shift();
        }
        this.moves.push(move);
      },
      movefn: null,
      upfn: null,
      prevent: false
    },
    /**
     * @this {GestureRecognizer}
     * @return {void}
     */
    reset: function () {
      this.info.state = 'start';
      this.info.started = false;
      this.info.moves = [];
      this.info.x = 0;
      this.info.y = 0;
      this.info.prevent = false;
      untrackDocument(this.info);
    },
    /**
     * @this {GestureRecognizer}
     * @param {MouseEvent} e
     * @return {void}
     */
    mousedown: function (e) {
      if (!hasLeftMouseButton(e)) {
        return;
      }
      let t = _findOriginalTarget(e);
      let self = this;
      let movefn = function movefn(e) {
        let x = e.clientX,
          y = e.clientY;
        if (trackHasMovedEnough(self.info, x, y)) {
          // first move is 'start', subsequent moves are 'move', mouseup is 'end'
          self.info.state = self.info.started ? e.type === 'mouseup' ? 'end' : 'track' : 'start';
          if (self.info.state === 'start') {
            // if and only if tracking, always prevent tap
            prevent('tap');
          }
          self.info.addMove({
            x: x,
            y: y
          });
          if (!hasLeftMouseButton(e)) {
            // always fire "end"
            self.info.state = 'end';
            untrackDocument(self.info);
          }
          if (t) {
            trackFire(self.info, t, e);
          }
          self.info.started = true;
        }
      };
      let upfn = function upfn(e) {
        if (self.info.started) {
          movefn(e);
        }

        // remove the temporary listeners
        untrackDocument(self.info);
      };
      // add temporary document listeners as mouse retargets
      trackDocument(this.info, movefn, upfn);
      this.info.x = e.clientX;
      this.info.y = e.clientY;
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchstart: function (e) {
      let ct = e.changedTouches[0];
      this.info.x = ct.clientX;
      this.info.y = ct.clientY;
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchmove: function (e) {
      let t = _findOriginalTarget(e);
      let ct = e.changedTouches[0];
      let x = ct.clientX,
        y = ct.clientY;
      if (trackHasMovedEnough(this.info, x, y)) {
        if (this.info.state === 'start') {
          // if and only if tracking, always prevent tap
          prevent('tap');
        }
        this.info.addMove({
          x: x,
          y: y
        });
        trackFire(this.info, t, ct);
        this.info.state = 'track';
        this.info.started = true;
      }
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchend: function (e) {
      let t = _findOriginalTarget(e);
      let ct = e.changedTouches[0];
      // only trackend if track was started and not aborted
      if (this.info.started) {
        // reset started state on up
        this.info.state = 'end';
        this.info.addMove({
          x: ct.clientX,
          y: ct.clientY
        });
        trackFire(this.info, t, ct);
      }
    }
  });

  /**
   * @param {!GestureInfo} info
   * @param {number} x
   * @param {number} y
   * @return {boolean}
   */
  function trackHasMovedEnough(info, x, y) {
    if (info.prevent) {
      return false;
    }
    if (info.started) {
      return true;
    }
    let dx = Math.abs(info.x - x);
    let dy = Math.abs(info.y - y);
    return dx >= TRACK_DISTANCE || dy >= TRACK_DISTANCE;
  }

  /**
   * @param {!GestureInfo} info
   * @param {?EventTarget} target
   * @param {Touch} touch
   * @return {void}
   */
  function trackFire(info, target, touch) {
    if (!target) {
      return;
    }
    let secondlast = info.moves[info.moves.length - 2];
    let lastmove = info.moves[info.moves.length - 1];
    let dx = lastmove.x - info.x;
    let dy = lastmove.y - info.y;
    let ddx,
      ddy = 0;
    if (secondlast) {
      ddx = lastmove.x - secondlast.x;
      ddy = lastmove.y - secondlast.y;
    }
    _fire(target, 'track', {
      state: info.state,
      x: touch.clientX,
      y: touch.clientY,
      dx: dx,
      dy: dy,
      ddx: ddx,
      ddy: ddy,
      sourceEvent: touch,
      hover: function () {
        return deepTargetFind(touch.clientX, touch.clientY);
      }
    });
  }
  register({
    name: 'tap',
    deps: ['mousedown', 'click', 'touchstart', 'touchend'],
    flow: {
      start: ['mousedown', 'touchstart'],
      end: ['click', 'touchend']
    },
    emits: ['tap'],
    info: {
      x: NaN,
      y: NaN,
      prevent: false
    },
    /**
     * @this {GestureRecognizer}
     * @return {void}
     */
    reset: function () {
      this.info.x = NaN;
      this.info.y = NaN;
      this.info.prevent = false;
    },
    /**
     * @this {GestureRecognizer}
     * @param {MouseEvent} e
     * @return {void}
     */
    mousedown: function (e) {
      if (hasLeftMouseButton(e)) {
        this.info.x = e.clientX;
        this.info.y = e.clientY;
      }
    },
    /**
     * @this {GestureRecognizer}
     * @param {MouseEvent} e
     * @return {void}
     */
    click: function (e) {
      if (hasLeftMouseButton(e)) {
        trackForward(this.info, e);
      }
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchstart: function (e) {
      const touch = e.changedTouches[0];
      this.info.x = touch.clientX;
      this.info.y = touch.clientY;
    },
    /**
     * @this {GestureRecognizer}
     * @param {TouchEvent} e
     * @return {void}
     */
    touchend: function (e) {
      trackForward(this.info, e.changedTouches[0], e);
    }
  });

  /**
   * @param {!GestureInfo} info
   * @param {Event | Touch} e
   * @param {Event=} preventer
   * @return {void}
   */
  function trackForward(info, e, preventer) {
    let dx = Math.abs(e.clientX - info.x);
    let dy = Math.abs(e.clientY - info.y);
    // find original target from `preventer` for TouchEvents, or `e` for MouseEvents
    let t = _findOriginalTarget(preventer || e);
    if (!t || canBeDisabled[/** @type {!HTMLElement} */t.localName] && t.hasAttribute('disabled')) {
      return;
    }
    // dx,dy can be NaN if `click` has been simulated and there was no `down` for `start`
    if (isNaN(dx) || isNaN(dy) || dx <= TAP_DISTANCE && dy <= TAP_DISTANCE || isSyntheticClick(e)) {
      // prevent taps from being generated if an event has canceled them
      if (!info.prevent) {
        _fire(t, 'tap', {
          x: e.clientX,
          y: e.clientY,
          sourceEvent: e,
          preventer: preventer
        });
      }
    }
  }

  /**
   * Element class mixin that provides API for adding Polymer's cross-platform
   * gesture events to nodes.
   *
   * The API is designed to be compatible with override points implemented
   * in `TemplateStamp` such that declarative event listeners in
   * templates will support gesture events when this mixin is applied along with
   * `TemplateStamp`.
   *
   * @mixinFunction
   * @polymer
   * @summary Element class mixin that provides API for adding Polymer's
   *   cross-platform gesture events to nodes
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const GestureEventListeners = dedupingMixin(superClass => {
    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_GestureEventListeners}
     */let GestureEventListeners = /*#__PURE__*/function (_superClass) {
      _inherits(GestureEventListeners, _superClass);
      var _super = _createSuper(GestureEventListeners);
      function GestureEventListeners() {
        _classCallCheck(this, GestureEventListeners);
        return _super.apply(this, arguments);
      }
      _createClass(GestureEventListeners, [{
        key: "_addEventListenerToNode",
        value:
        /**
         * Add the event listener to the node if it is a gestures event.
         *
         * @param {!EventTarget} node Node to add event listener to
         * @param {string} eventName Name of event
         * @param {function(!Event):void} handler Listener function to add
         * @return {void}
         * @override
         */
        function _addEventListenerToNode(node, eventName, handler) {
          if (!addListener(node, eventName, handler)) {
            _get(_getPrototypeOf(GestureEventListeners.prototype), "_addEventListenerToNode", this).call(this, node, eventName, handler);
          }
        }

        /**
         * Remove the event listener to the node if it is a gestures event.
         *
         * @param {!EventTarget} node Node to remove event listener from
         * @param {string} eventName Name of event
         * @param {function(!Event):void} handler Listener function to remove
         * @return {void}
         * @override
         */
      }, {
        key: "_removeEventListenerFromNode",
        value: function _removeEventListenerFromNode(node, eventName, handler) {
          if (!removeListener(node, eventName, handler)) {
            _get(_getPrototypeOf(GestureEventListeners.prototype), "_removeEventListenerFromNode", this).call(this, node, eventName, handler);
          }
        }
      }]);
      return GestureEventListeners;
    }(superClass);
    return GestureEventListeners;
  });

  const HOST_DIR = /:host\(:dir\((ltr|rtl)\)\)/g;
  const HOST_DIR_REPLACMENT = ':host([dir="$1"])';
  const EL_DIR = /([\s\w-#\.\[\]\*]*):dir\((ltr|rtl)\)/g;
  const EL_DIR_REPLACMENT = ':host([dir="$2"]) $1';
  const DIR_CHECK = /:dir\((?:ltr|rtl)\)/;
  const SHIM_SHADOW = Boolean(window['ShadyDOM'] && window['ShadyDOM']['inUse']);

  /**
   * @type {!Array<!Polymer_DirMixin>}
   */
  const DIR_INSTANCES = [];

  /** @type {?MutationObserver} */
  let observer = null;
  let documentDir = '';
  function getRTL() {
    documentDir = document.documentElement.getAttribute('dir');
  }

  /**
   * @param {!Polymer_DirMixin} instance Instance to set RTL status on
   */
  function setRTL(instance) {
    if (!instance.__autoDirOptOut) {
      const el = /** @type {!HTMLElement} */instance;
      el.setAttribute('dir', documentDir);
    }
  }
  function updateDirection() {
    getRTL();
    documentDir = document.documentElement.getAttribute('dir');
    for (let i = 0; i < DIR_INSTANCES.length; i++) {
      setRTL(DIR_INSTANCES[i]);
    }
  }
  function takeRecords() {
    if (observer && observer.takeRecords().length) {
      updateDirection();
    }
  }

  /**
   * Element class mixin that allows elements to use the `:dir` CSS Selector to
   * have text direction specific styling.
   *
   * With this mixin, any stylesheet provided in the template will transform
   * `:dir` into `:host([dir])` and sync direction with the page via the
   * element's `dir` attribute.
   *
   * Elements can opt out of the global page text direction by setting the `dir`
   * attribute directly in `ready()` or in HTML.
   *
   * Caveats:
   * - Applications must set `<html dir="ltr">` or `<html dir="rtl">` to sync
   *   direction
   * - Automatic left-to-right or right-to-left styling is sync'd with the
   *   `<html>` element only.
   * - Changing `dir` at runtime is supported.
   * - Opting out of the global direction styling is permanent
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin PropertyAccessors
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const DirMixin = dedupingMixin(base => {
    if (!SHIM_SHADOW) {
      if (!observer) {
        getRTL();
        observer = new MutationObserver(updateDirection);
        observer.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['dir']
        });
      }
    }

    /**
     * @constructor
     * @implements {Polymer_PropertyAccessors}
     * @private
     */
    const elementBase = PropertyAccessors(base);

    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_DirMixin}
     */
    let Dir = /*#__PURE__*/function (_elementBase) {
      _inherits(Dir, _elementBase);
      var _super = _createSuper(Dir);
      function Dir() {
        var _this;
        _classCallCheck(this, Dir);
        _this = _super.call(this);
        /** @type {boolean} */
        _this.__autoDirOptOut = false;
        return _this;
      }

      /**
       * @override
       * @suppress {invalidCasts} Closure doesn't understand that `this` is an
       *     HTMLElement
       * @return {void}
       */
      _createClass(Dir, [{
        key: "ready",
        value: function ready() {
          _get(_getPrototypeOf(Dir.prototype), "ready", this).call(this);
          this.__autoDirOptOut = /** @type {!HTMLElement} */this.hasAttribute('dir');
        }

        /**
         * @override
         * @suppress {missingProperties} If it exists on elementBase, it can be
         *   super'd
         * @return {void}
         */
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          if (elementBase.prototype.connectedCallback) {
            _get(_getPrototypeOf(Dir.prototype), "connectedCallback", this).call(this);
          }
          if (this.constructor.__activateDir) {
            takeRecords();
            DIR_INSTANCES.push(this);
            setRTL(this);
          }
        }

        /**
         * @override
         * @suppress {missingProperties} If it exists on elementBase, it can be
         *   super'd
         * @return {void}
         */
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          if (elementBase.prototype.disconnectedCallback) {
            _get(_getPrototypeOf(Dir.prototype), "disconnectedCallback", this).call(this);
          }
          if (this.constructor.__activateDir) {
            const idx = DIR_INSTANCES.indexOf(this);
            if (idx > -1) {
              DIR_INSTANCES.splice(idx, 1);
            }
          }
        }
      }], [{
        key: "_processStyleText",
        value:
        /**
         * @param {string} cssText .
         * @param {string} baseURI .
         * @return {string} .
         * @suppress {missingProperties} Interfaces in closure do not inherit statics, but classes do
         * @nocollapse
         */
        function _processStyleText(cssText, baseURI) {
          // TODO(https://github.com/google/closure-compiler/issues/3240):
          //     Change back to just super.methodCall()
          cssText = elementBase._processStyleText.call(this, cssText, baseURI);
          if (!SHIM_SHADOW && DIR_CHECK.test(cssText)) {
            cssText = this._replaceDirInCssText(cssText);
            this.__activateDir = true;
          }
          return cssText;
        }

        /**
         * Replace `:dir` in the given CSS text
         *
         * @param {string} text CSS text to replace DIR
         * @return {string} Modified CSS
         * @nocollapse
         */
      }, {
        key: "_replaceDirInCssText",
        value: function _replaceDirInCssText(text) {
          let replacedText = text;
          replacedText = replacedText.replace(HOST_DIR, HOST_DIR_REPLACMENT);
          replacedText = replacedText.replace(EL_DIR, EL_DIR_REPLACMENT);
          return replacedText;
        }
      }]);
      return Dir;
    }(elementBase);
    Dir.__activateDir = false;
    return Dir;
  });

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  function resolve() {
    document.body.removeAttribute('unresolved');
  }
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    resolve();
  } else {
    window.addEventListener('DOMContentLoaded', resolve);
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  function newSplice(index, removed, addedCount) {
    return {
      index: index,
      removed: removed,
      addedCount: addedCount
    };
  }
  const EDIT_LEAVE = 0;
  const EDIT_UPDATE = 1;
  const EDIT_ADD = 2;
  const EDIT_DELETE = 3;

  // Note: This function is *based* on the computation of the Levenshtein
  // "edit" distance. The one change is that "updates" are treated as two
  // edits - not one. With Array splices, an update is really a delete
  // followed by an add. By retaining this, we optimize for "keeping" the
  // maximum array items in the original array. For example:
  //
  //   'xxxx123' -> '123yyyy'
  //
  // With 1-edit updates, the shortest path would be just to update all seven
  // characters. With 2-edit updates, we delete 4, leave 3, and add 4. This
  // leaves the substring '123' intact.
  function calcEditDistances(current, currentStart, currentEnd, old, oldStart, oldEnd) {
    // "Deletion" columns
    let rowCount = oldEnd - oldStart + 1;
    let columnCount = currentEnd - currentStart + 1;
    let distances = new Array(rowCount);

    // "Addition" rows. Initialize null column.
    for (let i = 0; i < rowCount; i++) {
      distances[i] = new Array(columnCount);
      distances[i][0] = i;
    }

    // Initialize null row
    for (let j = 0; j < columnCount; j++) distances[0][j] = j;
    for (let i = 1; i < rowCount; i++) {
      for (let j = 1; j < columnCount; j++) {
        if (equals(current[currentStart + j - 1], old[oldStart + i - 1])) distances[i][j] = distances[i - 1][j - 1];else {
          let north = distances[i - 1][j] + 1;
          let west = distances[i][j - 1] + 1;
          distances[i][j] = north < west ? north : west;
        }
      }
    }
    return distances;
  }

  // This starts at the final weight, and walks "backward" by finding
  // the minimum previous weight recursively until the origin of the weight
  // matrix.
  function spliceOperationsFromEditDistances(distances) {
    let i = distances.length - 1;
    let j = distances[0].length - 1;
    let current = distances[i][j];
    let edits = [];
    while (i > 0 || j > 0) {
      if (i == 0) {
        edits.push(EDIT_ADD);
        j--;
        continue;
      }
      if (j == 0) {
        edits.push(EDIT_DELETE);
        i--;
        continue;
      }
      let northWest = distances[i - 1][j - 1];
      let west = distances[i - 1][j];
      let north = distances[i][j - 1];
      let min;
      if (west < north) min = west < northWest ? west : northWest;else min = north < northWest ? north : northWest;
      if (min == northWest) {
        if (northWest == current) {
          edits.push(EDIT_LEAVE);
        } else {
          edits.push(EDIT_UPDATE);
          current = northWest;
        }
        i--;
        j--;
      } else if (min == west) {
        edits.push(EDIT_DELETE);
        i--;
        current = west;
      } else {
        edits.push(EDIT_ADD);
        j--;
        current = north;
      }
    }
    edits.reverse();
    return edits;
  }

  /**
   * Splice Projection functions:
   *
   * A splice map is a representation of how a previous array of items
   * was transformed into a new array of items. Conceptually it is a list of
   * tuples of
   *
   *   <index, removed, addedCount>
   *
   * which are kept in ascending index order of. The tuple represents that at
   * the |index|, |removed| sequence of items were removed, and counting forward
   * from |index|, |addedCount| items were added.
   */

  /**
   * Lacking individual splice mutation information, the minimal set of
   * splices can be synthesized given the previous state and final state of an
   * array. The basic approach is to calculate the edit distance matrix and
   * choose the shortest path through it.
   *
   * Complexity: O(l * p)
   *   l: The length of the current array
   *   p: The length of the old array
   *
   * @param {!Array} current The current "changed" array for which to
   * calculate splices.
   * @param {number} currentStart Starting index in the `current` array for
   * which splices are calculated.
   * @param {number} currentEnd Ending index in the `current` array for
   * which splices are calculated.
   * @param {!Array} old The original "unchanged" array to compare `current`
   * against to determine splices.
   * @param {number} oldStart Starting index in the `old` array for
   * which splices are calculated.
   * @param {number} oldEnd Ending index in the `old` array for
   * which splices are calculated.
   * @return {!Array} Returns an array of splice record objects. Each of these
   * contains: `index` the location where the splice occurred; `removed`
   * the array of removed items from this location; `addedCount` the number
   * of items added at this location.
   */
  function calcSplices(current, currentStart, currentEnd, old, oldStart, oldEnd) {
    let prefixCount = 0;
    let suffixCount = 0;
    let splice;
    let minLength = Math.min(currentEnd - currentStart, oldEnd - oldStart);
    if (currentStart == 0 && oldStart == 0) prefixCount = sharedPrefix(current, old, minLength);
    if (currentEnd == current.length && oldEnd == old.length) suffixCount = sharedSuffix(current, old, minLength - prefixCount);
    currentStart += prefixCount;
    oldStart += prefixCount;
    currentEnd -= suffixCount;
    oldEnd -= suffixCount;
    if (currentEnd - currentStart == 0 && oldEnd - oldStart == 0) return [];
    if (currentStart == currentEnd) {
      splice = newSplice(currentStart, [], 0);
      while (oldStart < oldEnd) splice.removed.push(old[oldStart++]);
      return [splice];
    } else if (oldStart == oldEnd) return [newSplice(currentStart, [], currentEnd - currentStart)];
    let ops = spliceOperationsFromEditDistances(calcEditDistances(current, currentStart, currentEnd, old, oldStart, oldEnd));
    splice = undefined;
    let splices = [];
    let index = currentStart;
    let oldIndex = oldStart;
    for (let i = 0; i < ops.length; i++) {
      switch (ops[i]) {
        case EDIT_LEAVE:
          if (splice) {
            splices.push(splice);
            splice = undefined;
          }
          index++;
          oldIndex++;
          break;
        case EDIT_UPDATE:
          if (!splice) splice = newSplice(index, [], 0);
          splice.addedCount++;
          index++;
          splice.removed.push(old[oldIndex]);
          oldIndex++;
          break;
        case EDIT_ADD:
          if (!splice) splice = newSplice(index, [], 0);
          splice.addedCount++;
          index++;
          break;
        case EDIT_DELETE:
          if (!splice) splice = newSplice(index, [], 0);
          splice.removed.push(old[oldIndex]);
          oldIndex++;
          break;
      }
    }
    if (splice) {
      splices.push(splice);
    }
    return splices;
  }
  function sharedPrefix(current, old, searchLength) {
    for (let i = 0; i < searchLength; i++) if (!equals(current[i], old[i])) return i;
    return searchLength;
  }
  function sharedSuffix(current, old, searchLength) {
    let index1 = current.length;
    let index2 = old.length;
    let count = 0;
    while (count < searchLength && equals(current[--index1], old[--index2])) count++;
    return count;
  }

  /**
   * Returns an array of splice records indicating the minimum edits required
   * to transform the `previous` array into the `current` array.
   *
   * Splice records are ordered by index and contain the following fields:
   * - `index`: index where edit started
   * - `removed`: array of removed items from this index
   * - `addedCount`: number of items added at this index
   *
   * This function is based on the Levenshtein "minimum edit distance"
   * algorithm. Note that updates are treated as removal followed by addition.
   *
   * The worst-case time complexity of this algorithm is `O(l * p)`
   *   l: The length of the current array
   *   p: The length of the previous array
   *
   * However, the worst-case complexity is reduced by an `O(n)` optimization
   * to detect any shared prefix & suffix between the two arrays and only
   * perform the more expensive minimum edit distance calculation over the
   * non-shared portions of the arrays.
   *
   * @function
   * @param {!Array} current The "changed" array for which splices will be
   * calculated.
   * @param {!Array} previous The "unchanged" original array to compare
   * `current` against to determine the splices.
   * @return {!Array} Returns an array of splice record objects. Each of these
   * contains: `index` the location where the splice occurred; `removed`
   * the array of removed items from this location; `addedCount` the number
   * of items added at this location.
   */
  function calculateSplices(current, previous) {
    return calcSplices(current, 0, current.length, previous, 0, previous.length);
  }
  function equals(currentValue, previousValue) {
    return currentValue === previousValue;
  }

  /**
   * Returns true if `node` is a slot element
   * @param {!Node} node Node to test.
   * @return {boolean} Returns true if the given `node` is a slot
   * @private
   */
  function isSlot(node) {
    return node.localName === 'slot';
  }

  /**
   * Class that listens for changes (additions or removals) to
   * "flattened nodes" on a given `node`. The list of flattened nodes consists
   * of a node's children and, for any children that are `<slot>` elements,
   * the expanded flattened list of `assignedNodes`.
   * For example, if the observed node has children `<a></a><slot></slot><b></b>`
   * and the `<slot>` has one `<div>` assigned to it, then the flattened
   * nodes list is `<a></a><div></div><b></b>`. If the `<slot>` has other
   * `<slot>` elements assigned to it, these are flattened as well.
   *
   * The provided `callback` is called whenever any change to this list
   * of flattened nodes occurs, where an addition or removal of a node is
   * considered a change. The `callback` is called with one argument, an object
   * containing an array of any `addedNodes` and `removedNodes`.
   *
   * Note: the callback is called asynchronous to any changes
   * at a microtask checkpoint. This is because observation is performed using
   * `MutationObserver` and the `<slot>` element's `slotchange` event which
   * are asynchronous.
   *
   * An example:
   * ```js
   * class TestSelfObserve extends PolymerElement {
   *   static get is() { return 'test-self-observe';}
   *   connectedCallback() {
   *     super.connectedCallback();
   *     this._observer = new FlattenedNodesObserver(this, (info) => {
   *       this.info = info;
   *     });
   *   }
   *   disconnectedCallback() {
   *     super.disconnectedCallback();
   *     this._observer.disconnect();
   *   }
   * }
   * customElements.define(TestSelfObserve.is, TestSelfObserve);
   * ```
   *
   * @summary Class that listens for changes (additions or removals) to
   * "flattened nodes" on a given `node`.
   * @implements {PolymerDomApi.ObserveHandle}
   */
  let FlattenedNodesObserver = /*#__PURE__*/function () {
    /**
     * @param {!HTMLElement} target Node on which to listen for changes.
     * @param {?function(this: Element, { target: !HTMLElement, addedNodes: !Array<!Element>, removedNodes: !Array<!Element> }):void} callback Function called when there are additions
     * or removals from the target's list of flattened nodes.
     */
    // eslint-disable-next-line
    function FlattenedNodesObserver(target, callback) {
      _classCallCheck(this, FlattenedNodesObserver);
      /**
       * @type {MutationObserver}
       * @private
       */
      this._shadyChildrenObserver = null;
      /**
       * @type {MutationObserver}
       * @private
       */
      this._nativeChildrenObserver = null;
      this._connected = false;
      /**
       * @type {!HTMLElement}
       * @private
       */
      this._target = target;
      this.callback = callback;
      this._effectiveNodes = [];
      this._observer = null;
      this._scheduled = false;
      /**
       * @type {function()}
       * @private
       */
      this._boundSchedule = () => {
        this._schedule();
      };
      this.connect();
      this._schedule();
    }

    /**
     * Activates an observer. This method is automatically called when
     * a `FlattenedNodesObserver` is created. It should only be called to
     * re-activate an observer that has been deactivated via the `disconnect` method.
     *
     * @return {void}
     */
    _createClass(FlattenedNodesObserver, [{
      key: "connect",
      value: function connect() {
        if (isSlot(this._target)) {
          this._listenSlots([this._target]);
        } else if (wrap(this._target).children) {
          this._listenSlots( /** @type {!NodeList<!Node>} */wrap(this._target).children);
          if (window.ShadyDOM) {
            this._shadyChildrenObserver = window.ShadyDOM.observeChildren(this._target, mutations => {
              this._processMutations(mutations);
            });
          } else {
            this._nativeChildrenObserver = new MutationObserver(mutations => {
              this._processMutations(mutations);
            });
            this._nativeChildrenObserver.observe(this._target, {
              childList: true
            });
          }
        }
        this._connected = true;
      }

      /**
       * Deactivates the flattened nodes observer. After calling this method
       * the observer callback will not be called when changes to flattened nodes
       * occur. The `connect` method may be subsequently called to reactivate
       * the observer.
       *
       * @return {void}
       * @override
       */
    }, {
      key: "disconnect",
      value: function disconnect() {
        if (isSlot(this._target)) {
          this._unlistenSlots([this._target]);
        } else if (wrap(this._target).children) {
          this._unlistenSlots( /** @type {!NodeList<!Node>} */wrap(this._target).children);
          if (window.ShadyDOM && this._shadyChildrenObserver) {
            window.ShadyDOM.unobserveChildren(this._shadyChildrenObserver);
            this._shadyChildrenObserver = null;
          } else if (this._nativeChildrenObserver) {
            this._nativeChildrenObserver.disconnect();
            this._nativeChildrenObserver = null;
          }
        }
        this._connected = false;
      }

      /**
       * @return {void}
       * @private
       */
    }, {
      key: "_schedule",
      value: function _schedule() {
        if (!this._scheduled) {
          this._scheduled = true;
          microTask.run(() => this.flush());
        }
      }

      /**
       * @param {Array<MutationRecord>} mutations Mutations signaled by the mutation observer
       * @return {void}
       * @private
       */
    }, {
      key: "_processMutations",
      value: function _processMutations(mutations) {
        this._processSlotMutations(mutations);
        this.flush();
      }

      /**
       * @param {Array<MutationRecord>} mutations Mutations signaled by the mutation observer
       * @return {void}
       * @private
       */
    }, {
      key: "_processSlotMutations",
      value: function _processSlotMutations(mutations) {
        if (mutations) {
          for (let i = 0; i < mutations.length; i++) {
            let mutation = mutations[i];
            if (mutation.addedNodes) {
              this._listenSlots(mutation.addedNodes);
            }
            if (mutation.removedNodes) {
              this._unlistenSlots(mutation.removedNodes);
            }
          }
        }
      }

      /**
       * Flushes the observer causing any pending changes to be immediately
       * delivered the observer callback. By default these changes are delivered
       * asynchronously at the next microtask checkpoint.
       *
       * @return {boolean} Returns true if any pending changes caused the observer
       * callback to run.
       */
    }, {
      key: "flush",
      value: function flush() {
        if (!this._connected) {
          return false;
        }
        if (window.ShadyDOM) {
          ShadyDOM.flush();
        }
        if (this._nativeChildrenObserver) {
          this._processSlotMutations(this._nativeChildrenObserver.takeRecords());
        } else if (this._shadyChildrenObserver) {
          this._processSlotMutations(this._shadyChildrenObserver.takeRecords());
        }
        this._scheduled = false;
        let info = {
          target: this._target,
          addedNodes: [],
          removedNodes: []
        };
        let newNodes = this.constructor.getFlattenedNodes(this._target);
        let splices = calculateSplices(newNodes, this._effectiveNodes);
        // process removals
        for (let i = 0, s; i < splices.length && (s = splices[i]); i++) {
          for (let j = 0, n; j < s.removed.length && (n = s.removed[j]); j++) {
            info.removedNodes.push(n);
          }
        }
        // process adds
        for (let i = 0, s; i < splices.length && (s = splices[i]); i++) {
          for (let j = s.index; j < s.index + s.addedCount; j++) {
            info.addedNodes.push(newNodes[j]);
          }
        }
        // update cache
        this._effectiveNodes = newNodes;
        let didFlush = false;
        if (info.addedNodes.length || info.removedNodes.length) {
          didFlush = true;
          this.callback.call(this._target, info);
        }
        return didFlush;
      }

      /**
       * @param {!Array<!Node>|!NodeList<!Node>} nodeList Nodes that could change
       * @return {void}
       * @private
       */
    }, {
      key: "_listenSlots",
      value: function _listenSlots(nodeList) {
        for (let i = 0; i < nodeList.length; i++) {
          let n = nodeList[i];
          if (isSlot(n)) {
            n.addEventListener('slotchange', this._boundSchedule);
          }
        }
      }

      /**
       * @param {!Array<!Node>|!NodeList<!Node>} nodeList Nodes that could change
       * @return {void}
       * @private
       */
    }, {
      key: "_unlistenSlots",
      value: function _unlistenSlots(nodeList) {
        for (let i = 0; i < nodeList.length; i++) {
          let n = nodeList[i];
          if (isSlot(n)) {
            n.removeEventListener('slotchange', this._boundSchedule);
          }
        }
      }
    }], [{
      key: "getFlattenedNodes",
      value:
      /**
       * Returns the list of flattened nodes for the given `node`.
       * This list consists of a node's children and, for any children
       * that are `<slot>` elements, the expanded flattened list of `assignedNodes`.
       * For example, if the observed node has children `<a></a><slot></slot><b></b>`
       * and the `<slot>` has one `<div>` assigned to it, then the flattened
       * nodes list is `<a></a><div></div><b></b>`. If the `<slot>` has other
       * `<slot>` elements assigned to it, these are flattened as well.
       *
       * @param {!HTMLElement|!HTMLSlotElement} node The node for which to
       *      return the list of flattened nodes.
       * @return {!Array<!Node>} The list of flattened nodes for the given `node`.
       * @nocollapse See https://github.com/google/closure-compiler/issues/2763
       */
      // eslint-disable-next-line
      function getFlattenedNodes(node) {
        const wrapped = wrap(node);
        if (isSlot(node)) {
          node = /** @type {!HTMLSlotElement} */node; // eslint-disable-line no-self-assign
          return wrapped.assignedNodes({
            flatten: true
          });
        } else {
          return Array.from(wrapped.childNodes).map(node => {
            if (isSlot(node)) {
              node = /** @type {!HTMLSlotElement} */node; // eslint-disable-line no-self-assign
              return wrap(node).assignedNodes({
                flatten: true
              });
            } else {
              return [node];
            }
          }).reduce((a, b) => a.concat(b), []);
        }
      }
    }]);
    return FlattenedNodesObserver;
  }();

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Forces several classes of asynchronously queued tasks to flush:
   * - Debouncers added via `enqueueDebouncer`
   * - ShadyDOM distribution
   *
   * @return {void}
   */
  const flush = function () {
    let shadyDOM, debouncers;
    do {
      shadyDOM = window.ShadyDOM && ShadyDOM.flush();
      if (window.ShadyCSS && window.ShadyCSS.ScopingShim) {
        window.ShadyCSS.ScopingShim.flush();
      }
      debouncers = flushDebouncers();
    } while (shadyDOM || debouncers);
  };

  /* eslint-enable no-unused-vars */

  const p$1 = Element.prototype;
  /**
   * @const {function(this:Node, string): boolean}
   */
  const normalizedMatchesSelector = p$1.matches || p$1.matchesSelector || p$1.mozMatchesSelector || p$1.msMatchesSelector || p$1.oMatchesSelector || p$1.webkitMatchesSelector;

  /**
   * Cross-platform `element.matches` shim.
   *
   * @function matchesSelector
   * @param {!Node} node Node to check selector against
   * @param {string} selector Selector to match
   * @return {boolean} True if node matched selector
   */
  const matchesSelector = function (node, selector) {
    return normalizedMatchesSelector.call(node, selector);
  };

  /**
   * Node API wrapper class returned from `Polymer.dom.(target)` when
   * `target` is a `Node`.
   * @implements {PolymerDomApi}
   * @unrestricted
   */
  let DomApiNative = /*#__PURE__*/function () {
    /**
     * @param {!Node} node Node for which to create a Polymer.dom helper object.
     */
    function DomApiNative(node) {
      _classCallCheck(this, DomApiNative);
      if (window['ShadyDOM'] && window['ShadyDOM']['inUse']) {
        window['ShadyDOM']['patch'](node);
      }
      this.node = node;
    }

    /**
     * Returns an instance of `FlattenedNodesObserver` that
     * listens for node changes on this element.
     *
     * @param {function(this:HTMLElement, { target: !HTMLElement, addedNodes: !Array<!Element>, removedNodes: !Array<!Element> }):void} callback Called when direct or distributed children
     *   of this element changes
     * @return {!PolymerDomApi.ObserveHandle} Observer instance
     * @override
     */
    _createClass(DomApiNative, [{
      key: "observeNodes",
      value: function observeNodes(callback) {
        return new FlattenedNodesObserver( /** @type {!HTMLElement} */this.node, callback);
      }

      /**
       * Disconnects an observer previously created via `observeNodes`
       *
       * @param {!PolymerDomApi.ObserveHandle} observerHandle Observer instance
       *   to disconnect.
       * @return {void}
       * @override
       */
    }, {
      key: "unobserveNodes",
      value: function unobserveNodes(observerHandle) {
        observerHandle.disconnect();
      }

      /**
       * Provided as a backwards-compatible API only.  This method does nothing.
       * @return {void}
       */
    }, {
      key: "notifyObserver",
      value: function notifyObserver() {}

      /**
       * Returns true if the provided node is contained with this element's
       * light-DOM children or shadow root, including any nested shadow roots
       * of children therein.
       *
       * @param {Node} node Node to test
       * @return {boolean} Returns true if the given `node` is contained within
       *   this element's light or shadow DOM.
       * @override
       */
    }, {
      key: "deepContains",
      value: function deepContains(node) {
        if (wrap(this.node).contains(node)) {
          return true;
        }
        let n = node;
        let doc = node.ownerDocument;
        // walk from node to `this` or `document`
        while (n && n !== doc && n !== this.node) {
          // use logical parentnode, or native ShadowRoot host
          n = wrap(n).parentNode || wrap(n).host;
        }
        return n === this.node;
      }

      /**
       * Returns the root node of this node.  Equivalent to `getRootNode()`.
       *
       * @return {!Node} Top most element in the dom tree in which the node
       * exists. If the node is connected to a document this is either a
       * shadowRoot or the document; otherwise, it may be the node
       * itself or a node or document fragment containing it.
       * @override
       */
    }, {
      key: "getOwnerRoot",
      value: function getOwnerRoot() {
        return wrap(this.node).getRootNode();
      }

      /**
       * For slot elements, returns the nodes assigned to the slot; otherwise
       * an empty array. It is equivalent to `<slot>.addignedNodes({flatten:true})`.
       *
       * @return {!Array<!Node>} Array of assigned nodes
       * @override
       */
    }, {
      key: "getDistributedNodes",
      value: function getDistributedNodes() {
        return this.node.localName === 'slot' ? wrap(this.node).assignedNodes({
          flatten: true
        }) : [];
      }

      /**
       * Returns an array of all slots this element was distributed to.
       *
       * @return {!Array<!HTMLSlotElement>} Description
       * @override
       */
    }, {
      key: "getDestinationInsertionPoints",
      value: function getDestinationInsertionPoints() {
        let ip$ = [];
        let n = wrap(this.node).assignedSlot;
        while (n) {
          ip$.push(n);
          n = wrap(n).assignedSlot;
        }
        return ip$;
      }

      /**
       * Calls `importNode` on the `ownerDocument` for this node.
       *
       * @param {!Node} node Node to import
       * @param {boolean} deep True if the node should be cloned deeply during
       *   import
       * @return {Node} Clone of given node imported to this owner document
       */
    }, {
      key: "importNode",
      value: function importNode(node, deep) {
        let doc = this.node instanceof Document ? this.node : this.node.ownerDocument;
        return wrap(doc).importNode(node, deep);
      }

      /**
       * @return {!Array<!Node>} Returns a flattened list of all child nodes and
       * nodes assigned to child slots.
       * @override
       */
    }, {
      key: "getEffectiveChildNodes",
      value: function getEffectiveChildNodes() {
        return FlattenedNodesObserver.getFlattenedNodes( /** @type {!HTMLElement} */this.node);
      }

      /**
       * Returns a filtered list of flattened child elements for this element based
       * on the given selector.
       *
       * @param {string} selector Selector to filter nodes against
       * @return {!Array<!HTMLElement>} List of flattened child elements
       * @override
       */
    }, {
      key: "queryDistributedElements",
      value: function queryDistributedElements(selector) {
        let c$ = this.getEffectiveChildNodes();
        let list = [];
        for (let i = 0, l = c$.length, c; i < l && (c = c$[i]); i++) {
          if (c.nodeType === Node.ELEMENT_NODE && matchesSelector(c, selector)) {
            list.push(c);
          }
        }
        return list;
      }

      /**
       * For shadow roots, returns the currently focused element within this
       * shadow root.
       *
       * return {Node|undefined} Currently focused element
       * @override
       */
    }, {
      key: "activeElement",
      get: function () {
        let node = this.node;
        return node._activeElement !== undefined ? node._activeElement : node.activeElement;
      }
    }]);
    return DomApiNative;
  }();
  function forwardMethods(proto, methods) {
    for (let i = 0; i < methods.length; i++) {
      let method = methods[i];
      /* eslint-disable valid-jsdoc */
      proto[method] = /** @this {DomApiNative} */function () {
        return this.node[method].apply(this.node, arguments);
      };
      /* eslint-enable */
    }
  }

  function forwardReadOnlyProperties(proto, properties) {
    for (let i = 0; i < properties.length; i++) {
      let name = properties[i];
      Object.defineProperty(proto, name, {
        get: function () {
          const domApi = /** @type {DomApiNative} */this;
          return domApi.node[name];
        },
        configurable: true
      });
    }
  }
  function forwardProperties(proto, properties) {
    for (let i = 0; i < properties.length; i++) {
      let name = properties[i];
      Object.defineProperty(proto, name, {
        /**
         * @this {DomApiNative}
         * @return {*} .
         */
        get: function () {
          return this.node[name];
        },
        /**
         * @this {DomApiNative}
         * @param {*} value .
         */
        set: function (value) {
          this.node[name] = value;
        },
        configurable: true
      });
    }
  }

  /**
   * Event API wrapper class returned from `dom.(target)` when
   * `target` is an `Event`.
   */
  let EventApi = /*#__PURE__*/function () {
    function EventApi(event) {
      _classCallCheck(this, EventApi);
      this.event = event;
    }

    /**
     * Returns the first node on the `composedPath` of this event.
     *
     * @return {!EventTarget} The node this event was dispatched to
     */
    _createClass(EventApi, [{
      key: "rootTarget",
      get: function () {
        return this.path[0];
      }

      /**
       * Returns the local (re-targeted) target for this event.
       *
       * @return {!EventTarget} The local (re-targeted) target for this event.
       */
    }, {
      key: "localTarget",
      get: function () {
        return this.event.target;
      }

      /**
       * Returns the `composedPath` for this event.
       * @return {!Array<!EventTarget>} The nodes this event propagated through
       */
    }, {
      key: "path",
      get: function () {
        return this.event.composedPath();
      }
    }]);
    return EventApi;
  }();

  /**
   * @function
   * @param {boolean=} deep
   * @return {!Node}
   */
  DomApiNative.prototype.cloneNode;
  /**
   * @function
   * @param {!Node} node
   * @return {!Node}
   */
  DomApiNative.prototype.appendChild;
  /**
   * @function
   * @param {!Node} newChild
   * @param {Node} refChild
   * @return {!Node}
   */
  DomApiNative.prototype.insertBefore;
  /**
   * @function
   * @param {!Node} node
   * @return {!Node}
   */
  DomApiNative.prototype.removeChild;
  /**
   * @function
   * @param {!Node} oldChild
   * @param {!Node} newChild
   * @return {!Node}
   */
  DomApiNative.prototype.replaceChild;
  /**
   * @function
   * @param {string} name
   * @param {string} value
   * @return {void}
   */
  DomApiNative.prototype.setAttribute;
  /**
   * @function
   * @param {string} name
   * @return {void}
   */
  DomApiNative.prototype.removeAttribute;
  /**
   * @function
   * @param {string} selector
   * @return {?Element}
   */
  DomApiNative.prototype.querySelector;
  /**
   * @function
   * @param {string} selector
   * @return {!NodeList<!Element>}
   */
  DomApiNative.prototype.querySelectorAll;

  /** @type {?Node} */
  DomApiNative.prototype.parentNode;
  /** @type {?Node} */
  DomApiNative.prototype.firstChild;
  /** @type {?Node} */
  DomApiNative.prototype.lastChild;
  /** @type {?Node} */
  DomApiNative.prototype.nextSibling;
  /** @type {?Node} */
  DomApiNative.prototype.previousSibling;
  /** @type {?HTMLElement} */
  DomApiNative.prototype.firstElementChild;
  /** @type {?HTMLElement} */
  DomApiNative.prototype.lastElementChild;
  /** @type {?HTMLElement} */
  DomApiNative.prototype.nextElementSibling;
  /** @type {?HTMLElement} */
  DomApiNative.prototype.previousElementSibling;
  /** @type {!Array<!Node>} */
  DomApiNative.prototype.childNodes;
  /** @type {!Array<!HTMLElement>} */
  DomApiNative.prototype.children;
  /** @type {?DOMTokenList} */
  DomApiNative.prototype.classList;

  /** @type {string} */
  DomApiNative.prototype.textContent;
  /** @type {string} */
  DomApiNative.prototype.innerHTML;
  let DomApiImpl = DomApiNative;
  if (window['ShadyDOM'] && window['ShadyDOM']['inUse'] && window['ShadyDOM']['noPatch'] && window['ShadyDOM']['Wrapper']) {
    /**
     * @private
     * @extends {HTMLElement}
     */let Wrapper = /*#__PURE__*/function (_window$ShadyDOM$Wrap) {
      _inherits(Wrapper, _window$ShadyDOM$Wrap);
      var _super = _createSuper(Wrapper);
      function Wrapper() {
        _classCallCheck(this, Wrapper);
        return _super.apply(this, arguments);
      }
      return _createClass(Wrapper);
    }(window['ShadyDOM']['Wrapper']); // copy bespoke API onto wrapper
    Object.getOwnPropertyNames(DomApiNative.prototype).forEach(prop => {
      if (prop != 'activeElement') {
        Wrapper.prototype[prop] = DomApiNative.prototype[prop];
      }
    });

    // Note, `classList` is here only for legacy compatibility since it does not
    // trigger distribution in v1 Shadow DOM.
    forwardReadOnlyProperties(Wrapper.prototype, ['classList']);
    DomApiImpl = Wrapper;
    Object.defineProperties(EventApi.prototype, {
      // Returns the "lowest" node in the same root as the event's currentTarget.
      // When in `noPatch` mode, this must be calculated by walking the event's
      // path.
      localTarget: {
        get() {
          const current = this.event.currentTarget;
          const currentRoot = current && dom(current).getOwnerRoot();
          const p$ = this.path;
          for (let i = 0; i < p$.length; i++) {
            const e = p$[i];
            if (dom(e).getOwnerRoot() === currentRoot) {
              return e;
            }
          }
        },
        configurable: true
      },
      path: {
        get() {
          return window['ShadyDOM']['composedPath'](this.event);
        },
        configurable: true
      }
    });
  } else {
    // Methods that can provoke distribution or must return the logical, not
    // composed tree.
    forwardMethods(DomApiNative.prototype, ['cloneNode', 'appendChild', 'insertBefore', 'removeChild', 'replaceChild', 'setAttribute', 'removeAttribute', 'querySelector', 'querySelectorAll', 'attachShadow']);

    // Properties that should return the logical, not composed tree. Note, `classList`
    // is here only for legacy compatibility since it does not trigger distribution
    // in v1 Shadow DOM.
    forwardReadOnlyProperties(DomApiNative.prototype, ['parentNode', 'firstChild', 'lastChild', 'nextSibling', 'previousSibling', 'firstElementChild', 'lastElementChild', 'nextElementSibling', 'previousElementSibling', 'childNodes', 'children', 'classList', 'shadowRoot']);
    forwardProperties(DomApiNative.prototype, ['textContent', 'innerHTML', 'className']);
  }

  /**
   * Legacy DOM and Event manipulation API wrapper factory used to abstract
   * differences between native Shadow DOM and "Shady DOM" when polyfilling on
   * older browsers.
   *
   * Note that in Polymer 2.x use of `Polymer.dom` is no longer required and
   * in the majority of cases simply facades directly to the standard native
   * API.
   *
   * @summary Legacy DOM and Event manipulation API wrapper factory used to
   * abstract differences between native Shadow DOM and "Shady DOM."
   * @param {(Node|Event|DomApiNative|EventApi)=} obj Node or event to operate on
   * @return {!DomApiNative|!EventApi} Wrapper providing either node API or event API
   */
  const dom = function (obj) {
    obj = obj || document;
    if (obj instanceof DomApiImpl) {
      return (/** @type {!DomApi} */obj
      );
    }
    if (obj instanceof EventApi) {
      return (/** @type {!EventApi} */obj
      );
    }
    let helper = obj['__domApi'];
    if (!helper) {
      if (obj instanceof Event) {
        helper = new EventApi(obj);
      } else {
        helper = new DomApiImpl( /** @type {Node} */obj);
      }
      obj['__domApi'] = helper;
    }
    return helper;
  };

  /**
  @license
  Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  const ShadyDOM$1 = window.ShadyDOM;
  const ShadyCSS = window.ShadyCSS;

  /**
   * Return true if node scope is correct.
   *
   * @param {!Element} node Node to check scope
   * @param {!Node} scope Scope reference
   * @return {boolean} True if node is in scope
   */
  function sameScope(node, scope) {
    return wrap(node).getRootNode() === scope;
  }

  /**
   * Ensure that elements in a ShadowDOM container are scoped correctly.
   * This function is only needed when ShadyDOM is used and unpatched DOM APIs are used in third party code.
   * This can happen in noPatch mode or when specialized APIs like ranges or tables are used to mutate DOM.
   *
   * @param  {!Element} container Container element to scope
   * @param  {boolean=} shouldObserve if true, start a mutation observer for added nodes to the container
   * @return {?MutationObserver} Returns a new MutationObserver on `container` if `shouldObserve` is true.
   */
  function scopeSubtree(container) {
    let shouldObserve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    // If using native ShadowDOM, abort
    if (!ShadyDOM$1 || !ShadyCSS) {
      return null;
    }
    // ShadyCSS handles DOM mutations when ShadyDOM does not handle scoping itself
    if (!ShadyDOM$1['handlesDynamicScoping']) {
      return null;
    }
    const ScopingShim = ShadyCSS['ScopingShim'];
    // if ScopingShim is not available, abort
    if (!ScopingShim) {
      return null;
    }
    // capture correct scope for container
    const containerScope = ScopingShim['scopeForNode'](container);
    const root = wrap(container).getRootNode();
    const scopify = node => {
      if (!sameScope(node, root)) {
        return;
      }
      // NOTE: native qSA does not honor scoped DOM, but it is faster, and the same behavior as Polymer v1
      const elements = Array.from(ShadyDOM$1['nativeMethods']['querySelectorAll'].call(node, '*'));
      elements.push(node);
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (!sameScope(el, root)) {
          continue;
        }
        const currentScope = ScopingShim['currentScopeForNode'](el);
        if (currentScope !== containerScope) {
          if (currentScope !== '') {
            ScopingShim['unscopeNode'](el, currentScope);
          }
          ScopingShim['scopeNode'](el, containerScope);
        }
      }
    };

    // scope everything in container
    scopify(container);
    if (shouldObserve) {
      const mo = new MutationObserver(mxns => {
        for (let i = 0; i < mxns.length; i++) {
          const mxn = mxns[i];
          for (let j = 0; j < mxn.addedNodes.length; j++) {
            const addedNode = mxn.addedNodes[j];
            if (addedNode.nodeType === Node.ELEMENT_NODE) {
              scopify(addedNode);
            }
          }
        }
      });
      mo.observe(container, {
        childList: true,
        subtree: true
      });
      return mo;
    } else {
      return null;
    }
  }

  const DISABLED_ATTR$1 = 'disable-upgrade';
  const findObservedAttributesGetter = ctor => {
    while (ctor) {
      const desc = Object.getOwnPropertyDescriptor(ctor, 'observedAttributes');
      if (desc) {
        return desc.get;
      }
      ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return () => [];
  };

  /**
   * Element class mixin that allows the element to boot up in a non-enabled
   * state when the `disable-upgrade` attribute is present. This mixin is
   * designed to be used with element classes like PolymerElement that perform
   * initial startup work when they are first connected. When the
   * `disable-upgrade` attribute is removed, if the element is connected, it
   * boots up and "enables" as it otherwise would; if it is not connected, the
   * element boots up when it is next connected.
   *
   * Using `disable-upgrade` with PolymerElement prevents any data propagation
   * to the element, any element DOM from stamping, or any work done in
   * connected/disconnctedCallback from occuring, but it does not prevent work
   * done in the element constructor.
   *
   * Note, this mixin must be applied on top of any element class that
   * itself implements a `connectedCallback` so that it can control the work
   * done in `connectedCallback`. For example,
   *
   *     MyClass = DisableUpgradeMixin(class extends BaseClass {...});
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin ElementMixin
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  dedupingMixin(base => {
    /**
     * @constructor
     * @implements {Polymer_ElementMixin}
     * @extends {HTMLElement}
     * @private
     */
    const superClass = ElementMixin(base);

    // Work around for closure bug #126934458. Using `super` in a property
    // getter does not work so instead we search the Base prototype for an
    // implementation of observedAttributes so that we can override and call
    // the `super` getter. Note, this is done one time ever because we assume
    // that `Base` is always comes from `Polymer.LegacyElementMixn`.
    let observedAttributesGetter = findObservedAttributesGetter(superClass);

    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_DisableUpgradeMixin}
     */
    let DisableUpgradeClass = /*#__PURE__*/function (_superClass) {
      _inherits(DisableUpgradeClass, _superClass);
      var _super = _createSuper(DisableUpgradeClass);
      function DisableUpgradeClass() {
        var _this;
        _classCallCheck(this, DisableUpgradeClass);
        _this = _super.call(this);
        /** @type {boolean|undefined} */
        _this.__isUpgradeDisabled;
        return _this;
      }
      _createClass(DisableUpgradeClass, [{
        key: "_initializeProperties",
        value:
        // Prevent element from initializing properties when it's upgrade disabled.
        /** @override */
        function _initializeProperties() {
          if (this.hasAttribute(DISABLED_ATTR$1)) {
            this.__isUpgradeDisabled = true;
          } else {
            _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_initializeProperties", this).call(this);
          }
        }

        // Prevent element from enabling properties when it's upgrade disabled.
        // Normally overriding connectedCallback would be enough, but dom-* elements
        /** @override */
      }, {
        key: "_enableProperties",
        value: function _enableProperties() {
          if (!this.__isUpgradeDisabled) {
            _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_enableProperties", this).call(this);
          }
        }

        // If the element starts upgrade-disabled and a property is set for
        // which an accessor exists, the default should not be applied.
        // This additional check is needed because defaults are applied via
        // `_initializeProperties` which is called after initial properties
        // have been set when the element starts upgrade-disabled.
        /** @override */
      }, {
        key: "_canApplyPropertyDefault",
        value: function _canApplyPropertyDefault(property) {
          return _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_canApplyPropertyDefault", this).call(this, property) && !(this.__isUpgradeDisabled && this._isPropertyPending(property));
        }

        /**
         * @override
         * @param {string} name Attribute name.
         * @param {?string} old The previous value for the attribute.
         * @param {?string} value The new value for the attribute.
         * @param {?string} namespace The XML namespace for the attribute.
         * @return {void}
         */
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, old, value, namespace) {
          if (name == DISABLED_ATTR$1) {
            // When disable-upgrade is removed, initialize properties and
            // provoke connectedCallback if the element is already connected.
            if (this.__isUpgradeDisabled && value == null) {
              _get(_getPrototypeOf(DisableUpgradeClass.prototype), "_initializeProperties", this).call(this);
              this.__isUpgradeDisabled = false;
              if (wrap(this).isConnected) {
                _get(_getPrototypeOf(DisableUpgradeClass.prototype), "connectedCallback", this).call(this);
              }
            }
          } else {
            _get(_getPrototypeOf(DisableUpgradeClass.prototype), "attributeChangedCallback", this).call(this, name, old, value, /** @type {null|string} */namespace);
          }
        }

        // Prevent element from connecting when it's upgrade disabled.
        // This prevents user code in `attached` from being called.
        /** @override */
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          if (!this.__isUpgradeDisabled) {
            _get(_getPrototypeOf(DisableUpgradeClass.prototype), "connectedCallback", this).call(this);
          }
        }

        // Prevent element from disconnecting when it's upgrade disabled.
        // This avoids allowing user code `detached` from being called without a
        // paired call to `attached`.
        /** @override */
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          if (!this.__isUpgradeDisabled) {
            _get(_getPrototypeOf(DisableUpgradeClass.prototype), "disconnectedCallback", this).call(this);
          }
        }
      }], [{
        key: "observedAttributes",
        get: function () {
          return observedAttributesGetter.call(this).concat(DISABLED_ATTR$1);
        }
      }]);
      return DisableUpgradeClass;
    }(superClass);
    return DisableUpgradeClass;
  });

  const DISABLED_ATTR = 'disable-upgrade';
  let styleInterface = window.ShadyCSS;

  /**
   * Element class mixin that provides Polymer's "legacy" API intended to be
   * backward-compatible to the greatest extent possible with the API
   * found on the Polymer 1.x `Polymer.Base` prototype applied to all elements
   * defined using the `Polymer({...})` function.
   *
   * @mixinFunction
   * @polymer
   * @appliesMixin ElementMixin
   * @appliesMixin GestureEventListeners
   * @appliesMixin DirMixin
   * @property isAttached {boolean} Set to `true` in this element's
   *   `connectedCallback` and `false` in `disconnectedCallback`
   * @summary Element class mixin that provides Polymer's "legacy" API
   */
  const LegacyElementMixin = dedupingMixin(base => {
    // TODO(kschaaf): Note, the `@implements {Polymer_DirMixin}` is required here
    // (rather than on legacyElementBase) for unknown reasons.
    /**
     * @constructor
     * @implements {Polymer_ElementMixin}
     * @implements {Polymer_GestureEventListeners}
     * @implements {Polymer_DirMixin}
     * @extends {HTMLElement}
     * @private
     */
    const GesturesElement = GestureEventListeners(ElementMixin(base));

    // Note, the DirMixin does nothing if css is built so avoid including it
    // in that case.

    /**
     * @constructor
     * @extends {GesturesElement}
     * @private
     */
    const legacyElementBase = builtCSS ? GesturesElement : DirMixin(GesturesElement);
    const observedAttributesGetter = findObservedAttributesGetter(legacyElementBase);

    /**
     * Map of simple names to touch action names
     * @dict
     */
    const DIRECTION_MAP = {
      'x': 'pan-x',
      'y': 'pan-y',
      'none': 'none',
      'all': 'auto'
    };

    /**
     * @polymer
     * @mixinClass
     * @extends {legacyElementBase}
     * @implements {Polymer_LegacyElementMixin}
     * @unrestricted
     */
    let LegacyElement = /*#__PURE__*/function (_legacyElementBase) {
      _inherits(LegacyElement, _legacyElementBase);
      var _super = _createSuper(LegacyElement);
      function LegacyElement() {
        var _this;
        _classCallCheck(this, LegacyElement);
        _this = _super.call(this);
        /** @type {boolean} */
        _this.isAttached;
        /** @type {?WeakMap<!Element, !Object<string, !Function>>} */
        _this.__boundListeners;
        /** @type {?Object<string, ?Function>} */
        _this._debouncers;
        // NOTE: Inlined for perf from version of DisableUpgradeMixin.
        /** @type {boolean|undefined} */
        _this.__isUpgradeDisabled;
        /** @type {boolean|undefined} */
        _this.__needsAttributesAtConnected;
        /** @type {boolean|undefined} */
        _this._legacyForceObservedAttributes;
        return _this;
      }

      /**
       * Forwards `importMeta` from the prototype (i.e. from the info object
       * passed to `Polymer({...})`) to the static API.
       *
       * @return {!Object} The `import.meta` object set on the prototype
       * @suppress {missingProperties} `this` is always in the instance in
       *  closure for some reason even in a static method, rather than the class
       * @nocollapse
       */
      _createClass(LegacyElement, [{
        key: "created",
        value:
        /**
         * Legacy callback called during the `constructor`, for overriding
         * by the user.
         * @override
         * @return {void}
         */
        function created() {}

        /**
         * Processes an attribute reaction when the `legacyNoObservedAttributes`
         * setting is in use.
         * @param {string} name Name of attribute that changed
         * @param {?string} old Old attribute value
         * @param {?string} value New attribute value
         * @return {void}
         */
      }, {
        key: "__attributeReaction",
        value: function __attributeReaction(name, old, value) {
          if (this.__dataAttributes && this.__dataAttributes[name] || name === DISABLED_ATTR) {
            this.attributeChangedCallback(name, old, value, null);
          }
        }

        /**
         * Sets the value of an attribute.
         * @override
         */
      }, {
        key: "setAttribute",
        value: function setAttribute(name, value) {
          if (legacyNoObservedAttributes && !this._legacyForceObservedAttributes) {
            const oldValue = this.getAttribute(name);
            _get(_getPrototypeOf(LegacyElement.prototype), "setAttribute", this).call(this, name, value);
            // value coerced to String for closure's benefit
            this.__attributeReaction(name, oldValue, String(value));
          } else {
            _get(_getPrototypeOf(LegacyElement.prototype), "setAttribute", this).call(this, name, value);
          }
        }

        /**
         * Removes an attribute.
         * @override
         */
      }, {
        key: "removeAttribute",
        value: function removeAttribute(name) {
          if (legacyNoObservedAttributes && !this._legacyForceObservedAttributes) {
            const oldValue = this.getAttribute(name);
            _get(_getPrototypeOf(LegacyElement.prototype), "removeAttribute", this).call(this, name);
            this.__attributeReaction(name, oldValue, null);
          } else {
            _get(_getPrototypeOf(LegacyElement.prototype), "removeAttribute", this).call(this, name);
          }
        }

        // NOTE: Inlined for perf from version of DisableUpgradeMixin.
      }, {
        key: "_enableProperties",
        value:
        // NOTE: Inlined for perf from version of DisableUpgradeMixin.
        // Prevent element from enabling properties when it's upgrade disabled.
        // Normally overriding connectedCallback would be enough, but dom-* elements
        /** @override */
        function _enableProperties() {
          if (!this.__isUpgradeDisabled) {
            _get(_getPrototypeOf(LegacyElement.prototype), "_enableProperties", this).call(this);
          }
        }

        // NOTE: Inlined for perf from version of DisableUpgradeMixin.
        // If the element starts upgrade-disabled and a property is set for
        // which an accessor exists, the default should not be applied.
        // This additional check is needed because defaults are applied via
        // `_initializeProperties` which is called after initial properties
        // have been set when the element starts upgrade-disabled.
        /** @override */
      }, {
        key: "_canApplyPropertyDefault",
        value: function _canApplyPropertyDefault(property) {
          return _get(_getPrototypeOf(LegacyElement.prototype), "_canApplyPropertyDefault", this).call(this, property) && !(this.__isUpgradeDisabled && this._isPropertyPending(property));
        }

        /**
         * Provides an implementation of `connectedCallback`
         * which adds Polymer legacy API's `attached` method.
         * @return {void}
         * @override
         */
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          if (this.__needsAttributesAtConnected) {
            this._takeAttributes();
          }
          // NOTE: Inlined for perf from version of DisableUpgradeMixin.
          if (!this.__isUpgradeDisabled) {
            _get(_getPrototypeOf(LegacyElement.prototype), "connectedCallback", this).call(this);
            this.isAttached = true;
            this.attached();
          }
        }

        /**
         * Legacy callback called during `connectedCallback`, for overriding
         * by the user.
         * @override
         * @return {void}
         */
      }, {
        key: "attached",
        value: function attached() {}

        /**
         * Provides an implementation of `disconnectedCallback`
         * which adds Polymer legacy API's `detached` method.
         * @return {void}
         * @override
         */
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          // NOTE: Inlined for perf from version of DisableUpgradeMixin.
          if (!this.__isUpgradeDisabled) {
            _get(_getPrototypeOf(LegacyElement.prototype), "disconnectedCallback", this).call(this);
            this.isAttached = false;
            this.detached();
          }
        }

        /**
         * Legacy callback called during `disconnectedCallback`, for overriding
         * by the user.
         * @override
         * @return {void}
         */
      }, {
        key: "detached",
        value: function detached() {}

        /**
         * Provides an override implementation of `attributeChangedCallback`
         * which adds the Polymer legacy API's `attributeChanged` method.
         * @param {string} name Name of attribute.
         * @param {?string} old Old value of attribute.
         * @param {?string} value Current value of attribute.
         * @param {?string} namespace Attribute namespace.
         * @return {void}
         * @override
         */
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, old, value, namespace) {
          if (old !== value) {
            // NOTE: Inlined for perf from version of DisableUpgradeMixin.
            if (name == DISABLED_ATTR) {
              // When disable-upgrade is removed, intialize properties and
              // provoke connectedCallback if the element is already connected.
              if (this.__isUpgradeDisabled && value == null) {
                this._initializeProperties();
                this.__isUpgradeDisabled = false;
                if (wrap(this).isConnected) {
                  this.connectedCallback();
                }
              }
            } else {
              _get(_getPrototypeOf(LegacyElement.prototype), "attributeChangedCallback", this).call(this, name, old, value, namespace);
              this.attributeChanged(name, old, value);
            }
          }
        }

        /**
         * Legacy callback called during `attributeChangedChallback`, for overriding
         * by the user.
         * @param {string} name Name of attribute.
         * @param {?string} old Old value of attribute.
         * @param {?string} value Current value of attribute.
         * @return {void}
         * @override
         */
      }, {
        key: "attributeChanged",
        value: function attributeChanged(name, old, value) {} // eslint-disable-line no-unused-vars

        /**
         * Overrides the default `Polymer.PropertyEffects` implementation to
         * add support for class initialization via the `_registered` callback.
         * This is called only when the first instance of the element is created.
         *
         * @return {void}
         * @override
         * @suppress {invalidCasts}
         */
      }, {
        key: "_initializeProperties",
        value: function _initializeProperties() {
          // NOTE: Inlined for perf from version of DisableUpgradeMixin.
          // Only auto-use disable-upgrade if legacyOptimizations is set.
          if (legacyOptimizations && this.hasAttribute(DISABLED_ATTR)) {
            this.__isUpgradeDisabled = true;
          } else {
            let proto = Object.getPrototypeOf(this);
            if (!proto.hasOwnProperty(JSCompiler_renameProperty('__hasRegisterFinished', proto))) {
              this._registered();
              // backstop in case the `_registered` implementation does not set this
              proto.__hasRegisterFinished = true;
            }
            _get(_getPrototypeOf(LegacyElement.prototype), "_initializeProperties", this).call(this);
            this.root = /** @type {HTMLElement} */this;
            this.created();
            // Pull all attribute values 1x if `legacyNoObservedAttributes` is set.
            if (legacyNoObservedAttributes && !this._legacyForceObservedAttributes) {
              if (this.hasAttributes()) {
                this._takeAttributes();
                // Element created from scratch or parser generated
              } else if (!this.parentNode) {
                this.__needsAttributesAtConnected = true;
              }
            }
            // Ensure listeners are applied immediately so that they are
            // added before declarative event listeners. This allows an element to
            // decorate itself via an event prior to any declarative listeners
            // seeing the event. Note, this ensures compatibility with 1.x ordering.
            this._applyListeners();
          }
        }
      }, {
        key: "_takeAttributes",
        value: function _takeAttributes() {
          const a = this.attributes;
          for (let i = 0, l = a.length; i < l; i++) {
            const attr = a[i];
            this.__attributeReaction(attr.name, null, attr.value);
          }
        }

        /**
         * Called automatically when an element is initializing.
         * Users may override this method to perform class registration time
         * work. The implementation should ensure the work is performed
         * only once for the class.
         * @protected
         * @return {void}
         * @override
         */
      }, {
        key: "_registered",
        value: function _registered() {}

        /**
         * Overrides the default `Polymer.PropertyEffects` implementation to
         * add support for installing `hostAttributes` and `listeners`.
         *
         * @return {void}
         * @override
         */
      }, {
        key: "ready",
        value: function ready() {
          this._ensureAttributes();
          _get(_getPrototypeOf(LegacyElement.prototype), "ready", this).call(this);
        }

        /**
         * Ensures an element has required attributes. Called when the element
         * is being readied via `ready`. Users should override to set the
         * element's required attributes. The implementation should be sure
         * to check and not override existing attributes added by
         * the user of the element. Typically, setting attributes should be left
         * to the element user and not done here; reasonable exceptions include
         * setting aria roles and focusability.
         * @protected
         * @return {void}
         * @override
         */
      }, {
        key: "_ensureAttributes",
        value: function _ensureAttributes() {}

        /**
         * Adds element event listeners. Called when the element
         * is being readied via `ready`. Users should override to
         * add any required element event listeners.
         * In performance critical elements, the work done here should be kept
         * to a minimum since it is done before the element is rendered. In
         * these elements, consider adding listeners asynchronously so as not to
         * block render.
         * @protected
         * @return {void}
         * @override
         */
      }, {
        key: "_applyListeners",
        value: function _applyListeners() {}

        /**
         * Converts a typed JavaScript value to a string.
         *
         * Note this method is provided as backward-compatible legacy API
         * only.  It is not directly called by any Polymer features. To customize
         * how properties are serialized to attributes for attribute bindings and
         * `reflectToAttribute: true` properties as well as this method, override
         * the `_serializeValue` method provided by `Polymer.PropertyAccessors`.
         *
         * @param {*} value Value to deserialize
         * @return {string | undefined} Serialized value
         * @override
         */
      }, {
        key: "serialize",
        value: function serialize(value) {
          return this._serializeValue(value);
        }

        /**
         * Converts a string to a typed JavaScript value.
         *
         * Note this method is provided as backward-compatible legacy API
         * only.  It is not directly called by any Polymer features.  To customize
         * how attributes are deserialized to properties for in
         * `attributeChangedCallback`, override `_deserializeValue` method
         * provided by `Polymer.PropertyAccessors`.
         *
         * @param {string} value String to deserialize
         * @param {*} type Type to deserialize the string to
         * @return {*} Returns the deserialized value in the `type` given.
         * @override
         */
      }, {
        key: "deserialize",
        value: function deserialize(value, type) {
          return this._deserializeValue(value, type);
        }

        /**
         * Serializes a property to its associated attribute.
         *
         * Note this method is provided as backward-compatible legacy API
         * only.  It is not directly called by any Polymer features.
         *
         * @param {string} property Property name to reflect.
         * @param {string=} attribute Attribute name to reflect.
         * @param {*=} value Property value to reflect.
         * @return {void}
         * @override
         */
      }, {
        key: "reflectPropertyToAttribute",
        value: function reflectPropertyToAttribute(property, attribute, value) {
          this._propertyToAttribute(property, attribute, value);
        }

        /**
         * Sets a typed value to an HTML attribute on a node.
         *
         * Note this method is provided as backward-compatible legacy API
         * only.  It is not directly called by any Polymer features.
         *
         * @param {*} value Value to serialize.
         * @param {string} attribute Attribute name to serialize to.
         * @param {Element} node Element to set attribute to.
         * @return {void}
         * @override
         */
      }, {
        key: "serializeValueToAttribute",
        value: function serializeValueToAttribute(value, attribute, node) {
          this._valueToNodeAttribute( /** @type {Element} */node || this, value, attribute);
        }

        /**
         * Copies own properties (including accessor descriptors) from a source
         * object to a target object.
         *
         * @param {Object} prototype Target object to copy properties to.
         * @param {Object} api Source object to copy properties from.
         * @return {Object} prototype object that was passed as first argument.
         * @override
         */
      }, {
        key: "extend",
        value: function extend(prototype, api) {
          if (!(prototype && api)) {
            return prototype || api;
          }
          let n$ = Object.getOwnPropertyNames(api);
          for (let i = 0, n; i < n$.length && (n = n$[i]); i++) {
            let pd = Object.getOwnPropertyDescriptor(api, n);
            if (pd) {
              Object.defineProperty(prototype, n, pd);
            }
          }
          return prototype;
        }

        /**
         * Copies props from a source object to a target object.
         *
         * Note, this method uses a simple `for...in` strategy for enumerating
         * properties.  To ensure only `ownProperties` are copied from source
         * to target and that accessor implementations are copied, use `extend`.
         *
         * @param {!Object} target Target object to copy properties to.
         * @param {!Object} source Source object to copy properties from.
         * @return {!Object} Target object that was passed as first argument.
         * @override
         */
      }, {
        key: "mixin",
        value: function mixin(target, source) {
          for (let i in source) {
            target[i] = source[i];
          }
          return target;
        }

        /**
         * Sets the prototype of an object.
         *
         * Note this method is provided as backward-compatible legacy API
         * only.  It is not directly called by any Polymer features.
         * @param {Object} object The object on which to set the prototype.
         * @param {Object} prototype The prototype that will be set on the given
         * `object`.
         * @return {Object} Returns the given `object` with its prototype set
         * to the given `prototype` object.
         * @override
         */
      }, {
        key: "chainObject",
        value: function chainObject(object, prototype) {
          if (object && prototype && object !== prototype) {
            object.__proto__ = prototype;
          }
          return object;
        }

        /* **** Begin Template **** */

        /**
         * Calls `importNode` on the `content` of the `template` specified and
         * returns a document fragment containing the imported content.
         *
         * @param {HTMLTemplateElement} template HTML template element to instance.
         * @return {!DocumentFragment} Document fragment containing the imported
         *   template content.
         * @override
         * @suppress {missingProperties} go/missingfnprops
         */
      }, {
        key: "instanceTemplate",
        value: function instanceTemplate(template) {
          let content = this.constructor._contentForTemplate(template);
          let dom = /** @type {!DocumentFragment} */
          document.importNode(content, true);
          return dom;
        }

        /* **** Begin Events **** */

        /**
         * Dispatches a custom event with an optional detail value.
         *
         * @param {string} type Name of event type.
         * @param {*=} detail Detail value containing event-specific
         *   payload.
         * @param {{ bubbles: (boolean|undefined), cancelable: (boolean|undefined),
         *     composed: (boolean|undefined) }=}
         *  options Object specifying options.  These may include:
         *  `bubbles` (boolean, defaults to `true`),
         *  `cancelable` (boolean, defaults to false), and
         *  `node` on which to fire the event (HTMLElement, defaults to `this`).
         * @return {!Event} The new event that was fired.
         * @override
         */
      }, {
        key: "fire",
        value: function fire(type, detail, options) {
          options = options || {};
          detail = detail === null || detail === undefined ? {} : detail;
          let event = new Event(type, {
            bubbles: options.bubbles === undefined ? true : options.bubbles,
            cancelable: Boolean(options.cancelable),
            composed: options.composed === undefined ? true : options.composed
          });
          event.detail = detail;
          let node = options.node || this;
          wrap(node).dispatchEvent(event);
          return event;
        }

        /**
         * Convenience method to add an event listener on a given element,
         * late bound to a named method on this element.
         *
         * @param {?EventTarget} node Element to add event listener to.
         * @param {string} eventName Name of event to listen for.
         * @param {string} methodName Name of handler method on `this` to call.
         * @return {void}
         * @override
         */
      }, {
        key: "listen",
        value: function listen(node, eventName, methodName) {
          node = /** @type {!EventTarget} */node || this;
          let hbl = this.__boundListeners || (this.__boundListeners = new WeakMap());
          let bl = hbl.get(node);
          if (!bl) {
            bl = {};
            hbl.set(node, bl);
          }
          let key = eventName + methodName;
          if (!bl[key]) {
            bl[key] = this._addMethodEventListenerToNode( /** @type {!Node} */node, eventName, methodName, this);
          }
        }

        /**
         * Convenience method to remove an event listener from a given element,
         * late bound to a named method on this element.
         *
         * @param {?EventTarget} node Element to remove event listener from.
         * @param {string} eventName Name of event to stop listening to.
         * @param {string} methodName Name of handler method on `this` to not call
         anymore.
         * @return {void}
         * @override
         */
      }, {
        key: "unlisten",
        value: function unlisten(node, eventName, methodName) {
          node = /** @type {!EventTarget} */node || this;
          let bl = this.__boundListeners && this.__boundListeners.get( /** @type {!Element} */node);
          let key = eventName + methodName;
          let handler = bl && bl[key];
          if (handler) {
            this._removeEventListenerFromNode( /** @type {!Node} */node, eventName, handler);
            bl[key] = /** @type {?} */null;
          }
        }

        /**
         * Override scrolling behavior to all direction, one direction, or none.
         *
         * Valid scroll directions:
         *   - 'all': scroll in any direction
         *   - 'x': scroll only in the 'x' direction
         *   - 'y': scroll only in the 'y' direction
         *   - 'none': disable scrolling for this node
         *
         * @param {string=} direction Direction to allow scrolling
         * Defaults to `all`.
         * @param {Element=} node Element to apply scroll direction setting.
         * Defaults to `this`.
         * @return {void}
         * @override
         */
      }, {
        key: "setScrollDirection",
        value: function setScrollDirection(direction, node) {
          setTouchAction( /** @type {!Element} */node || this, DIRECTION_MAP[direction] || 'auto');
        }
        /* **** End Events **** */

        /**
         * Convenience method to run `querySelector` on this local DOM scope.
         *
         * This function calls `Polymer.dom(this.root).querySelector(slctr)`.
         *
         * @param {string} slctr Selector to run on this local DOM scope
         * @return {Element} Element found by the selector, or null if not found.
         * @override
         */
      }, {
        key: "$$",
        value: function $$(slctr) {
          // Note, no need to `wrap` this because root is always patched
          return this.root.querySelector(slctr);
        }

        /**
         * Return the element whose local dom within which this element
         * is contained. This is a shorthand for
         * `this.getRootNode().host`.
         * @this {Element}
         * @return {?Node} The element whose local dom within which this element is
         * contained.
         * @override
         */
      }, {
        key: "domHost",
        get: function () {
          let root = wrap(this).getRootNode();
          return root instanceof DocumentFragment ? /** @type {ShadowRoot} */root.host : root;
        }

        /**
         * Force this element to distribute its children to its local dom.
         * This should not be necessary as of Polymer 2.0.2 and is provided only
         * for backwards compatibility.
         * @return {void}
         * @override
         */
      }, {
        key: "distributeContent",
        value: function distributeContent() {
          const thisEl = /** @type {Element} */this;
          const domApi = /** @type {PolymerDomApi} */dom(thisEl);
          if (window.ShadyDOM && domApi.shadowRoot) {
            ShadyDOM.flush();
          }
        }

        /**
         * Returns a list of nodes that are the effective childNodes. The effective
         * childNodes list is the same as the element's childNodes except that
         * any `<content>` elements are replaced with the list of nodes distributed
         * to the `<content>`, the result of its `getDistributedNodes` method.
         * @return {!Array<!Node>} List of effective child nodes.
         * @suppress {invalidCasts} LegacyElementMixin must be applied to an
         *     HTMLElement
         * @override
         */
      }, {
        key: "getEffectiveChildNodes",
        value: function getEffectiveChildNodes() {
          const thisEl = /** @type {Element} */this;
          const domApi = /** @type {PolymerDomApi} */dom(thisEl);
          return domApi.getEffectiveChildNodes();
        }

        /**
         * Returns a list of nodes distributed within this element that match
         * `selector`. These can be dom children or elements distributed to
         * children that are insertion points.
         * @param {string} selector Selector to run.
         * @return {!Array<!Node>} List of distributed elements that match selector.
         * @suppress {invalidCasts} LegacyElementMixin must be applied to an
         * HTMLElement
         * @override
         */
      }, {
        key: "queryDistributedElements",
        value: function queryDistributedElements(selector) {
          const thisEl = /** @type {Element} */this;
          const domApi = /** @type {PolymerDomApi} */dom(thisEl);
          return domApi.queryDistributedElements(selector);
        }

        /**
         * Returns a list of elements that are the effective children. The effective
         * children list is the same as the element's children except that
         * any `<content>` elements are replaced with the list of elements
         * distributed to the `<content>`.
         *
         * @return {!Array<!Node>} List of effective children.
         * @override
         */
      }, {
        key: "getEffectiveChildren",
        value: function getEffectiveChildren() {
          let list = this.getEffectiveChildNodes();
          return list.filter(function ( /** @type {!Node} */n) {
            return n.nodeType === Node.ELEMENT_NODE;
          });
        }

        /**
         * Returns a string of text content that is the concatenation of the
         * text content's of the element's effective childNodes (the elements
         * returned by <a href="#getEffectiveChildNodes>getEffectiveChildNodes</a>.
         *
         * @return {string} List of effective children.
         * @override
         */
      }, {
        key: "getEffectiveTextContent",
        value: function getEffectiveTextContent() {
          let cn = this.getEffectiveChildNodes();
          let tc = [];
          for (let i = 0, c; c = cn[i]; i++) {
            if (c.nodeType !== Node.COMMENT_NODE) {
              tc.push(c.textContent);
            }
          }
          return tc.join('');
        }

        /**
         * Returns the first effective childNode within this element that
         * match `selector`. These can be dom child nodes or elements distributed
         * to children that are insertion points.
         * @param {string} selector Selector to run.
         * @return {Node} First effective child node that matches selector.
         * @override
         */
      }, {
        key: "queryEffectiveChildren",
        value: function queryEffectiveChildren(selector) {
          let e$ = this.queryDistributedElements(selector);
          return e$ && e$[0];
        }

        /**
         * Returns a list of effective childNodes within this element that
         * match `selector`. These can be dom child nodes or elements distributed
         * to children that are insertion points.
         * @param {string} selector Selector to run.
         * @return {!Array<!Node>} List of effective child nodes that match
         *     selector.
         * @override
         */
      }, {
        key: "queryAllEffectiveChildren",
        value: function queryAllEffectiveChildren(selector) {
          return this.queryDistributedElements(selector);
        }

        /**
         * Returns a list of nodes distributed to this element's `<slot>`.
         *
         * If this element contains more than one `<slot>` in its local DOM,
         * an optional selector may be passed to choose the desired content.
         *
         * @param {string=} slctr CSS selector to choose the desired
         *   `<slot>`.  Defaults to `content`.
         * @return {!Array<!Node>} List of distributed nodes for the `<slot>`.
         * @override
         */
      }, {
        key: "getContentChildNodes",
        value: function getContentChildNodes(slctr) {
          // Note, no need to `wrap` this because root is always
          let content = this.root.querySelector(slctr || 'slot');
          return content ? /** @type {PolymerDomApi} */dom(content).getDistributedNodes() : [];
        }

        /**
         * Returns a list of element children distributed to this element's
         * `<slot>`.
         *
         * If this element contains more than one `<slot>` in its
         * local DOM, an optional selector may be passed to choose the desired
         * content.  This method differs from `getContentChildNodes` in that only
         * elements are returned.
         *
         * @param {string=} slctr CSS selector to choose the desired
         *   `<content>`.  Defaults to `content`.
         * @return {!Array<!HTMLElement>} List of distributed nodes for the
         *   `<slot>`.
         * @suppress {invalidCasts}
         * @override
         */
      }, {
        key: "getContentChildren",
        value: function getContentChildren(slctr) {
          let children = /** @type {!Array<!HTMLElement>} */this.getContentChildNodes(slctr).filter(function (n) {
            return n.nodeType === Node.ELEMENT_NODE;
          });
          return children;
        }

        /**
         * Checks whether an element is in this element's light DOM tree.
         *
         * @param {?Node} node The element to be checked.
         * @return {boolean} true if node is in this element's light DOM tree.
         * @suppress {invalidCasts} LegacyElementMixin must be applied to an
         * HTMLElement
         * @override
         */
      }, {
        key: "isLightDescendant",
        value: function isLightDescendant(node) {
          const thisNode = /** @type {Node} */this;
          return thisNode !== node && wrap(thisNode).contains(node) && wrap(thisNode).getRootNode() === wrap(node).getRootNode();
        }

        /**
         * Checks whether an element is in this element's local DOM tree.
         *
         * @param {!Element} node The element to be checked.
         * @return {boolean} true if node is in this element's local DOM tree.
         * @override
         */
      }, {
        key: "isLocalDescendant",
        value: function isLocalDescendant(node) {
          return this.root === wrap(node).getRootNode();
        }

        /**
         * No-op for backwards compatibility. This should now be handled by
         * ShadyCss library.
         * @param  {!Element} container Container element to scope
         * @param  {boolean=} shouldObserve if true, start a mutation observer for added nodes to the container
         * @return {?MutationObserver} Returns a new MutationObserver on `container` if `shouldObserve` is true.
         * @override
         */
      }, {
        key: "scopeSubtree",
        value: function scopeSubtree$1(container) {
          let shouldObserve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          return scopeSubtree(container, shouldObserve);
        }

        /**
         * Returns the computed style value for the given property.
         * @param {string} property The css property name.
         * @return {string} Returns the computed css property value for the given
         * `property`.
         * @suppress {invalidCasts} LegacyElementMixin must be applied to an
         *     HTMLElement
         * @override
         */
      }, {
        key: "getComputedStyleValue",
        value: function getComputedStyleValue(property) {
          return styleInterface.getComputedStyleValue( /** @type {!Element} */this, property);
        }

        // debounce

        /**
         * Call `debounce` to collapse multiple requests for a named task into
         * one invocation which is made after the wait time has elapsed with
         * no new request.  If no wait time is given, the callback will be called
         * at microtask timing (guaranteed before paint).
         *
         *     debouncedClickAction(e) {
         *       // will not call `processClick` more than once per 100ms
         *       this.debounce('click', function() {
         *        this.processClick();
         *       } 100);
         *     }
         *
         * @param {string} jobName String to identify the debounce job.
         * @param {function():void} callback Function that is called (with `this`
         *   context) when the wait time elapses.
         * @param {number=} wait Optional wait time in milliseconds (ms) after the
         *   last signal that must elapse before invoking `callback`
         * @return {!Object} Returns a debouncer object on which exists the
         * following methods: `isActive()` returns true if the debouncer is
         * active; `cancel()` cancels the debouncer if it is active;
         * `flush()` immediately invokes the debounced callback if the debouncer
         * is active.
         * @override
         */
      }, {
        key: "debounce",
        value: function debounce(jobName, callback, wait) {
          this._debouncers = this._debouncers || {};
          return this._debouncers[jobName] = Debouncer.debounce(this._debouncers[jobName], wait > 0 ? timeOut.after(wait) : microTask, callback.bind(this));
        }

        /**
         * Returns whether a named debouncer is active.
         *
         * @param {string} jobName The name of the debouncer started with `debounce`
         * @return {boolean} Whether the debouncer is active (has not yet fired).
         * @override
         */
      }, {
        key: "isDebouncerActive",
        value: function isDebouncerActive(jobName) {
          this._debouncers = this._debouncers || {};
          let debouncer = this._debouncers[jobName];
          return !!(debouncer && debouncer.isActive());
        }

        /**
         * Immediately calls the debouncer `callback` and inactivates it.
         *
         * @param {string} jobName The name of the debouncer started with `debounce`
         * @return {void}
         * @override
         */
      }, {
        key: "flushDebouncer",
        value: function flushDebouncer(jobName) {
          this._debouncers = this._debouncers || {};
          let debouncer = this._debouncers[jobName];
          if (debouncer) {
            debouncer.flush();
          }
        }

        /**
         * Cancels an active debouncer.  The `callback` will not be called.
         *
         * @param {string} jobName The name of the debouncer started with `debounce`
         * @return {void}
         * @override
         */
      }, {
        key: "cancelDebouncer",
        value: function cancelDebouncer(jobName) {
          this._debouncers = this._debouncers || {};
          let debouncer = this._debouncers[jobName];
          if (debouncer) {
            debouncer.cancel();
          }
        }

        /**
         * Runs a callback function asynchronously.
         *
         * By default (if no waitTime is specified), async callbacks are run at
         * microtask timing, which will occur before paint.
         *
         * @param {!Function} callback The callback function to run, bound to
         *     `this`.
         * @param {number=} waitTime Time to wait before calling the
         *   `callback`.  If unspecified or 0, the callback will be run at microtask
         *   timing (before paint).
         * @return {number} Handle that may be used to cancel the async job.
         * @override
         */
      }, {
        key: "async",
        value: function async(callback, waitTime) {
          return waitTime > 0 ? timeOut.run(callback.bind(this), waitTime) : ~microTask.run(callback.bind(this));
        }

        /**
         * Cancels an async operation started with `async`.
         *
         * @param {number} handle Handle returned from original `async` call to
         *   cancel.
         * @return {void}
         * @override
         */
      }, {
        key: "cancelAsync",
        value: function cancelAsync(handle) {
          handle < 0 ? microTask.cancel(~handle) : timeOut.cancel(handle);
        }

        // other

        /**
         * Convenience method for creating an element and configuring it.
         *
         * @param {string} tag HTML element tag to create.
         * @param {Object=} props Object of properties to configure on the
         *    instance.
         * @return {!Element} Newly created and configured element.
         * @override
         */
      }, {
        key: "create",
        value: function create(tag, props) {
          let elt = document.createElement(tag);
          if (props) {
            if (elt.setProperties) {
              elt.setProperties(props);
            } else {
              for (let n in props) {
                elt[n] = props[n];
              }
            }
          }
          return elt;
        }

        /**
         * Polyfill for Element.prototype.matches, which is sometimes still
         * prefixed.
         *
         * @param {string} selector Selector to test.
         * @param {!Element=} node Element to test the selector against.
         * @return {boolean} Whether the element matches the selector.
         * @override
         */
      }, {
        key: "elementMatches",
        value: function elementMatches(selector, node) {
          return matchesSelector(node || this, selector);
        }

        /**
         * Toggles an HTML attribute on or off.
         *
         * @param {string} name HTML attribute name
         * @param {boolean=} bool Boolean to force the attribute on or off.
         *    When unspecified, the state of the attribute will be reversed.
         * @return {boolean} true if the attribute now exists
         * @override
         */
      }, {
        key: "toggleAttribute",
        value: function toggleAttribute(name, bool) {
          let node = /** @type {Element} */this;
          if (arguments.length === 3) {
            node = /** @type {Element} */arguments[2];
          }
          if (arguments.length == 1) {
            bool = !node.hasAttribute(name);
          }
          if (bool) {
            wrap(node).setAttribute(name, '');
            return true;
          } else {
            wrap(node).removeAttribute(name);
            return false;
          }
        }

        /**
         * Toggles a CSS class on or off.
         *
         * @param {string} name CSS class name
         * @param {boolean=} bool Boolean to force the class on or off.
         *    When unspecified, the state of the class will be reversed.
         * @param {Element=} node Node to target.  Defaults to `this`.
         * @return {void}
         * @override
         */
      }, {
        key: "toggleClass",
        value: function toggleClass(name, bool, node) {
          node = /** @type {Element} */node || this;
          if (arguments.length == 1) {
            bool = !node.classList.contains(name);
          }
          if (bool) {
            node.classList.add(name);
          } else {
            node.classList.remove(name);
          }
        }

        /**
         * Cross-platform helper for setting an element's CSS `transform` property.
         *
         * @param {string} transformText Transform setting.
         * @param {Element=} node Element to apply the transform to.
         * Defaults to `this`
         * @return {void}
         * @override
         */
      }, {
        key: "transform",
        value: function transform(transformText, node) {
          node = /** @type {Element} */node || this;
          node.style.webkitTransform = transformText;
          node.style.transform = transformText;
        }

        /**
         * Cross-platform helper for setting an element's CSS `translate3d`
         * property.
         *
         * @param {number|string} x X offset.
         * @param {number|string} y Y offset.
         * @param {number|string} z Z offset.
         * @param {Element=} node Element to apply the transform to.
         * Defaults to `this`.
         * @return {void}
         * @override
         */
      }, {
        key: "translate3d",
        value: function translate3d(x, y, z, node) {
          node = /** @type {Element} */node || this;
          this.transform('translate3d(' + x + ',' + y + ',' + z + ')', node);
        }

        /**
         * Removes an item from an array, if it exists.
         *
         * If the array is specified by path, a change notification is
         * generated, so that observers, data bindings and computed
         * properties watching that path can update.
         *
         * If the array is passed directly, **no change
         * notification is generated**.
         *
         * @param {string | !Array<number|string>} arrayOrPath Path to array from
         *     which to remove the item
         *   (or the array itself).
         * @param {*} item Item to remove.
         * @return {Array} Array containing item removed.
         * @override
         */
      }, {
        key: "arrayDelete",
        value: function arrayDelete(arrayOrPath, item) {
          let index;
          if (Array.isArray(arrayOrPath)) {
            index = arrayOrPath.indexOf(item);
            if (index >= 0) {
              return arrayOrPath.splice(index, 1);
            }
          } else {
            let arr = get(this, arrayOrPath);
            index = arr.indexOf(item);
            if (index >= 0) {
              return this.splice(arrayOrPath, index, 1);
            }
          }
          return null;
        }

        // logging

        /**
         * Facades `console.log`/`warn`/`error` as override point.
         *
         * @param {string} level One of 'log', 'warn', 'error'
         * @param {Array} args Array of strings or objects to log
         * @return {void}
         * @override
         */
      }, {
        key: "_logger",
        value: function _logger(level, args) {
          var _console;
          // accept ['foo', 'bar'] and [['foo', 'bar']]
          if (Array.isArray(args) && args.length === 1 && Array.isArray(args[0])) {
            args = args[0];
          }
          switch (level) {
            case 'log':
            case 'warn':
            case 'error':
              (_console = console)[level].apply(_console, _toConsumableArray(args));
          }
        }

        /**
         * Facades `console.log` as an override point.
         *
         * @param {...*} args Array of strings or objects to log
         * @return {void}
         * @override
         */
      }, {
        key: "_log",
        value: function _log() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          this._logger('log', args);
        }

        /**
         * Facades `console.warn` as an override point.
         *
         * @param {...*} args Array of strings or objects to log
         * @return {void}
         * @override
         */
      }, {
        key: "_warn",
        value: function _warn() {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          this._logger('warn', args);
        }

        /**
         * Facades `console.error` as an override point.
         *
         * @param {...*} args Array of strings or objects to log
         * @return {void}
         * @override
         */
      }, {
        key: "_error",
        value: function _error() {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }
          this._logger('error', args);
        }

        /**
         * Formats a message using the element type an a method name.
         *
         * @param {string} methodName Method name to associate with message
         * @param {...*} args Array of strings or objects to log
         * @return {!Array} Array with formatting information for `console`
         *   logging.
         * @override
         */
      }, {
        key: "_logf",
        value: function _logf(methodName) {
          for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            args[_key4 - 1] = arguments[_key4];
          }
          return ['[%s::%s]', this.is, methodName].concat(args);
        }
      }], [{
        key: "importMeta",
        get: function () {
          return this.prototype.importMeta;
        }
      }, {
        key: "observedAttributes",
        get: function () {
          if (legacyNoObservedAttributes && !this.prototype._legacyForceObservedAttributes) {
            // Ensure this element is property registered with the telemetry system.
            if (!this.hasOwnProperty(JSCompiler_renameProperty('__observedAttributes', this))) {
              this.__observedAttributes = [];
              register$1(this.prototype);
            }
            return this.__observedAttributes;
          } else {
            return observedAttributesGetter.call(this).concat(DISABLED_ATTR);
          }
        }
      }]);
      return LegacyElement;
    }(legacyElementBase);
    LegacyElement.prototype.is = '';
    return LegacyElement;
  });

  const lifecycleProps = {
    attached: true,
    detached: true,
    ready: true,
    created: true,
    beforeRegister: true,
    registered: true,
    attributeChanged: true,
    listeners: true,
    hostAttributes: true
  };
  const excludeOnInfo = {
    attached: true,
    detached: true,
    ready: true,
    created: true,
    beforeRegister: true,
    registered: true,
    attributeChanged: true,
    behaviors: true,
    _noAccessors: true
  };
  const excludeOnBehaviors = Object.assign({
    listeners: true,
    hostAttributes: true,
    properties: true,
    observers: true
  }, excludeOnInfo);
  function copyProperties(source, target, excludeProps) {
    const noAccessors = source._noAccessors;
    const propertyNames = Object.getOwnPropertyNames(source);
    for (let i = 0; i < propertyNames.length; i++) {
      let p = propertyNames[i];
      if (p in excludeProps) {
        continue;
      }
      if (noAccessors) {
        target[p] = source[p];
      } else {
        let pd = Object.getOwnPropertyDescriptor(source, p);
        if (pd) {
          // ensure property is configurable so that a later behavior can
          // re-configure it.
          pd.configurable = true;
          Object.defineProperty(target, p, pd);
        }
      }
    }
  }

  // NOTE:
  // 1.x
  // Behaviors were mixed in *in reverse order* and de-duped on the fly.
  // The rule was that behavior properties were copied onto the element
  // prototype if and only if the property did not already exist.
  // Given: Polymer{ behaviors: [A, B, C, A, B]}, property copy order was:
  // (1), B, (2), A, (3) C. This means prototype properties win over
  // B properties win over A win over C. This mirrors what would happen
  // with inheritance if element extended B extended A extended C.
  //
  // Again given, Polymer{ behaviors: [A, B, C, A, B]}, the resulting
  // `behaviors` array was [C, A, B].
  // Behavior lifecycle methods were called in behavior array order
  // followed by the element, e.g. (1) C.created, (2) A.created,
  // (3) B.created, (4) element.created. There was no support for
  // super, and "super-behavior" methods were callable only by name).
  //
  // 2.x
  // Behaviors are made into proper mixins which live in the
  // element's prototype chain. Behaviors are placed in the element prototype
  // eldest to youngest and de-duped youngest to oldest:
  // So, first [A, B, C, A, B] becomes [C, A, B] then,
  // the element prototype becomes (oldest) (1) PolymerElement, (2) class(C),
  // (3) class(A), (4) class(B), (5) class(Polymer({...})).
  // Result:
  // This means element properties win over B properties win over A win
  // over C. (same as 1.x)
  // If lifecycle is called (super then me), order is
  // (1) C.created, (2) A.created, (3) B.created, (4) element.created
  // (again same as 1.x)
  function applyBehaviors(proto, behaviors, lifecycle) {
    for (let i = 0; i < behaviors.length; i++) {
      applyInfo(proto, behaviors[i], lifecycle, excludeOnBehaviors);
    }
  }
  function applyInfo(proto, info, lifecycle, excludeProps) {
    copyProperties(info, proto, excludeProps);
    for (let p in lifecycleProps) {
      if (info[p]) {
        lifecycle[p] = lifecycle[p] || [];
        lifecycle[p].push(info[p]);
      }
    }
  }

  /**
   * @param {Array} behaviors List of behaviors to flatten.
   * @param {Array=} list Target list to flatten behaviors into.
   * @param {Array=} exclude List of behaviors to exclude from the list.
   * @return {!Array} Returns the list of flattened behaviors.
   */
  function flattenBehaviors(behaviors, list, exclude) {
    list = list || [];
    for (let i = behaviors.length - 1; i >= 0; i--) {
      let b = behaviors[i];
      if (b) {
        if (Array.isArray(b)) {
          flattenBehaviors(b, list);
        } else {
          // dedup
          if (list.indexOf(b) < 0 && (!exclude || exclude.indexOf(b) < 0)) {
            list.unshift(b);
          }
        }
      } else {
        console.warn('behavior is null, check for missing or 404 import');
      }
    }
    return list;
  }

  /**
   * Copies property descriptors from source to target, overwriting all fields
   * of any previous descriptor for a property *except* for `value`, which is
   * merged in from the target if it does not exist on the source.
   *
   * @param {*} target Target properties object
   * @param {*} source Source properties object
   */
  function mergeProperties(target, source) {
    for (const p in source) {
      const targetInfo = target[p];
      const sourceInfo = source[p];
      if (!('value' in sourceInfo) && targetInfo && 'value' in targetInfo) {
        target[p] = Object.assign({
          value: targetInfo.value
        }, sourceInfo);
      } else {
        target[p] = sourceInfo;
      }
    }
  }
  const LegacyElement = LegacyElementMixin(HTMLElement);

  /* Note about construction and extension of legacy classes.
    [Changed in Q4 2018 to optimize performance.]

    When calling `Polymer` or `mixinBehaviors`, the generated class below is
    made. The list of behaviors was previously made into one generated class per
    behavior, but this is no longer the case as behaviors are now called
    manually. Note, there may *still* be multiple generated classes in the
    element's prototype chain if extension is used with `mixinBehaviors`.

    The generated class is directly tied to the info object and behaviors
    used to create it. That list of behaviors is filtered so it's only the
    behaviors not active on the superclass. In order to call through to the
    entire list of lifecycle methods, it's important to call `super`.

    The element's `properties` and `observers` are controlled via the finalization
    mechanism provided by `PropertiesMixin`. `Properties` and `observers` are
    collected by manually traversing the prototype chain and merging.

    To limit changes, the `_registered` method is called via `_initializeProperties`
    and not `_finalizeClass`.

  */
  /**
   * @param {!PolymerInit} info Polymer info object
   * @param {function(new:HTMLElement)} Base base class to extend with info object
   * @param {Object=} behaviors behaviors to copy into the element
   * @return {function(new:HTMLElement)} Generated class
   * @suppress {checkTypes}
   * @private
   */
  function GenerateClassFromInfo(info, Base, behaviors) {
    // manages behavior and lifecycle processing (filled in after class definition)
    let behaviorList;
    const lifecycle = {};

    /** @private */
    let PolymerGenerated = /*#__PURE__*/function (_Base) {
      _inherits(PolymerGenerated, _Base);
      var _super = _createSuper(PolymerGenerated);
      function PolymerGenerated() {
        _classCallCheck(this, PolymerGenerated);
        return _super.apply(this, arguments);
      }
      _createClass(PolymerGenerated, [{
        key: "created",
        value:
        /**
         * @return {void}
         */
        function created() {
          _get(_getPrototypeOf(PolymerGenerated.prototype), "created", this).call(this);
          const list = lifecycle.created;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              list[i].call(this);
            }
          }
        }

        /**
         * @return {void}
         */
      }, {
        key: "_registered",
        value: function _registered() {
          /* NOTE: `beforeRegister` is called here for bc, but the behavior
            is different than in 1.x. In 1.0, the method was called *after*
            mixing prototypes together but *before* processing of meta-objects.
            However, dynamic effects can still be set here and can be done either
            in `beforeRegister` or `registered`. It is no longer possible to set
            `is` in `beforeRegister` as you could in 1.x.
          */
          // only proceed if the generated class' prototype has not been registered.
          const generatedProto = PolymerGenerated.prototype;
          if (!generatedProto.hasOwnProperty(JSCompiler_renameProperty('__hasRegisterFinished', generatedProto))) {
            generatedProto.__hasRegisterFinished = true;
            // ensure superclass is registered first.
            _get(_getPrototypeOf(PolymerGenerated.prototype), "_registered", this).call(this);
            // copy properties onto the generated class lazily if we're optimizing,
            if (legacyOptimizations) {
              copyPropertiesToProto(generatedProto);
            }
            // make sure legacy lifecycle is called on the *element*'s prototype
            // and not the generated class prototype; if the element has been
            // extended, these are *not* the same.
            const proto = Object.getPrototypeOf(this);
            let list = lifecycle.beforeRegister;
            if (list) {
              for (let i = 0; i < list.length; i++) {
                list[i].call(proto);
              }
            }
            list = lifecycle.registered;
            if (list) {
              for (let i = 0; i < list.length; i++) {
                list[i].call(proto);
              }
            }
          }
        }

        /**
         * @return {void}
         */
      }, {
        key: "_applyListeners",
        value: function _applyListeners() {
          _get(_getPrototypeOf(PolymerGenerated.prototype), "_applyListeners", this).call(this);
          const list = lifecycle.listeners;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              const listeners = list[i];
              if (listeners) {
                for (let l in listeners) {
                  this._addMethodEventListenerToNode(this, l, listeners[l]);
                }
              }
            }
          }
        }

        // note: exception to "super then me" rule;
        // do work before calling super so that super attributes
        // only apply if not already set.
        /**
         * @return {void}
         */
      }, {
        key: "_ensureAttributes",
        value: function _ensureAttributes() {
          const list = lifecycle.hostAttributes;
          if (list) {
            for (let i = list.length - 1; i >= 0; i--) {
              const hostAttributes = list[i];
              for (let a in hostAttributes) {
                this._ensureAttribute(a, hostAttributes[a]);
              }
            }
          }
          _get(_getPrototypeOf(PolymerGenerated.prototype), "_ensureAttributes", this).call(this);
        }

        /**
         * @return {void}
         */
      }, {
        key: "ready",
        value: function ready() {
          _get(_getPrototypeOf(PolymerGenerated.prototype), "ready", this).call(this);
          let list = lifecycle.ready;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              list[i].call(this);
            }
          }
        }

        /**
         * @return {void}
         */
      }, {
        key: "attached",
        value: function attached() {
          _get(_getPrototypeOf(PolymerGenerated.prototype), "attached", this).call(this);
          let list = lifecycle.attached;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              list[i].call(this);
            }
          }
        }

        /**
         * @return {void}
         */
      }, {
        key: "detached",
        value: function detached() {
          _get(_getPrototypeOf(PolymerGenerated.prototype), "detached", this).call(this);
          let list = lifecycle.detached;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              list[i].call(this);
            }
          }
        }

        /**
         * Implements native Custom Elements `attributeChangedCallback` to
         * set an attribute value to a property via `_attributeToProperty`.
         *
         * @param {string} name Name of attribute that changed
         * @param {?string} old Old attribute value
         * @param {?string} value New attribute value
         * @return {void}
         */
      }, {
        key: "attributeChanged",
        value: function attributeChanged(name, old, value) {
          _get(_getPrototypeOf(PolymerGenerated.prototype), "attributeChanged", this).call(this);
          let list = lifecycle.attributeChanged;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              list[i].call(this, name, old, value);
            }
          }
        }
      }], [{
        key: "_finalizeClass",
        value:
        // explicitly not calling super._finalizeClass
        /** @nocollapse */
        function _finalizeClass() {
          // if calling via a subclass that hasn't been generated, pass through to super
          if (!this.hasOwnProperty(JSCompiler_renameProperty('generatedFrom', this))) {
            // TODO(https://github.com/google/closure-compiler/issues/3240):
            //     Change back to just super.methodCall()
            Base._finalizeClass.call(this);
          } else {
            // interleave properties and observers per behavior and `info`
            if (behaviorList) {
              for (let i = 0, b; i < behaviorList.length; i++) {
                b = behaviorList[i];
                if (b.properties) {
                  this.createProperties(b.properties);
                }
                if (b.observers) {
                  this.createObservers(b.observers, b.properties);
                }
              }
            }
            if (info.properties) {
              this.createProperties(info.properties);
            }
            if (info.observers) {
              this.createObservers(info.observers, info.properties);
            }
            // make sure to prepare the element template
            this._prepareTemplate();
          }
        }

        /** @nocollapse */
      }, {
        key: "properties",
        get: function () {
          const properties = {};
          if (behaviorList) {
            for (let i = 0; i < behaviorList.length; i++) {
              mergeProperties(properties, behaviorList[i].properties);
            }
          }
          mergeProperties(properties, info.properties);
          return properties;
        }

        /** @nocollapse */
      }, {
        key: "observers",
        get: function () {
          let observers = [];
          if (behaviorList) {
            for (let i = 0, b; i < behaviorList.length; i++) {
              b = behaviorList[i];
              if (b.observers) {
                observers = observers.concat(b.observers);
              }
            }
          }
          if (info.observers) {
            observers = observers.concat(info.observers);
          }
          return observers;
        }
      }]);
      return PolymerGenerated;
    }(Base); // apply behaviors, note actual copying is done lazily at first instance creation
    if (behaviors) {
      // NOTE: ensure the behavior is extending a class with
      // legacy element api. This is necessary since behaviors expect to be able
      // to access 1.x legacy api.
      if (!Array.isArray(behaviors)) {
        behaviors = [behaviors];
      }
      let superBehaviors = Base.prototype.behaviors;
      // get flattened, deduped list of behaviors *not* already on super class
      behaviorList = flattenBehaviors(behaviors, null, superBehaviors);
      PolymerGenerated.prototype.behaviors = superBehaviors ? superBehaviors.concat(behaviors) : behaviorList;
    }
    const copyPropertiesToProto = proto => {
      if (behaviorList) {
        applyBehaviors(proto, behaviorList, lifecycle);
      }
      applyInfo(proto, info, lifecycle, excludeOnInfo);
    };

    // copy properties if we're not optimizing
    if (!legacyOptimizations) {
      copyPropertiesToProto(PolymerGenerated.prototype);
    }
    PolymerGenerated.generatedFrom = info;
    return PolymerGenerated;
  }

  /**
   * Generates a class that extends `LegacyElement` based on the
   * provided info object.  Metadata objects on the `info` object
   * (`properties`, `observers`, `listeners`, `behaviors`, `is`) are used
   * for Polymer's meta-programming systems, and any functions are copied
   * to the generated class.
   *
   * Valid "metadata" values are as follows:
   *
   * `is`: String providing the tag name to register the element under. In
   * addition, if a `dom-module` with the same id exists, the first template
   * in that `dom-module` will be stamped into the shadow root of this element,
   * with support for declarative event listeners (`on-...`), Polymer data
   * bindings (`[[...]]` and `{{...}}`), and id-based node finding into
   * `this.$`.
   *
   * `properties`: Object describing property-related metadata used by Polymer
   * features (key: property names, value: object containing property metadata).
   * Valid keys in per-property metadata include:
   * - `type` (String|Number|Object|Array|...): Used by
   *   `attributeChangedCallback` to determine how string-based attributes
   *   are deserialized to JavaScript property values.
   * - `notify` (boolean): Causes a change in the property to fire a
   *   non-bubbling event called `<property>-changed`. Elements that have
   *   enabled two-way binding to the property use this event to observe changes.
   * - `readOnly` (boolean): Creates a getter for the property, but no setter.
   *   To set a read-only property, use the private setter method
   *   `_setProperty(property, value)`.
   * - `observer` (string): Observer method name that will be called when
   *   the property changes. The arguments of the method are
   *   `(value, previousValue)`.
   * - `computed` (string): String describing method and dependent properties
   *   for computing the value of this property (e.g. `'computeFoo(bar, zot)'`).
   *   Computed properties are read-only by default and can only be changed
   *   via the return value of the computing method.
   *
   * `observers`: Array of strings describing multi-property observer methods
   *  and their dependent properties (e.g. `'observeABC(a, b, c)'`).
   *
   * `listeners`: Object describing event listeners to be added to each
   *  instance of this element (key: event name, value: method name).
   *
   * `behaviors`: Array of additional `info` objects containing metadata
   * and callbacks in the same format as the `info` object here which are
   * merged into this element.
   *
   * `hostAttributes`: Object listing attributes to be applied to the host
   *  once created (key: attribute name, value: attribute value).  Values
   *  are serialized based on the type of the value.  Host attributes should
   *  generally be limited to attributes such as `tabIndex` and `aria-...`.
   *  Attributes in `hostAttributes` are only applied if a user-supplied
   *  attribute is not already present (attributes in markup override
   *  `hostAttributes`).
   *
   * In addition, the following Polymer-specific callbacks may be provided:
   * - `registered`: called after first instance of this element,
   * - `created`: called during `constructor`
   * - `attached`: called during `connectedCallback`
   * - `detached`: called during `disconnectedCallback`
   * - `ready`: called before first `attached`, after all properties of
   *   this element have been propagated to its template and all observers
   *   have run
   *
   * @param {!PolymerInit} info Object containing Polymer metadata and functions
   *   to become class methods.
   * @template T
   * @param {function(T):T} mixin Optional mixin to apply to legacy base class
   *   before extending with Polymer metaprogramming.
   * @return {function(new:HTMLElement)} Generated class
   */
  const Class = function (info, mixin) {
    if (!info) {
      console.warn('Polymer.Class requires `info` argument');
    }
    let klass = mixin ? mixin(LegacyElement) : LegacyElement;
    klass = GenerateClassFromInfo(info, klass, info.behaviors);
    // decorate klass with registration info
    klass.is = klass.prototype.is = info.is;
    return klass;
  };

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Legacy class factory and registration helper for defining Polymer
   * elements.
   *
   * This method is equivalent to
   *
   *     import {Class} from '@polymer/polymer/lib/legacy/class.js';
   *     customElements.define(info.is, Class(info));
   *
   * See `Class` for details on valid legacy metadata format for `info`.
   *
   * @global
   * @override
   * @function
   * @param {!PolymerInit} info Object containing Polymer metadata and functions
   *   to become class methods.
   * @return {function(new: HTMLElement)} Generated class
   * @suppress {duplicate, invalidCasts, checkTypes}
   */
  const Polymer = function (info) {
    // if input is a `class` (aka a function with a prototype), use the prototype
    // remember that the `constructor` will never be called
    let klass;
    if (typeof info === 'function') {
      klass = info;
    } else {
      klass = Polymer.Class(info);
    }
    // Copy opt out for `legacyNoObservedAttributes` from info object to class.
    if (info._legacyForceObservedAttributes) {
      klass.prototype._legacyForceObservedAttributes = info._legacyForceObservedAttributes;
    }
    customElements.define(klass.is, /** @type {!HTMLElement} */klass);
    return klass;
  };
  Polymer.Class = Class;

  // Common implementation for mixin & behavior
  function mutablePropertyChange(inst, property, value, old, mutableData) {
    let isObject;
    if (mutableData) {
      isObject = typeof value === 'object' && value !== null;
      // Pull `old` for Objects from temp cache, but treat `null` as a primitive
      if (isObject) {
        old = inst.__dataTemp[property];
      }
    }
    // Strict equality check, but return false for NaN===NaN
    let shouldChange = old !== value && (old === old || value === value);
    // Objects are stored in temporary cache (cleared at end of
    // turn), which is used for dirty-checking
    if (isObject && shouldChange) {
      inst.__dataTemp[property] = value;
    }
    return shouldChange;
  }

  /**
   * Element class mixin to skip strict dirty-checking for objects and arrays
   * (always consider them to be "dirty"), for use on elements utilizing
   * `PropertyEffects`
   *
   * By default, `PropertyEffects` performs strict dirty checking on
   * objects, which means that any deep modifications to an object or array will
   * not be propagated unless "immutable" data patterns are used (i.e. all object
   * references from the root to the mutation were changed).
   *
   * Polymer also provides a proprietary data mutation and path notification API
   * (e.g. `notifyPath`, `set`, and array mutation API's) that allow efficient
   * mutation and notification of deep changes in an object graph to all elements
   * bound to the same object graph.
   *
   * In cases where neither immutable patterns nor the data mutation API can be
   * used, applying this mixin will cause Polymer to skip dirty checking for
   * objects and arrays (always consider them to be "dirty").  This allows a
   * user to make a deep modification to a bound object graph, and then either
   * simply re-set the object (e.g. `this.items = this.items`) or call `notifyPath`
   * (e.g. `this.notifyPath('items')`) to update the tree.  Note that all
   * elements that wish to be updated based on deep mutations must apply this
   * mixin or otherwise skip strict dirty checking for objects/arrays.
   * Specifically, any elements in the binding tree between the source of a
   * mutation and the consumption of it must apply this mixin or enable the
   * `OptionalMutableData` mixin.
   *
   * In order to make the dirty check strategy configurable, see
   * `OptionalMutableData`.
   *
   * Note, the performance characteristics of propagating large object graphs
   * will be worse as opposed to using strict dirty checking with immutable
   * patterns or Polymer's path notification API.
   *
   * @mixinFunction
   * @polymer
   * @summary Element class mixin to skip strict dirty-checking for objects
   *   and arrays
   * @template T
   * @param {function(new:T)} superClass Class to apply mixin to.
   * @return {function(new:T)} superClass with mixin applied.
   */
  const MutableData = dedupingMixin(superClass => {
    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_MutableData}
     */let MutableData = /*#__PURE__*/function (_superClass) {
      _inherits(MutableData, _superClass);
      var _super = _createSuper(MutableData);
      function MutableData() {
        _classCallCheck(this, MutableData);
        return _super.apply(this, arguments);
      }
      _createClass(MutableData, [{
        key: "_shouldPropertyChange",
        value:
        /**
         * Overrides `PropertyEffects` to provide option for skipping
         * strict equality checking for Objects and Arrays.
         *
         * This method pulls the value to dirty check against from the `__dataTemp`
         * cache (rather than the normal `__data` cache) for Objects.  Since the temp
         * cache is cleared at the end of a turn, this implementation allows
         * side-effects of deep object changes to be processed by re-setting the
         * same object (using the temp cache as an in-turn backstop to prevent
         * cycles due to 2-way notification).
         *
         * @param {string} property Property name
         * @param {*} value New property value
         * @param {*} old Previous property value
         * @return {boolean} Whether the property should be considered a change
         * @protected
         */
        function _shouldPropertyChange(property, value, old) {
          return mutablePropertyChange(this, property, value, old, true);
        }
      }]);
      return MutableData;
    }(superClass);
    return MutableData;
  });

  /**
   * Element class mixin to add the optional ability to skip strict
   * dirty-checking for objects and arrays (always consider them to be
   * "dirty") by setting a `mutable-data` attribute on an element instance.
   *
   * By default, `PropertyEffects` performs strict dirty checking on
   * objects, which means that any deep modifications to an object or array will
   * not be propagated unless "immutable" data patterns are used (i.e. all object
   * references from the root to the mutation were changed).
   *
   * Polymer also provides a proprietary data mutation and path notification API
   * (e.g. `notifyPath`, `set`, and array mutation API's) that allow efficient
   * mutation and notification of deep changes in an object graph to all elements
   * bound to the same object graph.
   *
   * In cases where neither immutable patterns nor the data mutation API can be
   * used, applying this mixin will allow Polymer to skip dirty checking for
   * objects and arrays (always consider them to be "dirty").  This allows a
   * user to make a deep modification to a bound object graph, and then either
   * simply re-set the object (e.g. `this.items = this.items`) or call `notifyPath`
   * (e.g. `this.notifyPath('items')`) to update the tree.  Note that all
   * elements that wish to be updated based on deep mutations must apply this
   * mixin or otherwise skip strict dirty checking for objects/arrays.
   * Specifically, any elements in the binding tree between the source of a
   * mutation and the consumption of it must enable this mixin or apply the
   * `MutableData` mixin.
   *
   * While this mixin adds the ability to forgo Object/Array dirty checking,
   * the `mutableData` flag defaults to false and must be set on the instance.
   *
   * Note, the performance characteristics of propagating large object graphs
   * will be worse by relying on `mutableData: true` as opposed to using
   * strict dirty checking with immutable patterns or Polymer's path notification
   * API.
   *
   * @mixinFunction
   * @polymer
   * @summary Element class mixin to optionally skip strict dirty-checking
   *   for objects and arrays
   */
  const OptionalMutableData = dedupingMixin(superClass => {
    /**
     * @mixinClass
     * @polymer
     * @implements {Polymer_OptionalMutableData}
     */let OptionalMutableData = /*#__PURE__*/function (_superClass2) {
      _inherits(OptionalMutableData, _superClass2);
      var _super2 = _createSuper(OptionalMutableData);
      function OptionalMutableData() {
        _classCallCheck(this, OptionalMutableData);
        return _super2.apply(this, arguments);
      }
      _createClass(OptionalMutableData, [{
        key: "_shouldPropertyChange",
        value:
        /**
         * Overrides `PropertyEffects` to provide option for skipping
         * strict equality checking for Objects and Arrays.
         *
         * When `this.mutableData` is true on this instance, this method
         * pulls the value to dirty check against from the `__dataTemp` cache
         * (rather than the normal `__data` cache) for Objects.  Since the temp
         * cache is cleared at the end of a turn, this implementation allows
         * side-effects of deep object changes to be processed by re-setting the
         * same object (using the temp cache as an in-turn backstop to prevent
         * cycles due to 2-way notification).
         *
         * @param {string} property Property name
         * @param {*} value New property value
         * @param {*} old Previous property value
         * @return {boolean} Whether the property should be considered a change
         * @protected
         */
        function _shouldPropertyChange(property, value, old) {
          return mutablePropertyChange(this, property, value, old, this.mutableData);
        }
      }], [{
        key: "properties",
        get: /** @nocollapse */
        function () {
          return {
            /**
             * Instance-level flag for configuring the dirty-checking strategy
             * for this element.  When true, Objects and Arrays will skip dirty
             * checking, otherwise strict equality checking will be used.
             */
            mutableData: Boolean
          };
        }
      }]);
      return OptionalMutableData;
    }(superClass);
    return OptionalMutableData;
  });

  // Export for use by legacy behavior
  MutableData._mutablePropertyChange = mutablePropertyChange;

  // Base class for HTMLTemplateElement extension that has property effects
  // machinery for propagating host properties to children. This is an ES5
  // class only because Babel (incorrectly) requires super() in the class
  // constructor even though no `this` is used and it returns an instance.
  let newInstance = null;

  /**
   * @constructor
   * @extends {HTMLTemplateElement}
   * @private
   */
  function HTMLTemplateElementExtension() {
    return newInstance;
  }
  HTMLTemplateElementExtension.prototype = Object.create(HTMLTemplateElement.prototype, {
    constructor: {
      value: HTMLTemplateElementExtension,
      writable: true
    }
  });

  /**
   * @constructor
   * @implements {Polymer_PropertyEffects}
   * @extends {HTMLTemplateElementExtension}
   * @private
   */
  const DataTemplate = PropertyEffects(HTMLTemplateElementExtension);

  /**
   * @constructor
   * @implements {Polymer_MutableData}
   * @extends {DataTemplate}
   * @private
   */
  const MutableDataTemplate = MutableData(DataTemplate);

  // Applies a DataTemplate subclass to a <template> instance
  function upgradeTemplate(template, constructor) {
    newInstance = template;
    Object.setPrototypeOf(template, constructor.prototype);
    new constructor();
    newInstance = null;
  }

  /**
   * Base class for TemplateInstance.
   * @constructor
   * @extends {HTMLElement}
   * @implements {Polymer_PropertyEffects}
   * @private
   */
  const templateInstanceBase = PropertyEffects( /*#__PURE__*/function () {
    function _class() {
      _classCallCheck(this, _class);
    }
    return _createClass(_class);
  }());
  function showHideChildren(hide, children) {
    for (let i = 0; i < children.length; i++) {
      let n = children[i];
      // Ignore non-changes
      if (Boolean(hide) != Boolean(n.__hideTemplateChildren__)) {
        // clear and restore text
        if (n.nodeType === Node.TEXT_NODE) {
          if (hide) {
            n.__polymerTextContent__ = n.textContent;
            n.textContent = '';
          } else {
            n.textContent = n.__polymerTextContent__;
          }
          // remove and replace slot
        } else if (n.localName === 'slot') {
          if (hide) {
            n.__polymerReplaced__ = document.createComment('hidden-slot');
            wrap(wrap(n).parentNode).replaceChild(n.__polymerReplaced__, n);
          } else {
            const replace = n.__polymerReplaced__;
            if (replace) {
              wrap(wrap(replace).parentNode).replaceChild(n, replace);
            }
          }
        }
        // hide and show nodes
        else if (n.style) {
          if (hide) {
            n.__polymerDisplay__ = n.style.display;
            n.style.display = 'none';
          } else {
            n.style.display = n.__polymerDisplay__;
          }
        }
      }
      n.__hideTemplateChildren__ = hide;
      if (n._showHideChildren) {
        n._showHideChildren(hide);
      }
    }
  }

  /**
   * @polymer
   * @customElement
   * @appliesMixin PropertyEffects
   * @unrestricted
   */
  let TemplateInstanceBase = /*#__PURE__*/function (_templateInstanceBase) {
    _inherits(TemplateInstanceBase, _templateInstanceBase);
    var _super = _createSuper(TemplateInstanceBase);
    function TemplateInstanceBase(props) {
      var _this;
      _classCallCheck(this, TemplateInstanceBase);
      _this = _super.call(this);
      _this._configureProperties(props);
      /** @type {!StampedTemplate} */
      _this.root = _this._stampTemplate(_this.__dataHost);
      // Save list of stamped children
      let children = [];
      /** @suppress {invalidCasts} */
      _this.children = /** @type {!NodeList} */children;
      // Polymer 1.x did not use `Polymer.dom` here so not bothering.
      for (let n = _this.root.firstChild; n; n = n.nextSibling) {
        children.push(n);
        n.__templatizeInstance = _assertThisInitialized(_this);
      }
      if (_this.__templatizeOwner && _this.__templatizeOwner.__hideTemplateChildren__) {
        _this._showHideChildren(true);
      }
      // Flush props only when props are passed if instance props exist
      // or when there isn't instance props.
      let options = _this.__templatizeOptions;
      if (props && options.instanceProps || !options.instanceProps) {
        _this._enableProperties();
      }
      return _this;
    }
    /**
     * Configure the given `props` by calling `_setPendingProperty`. Also
     * sets any properties stored in `__hostProps`.
     * @private
     * @param {Object} props Object of property name-value pairs to set.
     * @return {void}
     */
    _createClass(TemplateInstanceBase, [{
      key: "_configureProperties",
      value: function _configureProperties(props) {
        let options = this.__templatizeOptions;
        if (options.forwardHostProp) {
          for (let hprop in this.__hostProps) {
            this._setPendingProperty(hprop, this.__dataHost['_host_' + hprop]);
          }
        }
        // Any instance props passed in the constructor will overwrite host props;
        // normally this would be a user error but we don't specifically filter them
        for (let iprop in props) {
          this._setPendingProperty(iprop, props[iprop]);
        }
      }
      /**
       * Forwards a host property to this instance.  This method should be
       * called on instances from the `options.forwardHostProp` callback
       * to propagate changes of host properties to each instance.
       *
       * Note this method enqueues the change, which are flushed as a batch.
       *
       * @param {string} prop Property or path name
       * @param {*} value Value of the property to forward
       * @return {void}
       */
    }, {
      key: "forwardHostProp",
      value: function forwardHostProp(prop, value) {
        if (this._setPendingPropertyOrPath(prop, value, false, true)) {
          this.__dataHost._enqueueClient(this);
        }
      }

      /**
       * Override point for adding custom or simulated event handling.
       *
       * @override
       * @param {!Node} node Node to add event listener to
       * @param {string} eventName Name of event
       * @param {function(!Event):void} handler Listener function to add
       * @return {void}
       */
    }, {
      key: "_addEventListenerToNode",
      value: function _addEventListenerToNode(node, eventName, handler) {
        if (this._methodHost && this.__templatizeOptions.parentModel) {
          // If this instance should be considered a parent model, decorate
          // events this template instance as `model`
          this._methodHost._addEventListenerToNode(node, eventName, e => {
            e.model = this;
            handler(e);
          });
        } else {
          // Otherwise delegate to the template's host (which could be)
          // another template instance
          let templateHost = this.__dataHost.__dataHost;
          if (templateHost) {
            templateHost._addEventListenerToNode(node, eventName, handler);
          }
        }
      }
      /**
       * Shows or hides the template instance top level child elements. For
       * text nodes, `textContent` is removed while "hidden" and replaced when
       * "shown."
       * @param {boolean} hide Set to true to hide the children;
       * set to false to show them.
       * @return {void}
       * @protected
       */
    }, {
      key: "_showHideChildren",
      value: function _showHideChildren(hide) {
        showHideChildren(hide, this.children);
      }
      /**
       * Overrides default property-effects implementation to intercept
       * textContent bindings while children are "hidden" and cache in
       * private storage for later retrieval.
       *
       * @override
       * @param {!Node} node The node to set a property on
       * @param {string} prop The property to set
       * @param {*} value The value to set
       * @return {void}
       * @protected
       */
    }, {
      key: "_setUnmanagedPropertyToNode",
      value: function _setUnmanagedPropertyToNode(node, prop, value) {
        if (node.__hideTemplateChildren__ && node.nodeType == Node.TEXT_NODE && prop == 'textContent') {
          node.__polymerTextContent__ = value;
        } else {
          _get(_getPrototypeOf(TemplateInstanceBase.prototype), "_setUnmanagedPropertyToNode", this).call(this, node, prop, value);
        }
      }
      /**
       * Find the parent model of this template instance.  The parent model
       * is either another templatize instance that had option `parentModel: true`,
       * or else the host element.
       *
       * @return {!Polymer_PropertyEffects} The parent model of this instance
       */
    }, {
      key: "parentModel",
      get: function () {
        let model = this.__parentModel;
        if (!model) {
          let options;
          model = this;
          do {
            // A template instance's `__dataHost` is a <template>
            // `model.__dataHost.__dataHost` is the template's host
            model = model.__dataHost.__dataHost;
          } while ((options = model.__templatizeOptions) && !options.parentModel);
          this.__parentModel = model;
        }
        return model;
      }

      /**
       * Stub of HTMLElement's `dispatchEvent`, so that effects that may
       * dispatch events safely no-op.
       *
       * @param {Event} event Event to dispatch
       * @return {boolean} Always true.
       * @override
       */
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        // eslint-disable-line no-unused-vars
        return true;
      }
    }]);
    return TemplateInstanceBase;
  }(templateInstanceBase); /** @type {!DataTemplate} */
  TemplateInstanceBase.prototype.__dataHost;
  /** @type {!TemplatizeOptions} */
  TemplateInstanceBase.prototype.__templatizeOptions;
  /** @type {!Polymer_PropertyEffects} */
  TemplateInstanceBase.prototype._methodHost;
  /** @type {!Object} */
  TemplateInstanceBase.prototype.__templatizeOwner;
  /** @type {!Object} */
  TemplateInstanceBase.prototype.__hostProps;

  /**
   * @constructor
   * @extends {TemplateInstanceBase}
   * @implements {Polymer_MutableData}
   * @private
   */
  const MutableTemplateInstanceBase = MutableData(
  // This cast shouldn't be neccessary, but Closure doesn't understand that
  // TemplateInstanceBase is a constructor function.
  /** @type {function(new:TemplateInstanceBase)} */
  TemplateInstanceBase);
  function findMethodHost(template) {
    // Technically this should be the owner of the outermost template.
    // In shadow dom, this is always getRootNode().host, but we can
    // approximate this via cooperation with our dataHost always setting
    // `_methodHost` as long as there were bindings (or id's) on this
    // instance causing it to get a dataHost.
    let templateHost = template.__dataHost;
    return templateHost && templateHost._methodHost || templateHost;
  }

  /* eslint-disable valid-jsdoc */
  /**
   * @suppress {missingProperties} class.prototype is not defined for some reason
   */
  function createTemplatizerClass(template, templateInfo, options) {
    /**
     * @constructor
     * @extends {TemplateInstanceBase}
     */
    let templatizerBase = options.mutableData ? MutableTemplateInstanceBase : TemplateInstanceBase;

    // Affordance for global mixins onto TemplatizeInstance
    if (templatize.mixin) {
      templatizerBase = templatize.mixin(templatizerBase);
    }

    /**
     * Anonymous class created by the templatize
     * @constructor
     * @private
     */
    let klass = /*#__PURE__*/function (_templatizerBase) {
      _inherits(klass, _templatizerBase);
      var _super2 = _createSuper(klass);
      function klass() {
        _classCallCheck(this, klass);
        return _super2.apply(this, arguments);
      }
      return _createClass(klass);
    }(templatizerBase);
    /** @override */
    klass.prototype.__templatizeOptions = options;
    klass.prototype._bindTemplate(template);
    addNotifyEffects(klass, template, templateInfo, options);
    return klass;
  }

  /**
   * Adds propagate effects from the template to the template instance for
   * properties that the host binds to the template using the `_host_` prefix.
   *
   * @suppress {missingProperties} class.prototype is not defined for some reason
   */
  function addPropagateEffects(target, templateInfo, options, methodHost) {
    let userForwardHostProp = options.forwardHostProp;
    if (userForwardHostProp && templateInfo.hasHostProps) {
      // Under the `removeNestedTemplates` optimization, a custom element like
      // `dom-if` or `dom-repeat` can itself be treated as the "template"; this
      // flag is used to switch between upgrading a `<template>` to be a property
      // effects client vs. adding the effects directly to the custom element
      const isTemplate = target.localName == 'template';
      // Provide data API and property effects on memoized template class
      let klass = templateInfo.templatizeTemplateClass;
      if (!klass) {
        if (isTemplate) {
          /**
           * @constructor
           * @extends {DataTemplate}
           */
          let templatizedBase = options.mutableData ? MutableDataTemplate : DataTemplate;

          // NOTE: due to https://github.com/google/closure-compiler/issues/2928,
          // combining the next two lines into one assignment causes a spurious
          // type error.
          /** @private */
          let TemplatizedTemplate = /*#__PURE__*/function (_templatizedBase) {
            _inherits(TemplatizedTemplate, _templatizedBase);
            var _super3 = _createSuper(TemplatizedTemplate);
            function TemplatizedTemplate() {
              _classCallCheck(this, TemplatizedTemplate);
              return _super3.apply(this, arguments);
            }
            return _createClass(TemplatizedTemplate);
          }(templatizedBase);
          klass = templateInfo.templatizeTemplateClass = TemplatizedTemplate;
        } else {
          /**
           * @constructor
           * @extends {PolymerElement}
           */
          const templatizedBase = target.constructor;

          // Create a cached subclass of the base custom element class onto which
          // to put the template-specific propagate effects
          // NOTE: due to https://github.com/google/closure-compiler/issues/2928,
          // combining the next two lines into one assignment causes a spurious
          // type error.
          /** @private */
          let TemplatizedTemplateExtension = /*#__PURE__*/function (_templatizedBase2) {
            _inherits(TemplatizedTemplateExtension, _templatizedBase2);
            var _super4 = _createSuper(TemplatizedTemplateExtension);
            function TemplatizedTemplateExtension() {
              _classCallCheck(this, TemplatizedTemplateExtension);
              return _super4.apply(this, arguments);
            }
            return _createClass(TemplatizedTemplateExtension);
          }(templatizedBase);
          klass = templateInfo.templatizeTemplateClass = TemplatizedTemplateExtension;
        }
        // Add template - >instances effects
        // and host <- template effects
        let hostProps = templateInfo.hostProps;
        for (let prop in hostProps) {
          klass.prototype._addPropertyEffect('_host_' + prop, klass.prototype.PROPERTY_EFFECT_TYPES.PROPAGATE, {
            fn: createForwardHostPropEffect(prop, userForwardHostProp)
          });
          klass.prototype._createNotifyingProperty('_host_' + prop);
        }
        if (legacyWarnings && methodHost) {
          warnOnUndeclaredProperties(templateInfo, options, methodHost);
        }
      }
      // Mix any pre-bound data into __data; no need to flush this to
      // instances since they pull from the template at instance-time
      if (target.__dataProto) {
        // Note, generally `__dataProto` could be chained, but it's guaranteed
        // to not be since this is a vanilla template we just added effects to
        Object.assign(target.__data, target.__dataProto);
      }
      if (isTemplate) {
        upgradeTemplate(target, klass);
        // Clear any pending data for performance
        target.__dataTemp = {};
        target.__dataPending = null;
        target.__dataOld = null;
        target._enableProperties();
      } else {
        // Swizzle the cached subclass prototype onto the custom element
        Object.setPrototypeOf(target, klass.prototype);
        // Check for any pre-bound instance host properties, and do the
        // instance property delete/assign dance for those (directly into data;
        // not need to go through accessor since they are pulled at instance time)
        const hostProps = templateInfo.hostProps;
        for (let prop in hostProps) {
          prop = '_host_' + prop;
          if (prop in target) {
            const val = target[prop];
            delete target[prop];
            target.__data[prop] = val;
          }
        }
      }
    }
  }
  /* eslint-enable valid-jsdoc */

  function createForwardHostPropEffect(hostProp, userForwardHostProp) {
    return function forwardHostProp(template, prop, props) {
      userForwardHostProp.call(template.__templatizeOwner, prop.substring('_host_'.length), props[prop]);
    };
  }
  function addNotifyEffects(klass, template, templateInfo, options) {
    let hostProps = templateInfo.hostProps || {};
    for (let iprop in options.instanceProps) {
      delete hostProps[iprop];
      let userNotifyInstanceProp = options.notifyInstanceProp;
      if (userNotifyInstanceProp) {
        klass.prototype._addPropertyEffect(iprop, klass.prototype.PROPERTY_EFFECT_TYPES.NOTIFY, {
          fn: createNotifyInstancePropEffect(iprop, userNotifyInstanceProp)
        });
      }
    }
    if (options.forwardHostProp && template.__dataHost) {
      for (let hprop in hostProps) {
        // As we're iterating hostProps in this function, note whether
        // there were any, for an optimization in addPropagateEffects
        if (!templateInfo.hasHostProps) {
          templateInfo.hasHostProps = true;
        }
        klass.prototype._addPropertyEffect(hprop, klass.prototype.PROPERTY_EFFECT_TYPES.NOTIFY, {
          fn: createNotifyHostPropEffect()
        });
      }
    }
  }
  function createNotifyInstancePropEffect(instProp, userNotifyInstanceProp) {
    return function notifyInstanceProp(inst, prop, props) {
      userNotifyInstanceProp.call(inst.__templatizeOwner, inst, prop, props[prop]);
    };
  }
  function createNotifyHostPropEffect() {
    return function notifyHostProp(inst, prop, props) {
      inst.__dataHost._setPendingPropertyOrPath('_host_' + prop, props[prop], true, true);
    };
  }

  /**
   * Returns an anonymous `PropertyEffects` class bound to the
   * `<template>` provided.  Instancing the class will result in the
   * template being stamped into a document fragment stored as the instance's
   * `root` property, after which it can be appended to the DOM.
   *
   * Templates may utilize all Polymer data-binding features as well as
   * declarative event listeners.  Event listeners and inline computing
   * functions in the template will be called on the host of the template.
   *
   * The constructor returned takes a single argument dictionary of initial
   * property values to propagate into template bindings.  Additionally
   * host properties can be forwarded in, and instance properties can be
   * notified out by providing optional callbacks in the `options` dictionary.
   *
   * Valid configuration in `options` are as follows:
   *
   * - `forwardHostProp(property, value)`: Called when a property referenced
   *   in the template changed on the template's host. As this library does
   *   not retain references to templates instanced by the user, it is the
   *   templatize owner's responsibility to forward host property changes into
   *   user-stamped instances.  The `instance.forwardHostProp(property, value)`
   *    method on the generated class should be called to forward host
   *   properties into the template to prevent unnecessary property-changed
   *   notifications. Any properties referenced in the template that are not
   *   defined in `instanceProps` will be notified up to the template's host
   *   automatically.
   * - `instanceProps`: Dictionary of property names that will be added
   *   to the instance by the templatize owner.  These properties shadow any
   *   host properties, and changes within the template to these properties
   *   will result in `notifyInstanceProp` being called.
   * - `mutableData`: When `true`, the generated class will skip strict
   *   dirty-checking for objects and arrays (always consider them to be
   *   "dirty").
   * - `notifyInstanceProp(instance, property, value)`: Called when
   *   an instance property changes.  Users may choose to call `notifyPath`
   *   on e.g. the owner to notify the change.
   * - `parentModel`: When `true`, events handled by declarative event listeners
   *   (`on-event="handler"`) will be decorated with a `model` property pointing
   *   to the template instance that stamped it.  It will also be returned
   *   from `instance.parentModel` in cases where template instance nesting
   *   causes an inner model to shadow an outer model.
   *
   * All callbacks are called bound to the `owner`. Any context
   * needed for the callbacks (such as references to `instances` stamped)
   * should be stored on the `owner` such that they can be retrieved via
   * `this`.
   *
   * When `options.forwardHostProp` is declared as an option, any properties
   * referenced in the template will be automatically forwarded from the host of
   * the `<template>` to instances, with the exception of any properties listed in
   * the `options.instanceProps` object.  `instanceProps` are assumed to be
   * managed by the owner of the instances, either passed into the constructor
   * or set after the fact.  Note, any properties passed into the constructor will
   * always be set to the instance (regardless of whether they would normally
   * be forwarded from the host).
   *
   * Note that `templatize()` can be run only once for a given `<template>`.
   * Further calls will result in an error. Also, there is a special
   * behavior if the template was duplicated through a mechanism such as
   * `<dom-repeat>` or `<test-fixture>`. In this case, all calls to
   * `templatize()` return the same class for all duplicates of a template.
   * The class returned from `templatize()` is generated only once using
   * the `options` from the first call. This means that any `options`
   * provided to subsequent calls will be ignored. Therefore, it is very
   * important not to close over any variables inside the callbacks. Also,
   * arrow functions must be avoided because they bind the outer `this`.
   * Inside the callbacks, any contextual information can be accessed
   * through `this`, which points to the `owner`.
   *
   * @param {!HTMLTemplateElement} template Template to templatize
   * @param {Polymer_PropertyEffects=} owner Owner of the template instances;
   *   any optional callbacks will be bound to this owner.
   * @param {Object=} options Options dictionary (see summary for details)
   * @return {function(new:TemplateInstanceBase, Object=)} Generated class bound
   *   to the template provided
   * @suppress {invalidCasts}
   */
  function templatize(template, owner, options) {
    // Under strictTemplatePolicy, the templatized element must be owned
    // by a (trusted) Polymer element, indicated by existence of _methodHost;
    // e.g. for dom-if & dom-repeat in main document, _methodHost is null
    if (strictTemplatePolicy && !findMethodHost(template)) {
      throw new Error('strictTemplatePolicy: template owner not trusted');
    }
    options = /** @type {!TemplatizeOptions} */options || {};
    if (template.__templatizeOwner) {
      throw new Error('A <template> can only be templatized once');
    }
    template.__templatizeOwner = owner;
    const ctor = owner ? owner.constructor : TemplateInstanceBase;
    let templateInfo = ctor._parseTemplate(template);
    // Get memoized base class for the prototypical template, which
    // includes property effects for binding template & forwarding
    /**
     * @constructor
     * @extends {TemplateInstanceBase}
     */
    let baseClass = templateInfo.templatizeInstanceClass;
    if (!baseClass) {
      baseClass = createTemplatizerClass(template, templateInfo, options);
      templateInfo.templatizeInstanceClass = baseClass;
    }
    const methodHost = findMethodHost(template);
    // Host property forwarding must be installed onto template instance
    addPropagateEffects(template, templateInfo, options, methodHost);
    // Subclass base class and add reference for this specific template
    /** @private */
    let klass = /*#__PURE__*/function (_baseClass) {
      _inherits(TemplateInstance, _baseClass);
      var _super5 = _createSuper(TemplateInstance);
      function TemplateInstance() {
        _classCallCheck(this, TemplateInstance);
        return _super5.apply(this, arguments);
      }
      return _createClass(TemplateInstance);
    }(baseClass);
    /** @override */
    klass.prototype._methodHost = methodHost;
    /** @override */
    klass.prototype.__dataHost = /** @type {!DataTemplate} */template;
    /** @override */
    klass.prototype.__templatizeOwner = /** @type {!Object} */owner;
    /** @override */
    klass.prototype.__hostProps = templateInfo.hostProps;
    klass = /** @type {function(new:TemplateInstanceBase)} */klass; //eslint-disable-line no-self-assign
    return klass;
  }
  function warnOnUndeclaredProperties(templateInfo, options, methodHost) {
    const declaredProps = methodHost.constructor._properties;
    const {
      propertyEffects
    } = templateInfo;
    const {
      instanceProps
    } = options;
    for (let prop in propertyEffects) {
      // Ensure properties with template effects are declared on the outermost
      // host (`methodHost`), unless they are instance props or static functions
      if (!declaredProps[prop] && !(instanceProps && instanceProps[prop])) {
        const effects = propertyEffects[prop];
        for (let i = 0; i < effects.length; i++) {
          const {
            part
          } = effects[i].info;
          if (!(part.signature && part.signature.static)) {
            console.warn(`Property '${prop}' used in template but not ` + `declared in 'properties'; attribute will not be observed.`);
            break;
          }
        }
      }
    }
  }

  /**
   * Returns the template "model" associated with a given element, which
   * serves as the binding scope for the template instance the element is
   * contained in. A template model is an instance of
   * `TemplateInstanceBase`, and should be used to manipulate data
   * associated with this template instance.
   *
   * Example:
   *
   *   let model = modelForElement(el);
   *   if (model.index < 10) {
   *     model.set('item.checked', true);
   *   }
   *
   * @param {HTMLElement} template The model will be returned for
   *   elements stamped from this template (accepts either an HTMLTemplateElement)
   *   or a `<dom-if>`/`<dom-repeat>` element when using `removeNestedTemplates`
   *   optimization.
   * @param {Node=} node Node for which to return a template model.
   * @return {TemplateInstanceBase} Template instance representing the
   *   binding scope for the element
   */
  function modelForElement(template, node) {
    let model;
    while (node) {
      // An element with a __templatizeInstance marks the top boundary
      // of a scope; walk up until we find one, and then ensure that
      // its __dataHost matches `this`, meaning this dom-repeat stamped it
      if (model = node.__dataHost ? node : node.__templatizeInstance) {
        // Found an element stamped by another template; keep walking up
        // from its __dataHost
        if (model.__dataHost != template) {
          node = model.__dataHost;
        } else {
          return model;
        }
      } else {
        // Still in a template scope, keep going up until
        // a __templatizeInstance is found
        node = wrap(node).parentNode;
      }
    }
    return null;
  }

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  let elementsHidden = false;

  /**
   * @return {boolean} True if elements will be hidden globally
   */
  function hideElementsGlobally() {
    if (legacyOptimizations && !useShadow) {
      if (!elementsHidden) {
        elementsHidden = true;
        const style = document.createElement('style');
        style.textContent = 'dom-bind,dom-if,dom-repeat{display:none;}';
        document.head.appendChild(style);
      }
      return true;
    }
    return false;
  }

  /**
   * @constructor
   * @extends {HTMLElement}
   * @implements {Polymer_PropertyEffects}
   * @implements {Polymer_OptionalMutableData}
   * @implements {Polymer_GestureEventListeners}
   * @private
   */
  const domBindBase = GestureEventListeners(OptionalMutableData(PropertyEffects(HTMLElement)));

  /**
   * Custom element to allow using Polymer's template features (data binding,
   * declarative event listeners, etc.) in the main document without defining
   * a new custom element.
   *
   * `<template>` tags utilizing bindings may be wrapped with the `<dom-bind>`
   * element, which will immediately stamp the wrapped template into the main
   * document and bind elements to the `dom-bind` element itself as the
   * binding scope.
   *
   * @polymer
   * @customElement
   * @appliesMixin PropertyEffects
   * @appliesMixin OptionalMutableData
   * @appliesMixin GestureEventListeners
   * @extends {domBindBase}
   * @summary Custom element to allow using Polymer's template features (data
   *   binding, declarative event listeners, etc.) in the main document.
   */
  let DomBind = /*#__PURE__*/function (_domBindBase) {
    _inherits(DomBind, _domBindBase);
    var _super = _createSuper(DomBind);
    function DomBind() {
      var _this;
      _classCallCheck(this, DomBind);
      _this = _super.call(this);
      if (strictTemplatePolicy) {
        throw new Error(`strictTemplatePolicy: dom-bind not allowed`);
      }
      _this.root = null;
      _this.$ = null;
      _this.__children = null;
      return _this;
    }

    /* eslint-disable no-unused-vars */
    /**
     * @override
     * @param {string} name Name of attribute that changed
     * @param {?string} old Old attribute value
     * @param {?string} value New attribute value
     * @param {?string} namespace Attribute namespace.
     * @return {void}
     */
    _createClass(DomBind, [{
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, old, value, namespace) {
        // assumes only one observed attribute
        this.mutableData = true;
      }

      /**
       * @override
       * @return {void}
       */
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        if (!hideElementsGlobally()) {
          this.style.display = 'none';
        }
        this.render();
      }

      /**
       * @override
       * @return {void}
       */
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.__removeChildren();
      }
    }, {
      key: "__insertChildren",
      value: function __insertChildren() {
        wrap(wrap(this).parentNode).insertBefore(this.root, this);
      }
    }, {
      key: "__removeChildren",
      value: function __removeChildren() {
        if (this.__children) {
          for (let i = 0; i < this.__children.length; i++) {
            this.root.appendChild(this.__children[i]);
          }
        }
      }

      /**
       * Forces the element to render its content. This is typically only
       * necessary to call if HTMLImports with the async attribute are used.
       * @return {void}
       */
    }, {
      key: "render",
      value: function render() {
        let template;
        if (!this.__children) {
          template = /** @type {?HTMLTemplateElement} */template || this.querySelector('template');
          if (!template) {
            // Wait until childList changes and template should be there by then
            let observer = new MutationObserver(() => {
              template = /** @type {HTMLTemplateElement} */this.querySelector('template');
              if (template) {
                observer.disconnect();
                this.render();
              } else {
                throw new Error('dom-bind requires a <template> child');
              }
            });
            observer.observe(this, {
              childList: true
            });
            return;
          }
          this.root = this._stampTemplate( /** @type {!HTMLTemplateElement} */template);
          this.$ = this.root.$;
          this.__children = [];
          for (let n = this.root.firstChild; n; n = n.nextSibling) {
            this.__children[this.__children.length] = n;
          }
          this._enableProperties();
        }
        this.__insertChildren();
        this.dispatchEvent(new CustomEvent('dom-change', {
          bubbles: true,
          composed: true
        }));
      }
    }], [{
      key: "observedAttributes",
      get: function () {
        return ['mutable-data'];
      }
    }]);
    return DomBind;
  }(domBindBase);
  // customElements.define('dom-bind', DomBind);

  /**
   * Our TrustedTypePolicy for HTML which is declared using the Polymer html
   * template tag function.
   *
   * That HTML is a developer-authored constant, and is parsed with innerHTML
   * before any untrusted expressions have been mixed in. Therefor it is
   * considered safe by construction.
   *
   * @type {!TrustedTypePolicy|undefined}
   */
  const policy = window.trustedTypes && trustedTypes.createPolicy('polymer-html-literal', {
    createHTML: s => s
  });

  /**
   * Class representing a static string value which can be used to filter
   * strings by asseting that they have been created via this class. The
   * `value` property returns the string passed to the constructor.
   */
  let LiteralString = /*#__PURE__*/function () {
    /**
     * @param {!ITemplateArray} strings Constant parts of tagged template literal
     * @param {!Array<*>} values Variable parts of tagged template literal
     */
    function LiteralString(strings, values) {
      _classCallCheck(this, LiteralString);
      assertValidTemplateStringParameters(strings, values);
      const string = values.reduce((acc, v, idx) => acc + literalValue(v) + strings[idx + 1], strings[0]);
      /** @type {string} */
      this.value = string.toString();
    }
    /**
     * @return {string} LiteralString string value
     * @override
     */
    _createClass(LiteralString, [{
      key: "toString",
      value: function toString() {
        return this.value;
      }
    }]);
    return LiteralString;
  }(); /**
        * @param {*} value Object to stringify into HTML
        * @return {string} HTML stringified form of `obj`
        */
  function literalValue(value) {
    if (value instanceof LiteralString) {
      return (/** @type {!LiteralString} */value.value
      );
    } else {
      throw new Error(`non-literal value passed to Polymer's htmlLiteral function: ${value}`);
    }
  }

  /**
   * @param {*} value Object to stringify into HTML
   * @return {string} HTML stringified form of `obj`
   */
  function htmlValue(value) {
    if (value instanceof HTMLTemplateElement) {
      // This might be an mXSS risk – mainly in the case where this template
      // contains untrusted content that was believed to be sanitized.
      // However we can't just use the XMLSerializer here because it misencodes
      // `>` characters inside style tags.
      // For an example of an actual case that hit this encoding issue,
      // see b/198592167
      return (/** @type {!HTMLTemplateElement } */value.innerHTML
      );
    } else if (value instanceof LiteralString) {
      return literalValue(value);
    } else {
      throw new Error(`non-template value passed to Polymer's html function: ${value}`);
    }
  }

  /**
   * A template literal tag that creates an HTML <template> element from the
   * contents of the string.
   *
   * This allows you to write a Polymer Template in JavaScript.
   *
   * Templates can be composed by interpolating `HTMLTemplateElement`s in
   * expressions in the JavaScript template literal. The nested template's
   * `innerHTML` is included in the containing template.  The only other
   * values allowed in expressions are those returned from `htmlLiteral`
   * which ensures only literal values from JS source ever reach the HTML, to
   * guard against XSS risks.
   *
   * All other values are disallowed in expressions to help prevent XSS
   * attacks; however, `htmlLiteral` can be used to compose static
   * string values into templates. This is useful to compose strings into
   * places that do not accept html, like the css text of a `style`
   * element.
   *
   * Example:
   *
   *     static get template() {
   *       return html`
   *         <style>:host{ content:"..." }</style>
   *         <div class="shadowed">${this.partialTemplate}</div>
   *         ${super.template}
   *       `;
   *     }
   *     static get partialTemplate() { return html`<span>Partial!</span>`; }
   *
   * @param {!ITemplateArray} strings Constant parts of tagged template literal
   * @param {...*} values Variable parts of tagged template literal
   * @return {!HTMLTemplateElement} Constructed HTMLTemplateElement
   */
  const html = function html(strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    assertValidTemplateStringParameters(strings, values);
    const template = /** @type {!HTMLTemplateElement} */document.createElement('template');
    let value = values.reduce((acc, v, idx) => acc + htmlValue(v) + strings[idx + 1], strings[0]);
    if (policy) {
      value = policy.createHTML(value);
    }
    template.innerHTML = value;
    return template;
  };

  /**
   * @param {!ITemplateArray} strings Constant parts of tagged template literal
   * @param {!Array<*>} values Array of values from quasis
   */
  const assertValidTemplateStringParameters = (strings, values) => {
    // Note: if/when https://github.com/tc39/proposal-array-is-template-object
    // is standardized, use that instead when available, as it can perform an
    // unforgable check (though of course, the function itself can be forged).
    if (!Array.isArray(strings) || !Array.isArray(strings.raw) || values.length !== strings.length - 1) {
      // This is either caused by a browser bug, a compiler bug, or someone
      // calling the html template tag function as a regular function.
      //
      throw new TypeError('Invalid call to the html template tag');
    }
  };

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Base class that provides the core API for Polymer's meta-programming
   * features including template stamping, data-binding, attribute deserialization,
   * and property change observation.
   *
   * @customElement
   * @polymer
   * @constructor
   * @implements {Polymer_ElementMixin}
   * @extends HTMLElement
   * @appliesMixin ElementMixin
   * @summary Custom element base class that provides the core API for Polymer's
   *   key meta-programming features including template stamping, data-binding,
   *   attribute deserialization, and property change observation
   */
  const PolymerElement = ElementMixin(HTMLElement);

  /**
   * @constructor
   * @implements {Polymer_OptionalMutableData}
   * @extends {PolymerElement}
   * @private
   */
  const domRepeatBase = OptionalMutableData(PolymerElement);

  /**
   * The `<dom-repeat>` element will automatically stamp and binds one instance
   * of template content to each object in a user-provided array.
   * `dom-repeat` accepts an `items` property, and one instance of the template
   * is stamped for each item into the DOM at the location of the `dom-repeat`
   * element.  The `item` property will be set on each instance's binding
   * scope, thus templates should bind to sub-properties of `item`.
   *
   * Example:
   *
   * ```html
   * <dom-module id="employee-list">
   *
   *   <template>
   *
   *     <div> Employee list: </div>
   *     <dom-repeat items="{{employees}}">
   *       <template>
   *         <div>First name: <span>{{item.first}}</span></div>
   *         <div>Last name: <span>{{item.last}}</span></div>
   *       </template>
   *     </dom-repeat>
   *
   *   </template>
   *
   * </dom-module>
   * ```
   *
   * With the following custom element definition:
   *
   * ```js
   * class EmployeeList extends PolymerElement {
   *   static get is() { return 'employee-list'; }
   *   static get properties() {
   *     return {
   *       employees: {
   *         value() {
   *           return [
   *             {first: 'Bob', last: 'Smith'},
   *             {first: 'Sally', last: 'Johnson'},
   *             ...
   *           ];
   *         }
   *       }
   *     };
   *   }
   * }
   * ```
   *
   * Notifications for changes to items sub-properties will be forwarded to template
   * instances, which will update via the normal structured data notification system.
   *
   * Mutations to the `items` array itself should be made using the Array
   * mutation API's on the PropertyEffects mixin (`push`, `pop`, `splice`,
   * `shift`, `unshift`), and template instances will be kept in sync with the
   * data in the array.
   *
   * Events caught by event handlers within the `dom-repeat` template will be
   * decorated with a `model` property, which represents the binding scope for
   * each template instance.  The model should be used to manipulate data on the
   * instance, for example `event.model.set('item.checked', true);`.
   *
   * Alternatively, the model for a template instance for an element stamped by
   * a `dom-repeat` can be obtained using the `modelForElement` API on the
   * `dom-repeat` that stamped it, for example
   * `this.$.domRepeat.modelForElement(event.target).set('item.checked', true);`.
   * This may be useful for manipulating instance data of event targets obtained
   * by event handlers on parents of the `dom-repeat` (event delegation).
   *
   * A view-specific filter/sort may be applied to each `dom-repeat` by supplying a
   * `filter` and/or `sort` property.  This may be a string that names a function on
   * the host, or a function may be assigned to the property directly.  The functions
   * should implemented following the standard `Array` filter/sort API.
   *
   * In order to re-run the filter or sort functions based on changes to sub-fields
   * of `items`, the `observe` property may be set as a space-separated list of
   * `item` sub-fields that should cause a re-filter/sort when modified.  If
   * the filter or sort function depends on properties not contained in `items`,
   * the user should observe changes to those properties and call `render` to update
   * the view based on the dependency change.
   *
   * For example, for an `dom-repeat` with a filter of the following:
   *
   * ```js
   * isEngineer(item) {
   *   return item.type == 'engineer' || item.manager.type == 'engineer';
   * }
   * ```
   *
   * Then the `observe` property should be configured as follows:
   *
   * ```html
   * <dom-repeat items="{{employees}}" filter="isEngineer" observe="type manager.type">
   * ```
   *
   * @customElement
   * @polymer
   * @extends {domRepeatBase}
   * @appliesMixin OptionalMutableData
   * @summary Custom element for stamping instance of a template bound to
   *   items in an array.
   */
  let DomRepeat = /*#__PURE__*/function (_domRepeatBase) {
    _inherits(DomRepeat, _domRepeatBase);
    var _super = _createSuper(DomRepeat);
    function DomRepeat() {
      var _this;
      _classCallCheck(this, DomRepeat);
      _this = _super.call(this);
      _this.__instances = [];
      _this.__renderDebouncer = null;
      _this.__itemsIdxToInstIdx = {};
      _this.__chunkCount = null;
      _this.__renderStartTime = null;
      _this.__itemsArrayChanged = false;
      _this.__shouldMeasureChunk = false;
      _this.__shouldContinueChunking = false;
      _this.__chunkingId = 0;
      _this.__sortFn = null;
      _this.__filterFn = null;
      _this.__observePaths = null;
      /** @type {?function(new:TemplateInstanceBase, Object=)} */
      _this.__ctor = null;
      _this.__isDetached = true;
      _this.template = null;
      /** @type {TemplateInfo} */
      _this._templateInfo;
      return _this;
    }

    /**
     * @override
     * @return {void}
     */
    _createClass(DomRepeat, [{
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(DomRepeat.prototype), "disconnectedCallback", this).call(this);
        this.__isDetached = true;
        for (let i = 0; i < this.__instances.length; i++) {
          this.__detachInstance(i);
        }
        // Stop chunking if one was in progress
        if (this.__chunkingId) {
          cancelAnimationFrame(this.__chunkingId);
        }
      }

      /**
       * @override
       * @return {void}
       */
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(DomRepeat.prototype), "connectedCallback", this).call(this);
        if (!hideElementsGlobally()) {
          this.style.display = 'none';
        }
        // only perform attachment if the element was previously detached.
        if (this.__isDetached) {
          this.__isDetached = false;
          let wrappedParent = wrap(wrap(this).parentNode);
          for (let i = 0; i < this.__instances.length; i++) {
            this.__attachInstance(i, wrappedParent);
          }
          // Restart chunking if one was in progress when disconnected
          if (this.__chunkingId) {
            this.__render();
          }
        }
      }
    }, {
      key: "__ensureTemplatized",
      value: function __ensureTemplatized() {
        // Templatizing (generating the instance constructor) needs to wait
        // until ready, since won't have its template content handed back to
        // it until then
        if (!this.__ctor) {
          // When `removeNestedTemplates` is true, the "template" is the element
          // itself, which has been given a `_templateInfo` property
          const thisAsTemplate = /** @type {!HTMLTemplateElement} */
          /** @type {!HTMLElement} */this;
          let template = this.template = thisAsTemplate._templateInfo ? thisAsTemplate : /** @type {!HTMLTemplateElement} */this.querySelector('template');
          if (!template) {
            // Wait until childList changes and template should be there by then
            let observer = new MutationObserver(() => {
              if (this.querySelector('template')) {
                observer.disconnect();
                this.__render();
              } else {
                throw new Error('dom-repeat requires a <template> child');
              }
            });
            observer.observe(this, {
              childList: true
            });
            return false;
          }
          // Template instance props that should be excluded from forwarding
          let instanceProps = {};
          instanceProps[this.as] = true;
          instanceProps[this.indexAs] = true;
          instanceProps[this.itemsIndexAs] = true;
          this.__ctor = templatize(template, this, {
            mutableData: this.mutableData,
            parentModel: true,
            instanceProps: instanceProps,
            /**
             * @this {DomRepeat}
             * @param {string} prop Property to set
             * @param {*} value Value to set property to
             */
            forwardHostProp: function (prop, value) {
              let i$ = this.__instances;
              for (let i = 0, inst; i < i$.length && (inst = i$[i]); i++) {
                inst.forwardHostProp(prop, value);
              }
            },
            /**
             * @this {DomRepeat}
             * @param {Object} inst Instance to notify
             * @param {string} prop Property to notify
             * @param {*} value Value to notify
             */
            notifyInstanceProp: function (inst, prop, value) {
              if (matches$2(this.as, prop)) {
                let idx = inst[this.itemsIndexAs];
                if (prop == this.as) {
                  this.items[idx] = value;
                }
                let path = translate(this.as, `${JSCompiler_renameProperty('items', this)}.${idx}`, prop);
                this.notifyPath(path, value);
              }
            }
          });
        }
        return true;
      }
    }, {
      key: "__getMethodHost",
      value: function __getMethodHost() {
        // Technically this should be the owner of the outermost template.
        // In shadow dom, this is always getRootNode().host, but we can
        // approximate this via cooperation with our dataHost always setting
        // `_methodHost` as long as there were bindings (or id's) on this
        // instance causing it to get a dataHost.
        return this.__dataHost._methodHost || this.__dataHost;
      }
    }, {
      key: "__functionFromPropertyValue",
      value: function __functionFromPropertyValue(functionOrMethodName) {
        if (typeof functionOrMethodName === 'string') {
          let methodName = functionOrMethodName;
          let obj = this.__getMethodHost();
          return function () {
            return obj[methodName].apply(obj, arguments);
          };
        }
        return functionOrMethodName;
      }
    }, {
      key: "__sortChanged",
      value: function __sortChanged(sort) {
        this.__sortFn = this.__functionFromPropertyValue(sort);
        if (this.items) {
          this.__debounceRender(this.__render);
        }
      }
    }, {
      key: "__filterChanged",
      value: function __filterChanged(filter) {
        this.__filterFn = this.__functionFromPropertyValue(filter);
        if (this.items) {
          this.__debounceRender(this.__render);
        }
      }
    }, {
      key: "__computeFrameTime",
      value: function __computeFrameTime(rate) {
        return Math.ceil(1000 / rate);
      }
    }, {
      key: "__observeChanged",
      value: function __observeChanged() {
        this.__observePaths = this.observe && this.observe.replace('.*', '.').split(' ');
      }
    }, {
      key: "__handleObservedPaths",
      value: function __handleObservedPaths(path) {
        // Handle cases where path changes should cause a re-sort/filter
        if (this.__sortFn || this.__filterFn) {
          if (!path) {
            // Always re-render if the item itself changed
            this.__debounceRender(this.__render, this.delay);
          } else if (this.__observePaths) {
            // Otherwise, re-render if the path changed matches an observed path
            let paths = this.__observePaths;
            for (let i = 0; i < paths.length; i++) {
              if (path.indexOf(paths[i]) === 0) {
                this.__debounceRender(this.__render, this.delay);
              }
            }
          }
        }
      }
    }, {
      key: "__itemsChanged",
      value: function __itemsChanged(change) {
        if (this.items && !Array.isArray(this.items)) {
          console.warn('dom-repeat expected array for `items`, found', this.items);
        }
        // If path was to an item (e.g. 'items.3' or 'items.3.foo'), forward the
        // path to that instance synchronously (returns false for non-item paths)
        if (!this.__handleItemPath(change.path, change.value)) {
          // Otherwise, the array was reset ('items') or spliced ('items.splices'),
          // so queue a render.  Restart chunking when the items changed (for
          // backward compatibility), unless `reuseChunkedInstances` option is set
          if (change.path === 'items') {
            this.__itemsArrayChanged = true;
          }
          this.__debounceRender(this.__render);
        }
      }

      /**
       * @param {function(this:DomRepeat)} fn Function to debounce.
       * @param {number=} delay Delay in ms to debounce by.
       */
    }, {
      key: "__debounceRender",
      value: function __debounceRender(fn) {
        let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.__renderDebouncer = Debouncer.debounce(this.__renderDebouncer, delay > 0 ? timeOut.after(delay) : microTask, fn.bind(this));
        enqueueDebouncer(this.__renderDebouncer);
      }

      /**
       * Forces the element to render its content. Normally rendering is
       * asynchronous to a provoking change. This is done for efficiency so
       * that multiple changes trigger only a single render. The render method
       * should be called if, for example, template rendering is required to
       * validate application state.
       * @return {void}
       */
    }, {
      key: "render",
      value: function render() {
        // Queue this repeater, then flush all in order
        this.__debounceRender(this.__render);
        flush();
      }
    }, {
      key: "__render",
      value: function __render() {
        if (!this.__ensureTemplatized()) {
          // No template found yet
          return;
        }
        let items = this.items || [];
        // Sort and filter the items into a mapping array from instance->item
        const isntIdxToItemsIdx = this.__sortAndFilterItems(items);
        // If we're chunking, increase the limit if there are new instances to
        // create and schedule the next chunk
        const limit = this.__calculateLimit(isntIdxToItemsIdx.length);
        // Create, update, and/or remove instances
        this.__updateInstances(items, limit, isntIdxToItemsIdx);
        // If we're chunking, schedule a rAF task to measure/continue chunking.
        // Do this before any notifying events (renderedItemCount & dom-change)
        // since those could modify items and enqueue a new full render which will
        // pre-empt this measurement.
        if (this.initialCount && (this.__shouldMeasureChunk || this.__shouldContinueChunking)) {
          cancelAnimationFrame(this.__chunkingId);
          this.__chunkingId = requestAnimationFrame(() => {
            this.__chunkingId = null;
            this.__continueChunking();
          });
        }
        // Set rendered item count
        this._setRenderedItemCount(this.__instances.length);
        // Notify users
        if (!suppressTemplateNotifications || this.notifyDomChange) {
          this.dispatchEvent(new CustomEvent('dom-change', {
            bubbles: true,
            composed: true
          }));
        }
      }
    }, {
      key: "__sortAndFilterItems",
      value: function __sortAndFilterItems(items) {
        // Generate array maping the instance index to the items array index
        let isntIdxToItemsIdx = new Array(items.length);
        for (let i = 0; i < items.length; i++) {
          isntIdxToItemsIdx[i] = i;
        }
        // Apply user filter
        if (this.__filterFn) {
          isntIdxToItemsIdx = isntIdxToItemsIdx.filter((i, idx, array) => this.__filterFn(items[i], idx, array));
        }
        // Apply user sort
        if (this.__sortFn) {
          isntIdxToItemsIdx.sort((a, b) => this.__sortFn(items[a], items[b]));
        }
        return isntIdxToItemsIdx;
      }
    }, {
      key: "__calculateLimit",
      value: function __calculateLimit(filteredItemCount) {
        let limit = filteredItemCount;
        const currentCount = this.__instances.length;
        // When chunking, we increase the limit from the currently rendered count
        // by the chunk count that is re-calculated after each rAF (with special
        // cases for resetting the limit to initialCount after changing items)
        if (this.initialCount) {
          let newCount;
          if (!this.__chunkCount || this.__itemsArrayChanged && !this.reuseChunkedInstances) {
            // Limit next render to the initial count
            limit = Math.min(filteredItemCount, this.initialCount);
            // Subtract off any existing instances to determine the number of
            // instances that will be created
            newCount = Math.max(limit - currentCount, 0);
            // Initialize the chunk size with how many items we're creating
            this.__chunkCount = newCount || 1;
          } else {
            // The number of new instances that will be created is based on the
            // existing instances, the new list size, and the chunk size
            newCount = Math.min(Math.max(filteredItemCount - currentCount, 0), this.__chunkCount);
            // Update the limit based on how many new items we're making, limited
            // buy the total size of the list
            limit = Math.min(currentCount + newCount, filteredItemCount);
          }
          // Record some state about chunking for use in `__continueChunking`
          this.__shouldMeasureChunk = newCount === this.__chunkCount;
          this.__shouldContinueChunking = limit < filteredItemCount;
          this.__renderStartTime = performance.now();
        }
        this.__itemsArrayChanged = false;
        return limit;
      }
    }, {
      key: "__continueChunking",
      value: function __continueChunking() {
        // Simple auto chunkSize throttling algorithm based on feedback loop:
        // measure actual time between frames and scale chunk count by ratio of
        // target/actual frame time.  Only modify chunk size if our measurement
        // reflects the cost of a creating a full chunk's worth of instances; this
        // avoids scaling up the chunk size if we e.g. quickly re-rendered instances
        // in place
        if (this.__shouldMeasureChunk) {
          const renderTime = performance.now() - this.__renderStartTime;
          const ratio = this._targetFrameTime / renderTime;
          this.__chunkCount = Math.round(this.__chunkCount * ratio) || 1;
        }
        // Enqueue a new render if we haven't reached the full size of the list
        if (this.__shouldContinueChunking) {
          this.__debounceRender(this.__render);
        }
      }
    }, {
      key: "__updateInstances",
      value: function __updateInstances(items, limit, isntIdxToItemsIdx) {
        // items->inst map kept for item path forwarding
        const itemsIdxToInstIdx = this.__itemsIdxToInstIdx = {};
        let instIdx;
        // Generate instances and assign items
        for (instIdx = 0; instIdx < limit; instIdx++) {
          let inst = this.__instances[instIdx];
          let itemIdx = isntIdxToItemsIdx[instIdx];
          let item = items[itemIdx];
          itemsIdxToInstIdx[itemIdx] = instIdx;
          if (inst) {
            inst._setPendingProperty(this.as, item);
            inst._setPendingProperty(this.indexAs, instIdx);
            inst._setPendingProperty(this.itemsIndexAs, itemIdx);
            inst._flushProperties();
          } else {
            this.__insertInstance(item, instIdx, itemIdx);
          }
        }
        // Remove any extra instances from previous state
        for (let i = this.__instances.length - 1; i >= instIdx; i--) {
          this.__detachAndRemoveInstance(i);
        }
      }
    }, {
      key: "__detachInstance",
      value: function __detachInstance(idx) {
        let inst = this.__instances[idx];
        const wrappedRoot = wrap(inst.root);
        for (let i = 0; i < inst.children.length; i++) {
          let el = inst.children[i];
          wrappedRoot.appendChild(el);
        }
        return inst;
      }
    }, {
      key: "__attachInstance",
      value: function __attachInstance(idx, parent) {
        let inst = this.__instances[idx];
        // Note, this is pre-wrapped as an optimization
        parent.insertBefore(inst.root, this);
      }
    }, {
      key: "__detachAndRemoveInstance",
      value: function __detachAndRemoveInstance(idx) {
        this.__detachInstance(idx);
        this.__instances.splice(idx, 1);
      }
    }, {
      key: "__stampInstance",
      value: function __stampInstance(item, instIdx, itemIdx) {
        let model = {};
        model[this.as] = item;
        model[this.indexAs] = instIdx;
        model[this.itemsIndexAs] = itemIdx;
        return new this.__ctor(model);
      }
    }, {
      key: "__insertInstance",
      value: function __insertInstance(item, instIdx, itemIdx) {
        const inst = this.__stampInstance(item, instIdx, itemIdx);
        let beforeRow = this.__instances[instIdx + 1];
        let beforeNode = beforeRow ? beforeRow.children[0] : this;
        wrap(wrap(this).parentNode).insertBefore(inst.root, beforeNode);
        this.__instances[instIdx] = inst;
        return inst;
      }

      // Implements extension point from Templatize mixin
      /**
       * Shows or hides the template instance top level child elements. For
       * text nodes, `textContent` is removed while "hidden" and replaced when
       * "shown."
       * @param {boolean} hidden Set to true to hide the children;
       * set to false to show them.
       * @return {void}
       * @protected
       */
    }, {
      key: "_showHideChildren",
      value: function _showHideChildren(hidden) {
        for (let i = 0; i < this.__instances.length; i++) {
          this.__instances[i]._showHideChildren(hidden);
        }
      }

      // Called as a side effect of a host items.<key>.<path> path change,
      // responsible for notifying item.<path> changes to inst for key
    }, {
      key: "__handleItemPath",
      value: function __handleItemPath(path, value) {
        let itemsPath = path.slice(6); // 'items.'.length == 6
        let dot = itemsPath.indexOf('.');
        let itemsIdx = dot < 0 ? itemsPath : itemsPath.substring(0, dot);
        // If path was index into array...
        if (itemsIdx == parseInt(itemsIdx, 10)) {
          let itemSubPath = dot < 0 ? '' : itemsPath.substring(dot + 1);
          // If the path is observed, it will trigger a full refresh
          this.__handleObservedPaths(itemSubPath);
          // Note, even if a rull refresh is triggered, always do the path
          // notification because unless mutableData is used for dom-repeat
          // and all elements in the instance subtree, a full refresh may
          // not trigger the proper update.
          let instIdx = this.__itemsIdxToInstIdx[itemsIdx];
          let inst = this.__instances[instIdx];
          if (inst) {
            let itemPath = this.as + (itemSubPath ? '.' + itemSubPath : '');
            // This is effectively `notifyPath`, but avoids some of the overhead
            // of the public API
            inst._setPendingPropertyOrPath(itemPath, value, false, true);
            inst._flushProperties();
          }
          return true;
        }
      }

      /**
       * Returns the item associated with a given element stamped by
       * this `dom-repeat`.
       *
       * Note, to modify sub-properties of the item,
       * `modelForElement(el).set('item.<sub-prop>', value)`
       * should be used.
       *
       * @param {!HTMLElement} el Element for which to return the item.
       * @return {*} Item associated with the element.
       */
    }, {
      key: "itemForElement",
      value: function itemForElement(el) {
        let instance = this.modelForElement(el);
        return instance && instance[this.as];
      }

      /**
       * Returns the inst index for a given element stamped by this `dom-repeat`.
       * If `sort` is provided, the index will reflect the sorted order (rather
       * than the original array order).
       *
       * @param {!HTMLElement} el Element for which to return the index.
       * @return {?number} Row index associated with the element (note this may
       *   not correspond to the array index if a user `sort` is applied).
       */
    }, {
      key: "indexForElement",
      value: function indexForElement(el) {
        let instance = this.modelForElement(el);
        return instance && instance[this.indexAs];
      }

      /**
       * Returns the template "model" associated with a given element, which
       * serves as the binding scope for the template instance the element is
       * contained in. A template model
       * should be used to manipulate data associated with this template instance.
       *
       * Example:
       *
       *   let model = modelForElement(el);
       *   if (model.index < 10) {
       *     model.set('item.checked', true);
       *   }
       *
       * @param {!HTMLElement} el Element for which to return a template model.
       * @return {TemplateInstanceBase} Model representing the binding scope for
       *   the element.
       */
    }, {
      key: "modelForElement",
      value: function modelForElement$1(el) {
        return modelForElement(this.template, el);
      }
    }], [{
      key: "is",
      get:
      // Not needed to find template; can be removed once the analyzer
      // can find the tag name from customElements.define call
      function () {
        return 'dom-repeat';
      }
    }, {
      key: "template",
      get: function () {
        return null;
      }
    }, {
      key: "properties",
      get: function () {
        /**
         * Fired whenever DOM is added or removed by this template (by
         * default, rendering occurs lazily).  To force immediate rendering, call
         * `render`.
         *
         * @event dom-change
         */
        return {
          /**
           * An array containing items determining how many instances of the template
           * to stamp and that that each template instance should bind to.
           */
          items: {
            type: Array
          },
          /**
           * The name of the variable to add to the binding scope for the array
           * element associated with a given template instance.
           */
          as: {
            type: String,
            value: 'item'
          },
          /**
           * The name of the variable to add to the binding scope with the index
           * of the instance in the sorted and filtered list of rendered items.
           * Note, for the index in the `this.items` array, use the value of the
           * `itemsIndexAs` property.
           */
          indexAs: {
            type: String,
            value: 'index'
          },
          /**
           * The name of the variable to add to the binding scope with the index
           * of the instance in the `this.items` array. Note, for the index of
           * this instance in the sorted and filtered list of rendered items,
           * use the value of the `indexAs` property.
           */
          itemsIndexAs: {
            type: String,
            value: 'itemsIndex'
          },
          /**
           * A function that should determine the sort order of the items.  This
           * property should either be provided as a string, indicating a method
           * name on the element's host, or else be an actual function.  The
           * function should match the sort function passed to `Array.sort`.
           * Using a sort function has no effect on the underlying `items` array.
           */
          sort: {
            type: Function,
            observer: '__sortChanged'
          },
          /**
           * A function that can be used to filter items out of the view.  This
           * property should either be provided as a string, indicating a method
           * name on the element's host, or else be an actual function.  The
           * function should match the sort function passed to `Array.filter`.
           * Using a filter function has no effect on the underlying `items` array.
           */
          filter: {
            type: Function,
            observer: '__filterChanged'
          },
          /**
           * When using a `filter` or `sort` function, the `observe` property
           * should be set to a space-separated list of the names of item
           * sub-fields that should trigger a re-sort or re-filter when changed.
           * These should generally be fields of `item` that the sort or filter
           * function depends on.
           */
          observe: {
            type: String,
            observer: '__observeChanged'
          },
          /**
           * When using a `filter` or `sort` function, the `delay` property
           * determines a debounce time in ms after a change to observed item
           * properties that must pass before the filter or sort is re-run.
           * This is useful in rate-limiting shuffling of the view when
           * item changes may be frequent.
           */
          delay: Number,
          /**
           * Count of currently rendered items after `filter` (if any) has been applied.
           * If "chunking mode" is enabled, `renderedItemCount` is updated each time a
           * set of template instances is rendered.
           *
           */
          renderedItemCount: {
            type: Number,
            notify: !suppressTemplateNotifications,
            readOnly: true
          },
          /**
           * When greater than zero, defines an initial count of template instances
           * to render after setting the `items` array, before the next paint, and
           * puts the `dom-repeat` into "chunking mode".  The remaining items (and
           * any future items as a result of pushing onto the array) will be created
           * and rendered incrementally at each animation frame thereof until all
           * instances have been rendered.
           */
          initialCount: {
            type: Number
          },
          /**
           * When `initialCount` is used, this property defines a frame rate (in
           * fps) to target by throttling the number of instances rendered each
           * frame to not exceed the budget for the target frame rate.  The
           * framerate is effectively the number of `requestAnimationFrame`s that
           * it tries to allow to actually fire in a given second. It does this
           * by measuring the time between `rAF`s and continuously adjusting the
           * number of items created each `rAF` to maintain the target framerate.
           * Setting this to a higher number allows lower latency and higher
           * throughput for event handlers and other tasks, but results in a
           * longer time for the remaining items to complete rendering.
           */
          targetFramerate: {
            type: Number,
            value: 20
          },
          _targetFrameTime: {
            type: Number,
            computed: '__computeFrameTime(targetFramerate)'
          },
          /**
           * When the global `suppressTemplateNotifications` setting is used, setting
           * `notifyDomChange: true` will enable firing `dom-change` events on this
           * element.
           */
          notifyDomChange: {
            type: Boolean
          },
          /**
           * When chunking is enabled via `initialCount` and the `items` array is
           * set to a new array, this flag controls whether the previously rendered
           * instances are reused or not.
           *
           * When `true`, any previously rendered template instances are updated in
           * place to their new item values synchronously in one shot, and then any
           * further items (if any) are chunked out.  When `false`, the list is
           * returned back to its `initialCount` (any instances over the initial
           * count are discarded) and the remainder of the list is chunked back in.
           * Set this to `true` to avoid re-creating the list and losing scroll
           * position, although note that when changing the list to completely
           * different data the render thread will be blocked until all existing
           * instances are updated to their new data.
           */
          reuseChunkedInstances: {
            type: Boolean
          }
        };
      }
    }, {
      key: "observers",
      get: function () {
        return ['__itemsChanged(items.*)'];
      }
    }]);
    return DomRepeat;
  }(domRepeatBase);
  // customElements.define(DomRepeat.is, DomRepeat);

  /**
   * @customElement
   * @polymer
   * @extends PolymerElement
   * @summary Base class for dom-if element; subclassed into concrete
   *   implementation.
   */
  let DomIfBase = /*#__PURE__*/function (_PolymerElement) {
    _inherits(DomIfBase, _PolymerElement);
    var _super = _createSuper(DomIfBase);
    function DomIfBase() {
      var _this;
      _classCallCheck(this, DomIfBase);
      _this = _super.call(this);
      _this.__renderDebouncer = null;
      _this._lastIf = false;
      _this.__hideTemplateChildren__ = false;
      /** @type {!HTMLTemplateElement|undefined} */
      _this.__template;
      /** @type {!TemplateInfo|undefined} */
      _this._templateInfo;
      return _this;
    }
    _createClass(DomIfBase, [{
      key: "__debounceRender",
      value: function __debounceRender() {
        // Render is async for 2 reasons:
        // 1. To eliminate dom creation trashing if user code thrashes `if` in the
        //    same turn. This was more common in 1.x where a compound computed
        //    property could result in the result changing multiple times, but is
        //    mitigated to a large extent by batched property processing in 2.x.
        // 2. To avoid double object propagation when a bag including values bound
        //    to the `if` property as well as one or more hostProps could enqueue
        //    the <dom-if> to flush before the <template>'s host property
        //    forwarding. In that scenario creating an instance would result in
        //    the host props being set once, and then the enqueued changes on the
        //    template would set properties a second time, potentially causing an
        //    object to be set to an instance more than once.  Creating the
        //    instance async from flushing data ensures this doesn't happen. If
        //    we wanted a sync option in the future, simply having <dom-if> flush
        //    (or clear) its template's pending host properties before creating
        //    the instance would also avoid the problem.
        this.__renderDebouncer = Debouncer.debounce(this.__renderDebouncer, microTask, () => this.__render());
        enqueueDebouncer(this.__renderDebouncer);
      }

      /**
       * @override
       * @return {void}
       */
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(DomIfBase.prototype), "disconnectedCallback", this).call(this);
        const parent = wrap(this).parentNode;
        if (!parent || parent.nodeType == Node.DOCUMENT_FRAGMENT_NODE && !wrap(parent).host) {
          this.__teardownInstance();
        }
      }

      /**
       * @override
       * @return {void}
       */
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(DomIfBase.prototype), "connectedCallback", this).call(this);
        if (!hideElementsGlobally()) {
          this.style.display = 'none';
        }
        if (this.if) {
          this.__debounceRender();
        }
      }

      /**
       * Ensures a template has been assigned to `this.__template`.  If it has not
       * yet been, it querySelectors for it in its children and if it does not yet
       * exist (e.g. in parser-generated case), opens a mutation observer and
       * waits for it to appear (returns false if it has not yet been found,
       * otherwise true).  In the `removeNestedTemplates` case, the "template" will
       * be the `dom-if` element itself.
       *
       * @return {boolean} True when a template has been found, false otherwise
       */
    }, {
      key: "__ensureTemplate",
      value: function __ensureTemplate() {
        if (!this.__template) {
          // When `removeNestedTemplates` is true, the "template" is the element
          // itself, which has been given a `_templateInfo` property
          const thisAsTemplate = /** @type {!HTMLTemplateElement} */
          /** @type {!HTMLElement} */this;
          let template = thisAsTemplate._templateInfo ? thisAsTemplate : /** @type {!HTMLTemplateElement} */
          wrap(thisAsTemplate).querySelector('template');
          if (!template) {
            // Wait until childList changes and template should be there by then
            let observer = new MutationObserver(() => {
              if (wrap(this).querySelector('template')) {
                observer.disconnect();
                this.__render();
              } else {
                throw new Error('dom-if requires a <template> child');
              }
            });
            observer.observe(this, {
              childList: true
            });
            return false;
          }
          this.__template = template;
        }
        return true;
      }

      /**
       * Ensures a an instance of the template has been created and inserted. This
       * method may return false if the template has not yet been found or if
       * there is no `parentNode` to insert the template into (in either case,
       * connection or the template-finding mutation observer firing will queue
       * another render, causing this method to be called again at a more
       * appropriate time).
       *
       * Subclasses should implement the following methods called here:
       * - `__hasInstance`
       * - `__createAndInsertInstance`
       * - `__getInstanceNodes`
       *
       * @return {boolean} True if the instance was created, false otherwise.
       */
    }, {
      key: "__ensureInstance",
      value: function __ensureInstance() {
        let parentNode = wrap(this).parentNode;
        if (!this.__hasInstance()) {
          // Guard against element being detached while render was queued
          if (!parentNode) {
            return false;
          }
          // Find the template (when false, there was no template yet)
          if (!this.__ensureTemplate()) {
            return false;
          }
          this.__createAndInsertInstance(parentNode);
        } else {
          // Move instance children if necessary
          let children = this.__getInstanceNodes();
          if (children && children.length) {
            // Detect case where dom-if was re-attached in new position
            let lastChild = wrap(this).previousSibling;
            if (lastChild !== children[children.length - 1]) {
              for (let i = 0, n; i < children.length && (n = children[i]); i++) {
                wrap(parentNode).insertBefore(n, this);
              }
            }
          }
        }
        return true;
      }

      /**
       * Forces the element to render its content. Normally rendering is
       * asynchronous to a provoking change. This is done for efficiency so
       * that multiple changes trigger only a single render. The render method
       * should be called if, for example, template rendering is required to
       * validate application state.
       *
       * @return {void}
       */
    }, {
      key: "render",
      value: function render() {
        flush();
      }

      /**
       * Performs the key rendering steps:
       * 1. Ensure a template instance has been stamped (when true)
       * 2. Remove the template instance (when false and restamp:true)
       * 3. Sync the hidden state of the instance nodes with the if/restamp state
       * 4. Fires the `dom-change` event when necessary
       *
       * @return {void}
       */
    }, {
      key: "__render",
      value: function __render() {
        if (this.if) {
          if (!this.__ensureInstance()) {
            // No template found yet
            return;
          }
        } else if (this.restamp) {
          this.__teardownInstance();
        }
        this._showHideChildren();
        if ((!suppressTemplateNotifications || this.notifyDomChange) && this.if != this._lastIf) {
          this.dispatchEvent(new CustomEvent('dom-change', {
            bubbles: true,
            composed: true
          }));
          this._lastIf = this.if;
        }
      }

      // Ideally these would be annotated as abstract methods in an abstract class,
      // but closure compiler is finnicky
      /* eslint-disable valid-jsdoc */
      /**
       * Abstract API to be implemented by subclass: Returns true if a template
       * instance has been created and inserted.
       *
       * @protected
       * @return {boolean} True when an instance has been created.
       */
    }, {
      key: "__hasInstance",
      value: function __hasInstance() {}

      /**
       * Abstract API to be implemented by subclass: Returns the child nodes stamped
       * from a template instance.
       *
       * @protected
       * @return {Array<Node>} Array of child nodes stamped from the template
       * instance.
       */
    }, {
      key: "__getInstanceNodes",
      value: function __getInstanceNodes() {}

      /**
       * Abstract API to be implemented by subclass: Creates an instance of the
       * template and inserts it into the given parent node.
       *
       * @protected
       * @param {Node} parentNode The parent node to insert the instance into
       * @return {void}
       */
    }, {
      key: "__createAndInsertInstance",
      value: function __createAndInsertInstance(parentNode) {} // eslint-disable-line no-unused-vars

      /**
       * Abstract API to be implemented by subclass: Removes nodes created by an
       * instance of a template and any associated cleanup.
       *
       * @protected
       * @return {void}
       */
    }, {
      key: "__teardownInstance",
      value: function __teardownInstance() {}

      /**
       * Abstract API to be implemented by subclass: Shows or hides any template
       * instance childNodes based on the `if` state of the element and its
       * `__hideTemplateChildren__` property.
       *
       * @protected
       * @return {void}
       */
    }, {
      key: "_showHideChildren",
      value: function _showHideChildren() {}
      /* eslint-enable valid-jsdoc */
    }], [{
      key: "is",
      get:
      // Not needed to find template; can be removed once the analyzer
      // can find the tag name from customElements.define call
      function () {
        return 'dom-if';
      }
    }, {
      key: "template",
      get: function () {
        return null;
      }
    }, {
      key: "properties",
      get: function () {
        return {
          /**
           * Fired whenever DOM is added or removed/hidden by this template (by
           * default, rendering occurs lazily).  To force immediate rendering, call
           * `render`.
           *
           * @event dom-change
           */

          /**
           * A boolean indicating whether this template should stamp.
           */
          if: {
            type: Boolean,
            observer: '__debounceRender'
          },
          /**
           * When true, elements will be removed from DOM and discarded when `if`
           * becomes false and re-created and added back to the DOM when `if`
           * becomes true.  By default, stamped elements will be hidden but left
           * in the DOM when `if` becomes false, which is generally results
           * in better performance.
           */
          restamp: {
            type: Boolean,
            observer: '__debounceRender'
          },
          /**
           * When the global `suppressTemplateNotifications` setting is used, setting
           * `notifyDomChange: true` will enable firing `dom-change` events on this
           * element.
           */
          notifyDomChange: {
            type: Boolean
          }
        };
      }
    }]);
    return DomIfBase;
  }(PolymerElement); /**
                      * The version of DomIf used when `fastDomIf` setting is in use, which is
                      * optimized for first-render (but adds a tax to all subsequent property updates
                      * on the host, whether they were used in a given `dom-if` or not).
                      *
                      * This implementation avoids use of `Templatizer`, which introduces a new scope
                      * (a non-element PropertyEffects instance), which is not strictly necessary
                      * since `dom-if` never introduces new properties to its scope (unlike
                      * `dom-repeat`). Taking advantage of this fact, the `dom-if` reaches up to its
                      * `__dataHost` and stamps the template directly from the host using the host's
                      * runtime `_stampTemplate` API, which binds the property effects of the
                      * template directly to the host. This both avoids the intermediary
                      * `Templatizer` instance, but also avoids the need to bind host properties to
                      * the `<template>` element and forward those into the template instance.
                      *
                      * In this version of `dom-if`, the `this.__instance` method is the
                      * `DocumentFragment` returned from `_stampTemplate`, which also serves as the
                      * handle for later removing it using the `_removeBoundDom` method.
                      */
  let DomIfFast = /*#__PURE__*/function (_DomIfBase) {
    _inherits(DomIfFast, _DomIfBase);
    var _super2 = _createSuper(DomIfFast);
    function DomIfFast() {
      var _this2;
      _classCallCheck(this, DomIfFast);
      _this2 = _super2.call(this);
      _this2.__instance = null;
      _this2.__syncInfo = null;
      return _this2;
    }

    /**
     * Implementation of abstract API needed by DomIfBase.
     *
     * @override
     * @return {boolean} True when an instance has been created.
     */
    _createClass(DomIfFast, [{
      key: "__hasInstance",
      value: function __hasInstance() {
        return Boolean(this.__instance);
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * @override
       * @return {Array<Node>} Array of child nodes stamped from the template
       * instance.
       */
    }, {
      key: "__getInstanceNodes",
      value: function __getInstanceNodes() {
        return this.__instance.templateInfo.childNodes;
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * Stamps the template by calling `_stampTemplate` on the `__dataHost` of this
       * element and then inserts the resulting nodes into the given `parentNode`.
       *
       * @override
       * @param {Node} parentNode The parent node to insert the instance into
       * @return {void}
       */
    }, {
      key: "__createAndInsertInstance",
      value: function __createAndInsertInstance(parentNode) {
        const host = this.__dataHost || this;
        if (strictTemplatePolicy) {
          if (!this.__dataHost) {
            throw new Error('strictTemplatePolicy: template owner not trusted');
          }
        }
        // Pre-bind and link the template into the effects system
        const templateInfo = host._bindTemplate( /** @type {!HTMLTemplateElement} */this.__template, true);
        // Install runEffects hook that prevents running property effects
        // (and any nested template effects) when the `if` is false
        templateInfo.runEffects = (runEffects, changedProps, hasPaths) => {
          let syncInfo = this.__syncInfo;
          if (this.if) {
            // Mix any props that changed while the `if` was false into `changedProps`
            if (syncInfo) {
              // If there were properties received while the `if` was false, it is
              // important to sync the hidden state with the element _first_, so that
              // new bindings to e.g. `textContent` do not get stomped on by
              // pre-hidden values if `_showHideChildren` were to be called later at
              // the next render. Clearing `__invalidProps` here ensures
              // `_showHideChildren`'s call to `__syncHostProperties` no-ops, so
              // that we don't call `runEffects` more often than necessary.
              this.__syncInfo = null;
              this._showHideChildren();
              changedProps = Object.assign(syncInfo.changedProps, changedProps);
            }
            runEffects(changedProps, hasPaths);
          } else {
            // Accumulate any values changed while `if` was false, along with the
            // runEffects method to sync them, so that we can replay them once `if`
            // becomes true
            if (this.__instance) {
              if (!syncInfo) {
                syncInfo = this.__syncInfo = {
                  runEffects,
                  changedProps: {}
                };
              }
              if (hasPaths) {
                // Store root object of any paths; this will ensure direct bindings
                // like [[obj.foo]] bindings run after a `set('obj.foo', v)`, but
                // note that path notifications like `set('obj.foo.bar', v)` will
                // not propagate. Since batched path notifications are not
                // supported, we cannot simply accumulate path notifications. This
                // is equivalent to the non-fastDomIf case, which stores root(p) in
                // __invalidProps.
                for (const p in changedProps) {
                  const rootProp = root(p);
                  syncInfo.changedProps[rootProp] = this.__dataHost[rootProp];
                }
              } else {
                Object.assign(syncInfo.changedProps, changedProps);
              }
            }
          }
        };
        // Stamp the template, and set its DocumentFragment to the "instance"
        this.__instance = host._stampTemplate( /** @type {!HTMLTemplateElement} */this.__template, templateInfo);
        wrap(parentNode).insertBefore(this.__instance, this);
      }

      /**
       * Run effects for any properties that changed while the `if` was false.
       *
       * @return {void}
       */
    }, {
      key: "__syncHostProperties",
      value: function __syncHostProperties() {
        const syncInfo = this.__syncInfo;
        if (syncInfo) {
          this.__syncInfo = null;
          syncInfo.runEffects(syncInfo.changedProps, false);
        }
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * Remove the instance and any nodes it created.  Uses the `__dataHost`'s
       * runtime `_removeBoundDom` method.
       *
       * @override
       * @return {void}
       */
    }, {
      key: "__teardownInstance",
      value: function __teardownInstance() {
        const host = this.__dataHost || this;
        if (this.__instance) {
          host._removeBoundDom(this.__instance);
          this.__instance = null;
          this.__syncInfo = null;
        }
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * Shows or hides the template instance top level child nodes. For
       * text nodes, `textContent` is removed while "hidden" and replaced when
       * "shown."
       *
       * @override
       * @return {void}
       * @protected
       * @suppress {visibility}
       */
    }, {
      key: "_showHideChildren",
      value: function _showHideChildren() {
        const hidden = this.__hideTemplateChildren__ || !this.if;
        if (this.__instance && Boolean(this.__instance.__hidden) !== hidden) {
          this.__instance.__hidden = hidden;
          showHideChildren(hidden, this.__instance.templateInfo.childNodes);
        }
        if (!hidden) {
          this.__syncHostProperties();
        }
      }
    }]);
    return DomIfFast;
  }(DomIfBase); /**
                 * The "legacy" implementation of `dom-if`, implemented using `Templatizer`.
                 *
                 * In this version, `this.__instance` is the `TemplateInstance` returned
                 * from the templatized constructor.
                 */
  let DomIfLegacy = /*#__PURE__*/function (_DomIfBase2) {
    _inherits(DomIfLegacy, _DomIfBase2);
    var _super3 = _createSuper(DomIfLegacy);
    function DomIfLegacy() {
      var _this3;
      _classCallCheck(this, DomIfLegacy);
      _this3 = _super3.call(this);
      _this3.__ctor = null;
      _this3.__instance = null;
      _this3.__invalidProps = null;
      return _this3;
    }

    /**
     * Implementation of abstract API needed by DomIfBase.
     *
     * @override
     * @return {boolean} True when an instance has been created.
     */
    _createClass(DomIfLegacy, [{
      key: "__hasInstance",
      value: function __hasInstance() {
        return Boolean(this.__instance);
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * @override
       * @return {Array<Node>} Array of child nodes stamped from the template
       * instance.
       */
    }, {
      key: "__getInstanceNodes",
      value: function __getInstanceNodes() {
        return this.__instance.children;
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * Stamps the template by creating a new instance of the templatized
       * constructor (which is created lazily if it does not yet exist), and then
       * inserts its resulting `root` doc fragment into the given `parentNode`.
       *
       * @override
       * @param {Node} parentNode The parent node to insert the instance into
       * @return {void}
       */
    }, {
      key: "__createAndInsertInstance",
      value: function __createAndInsertInstance(parentNode) {
        // Ensure we have an instance constructor
        if (!this.__ctor) {
          this.__ctor = templatize( /** @type {!HTMLTemplateElement} */this.__template, this, {
            // dom-if templatizer instances require `mutable: true`, as
            // `__syncHostProperties` relies on that behavior to sync objects
            mutableData: true,
            /**
             * @param {string} prop Property to forward
             * @param {*} value Value of property
             * @this {DomIfLegacy}
             */
            forwardHostProp: function (prop, value) {
              if (this.__instance) {
                if (this.if) {
                  this.__instance.forwardHostProp(prop, value);
                } else {
                  // If we have an instance but are squelching host property
                  // forwarding due to if being false, note the invalidated
                  // properties so `__syncHostProperties` can sync them the next
                  // time `if` becomes true
                  this.__invalidProps = this.__invalidProps || Object.create(null);
                  this.__invalidProps[root(prop)] = true;
                }
              }
            }
          });
        }
        // Create and insert the instance
        this.__instance = new this.__ctor();
        wrap(parentNode).insertBefore(this.__instance.root, this);
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * Removes the instance and any nodes it created.
       *
       * @override
       * @return {void}
       */
    }, {
      key: "__teardownInstance",
      value: function __teardownInstance() {
        if (this.__instance) {
          let c$ = this.__instance.children;
          if (c$ && c$.length) {
            // use first child parent, for case when dom-if may have been detached
            let parent = wrap(c$[0]).parentNode;
            // Instance children may be disconnected from parents when dom-if
            // detaches if a tree was innerHTML'ed
            if (parent) {
              parent = wrap(parent);
              for (let i = 0, n; i < c$.length && (n = c$[i]); i++) {
                parent.removeChild(n);
              }
            }
          }
          this.__invalidProps = null;
          this.__instance = null;
        }
      }

      /**
       * Forwards any properties that changed while the `if` was false into the
       * template instance and flushes it.
       *
       * @return {void}
       */
    }, {
      key: "__syncHostProperties",
      value: function __syncHostProperties() {
        let props = this.__invalidProps;
        if (props) {
          this.__invalidProps = null;
          for (let prop in props) {
            this.__instance._setPendingProperty(prop, this.__dataHost[prop]);
          }
          this.__instance._flushProperties();
        }
      }

      /**
       * Implementation of abstract API needed by DomIfBase.
       *
       * Shows or hides the template instance top level child elements. For
       * text nodes, `textContent` is removed while "hidden" and replaced when
       * "shown."
       *
       * @override
       * @protected
       * @return {void}
       * @suppress {visibility}
       */
    }, {
      key: "_showHideChildren",
      value: function _showHideChildren() {
        const hidden = this.__hideTemplateChildren__ || !this.if;
        if (this.__instance && Boolean(this.__instance.__hidden) !== hidden) {
          this.__instance.__hidden = hidden;
          this.__instance._showHideChildren(hidden);
        }
        if (!hidden) {
          this.__syncHostProperties();
        }
      }
    }]);
    return DomIfLegacy;
  }(DomIfBase); /**
                 * The `<dom-if>` element will stamp a light-dom `<template>` child when
                 * the `if` property becomes truthy, and the template can use Polymer
                 * data-binding and declarative event features when used in the context of
                 * a Polymer element's template.
                 *
                 * When `if` becomes falsy, the stamped content is hidden but not
                 * removed from dom. When `if` subsequently becomes truthy again, the content
                 * is simply re-shown. This approach is used due to its favorable performance
                 * characteristics: the expense of creating template content is paid only
                 * once and lazily.
                 *
                 * Set the `restamp` property to true to force the stamped content to be
                 * created / destroyed when the `if` condition changes.
                 *
                 * @customElement
                 * @polymer
                 * @extends DomIfBase
                 * @constructor
                 * @summary Custom element that conditionally stamps and hides or removes
                 *   template content based on a boolean flag.
                 */
  const DomIf = fastDomIf ? DomIfFast : DomIfLegacy;
  // customElements.define(DomIf.is, DomIf);

  /**
   * Element mixin for recording dynamic associations between item paths in a
   * master `items` array and a `selected` array such that path changes to the
   * master array (at the host) element or elsewhere via data-binding) are
   * correctly propagated to items in the selected array and vice-versa.
   *
   * The `items` property accepts an array of user data, and via the
   * `select(item)` and `deselect(item)` API, updates the `selected` property
   * which may be bound to other parts of the application, and any changes to
   * sub-fields of `selected` item(s) will be kept in sync with items in the
   * `items` array.  When `multi` is false, `selected` is a property
   * representing the last selected item.  When `multi` is true, `selected`
   * is an array of multiply selected items.
   *
   * @polymer
   * @mixinFunction
   * @appliesMixin ElementMixin
   * @summary Element mixin for recording dynamic associations between item paths in a
   * master `items` array and a `selected` array
   */
  let ArraySelectorMixin = dedupingMixin(superClass => {
    /**
     * @constructor
     * @implements {Polymer_ElementMixin}
     * @private
     */
    let elementBase = ElementMixin(superClass);

    /**
     * @polymer
     * @mixinClass
     * @implements {Polymer_ArraySelectorMixin}
     * @unrestricted
     */
    let ArraySelectorMixin = /*#__PURE__*/function (_elementBase) {
      _inherits(ArraySelectorMixin, _elementBase);
      var _super = _createSuper(ArraySelectorMixin);
      function ArraySelectorMixin() {
        var _this;
        _classCallCheck(this, ArraySelectorMixin);
        _this = _super.call(this);
        _this.__lastItems = null;
        _this.__lastMulti = null;
        _this.__selectedMap = null;
        return _this;
      }
      _createClass(ArraySelectorMixin, [{
        key: "__updateSelection",
        value: function __updateSelection(multi, itemsInfo) {
          let path = itemsInfo.path;
          if (path == JSCompiler_renameProperty('items', this)) {
            // Case 1 - items array changed, so diff against previous array and
            // deselect any removed items and adjust selected indices
            let newItems = itemsInfo.base || [];
            let lastItems = this.__lastItems;
            let lastMulti = this.__lastMulti;
            if (multi !== lastMulti) {
              this.clearSelection();
            }
            if (lastItems) {
              let splices = calculateSplices(newItems, lastItems);
              this.__applySplices(splices);
            }
            this.__lastItems = newItems;
            this.__lastMulti = multi;
          } else if (itemsInfo.path == `${JSCompiler_renameProperty('items', this)}.splices`) {
            // Case 2 - got specific splice information describing the array mutation:
            // deselect any removed items and adjust selected indices
            this.__applySplices(itemsInfo.value.indexSplices);
          } else {
            // Case 3 - an array element was changed, so deselect the previous
            // item for that index if it was previously selected
            let part = path.slice(`${JSCompiler_renameProperty('items', this)}.`.length);
            let idx = parseInt(part, 10);
            if (part.indexOf('.') < 0 && part == idx) {
              this.__deselectChangedIdx(idx);
            }
          }
        }
      }, {
        key: "__applySplices",
        value: function __applySplices(splices) {
          let selected = this.__selectedMap;
          // Adjust selected indices and mark removals
          for (let i = 0; i < splices.length; i++) {
            let s = splices[i];
            selected.forEach((idx, item) => {
              if (idx < s.index) ; else if (idx >= s.index + s.removed.length) {
                // adjust index
                selected.set(item, idx + s.addedCount - s.removed.length);
              } else {
                // remove index
                selected.set(item, -1);
              }
            });
            for (let j = 0; j < s.addedCount; j++) {
              let idx = s.index + j;
              if (selected.has(this.items[idx])) {
                selected.set(this.items[idx], idx);
              }
            }
          }
          // Update linked paths
          this.__updateLinks();
          // Remove selected items that were removed from the items array
          let sidx = 0;
          selected.forEach((idx, item) => {
            if (idx < 0) {
              if (this.multi) {
                this.splice(JSCompiler_renameProperty('selected', this), sidx, 1);
              } else {
                this.selected = this.selectedItem = null;
              }
              selected.delete(item);
            } else {
              sidx++;
            }
          });
        }
      }, {
        key: "__updateLinks",
        value: function __updateLinks() {
          this.__dataLinkedPaths = {};
          if (this.multi) {
            let sidx = 0;
            this.__selectedMap.forEach(idx => {
              if (idx >= 0) {
                this.linkPaths(`${JSCompiler_renameProperty('items', this)}.${idx}`, `${JSCompiler_renameProperty('selected', this)}.${sidx++}`);
              }
            });
          } else {
            this.__selectedMap.forEach(idx => {
              this.linkPaths(JSCompiler_renameProperty('selected', this), `${JSCompiler_renameProperty('items', this)}.${idx}`);
              this.linkPaths(JSCompiler_renameProperty('selectedItem', this), `${JSCompiler_renameProperty('items', this)}.${idx}`);
            });
          }
        }

        /**
         * Clears the selection state.
         * @override
         * @return {void}
         */
      }, {
        key: "clearSelection",
        value: function clearSelection() {
          // Unbind previous selection
          this.__dataLinkedPaths = {};
          // The selected map stores 3 pieces of information:
          // key: items array object
          // value: items array index
          // order: selected array index
          this.__selectedMap = new Map();
          // Initialize selection
          this.selected = this.multi ? [] : null;
          this.selectedItem = null;
        }

        /**
         * Returns whether the item is currently selected.
         *
         * @override
         * @param {*} item Item from `items` array to test
         * @return {boolean} Whether the item is selected
         */
      }, {
        key: "isSelected",
        value: function isSelected(item) {
          return this.__selectedMap.has(item);
        }

        /**
         * Returns whether the item is currently selected.
         *
         * @override
         * @param {number} idx Index from `items` array to test
         * @return {boolean} Whether the item is selected
         */
      }, {
        key: "isIndexSelected",
        value: function isIndexSelected(idx) {
          return this.isSelected(this.items[idx]);
        }
      }, {
        key: "__deselectChangedIdx",
        value: function __deselectChangedIdx(idx) {
          let sidx = this.__selectedIndexForItemIndex(idx);
          if (sidx >= 0) {
            let i = 0;
            this.__selectedMap.forEach((idx, item) => {
              if (sidx == i++) {
                this.deselect(item);
              }
            });
          }
        }
      }, {
        key: "__selectedIndexForItemIndex",
        value: function __selectedIndexForItemIndex(idx) {
          let selected = this.__dataLinkedPaths[`${JSCompiler_renameProperty('items', this)}.${idx}`];
          if (selected) {
            return parseInt(selected.slice(`${JSCompiler_renameProperty('selected', this)}.`.length), 10);
          }
        }

        /**
         * Deselects the given item if it is already selected.
         *
         * @override
         * @param {*} item Item from `items` array to deselect
         * @return {void}
         */
      }, {
        key: "deselect",
        value: function deselect(item) {
          let idx = this.__selectedMap.get(item);
          if (idx >= 0) {
            this.__selectedMap.delete(item);
            let sidx;
            if (this.multi) {
              sidx = this.__selectedIndexForItemIndex(idx);
            }
            this.__updateLinks();
            if (this.multi) {
              this.splice(JSCompiler_renameProperty('selected', this), sidx, 1);
            } else {
              this.selected = this.selectedItem = null;
            }
          }
        }

        /**
         * Deselects the given index if it is already selected.
         *
         * @override
         * @param {number} idx Index from `items` array to deselect
         * @return {void}
         */
      }, {
        key: "deselectIndex",
        value: function deselectIndex(idx) {
          this.deselect(this.items[idx]);
        }

        /**
         * Selects the given item.  When `toggle` is true, this will automatically
         * deselect the item if already selected.
         *
         * @override
         * @param {*} item Item from `items` array to select
         * @return {void}
         */
      }, {
        key: "select",
        value: function select(item) {
          this.selectIndex(this.items.indexOf(item));
        }

        /**
         * Selects the given index.  When `toggle` is true, this will automatically
         * deselect the item if already selected.
         *
         * @override
         * @param {number} idx Index from `items` array to select
         * @return {void}
         */
      }, {
        key: "selectIndex",
        value: function selectIndex(idx) {
          let item = this.items[idx];
          if (!this.isSelected(item)) {
            if (!this.multi) {
              this.__selectedMap.clear();
            }
            this.__selectedMap.set(item, idx);
            this.__updateLinks();
            if (this.multi) {
              this.push(JSCompiler_renameProperty('selected', this), item);
            } else {
              this.selected = this.selectedItem = item;
            }
          } else if (this.toggle) {
            this.deselectIndex(idx);
          }
        }
      }], [{
        key: "properties",
        get: function () {
          return {
            /**
             * An array containing items from which selection will be made.
             */
            items: {
              type: Array
            },
            /**
             * When `true`, multiple items may be selected at once (in this case,
             * `selected` is an array of currently selected items).  When `false`,
             * only one item may be selected at a time.
             */
            multi: {
              type: Boolean,
              value: false
            },
            /**
             * When `multi` is true, this is an array that contains any selected.
             * When `multi` is false, this is the currently selected item, or `null`
             * if no item is selected.
             * @type {?Object|?Array<!Object>}
             */
            selected: {
              type: Object,
              notify: true
            },
            /**
             * When `multi` is false, this is the currently selected item, or `null`
             * if no item is selected.
             * @type {?Object}
             */
            selectedItem: {
              type: Object,
              notify: true
            },
            /**
             * When `true`, calling `select` on an item that is already selected
             * will deselect the item.
             */
            toggle: {
              type: Boolean,
              value: false
            }
          };
        }
      }, {
        key: "observers",
        get: function () {
          return ['__updateSelection(multi, items.*)'];
        }
      }]);
      return ArraySelectorMixin;
    }(elementBase);
    return ArraySelectorMixin;
  });

  /**
   * @constructor
   * @extends {PolymerElement}
   * @implements {Polymer_ArraySelectorMixin}
   * @private
   */
  let baseArraySelector = ArraySelectorMixin(PolymerElement);

  /**
   * Element implementing the `ArraySelector` mixin, which records
   * dynamic associations between item paths in a master `items` array and a
   * `selected` array such that path changes to the master array (at the host)
   * element or elsewhere via data-binding) are correctly propagated to items
   * in the selected array and vice-versa.
   *
   * The `items` property accepts an array of user data, and via the
   * `select(item)` and `deselect(item)` API, updates the `selected` property
   * which may be bound to other parts of the application, and any changes to
   * sub-fields of `selected` item(s) will be kept in sync with items in the
   * `items` array.  When `multi` is false, `selected` is a property
   * representing the last selected item.  When `multi` is true, `selected`
   * is an array of multiply selected items.
   *
   * Example:
   *
   * ```js
   * import {PolymerElement} from '@polymer/polymer';
   * import '@polymer/polymer/lib/elements/array-selector.js';
   *
   * class EmployeeList extends PolymerElement {
   *   static get _template() {
   *     return html`
   *         <div> Employee list: </div>
   *         <dom-repeat id="employeeList" items="{{employees}}">
   *           <template>
   *             <div>First name: <span>{{item.first}}</span></div>
   *               <div>Last name: <span>{{item.last}}</span></div>
   *               <button on-click="toggleSelection">Select</button>
   *           </template>
   *         </dom-repeat>
   *
   *         <array-selector id="selector"
   *                         items="{{employees}}"
   *                         selected="{{selected}}"
   *                         multi toggle></array-selector>
   *
   *         <div> Selected employees: </div>
   *         <dom-repeat items="{{selected}}">
   *           <template>
   *             <div>First name: <span>{{item.first}}</span></div>
   *             <div>Last name: <span>{{item.last}}</span></div>
   *           </template>
   *         </dom-repeat>`;
   *   }
   *   static get is() { return 'employee-list'; }
   *   static get properties() {
   *     return {
   *       employees: {
   *         value() {
   *           return [
   *             {first: 'Bob', last: 'Smith'},
   *             {first: 'Sally', last: 'Johnson'},
   *             ...
   *           ];
   *         }
   *       }
   *     };
   *   }
   *   toggleSelection(e) {
   *     const item = this.$.employeeList.itemForElement(e.target);
   *     this.$.selector.select(item);
   *   }
   * }
   * ```
   *
   * @polymer
   * @customElement
   * @extends {baseArraySelector}
   * @appliesMixin ArraySelectorMixin
   * @summary Custom element that links paths between an input `items` array and
   *   an output `selected` item or array based on calls to its selection API.
   */
  let ArraySelector = /*#__PURE__*/function (_baseArraySelector) {
    _inherits(ArraySelector, _baseArraySelector);
    var _super2 = _createSuper(ArraySelector);
    function ArraySelector() {
      _classCallCheck(this, ArraySelector);
      return _super2.apply(this, arguments);
    }
    _createClass(ArraySelector, null, [{
      key: "is",
      get:
      // Not needed to find template; can be removed once the analyzer
      // can find the tag name from customElements.define call
      function () {
        return 'array-selector';
      }
    }, {
      key: "template",
      get: function () {
        return null;
      }
    }]);
    return ArraySelector;
  }(baseArraySelector);
  // customElements.define(ArraySelector.is, ArraySelector);

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  const customStyleInterface = new CustomStyleInterface$1();
  if (!window.ShadyCSS) {
    window.ShadyCSS = {
      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       * @param {string=} elementExtends
       */
      prepareTemplate(template, elementName, elementExtends) {},
      // eslint-disable-line @typescript-eslint/no-unused-vars

      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       */
      prepareTemplateDom(template, elementName) {},
      // eslint-disable-line @typescript-eslint/no-unused-vars

      /**
       * @param {!HTMLTemplateElement} template
       * @param {string} elementName
       * @param {string=} elementExtends
       */
      prepareTemplateStyles(template, elementName, elementExtends) {},
      // eslint-disable-line @typescript-eslint/no-unused-vars

      /**
       * @param {Element} element
       * @param {Object=} properties
       */
      styleSubtree(element, properties) {
        customStyleInterface.processStyles();
        updateNativeProperties(element, properties);
      },
      /**
       * @param {Element} element
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      styleElement(element) {
        customStyleInterface.processStyles();
      },
      /**
       * @param {Object=} properties
       */
      styleDocument(properties) {
        customStyleInterface.processStyles();
        updateNativeProperties(document.body, properties);
      },
      /**
       * @param {Element} element
       * @param {string} property
       * @return {string}
       */
      getComputedStyleValue(element, property) {
        return getComputedStyleValue(element, property);
      },
      flushCustomStyles() {},
      nativeCss: nativeCssVariables,
      nativeShadow: nativeShadow,
      cssBuild: cssBuild,
      disableRuntime: disableRuntime
    };
  }
  window.ShadyCSS.CustomStyleInterface = customStyleInterface;

  const attr = 'include';
  const CustomStyleInterface = window.ShadyCSS.CustomStyleInterface;

  /**
   * Custom element for defining styles in the main document that can take
   * advantage of [shady DOM](https://github.com/webcomponents/shadycss) shims
   * for style encapsulation, custom properties, and custom mixins.
   *
   * - Document styles defined in a `<custom-style>` are shimmed to ensure they
   *   do not leak into local DOM when running on browsers without native
   *   Shadow DOM.
   * - Custom properties can be defined in a `<custom-style>`. Use the `html` selector
   *   to define custom properties that apply to all custom elements.
   * - Custom mixins can be defined in a `<custom-style>`, if you import the optional
   *   [apply shim](https://github.com/webcomponents/shadycss#about-applyshim)
   *   (`shadycss/apply-shim.html`).
   *
   * To use:
   *
   * - Import `custom-style.html`.
   * - Place a `<custom-style>` element in the main document, wrapping an inline `<style>` tag that
   *   contains the CSS rules you want to shim.
   *
   * For example:
   *
   * ```html
   * <!-- import apply shim--only required if using mixins -->
   * <link rel="import" href="bower_components/shadycss/apply-shim.html">
   * <!-- import custom-style element -->
   * <link rel="import" href="bower_components/polymer/lib/elements/custom-style.html">
   *
   * <custom-style>
   *   <style>
   *     html {
   *       --custom-color: blue;
   *       --custom-mixin: {
   *         font-weight: bold;
   *         color: red;
   *       };
   *     }
   *   </style>
   * </custom-style>
   * ```
   *
   * @customElement
   * @extends HTMLElement
   * @summary Custom element for defining styles in the main document that can
   *   take advantage of Polymer's style scoping and custom properties shims.
   */
  let CustomStyle = /*#__PURE__*/function (_HTMLElement) {
    _inherits(CustomStyle, _HTMLElement);
    var _super = _createSuper(CustomStyle);
    function CustomStyle() {
      var _this;
      _classCallCheck(this, CustomStyle);
      _this = _super.call(this);
      _this._style = null;
      CustomStyleInterface.addCustomStyle(_assertThisInitialized(_this));
      return _this;
    }
    /**
     * Returns the light-DOM `<style>` child this element wraps.  Upon first
     * call any style modules referenced via the `include` attribute will be
     * concatenated to this element's `<style>`.
     *
     * @export
     * @return {HTMLStyleElement} This element's light-DOM `<style>`
     */
    _createClass(CustomStyle, [{
      key: "getStyle",
      value: function getStyle() {
        if (this._style) {
          return this._style;
        }
        const style = /** @type {HTMLStyleElement} */this.querySelector('style');
        if (!style) {
          return null;
        }
        this._style = style;
        const include = style.getAttribute(attr);
        if (include) {
          style.removeAttribute(attr);
          /** @suppress {deprecated} */
          style.textContent = cssFromModules(include) + style.textContent;
        }
        /*
        HTML Imports styling the main document are deprecated in Chrome
        https://crbug.com/523952
         If this element is not in the main document, then it must be in an HTML Import document.
        In that case, move the custom style to the main document.
         The ordering of `<custom-style>` should stay the same as when loaded by HTML Imports, but there may be odd
        cases of ordering w.r.t the main document styles.
        */
        if (this.ownerDocument !== window.document) {
          window.document.head.appendChild(this);
        }
        return this._style;
      }
    }]);
    return CustomStyle;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  // window.customElements.define('custom-style', CustomStyle);

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  // bc
  const Base = LegacyElementMixin(HTMLElement).prototype;

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  The `<iron-flex-layout>` component provides simple ways to use
  [CSS flexible box
  layout](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Flexible_boxes),
  also known as flexbox. Note that this is an old element, that was written
  before all modern browsers had non-prefixed flex styles. As such, nowadays you
  don't really need to use this element anymore, and can use CSS flex styles
  directly in your code.

  This component provides two different ways to use flexbox:

  1. [Layout
  classes](https://github.com/PolymerElements/iron-flex-layout/tree/master/iron-flex-layout-classes.html).
  The layout class stylesheet provides a simple set of class-based flexbox rules,
  that let you specify layout properties directly in markup. You must include this
  file in every element that needs to use them.

      Sample use:

      ```
      <custom-element-demo>
        <template>
          <script src="../webcomponentsjs/webcomponents-lite.js"></script>
          <next-code-block></next-code-block>
        </template>
      </custom-element-demo>
      ```

      ```js
      import {html} from '@polymer/polymer/lib/utils/html-tag.js';
      import '@polymer/iron-flex-layout/iron-flex-layout-classes.js';

      const template = html`
        <style is="custom-style" include="iron-flex iron-flex-alignment"></style>
        <style>
          .test { width: 100px; }
        </style>
        <div class="layout horizontal center-center">
          <div class="test">horizontal layout center alignment</div>
        </div>
      `;
      document.body.appendChild(template.content);
      ```

  2. [Custom CSS
  mixins](https://github.com/PolymerElements/iron-flex-layout/blob/master/iron-flex-layout.html).
  The mixin stylesheet includes custom CSS mixins that can be applied inside a CSS
  rule using the `@apply` function.

  Please note that the old [/deep/ layout
  classes](https://github.com/PolymerElements/iron-flex-layout/tree/master/classes)
  are deprecated, and should not be used. To continue using layout properties
  directly in markup, please switch to using the new `dom-module`-based
  [layout
  classes](https://github.com/PolymerElements/iron-flex-layout/tree/master/iron-flex-layout-classes.html).
  Please note that the new version does not use `/deep/`, and therefore requires
  you to import the `dom-modules` in every element that needs to use them.

  @group Iron Elements
  @pseudoElement iron-flex-layout
  @demo demo/index.html
  */
  const template$e = html`
<custom-style>
  <style is="custom-style">
    [hidden] {
      display: none !important;
    }
  </style>
</custom-style>
<custom-style>
  <style is="custom-style">
    html {

      --layout: {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
      };

      --layout-inline: {
        display: -ms-inline-flexbox;
        display: -webkit-inline-flex;
        display: inline-flex;
      };

      --layout-horizontal: {
        @apply --layout;

        -ms-flex-direction: row;
        -webkit-flex-direction: row;
        flex-direction: row;
      };

      --layout-horizontal-reverse: {
        @apply --layout;

        -ms-flex-direction: row-reverse;
        -webkit-flex-direction: row-reverse;
        flex-direction: row-reverse;
      };

      --layout-vertical: {
        @apply --layout;

        -ms-flex-direction: column;
        -webkit-flex-direction: column;
        flex-direction: column;
      };

      --layout-vertical-reverse: {
        @apply --layout;

        -ms-flex-direction: column-reverse;
        -webkit-flex-direction: column-reverse;
        flex-direction: column-reverse;
      };

      --layout-wrap: {
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
      };

      --layout-wrap-reverse: {
        -ms-flex-wrap: wrap-reverse;
        -webkit-flex-wrap: wrap-reverse;
        flex-wrap: wrap-reverse;
      };

      --layout-flex-auto: {
        -ms-flex: 1 1 auto;
        -webkit-flex: 1 1 auto;
        flex: 1 1 auto;
      };

      --layout-flex-none: {
        -ms-flex: none;
        -webkit-flex: none;
        flex: none;
      };

      --layout-flex: {
        -ms-flex: 1 1 0.000000001px;
        -webkit-flex: 1;
        flex: 1;
        -webkit-flex-basis: 0.000000001px;
        flex-basis: 0.000000001px;
      };

      --layout-flex-2: {
        -ms-flex: 2;
        -webkit-flex: 2;
        flex: 2;
      };

      --layout-flex-3: {
        -ms-flex: 3;
        -webkit-flex: 3;
        flex: 3;
      };

      --layout-flex-4: {
        -ms-flex: 4;
        -webkit-flex: 4;
        flex: 4;
      };

      --layout-flex-5: {
        -ms-flex: 5;
        -webkit-flex: 5;
        flex: 5;
      };

      --layout-flex-6: {
        -ms-flex: 6;
        -webkit-flex: 6;
        flex: 6;
      };

      --layout-flex-7: {
        -ms-flex: 7;
        -webkit-flex: 7;
        flex: 7;
      };

      --layout-flex-8: {
        -ms-flex: 8;
        -webkit-flex: 8;
        flex: 8;
      };

      --layout-flex-9: {
        -ms-flex: 9;
        -webkit-flex: 9;
        flex: 9;
      };

      --layout-flex-10: {
        -ms-flex: 10;
        -webkit-flex: 10;
        flex: 10;
      };

      --layout-flex-11: {
        -ms-flex: 11;
        -webkit-flex: 11;
        flex: 11;
      };

      --layout-flex-12: {
        -ms-flex: 12;
        -webkit-flex: 12;
        flex: 12;
      };

      /* alignment in cross axis */

      --layout-start: {
        -ms-flex-align: start;
        -webkit-align-items: flex-start;
        align-items: flex-start;
      };

      --layout-center: {
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      };

      --layout-end: {
        -ms-flex-align: end;
        -webkit-align-items: flex-end;
        align-items: flex-end;
      };

      --layout-baseline: {
        -ms-flex-align: baseline;
        -webkit-align-items: baseline;
        align-items: baseline;
      };

      /* alignment in main axis */

      --layout-start-justified: {
        -ms-flex-pack: start;
        -webkit-justify-content: flex-start;
        justify-content: flex-start;
      };

      --layout-center-justified: {
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
      };

      --layout-end-justified: {
        -ms-flex-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
      };

      --layout-around-justified: {
        -ms-flex-pack: distribute;
        -webkit-justify-content: space-around;
        justify-content: space-around;
      };

      --layout-justified: {
        -ms-flex-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
      };

      --layout-center-center: {
        @apply --layout-center;
        @apply --layout-center-justified;
      };

      /* self alignment */

      --layout-self-start: {
        -ms-align-self: flex-start;
        -webkit-align-self: flex-start;
        align-self: flex-start;
      };

      --layout-self-center: {
        -ms-align-self: center;
        -webkit-align-self: center;
        align-self: center;
      };

      --layout-self-end: {
        -ms-align-self: flex-end;
        -webkit-align-self: flex-end;
        align-self: flex-end;
      };

      --layout-self-stretch: {
        -ms-align-self: stretch;
        -webkit-align-self: stretch;
        align-self: stretch;
      };

      --layout-self-baseline: {
        -ms-align-self: baseline;
        -webkit-align-self: baseline;
        align-self: baseline;
      };

      /* multi-line alignment in main axis */

      --layout-start-aligned: {
        -ms-flex-line-pack: start;  /* IE10 */
        -ms-align-content: flex-start;
        -webkit-align-content: flex-start;
        align-content: flex-start;
      };

      --layout-end-aligned: {
        -ms-flex-line-pack: end;  /* IE10 */
        -ms-align-content: flex-end;
        -webkit-align-content: flex-end;
        align-content: flex-end;
      };

      --layout-center-aligned: {
        -ms-flex-line-pack: center;  /* IE10 */
        -ms-align-content: center;
        -webkit-align-content: center;
        align-content: center;
      };

      --layout-between-aligned: {
        -ms-flex-line-pack: justify;  /* IE10 */
        -ms-align-content: space-between;
        -webkit-align-content: space-between;
        align-content: space-between;
      };

      --layout-around-aligned: {
        -ms-flex-line-pack: distribute;  /* IE10 */
        -ms-align-content: space-around;
        -webkit-align-content: space-around;
        align-content: space-around;
      };

      /*******************************
                Other Layout
      *******************************/

      --layout-block: {
        display: block;
      };

      --layout-invisible: {
        visibility: hidden !important;
      };

      --layout-relative: {
        position: relative;
      };

      --layout-fit: {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      };

      --layout-scroll: {
        -webkit-overflow-scrolling: touch;
        overflow: auto;
      };

      --layout-fullbleed: {
        margin: 0;
        height: 100vh;
      };

      /* fixed position */

      --layout-fixed-top: {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
      };

      --layout-fixed-right: {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
      };

      --layout-fixed-bottom: {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
      };

      --layout-fixed-left: {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
      };

    }
  </style>
</custom-style>`;
  template$e.setAttribute('style', 'display: none;');
  document.head.appendChild(template$e.content);
  var style = document.createElement('style');
  style.textContent = '[hidden] { display: none !important; }';
  document.head.appendChild(style);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$d = html`
<custom-style>
  <style is="custom-style">
    html {

      --shadow-transition: {
        transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
      };

      --shadow-none: {
        box-shadow: none;
      };

      /* from http://codepen.io/shyndman/pen/c5394ddf2e8b2a5c9185904b57421cdb */

      --shadow-elevation-2dp: {
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
                    0 1px 5px 0 rgba(0, 0, 0, 0.12),
                    0 3px 1px -2px rgba(0, 0, 0, 0.2);
      };

      --shadow-elevation-3dp: {
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.14),
                    0 1px 8px 0 rgba(0, 0, 0, 0.12),
                    0 3px 3px -2px rgba(0, 0, 0, 0.4);
      };

      --shadow-elevation-4dp: {
        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
                    0 1px 10px 0 rgba(0, 0, 0, 0.12),
                    0 2px 4px -1px rgba(0, 0, 0, 0.4);
      };

      --shadow-elevation-6dp: {
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14),
                    0 1px 18px 0 rgba(0, 0, 0, 0.12),
                    0 3px 5px -1px rgba(0, 0, 0, 0.4);
      };

      --shadow-elevation-8dp: {
        box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14),
                    0 3px 14px 2px rgba(0, 0, 0, 0.12),
                    0 5px 5px -3px rgba(0, 0, 0, 0.4);
      };

      --shadow-elevation-12dp: {
        box-shadow: 0 12px 16px 1px rgba(0, 0, 0, 0.14),
                    0 4px 22px 3px rgba(0, 0, 0, 0.12),
                    0 6px 7px -4px rgba(0, 0, 0, 0.4);
      };

      --shadow-elevation-16dp: {
        box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14),
                    0  6px 30px 5px rgba(0, 0, 0, 0.12),
                    0  8px 10px -5px rgba(0, 0, 0, 0.4);
      };

      --shadow-elevation-24dp: {
        box-shadow: 0 24px 38px 3px rgba(0, 0, 0, 0.14),
                    0 9px 46px 8px rgba(0, 0, 0, 0.12),
                    0 11px 15px -7px rgba(0, 0, 0, 0.4);
      };
    }
  </style>
</custom-style>`;
  template$d.setAttribute('style', 'display: none;');
  document.head.appendChild(template$d.content);

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$c = html`
<dom-module id="paper-material-styles">
  <template>
    <style>
      html {
        --paper-material: {
          display: block;
          position: relative;
        };
        --paper-material-elevation-1: {
          @apply --shadow-elevation-2dp;
        };
        --paper-material-elevation-2: {
          @apply --shadow-elevation-4dp;
        };
        --paper-material-elevation-3: {
          @apply --shadow-elevation-6dp;
        };
        --paper-material-elevation-4: {
          @apply --shadow-elevation-8dp;
        };
        --paper-material-elevation-5: {
          @apply --shadow-elevation-16dp;
        };
      }
      .paper-material {
        @apply --paper-material;
      }
      .paper-material[elevation="1"] {
        @apply --paper-material-elevation-1;
      }
      .paper-material[elevation="2"] {
        @apply --paper-material-elevation-2;
      }
      .paper-material[elevation="3"] {
        @apply --paper-material-elevation-3;
      }
      .paper-material[elevation="4"] {
        @apply --paper-material-elevation-4;
      }
      .paper-material[elevation="5"] {
        @apply --paper-material-elevation-5;
      }

      /* Duplicate the styles because of https://github.com/webcomponents/shadycss/issues/193 */
      :host {
        --paper-material: {
          display: block;
          position: relative;
        };
        --paper-material-elevation-1: {
          @apply --shadow-elevation-2dp;
        };
        --paper-material-elevation-2: {
          @apply --shadow-elevation-4dp;
        };
        --paper-material-elevation-3: {
          @apply --shadow-elevation-6dp;
        };
        --paper-material-elevation-4: {
          @apply --shadow-elevation-8dp;
        };
        --paper-material-elevation-5: {
          @apply --shadow-elevation-16dp;
        };
      }
      :host(.paper-material) {
        @apply --paper-material;
      }
      :host(.paper-material[elevation="1"]) {
        @apply --paper-material-elevation-1;
      }
      :host(.paper-material[elevation="2"]) {
        @apply --paper-material-elevation-2;
      }
      :host(.paper-material[elevation="3"]) {
        @apply --paper-material-elevation-3;
      }
      :host(.paper-material[elevation="4"]) {
        @apply --paper-material-elevation-4;
      }
      :host(.paper-material[elevation="5"]) {
        @apply --paper-material-elevation-5;
      }
    </style>
  </template>
</dom-module>`;
  template$c.setAttribute('style', 'display: none;');
  document.head.appendChild(template$c.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @demo demo/index.html
   * @polymerBehavior
   */
  const IronControlState = {
    properties: {
      /**
       * If true, the element currently has focus.
       */
      focused: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true,
        reflectToAttribute: true
      },
      /**
       * If true, the user cannot interact with this element.
       */
      disabled: {
        type: Boolean,
        value: false,
        notify: true,
        observer: '_disabledChanged',
        reflectToAttribute: true
      },
      /**
       * Value of the `tabindex` attribute before `disabled` was activated.
       * `null` means the attribute was not present.
       * @type {?string|undefined}
       */
      _oldTabIndex: {
        type: String
      },
      _boundFocusBlurHandler: {
        type: Function,
        value: function () {
          return this._focusBlurHandler.bind(this);
        }
      }
    },
    observers: ['_changedControlState(focused, disabled)'],
    /**
     * @return {void}
     */
    ready: function () {
      this.addEventListener('focus', this._boundFocusBlurHandler, true);
      this.addEventListener('blur', this._boundFocusBlurHandler, true);
    },
    _focusBlurHandler: function (event) {
      // Polymer takes care of retargeting events.
      this._setFocused(event.type === 'focus');
      return;
    },
    _disabledChanged: function (disabled, old) {
      this.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      this.style.pointerEvents = disabled ? 'none' : '';
      if (disabled) {
        // Read the `tabindex` attribute instead of the `tabIndex` property.
        // The property returns `-1` if there is no `tabindex` attribute.
        // This distinction is important when restoring the value because
        // leaving `-1` hides shadow root children from the tab order.
        this._oldTabIndex = this.getAttribute('tabindex');
        this._setFocused(false);
        this.tabIndex = -1;
        this.blur();
      } else if (this._oldTabIndex !== undefined) {
        if (this._oldTabIndex === null) {
          this.removeAttribute('tabindex');
        } else {
          this.setAttribute('tabindex', this._oldTabIndex);
        }
      }
    },
    _changedControlState: function () {
      // _controlStateChanged is abstract, follow-on behaviors may implement it
      if (this._controlStateChanged) {
        this._controlStateChanged();
      }
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Chrome uses an older version of DOM Level 3 Keyboard Events
   *
   * Most keys are labeled as text, but some are Unicode codepoints.
   * Values taken from:
   * http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/keyset.html#KeySet-Set
   */
  var KEY_IDENTIFIER = {
    'U+0008': 'backspace',
    'U+0009': 'tab',
    'U+001B': 'esc',
    'U+0020': 'space',
    'U+007F': 'del'
  };

  /**
   * Special table for KeyboardEvent.keyCode.
   * KeyboardEvent.keyIdentifier is better, and KeyBoardEvent.key is even better
   * than that.
   *
   * Values from:
   * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent.keyCode#Value_of_keyCode
   */
  var KEY_CODE = {
    8: 'backspace',
    9: 'tab',
    13: 'enter',
    27: 'esc',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    32: 'space',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down',
    46: 'del',
    106: '*'
  };

  /**
   * MODIFIER_KEYS maps the short name for modifier keys used in a key
   * combo string to the property name that references those same keys
   * in a KeyboardEvent instance.
   */
  var MODIFIER_KEYS = {
    'shift': 'shiftKey',
    'ctrl': 'ctrlKey',
    'alt': 'altKey',
    'meta': 'metaKey'
  };

  /**
   * KeyboardEvent.key is mostly represented by printable character made by
   * the keyboard, with unprintable keys labeled nicely.
   *
   * However, on OS X, Alt+char can make a Unicode character that follows an
   * Apple-specific mapping. In this case, we fall back to .keyCode.
   */
  var KEY_CHAR = /[a-z0-9*]/;

  /**
   * Matches a keyIdentifier string.
   */
  var IDENT_CHAR = /U\+/;

  /**
   * Matches arrow keys in Gecko 27.0+
   */
  var ARROW_KEY = /^arrow/;

  /**
   * Matches space keys everywhere (notably including IE10's exceptional name
   * `spacebar`).
   */
  var SPACE_KEY = /^space(bar)?/;

  /**
   * Matches ESC key.
   *
   * Value from: http://w3c.github.io/uievents-key/#key-Escape
   */
  var ESC_KEY = /^escape$/;

  /**
   * Transforms the key.
   * @param {string} key The KeyBoardEvent.key
   * @param {Boolean} [noSpecialChars] Limits the transformation to
   * alpha-numeric characters.
   */
  function transformKey(key, noSpecialChars) {
    var validKey = '';
    if (key) {
      var lKey = key.toLowerCase();
      if (lKey === ' ' || SPACE_KEY.test(lKey)) {
        validKey = 'space';
      } else if (ESC_KEY.test(lKey)) {
        validKey = 'esc';
      } else if (lKey.length == 1) {
        if (!noSpecialChars || KEY_CHAR.test(lKey)) {
          validKey = lKey;
        }
      } else if (ARROW_KEY.test(lKey)) {
        validKey = lKey.replace('arrow', '');
      } else if (lKey == 'multiply') {
        // numpad '*' can map to Multiply on IE/Windows
        validKey = '*';
      } else {
        validKey = lKey;
      }
    }
    return validKey;
  }
  function transformKeyIdentifier(keyIdent) {
    var validKey = '';
    if (keyIdent) {
      if (keyIdent in KEY_IDENTIFIER) {
        validKey = KEY_IDENTIFIER[keyIdent];
      } else if (IDENT_CHAR.test(keyIdent)) {
        keyIdent = parseInt(keyIdent.replace('U+', '0x'), 16);
        validKey = String.fromCharCode(keyIdent).toLowerCase();
      } else {
        validKey = keyIdent.toLowerCase();
      }
    }
    return validKey;
  }
  function transformKeyCode(keyCode) {
    var validKey = '';
    if (Number(keyCode)) {
      if (keyCode >= 65 && keyCode <= 90) {
        // ascii a-z
        // lowercase is 32 offset from uppercase
        validKey = String.fromCharCode(32 + keyCode);
      } else if (keyCode >= 112 && keyCode <= 123) {
        // function keys f1-f12
        validKey = 'f' + (keyCode - 112 + 1);
      } else if (keyCode >= 48 && keyCode <= 57) {
        // top 0-9 keys
        validKey = String(keyCode - 48);
      } else if (keyCode >= 96 && keyCode <= 105) {
        // num pad 0-9
        validKey = String(keyCode - 96);
      } else {
        validKey = KEY_CODE[keyCode];
      }
    }
    return validKey;
  }

  /**
   * Calculates the normalized key for a KeyboardEvent.
   * @param {KeyboardEvent} keyEvent
   * @param {Boolean} [noSpecialChars] Set to true to limit keyEvent.key
   * transformation to alpha-numeric chars. This is useful with key
   * combinations like shift + 2, which on FF for MacOS produces
   * keyEvent.key = @
   * To get 2 returned, set noSpecialChars = true
   * To get @ returned, set noSpecialChars = false
   */
  function normalizedKeyForEvent(keyEvent, noSpecialChars) {
    // Fall back from .key, to .detail.key for artifical keyboard events,
    // and then to deprecated .keyIdentifier and .keyCode.
    if (keyEvent.key) {
      return transformKey(keyEvent.key, noSpecialChars);
    }
    if (keyEvent.detail && keyEvent.detail.key) {
      return transformKey(keyEvent.detail.key, noSpecialChars);
    }
    return transformKeyIdentifier(keyEvent.keyIdentifier) || transformKeyCode(keyEvent.keyCode) || '';
  }
  function keyComboMatchesEvent(keyCombo, event) {
    // For combos with modifiers we support only alpha-numeric keys
    var keyEvent = normalizedKeyForEvent(event, keyCombo.hasModifiers);
    return keyEvent === keyCombo.key && (!keyCombo.hasModifiers || !!event.shiftKey === !!keyCombo.shiftKey && !!event.ctrlKey === !!keyCombo.ctrlKey && !!event.altKey === !!keyCombo.altKey && !!event.metaKey === !!keyCombo.metaKey);
  }
  function parseKeyComboString(keyComboString) {
    if (keyComboString.length === 1) {
      return {
        combo: keyComboString,
        key: keyComboString,
        event: 'keydown'
      };
    }
    return keyComboString.split('+').reduce(function (parsedKeyCombo, keyComboPart) {
      var eventParts = keyComboPart.split(':');
      var keyName = eventParts[0];
      var event = eventParts[1];
      if (keyName in MODIFIER_KEYS) {
        parsedKeyCombo[MODIFIER_KEYS[keyName]] = true;
        parsedKeyCombo.hasModifiers = true;
      } else {
        parsedKeyCombo.key = keyName;
        parsedKeyCombo.event = event || 'keydown';
      }
      return parsedKeyCombo;
    }, {
      combo: keyComboString.split(':').shift()
    });
  }
  function parseEventString(eventString) {
    return eventString.trim().split(' ').map(function (keyComboString) {
      return parseKeyComboString(keyComboString);
    });
  }

  /**
   * `Polymer.IronA11yKeysBehavior` provides a normalized interface for processing
   * keyboard commands that pertain to [WAI-ARIA best
   * practices](http://www.w3.org/TR/wai-aria-practices/#kbd_general_binding). The
   * element takes care of browser differences with respect to Keyboard events and
   * uses an expressive syntax to filter key presses.
   *
   * Use the `keyBindings` prototype property to express what combination of keys
   * will trigger the callback. A key binding has the format
   * `"KEY+MODIFIER:EVENT": "callback"` (`"KEY": "callback"` or
   * `"KEY:EVENT": "callback"` are valid as well). Some examples:
   *
   *      keyBindings: {
   *        'space': '_onKeydown', // same as 'space:keydown'
   *        'shift+tab': '_onKeydown',
   *        'enter:keypress': '_onKeypress',
   *        'esc:keyup': '_onKeyup'
   *      }
   *
   * The callback will receive with an event containing the following information
   * in `event.detail`:
   *
   *      _onKeydown: function(event) {
   *        console.log(event.detail.combo); // KEY+MODIFIER, e.g. "shift+tab"
   *        console.log(event.detail.key); // KEY only, e.g. "tab"
   *        console.log(event.detail.event); // EVENT, e.g. "keydown"
   *        console.log(event.detail.keyboardEvent); // the original KeyboardEvent
   *      }
   *
   * Use the `keyEventTarget` attribute to set up event handlers on a specific
   * node.
   *
   * See the [demo source
   * code](https://github.com/PolymerElements/iron-a11y-keys-behavior/blob/master/demo/x-key-aware.html)
   * for an example.
   *
   * @demo demo/index.html
   * @polymerBehavior
   */
  const IronA11yKeysBehavior = {
    properties: {
      /**
       * The EventTarget that will be firing relevant KeyboardEvents. Set it to
       * `null` to disable the listeners.
       * @type {?EventTarget}
       */
      keyEventTarget: {
        type: Object,
        value: function () {
          return this;
        }
      },
      /**
       * If true, this property will cause the implementing element to
       * automatically stop propagation on any handled KeyboardEvents.
       */
      stopKeyboardEventPropagation: {
        type: Boolean,
        value: false
      },
      _boundKeyHandlers: {
        type: Array,
        value: function () {
          return [];
        }
      },
      // We use this due to a limitation in IE10 where instances will have
      // own properties of everything on the "prototype".
      _imperativeKeyBindings: {
        type: Object,
        value: function () {
          return {};
        }
      }
    },
    observers: ['_resetKeyEventListeners(keyEventTarget, _boundKeyHandlers)'],
    /**
     * To be used to express what combination of keys  will trigger the relative
     * callback. e.g. `keyBindings: { 'esc': '_onEscPressed'}`
     * @type {!Object}
     */
    keyBindings: {},
    registered: function () {
      this._prepKeyBindings();
    },
    attached: function () {
      this._listenKeyEventListeners();
    },
    detached: function () {
      this._unlistenKeyEventListeners();
    },
    /**
     * Can be used to imperatively add a key binding to the implementing
     * element. This is the imperative equivalent of declaring a keybinding
     * in the `keyBindings` prototype property.
     *
     * @param {string} eventString
     * @param {string} handlerName
     */
    addOwnKeyBinding: function (eventString, handlerName) {
      this._imperativeKeyBindings[eventString] = handlerName;
      this._prepKeyBindings();
      this._resetKeyEventListeners();
    },
    /**
     * When called, will remove all imperatively-added key bindings.
     */
    removeOwnKeyBindings: function () {
      this._imperativeKeyBindings = {};
      this._prepKeyBindings();
      this._resetKeyEventListeners();
    },
    /**
     * Returns true if a keyboard event matches `eventString`.
     *
     * @param {KeyboardEvent} event
     * @param {string} eventString
     * @return {boolean}
     */
    keyboardEventMatchesKeys: function (event, eventString) {
      var keyCombos = parseEventString(eventString);
      for (var i = 0; i < keyCombos.length; ++i) {
        if (keyComboMatchesEvent(keyCombos[i], event)) {
          return true;
        }
      }
      return false;
    },
    _collectKeyBindings: function () {
      var keyBindings = this.behaviors.map(function (behavior) {
        return behavior.keyBindings;
      });
      if (keyBindings.indexOf(this.keyBindings) === -1) {
        keyBindings.push(this.keyBindings);
      }
      return keyBindings;
    },
    _prepKeyBindings: function () {
      this._keyBindings = {};
      this._collectKeyBindings().forEach(function (keyBindings) {
        for (var eventString in keyBindings) {
          this._addKeyBinding(eventString, keyBindings[eventString]);
        }
      }, this);
      for (var eventString in this._imperativeKeyBindings) {
        this._addKeyBinding(eventString, this._imperativeKeyBindings[eventString]);
      }

      // Give precedence to combos with modifiers to be checked first.
      for (var eventName in this._keyBindings) {
        this._keyBindings[eventName].sort(function (kb1, kb2) {
          var b1 = kb1[0].hasModifiers;
          var b2 = kb2[0].hasModifiers;
          return b1 === b2 ? 0 : b1 ? -1 : 1;
        });
      }
    },
    _addKeyBinding: function (eventString, handlerName) {
      parseEventString(eventString).forEach(function (keyCombo) {
        this._keyBindings[keyCombo.event] = this._keyBindings[keyCombo.event] || [];
        this._keyBindings[keyCombo.event].push([keyCombo, handlerName]);
      }, this);
    },
    _resetKeyEventListeners: function () {
      this._unlistenKeyEventListeners();
      if (this.isAttached) {
        this._listenKeyEventListeners();
      }
    },
    _listenKeyEventListeners: function () {
      if (!this.keyEventTarget) {
        return;
      }
      Object.keys(this._keyBindings).forEach(function (eventName) {
        var keyBindings = this._keyBindings[eventName];
        var boundKeyHandler = this._onKeyBindingEvent.bind(this, keyBindings);
        this._boundKeyHandlers.push([this.keyEventTarget, eventName, boundKeyHandler]);
        this.keyEventTarget.addEventListener(eventName, boundKeyHandler);
      }, this);
    },
    _unlistenKeyEventListeners: function () {
      var keyHandlerTuple;
      var keyEventTarget;
      var eventName;
      var boundKeyHandler;
      while (this._boundKeyHandlers.length) {
        // My kingdom for block-scope binding and destructuring assignment..
        keyHandlerTuple = this._boundKeyHandlers.pop();
        keyEventTarget = keyHandlerTuple[0];
        eventName = keyHandlerTuple[1];
        boundKeyHandler = keyHandlerTuple[2];
        keyEventTarget.removeEventListener(eventName, boundKeyHandler);
      }
    },
    _onKeyBindingEvent: function (keyBindings, event) {
      if (this.stopKeyboardEventPropagation) {
        event.stopPropagation();
      }

      // if event has been already prevented, don't do anything
      if (event.defaultPrevented) {
        return;
      }
      for (var i = 0; i < keyBindings.length; i++) {
        var keyCombo = keyBindings[i][0];
        var handlerName = keyBindings[i][1];
        if (keyComboMatchesEvent(keyCombo, event)) {
          this._triggerKeyHandler(keyCombo, handlerName, event);
          // exit the loop if eventDefault was prevented
          if (event.defaultPrevented) {
            return;
          }
        }
      }
    },
    _triggerKeyHandler: function (keyCombo, handlerName, keyboardEvent) {
      var detail = Object.create(keyCombo);
      detail.keyboardEvent = keyboardEvent;
      var event = new CustomEvent(keyCombo.event, {
        detail: detail,
        cancelable: true
      });
      this[handlerName].call(this, event);
      if (event.defaultPrevented) {
        keyboardEvent.preventDefault();
      }
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @demo demo/index.html
   * @polymerBehavior IronButtonState
   */
  const IronButtonStateImpl = {
    properties: {
      /**
       * If true, the user is currently holding down the button.
       */
      pressed: {
        type: Boolean,
        readOnly: true,
        value: false,
        reflectToAttribute: true,
        observer: '_pressedChanged'
      },
      /**
       * If true, the button toggles the active state with each tap or press
       * of the spacebar.
       */
      toggles: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      /**
       * If true, the button is a toggle and is currently in the active state.
       */
      active: {
        type: Boolean,
        value: false,
        notify: true,
        reflectToAttribute: true
      },
      /**
       * True if the element is currently being pressed by a "pointer," which
       * is loosely defined as mouse or touch input (but specifically excluding
       * keyboard input).
       */
      pointerDown: {
        type: Boolean,
        readOnly: true,
        value: false
      },
      /**
       * True if the input device that caused the element to receive focus
       * was a keyboard.
       */
      receivedFocusFromKeyboard: {
        type: Boolean,
        readOnly: true
      },
      /**
       * The aria attribute to be set if the button is a toggle and in the
       * active state.
       */
      ariaActiveAttribute: {
        type: String,
        value: 'aria-pressed',
        observer: '_ariaActiveAttributeChanged'
      }
    },
    listeners: {
      down: '_downHandler',
      up: '_upHandler',
      tap: '_tapHandler'
    },
    observers: ['_focusChanged(focused)', '_activeChanged(active, ariaActiveAttribute)'],
    /**
     * @type {!Object}
     */
    keyBindings: {
      'enter:keydown': '_asyncClick',
      'space:keydown': '_spaceKeyDownHandler',
      'space:keyup': '_spaceKeyUpHandler'
    },
    _mouseEventRe: /^mouse/,
    _tapHandler: function () {
      if (this.toggles) {
        // a tap is needed to toggle the active state
        this._userActivate(!this.active);
      } else {
        this.active = false;
      }
    },
    _focusChanged: function (focused) {
      this._detectKeyboardFocus(focused);
      if (!focused) {
        this._setPressed(false);
      }
    },
    _detectKeyboardFocus: function (focused) {
      this._setReceivedFocusFromKeyboard(!this.pointerDown && focused);
    },
    // to emulate native checkbox, (de-)activations from a user interaction fire
    // 'change' events
    _userActivate: function (active) {
      if (this.active !== active) {
        this.active = active;
        this.fire('change');
      }
    },
    _downHandler: function (event) {
      this._setPointerDown(true);
      this._setPressed(true);
      this._setReceivedFocusFromKeyboard(false);
    },
    _upHandler: function () {
      this._setPointerDown(false);
      this._setPressed(false);
    },
    /**
     * @param {!KeyboardEvent} event .
     */
    _spaceKeyDownHandler: function (event) {
      var keyboardEvent = event.detail.keyboardEvent;
      var target = dom(keyboardEvent).localTarget;

      // Ignore the event if this is coming from a focused light child, since that
      // element will deal with it.
      if (this.isLightDescendant( /** @type {Node} */target)) return;
      keyboardEvent.preventDefault();
      keyboardEvent.stopImmediatePropagation();
      this._setPressed(true);
    },
    /**
     * @param {!KeyboardEvent} event .
     */
    _spaceKeyUpHandler: function (event) {
      var keyboardEvent = event.detail.keyboardEvent;
      var target = dom(keyboardEvent).localTarget;

      // Ignore the event if this is coming from a focused light child, since that
      // element will deal with it.
      if (this.isLightDescendant( /** @type {Node} */target)) return;
      if (this.pressed) {
        this._asyncClick();
      }
      this._setPressed(false);
    },
    // trigger click asynchronously, the asynchrony is useful to allow one
    // event handler to unwind before triggering another event
    _asyncClick: function () {
      this.async(function () {
        this.click();
      }, 1);
    },
    // any of these changes are considered a change to button state

    _pressedChanged: function (pressed) {
      this._changedButtonState();
    },
    _ariaActiveAttributeChanged: function (value, oldValue) {
      if (oldValue && oldValue != value && this.hasAttribute(oldValue)) {
        this.removeAttribute(oldValue);
      }
    },
    _activeChanged: function (active, ariaActiveAttribute) {
      if (this.toggles) {
        this.setAttribute(this.ariaActiveAttribute, active ? 'true' : 'false');
      } else {
        this.removeAttribute(this.ariaActiveAttribute);
      }
      this._changedButtonState();
    },
    _controlStateChanged: function () {
      if (this.disabled) {
        this._setPressed(false);
      } else {
        this._changedButtonState();
      }
    },
    // provide hook for follow-on behaviors to react to button-state

    _changedButtonState: function () {
      if (this._buttonStateChanged) {
        this._buttonStateChanged(); // abstract
      }
    }
  };

  /** @polymerBehavior */
  const IronButtonState = [IronA11yKeysBehavior, IronButtonStateImpl];

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  var Utility = {
    distance: function (x1, y1, x2, y2) {
      var xDelta = x1 - x2;
      var yDelta = y1 - y2;
      return Math.sqrt(xDelta * xDelta + yDelta * yDelta);
    },
    now: window.performance && window.performance.now ? window.performance.now.bind(window.performance) : Date.now
  };

  /**
   * @param {HTMLElement} element
   * @constructor
   */
  function ElementMetrics(element) {
    this.element = element;
    this.width = this.boundingRect.width;
    this.height = this.boundingRect.height;
    this.size = Math.max(this.width, this.height);
  }
  ElementMetrics.prototype = {
    get boundingRect() {
      return this.element.getBoundingClientRect();
    },
    furthestCornerDistanceFrom: function (x, y) {
      var topLeft = Utility.distance(x, y, 0, 0);
      var topRight = Utility.distance(x, y, this.width, 0);
      var bottomLeft = Utility.distance(x, y, 0, this.height);
      var bottomRight = Utility.distance(x, y, this.width, this.height);
      return Math.max(topLeft, topRight, bottomLeft, bottomRight);
    }
  };

  /**
   * @param {HTMLElement} element
   * @constructor
   */
  function Ripple(element) {
    this.element = element;
    this.color = window.getComputedStyle(element).color;
    this.wave = document.createElement('div');
    this.waveContainer = document.createElement('div');
    this.wave.style.backgroundColor = this.color;
    this.wave.classList.add('wave');
    this.waveContainer.classList.add('wave-container');
    dom(this.waveContainer).appendChild(this.wave);
    this.resetInteractionState();
  }
  Ripple.MAX_RADIUS = 300;
  Ripple.prototype = {
    get recenters() {
      return this.element.recenters;
    },
    get center() {
      return this.element.center;
    },
    get mouseDownElapsed() {
      var elapsed;
      if (!this.mouseDownStart) {
        return 0;
      }
      elapsed = Utility.now() - this.mouseDownStart;
      if (this.mouseUpStart) {
        elapsed -= this.mouseUpElapsed;
      }
      return elapsed;
    },
    get mouseUpElapsed() {
      return this.mouseUpStart ? Utility.now() - this.mouseUpStart : 0;
    },
    get mouseDownElapsedSeconds() {
      return this.mouseDownElapsed / 1000;
    },
    get mouseUpElapsedSeconds() {
      return this.mouseUpElapsed / 1000;
    },
    get mouseInteractionSeconds() {
      return this.mouseDownElapsedSeconds + this.mouseUpElapsedSeconds;
    },
    get initialOpacity() {
      return this.element.initialOpacity;
    },
    get opacityDecayVelocity() {
      return this.element.opacityDecayVelocity;
    },
    get radius() {
      var width2 = this.containerMetrics.width * this.containerMetrics.width;
      var height2 = this.containerMetrics.height * this.containerMetrics.height;
      var waveRadius = Math.min(Math.sqrt(width2 + height2), Ripple.MAX_RADIUS) * 1.1 + 5;
      var duration = 1.1 - 0.2 * (waveRadius / Ripple.MAX_RADIUS);
      var timeNow = this.mouseInteractionSeconds / duration;
      var size = waveRadius * (1 - Math.pow(80, -timeNow));
      return Math.abs(size);
    },
    get opacity() {
      if (!this.mouseUpStart) {
        return this.initialOpacity;
      }
      return Math.max(0, this.initialOpacity - this.mouseUpElapsedSeconds * this.opacityDecayVelocity);
    },
    get outerOpacity() {
      // Linear increase in background opacity, capped at the opacity
      // of the wavefront (waveOpacity).
      var outerOpacity = this.mouseUpElapsedSeconds * 0.3;
      var waveOpacity = this.opacity;
      return Math.max(0, Math.min(outerOpacity, waveOpacity));
    },
    get isOpacityFullyDecayed() {
      return this.opacity < 0.01 && this.radius >= Math.min(this.maxRadius, Ripple.MAX_RADIUS);
    },
    get isRestingAtMaxRadius() {
      return this.opacity >= this.initialOpacity && this.radius >= Math.min(this.maxRadius, Ripple.MAX_RADIUS);
    },
    get isAnimationComplete() {
      return this.mouseUpStart ? this.isOpacityFullyDecayed : this.isRestingAtMaxRadius;
    },
    get translationFraction() {
      return Math.min(1, this.radius / this.containerMetrics.size * 2 / Math.sqrt(2));
    },
    get xNow() {
      if (this.xEnd) {
        return this.xStart + this.translationFraction * (this.xEnd - this.xStart);
      }
      return this.xStart;
    },
    get yNow() {
      if (this.yEnd) {
        return this.yStart + this.translationFraction * (this.yEnd - this.yStart);
      }
      return this.yStart;
    },
    get isMouseDown() {
      return this.mouseDownStart && !this.mouseUpStart;
    },
    resetInteractionState: function () {
      this.maxRadius = 0;
      this.mouseDownStart = 0;
      this.mouseUpStart = 0;
      this.xStart = 0;
      this.yStart = 0;
      this.xEnd = 0;
      this.yEnd = 0;
      this.slideDistance = 0;
      this.containerMetrics = new ElementMetrics(this.element);
    },
    draw: function () {
      var scale;
      var dx;
      var dy;
      this.wave.style.opacity = this.opacity;
      scale = this.radius / (this.containerMetrics.size / 2);
      dx = this.xNow - this.containerMetrics.width / 2;
      dy = this.yNow - this.containerMetrics.height / 2;

      // 2d transform for safari because of border-radius and overflow:hidden
      // clipping bug. https://bugs.webkit.org/show_bug.cgi?id=98538
      this.waveContainer.style.webkitTransform = 'translate(' + dx + 'px, ' + dy + 'px)';
      this.waveContainer.style.transform = 'translate3d(' + dx + 'px, ' + dy + 'px, 0)';
      this.wave.style.webkitTransform = 'scale(' + scale + ',' + scale + ')';
      this.wave.style.transform = 'scale3d(' + scale + ',' + scale + ',1)';
    },
    /** @param {Event=} event */
    downAction: function (event) {
      var xCenter = this.containerMetrics.width / 2;
      var yCenter = this.containerMetrics.height / 2;
      this.resetInteractionState();
      this.mouseDownStart = Utility.now();
      if (this.center) {
        this.xStart = xCenter;
        this.yStart = yCenter;
        this.slideDistance = Utility.distance(this.xStart, this.yStart, this.xEnd, this.yEnd);
      } else {
        this.xStart = event ? event.detail.x - this.containerMetrics.boundingRect.left : this.containerMetrics.width / 2;
        this.yStart = event ? event.detail.y - this.containerMetrics.boundingRect.top : this.containerMetrics.height / 2;
      }
      if (this.recenters) {
        this.xEnd = xCenter;
        this.yEnd = yCenter;
        this.slideDistance = Utility.distance(this.xStart, this.yStart, this.xEnd, this.yEnd);
      }
      this.maxRadius = this.containerMetrics.furthestCornerDistanceFrom(this.xStart, this.yStart);
      this.waveContainer.style.top = (this.containerMetrics.height - this.containerMetrics.size) / 2 + 'px';
      this.waveContainer.style.left = (this.containerMetrics.width - this.containerMetrics.size) / 2 + 'px';
      this.waveContainer.style.width = this.containerMetrics.size + 'px';
      this.waveContainer.style.height = this.containerMetrics.size + 'px';
    },
    /** @param {Event=} event */
    upAction: function (event) {
      if (!this.isMouseDown) {
        return;
      }
      this.mouseUpStart = Utility.now();
    },
    remove: function () {
      dom(dom(this.waveContainer).parentNode).removeChild(this.waveContainer);
    }
  };

  /**
  Material design: [Surface
  reaction](https://www.google.com/design/spec/animation/responsive-interaction.html#responsive-interaction-surface-reaction)

  `paper-ripple` provides a visual effect that other paper elements can
  use to simulate a rippling effect emanating from the point of contact.  The
  effect can be visualized as a concentric circle with motion.

  Example:

      <div style="position:relative">
        <paper-ripple></paper-ripple>
      </div>

  Note, it's important that the parent container of the ripple be relative
  position, otherwise the ripple will emanate outside of the desired container.

  `paper-ripple` listens to "mousedown" and "mouseup" events so it would display
  ripple effect when touches on it.  You can also defeat the default behavior and
  manually route the down and up actions to the ripple element.  Note that it is
  important if you call `downAction()` you will have to make sure to call
  `upAction()` so that `paper-ripple` would end the animation loop.

  Example:

      <paper-ripple id="ripple" style="pointer-events: none;"></paper-ripple>
      ...
      downAction: function(e) {
        this.$.ripple.downAction(e.detail);
      },
      upAction: function(e) {
        this.$.ripple.upAction();
      }

  Styling ripple effect:

    Use CSS color property to style the ripple:

      paper-ripple {
        color: #4285f4;
      }

    Note that CSS color property is inherited so it is not required to set it on
    the `paper-ripple` element directly.

  By default, the ripple is centered on the point of contact.  Apply the
  `recenters` attribute to have the ripple grow toward the center of its
  container.

      <paper-ripple recenters></paper-ripple>

  You can also  center the ripple inside its container from the start.

      <paper-ripple center></paper-ripple>

  Apply `circle` class to make the rippling effect within a circle.

      <paper-ripple class="circle"></paper-ripple>

  @element paper-ripple
  @demo demo/index.html
  */
  Polymer({
    /** @override */
    _template: html`
    <style>
      :host {
        display: block;
        position: absolute;
        border-radius: inherit;
        overflow: hidden;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        /* See PolymerElements/paper-behaviors/issues/34. On non-Chrome browsers,
         * creating a node (with a position:absolute) in the middle of an event
         * handler "interrupts" that event handler (which happens when the
         * ripple is created on demand) */
        pointer-events: none;
      }

      :host([animating]) {
        /* This resolves a rendering issue in Chrome (as of 40) where the
           ripple is not properly clipped by its parent (which may have
           rounded corners). See: http://jsbin.com/temexa/4

           Note: We only apply this style conditionally. Otherwise, the browser
           will create a new compositing layer for every ripple element on the
           page, and that would be bad. */
        -webkit-transform: translate(0, 0);
        transform: translate3d(0, 0, 0);
      }

      #background,
      #waves,
      .wave-container,
      .wave {
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      #background,
      .wave {
        opacity: 0;
      }

      #waves,
      .wave {
        overflow: hidden;
      }

      .wave-container,
      .wave {
        border-radius: 50%;
      }

      :host(.circle) #background,
      :host(.circle) #waves {
        border-radius: 50%;
      }

      :host(.circle) .wave-container {
        overflow: hidden;
      }
    </style>

    <div id="background"></div>
    <div id="waves"></div>
`,
    is: 'paper-ripple',
    behaviors: [IronA11yKeysBehavior],
    properties: {
      /**
       * The initial opacity set on the wave.
       * @type number
       * @default 0.25
       */
      initialOpacity: {
        type: Number,
        value: 0.25
      },
      /**
       * How fast (opacity per second) the wave fades out.
       *
       * @type number
       * @default 0.8
       */
      opacityDecayVelocity: {
        type: Number,
        value: 0.8
      },
      /**
       * If true, ripples will exhibit a gravitational pull towards
       * the center of their container as they fade away.
       *
       * @type boolean
       * @default false
       */
      recenters: {
        type: Boolean,
        value: false
      },
      /**
       * If true, ripples will center inside its container
       *
       * @type boolean
       * @default false
       */
      center: {
        type: Boolean,
        value: false
      },
      /**
       * A list of the visual ripples.
       *
       * @type Array
       * @default []
       */
      ripples: {
        type: Array,
        value: function () {
          return [];
        }
      },
      /**
       * True when there are visible ripples animating within the
       * element.
       */
      animating: {
        type: Boolean,
        readOnly: true,
        reflectToAttribute: true,
        value: false
      },
      /**
       * If true, the ripple will remain in the "down" state until `holdDown`
       * is set to false again.
       */
      holdDown: {
        type: Boolean,
        value: false,
        observer: '_holdDownChanged'
      },
      /**
       * If true, the ripple will not generate a ripple effect
       * via pointer interaction.
       * Calling ripple's imperative api like `simulatedRipple` will
       * still generate the ripple effect.
       */
      noink: {
        type: Boolean,
        value: false
      },
      _animating: {
        type: Boolean
      },
      _boundAnimate: {
        type: Function,
        value: function () {
          return this.animate.bind(this);
        }
      }
    },
    get target() {
      return this.keyEventTarget;
    },
    /**
     * @type {!Object}
     */
    keyBindings: {
      'enter:keydown': '_onEnterKeydown',
      'space:keydown': '_onSpaceKeydown',
      'space:keyup': '_onSpaceKeyup'
    },
    /** @override */
    attached: function () {
      // Set up a11yKeysBehavior to listen to key events on the target,
      // so that space and enter activate the ripple even if the target doesn't
      // handle key events. The key handlers deal with `noink` themselves.
      if (dom(this).parentNode.nodeType == 11) {
        // DOCUMENT_FRAGMENT_NODE
        this.keyEventTarget = dom(this).getOwnerRoot().host;
      } else {
        this.keyEventTarget = dom(this).parentNode;
      }
      var keyEventTarget = /** @type {!EventTarget} */this.keyEventTarget;
      this.listen(keyEventTarget, 'up', 'uiUpAction');
      this.listen(keyEventTarget, 'down', 'uiDownAction');
    },
    /** @override */
    detached: function () {
      this.unlisten(this.keyEventTarget, 'up', 'uiUpAction');
      this.unlisten(this.keyEventTarget, 'down', 'uiDownAction');
      this.keyEventTarget = null;
    },
    get shouldKeepAnimating() {
      for (var index = 0; index < this.ripples.length; ++index) {
        if (!this.ripples[index].isAnimationComplete) {
          return true;
        }
      }
      return false;
    },
    simulatedRipple: function () {
      this.downAction(null);

      // Please see polymer/polymer#1305
      this.async(function () {
        this.upAction();
      }, 1);
    },
    /**
     * Provokes a ripple down effect via a UI event,
     * respecting the `noink` property.
     * @param {Event=} event
     */
    uiDownAction: function (event) {
      if (!this.noink) {
        this.downAction(event);
      }
    },
    /**
     * Provokes a ripple down effect via a UI event,
     * *not* respecting the `noink` property.
     * @param {Event=} event
     */
    downAction: function (event) {
      if (this.holdDown && this.ripples.length > 0) {
        return;
      }
      var ripple = this.addRipple();
      ripple.downAction(event);
      if (!this._animating) {
        this._animating = true;
        this.animate();
      }
    },
    /**
     * Provokes a ripple up effect via a UI event,
     * respecting the `noink` property.
     * @param {Event=} event
     */
    uiUpAction: function (event) {
      if (!this.noink) {
        this.upAction(event);
      }
    },
    /**
     * Provokes a ripple up effect via a UI event,
     * *not* respecting the `noink` property.
     * @param {Event=} event
     */
    upAction: function (event) {
      if (this.holdDown) {
        return;
      }
      this.ripples.forEach(function (ripple) {
        ripple.upAction(event);
      });
      this._animating = true;
      this.animate();
    },
    onAnimationComplete: function () {
      this._animating = false;
      this.$.background.style.backgroundColor = '';
      this.fire('transitionend');
    },
    addRipple: function () {
      var ripple = new Ripple(this);
      dom(this.$.waves).appendChild(ripple.waveContainer);
      this.$.background.style.backgroundColor = ripple.color;
      this.ripples.push(ripple);
      this._setAnimating(true);
      return ripple;
    },
    removeRipple: function (ripple) {
      var rippleIndex = this.ripples.indexOf(ripple);
      if (rippleIndex < 0) {
        return;
      }
      this.ripples.splice(rippleIndex, 1);
      ripple.remove();
      if (!this.ripples.length) {
        this._setAnimating(false);
      }
    },
    /**
     * Deprecated. Please use animateRipple() instead.
     *
     * This method name conflicts with Element#animate().
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/animate.
     *
     * @suppress {checkTypes}
     * @override
     */
    animate: function () {
      if (!this._animating) {
        return;
      }
      var index;
      var ripple;
      for (index = 0; index < this.ripples.length; ++index) {
        ripple = this.ripples[index];
        ripple.draw();
        this.$.background.style.opacity = ripple.outerOpacity;
        if (ripple.isOpacityFullyDecayed && !ripple.isRestingAtMaxRadius) {
          this.removeRipple(ripple);
        }
      }
      if (!this.shouldKeepAnimating && this.ripples.length === 0) {
        this.onAnimationComplete();
      } else {
        window.requestAnimationFrame(this._boundAnimate);
      }
    },
    /**
     * An alias for animate() whose name does not conflict with the platform
     * Element.animate() method.
     */
    animateRipple: function () {
      return this.animate();
    },
    _onEnterKeydown: function () {
      this.uiDownAction();
      this.async(this.uiUpAction, 1);
    },
    _onSpaceKeydown: function () {
      this.uiDownAction();
    },
    _onSpaceKeyup: function () {
      this.uiUpAction();
    },
    // note: holdDown does not respect noink since it can be a focus based
    // effect.
    _holdDownChanged: function (newVal, oldVal) {
      if (oldVal === undefined) {
        return;
      }
      if (newVal) {
        this.downAction();
      } else {
        this.upAction();
      }
    }

    /**
    Fired when the animation finishes.
    This is useful if you want to wait until
    the ripple animation finishes to perform some action.
     @event transitionend
    @param {{node: Object}} detail Contains the animated node.
    */
  });

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `PaperRippleBehavior` dynamically implements a ripple when the element has
   * focus via pointer or keyboard.
   *
   * NOTE: This behavior is intended to be used in conjunction with and after
   * `IronButtonState` and `IronControlState`.
   *
   * @polymerBehavior PaperRippleBehavior
   */
  const PaperRippleBehavior = {
    properties: {
      /**
       * If true, the element will not produce a ripple effect when interacted
       * with via the pointer.
       */
      noink: {
        type: Boolean,
        observer: '_noinkChanged'
      },
      /**
       * @type {Element|undefined}
       */
      _rippleContainer: {
        type: Object
      }
    },
    /**
     * Ensures a `<paper-ripple>` element is available when the element is
     * focused.
     */
    _buttonStateChanged: function () {
      if (this.focused) {
        this.ensureRipple();
      }
    },
    /**
     * In addition to the functionality provided in `IronButtonState`, ensures
     * a ripple effect is created when the element is in a `pressed` state.
     */
    _downHandler: function (event) {
      IronButtonStateImpl._downHandler.call(this, event);
      if (this.pressed) {
        this.ensureRipple(event);
      }
    },
    /**
     * Ensures this element contains a ripple effect. For startup efficiency
     * the ripple effect is dynamically on demand when needed.
     * @param {!Event=} optTriggeringEvent (optional) event that triggered the
     * ripple.
     */
    ensureRipple: function (optTriggeringEvent) {
      if (!this.hasRipple()) {
        this._ripple = this._createRipple();
        this._ripple.noink = this.noink;
        var rippleContainer = this._rippleContainer || this.root;
        if (rippleContainer) {
          dom(rippleContainer).appendChild(this._ripple);
        }
        if (optTriggeringEvent) {
          // Check if the event happened inside of the ripple container
          // Fall back to host instead of the root because distributed text
          // nodes are not valid event targets
          var domContainer = dom(this._rippleContainer || this);
          var target = dom(optTriggeringEvent).rootTarget;
          if (domContainer.deepContains( /** @type {Node} */target)) {
            this._ripple.uiDownAction(optTriggeringEvent);
          }
        }
      }
    },
    /**
     * Returns the `<paper-ripple>` element used by this element to create
     * ripple effects. The element's ripple is created on demand, when
     * necessary, and calling this method will force the
     * ripple to be created.
     */
    getRipple: function () {
      this.ensureRipple();
      return this._ripple;
    },
    /**
     * Returns true if this element currently contains a ripple effect.
     * @return {boolean}
     */
    hasRipple: function () {
      return Boolean(this._ripple);
    },
    /**
     * Create the element's ripple effect via creating a `<paper-ripple>`.
     * Override this method to customize the ripple element.
     * @return {!PaperRippleElement} Returns a `<paper-ripple>` element.
     */
    _createRipple: function () {
      var element = /** @type {!PaperRippleElement} */
      document.createElement('paper-ripple');
      return element;
    },
    _noinkChanged: function (noink) {
      if (this.hasRipple()) {
        this._ripple.noink = noink;
      }
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /** @polymerBehavior PaperButtonBehavior */
  const PaperButtonBehaviorImpl = {
    properties: {
      /**
       * The z-depth of this element, from 0-5. Setting to 0 will remove the
       * shadow, and each increasing number greater than 0 will be "deeper"
       * than the last.
       *
       * @attribute elevation
       * @type number
       * @default 1
       */
      elevation: {
        type: Number,
        reflectToAttribute: true,
        readOnly: true
      }
    },
    observers: ['_calculateElevation(focused, disabled, active, pressed, receivedFocusFromKeyboard)', '_computeKeyboardClass(receivedFocusFromKeyboard)'],
    hostAttributes: {
      role: 'button',
      tabindex: '0',
      animated: true
    },
    _calculateElevation: function () {
      var e = 1;
      if (this.disabled) {
        e = 0;
      } else if (this.active || this.pressed) {
        e = 4;
      } else if (this.receivedFocusFromKeyboard) {
        e = 3;
      }
      this._setElevation(e);
    },
    _computeKeyboardClass: function (receivedFocusFromKeyboard) {
      this.toggleClass('keyboard-focus', receivedFocusFromKeyboard);
    },
    /**
     * In addition to `IronButtonState` behavior, when space key goes down,
     * create a ripple down effect.
     *
     * @param {!KeyboardEvent} event .
     */
    _spaceKeyDownHandler: function (event) {
      IronButtonStateImpl._spaceKeyDownHandler.call(this, event);
      // Ensure that there is at most one ripple when the space key is held down.
      if (this.hasRipple() && this.getRipple().ripples.length < 1) {
        this._ripple.uiDownAction();
      }
    },
    /**
     * In addition to `IronButtonState` behavior, when space key goes up,
     * create a ripple up effect.
     *
     * @param {!KeyboardEvent} event .
     */
    _spaceKeyUpHandler: function (event) {
      IronButtonStateImpl._spaceKeyUpHandler.call(this, event);
      if (this.hasRipple()) {
        this._ripple.uiUpAction();
      }
    }
  };

  /** @polymerBehavior */
  const PaperButtonBehavior = [IronButtonState, IronControlState, PaperRippleBehavior, PaperButtonBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$b = html`
  <style include="paper-material-styles">
    /* Need to specify the same specificity as the styles imported from paper-material. */
    :host {
      @apply --layout-inline;
      @apply --layout-center-center;
      position: relative;
      box-sizing: border-box;
      min-width: 5.14em;
      margin: 0 0.29em;
      background: transparent;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent;
      font: inherit;
      text-transform: uppercase;
      outline-width: 0;
      border-radius: 3px;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-select: none;
      user-select: none;
      cursor: pointer;
      z-index: 0;
      padding: 0.7em 0.57em;

      @apply --paper-font-common-base;
      @apply --paper-button;
    }

    :host([elevation="1"]) {
      @apply --paper-material-elevation-1;
    }

    :host([elevation="2"]) {
      @apply --paper-material-elevation-2;
    }

    :host([elevation="3"]) {
      @apply --paper-material-elevation-3;
    }

    :host([elevation="4"]) {
      @apply --paper-material-elevation-4;
    }

    :host([elevation="5"]) {
      @apply --paper-material-elevation-5;
    }

    :host([hidden]) {
      display: none !important;
    }

    :host([raised].keyboard-focus) {
      font-weight: bold;
      @apply --paper-button-raised-keyboard-focus;
    }

    :host(:not([raised]).keyboard-focus) {
      font-weight: bold;
      @apply --paper-button-flat-keyboard-focus;
    }

    :host([disabled]) {
      background: none;
      color: #a8a8a8;
      cursor: auto;
      pointer-events: none;

      @apply --paper-button-disabled;
    }

    :host([disabled][raised]) {
      background: #eaeaea;
    }


    :host([animated]) {
      @apply --shadow-transition;
    }

    paper-ripple {
      color: var(--paper-button-ink-color);
    }
  </style>

  <slot></slot>`;
  template$b.setAttribute('strip-whitespace', '');

  /**
  Material design:
  [Buttons](https://www.google.com/design/spec/components/buttons.html)

  `paper-button` is a button. When the user touches the button, a ripple effect
  emanates from the point of contact. It may be flat or raised. A raised button is
  styled with a shadow.

  Example:

      <paper-button>Flat button</paper-button>
      <paper-button raised>Raised button</paper-button>
      <paper-button noink>No ripple effect</paper-button>
      <paper-button toggles>Toggle-able button</paper-button>

  A button that has `toggles` true will remain `active` after being clicked (and
  will have an `active` attribute set). For more information, see the
  `IronButtonState` behavior.

  You may use custom DOM in the button body to create a variety of buttons. For
  example, to create a button with an icon and some text:

      <paper-button>
        <iron-icon icon="favorite"></iron-icon>
        custom button content
      </paper-button>

  To use `paper-button` as a link, wrap it in an anchor tag. Since `paper-button`
  will already receive focus, you may want to prevent the anchor tag from
  receiving focus as well by setting its tabindex to -1.

      <a href="https://www.polymer-project.org/" tabindex="-1">
        <paper-button raised>Polymer Project</paper-button>
      </a>

  ### Styling

  Style the button with CSS as you would a normal DOM element.

      paper-button.fancy {
        background: green;
        color: yellow;
      }

      paper-button.fancy:hover {
        background: lime;
      }

      paper-button[disabled],
      paper-button[toggles][active] {
        background: red;
      }

  By default, the ripple is the same color as the foreground at 25% opacity. You
  may customize the color using the `--paper-button-ink-color` custom property.

  The following custom properties and mixins are also available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--paper-button-ink-color` | Background color of the ripple | `Based on the button's color`
  `--paper-button` | Mixin applied to the button | `{}`
  `--paper-button-disabled` | Mixin applied to the disabled button. Note that you can also use the `paper-button[disabled]` selector | `{}`
  `--paper-button-flat-keyboard-focus` | Mixin applied to a flat button after it's been focused using the keyboard | `{}`
  `--paper-button-raised-keyboard-focus` | Mixin applied to a raised button after it's been focused using the keyboard | `{}`

  @demo demo/index.html
  */
  Polymer({
    _template: template$b,
    is: 'paper-button',
    behaviors: [PaperButtonBehavior],
    properties: {
      /**
       * If true, the button should be styled with a shadow.
       */
      raised: {
        type: Boolean,
        reflectToAttribute: true,
        value: false,
        observer: '_calculateElevation'
      }
    },
    _calculateElevation: function () {
      if (!this.raised) {
        this._setElevation(0);
      } else {
        PaperButtonBehaviorImpl._calculateElevation.apply(this);
      }
    }

    /**
    Fired when the animation finishes.
    This is useful if you want to wait until
    the ripple animation finishes to perform some action.
     @event transitionend
    Event param: {{node: Object}} detail Contains the animated node.
    */
  });

  let IronMeta = /*#__PURE__*/function () {
    /**
     * @param {{
     *   type: (string|null|undefined),
     *   key: (string|null|undefined),
     *   value: *,
     * }=} options
     */
    function IronMeta(options) {
      _classCallCheck(this, IronMeta);
      IronMeta[' '](options);

      /** @type {string} */
      this.type = options && options.type || 'default';
      /** @type {string|null|undefined} */
      this.key = options && options.key;
      if (options && 'value' in options) {
        /** @type {*} */
        this.value = options.value;
      }
    }

    /** @return {*} */
    _createClass(IronMeta, [{
      key: "value",
      get: function () {
        var type = this.type;
        var key = this.key;
        if (type && key) {
          return IronMeta.types[type] && IronMeta.types[type][key];
        }
      }

      /** @param {*} value */,
      set: function (value) {
        var type = this.type;
        var key = this.key;
        if (type && key) {
          type = IronMeta.types[type] = IronMeta.types[type] || {};
          if (value == null) {
            delete type[key];
          } else {
            type[key] = value;
          }
        }
      }

      /** @return {!Array<*>} */
    }, {
      key: "list",
      get: function () {
        var type = this.type;
        if (type) {
          var items = IronMeta.types[this.type];
          if (!items) {
            return [];
          }
          return Object.keys(items).map(function (key) {
            return metaDatas[this.type][key];
          }, this);
        }
      }

      /**
       * @param {string} key
       * @return {*}
       */
    }, {
      key: "byKey",
      value: function byKey(key) {
        this.key = key;
        return this.value;
      }
    }]);
    return IronMeta;
  }();

  // This function is used to convince Closure not to remove constructor calls
  // for instances that are not held anywhere. For example, when
  // `new IronMeta({...})` is used only for the side effect of adding a value.
  IronMeta[' '] = function () {};
  IronMeta.types = {};
  var metaDatas = IronMeta.types;

  /**
  `iron-meta` is a generic element you can use for sharing information across the
  DOM tree. It uses [monostate pattern](http://c2.com/cgi/wiki?MonostatePattern)
  such that any instance of iron-meta has access to the shared information. You
  can use `iron-meta` to share whatever you want (or create an extension [like
  x-meta] for enhancements).

  The `iron-meta` instances containing your actual data can be loaded in an
  import, or constructed in any way you see fit. The only requirement is that you
  create them before you try to access them.

  Examples:

  If I create an instance like this:

      <iron-meta key="info" value="foo/bar"></iron-meta>

  Note that value="foo/bar" is the metadata I've defined. I could define more
  attributes or use child nodes to define additional metadata.

  Now I can access that element (and it's metadata) from any iron-meta instance
  via the byKey method, e.g.

      meta.byKey('info');

  Pure imperative form would be like:

      document.createElement('iron-meta').byKey('info');

  Or, in a Polymer element, you can include a meta in your template:

      <iron-meta id="meta"></iron-meta>
      ...
      this.$.meta.byKey('info');

  @group Iron Elements
  @demo demo/index.html
  @element iron-meta
  */
  Polymer({
    is: 'iron-meta',
    properties: {
      /**
       * The type of meta-data.  All meta-data of the same type is stored
       * together.
       * @type {string}
       */
      type: {
        type: String,
        value: 'default'
      },
      /**
       * The key used to store `value` under the `type` namespace.
       * @type {?string}
       */
      key: {
        type: String
      },
      /**
       * The meta-data to store or retrieve.
       * @type {*}
       */
      value: {
        type: String,
        notify: true
      },
      /**
       * If true, `value` is set to the iron-meta instance itself.
       */
      self: {
        type: Boolean,
        observer: '_selfChanged'
      },
      __meta: {
        type: Boolean,
        computed: '__computeMeta(type, key, value)'
      }
    },
    hostAttributes: {
      hidden: true
    },
    __computeMeta: function (type, key, value) {
      var meta = new IronMeta({
        type: type,
        key: key
      });
      if (value !== undefined && value !== meta.value) {
        meta.value = value;
      } else if (this.value !== meta.value) {
        this.value = meta.value;
      }
      return meta;
    },
    get list() {
      return this.__meta && this.__meta.list;
    },
    _selfChanged: function (self) {
      if (self) {
        this.value = this;
      }
    },
    /**
     * Retrieves meta data value by key.
     *
     * @method byKey
     * @param {string} key The key of the meta-data to be returned.
     * @return {*}
     */
    byKey: function (key) {
      return new IronMeta({
        type: this.type,
        key: key
      }).value;
    }
  });

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**

  The `iron-icon` element displays an icon. By default an icon renders as a 24px
  square.

  Example using src:

      <iron-icon src="star.png"></iron-icon>

  Example setting size to 32px x 32px:

      <iron-icon class="big" src="big_star.png"></iron-icon>

      <style is="custom-style">
        .big {
          --iron-icon-height: 32px;
          --iron-icon-width: 32px;
        }
      </style>

  The iron elements include several sets of icons. To use the default set of
  icons, import `iron-icons.js` and use the `icon` attribute to specify an icon:

      <script type="module">
        import "@polymer/iron-icons/iron-icons.js";
      </script>

      <iron-icon icon="menu"></iron-icon>

  To use a different built-in set of icons, import the specific
  `iron-icons/<iconset>-icons.js`, and specify the icon as `<iconset>:<icon>`.
  For example, to use a communication icon, you would use:

      <script type="module">
        import "@polymer/iron-icons/communication-icons.js";
      </script>

      <iron-icon icon="communication:email"></iron-icon>

  You can also create custom icon sets of bitmap or SVG icons.

  Example of using an icon named `cherry` from a custom iconset with the ID
  `fruit`:

      <iron-icon icon="fruit:cherry"></iron-icon>

  See `<iron-iconset>` and `<iron-iconset-svg>` for more information about how to
  create a custom iconset.

  See the `iron-icons` demo to see the icons available in the various iconsets.

  ### Styling

  The following custom properties are available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--iron-icon` | Mixin applied to the icon | {}
  `--iron-icon-width` | Width of the icon | `24px`
  `--iron-icon-height` | Height of the icon | `24px`
  `--iron-icon-fill-color` | Fill color of the svg icon | `currentcolor`
  `--iron-icon-stroke-color` | Stroke color of the svg icon | none

  @group Iron Elements
  @element iron-icon
  @demo demo/index.html
  @hero hero.svg
  @homepage polymer.github.io
  */
  Polymer({
    _template: html`
    <style>
      :host {
        @apply --layout-inline;
        @apply --layout-center-center;
        position: relative;

        vertical-align: middle;

        fill: var(--iron-icon-fill-color, currentcolor);
        stroke: var(--iron-icon-stroke-color, none);

        width: var(--iron-icon-width, 24px);
        height: var(--iron-icon-height, 24px);
        @apply --iron-icon;
      }

      :host([hidden]) {
        display: none;
      }
    </style>
`,
    is: 'iron-icon',
    properties: {
      /**
       * The name of the icon to use. The name should be of the form:
       * `iconset_name:icon_name`.
       */
      icon: {
        type: String
      },
      /**
       * The name of the theme to used, if one is specified by the
       * iconset.
       */
      theme: {
        type: String
      },
      /**
       * If using iron-icon without an iconset, you can set the src to be
       * the URL of an individual icon image file. Note that this will take
       * precedence over a given icon attribute.
       */
      src: {
        type: String
      },
      /**
       * @type {!IronMeta}
       */
      _meta: {
        value: Base.create('iron-meta', {
          type: 'iconset'
        })
      }
    },
    observers: ['_updateIcon(_meta, isAttached)', '_updateIcon(theme, isAttached)', '_srcChanged(src, isAttached)', '_iconChanged(icon, isAttached)'],
    _DEFAULT_ICONSET: 'icons',
    _iconChanged: function (icon) {
      var parts = (icon || '').split(':');
      this._iconName = parts.pop();
      this._iconsetName = parts.pop() || this._DEFAULT_ICONSET;
      this._updateIcon();
    },
    _srcChanged: function (src) {
      this._updateIcon();
    },
    _usesIconset: function () {
      return this.icon || !this.src;
    },
    /** @suppress {visibility} */
    _updateIcon: function () {
      if (this._usesIconset()) {
        if (this._img && this._img.parentNode) {
          dom(this.root).removeChild(this._img);
        }
        if (this._iconName === '') {
          if (this._iconset) {
            this._iconset.removeIcon(this);
          }
        } else if (this._iconsetName && this._meta) {
          this._iconset = /** @type {?Polymer.Iconset} */
          this._meta.byKey(this._iconsetName);
          if (this._iconset) {
            this._iconset.applyIcon(this, this._iconName, this.theme);
            this.unlisten(window, 'iron-iconset-added', '_updateIcon');
          } else {
            this.listen(window, 'iron-iconset-added', '_updateIcon');
          }
        }
      } else {
        if (this._iconset) {
          this._iconset.removeIcon(this);
        }
        if (!this._img) {
          this._img = document.createElement('img');
          this._img.style.width = '100%';
          this._img.style.height = '100%';
          this._img.draggable = false;
        }
        this._img.src = this.src;
        dom(this.root).appendChild(this._img);
      }
    }
  });

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  /**
   * The `iron-iconset-svg` element allows users to define their own icon sets
   * that contain svg icons. The svg icon elements should be children of the
   * `iron-iconset-svg` element. Multiple icons should be given distinct id's.
   *
   * Using svg elements to create icons has a few advantages over traditional
   * bitmap graphics like jpg or png. Icons that use svg are vector based so
   * they are resolution independent and should look good on any device. They
   * are stylable via css. Icons can be themed, colorized, and even animated.
   *
   * Example:
   *
   *     <iron-iconset-svg name="my-svg-icons" size="24">
   *       <svg>
   *         <defs>
   *           <g id="shape">
   *             <rect x="12" y="0" width="12" height="24" />
   *             <circle cx="12" cy="12" r="12" />
   *           </g>
   *         </defs>
   *       </svg>
   *     </iron-iconset-svg>
   *
   * This will automatically register the icon set "my-svg-icons" to the iconset
   * database.  To use these icons from within another element, make a
   * `iron-iconset` element and call the `byId` method
   * to retrieve a given iconset. To apply a particular icon inside an
   * element use the `applyIcon` method. For example:
   *
   *     iconset.applyIcon(iconNode, 'car');
   *
   * @element iron-iconset-svg
   * @demo demo/index.html
   * @implements {Polymer.Iconset}
   */
  Polymer({
    is: 'iron-iconset-svg',
    properties: {
      /**
       * The name of the iconset.
       */
      name: {
        type: String,
        observer: '_nameChanged'
      },
      /**
       * The size of an individual icon. Note that icons must be square.
       */
      size: {
        type: Number,
        value: 24
      },
      /**
       * Set to true to enable mirroring of icons where specified when they are
       * stamped. Icons that should be mirrored should be decorated with a
       * `mirror-in-rtl` attribute.
       *
       * NOTE: For performance reasons, direction will be resolved once per
       * document per iconset, so moving icons in and out of RTL subtrees will
       * not cause their mirrored state to change.
       */
      rtlMirroring: {
        type: Boolean,
        value: false
      },
      /**
       * Set to true to measure RTL based on the dir attribute on the body or
       * html elements (measured on document.body or document.documentElement as
       * available).
       */
      useGlobalRtlAttribute: {
        type: Boolean,
        value: false
      }
    },
    created: function () {
      this._meta = new IronMeta({
        type: 'iconset',
        key: null,
        value: null
      });
    },
    attached: function () {
      this.style.display = 'none';
    },
    /**
     * Construct an array of all icon names in this iconset.
     *
     * @return {!Array} Array of icon names.
     */
    getIconNames: function () {
      this._icons = this._createIconMap();
      return Object.keys(this._icons).map(function (n) {
        return this.name + ':' + n;
      }, this);
    },
    /**
     * Applies an icon to the given element.
     *
     * An svg icon is prepended to the element's shadowRoot if it exists,
     * otherwise to the element itself.
     *
     * If RTL mirroring is enabled, and the icon is marked to be mirrored in
     * RTL, the element will be tested (once and only once ever for each
     * iconset) to determine the direction of the subtree the element is in.
     * This direction will apply to all future icon applications, although only
     * icons marked to be mirrored will be affected.
     *
     * @method applyIcon
     * @param {Element} element Element to which the icon is applied.
     * @param {string} iconName Name of the icon to apply.
     * @return {?Element} The svg element which renders the icon.
     */
    applyIcon: function (element, iconName) {
      // Remove old svg element
      this.removeIcon(element);
      // install new svg element
      var svg = this._cloneIcon(iconName, this.rtlMirroring && this._targetIsRTL(element));
      if (svg) {
        // insert svg element into shadow root, if it exists
        var pde = dom(element.root || element);
        pde.insertBefore(svg, pde.childNodes[0]);
        return element._svgIcon = svg;
      }
      return null;
    },
    /**
     * Remove an icon from the given element by undoing the changes effected
     * by `applyIcon`.
     *
     * @param {Element} element The element from which the icon is removed.
     */
    removeIcon: function (element) {
      // Remove old svg element
      if (element._svgIcon) {
        dom(element.root || element).removeChild(element._svgIcon);
        element._svgIcon = null;
      }
    },
    /**
     * Measures and memoizes the direction of the element. Note that this
     * measurement is only done once and the result is memoized for future
     * invocations.
     */
    _targetIsRTL: function (target) {
      if (this.__targetIsRTL == null) {
        if (this.useGlobalRtlAttribute) {
          var globalElement = document.body && document.body.hasAttribute('dir') ? document.body : document.documentElement;
          this.__targetIsRTL = globalElement.getAttribute('dir') === 'rtl';
        } else {
          if (target && target.nodeType !== Node.ELEMENT_NODE) {
            target = target.host;
          }
          this.__targetIsRTL = target && window.getComputedStyle(target)['direction'] === 'rtl';
        }
      }
      return this.__targetIsRTL;
    },
    /**
     *
     * When name is changed, register iconset metadata
     *
     */
    _nameChanged: function () {
      this._meta.value = null;
      this._meta.key = this.name;
      this._meta.value = this;
      this.async(function () {
        this.fire('iron-iconset-added', this, {
          node: window
        });
      });
    },
    /**
     * Create a map of child SVG elements by id.
     *
     * @return {!Object} Map of id's to SVG elements.
     */
    _createIconMap: function () {
      // Objects chained to Object.prototype (`{}`) have members. Specifically,
      // on FF there is a `watch` method that confuses the icon map, so we
      // need to use a null-based object here.
      var icons = Object.create(null);
      dom(this).querySelectorAll('[id]').forEach(function (icon) {
        icons[icon.id] = icon;
      });
      return icons;
    },
    /**
     * Produce installable clone of the SVG element matching `id` in this
     * iconset, or `undefined` if there is no matching element.
     *
     * @return {Element} Returns an installable clone of the SVG element
     * matching `id`.
     */
    _cloneIcon: function (id, mirrorAllowed) {
      // create the icon map on-demand, since the iconset itself has no discrete
      // signal to know when it's children are fully parsed
      this._icons = this._icons || this._createIconMap();
      return this._prepareSvgClone(this._icons[id], this.size, mirrorAllowed);
    },
    /**
     * @param {Element} sourceSvg
     * @param {number} size
     * @param {Boolean} mirrorAllowed
     * @return {Element}
     */
    _prepareSvgClone: function (sourceSvg, size, mirrorAllowed) {
      if (sourceSvg) {
        var content = sourceSvg.cloneNode(true),
          svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
          viewBox = content.getAttribute('viewBox') || '0 0 ' + size + ' ' + size,
          cssText = 'pointer-events: none; display: block; width: 100%; height: 100%;';
        if (mirrorAllowed && content.hasAttribute('mirror-in-rtl')) {
          cssText += '-webkit-transform:scale(-1,1);transform:scale(-1,1);transform-origin:center;';
        }
        svg.setAttribute('viewBox', viewBox);
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.setAttribute('focusable', 'false');
        // TODO(dfreedm): `pointer-events: none` works around
        // https://crbug.com/370136
        // TODO(sjmiles): inline style may not be ideal, but avoids requiring a
        // shadow-root
        svg.style.cssText = cssText;
        svg.appendChild(content).removeAttribute('id');
        return svg;
      }
      return null;
    }
  });

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**

  `iron-icons` is a utility import that includes the definition for the
  `iron-icon` element, `iron-iconset-svg` element, as well as an import for the
  default icon set.

  The `iron-icons` directory also includes imports for additional icon sets that
  can be loaded into your project.

  Example loading icon set:

      <script type="module">
        import '@polymer/iron-icons/maps-icons.js';
      </script>

  To use an icon from one of these sets, first prefix your `iron-icon` with the
  icon set name, followed by a colon, ":", and then the icon id.

  Example using the directions-bus icon from the maps icon set:

      <iron-icon icon="maps:directions-bus"></iron-icon>

  See [iron-icon](https://www.webcomponents.org/element/@polymer/iron-icon) for
  more information about working with icons.

  See [iron-iconset](https://www.webcomponents.org/element/@polymer/iron-iconset)
  and
  [iron-iconset-svg](https://www.webcomponents.org/element/@polymer/iron-iconset-svg)
  for more information about how to create a custom iconset.

  @group Iron Elements
  @pseudoElement iron-icons
  @demo demo/index.html
  */

  const template$a = html`<iron-iconset-svg name="icons" size="24">
<svg><defs>
<g id="3d-rotation"><path d="M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"></path></g>
<g id="accessibility"><path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"></path></g>
<g id="accessible"><circle cx="12" cy="4" r="2"></circle><path d="M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"></path></g>
<g id="account-balance"><path d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"></path></g>
<g id="account-balance-wallet"><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></g>
<g id="account-box"><path d="M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"></path></g>
<g id="account-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"></path></g>
<g id="add"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></g>
<g id="add-alert"><path d="M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"></path></g>
<g id="add-box"><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"></path></g>
<g id="add-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"></path></g>
<g id="add-circle-outline"><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="add-shopping-cart"><path d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"></path></g>
<g id="alarm"><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></g>
<g id="alarm-add"><path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"></path></g>
<g id="alarm-off"><path d="M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"></path></g>
<g id="alarm-on"><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"></path></g>
<g id="all-out"><path d="M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z"></path></g>
<g id="android"><path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"></path></g>
<g id="announcement"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"></path></g>
<g id="apps"><path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"></path></g>
<g id="archive"><path d="M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"></path></g>
<g id="arrow-back"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></g>
<g id="arrow-downward"><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path></g>
<g id="arrow-drop-down"><path d="M7 10l5 5 5-5z"></path></g>
<g id="arrow-drop-down-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"></path></g>
<g id="arrow-drop-up"><path d="M7 14l5-5 5 5z"></path></g>
<g id="arrow-forward"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path></g>
<g id="arrow-upward"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path></g>
<g id="aspect-ratio"><path d="M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"></path></g>
<g id="assessment"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"></path></g>
<g id="assignment"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"></path></g>
<g id="assignment-ind"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"></path></g>
<g id="assignment-late"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path></g>
<g id="assignment-return"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"></path></g>
<g id="assignment-returned"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"></path></g>
<g id="assignment-turned-in"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path></g>
<g id="attachment"><path d="M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"></path></g>
<g id="autorenew"><path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"></path></g>
<g id="backspace"><path d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"></path></g>
<g id="backup"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"></path></g>
<g id="block"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"></path></g>
<g id="book"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"></path></g>
<g id="bookmark"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"></path></g>
<g id="bookmark-border"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"></path></g>
<g id="bug-report"><path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"></path></g>
<g id="build"><path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"></path></g>
<g id="cached"><path d="M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"></path></g>
<g id="camera-enhance"><path d="M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"></path></g>
<g id="cancel"><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></g>
<g id="card-giftcard"><path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path></g>
<g id="card-membership"><path d="M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"></path></g>
<g id="card-travel"><path d="M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"></path></g>
<g id="change-history"><path d="M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"></path></g>
<g id="check"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></g>
<g id="check-box"><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></g>
<g id="check-box-outline-blank"><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></g>
<g id="check-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></g>
<g id="chevron-left"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></g>
<g id="chevron-right"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></g>
<g id="chrome-reader-mode"><path d="M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"></path></g>
<g id="class"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"></path></g>
<g id="clear"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></g>
<g id="close"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></g>
<g id="cloud"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"></path></g>
<g id="cloud-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"></path></g>
<g id="cloud-done"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"></path></g>
<g id="cloud-download"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path></g>
<g id="cloud-off"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"></path></g>
<g id="cloud-queue"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"></path></g>
<g id="cloud-upload"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"></path></g>
<g id="code"><path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"></path></g>
<g id="compare-arrows"><path d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"></path></g>
<g id="content-copy"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"></path></g>
<g id="content-cut"><path d="M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"></path></g>
<g id="content-paste"><path d="M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"></path></g>
<g id="copyright"><path d="M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="create"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></g>
<g id="create-new-folder"><path d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"></path></g>
<g id="credit-card"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"></path></g>
<g id="dashboard"><path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"></path></g>
<g id="date-range"><path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"></path></g>
<g id="delete"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></g>
<g id="delete-forever"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"></path></g>
<g id="delete-sweep"><path d="M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"></path></g>
<g id="description"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"></path></g>
<g id="dns"><path d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></g>
<g id="done"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></g>
<g id="done-all"><path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"></path></g>
<g id="donut-large"><path d="M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"></path></g>
<g id="donut-small"><path d="M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"></path></g>
<g id="drafts"><path d="M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"></path></g>
<g id="eject"><path d="M5 17h14v2H5zm7-12L5.33 15h13.34z"></path></g>
<g id="error"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path></g>
<g id="error-outline"><path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></g>
<g id="euro-symbol"><path d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"></path></g>
<g id="event"><path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"></path></g>
<g id="event-seat"><path d="M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"></path></g>
<g id="exit-to-app"><path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></g>
<g id="expand-less"><path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"></path></g>
<g id="expand-more"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></g>
<g id="explore"><path d="M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"></path></g>
<g id="extension"><path d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"></path></g>
<g id="face"><path d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"></path></g>
<g id="favorite"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></g>
<g id="favorite-border"><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"></path></g>
<g id="feedback"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"></path></g>
<g id="file-download"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path></g>
<g id="file-upload"><path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"></path></g>
<g id="filter-list"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"></path></g>
<g id="find-in-page"><path d="M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"></path></g>
<g id="find-replace"><path d="M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"></path></g>
<g id="fingerprint"><path d="M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"></path></g>
<g id="first-page"><path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path></g>
<g id="flag"><path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"></path></g>
<g id="flight-land"><path d="M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z"></path></g>
<g id="flight-takeoff"><path d="M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"></path></g>
<g id="flip-to-back"><path d="M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"></path></g>
<g id="flip-to-front"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"></path></g>
<g id="folder"><path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"></path></g>
<g id="folder-open"><path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"></path></g>
<g id="folder-shared"><path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"></path></g>
<g id="font-download"><path d="M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"></path></g>
<g id="forward"><path d="M12 8V4l8 8-8 8v-4H4V8z"></path></g>
<g id="fullscreen"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"></path></g>
<g id="fullscreen-exit"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"></path></g>
<g id="g-translate"><path d="M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"></path></g>
<g id="gavel"><path d="M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"></path></g>
<g id="gesture"><path d="M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"></path></g>
<g id="get-app"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path></g>
<g id="gif"><path d="M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"></path></g>
<g id="grade"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></g>
<g id="group-work"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></g>
<g id="help"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"></path></g>
<g id="help-outline"><path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"></path></g>
<g id="highlight-off"><path d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="history"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"></path></g>
<g id="home"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path></g>
<g id="hourglass-empty"><path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"></path></g>
<g id="hourglass-full"><path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"></path></g>
<g id="http"><path d="M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"></path></g>
<g id="https"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path></g>
<g id="important-devices"><path d="M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"></path></g>
<g id="inbox"><path d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"></path></g>
<g id="indeterminate-check-box"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"></path></g>
<g id="info"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"></path></g>
<g id="info-outline"><path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"></path></g>
<g id="input"><path d="M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"></path></g>
<g id="invert-colors"><path d="M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"></path></g>
<g id="label"><path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"></path></g>
<g id="label-outline"><path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"></path></g>
<g id="language"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"></path></g>
<g id="last-page"><path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path></g>
<g id="launch"><path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path></g>
<g id="lightbulb-outline"><path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"></path></g>
<g id="line-style"><path d="M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"></path></g>
<g id="line-weight"><path d="M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"></path></g>
<g id="link"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path></g>
<g id="list"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"></path></g>
<g id="lock"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path></g>
<g id="lock-open"><path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"></path></g>
<g id="lock-outline"><path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"></path></g>
<g id="low-priority"><path d="M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"></path></g>
<g id="loyalty"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"></path></g>
<g id="mail"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path></g>
<g id="markunread"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path></g>
<g id="markunread-mailbox"><path d="M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"></path></g>
<g id="menu"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path></g>
<g id="more-horiz"><path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></g>
<g id="more-vert"><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></g>
<g id="motorcycle"><path d="M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"></path></g>
<g id="move-to-inbox"><path d="M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"></path></g>
<g id="next-week"><path d="M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"></path></g>
<g id="note-add"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"></path></g>
<g id="offline-pin"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"></path></g>
<g id="opacity"><path d="M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"></path></g>
<g id="open-in-browser"><path d="M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"></path></g>
<g id="open-in-new"><path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path></g>
<g id="open-with"><path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path></g>
<g id="pageview"><path d="M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"></path></g>
<g id="pan-tool"><path d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"></path></g>
<g id="payment"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"></path></g>
<g id="perm-camera-mic"><path d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"></path></g>
<g id="perm-contact-calendar"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"></path></g>
<g id="perm-data-setting"><path d="M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></g>
<g id="perm-device-information"><path d="M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"></path></g>
<g id="perm-identity"><path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"></path></g>
<g id="perm-media"><path d="M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"></path></g>
<g id="perm-phone-msg"><path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"></path></g>
<g id="perm-scan-wifi"><path d="M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"></path></g>
<g id="pets"><circle cx="4.5" cy="9.5" r="2.5"></circle><circle cx="9" cy="5.5" r="2.5"></circle><circle cx="15" cy="5.5" r="2.5"></circle><circle cx="19.5" cy="9.5" r="2.5"></circle><path d="M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"></path></g>
<g id="picture-in-picture"><path d="M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"></path></g>
<g id="picture-in-picture-alt"><path d="M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"></path></g>
<g id="play-for-work"><path d="M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"></path></g>
<g id="polymer"><path d="M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"></path></g>
<g id="power-settings-new"><path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"></path></g>
<g id="pregnant-woman"><path d="M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"></path></g>
<g id="print"><path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"></path></g>
<g id="query-builder"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></g>
<g id="question-answer"><path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"></path></g>
<g id="radio-button-checked"><path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></g>
<g id="radio-button-unchecked"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></g>
<g id="receipt"><path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"></path></g>
<g id="record-voice-over"><circle cx="9" cy="9" r="4"></circle><path d="M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"></path></g>
<g id="redeem"><path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path></g>
<g id="redo"><path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"></path></g>
<g id="refresh"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path></g>
<g id="remove"><path d="M19 13H5v-2h14v2z"></path></g>
<g id="remove-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"></path></g>
<g id="remove-circle-outline"><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="remove-shopping-cart"><path d="M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"></path></g>
<g id="reorder"><path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"></path></g>
<g id="reply"><path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"></path></g>
<g id="reply-all"><path d="M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"></path></g>
<g id="report"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"></path></g>
<g id="report-problem"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path></g>
<g id="restore"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"></path></g>
<g id="restore-page"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"></path></g>
<g id="room"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></g>
<g id="rounded-corner"><path d="M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"></path></g>
<g id="rowing"><path d="M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"></path></g>
<g id="save"><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"></path></g>
<g id="schedule"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></g>
<g id="search"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path></g>
<g id="select-all"><path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"></path></g>
<g id="send"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path></g>
<g id="settings"><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"></path></g>
<g id="settings-applications"><path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"></path></g>
<g id="settings-backup-restore"><path d="M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"></path></g>
<g id="settings-bluetooth"><path d="M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"></path></g>
<g id="settings-brightness"><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"></path></g>
<g id="settings-cell"><path d="M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"></path></g>
<g id="settings-ethernet"><path d="M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"></path></g>
<g id="settings-input-antenna"><path d="M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"></path></g>
<g id="settings-input-component"><path d="M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"></path></g>
<g id="settings-input-composite"><path d="M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"></path></g>
<g id="settings-input-hdmi"><path d="M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"></path></g>
<g id="settings-input-svideo"><path d="M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path></g>
<g id="settings-overscan"><path d="M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"></path></g>
<g id="settings-phone"><path d="M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"></path></g>
<g id="settings-power"><path d="M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"></path></g>
<g id="settings-remote"><path d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"></path></g>
<g id="settings-voice"><path d="M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"></path></g>
<g id="shop"><path d="M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"></path></g>
<g id="shop-two"><path d="M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"></path></g>
<g id="shopping-basket"><path d="M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></g>
<g id="shopping-cart"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"></path></g>
<g id="sort"><path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"></path></g>
<g id="speaker-notes"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"></path></g>
<g id="speaker-notes-off"><path d="M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"></path></g>
<g id="spellcheck"><path d="M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"></path></g>
<g id="star"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path></g>
<g id="star-border"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"></path></g>
<g id="star-half"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"></path></g>
<g id="stars"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"></path></g>
<g id="store"><path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"></path></g>
<g id="subdirectory-arrow-left"><path d="M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"></path></g>
<g id="subdirectory-arrow-right"><path d="M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"></path></g>
<g id="subject"><path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"></path></g>
<g id="supervisor-account"><path d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"></path></g>
<g id="swap-horiz"><path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"></path></g>
<g id="swap-vert"><path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"></path></g>
<g id="swap-vertical-circle"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"></path></g>
<g id="system-update-alt"><path d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"></path></g>
<g id="tab"><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"></path></g>
<g id="tab-unselected"><path d="M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"></path></g>
<g id="text-format"><path d="M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"></path></g>
<g id="theaters"><path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"></path></g>
<g id="thumb-down"><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"></path></g>
<g id="thumb-up"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"></path></g>
<g id="thumbs-up-down"><path d="M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"></path></g>
<g id="timeline"><path d="M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"></path></g>
<g id="toc"><path d="M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"></path></g>
<g id="today"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"></path></g>
<g id="toll"><path d="M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"></path></g>
<g id="touch-app"><path d="M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"></path></g>
<g id="track-changes"><path d="M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"></path></g>
<g id="translate"><path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"></path></g>
<g id="trending-down"><path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"></path></g>
<g id="trending-flat"><path d="M22 12l-4-4v3H3v2h15v3z"></path></g>
<g id="trending-up"><path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"></path></g>
<g id="turned-in"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"></path></g>
<g id="turned-in-not"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"></path></g>
<g id="unarchive"><path d="M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"></path></g>
<g id="undo"><path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"></path></g>
<g id="unfold-less"><path d="M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"></path></g>
<g id="unfold-more"><path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"></path></g>
<g id="update"><path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"></path></g>
<g id="verified-user"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path></g>
<g id="view-agenda"><path d="M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"></path></g>
<g id="view-array"><path d="M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"></path></g>
<g id="view-carousel"><path d="M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"></path></g>
<g id="view-column"><path d="M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"></path></g>
<g id="view-day"><path d="M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"></path></g>
<g id="view-headline"><path d="M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"></path></g>
<g id="view-list"><path d="M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"></path></g>
<g id="view-module"><path d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"></path></g>
<g id="view-quilt"><path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"></path></g>
<g id="view-stream"><path d="M4 18h17v-6H4v6zM4 5v6h17V5H4z"></path></g>
<g id="view-week"><path d="M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"></path></g>
<g id="visibility"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></g>
<g id="visibility-off"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path></g>
<g id="warning"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path></g>
<g id="watch-later"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"></path></g>
<g id="weekend"><path d="M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z"></path></g>
<g id="work"><path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"></path></g>
<g id="youtube-searched-for"><path d="M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"></path></g>
<g id="zoom-in"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z"></path></g>
<g id="zoom-out"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template$a.content);

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$9 = html`<iron-iconset-svg name="image" size="24">
<svg><defs>
<g id="add-a-photo"><path d="M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"></path></g>
<g id="add-to-photos"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"></path></g>
<g id="adjust"><path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"></path></g>
<g id="assistant"><path d="M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"></path></g>
<g id="assistant-photo"><path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"></path></g>
<g id="audiotrack"><path d="M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"></path></g>
<g id="blur-circular"><path d="M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"></path></g>
<g id="blur-linear"><path d="M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"></path></g>
<g id="blur-off"><path d="M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"></path></g>
<g id="blur-on"><path d="M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path></g>
<g id="brightness-1"><circle cx="12" cy="12" r="10"></circle></g>
<g id="brightness-2"><path d="M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"></path></g>
<g id="brightness-3"><path d="M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"></path></g>
<g id="brightness-4"><path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"></path></g>
<g id="brightness-5"><path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"></path></g>
<g id="brightness-6"><path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"></path></g>
<g id="brightness-7"><path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"></path></g>
<g id="broken-image"><path d="M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"></path></g>
<g id="brush"><path d="M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"></path></g>
<g id="burst-mode"><path d="M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"></path></g>
<g id="camera"><path d="M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"></path></g>
<g id="camera-alt"><circle cx="12" cy="12" r="3.2"></circle><path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path></g>
<g id="camera-front"><path d="M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"></path></g>
<g id="camera-rear"><path d="M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"></path></g>
<g id="camera-roll"><path d="M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"></path></g>
<g id="center-focus-strong"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"></path></g>
<g id="center-focus-weak"><path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></g>
<g id="collections"><path d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"></path></g>
<g id="collections-bookmark"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"></path></g>
<g id="color-lens"><path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></g>
<g id="colorize"><path d="M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"></path></g>
<g id="compare"><path d="M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></g>
<g id="control-point"><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="control-point-duplicate"><path d="M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"></path></g>
<g id="crop"><path d="M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"></path></g>
<g id="crop-16-9"><path d="M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"></path></g>
<g id="crop-3-2"><path d="M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"></path></g>
<g id="crop-5-4"><path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"></path></g>
<g id="crop-7-5"><path d="M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"></path></g>
<g id="crop-din"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"></path></g>
<g id="crop-free"><path d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"></path></g>
<g id="crop-landscape"><path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"></path></g>
<g id="crop-original"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"></path></g>
<g id="crop-portrait"><path d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"></path></g>
<g id="crop-rotate"><path d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"></path></g>
<g id="crop-square"><path d="M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"></path></g>
<g id="dehaze"><path d="M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"></path></g>
<g id="details"><path d="M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"></path></g>
<g id="edit"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></g>
<g id="exposure"><path d="M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z"></path></g>
<g id="exposure-neg-1"><path d="M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"></path></g>
<g id="exposure-neg-2"><path d="M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"></path></g>
<g id="exposure-plus-1"><path d="M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"></path></g>
<g id="exposure-plus-2"><path d="M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"></path></g>
<g id="exposure-zero"><path d="M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"></path></g>
<g id="filter"><path d="M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"></path></g>
<g id="filter-1"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"></path></g>
<g id="filter-2"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"></path></g>
<g id="filter-3"><path d="M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z"></path></g>
<g id="filter-4"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"></path></g>
<g id="filter-5"><path d="M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"></path></g>
<g id="filter-6"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z"></path></g>
<g id="filter-7"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"></path></g>
<g id="filter-8"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"></path></g>
<g id="filter-9"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z"></path></g>
<g id="filter-9-plus"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"></path></g>
<g id="filter-b-and-w"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"></path></g>
<g id="filter-center-focus"><path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></g>
<g id="filter-drama"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"></path></g>
<g id="filter-frames"><path d="M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"></path></g>
<g id="filter-hdr"><path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"></path></g>
<g id="filter-none"><path d="M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"></path></g>
<g id="filter-tilt-shift"><path d="M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"></path></g>
<g id="filter-vintage"><path d="M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"></path></g>
<g id="flare"><path d="M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"></path></g>
<g id="flash-auto"><path d="M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"></path></g>
<g id="flash-off"><path d="M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"></path></g>
<g id="flash-on"><path d="M7 2v11h3v9l7-12h-4l4-8z"></path></g>
<g id="flip"><path d="M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"></path></g>
<g id="gradient"><path d="M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"></path></g>
<g id="grain"><path d="M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></g>
<g id="grid-off"><path d="M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"></path></g>
<g id="grid-on"><path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"></path></g>
<g id="hdr-off"><path d="M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"></path></g>
<g id="hdr-on"><path d="M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"></path></g>
<g id="hdr-strong"><path d="M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></g>
<g id="hdr-weak"><path d="M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"></path></g>
<g id="healing"><path d="M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"></path></g>
<g id="image"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"></path></g>
<g id="image-aspect-ratio"><path d="M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"></path></g>
<g id="iso"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"></path></g>
<g id="landscape"><path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"></path></g>
<g id="leak-add"><path d="M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"></path></g>
<g id="leak-remove"><path d="M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z"></path></g>
<g id="lens"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"></path></g>
<g id="linked-camera"><circle cx="12" cy="14" r="3.2"></circle><path d="M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"></path><path d="M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path></g>
<g id="looks"><path d="M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"></path></g>
<g id="looks-3"><path d="M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z"></path></g>
<g id="looks-4"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"></path></g>
<g id="looks-5"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z"></path></g>
<g id="looks-6"><path d="M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z"></path></g>
<g id="looks-one"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"></path></g>
<g id="looks-two"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z"></path></g>
<g id="loupe"><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="monochrome-photos"><path d="M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"></path></g>
<g id="movie-creation"><path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"></path></g>
<g id="movie-filter"><path d="M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"></path></g>
<g id="music-note"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"></path></g>
<g id="nature"><path d="M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"></path></g>
<g id="nature-people"><path d="M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"></path></g>
<g id="navigate-before"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></g>
<g id="navigate-next"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></g>
<g id="palette"><path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></g>
<g id="panorama"><path d="M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"></path></g>
<g id="panorama-fish-eye"><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path></g>
<g id="panorama-horizontal"><path d="M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"></path></g>
<g id="panorama-vertical"><path d="M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"></path></g>
<g id="panorama-wide-angle"><path d="M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"></path></g>
<g id="photo"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"></path></g>
<g id="photo-album"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"></path></g>
<g id="photo-camera"><circle cx="12" cy="12" r="3.2"></circle><path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path></g>
<g id="photo-filter"><path d="M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"></path></g>
<g id="photo-library"><path d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"></path></g>
<g id="photo-size-select-actual"><path d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"></path></g>
<g id="photo-size-select-large"><path d="M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"></path></g>
<g id="photo-size-select-small"><path d="M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"></path></g>
<g id="picture-as-pdf"><path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"></path></g>
<g id="portrait"><path d="M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"></path></g>
<g id="remove-red-eye"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></g>
<g id="rotate-90-degrees-ccw"><path d="M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"></path></g>
<g id="rotate-left"><path d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"></path></g>
<g id="rotate-right"><path d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"></path></g>
<g id="slideshow"><path d="M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"></path></g>
<g id="straighten"><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"></path></g>
<g id="style"><path d="M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"></path></g>
<g id="switch-camera"><path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"></path></g>
<g id="switch-video"><path d="M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"></path></g>
<g id="tag-faces"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"></path></g>
<g id="texture"><path d="M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"></path></g>
<g id="timelapse"><path d="M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></g>
<g id="timer"><path d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></g>
<g id="timer-10"><path d="M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"></path></g>
<g id="timer-3"><path d="M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"></path></g>
<g id="timer-off"><path d="M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"></path></g>
<g id="tonality"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"></path></g>
<g id="transform"><path d="M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"></path></g>
<g id="tune"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></g>
<g id="view-comfy"><path d="M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"></path></g>
<g id="view-compact"><path d="M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"></path></g>
<g id="vignette"><path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"></path></g>
<g id="wb-auto"><path d="M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"></path></g>
<g id="wb-cloudy"><path d="M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"></path></g>
<g id="wb-incandescent"><path d="M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"></path></g>
<g id="wb-iridescent"><path d="M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"></path></g>
<g id="wb-sunny"><path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template$9.content);

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$8 = html`<iron-iconset-svg name="communication" size="24">
<svg><defs>
<g id="business"><path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"></path></g>
<g id="call"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path></g>
<g id="call-end"><path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"></path></g>
<g id="call-made"><path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"></path></g>
<g id="call-merge"><path d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"></path></g>
<g id="call-missed"><path d="M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"></path></g>
<g id="call-missed-outgoing"><path d="M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"></path></g>
<g id="call-received"><path d="M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"></path></g>
<g id="call-split"><path d="M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"></path></g>
<g id="chat"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"></path></g>
<g id="chat-bubble"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"></path></g>
<g id="chat-bubble-outline"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"></path></g>
<g id="clear-all"><path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"></path></g>
<g id="comment"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"></path></g>
<g id="contact-mail"><path d="M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"></path></g>
<g id="contact-phone"><path d="M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"></path></g>
<g id="contacts"><path d="M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"></path></g>
<g id="dialer-sip"><path d="M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"></path></g>
<g id="dialpad"><path d="M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></g>
<g id="email"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path></g>
<g id="forum"><path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"></path></g>
<g id="import-contacts"><path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"></path></g>
<g id="import-export"><path d="M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"></path></g>
<g id="invert-colors-off"><path d="M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z"></path></g>
<g id="live-help"><path d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"></path></g>
<g id="location-off"><path d="M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"></path></g>
<g id="location-on"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></g>
<g id="mail-outline"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"></path></g>
<g id="message"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"></path></g>
<g id="no-sim"><path d="M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"></path></g>
<g id="phone"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path></g>
<g id="phonelink-erase"><path d="M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"></path></g>
<g id="phonelink-lock"><path d="M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"></path></g>
<g id="phonelink-ring"><path d="M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"></path></g>
<g id="phonelink-setup"><path d="M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"></path></g>
<g id="portable-wifi-off"><path d="M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"></path></g>
<g id="present-to-all"><path d="M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"></path></g>
<g id="ring-volume"><path d="M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"></path></g>
<g id="rss-feed"><circle cx="6.18" cy="17.82" r="2.18"></circle><path d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"></path></g>
<g id="screen-share"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"></path></g>
<g id="speaker-phone"><path d="M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"></path></g>
<g id="stay-current-landscape"><path d="M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"></path></g>
<g id="stay-current-portrait"><path d="M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"></path></g>
<g id="stay-primary-landscape"><path d="M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"></path></g>
<g id="stay-primary-portrait"><path d="M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"></path></g>
<g id="stop-screen-share"><path d="M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"></path></g>
<g id="swap-calls"><path d="M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"></path></g>
<g id="textsms"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"></path></g>
<g id="voicemail"><path d="M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"></path></g>
<g id="vpn-key"><path d="M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template$8.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$7 = html`
<custom-style>
  <style is="custom-style">
    html {

      /* Material Design color palette for Google products */

      --google-red-100: #f4c7c3;
      --google-red-300: #e67c73;
      --google-red-500: #db4437;
      --google-red-700: #c53929;

      --google-blue-100: #c6dafc;
      --google-blue-300: #7baaf7;
      --google-blue-500: #4285f4;
      --google-blue-700: #3367d6;

      --google-green-100: #b7e1cd;
      --google-green-300: #57bb8a;
      --google-green-500: #0f9d58;
      --google-green-700: #0b8043;

      --google-yellow-100: #fce8b2;
      --google-yellow-300: #f7cb4d;
      --google-yellow-500: #f4b400;
      --google-yellow-700: #f09300;

      --google-grey-100: #f5f5f5;
      --google-grey-300: #e0e0e0;
      --google-grey-500: #9e9e9e;
      --google-grey-700: #616161;

      /* Material Design color palette from online spec document */

      --paper-red-50: #ffebee;
      --paper-red-100: #ffcdd2;
      --paper-red-200: #ef9a9a;
      --paper-red-300: #e57373;
      --paper-red-400: #ef5350;
      --paper-red-500: #f44336;
      --paper-red-600: #e53935;
      --paper-red-700: #d32f2f;
      --paper-red-800: #c62828;
      --paper-red-900: #b71c1c;
      --paper-red-a100: #ff8a80;
      --paper-red-a200: #ff5252;
      --paper-red-a400: #ff1744;
      --paper-red-a700: #d50000;

      --paper-pink-50: #fce4ec;
      --paper-pink-100: #f8bbd0;
      --paper-pink-200: #f48fb1;
      --paper-pink-300: #f06292;
      --paper-pink-400: #ec407a;
      --paper-pink-500: #e91e63;
      --paper-pink-600: #d81b60;
      --paper-pink-700: #c2185b;
      --paper-pink-800: #ad1457;
      --paper-pink-900: #880e4f;
      --paper-pink-a100: #ff80ab;
      --paper-pink-a200: #ff4081;
      --paper-pink-a400: #f50057;
      --paper-pink-a700: #c51162;

      --paper-purple-50: #f3e5f5;
      --paper-purple-100: #e1bee7;
      --paper-purple-200: #ce93d8;
      --paper-purple-300: #ba68c8;
      --paper-purple-400: #ab47bc;
      --paper-purple-500: #9c27b0;
      --paper-purple-600: #8e24aa;
      --paper-purple-700: #7b1fa2;
      --paper-purple-800: #6a1b9a;
      --paper-purple-900: #4a148c;
      --paper-purple-a100: #ea80fc;
      --paper-purple-a200: #e040fb;
      --paper-purple-a400: #d500f9;
      --paper-purple-a700: #aa00ff;

      --paper-deep-purple-50: #ede7f6;
      --paper-deep-purple-100: #d1c4e9;
      --paper-deep-purple-200: #b39ddb;
      --paper-deep-purple-300: #9575cd;
      --paper-deep-purple-400: #7e57c2;
      --paper-deep-purple-500: #673ab7;
      --paper-deep-purple-600: #5e35b1;
      --paper-deep-purple-700: #512da8;
      --paper-deep-purple-800: #4527a0;
      --paper-deep-purple-900: #311b92;
      --paper-deep-purple-a100: #b388ff;
      --paper-deep-purple-a200: #7c4dff;
      --paper-deep-purple-a400: #651fff;
      --paper-deep-purple-a700: #6200ea;

      --paper-indigo-50: #e8eaf6;
      --paper-indigo-100: #c5cae9;
      --paper-indigo-200: #9fa8da;
      --paper-indigo-300: #7986cb;
      --paper-indigo-400: #5c6bc0;
      --paper-indigo-500: #3f51b5;
      --paper-indigo-600: #3949ab;
      --paper-indigo-700: #303f9f;
      --paper-indigo-800: #283593;
      --paper-indigo-900: #1a237e;
      --paper-indigo-a100: #8c9eff;
      --paper-indigo-a200: #536dfe;
      --paper-indigo-a400: #3d5afe;
      --paper-indigo-a700: #304ffe;

      --paper-blue-50: #e3f2fd;
      --paper-blue-100: #bbdefb;
      --paper-blue-200: #90caf9;
      --paper-blue-300: #64b5f6;
      --paper-blue-400: #42a5f5;
      --paper-blue-500: #2196f3;
      --paper-blue-600: #1e88e5;
      --paper-blue-700: #1976d2;
      --paper-blue-800: #1565c0;
      --paper-blue-900: #0d47a1;
      --paper-blue-a100: #82b1ff;
      --paper-blue-a200: #448aff;
      --paper-blue-a400: #2979ff;
      --paper-blue-a700: #2962ff;

      --paper-light-blue-50: #e1f5fe;
      --paper-light-blue-100: #b3e5fc;
      --paper-light-blue-200: #81d4fa;
      --paper-light-blue-300: #4fc3f7;
      --paper-light-blue-400: #29b6f6;
      --paper-light-blue-500: #03a9f4;
      --paper-light-blue-600: #039be5;
      --paper-light-blue-700: #0288d1;
      --paper-light-blue-800: #0277bd;
      --paper-light-blue-900: #01579b;
      --paper-light-blue-a100: #80d8ff;
      --paper-light-blue-a200: #40c4ff;
      --paper-light-blue-a400: #00b0ff;
      --paper-light-blue-a700: #0091ea;

      --paper-cyan-50: #e0f7fa;
      --paper-cyan-100: #b2ebf2;
      --paper-cyan-200: #80deea;
      --paper-cyan-300: #4dd0e1;
      --paper-cyan-400: #26c6da;
      --paper-cyan-500: #00bcd4;
      --paper-cyan-600: #00acc1;
      --paper-cyan-700: #0097a7;
      --paper-cyan-800: #00838f;
      --paper-cyan-900: #006064;
      --paper-cyan-a100: #84ffff;
      --paper-cyan-a200: #18ffff;
      --paper-cyan-a400: #00e5ff;
      --paper-cyan-a700: #00b8d4;

      --paper-teal-50: #e0f2f1;
      --paper-teal-100: #b2dfdb;
      --paper-teal-200: #80cbc4;
      --paper-teal-300: #4db6ac;
      --paper-teal-400: #26a69a;
      --paper-teal-500: #009688;
      --paper-teal-600: #00897b;
      --paper-teal-700: #00796b;
      --paper-teal-800: #00695c;
      --paper-teal-900: #004d40;
      --paper-teal-a100: #a7ffeb;
      --paper-teal-a200: #64ffda;
      --paper-teal-a400: #1de9b6;
      --paper-teal-a700: #00bfa5;

      --paper-green-50: #e8f5e9;
      --paper-green-100: #c8e6c9;
      --paper-green-200: #a5d6a7;
      --paper-green-300: #81c784;
      --paper-green-400: #66bb6a;
      --paper-green-500: #4caf50;
      --paper-green-600: #43a047;
      --paper-green-700: #388e3c;
      --paper-green-800: #2e7d32;
      --paper-green-900: #1b5e20;
      --paper-green-a100: #b9f6ca;
      --paper-green-a200: #69f0ae;
      --paper-green-a400: #00e676;
      --paper-green-a700: #00c853;

      --paper-light-green-50: #f1f8e9;
      --paper-light-green-100: #dcedc8;
      --paper-light-green-200: #c5e1a5;
      --paper-light-green-300: #aed581;
      --paper-light-green-400: #9ccc65;
      --paper-light-green-500: #8bc34a;
      --paper-light-green-600: #7cb342;
      --paper-light-green-700: #689f38;
      --paper-light-green-800: #558b2f;
      --paper-light-green-900: #33691e;
      --paper-light-green-a100: #ccff90;
      --paper-light-green-a200: #b2ff59;
      --paper-light-green-a400: #76ff03;
      --paper-light-green-a700: #64dd17;

      --paper-lime-50: #f9fbe7;
      --paper-lime-100: #f0f4c3;
      --paper-lime-200: #e6ee9c;
      --paper-lime-300: #dce775;
      --paper-lime-400: #d4e157;
      --paper-lime-500: #cddc39;
      --paper-lime-600: #c0ca33;
      --paper-lime-700: #afb42b;
      --paper-lime-800: #9e9d24;
      --paper-lime-900: #827717;
      --paper-lime-a100: #f4ff81;
      --paper-lime-a200: #eeff41;
      --paper-lime-a400: #c6ff00;
      --paper-lime-a700: #aeea00;

      --paper-yellow-50: #fffde7;
      --paper-yellow-100: #fff9c4;
      --paper-yellow-200: #fff59d;
      --paper-yellow-300: #fff176;
      --paper-yellow-400: #ffee58;
      --paper-yellow-500: #ffeb3b;
      --paper-yellow-600: #fdd835;
      --paper-yellow-700: #fbc02d;
      --paper-yellow-800: #f9a825;
      --paper-yellow-900: #f57f17;
      --paper-yellow-a100: #ffff8d;
      --paper-yellow-a200: #ffff00;
      --paper-yellow-a400: #ffea00;
      --paper-yellow-a700: #ffd600;

      --paper-amber-50: #fff8e1;
      --paper-amber-100: #ffecb3;
      --paper-amber-200: #ffe082;
      --paper-amber-300: #ffd54f;
      --paper-amber-400: #ffca28;
      --paper-amber-500: #ffc107;
      --paper-amber-600: #ffb300;
      --paper-amber-700: #ffa000;
      --paper-amber-800: #ff8f00;
      --paper-amber-900: #ff6f00;
      --paper-amber-a100: #ffe57f;
      --paper-amber-a200: #ffd740;
      --paper-amber-a400: #ffc400;
      --paper-amber-a700: #ffab00;

      --paper-orange-50: #fff3e0;
      --paper-orange-100: #ffe0b2;
      --paper-orange-200: #ffcc80;
      --paper-orange-300: #ffb74d;
      --paper-orange-400: #ffa726;
      --paper-orange-500: #ff9800;
      --paper-orange-600: #fb8c00;
      --paper-orange-700: #f57c00;
      --paper-orange-800: #ef6c00;
      --paper-orange-900: #e65100;
      --paper-orange-a100: #ffd180;
      --paper-orange-a200: #ffab40;
      --paper-orange-a400: #ff9100;
      --paper-orange-a700: #ff6500;

      --paper-deep-orange-50: #fbe9e7;
      --paper-deep-orange-100: #ffccbc;
      --paper-deep-orange-200: #ffab91;
      --paper-deep-orange-300: #ff8a65;
      --paper-deep-orange-400: #ff7043;
      --paper-deep-orange-500: #ff5722;
      --paper-deep-orange-600: #f4511e;
      --paper-deep-orange-700: #e64a19;
      --paper-deep-orange-800: #d84315;
      --paper-deep-orange-900: #bf360c;
      --paper-deep-orange-a100: #ff9e80;
      --paper-deep-orange-a200: #ff6e40;
      --paper-deep-orange-a400: #ff3d00;
      --paper-deep-orange-a700: #dd2c00;

      --paper-brown-50: #efebe9;
      --paper-brown-100: #d7ccc8;
      --paper-brown-200: #bcaaa4;
      --paper-brown-300: #a1887f;
      --paper-brown-400: #8d6e63;
      --paper-brown-500: #795548;
      --paper-brown-600: #6d4c41;
      --paper-brown-700: #5d4037;
      --paper-brown-800: #4e342e;
      --paper-brown-900: #3e2723;

      --paper-grey-50: #fafafa;
      --paper-grey-100: #f5f5f5;
      --paper-grey-200: #eeeeee;
      --paper-grey-300: #e0e0e0;
      --paper-grey-400: #bdbdbd;
      --paper-grey-500: #9e9e9e;
      --paper-grey-600: #757575;
      --paper-grey-700: #616161;
      --paper-grey-800: #424242;
      --paper-grey-900: #212121;

      --paper-blue-grey-50: #eceff1;
      --paper-blue-grey-100: #cfd8dc;
      --paper-blue-grey-200: #b0bec5;
      --paper-blue-grey-300: #90a4ae;
      --paper-blue-grey-400: #78909c;
      --paper-blue-grey-500: #607d8b;
      --paper-blue-grey-600: #546e7a;
      --paper-blue-grey-700: #455a64;
      --paper-blue-grey-800: #37474f;
      --paper-blue-grey-900: #263238;

      /* opacity for dark text on a light background */
      --dark-divider-opacity: 0.12;
      --dark-disabled-opacity: 0.38; /* or hint text or icon */
      --dark-secondary-opacity: 0.54;
      --dark-primary-opacity: 0.87;

      /* opacity for light text on a dark background */
      --light-divider-opacity: 0.12;
      --light-disabled-opacity: 0.3; /* or hint text or icon */
      --light-secondary-opacity: 0.7;
      --light-primary-opacity: 1.0;

    }

  </style>
</custom-style>
`;
  template$7.setAttribute('style', 'display: none;');
  document.head.appendChild(template$7.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const $_documentContainer$1 = document.createElement('template');
  $_documentContainer$1.setAttribute('style', 'display: none;');
  $_documentContainer$1.innerHTML = `<dom-module id="paper-spinner-styles">
  <template>
    <style>
      /*
      /**************************/
      /* STYLES FOR THE SPINNER */
      /**************************/

      /*
       * Constants:
       *      ARCSIZE     = 270 degrees (amount of circle the arc takes up)
       *      ARCTIME     = 1333ms (time it takes to expand and contract arc)
       *      ARCSTARTROT = 216 degrees (how much the start location of the arc
       *                                should rotate each time, 216 gives us a
       *                                5 pointed star shape (it's 360/5 * 3).
       *                                For a 7 pointed star, we might do
       *                                360/7 * 3 = 154.286)
       *      SHRINK_TIME = 400ms
       */

      :host {
        display: inline-block;
        position: relative;
        width: 28px;
        height: 28px;

        /* 360 * ARCTIME / (ARCSTARTROT + (360-ARCSIZE)) */
        --paper-spinner-container-rotation-duration: 1568ms;

        /* ARCTIME */
        --paper-spinner-expand-contract-duration: 1333ms;

        /* 4 * ARCTIME */
        --paper-spinner-full-cycle-duration: 5332ms;

        /* SHRINK_TIME */
        --paper-spinner-cooldown-duration: 400ms;
      }

      #spinnerContainer {
        width: 100%;
        height: 100%;

        /* The spinner does not have any contents that would have to be
         * flipped if the direction changes. Always use ltr so that the
         * style works out correctly in both cases. */
        direction: ltr;
      }

      #spinnerContainer.active {
        -webkit-animation: container-rotate var(--paper-spinner-container-rotation-duration) linear infinite;
        animation: container-rotate var(--paper-spinner-container-rotation-duration) linear infinite;
      }

      @-webkit-keyframes container-rotate {
        to { -webkit-transform: rotate(360deg) }
      }

      @keyframes container-rotate {
        to { transform: rotate(360deg) }
      }

      .spinner-layer {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0;
        white-space: nowrap;
        color: var(--paper-spinner-color, var(--google-blue-500));
      }

      .layer-1 {
        color: var(--paper-spinner-layer-1-color, var(--google-blue-500));
      }

      .layer-2 {
        color: var(--paper-spinner-layer-2-color, var(--google-red-500));
      }

      .layer-3 {
        color: var(--paper-spinner-layer-3-color, var(--google-yellow-500));
      }

      .layer-4 {
        color: var(--paper-spinner-layer-4-color, var(--google-green-500));
      }

      /**
       * IMPORTANT NOTE ABOUT CSS ANIMATION PROPERTIES (keanulee):
       *
       * iOS Safari (tested on iOS 8.1) does not handle animation-delay very well - it doesn't
       * guarantee that the animation will start _exactly_ after that value. So we avoid using
       * animation-delay and instead set custom keyframes for each color (as layer-2undant as it
       * seems).
       */
      .active .spinner-layer {
        -webkit-animation-name: fill-unfill-rotate;
        -webkit-animation-duration: var(--paper-spinner-full-cycle-duration);
        -webkit-animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
        -webkit-animation-iteration-count: infinite;
        animation-name: fill-unfill-rotate;
        animation-duration: var(--paper-spinner-full-cycle-duration);
        animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
        animation-iteration-count: infinite;
        opacity: 1;
      }

      .active .spinner-layer.layer-1 {
        -webkit-animation-name: fill-unfill-rotate, layer-1-fade-in-out;
        animation-name: fill-unfill-rotate, layer-1-fade-in-out;
      }

      .active .spinner-layer.layer-2 {
        -webkit-animation-name: fill-unfill-rotate, layer-2-fade-in-out;
        animation-name: fill-unfill-rotate, layer-2-fade-in-out;
      }

      .active .spinner-layer.layer-3 {
        -webkit-animation-name: fill-unfill-rotate, layer-3-fade-in-out;
        animation-name: fill-unfill-rotate, layer-3-fade-in-out;
      }

      .active .spinner-layer.layer-4 {
        -webkit-animation-name: fill-unfill-rotate, layer-4-fade-in-out;
        animation-name: fill-unfill-rotate, layer-4-fade-in-out;
      }

      @-webkit-keyframes fill-unfill-rotate {
        12.5% { -webkit-transform: rotate(135deg) } /* 0.5 * ARCSIZE */
        25%   { -webkit-transform: rotate(270deg) } /* 1   * ARCSIZE */
        37.5% { -webkit-transform: rotate(405deg) } /* 1.5 * ARCSIZE */
        50%   { -webkit-transform: rotate(540deg) } /* 2   * ARCSIZE */
        62.5% { -webkit-transform: rotate(675deg) } /* 2.5 * ARCSIZE */
        75%   { -webkit-transform: rotate(810deg) } /* 3   * ARCSIZE */
        87.5% { -webkit-transform: rotate(945deg) } /* 3.5 * ARCSIZE */
        to    { -webkit-transform: rotate(1080deg) } /* 4   * ARCSIZE */
      }

      @keyframes fill-unfill-rotate {
        12.5% { transform: rotate(135deg) } /* 0.5 * ARCSIZE */
        25%   { transform: rotate(270deg) } /* 1   * ARCSIZE */
        37.5% { transform: rotate(405deg) } /* 1.5 * ARCSIZE */
        50%   { transform: rotate(540deg) } /* 2   * ARCSIZE */
        62.5% { transform: rotate(675deg) } /* 2.5 * ARCSIZE */
        75%   { transform: rotate(810deg) } /* 3   * ARCSIZE */
        87.5% { transform: rotate(945deg) } /* 3.5 * ARCSIZE */
        to    { transform: rotate(1080deg) } /* 4   * ARCSIZE */
      }

      @-webkit-keyframes layer-1-fade-in-out {
        0% { opacity: 1 }
        25% { opacity: 1 }
        26% { opacity: 0 }
        89% { opacity: 0 }
        90% { opacity: 1 }
        to { opacity: 1 }
      }

      @keyframes layer-1-fade-in-out {
        0% { opacity: 1 }
        25% { opacity: 1 }
        26% { opacity: 0 }
        89% { opacity: 0 }
        90% { opacity: 1 }
        to { opacity: 1 }
      }

      @-webkit-keyframes layer-2-fade-in-out {
        0% { opacity: 0 }
        15% { opacity: 0 }
        25% { opacity: 1 }
        50% { opacity: 1 }
        51% { opacity: 0 }
        to { opacity: 0 }
      }

      @keyframes layer-2-fade-in-out {
        0% { opacity: 0 }
        15% { opacity: 0 }
        25% { opacity: 1 }
        50% { opacity: 1 }
        51% { opacity: 0 }
        to { opacity: 0 }
      }

      @-webkit-keyframes layer-3-fade-in-out {
        0% { opacity: 0 }
        40% { opacity: 0 }
        50% { opacity: 1 }
        75% { opacity: 1 }
        76% { opacity: 0 }
        to { opacity: 0 }
      }

      @keyframes layer-3-fade-in-out {
        0% { opacity: 0 }
        40% { opacity: 0 }
        50% { opacity: 1 }
        75% { opacity: 1 }
        76% { opacity: 0 }
        to { opacity: 0 }
      }

      @-webkit-keyframes layer-4-fade-in-out {
        0% { opacity: 0 }
        65% { opacity: 0 }
        75% { opacity: 1 }
        90% { opacity: 1 }
        to { opacity: 0 }
      }

      @keyframes layer-4-fade-in-out {
        0% { opacity: 0 }
        65% { opacity: 0 }
        75% { opacity: 1 }
        90% { opacity: 1 }
        to { opacity: 0 }
      }

      .circle-clipper {
        display: inline-block;
        position: relative;
        width: 50%;
        height: 100%;
        overflow: hidden;
      }

      /**
       * Patch the gap that appear between the two adjacent div.circle-clipper while the
       * spinner is rotating (appears on Chrome 50, Safari 9.1.1, and Edge).
       */
      .spinner-layer::after {
        content: '';
        left: 45%;
        width: 10%;
        border-top-style: solid;
      }

      .spinner-layer::after,
      .circle-clipper .circle {
        box-sizing: border-box;
        position: absolute;
        top: 0;
        border-width: var(--paper-spinner-stroke-width, 3px);
        border-radius: 50%;
      }

      .circle-clipper .circle {
        bottom: 0;
        width: 200%;
        border-style: solid;
        border-bottom-color: transparent !important;
      }

      .circle-clipper.left .circle {
        left: 0;
        border-right-color: transparent !important;
        -webkit-transform: rotate(129deg);
        transform: rotate(129deg);
      }

      .circle-clipper.right .circle {
        left: -100%;
        border-left-color: transparent !important;
        -webkit-transform: rotate(-129deg);
        transform: rotate(-129deg);
      }

      .active .gap-patch::after,
      .active .circle-clipper .circle {
        -webkit-animation-duration: var(--paper-spinner-expand-contract-duration);
        -webkit-animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
        -webkit-animation-iteration-count: infinite;
        animation-duration: var(--paper-spinner-expand-contract-duration);
        animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);
        animation-iteration-count: infinite;
      }

      .active .circle-clipper.left .circle {
        -webkit-animation-name: left-spin;
        animation-name: left-spin;
      }

      .active .circle-clipper.right .circle {
        -webkit-animation-name: right-spin;
        animation-name: right-spin;
      }

      @-webkit-keyframes left-spin {
        0% { -webkit-transform: rotate(130deg) }
        50% { -webkit-transform: rotate(-5deg) }
        to { -webkit-transform: rotate(130deg) }
      }

      @keyframes left-spin {
        0% { transform: rotate(130deg) }
        50% { transform: rotate(-5deg) }
        to { transform: rotate(130deg) }
      }

      @-webkit-keyframes right-spin {
        0% { -webkit-transform: rotate(-130deg) }
        50% { -webkit-transform: rotate(5deg) }
        to { -webkit-transform: rotate(-130deg) }
      }

      @keyframes right-spin {
        0% { transform: rotate(-130deg) }
        50% { transform: rotate(5deg) }
        to { transform: rotate(-130deg) }
      }

      #spinnerContainer.cooldown {
        -webkit-animation: container-rotate var(--paper-spinner-container-rotation-duration) linear infinite, fade-out var(--paper-spinner-cooldown-duration) cubic-bezier(0.4, 0.0, 0.2, 1);
        animation: container-rotate var(--paper-spinner-container-rotation-duration) linear infinite, fade-out var(--paper-spinner-cooldown-duration) cubic-bezier(0.4, 0.0, 0.2, 1);
      }

      @-webkit-keyframes fade-out {
        0% { opacity: 1 }
        to { opacity: 0 }
      }

      @keyframes fade-out {
        0% { opacity: 1 }
        to { opacity: 0 }
      }
    </style>
  </template>
</dom-module>`;
  document.head.appendChild($_documentContainer$1.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /** @polymerBehavior */
  const PaperSpinnerBehavior = {
    properties: {
      /**
       * Displays the spinner.
       */
      active: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        observer: '__activeChanged'
      },
      /**
       * Alternative text content for accessibility support.
       * If alt is present, it will add an aria-label whose content matches alt
       * when active. If alt is not present, it will default to 'loading' as the
       * alt value.
       */
      alt: {
        type: String,
        value: 'loading',
        observer: '__altChanged'
      },
      __coolingDown: {
        type: Boolean,
        value: false
      }
    },
    __computeContainerClasses: function (active, coolingDown) {
      return [active || coolingDown ? 'active' : '', coolingDown ? 'cooldown' : ''].join(' ');
    },
    __activeChanged: function (active, old) {
      this.__setAriaHidden(!active);
      this.__coolingDown = !active && old;
    },
    __altChanged: function (alt) {
      // user-provided `aria-label` takes precedence over prototype default
      if (alt === 'loading') {
        this.alt = this.getAttribute('aria-label') || alt;
      } else {
        this.__setAriaHidden(alt === '');
        this.setAttribute('aria-label', alt);
      }
    },
    __setAriaHidden: function (hidden) {
      var attr = 'aria-hidden';
      if (hidden) {
        this.setAttribute(attr, 'true');
      } else {
        this.removeAttribute(attr);
      }
    },
    __reset: function () {
      this.active = false;
      this.__coolingDown = false;
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$6 = html`
  <style include="paper-spinner-styles"></style>

  <div id="spinnerContainer" class-name="[[__computeContainerClasses(active, __coolingDown)]]" on-animationend="__reset" on-webkit-animation-end="__reset">
    <div class="spinner-layer">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div>
      <div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
`;
  template$6.setAttribute('strip-whitespace', '');

  /**
  Material design: [Progress &
  activity](https://www.google.com/design/spec/components/progress-activity.html)

  Element providing a single color material design circular spinner.

      <paper-spinner-lite active></paper-spinner-lite>

  The default spinner is blue. It can be customized to be a different color.

  ### Accessibility

  Alt attribute should be set to provide adequate context for accessibility. If
  not provided, it defaults to 'loading'. Empty alt can be provided to mark the
  element as decorative if alternative content is provided in another form (e.g. a
  text block following the spinner).

      <paper-spinner-lite alt="Loading contacts list" active></paper-spinner-lite>

  ### Styling

  The following custom properties and mixins are available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--paper-spinner-color` | Color of the spinner | `--google-blue-500`
  `--paper-spinner-stroke-width` | The width of the spinner stroke | 3px

  @group Paper Elements
  @element paper-spinner-lite
  @hero hero.svg
  @demo demo/index.html
  */
  // Polymer({
  //   _template: template$6,
  //   is: 'paper-spinner-lite',
  //   behaviors: [PaperSpinnerBehavior]
  // });

  //Note: was not able to import css files,
  // Therefore any specified font should be loaded in parent app
  // import 'typeface-nunito-sans';

  const UnityDefaultThemeStyles = css$1`
  :host {
    /* Colors */
    --default-black-rgb: 0, 0, 0;                   /* #000000 */
    --default-white-rgb: 255, 255, 255;             /* #FFFFFF */
    --default-charcoal-rgb: 77, 77, 77;             /* #4D4D4D */
    --default-dark-gray-rgb: 151, 151, 151;         /* #979797 */
    --default-gray-rgb: 162, 170, 173;              /* #A2AAAD */
    --default-light-gray-1-rgb: 235, 235, 235;      /* #EBEBEB */
    --default-light-gray-2-rgb: 244, 244, 244;      /* #F4F4F4 */
    --default-white-rgb: 255, 255, 255;             /* #FFFFFF */
    --default-deep-blue-rgb: 0, 87, 118;            /* #005776 */
    --default-deep-blue-tint-rgb: 64, 129, 153;     /* #408199 */
    --default-sky-blue-rgb: 45, 204, 211;           /* #2DCCD3 */
    --default-sky-blue-shade-rgb: 50, 166, 172;     /* #32A6AC */
    --default-sky-blue-tint-1-rgb: 234, 249, 250;   /* #EAF9FA */
    --default-sky-blue-tint-2-rgb: 217, 243, 244;   /* #D9F3F4 */
    --default-red-orange-rgb: 250, 70, 22;          /* #FA4616 */
    --default-dark-red-orange-rgb: 145, 61, 38;     /* #913D26 */
    --default-light-red-orange-rgb: 252, 221, 220;  /* #FCDDDC */
    --default-yellow-rgb: 255, 198, 0;              /* #FFC600 */
    --default-green-rgb: 71, 162, 63;               /* #47A23F */

    /* Uses */

    /* Input text color */
    --default-black-color: rgb(var(--default-black-rgb));

    /* Default background color, Font Color */
    --default-white-color: rgb(var(--default-white-rgb));

    /* dark grey, text default */
    --default-dark-gray-color: rgb(var(--default-charcoal-rgb));

    /* dark grey 2 */
    --default-dark-gray-2-color: rgb(var(--default-dark-gray-rgb));

    /* normal gray, border default, disabled text */
    --default-gray-color: rgb(var(--default-gray-rgb));

    /* light gray 1, disabled content */
    --default-light-gray-1-color: rgb(var(--default-light-gray-1-rgb));

    /* light gray 2, disabled content */
    --default-light-gray-2-color: rgb(var(--default-light-gray-2-rgb));

    /* default brand color, switches, radios, checkboxes, focus */
    --default-primary-color: rgb(var(--default-sky-blue-rgb));

    /* darked primary color */
    --default-primary-shade-color: rgb(var(--default-sky-blue-shade-rgb));

    /* faint primary highlight */
    --default-primary-tint-1-color: rgb(var(--default-sky-blue-tint-1-rgb));

    /* primary highlight */
    --default-primary-tint-2-color: rgb(var(--default-sky-blue-tint-2-rgb));

    /* secondary brand color, buttons, tabs, links */
    --default-secondary-color: rgb(var(--default-deep-blue-rgb));

    /* muted secondary color, clicked button */
    --default-secondary-tint-color: rgb(var(--default-deep-blue-tint-rgb));

    /* utility color, error, alert, attention grabbing, present/past-tense */
    --default-tertiary-1-color: rgb(var(--default-red-orange-rgb));

    /* darker tertiary 1, pressed alert button */
    --default-tertiary-1-shade-color: rgb(var(--default-dark-red-orange-rgb));

    /* lighter tertiary 1, field error background */
    --default-tertiary-1-light-color: rgb(var(--default-light-red-orange-rgb));

    /* utility color, warning, alert, future/present-tense */
    --default-tertiary-2-color: rgb(var(--default-yellow-rgb));

    /* utility color, success, notification */
    --default-tertiary-3-color: rgb(var(--default-green-rgb));

    /* Old Colors */
    --default-primary-brand-color: rgb(var(--default-sky-blue-rgb));
    --default-primary-brand-color-light: rgb(var(--default-sky-blue-tint-2-rgb));
    --default-primary-brand-color-dark: rgb(var(--default-deep-blue-rgb));
    --default-secondary-brand-color: rgb(var(--default-red-orange-rgb));
    --default-success-color: rgb(var(--default-green-rgb));
    --default-danger-color: rgb(var(--default-yellow-rgb));
    --default-danger-lite-color: rgba(var(--default-yellow-rgb), .5);
    --default-error-color: rgb(var(--default-red-orange-rgb));
    --default-error-lite-color: rgba(var(--default-red-orange-rgb), .5);
    --default-background-color: rgb(var(--default-white-rgb));
    --default-black-text-color: rgb(var(--default-black-rgb));

    --default-dark-grey-text-color: rgb(var(--default-charcoal-rgb));
    --default-medium-grey-text-color: #80868b;
    --default-light-grey-text-color: #b8b8b8;
    --default-dark-grey-background-color: rgb(var(--default-gray-rgb));
    --default-medium-grey-background-color: rgb(var(--default-light-gray-1-rgb));
    --default-light-grey-background-color: rgb(var(--default-light-gray-2-rgb));

    /* Fonts */
    --default-font-family: 'NotoSans', sans-serif;
    --default-monospace-font-family: 'NotoMono', monospace;

    --default-header1-font-size: 16px;
    --default-header1-font-weight: 400;
    --default-header1-line-height: 24px;

    --default-header2-font-size: 16px;
    --default-header2-font-weight: 400;
    --default-header1-line-height: 24px;

    --default-header2-selected-font-size: 16px;
    --default-header2-selected-font-weight: 600;

    --default-paragraph-font-size: 12px;
    --default-paragraph-font-weight: 400;
    --default-paragraph-line-height: 16px;

    /* this font size should likely change */
    --default-small-text-size: 10px;
    --default-small-text-weight: 400;

    --default-small-text-selected-size: 10px;
    --default-small-text-selected-weight: 600;

    --default-bold-text-weight: 600;

    --default-medium-icon-size: 18px;
    --default-small-icon-size: 14px;
    --default-xsmall-icon-size: 10px;

    /* Sizes and Spacing */
    --default-unity-button-height: 32px;
    --default-unity-button-border-radius: 32px;

    --default-unity-text-input-height: 27px;

    /* Margins and Paddings */
    --default-margin-size-md: 12px;
    --default-padding-size-sm: 8px;
    --default-padding-size-md: 12px;
    --default-padding-size-lg: 16px;
    --default-padding-size-xl: 24px;

    /* Checkbox */
    --default-unity-checkbox-size: 16px;
    --default-unity-checkbox-border-size: 1px;
    --default-unity-checkbox-border-radius: 1px;
    --default-unity-checkbox-text-margin: 4px;
    --default-unity-checkbox-text-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
    --default-unity-checkbox-text-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
    --default-unity-checkbox-text-color-disabled: var(--gray-color, var(--default-gray-color));
    --default-unity-checkbox-background-color: var(--white-color, var(--default-white-color));
    --default-unity-checkbox-background-color-hover: var(--primary-tint-1-color, var(--default-primary-tint-1-color));
    --default-unity-checkbox-background-color-disabled: var(--light-gray-2-color, var(--default-light-gray-2-color));
    --default-unity-checkbox-border-color: var(--gray-color, var(--default-gray-color));
    --default-unity-checkbox-color: var(--primary-color, var(--default-primary-color));
    --default-unity-checkbox-color-hover: var(--primary-shade-color, var(--default-primary-shade-color));
    --default-unity-checkbox-color-disabled: var(--gray-color, var(--default-gray-color));
    --default-unity-checkbox-checkmark-color: var(--white-color, var(--default-white-color));
    --default-unity-checkbox-checkmark-color-disabled: var(--white-color, var(--default-white-color));
  }
`;

  /**
   * Renders a div/p with text, styled
   * @name UnityTypography
   * @param {''} color, dark, medium, or light, defaults dark
   * @param {''} size, header1, header2, paragraph, medium, small, defaults paragraph
   * @param {''} weight, header1, header2, paragraph, medium, small, defaults to match size
   * @param {bool} monospace, use monospace font
   * @example
   * <unity-typography size="header1" weight="header2">
   *   "And then you can give it any kind of text you want on the inside."
   * </unity-typography>
   *
   * There are a number of css vars exposed for specific style overrides. These will override
   * any of the attribute controled styles, allowing the classes matching the attributes
   * to still show, but having the effect of the override.
   * CSS variables:
   *   --font-face   -  font family
   *   --font-size   -  font size
   *   --font-weight -  font weight
   *   --font-color  -  font color
   **/

  const BLACK = 'black';
  const DARK = 'dark';
  const MEDIUM = 'medium';
  const LIGHT = 'light';
  const SMALL = 'small';
  const HEADER_ONE = 'header1';
  const HEADER_TWO = 'header2';
  const PARA = 'paragraph';
  let UnityTypography = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTypography, _LitElement);
    var _super = _createSuper(UnityTypography);
    function UnityTypography() {
      var _this;
      _classCallCheck(this, UnityTypography);
      _this = _super.call(this);
      _this.color = 'dark';
      _this.size = 'paragraph';
      _this.weight = '';
      _this.monospace = false;
      return _this;
    }
    _createClass(UnityTypography, [{
      key: "getClasses",
      value: function getClasses() {
        const {
          color,
          size,
          monospace
        } = this;
        let classes = [];
        switch (color) {
          case BLACK:
            classes.push('color-black');
            break;
          case DARK:
            classes.push('color-dark');
            break;
          case MEDIUM:
            classes.push('color-medium');
            break;
          case LIGHT:
            classes.push('color-light');
            break;
        }
        switch (size) {
          case HEADER_ONE:
            classes.push('size-header-1');
            break;
          case HEADER_TWO:
            classes.push('size-header-2');
            break;
          case PARA:
            classes.push('size-paragraph');
            break;
          case MEDIUM:
            classes.push('size-medium');
            break;
          case SMALL:
            classes.push('size-small');
            break;
        }
        const weight = this.weight || size;
        switch (weight) {
          case HEADER_ONE:
            classes.push('weight-header-1');
            break;
          case HEADER_TWO:
            classes.push('weight-header-2');
            break;
          case PARA:
            classes.push('weight-paragraph');
            break;
          case MEDIUM:
            classes.push('weight-medium');
            break;
          case SMALL:
            classes.push('weight-small');
            break;
        }
        if (monospace) classes.push('monospace');
        return classes.join(' ');
      }
    }, {
      key: "render",
      value: function render() {
        const classes = this.getClasses();
        return html$1`
      <div class="${classes}">
        <slot></slot>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          color: {
            type: String
          },
          size: {
            type: String
          },
          weight: {
            type: String
          },
          monospace: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --font-face: var(--font-family, var(--default-font-family));
          --monospace-font-face: var(--monospace-font-family, var(--default-monospace-font-family));
          --font-color-light: var(--light-grey-text-color, var(--default-light-grey-text-color));
          --font-color-medium: var(--medium-grey-text-color, var(--default-medium-grey-text-color));
          --font-color-dark: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
          --font-color-black: var(--black-text-color, var(--default-black-text-color));
          --header1-size: var(--header1-font-size, var(--default-header1-font-size));
          --header2-size: var(--header2-font-size, var(--default-header2-font-size));
          --paragraph-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          --medium-size: var(--medium-text-size, var(--default-medium-text-size));
          --small-size: var(--small-text-size, var(--default-small-text-size));
          --header1-weight: var(--header1-font-weight, var(--default-header1-font-weight));
          --header2-weight: var(--header2-font-weight, var(--default-header2-font-weight));
          --paragraph-weight: var(--paragraph-font-weight, var(--default-paragraph-font-weight));
          --medium-weight: var(--medium-text-weight, var(--default-medium-text-weight));
          --small-weight: var(--small-text-weight, var(--default-small-text-weight));
          --font-size: var(--font-size, var(--paragraph-size));
        }
        div {
          font-family: var(--font-face, var(--default-font-family));
          font-size: var(--font-size, var(--paragraph-weight));
          font-weight: var(--font-weight, var(--paragraph-weight));
          color: var(--font-color, var(--font-color-black));
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .monospace {
          font-family: var(--monospace-font-face);
        }
        .color-light {
          color: var(--font-color, var(--font-color-light));
        }
        .color-medium {
          color: var(--font-color, var(--font-color-medium));
        }
        .color-dark {
          color: var(--font-color, var(--font-color-dark));
        }
        .color-black {
          color: var(--font-color, var(--font-color-black));
        }
        .size-header-1 {
          font-size: var(--font-size, var(--header1-size));
        }
        .size-header-2 {
          font-size: var(--font-size, var(--header2-size));
        }
        .size-paragraph {
          font-size: var(--font-size, var(--paragraph-size));
        }
        .size-medium {
          font-size: var(--font-size, var(--medium-size));
        }
        .size-small {
          font-size: var(--font-size, var(--small-size));
        }
        .weight-header-1 {
          font-weight: var(--font-weight, var(--header1-weight));
        }
        .weight-header-2 {
          font-weight: var(--font-weight, var(--header2-weight));
        }
        .weight-paragraph {
          font-weight: var(--font-weight, var(--paragraph-weight));
        }
        .weight-medium {
          font-weight: var(--font-weight, var(--medium-weight));
        }
        .weight-small {
          font-weight: var(--font-weight, var(--small-weight));
        }
      `];
      }
    }]);
    return UnityTypography;
  }(LitElement);
  window.customElements.define('unity-typography', UnityTypography);

  /**
   * Button with configurable styles.
   * @name UnityButton
   * @param {string} label, button text
   * @param {string} leftIcon, iron icon name to be displayed to the left of the label
   * @param {string} rightIcon, iron icon name to be displayed to the right of the label
   * @param {string} centerIcon, iron icon name to be displayed in place of the label. Note: Do not pass in a label if used, overwrites label
   * @param {string} type, type of button to render (optional): primary , secondary, borderless
   * @param {bool} important, style button in important colors.
   * @param {bool} disabled, style button in disabled mode
   * @param {bool} loading, displays loading spinner in place of leftIcon
   * @param {function} click, event handler
  *  @example
  *   <unity-button
  *     label="example button"
  *     ?loading=${fetching}
  *     leftIcon="add"
  *     @click=${() => console.log("button clicked")}
  *   />
  */

  const PRIMARY = 'primary';
  const SECONDARY = 'secondary';
  const BORDERLESS = 'borderless';
  let UnityButton = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityButton, _LitElement);
    var _super = _createSuper(UnityButton);
    function UnityButton() {
      var _this;
      _classCallCheck(this, UnityButton);
      _this = _super.call(this);
      _this.label = '';
      _this.type = '';
      _this.disabled = false;
      _this.important = false;
      _this.loading = false;
      _this.leftIcon = '';
      _this.centerIcon = '';
      _this.rightIcon = '';
      return _this;
    }
    _createClass(UnityButton, [{
      key: "_getClassNames",
      value: function _getClassNames() {
        let classList = ['unity-button'];
        const {
          label,
          type,
          important,
          disabled,
          loading,
          leftIcon,
          centerIcon,
          rightIcon
        } = this;
        switch (type) {
          case SECONDARY:
            {
              classList.push(SECONDARY);
              break;
            }
          case BORDERLESS:
            {
              classList.push(BORDERLESS);
              break;
            }
          default:
            {
              classList.push(PRIMARY);
              break;
            }
        }
        if (important) {
          classList.push('important');
        }
        if (disabled) {
          classList.push('disabled');
        }
        if (loading) {
          classList.push('loading');
        }
        if (leftIcon) {
          classList.push('left-icon');
        }
        if (centerIcon) {
          classList.push('icon-btn');
        }
        if (rightIcon) {
          classList.push('right-icon');
        }
        return classList.join(' ');
      }

      //NOTE: consider rendering slot inside paper button that will render in place of label
    }, {
      key: "render",
      value: function render() {
        //NOTE: @click is bubbled up
        if (this.label === 'left icon') {
          console.log('this.label', this.label);
          console.log('this.loading', this.loading);
          console.log('this.leftIcon', this.leftIcon);
        }
        return html$1`
      <paper-button
        noink
        ?disabled=${this.disabled}
        class=${this._getClassNames()}
      >
        ${this.loading ? html$1`<paper-spinner-lite active class="spinner icon left-icon" />` : !!this.leftIcon ? html$1`<iron-icon
                icon=${this.leftIcon}
                class="icon left-icon"
              ></iron-icon>` : null}

        ${this.centerIcon && !this.loading ? html$1`<iron-icon
              icon=${this.centerIcon}
              class="icon center-icon"
            ></iron-icon>` : html$1`<unity-typography>
            ${this.label}
          </unity-typography>`}

        ${this.rightIcon ? html$1`<iron-icon
              icon=${this.rightIcon}
              class="icon right-icon"
            ></iron-icon>` : ''}

      </paper-button>
    `;
      }
    }], [{
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-button-primary-color: var(--secondary-color, var(--default-secondary-color));
          --default-button-primary-pressed-color: var(--secondary-tint-color, var(--default-secondary-tint-color));
          --default-button-secondary-text-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-button-secondary-color: var(--gray-color, var(--default-gray-color));
          --default-button-borderless-text-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-button-borderless-color: var(--light-gray-2-color, var(--default-light-gray-2-color));
          --default-button-borderless-pressed-color: var(--light-gray-1-color, var(--default-light-gray-1-color));
          --default-button-disabled-text-color: var(--gray-color, var(--default-gray-color));
          --default-button-disabled-color: var(--light-gray-2-color, var(--default-light-gray-2-color));
          --default-button-important-color: var(--tertiary-1-color, var(--default-tertiary-1-color));
          --default-button-important-pressed-color: var(--tertiary-1-shade-color, var(--default-tertiary-1-shade-color));
          --default-background-color: var(--white-color, var(--default-white-color));
          --default-button-width: unset;
          --default-button-padding: 7px 14px; /* Design wants 8x15, but must account for border 1 */
          flex-shrink: 0;
          display: block;
          --button-color: var(--button-primary-color, var(--default-button-primary-color));
          --pressed-color: var(--button-primary-pressed-color, var(--default-button-primary-pressed-color));
          --font-color: var(--background-color, var(--default-background-color));
          --icon-color: var(--font-color);
          --default-button-hover-color: var(--button-color);
          --default-icon-button-size: 27px;
          --default-icon-size: 16px;
        }

        paper-button {
          height: var(--unity-button-height, var(--default-unity-button-height));
          border-radius: var(--unity-border-radius, var(--default-unity-button-border-radius));
          min-width: max-content;
          font-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          font-weight: var(--paragraph-font-weight, var(--default-paragraph-font-weight));
          text-transform: none;
          white-space: nowrap;
          outline: none;
          margin: 0;
          border: 1px solid var(--button-color);
          padding: var(--button-padding, var(--default-button-padding));
          width: var(--button-width, var(--default-button-width));
        }

        paper-button.text-button {
          padding: 0 10px;
          min-width: 0;
        }

        /* Primary Styles */
        paper-button.primary {
          background-color: var(--button-color);
        }

        /* Secondary Styles */
        paper-button.secondary {
          background-color: var(--background-color, var(--default-background-color));
          --font-color: var(--button-secondary-text-color, var(--default-button-secondary-text-color));
          border: 1px solid var(--button-secondary-color, var(--default-button-secondary-color));
        }

        paper-button.unity-button:hover {
          /*NOTE: css filters are not supported on older browsers*/
          border-color: var(--button-hover-color, var(--default-button-hover-color));
          background-color: var(--background-color, var(--default-background-color));
          --font-color: var(--button-hover-color, var(--default-button-hover-color));
        }

        paper-button.unity-button:active {
          --button-color: var(--pressed-color);
        }

        /* Borderless Styles */
        paper-button.unity-button.borderless {
          --font-color: var(--button-borderless-text-color, var(--default-button-borderless-text-color));
          --bg-color: var(--background-color, var(--default-background-color));
          background-color: var(--bg-color);
          border: 1px solid var(--bg-color);
        }


        paper-button.unity-button.borderless:hover {
          --font-color: var(--button-color);
          --bg-color: var(--button-borderless-color, var(--default-button-borderless-color));
        }

        paper-button.unity-button.borderless:active {
          --font-color: var(--pressed-color);
          --bg-color: var(--button-borderless-pressed-color, var(--default-button-borderless-pressed-color));

        }

        .icon {
          margin: 0;
          color: var(--font-color);
          height: var(--icon-size, var(--default-icon-size));
          width: var(--icon-size, var(--default-icon-size));
          --iron-icon-width: var(--icon-size, var(--default-icon-size));
          --iron-icon-height: var(--icon-size, var(--default-icon-size));
          --paper-spinner-color: var(--font-color);
          --paper-spinner-stroke-width: 2px;
        }

        paper-spinner-lite.icon.left-icon {
          margin-right: 8px;
        }
        paper-spinner-lite.icon.right-icon {
          margin-left: 8px;
        }

        .icon-btn paper-spinner-lite.icon.left-icon {
          padding: 0;
        }

        iron-icon.left-icon {
          padding-right: 2px;
        }
        iron-icon.right-icon {
          padding-left: 2px;
        }

        paper-button.icon-btn {
          min-width: var(--icon-button-size, var(--default-icon-button-size));
          width: var(--icon-button-size, var(--default-icon-button-size));
          height: var(--icon-button-size, var(--default-icon-button-size));
          padding: 0;
          border-radius: 50%;
        }

        /* Important Styles */
        paper-button.important {
          --button-color: var(--button-important-color, var(--default-button-important-color)) !important;
          --button-hover-color: var(--button-important-color, var(--default-button-important-color)) !important;
          --pressed-color: var(--button-important-pressed-color, var(--default-button-important-pressed-color));
        }

        paper-button.icon-btn .icon {
          --iron-icon-width: var(--medium-icon-size, var(--default-medium-icon-size));
          --iron-icon-height: var(--medium-icon-size, var(--default-medium-icon-size));
        }

        /*Including .unity-button selector for increased specificity and override other class styles*/
        paper-button.unity-button.disabled {
          --font-color: var(--button-disabled-text-color, var(--default-button-disabled-text-color));
          background-color: var(--button-disabled-color, var(--default-button-disabled-color));
          border-color: var(--button-disabled-color, var(--default-button-disabled-color));
        }

        paper-button.borderless.disabled {
          --font-color: var(--button-disabled-text-color, var(--default-button-disabled-text-color));
          background-color: var(--background-color, var(--default-background-color));
          border-color: var(--background-color, var(--default-background-color));
        }
      `];
      }
    }, {
      key: "properties",
      get: function () {
        return {
          label: {
            type: String
          },
          disabled: {
            type: Boolean
          },
          type: {
            type: String
          },
          important: {
            type: Boolean
          },
          loading: {
            type: Boolean
          },
          leftIcon: {
            type: String
          },
          centerIcon: {
            type: String
          },
          rightIcon: {
            type: String
          }
        };
      }
    }]);
    return UnityButton;
  }(LitElement);
  window.customElements.define('unity-button', UnityButton);

  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }
    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
  }

  function isElement$1(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }
  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }
  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }
    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  }

  // and applies them to the HTMLElements such as popper and arrow

  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];
        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }
  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }
    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules

  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: ['computeStyles']
  };

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  var max = Math.max;
  var min = Math.min;
  var round = Math.round;

  function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) {
      return uaData.brands.map(function (item) {
        return item.brand + "/" + item.version;
      }).join(' ');
    }
    return navigator.userAgent;
  }

  function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test(getUAString());
  }

  function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) {
      includeScale = false;
    }
    if (isFixedStrategy === void 0) {
      isFixedStrategy = false;
    }
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && isHTMLElement(element)) {
      scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
      scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = isElement$1(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
    var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
      width: width,
      height: height,
      top: y,
      right: x + width,
      bottom: y + height,
      left: x,
      x: x,
      y: y
    };
  }

  // means it doesn't take into account transforms.

  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }
    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }
    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;
      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...

        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false

    return false;
  }

  function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement$1(element) ? element.ownerDocument :
    // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }
    return (
      // this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot ||
      // step into the shadow DOM of the parent of a slotted node
      element.parentNode || (
      // DOM Element detected
      isShadowRoot(element) ? element.host : null) ||
      // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback
    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) ||
    // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$1(element).position === 'fixed') {
      return null;
    }
    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block

  function getContainingBlock(element) {
    var isFirefox = /firefox/i.test(getUAString());
    var isIE = /Trident/i.test(getUAString());
    if (isIE && isHTMLElement(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle$1(element);
      if (elementCss.position === 'fixed') {
        return null;
      }
    }
    var currentNode = getParentNode(element);
    if (isShadowRoot(currentNode)) {
      currentNode = currentNode.host;
    }
    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }
    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.

  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);
    while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }
    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
      return window;
    }
    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }
  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };
  function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) {
      return;
    }
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }
  function effect$1(_ref2) {
    var state = _ref2.state,
      options = _ref2.options;
    var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) {
      return;
    } // CSS selector

    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);
      if (!arrowElement) {
        return;
      }
    }
    if (process.env.NODE_ENV !== "production") {
      if (!isHTMLElement(arrowElement)) {
        console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
      }
    }
    if (!contains(state.elements.popper, arrowElement)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
      }
      return;
    }
    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules

  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref) {
    var x = _ref.x,
      y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }
  function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;
    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';
      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);
        if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

      offsetParent = offsetParent;
      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }
      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }
    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
      var _Object$assign;
      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }
  function computeStyles(_ref5) {
    var state = _ref5.state,
      options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    if (process.env.NODE_ENV !== "production") {
      var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';
      if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })) {
        console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
      }
    }
    var commonStyles = {
      placement: getBasePlacement(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }
    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules

  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };

  var passive = {
    passive: true
  };
  function effect(_ref) {
    var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
    var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }
    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }
      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules

  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };

  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash = {
    start: 'end',
    end: 'start'
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element, strategy) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height;
      var layoutViewport = isLayoutViewport();
      if (layoutViewport || !layoutViewport && strategy === 'fixed') {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }
    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  }

  // of the `<html>` and `<body>` rect bounds if horizontally scrollable

  function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;
    if (getComputedStyle$1(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }
    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }
    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }
    return getScrollParent(getParentNode(node));
  }

  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */

  function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) {
      list = [];
    }
    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList :
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element, strategy) {
    var rect = getBoundingClientRect(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }
  function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`

  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
    if (!isElement$1(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

    return clippingParents.filter(function (clippingParent) {
      return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents

  function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent, strategy);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;
      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;
      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;
      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;
      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }
    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';
      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;
        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }
    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }
    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;
      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
      }
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }
    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }
  function flip(_ref) {
    var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
    if (state.modifiersData[name]._skip) {
      return;
    }
    var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];
      var _basePlacement = getBasePlacement(placement);
      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }
      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];
      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }
      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }
      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }
      checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;
      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);
          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });
        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };
      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);
        if (_ret === "break") break;
      }
    }
    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules

  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }
    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }
  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }
  function hide(_ref) {
    var state = _ref.state,
      name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules

  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
      })) : offset,
      skidding = _ref[0],
      distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }
  function offset(_ref2) {
    var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
    var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules

  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
      name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules

  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
    var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };
    if (!popperOffsets) {
      return;
    }
    if (checkMainAxis) {
      var _offsetModifierState$;
      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min$1 = offset + overflow[mainSide];
      var max$1 = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
      var _offsetModifierState$2;
      var _mainSide = mainAxis === 'x' ? top : left;
      var _altSide = mainAxis === 'x' ? bottom : right;
      var _offset = popperOffsets[altAxis];
      var _len = altAxis === 'y' ? 'height' : 'width';
      var _min = _offset + overflow[_mainSide];
      var _max = _offset - overflow[_altSide];
      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules

  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.

  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }
    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' ||
      // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }
      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }
    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);
          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }
    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }
  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce$1(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }
      return pending;
    };
  }

  function format(str) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return [].concat(args).reduce(function (p, c) {
      return p.replace(/%s/, c);
    }, str);
  }

  var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
  var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
  var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
  function validateModifiers(modifiers) {
    modifiers.forEach(function (modifier) {
      [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
            }
            break;
          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
            }
            break;
          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
            }
            break;
          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
            }
            break;
          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
            }
            break;
          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
            }
            break;
          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
            }
            break;
          case 'options':
          case 'data':
            break;
          default:
            console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
              return "\"" + s + "\"";
            }).join(', ') + "; but \"" + key + "\" was provided.");
        }
        modifier.requires && modifier.requires.forEach(function (requirement) {
          if (modifiers.find(function (mod) {
            return mod.name === requirement;
          }) == null) {
            console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
          }
        });
      });
    });
  }

  function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function (item) {
      var identifier = fn(item);
      if (!identifiers.has(identifier)) {
        identifiers.add(identifier);
        return true;
      }
    });
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
  var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };
  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }
  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }
    var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }
      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned
          // if one of the modifiers is invalid for any reason

          if (process.env.NODE_ENV !== "production") {
            var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
              var name = _ref.name;
              return name;
            });
            validateModifiers(modifiers);
            if (getBasePlacement(state.options.placement) === auto) {
              var flipModifier = state.orderedModifiers.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'flip';
              });
              if (!flipModifier) {
                console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
              }
            }
            var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
            // cause bugs with positioning, so we'll warn the consumer

            if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })) {
              console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
            }
          }
          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }
          var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            if (process.env.NODE_ENV !== "production") {
              console.error(INVALID_ELEMENT_ERROR);
            }
            return;
          } // Store the reference and popper rects to be read by modifiers

          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          var __debug_loops__ = 0;
          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (process.env.NODE_ENV !== "production") {
              __debug_loops__ += 1;
              if (__debug_loops__ > 100) {
                console.error(INFINITE_LOOP_ERROR);
                break;
              }
            }
            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }
            var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce$1(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };
      if (!areValidElements(reference, popper)) {
        if (process.env.NODE_ENV !== "production") {
          console.error(INVALID_ELEMENT_ERROR);
        }
        return instance;
      }
      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;
          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });
            var noopFn = function noopFn() {};
            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }
      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }
      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  /*
      Lit-Element Properties and Curiosities
    One of the biggest things to note, and by far one of the most annoying things by far, is that
    Lit-Element's html`` tags will translate all text in them into a text element, including the
    whitespace we use for formatting. Unless elements are made to be one line, or with clever
    formatting, almost all elements will have children/siblings of newlines and tabs, even if the
    element doesn't have any element siblings. The easiest way to tell if these exist is if the
    element doesn't have a 'localName', and you can check that '.textContent.trim().length === 0'.
    You can usually skip this if you are using only named slots, or if you don't need your element
    to be aware of slot/element content

    Lit-Elements also have a wide variety of features upon them. A quick way to see this for yourself
    is to add a log for `[this]`, which will allow you to expand your element like an object. It has
    many of the same properties you'll see on HTML elements, as well as some of their own. Some
    useful ones include:
      localName - the name of the element tag, will not exist on a text element
      slot - the slot the element is assigned to
      innerHTML - the HTML rendering inside the element
      outerHTML - the HTML of the element's tag
      parentNode, parentElement - parent element (not sure what the difference is)
      childNodes - array of all children elements
      firstChild, lastChild - first/last child of the above array
      previousSibling - the element that comes before this in the written order
      nextSibling - the element that comes after this in the written order
    Note should be taken for the the child and sibling functions. Because of the interaction above
    where whitespace becomes a text element, it is often likely that childNodes will contain a number
    of whitespace filled text nodes, while each of the first/lastChild and previous/nextSibling will
    most likely be one of these whitespace filled text elements. There are utils below to help handle
    those parsing the whitespace elements out, as well as traversing sibling elements.
  */

  // determines if the passed in element is whitespace or not
  // input:  element
  // output: bool
  const isWhitespace = _ref => {
    let {
      localName,
      textContent,
      nodeName
    } = _ref;
    // if has localname, not a text element
    if (!!localName) return false;
    // count as whitespace if comment
    if (nodeName === '#comment' ||
    // if text element, ignore if empty
    typeof textContent === 'string' && !textContent.trim().length) return true;
    return false;
  };

  // takes an array of elements, remove any that are just whitespace
  // input:  array of elements
  // output: array of elements
  const trimWhitespace = slots => slots.reduce((slots, current) => {
    return isWhitespace(current) ? slots : [].concat(_toConsumableArray(slots), [current]);
  }, []);

  // returns the specified element (non whitespace), false if there is no valid element
  // input:  lit element
  // output: lit element or false
  const getParent = _ref2 => {
    let {
      parentNode
    } = _ref2;
    return getNode(getParent, parentNode);
  };
  const getPrevSibling = _ref3 => {
    let {
      previousSibling
    } = _ref3;
    return getNode(getPrevSibling, previousSibling);
  };
  const getNextSibling = _ref4 => {
    let {
      nextSibling
    } = _ref4;
    return getNode(getNextSibling, nextSibling);
  };
  const getNode = (getFunc, node) => {
    // no node, node not an object/element
    if (!node || typeof node !== 'object') return false;
    // recurse if node is whitespace
    if (isWhitespace(node)) return getFunc(node);
    return node;
  };
  const isElement = obj => {
    try {
      //Using W3 DOM2 (works for FF, Opera and Chrome)
      return obj instanceof HTMLElement;
    } catch (e) {
      //Browsers not supporting W3 DOM2 don't have HTMLElement and
      //an exception is thrown and we end up here. Testing some
      //properties that all elements have (works on IE7)
      return typeof obj === "object" && obj.nodeType === 1 && typeof obj.style === "object" && typeof obj.ownerDocument === "object";
    }
  };

  // function to perform search/find from tagSeed and textSeed based on search input
  // input:
  //    tagSeed = array of tag-format objects (string "value" || object { label: string, value: string})
  //   textSeed = array of strings
  //     search = string with space separated terms to search for within tagSeed and textSeed
  //    exclude = array of strings (tag component strings and/or text strings) to ignore from the seeds
  //              given how exclude works, tags and text seeds should have no crossover
  // output:
  //   {
  //     tags: [tag strings/objects that match],
  //     text: [text strings that match]
  //   }
  const findMatches = _ref5 => {
    let {
      tagSeed = [],
      textSeed = [],
      search = "",
      exclude = []
    } = _ref5;
    if (!Array.isArray(tagSeed) || !Array.isArray(textSeed)) return {
      tags: [],
      text: []
    };
    const excludeLib = exclude.reduce((lib, item) => _objectSpread2$1(_objectSpread2$1({}, lib), {}, {
      [item]: item
    }), {});
    // split search on spaces into terms
    const allTerms = search.trim().split(/\s+/);
    let tagMatches = new Map();
    let textMatches = new Map();
    // for each term
    allTerms.forEach((term, index) => {
      if (!term) return;
      // check against all tag results (string, tag.label, tag.value)
      let tagTermRegex = RegExp('', 'i');
      if (tagSeed.length > 0) {
        const tagTerm = index > 0 ? allTerms.slice(index).join(" ") : allTerms.join(" ");
        tagTermRegex = RegExp(tagTerm, 'i');
      }
      tagSeed.forEach(tag => {
        // if tag includes term in any, add to matches
        if (tag instanceof Object) {
          // if tag is excluded, skip
          if (!!excludeLib[tag.value] || !!excludeLib[tag.label]) return;
          if (tag.value && tagTermRegex.test(tag.value) || tag.label && tagTermRegex.test(tag.label)) tagMatches.set(tag.value, tag);
        }
      });
      // check against all strings in seed
      textSeed.forEach(text => {
        // if string includes term, add to matches
        // if text is excluded, skip
        if (!!excludeLib[tag]) return;
        if (RegExp(term, 'i').test(text)) textMatches.set(text, text);
      });
    });
    let outTags = [];
    let outText = [];
    tagMatches.forEach(tag => outTags.push(tag));
    textMatches.forEach(text => outText.push(tag));
    return {
      tags: outTags,
      text: outText
    };
  };

  // function to translate a React/Object style to an HTML/String style
  // input:  givenStyle = string or object styling
  // output: string version of the given style
  const styleToString = givenStyle => {
    if (typeof givenStyle === 'string') return givenStyle;
    if (givenStyle instanceof Object) {
      return Object.entries(givenStyle).reduce((out, _ref6) => {
        let [key, val] = _ref6;
        return out += `${key}: ${val};`;
      }, '');
    }
    return '';
  };

  /**
  * Shadowed popover/popover with optional close button for holding variable content
  * @name UnityPopover
  * @param {bool} withClose, determines whether the close button is displayed
  * @param {func} onClose, callback fired when the close button is clicked; return true
  * @param {bool} closeOnOutsideClick, determines whether popover will close when the user clicks outside of it or its on-page-content (not supported on IE)
  * @param {bool} show, determines whether the popover is visible
  * @param {string} placement, the position of the popover in reference to the on-page content options are
  *  'auto'
  *  'auto-start'
  *  'auto-end'
  *  'top'
  *  'top-start'
  *  'top-end'
  *  'bottom'
  *  'bottom-start'
  *  'bottom-end'
  *  'right'
  *  'right-start'
  *  'right-end'
  *  'left'
  *  'left-start'
  *  'left-end'
  * @param {Boolean} flip, determines whether popover will change placement to try to stay in view
  * @param {Boolean} preventOveflow, nudge the popover inwards to prevent it escaping the container
  * @param {Array} fallbackPlacements, if flip is true, this is an array of strings (selected from placement options) for possible placements the Popover will flip to
  * @param {Number} distance, offset of the popover from the on-page-content, in pixels. Overrides offsetModifier
  * @param {Function} offsetModifier, used to define Popper's offset modifier. Use in place of distance param. Overridden by distance.
  * @param {HTML Element} boundary, ref specifying the boundary element for flip and preventOverflow
  * @param {HTML Element} referenceElement, if provided, this will be the element to which the popover is anchored (not the on-page-content slot). Note that this has to be a DOM element (not a React element, for example)
  * @return {LitElement} returns a class extended from LitElement
  * @example
  * <unity-popover
  *   withClose
  *   .onClose=${() => { console.log(`popover closed`); return true; }}
  *   .show=${true}
  *   placement='bottom'
  *   flip
  * >
  *   <div slot='on-page-content'>Content always visible, to which popover is anchored</div>
  *   <div slot='popover-content'>Content to be placed inside the popover</div>
  * </unity-popover>
  *
  * CSS Variables:
  * @css --popover-min-width - default value: 120px
  * @css --popover-min-height - default value: 38px
  * @css --popover-max-width - default value: 300px
  * @css --popover-max-height - default value: 300px
  * @css --popover-shadow - default value: 0 0 3px 2px rgba(0,0,0,0.2)
  * @css --popover-border - default value: none
  * @css --popover-close-button-color   default value: --dark-grey-text-color
  * @css --popover-z-index - default value: 1
  * @css --popover-content-overflow - default value: scroll
  * @css --popover-padding - default value: 2px 8px
  **/

  const defaultPlacement = 'bottom';
  let UnityPopover = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityPopover, _LitElement);
    var _super = _createSuper(UnityPopover);
    function UnityPopover() {
      var _this;
      _classCallCheck(this, UnityPopover);
      _this = _super.call(this);
      _this.onClose = () => {};
      _this.withClose = false;
      _this.closeOnOutsideClick = false;
      _this.flip = false;
      _this.preventOverflow = false;
      _this.boundary = null;
      _this.fallbackPlacements = [];
      _this.placement = defaultPlacement;
      _this.distance = 0;
      _this.offsetModifier = undefined;
      _this._referenceElement = null;
      _this.show = false;
      _this._show = false;
      _this._popoverInstance = null;
      _this._observer = null;
      _this.outsideClickListener = _this.outsideClickListener.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(UnityPopover, [{
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(UnityPopover.prototype), "disconnectedCallback", this).call(this);
        this.destroyPopover();
        document.removeEventListener('click', this.outsideClickListener);
      }
    }, {
      key: "show",
      get: function () {
        return this._show;
      },
      set: function (val) {
        const oldVal = this._show;
        this._show = val;
        const popoverElement = this.shadowRoot.querySelector('#popover-container');
        if (!!popoverElement) {
          if (!!val) {
            this.createPopover();
            popoverElement.setAttribute('data-show', '');
          } else {
            this.destroyPopover();
            popoverElement.removeAttribute('data-show');
          }
        }

        //If closeOnOutsideClick is true, register document onClick handler when menu opens
        // cleanup document onClick handler when menu closes
        if (!oldVal && val && this.closeOnOutsideClick) {
          document.addEventListener('click', this.outsideClickListener);
        } else if (oldVal && !val) {
          document.removeEventListener('click', this.outsideClickListener);
        }
        this.requestUpdate('show', oldVal);
      }
    }, {
      key: "referenceElement",
      get: function () {
        return this._referenceElement;
      },
      set: function (val) {
        this._referenceElement;
        this._referenceElement = val;
        this.createPopover();
        this.requestUpdate('referenceElement');
      }
    }, {
      key: "startObserver",
      value: function startObserver(reference) {
        this.stopObserver();
        if (!!reference) {
          this._observedElement = reference;
          this._observer = new ResizeObserver(_ref => {
            this.createPopover();
          });
          this._observer.observe(reference);
        }
      }
    }, {
      key: "stopObserver",
      value: function stopObserver() {
        if (this._observer) this._observer.disconnect();
      }
    }, {
      key: "outsideClickListener",
      value: function outsideClickListener(event) {
        const {
          target,
          path: eventPath
        } = event;
        const path = eventPath || event.composedPath && event.composedPath();
        if (!path) return; // IE will not have a path here

        if (!target || !Array.isArray(path)) return;
        const containerElement = this.shadowRoot.getElementById('main-container');
        const pathInContainer = path.some(comp => comp === containerElement);
        const pathInReferenceElement = isElement(this.referenceElement) && path.some(comp => comp === this.referenceElement);
        if (!pathInContainer && !pathInReferenceElement) {
          event.stopPropagation();
          if (!!this.show) this.onClose();
        }
      }
    }, {
      key: "createPopover",
      value: function createPopover() {
        const reference = isElement(this.referenceElement) ? this.referenceElement : this.shadowRoot.getElementById('page-content-container');
        if (!isElement(this.referenceElement)) console.warn(`unity-popover: provided reference element is not a valid DOM element. Popover placement may be impacted.`);
        const popover = this.shadowRoot.getElementById('popover-container');
        if (!reference || !popover) return;

        //To prevent infinite loop, check if this._observer exists before calling startObserver
        if (!this._observer) {
          this.startObserver(reference);
        }
        this._popoverInstance = createPopper(reference, popover, {
          placement: this.placement,
          modifiers: this.makeModifiers()
        });
      }
    }, {
      key: "destroyPopover",
      value: function destroyPopover() {
        if (this._popoverInstance) this._popoverInstance.destroy();
        this.stopObserver();
        this._popoverInstance = null;
      }
    }, {
      key: "makeModifiers",
      value: function makeModifiers() {
        const modifiers = [];
        if (this.flip) {
          const flipModifier = {
            name: 'flip',
            options: {}
          };
          if (!!this.fallbackPlacements[0]) flipModifier.options.fallbackPlacements = this.fallbackPlacements;
          if (!!this.boundary) flipModifier.options.boundary = this.boundary;
          modifiers.push(flipModifier);
        }
        if (this.preventOverflow) {
          const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {}
          };
          if (!!this.boundary) preventOverflowModifier.options.boundary = this.boundary;
          modifiers.push(preventOverflowModifier);
        }
        if (this.distance || this.offsetModifier) {
          const offsetModifier = {
            name: 'offset',
            options: {
              offset: this.distance ? [0, this.distance] : this.offsetModifier
            }
          };
          modifiers.push(offsetModifier);
        }
        return modifiers;
      }
    }, {
      key: "render",
      value: function render() {
        return html$1`
      <div id='main-container'>
        <div id='page-content-container'>
          <slot name="on-page-content" id='page-content'></slot>
        </div>
        <div id='popover-container'>
          ${this.withClose ? html$1`<unity-button
            id='close-button'
            type='borderless'
            centerIcon='unity:close'
            @click=${this.onClose}
          ></unity-button>` : ``}
          <div id="popover-content-container">
            <slot name="popover-content">No Popover Content Provided</slot>
          </div>
        </div>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          withClose: {
            type: Boolean
          },
          onClose: {
            type: Function
          },
          closeOnOutsideClick: {
            type: Boolean
          },
          show: {
            type: Boolean
          },
          placement: {
            type: String
          },
          flip: {
            type: Boolean
          },
          fallbackPlacements: {
            type: Array
          },
          preventOverflow: {
            type: Boolean
          },
          boundary: {
            type: Object
          },
          distance: {
            type: Number
          },
          offsetModifier: {
            type: Function
          },
          referenceElement: {
            type: Object
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-popover-min-width: 120px;
          --default-popover-max-width: 300px;
          --default-popover-min-height: 38px;
          --default-popover-max-height: 300px;
          --default-popover-shadow: 0 0 3px 2px rgba(0,0,0,0.2);
          --default-popover-border: none;
          --default-popover-close-button-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
          --default-popover-z-index: 1;
          --default-popover-content-overflow: auto;
          --default-popover-padding: 2px 8px;
        }

        #page-content-container {
          height: fit-content;
        }

        #popover-container {
          display: none;
          max-width: var(--popover-max-width, var(--default-popover-max-width));
          min-width: var(--popover-min-width, var(--default-popover-min-width));
          max-height: var(--popover-max-height, var(--default-popover-max-height));
          min-height: var(--popover-min-height, var(--default-popover-min-height));
          background-color: var(--popover-background-color, var(--default-white-color));
          box-shadow: var(--popover-shadow, var(--default-popover-shadow));
          border: var(--popover-border, var(--default-popover-border));
          padding: var(--popover-padding, var(--default-popover-padding));
          overflow-y: var(--popover-content-overflow, var(--default-popover-content-overflow));
          z-index: var(--popover-z-index, var(--default-popover-z-index));
        }

        #popover-container[data-show] {
          display: block;
        }

        #close-button {
          position: absolute;
          top: 5px;
          right: 5px;
          --button-color: var(--popover-close-button-color, var(--default-popover-close-button-color));
        }
      `];
      }
    }]);
    return UnityPopover;
  }(LitElement);
  window.customElements.define('unity-popover', UnityPopover);

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$5 = html`<iron-iconset-svg name="device" size="24">
<svg><defs>
<g id="access-alarm"><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></g>
<g id="access-alarms"><path d="M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"></path></g>
<g id="access-time"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></g>
<g id="add-alarm"><path d="M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"></path></g>
<g id="airplanemode-active"><path d="M10.18 9"></path><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"></path></g>
<g id="airplanemode-inactive"><path d="M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z"></path></g>
<g id="battery-20"><path d="M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"></path><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"></path></g>
<g id="battery-30"><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"></path><path d="M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"></path></g>
<g id="battery-50"><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"></path><path d="M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"></path></g>
<g id="battery-60"><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"></path><path d="M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"></path></g>
<g id="battery-80"><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"></path><path d="M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"></path></g>
<g id="battery-90"><path fill-opacity=".3" d="M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"></path><path d="M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"></path></g>
<g id="battery-alert"><path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"></path></g>
<g id="battery-charging-20"><path d="M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"></path><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"></path></g>
<g id="battery-charging-30"><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"></path><path d="M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"></path></g>
<g id="battery-charging-50"><path d="M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"></path><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"></path></g>
<g id="battery-charging-60"><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"></path><path d="M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"></path></g>
<g id="battery-charging-80"><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"></path><path d="M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"></path></g>
<g id="battery-charging-90"><path fill-opacity=".3" d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"></path><path d="M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"></path></g>
<g id="battery-charging-full"><path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"></path></g>
<g id="battery-full"><path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"></path></g>
<g id="battery-std"><path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"></path></g>
<g id="battery-unknown"><path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"></path></g>
<g id="bluetooth"><path d="M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"></path></g>
<g id="bluetooth-connected"><path d="M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"></path></g>
<g id="bluetooth-disabled"><path d="M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"></path></g>
<g id="bluetooth-searching"><path d="M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"></path></g>
<g id="brightness-auto"><path d="M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"></path></g>
<g id="brightness-high"><path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"></path></g>
<g id="brightness-low"><path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"></path></g>
<g id="brightness-medium"><path d="M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"></path></g>
<g id="data-usage"><path d="M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"></path></g>
<g id="developer-mode"><path d="M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"></path></g>
<g id="devices"><path d="M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"></path></g>
<g id="dvr"><path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"></path></g>
<g id="gps-fixed"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></g>
<g id="gps-not-fixed"><path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></g>
<g id="gps-off"><path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"></path></g>
<g id="graphic-eq"><path d="M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"></path></g>
<g id="location-disabled"><path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"></path></g>
<g id="location-searching"><path d="M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></g>
<g id="network-cell"><path fill-opacity=".3" d="M2 22h20V2z"></path><path d="M17 7L2 22h15z"></path></g>
<g id="network-wifi"><path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path><path d="M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"></path></g>
<g id="nfc"><path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"></path></g>
<g id="screen-lock-landscape"><path d="M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"></path></g>
<g id="screen-lock-portrait"><path d="M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"></path></g>
<g id="screen-lock-rotation"><path d="M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"></path></g>
<g id="screen-rotation"><path d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"></path></g>
<g id="sd-storage"><path d="M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"></path></g>
<g id="settings-system-daydream"><path d="M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"></path></g>
<g id="signal-cellular-0-bar"><path fill-opacity=".3" d="M2 22h20V2z"></path></g>
<g id="signal-cellular-1-bar"><path fill-opacity=".3" d="M2 22h20V2z"></path><path d="M12 12L2 22h10z"></path></g>
<g id="signal-cellular-2-bar"><path fill-opacity=".3" d="M2 22h20V2z"></path><path d="M14 10L2 22h12z"></path></g>
<g id="signal-cellular-3-bar"><path fill-opacity=".3" d="M2 22h20V2z"></path><path d="M17 7L2 22h15z"></path></g>
<g id="signal-cellular-4-bar"><path d="M2 22h20V2z"></path></g>
<g id="signal-cellular-connected-no-internet-0-bar"><path fill-opacity=".3" d="M22 8V2L2 22h16V8z"></path><path d="M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"></path></g>
<g id="signal-cellular-connected-no-internet-1-bar"><path fill-opacity=".3" d="M22 8V2L2 22h16V8z"></path><path d="M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"></path></g>
<g id="signal-cellular-connected-no-internet-2-bar"><path fill-opacity=".3" d="M22 8V2L2 22h16V8z"></path><path d="M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"></path></g>
<g id="signal-cellular-connected-no-internet-3-bar"><path fill-opacity=".3" d="M22 8V2L2 22h16V8z"></path><path d="M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z"></path></g>
<g id="signal-cellular-connected-no-internet-4-bar"><path d="M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"></path></g>
<g id="signal-cellular-no-sim"><path d="M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"></path></g>
<g id="signal-cellular-null"><path d="M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"></path></g>
<g id="signal-cellular-off"><path d="M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"></path></g>
<g id="signal-wifi-0-bar"><path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path></g>
<g id="signal-wifi-1-bar"><path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path><path d="M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"></path></g>
<g id="signal-wifi-1-bar-lock"><path d="M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"></path><path d="M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z" opacity=".3"></path><path d="M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z"></path></g>
<g id="signal-wifi-2-bar"><path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path><path d="M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"></path></g>
<g id="signal-wifi-2-bar-lock"><path d="M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"></path><path d="M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z" opacity=".3"></path><path d="M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z"></path></g>
<g id="signal-wifi-3-bar"><path fill-opacity=".3" d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path><path d="M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"></path></g>
<g id="signal-wifi-3-bar-lock"><path opacity=".3" d="M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z"></path><path d="M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9"></path></g>
<g id="signal-wifi-4-bar"><path d="M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"></path></g>
<g id="signal-wifi-4-bar-lock"><path d="M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z"></path></g>
<g id="signal-wifi-off"><path d="M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"></path></g>
<g id="storage"><path d="M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"></path></g>
<g id="usb"><path d="M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"></path></g>
<g id="wallpaper"><path d="M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"></path></g>
<g id="widgets"><path d="M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"></path></g>
<g id="wifi-lock"><path d="M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"></path></g>
<g id="wifi-tethering"><path d="M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template$5.content);

  const unitIconSet = html`<iron-iconset-svg name="unity" size="32">
  <svg>
    <defs>
      <g id="3dbar_chart">
        <path d="M9.284 14.688c-0.008-0.007-0.005-0.021-0.014-0.028-0.003-0.002-0.008 0-0.011-0.002-0.005-0.004-0.007-0.011-0.012-0.015l-1.785-1.191c-0.123-0.084-0.271-0.106-0.416-0.064l-4.152 1.191c-0.017 0.005-0.027 0.021-0.043 0.027-0.018 0.007-0.037 0.003-0.054 0.013-0.029 0.015-0.043 0.045-0.068 0.065-0.034 0.027-0.064 0.051-0.090 0.085-0.030 0.041-0.046 0.085-0.062 0.133-0.010 0.028-0.033 0.050-0.038 0.080-0.002 0.013 0.006 0.025 0.005 0.038s-0.011 0.025-0.011 0.039v11.872c0 0.167 0.084 0.323 0.223 0.416l1.785 1.191c0.084 0.056 0.18 0.084 0.277 0.084 0.047 0 0.092-0.007 0.139-0.020l4.152-1.191c0.213-0.062 0.361-0.258 0.361-0.48v-11.872c0-0.017-0.020-0.027-0.022-0.044-0.012-0.128-0.065-0.243-0.163-0.328zM7.1 14.413l0.693 0.463-2.893 0.829-0.693-0.463 2.893-0.829zM3.531 15.994l0.785 0.523v10.671l-0.785-0.524v-10.67zM5.316 27.459v-10.832l3.152-0.904v10.832l-3.152 0.904z"></path>
        <path d="M19.264 9.345c-0.008-0.007-0.005-0.021-0.014-0.028-0.003-0.002-0.008 0-0.011-0.002-0.005-0.004-0.007-0.011-0.012-0.015l-1.785-1.191c-0.123-0.082-0.273-0.104-0.416-0.064l-4.152 1.191c-0.017 0.005-0.027 0.021-0.044 0.028-0.018 0.007-0.037 0.003-0.054 0.012-0.029 0.015-0.043 0.045-0.068 0.065-0.034 0.027-0.064 0.051-0.090 0.085-0.030 0.041-0.046 0.085-0.062 0.133-0.010 0.028-0.033 0.050-0.038 0.080-0.002 0.013 0.006 0.025 0.005 0.038s-0.011 0.025-0.011 0.039v17.216c0 0.167 0.084 0.323 0.223 0.416l1.785 1.191c0.084 0.056 0.18 0.084 0.277 0.084 0.047 0 0.092-0.007 0.139-0.020l4.152-1.191c0.213-0.062 0.361-0.258 0.361-0.48v-17.216c0-0.017-0.020-0.027-0.022-0.044-0.012-0.128-0.065-0.243-0.163-0.328zM17.080 9.070l0.693 0.463-2.893 0.829-0.693-0.463 2.893-0.829zM13.512 10.651l0.785 0.523v16.015l-0.785-0.524v-16.014zM15.297 27.459v-16.176l3.152-0.904v16.175l-3.152 0.904z"></path>
        <path d="M29.447 5.025c-0.012-0.128-0.065-0.243-0.163-0.328-0.008-0.007-0.005-0.021-0.014-0.028-0.003-0.002-0.008 0-0.011-0.002-0.005-0.004-0.007-0.011-0.012-0.015l-1.785-1.191c-0.123-0.083-0.273-0.105-0.416-0.064l-4.152 1.191c-0.017 0.005-0.027 0.021-0.044 0.028-0.017 0.007-0.037 0.003-0.054 0.012-0.029 0.015-0.043 0.045-0.068 0.065-0.034 0.027-0.064 0.051-0.090 0.085-0.030 0.041-0.046 0.085-0.062 0.133-0.010 0.028-0.033 0.050-0.038 0.080-0.002 0.013 0.006 0.025 0.005 0.038s-0.011 0.025-0.011 0.039v21.863c0 0.167 0.084 0.323 0.223 0.416l1.785 1.191c0.084 0.056 0.18 0.084 0.277 0.084 0.047 0 0.092-0.007 0.139-0.020l4.152-1.191c0.213-0.062 0.361-0.258 0.361-0.48v-21.863c0-0.017-0.020-0.027-0.022-0.044zM27.1 4.422l0.693 0.463-2.893 0.829-0.693-0.463 2.893-0.829zM23.531 6.003l0.785 0.523v20.662l-0.785-0.524v-20.661zM25.316 27.459v-20.823l3.152-0.904v20.823l-3.152 0.904z"></path>
      </g>
      <g id="Save">
        <path d="M24 4h-17.936c-1.14 0-2.064 0.924-2.064 2.064v19.871c0 1.14 0.924 2.064 2.064 2.064h19.871c1.14 0 2.064-0.924 2.064-2.064v-17.936l-4-4zM19.969 6v4.003h-1.938v-4.003h1.938zM16.031 6v4.003h-6.031v-4.003h6.031zM10 25.948v-9.977h12v10.016l-12-0.039zM25.936 26l-1.936-0.006v-12.022h-16.008v2h0.008v9.971l-2-0.006 0.064-19.936h1.936v4.003h-0.008v2h14.007v-2h-0.030v-4.003h1.203l2.805 2.823 0.015-0.006-0.056 17.183z"></path>
        <path d="M12 17.971h7.992v2h-7.992v-2z"></path>
        <path d="M12 21.971h7.992v2h-7.992v-2z"></path>
      </g>
      <g id="Save_as">
        <path d="M16.243 26.142l12.95-12.95 2.121 2.121-12.95 12.95-5.303 3.182z"></path>
        <path d="M25.936 26l-1.808-0.006-2.006 2.006h3.814c1.14 0 2.064-0.924 2.064-2.064v-3.814l-2.059 2.059-0.006 1.82z"></path>
        <path d="M24 4h-17.936c-1.14 0-2.064 0.924-2.064 2.064v19.871c0 1.14 0.924 2.064 2.064 2.064h3.814l2.045-2.045-1.924-0.006v-9.977h11.907l2-2h-15.915v2h0.008v9.971l-2-0.006 0.064-19.936h1.936v4.003h-0.008v2h14.007v-2h-0.030v-4.003h1.203l2.805 2.823 0.015-0.006-0.010 3.080 2.019-2.019v-1.879l-4-4zM16.031 10.003h-6.031v-4.003h6.031v4.003zM19.969 10.003h-1.938v-4.003h1.938v4.003z"></path>
        <path d="M12 19.971h5.907l2-2h-7.907z"></path>
        <path d="M12 23.971h1.907l2-2h-3.907z"></path>
      </g>
      <g id="Show_hide">
        <path d="M16 6c2.671 0 5.182 1.040 7.071 2.929 3.899 3.899 3.899 10.243 0 14.142-1.889 1.889-4.4 2.929-7.071 2.929s-5.182-1.040-7.071-2.929c-3.899-3.899-3.899-10.243 0-14.142 1.889-1.889 4.4-2.929 7.071-2.929zM16 4c-3.071 0-6.142 1.172-8.485 3.515-4.686 4.686-4.686 12.284 0 16.971 2.343 2.343 5.414 3.515 8.485 3.515s6.142-1.172 8.485-3.515c4.686-4.686 4.686-12.284 0-16.971-2.343-2.343-5.414-3.515-8.485-3.515v0z"></path>
        <path d="M20.626 20.626c2.555-2.555 2.555-6.697 0-9.251l-9.251 9.251c2.555 2.555 6.697 2.555 9.251 0z"></path>
      </g>
      <g id="acrobat">
        <path d="M21.687 19.838c-0.324 0.41-0.715 0.625-1.197 0.625-0.678 0-1.428-0.43-2.268-1.215-1.535 0.305-3.32 0.893-4.785 1.518-0.465 0.947-0.875 1.748-1.303 2.32-0.553 0.768-1.053 1.143-1.498 1.143-0.18 0-0.375-0.070-0.52-0.18-0.555-0.426-0.625-0.91-0.59-1.213 0.090-0.875 1.18-1.822 3.25-2.713 0.785-1.785 1.553-4 2.053-5.82-0.518-1.196-1.035-2.696-0.66-3.59 0.143-0.32 0.393-0.535 0.66-0.623 0.143-0.037 0.232-0.090 0.357-0.090 0.268 0 0.518 0.107 0.695 0.357 0.18 0.215 0.625 0.805-0.070 3.855 0.73 1.5 1.75 3.018 2.75 4.070 0.713-0.143 1.338-0.195 1.82-0.195 0.84 0 1.355 0.195 1.57 0.59 0.107 0.32 0.035 0.695-0.266 1.16zM12.098 21.443c-1.176 0.625-1.641 1.145-1.66 1.447 0 0.053-0.035 0.197 0.25 0.393 0.055-0.035 0.535-0.25 1.41-1.84zM13.955 19.553c1.107-0.447 2.375-0.805 3.482-1.090-0.732-0.84-1.465-1.928-2.055-3-0.375 1.322-0.856 2.785-1.426 4.090h-0.002zM15.152 12.625c0.16-1.143 0.053-1.643 0-1.75h-0.035c-0.072 0-0.109 0.037-0.145 0.143-0.143 0.322-0.035 0.965 0.18 1.607zM21.078 19.053c-0.070-0.035-0.25-0.090-0.73-0.090-0.305 0-0.625 0.035-0.982 0.055 0.447 0.355 0.838 0.535 1.123 0.535 0.145 0 0.287-0.035 0.447-0.285 0.072-0.109 0.125-0.162 0.143-0.215z"></path>
        <path d="M20 2h-16v28h24v-20l-8-8zM25.172 10h-5.172v-5.172l5.172 5.172zM26 28h-20v-24h12v8h8v16z"></path>
      </g>
      <g id="add">
        <path d="M26 14h-8v-8h-4v8h-8v4h8v8h4v-8h8z"></path>
      </g>
      <g id="adv_forecast">
        <path d="M12 15.414l6 6 7.043-7.043 1.408 1.409 1.548-5.779-5.779 1.548 1.409 1.408-5.629 5.629-6-6-6.707 6.707 1.414 1.414z"></path>
        <path d="M4 28v-26h-2v28h28v-2z"></path>
        <path d="M12 9.414l6.172 6.172 1.414-1.414-7.586-7.586-6.707 6.707 1.414 1.414z"></path>
        <path d="M28 24l-1.548-5.779-1.408 1.408-1.215-1.215-1.414 1.414 1.215 1.215-1.409 1.409z"></path>
      </g>
      <g id="adv_learn">
        <path d="M16 24h4v4h-4v-4z"></path>
        <path d="M22 26h4v2h-4v-2z"></path>
        <path d="M4 10h4v18h-4v-18z"></path>
        <path d="M10.967 23c-0.325 0-0.65-0.066-0.967-0.174v5.174h4v-6.5c-0.429 0.224-0.768 0.486-0.911 0.622-0.574 0.574-1.341 0.879-2.122 0.879z"></path>
        <path d="M28.707 6.519c-1.618-1.615-5.501-3.661-9.223-0.637-3.723-3.027-7.609-0.979-9.225 0.637-0.188 0.188-0.293 0.441-0.293 0.707v12.774c0 0.404 0.244 0.77 0.617 0.924 0.123 0.051 0.254 0.076 0.383 0.076 0.26 0 0.516-0.102 0.707-0.293 0.145-0.145 3.588-3.518 7.103 0 0.048 0.048 0.116 0.055 0.171 0.091 0.056 0.038 0.089 0.099 0.153 0.125 0.042 0.017 0.088 0.015 0.132 0.026 0.042 0.011 0.079 0.019 0.123 0.024s0.085 0.026 0.128 0.026c0.131 0 0.26-0.026 0.381-0.076 0 0 0.001 0 0.002-0 0.003-0.001 0.004-0.004 0.006-0.005 0.116-0.049 0.225-0.119 0.318-0.212 3.428-3.433 6.738-0.361 7.104 0.002 0.285 0.283 0.713 0.363 1.090 0.213 0.371-0.156 0.615-0.52 0.615-0.922v-12.774c0-0.266-0.105-0.52-0.293-0.707zM18.484 17.96c-2.42-1.401-4.813-0.88-6.518 0.065v-10.354c0.893-0.734 3.648-2.581 6.518-0.016v10.305zM27 18.025c-0.957-0.529-2.129-0.925-3.398-0.925-0.996 0-2.055 0.244-3.117 0.859v-10.305c2.867-2.57 5.594-0.756 6.516 0.015v10.355z"></path>
      </g>
      <g id="adv_scoring">
        <path d="M6 2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4c0-2.209-1.791-4-4-4zM6 8c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"></path>
        <path d="M16 2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4c0-2.209-1.791-4-4-4zM16 8c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"></path>
        <path d="M30 6c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"></path>
        <path d="M10 16c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"></path>
        <path d="M16 12c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4c0-2.209-1.791-4-4-4zM16 18c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"></path>
        <path d="M6 22c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4c0-2.209-1.791-4-4-4zM6 28c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2z"></path>
      </g>
      <g id="adv_what_if">
        <path d="M16 24h4v4h-4v-4z"></path>
        <path d="M22 26h4v2h-4v-2z"></path>
        <path d="M19 22c4.971 0 9-4.029 9-9s-4.029-9-9-9-9 4.029-9 9 4.029 9 9 9zM19 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7c0-3.86 3.14-7 7-7z"></path>
        <path d="M18.871 15.86c-0.393 0-0.691 0.098-0.895 0.294-0.207 0.196-0.309 0.485-0.309 0.868 0 0.369 0.105 0.655 0.314 0.858 0.209 0.201 0.506 0.303 0.889 0.303 0.373 0 0.666-0.102 0.875-0.311 0.209-0.207 0.314-0.49 0.314-0.851 0-0.374-0.104-0.661-0.311-0.861s-0.5-0.301-0.879-0.301z"></path>
        <path d="M19.125 9.544c0.391 0 0.695 0.077 0.914 0.232s0.328 0.381 0.328 0.677c0 0.265-0.076 0.504-0.229 0.718s-0.467 0.492-0.947 0.834c-0.496 0.364-0.838 0.709-1.023 1.032-0.188 0.323-0.281 0.704-0.281 1.142v0.506h1.813v-0.41c0-0.273 0.057-0.494 0.174-0.663 0.115-0.169 0.393-0.415 0.83-0.738 0.639-0.456 1.070-0.866 1.299-1.23s0.342-0.798 0.342-1.299c0-0.752-0.277-1.354-0.83-1.805-0.555-0.451-1.301-0.677-2.24-0.677-1.139 0-2.217 0.285-3.232 0.854l0.744 1.497c0.875-0.446 1.656-0.67 2.34-0.67z"></path>
        <path d="M10 19.305v8.695h4v-5.214c-1.6-0.821-2.973-2.019-4-3.481z"></path>
        <path d="M4 10h4v18h-4v-18z"></path>
      </g>
      <g id="aggregation">
        <path d="M8.346 26.52v-1.080l5.59-8.343-4.996-8.991v-0.864h12.879l0.135 4.807h-1.457l-0.135-1.242c-0.059-0.577-0.289-1.092-0.638-1.503l0.003 0.004c-0.395-0.382-0.935-0.618-1.529-0.618-0.075 0-0.149 0.004-0.223 0.011l0.009-0.001h-5.508l3.916 7.074v0.405l-5.158 7.642h7.803c0.060 0.006 0.129 0.009 0.199 0.009 0.651 0 1.235-0.285 1.635-0.737l0.002-0.002c0.383-0.511 0.636-1.139 0.702-1.821l0.001-0.015 0.107-0.809h1.459l-0.137 6.074z"></path>
      </g>
      <g id="app_menu">
        <path d="M0 0h4v4h-4v-4z"></path>
        <path d="M14 0h4v4h-4v-4z"></path>
        <path d="M28 0h4v4h-4v-4z"></path>
        <path d="M0 14h4v4h-4v-4z"></path>
        <path d="M14 14h4v4h-4v-4z"></path>
        <path d="M28 14h4v4h-4v-4z"></path>
        <path d="M0 28h4v4h-4v-4z"></path>
        <path d="M14 28h4v4h-4v-4z"></path>
        <path d="M28 28h4v4h-4v-4z"></path>
      </g>
      <g id="area_chart">
        <path d="M30 28h-28l6-16 6 4c0 0 8-10.018 8-10l8 22z"></path>
      </g>
      <g id="arrow_circle">
        <path d="M12.293 10.707l5.293 5.293-5.293 5.293 1.414 1.414 6.707-6.707-6.707-6.707z"></path>
        <path d="M16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14c0-7.732-6.268-14-14-14zM16 28c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12z"></path>
      </g>
      <g id="asterix">
        <path d="M25.66 12.732l-2-3.464-5.66 3.268v-6.536h-4v6.536l-5.66-3.268-2 3.464 5.66 3.268-5.66 3.268 2 3.464 5.66-3.268v6.536h4v-6.536l5.66 3.268 2-3.464-5.66-3.268z"></path>
      </g>
      <g id="avg">
        <path d="M11.75 19.347l-0.59-1.516h-2.66l-0.551 1.516h-1.43l2.59-6.676h1.428l2.678 6.676h-1.465zM8.912 16.706h1.82l-0.928-2.482-0.892 2.482zM12.555 12.671h1.463l1.697 4.945 1.623-4.945h1.447l-2.392 6.676h-1.447l-2.391-6.676zM24.496 13.063c0.465 0.357 0.77 0.838 0.895 1.447l-1.34 0.25c-0.090-0.322-0.268-0.59-0.518-0.77-0.268-0.195-0.588-0.285-0.982-0.285-0.59 0-1.053 0.18-1.41 0.555-0.34 0.375-0.518 0.928-0.518 1.66 0 0.803 0.178 1.391 0.537 1.785 0.338 0.41 0.801 0.605 1.373 0.605 0.287 0 0.572-0.053 0.857-0.178 0.285-0.107 0.518-0.232 0.73-0.393v-0.857h-1.551v-1.125h2.91v2.66c-0.287 0.287-0.697 0.518-1.234 0.732-0.535 0.195-1.070 0.303-1.623 0.303-0.697 0-1.303-0.143-1.822-0.428-0.518-0.305-0.91-0.715-1.178-1.27-0.268-0.535-0.393-1.141-0.393-1.785 0-0.676 0.143-1.301 0.445-1.838 0.285-0.553 0.715-0.963 1.27-1.248 0.426-0.234 0.963-0.34 1.605-0.34 0.822-0 1.482 0.18 1.945 0.517z"></path>
        <path d="M27.691 10.309v11.381h-23.381v-11.381h23.381zM30 8h-28v16h28v-16z"></path>
      </g>
      <g id="aws">
        <path d="M0.414 18.32v-4.623l4.018-1.731 4.018 1.731v4.623l-4.018 1.715-4.018-1.715zM4.914 25.711v-4.623l4.016-1.713 4.020 1.713v4.623l-4.020 1.715-4.016-1.715zM9.734 18.32v-4.623l3.855-1.731 3.855 1.731v4.623l-3.855 1.715-3.855-1.715zM14.234 10.912v-4.624l4.016-1.714 4.016 1.714v4.624l-4.016 1.732-4.016-1.731zM23.553 10.912v-4.624l4.018-1.714 4.016 1.714v4.624l-4.016 1.731-4.018-1.731z"></path>
      </g>
      <g id="bar_chart">
        <path d="M2 16h6v12h-6v-12z"></path>
        <path d="M12 10h6v18h-6v-18z"></path>
        <path d="M22 4h6v24h-6v-24z"></path>
      </g>
      <g id="bookmark">
        <path d="M20 6c1.104 0.001 1.999 0.896 2 2v16l-6-4.5-6 4.5v-16c0.001-1.104 0.896-1.999 2-2h8zM20 4h-8c-2.209 0-4 1.791-4 4v0 20l8-6 8 6v-20c0-2.209-1.791-4-4-4v0z"></path>
      </g>
      <g id="box">
        <path d="M22.655 18.41c0 1.572-0.645 2.998-1.645 4.018-1.035 1.035-2.463 1.66-4.016 1.66-1.57 0-3-0.625-4.016-1.66-0.484-0.482-0.875-1.055-1.16-1.695-0.287 0.641-0.697 1.213-1.18 1.695-1 1.035-2.428 1.66-3.98 1.66-1.57 0-3.018-0.625-4.018-1.66-1.035-1.020-1.643-2.445-1.643-4.018v-9.587c0-0.606 0.5-1.089 1.107-1.089 0.588 0 1.107 0.482 1.107 1.089l-0.020 5.089c0.947-0.732 2.16-1.18 3.465-1.18 1.553 0 2.98 0.645 3.98 1.66 0.481 0.482 0.893 1.054 1.178 1.697 0.287-0.643 0.678-1.215 1.162-1.697 1.016-1.016 2.445-1.66 4.016-1.66 1.553 0 2.98 0.645 4.016 1.66 1 1.035 1.644 2.447 1.644 4.018zM10.104 18.412c0-0.965-0.375-1.84-1.018-2.43-0.607-0.66-1.482-1.035-2.428-1.035-0.965 0-1.803 0.375-2.465 1.035-0.606 0.59-1.016 1.465-1.016 2.43 0 0.945 0.41 1.801 1.016 2.445 0.662 0.605 1.5 1.035 2.465 1.035 0.945 0 1.82-0.43 2.428-1.035 0.643-0.645 1.018-1.5 1.018-2.445zM20.44 18.412c0-0.965-0.375-1.84-1.016-2.43-0.645-0.66-1.482-1.035-2.43-1.035-0.963 0-1.82 0.375-2.463 1.035-0.643 0.59-1.035 1.465-1.035 2.43 0 0.945 0.393 1.801 1.035 2.445 0.643 0.605 1.5 1.035 2.463 1.035 0.947 0 1.785-0.43 2.43-1.035 0.641-0.645 1.016-1.5 1.016-2.445zM30.725 22.483c0.375 0.5 0.303 1.176-0.197 1.551-0.463 0.375-1.162 0.285-1.553-0.195l-2.805-3.605-2.801 3.605c-0.395 0.48-1.090 0.57-1.555 0.195-0.48-0.375-0.59-1.088-0.195-1.57l3.16-4.053-3.16-4.053c-0.375-0.48-0.27-1.178 0.213-1.57 0.465-0.375 1.178-0.268 1.537 0.215l2.801 3.623 2.822-3.623c0.393-0.482 1.107-0.572 1.588-0.18 0.482 0.375 0.57 1.070 0.16 1.535l-3.16 4.071 3.145 4.055z"></path>
      </g>
      <g id="box_down">
        <path d="M20 14l-4 4-4-4h8z"></path>
        <path d="M22 10v12h-12v-12h12zM24 8h-16v16h16v-16z"></path>
      </g>
      <g id="box_left">
        <path d="M18 20l-4-4 4-4v8z"></path>
        <path d="M22 10v12h-12v-12h12zM24 8h-16v16h16v-16z"></path>
      </g>
      <g id="box_minus">
        <path d="M10 14h10v2h-10v-2z"></path>
        <path d="M22 8v14h-14v-14h14zM24 6h-18v18h18v-18z"></path>
      </g>
      <g id="box_plus">
        <path d="M20 14h-4v-4h-2v4h-4v2h4v4h2v-4h4z"></path>
        <path d="M22 8v14h-14v-14h14zM24 6h-18v18h18v-18z"></path>
      </g>
      <g id="box_right">
        <path d="M14 12l4 4-4 4v-8z"></path>
        <path d="M22 10v12h-12v-12h12zM24 8h-16v16h16v-16z"></path>
      </g>
      <g id="box_up">
        <path d="M12 18l4-4 4 4h-8z"></path>
        <path d="M22 10v12h-12v-12h12zM24 8h-16v16h16v-16z"></path>
      </g>
      <g id="boxplot_chart">
        <path d="M2 10h6v12h-6v-12z"></path>
        <path d="M10 14h6v4h-6v-4z"></path>
        <path d="M26 10h6v12h-6v-12z"></path>
        <path d="M18 6h6v20h-6v-20z"></path>
        <path d="M4 8h2v2h-2v-2z"></path>
        <path d="M4 22h2v2h-2v-2z"></path>
        <path d="M12 12h2v8h-2v-8z"></path>
        <path d="M20 4h2v24h-2v-24z"></path>
        <path d="M28 8h2v16h-2v-16z"></path>
      </g>
      <g id="branch">
        <path d="M26 8c-1.804 0.007-3.325 1.208-3.814 2.854l-0.007 0.028h-12.358c-0.5-1.679-2.030-2.882-3.841-2.882-2.209 0-4 1.791-4 4s1.791 4 4 4c1.811 0 3.34-1.203 3.833-2.854l0.007-0.028h0.179c1.59 0 2.883 1.741 2.883 3.882-0.012 0.136-0.018 0.294-0.018 0.454 0 2.947 2.241 5.371 5.111 5.662l0.024 0.002h0.178c0.5 1.679 2.030 2.883 3.841 2.883 2.209 0 4-1.791 4-4s-1.791-4-4-4c-1.811 0-3.341 1.204-3.834 2.855l-0.007 0.028h-0.178c-1.59 0-2.883-1.742-2.883-3.883 0-0.009 0-0.020 0-0.031 0-1.439-0.447-2.774-1.21-3.873l0.015 0.022h8.257c0.503 1.67 2.026 2.865 3.829 2.865 2.205 0 3.992-1.787 3.992-3.992s-1.787-3.992-3.992-3.992c-0.003 0-0.006 0-0.009 0h0zM22 20c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2v0c0-1.105 0.895-2 2-2v0zM6 14c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0zM26 14c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0z"></path>
      </g>
      <g id="breakdown">
        <path d="M27 21v-6h-10v-4h2v-6h-6v6h2v4h-10v6h-2v6h6v-6h-2v-4h8v4h-2v6h6v-6h-2v-4h8v4h-2v6h6v-6h-2z"></path>
      </g>
      <g id="bubble_chart">
        <path d="M30 15c0 3.866-3.134 7-7 7s-7-3.134-7-7c0-3.866 3.134-7 7-7s7 3.134 7 7z"></path>
        <path d="M14 12c0 3.314-2.686 6-6 6s-6-2.686-6-6c0-3.314 2.686-6 6-6s6 2.686 6 6z"></path>
        <path d="M16 24c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"></path>
        <path d="M6 22c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M22 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M18 6c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
      </g>
      <g id="calculate">
        <path d="M24 0h-16c-2.209 0-4 1.791-4 4v0 24c0 2.209 1.791 4 4 4v0h16c2.209 0 4-1.791 4-4v0-24c0-2.209-1.791-4-4-4v0zM26 28c-0.001 1.104-0.896 1.999-2 2h-16c-1.104-0.001-1.999-0.896-2-2v-24c0.001-1.104 0.896-1.999 2-2h16c1.104 0.001 1.999 0.896 2 2v0z"></path>
        <path d="M9 4h14c0.552 0 1 0.448 1 1v4c0 0.552-0.448 1-1 1h-14c-0.552 0-1-0.448-1-1v-4c0-0.552 0.448-1 1-1z"></path>
        <path d="M12 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M18 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M24 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M12 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M18 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M16 24h-6c-1.105 0-2 0.895-2 2s0.895 2 2 2v0h6c1.105 0 2-0.895 2-2s-0.895-2-2-2v0z"></path>
        <path d="M24 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M24 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
      </g>
      <g id="calendar">
        <path d="M23 6v-4h-4v4h-6v-4h-4v4h-6v24h26v-24h-6zM21 16h-4v-4h4v4zM15 16h-4v-4h4v4zM15 18v4h-4v-4h4zM17 18h4v4h-4v-4zM5 12h4v4h-4v-4zM5 18h4v4h-4v-4zM5 28v-4h4v4h-4zM11 28v-4h4v4h-4zM17 28v-4h4v4h-4zM27 28h-4v-4h4v4zM27 22h-4v-4h4v4zM27 16h-4v-4h4v4z"></path>
      </g>
      <g id="change">
        <path d="M22 25.666l-12-16-5.2 6.934-1.6-1.2 6.8-9.066 12 16 5.2-6.934 1.6 1.2-6.8 9.066z"></path>
      </g>
      <g id="chat">
        <path d="M16 8c5.523 0 10 3.224 10 7.2s-4.477 7.2-10 7.2c-1.363 0-2.662-0.198-3.846-0.554l-4.154 2.154 0.683-3.904c-1.66-1.285-2.683-3.003-2.683-4.896 0-3.976 4.477-7.2 10-7.2zM16 6c-6.729 0-12 4.041-12 9.2 0 2.081 0.886 4.054 2.519 5.659l-1.186 6.776 7.052-3.656c1.167 0.279 2.379 0.421 3.615 0.421 6.729 0 12-4.041 12-9.2s-5.271-9.2-12-9.2v0z"></path>
      </g>
      <g id="check">
        <path d="M11.922 24.043l-6.982-6.982 2.121-2.121 5.018 5.018 12.945-11.096 1.953 2.277z"></path>
      </g>
      <g id="checkbox">
        <path d="M14.2 21.2l-4.2-4.2 2.2-2.2 2 2 5.6-5.8 2.2 2.2z"></path>
        <path d="M24 8v16h-16v-16h16zM26 6h-20v20h20v-20z"></path>
      </g>
      <g id="checkbox_empty">
        <path d="M24 8v16h-16v-16h16zM26 6h-20v20h20v-20z"></path>
      </g>
      <g id="circle">
        <path d="M16 27c-6.065 0-11-4.936-11-11s4.935-11 11-11 11 4.936 11 11-4.935 11-11 11zM16 7c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z"></path>
      </g>
      <g id="circle_check">
        <path d="M14.104 21.121l-4.123-4.123 2.121-2.121 2.002 2.002 5.795-5.794 2.121 2.121z"></path>
        <path d="M16 27c-6.064 0-11-4.936-11-11s4.936-11 11-11 11 4.935 11 11c0 6.064-4.936 11-11 11zM16 7c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z"></path>
      </g>
      <g id="circle_filled">
        <path d="M16 27c-6.065 0-11-4.936-11-11s4.935-11 11-11 11 4.936 11 11-4.935 11-11 11z"></path>
      </g>
      <g id="circle_markup">
        <path d="M16.023 29c-1.004-0.043-1.996-0.111-2.967-0.334l0.449-1.949c0.822 0.189 1.635 0.334 2.516 0.283 0.877 0 1.746-0.104 2.588-0.309l0.473 1.941c-0.996 0.244-2.023 0.367-3.058 0.367zM9.309 27.146c-1.738-1.045-3.229-2.504-4.309-4.219l1.691-1.066c0.914 1.451 2.176 2.686 3.648 3.57l-1.031 1.715zM22.814 27.076l-1.051-1.703c1.461-0.9 2.709-2.15 3.609-3.611l1.703 1.051c-1.064 1.725-2.537 3.199-4.262 4.264zM3.402 19.219c-0.268-1.047-0.402-2.13-0.402-3.219 0-0.943 0.102-1.888 0.305-2.807l1.953 0.43c-0.172 0.778-0.258 1.578-0.258 2.377 0 0.922 0.115 1.84 0.34 2.727l-1.937 0.492zM28.631 19.082l-1.941-0.473c0.205-0.847 0.311-1.725 0.311-2.609 0-0.843-0.096-1.682-0.285-2.494l1.949-0.453c0.223 0.961 0.336 1.952 0.336 2.947 0 1.044-0.123 2.082-0.369 3.082zM6.508 10.441l-1.727-1.012c1.025-1.748 2.469-3.254 4.172-4.354l1.086 1.68c-1.443 0.933-2.664 2.207-3.531 3.687zM25.436 10.339c-0.887-1.471-2.123-2.732-3.572-3.648l1.066-1.691c1.713 1.082 3.172 2.571 4.217 4.307l-1.711 1.033z"></path>
        <path d="M16 3c-1.088 0-2.172 0.136-3.219 0.402l0.492 1.938c0.887-0.226 1.805-0.34 2.727-0.34s1.84 0.114 2.727 0.34l0.492-1.938c-1.047-0.266-2.131-0.402-3.219-0.402z"></path>
      </g>
      <g id="circle_minus">
        <path d="M16 7c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zM16 5c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11v0z"></path>
        <path d="M11 15h10v2h-10v-2z"></path>
      </g>
      <g id="circle_plus">
        <path d="M16 7c4.963 0 9 4.037 9 9s-4.037 9-9 9-9-4.037-9-9 4.037-9 9-9zM16 5c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11v0z"></path>
        <path d="M21 15h-4v-4h-2v4h-4v2h4v4h2v-4h4z"></path>
      </g>
      <g id="clear">
        <path d="M28.828 8.828l-5.656-5.656c-0.781-0.781-2.047-0.781-2.828 0l-17.172 17.172c-0.781 0.781-0.781 2.047 0 2.828l5.656 5.656c0.391 0.391 0.902 0.586 1.414 0.586s1.024-0.195 1.414-0.586l17.172-17.172c0.781-0.781 0.781-2.047 0-2.828zM10.242 27.414l-5.656-5.656 5.172-5.172 5.656 5.656-5.172 5.172z"></path>
      </g>
      <g id="clock">
        <path d="M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 27c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11z"></path>
        <path d="M17 9h-2v8h6v-2h-4z"></path>
      </g>
      <g id="close">
        <path d="M24.707 8.707l-1.414-1.414-7.293 7.293-7.293-7.293-1.414 1.414 7.293 7.293-7.293 7.293 1.414 1.414 7.293-7.293 7.293 7.293 1.414-1.414-7.293-7.293z"></path>
      </g>
      <g id="cloud">
        <path d="M32 20.475c0-2.967-2.367-5.369-5.33-5.5 0.037-0.258 0.080-0.515 0.080-0.783 0-3.051-2.497-5.525-5.578-5.525-2.075 0-3.864 1.135-4.825 2.8-0.92-0.663-2.044-1.066-3.269-1.066-3.081 0-5.578 2.474-5.578 5.525 0 0.309 0.042 0.608 0.092 0.903-2.058 0.497-3.592 2.322-3.592 4.513 0 2.573 2.106 4.658 4.703 4.658h18.047v-0.033c2.925-0.172 5.25-2.552 5.25-5.492z"></path>
        <path d="M5.512 15.496c0.224-3.951 3.532-7.096 7.566-7.096 0.941 0 1.861 0.174 2.727 0.511 1.213-1.22 2.822-1.968 4.544-2.161-0.911-1.644-2.535-2.75-4.403-2.75-1.927 0-3.588 1.179-4.48 2.907-0.855-0.689-1.898-1.107-3.036-1.107-2.861 0-5.18 2.569-5.18 5.737 0 0.321 0.039 0.631 0.085 0.938-1.911 0.516-3.335 2.411-3.335 4.687 0 1.707 0.803 3.2 2.008 4.061 0.043-2.442 1.409-4.607 3.504-5.727z"></path>
      </g>
      <g id="columns">
        <path d="M29 3h-26v26h26v-26zM21 27v-22h6v22zM13 27v-22h6v22zM5 27v-22h6v22z"></path>
      </g>
      <g id="compass">
        <path d="M16 6c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zM16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12v0z"></path>
        <path d="M24.194 16l-6.669 1.525-1.525 6.669-1.525-6.669-6.669-1.525 6.669-1.525 1.525-6.669 1.525 6.669z"></path>
        <path d="M20.442 20.442l-4.442-2.789-4.442 2.789 2.789-4.442-2.789-4.442 4.442 2.789 4.442-2.789-2.789 4.442z"></path>
      </g>
      <g id="compress">
        <path d="M17.293 14.707h8l-3.293-3.293 6-6-1.414-1.414-6 6-3.293-3.293z"></path>
        <path d="M5.414 28l6-6 3.293 3.293v-8h-8l3.293 3.293-6 6z"></path>
      </g>
      <g id="compute">
        <path d="M6 4v24h20v-24h-20zM24 26h-16v-4h16v4zM24 20h-16v-4h16v4zM24 14h-16v-4h16v4z"></path>
      </g>
      <g id="conical_flask">
        <path d="M20.415 4.923c0 0.41-0.32 0.768-0.715 0.768h-0.766v4.873l7.301 12.176c1.66 2.75 0.375 5.053-2.855 5.053h-14.766c-3.23 0-4.516-2.303-2.84-5.053l7.285-12.176v-4.873h-0.73c-0.395 0-0.75-0.357-0.75-0.768 0-0.393 0.355-0.715 0.75-0.715h7.371c0.395 0 0.715 0.322 0.715 0.715zM22.236 18.937l-4.748-7.944v-5.302h-2.945v5.302l-4.768 7.944h12.461zM11.042 19.474c0 1.266 1.035 2.248 2.268 2.248 1.23 0 2.268-0.982 2.268-2.248 0-1.234-1.037-2.25-2.268-2.25-1.232 0-2.268 1.016-2.268 2.25zM17.665 14.724c0 0.625-0.518 1.145-1.16 1.145-0.625 0-1.143-0.52-1.143-1.145 0-0.643 0.518-1.16 1.143-1.16 0.643 0 1.16 0.518 1.16 1.16z"></path>
      </g>
      <g id="copy">
        <path d="M26 10v18h-12v-18h12zM28 8h-16v22h16v-22z"></path>
        <path d="M18 2h-14v22h6v-2h-4v-18h12v2h2v-4z"></path>
      </g>
      <g id="css">
        <path d="M10 4h-2c-1.2 0-2 0.8-2 2v20c0 1.2 0.8 2 2 2h18v-24h-16zM10 6h14v16h-14v-16z"></path>
      </g>
      <g id="csv">
        <path d="M6.816 10.321c0.305 0 0.607 0.018 0.893 0.072 0.287 0.053 0.553 0.125 0.822 0.213 0.25 0.090 0.465 0.197 0.678 0.303 0.197 0.125 0.338 0.215 0.41 0.305 0.090 0.070 0.143 0.143 0.178 0.215 0.035 0.053 0.072 0.125 0.090 0.215 0.020 0.090 0.035 0.195 0.035 0.338 0.020 0.125 0.020 0.287 0.020 0.482 0 0.43-0.035 0.732-0.109 0.91-0.070 0.18-0.178 0.27-0.303 0.27-0.123 0-0.25-0.055-0.41-0.162-0.143-0.107-0.303-0.213-0.5-0.338-0.197-0.145-0.428-0.25-0.697-0.359-0.285-0.105-0.605-0.16-0.98-0.16-0.732 0-1.305 0.285-1.695 0.857-0.395 0.572-0.59 1.41-0.59 2.5 0 0.553 0.055 1.035 0.143 1.445 0.107 0.412 0.25 0.768 0.447 1.037 0.178 0.285 0.428 0.498 0.713 0.641 0.287 0.125 0.625 0.197 1.018 0.197s0.732-0.053 1.019-0.178c0.285-0.109 0.516-0.234 0.73-0.375 0.215-0.145 0.393-0.285 0.535-0.395 0.145-0.125 0.27-0.178 0.357-0.178 0.072 0 0.125 0.018 0.178 0.053 0.035 0.035 0.072 0.109 0.109 0.215 0.016 0.090 0.051 0.232 0.051 0.395 0.020 0.16 0.037 0.355 0.037 0.605 0 0.195-0.018 0.357-0.018 0.5l-0.055 0.32c-0.018 0.090-0.035 0.162-0.070 0.234-0.020 0.053-0.072 0.125-0.16 0.213-0.109 0.090-0.25 0.178-0.465 0.303-0.232 0.125-0.482 0.25-0.75 0.34-0.285 0.107-0.59 0.18-0.91 0.232-0.34 0.072-0.68 0.107-1.020 0.107-0.785 0-1.463-0.125-2.070-0.375-0.605-0.232-1.105-0.59-1.516-1.070-0.394-0.465-0.715-1.035-0.912-1.715-0.213-0.695-0.322-1.465-0.322-2.34 0-1.016 0.125-1.891 0.395-2.623 0.25-0.732 0.59-1.338 1.053-1.82 0.447-0.482 0.982-0.857 1.607-1.090s1.303-0.338 2.035-0.338v-0.002zM16.547 10.376c0.285 0.037 0.551 0.107 0.803 0.162 0.25 0.070 0.447 0.141 0.607 0.23 0.178 0.072 0.285 0.145 0.355 0.197 0.072 0.053 0.125 0.107 0.16 0.178 0.020 0.055 0.055 0.125 0.072 0.197 0 0.088 0.018 0.178 0.033 0.305 0 0.107 0.020 0.248 0.020 0.428 0 0.195-0.020 0.375-0.020 0.5l-0.051 0.305c-0.037 0.070-0.074 0.125-0.109 0.16-0.053 0.018-0.106 0.035-0.16 0.035-0.070 0-0.178-0.035-0.32-0.125-0.144-0.070-0.322-0.16-0.535-0.25-0.215-0.090-0.465-0.18-0.75-0.25-0.285-0.090-0.607-0.125-0.965-0.125-0.268 0-0.482 0.018-0.68 0.070-0.176 0.055-0.338 0.144-0.463 0.234-0.107 0.105-0.213 0.213-0.268 0.338-0.055 0.143-0.090 0.285-0.090 0.428 0 0.234 0.072 0.43 0.215 0.59 0.144 0.16 0.34 0.305 0.572 0.43 0.232 0.105 0.498 0.23 0.803 0.338 0.285 0.108 0.59 0.213 0.893 0.338s0.607 0.27 0.91 0.43c0.303 0.18 0.572 0.375 0.803 0.625 0.234 0.232 0.412 0.518 0.555 0.857 0.142 0.338 0.232 0.732 0.232 1.197 0 0.57-0.125 1.088-0.34 1.516-0.213 0.447-0.518 0.805-0.91 1.107-0.393 0.287-0.857 0.518-1.393 0.66s-1.105 0.215-1.73 0.215c-0.395 0-0.75-0.018-1.090-0.090-0.34-0.053-0.645-0.125-0.93-0.213-0.266-0.072-0.5-0.162-0.678-0.27-0.178-0.090-0.303-0.16-0.393-0.25-0.090-0.070-0.143-0.195-0.195-0.375-0.037-0.16-0.055-0.41-0.055-0.75 0-0.215 0-0.391 0.018-0.516 0.018-0.145 0.037-0.25 0.072-0.322 0.016-0.090 0.053-0.143 0.105-0.162 0.035-0.035 0.109-0.035 0.16-0.035 0.090 0 0.215 0.035 0.375 0.145 0.162 0.088 0.359 0.195 0.609 0.303s0.515 0.213 0.84 0.32c0.32 0.090 0.695 0.143 1.088 0.143 0.268 0 0.498-0.018 0.697-0.070 0.195-0.055 0.373-0.145 0.516-0.232 0.145-0.107 0.27-0.213 0.34-0.375 0.070-0.142 0.107-0.322 0.107-0.517 0-0.232-0.072-0.43-0.215-0.59-0.125-0.16-0.322-0.303-0.553-0.428-0.232-0.107-0.482-0.232-0.768-0.34-0.303-0.107-0.59-0.213-0.912-0.338-0.301-0.125-0.588-0.285-0.891-0.447-0.285-0.162-0.555-0.375-0.769-0.607-0.23-0.25-0.426-0.535-0.57-0.875-0.125-0.34-0.195-0.75-0.195-1.231 0-0.482 0.090-0.93 0.285-1.322 0.18-0.41 0.445-0.75 0.803-1.035s0.787-0.518 1.303-0.678c0.5-0.16 1.072-0.234 1.715-0.234 0.32 0 0.625 0.020 0.93 0.072zM28.918 10.503c0.285 0 0.518 0 0.695 0.016 0.18 0.020 0.305 0.035 0.41 0.090 0.090 0.035 0.16 0.070 0.197 0.125 0.035 0.070 0.053 0.125 0.053 0.215v0.125c0 0.053-0.018 0.105-0.018 0.178l-0.053 0.215c-0.020 0.088-0.035 0.178-0.072 0.285l-3.033 9.141c-0.037 0.125-0.090 0.232-0.145 0.322-0.070 0.070-0.178 0.143-0.32 0.178-0.145 0.053-0.357 0.072-0.607 0.088-0.25 0.020-0.572 0.020-0.982 0.020s-0.73 0-0.98-0.020c-0.25-0.016-0.447-0.051-0.59-0.105-0.145-0.035-0.25-0.107-0.32-0.18-0.055-0.070-0.109-0.178-0.145-0.303l-3.035-9.141c-0.053-0.143-0.090-0.285-0.105-0.412-0.037-0.105-0.055-0.195-0.055-0.248v-0.143c0-0.090 0.018-0.145 0.055-0.215 0.035-0.055 0.125-0.090 0.23-0.125 0.090-0.055 0.25-0.070 0.43-0.090s0.41-0.020 0.697-0.020c0.303 0 0.553 0 0.748 0.020 0.18 0.016 0.34 0.053 0.447 0.088 0.107 0.037 0.178 0.090 0.232 0.143 0.035 0.072 0.090 0.145 0.107 0.232l2.303 7.428 0.070 0.266 0.072-0.266 2.25-7.428c0.035-0.088 0.072-0.16 0.125-0.232 0.035-0.053 0.125-0.105 0.232-0.143 0.090-0.035 0.23-0.072 0.41-0.088 0.178-0.020 0.41-0.020 0.695-0.020v0.004z"></path>
      </g>
      <g id="csv_alt">
        <path d="M9.419 19.877c0.806 0 1.47-0.2 1.994-0.596 0.524-0.398 0.898-1.006 1.124-1.825l-1.469-0.466c-0.126 0.549-0.335 0.952-0.624 1.208s-0.637 0.384-1.039 0.384c-0.546 0-0.99-0.202-1.331-0.604-0.341-0.403-0.512-1.079-0.512-2.027 0-0.894 0.173-1.541 0.52-1.94s0.798-0.599 1.354-0.599c0.402 0 0.745 0.113 1.026 0.338s0.466 0.532 0.555 0.921l1.5-0.358c-0.171-0.601-0.427-1.062-0.768-1.382-0.573-0.543-1.319-0.814-2.237-0.814-1.051 0-1.899 0.345-2.544 1.037s-0.967 1.661-0.967 2.91c0 1.18 0.321 2.111 0.962 2.792s1.461 1.021 2.457 1.021z"></path>
        <path d="M16.041 18.603c-0.461 0-0.827-0.116-1.098-0.348-0.271-0.233-0.451-0.596-0.54-1.090l-1.474 0.143c0.099 0.839 0.402 1.478 0.911 1.917 0.509 0.438 1.237 0.658 2.186 0.658 0.652 0 1.195-0.092 1.633-0.274 0.436-0.183 0.774-0.462 1.014-0.837 0.239-0.376 0.358-0.778 0.358-1.208 0-0.475-0.1-0.873-0.299-1.195s-0.476-0.577-0.829-0.763c-0.353-0.187-0.898-0.366-1.635-0.54s-1.201-0.342-1.392-0.502c-0.15-0.127-0.225-0.279-0.225-0.456 0-0.194 0.080-0.351 0.241-0.466 0.249-0.182 0.594-0.271 1.034-0.271 0.427 0 0.747 0.084 0.96 0.253s0.353 0.445 0.417 0.832l1.515-0.067c-0.024-0.69-0.274-1.241-0.75-1.653-0.476-0.413-1.185-0.619-2.127-0.619-0.576 0-1.069 0.087-1.477 0.261s-0.72 0.427-0.937 0.76c-0.217 0.333-0.325 0.69-0.325 1.072 0 0.594 0.23 1.097 0.691 1.51 0.328 0.293 0.898 0.54 1.71 0.742 0.631 0.156 1.036 0.266 1.213 0.328 0.258 0.092 0.44 0.2 0.545 0.325 0.105 0.124 0.156 0.275 0.156 0.453 0 0.276-0.123 0.517-0.371 0.724-0.248 0.206-0.615 0.31-1.103 0.31z"></path>
        <path d="M23.313 19.749l2.687-7.504h-1.607l-1.838 5.554-1.899-5.554h-1.643l2.682 7.504z"></path>
        <path d="M2 8v16h28v-16h-28zM28 22h-24v-12h24v12z"></path>
      </g>
      <g id="csv_alt1">
        <path d="M11.433 18.699c-0.224 0.198-0.492 0.297-0.803 0.297-0.422 0-0.765-0.156-1.028-0.467-0.264-0.312-0.396-0.834-0.396-1.566 0-0.691 0.134-1.191 0.402-1.499s0.617-0.463 1.046-0.463c0.311 0 0.575 0.087 0.793 0.261s0.36 0.411 0.429 0.712l1.159-0.277c-0.132-0.465-0.33-0.821-0.593-1.068-0.443-0.419-1.019-0.629-1.728-0.629-0.812 0-1.467 0.267-1.966 0.801s-0.748 1.283-0.748 2.249c0 0.912 0.248 1.631 0.744 2.157s1.129 0.789 1.898 0.789c0.622 0 1.136-0.154 1.541-0.461 0.405-0.308 0.694-0.777 0.868-1.41l-1.135-0.36c-0.097 0.424-0.259 0.736-0.483 0.933z"></path>
        <path d="M17.196 16.695c-0.273-0.144-0.694-0.283-1.264-0.417s-0.928-0.264-1.076-0.388c-0.116-0.098-0.174-0.216-0.174-0.352 0-0.15 0.062-0.271 0.186-0.36 0.192-0.14 0.459-0.21 0.799-0.21 0.33 0 0.577 0.065 0.742 0.196s0.273 0.344 0.322 0.643l1.171-0.051c-0.019-0.533-0.212-0.959-0.579-1.278s-0.916-0.479-1.643-0.479c-0.445 0-0.826 0.067-1.141 0.202s-0.556 0.33-0.724 0.587-0.251 0.533-0.251 0.829c0 0.459 0.178 0.847 0.534 1.167 0.253 0.226 0.694 0.417 1.321 0.573 0.488 0.121 0.8 0.206 0.937 0.253 0.2 0.071 0.34 0.154 0.421 0.251s0.121 0.213 0.121 0.35c0 0.213-0.095 0.399-0.287 0.56s-0.475 0.239-0.852 0.239c-0.356 0-0.639-0.090-0.848-0.269-0.21-0.18-0.348-0.461-0.417-0.842l-1.139 0.111c0.077 0.649 0.311 1.142 0.704 1.481s0.956 0.508 1.689 0.508c0.504 0 0.924-0.071 1.262-0.212s0.598-0.357 0.783-0.647c0.185-0.291 0.277-0.601 0.277-0.933 0-0.367-0.077-0.674-0.231-0.923s-0.368-0.446-0.641-0.589z"></path>
        <path d="M21.378 19.897l2.076-5.798h-1.242l-1.42 4.291-1.467-4.291h-1.27l2.072 5.798z"></path>
        <path d="M20 2h-16v28h24v-20l-8-8zM20 4.828l5.172 5.172h-5.172v-5.172zM26 28h-20v-24h12v8h8v16z"></path>
      </g>
      <g id="cube">
        <path d="M26.632 9.436l-10.632-3.544-12 4v14.55l12 4 12-4v-14.55l-1.368-0.456zM16 8l8.42 2.807-10.001 3.333-8.419-2.806 10-3.333zM16 26.333v-10.611l10-3.333v10.611l-10 3.333z"></path>
      </g>
      <g id="cube_1">
        <path d="M12.084 21.805l3.166 1.131v-4.406l-3.166-1.131z"></path>
        <path d="M7.416 20.139l3.168 1.131v-4.408l-3.168-1.129z"></path>
        <path d="M6.607 6.15l-2.467 0.881 2.467 0.881 2.467-0.881z"></path>
        <path d="M12.084 27.805l3.166 1.131v-4.406l-3.166-1.131z"></path>
        <path d="M11.303 7.828l-2.467 0.881 2.469 0.881 2.467-0.881z"></path>
        <path d="M7.416 14.139l3.168 1.131v-4.346l-3.168-1.131z"></path>
        <path d="M7.416 26.139l3.168 1.131v-4.408l-3.168-1.129z"></path>
        <path d="M20.695 6.236l2.469-0.881-2.467-0.883-2.471 0.883z"></path>
        <path d="M11.303 4.473l-2.467 0.883 2.469 0.881 2.469-0.881z"></path>
        <path d="M13.533 7.031l2.467 0.881 2.467-0.881-2.467-0.881z"></path>
        <path d="M2.75 24.473l3.166 1.129v-4.406l-3.166-1.131z"></path>
        <path d="M2.75 12.473l3.166 1.129v-4.344l-3.166-1.131z"></path>
        <path d="M18.467 3.678l-2.467-0.881-2.467 0.881 2.467 0.881z"></path>
        <path d="M2.75 18.473l3.166 1.129v-4.406l-3.166-1.131z"></path>
        <path d="M25.393 6.15l-2.467 0.881 2.467 0.881 2.467-0.881z"></path>
        <path d="M21.416 15.27l3.168-1.131v-4.346l-3.168 1.131z"></path>
        <path d="M21.416 21.27l3.168-1.131v-4.406l-3.168 1.129z"></path>
        <path d="M26.084 25.602l3.166-1.129v-4.408l-3.166 1.131z"></path>
        <path d="M26.084 19.602l3.166-1.129v-4.408l-3.166 1.131z"></path>
        <path d="M29.25 8.127l-3.166 1.131v4.344l3.166-1.129z"></path>
        <path d="M12.084 15.805l3.166 1.131v-4.346l-3.166-1.129z"></path>
        <path d="M16.75 22.935l3.166-1.131v-4.406l-3.166 1.131z"></path>
        <path d="M16.75 28.935l3.166-1.131v-4.406l-3.166 1.131z"></path>
        <path d="M16 9.504l-2.469 0.881 2.469 0.883 2.469-0.883z"></path>
        <path d="M16.75 16.936l3.166-1.131v-4.344l-3.166 1.129z"></path>
        <path d="M20.697 7.828l-2.469 0.881 2.467 0.881 2.469-0.881z"></path>
        <path d="M21.416 27.27l3.168-1.131v-4.406l-3.168 1.129z"></path>
      </g>
      <g id="cube_2">
        <path d="M13.027 7.209l-4.072-1.453-3.982 1.422 4.072 1.453z"></path>
        <path d="M8 10.443l-5-1.785v6.816l5 1.785z"></path>
        <path d="M15 21.883l-5-1.787v6.879l5 1.785z"></path>
        <path d="M20.072 4.694l-4.072-1.453-4.072 1.453 4.072 1.455z"></path>
        <path d="M10 17.975l5 1.785v-6.816l-5-1.785z"></path>
        <path d="M8 19.381l-5-1.785v6.879l5 1.785z"></path>
        <path d="M24 26.26l5-1.785v-6.879l-5 1.785z"></path>
        <path d="M22.955 8.631l4.072-1.453-3.982-1.422-4.072 1.453z"></path>
        <path d="M24 17.26l5-1.785v-6.816l-5 1.785z"></path>
        <path d="M12.016 9.693l3.984 1.422 3.984-1.422-3.984-1.422z"></path>
        <path d="M22 20.096l-5 1.787v6.877l5-1.785z"></path>
        <path d="M17 19.76l5-1.785v-6.816l-5 1.785z"></path>
      </g>
      <g id="cube_doc">
        <path d="M20 2h-16v28h24v-20l-8-8zM25.172 10h-5.172v-5.172l5.172 5.172zM26 28h-20v-24h12v8h8v16z"></path>
        <path d="M8 12v10h6v4h10v-10h-6v-4h-10zM22 18v6h-6v-6h6zM14 16v4h-4v-6h6v2h-2z"></path>
      </g>
      <g id="currency">
        <path d="M1 6v20h30v-20h-30zM29 22c-1.2 0-2 0.8-2 2h-22c0-1.2-0.8-2-2-2v-12c1.2 0 2-0.8 2-2h22c0 1.2 0.8 2 2 2v12z"></path>
        <path d="M16 10c-2.8 0-5 2.6-5 6s2.2 6 5 6 5-2.6 5-6-2.2-6-5-6zM18.8 19.6h-5.4v-1.2h1.8v-4c-0.2 0.4-0.4 0.6-0.8 0.8l-1-1 2-1.8h1.6v6h1.8v1.2z"></path>
      </g>
      <g id="cursor">
        <path d="M23 19.336l-14-14v20l4.857-4.857 2.651 6.186 2.758-1.182-2.634-6.147z"></path>
      </g>
      <g id="cut">
        <path d="M27.662 20.764c0.24 0.174 0.361 0.469 0.334 0.75-0.041 0.295-0.215 0.549-0.469 0.684l-1.715 0.857c-0.121 0.066-0.254 0.094-0.389 0.094-0.146 0-0.295-0.041-0.416-0.107l-9.244-5.184-1.473 0.883c-0.055 0.027-0.108 0.055-0.16 0.068 0.119 0.414 0.174 0.857 0.133 1.299-0.121 1.379-1.045 2.693-2.518 3.631-1.139 0.723-2.453 1.125-3.711 1.125-1.207 0-2.225-0.361-2.975-1.045-0.764-0.711-1.152-1.729-1.059-2.773 0.121-1.367 1.045-2.693 2.506-3.631 1.139-0.723 2.465-1.125 3.723-1.125 0.752 0 1.434 0.146 2.023 0.416 0.080-0.121 0.174-0.215 0.295-0.295l1.635-0.979-1.635-0.978c-0.121-0.080-0.215-0.174-0.295-0.295-0.59 0.27-1.271 0.416-2.023 0.416-1.258 0-2.584-0.402-3.723-1.125-1.461-0.937-2.385-2.264-2.506-3.631-0.094-1.045 0.295-2.063 1.059-2.76 0.75-0.697 1.768-1.059 2.975-1.059 1.258 0 2.572 0.402 3.711 1.125 1.473 0.924 2.396 2.252 2.518 3.631 0.041 0.441-0.014 0.885-0.133 1.299 0.053 0.014 0.105 0.041 0.16 0.068l1.473 0.883 9.244-5.184c0.121-0.066 0.27-0.107 0.416-0.107 0.135 0 0.268 0.027 0.389 0.094l1.715 0.857c0.254 0.135 0.428 0.389 0.469 0.684 0.027 0.281-0.094 0.576-0.334 0.75l-6.793 5.332 6.793 5.332zM11.746 18.914c-0.35-0.32-0.898-0.482-1.516-0.482-0.816 0-1.754 0.27-2.572 0.791-1.445 0.912-1.955 2.264-1.139 3.016 0.35 0.32 0.898 0.482 1.516 0.482 0.803 0 1.754-0.27 2.572-0.791 1.445-0.912 1.955-2.264 1.139-3.016zM10.608 8.934c-0.818-0.521-1.77-0.791-2.572-0.791-0.617 0-1.166 0.162-1.516 0.482-0.816 0.752-0.307 2.104 1.139 3.016 0.818 0.521 1.756 0.791 2.572 0.791 0.617 0 1.166-0.162 1.516-0.482 0.817-0.752 0.307-2.103-1.138-3.016zM17.277 17.146l9.861-7.717-1.715-0.857-10.289 5.774v1.516l-2.143 1.285 0.119 0.108c0.027 0.039 0.055 0.053 0.094 0.080 0.107 0.107 0.188 0.215 0.295 0.322l0.348 0.348 2.145-1.287 1.285 0.43zM14.277 14.494v-0.148c0-0.307 0.174-0.588 0.441-0.75l0.188-0.107-1.059-0.629-0.348 0.348c-0.108 0.107-0.188 0.215-0.295 0.309-0.039 0.041-0.066 0.055-0.094 0.080l-0.119 0.121 1.285 0.777zM17.707 15.432c0 0.469-0.389 0.857-0.857 0.857s-0.858-0.389-0.858-0.857 0.389-0.857 0.857-0.857 0.858 0.389 0.858 0.857zM27.139 21.434l-6.967-5.467-2.371 1.85c-0.041 0.053-0.107 0.066-0.174 0.094l7.797 4.381 1.715-0.857z"></path>
      </g>
      <g id="dashboard">
        <path d="M2 2v28h28v-28h-28zM28 28h-24v-24h24v24z"></path>
        <path d="M6 8h2v6h-2v-6z"></path>
        <path d="M10 10h2v4h-2v-4z"></path>
        <path d="M14 6h2v8h-2v-8z"></path>
        <path d="M18 8h2v6h-2v-6z"></path>
        <path d="M22 6h2v8h-2v-8z"></path>
        <path d="M6 16h8v2h-8v-2z"></path>
        <path d="M6 20h8v2h-8v-2z"></path>
        <path d="M6 24h8v2h-8v-2z"></path>
        <path d="M21 26c2.761 0 5-2.239 5-5h-5v-5c-2.761 0-5 2.239-5 5s2.239 5 5 5z"></path>
      </g>
      <g id="dashlet_chart">
        <path d="M2 6v20h28v-20h-28zM28 24h-24v-16h24v16z"></path>
        <path d="M10 12h12v4h-12v-4z"></path>
        <path d="M12 18h8v2h-8v-2z"></path>
      </g>
      <g id="data_format">
        <path d="M4 26h2v2h-2v-2z"></path>
        <path d="M12 12h2v2h-2v-2z"></path>
        <path d="M12 16c-1.193 0-2.123 0.401-2.79 1.202-0.807 0.972-1.21 2.565-1.21 4.778 0 2.255 0.367 3.822 1.101 4.701s1.701 1.319 2.899 1.319c1.193 0 2.123-0.401 2.79-1.202 0.807-0.972 1.21-2.571 1.21-4.794 0-2.229-0.4-3.824-1.202-4.786-0.672-0.813-1.605-1.218-2.798-1.218zM13.286 24.938c-0.123 0.449-0.297 0.76-0.521 0.934s-0.479 0.261-0.765 0.261c-0.286 0-0.539-0.086-0.761-0.256s-0.404-0.515-0.55-1.030-0.219-1.463-0.219-2.842c0-1.379 0.081-2.359 0.244-2.942 0.123-0.449 0.297-0.76 0.521-0.934 0.224-0.173 0.479-0.261 0.765-0.261s0.539 0.087 0.761 0.261c0.222 0.174 0.404 0.519 0.55 1.034s0.219 1.463 0.219 2.842c0 1.379-0.081 2.357-0.244 2.934z"></path>
        <path d="M22 16c-1.193 0-2.123 0.401-2.79 1.202-0.807 0.972-1.21 2.565-1.21 4.778 0 2.255 0.367 3.822 1.101 4.701s1.701 1.319 2.899 1.319c1.193 0 2.123-0.401 2.79-1.202 0.807-0.972 1.21-2.571 1.21-4.794 0-2.229-0.4-3.824-1.202-4.786-0.672-0.813-1.605-1.218-2.798-1.218zM23.286 24.938c-0.123 0.449-0.297 0.76-0.521 0.934s-0.479 0.261-0.765 0.261c-0.286 0-0.539-0.086-0.761-0.256s-0.404-0.515-0.55-1.030-0.218-1.463-0.218-2.842c0-1.379 0.081-2.359 0.244-2.942 0.123-0.449 0.297-0.76 0.521-0.934 0.224-0.173 0.479-0.261 0.765-0.261s0.539 0.087 0.761 0.261c0.222 0.174 0.404 0.519 0.55 1.034s0.218 1.463 0.218 2.842c0 1.379-0.081 2.357-0.244 2.934z"></path>
        <path d="M22 14.020c1.193 0 2.123-0.401 2.79-1.202 0.807-0.972 1.21-2.571 1.21-4.794 0-2.229-0.4-3.824-1.202-4.786-0.672-0.813-1.605-1.218-2.798-1.218s-2.123 0.401-2.79 1.202c-0.807 0.972-1.21 2.565-1.21 4.778 0 2.255 0.367 3.822 1.101 4.701s1.701 1.319 2.899 1.319zM20.714 5.082c0.123-0.449 0.297-0.76 0.521-0.934s0.479-0.261 0.765-0.261c0.286 0 0.539 0.087 0.761 0.261s0.404 0.519 0.55 1.034 0.218 1.463 0.218 2.842-0.081 2.357-0.244 2.934c-0.123 0.449-0.297 0.76-0.521 0.934s-0.479 0.261-0.765 0.261c-0.286 0-0.539-0.086-0.761-0.256s-0.404-0.515-0.55-1.030-0.218-1.463-0.218-2.842 0.081-2.359 0.244-2.942z"></path>
      </g>
      <g id="data_input">
        <path d="M21.938 23.25c-0.55 0.483-1.164 0.917-1.821 1.285l-0.054 0.028c-0.642 0.355-1.396 0.688-2.18 0.955l-0.101 0.030c-0.761 0.264-1.667 0.488-2.6 0.63l-0.088 0.011c-0.883 0.139-1.901 0.219-2.938 0.219s-2.055-0.080-3.048-0.233l0.111 0.014c-1.021-0.153-1.927-0.376-2.799-0.674l0.111 0.033c-0.885-0.296-1.639-0.629-2.356-1.022l0.075 0.037c-0.711-0.395-1.325-0.83-1.887-1.323l0.012 0.010c-0.051 0.144-0.105 0.333-0.149 0.525l-0.007 0.038c-0.040 0.174-0.063 0.374-0.063 0.579 0 0.005 0 0.010 0 0.015v-0.001c0.009 0.832 0.302 1.593 0.787 2.194l-0.005-0.007c0.587 0.717 1.298 1.309 2.104 1.747l0.037 0.018c0.914 0.511 1.972 0.925 3.088 1.187l0.083 0.017c1.147 0.278 2.463 0.438 3.816 0.438 0.032 0 0.063-0 0.095-0l-0.005 0c0.027 0 0.058 0 0.089 0 1.354 0 2.67-0.16 3.932-0.461l-0.115 0.023c1.2-0.279 2.258-0.692 3.235-1.235l-0.063 0.032c0.843-0.457 1.554-1.048 2.131-1.753l0.010-0.012c0.479-0.594 0.772-1.356 0.781-2.185l0-0.002c0-0.003 0-0.007 0-0.011 0-0.206-0.023-0.407-0.066-0.601l0.003 0.018c-0.052-0.231-0.105-0.419-0.168-0.603l0.012 0.040z"></path>
        <path d="M3.532 10.406c0.306 0.265 0.643 0.522 0.994 0.758l0.037 0.023c0.345 0.233 0.745 0.462 1.161 0.662l0.058 0.025c0.058 0.040 0.125 0.076 0.195 0.106l0.008 0.003c0.073 0.031 0.141 0.058 0.203 0.078 0.103 0.054 0.227 0.106 0.355 0.15l0.020 0.006q0.188 0.063 0.375 0.125c0.121 0.054 0.276 0.112 0.435 0.163l0.034 0.009q0.25 0.078 0.5 0.141 0.156 0.031 0.313 0.078c0.104 0.031 0.208 0.058 0.313 0.078q0.344 0.063 0.672 0.125c0.183 0.037 0.413 0.071 0.646 0.092l0.026 0.002c0.069 0.018 0.153 0.035 0.24 0.046l0.010 0.001c0.074 0.010 0.159 0.016 0.246 0.016 0.001 0 0.003 0 0.004 0h-0c0.252 0.039 0.554 0.067 0.861 0.078l0.014 0q0.437 0.016 0.906 0.016c0.286 0 0.561-0.005 0.83-0.014-0.358-0.941-0.571-2.030-0.584-3.166l-0-0.006c0.001-3.060 1.437-5.785 3.672-7.539l0.021-0.016-0.032-0.010c-1.148-0.278-2.465-0.438-3.82-0.438-0.030 0-0.061 0-0.091 0l0.005-0c-0.026-0-0.056-0-0.087-0-1.355 0-2.672 0.16-3.934 0.461l0.115-0.023c-1.2 0.279-2.258 0.693-3.235 1.235l0.063-0.032c-0.843 0.457-1.553 1.048-2.131 1.753l-0.010 0.013c-0.479 0.594-0.772 1.356-0.781 2.185l-0 0.002c0 0.001 0 0.003 0 0.004 0 0.543 0.139 1.053 0.383 1.496l-0.008-0.016c0.279 0.509 0.612 0.946 0.999 1.327l0.001 0.001z"></path>
        <path d="M21.999 2.4h-0.005c-4.194 0.001-7.593 3.401-7.593 7.595s3.401 7.595 7.595 7.595c0.001 0 0.002 0 0.003 0h0.005c4.194-0.001 7.593-3.401 7.593-7.595s-3.401-7.595-7.595-7.595c-0.001 0-0.002 0-0.003 0h0zM21.999 14.798l-4-4.8h2.4v-4.799h3.2v4.799h2.4z"></path>
        <path d="M5.079 17.156c0.911 0.5 1.967 0.918 3.078 1.199l0.094 0.020c1.147 0.278 2.463 0.438 3.816 0.438 0.032 0 0.063-0 0.095-0l-0.005 0c0.027 0 0.058 0 0.089 0 1.354 0 2.67-0.16 3.932-0.461l-0.115 0.023c0.305-0.079 0.572-0.181 0.857-0.272-1.236-0.786-2.254-1.805-3.014-3.005l-0.023-0.039c-0.571 0.050-1.127 0.129-1.726 0.129-0.017 0-0.036 0-0.056 0-1.017 0-2.015-0.080-2.989-0.233l0.108 0.014c-1.025-0.153-1.932-0.371-2.807-0.659l0.119 0.034c-0.875-0.282-1.63-0.621-2.339-1.031l0.058 0.031c-0.711-0.395-1.325-0.83-1.887-1.323l0.012 0.010c-0.054 0.152-0.107 0.346-0.15 0.544l-0.006 0.034c-0.039 0.174-0.062 0.373-0.063 0.578v0c0.002 0.833 0.296 1.596 0.786 2.194l-0.005-0.006c0.579 0.731 1.292 1.329 2.105 1.764l0.036 0.017z"></path>
        <path d="M5.079 22.766c0.914 0.511 1.972 0.925 3.088 1.187l0.083 0.017c1.147 0.278 2.463 0.438 3.816 0.438 0.032 0 0.063-0 0.095-0l-0.005 0c0.027 0 0.058 0 0.089 0 1.354 0 2.67-0.16 3.932-0.461l-0.115 0.023c1.2-0.279 2.258-0.693 3.235-1.235l-0.063 0.032c0.847-0.461 1.559-1.063 2.13-1.783l0.011-0.014c0.3-0.389 0.524-0.852 0.641-1.357l0.005-0.024-0.023 0.002c-0.911-0.013-1.785-0.154-2.611-0.403l0.067 0.017c-0.465 0.255-1.017 0.502-1.589 0.707l-0.083 0.026c-0.756 0.254-1.662 0.471-2.594 0.613l-0.094 0.012c-0.883 0.159-1.9 0.25-2.938 0.25s-2.054-0.091-3.042-0.265l0.105 0.015c-1.025-0.153-1.932-0.371-2.807-0.659l0.119 0.034c-0.875-0.282-1.63-0.621-2.339-1.031l0.058 0.031c-0.713-0.375-1.328-0.801-1.886-1.291l0.011 0.009c-0.051 0.144-0.105 0.333-0.149 0.525l-0.007 0.038c-0.040 0.174-0.063 0.374-0.063 0.579 0 0.005 0 0.010 0 0.015v-0.001c0.006 0.822 0.3 1.574 0.786 2.162l-0.005-0.006c0.581 0.734 1.293 1.336 2.105 1.779l0.036 0.018z"></path>
      </g>
      <g id="data_output">
        <path d="M21.938 23.25c-0.55 0.483-1.164 0.917-1.821 1.285l-0.054 0.028c-0.642 0.355-1.396 0.688-2.18 0.955l-0.101 0.030c-0.761 0.264-1.667 0.488-2.6 0.63l-0.088 0.011c-0.883 0.139-1.901 0.219-2.938 0.219s-2.055-0.080-3.048-0.233l0.111 0.014c-1.021-0.153-1.927-0.376-2.799-0.674l0.111 0.033c-0.885-0.296-1.639-0.629-2.356-1.022l0.075 0.037c-0.711-0.395-1.325-0.83-1.887-1.323l0.012 0.010c-0.051 0.144-0.105 0.333-0.149 0.525l-0.007 0.038c-0.040 0.174-0.063 0.374-0.063 0.579 0 0.005 0 0.010 0 0.015v-0.001c0.009 0.832 0.302 1.593 0.787 2.194l-0.005-0.007c0.587 0.717 1.298 1.309 2.104 1.747l0.037 0.018c0.914 0.511 1.972 0.925 3.088 1.187l0.083 0.017c1.147 0.278 2.463 0.438 3.816 0.438 0.032 0 0.063-0 0.095-0l-0.005 0c0.027 0 0.058 0 0.089 0 1.354 0 2.67-0.16 3.932-0.461l-0.115 0.023c1.2-0.279 2.258-0.692 3.235-1.235l-0.063 0.032c0.843-0.457 1.554-1.048 2.131-1.753l0.010-0.012c0.479-0.594 0.772-1.356 0.781-2.185l0-0.002c0-0.003 0-0.007 0-0.011 0-0.206-0.023-0.407-0.066-0.601l0.003 0.018c-0.052-0.231-0.105-0.419-0.168-0.603l0.012 0.040z"></path>
        <path d="M3.532 10.406c0.306 0.265 0.643 0.522 0.994 0.758l0.037 0.023c0.345 0.233 0.745 0.462 1.161 0.662l0.058 0.025c0.058 0.040 0.125 0.076 0.195 0.106l0.008 0.003c0.073 0.031 0.141 0.058 0.203 0.078 0.103 0.054 0.227 0.106 0.355 0.15l0.020 0.006q0.188 0.063 0.375 0.125c0.121 0.054 0.276 0.112 0.435 0.163l0.034 0.009q0.25 0.078 0.5 0.141 0.156 0.031 0.313 0.078c0.104 0.031 0.208 0.058 0.313 0.078q0.344 0.063 0.672 0.125c0.183 0.037 0.413 0.071 0.646 0.092l0.026 0.002c0.069 0.018 0.153 0.035 0.24 0.046l0.010 0.001c0.074 0.010 0.159 0.016 0.246 0.016 0.001 0 0.003 0 0.004 0h-0c0.252 0.039 0.554 0.067 0.861 0.078l0.014 0q0.437 0.016 0.906 0.016c0.286 0 0.561-0.005 0.83-0.014-0.358-0.941-0.571-2.030-0.584-3.166l-0-0.006c0.001-3.060 1.437-5.785 3.672-7.539l0.021-0.016-0.032-0.010c-1.148-0.278-2.465-0.438-3.82-0.438-0.030 0-0.061 0-0.091 0l0.005-0c-0.026-0-0.056-0-0.087-0-1.355 0-2.672 0.16-3.934 0.461l0.115-0.023c-1.2 0.279-2.258 0.693-3.235 1.235l0.063-0.032c-0.843 0.457-1.553 1.048-2.131 1.753l-0.010 0.013c-0.479 0.594-0.772 1.356-0.781 2.185l-0 0.002c0 0.001 0 0.003 0 0.004 0 0.543 0.139 1.053 0.383 1.496l-0.008-0.016c0.279 0.509 0.612 0.946 0.999 1.327l0.001 0.001z"></path>
        <path d="M21.998 17.59h0.005c4.182-0.017 7.565-3.411 7.565-7.595 0-4.186-3.386-7.581-7.569-7.595h-0.007c-4.194 0.001-7.593 3.401-7.593 7.595s3.401 7.595 7.595 7.595c0.001 0 0.002 0 0.003 0h-0zM21.998 5.192l4 4.8h-2.4v4.799h-3.2v-4.799h-2.4z"></path>
        <path d="M5.079 17.156c0.911 0.5 1.967 0.918 3.078 1.199l0.094 0.020c1.147 0.278 2.463 0.438 3.816 0.438 0.032 0 0.063-0 0.095-0l-0.005 0c0.027 0 0.058 0 0.089 0 1.354 0 2.67-0.16 3.932-0.461l-0.115 0.023c0.305-0.079 0.572-0.181 0.857-0.272-1.236-0.786-2.254-1.805-3.014-3.005l-0.023-0.039c-0.571 0.050-1.127 0.129-1.726 0.129-0.017 0-0.036 0-0.056 0-1.017 0-2.015-0.080-2.989-0.233l0.108 0.014c-1.025-0.153-1.932-0.371-2.807-0.659l0.119 0.034c-0.875-0.282-1.63-0.621-2.339-1.031l0.058 0.031c-0.711-0.395-1.325-0.83-1.887-1.323l0.012 0.010c-0.054 0.152-0.107 0.346-0.15 0.544l-0.006 0.034c-0.039 0.174-0.062 0.373-0.063 0.578v0c0.002 0.833 0.296 1.596 0.786 2.194l-0.005-0.006c0.579 0.731 1.292 1.329 2.105 1.764l0.036 0.017z"></path>
        <path d="M5.079 22.766c0.914 0.511 1.972 0.925 3.088 1.187l0.083 0.017c1.147 0.278 2.463 0.438 3.816 0.438 0.032 0 0.063-0 0.095-0l-0.005 0c0.027 0 0.058 0 0.089 0 1.354 0 2.67-0.16 3.932-0.461l-0.115 0.023c1.2-0.279 2.258-0.693 3.235-1.235l-0.063 0.032c0.847-0.461 1.559-1.063 2.13-1.783l0.011-0.014c0.3-0.389 0.524-0.852 0.641-1.357l0.005-0.024-0.023 0.002c-0.911-0.013-1.785-0.154-2.611-0.403l0.067 0.017c-0.465 0.255-1.017 0.502-1.589 0.707l-0.083 0.026c-0.756 0.254-1.662 0.471-2.594 0.613l-0.094 0.012c-0.883 0.159-1.9 0.25-2.938 0.25s-2.054-0.091-3.042-0.265l0.105 0.015c-1.025-0.153-1.932-0.371-2.807-0.659l0.119 0.034c-0.875-0.282-1.63-0.621-2.339-1.031l0.058 0.031c-0.713-0.375-1.328-0.801-1.886-1.291l0.011 0.009c-0.051 0.144-0.105 0.333-0.149 0.525l-0.007 0.038c-0.040 0.174-0.063 0.374-0.063 0.579 0 0.005 0 0.010 0 0.015v-0.001c0.006 0.822 0.3 1.574 0.786 2.162l-0.005-0.006c0.581 0.734 1.293 1.336 2.105 1.779l0.036 0.018z"></path>
      </g>
      <g id="date_time">
        <path d="M10 12h4v0.521c1.903-1.574 4.343-2.521 7-2.521 0.338 0 0.67 0.021 1 0.051v-4.051h-2v-2c0-1.105-0.895-2-2-2s-2 0.895-2 2v2h-8v-2c0-1.105-0.895-2-2-2s-2 0.895-2 2v2h-2v18h8.426c-0.183-0.646-0.313-1.312-0.376-2h-0.051v-4h0.426c0.198-0.698 0.463-1.366 0.788-2h-1.214v-4zM8 22h-4v-4h4v4zM8 16h-4v-4h4v4z"></path>
        <path d="M21 12c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zM21 28c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7c0 3.86-3.14 7-7 7z"></path>
        <path d="M20 20h-2v2h4v-6h-2z"></path>
      </g>
      <g id="db">
        <path d="M7.856 13.377c-0.838 0.338-1.355 0.678-1.176 1.355 0 1.32 5.176 2.482 11.389 2.482 3.873 0 7.373-0.982 9.391-1.643l-0.66 4.373c-1.838 0.982-5.873 1.963-10.391 1.963-2.857 0-5.355-0.32-7.373-0.82-1.018 0.5-1.695 0.82-1.695 1.34 0 1.355 3.713 2.355 9.391 2.355 3.535 0 7.711-1.16 9.551-1.838l-0.66 3.998c-1.695 0.84-5.213 1.875-9.391 1.875-4.516 0-8.551-1.5-9.873-2.518l-0.697-4.195v-0.197c0-0.463 0.84-0.98 2.020-1.301-1-0.34-1.68-0.662-2.16-1.037l-0.857-5.177v-0.178c0-0.518 0.518-0.982 1.5-1.322-0.822-0.178-1.303-0.516-1.822-0.855l-0.838-5.856v-0.18c0-1.518 5.533-2.82 12.568-2.82 4.195 0 7.711 0.465 10.051 1.16-2.195-0.518-5.016-0.695-8.051-0.695-7.016 0-12.551 1.355-12.551 2.855 0 1.518 5.676 2.855 12.551 2.855 4.355 0 8.211-0.516 10.426-1.338l-0.715 4.357c-1.965 0.998-6.355 1.82-11.371 1.82-3.375 0-6.375-0.322-8.551-0.822l-0.004 0.002z"></path>
      </g>
      <g id="db_alt">
        <path d="M16 15.2c-4.085 0-7.625-1.235-9.782-3.156-0.14 0.373-0.218 0.759-0.218 1.156 0 3.093 4.477 5.6 10 5.6s10-2.507 10-5.6c0-0.397-0.078-0.782-0.218-1.156-2.157 1.921-5.696 3.156-9.782 3.156z"></path>
        <path d="M24.613 10.4c0.859-0.827 1.387-1.775 1.387-2.8 0-3.093-4.477-5.6-10-5.6s-10 2.507-10 5.6c0 1.025 0.528 1.973 1.387 2.8v0c0 0 0 0 0.001 0.001 0.591 0.569 1.35 1.067 2.247 1.485 0.13 0.062 0.258 0.124 0.394 0.182 0.243 0.102 0.49 0.198 0.75 0.288 0.308 0.108 0.631 0.203 0.961 0.292 0.214 0.057 0.426 0.112 0.648 0.161 0.434 0.096 0.884 0.173 1.346 0.234 0.164 0.021 0.327 0.041 0.494 0.057 0.577 0.059 1.165 0.1 1.773 0.1s1.196-0.041 1.773-0.1c0.167-0.017 0.33-0.036 0.494-0.057 0.462-0.061 0.911-0.138 1.346-0.234 0.222-0.048 0.434-0.104 0.648-0.161 0.33-0.089 0.652-0.184 0.961-0.292 0.26-0.090 0.506-0.186 0.75-0.288 0.136-0.058 0.263-0.12 0.394-0.182 0.898-0.419 1.656-0.917 2.247-1.485 0-0 0.001-0.001 0.001-0.001v0z"></path>
        <path d="M16 20.8c-4.085 0-7.625-1.235-9.782-3.156-0.14 0.373-0.218 0.759-0.218 1.156 0 3.093 4.477 5.6 10 5.6s10-2.507 10-5.6c0-0.397-0.078-0.782-0.218-1.156-2.157 1.921-5.696 3.156-9.782 3.156z"></path>
        <path d="M16 26.4c-4.085 0-7.625-1.235-9.782-3.156-0.14 0.373-0.218 0.759-0.218 1.156 0 3.093 4.477 5.6 10 5.6s10-2.507 10-5.6c0-0.397-0.078-0.782-0.218-1.156-2.157 1.921-5.696 3.156-9.782 3.156z"></path>
      </g>
      <g id="db_aws">
        <path d="M23.048 15.84c0.25 0.142 0.609 0.267 1.077 0.375s0.946 0.163 1.436 0.163c0.478 0 0.919-0.060 1.321-0.179s0.748-0.293 1.036-0.522c0.288-0.228 0.514-0.503 0.677-0.824s0.245-0.682 0.245-1.085c0-0.489-0.144-0.924-0.432-1.305s-0.77-0.68-1.444-0.897l-1.322-0.424c-0.5-0.163-0.843-0.334-1.028-0.514s-0.277-0.4-0.277-0.661c0-0.381 0.147-0.658 0.44-0.832s0.707-0.261 1.24-0.261c0.663 0 1.262 0.12 1.795 0.359 0.163 0.076 0.282 0.114 0.359 0.114 0.141 0 0.212-0.098 0.212-0.294v-0.44c0-0.131-0.027-0.234-0.081-0.31s-0.147-0.152-0.278-0.228c-0.098-0.054-0.229-0.108-0.392-0.163s-0.34-0.103-0.53-0.147c-0.19-0.043-0.391-0.079-0.604-0.106s-0.422-0.041-0.628-0.041c-0.413 0-0.805 0.055-1.175 0.163s-0.693 0.269-0.97 0.481c-0.278 0.212-0.501 0.468-0.669 0.767s-0.253 0.645-0.253 1.036c0 0.489 0.155 0.941 0.465 1.354s0.808 0.729 1.493 0.946l1.354 0.424c0.457 0.152 0.77 0.316 0.938 0.49s0.253 0.391 0.253 0.653c0 0.381-0.161 0.675-0.481 0.881s-0.775 0.31-1.362 0.31c-0.37 0-0.74-0.038-1.11-0.114s-0.712-0.185-1.028-0.326c-0.098-0.043-0.177-0.076-0.237-0.098s-0.117-0.033-0.171-0.033c-0.142 0-0.212 0.098-0.212 0.293v0.473c0 0.087 0.019 0.174 0.057 0.261s0.133 0.174 0.285 0.261z"></path>
        <path d="M7.28 11.313c-0.343-0.049-0.672-0.073-0.987-0.073-0.957 0-1.719 0.242-2.284 0.726s-0.849 1.123-0.849 1.917c0 0.751 0.228 1.349 0.685 1.795s1.077 0.669 1.86 0.669c1.098 0 2.012-0.43 2.741-1.289 0.098 0.207 0.193 0.389 0.285 0.546s0.204 0.302 0.335 0.432c0.087 0.087 0.179 0.13 0.277 0.13 0.076 0 0.157-0.027 0.245-0.082l0.588-0.391c0.12-0.087 0.179-0.179 0.179-0.277 0-0.065-0.022-0.136-0.065-0.212-0.13-0.239-0.231-0.462-0.302-0.669s-0.106-0.484-0.106-0.832v-3.034c0-1.022-0.258-1.787-0.775-2.292s-1.33-0.759-2.439-0.759c-0.511 0-0.995 0.060-1.452 0.179s-0.848 0.261-1.175 0.424c-0.13 0.065-0.218 0.13-0.261 0.196s-0.065 0.174-0.065 0.326v0.457c0 0.196 0.065 0.294 0.196 0.294 0.032 0 0.082-0.008 0.147-0.024s0.174-0.057 0.326-0.123c0.326-0.13 0.661-0.236 1.003-0.318s0.677-0.122 1.003-0.122c0.718 0 1.223 0.144 1.517 0.432s0.44 0.786 0.44 1.493v0.685c-0.37-0.087-0.726-0.155-1.069-0.204zM8.349 12.953c0 0.316-0.030 0.585-0.090 0.807s-0.166 0.422-0.318 0.596c-0.25 0.283-0.544 0.481-0.881 0.595s-0.658 0.171-0.962 0.171c-0.424 0-0.75-0.112-0.979-0.335s-0.343-0.552-0.343-0.987c0-0.468 0.152-0.826 0.457-1.077s0.766-0.375 1.386-0.375c0.283 0 0.574 0.019 0.873 0.057s0.584 0.090 0.857 0.155v0.392z"></path>
        <path d="M13.031 15.677c0.054 0.185 0.12 0.307 0.196 0.367s0.196 0.090 0.359 0.090h0.799c0.174 0 0.299-0.032 0.375-0.098s0.136-0.19 0.18-0.375l1.435-6.004 1.452 6.004c0.043 0.185 0.103 0.31 0.179 0.375s0.201 0.098 0.375 0.098h0.799c0.163 0 0.283-0.030 0.359-0.090s0.141-0.182 0.196-0.367l2.251-7.211c0.033-0.098 0.054-0.174 0.065-0.228s0.016-0.103 0.016-0.147c0-0.152-0.076-0.228-0.228-0.228h-0.865c-0.174 0-0.296 0.030-0.367 0.090s-0.133 0.182-0.187 0.367l-1.615 6.248-1.468-6.248c-0.044-0.185-0.104-0.307-0.179-0.367s-0.202-0.090-0.375-0.090h-0.751c-0.174 0-0.299 0.030-0.375 0.090s-0.136 0.182-0.179 0.367l-1.452 6.167-1.566-6.167c-0.054-0.185-0.117-0.307-0.188-0.367s-0.193-0.090-0.367-0.090h-0.913c-0.153 0-0.229 0.076-0.229 0.228 0 0.065 0.027 0.191 0.082 0.375l2.186 7.211z"></path>
        <path d="M26.877 20.195c-3.441 1.46-7.181 2.165-10.583 2.165-5.043 0-9.926-1.384-13.874-3.681-0.346-0.201-0.602 0.153-0.314 0.413 3.659 3.304 8.495 5.29 13.866 5.29 3.832 0 8.282-1.205 11.351-3.47 0.508-0.375 0.073-0.937-0.446-0.717z"></path>
        <path d="M29.911 18.454c-0.335-0.414-3.213-0.769-4.971 0.464-0.27 0.19-0.224 0.452 0.076 0.416 0.99-0.119 3.192-0.383 3.585 0.119s-0.436 2.574-0.807 3.5c-0.112 0.28 0.129 0.392 0.382 0.181 1.646-1.377 2.072-4.264 1.735-4.681z"></path>
      </g>
      <g id="db_bigquery">
        <path d="M27.803 15.266l-5.266-9.121c-0.262-0.454-0.747-0.734-1.271-0.734h-10.532c-0.524 0-1.009 0.28-1.271 0.734l-5.266 9.121c-0.262 0.454-0.262 1.014 0 1.468l5.266 9.121c0.262 0.454 0.747 0.734 1.271 0.734h10.532c0.524 0 1.009-0.28 1.271-0.734l5.266-9.121c0.262-0.454 0.262-1.014 0-1.468zM20.69 20.887c-0.107 0.107-0.249 0.162-0.39 0.162s-0.281-0.055-0.389-0.162l-1.403-1.402c-0.75 0.584-1.682 0.946-2.707 0.946-2.447 0-4.431-1.984-4.431-4.431s1.984-4.431 4.431-4.431c2.447 0 4.431 1.984 4.431 4.431 0 1.025-0.362 1.957-0.947 2.708l1.403 1.402c0.216 0.215 0.216 0.563 0.001 0.777z"></path>
        <path d="M15.802 12.67c-1.836 0-3.33 1.494-3.33 3.33s1.494 3.33 3.33 3.33c1.836 0 3.33-1.494 3.33-3.33s-1.494-3.33-3.33-3.33zM14.573 18.258l-0.865-1.056v-1.498h0.865v2.553zM16.362 18.38h-1.055v-3.838h1.055v3.838zM17.845 17.386l-0.727 0.808v-1.774h0.727v0.965z"></path>
      </g>
      <g id="db_candi">
        <path d="M30 20.971c-0.13 0.255-0.247 0.274-0.479 0.073-1.372-1.187-2.744-2.375-4.117-3.562-0.377-0.326-0.755-0.65-1.13-0.978-0.357-0.313-0.359-0.678-0.005-0.988 1.747-1.531 3.496-3.060 5.244-4.59 0.011-0.010 0.023-0.020 0.035-0.030 0.218-0.178 0.33-0.155 0.453 0.095 0 3.327 0 6.654 0 9.981z"></path>
        <path d="M11.133 16.049c0-1.602-0.002-3.205 0.001-4.807 0.001-0.673 0.069-1.338 0.323-1.97 0.487-1.212 1.394-1.896 2.674-2.082 0.39-0.057 0.789-0.054 1.185-0.060 0.585-0.009 1.17-0.005 1.755-0.002 0.697 0.005 1.364 0.135 1.967 0.503 0.916 0.559 1.438 1.396 1.688 2.421 0.103 0.422 0.134 0.851 0.129 1.284-0.004 0.366 0.004 0.733-0.002 1.099-0.009 0.553-0.262 0.819-0.812 0.83-0.559 0.012-1.119 0.013-1.678-0-0.538-0.013-0.815-0.315-0.821-0.851-0.004-0.335 0.007-0.673-0.037-1.003-0.061-0.459-0.4-0.764-0.858-0.782-0.441-0.017-0.885-0.012-1.325 0.019-0.503 0.035-0.79 0.363-0.791 0.866-0.003 1.394 0.001 2.788-0.002 4.181-0.004 1.556-0.014 3.112-0.019 4.668-0 0.126 0.011 0.255 0.040 0.377 0.092 0.379 0.35 0.601 0.817 0.625 0.47 0.025 0.946 0.016 1.416-0.022 0.446-0.036 0.722-0.379 0.731-0.83 0.010-0.523 0.016-1.047 0.029-1.57 0.011-0.418 0.268-0.697 0.684-0.706 0.644-0.014 1.289-0.015 1.934-0.001 0.419 0.009 0.683 0.267 0.689 0.681 0.012 0.868 0.037 1.739-0.012 2.605-0.050 0.878-0.322 1.694-0.95 2.352-0.504 0.529-1.132 0.818-1.843 0.927-0.305 0.047-0.616 0.062-0.925 0.064-0.87 0.008-1.74 0.023-2.609-0.005-0.857-0.028-1.652-0.266-2.299-0.87-0.525-0.491-0.818-1.111-0.947-1.804-0.074-0.397-0.119-0.805-0.122-1.208-0.013-1.643-0.006-3.286-0.006-4.929z"></path>
        <path d="M2 15.979c0-1.607-0-3.214 0-4.822 0-0.138-0.010-0.293 0.14-0.359 0.143-0.064 0.249 0.044 0.349 0.13 1.746 1.51 3.491 3.020 5.237 4.531 0.348 0.301 0.35 0.676 0.006 0.978-1.748 1.531-3.497 3.061-5.246 4.591-0.099 0.086-0.203 0.197-0.348 0.132-0.15-0.068-0.138-0.222-0.138-0.36-0-1.607-0-3.214-0-4.822z"></path>
      </g>
      <g id="db_carriots">
        <path d="M15.765 30c-0.639-0.185-0.696-0.711-0.72-1.247-0.086-1.915-0.166-3.831-0.249-5.747-0.080-1.843-0.16-3.686-0.242-5.529-0.047-1.047-0.099-2.093-0.146-3.14-0.042-0.942 0.681-1.692 1.621-1.683 0.918 0.009 1.614 0.783 1.567 1.72-0.064 1.258-0.114 2.517-0.171 3.775-0.067 1.492-0.134 2.985-0.201 4.477-0.067 1.498-0.134 2.996-0.201 4.493-0.028 0.629-0.055 1.258-0.086 1.887-0.005 0.1-0.024 0.199-0.045 0.297-0.079 0.382-0.314 0.611-0.692 0.697-0.145 0-0.29 0-0.435 0z"></path>
        <path d="M16.102 2c2.514 0.025 4.714 0.888 6.628 2.503 0.204 0.172 0.4 0.356 0.591 0.544 0.263 0.258 0.268 0.636 0.022 0.88-0.238 0.236-0.616 0.232-0.871-0.017-1.055-1.026-2.26-1.819-3.669-2.257-2.935-0.913-5.637-0.396-8.103 1.405-0.403 0.295-0.764 0.65-1.134 0.988-0.183 0.167-0.38 0.255-0.623 0.196-0.433-0.105-0.617-0.628-0.317-0.966 0.266-0.298 0.568-0.568 0.875-0.825 1.318-1.101 2.809-1.859 4.493-2.225 0.694-0.151 1.396-0.232 2.109-0.226z"></path>
        <path d="M16.124 4.921c2.049 0.006 3.811 0.743 5.322 2.109 0.283 0.256 0.31 0.636 0.075 0.892s-0.615 0.256-0.896 0.001c-1.012-0.917-2.181-1.523-3.537-1.725-1.747-0.26-3.342 0.15-4.78 1.163-0.331 0.233-0.634 0.51-0.938 0.779-0.273 0.241-0.625 0.252-0.869 0.007-0.241-0.242-0.242-0.619 0.013-0.868 1.353-1.318 2.95-2.133 4.842-2.331 0.089-0.009 0.177-0.023 0.266-0.025 0.167-0.004 0.335-0.001 0.502-0.001z"></path>
        <path d="M16.081 9.029c-1.027 0.012-1.976 0.401-2.793 1.121-0.16 0.141-0.322 0.263-0.547 0.243-0.255-0.023-0.444-0.152-0.529-0.397-0.086-0.248-0.038-0.475 0.159-0.657 0.751-0.697 1.619-1.187 2.624-1.398 1.698-0.356 3.225 0.037 4.584 1.105 0.288 0.226 0.335 0.608 0.119 0.873-0.222 0.271-0.589 0.304-0.88 0.073-0.782-0.619-1.665-0.955-2.737-0.962z"></path>
      </g>
      <g id="db_crm">
        <path d="M6.092 11.181c0.12 0.057 0.237 0.114 0.362 0.167 0.227 0.095 0.457 0.185 0.699 0.268 0.286 0.1 0.585 0.188 0.891 0.271 0.198 0.053 0.395 0.104 0.601 0.149 0.404 0.089 0.821 0.161 1.251 0.218 0.152 0.020 0.303 0.038 0.458 0.053 0.536 0.055 1.081 0.093 1.646 0.093s1.111-0.038 1.646-0.093c0.155-0.015 0.306-0.033 0.458-0.053 0.429-0.057 0.847-0.128 1.251-0.218 0.206-0.045 0.402-0.096 0.601-0.149 0.306-0.082 0.605-0.171 0.891-0.271 0.242-0.084 0.472-0.173 0.699-0.268 0.125-0.053 0.242-0.111 0.362-0.167 2.047-0.954 3.378-2.373 3.378-3.981 0-2.872-4.157-5.2-9.286-5.2s-9.286 2.328-9.286 5.2c0 1.608 1.331 3.027 3.378 3.981z"></path>
        <path d="M28 29h2c0-2.85-3.842-5-8.938-5s-8.938 2.15-8.938 5h2c0-1.416 2.967-3 6.938-3s6.938 1.584 6.938 3z"></path>
        <path d="M22.471 23.063c1.076-0.402 1.936-1.258 2.488-2.479 0.168-0.371 0.305-0.756 0.439-1.139l0.188-0.52c0.201-0.531 0.414-1.162 0.414-1.925 0-2.757-2.242-5-5-5s-5 2.243-5 5c0 0.768 0.213 1.396 0.414 1.929l0.195 0.542c0.133 0.375 0.266 0.75 0.432 1.115 0.551 1.219 1.412 2.074 2.482 2.475 0.152 0.057 0.313 0.104 0.508 0.15l0.205 0.049c0.246 0.047 0.502 0.074 0.764 0.074 0.26 0 0.516-0.027 0.758-0.072l0.242-0.059c0.16-0.039 0.318-0.084 0.471-0.141zM21.395 21.295c-0.128 0.024-0.228 0.044-0.359 0.044-0.134 0-0.302-0.021-0.569-0.082-0.080-0.020-0.158-0.039-0.238-0.070-0.576-0.213-1.035-0.693-1.365-1.424-0.141-0.313-0.254-0.637-0.367-0.959l-0.213-0.585c-0.184-0.488-0.283-0.826-0.283-1.22 0-1.654 1.346-3 3-3s3 1.346 3 3c0 0.389-0.1 0.729-0.285 1.22l-0.203 0.559c-0.117 0.331-0.232 0.665-0.375 0.983-0.332 0.732-0.791 1.213-1.365 1.426-0.078 0.029-0.158 0.051-0.377 0.107z"></path>
        <path d="M14 17c0-1.054 0.251-2.045 0.671-2.942-0.853 0.129-1.746 0.199-2.671 0.199-3.794 0-7.080-1.147-9.083-2.93-0.13 0.347-0.203 0.705-0.203 1.073 0 2.872 4.157 5.2 9.286 5.2 0.708 0 1.391-0.053 2.053-0.137-0.013-0.159-0.053-0.293-0.053-0.463z"></path>
        <path d="M15.22 21.414c-0.19-0.418-0.344-0.846-0.492-1.265l-0.185-0.513c-0.041-0.109-0.071-0.238-0.11-0.351-0.782 0.107-1.593 0.172-2.433 0.172-3.794 0-7.080-1.147-9.083-2.93-0.13 0.347-0.203 0.705-0.203 1.073 0 2.872 4.157 5.2 9.286 5.2 1.336 0 2.598-0.164 3.746-0.449-0.188-0.298-0.373-0.6-0.526-0.937z"></path>
        <path d="M12.372 24.643c-0.125 0.003-0.246 0.014-0.372 0.014-3.794 0-7.080-1.147-9.083-2.93-0.13 0.347-0.203 0.705-0.203 1.073 0 2.542 3.262 4.651 7.568 5.103 0.272-1.247 0.999-2.348 2.090-3.26z"></path>
      </g>
      <g id="db_dynamo">
        <path d="M29.070 19.492v-7.199l0.002-0.5-0.002-0.001v-2.001h-0.001l0.001-1.673-3.295-3.614-5.91-3.026h-7.994l-5.621 2.806-3.586 3.835 0.003 3.672-0.005 0.002 0.006 1.172 0 0.344 0.001-0.001 0.012 2.583-0.012 2.583-0.001-0.001-0 0.345-0.006 1.172 0.005 0.002-0.003 3.671 3.295 3.614 5.912 3.026h7.994l5.619-2.806 3.586-3.835-0.001-1.673h0.001v-2l0.002-0.001-0.002-0.5zM20.629 10.775l3.408 0.804v2.43l-3.408-0.147v-3.086zM18.629 13.818l-5.521 0.001v-3.307h5.521v3.307zM11.107 13.851l-3.41 0.111v-2.382l3.41-0.804v3.076zM20.629 17.934l3.408-0.111v2.382l-3.408 0.804v-3.075zM11.107 17.924v3.086l-3.41-0.804v-2.43l3.41 0.147zM13.107 17.967l5.521-0.001v3.308h-5.521v-3.307zM27.063 14.14l-1.025-0.044v-1.646l1.031 0.546-0.006 1.145zM4.672 17.645l1.025 0.044v1.647l-1.031-0.546 0.006-1.145zM26.037 19.337v-1.615l1.025-0.075 0.006 1.145-1.031 0.546zM24.037 7.934l-3.408-1.128v-2.71l3.408 1.701v2.137zM18.629 6.568l-5.521-0.034v-3.056h5.521v3.090zM11.107 6.842l-3.41 1.070v-2.115l3.41-1.702v2.747zM5.697 12.449v1.615l-1.025 0.075-0.006-1.144 1.031-0.546zM7.697 23.851l3.41 1.129v2.71l-3.41-1.702v-2.137zM13.107 25.217l5.521 0.034v3.056h-5.521v-3.090zM20.629 24.943l3.408-1.069v2.114l-3.408 1.701v-2.746zM27.070 9.475l-1.033-0.722v-0.993l1.033 1.133v0.582zM4.664 8.893l1.033-1.133v1.026l-1.033 0.689v-0.582zM4.664 22.311l1.033 0.721v0.994l-1.033-1.133v-0.582zM27.070 22.893l-1.033 1.133v-1.025l1.033-0.69v0.582z"></path>
      </g>
      <g id="db_ibm">
        <path d="M23.75 21.535c-0.025-0.052-0.054-0.101-0.074-0.155-0.22-0.59-0.445-1.178-0.655-1.771-0.499-1.404-0.99-2.81-1.485-4.214-0.010-0.028-0.023-0.055-0.042-0.101-0.012 0.037-0.020 0.054-0.022 0.073-0.003 0.025-0.003 0.051-0.003 0.077-0.003 0.89-0.009 1.779-0.008 2.668 0.001 1.009 0.007 2.017 0.012 3.026 0.001 0.119 0.005 0.238 0.009 0.357 0.002 0.044-0.013 0.067-0.060 0.062-0.014-0.001-0.028-0-0.042-0-1.252 0-2.503 0-3.755 0-0.096 0-0.096-0-0.096-0.096 0-0.691 0.001-1.382-0.002-2.073-0-0.072 0.020-0.090 0.091-0.090 0.467 0.003 0.934 0 1.401 0.003 0.070 0 0.093-0.020 0.093-0.091-0.002-2.139-0.001-4.278-0.001-6.417 0-0.091-0.001-0.091-0.095-0.091-0.467-0-0.934-0.001-1.401 0.001-0.068 0-0.087-0.019-0.087-0.087 0.002-0.696 0.002-1.392 0-2.087-0-0.068 0.019-0.087 0.087-0.087 1.438 0.002 2.877 0.002 4.315-0 0.063-0 0.089 0.022 0.109 0.079 0.312 0.901 0.625 1.801 0.941 2.701 0.24 0.681 0.486 1.361 0.729 2.041 0.010 0.028 0.025 0.054 0.045 0.099 0.021-0.042 0.038-0.067 0.049-0.096 0.29-0.787 0.581-1.575 0.869-2.363 0.287-0.784 0.571-1.568 0.854-2.353 0.022-0.061 0.051-0.080 0.116-0.081 0.868-0.004 1.737-0.010 2.605-0.016 0.556-0.004 1.111-0.005 1.667-0.011 0.069-0.001 0.086 0.021 0.086 0.087-0.002 0.696-0.002 1.392 0 2.087 0 0.068-0.020 0.087-0.087 0.086-0.467-0.003-0.934-0-1.401-0.003-0.062-0-0.084 0.014-0.084 0.081 0.002 2.146 0.002 4.292 0 6.438-0 0.068 0.025 0.081 0.085 0.081 0.467-0.002 0.934 0 1.401-0.002 0.069-0 0.086 0.022 0.085 0.088-0.002 0.696-0.002 1.392 0 2.087 0 0.070-0.023 0.085-0.088 0.085-1.254-0.002-2.508-0.001-3.762-0.001-0.090 0-0.090-0-0.090-0.094-0.001-2.036-0.002-4.072-0.003-6.108-0-0.033-0.004-0.066-0.006-0.1-0.008-0.001-0.016-0.002-0.024-0.004-0.366 1.049-0.73 2.1-1.1 3.148-0.371 1.050-0.727 2.105-1.146 3.137-0.011 0-0.021 0-0.032 0z"></path>
        <path d="M15.225 15.954c0.034 0.026 0.056 0.045 0.081 0.061 0.366 0.239 0.657 0.558 0.937 0.888 0.233 0.274 0.432 0.568 0.554 0.91 0.085 0.238 0.137 0.483 0.148 0.737 0.036 0.879-0.287 1.613-0.913 2.217-0.319 0.308-0.688 0.547-1.12 0.665-0.176 0.048-0.362 0.072-0.544 0.080-0.475 0.020-0.951 0.033-1.427 0.036-1.102 0.007-2.204 0.008-3.306 0.008-0.275 0-0.551-0.006-0.826-0.014-0.172-0.005-0.344-0.018-0.517-0.027-0.054-0.003-0.083-0.025-0.083-0.087-0.002-0.355-0.010-0.709-0.010-1.064 0-0.32 0.010-0.639 0.012-0.959 0-0.062 0.020-0.079 0.080-0.080 0.46-0.007 0.919-0.017 1.379-0.026 0.097-0.002 0.097-0.002 0.097-0.099 0-2.134 0-4.268 0-6.402 0-0.095-0-0.094-0.091-0.096-0.462-0.009-0.924-0.019-1.386-0.027-0.051-0.001-0.069-0.017-0.069-0.069 0.007-0.658 0.009-1.317 0.022-1.975 0.004-0.191-0.020-0.159 0.158-0.16 1.036-0.007 2.073-0.012 3.109-0.018 0.49-0.003 0.98-0.008 1.47-0.007 0.289 0 0.579 0.001 0.868 0.015 0.334 0.017 0.672 0.027 0.993 0.137 0.581 0.199 1.109 0.48 1.492 0.981 0.294 0.384 0.48 0.813 0.552 1.292 0.087 0.585 0.007 1.147-0.246 1.683-0.098 0.207-0.237 0.384-0.386 0.555-0.272 0.313-0.59 0.57-0.943 0.786-0.026 0.016-0.050 0.034-0.086 0.059zM13.284 12.702c-0.357 0-0.714 0.001-1.071-0.001-0.062-0.001-0.079 0.018-0.078 0.079 0.002 0.66 0.002 1.321 0 1.981-0 0.064 0.018 0.084 0.082 0.084 0.712-0.002 1.424-0.002 2.135 0 0.066 0 0.082-0.022 0.082-0.085-0.002-0.66-0.002-1.321 0-1.981 0-0.062-0.017-0.079-0.079-0.078-0.357 0.003-0.714 0.001-1.071 0.001zM13.284 17.157c-0.357 0-0.714 0.001-1.071-0.001-0.062-0-0.078 0.018-0.078 0.079 0.002 0.66 0.002 1.321-0 1.981-0 0.064 0.018 0.084 0.082 0.084 0.712-0.002 1.424-0.002 2.135 0 0.066 0 0.082-0.022 0.081-0.085-0.002-0.66-0.002-1.321 0-1.981 0-0.062-0.017-0.079-0.079-0.078-0.357 0.003-0.714 0.001-1.071 0.001z"></path>
        <path d="M5.943 16.001c0 1.067-0 2.134 0 3.201 0 0.096 0 0.097 0.095 0.097 0.446 0 0.892 0.001 1.338-0.001 0.065-0 0.083 0.019 0.083 0.083-0.002 0.698-0.002 1.396 0 2.094 0 0.065-0.019 0.083-0.083 0.083-1.763-0.002-3.525-0.002-5.288 0-0.067 0-0.088-0.018-0.088-0.086 0.002-0.696 0.002-1.391 0-2.087-0-0.067 0.020-0.087 0.087-0.087 0.465 0.003 0.929 0.001 1.394 0.001 0.092-0 0.093-0 0.093-0.094 0-2.136 0-4.272 0-6.409 0-0.094-0-0.095-0.097-0.095-0.462-0-0.925-0.002-1.387 0.002-0.072 0.001-0.090-0.022-0.090-0.092 0.002-0.693 0.002-1.387-0-2.080-0-0.072 0.023-0.090 0.092-0.089 1.758 0.002 3.516 0.001 5.274 0.001 0.092 0 0.092 0 0.092 0.093 0 0.691 0 1.382 0 2.073 0 0.092-0 0.092-0.093 0.092-0.446 0-0.892 0.001-1.338-0.001-0.067-0-0.086 0.019-0.086 0.086 0.002 1.072 0.001 2.143 0.001 3.215z"></path>
      </g>
      <g id="db_iot">
        <path d="M18 18.012c0 1.235-0.895 2.235-2 2.235s-2-1.001-2-2.235c0-1.235 0.895-2.235 2-2.235s2 1.001 2 2.235z"></path>
        <path d="M16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14c7.732 0 14-6.268 14-14s-6.268-14-14-14zM10 22h-2v-12h2v12zM16 22.012c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM24 12v10h-2v-10h-2v-2h6v2h-2z"></path>
      </g>
      <g id="db_maria">
        <path d="M22.963 21.926c0.306 0.489 1.501 0.768 2.194 0.599-0.354-0.333-0.755-1.703-0.798-2.394-0.419 0.444-1.238 1.089-1.396 1.795z"></path>
        <path d="M28.767 7.375c-0.362 0.204-0.694 0.247-1.069 0.259-0.326 0.010-0.684-0.005-1.121 0.040-3.616 0.371-4.075 4.357-6.393 6.616-0.171 0.166-0.352 0.32-0.544 0.461-0.812 0.605-1.808 1.037-2.723 1.387-1.482 0.566-2.891 0.607-4.282 1.095-1.021 0.359-2.058 0.879-2.897 1.453-0.202 0.138-0.399 0.284-0.589 0.439-0.492 0.402-0.815 0.849-1.127 1.309-0.322 0.473-0.633 0.961-1.108 1.426-0.768 0.755-3.64 0.22-4.65 0.92-0.113 0.078-0.202 0.171-0.263 0.283 0.552 0.251 0.92 0.097 1.554 0.167 0.083 0.602-1.309 0.96-1.103 1.237v-0c1.621 0.232 2.607 0 3.909-0.564 1.108-0.48 2.178-1.471 3.485-1.891 1.921-0.616 4.028 0.001 6.081 0.124 0.5 0.030 0.997 0.030 1.487-0.023 0.765-0.47 0.749-2.229 1.494-2.39-0.022 2.467-1.034 3.946-2.091 5.377 2.23-0.394 3.564-1.683 4.465-3.406 0.274-0.522 0.507-1.084 0.713-1.673 0.319 0.245 0.138 0.99 0.299 1.394 1.536-0.856 2.415-2.808 2.998-4.782 0.674-2.285 0.95-4.599 1.384-5.276 0.424-0.66 1.084-1.067 1.687-1.489 0.685-0.48 1.295-0.981 1.401-1.896-0.722-0.067-0.889-0.234-0.996-0.598zM25.374 9.169c0.138-0.592 0.599-0.862 1.394-0.796 0.192 0.884-0.882 1.241-1.394 0.796zM27.418 9.409c-0.040 0.118-0.155 0.171-0.097-0.013 0.226-0.674 0.847-1.4 1.162-1.722 0.139-0.129 0.171-0.047 0.086 0.052-0.217 0.23-0.927 0.991-1.151 1.683zM27.68 9.458c0.129-0.699 0.642-1.248 0.908-1.611 0.119-0.147 0.163-0.070 0.093 0.039-0.183 0.258-0.778 0.855-0.903 1.571-0.022 0.123-0.13 0.191-0.098 0.001zM28.194 9.522c-0.012 0.124-0.113 0.201-0.097 0.009 0.070-0.707 0.379-1.15 0.613-1.534 0.106-0.156 0.157-0.083 0.095 0.031-0.161 0.272-0.547 0.77-0.611 1.494zM28.943 8.136c-0.136 0.286-0.397 0.654-0.397 1.381-0.001 0.125-0.095 0.21-0.096 0.018 0.007-0.711 0.195-1.018 0.395-1.421 0.093-0.165 0.149-0.097 0.098 0.023z"></path>
        <path d="M29.909 6.98c-0.057-0.058-0.141-0.080-0.223-0.085-0.101-0.006-0.202 0.012-0.295 0.051-0.043 0.018-0.080 0.043-0.12 0.066-0.005 0.003-0.010 0.006-0.015 0.009-0.117 0.064-0.188 0.144-0.175 0.285 0.003 0.034 0.011 0.069 0.030 0.098 0.013 0.020 0.031 0.035 0.049 0.050 0.163 0.135 0.378 0.23 0.592 0.231 0.048 0 0.1-0.005 0.139-0.033 0.030-0.022 0.049-0.055 0.063-0.089 0.050-0.122 0.057-0.289 0.033-0.418-0.011-0.060-0.035-0.119-0.077-0.163z"></path>
      </g>
      <g id="db_monet">
        <path d="M6.521 15.431l-5.143 2.643c0-1.428 2.785-9.908 13.568-11.747 8.82-1.518 13.193 3.695 14.479 5.641-0.947-1.303-3.748-3.945-10.641-3.659-9.123 0.375-12.264 7.123-12.264 7.123zM8.199 16.199l-0.018 0.037c0 0 0-0.019 0.018-0.037zM25.265 25.947c0 0 4.268-4.16 2.41-8.195-1.857-4.016-6.338-5.086-8.105-5.086-9.033 0-11.176 3.211-11.373 3.533 0.234-0.392 3.035-4.98 10.125-5.427 7.408-0.464 10.979 2.964 12.031 5.964 1.070 3.016-1.142 7.783-5.088 9.211zM29.423 11.968c0.305 0.41 0.43 0.697 0.43 0.697s-0.142-0.27-0.43-0.697z"></path>
      </g>
      <g id="db_mqtt">
        <path d="M8 4c-0.228 0-0.449 0.030-0.666 0.067-1.18 0.199-2.175 0.912-2.763 1.904-0.354 0.597-0.57 1.285-0.57 2.029v16c0 2.209 1.791 4 4 4h16c0.744 0 1.432-0.217 2.029-0.57 0.992-0.588 1.705-1.583 1.904-2.763 0.037-0.218 0.067-0.438 0.067-0.666v-16c0-2.209-1.791-4-4-4zM8 26c-1.103 0-2-0.897-2-2v-5.899c4.155 0.467 7.431 3.744 7.899 7.899h-5.899zM15.95 26c-0.476-5.276-4.673-9.474-9.95-9.95v-4c7.473 0.496 13.453 6.477 13.949 13.949h-4zM24 26h-2.051c-0.501-8.588-7.362-15.448-15.949-15.949v-2.051c0-0.915 0.63-1.656 1.47-1.893 9.634 1.133 17.29 8.789 18.423 18.423-0.237 0.84-0.978 1.47-1.893 1.47zM26 17.531c-2.309-5.111-6.42-9.222-11.531-11.531h7.513c1.476 1.196 2.822 2.542 4.018 4.018v7.513z"></path>
      </g>
      <g id="db_msaccess">
        <path d="M8.337 16.902c0.716 0.006 1.433 0.010 2.152 0.013-0.371-1.524-0.823-3.028-1.117-4.571-0.218 1.546-0.707 3.034-1.036 4.558z"></path>
        <path d="M28.051 5.536c-3.018-1.068-6.306-1.097-9.452-0.697v-2.839h-1.947c-4.988 0.889-9.985 1.739-14.977 2.611v22.784c4.965 0.873 9.937 1.699 14.896 2.605h2.028v-3.507c3.135 0.446 6.388 0.326 9.409-0.677 1.149-0.384 2.419-1.263 2.305-2.634 0.013-5.008 0.013-10.015 0-15.019 0.11-1.354-1.127-2.24-2.263-2.627zM11.551 21.183c-0.2-0.815-0.409-1.628-0.625-2.439-0.999-0.005-1.998-0.033-2.995-0.084-0.192 0.77-0.387 1.54-0.586 2.308-0.636-0.049-1.272-0.094-1.908-0.137 0.951-3.428 1.94-6.844 2.885-10.272 0.759-0.055 1.514-0.107 2.276-0.166 1.091 3.647 2.126 7.313 3.204 10.962-0.752-0.049-1.504-0.104-2.25-0.172zM18.6 16.117c2.221 0.283 4.468 0.277 6.688-0.016 1.429-0.212 2.914-0.521 4.066-1.449-0.065 1.397 0.101 2.806-0.091 4.193-0.57 0.697-1.494 0.944-2.325 1.182-2.725 0.647-5.571 0.664-8.338 0.312v-4.223zM29.256 24.062c-0.921 1.003-2.383 1.188-3.65 1.446-2.326 0.354-4.691 0.363-7.019 0.026 0.023-1.403 0.013-2.803 0.013-4.206 2.216 0.282 4.46 0.277 6.674-0.017 1.433-0.208 2.92-0.521 4.079-1.449-0.069 1.397 0.108 2.813-0.098 4.2zM29.256 13.646c-0.583 0.694-1.507 0.941-2.341 1.179-2.719 0.642-5.555 0.658-8.316 0.303v-4.219c2.214 0.281 4.455 0.276 6.668-0.013 1.433-0.212 2.927-0.521 4.086-1.452-0.071 1.4 0.111 2.816-0.098 4.203zM27.81 9.244c-2.953 0.996-6.147 1.091-9.211 0.628v-4.044c2.907-0.401 5.935-0.388 8.762 0.475 0.778 0.29 1.82 0.638 1.996 1.566-0.13 0.759-0.921 1.1-1.547 1.374z"></path>
      </g>
      <g id="db_msdynamics">
        <path d="M8 2l16.576 8.96-5.6 4.032-10.976-5.376z"></path>
        <path d="M8 11.028l5.488 3.628-4.76 14.448 16.632-17.136v8.4l-17.36 9.632z"></path>
      </g>
      <g id="db_mysql">
        <path d="M6.284 3.753c0.625 0.286 1.232 0.589 1.748 1.071 0.162 0.161 0.359 0.232 0.59 0.232 1.035 0 2.055 0.196 2.982 0.643 0.643 0.304 1.232 0.714 1.82 1.106 2.25 1.481 4.018 3.428 5.357 5.767 0.303 0.535 0.48 1.125 0.73 1.678l1.93 4.125c0.178 0.375 0.445 0.605 0.838 0.75 1.268 0.463 2.447 1.125 3.498 1.98 0.322 0.268 0.645 0.555 1 0.805 0.482 0.355 0.822 0.855 1.197 1.301 0.072 0.109 0.072 0.18-0.072 0.215-0.553 0.18-1.125 0.285-1.695 0.375-0.555 0.072-1.090 0.215-1.643 0.34l-0.375 0.070c0.162 0.215 0.287 0.412 0.447 0.537 0.32 0.268 0.678 0.5 1.035 0.713 0.91 0.537 1.695 1.215 2.355 2.055l0.162 0.16c0.285 0.285 0.57 0.57 0.66 1l-0.213-0.16c-1.27-1.125-3.27-1.322-4.875-1.607-2.43-0.447-4.855-0.838-7.125-1.875-0.785-0.357-1.588-0.838-2.355-1.428-1.643-1.232-3.125-2.875-3.875-4.57-0.195 0.643-0.16 1.355-0.391 2-0.232 0.605-0.84 0.838-1.41 0.553-0.285-0.143-0.52-0.375-0.715-0.625-0.57-0.768-0.857-1.643-1-2.572-0.215-1.266-0.125-2.516 0.25-3.748 0.072-0.232 0.107-0.463 0.16-0.678 0.035-0.16 0.072-0.322 0.145-0.445 0.105-0.18 0.070-0.323-0.055-0.447-0.73-0.733-1.090-1.643-1.445-2.589-0.215-0.607-0.394-1.232-0.609-1.839-0.105-0.286-0.23-0.554-0.41-0.786-0.32-0.481-0.695-0.946-1.053-1.428-0.303-0.411-0.588-0.84-0.695-1.339-0.162-0.839 0.357-1.75 1.373-1.768 0.625 0 1.18 0.179 1.733 0.429zM9.267 9.323c0.375-0.25 0.48-0.696 0.25-1.143-0.215-0.429-0.715-0.589-1.234-0.393 0.43 0.446 0.77 0.946 0.984 1.535z"></path>
      </g>
      <g id="db_oracle">
        <path d="M20.717 8.122h-9.433c-4.48 0-8.115 3.633-8.115 8.115s3.635 8.113 8.115 8.113l9.433 0.003c4.481 0 8.114-3.633 8.114-8.116s-3.633-8.115-8.114-8.115zM20.507 21.491h-9.014c-2.901 0-5.254-2.352-5.254-5.254s2.353-5.255 5.254-5.255l9.014 0.001c2.902 0 5.253 2.352 5.253 5.254s-2.351 5.254-5.253 5.254z"></path>
      </g>
      <g id="db_postgres">
        <path d="M29.561 19.699c-0.022-0.068-0.059-0.136-0.108-0.2-0.152-0.235-0.481-0.42-1.221-0.267-1.732 0.359-2.464 0.184-2.76 0.035 2.214-3.408 3.678-7.538 3.926-10.458 0.004-0.048 0.007-0.094 0.011-0.142 0.028-0.396 0.037-0.766 0.016-1.108-0.012-0.233-0.035-0.452-0.070-0.657-0.022-0.123-0.041-0.249-0.072-0.361-0.092-0.35-0.222-0.651-0.401-0.88-3.312-4.23-9.016-2.838-9.988-2.423-0.089-0.016-0.196-0.014-0.288-0.028-0.561-0.122-1.152-0.205-1.789-0.216-1.365-0.018-2.54 0.305-3.521 0.96-1.054-0.391-5.551-1.875-8.36 0.115-1.592 1.128-2.327 3.137-2.186 5.97 0.051 1.026 1.131 7.155 2.991 10.591 0.623 1.162 1.335 2.025 2.126 2.289 0.54 0.182 1.37 0.18 2.239-0.865 0.887-1.066 1.761-2.025 2.188-2.488 0.444 0.231 0.92 0.363 1.407 0.401-0.057 0.070-0.135 0.16-0.183 0.22-0.382 0.484-0.45 0.572-1.673 0.824-0.377 0.078-1.378 0.283-1.394 1.021-0.004 0.2 0.068 0.37 0.18 0.513 0.324 0.456 1.059 0.657 1.164 0.682 1.496 0.373 2.808 0.111 3.813-0.698-0.013 2.517 0.098 4.955 0.403 5.72 0.237 0.594 0.898 2.25 2.943 2.25 0.291 0 0.609-0.033 0.959-0.109 2.097-0.449 3.007-1.375 3.359-3.418 0.176-1.023 0.471-3.386 0.628-4.792 0.002-0.005 0.004-0.019 0.006-0.023 0.009 0 0.101-0.029 0.497 0.053l0.312 0.027c1.010 0.045 2.22-0.16 2.959-0.506 0.822-0.381 2.146-1.24 1.884-2.033zM22.792 22.973c-0.012 0.124-0.021 0.239-0.031 0.363-0.012 0.102-0.024 0.202-0.037 0.306l-0.166 0.501c-0.017 0.049-0.024 0.1-0.025 0.152-0.007 0.533-0.061 0.729-0.129 0.977-0.071 0.254-0.158 0.572-0.21 1.234-0.124 1.584-0.985 2.492-2.711 2.863-1.67 0.355-1.948-0.51-2.222-1.346l-0.089-0.264c-0.242-0.66-0.215-1.604-0.176-2.908 0.018-0.635-0.046-2.086-0.38-2.979 0.005-0.357 0.011-0.718 0.021-1.095 0.001-0.052-0.038-0.087-0.052-0.135-0.011-0.089 0.006-0.174-0.020-0.264-0.149-0.52-0.514-0.955-0.951-1.135-0.152-0.063-0.419-0.157-0.739-0.12 0.078-0.28 0.193-0.591 0.318-0.925l0.063-0.166c0.069-0.188 0.154-0.375 0.243-0.573 0.496-1.103 1.175-2.612 0.438-6.018-0.28-1.297-1.259-1.951-2.667-1.811-0.611 0.063-1.428 0.324-2.075 0.662 0.121-1.288 0.53-3.497 1.951-4.932 0.135-0.136 0.292-0.241 0.441-0.357 0.021-0.012 0.047-0.012 0.067-0.027 0.851-0.645 1.926-0.996 3.169-0.94 0.622 0.010 1.18 0.088 1.722 0.179 3.587 0.849 5.306 3.979 5.792 5.286-1.492-0.124-2.487 0.183-3.024 0.95-1.177 1.681 0.545 4.768 1.47 6.426 0.158 0.285 0.28 0.499 0.328 0.614 0.281 0.683 0.645 1.136 0.909 1.466 0.046 0.059 0.095 0.119 0.139 0.176-0.472 0.159-1.197 0.566-1.149 1.986-0.001 0.005-0.006 0.008-0.007 0.014-0.014 0.185-0.053 0.567-0.108 1.049-0.044 0.229-0.075 0.484-0.104 0.791zM12.813 18.671c-0.316-0.151-0.614-0.356-0.87-0.624-0.703-0.734-1.022-1.757-0.876-2.804 0.212-1.518 0.134-2.836 0.092-3.544-0.005-0.077-0.010-0.146-0.013-0.204 0.204-0.167 0.692-0.437 1.254-0.634-0.041 0.095-0.079 0.191-0.092 0.284-0.045 0.319 0.054 0.654 0.287 0.964 0.289 0.382 0.709 0.637 1.154 0.699l0.068 0.009 0.148 0.005c0.427 0 0.827-0.19 1.124-0.466 0.433 2.57-0.075 3.747-0.501 4.693-0.099 0.22-0.191 0.427-0.269 0.635l-0.062 0.165c-0.144 0.387-0.278 0.746-0.368 1.092-0.346-0.010-0.685-0.096-1.005-0.237-0.024-0.011-0.048-0.021-0.072-0.033zM3.772 10.030c-0.123-2.467 0.47-4.18 1.761-5.093 2.025-1.432 5.311-0.654 6.822-0.179-2.287 2.416-2.219 6.421-2.215 6.593 0 0 0.001 0.001 0.001 0.002 0.001 0.089 0.008 0.223 0.018 0.406 0.040 0.674 0.115 1.927-0.083 3.346-0.189 1.353 0.228 2.677 1.144 3.634 0.074 0.077 0.158 0.136 0.236 0.205-0.415 0.445-1.243 1.349-2.141 2.429-0.61 0.738-1.006 0.607-1.153 0.559-0.541-0.181-1.079-0.876-1.583-1.851-1.518-2.961-2.725-8.438-2.807-10.051zM13.742 11.11c0.067 0 0.138 0.005 0.211 0.015 0.344 0.048 0.607 0.195 0.588 0.329-0.017 0.123-0.268 0.37-0.576 0.37-0.026 0-0.052-0.002-0.079-0.005-0.344-0.048-0.607-0.404-0.588-0.537 0.014-0.105 0.199-0.17 0.443-0.17zM14.329 20.846c0.11-0.139 0.24-0.305 0.42-0.504 0.018-0.020 0.008-0.053 0.022-0.076 0.18-0.185 0.266-0.18 0.461-0.098 0.131 0.053 0.301 0.238 0.372 0.486 0.029 0.102 0.063 0.293-0.038 0.434-1.010 1.414-2.489 1.395-3.55 1.131-0.103-0.026-0.194-0.065-0.281-0.103 0.089-0.027 0.191-0.056 0.335-0.085 1.509-0.311 1.744-0.531 2.258-1.186zM24.556 21.225c-0.158-0.033-0.324-0.056-0.489-0.064-0.020-0.007-0.053-0.012-0.065-0.020-0.052-0.914 0.259-1 0.619-1.102 0.041-0.013 0.079-0.024 0.116-0.038 0.040 0.033 0.070 0.066 0.119 0.098 0.621 0.41 1.682 0.484 3.145 0.234-0.208 0.148-0.452 0.306-0.769 0.453-0.741 0.343-1.942 0.461-2.66 0.439l-0.017-0.001zM28.116 6.318c0.949 1.33-0.163 7.040-3.301 12.034-0.005-0.007-0.009-0.013-0.015-0.019s-0.014-0.019-0.020-0.027c0.797-1.377 0.671-2.732 0.526-3.935-0.059-0.493-0.115-0.96-0.101-1.395 0.015-0.471 0.076-0.866 0.135-1.247 0.079-0.509 0.16-1.035 0.126-1.671-0.001-0.023-0.022-0.036-0.026-0.058l0.043-0.066c-0.099-1.046-1.615-4.416-4.907-6.042 1.859-0.335 5.281-0.456 7.539 2.427zM23.74 11.008c0.019 0.134-0.244 0.49-0.588 0.537-0.027 0.004-0.053 0.005-0.079 0.005-0.308 0-0.559-0.246-0.576-0.37-0.018-0.134 0.245-0.281 0.588-0.328 0.073-0.010 0.145-0.015 0.211-0.015 0.245 0 0.429 0.065 0.444 0.17zM21.936 12.069c0.298 0.285 0.704 0.482 1.137 0.482h0.069l0.147-0.015c0.369-0.051 0.723-0.239 1.001-0.526-0.039 0.287-0.074 0.587-0.085 0.933-0.017 0.511 0.047 1.037 0.108 1.546 0.117 0.977 0.204 1.911-0.16 2.843-0.039-0.078-0.083-0.136-0.119-0.222-0.056-0.135-0.193-0.387-0.379-0.72-0.496-0.889-1.613-2.909-1.72-4.322z"></path>
      </g>
      <g id="db_progress">
        <path d="M16.448 2.103l-7.172 4.483 12.552 7.173v15.241l7.172-4.483v-15.241z"></path>
        <path d="M3 14.655l9.862 5.379v9.862l6.276-3.586v-10.759l-8.966-5.379z"></path>
        <path d="M10.172 28.103v-7.172l-6.276 3.586z"></path>
      </g>
      <g id="db_redshift">
        <path d="M26 9.3l-0-0.001c-0-0.164-0.019-0.337-0.051-0.515-0.015-0.084-0.038-0.163-0.060-0.244s-0.045-0.16-0.076-0.242c-0.040-0.108-0.088-0.213-0.141-0.315-0.028-0.053-0.056-0.105-0.088-0.159-0.073-0.121-0.154-0.238-0.245-0.351-0.033-0.042-0.066-0.083-0.102-0.124-0.112-0.128-0.236-0.25-0.37-0.367-0.036-0.032-0.069-0.063-0.107-0.095-0.401-0.328-0.886-0.612-1.436-0.855-0.020-0.009-0.042-0.017-0.062-0.026-1.939-0.84-4.645-1.189-7.26-1.189-4.834 0-10 1.178-10 4.482v12.999c-0 1.141 0.651 2.704 3.75 3.666 1.698 0.527 3.917 0.817 6.25 0.817 4.834 0 10-1.177 10-4.482v-13zM16 6.817c4.418 0 8 1.111 8 2.482s-3.582 2.482-8 2.482c-4.418 0-8-1.111-8-2.482s3.582-2.482 8-2.482zM16 24.782c-4.418 0-8-1.111-8-2.482l0-0v-1.412c0.474 0.271 1.041 0.525 1.75 0.745 1.698 0.527 3.917 0.817 6.25 0.817 2.967 0 6.054-0.447 8-1.553v1.404c0 1.371-3.582 2.482-8 2.482zM24 17.966c0 1.371-3.582 2.482-8 2.482s-7.999-1.111-8-2.482v-1.413c0.474 0.271 1.041 0.525 1.75 0.745 1.698 0.527 3.917 0.817 6.25 0.817 2.967 0 6.054-0.447 8-1.553v1.404zM24 13.633c0 1.371-3.582 2.482-8 2.482s-7.999-1.111-8-2.482v-1.405c1.946 1.107 5.033 1.553 8 1.553s6.054-0.447 8-1.553v1.404z"></path>
      </g>
      <g id="db_salesforce">
        <path d="M13.652 8.539c0.903-0.941 2.16-1.524 3.551-1.524 1.848 0 3.461 1.031 4.319 2.561 0.747-0.334 1.573-0.519 2.442-0.519 3.334 0 6.036 2.726 6.036 6.089s-2.703 6.089-6.036 6.089c-0.407 0-0.805-0.041-1.189-0.118-0.756 1.349-2.197 2.26-3.851 2.26-0.692 0-1.347-0.16-1.93-0.444-0.766 1.803-2.553 3.068-4.634 3.068-2.168 0-4.016-1.372-4.724-3.295-0.31 0.066-0.631 0.1-0.961 0.1-2.581 0-4.673-2.114-4.673-4.722 0-1.748 0.94-3.274 2.337-4.090-0.288-0.662-0.447-1.392-0.447-2.16 0-2.999 2.435-5.431 5.438-5.431 1.763 0 3.331 0.838 4.324 2.138z"></path>
      </g>
      <g id="db_spark">
        <path d="M26.766 8.377c-0.397-0.048-0.826 0.007-1.217 0.106-1.934 0.492-3.875 0.965-5.782 1.547-0.894 0.273-1.38 0.091-1.828-0.73-0.775-1.418-1.61-2.81-2.516-4.147-1.112-1.64-2.636-1.51-3.535 0.256-0.213 0.418-0.356 0.884-0.452 1.345-0.219 1.054-0.378 2.12-0.582 3.177-0.658 3.413 0.164 2.488-3.157 3.6-1.471 0.492-2.978 0.905-4.397 1.52-1.599 0.692-1.754 2.283-0.439 3.435 0.189 0.166 0.398 0.323 0.625 0.428 0.941 0.437 1.887 0.862 2.834 1.286l-0.003 0.006c0.031 0.013 0.063 0.023 0.095 0.036 0.295 0.132 0.588 0.27 0.883 0.401 0.126 0.056 0.289 0.098 0.418 0.091 0.134 0.050 0.268 0.099 0.401 0.151 0.261 0.104 0.562 0.219 0.717 0.469 0.167 0.27 0.168 0.64 0.194 0.946 0.061 0.724 0.111 1.449 0.259 2.161 0.17 0.811 0.339 1.623 0.508 2.434 0.181 0.866 0.359 1.816 0.922 2.523 0.483 0.606 1.219 0.912 1.961 0.595 0.443-0.19 0.803-0.54 1.093-0.917 0.983-1.282 1.899-2.622 2.755-3.993 0.495-0.793 0.991-0.946 1.867-0.621 0.040 0.015 0.087 0.027 0.127 0.042 0.015 0.006 0.029 0.026 0.044 0.031 0.739 0.25 1.486 0.476 2.235 0.696 0.005 0.002 0.012 0.004 0.017 0.005l-0-0c0.613 0.18 1.227 0.357 1.838 0.54 1.007 0.302 1.912 0.143 2.572-0.703 0.649-0.832 0.461-1.723 0.004-2.59-0.798-1.515-1.562-3.048-2.399-4.541-0.364-0.65-0.347-1.105 0.169-1.682 1.416-1.584 2.773-3.223 4.131-4.858 0.299-0.36 0.571-0.77 0.743-1.202 0.381-0.957-0.078-1.719-1.106-1.844zM23.143 12.465c-1.107 1.308-2.203 2.626-3.339 3.908-0.399 0.45-0.454 0.827-0.161 1.356 0.724 1.302 1.402 2.63 2.089 3.953 0.131 0.253 0.218 0.529 0.408 0.998-1.655-0.44-3.073-0.818-4.701-1.251 0.002 0.010 0.003 0.017 0.004 0.027-0.203-0.065-0.441-0.149-0.761-0.268-0.642-0.24-1.114-0.045-1.495 0.558-0.745 1.179-1.574 2.304-2.375 3.447-0.176 0.251-0.375 0.485-0.687 0.884-0.091-0.308-0.217-0.602-0.253-0.923-0.041-0.356-0.056-0.718-0.076-1.076-0.079-1.389-0.039-2.783-0.142-4.171-0.046-0.615-0.315-0.901-0.778-1.11 0.005-0.003 0.008-0.005 0.013-0.008-1.728-0.713-3.202-1.32-4.676-1.928 0.315-0.364 0.618-0.501 0.933-0.601 1.509-0.481 3.016-0.973 4.536-1.418 0.607-0.178 0.95-0.435 1.048-1.131 0.234-1.661 0.57-3.307 0.877-4.957 0.041-0.22 0.152-0.428 0.294-0.817 0.285 0.419 0.469 0.666 0.627 0.928 0.723 1.194 1.477 2.371 2.143 3.596 0.34 0.626 0.707 0.735 1.363 0.537 1.425-0.429 2.874-0.779 4.314-1.157 0.407-0.107 0.818-0.201 1.227-0.3-0.064 0.447-0.238 0.694-0.433 0.925z"></path>
      </g>
      <g id="db_sql_server">
        <path d="M28.405 13.368l0.386-0.059-0.059-0.093c-0.339-0.525-0.572-0.852-0.852-1.199-0.814-1.009-1.801-1.827-3.009-2.505-1.661-0.928-3.81-1.653-6.531-2.191-0.513-0.102-1.64-0.296-2.555-0.437l-0.086-0.153c-0.5-0.882-1.051-1.975-1.373-2.713-0.25-0.572-0.487-1.233-0.619-1.708-0.072-0.288-0.081-0.305-0.127-0.309h-0c-0.093-0.013-1.598 0.53-2.568 0.924-1.31 0.534-2.327 1.043-2.954 1.483-0.213 0.151-0.456 0.396-0.535 0.526-0.002-0.005-0.006-0.008-0.008-0.014 0 0-0.009 0.029-0.014 0.040-0.002 0.005-0.014 0.015-0.016 0.019-0.017 0.042-0.025 0.093-0.025 0.144l0.035 0.034c0.004 0.044-0.007 0.077 0.015 0.132 0.055 0.136 0.216 0.301 0.398 0.47 0 0 1.886 1.839 2.115 2.102 1.043 1.204 1.496 2.39 1.539 4.026 0.025 1.051-0.174 1.975-0.67 3.047-0.882 1.924-2.742 4.048-5.612 6.404l0.042-0.014c-0.019 0.015-0.045 0.037-0.064 0.052-0.343 0.271-0.852 0.78-1.11 1.102-0.386 0.483-0.691 0.996-0.822 1.39-0.233 0.712-0.119 1.433 0.331 2.098 0.576 0.848 1.725 1.712 3.064 2.301 0.682 0.301 1.831 0.687 2.696 0.903 1.437 0.364 4.217 0.759 5.747 0.818 0.309 0.013 0.725 0.013 0.742 0 0.034-0.021 0.271-0.475 0.547-1.038 0.941-1.92 1.619-3.721 1.988-5.26 0.22-0.933 0.394-2.174 0.509-3.645 0.030-0.411 0.042-1.789 0.017-2.255-0.038-0.763-0.106-1.382-0.212-1.988-0.009-0.050-0.014-0.092-0.016-0.125 3.408-1.013 7.168-1.93 9.666-2.312zM15.593 16.962c0.873 0.547 2.060 1.208 2.568 1.428 0.157 0.068 0.174 0.042-0.187 0.288-0.771 0.526-1.734 1.043-2.912 1.564-0.208 0.093-0.381 0.165-0.386 0.165-0.009 0 0.017-0.106 0.051-0.233 0.284-1.055 0.445-2.123 0.454-2.98 0.002-0.213 0.003-0.318 0.009-0.373 0.032-0.011 0.063-0.023 0.096-0.034 0.056 0.024 0.139 0.070 0.307 0.174zM14.609 18.22c-0.076 0.619-0.195 1.195-0.39 1.844-0.047 0.157-0.089 0.288-0.097 0.297-0.017 0.021-0.598-0.547-0.788-0.767-0.331-0.381-0.589-0.763-0.78-1.136-0.088-0.172-0.215-0.48-0.23-0.55 0.601-0.244 1.224-0.488 1.879-0.734 0.135-0.051 0.294-0.104 0.435-0.155 0.020 0.104 0.005 0.955-0.028 1.202zM8.523 19.831c0.035-0.169 0.058-0.223 0.095-0.26 0.748-0.373 1.546-0.739 2.382-1.101-0.036 0.098-0.215 0.473-0.4 0.836-0.411 0.801-0.86 1.589-1.462 2.547-0.102 0.165-0.199 0.318-0.212 0.335-0.021 0.030-0.030 0.021-0.098-0.11-0.144-0.284-0.263-0.649-0.326-0.983-0.064-0.331-0.051-0.907 0.021-1.263zM11.825 10.227c-0.013-0.119-0.025-0.22-0.021-0.225 0.013-0.013 0.602 0.127 0.92 0.216 0.483 0.136 1.509 0.479 1.509 0.504 0 0.004-0.114 0.102-0.25 0.22-0.555 0.462-1.089 0.949-1.729 1.568-0.191 0.182-0.352 0.331-0.36 0.331s-0.013-0.025-0.008-0.059c0.097-0.712 0.076-1.628-0.059-2.556zM14.516 7.726c0.157 0.615 0.229 1.301 0.204 1.941-0.009 0.178-0.017 0.343-0.025 0.364l-0.013 0.042-0.22-0.072c-0.454-0.144-1.191-0.36-1.822-0.538-0.36-0.098-0.653-0.187-0.653-0.195 0-0.025 0.525-0.551 0.75-0.75 0.428-0.377 1.589-1.276 1.627-1.263 0.025 0.008 0.068 0.152 0.153 0.47zM16.631 12.299c-0.797 0.398-1.479 0.775-2.191 1.208-0.203 0.123-0.373 0.225-0.377 0.225-0.017 0-0.013-0.017 0.102-0.225 0.381-0.695 0.687-1.526 0.86-2.335 0.017-0.064 0.034-0.106 0.046-0.106 0.059 0.013 0.61 0.271 1.026 0.479 0.381 0.191 0.954 0.496 0.983 0.521 0.004 0.004-0.199 0.11-0.449 0.233zM17.004 12.774c0.009 0.008-0.572 0.826-0.92 1.288-0.415 0.551-1.153 1.475-1.662 2.077-0.212 0.25-0.394 0.458-0.403 0.462-0.013 0.004-0.017-0.059-0.017-0.157 0-0.513-0.131-1.060-0.36-1.526-0.098-0.195-0.114-0.242-0.093-0.263 0.081-0.072 1.314-0.776 2.094-1.195 0.525-0.28 1.348-0.695 1.36-0.687zM13.27 12.172c0.398-0.343 1.238-1.017 1.25-1.004s-0.131 0.534-0.22 0.818c-0.174 0.538-0.466 1.212-0.75 1.721-0.068 0.119-0.17 0.292-0.225 0.39l-0.106 0.17-0.237-0.229c-0.275-0.267-0.5-0.432-0.788-0.581-0.114-0.059-0.204-0.11-0.204-0.119 0-0.034 0.725-0.691 1.28-1.166zM13.067 15.207h0.008c0.021-0.004 0.047 0.034 0.161 0.204 0.242 0.36 0.428 0.843 0.475 1.233l0.008 0.085-0.581 0.225c-1.038 0.403-1.996 0.801-2.645 1.098-0.182 0.085-0.5 0.237-0.708 0.339-0.208 0.106-0.377 0.186-0.377 0.182s0.131-0.102 0.292-0.22c1.267-0.92 2.365-1.928 3.187-2.937 0.089-0.106 0.17-0.204 0.178-0.208zM9.727 22.789c1.382-0.377 2.556-0.784 3.721-1.284 0.165-0.068 0.301-0.123 0.305-0.123 0.004 0.004-0.030 0.093-0.072 0.195-0.369 0.894-0.852 1.869-1.471 2.963-0.157 0.28-0.288 0.505-0.292 0.505s-0.131-0.076-0.284-0.17c-0.899-0.551-1.695-1.229-2.217-1.886l-0.076-0.093 0.386-0.106zM13.172 21.009c-0.801 0.305-1.674 0.61-2.674 0.932-0.239 0.077-0.478 0.155-0.716 0.233-0.038 0.013-0.025-0.008 0.085-0.182 0.496-0.776 1.25-2.297 1.674-3.374 0.072-0.186 0.144-0.373 0.157-0.415 0.008-0.027 0.030-0.034 0.042-0.050 0.048-0.020 0.093-0.040 0.141-0.060 0.011 0.017 0.035 0.070 0.058 0.14 0.136 0.369 0.441 0.911 0.704 1.259 0.288 0.381 0.665 0.788 0.979 1.055 0.102 0.085 0.195 0.165 0.208 0.178 0.025 0.025 0.034 0.021-0.657 0.284zM20.068 14.643c-1.941 0.538-3.442 1.017-5.192 1.661-0.195 0.072-0.36 0.131-0.373 0.131-0.025 0-0.047 0.021 0.39-0.381 1.119-1.030 2.111-2.166 2.848-3.272l0.148-0.229 0.208 0.136c0.474 0.309 1.034 0.721 1.462 1.081 0.241 0.199 0.708 0.619 0.801 0.72l0.051 0.055-0.343 0.098zM24.51 10.1c0.017-0.004 0.119 0.047 0.242 0.119 1.030 0.589 2.039 1.348 2.836 2.128 0.225 0.22 0.78 0.797 0.771 0.801 0 0-0.195 0.017-0.424 0.034-1.784 0.136-4.069 0.513-6.264 1.043-0.148 0.034-0.28 0.063-0.288 0.063s0.157-0.165 0.364-0.364c1.288-1.242 1.878-2.026 2.573-3.425 0.097-0.208 0.182-0.386 0.191-0.398zM23.735 10.714c-0.254 0.364-0.627 0.848-1.471 1.907-0.445 0.559-0.945 1.191-1.11 1.403-0.17 0.212-0.309 0.39-0.314 0.39s-0.059-0.076-0.119-0.169c-0.475-0.712-1.043-1.335-1.717-1.895-0.127-0.106-0.267-0.22-0.314-0.254s-0.085-0.068-0.085-0.072c0-0.013 0.72-0.322 1.267-0.542 0.958-0.39 2.263-0.856 3.242-1.157 0.513-0.161 1.060-0.318 1.068-0.309s-0.271 0.449-0.449 0.699zM19.483 8.239c0.038 0 0.81 0.212 1.212 0.331 0.996 0.297 2.14 0.716 2.886 1.055l0.309 0.14-0.216 0.051c-1.822 0.42-3.382 0.903-4.887 1.513-0.123 0.051-0.233 0.093-0.241 0.093s0.034-0.097 0.089-0.216c0.454-0.962 0.746-1.967 0.818-2.823 0.004-0.081 0.017-0.144 0.030-0.144zM19.068 8.748c-0.153 0.632-0.564 1.568-1.068 2.45-0.089 0.157-0.17 0.284-0.178 0.288s-0.123-0.059-0.254-0.136c-0.492-0.288-1.051-0.559-1.662-0.814-0.169-0.072-0.318-0.131-0.322-0.14-0.030-0.025 1.335-0.928 2.056-1.361 0.572-0.348 1.505-0.865 1.522-0.848 0.013 0.013-0.042 0.356-0.093 0.559zM18.699 8.053c0.026 0.008-0.064 0.059-0.348 0.186-1.119 0.505-1.95 0.958-2.776 1.509-0.216 0.144-0.398 0.263-0.403 0.263s-0.008-0.123-0.008-0.271c0-0.805-0.161-1.619-0.458-2.306-0.030-0.068-0.055-0.131-0.051-0.136 0.013-0.013 1.755 0.288 2.547 0.441 0.589 0.114 1.445 0.292 1.496 0.314zM14.334 5.264c0.017 0 0.038 0.038 0.089 0.153 0.144 0.318 0.594 1.174 0.704 1.339 0.007 0.012 0.014 0.020 0.017 0.027-0.916-0.144-1.696-0.269-2.412-0.388 0.006-0.008 0.039-0.031 0.089-0.058 0.445-0.246 0.894-0.559 1.293-0.894 0.098-0.081 0.187-0.157 0.203-0.17 0.004-0.008 0.013-0.013 0.017-0.008zM11.219 3.17c0.581-0.267 2.174-0.933 2.293-0.954h0.004c0.004 0.004 0.021 0.123 0.038 0.263 0.072 0.594 0.204 1.166 0.411 1.784 0.157 0.466 0.157 0.441-0.025 0.386-0.432-0.119-2.369-0.454-3.772-0.648-0.225-0.030-0.415-0.059-0.415-0.063-0.017-0.017 1.013-0.555 1.466-0.767zM9.591 4.17c0.898 0.305 3.157 0.738 4.404 0.839 0.14 0.013 0.259 0.026 0.263 0.026 0.004 0.004-0.114 0.068-0.267 0.14-0.602 0.301-1.263 0.67-1.721 0.954-0.124 0.078-0.229 0.135-0.26 0.145-0.135-0.023-0.271-0.046-0.406-0.069l-0.402-0.394c-0.746-0.725-1.331-1.284-1.555-1.496l-0.22-0.199 0.165 0.055zM9.201 4.285l0.055-0.038 0.598 0.746c0.326 0.411 0.657 0.814 0.729 0.903 0.067 0.083 0.114 0.141 0.118 0.154-0.423-0.074-0.876-0.155-1.225-0.23-0.254-0.055-0.742-0.17-1.123-0.301-0.039-0.015-0.084-0.032-0.127-0.048v-0.046c0.004-0.284 0.364-0.708 0.975-1.14zM11.003 8.616c-0.496-0.873-1.28-1.759-2.187-2.471-0.119-0.085-0.208-0.161-0.208-0.165 0.004-0.004 0.072 0.021 0.161 0.051 0.161 0.055 0.369 0.119 0.615 0.187 0.186 0.051 0.373 0.101 0.559 0.148 0.254 0.064 0.466 0.123 0.47 0.123 0.030 0.030 0.458 1.399 0.602 1.924 0.055 0.199 0.098 0.369 0.093 0.369-0.004 0.004-0.051-0.068-0.106-0.165zM11.532 8.824c-0.153-0.589-0.47-1.462-0.759-2.077-0.047-0.098-0.085-0.187-0.085-0.195 0 0.008 0 0.004 0.004 0.004 0.021 0 0.114 0.013 0.229 0.038 0.721 0.161 2.013 0.407 2.84 0.547 0.14 0.021 0.25 0.047 0.25 0.055s-0.051 0.038-0.114 0.072c-0.14 0.072-0.704 0.407-0.89 0.534-0.47 0.314-0.894 0.653-1.199 0.958-0.123 0.123-0.229 0.225-0.229 0.225s-0.025-0.072-0.047-0.161zM10.638 16.169c0.28-0.428 0.42-0.67 0.568-0.979 0.131-0.275 0.263-0.602 0.356-0.886 0.034-0.123 0.076-0.216 0.085-0.216 0.013 0 0.11 0.051 0.22 0.11 0.271 0.148 0.513 0.314 0.729 0.492 0.008 0.008-0.102 0.097-0.246 0.203-0.403 0.288-1.013 0.75-1.369 1.034-0.373 0.297-0.386 0.305-0.343 0.242zM9.184 18.047c0.28-0.301 0.492-0.555 0.733-0.869 0.161-0.208 0.191-0.237 0.424-0.403 0.623-0.449 2.060-1.424 2.077-1.407s-0.466 0.564-0.797 0.898c-0.818 0.835-1.627 1.488-2.632 2.124-0.127 0.080-0.242 0.152-0.254 0.161-0.030 0.017 0.009-0.025 0.449-0.504zM5.264 21.683c0.441-0.458 0.793-0.725 1.394-1.068 0.187-0.106 0.413-0.233 0.619-0.347 0.175-0.095 0.362-0.187 0.541-0.281 0.011 0.008 0.008 0.043-0.015 0.179-0.017 0.11-0.038 0.314-0.047 0.453-0.034 0.619 0.068 1.077 0.373 1.704 0.085 0.174 0.153 0.318 0.148 0.322-0.030 0.025-2.835 0.848-3.717 1.089-0.263 0.072-0.492 0.136-0.509 0.14-0.030 0.009-0.034 0.004-0.021-0.068 0.098-0.623 0.572-1.437 1.233-2.123zM5.743 26.82l-0.191-0.161c-0.225-0.187-0.615-0.585-0.788-0.805-0.364-0.453-0.61-0.933-0.708-1.369-0.047-0.203-0.047-0.305-0.004-0.318 0.064-0.017 1.195-0.284 2.255-0.53 0.589-0.136 1.272-0.297 1.517-0.356s0.445-0.106 0.449-0.106c0.008 0.009-0.53 0.784-1.284 1.839-0.263 0.369-0.568 0.801-0.682 0.962s-0.288 0.415-0.386 0.568l-0.178 0.276zM6.031 27.040l-0.076-0.055 0.123-0.178c0.398-0.576 0.899-1.208 1.988-2.522l0.75-0.903 0.136 0.153c0.61 0.682 1.233 1.187 1.988 1.627 0.136 0.076 0.237 0.144 0.229 0.148-0.030 0.021-2.619 0.941-3.819 1.356-0.674 0.237-1.229 0.428-1.233 0.428s-0.042-0.025-0.085-0.055zM9.659 28.715l-0.063-0.017c-0.153-0.042-1.225-0.42-1.509-0.534-0.352-0.14-0.716-0.309-0.988-0.453-0.339-0.182-0.763-0.453-0.729-0.462 0.008-0.004 0.589-0.161 1.288-0.352 1.856-0.504 2.886-0.797 3.56-1.009 0.123-0.038 0.229-0.068 0.233-0.063s-0.297 0.487-0.822 1.318c-0.225 0.352-0.475 0.75-0.564 0.89-0.085 0.136-0.212 0.348-0.284 0.466l-0.123 0.216zM9.994 28.791c0-0.008 0.102-0.14 0.225-0.284 0.61-0.729 1.216-1.543 1.721-2.314 0.14-0.212 0.259-0.386 0.259-0.39 0.004-0.004 0.191 0.064 0.42 0.148 0.551 0.208 0.988 0.339 1.572 0.487 0.72 0.182 1.763 0.36 2.378 0.411 0.093 0.008 0.144 0.017 0.127 0.030-0.030 0.017-0.653 0.225-1.11 0.369-0.729 0.229-2.954 0.886-4.768 1.407-0.335 0.098-0.623 0.178-0.64 0.182-0.042 0.009-0.182-0.030-0.182-0.047zM15.813 29.613c-0.055 0.136-0.076 0.17-0.106 0.165-0.072-0.004-1.068-0.144-1.674-0.233-1.055-0.161-2.827-0.47-3.272-0.572l-0.102-0.021 0.631-0.144c1.356-0.305 2.009-0.47 2.67-0.674 0.835-0.254 1.662-0.572 2.496-0.962 0.131-0.059 0.242-0.106 0.271-0.11h0.004c0.017 0.042-0.67 1.95-0.92 2.552zM17.551 24.447c-0.148 0.53-0.276 0.945-0.509 1.678-0.102 0.322-0.191 0.589-0.195 0.589s-0.030-0.004-0.055-0.013c-1.259-0.229-2.386-0.547-3.446-0.971-0.297-0.119-0.72-0.309-0.746-0.331-0.009-0.009 0.246-0.127 0.568-0.267 1.928-0.843 3.929-1.801 4.616-2.212 0.080-0.051 0.144-0.076 0.157-0.076 0.004 0.098-0.212 0.971-0.39 1.602zM17.864 22.645c-0.564 0.314-2.416 1.085-4.31 1.793-0.275 0.102-0.547 0.203-0.598 0.225s-0.097 0.034-0.097 0.030 0.076-0.153 0.174-0.335c0.53-0.992 1.064-2.2 1.335-3.039 0.034-0.080 0.055-0.152 0.059-0.157s0.106 0.051 0.229 0.123c0.907 0.526 2.17 1.013 3.246 1.263l0.098 0.021-0.136 0.076zM18.326 18.903c0 0.945-0.102 2.242-0.25 3.187-0.025 0.165-0.047 0.301-0.051 0.305 0 0-0.123-0.034-0.267-0.076-0.636-0.199-1.327-0.492-1.95-0.835-0.411-0.225-1.009-0.593-0.992-0.61 0.004-0.004 0.182-0.097 0.39-0.208 0.831-0.432 1.628-0.899 2.318-1.36 0.259-0.174 0.648-0.454 0.733-0.53l0.068-0.051v0.178zM18.301 17.945c0.009 0.174 0.004 0.288-0.004 0.288-0.034 0-0.716-0.403-1.204-0.708-0.422-0.265-1.218-0.794-1.352-0.9 0.741-0.252 1.539-0.504 2.359-0.755 0.060 0.232 0.17 1.34 0.201 2.074z"></path>
      </g>
      <g id="db_sun">
        <path d="M18.325 9.254l-0.128-0.981c1.536-0.683 4.053-0.683 4.053-0.683l0.683-3.755c-10.283 0.597-10.325 10.027-10.325 10.027 1.963-3.669 5.717-4.608 5.717-4.608z"></path>
        <path d="M13.675 22.746l0.128 0.981c-1.536 0.683-4.053 0.683-4.053 0.683l-0.683 3.755c10.283-0.597 10.325-10.027 10.325-10.027-1.963 3.669-5.717 4.608-5.717 4.608z"></path>
        <path d="M16.113 11.992c4.157-0.179 6.877 2.575 6.877 2.575l0.779-0.61c1.37 0.975 2.651 3.141 2.651 3.141l3.579-1.324c-5.749-8.546-13.887-3.782-13.887-3.782z"></path>
        <path d="M15.887 20.008c-4.157 0.179-6.877-2.575-6.877-2.575l-0.779 0.61c-1.37-0.974-2.651-3.141-2.651-3.141l-3.579 1.324c5.749 8.546 13.887 3.782 13.887 3.782z"></path>
        <path d="M19.527 14.094c2.234 3.511 1.21 7.243 1.21 7.243l0.918 0.37c-0.159 1.673-1.394 3.867-1.394 3.867l2.937 2.437c4.525-9.253-3.67-13.917-3.67-13.917z"></path>
        <path d="M12.473 17.906c-2.234-3.511-1.21-7.243-1.21-7.243l-0.918-0.37c0.159-1.673 1.394-3.867 1.394-3.867l-2.937-2.437c-4.525 9.253 3.67 13.917 3.67 13.917z"></path>
      </g>
      <g id="db_timescale">
        <path d="M21.704 25.642c3.47-1.861 5.941-5.362 6.351-9.474l1.945 2.229c-1.083 4.406-4.195 8.023-8.285 9.799 0.042-0.347 0.053-0.747 0.053-1.199-0.011-0.452-0.032-0.904-0.063-1.356zM12.083 26.441c1.22 0.41 2.534 0.641 3.89 0.641 1.419 0 2.786-0.242 4.059-0.694-0.263 1.062-0.683 1.987-1.209 2.713-0.915 0.179-1.872 0.284-2.849 0.284-0.915 0-1.809-0.084-2.681-0.252-0.526-0.715-0.946-1.64-1.209-2.692zM10.317 25.684c-3.533-1.861-6.025-5.415-6.424-9.579l-1.893 2.471c1.125 4.364 4.248 7.917 8.317 9.663-0.042-0.358-0.063-0.768-0.063-1.23 0-0.452 0.021-0.894 0.063-1.325zM25.721 7.704l1.377-1.966c-0.978-1.178-2.134-2.198-3.438-3.018l-2.324 1.335c1.735 0.852 3.238 2.103 4.385 3.649zM8.456 2.615c-1.367 0.831-2.576 1.882-3.596 3.112l1.556 1.745c1.125-1.44 2.576-2.618 4.237-3.428l-2.198-1.43z"></path>
        <path d="M7.983 14.854c0-3.638 2.429-6.708 5.751-7.686 0.147-0.421 0.336-0.778 0.547-1.083-4.111 0.799-7.223 4.416-7.223 8.759 0 3.081 1.556 5.793 3.932 7.392 0.105-0.305 0.221-0.599 0.347-0.883-2.029-1.44-3.354-3.817-3.354-6.498z"></path>
        <path d="M9.56 12.173l0.673 0.179c0.61-1.409 1.714-2.544 3.102-3.196 0.021-0.273 0.053-0.536 0.095-0.789-1.745 0.694-3.144 2.071-3.869 3.806z"></path>
        <path d="M9.802 15.842h-0.694c0.273 1.861 1.272 3.48 2.713 4.563 0.116-0.2 0.242-0.4 0.368-0.589-1.251-0.946-2.124-2.355-2.387-3.974z"></path>
        <path d="M21.757 12.373l0.673-0.179c-0.81-1.966-2.481-3.47-4.542-4.059 0.053 0.242 0.095 0.494 0.126 0.757 1.682 0.589 3.049 1.861 3.743 3.48z"></path>
        <path d="M22.955 13.971l-0.726-0.747-2.387 0.389-0.368 1.094 1.104 0.736 2.008-0.736z"></path>
        <path d="M9.129 13.971l0.726-0.747 2.387 0.389 0.368 1.094-1.104 0.736-2.019-0.736z"></path>
        <path d="M22.619 16.957c0.116-0.358 0.2-0.736 0.263-1.115h-0.694c-0.032 0.21-0.084 0.421-0.137 0.631 0.2 0.158 0.389 0.326 0.568 0.484z"></path>
        <path d="M20.411 19.28c-0.179 0.179-0.368 0.347-0.568 0.505 0.126 0.189 0.252 0.379 0.368 0.589 0.305-0.242 0.599-0.505 0.862-0.789-0.21-0.084-0.431-0.189-0.662-0.305z"></path>
        <path d="M24.007 14.854c0 1.041-0.2 2.040-0.568 2.955 0.273 0.326 0.473 0.631 0.61 0.904 0.557-1.167 0.883-2.481 0.883-3.859 0-4.605-3.491-8.401-7.97-8.874 0.221 0.273 0.421 0.62 0.589 1.020 3.67 0.715 6.456 3.953 6.456 7.854z"></path>
        <path d="M22.167 19.953c-0.431 0.515-0.915 0.978-1.462 1.377 0.126 0.284 0.242 0.578 0.347 0.883 0.841-0.578 1.567-1.293 2.166-2.113-0.305 0-0.662-0.053-1.051-0.147z"></path>
        <path d="M16.762 13.76v0c-0.011 0-0.011 0-0.011-0.011l-0.757-7.833h-0.704l-0.641 7.896c0 0.011 0 0.032 0 0.042 0 0.137 0.021 0.263 0.042 0.379 0.011 0.137 0.053 0.273 0.116 0.41 0.137 0.347 0.347 0.599 0.599 0.726 0.063 0.042 0.116 0.095 0.189 0.137 0.011 0.011 0.032 0.011 0.042 0.021v0l7.791 4.279 0.41-0.568-7.076-5.478z"></path>
        <path d="M17.751 24.496c-0.61 0-1.115-0.41-1.262-0.978l2.881-1.104-0.683-1.714-2.692 1.093-2.692-1.083-0.683 1.703 2.86 1.125c-0.158 0.547-0.662 0.957-1.262 0.957-0.042 0-0.084 0-0.116-0.011l-0.578 0.81c0.221 0.074 0.452 0.116 0.704 0.116 0.726 0 1.367-0.347 1.766-0.883 0.41 0.536 1.051 0.883 1.777 0.883 0.273 0 0.536-0.053 0.778-0.137l-0.568-0.799c-0.095 0.011-0.158 0.021-0.231 0.021z"></path>
        <path d="M24.964 8.083l-0.936 1.062c1.136 1.609 1.808 3.575 1.808 5.688 0 3.47-1.798 6.529-4.521 8.285 0.116 0.463 0.221 0.946 0.294 1.44 3.354-1.945 5.604-5.573 5.604-9.715 0.011-2.534-0.831-4.879-2.25-6.761z"></path>
        <path d="M6.143 14.843c0-2.113 0.673-4.080 1.808-5.688l-0.936-1.062c-1.419 1.882-2.25 4.216-2.25 6.75 0 4.174 2.282 7.823 5.667 9.757 0.074-0.494 0.168-0.978 0.284-1.44-2.744-1.745-4.574-4.816-4.574-8.317z"></path>
        <path d="M15.995 3.614c-1.724 0-3.354 0.389-4.816 1.083l0.683 1.209c1.262-0.578 2.66-0.904 4.132-0.904s2.87 0.326 4.122 0.904l0.683-1.209c-1.451-0.694-3.081-1.083-4.805-1.083z"></path>
      </g>
      <g id="db_vertica">
        <path d="M29.982 14.964c-0.178-2.393-0.971-4.741-2.308-6.736-1.311-1.961-3.119-3.597-5.22-4.673-1.624-0.855-3.424-1.357-5.25-1.519-0.412-0.088-0.826 0.006-1.242 0.009-0.984 2.819-2.006 5.624-2.998 8.44 0.722 0.013 1.444-0.010 2.165 0.011 0.527 0.022 1.080 0.242 1.371 0.703 0.333 0.521 0.315 1.188 0.105 1.753-0.981 2.761-1.972 5.518-2.951 8.281-0.866 0.012-1.733-0.002-2.599 0.006-0.12-0.003-0.246 0.012-0.361-0.034 1.1-3.034 2.174-6.079 3.258-9.119-0.517-0.008-1.034 0.003-1.551-0.006-0.080 0.165-0.136 0.341-0.195 0.514-0.997 2.805-2.003 5.607-2.997 8.413-0.047 0.072-0.035 0.228-0.148 0.229-0.825 0.003-1.65-0.002-2.475 0.002-0.148-0.002-0.3 0.015-0.444-0.029 2.263-6.278 4.474-12.574 6.738-18.851-4.422 0.946-8.226 4.256-9.87 8.459-0.674 1.664-0.968 3.461-1.005 5.25 0.046 0.859 0.107 1.721 0.274 2.567 0.532 2.818 1.97 5.454 4.042 7.437 1.72 1.663 3.877 2.865 6.192 3.466 2.253-6.302 4.494-12.608 6.739-18.913 0.022-0.045 0.068-0.137 0.090-0.183 1.386 0.014 2.772 0.002 4.158 0.006 0.455 0.008 0.921-0.042 1.363 0.095 0.509 0.137 0.983 0.503 1.139 1.021 0.116 0.408 0.035 0.843-0.11 1.233-0.885 2.583-1.821 5.147-2.735 7.719-0.227 0.67-0.908 1.090-1.597 1.114-1.080 0.020-2.161-0.007-3.241 0.013-0.992 2.765-1.975 5.533-2.959 8.3 0.257 0.109 0.53 0.024 0.798 0.042 0.403 0.031 0.804-0.043 1.205-0.072 2.634-0.242 5.187-1.262 7.267-2.893 1.669-1.302 3.041-2.987 3.967-4.891 0.812-1.638 1.267-3.443 1.398-5.262-0.061-0.632-0.043-1.269-0.014-1.902z"></path>
        <path d="M23.264 12.068c-0.401-0.009-0.801 0.002-1.201-0.006-0.115 0.017-0.268-0.042-0.354 0.055-0.947 2.645-1.884 5.293-2.831 7.938 0.519 0.003 1.042 0.026 1.56-0.011 0.917-2.668 1.894-5.314 2.826-7.976z"></path>
      </g>
      <g id="db_websockets">
        <path d="M23.048 21.315h3.476v-8.346l-3.916-3.916-2.458 2.458 2.898 2.898v6.906zM26.533 23.057h-12.124l-2.898-2.898 1.229-1.229 2.394 2.394h4.925l-4.852-4.861 1.238-1.238 4.852 4.852v-4.925l-2.384-2.384 1.22-1.22-6.025-6.053h-12.106l3.467 3.467v0.009h7.19l2.54 2.54-3.714 3.714-2.54-2.54v-1.972h-3.476v3.412l6.016 6.016-2.449 2.449 3.916 3.916h17.049l-3.467-3.448z"></path>
      </g>
      <g id="delta_drill_chart">
        <path d="M2 4h6v24h-6v-24z"></path>
        <path d="M10 16h6v12h-6v-12z"></path>
        <path d="M24 4h6v14h-6v-14z"></path>
        <path d="M10 4h12v2h-12v-2z"></path>
        <path d="M18 16h4v2h-4v-2z"></path>
      </g>
      <g id="details">
        <path d="M28 6h-24v18h4v6l8-6h12v-18zM6 22v-14h20v14h-10.667l-5.333 4v-4h-4z"></path>
        <path d="M22 12h-12v2h12v-2z"></path>
        <path d="M14 16h-4v2h4v-2z"></path>
        <path d="M20 16h-4v2h4v-2z"></path>
      </g>
      <g id="document">
        <path d="M10 14h12v2h-12v-2z"></path>
        <path d="M10 10h6v2h-6v-2z"></path>
        <path d="M10 18h12v2h-12v-2z"></path>
        <path d="M10 22h12v2h-12v-2z"></path>
        <path d="M20 2h-16v28h24v-20l-8-8zM20 4.828l5.172 5.172h-5.172v-5.172zM26 28h-20v-24h12v8h8v16z"></path>
      </g>
      <g id="dollar">
        <path d="M17.067 14.607c-1.902-0.738-3.537-1.367-3.537-2.787 0-1.219 1.178-2.062 2.879-2.062 1.141 0 2.144 0.459 2.811 0.861 0.293 0.177 0.699 0.471 1.257 0.915l1.507-2.722c-0.111-0.097-0.198-0.165-0.295-0.245-0.25-0.238-1.66-1.499-4.167-1.783v-2.787h-2.666v2.84c-2.801 0.537-4.731 2.572-4.731 5.037 0 3.363 3.002 4.568 5.414 5.52 1.809 0.725 3.389 1.354 3.389 2.641 0 1.514-1.42 2.209-2.732 2.209-1.169 0-2.216-0.437-2.982-0.881-0.423-0.251-1.022-0.66-1.65-1.258l-1.881 2.482c0.091 0.094 0.161 0.147 0.248 0.23 0.004 0.005 0.003 0.012 0.007 0.017 0.031 0.036 0.407 0.434 1.075 0.899 0.017 0.012 0.050 0.039 0.065 0.049l0.002-0.002c0.829 0.565 2.089 1.215 3.776 1.452v2.773h2.666v-2.773c2.84-0.469 4.795-2.625 4.795-5.359 0-3.229-2.785-4.313-5.25-5.264z"></path>
      </g>
      <g id="donut_chart">
        <path d="M27.867 14.305c-0.28-1.975-1.040-3.794-2.158-5.336-1.863-2.57-4.722-4.369-8.014-4.835-0.555-0.079-1.118-0.133-1.695-0.133-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c0-0.577-0.055-1.14-0.133-1.695zM20 16c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.206 1.794-4 4-4 0.158 0 0.309 0.029 0.461 0.050l0.103 0.015c1.738 0.247 3.124 1.634 3.371 3.371l0.014 0.101 0 0.003c0.022 0.152 0.050 0.303 0.050 0.46zM16 26c-5.514 0-10-4.486-10-10s4.486-10 10-10c0.418 0 0.867 0.036 1.412 0.113l-0.567 3.972c-0.278-0.040-0.556-0.085-0.845-0.085-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6c0-0.289-0.046-0.567-0.085-0.845l3.972-0.567c0.077 0.546 0.113 0.995 0.113 1.412 0 5.514-4.486 10-10 10z"></path>
      </g>
      <g id="double_down_chevron">
        <path d="M16 25.414l-6.707-6.707 1.414-1.414 5.293 5.293 5.293-5.293 1.414 1.414z"></path>
        <path d="M16 17.414l-6.707-6.707 1.414-1.414 5.293 5.293 5.293-5.293 1.414 1.414z"></path>
      </g>
      <g id="double_left_chevron">
        <path d="M13.293 22.707l-6.707-6.707 6.707-6.707 1.414 1.414-5.293 5.293 5.293 5.293z"></path>
        <path d="M21.293 22.707l-6.707-6.707 6.707-6.707 1.414 1.414-5.293 5.293 5.293 5.293z"></path>
      </g>
      <g id="double_right_chevron">
        <path d="M18.707 22.707l-1.414-1.414 5.293-5.293-5.293-5.293 1.414-1.414 6.707 6.707z"></path>
        <path d="M10.707 22.707l-1.414-1.414 5.293-5.293-5.293-5.293 1.414-1.414 6.707 6.707z"></path>
      </g>
      <g id="double_up_chevron">
        <path d="M21.293 14.707l-5.293-5.293-5.293 5.293-1.414-1.414 6.707-6.707 6.707 6.707z"></path>
        <path d="M21.293 22.707l-5.293-5.293-5.293 5.293-1.414-1.414 6.707-6.707 6.707 6.707z"></path>
      </g>
      <g id="down">
        <path d="M8 14h16l-8 8-8-8z"></path>
      </g>
      <g id="down_arrow">
        <path d="M22.35 16.583l-5.35 4.584v-13.826h-2v13.826l-5.35-4.584-1.301 1.517 7.65 6.559 7.65-6.559z"></path>
      </g>
      <g id="down_chevron">
        <path d="M16 21.414l-6.707-6.707 1.414-1.414 5.293 5.293 5.293-5.293 1.414 1.414z"></path>
      </g>
      <g id="down_small">
        <path d="M22 14l-6 6-6-6h12z"></path>
      </g>
      <g id="download">
        <path d="M10 16h12l-6 6-6-6z"></path>
        <path d="M14 4h4v12h-4v-12z"></path>
        <path d="M4 24h24v4h-24v-4z"></path>
      </g>
      <g id="download_alt">
        <path d="M22.93 6l3.070 4.606v15.394h-20v-15.394l3.070-4.606h13.859zM24 4h-16l-4 6v18h24v-18l-4-6z"></path>
        <path d="M10 8l-2 4h16l-2-4z"></path>
        <path d="M10 18h12l-6 6-6-6z"></path>
        <path d="M14 14h4v4h-4v-4z"></path>
      </g>
      <g id="download_alt1">
        <path d="M10 12h12l-6 6-6-6z"></path>
        <path d="M14 4h4v12h-4v-12z"></path>
        <path d="M4 20v8h24v-8h-24zM22 26h-2v-2h2v2zM26 26h-2v-2h2v2z"></path>
      </g>
      <g id="download_files">
        <path d="M16 14v0zM18 12h-4v8h4v-8z"></path>
        <path d="M12 18l4 4 4-4z"></path>
        <path d="M11.172 8l2 2h12.828v14h-20v-16h5.172zM12 6h-8v20h24v-18h-14l-2-2z"></path>
      </g>
      <g id="drill_down">
        <path d="M22.4 21.6l-2.4-0.8v-2.8l1.6 0.6 1-2.8-2.6-1v-2.8l1.6 0.6 1-2.8-2.6-1v-5.8h-8v3l-1.6-0.4-0.8 2.8 2.4 0.8v2.8l-1.6-0.4-0.8 2.8 2.4 0.8v2.8l-1.6-0.4-1 2.8 2.6 0.8v3.8l4 4 4-4v-1l1.6 0.6 0.8-3zM14 5h4v3l-4-1.2v-1.8zM14 10l4 1.4v2.6l-4-1.2v-2.8zM14 16l4 1.4v2.6l-4-1.2v-2.8zM18 24.2l-2 2-2-2v-2.2l4 1.4v0.8z"></path>
      </g>
      <g id="drive">
        <path d="M10.725 4.147l4.891 8.246-9.266 15.693-4.891-8.248 9.266-15.691zM12.17 20.284h18.371l-4.766 8.213h-18.371l4.766-8.213zM11.652 3.503h9.641l9.248 15.676h-9.641l-9.248-15.676z"></path>
      </g>
      <g id="dropbox">
        <path d="M15.92 8.091l-7.766 4.82-5.248-4.339 7.711-5.070 5.303 4.589zM8.154 12.912l7.854 4.82-5.48 4.516-7.443-5.088 5.070-4.248zM21.203 23.498l2.5-1.465v1.715l-7.57 4.75-7.891-4.75 0.072-1.715 2.303 1.555 5.32-4.5 5.266 4.41zM23.633 13l-7.713-4.909 5.338-4.518 7.836 5.089-5.461 4.338zM23.633 13l5.23 4.159-7.535 5.088-5.32-4.515 7.625-4.732z"></path>
      </g>
      <g id="duplicate">
        <path d="M20 3h-8v6h-8v20h16v-6h8v-12l-8-8zM20 5.8l5.2 5.2h-5.2v-5.2zM12 11.8l5.2 5.2h-5.2v-5.2zM18 27h-12v-16h4v8h8v8zM26 21h-6v-4l-6-6v-6h4v8h8v8z"></path>
      </g>
      <g id="edit">
        <path d="M11.050 18.121l8.485-8.485 2.828 2.828-8.485 8.485-2.828-2.828z"></path>
        <path d="M21.657 7.515l1.414-1.414 2.828 2.828-1.414 1.414-2.828-2.828z"></path>
        <path d="M8.929 20.243l-2.828 5.657 5.657-2.828z"></path>
      </g>
      <g id="edit_alt">
        <path d="M24.571 5.143l1.143-1.143 2.286 2.286-1.143 1.143-2.286-2.286z"></path>
        <path d="M15.428 14.286l8-8 2.286 2.286-8 8-2.286-2.286z"></path>
        <path d="M12 20l2.286-4.571 2.286 2.286-4.572 2.286z"></path>
        <path d="M22 16v10h-16v-16h10v-2h-12v20h20v-12z"></path>
      </g>
      <g id="ellipses_horizontal">
        <path d="M9 16c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M19 16c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M29 16c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
      </g>
      <g id="ellipses_vertical">
        <path d="M19 6c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M19 16c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M19 26c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
      </g>
      <g id="embed">
        <path d="M27.585 10.415v15.17h-23.17v-15.17h23.17zM30 8h-28v20h28v-20z"></path>
        <path d="M11.293 22.707l-4.707-4.707 4.707-4.707 1.414 1.414-3.293 3.293 3.293 3.293z"></path>
        <path d="M20.707 22.707l-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414 4.707 4.707z"></path>
        <path d="M13.051 23.683l4-12 1.899 0.633-4 12-1.899-0.633z"></path>
        <path d="M6 4h20v2h-20v-2z"></path>
      </g>
      <g id="error">
        <path d="M16 6l12 20h-24l12-20zM16 4c-0.703 0-1.354 0.369-1.715 0.971l-12 20c-0.371 0.618-0.38 1.387-0.025 2.014s1.020 1.015 1.74 1.015h24c0.721 0 1.385-0.388 1.74-1.015s0.345-1.397-0.025-2.014l-12-20c-0.361-0.602-1.012-0.971-1.715-0.971v0z"></path>
        <path d="M17 19h-2c-0.552 0-1-0.448-1-1v-4c0-1.105 0.895-2 2-2v0c1.105 0 2 0.895 2 2v4c0 0.552-0.448 1-1 1z"></path>
        <path d="M16 24v0c-1.105 0-2-0.895-2-2v0c0-1.105 0.895-2 2-2v0c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2z"></path>
      </g>
      <g id="error_circle">
        <path d="M26.125 11.719c-1.124-2.651-3.192-4.719-5.773-5.817l-0.071-0.027c-1.263-0.553-2.734-0.875-4.281-0.875s-3.018 0.322-4.352 0.902l0.070-0.027c-2.651 1.124-4.719 3.192-5.817 5.773l-0.027 0.071c-0.553 1.263-0.875 2.734-0.875 4.281s0.322 3.018 0.902 4.352l-0.027-0.070c1.124 2.651 3.192 4.719 5.773 5.817l0.071 0.027c1.263 0.553 2.734 0.875 4.281 0.875s3.018-0.322 4.352-0.902l-0.070 0.027c2.651-1.124 4.719-3.192 5.817-5.773l0.027-0.071c0.553-1.263 0.875-2.734 0.875-4.281s-0.322-3.018-0.902-4.352l0.027 0.070zM24.281 19.5c-0.927 2.165-2.616 3.854-4.723 4.759l-0.058 0.022c-1.032 0.454-2.235 0.719-3.5 0.719s-2.468-0.264-3.557-0.741l0.057 0.022c-2.165-0.927-3.854-2.616-4.759-4.723l-0.022-0.058c-0.454-1.032-0.719-2.235-0.719-3.5s0.264-2.468 0.741-3.557l-0.022 0.057c0.927-2.165 2.616-3.854 4.723-4.759l0.058-0.022c1.032-0.454 2.235-0.719 3.5-0.719s2.468 0.264 3.557 0.741l-0.057-0.022c2.165 0.927 3.854 2.616 4.759 4.723l0.022 0.058c0.454 1.032 0.719 2.235 0.719 3.5s-0.264 2.468-0.741 3.557l0.022-0.057z"></path>
        <path d="M19.292 11.292l-3.292 3.294-3.292-3.294-1.416 1.416 3.294 3.292-3.294 3.292 1.416 1.416 3.292-3.294 3.292 3.294 1.416-1.416-3.294-3.292 3.294-3.292-1.416-1.416z"></path>
      </g>
      <g id="euro">
        <path d="M20.104 22.5c-2.395 0-4.468-1.317-5.596-3.25h5.475l0.524-2.5h-6.828c-0.029-0.249-0.076-0.493-0.076-0.75s0.047-0.501 0.076-0.75h7.142l0.524-2.5h-6.838c1.128-1.933 3.201-3.25 5.596-3.25 0.486 0 1.002 0.074 1.625 0.236l0.75-2.906c-0.873-0.225-1.629-0.33-2.375-0.33-4.092 0-7.556 2.615-8.89 6.25h-1.693v2.5h1.16c-0.020 0.252-0.076 0.493-0.076 0.75s0.056 0.498 0.076 0.75h-1.16v2.5h1.693c1.334 3.635 4.798 6.25 8.89 6.25 0.746 0 1.502-0.105 2.375-0.33l-0.75-2.906c-0.623 0.162-1.138 0.236-1.625 0.236z"></path>
      </g>
      <g id="excel">
        <path d="M2 5.075c0.569-0.126 1.13-0.251 1.691-0.376 2.745-0.61 5.49-1.22 8.236-1.829 1.297-0.288 2.594-0.576 3.89-0.864 0.034-0.008 0.069-0.013 0.104-0.013 0.782-0.001 1.564-0.001 2.346-0 0.019 0 0.038 0.002 0.069 0.004 0 1.165 0 2.325 0 3.494 3.894 0 7.775 0 11.665 0 0 7.005 0 14.001 0 21.009-3.883 0-7.767 0-11.659 0 0 1.17 0 2.328 0 3.496-0.041 0.003-0.074 0.007-0.108 0.007-0.762 0-1.525 0.012-2.287-0.006-0.248-0.006-0.496-0.087-0.742-0.142-2.969-0.659-5.938-1.319-8.907-1.979-1.399-0.311-2.798-0.622-4.197-0.933-0.033-0.007-0.066-0.018-0.1-0.027 0-7.281 0-14.555 0-21.841zM15.997 27.64c0-7.77 0-15.522 0-23.284-3.892 0.865-7.777 1.728-11.66 2.591 0 6.041 0 12.070 0 18.102 3.887 0.864 7.769 1.727 11.66 2.591zM27.669 7.836c-3.114 0-6.22 0-9.326 0 0 0.388 0 0.768 0 1.16 0.777 0 1.549 0 2.32 0 0 0.784 0 1.556 0 2.336-0.777 0-1.546 0-2.318 0 0 0.391 0 0.774 0 1.169 0.779 0 1.551 0 2.321 0 0 0.782 0 1.55 0 2.332-0.778 0-1.549 0-2.319 0 0 0.395 0 0.778 0 1.169 0.778 0 1.547 0 2.317 0 0 0.78 0 1.552 0 2.336-0.78 0-1.551 0-2.319 0 0 0.393 0 0.772 0 1.165 0.778 0 1.55 0 2.322 0 0 0.782 0 1.55 0 2.332-0.777 0-1.549 0-2.32 0 0 0.784 0 1.556 0 2.327 3.112 0 6.215 0 9.323 0 0-5.443 0-10.88 0-16.326z"></path>
        <path d="M8.017 20.969c-0.848-0.108-1.676-0.213-2.516-0.32 0.026-0.054 0.044-0.092 0.062-0.129 0.733-1.471 1.465-2.942 2.199-4.411 0.038-0.075 0.043-0.135 0.008-0.216-0.652-1.487-1.299-2.975-1.948-4.463-0.015-0.035-0.030-0.071-0.051-0.12 0.045-0.017 0.086-0.041 0.129-0.047 0.794-0.1 1.589-0.197 2.384-0.295 0.011-0.001 0.023 0.002 0.038 0.003 0.35 1.223 0.7 2.446 1.057 3.692 0.024-0.035 0.039-0.047 0.042-0.061 0.207-0.865 0.622-1.647 0.987-2.448 0.231-0.505 0.468-1.007 0.696-1.514 0.046-0.101 0.098-0.151 0.217-0.165 0.837-0.098 1.674-0.205 2.531-0.312-0.025 0.051-0.043 0.090-0.063 0.129-0.964 1.846-1.927 3.692-2.894 5.536-0.048 0.091-0.043 0.157 0.003 0.244 0.991 1.871 1.978 3.744 2.967 5.616 0.021 0.040 0.041 0.082 0.070 0.141-0.211-0.026-0.406-0.048-0.6-0.073-0.717-0.091-1.434-0.183-2.152-0.271-0.070-0.009-0.109-0.033-0.139-0.099-0.505-1.11-1.018-2.216-1.514-3.33-0.1-0.224-0.137-0.476-0.203-0.715-0.007-0.025-0.013-0.050-0.015-0.056-0.428 1.217-0.861 2.447-1.297 3.684z"></path>
        <path d="M26.502 9.003c0 0.777 0 1.546 0 2.32-1.552 0-3.098 0-4.654 0 0-0.769 0-1.541 0-2.32 1.546 0 3.096 0 4.654 0z"></path>
        <path d="M21.845 12.502c1.552 0 3.099 0 4.654 0 0 0.772 0 1.543 0 2.322-1.549 0-3.098 0-4.654 0 0-0.771 0-1.54 0-2.322z"></path>
        <path d="M26.502 16.007c0 0.776 0 1.545 0 2.32-1.551 0-3.098 0-4.654 0 0-0.768 0-1.54 0-2.32 1.545 0 3.095 0 4.654 0z"></path>
        <path d="M26.499 21.829c-1.555 0-3.101 0-4.654 0 0-0.774 0-1.542 0-2.32 1.547 0 3.096 0 4.654 0 0 0.768 0 1.539 0 2.32z"></path>
      </g>
      <g id="exchange_doc">
        <path d="M12 14v-2l-4 3 4 3v-2h8v-2z"></path>
        <path d="M24 21l-4-3v2h-8v2h8v2z"></path>
        <path d="M22 2h-18v28h24v-22l-6-6zM25.2 8h-3.2v-3.2l3.2 3.2zM26 28h-20v-24h14v6h6v18z"></path>
      </g>
      <g id="expand">
        <path d="M4 4v8h2v-6h6v-2h-8z"></path>
        <path d="M26 4h-6v2h6v6h2v-8h-2z"></path>
        <path d="M6 20h-2v8h8v-2h-6v-6z"></path>
        <path d="M26 26h-6v2h8v-8h-2v6z"></path>
      </g>
      <g id="expand_horizontal">
        <path d="M30 17l-6-5v4h-16v-4l-6 5 6 5v-4h16v4z"></path>
      </g>
      <g id="expand_vertical">
        <path d="M11 24l5 6 5-6h-4v-16h4l-5-6-5 6h4v16z"></path>
      </g>
      <g id="facebook">
        <path d="M24.893 6h-18.893v20h10.678v-7.747h-2.605v-3.022h2.604v-2.227c0-2.578 1.589-3.984 3.893-3.984 1.093 0 2.044 0.080 2.318 0.118v2.695l-1.589 0.013c-1.264 0-1.498 0.587-1.498 1.458v1.927h2.982l-0.391 3.022h-2.591v7.747h6.198v-20h-1.107z"></path>
      </g>
      <g id="fast_forward">
        <path d="M6 22l10-6-10-6z"></path>
        <path d="M26 16l-10-6v12z"></path>
      </g>
      <g id="file">
        <path d="M20 2h-16v28h24v-20l-8-8zM6 28v-24h12v8h8v16zM20 10v-5.172l5.172 5.172z"></path>
      </g>
      <g id="file_add">
        <path d="M20 2h-16v28h24v-20l-8-8zM20 4.828l5.172 5.172h-5.172v-5.172zM26 28h-20v-24h12v8h8v16z"></path>
        <path d="M16 14h-2v4h-4v2h4v4h2v-4h4v-2h-4z"></path>
      </g>
      <g id="file_archive">
        <path d="M20 2h-16v28h24v-20zM20 4.828l5.172 5.172h-5.172zM26 28h-20v-24h4v2h2v-2h6v8h8z"></path>
        <path d="M12 6h2v2h-2v-2z"></path>
        <path d="M10 8h2v2h-2v-2z"></path>
        <path d="M12 10h2v2h-2v-2z"></path>
        <path d="M10 12h2v2h-2v-2z"></path>
        <path d="M10 16l-1 8h6l-1-8v-2h-2v2zM12 19c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1v0c0 0.552-0.448 1-1 1v0z"></path>
      </g>
      <g id="file_download">
        <path d="M20 2h-16v28h24v-20l-8-8zM20 4.828l5.172 5.172h-5.172v-5.172zM26 28h-20v-24h12v8h8v16z"></path>
        <path d="M14 16h-2l4 4 4-4h-2v-4h-4z"></path>
        <path d="M12 22h8v2h-8v-2z"></path>
      </g>
      <g id="file_upload">
        <path d="M20 2h-16v28h24v-20l-8-8zM20 4.828l5.172 5.172h-5.172v-5.172zM26 28h-20v-24h12v8h8v16z"></path>
        <path d="M12 16h2v6h4v-6h2l-4-4z"></path>
        <path d="M12 24h8v2h-8v-2z"></path>
      </g>
      <g id="filter">
        <path d="M22 8l-6 8v8l-2-2v-6l-6-8h14zM26 6h-22l8 10.667v6.162l6 6v-12.162l8-10.667z"></path>
      </g>
      <g id="flag">
        <path d="M9.311 16.606l14.269-5.351c0.262-0.105 0.42-0.341 0.42-0.603s-0.157-0.525-0.42-0.603l-14.689-5.508c-0.21-0.079-0.42-0.052-0.603 0.079s-0.289 0.315-0.289 0.551v21.797h1.311c0 0 0-10.361 0-10.361z"></path>
      </g>
      <g id="folder">
        <path d="M11.172 8l2 2h12.828v14h-20v-16h5.172zM12 6h-8v20h24v-18h-14l-2-2z"></path>
        <path d="M26 12h-20v2h20v-2z"></path>
      </g>
      <g id="folder_add">
        <path d="M14 8l-2-2h-8v20h24v-18h-14zM26 14v10h-20v-16h5.172l2 2h12.828v4z"></path>
        <path d="M11 16v2h4v4h2v-4h4v-2h-4v-4h-2v4z"></path>
      </g>
      <g id="folder_download">
        <path d="M14 8l-2-2h-8v20h24v-18h-14zM26 14v10h-20v-16h5.172l2 2h12.828v4z"></path>
        <path d="M12 22h8v-2h-8z"></path>
        <path d="M14 12v4h-2l4 4 4-4h-2v-4z"></path>
      </g>
      <g id="folder_open">
        <path d="M10 6h-8v20h21.132l8.4-14h-5.532v-4h-14l-2-2zM4 20.113v-12.113h5.172l2 2h12.828v2h-15.161l-0.565 0.988-4.275 7.125zM4 24l6-10h18l-6 10h-18z"></path>
      </g>
      <g id="folder_upload">
        <path d="M14 8l-2-2h-8v20h24v-18h-14zM26 14v10h-20v-16h5.171l2 2h12.828v4z"></path>
        <path d="M12 20h8v2h-8v-2z"></path>
        <path d="M14 14v4h4v-4h2l-4-4-4 4z"></path>
      </g>
      <g id="form_chart">
        <path d="M4 4v12h24v-12h-24zM26 14h-20v-8h20v8z"></path>
        <path d="M12 8h12v4h-12v-4z"></path>
        <path d="M8 8h2v4h-2v-4z"></path>
        <path d="M7.892 24.479l-3.185-3.186-1.414 1.414 4.815 4.814 6.691-8.922-1.6-1.199z"></path>
        <path d="M23 18c-2.761 0-5 2.239-5 5s2.239 5 5 5c2.761 0 5-2.239 5-5s-2.239-5-5-5zM23 25c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"></path>
      </g>
      <g id="forward">
        <path d="M8 24v-16l8 8-8 8z"></path>
        <path d="M16 24v-16l8 8-8 8z"></path>
      </g>
      <g id="full_screen">
        <path d="M4 20l8 8h-8v-8z"></path>
        <path d="M28 12l-8-8h8v8z"></path>
        <path d="M5.293 25.293l8-8 1.414 1.414-8 8-1.414-1.414z"></path>
        <path d="M17.293 13.293l8-8 1.414 1.414-8 8-1.414-1.414z"></path>
      </g>
      <g id="funnel_chart">
        <path d="M2 6l2.182 6h23.636l2.182-6z"></path>
        <path d="M10 28h12l2.182-6h-16.364z"></path>
        <path d="M7.091 20h17.818l2.182-6h-22.182z"></path>
      </g>
      <g id="gauge_chart">
        <path d="M16 6c5.6 0 10 4.4 10 10s-4.4 10-10 10-10-4.4-10-10 4.4-10 10-10zM16 4c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12v0z"></path>
        <path d="M14.4 17.2l-4.2-5.6c0 0 0 0 0 0-0.2-0.2-0.4-0.4-0.4-0.8 0-0.6 0.4-1 1-1 0.2 0 0.6 0.2 0.6 0.2s0 0 0 0l5.6 4.2 0.2 0.2c0.8 0.8 0.8 2 0 2.8s-2 0.8-2.8 0c0.2 0.2 0 0 0 0z"></path>
      </g>
      <g id="gear">
        <path d="M28 18c0-1.333 0-2.667 0-4-1.48-0.234-2.967-0.411-4.456-0.558-0.117-0.346-0.253-0.678-0.414-1.001 0.945-1.153 1.892-2.305 2.769-3.513-0.943-0.943-1.886-1.886-2.828-2.828-1.208 0.878-2.36 1.824-3.513 2.769-0.323-0.162-0.655-0.297-1.001-0.414-0.147-1.489-0.323-2.976-0.558-4.456h-4c-0.234 1.48-0.411 2.967-0.558 4.456-0.346 0.117-0.678 0.253-1.001 0.414-1.153-0.945-2.305-1.892-3.513-2.77-0.943 0.943-1.886 1.886-2.829 2.829 0.878 1.208 1.824 2.36 2.769 3.513-0.161 0.323-0.297 0.655-0.414 1.001-1.489 0.147-2.976 0.323-4.456 0.558 0 1.333 0 2.667 0 4 1.48 0.234 2.967 0.411 4.456 0.558 0.117 0.346 0.253 0.678 0.414 1.001-0.945 1.153-1.892 2.305-2.769 3.513 0.943 0.943 1.886 1.886 2.828 2.828 1.208-0.878 2.36-1.824 3.513-2.769 0.323 0.161 0.655 0.297 1.001 0.414 0.147 1.489 0.323 2.976 0.558 4.456h4c0.234-1.48 0.411-2.967 0.558-4.456 0.346-0.117 0.678-0.253 1.001-0.414 1.153 0.945 2.305 1.892 3.513 2.769 0.943-0.943 1.886-1.886 2.828-2.828-0.878-1.208-1.824-2.36-2.769-3.513 0.161-0.323 0.297-0.655 0.414-1.001 1.489-0.147 2.976-0.323 4.456-0.558zM16 19c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"></path>
      </g>
      <g id="globe">
        <path d="M16 6c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zM16 4c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12v0z"></path>
        <path d="M19.942 12.373c0.079-0.016 0.157-0.3 0.206-0.365 0.095-0.111 0.222-0.173 0.349-0.238 0.268-0.111 0.539-0.141 0.823-0.19 0.27-0.062 0.603-0.062 0.809 0.176-0.046-0.049 0.333-0.381 0.381-0.398 0.143-0.079 0.381-0.049 0.476-0.19 0.030-0.049 0.030-0.349 0.030-0.349-0.268 0.032-0.363-0.222-0.379-0.444 0 0.016-0.032 0.062-0.095 0.127 0.014-0.238-0.287-0.065-0.398-0.095-0.365-0.097-0.317-0.349-0.428-0.619-0.062-0.143-0.238-0.19-0.3-0.333-0.065-0.095-0.097-0.3-0.238-0.317-0.095-0.016-0.27 0.333-0.303 0.317-0.141-0.079-0.206 0.032-0.317 0.095-0.095 0.065-0.173 0.032-0.268 0.079 0.284-0.095-0.127-0.252-0.27-0.222 0.222-0.062 0.111-0.3-0.016-0.411 0.032 0 0.049 0 0.079 0-0.030-0.143-0.474-0.27-0.617-0.365s-0.904-0.252-1.064-0.157c-0.189 0.111 0.049 0.428 0.049 0.585 0.016 0.192-0.19 0.238-0.19 0.398 0 0.27 0.506 0.222 0.379 0.587-0.078 0.222-0.379 0.268-0.506 0.444-0.127 0.157 0.016 0.444 0.141 0.555 0.127 0.095-0.222 0.254-0.268 0.284-0.27 0.127-0.476-0.268-0.539-0.506-0.049-0.176-0.065-0.381-0.254-0.476-0.095-0.032-0.398-0.079-0.46 0.016-0.095-0.238-0.428-0.333-0.65-0.412-0.317-0.111-0.587-0.111-0.92-0.065 0.111-0.016-0.032-0.506-0.3-0.427 0.079-0.16 0.046-0.333 0.079-0.492 0.032-0.127 0.095-0.252 0.19-0.363 0.032-0.065 0.381-0.43 0.27-0.446 0.268 0.032 0.571 0.049 0.793-0.173 0.141-0.143 0.206-0.381 0.349-0.539 0.206-0.238 0.46 0.062 0.682 0.079 0.317 0.016 0.3-0.333 0.125-0.492 0.208 0.016 0.032-0.363-0.079-0.411-0.143-0.046-0.682 0.095-0.395 0.206-0.065-0.030-0.444 0.763-0.666 0.365-0.065-0.079-0.097-0.411-0.238-0.428-0.127 0-0.206 0.143-0.254 0.238 0.079-0.206-0.444-0.349-0.555-0.365 0.238-0.159 0.046-0.333-0.127-0.428-0.127-0.081-0.522-0.143-0.633-0.016-0.303 0.365 0.317 0.411 0.474 0.506 0.049 0.032 0.238 0.143 0.127 0.222-0.095 0.048-0.379 0.127-0.411 0.192-0.095 0.141 0.111 0.3-0.032 0.444-0.143-0.143-0.143-0.381-0.254-0.539 0.143 0.173-0.569 0.079-0.555 0.079-0.236 0-0.617 0.157-0.793-0.079-0.030-0.065-0.030-0.43 0.065-0.349-0.143-0.111-0.238-0.222-0.333-0.287-0.525 0.176-1.015 0.398-1.491 0.649 0.062 0.016 0.111 0.016 0.19-0.014 0.127-0.049 0.238-0.127 0.365-0.192 0.159-0.062 0.492-0.252 0.666-0.111 0.016-0.030 0.065-0.062 0.081-0.079 0.111 0.127 0.222 0.254 0.317 0.395-0.127-0.062-0.333-0.030-0.476-0.014-0.111 0.030-0.3 0.062-0.349 0.19 0.048 0.079 0.111 0.206 0.078 0.284-0.206-0.141-0.363-0.379-0.65-0.411-0.127 0-0.254 0-0.349 0.016-1.521 0.839-2.806 2.062-3.726 3.52 0.065 0.062 0.127 0.111 0.192 0.127 0.157 0.046 0 0.506 0.3 0.268 0.095 0.079 0.111 0.19 0.046 0.3 0.016-0.014 0.652 0.398 0.698 0.43 0.111 0.095 0.287 0.206 0.333 0.333 0.032 0.111-0.062 0.238-0.157 0.284-0.016-0.033-0.254-0.268-0.286-0.206-0.046 0.079 0 0.509 0.176 0.492-0.254 0.016-0.143 0.998-0.206 1.188 0 0.016 0.030 0.016 0.030 0.016-0.046 0.189 0.111 0.936 0.428 0.855-0.206 0.049 0.365 0.777 0.446 0.825 0.206 0.143 0.444 0.238 0.585 0.444 0.159 0.222 0.159 0.555 0.381 0.73-0.065 0.19 0.333 0.411 0.317 0.682-0.032 0.014-0.046 0.014-0.079 0.030 0.079 0.222 0.379 0.222 0.49 0.43 0.065 0.125 0 0.428 0.208 0.363 0.030-0.349-0.208-0.698-0.381-0.982-0.095-0.159-0.19-0.3-0.27-0.46-0.079-0.143-0.095-0.317-0.157-0.476 0.062 0.016 0.411 0.143 0.379 0.192-0.125 0.317 0.509 0.872 0.682 1.077 0.049 0.049 0.414 0.522 0.222 0.522 0.208 0 0.492 0.319 0.587 0.476 0.143 0.238 0.111 0.539 0.206 0.793 0.097 0.317 0.541 0.46 0.793 0.603 0.222 0.111 0.414 0.268 0.636 0.349 0.333 0.127 0.411 0.016 0.698-0.032 0.411-0.062 0.458 0.398 0.793 0.571 0.206 0.111 0.65 0.27 0.871 0.173-0.095 0.032 0.333 0.682 0.365 0.73 0.141 0.19 0.411 0.284 0.569 0.476 0.049-0.032 0.097-0.081 0.111-0.143-0.062 0.173 0.238 0.509 0.398 0.476 0.173-0.032 0.222-0.381 0.222-0.509-0.317 0.159-0.603 0.032-0.777-0.284-0.032-0.079-0.287-0.525-0.065-0.525 0.303 0 0.097-0.236 0.065-0.458s-0.254-0.365-0.365-0.557c-0.095 0.192-0.411 0.143-0.506-0.014 0 0.046-0.049 0.125-0.049 0.19-0.079 0-0.159 0.016-0.238-0.016 0.032-0.19 0.049-0.428 0.095-0.633 0.081-0.286 0.603-0.841-0.079-0.809-0.238 0.016-0.333 0.111-0.411 0.317-0.081 0.19-0.048 0.365-0.27 0.46-0.143 0.062-0.617 0.032-0.76-0.048-0.303-0.173-0.509-0.728-0.509-1.045-0.016-0.43 0.206-0.809 0-1.207 0.095-0.079 0.192-0.238 0.303-0.317 0.095-0.062 0.206 0.049 0.252-0.143-0.046-0.030-0.111-0.095-0.125-0.095 0.236 0.111 0.68-0.157 0.888 0 0.127 0.095 0.268 0.127 0.349-0.030 0.014-0.049-0.111-0.238-0.049-0.365 0.049 0.268 0.222 0.317 0.46 0.143 0.095 0.095 0.349 0.062 0.522 0.157 0.176 0.111 0.206 0.287 0.414 0.049 0.125 0.19 0.141 0.19 0.19 0.379 0.046 0.176 0.143 0.619 0.3 0.698 0.333 0.206 0.254-0.349 0.222-0.539-0.016-0.016-0.016-0.539-0.030-0.539-0.509-0.111-0.319-0.508-0.033-0.776 0.046-0.032 0.411-0.159 0.571-0.287 0.141-0.127 0.317-0.349 0.238-0.555 0.079 0 0.141-0.062 0.173-0.143-0.046-0.016-0.238-0.173-0.27-0.157 0.113-0.065 0.097-0.159 0.032-0.254 0.159-0.095 0.081-0.27 0.238-0.333 0.176 0.238 0.522-0.032 0.349-0.222 0.159-0.222 0.522-0.111 0.619-0.317 0.236 0.062 0.062-0.238 0.19-0.414 0.111-0.141 0.3-0.141 0.444-0.222 0 0.016 0.395-0.222 0.27-0.238 0.268 0.032 0.807-0.252 0.395-0.49 0.062-0.143-0.143-0.206-0.284-0.238 0.111-0.032 0.252 0.032 0.347-0.032 0.208-0.143 0.065-0.206-0.111-0.254-0.222-0.062-0.506 0.081-0.682 0.192-0.125 0.095-0.206 0.268-0.363 0.3zM23.286 22.981c-0.095-0.095-0.27-0.062-0.395-0.127-0.127-0.046-0.222-0.095-0.381-0.127 0.032-0.317-0.317-0.428-0.539-0.587-0.206-0.157-0.333-0.333-0.636-0.268-0.030 0.016-0.349 0.127-0.284 0.19-0.206-0.173-0.3-0.268-0.571-0.349-0.254-0.079-0.428-0.395-0.682-0.111-0.127 0.127-0.062 0.317-0.127 0.444-0.206-0.173 0.19-0.379 0.032-0.571-0.19-0.222-0.525 0.143-0.682 0.238-0.095 0.081-0.206 0.111-0.27 0.206-0.079 0.111-0.111 0.254-0.173 0.365-0.049-0.127-0.317-0.095-0.333-0.19 0.062 0.379 0.062 0.777 0.141 1.158 0.049 0.222 0 0.585-0.19 0.76-0.19 0.173-0.428 0.365-0.46 0.633-0.030 0.192 0.016 0.365 0.192 0.414 0.014 0.236-0.254 0.411-0.238 0.666 0 0.016 0.016 0.173 0.030 0.252 2.173-0.379 4.107-1.458 5.566-2.995z"></path>
      </g>
      <g id="gplus">
        <path d="M6 6v20h20v-20h-20zM13.066 21c-2.773 0-5-2.24-5-5s2.227-5 5-5c1.262 0 2.422 0.442 3.347 1.302l-1.355 1.316c-0.533-0.522-1.262-0.769-1.991-0.769-1.733 0-3.113 1.433-3.113 3.151s1.38 3.151 3.113 3.151c1.315 0 2.618-0.769 2.825-2.149h-2.825v-1.718h4.713c0.051 0.273 0.078 0.547 0.078 0.833 0 2.851-1.913 4.882-4.791 4.882zM23.768 16.716h-1.418v1.433h-1.433v-1.433h-1.433v-1.431h1.433v-1.433h1.433v1.433h1.418v1.431z"></path>
      </g>
      <g id="group">
        <path d="M6 30h4v-2h-4v-2h-2v-4h-2v4h-2v6h6z"></path>
        <path d="M28 14h2v4h-2v-4z"></path>
        <path d="M20 2h4v2h-4v-2z"></path>
        <path d="M12 28h4v2h-4v-2z"></path>
        <path d="M28 8h2v4h-2v-4z"></path>
        <path d="M28 20h2v4h-2v-4z"></path>
        <path d="M18 28h4v2h-4v-2z"></path>
        <path d="M24 28v2h2v2h6v-6h-6v2z"></path>
        <path d="M2 10h2v4h-2v-4z"></path>
        <path d="M2 8h2v-2h2v-6h-6v6h2z"></path>
        <path d="M2 16h2v4h-2v-4z"></path>
        <path d="M8 2h4v2h-4v-2z"></path>
        <path d="M14 2h4v2h-4v-2z"></path>
        <path d="M30 6h2v-6h-6v6h2z"></path>
        <path d="M12 22v2h12v-12h-4v-4h-12v12h4v2zM20 14h2v8h-8v-2h6v-6zM10 18v-8h8v8h-8z"></path>
      </g>
      <g id="hamburger">
        <path d="M6 6h20v4h-20v-4z"></path>
        <path d="M6 14h20v4h-20v-4z"></path>
        <path d="M6 22h20v4h-20v-4z"></path>
      </g>
      <g id="hand_down">
        <path d="M11.005 29h5.986l0.084-6.082 3.337-0.293 6.593-4.066v-4.795l-3-6v-5.764h-12v4.899l-7.34 9.175 3.143 3.143 3.197-1.599v11.382zM21.005 6c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM13.005 27v-12.618l-4.803 2.401-0.857-0.857 6.341-7.926h8.201l3.118 6.236v3.206l-5.239 3.233-4.665 0.406-0.082 5.918h-2.014z"></path>
      </g>
      <g id="hand_left">
        <path d="M3 11v5.986l6.082 0.084 0.293 3.337 4.066 6.593h4.795l6-3h5.764v-12h-4.899l-9.175-7.34-3.143 3.143 1.599 3.197h-11.382zM26 21c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM5 13h12.618l-2.401-4.803 0.857-0.857 7.926 6.341v8.201l-6.236 3.118h-3.206l-3.233-5.239-0.406-4.665-5.918-0.082v-2.014z"></path>
      </g>
      <g id="hand_right">
        <path d="M17.618 11l1.599-3.197-3.143-3.143-9.175 7.34h-4.899v12h5.764l6 3h4.795l4.066-6.593 0.293-3.337 6.082-0.084v-5.986h-11.382zM5 22c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM27 15.014l-5.918 0.082-0.406 4.665-3.233 5.239h-3.206l-6.236-3.118v-8.201l7.926-6.341 0.857 0.857-2.401 4.803h12.618v2.014z"></path>
      </g>
      <g id="hand_up">
        <path d="M11.005 14.382l-3.197-1.599-3.143 3.143 7.34 9.175v4.899h12v-5.764l3-6v-4.795l-6.593-4.066-3.337-0.293-0.084-6.082h-5.986v11.382zM22.005 27c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1zM15.019 5l0.082 5.918 4.665 0.406 5.239 3.233v3.206l-3.118 6.236h-8.201l-6.341-7.926 0.857-0.857 4.803 2.401v-12.618h2.014z"></path>
      </g>
      <g id="hash_tag">
        <path d="M25.018 22.016h-4.48l-1.070 4.746h-3.75l1.072-4.746h-5.838l-1.070 4.746h-3.75l1.070-4.746h-4.23l0.82-3.66h4.23l1.322-5.91h-4.213l0.82-3.66h4.215l1.090-4.785h3.748l-1.090 4.785h5.838l1.072-4.785h3.748l-1.070 4.785h4.498l-0.822 3.66h-4.496l-1.322 5.91h4.48l-0.822 3.66zM19.074 12.428h-5.838l-1.32 5.908h5.836l1.322-5.908z"></path>
      </g>
      <g id="heatmap_chart">
        <path d="M2 2h8v8h-8v-8z"></path>
        <path d="M12 2h8v8h-8v-8z"></path>
        <path d="M22 2h8v8h-8v-8z"></path>
        <path d="M2 12h8v8h-8v-8z"></path>
        <path d="M12 12h8v8h-8v-8z"></path>
        <path d="M22 12h8v8h-8v-8z"></path>
        <path d="M2 22h8v8h-8v-8z"></path>
        <path d="M12 22h8v8h-8v-8z"></path>
        <path d="M22 22h8v8h-8v-8z"></path>
      </g>
      <g id="help">
        <path d="M16.751 19.076h-2v-0.49c0-1.138 0.49-2.053 1.416-2.646 0.309-0.198 0.625-0.375 0.941-0.551 0.334-0.186 0.666-0.369 0.984-0.588 0.725-0.497 1.084-1.309 0.965-2.172-0.068-0.497-0.324-0.876-0.783-1.157-1.021-0.631-2.768-0.618-3.859-0.242-0.719 0.247-1.494 0.906-1.494 1.77h-2c0-1.605 1.143-3.077 2.846-3.661 1.496-0.517 3.879-0.604 5.557 0.431 0.971 0.597 1.564 1.491 1.715 2.586 0.223 1.604-0.473 3.174-1.812 4.095-0.371 0.255-0.756 0.471-1.145 0.687-0.279 0.155-0.56 0.31-0.834 0.486-0.348 0.223-0.496 0.511-0.496 0.962v0.49z"></path>
        <path d="M14.92 22h2v2h-2v-2z"></path>
        <path d="M16 4c6.617 0 12 5.383 12 12s-5.383 12-12 12-12-5.383-12-12 5.383-12 12-12zM16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14c7.732 0 14-6.268 14-14s-6.268-14-14-14v0z"></path>
      </g>
      <g id="hide">
        <path d="M3.394 25.19l24.014-17.981 1.199 1.601-24.014 17.981-1.199-1.601z"></path>
        <path d="M6.224 20.581l1.667-1.25c-1.623-1.166-2.795-2.458-3.464-3.331 1.493-1.949 5.345-6 11.573-6 1.329 0 2.526 0.212 3.639 0.521l1.958-1.469c-1.632-0.632-3.489-1.052-5.597-1.052-9.333 0-14 8-14 8s1.414 2.407 4.224 4.581z"></path>
        <path d="M27.027 12.479l-1.624 1.218c0.954 0.848 1.696 1.683 2.17 2.303-1.493 1.949-5.345 6-11.573 6-0.527 0-1.013-0.066-1.506-0.12l-2.213 1.66c1.147 0.282 2.379 0.461 3.719 0.461 9.333 0 14-8 14-8s-0.999-1.693-2.973-3.521z"></path>
      </g>
      <g id="histogram_chart">
        <path d="M6 18h-4v12h4v-12z"></path>
        <path d="M12 10h-4v20h4v-20z"></path>
        <path d="M18 4h-4v26h4v-26z"></path>
        <path d="M24 10h-4v20h4v-20z"></path>
        <path d="M30 18h-4v12h4v-12z"></path>
      </g>
      <g id="history">
        <path d="M9.636 22.364c-3.509-3.509-3.509-9.219 0-12.728s9.218-3.509 12.727-0c-1.623 1.622-3.064 3.064-3.064 3.064 0.002 0.002 8.721 1.179 8.721 1.179l-1.178-8.721c0 0-1.442 1.441-3.065 3.063-4.288-4.288-11.268-4.288-15.556 0s-4.288 11.268 0 15.556 11.268 4.288 15.556 0l-1.414-1.414c-3.509 3.509-9.219 3.509-12.728 0z"></path>
        <path d="M15 15h-3v2h5v-7h-2z"></path>
      </g>
      <g id="home">
        <path d="M26.707 17l-10.707-10.707-6 6v-4.586h-2v6.586l-2.707 2.707 1.414 1.414 1.293-1.293v8.586h6v-6h2v6h8v-8.586l1.293 1.293 1.414-1.414zM22 23.707h-4v-6h-6v6h-2v-8.586l6-6 6 6v8.586z"></path>
      </g>
      <g id="horizontal_bar_chart">
        <path d="M28 2v6h-26v-6h26z"></path>
        <path d="M14 12v6h-12v-6h12z"></path>
        <path d="M22 22v6h-20v-6h20z"></path>
      </g>
      <g id="horizontal_bracket">
        <path d="M2 10h4v12h-4v-12z"></path>
        <path d="M6 14h20v4h-20v-4z"></path>
        <path d="M26 10h4v12h-4v-12z"></path>
      </g>
      <g id="image">
        <path d="M28 6h-26v20h28v-20zM28 24h-24v-16h24z"></path>
        <path d="M14 13c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M20 14l-6.858 6.666-3.142-2.666-4 4h20l-6-8z"></path>
      </g>
      <g id="indent">
        <path d="M4 12h24v4h-24v-4z"></path>
        <path d="M4 4h24v6h-24v-6z"></path>
        <path d="M14 18h14v4h-14v-4z"></path>
        <path d="M14 24h14v4h-14v-4z"></path>
        <path d="M12 22h-4v-4h4v4z"></path>
        <path d="M12 28h-4v-4h4v4z"></path>
      </g>
      <g id="indent_alt">
        <path d="M4 4h24v4h-24v-4z"></path>
        <path d="M14 10h14v4h-14v-4z"></path>
        <path d="M14 16h14v4h-14v-4z"></path>
        <path d="M14 22h14v4h-14v-4z"></path>
        <path d="M6 20v-10l6 5-6 5z"></path>
      </g>
      <g id="info">
        <path d="M12 24h8v2h-8v-2z"></path>
        <path d="M14 12h4v12h-4v-12z"></path>
        <path d="M12 12h2v2h-2v-2z"></path>
        <path d="M18 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
      </g>
      <g id="info_circle">
        <path d="M16 6c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zM16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12v0z"></path>
        <path d="M14.586 9.836v0c-0.781 0.781-0.781 2.047 0 2.828v0c0.781 0.781 2.047 0.781 2.828 0v0c0.781-0.781 0.781-2.047 0-2.828v0c-0.781-0.781-2.047-0.781-2.828 0z"></path>
        <path d="M17.5 20.75v-6h-4.5v2h1.5v4h-1.5v2h6v-2z"></path>
      </g>
      <g id="job_resubmit">
        <path d="M24 6h-10v20h16v-14l-6-6zM27.172 12h-3.172v-3.172l3.172 3.172zM28 24h-12v-16h6v6h6v10z"></path>
        <path d="M18 16h8v2h-8v-2z"></path>
        <path d="M18 20h8v2h-8v-2z"></path>
        <path d="M18 12h2v2h-2v-2z"></path>
        <path d="M7.523 7.523c-2.268 2.265-3.523 5.257-3.523 8.477 0 3.287 1.37 6.467 3.76 8.723l1.373-1.453c-2.020-1.908-3.133-4.49-3.133-7.269 0-2.682 1.058-5.166 2.947-7.053l3.053 3.053v-8h-8l3.523 3.523z"></path>
      </g>
      <g id="job_run">
        <path d="M16 4c6.617 0 12 5.383 12 12s-5.383 12-12 12-12-5.383-12-12 5.383-12 12-12zM16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14-6.268-14-14-14v0z"></path>
        <path d="M12 8v16l12-8z"></path>
      </g>
      <g id="job_suspend">
        <path d="M16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14c7.732 0 14-6.268 14-14s-6.268-14-14-14zM16 27.5c-6.341 0-11.5-5.159-11.5-11.5s5.159-11.5 11.5-11.5c6.341 0 11.5 5.159 11.5 11.5s-5.159 11.5-11.5 11.5z"></path>
        <path d="M10 10h4v12h-4v-12z"></path>
        <path d="M18 10h4v12h-4v-12z"></path>
      </g>
      <g id="jobs">
        <path d="M26 8h-4v-2c0-1.105-0.895-2-2-2h-8c-1.105 0-2 0.895-2 2v2h-4c-1.105 0-2 0.895-2 2v6c0 1.477 0.809 2.752 2 3.445v6.555c0 1.104 0.895 2 2 2h16c1.105 0 2-0.896 2-2v-6.555c1.191-0.693 2-1.968 2-3.445v-6c0-1.105-0.895-2-2-2zM12 6h8v2h-8v-2zM24 26h-16v-6h4c0 2.209 1.791 4 4 4s4-1.791 4-4h4v6zM14 20c0-1.103 0.897-2 2-2s2 0.897 2 2-0.897 2-2 2-2-0.897-2-2zM26 16c0 1.103-0.897 2-2 2h-4.555c-0.693-1.191-1.968-2-3.445-2s-2.752 0.809-3.445 2h-4.555c-1.103 0-2-0.897-2-2v-6h20v6z"></path>
      </g>
      <g id="join">
        <path d="M10 10h12v12h-12v-12z"></path>
        <path d="M10 2v6h14v14h6v-20h-20z"></path>
        <path d="M8 24v-14h-6v20h20v-6h-14z"></path>
      </g>
      <g id="join_intersect">
        <path d="M10 2v8h-8v20h20v-8h8v-20h-20zM20 28h-16v-16h6v10h10v6zM28 20h-6v-10h-10v-6h16v16z"></path>
      </g>
      <g id="join_intersect_left">
        <path d="M10 2v8h-8v20h20v-8h8v-20zM20.182 28.182h-16.364v-16.364h6.182v10.182h10.182z"></path>
      </g>
      <g id="join_intersect_right">
        <path d="M10 2v8h-8v20h20v-8h8v-20zM28.182 20.182h-6.182v-10.182h-10.182v-6.182h16.364z"></path>
      </g>
      <g id="join_left">
        <path d="M22 30v-8h8v-20h-20v8h-8v20zM12 12h8v8h-8zM4 12h6v10h10v6h-16z"></path>
      </g>
      <g id="join_outline">
        <path d="M10 2v8h-8v20h20v-8h8v-20zM20 20h-8v-8h8zM20 28h-16v-16h6v10h10zM28 20h-6v-10h-10v-6h16z"></path>
      </g>
      <g id="join_right">
        <path d="M10 2v8h-8v20h20v-8h8v-20zM20 20h-8v-8h8zM28 20h-6v-10h-10v-6h16z"></path>
      </g>
      <g id="join_union">
        <path d="M30 2h-20v8h-8v20h20v-8h8v-20z"></path>
      </g>
      <g id="latitude">
        <path d="M28 16c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 6.627 5.373 12 12 12v0c6.627 0 12-5.373 12-12v0zM25.568 15h-19.136c1.032-1.868 4.771-3.629 9.568-3.629s8.536 1.761 9.568 3.629zM6.432 17h19.136c-1.032 1.868-4.771 3.629-9.568 3.629s-8.536-1.761-9.568-3.629zM16 6c3.847 0.014 7.179 2.204 8.831 5.402l0.026 0.056c-2.43-1.392-5.342-2.212-8.446-2.212-0.145 0-0.289 0.002-0.433 0.005l0.021-0c-0.123-0.003-0.267-0.005-0.412-0.005-3.104 0-6.016 0.821-8.531 2.257l0.085-0.044c1.679-3.254 5.011-5.444 8.856-5.457h0.002zM7.142 20.542c2.431 1.392 5.342 2.212 8.446 2.212 0.145 0 0.289-0.002 0.433-0.005l-0.021 0c0.123 0.003 0.267 0.005 0.412 0.005 3.104 0 6.015-0.821 8.531-2.257l-0.085 0.044c-1.669 3.263-5.007 5.458-8.858 5.458s-7.189-2.195-8.832-5.402l-0.026-0.056z"></path>
      </g>
      <g id="layers">
        <path d="M4 10l12 4 12-4-12-4z"></path>
        <path d="M16.632 15.897l-0.632 0.211-6.162-2.054-5.838 1.946 12 4 12-4-5.838-1.946z"></path>
        <path d="M16.632 21.897l-0.632 0.211-6.162-2.054-5.838 1.946 12 4 12-4-5.838-1.946z"></path>
      </g>
      <g id="left">
        <path d="M20 8v16l-8-8 8-8z"></path>
      </g>
      <g id="left_arrow">
        <path d="M24 14v2h-16v-2h16z"></path>
        <path d="M13.24 22.65l-6.557-7.65 6.557-7.65 1.52 1.301-5.443 6.35 5.443 6.35z"></path>
      </g>
      <g id="left_chevron">
        <path d="M17.293 22.707l-6.707-6.707 6.707-6.707 1.414 1.414-5.293 5.293 5.293 5.293z"></path>
      </g>
      <g id="left_small">
        <path d="M18 22l-6-6 6-6v12z"></path>
      </g>
      <g id="lightning">
        <path d="M16 14h8l-12 14 4-10h-8l12-14z"></path>
      </g>
      <g id="line_chart">
        <path d="M8 15c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M14 21c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M24 9c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M30 15c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"></path>
        <path d="M11.051 22.111l-6.581-6.581 1.060-1.060 5.419 5.419 10-12 6.581 6.581-1.060 1.060-5.419-5.419z"></path>
      </g>
      <g id="link">
        <path d="M22 10v12c0 3.314-2.686 6-6 6s-6-2.686-6-6v-14c0-2.209 1.791-4 4-4s4 1.791 4 4v12c0 0.512-0.195 1.024-0.586 1.414s-0.902 0.586-1.414 0.586-1.024-0.195-1.414-0.586-0.586-0.902-0.586-1.414v-10h-2v10c0 1.068 0.416 2.073 1.172 2.828s1.76 1.172 2.828 1.172 2.073-0.416 2.828-1.172c0.756-0.755 1.172-1.76 1.172-2.828v-12c0-3.308-2.692-6-6-6s-6 2.692-6 6v14c0 4.411 3.589 8 8 8s8-3.589 8-8v-12h-2z"></path>
      </g>
      <g id="load_profile">
        <path d="M20 2h-16v28h24v-20l-8-8zM20 4.828l5.172 5.172h-5.172v-5.172zM26 28h-20v-24h12v8h8v16z"></path>
        <path d="M16 14h8v2h-8v-2z"></path>
        <path d="M16 20h8v2h-8v-2z"></path>
        <path d="M10 14.586l-1.293-1.293-1.414 1.414 2.707 2.707 4.707-4.707-1.414-1.414z"></path>
        <path d="M10 20.586l-1.293-1.293-1.414 1.414 2.707 2.707 4.707-4.707-1.414-1.414z"></path>
      </g>
      <g id="loading_spinner">
        <path d="M3.98 14.080c-1.097 0.014-1.98 0.906-1.98 2.005 0 0.005 0 0.010 0 0.015v-0.001c0.006 1.1 0.899 1.99 2 1.99 1.105 0 2-0.895 2-2 0-0.003 0-0.007-0-0.010v0.001c-0.013-1.106-0.912-1.998-2.019-2h-0z"></path>
        <path d="M7.439 9.58c0.004 0 0.008 0 0.012 0 0.553 0 1.052-0.23 1.407-0.6l0.001-0.001c0.354-0.361 0.573-0.856 0.573-1.403 0-1.106-0.897-2.004-2.004-2.004s-2.004 0.897-2.004 2.004c0 1.106 0.897 2.004 2.004 2.004 0.004 0 0.007 0 0.011-0h-0.001z"></path>
        <path d="M6.139 23.119c-0.356 0.363-0.576 0.86-0.576 1.409 0 1.106 0.893 2.004 1.998 2.011h0.001c0.004 0 0.008 0 0.012 0 0.553 0 1.052-0.23 1.407-0.599l0.001-0.001c0.35-0.36 0.565-0.852 0.565-1.394 0-1.106-0.896-2.002-2.002-2.002-0.547 0-1.044 0.22-1.405 0.576l0-0z"></path>
        <path d="M23.1 23.061c-0.366 0.358-0.593 0.857-0.593 1.409s0.227 1.051 0.592 1.409l0 0c0.363 0.366 0.865 0.592 1.421 0.592 1.105 0 2.001-0.896 2.001-2.001s-0.896-2.001-2.001-2.001c-0.556 0-1.058 0.226-1.421 0.592l-0 0z"></path>
        <path d="M16.039 26c-1.1 0.006-1.989 0.899-1.989 2 0 1.105 0.895 2 2 2 0.004 0 0.008 0 0.011-0h-0.001c1.1-0.006 1.989-0.899 1.989-2 0-1.105-0.895-2-2-2-0.004 0-0.008 0-0.011 0h0.001z"></path>
        <path d="M30 15.979c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M16 6c0.552-0.009 1.050-0.228 1.421-0.581l-0.001 0.001c0.352-0.37 0.571-0.868 0.58-1.418l0-0.002c-0.008-0.552-0.228-1.050-0.581-1.421l0.001 0.001c-0.372-0.344-0.871-0.555-1.42-0.555s-1.048 0.211-1.421 0.557l0.001-0.001c-0.353 0.369-0.573 0.868-0.58 1.419v0.001c0.008 0.552 0.227 1.051 0.581 1.421l-0.001-0.001c0.369 0.352 0.868 0.572 1.418 0.58l0.002 0z"></path>
      </g>
      <g id="local_system">
        <path d="M26 18v-12h-20v12l-4 10h28l-4-10zM8 8h16v10h-16v-10zM7.354 20h17.292l2.4 6h-22.092l2.4-6z"></path>
        <path d="M10.5 22l-0.5 2h12l-0.5-2z"></path>
      </g>
      <g id="lock">
        <path d="M22 12v-2c0-3.314-2.686-6-6-6s-6 2.686-6 6v2c-1.105 0-2 0.895-2 2v12c0 1.105 0.895 2 2 2h12c1.105 0 2-0.895 2-2v-12c0-1.105-0.895-2-2-2zM16 22c-1.105 0-2-0.895-2-2s0.895-2 2-2 2 0.895 2 2-0.895 2-2 2zM20 12h-8v-2c0-2.206 1.794-4 4-4s4 1.794 4 4v2z"></path>
      </g>
      <g id="longitude">
        <path d="M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.627 0 12-5.373 12-12v0c0-6.627-5.373-12-12-12v0zM15 6.432v19.136c-1.868-1.032-3.629-4.771-3.629-9.568s1.761-8.536 3.629-9.568zM17 25.568v-19.136c1.868 1.032 3.629 4.771 3.629 9.568s-1.761 8.536-3.629 9.568zM6 16c0.014-3.847 2.204-7.179 5.402-8.831l0.056-0.026c-1.392 2.43-2.212 5.342-2.212 8.446 0 0.145 0.002 0.289 0.005 0.433l-0-0.021c-0.003 0.123-0.005 0.267-0.005 0.412 0 3.104 0.821 6.016 2.257 8.531l-0.044-0.085c-3.254-1.679-5.444-5.011-5.457-8.856v-0.002zM20.542 24.858c1.392-2.43 2.212-5.342 2.212-8.446 0-0.145-0.002-0.289-0.005-0.433l0 0.021c0.003-0.123 0.005-0.267 0.005-0.412 0-3.104-0.821-6.016-2.257-8.531l0.044 0.085c3.263 1.669 5.458 5.007 5.458 8.858s-2.195 7.189-5.402 8.832l-0.056 0.026z"></path>
      </g>
      <g id="magic_wand">
        <path d="M3.152 21.807l0.732 1.5 1.66 0.23-1.197 1.16 0.287 1.645-1.482-0.77-1.463 0.77 0.285-1.645-1.196-1.16 1.641-0.23 0.733-1.5zM5.757 12.827l1.037 2.090 2.301 0.338-1.66 1.625 0.395 2.285-2.072-1.072-2.053 1.072 0.393-2.285-1.66-1.625 2.303-0.338 1.018-2.090zM7.222 26.538l0.518 1.055 1.16 0.16-0.84 0.82 0.197 1.16-1.035-0.553-1.053 0.553 0.195-1.16-0.84-0.82 1.16-0.16 0.537-1.055zM31.197 7.096l-19.352 21.548c-0.055 0.055-0.125 0.055-0.16 0.020l-5.195-4.68c-0.035-0.035-0.055-0.105 0-0.141l19.352-21.549c0.035-0.036 0.109-0.036 0.145 0l5.195 4.659c0.051 0.035 0.051 0.107 0.016 0.142zM14.203 16.843l-6.158 6.84c-0.037 0.035-0.037 0.106 0.016 0.141l3.625 3.25c0.035 0.055 0.107 0.035 0.143 0l6.143-6.836c0.035-0.055 0.035-0.127 0-0.162l-3.625-3.248c-0.035-0.037-0.108-0.037-0.143 0.016z"></path>
      </g>
      <g id="maps_chart">
        <path d="M25.751 9.438c-0.176 0.616-0.421 1.25-0.733 1.878l0.982 0.246v13.877l-5-1.25v-7.641c-0.315 0.127-0.648 0.207-0.992 0.207-0.349 0-0.687-0.082-1.008-0.214v7.648l-6 1.5v-13.877l1.995-0.499c-0.312-0.628-0.557-1.262-0.732-1.878l-2.263 0.566-8-2v18l8 2 8-2 8 2v-18l-2.249-0.562zM11 25.688l-5-1.25v-13.877l5 1.25v13.877z"></path>
        <path d="M19.437 14.465c0 0-3.422-4.276-3.422-6.473 0-2.214 1.794-3.991 3.993-3.991 2.213 0 3.992 1.777 3.992 3.992 0 2.197-3.422 6.473-3.422 6.473-0.319 0.386-0.822 0.386-1.141-0zM20.108 10.054c1.090 0 1.98-0.872 1.98-1.962 0-1.090-0.89-1.961-1.98-1.961-1.073 0-1.961 0.872-1.961 1.961 0 1.091 0.888 1.962 1.961 1.962z"></path>
      </g>
      <g id="max">
        <path d="M7.985 12.66l1.213 4.555 1.197-4.555h2.035v6.68h-1.269v-5.25l-1.32 5.25h-1.305l-1.32-5.25v5.25h-1.25v-6.68h2.020zM18.321 19.34l-0.59-1.519h-2.66l-0.553 1.519h-1.428l2.588-6.68h1.428l2.68 6.68h-1.465zM15.483 16.695h1.82l-0.928-2.481-0.893 2.481zM22.962 14.803l1.305-2.143h1.57l-2.088 3.25 2.285 3.428h-1.625l-1.482-2.303-1.48 2.303h-1.625l2.285-3.48-2.070-3.197h1.588l1.338 2.142z"></path>
        <path d="M27.691 10.309v11.381h-23.381v-11.381h23.381zM30 8h-28v16h28v-16z"></path>
      </g>
      <g id="memory_card">
        <path d="M19.172 6l4.828 4.828v15.172h-16v-20h11.172zM20 4h-14v24h20v-18l-6-6z"></path>
        <path d="M12 8h-2v4h2v-4z"></path>
        <path d="M16 8h-2v4h2v-4z"></path>
        <path d="M20 8h-2v4h2v-4z"></path>
        <path d="M10 14v10h12v-10h-12zM20 22h-8v-4h8v4z"></path>
      </g>
      <g id="message">
        <path d="M4 8v16h24v-16h-24zM6 10h20v2.764l-10 5-10-5v-2.764zM26 22h-20v-7l10 5 10-5v7z"></path>
      </g>
      <g id="metronome">
        <path d="M19.4 4h-8.8l-6.6 24h22l-2.967-10.79-1.627 1.627 0.32 1.164h-4.312l8.099-8.099c0.143 0.051 0.309 0.086 0.481 0.098l0.006 0c1.105 0 2-0.895 2-2s-0.895-2-2-2c-1.105 0-2 0.895-2 2v0c0.013 0.178 0.048 0.344 0.103 0.501l-0.004-0.014-9.513 9.513h-6.312l3.85-14h1.876v11.758l2-2v-9.758h1.876l1.7 6.182 1.627-1.627-1.803-6.555zM6.624 26l1.1-4h14.552l1.1 4z"></path>
      </g>
      <g id="min">
        <path d="M10.182 12.662l1.195 4.551 1.213-4.551h2.018v6.676h-1.25v-5.25l-1.34 5.25h-1.285l-1.32-5.25v5.25h-1.268v-6.676z"></path>
        <path d="M15.912 12.662h1.338v6.676h-1.338v-6.676z"></path>
        <path d="M23.855 12.662v6.676h-1.357l-2.695-4.355v4.355h-1.25v-6.676h1.32l2.732 4.461v-4.461z"></path>
        <path d="M27.691 10.309v11.381h-23.381v-11.381h23.381zM30 8h-28v16h28v-16z"></path>
      </g>
      <g id="minus">
        <path d="M6 14h20v4h-20v-4z"></path>
      </g>
      <g id="monitor">
        <path d="M28 6h-24v18h8.752c-0.7 2.935-2.752 4-2.752 4h12c0 0-2.052-1.065-2.752-4h8.752v-18zM26 20h-20v-12h20v12z"></path>
      </g>
      <g id="move">
        <path d="M17 25h-2v-18h2v18z"></path>
        <path d="M21 7h-10l5-6 5 6z"></path>
        <path d="M11 25h10l-5 6-5-6z"></path>
        <path d="M7 17v-2h18v2h-18z"></path>
        <path d="M25 21v-10l6 5-6 5z"></path>
        <path d="M7 11v10l-6-5 6-5z"></path>
      </g>
      <g id="move_to">
        <path d="M18 14h-10v4h10v4l6-6-6-6z"></path>
        <path d="M16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14c0-7.732-6.268-14-14-14zM16 28c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12z"></path>
      </g>
      <g id="navigate">
        <path d="M6 16l20-10-10 20v-10z"></path>
      </g>
      <g id="notepad">
        <path d="M10 14h12v2h-12v-2z"></path>
        <path d="M10 18h6v2h-6v-2z"></path>
        <path d="M10 22h10v2h-10v-2z"></path>
        <path d="M20 6c0-2.209-1.791-4-4-4s-4 1.791-4 4h-2v6h12v-6h-2zM20 10h-8v-2h2v-2c0-1.103 0.897-2 2-2s2 0.897 2 2v2h2v2z"></path>
        <path d="M22 6h-4v2h4c1.103 0 2 0.897 2 2v16c0 1.103-0.897 2-2 2h-12c-1.103 0-2-0.897-2-2v-16c0-1.103 0.897-2 2-2h4v-2h-4c-2.209 0-4 1.791-4 4v16c0 2.209 1.791 4 4 4h12c2.209 0 4-1.791 4-4v-16c0-2.209-1.791-4-4-4z"></path>
      </g>
      <g id="notification">
        <path d="M15.031 8c3.308 0 6 2.692 6 6v4.472l2.764 5.528h-17.528l2.764-5.528v-4.472c0-3.308 2.692-6 6-6zM15.031 6c-4.418 0-8 3.582-8 8v4l-2.805 5.61c-0.566 1.131 0.402 2.39 1.838 2.39h17.934c1.436 0 2.404-1.258 1.838-2.39l-2.805-5.61v-4c0-4.418-3.582-8-8-8v0z"></path>
        <path d="M17.031 6c0 1.105-0.895 0-2 0s-2 1.105-2 0 0.895-2 2-2 2 0.895 2 2z"></path>
        <path d="M17.031 26c0 1.105-0.895 2-2 2s-2-0.895-2-2 0.895 0 2 0 2-1.105 2 0z"></path>
      </g>
      <g id="numbered_list">
        <path d="M8.93 19.426h-4.85c-0.041-0.24-0.080-0.482-0.080-0.723 0-2.479 3.027-2.854 3.027-3.98 0-0.455-0.281-0.695-0.723-0.695-0.469 0-0.857 0.4-1.086 0.777l-1.139-0.791c0.441-0.924 1.354-1.447 2.371-1.447 1.246 0 2.318 0.736 2.318 2.062 0 1.984-2.908 2.426-2.947 3.471h1.701v-0.805h1.406v2.131z"></path>
        <path d="M6.357 28c-0.844 0-1.701-0.281-2.305-0.885l0.764-1.178c0.363 0.334 0.912 0.602 1.42 0.602 0.469 0 0.965-0.227 0.965-0.764 0-0.75-0.857-0.789-1.406-0.75l-0.348-0.75c0.482-0.615 0.924-1.299 1.5-1.822v-0.014c-0.43 0-0.871 0.027-1.299 0.027v0.711h-1.422v-2.037h4.463v1.18l-1.273 1.539c0.898 0.215 1.486 0.912 1.486 1.836 0 1.475-1.15 2.305-2.545 2.305z"></path>
        <path d="M8.943 10.852h-4.488v-1.326h1.434c0-1.086 0.014-2.17 0.014-3.256v-0.16h-0.027c-0.146 0.295-0.414 0.496-0.67 0.723l-0.951-1.018 1.822-1.701h1.42v5.412h1.447v1.326z"></path>
        <path d="M12 6h16v4h-16v-4z"></path>
        <path d="M12 14h16v4h-16v-4z"></path>
        <path d="M12 22h16v4h-16v-4z"></path>
      </g>
      <g id="numeral">
        <path d="M14.028 10.824c0-0.411 0.018-0.84 0.018-1.144v-0.518h-0.055l-0.213 0.393c-0.162 0.25-0.428 0.571-0.84 0.982l-1.998 1.856-2.607-2.749 6.143-5.928h3.926v20.925h5.266v3.641h-14.977v-3.641h5.338v-13.818z"></path>
      </g>
      <g id="numeric_formula">
        <path d="M6.566 26c-0.235-0.002-0.463-0.020-0.687-0.054l0.027 0.003c-0.213-0.027-0.403-0.065-0.587-0.116l0.028 0.007 0.24-1.16c0.105 0.025 0.25 0.057 0.43 0.090 0.147 0.030 0.316 0.047 0.489 0.049h0.001c0.019 0.001 0.041 0.001 0.063 0.001 0.389 0 0.751-0.116 1.053-0.314l-0.007 0.005c0.347-0.272 0.617-0.626 0.783-1.034l0.006-0.017c0.257-0.595 0.472-1.292 0.611-2.016l0.010-0.064 2.020-9.54h-1.82l0.201-0.939 1.92-0.42 0.16-0.74c0.215-1.174 0.782-2.189 1.588-2.958l0.002-0.002c0.781-0.617 1.781-0.989 2.867-0.989 0.099 0 0.198 0.003 0.295 0.009l-0.013-0.001c0.081-0.005 0.176-0.008 0.272-0.008 0.757 0 1.47 0.188 2.094 0.52l-0.024-0.012c0.461 0.236 0.776 0.699 0.799 1.237l0 0.003c0 0.006 0 0.014 0 0.022 0 0.431-0.235 0.806-0.584 1.006l-0.006 0.003c-0.438 0.237-0.96 0.376-1.513 0.376-0.069 0-0.137-0.002-0.205-0.006l0.009 0c0-0.018 0-0.040 0-0.062 0-0.463-0.070-0.91-0.2-1.331l0.009 0.032c-0.066-0.344-0.364-0.6-0.722-0.6-0.003 0-0.006 0-0.009 0h0c-0.010-0-0.022-0.001-0.034-0.001-0.403 0-0.754 0.219-0.942 0.545l-0.003 0.005c-0.265 0.483-0.455 1.046-0.538 1.644l-0.003 0.026-0.26 1.28h2.52l-0.279 1.359h-2.539l-1.9 8.94c-0.189 0.986-0.519 1.863-0.973 2.662l0.022-0.042c-0.361 0.63-0.826 1.158-1.376 1.581l-0.012 0.009c-0.463 0.349-1.008 0.621-1.597 0.783l-0.034 0.008c-0.494 0.137-1.062 0.217-1.648 0.221h-0.002z"></path>
        <path d="M15.687 22.102l0.173-0.926h0.229c0.009 0 0.020 0 0.031 0 0.198 0 0.389-0.029 0.569-0.083l-0.014 0.004c0.21-0.076 0.39-0.186 0.543-0.326l-0.001 0.001c0.26-0.228 0.497-0.461 0.72-0.708l0.007-0.007 2.203-2.433-1.207-2.903c-0.117-0.343-0.309-0.634-0.558-0.864l-0.001-0.001c-0.198-0.127-0.439-0.203-0.698-0.203-0.025 0-0.051 0.001-0.076 0.002l0.003-0h-0.208l0.173-0.927h3.29l1.225 3.324 2.429-3.324h2.136l-0.176 0.927h-0.313c-0.008-0-0.018-0-0.028-0-0.204 0-0.399 0.039-0.577 0.109l0.011-0.004c-0.211 0.093-0.391 0.219-0.542 0.375l-0 0c-0.238 0.239-0.462 0.493-0.669 0.761l-0.014 0.019-1.802 2.082 1.277 2.938c0.139 0.382 0.341 0.711 0.597 0.99l-0.002-0.002c0.192 0.16 0.442 0.257 0.714 0.257 0.025 0 0.050-0.001 0.074-0.002l-0.003 0h0.229l-0.176 0.926h-3.393l-1.313-3.533-2.728 3.533z"></path>
      </g>
      <g id="numeric_series">
        <path d="M19.998 26.91c-3.019 0-4.041-4.938-5.225-10.656-0.605-2.922-1.731-8.361-2.785-8.666-1.037 0.309-2.162 5.744-2.767 8.666-1.183 5.717-2.205 10.656-5.222 10.656v-2.5l-0.009 0.002c1.054-0.309 2.179-5.744 2.783-8.666 1.183-5.717 2.205-10.656 5.222-10.656 3.019 0 4.041 4.938 5.225 10.656 0.605 2.922 1.731 8.361 2.785 8.666 1.038-0.305 2.164-5.744 2.77-8.666 1.184-5.719 2.206-10.656 5.225-10.656v2.5c-1.046 0.303-2.172 5.742-2.777 8.664-1.184 5.719-2.206 10.656-5.225 10.656z"></path>
      </g>
      <g id="open_new_window">
        <path d="M2 2v20h10v-2h-8v-12h24v12h-8v2h10v-20h-28zM6 6h-2v-2h2v2zM10 6h-2v-2h2v2zM28 6h-16v-2h16v2z"></path>
        <path d="M16 12l-4 4h3v2c0 3.859-3.141 7-7 7v2c4.963 0 9-4.037 9-9v-2h3l-4-4z"></path>
      </g>
      <g id="options">
        <path d="M18 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M18 16c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M18 24c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
      </g>
      <g id="ordered_list">
        <path d="M10 6h18v4h-18v-4z"></path>
        <path d="M10 14h18v4h-18v-4z"></path>
        <path d="M10 22h18v4h-18v-4z"></path>
        <path d="M4 6h4v4h-4v-4z"></path>
        <path d="M4 14h4v4h-4v-4z"></path>
        <path d="M4 22h4v4h-4v-4z"></path>
      </g>
      <g id="pages">
        <path d="M27.868 6.984l-3.83-1.302-0.193 1.186 3.667 1.223c0.355 0.16 0.57 0.518 0.355 0.893l-6.373 19.816c0 0.215-0.16 0.375-0.375 0.375h-0.518l-7.695-2.285c-2.32-0.375-4.033-0.66-5.176-0.82-0.219-0.050-0.392-0.087-0.55-0.12l-0.893-0.146c-0.292-0.032-0.629-0.056-1.218-0.109l15.156 4.586c0 0 1.045 0.228 1.465 0 0.375-0.215 0.75-0.535 0.91-1.105l6.373-19.816c0.358-1.108-0.213-2.018-1.107-2.375z"></path>
        <path d="M19.122 27.906c0.73 0.162 1.48-0.373 1.48-1.105l3.243-19.932-0.028-0.009 0.213-1.18 0.008 0.003 0.029-0.178c0.16-0.52-0.359-1.27-1.107-1.27l-4.732-0.891v-0.537c0-0.732-0.535-1.088-1.266-1.088h-0.16l-12.748 0.891c-0.75 0-1.268 0.734-1.107 1.27l1.465 20.762c0 0.73 0.535 1.090 1.266 1.090h0.162l0.45 0.074c0.279 0.030 0.526 0.070 0.893 0.146l11.94 1.956zM4.053 3.717c0 0 0-0.213 0.16-0.213l12.748-0.895c0 0 0.195 0 0.195 0.197l1.445 20.729v0.195l-12.926 0.91-1.623-20.924z"></path>
        <path d="M10.587 5.877l-4.176 0.375c-0.359 0-0.572 0.357-0.572 0.732 0.213 0.355 0.375 0.535 0.75 0.535l4.195-0.375c0.375 0 0.535-0.32 0.535-0.695s-0.375-0.572-0.733-0.572z"></path>
        <path d="M9.159 8.609l-2.373 0.213c-0.375 0-0.572 0.322-0.572 0.697 0.197 0.356 0.375 0.57 0.732 0.57l2.375-0.215c0.355 0 0.535-0.355 0.535-0.73-0-0.322-0.34-0.535-0.697-0.535z"></path>
      </g>
      <g id="palette">
        <path d="M17.5 8c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path>
        <path d="M9.5 16c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path>
        <path d="M11.5 10c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path>
        <path d="M23.5 10c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"></path>
        <path d="M28.991 15.923l0.002-0.019h0.002c-0.002-0.221-0.025-0.437-0.038-0.655-0.012-0.208-0.014-0.418-0.036-0.623-0.019-0.177-0.054-0.348-0.080-0.522-0.038-0.262-0.072-0.525-0.125-0.781-0.015-0.073-0.039-0.142-0.055-0.215-1.36-5.829-6.511-10.105-12.661-10.108h-0l-0.319 0.004c-0.119 0.003-0.236 0.013-0.354 0.023l0.001 0.011c-0.098 0.005-0.195 0.008-0.292 0.015l-0.002-0.004c-0.049 0.003-0.097 0.008-0.147 0.012-0.102 0.009-0.204 0.014-0.305 0.025l-0.060 0.005c-0.186 0.021-0.369 0.051-0.743 0.113-0.058 0.009-0.116 0.021-0.174 0.031-0.099 0.018-0.199 0.032-0.298 0.053l-0.065 0.012c-0.178 0.038-0.353 0.086-0.526 0.133l0.002 0.007c-0.074 0.019-0.15 0.037-0.223 0.057l-0.002-0.004c-0.053 0.014-0.107 0.031-0.159 0.046-0.090 0.026-0.181 0.049-0.269 0.077l-0.060 0.017c-0.182 0.059-0.359 0.127-0.724 0.266-0.048 0.018-0.095 0.038-0.143 0.056-0.086 0.035-0.173 0.065-0.259 0.102l-0.054 0.021c-0.162 0.070-0.319 0.148-0.476 0.227l0.003 0.006c-0.072 0.035-0.145 0.068-0.216 0.104l-0.003-0.003c-0.053 0.026-0.104 0.054-0.158 0.081-0.075 0.039-0.151 0.075-0.225 0.115l-0.052 0.027c-0.16 0.089-0.314 0.186-0.469 0.282l0.003 0.005c-0.060 0.037-0.121 0.072-0.181 0.11l-0.003-0.003c-0.053 0.033-0.105 0.068-0.158 0.101-0.067 0.044-0.136 0.084-0.202 0.129l-0.051 0.032c-0.145 0.1-0.283 0.206-0.422 0.313l0.004 0.005c-0.061 0.046-0.122 0.090-0.182 0.136l-0.003-0.002c-0.049 0.037-0.097 0.077-0.146 0.114-0.064 0.051-0.13 0.098-0.192 0.15l-0.051 0.040c-0.135 0.113-0.264 0.234-0.394 0.354l0.005 0.005c-0.060 0.055-0.122 0.108-0.181 0.164l-0.004-0.003c-0.049 0.044-0.096 0.093-0.145 0.138-0.049 0.048-0.1 0.093-0.149 0.141l-0.044 0.042c-0.118 0.121-0.231 0.248-0.345 0.375l0.005 0.005c-0.062 0.068-0.125 0.135-0.185 0.204l-0.004-0.002c-0.043 0.047-0.084 0.098-0.127 0.145-0.044 0.052-0.090 0.1-0.133 0.152l-0.040 0.046c-0.104 0.129-0.202 0.264-0.3 0.398l0.005 0.004c-0.056 0.074-0.112 0.147-0.167 0.223l-0.004-0.002c-0.041 0.054-0.079 0.112-0.119 0.167-0.040 0.057-0.083 0.112-0.122 0.171l-0.029 0.041c-0.098 0.146-0.188 0.299-0.277 0.451l0.006 0.003c-0.046 0.075-0.093 0.15-0.137 0.226l-0.004-0.001c-0.038 0.061-0.073 0.126-0.11 0.189-0.028 0.050-0.060 0.098-0.087 0.149l-0.031 0.054c-0.076 0.144-0.145 0.291-0.214 0.439l0.006 0.003c-0.044 0.090-0.089 0.18-0.131 0.272l-0.004-0.001c-0.032 0.067-0.063 0.138-0.095 0.206-0.024 0.055-0.052 0.108-0.075 0.163l-0.024 0.052c-0.064 0.157-0.121 0.318-0.178 0.48l0.006 0.002c-0.034 0.091-0.068 0.182-0.1 0.274l-0.005-0c-0.027 0.073-0.051 0.15-0.077 0.224-0.018 0.055-0.039 0.108-0.056 0.163l-0.017 0.048c-0.049 0.162-0.090 0.329-0.13 0.496l0.006 0.001c-0.024 0.092-0.049 0.184-0.071 0.277l-0.004 0c-0.022 0.082-0.040 0.168-0.060 0.252-0.012 0.056-0.029 0.111-0.040 0.167l-0.013 0.053c-0.030 0.157-0.054 0.317-0.076 0.479l0.008 0.001c-0.017 0.108-0.035 0.215-0.049 0.324l-0.006 0.001c-0.014 0.094-0.025 0.188-0.037 0.282-0.006 0.052-0.015 0.102-0.020 0.154l-0.006 0.045c-0.016 0.165-0.022 0.334-0.029 0.502l0.008 0.002c-0.007 0.119-0.015 0.238-0.018 0.359l-0.007 0.001c-0.007 0.104-0.010 0.218-0.010 0.34l-0.002 0.049h0.001c0 0.012-0.001 0.020-0.001 0.033l0.009 0.233c0.014 0.581 0.080 1.139 0.195 1.678l-0.011-0.059c0.821 5.578 5.127 9.95 10.604 10.859l0.075 0.010c0.403 0.094 0.887 0.17 1.382 0.211l0.038 0.003 0.347 0.013c0.899-0.007 1.701-0.422 2.227-1.070l0.004-0.005c0.426-0.516 0.685-1.185 0.685-1.914 0-0.21-0.021-0.415-0.062-0.613l0.003 0.020-0.52-2.602c-0.039-0.187-0.061-0.402-0.061-0.622 0-1.753 1.421-3.175 3.175-3.175h4.898c1.648-0.017 2.979-1.351 2.992-2.999v-0.001h0.012c-0-0.026-0.004-0.051-0.004-0.077zM25.991 17h-4.898c-0 0-0.001 0-0.001 0-2.858 0-5.174 2.316-5.174 5.174 0 0.359 0.037 0.71 0.106 1.049l-0.006-0.033 0.52 2.602c0.012 0.060 0.020 0.129 0.020 0.2 0 0.248-0.088 0.475-0.235 0.652l0.001-0.002c-0.173 0.212-0.432 0.347-0.724 0.351h-0.001l-0.204-0.022c-0.432-0.038-0.824-0.101-1.206-0.19l0.057 0.011c-4.727-0.775-8.395-4.5-9.074-9.193l-0.007-0.059c-0.086-0.391-0.141-0.844-0.153-1.309l-0-0.010-0.013-0.22h0.004c0-0.391 0.021-0.778 0.060-1.158l-0.004 0.048 0.011-0.077c0.037-0.343 0.087-0.682 0.155-1.015l0.018-0.073c0.070-0.333 0.153-0.662 0.253-0.983l0.018-0.052c0.894-2.755 2.761-4.982 5.186-6.325l0.075-0.038q0.452-0.245 0.928-0.448l0.085-0.033c0.295-0.123 0.596-0.234 0.903-0.331l0.217-0.060c0.27-0.079 0.543-0.153 0.822-0.212 0.080-0.016 0.161-0.029 0.242-0.043 0.278-0.052 0.558-0.098 0.843-0.129 0.059-0.006 0.128-0.011 0.206-0.017 0.322-0.029 0.647-0.049 0.977-0.049 0.003 0 0.007 0 0.011 0 1.536 0 2.998 0.317 4.325 0.889l-0.071-0.027c0.295 0.125 0.581 0.265 0.862 0.415 0.027 0.014 0.056 0.026 0.083 0.040 2.171 1.195 3.863 3.029 4.851 5.247l0.028 0.071 0.018 0.037c0.113 0.262 0.208 0.532 0.301 0.804 0.024 0.071 0.055 0.139 0.077 0.21 0.070 0.219 0.122 0.445 0.178 0.67 0.032 0.13 0.073 0.257 0.1 0.389 0.038 0.183 0.060 0.372 0.090 0.559 0.028 0.178 0.063 0.354 0.082 0.535 0.018 0.166 0.019 0.336 0.029 0.504 0.013 0.218 0.033 0.433 0.033 0.654h0.003c-0.005 0.553-0.454 0.999-1.007 1h-0z"></path>
      </g>
      <g id="parameters">
        <path d="M9 6.184v-2.184h-2v2.184c-1.174 0.419-2 1.521-2 2.816s0.826 2.398 1.979 2.81l0.021 0.007v16.184h2v-16.184c1.174-0.419 2-1.521 2-2.816s-0.826-2.398-1.979-2.81l-0.021-0.006z"></path>
        <path d="M17 20.184v-16.184h-2v16.184c-1.174 0.419-2 1.521-2 2.816s0.826 2.398 1.979 2.81l0.021 0.006v2.184h2v-2.184c1.174-0.419 2-1.521 2-2.816s-0.826-2.398-1.979-2.81l-0.021-0.006z"></path>
        <path d="M27 15c-0.003-1.294-0.827-2.396-1.979-2.81l-0.021-0.007v-8.184h-2v8.184c-1.174 0.419-2 1.521-2 2.816s0.826 2.398 1.979 2.81l0.021 0.006v10.184h2v-10.184c1.173-0.421 1.997-1.522 2-2.816v-0z"></path>
      </g>
      <g id="parameters_outline">
        <path d="M12 9c-0.006-1.848-1.265-3.401-2.972-3.852l-0.028-0.006v-1.142h-2v1.142c-1.738 0.453-3 2.008-3 3.858s1.262 3.405 2.972 3.852l0.028 0.006v15.142h2v-15.142c1.735-0.457 2.994-2.010 3-3.857v-0.001zM8 11c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c-0.001 1.104-0.896 1.999-2 2h-0z"></path>
        <path d="M17 19.142v-15.142h-2v15.142c-1.738 0.453-3 2.008-3 3.858s1.262 3.405 2.972 3.852l0.028 0.006v1.142h2v-1.142c1.738-0.453 3-2.008 3-3.858s-1.262-3.405-2.972-3.852l-0.028-0.006zM16 25c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c-0.001 1.104-0.896 1.999-2 2h-0z"></path>
        <path d="M28 15c-0.006-1.848-1.265-3.401-2.972-3.852l-0.028-0.006v-7.142h-2v7.142c-1.738 0.453-3 2.008-3 3.858s1.262 3.405 2.972 3.852l0.028 0.006v9.142h2v-9.142c1.735-0.457 2.994-2.010 3-3.857v-0.001zM24 17c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c-0.001 1.104-0.896 1.999-2 2h-0z"></path>
      </g>
      <g id="paste">
        <path d="M24 12h-12v20h18v-14zM24 14.828l3.172 3.172h-3.172zM28 30h-14v-16h8v6h6z"></path>
        <path d="M16 18h4v2h-4v-2z"></path>
        <path d="M16 22h10v2h-10v-2z"></path>
        <path d="M16 26h8v2h-8v-2z"></path>
        <path d="M4.594 25.406c-0.366-0.35-0.594-0.843-0.594-1.389 0-0.006 0-0.012 0-0.019v0.001-16c-0-0.005-0-0.011-0-0.017 0-0.546 0.228-1.039 0.593-1.389l0.001-0.001c0.351-0.366 0.843-0.594 1.389-0.594 0.006 0 0.012 0 0.018 0h-0.001v4h12v-4c1.098 0.015 1.985 0.902 2 1.999l0 0.001v2h2v-2c0-0.018 0-0.039 0-0.060 0-1.086-0.449-2.067-1.171-2.767l-0.001-0.001c-0.701-0.723-1.682-1.172-2.768-1.172-0.021 0-0.042 0-0.063 0.001l0.003-0h-2c0-0.018 0-0.039 0-0.060 0-1.086-0.449-2.067-1.171-2.767l-0.001-0.001c-0.701-0.723-1.682-1.172-2.768-1.172-0.021 0-0.042 0-0.063 0.001l0.003-0c-0.018-0-0.039-0-0.060-0-1.086 0-2.066 0.449-2.767 1.171l-0.001 0.001c-0.723 0.701-1.172 1.682-1.172 2.768 0 0.021 0 0.042 0 0.063l-0-0.003h-2c-0.018-0-0.039-0-0.060-0-1.086 0-2.066 0.449-2.767 1.171l-0.001 0.001c-0.723 0.701-1.172 1.682-1.172 2.768 0 0.021 0 0.042 0 0.063l-0-0.003v16c-0 0.018-0 0.039-0 0.060 0 1.086 0.449 2.066 1.171 2.767l0.001 0.001c0.701 0.723 1.682 1.172 2.768 1.172 0.021 0 0.042-0 0.064-0l-0.003 0h4v-2h-4c-0.005 0-0.011 0-0.018 0-0.546 0-1.038-0.228-1.388-0.593l-0.001-0.001zM8 6h2v-2c-0-0.005-0-0.011-0-0.017 0-0.546 0.228-1.039 0.593-1.389l0.001-0.001c0.357-0.366 0.855-0.594 1.406-0.594s1.049 0.227 1.406 0.593l0 0c0.366 0.351 0.594 0.844 0.594 1.39 0 0.006-0 0.011-0 0.017v-0.001 2h2v2h-8z"></path>
      </g>
      <g id="pause">
        <path d="M10 8h4v16h-4v-16z"></path>
        <path d="M18 8h4v16h-4v-16z"></path>
      </g>
      <g id="pie_chart">
        <path d="M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12h-12v-12z"></path>
        <path d="M18 2v12h12c0-6.627-5.373-12-12-12z"></path>
      </g>
      <g id="pin">
        <path d="M17.414 3.272l-1.414 1.414 2.828 2.828-5.657 5.657h-5.657l-1.414 1.414 4.243 4.243-7.071 9.9 9.9-7.071 4.243 4.243 1.414-1.414v-5.657l5.657-5.657 2.828 2.828 1.414-1.414zM17.414 17.414l-0.586 0.586v4.485l-7.314-7.314h4.485l6.242-6.243 2.828 2.828z"></path>
      </g>
      <g id="pivot">
        <path d="M0 32h10v-22h-10v22zM2 12h6v18h-6v-18z"></path>
        <path d="M4 18h2v2h-2v-2z"></path>
        <path d="M4 14h2v2h-2v-2z"></path>
        <path d="M4 22h2v2h-2v-2z"></path>
        <path d="M4 26h2v2h-2v-2z"></path>
        <path d="M10 0v10h22v-10h-22zM30 8h-18v-6h18v6z"></path>
        <path d="M18 4h2v2h-2v-2z"></path>
        <path d="M14 4h2v2h-2v-2z"></path>
        <path d="M22 4h2v2h-2v-2z"></path>
        <path d="M26 4h2v2h-2v-2z"></path>
        <path d="M22 18h3c0 3.8-3.2 7-7 7v0-3l-6 4 6 4v-3c5 0 9-4 9-9v0h3l-4-6-4 6z"></path>
      </g>
      <g id="placeholder">
        <path d="M4 4v24h24v-24h-24zM14.6 16l-8.6 8.6v-17.2l8.6 8.6zM7.4 6h17.2l-8.6 8.6-8.6-8.6zM16 17.4l8.6 8.6h-17.2l8.6-8.6zM17.4 16l8.6-8.6v17.2l-8.6-8.6z"></path>
      </g>
      <g id="play">
        <path d="M10 8v16l14-8z"></path>
      </g>
      <g id="plug">
        <path d="M26 11.657l-1.414-1.414-4.243 4.243-2.828-2.828 4.243-4.243-1.414-1.414-4.243 4.243-2.828-2.828-2.829 2.829c-1.437 1.442-2.325 3.431-2.325 5.628 0 1.859 0.636 3.569 1.702 4.925l-0.013-0.017-4.314 4.314 1.414 1.414 4.314-4.314c1.336 1.064 3.049 1.707 4.912 1.707 2.199 0 4.188-0.896 5.623-2.343l2.829-2.829-2.828-2.829zM20.343 20.142c-1.085 1.079-2.58 1.746-4.231 1.746-3.314 0-6-2.686-6-6 0-1.651 0.667-3.146 1.746-4.231l1.414-1.414 8.485 8.485z"></path>
      </g>
      <g id="polygon_chart">
        <path d="M27 13c-0.295 0-0.575 0.056-0.844 0.135l-3.019-5.032c0.533-0.542 0.863-1.283 0.863-2.103 0-1.657-1.343-3-3-3-1.396 0-2.559 0.958-2.894 2.25h-4.212c-0.335-1.292-1.498-2.25-2.894-2.25-1.657 0-3 1.343-3 3 0 0.82 0.331 1.561 0.864 2.103l-3.019 5.032c-0.27-0.079-0.549-0.135-0.844-0.135-1.657 0-3 1.343-3 3 0 1.599 1.255 2.894 2.832 2.983l0.865 4.326c-1.001 0.486-1.697 1.503-1.697 2.691 0 1.657 1.343 3 3 3s3-1.343 3-3c0-0.555-0.161-1.069-0.424-1.515l3.909-3.909c0.446 0.263 0.96 0.424 1.515 0.424 1.566 0 2.837-1.205 2.973-2.735l6.289-1.048c0.467 1.049 1.515 1.783 2.738 1.783 1.657 0 3-1.343 3-3s-1.343-3-3-3zM15 15c-1.657 0-3 1.343-3 3 0 0.555 0.161 1.069 0.424 1.515l-3.909 3.909c-0.4-0.236-0.856-0.38-1.347-0.407l-0.866-4.326c1.001-0.486 1.697-1.503 1.697-2.691 0-0.82-0.33-1.562-0.864-2.103l3.019-5.032c0.269 0.079 0.549 0.135 0.844 0.135 1.396 0 2.559-0.959 2.894-2.25h4.212c0.335 1.292 1.498 2.25 2.894 2.25 0.295 0 0.575-0.056 0.844-0.135l3.019 5.032c-0.474 0.482-0.773 1.126-0.837 1.838l-6.289 1.048c-0.467-1.049-1.515-1.783-2.738-1.783z"></path>
      </g>
      <g id="powerpoint">
        <path d="M13.4 18.4c0.4 0 0.6 0 1 0 1.4 0 2.6-0.4 3.2-1.2 0.6-0.4 0.8-1.2 0.8-2.2s-0.4-1.6-1-2.2c-0.4-0.4-1.4-0.8-2.8-0.8-1 0-2 0-2.6 0.2v10.4h1.4v-4.2zM14.6 13c1.4 0 2.4 0.6 2.4 2s-1 2.2-2.6 2.2c-0.4 0-0.8 0-1.2-0.2v-4c0.4 0.2 0.8 0 1.4 0z"></path>
        <path d="M20 2h-16v28h24v-20l-8-8zM25.2 10h-5.2v-5.2l5.2 5.2zM26 28h-20v-24h12v8h8v16z"></path>
      </g>
      <g id="print">
        <path d="M28 12h-4v-2l-6-6h-10v8h-4v12h4v4h16v-4h4v-12zM10 6h8v4h4v2h-12v-6zM22 26h-12v-4h12v4zM26 22h-2v-2h-16v2h-2v-8h20v8z"></path>
        <path d="M22 16h2v2h-2v-2z"></path>
      </g>
      <g id="properties">
        <path d="M6 6h20v4h-20v-4z"></path>
        <path d="M6 14h20v4h-20v-4z"></path>
        <path d="M6 22h20v4h-20v-4z"></path>
        <path d="M2 2h2v28h-2v-28z"></path>
        <path d="M4 28h4v2h-4v-2z"></path>
        <path d="M4 2h4v2h-4v-2z"></path>
        <path d="M30 30h-2v-28h2v28z"></path>
        <path d="M28 4h-4v-2h4v2z"></path>
        <path d="M28 30h-4v-2h4v2z"></path>
      </g>
      <g id="property_alt">
        <path d="M10 12h16v2h-16v-2z"></path>
        <path d="M6 12h2v2h-2v-2z"></path>
        <path d="M10 16h16v2h-16v-2z"></path>
        <path d="M6 16h2v2h-2v-2z"></path>
        <path d="M10 20h16v2h-16v-2z"></path>
        <path d="M6 20h2v2h-2v-2z"></path>
        <path d="M28 8v16h-24v-16h24zM30 6h-28v20h28v-20z"></path>
        <path d="M4 8h24v2h-24v-2z"></path>
      </g>
      <g id="python">
        <path d="M15.833 1.846c-1.141 0.001-2.258 0.101-3.343 0.292l0.116-0.017c-2.858 0.505-3.377 1.562-3.377 3.511v2.574h6.754v0.858h-9.288c-0.023-0-0.050-0.001-0.077-0.001-2.049 0-3.756 1.461-4.137 3.398l-0.004 0.027c-0.302 1.028-0.475 2.21-0.475 3.432s0.174 2.404 0.498 3.521l-0.022-0.089c0.48 1.999 1.627 3.424 3.589 3.424h2.322v-3.086c0.053-2.304 1.913-4.156 4.215-4.195l0.004-0h6.746c1.868-0.015 3.377-1.532 3.377-3.402 0-0.010-0-0.021-0-0.031v0.002-6.431c-0.121-1.843-1.549-3.317-3.36-3.509l-0.016-0.001c-1.021-0.176-2.198-0.276-3.398-0.276-0.042 0-0.085 0-0.127 0l0.007-0zM12.181 3.916c0.006-0 0.013-0 0.020-0 0.711 0 1.287 0.576 1.287 1.287s-0.576 1.287-1.287 1.287c-0.71 0-1.285-0.574-1.287-1.283v-0c-0-0.003-0-0.006-0-0.010 0-0.703 0.566-1.273 1.267-1.281h0.001z"></path>
        <path d="M23.571 9.064v2.999c-0.027 2.332-1.892 4.22-4.213 4.282l-0.006 0h-6.746c-1.869 0.038-3.37 1.559-3.377 3.431v6.432c0 1.83 1.592 2.907 3.377 3.432 1.008 0.327 2.169 0.515 3.373 0.515s2.365-0.188 3.453-0.537l-0.080 0.022c1.7-0.492 3.377-1.483 3.377-3.432v-2.574h-6.746v-0.858h10.123c1.963 0 2.694-1.369 3.377-3.424 0.33-1.026 0.52-2.207 0.52-3.432s-0.19-2.406-0.542-3.514l0.023 0.082c-0.485-1.954-1.412-3.424-3.377-3.424zM19.777 25.35c0.006-0 0.013-0 0.020-0 0.711 0 1.287 0.576 1.287 1.287s-0.576 1.287-1.287 1.287c-0.711 0-1.287-0.576-1.287-1.287 0-0.001 0-0.003 0-0.004v0c-0-0.003-0-0.005-0-0.008 0-0.701 0.567-1.27 1.267-1.275h0z"></path>
      </g>
      <g id="radar_chart">
        <path d="M23 3.876h-14l-7 12.124 7 12.124h14l7-12.124-7-12.124zM27.113 15h-2.661l-3.282-5.685 1.355-2.262 4.588 7.947zM19.518 8.181h-7.045l-1.383-2.305h9.808l-1.381 2.305zM18.32 10.181l-2.321 3.875-2.325-3.875h4.646zM14.234 15h-4.376l2.146-3.717 2.23 3.717zM14.235 17l-2.229 3.721-2.148-3.721h4.377zM16 17.944l2.325 3.875h-4.647l2.322-3.875zM12.48 23.819h7.045l1.383 2.305h-9.809l1.381-2.305zM17.766 17h4.377l-2.146 3.717-2.23-3.717zM17.764 15l2.23-3.722 2.149 3.722h-4.379zM21.875 5.926l-0.085-0.051h0.055l0.029 0.051zM10.208 5.876l-0.081 0.049 0.028-0.049h0.053zM9.47 7.061l1.356 2.261-3.278 5.678h-2.661l4.583-7.939zM4.887 17h2.661l3.281 5.684-1.355 2.262-4.588-7.946zM10.127 26.076l0.080 0.048h-0.052l-0.028-0.048zM21.794 26.124l0.079-0.047-0.027 0.047h-0.052zM22.529 24.94l-1.356-2.261 3.279-5.679h2.661l-4.584 7.94z"></path>
      </g>
      <g id="randomize">
        <path d="M24 21h-1.467c-2.17 0-4.252-1.031-5.567-2.757l-4.341-5.698c-1.692-2.22-4.368-3.545-7.158-3.545h-1.467v2h1.467c2.17 0 4.252 1.031 5.567 2.757l4.341 5.698c1.692 2.22 4.369 3.545 7.158 3.545h1.467v3l4-4-4-4v3z"></path>
        <path d="M16.965 13.758c1.316-1.727 3.398-2.758 5.568-2.758h1.467v3l4-4-4-4v3h-1.467c-2.789 0-5.466 1.325-7.159 3.545l-0.117 0.154 1.257 1.651 0.451-0.592z"></path>
        <path d="M11.035 18.242c-1.316 1.727-3.398 2.758-5.568 2.758h-1.467v2h1.467c2.79 0 5.466-1.325 7.159-3.545l0.117-0.154-1.257-1.651-0.451 0.592z"></path>
      </g>
      <g id="ranking_horiz_chart">
        <path d="M26 16h6v4h-6v-4z"></path>
        <path d="M2 0h6v20h-6v-20z"></path>
        <path d="M10 6h6v14h-6v-14z"></path>
        <path d="M18 12h6v8h-6v-8z"></path>
        <path d="M24 26h-14.189c-0.143-0.412-0.355-0.794-0.686-1.125-0.583-0.583-1.292-0.875-2.125-0.875s-1.542 0.292-2.125 0.875c-0.583 0.583-0.875 1.292-0.875 2.125s0.292 1.542 0.875 2.125c0.583 0.583 1.292 0.875 2.125 0.875s1.542-0.292 2.125-0.875c0.331-0.331 0.543-0.713 0.686-1.125h14.189v4l6-5-6-5v4zM7.708 27.708c-0.194 0.194-0.431 0.292-0.708 0.292s-0.514-0.097-0.708-0.292-0.292-0.431-0.292-0.708 0.097-0.514 0.292-0.708 0.431-0.292 0.708-0.292c0.278 0 0.514 0.097 0.708 0.292s0.292 0.431 0.292 0.708-0.097 0.514-0.292 0.708z"></path>
      </g>
      <g id="ranking_vert_chart">
        <path d="M12 26h4v6h-4v-6z"></path>
        <path d="M12 2h20v6h-20v-6z"></path>
        <path d="M12 10h14v6h-14v-6z"></path>
        <path d="M12 18h8v6h-8v-6z"></path>
        <path d="M6 24v-14.189c0.412-0.143 0.794-0.355 1.125-0.686 0.583-0.583 0.875-1.292 0.875-2.125s-0.292-1.542-0.875-2.125c-0.583-0.583-1.292-0.875-2.125-0.875s-1.542 0.292-2.125 0.875c-0.583 0.583-0.875 1.292-0.875 2.125s0.292 1.542 0.875 2.125c0.331 0.331 0.713 0.543 1.125 0.686v14.189h-4l5 6 5-6h-4zM5 8c-0.278 0-0.514-0.097-0.708-0.292s-0.292-0.431-0.292-0.708 0.097-0.514 0.292-0.708 0.431-0.292 0.708-0.292 0.514 0.097 0.708 0.292 0.292 0.431 0.292 0.708-0.097 0.514-0.292 0.708-0.431 0.292-0.708 0.292z"></path>
      </g>
      <g id="redo">
        <path d="M7.987 10.626l9.089-4.17-2.541 11.728-6.548-7.558z"></path>
        <path d="M24.851 25.702l-1.975-0.316c0.197-1.231 0.182-2.484-0.046-3.724-0.833-4.543-4.451-8.106-9.004-8.868l0.33-1.973c5.381 0.9 9.657 5.112 10.641 10.479 0.269 1.463 0.287 2.944 0.054 4.401z"></path>
      </g>
      <g id="refresh">
        <path d="M16.5 9.051v-3.051l-6.5 4 6.5 4v-2.949c3.623 0.262 6.5 3.261 6.5 6.949 0 3.859-3.141 7-7 7s-7-3.141-7-7c0-0.553-0.447-1-1-1s-1 0.447-1 1c0 4.963 4.037 9 9 9s9-4.037 9-9c0-4.792-3.774-8.684-8.5-8.949z"></path>
      </g>
      <g id="relate">
        <path d="M21.75 16c0-1.078-0.265-2.087-0.702-3h-2.323c0.635 0.838 1.026 1.87 1.026 3s-0.391 2.162-1.025 3c-0.67 0.885-1.62 1.536-2.725 1.823-0.402 0.105-0.816 0.177-1.25 0.177h-6.75c-2.757 0-5-2.242-5-5s2.243-5 5-5h1.774c0.515-0.768 1.169-1.424 1.89-2h-3.663c-3.859 0-7 3.141-7 7s3.141 7 7 7h6.75c0.428 0 0.843-0.052 1.25-0.126 1.4-0.254 2.655-0.918 3.633-1.874 0.586-0.572 1.057-1.253 1.414-2 0.437-0.913 0.702-1.922 0.702-3z"></path>
        <path d="M24 9h-6.75c-0.428 0-0.843 0.052-1.25 0.126-1.4 0.254-2.655 0.918-3.633 1.874-0.586 0.572-1.057 1.253-1.414 2-0.437 0.913-0.702 1.922-0.702 3s0.265 2.087 0.702 3h2.323c-0.634-0.838-1.025-1.87-1.025-3s0.391-2.162 1.026-3c0.67-0.885 1.62-1.535 2.724-1.822 0.402-0.104 0.816-0.178 1.25-0.178h6.75c2.757 0 5 2.243 5 5s-2.243 5-5 5h-1.774c-0.515 0.768-1.169 1.424-1.89 2h3.663c3.859 0 7-3.141 7-7s-3.141-7-7-7z"></path>
      </g>
      <g id="resolution">
        <path d="M2 6v20h28v-20zM28 24h-24v-16h24z"></path>
        <path d="M12 22v-2h-4v-4h-2v6h6z"></path>
        <path d="M24 16h2v-6h-6v2h4v4z"></path>
      </g>
      <g id="rewind">
        <path d="M16 16l10 6v-12z"></path>
        <path d="M6 16l10 6v-12z"></path>
      </g>
      <g id="richtext_chart">
        <path d="M13 24.8v3.4h-9v-3.4h2.2l7.2-21h5.2l7.2 21h2.2v3.4h-9v-3.4h2.4l-1.4-4.6h-7.8l-1.6 4.6h2.4zM15.8 8.4c0 0.4 0 0.8-0.4 1.4l-2.2 7h5.6l-2.2-7-0.4-1.4c-0.2-0.2-0.2-0.4-0.2-0.6v0l-0.2 0.6z"></path>
      </g>
      <g id="right">
        <path d="M12 24v-16l8 8-8 8z"></path>
      </g>
      <g id="right_arrow">
        <path d="M8 16v-2h16v2h-16z"></path>
        <path d="M18.76 22.65l-1.52-1.301 5.443-6.35-5.443-6.35 1.52-1.301 6.557 7.65z"></path>
      </g>
      <g id="right_chevron">
        <path d="M14.707 22.707l-1.414-1.414 5.293-5.293-5.293-5.293 1.414-1.414 6.707 6.707z"></path>
      </g>
      <g id="right_small">
        <path d="M14 10l6 6-6 6v-12z"></path>
      </g>
      <g id="rows">
        <path d="M29 3h-26v26h26v-26zM5 11v-6h22v6zM5 19v-6h22v6zM5 27v-6h22v6z"></path>
      </g>
      <g id="rupee">
        <path d="M22 9v-2.5h-12v3h4c0.914 0 1.68 0.517 2.116 1.25h-6.116v2.5h6.116c-0.436 0.733-1.202 1.25-2.116 1.25h-4v3h0.010l6.942 7.932h3.988l-6.94-7.932c2.602 0 4.774-1.82 5.344-4.25h2.656v-2.5h-2.656c-0.148-0.632-0.399-1.223-0.744-1.75h3.401z"></path>
      </g>
      <g id="scatter_chart">
        <path d="M12 22c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M26 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M20 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M6 26v-22h-2v24h24v-2z"></path>
        <path d="M14 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
        <path d="M18 8c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"></path>
      </g>
      <g id="schedule">
        <path d="M2 2v28h28v-28zM10 28h-6v-6h6zM10 20h-6v-6h6zM10 12h-6v-6h6zM28 28h-16v-6h16zM28 20h-16v-6h16zM28 12h-16v-6h16z"></path>
        <path d="M6 8h2v2h-2v-2z"></path>
        <path d="M6 24h2v2h-2v-2z"></path>
        <path d="M14 8h8v2h-8v-2z"></path>
        <path d="M24 8h2v2h-2v-2z"></path>
        <path d="M14 16h4v2h-4v-2z"></path>
        <path d="M24 16h2v2h-2v-2z"></path>
        <path d="M14 24h6v2h-6v-2z"></path>
        <path d="M24 24h2v2h-2v-2z"></path>
      </g>
      <g id="screencapture">
        <path d="M26 6h-6c-0 0-0 0-0.001 0-1.104 0-1.999 0.895-1.999 1.999 0 0 0 0 0 0.001v-0 2h-6v-2h-4v2h-2c-1.104 0-2 0.896-2 2v12c0 0 0 0 0 0.001 0 1.104 0.895 1.999 1.999 1.999 0 0 0 0 0.001 0h20c0.001 0 0.001 0 0.002 0 1.104 0 1.998-0.895 1.998-1.998 0-0.001 0-0.001 0-0.002v0-16c0-0 0-0 0-0.001 0-1.104-0.895-1.999-1.999-1.999-0 0-0 0-0.001 0h0zM23 8c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1h0zM6 24v-12h4.758c-1.693 1.458-2.758 3.605-2.758 6s1.065 4.542 2.748 5.991l0.010 0.009zM16 24c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6v0c-0.004 3.312-2.688 5.996-6 6h-0zM26 24h-4.76c1.694-1.458 2.76-3.604 2.76-6s-1.066-4.542-2.75-5.991l-0.010-0.009h4.76z"></path>
        <path d="M16 14c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4v0c-0.001-2.209-1.791-3.999-4-4h-0zM16 20c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c-0.001 1.104-0.896 1.999-2 2h-0z"></path>
      </g>
      <g id="search">
        <path d="M26.85 25.436c-0.002-0.002-0.004-0.002-0.006-0.004l0.001-0.001-5.993-5.993c2.821-3.533 2.637-8.677-0.636-11.95-3.515-3.515-9.213-3.515-12.728 0s-3.515 9.213 0 12.728c3.273 3.272 8.416 3.457 11.95 0.636l5.994 5.992c0.002 0.002 0.002 0.004 0.004 0.006 0.395 0.395 1.032 0.399 1.422 0.008s0.387-1.027-0.008-1.422zM18.801 18.801c-2.729 2.729-7.17 2.729-9.899 0s-2.729-7.17 0-9.899c2.729-2.729 7.17-2.729 9.899 0s2.729 7.17 0 9.899z"></path>
      </g>
      <g id="select_all">
        <path d="M20.533 4v8h-8v-8h8zM22.533 2h-12v12h12v-12z"></path>
        <path d="M14.586 6.868l1.414 1.414 2.481-2.478 1.061 1.061-3.542 3.542-2.475-2.478z"></path>
        <path d="M20.533 20v8h-8v-8h8zM22.533 18h-12v12h12v-12z"></path>
        <path d="M14.586 22.868l1.414 1.414 2.481-2.478 1.061 1.061-3.542 3.542-2.475-2.478z"></path>
      </g>
      <g id="select_inverse">
        <path d="M20.533 4v8h-8v-8h8zM22.533 2h-12v12h12v-12z"></path>
        <path d="M14.586 6.868l1.414 1.414 2.481-2.478 1.061 1.061-3.542 3.542-2.475-2.478z"></path>
        <path d="M6.933 15.906l-6.4-4.8 6.8-2.4-0.4 7.2z"></path>
        <path d="M8.143 24.92c-2.922-1.24-4.795-3.070-5.568-5.439-1.283-3.931 1.002-7.829 1.1-7.993l1.719 1.023c-0.020 0.032-1.918 3.304-0.912 6.36 0.588 1.791 2.084 3.207 4.443 4.209l-0.781 1.84z"></path>
        <path d="M26.133 16.675l6.4 4.8-6.8 2.4 0.4-7.2z"></path>
        <path d="M29.393 21.094l-1.719-1.021c0.020-0.033 1.918-3.305 0.912-6.362-0.588-1.791-2.084-3.206-4.443-4.208l0.781-1.842c2.922 1.24 4.795 3.071 5.568 5.44 1.283 3.931-1.002 7.829-1.1 7.993z"></path>
        <path d="M20.533 20v8h-8v-8h8zM22.533 18h-12v12h12v-12z"></path>
        <path d="M14.586 22.868l1.414 1.414 2.481-2.478 1.061 1.061-3.542 3.542-2.475-2.478z"></path>
      </g>
      <g id="select_none">
        <path d="M20.533 4v8h-8v-8h8zM22.533 2h-12v12h12v-12z"></path>
        <path d="M20.533 20v8h-8v-8h8zM22.533 18h-12v12h12v-12z"></path>
      </g>
      <g id="server">
        <path d="M27 9v-6h-22v6h10v2h-10v6h10v2h-10v6h10v2h-6v2h14v-2h-6v-2h10v-6h-10v-2h10v-6h-10v-2h10zM7 23v-2h10v2h-10zM25 21v2h-2v-2h2zM21 21v2h-2v-2h2zM7 15v-2h10v2h-10zM25 13v2h-2v-2h2zM21 13v2h-2v-2h2zM25 5v2h-2v-2h2zM21 5v2h-2v-2h2zM7 7v-2h10v2h-10z"></path>
      </g>
      <g id="session_remote">
        <path d="M28 8h-4v-1.898c0.302-0.274 0.5-0.661 0.5-1.102 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.441 0.198 0.827 0.5 1.102v1.898h-18v16h9.429l-3.429 4h12l-3.429-4h9.429v-16zM26 22h-20v-12h20v12z"></path>
      </g>
      <g id="shapes">
        <path d="M23 17c-3.314 0-6 2.686-6 6s2.686 6 6 6c3.314 0 6-2.686 6-6v0c-0.004-3.312-2.688-5.996-6-6h-0zM23 27c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4v0c-0.003 2.208-1.792 3.997-4 4h-0z"></path>
        <path d="M15 3h-12v12h12zM13 13h-8v-8h8z"></path>
        <path d="M23 2.94l-6.699 12.060h13.398zM23 7.060l3.301 5.94h-6.602z"></path>
        <path d="M2.311 21.438l2.457 7.563h7.951l2.457-7.563-6.434-4.674zM11.266 27h-5.045l-1.559-4.799 4.080-2.965 4.082 2.965z"></path>
      </g>
      <g id="share">
        <path d="M28 10c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"></path>
        <path d="M28 22c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"></path>
        <path d="M12 16c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"></path>
        <path d="M18.837 18.996l-4.952-1.857c-0.13 0.672-0.387 1.292-0.721 1.864l4.952 1.857c0.13-0.672 0.387-1.292 0.721-1.864z"></path>
        <path d="M13.885 14.861l4.952-1.857c-0.334-0.572-0.591-1.193-0.721-1.864l-4.952 1.857c0.334 0.572 0.592 1.193 0.722 1.864z"></path>
      </g>
      <g id="show">
        <path d="M16 10c6.23 0 10.083 4.055 11.573 6-1.493 1.949-5.345 6-11.573 6-6.23 0-10.083-4.055-11.573-6 1.493-1.949 5.345-6 11.573-6zM16 8c-9.333 0-14 8-14 8s4.667 8 14 8 14-8 14-8-4.667-8-14-8v0z"></path>
        <path d="M18 16c-1.105 0-2-0.895-2-2 0-0.805 0.482-1.489 1.167-1.807-0.372-0.114-0.758-0.193-1.167-0.193-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4c0-0.409-0.079-0.796-0.193-1.167-0.317 0.686-1.001 1.167-1.807 1.167z"></path>
      </g>
      <g id="skip_forward">
        <path d="M18 10v12h4v-12z"></path>
        <path d="M8 16v6l10-6-10-6z"></path>
      </g>
      <g id="skip_rewind">
        <path d="M8 10v12h4v-12z"></path>
        <path d="M12 16l10 6v-12z"></path>
      </g>
      <g id="slope_chart">
        <path d="M4 28l24-24v24h-24z"></path>
      </g>
      <g id="sort">
        <path d="M16 26l6-6h-12l6 6z"></path>
        <path d="M16 6l-6 6h12l-6-6z"></path>
      </g>
      <g id="sort_down">
        <path d="M22 20l-6 6-6-6h12z"></path>
      </g>
      <g id="sort_up">
        <path d="M10 12l6-6 6 6h-12z"></path>
      </g>
      <g id="sound_off">
        <path d="M2 12v8h4.75l5.25 4v-16l-5.25 4h-4.75z"></path>
        <path d="M24.708 12.708l-1.416-1.416-3.292 3.294-3.292-3.294-1.416 1.416 3.294 3.292-3.294 3.292 1.416 1.416 3.292-3.294 3.292 3.294 1.416-1.416-3.294-3.292 3.294-3.292z"></path>
      </g>
      <g id="sound_on">
        <path d="M2 12v8h4.75l5.25 4v-16l-5.25 4h-4.75z"></path>
        <path d="M15.523 12.485c0.912 0.894 1.477 2.138 1.477 3.515s-0.565 2.621-1.476 3.514l-0.001 0.001 1.406 1.422c1.278-1.256 2.070-3.004 2.070-4.937s-0.792-3.68-2.069-4.936l-0.001-0.001z"></path>
        <path d="M26.193 1.981l-1.578 1.227c2.734 3.493 4.385 7.95 4.385 12.791s-1.65 9.298-4.419 12.837l0.035-0.046 1.578 1.227c2.997-3.828 4.807-8.712 4.807-14.018s-1.809-10.19-4.844-14.068l0.038 0.050z"></path>
        <path d="M21.568 6.562l-1.539 1.277c1.848 2.19 2.971 5.045 2.971 8.161s-1.123 5.971-2.986 8.18l0.016-0.019 1.539 1.277c2.135-2.534 3.432-5.835 3.432-9.438s-1.297-6.904-3.45-9.461l0.018 0.022z"></path>
      </g>
      <g id="source_csv">
        <path d="M8.843 17.246l2.242 0.711c-0.344 1.25-0.915 2.178-1.715 2.785-0.8 0.605-1.813 0.91-3.043 0.91-1.521 0-2.771-0.52-3.75-1.559s-1.469-2.461-1.469-4.262c0-1.906 0.492-3.387 1.477-4.441s2.278-1.582 3.883-1.582c1.401 0 2.539 0.414 3.414 1.242 0.521 0.488 0.911 1.191 1.172 2.109l-2.289 0.547c-0.136-0.594-0.418-1.063-0.848-1.406s-0.952-0.516-1.566-0.516c-0.849 0-1.538 0.305-2.066 0.914s-0.793 1.596-0.793 2.961c0 1.447 0.261 2.479 0.781 3.094 0.521 0.613 1.198 0.922 2.031 0.922 0.614 0 1.144-0.195 1.586-0.586s0.761-1.006 0.953-1.844z"></path>
        <path d="M11.684 17.73l2.25-0.219c0.136 0.754 0.41 1.309 0.824 1.664 0.414 0.354 0.973 0.531 1.676 0.531 0.745 0 1.306-0.158 1.684-0.473 0.379-0.316 0.566-0.684 0.566-1.105 0-0.271-0.078-0.502-0.238-0.691-0.16-0.191-0.438-0.355-0.832-0.496-0.27-0.094-0.888-0.262-1.852-0.5-1.239-0.309-2.109-0.686-2.609-1.133-0.703-0.631-1.055-1.398-1.055-2.305 0-0.584 0.165-1.129 0.496-1.637s0.808-0.895 1.43-1.16 1.374-0.398 2.254-0.398c1.438 0 2.52 0.314 3.246 0.945 0.727 0.629 1.107 1.471 1.145 2.523l-2.313 0.102c-0.098-0.59-0.313-1.012-0.637-1.27s-0.813-0.387-1.465-0.387c-0.672 0-1.198 0.137-1.578 0.414-0.245 0.176-0.367 0.414-0.367 0.711 0 0.27 0.114 0.502 0.344 0.695 0.292 0.244 1 0.5 2.125 0.766s1.957 0.539 2.496 0.824c0.539 0.283 0.961 0.672 1.266 1.164s0.457 1.1 0.457 1.824c0 0.656-0.182 1.27-0.547 1.844-0.365 0.572-0.881 0.998-1.547 1.277-0.668 0.277-1.497 0.418-2.492 0.418-1.448 0-2.56-0.336-3.336-1.004-0.776-0.67-1.239-1.645-1.391-2.926z"></path>
        <path d="M25.064 21.457l-4.094-11.453h2.508l2.898 8.477 2.805-8.477h2.453l-4.102 11.453h-2.469z"></path>
      </g>
      <g id="split_horizontal">
        <path d="M28 14v2h-24v-2h24z"></path>
        <path d="M10 20h12l-6 6-6-6z"></path>
        <path d="M22 10h-12l6-6 6 6z"></path>
      </g>
      <g id="split_vertical">
        <path d="M14 4h2v24h-2v-24z"></path>
        <path d="M20 22v-12l6 6-6 6z"></path>
        <path d="M10 10v12l-6-6 6-6z"></path>
      </g>
      <g id="square_markup">
        <path d="M28 4h-6v2h6v-2zM16 4h-6v2h6v-2zM6 4h-2v6h2v-6zM6 16h-2v6h2v-6zM10 26h-6v2h6v-2zM22 26h-6v2h6v-2zM28 22h-2v6h2v-6zM28 10h-2v6h2v-6z"></path>
      </g>
      <g id="stack_overflow">
        <path d="M23.64 26.771v-7.019h2.33v9.349h-21.028v-9.349h2.33v7.019z"></path>
        <path d="M9.843 19.086l11.437 2.39 0.484-2.299-11.437-2.39-0.484 2.299zM11.356 13.64l10.59 4.932 0.968-2.118-10.59-4.962-0.968 2.148zM14.291 8.436l8.986 7.473 1.483-1.785-8.986-7.473-1.483 1.785zM20.1 2.899l-1.876 1.392 6.959 9.379 1.876-1.392-6.959-9.379zM9.601 24.411h11.679v-2.33h-11.679v2.33z"></path>
      </g>
      <g id="stacked_bar_chart">
        <path d="M2 16h6v6h-6v-6z"></path>
        <path d="M2 24h6v4h-6v-4z"></path>
        <path d="M12 10h6v8h-6v-8z"></path>
        <path d="M12 20h6v8h-6v-8z"></path>
        <path d="M22 4h6v10h-6v-10z"></path>
        <path d="M22 16h6v12h-6v-12z"></path>
      </g>
      <g id="star">
        <path d="M15.968 8.633l2.426 4.823 5.348 0.736-3.837 3.798 0.953 5.314-4.798-2.476-4.76 2.549 0.872-5.328-3.895-3.739 5.337-0.817 2.352-4.859zM15.934 4.114l-3.66 7.56-8.303 1.271 6.059 5.817-1.357 8.289 7.405-3.965 7.464 3.852-1.483-8.268 5.97-5.909-8.322-1.145-3.774-7.504z"></path>
      </g>
      <g id="star_selected">
        <path d="M28.030 12.763l-5.97 5.909 1.483 8.268-7.464-3.852-7.405 3.965 1.357-8.289-6.059-5.818 8.303-1.271 3.66-7.56 3.775 7.504 8.321 1.145z"></path>
      </g>
      <g id="std">
        <path d="M27.691 10.309v11.381h-23.381v-11.381h23.381zM30 8h-28v16h28v-16z"></path>
        <path d="M11.635 13.092c0.428 0.375 0.66 0.855 0.678 1.48l-1.356 0.055c-0.055-0.34-0.18-0.59-0.375-0.734-0.18-0.16-0.465-0.23-0.84-0.23-0.393 0-0.715 0.070-0.928 0.23-0.143 0.109-0.215 0.25-0.215 0.43 0 0.143 0.072 0.285 0.197 0.393 0.178 0.143 0.588 0.303 1.25 0.447 0.641 0.16 1.141 0.32 1.445 0.48 0.32 0.18 0.57 0.395 0.75 0.68 0.178 0.285 0.268 0.643 0.268 1.071 0 0.375-0.107 0.732-0.322 1.070-0.213 0.34-0.516 0.59-0.91 0.75-0.393 0.162-0.875 0.25-1.445 0.25-0.855 0-1.5-0.195-1.945-0.588-0.465-0.393-0.732-0.963-0.822-1.713l1.322-0.125c0.070 0.445 0.231 0.767 0.481 0.965 0.234 0.213 0.555 0.32 0.965 0.32 0.445 0 0.768-0.090 0.982-0.285 0.232-0.18 0.338-0.395 0.338-0.645 0-0.16-0.053-0.285-0.141-0.391-0.090-0.125-0.252-0.215-0.484-0.305-0.16-0.055-0.515-0.143-1.088-0.285-0.713-0.18-1.213-0.395-1.518-0.66-0.41-0.375-0.607-0.822-0.607-1.34 0-0.34 0.090-0.66 0.287-0.965 0.195-0.285 0.463-0.516 0.838-0.678 0.357-0.143 0.803-0.232 1.303-0.232 0.84 0 1.482 0.195 1.893 0.555zM16.492 13.787v5.553h-1.359v-5.553h-1.98v-1.125h5.32v1.125h-1.981zM23.078 12.787c0.395 0.107 0.715 0.322 1 0.607 0.285 0.303 0.5 0.662 0.643 1.088 0.143 0.43 0.215 0.949 0.215 1.572 0 0.553-0.072 1.037-0.197 1.428-0.178 0.482-0.41 0.875-0.73 1.18-0.234 0.23-0.535 0.41-0.947 0.535-0.285 0.090-0.697 0.143-1.197 0.143h-2.535v-6.678h2.465c0.572 0 0.982 0.035 1.285 0.125zM21.686 18.215c0.375 0 0.662-0.018 0.822-0.072 0.215-0.053 0.393-0.141 0.535-0.266 0.16-0.145 0.268-0.359 0.357-0.645 0.088-0.303 0.143-0.713 0.143-1.23 0-0.52-0.055-0.91-0.143-1.195-0.088-0.27-0.213-0.484-0.375-0.645-0.162-0.143-0.375-0.25-0.625-0.303-0.197-0.053-0.553-0.072-1.107-0.072h-0.605v4.428h0.998z"></path>
      </g>
      <g id="step_in">
        <path d="M28 28h-18v-2h18v2z"></path>
        <path d="M28 28h-2v-24h2v24z"></path>
        <path d="M26 6h-16v-2h16v2z"></path>
        <path d="M12 28h-2v-8h2v8z"></path>
        <path d="M12 12h-2v-8h2v8z"></path>
        <path d="M18 14v4h-16v-4h16z"></path>
        <path d="M18 22v-12l6 6-6 6z"></path>
      </g>
      <g id="step_out">
        <path d="M4 4h18v2h-18v-2z"></path>
        <path d="M4 4h2v24h-2v-24z"></path>
        <path d="M6 26h16v2h-16v-2z"></path>
        <path d="M20 4h2v8h-2v-8z"></path>
        <path d="M20 20h2v8h-2v-8z"></path>
        <path d="M24 14v4h-16v-4h16z"></path>
        <path d="M24 22v-12l6 6-6 6z"></path>
      </g>
      <g id="stop">
        <path d="M8 8h16v16h-16v-16z"></path>
      </g>
      <g id="sum">
        <path d="M8.804 12.661c0.84 0 1.482 0.178 1.895 0.537 0.426 0.375 0.66 0.875 0.678 1.48l-1.357 0.055c-0.055-0.34-0.178-0.59-0.375-0.732-0.178-0.162-0.465-0.232-0.856-0.232-0.375 0-0.697 0.090-0.91 0.25-0.144 0.090-0.215 0.232-0.215 0.41 0 0.16 0.070 0.285 0.195 0.41 0.18 0.144 0.59 0.285 1.25 0.447 0.643 0.143 1.143 0.303 1.445 0.482 0.322 0.16 0.572 0.393 0.75 0.68 0.162 0.285 0.25 0.641 0.25 1.051 0 0.395-0.088 0.75-0.303 1.072-0.213 0.34-0.518 0.59-0.91 0.75-0.393 0.162-0.875 0.25-1.447 0.25-0.855 0-1.5-0.197-1.945-0.588-0.465-0.395-0.73-0.965-0.82-1.715l1.32-0.125c0.072 0.445 0.232 0.768 0.482 0.98 0.232 0.199 0.553 0.305 0.965 0.305 0.447 0 0.768-0.090 0.982-0.268 0.23-0.197 0.338-0.41 0.338-0.643 0-0.16-0.053-0.305-0.143-0.41-0.090-0.107-0.25-0.215-0.48-0.285-0.162-0.054-0.519-0.162-1.090-0.304-0.715-0.18-1.232-0.393-1.518-0.66-0.412-0.357-0.607-0.805-0.607-1.34 0-0.34 0.090-0.66 0.285-0.945 0.195-0.305 0.465-0.535 0.84-0.68 0.355-0.16 0.785-0.231 1.303-0.231l-0.002-0.002z"></path>
        <path d="M18.019 16.286c0 0.785-0.037 1.357-0.109 1.695-0.070 0.322-0.215 0.607-0.41 0.84s-0.445 0.41-0.785 0.535c-0.32 0.143-0.75 0.215-1.285 0.215-0.645 0-1.125-0.072-1.445-0.232-0.34-0.143-0.59-0.34-0.787-0.57-0.197-0.234-0.322-0.484-0.373-0.734-0.090-0.391-0.125-0.963-0.125-1.695v-3.57h1.338v3.625c0 0.57 0.018 0.945 0.053 1.105 0.055 0.285 0.197 0.5 0.41 0.66 0.215 0.162 0.52 0.25 0.895 0.25s0.678-0.070 0.855-0.23c0.197-0.16 0.322-0.357 0.357-0.57 0.037-0.234 0.053-0.609 0.053-1.145v-3.695h1.357v3.518h0.002z"></path>
        <path d="M21.444 12.769l1.215 4.553 1.195-4.553h2.018v6.676h-1.248v-5.246l-1.322 5.246h-1.303l-1.322-5.246v5.246h-1.248v-6.676z"></path>
        <path d="M27.691 10.309v11.381h-23.381v-11.381h23.381zM30 8h-28v16h28v-16z"></path>
      </g>
      <g id="surface_3d_chart">
        <path d="M23.149 17.716l-1.307-5.543c-0.117-0.498-0.559-0.854-1.070-0.864-0.006 0-0.014 0-0.021 0-0.502 0-0.945 0.335-1.080 0.82l-0.426 1.527-1.307-7.394c-0.094-0.531-0.553-0.921-1.094-0.926-0.525-0.003-1.008 0.375-1.109 0.905l-1.754 8.954-1.248-3.846c-0.16-0.491-0.613-0.82-1.15-0.772-0.514 0.038-0.938 0.424-1.021 0.934l-0.997 5.967-9.564 3.188 16 5.333 16-5.333-8.851-2.95zM9.191 19.711l-0.302 1.81-2.564-0.855 2.866-0.955zM11.042 22.239l0.974-5.832 1.168 3.597c0.156 0.486 0.582 0.828 1.135 0.773 0.51-0.031 0.934-0.402 1.031-0.904l1.428-7.291 1.119 6.328c0.090 0.516 0.527 0.898 1.049 0.924 0.561 0.066 0.994-0.314 1.135-0.818l0.58-2.082 0.609 2.59c0.143 0.6 0.727 0.969 1.35 0.834 0.292-0.069 0.527-0.25 0.679-0.483l2.378 0.792-9.676 3.225-4.958-1.653z"></path>
      </g>
      <g id="sync">
        <path d="M5.25 16c0.001-1.527 0.321-2.978 0.897-4.292l-0.027 0.069 2.809 2.809 2.121-9.192-9.192 2.121 2.383 2.383c-0.939 1.772-1.49 3.874-1.49 6.104 0 7.292 5.891 13.208 13.173 13.248l0.004 0 0.014-2.5c-5.912-0.033-10.691-4.833-10.691-10.75 0-0 0-0 0-0v0z"></path>
        <path d="M23.071 17.414l-2.121 9.192 9.192-2.121-2.383-2.383c0.939-1.772 1.49-3.873 1.49-6.104 0-7.295-5.896-13.212-13.182-13.248h-0.003l-0.012 2.5c5.913 0.023 10.698 4.822 10.698 10.739 0 1.53-0.32 2.986-0.897 4.304l0.027-0.069z"></path>
      </g>
      <g id="table_chart">
        <path d="M3 3v26h26v-26h-26zM5 13h6v6h-6v-6zM19 19h-6v-6h6v6zM5 27v-6h6v6h-6zM13 27v-6h6v6h-6zM27 27h-6v-6h6v6zM27 19h-6v-6h6v6zM5 11v-6h22v6h-22z"></path>
      </g>
      <g id="terminate">
        <path d="M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM16 6c2.396 0 4.569 0.882 6.293 2.293l-14 14c-1.411-1.724-2.293-3.897-2.293-6.293 0-5.514 4.486-10 10-10zM16 26c-2.396 0-4.569-0.882-6.293-2.293l14-14c1.411 1.724 2.293 3.897 2.293 6.293 0 5.514-4.486 10-10 10z"></path>
      </g>
      <g id="text">
        <path d="M8.776 8h14.449l0.023 4.73h-0.691c-0.227-1.731-0.875-2.902-1.945-3.514-0.601-0.337-1.416-0.521-2.611-0.553v12.643c0 0.885 0.070 1.471 0.379 1.76s0.951 0.334 1.928 0.334v0.6h-8.555v-0.6c0.938 0 1.561-0.046 1.869-0.339 0.308-0.295 0.379-0.877 0.379-1.754v-12.643c-1.172 0.031-1.986 0.216-2.611 0.553-1.148 0.627-1.797 1.798-1.945 3.514h-0.691l0.024-4.73z"></path>
      </g>
      <g id="text_bold">
        <path d="M18.842 15.52c1.508 0.352 2.566 0.777 3.176 1.277 0.875 0.711 1.313 1.633 1.313 2.766 0 1.195-0.48 2.184-1.441 2.965-1.18 0.945-2.895 1.418-5.145 1.418h-8.074v-0.434c0.734 0 1.232-0.068 1.494-0.205s0.445-0.314 0.551-0.533 0.158-0.758 0.158-1.617v-10.313c0-0.859-0.053-1.4-0.158-1.623s-0.291-0.4-0.557-0.533-0.762-0.199-1.488-0.199v-0.434h7.617c1.82 0 3.109 0.162 3.867 0.486s1.355 0.809 1.793 1.453 0.656 1.33 0.656 2.057c0 0.766-0.277 1.447-0.832 2.045s-1.531 1.072-2.93 1.424zM14.576 16.117v5.098l-0.012 0.586c0 0.422 0.107 0.74 0.322 0.955s0.533 0.322 0.955 0.322c0.625 0 1.201-0.139 1.729-0.416s0.932-0.68 1.213-1.207 0.422-1.115 0.422-1.764c0-0.742-0.172-1.408-0.516-1.998s-0.816-1.002-1.418-1.236-1.5-0.348-2.695-0.34zM14.576 15.203c1.109 0 1.928-0.125 2.455-0.375s0.932-0.602 1.213-1.055 0.422-1.031 0.422-1.734-0.139-1.279-0.416-1.729-0.674-0.791-1.189-1.025-1.344-0.348-2.484-0.34v6.258z"></path>
      </g>
      <g id="text_formula">
        <path d="M2.037 14.54l0.145-0.696h0.277c0.009 0 0.019 0.001 0.030 0.001 0.139 0 0.271-0.031 0.389-0.088l-0.006 0.002c0.135-0.082 0.248-0.185 0.339-0.306l0.002-0.003c0.14-0.182 0.277-0.388 0.4-0.603l0.014-0.027 4.452-7.655h1.799l1.102 7.734c0.027 0.252 0.106 0.481 0.226 0.683l-0.004-0.008c0.116 0.165 0.305 0.272 0.519 0.272 0.021 0 0.041-0.001 0.062-0.003l-0.003 0h0.238l-0.145 0.696h-4.333l0.145-0.696h0.301c0.019 0.001 0.042 0.001 0.064 0.001 0.219 0 0.427-0.049 0.613-0.136l-0.009 0.004c0.15-0.073 0.251-0.224 0.251-0.399 0-0.008-0-0.015-0.001-0.022l0 0.001c0-0.070-0.002-0.143-0.007-0.217-0.004-0.075-0.011-0.143-0.020-0.203l-0.172-1.419h-3.202l-0.658 1.182c-0.134 0.209-0.223 0.459-0.248 0.728l-0 0.007c0 0.316 0.244 0.473 0.735 0.473h0.262l-0.143 0.696zM7.239 8.329l-1.287 2.325h2.663l-0.262-2.206c-0.035-0.385-0.070-0.729-0.106-1.030q-0.053-0.454-0.066-0.926c-0.086 0.21-0.174 0.402-0.262 0.577-0.088 0.176-0.187 0.362-0.295 0.559-0.11 0.197-0.24 0.431-0.387 0.702z"></path>
        <path d="M9.876 26c-0.235-0.002-0.463-0.020-0.687-0.054l0.027 0.003c-0.213-0.027-0.403-0.065-0.587-0.116l0.028 0.007 0.24-1.16c0.105 0.025 0.25 0.057 0.43 0.090 0.147 0.030 0.316 0.047 0.489 0.049h0.001c0.019 0.001 0.041 0.001 0.063 0.001 0.389 0 0.751-0.116 1.053-0.314l-0.007 0.005c0.347-0.272 0.617-0.626 0.783-1.034l0.006-0.017c0.257-0.595 0.472-1.292 0.611-2.016l0.010-0.064 2.020-9.54h-1.82l0.201-0.939 1.92-0.42 0.16-0.74c0.215-1.174 0.782-2.189 1.588-2.958l0.002-0.002c0.781-0.617 1.78-0.989 2.867-0.989 0.099 0 0.198 0.003 0.295 0.009l-0.013-0.001c0.081-0.005 0.176-0.008 0.272-0.008 0.757 0 1.47 0.188 2.094 0.52l-0.024-0.012c0.461 0.236 0.776 0.699 0.799 1.237l0 0.003c0 0.006 0 0.014 0 0.022 0 0.431-0.235 0.806-0.584 1.006l-0.006 0.003c-0.438 0.237-0.96 0.376-1.513 0.376-0.069 0-0.137-0.002-0.205-0.006l0.009 0c0-0.018 0-0.040 0-0.062 0-0.463-0.070-0.91-0.2-1.33l0.009 0.032c-0.066-0.344-0.364-0.6-0.722-0.6-0.003 0-0.006 0-0.009 0h0c-0.010-0-0.022-0.001-0.034-0.001-0.403 0-0.754 0.219-0.942 0.545l-0.003 0.005c-0.265 0.483-0.455 1.046-0.538 1.644l-0.003 0.026-0.26 1.28h2.519l-0.279 1.359h-2.539l-1.9 8.94c-0.189 0.986-0.519 1.863-0.973 2.662l0.022-0.042c-0.361 0.63-0.826 1.158-1.376 1.581l-0.012 0.009c-0.463 0.349-1.008 0.621-1.597 0.783l-0.034 0.008c-0.494 0.137-1.062 0.217-1.648 0.221h-0.002z"></path>
        <path d="M18.997 22.102l0.173-0.926h0.229c0.009 0 0.020 0 0.031 0 0.198 0 0.389-0.029 0.569-0.083l-0.014 0.004c0.21-0.076 0.39-0.186 0.543-0.326l-0.001 0.001c0.259-0.228 0.497-0.461 0.72-0.708l0.007-0.007 2.203-2.433-1.207-2.903c-0.117-0.343-0.309-0.634-0.558-0.864l-0.001-0.001c-0.198-0.127-0.439-0.203-0.698-0.203-0.025 0-0.051 0.001-0.076 0.002l0.003-0h-0.208l0.173-0.927h3.29l1.225 3.324 2.429-3.324h2.136l-0.176 0.927h-0.313c-0.008-0-0.018-0-0.028-0-0.204 0-0.399 0.039-0.577 0.109l0.011-0.004c-0.211 0.093-0.391 0.219-0.542 0.375l-0 0c-0.238 0.239-0.462 0.493-0.669 0.761l-0.014 0.019-1.802 2.082 1.277 2.938c0.139 0.382 0.341 0.711 0.597 0.99l-0.002-0.002c0.192 0.16 0.442 0.257 0.714 0.257 0.025 0 0.050-0.001 0.074-0.002l-0.003 0h0.229l-0.176 0.926h-3.392l-1.313-3.533-2.728 3.533z"></path>
      </g>
      <g id="text_italic">
        <path d="M14.137 8.488l0.129-0.434h7.758l-0.152 0.434c-0.703 0-1.24 0.156-1.611 0.469s-0.697 0.965-0.979 1.957l-2.906 10.172c-0.211 0.719-0.316 1.199-0.316 1.441 0 0.281 0.109 0.5 0.328 0.656 0.281 0.203 0.813 0.313 1.594 0.328l-0.117 0.434h-7.887l0.129-0.434c0.789 0 1.367-0.15 1.734-0.451s0.699-0.959 0.996-1.975l2.93-10.172c0.18-0.625 0.27-1.098 0.27-1.418 0-0.289-0.109-0.516-0.328-0.68s-0.742-0.273-1.57-0.328z"></path>
      </g>
      <g id="text_justify_left">
        <path d="M28 6h-24v2h24v-2z"></path>
        <path d="M16 12h-12v2h12v-2z"></path>
        <path d="M28 18h-24v2h24v-2z"></path>
        <path d="M16 24h-12v2h12v-2z"></path>
      </g>
      <g id="text_justify_middle">
        <path d="M28 6h-24v2h24v-2z"></path>
        <path d="M22 12h-12v2h12v-2z"></path>
        <path d="M28 18h-24v2h24v-2z"></path>
        <path d="M22 24h-12v2h12v-2z"></path>
      </g>
      <g id="text_justify_right">
        <path d="M28 6h-24v2h24v-2z"></path>
        <path d="M28 12h-12v2h12v-2z"></path>
        <path d="M28 18h-24v2h24v-2z"></path>
        <path d="M28 24h-12v2h12v-2z"></path>
      </g>
      <g id="three_d">
        <path d="M10.221 15.68v-0.060c0.86-0.204 1.602-0.624 2.19-1.201l-0.001 0.001c0.553-0.57 0.894-1.348 0.894-2.206 0-0.054-0.001-0.108-0.004-0.162l0 0.008c0.001-0.032 0.002-0.070 0.002-0.109 0-0.999-0.509-1.879-1.283-2.394l-0.011-0.007c-0.902-0.564-1.999-0.899-3.173-0.899-0.112 0-0.222 0.003-0.333 0.009l0.015-0.001c-0.051-0.001-0.111-0.002-0.171-0.002-0.9 0-1.766 0.147-2.575 0.419l0.057-0.017c-0.752 0.261-1.404 0.599-1.996 1.017l0.025-0.017 1.4 2.080c0.349-0.222 0.762-0.448 1.189-0.65l0.071-0.030c0.496-0.228 1.076-0.361 1.687-0.361 0.033 0 0.066 0 0.099 0.001l-0.005-0c0.065-0.006 0.139-0.010 0.215-0.010 0.509 0 0.979 0.165 1.36 0.444l-0.006-0.005c0.292 0.279 0.473 0.671 0.473 1.106 0 0.030-0.001 0.059-0.002 0.088l0-0.004c0 0.011 0 0.024 0 0.036 0 0.351-0.093 0.679-0.255 0.963l0.005-0.009c-0.223 0.325-0.547 0.565-0.927 0.677l-0.012 0.003c-0.527 0.162-1.133 0.255-1.76 0.255-0.088 0-0.175-0.002-0.262-0.005l0.012 0h-1.1v2.32h1.078c0.073-0.002 0.158-0.004 0.244-0.004 0.656 0 1.293 0.078 1.903 0.225l-0.055-0.011c0.425 0.089 0.786 0.314 1.046 0.627l0.002 0.003c0.189 0.266 0.301 0.598 0.301 0.955 0 0.015-0 0.031-0.001 0.046l0-0.002c0.002 0.034 0.003 0.073 0.003 0.113 0 0.581-0.252 1.104-0.652 1.465l-0.002 0.002c-0.544 0.362-1.212 0.577-1.931 0.577-0.119 0-0.237-0.006-0.353-0.017l0.015 0.001c-0.671-0.006-1.318-0.094-1.937-0.252l0.056 0.012c-0.731-0.177-1.37-0.417-1.971-0.723l0.051 0.024v2.559c1.161 0.495 2.513 0.783 3.931 0.783 0.067 0 0.134-0.001 0.2-0.002l-0.010 0c0.083 0.003 0.181 0.005 0.279 0.005 1.077 0 2.105-0.211 3.044-0.595l-0.054 0.019c0.783-0.328 1.424-0.866 1.869-1.545l0.010-0.016c0.384-0.617 0.612-1.367 0.612-2.169 0-0.022-0-0.043-0.001-0.065l0 0.003c0.002-0.038 0.003-0.082 0.003-0.127 0-0.83-0.346-1.579-0.902-2.111l-0.001-0.001c-0.704-0.595-1.6-0.982-2.584-1.059l-0.016-0.001z"></path>
        <path d="M27.25 12.020c-0.602-1.027-1.477-1.838-2.526-2.345l-0.035-0.015c-1.080-0.507-2.346-0.802-3.68-0.802-0.074 0-0.148 0.001-0.221 0.003l0.011-0h-4.479v14.279h4.039c0.152 0.010 0.329 0.015 0.507 0.015 1.989 0 3.815-0.696 5.249-1.858l-0.016 0.012c1.284-1.255 2.079-3.005 2.079-4.94 0-0.179-0.007-0.357-0.020-0.533l0.001 0.023c0.003-0.073 0.004-0.159 0.004-0.246 0-1.317-0.339-2.556-0.934-3.633l0.020 0.039zM20.639 20.639h-1.299v-9.299h1.619c0.080-0.006 0.173-0.009 0.267-0.009 1.074 0 2.046 0.431 2.755 1.13l-0-0c0.658 0.837 1.056 1.907 1.056 3.069 0 0.144-0.006 0.287-0.018 0.429l0.001-0.018q0 4.699-4.381 4.699z"></path>
      </g>
      <g id="thumbs_down">
        <path d="M25 16.236v-4.658l-4.467-5.411-4.678 0.021-8.576 1.812h-3.217v12h4.625l4.539 4.406 2.645 3.594h4.293l-0.193-4.427-0.633-2.573h3.279l2.383-4.764zM8 11c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1zM23 15.764l-1.617 3.236h-4.596l1.217 4.953 0.082 2.047h-1.207l-2.152-2.906-4.664-4.542v-9.096l6.105-1.289h3.425l3.408 4.13v3.467z"></path>
      </g>
      <g id="thumbs_down_filled">
        <path d="M8 11.021c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path>
        <path d="M20.533 6.188l-4.678 0.021-8.576 1.812h-3.217v12h4.625l4.539 4.406 2.645 3.594h4.293l-0.193-4.427-0.633-2.573h3.279l2.383-4.764v-4.658l-4.467-5.411zM8.64 18.728h-3.281v-9.409h3.281v9.409z"></path>
      </g>
      <g id="thumbs_up">
        <path d="M22.617 11h-3.279l0.633-2.573 0.193-4.427h-4.293l-2.645 3.594-4.539 4.406h-4.625v12h3.217l8.576 1.812 4.678 0.021 4.467-5.411v-4.658l-2.383-4.764zM7 22c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM23 19.703l-3.408 4.13h-3.425l-6.104-1.289v-9.096l4.664-4.542 2.152-2.906h1.207l-0.082 2.047-1.217 4.953h4.596l1.617 3.236v3.467z"></path>
      </g>
      <g id="thumbs_up_filled">
        <path d="M22.617 11h-3.279l0.633-2.573 0.193-4.427h-4.293l-2.645 3.594-4.539 4.406h-4.625v12h3.217l8.576 1.812 4.678 0.021 4.467-5.411v-4.658l-2.383-4.764zM8.64 22.702h-3.281v-9.409h3.281v9.409z"></path>
        <path d="M8 21c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path>
      </g>
      <g id="tile_view">
        <path d="M12 14h-6c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2h6c1.105 0 2 0.895 2 2v6c0 1.105-0.895 2-2 2z"></path>
        <path d="M26 14h-6c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2h6c1.105 0 2 0.895 2 2v6c0 1.105-0.895 2-2 2z"></path>
        <path d="M12 28h-6c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2h6c1.105 0 2 0.895 2 2v6c0 1.105-0.895 2-2 2z"></path>
        <path d="M26 28h-6c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2h6c1.105 0 2 0.895 2 2v6c0 1.105-0.895 2-2 2z"></path>
      </g>
      <g id="toggle_off">
        <path d="M20 8.236c4.281 0 7.764 3.483 7.764 7.764s-3.483 7.764-7.764 7.764h-8c-4.281 0-7.764-3.483-7.764-7.764s3.483-7.764 7.764-7.764h8zM20 6h-8c-5.523 0-10 4.477-10 10v0c0 5.523 4.477 10 10 10h8c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0z"></path>
        <path d="M18 16c0 3.314-2.686 6-6 6s-6-2.686-6-6c0-3.314 2.686-6 6-6s6 2.686 6 6z"></path>
      </g>
      <g id="toggle_on">
        <path d="M20 6h-8c-5.523 0-10 4.477-10 10s4.477 10 10 10h8c5.523 0 10-4.477 10-10s-4.477-10-10-10zM20 22c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z"></path>
      </g>
      <g id="token">
        <path d="M30 14h-14.325c-0.865-2.885-3.509-5-6.675-5-3.866 0-7 3.134-7 7s3.134 7 7 7c3.166 0 5.81-2.115 6.675-5h8.325v4h4v-4h2v-4zM9 19c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"></path>
      </g>
      <g id="trash_can">
        <path d="M27 7h-6v-4h-10v4h-6v4h2v14c0 2.209 1.791 4 4 4h10c2.209 0 4-1.791 4-4v-14h2v-4zM13 5h6v2h-6v-2zM23 25c0 1.103-0.897 2-2 2h-10c-1.103 0-2-0.897-2-2v-14h14v14z"></path>
        <path d="M11 13h2v12h-2v-12z"></path>
        <path d="M15 13h2v12h-2v-12z"></path>
        <path d="M19 13h2v12h-2v-12z"></path>
      </g>
      <g id="trash_delete">
        <path d="M21 7v-4h-10v4h-6v4h2v14c0.001 2.209 1.791 3.999 4 4h10c2.209-0.001 3.999-1.791 4-4v-14h2v-4zM13 5h6v2h-6zM23 25c-0.015 1.098-0.902 1.985-1.999 2l-0.001 0h-10c-1.098-0.015-1.985-0.902-2-1.999l-0-0.001v-14h14z"></path>
        <path d="M12.708 23.708l3.292-3.294 3.292 3.294 1.416-1.416-3.294-3.292 3.294-3.292-1.416-1.416-3.292 3.294-3.292-3.294-1.416 1.416 3.294 3.292-3.294 3.292 1.416 1.416z"></path>
      </g>
      <g id="trash_empty">
        <path d="M27 11h-2v14c-0.001 2.209-1.791 3.999-4 4h-10c-2.209-0.001-3.999-1.791-4-4v-14h-2v-4h6v-4h10v4h6zM23 11h-14v14c0.015 1.098 0.902 1.985 1.999 2l0.001 0h10c1.098-0.015 1.985-0.902 2-1.999l0-0.001zM13 7h6v-2h-6z"></path>
      </g>
      <g id="trash_full">
        <path d="M21 7v-4h-10v4h-6v4h2v14c0.001 2.209 1.791 3.999 4 4h10c2.209-0.001 3.999-1.791 4-4v-14h2v-4zM13 5h6v2h-6zM23 25c-0.015 1.098-0.902 1.985-1.999 2l-0.001 0h-10c-1.098-0.015-1.985-0.902-2-1.999l-0-0.001v-14h14z"></path>
        <path d="M13 25h6c1.105 0 2-0.895 2-2v0-10h-10v10c0 1.105 0.895 2 2 2v0z"></path>
      </g>
      <g id="trash_restore">
        <path d="M20.341 21.177c-0.235-0.048-0.481-0.044-0.721-0.073v3.895c-0.015 1.098-0.902 1.985-1.999 2l-0.001 0h-10c-1.098-0.015-1.985-0.902-2-1.999l-0-0.001v-14h14v4.047c0.709 0.041 1.366 0.127 2.008 0.254l-0.092-0.015c0.028 0.006 0.055 0.018 0.084 0.024v-4.31h2v-4h-6v-4h-10v4h-6v4h2v14c-0 0.018-0 0.039-0 0.060 0 1.086 0.449 2.066 1.171 2.767l0.001 0.001c0.701 0.723 1.682 1.172 2.768 1.172 0.021 0 0.042-0 0.064-0l-0.003 0h10c2.209-0.001 3.999-1.791 4-4v-3.46c-0.35-0.133-0.779-0.258-1.219-0.352l-0.060-0.011zM9.62 5h6v2h-6z"></path>
        <path d="M30.38 24.764l-1.244-7.374-2.383 2.502c-0.566-0.466-1.199-0.894-1.871-1.261l-0.063-0.032c-1.061-0.599-2.292-1.067-3.595-1.339l-0.084-0.015c-0.746-0.157-1.603-0.247-2.482-0.247-0.51 0-1.012 0.030-1.506 0.089l0.060-0.006c-1.433 0.137-2.749 0.497-3.961 1.046l0.078-0.032c-0.75 0.344-1.385 0.701-1.988 1.103l0.052-0.033c-0.646 0.429-1.21 0.883-1.729 1.384l0.004-0.003 1.391 1.435c0.431-0.417 0.904-0.796 1.409-1.13l0.037-0.023c0.467-0.312 1.007-0.616 1.57-0.88l0.077-0.032c0.954-0.433 2.061-0.738 3.223-0.858l0.046-0.004c0.341-0.038 0.736-0.059 1.137-0.059 0.773 0 1.527 0.080 2.255 0.232l-0.071-0.012c1.174 0.245 2.215 0.637 3.172 1.163l-0.059-0.030c0.578 0.317 1.074 0.646 1.539 1.012l-0.024-0.018-2.435 2.557z"></path>
      </g>
      <g id="tree_view">
        <path d="M24 20v-6h-6v2h-6v-4h2v-6h-6v6h2v14h8v2h6v-6h-6v2h-6v-6h6v2z"></path>
      </g>
      <g id="treemap_chart">
        <path d="M12 4h16v18h-16v-18z"></path>
        <path d="M4 4h6v12h-6v-12z"></path>
        <path d="M4 18h6v4h-6v-4z"></path>
        <path d="M4 24h24v4h-24v-4z"></path>
      </g>
      <g id="type_integer">
        <path d="M8.949 21.457h-2.195v-8.273c-0.802 0.75-1.747 1.305-2.836 1.664v-1.992c0.573-0.188 1.195-0.543 1.867-1.066s1.133-1.135 1.383-1.832h1.781v11.5z"></path>
        <path d="M19.645 19.418v2.039h-7.695c0.083-0.771 0.333-1.502 0.75-2.191 0.417-0.691 1.239-1.605 2.469-2.746 0.989-0.922 1.597-1.547 1.82-1.875 0.302-0.453 0.453-0.902 0.453-1.344 0-0.49-0.132-0.867-0.395-1.129-0.263-0.264-0.626-0.395-1.090-0.395-0.458 0-0.823 0.137-1.094 0.414-0.271 0.275-0.427 0.734-0.469 1.375l-2.188-0.219c0.13-1.209 0.539-2.076 1.227-2.602 0.688-0.527 1.547-0.789 2.578-0.789 1.13 0 2.020 0.305 2.664 0.914s0.969 1.367 0.969 2.273c0 0.516-0.092 1.006-0.277 1.473-0.184 0.465-0.477 0.953-0.879 1.465-0.266 0.338-0.745 0.824-1.438 1.461-0.692 0.635-1.132 1.057-1.316 1.266-0.185 0.207-0.335 0.41-0.449 0.609h4.359z"></path>
        <path d="M21.051 18.418l2.125-0.258c0.068 0.541 0.25 0.955 0.547 1.242 0.297 0.285 0.656 0.43 1.078 0.43 0.453 0 0.834-0.172 1.145-0.516s0.465-0.809 0.465-1.391c0-0.553-0.148-0.99-0.445-1.313-0.297-0.324-0.658-0.484-1.086-0.484-0.281 0-0.617 0.055-1.008 0.164l0.242-1.789c0.594 0.016 1.047-0.113 1.359-0.387s0.469-0.637 0.469-1.090c0-0.387-0.115-0.693-0.344-0.922-0.229-0.23-0.533-0.344-0.914-0.344-0.375 0-0.695 0.129-0.961 0.391-0.266 0.26-0.428 0.641-0.484 1.141l-2.023-0.344c0.141-0.693 0.354-1.246 0.637-1.66s0.68-0.74 1.188-0.977c0.508-0.238 1.076-0.355 1.707-0.355 1.078 0 1.943 0.344 2.594 1.031 0.537 0.563 0.805 1.197 0.805 1.906 0 1.004-0.549 1.807-1.648 2.406 0.656 0.141 1.182 0.455 1.574 0.945 0.393 0.488 0.59 1.080 0.59 1.773 0 1.004-0.367 1.861-1.102 2.57-0.734 0.707-1.648 1.063-2.742 1.063-1.037 0-1.896-0.299-2.578-0.895-0.682-0.598-1.078-1.377-1.188-2.34z"></path>
      </g>
      <g id="type_string">
        <path d="M5.004 15.69l-1.992-0.359c0.224-0.802 0.609-1.396 1.156-1.781s1.359-0.578 2.438-0.578c0.979 0 1.708 0.116 2.188 0.348s0.816 0.526 1.012 0.883 0.293 1.012 0.293 1.965l-0.023 2.563c0 0.73 0.035 1.267 0.105 1.613s0.202 0.718 0.395 1.113h-2.172c-0.058-0.145-0.128-0.362-0.211-0.648-0.036-0.13-0.063-0.216-0.078-0.258-0.375 0.364-0.776 0.638-1.203 0.82s-0.883 0.273-1.367 0.273c-0.854 0-1.527-0.231-2.020-0.695s-0.738-1.050-0.738-1.758c0-0.469 0.112-0.887 0.336-1.254s0.538-0.648 0.941-0.844 0.985-0.366 1.746-0.512c1.026-0.192 1.737-0.372 2.133-0.539v-0.219c0-0.422-0.104-0.723-0.313-0.902s-0.602-0.27-1.18-0.27c-0.391 0-0.695 0.077-0.914 0.23s-0.396 0.423-0.531 0.809zM7.941 17.472c-0.281 0.094-0.727 0.206-1.336 0.336s-1.008 0.258-1.195 0.383c-0.286 0.203-0.43 0.461-0.43 0.773 0 0.308 0.114 0.573 0.344 0.797s0.521 0.336 0.875 0.336c0.396 0 0.773-0.13 1.133-0.391 0.266-0.198 0.44-0.44 0.523-0.727 0.058-0.188 0.086-0.544 0.086-1.070v-0.438z"></path>
        <path d="M12.168 21.456v-11.453h2.195v4.125c0.677-0.771 1.479-1.156 2.406-1.156 1.011 0 1.848 0.366 2.508 1.098 0.662 0.731 0.992 1.782 0.992 3.152 0 1.417-0.338 2.508-1.012 3.273-0.676 0.766-1.493 1.148-2.457 1.148-0.474 0-0.941-0.118-1.402-0.355s-0.858-0.587-1.191-1.051v1.219h-2.039zM14.348 17.128c0 0.859 0.136 1.495 0.406 1.906 0.38 0.583 0.886 0.875 1.516 0.875 0.484 0 0.897-0.207 1.238-0.621s0.512-1.066 0.512-1.957c0-0.948-0.172-1.632-0.516-2.051s-0.784-0.629-1.32-0.629c-0.526 0-0.964 0.204-1.313 0.613s-0.523 1.030-0.523 1.863z"></path>
        <path d="M29.27 15.612l-2.164 0.391c-0.072-0.433-0.238-0.758-0.496-0.977s-0.592-0.328-1.004-0.328c-0.547 0-0.982 0.188-1.309 0.566s-0.488 1.009-0.488 1.895c0 0.984 0.166 1.68 0.496 2.086s0.775 0.609 1.332 0.609c0.416 0 0.758-0.118 1.023-0.355s0.453-0.645 0.563-1.223l2.156 0.367c-0.225 0.989-0.654 1.737-1.289 2.242s-1.486 0.758-2.555 0.758c-1.213 0-2.182-0.383-2.902-1.148s-1.082-1.825-1.082-3.18c0-1.37 0.361-2.437 1.086-3.199s1.703-1.145 2.938-1.145c1.010 0 1.814 0.218 2.41 0.652s1.025 1.098 1.285 1.988z"></path>
      </g>
      <g id="undo">
        <path d="M17.465 18.184l-2.541-11.728 9.089 4.17-6.548 7.558z"></path>
        <path d="M7.148 25.703c-0.232-1.45-0.215-2.932 0.053-4.401 0.986-5.368 5.264-9.58 10.645-10.48l0.33 1.973c-4.555 0.762-8.174 4.325-9.006 8.868-0.229 1.244-0.242 2.498-0.045 3.723l-1.977 0.318z"></path>
      </g>
      <g id="unlock">
        <path d="M26 4c-3.314 0-6 2.686-6 6v2h-10c-1.105 0-2 0.895-2 2v12c0 1.105 0.895 2 2 2h12c1.105 0 2-0.895 2-2v-12c0-1.105-0.895-2-2-2v-2c0-2.206 1.794-4 4-4 1.474 0 2.75 0.81 3.444 2h2.189c-0.827-2.325-3.024-4-5.633-4zM16 22c-1.105 0-2-0.895-2-2s0.895-2 2-2 2 0.895 2 2-0.895 2-2 2z"></path>
      </g>
      <g id="up">
        <path d="M24 18h-16l8-8 8 8z"></path>
      </g>
      <g id="up_arrow">
        <path d="M18 24h-2v-16h2v16z"></path>
        <path d="M23.35 14.759l-6.35-5.441-6.35 5.441-1.301-1.518 7.65-6.559 7.65 6.559z"></path>
      </g>
      <g id="up_chevron">
        <path d="M21.293 18.707l-5.293-5.293-5.293 5.293-1.414-1.414 6.707-6.707 6.707 6.707z"></path>
      </g>
      <g id="up_small">
        <path d="M10 18l6-6 6 6h-12z"></path>
      </g>
      <g id="upload">
        <path d="M4 24h24v4h-24v-4z"></path>
        <path d="M22 10h-12l6-6 6 6z"></path>
        <path d="M18 22h-4v-12h4v12z"></path>
      </g>
      <g id="upload_alt">
        <path d="M22.93 6l3.070 4.606v15.394h-20v-15.394l3.070-4.606h13.859zM24 4h-16l-4 6v18h24v-18l-4-6z"></path>
        <path d="M22 20h-12l6-6 6 6z"></path>
        <path d="M18 24h-4v-4h4v4z"></path>
        <path d="M10 8l-2 4h16l-2-4z"></path>
      </g>
      <g id="upload_alt1">
        <path d="M22 10h-12l6-6 6 6z"></path>
        <path d="M18 18h-4v-12h4v12z"></path>
        <path d="M4 20v8h24v-8h-24zM22 26h-2v-2h2v2zM26 26h-2v-2h2v2z"></path>
      </g>
      <g id="user">
        <path d="M29 28h-2c0-2.365-4.479-5-10.906-5s-10.906 2.635-10.906 5h-2c0-3.926 5.669-7 12.906-7s12.906 3.074 12.906 7z"></path>
        <path d="M16 3c-3.859 0-7 3.141-7 7 0 1.064 0.29 1.924 0.588 2.713l0.29 0.803c0.197 0.559 0.396 1.117 0.64 1.656 0.77 1.705 1.963 2.898 3.449 3.453 0.208 0.078 0.423 0.137 0.713 0.211l0.268 0.062c0.342 0.064 0.693 0.102 1.053 0.102s0.711-0.037 1.050-0.1c0.092-0.018 0.182-0.041 0.342-0.084 0.219-0.055 0.434-0.113 0.64-0.189 1.488-0.557 2.682-1.75 3.451-3.455 0.244-0.539 0.442-1.098 0.64-1.656l0.29-0.803c0.298-0.789 0.588-1.649 0.588-2.713 0-3.859-3.141-7-7-7zM20.541 12.006c-0.105 0.279-0.205 0.562-0.306 0.844-0.178 0.506-0.354 1.010-0.575 1.498-0.381 0.844-1.093 1.943-2.33 2.406-0.136 0.051-0.278 0.086-0.421 0.121-0.109 0.038-0.19 0.039-0.29 0.064-0.427 0.071-0.881 0.072-1.305-0.006l-0.224-0.059c-0.143-0.035-0.285-0.070-0.423-0.123-1.235-0.461-1.947-1.561-2.328-2.404-0.221-0.488-0.397-0.992-0.575-1.498-0.101-0.281-0.2-0.564-0.306-0.844-0.291-0.771-0.459-1.346-0.459-2.006 0-2.758 2.243-5 5-5s5 2.242 5 5c0 0.66-0.168 1.234-0.459 2.006z"></path>
      </g>
      <g id="user_admin">
        <path d="M17.619 11.017l0.006-0.029 0.001-0.002c0.024-0.073 0.027-0.143 0.049-0.216 0.098-0.305 0.184-0.673 0.24-1.050l0.005-0.040c0.015-0.163 0.024-0.353 0.024-0.544 0-0.082-0.002-0.163-0.005-0.244l0 0.012c0-0.168 0.025-0.34 0.012-0.505l-0.008-0.041c-0.076-0.864-0.335-1.653-0.738-2.349l0.015 0.027c-0.998-1.821-2.902-3.035-5.089-3.035-0.040 0-0.079 0-0.119 0.001l0.006-0-0.001 0-0.001-0c-0.034-0.001-0.073-0.001-0.113-0.001-2.187 0-4.091 1.214-5.074 3.005l-0.015 0.030c-0.389 0.668-0.648 1.458-0.722 2.3l-0.002 0.021-0.008 0.041c-0.013 0.165 0.011 0.337 0.012 0.505-0.003 0.069-0.004 0.151-0.004 0.233 0 0.192 0.009 0.381 0.026 0.568l-0.002-0.024c0.062 0.418 0.147 0.786 0.26 1.143l-0.014-0.052c0.021 0.072 0.025 0.143 0.049 0.216l0.001 0.002 0.006 0.029 0.070 0.213c0.389 1.593 1.143 2.974 2.169 4.102l-0.007-0.008c0.879 0.827 2.063 1.337 3.367 1.343h0.001l0.001-0 0.001 0c1.305-0.006 2.49-0.516 3.371-1.345l-0.003 0.002c1.019-1.121 1.773-2.502 2.149-4.031l0.013-0.064zM15.711 10.406l-0.066 0.203c-0.297 1.26-0.866 2.358-1.643 3.273l0.009-0.011c-0.527 0.471-1.227 0.759-1.994 0.759s-1.466-0.288-1.997-0.761l0.003 0.003c-0.768-0.904-1.337-2.002-1.623-3.209l-0.011-0.053-0.066-0.203c-0.168-0.428-0.266-0.924-0.266-1.442 0-0.711 0.184-1.379 0.506-1.96l-0.011 0.021c0.656-1.215 1.919-2.026 3.373-2.026 0.032 0 0.065 0 0.097 0.001l-0.005-0c0.027-0.001 0.060-0.001 0.092-0.001 1.453 0 2.717 0.812 3.363 2.006l0.010 0.020c0.312 0.56 0.495 1.228 0.495 1.939 0 0.518-0.098 1.014-0.275 1.469l0.009-0.027z"></path>
        <path d="M12.094 18c-6.115 0-10.906 2.635-10.906 6h2c0-1.893 3.657-4 8.906-4 0.786 0.003 1.557 0.056 2.313 0.155l-0.092-0.010c-0.1-0.753-0.17-1.441-0.216-2.037-0.65-0.064-1.316-0.108-2.005-0.108z"></path>
        <path d="M23 14l-7 2s0 14 7 14 7-14 7-14z"></path>
      </g>
      <g id="user_groups">
        <path d="M9.938 18.333c-0.262 0-0.514-0.027-0.762-0.071l-0.213-0.050c-0.193-0.048-0.353-0.092-0.506-0.15-1.082-0.4-1.949-1.257-2.502-2.475-0.168-0.369-0.305-0.751-0.439-1.133l-0.191-0.526c-0.203-0.531-0.418-1.16-0.418-1.929 0-2.757 2.258-5 5.031-5s5.031 2.243 5.031 5c0 0.769-0.215 1.397-0.416 1.928l-0.19 0.519c-0.137 0.385-0.275 0.771-0.445 1.143-0.553 1.216-1.42 2.072-2.504 2.474-0.15 0.057-0.309 0.101-0.469 0.139l-0.244 0.059c-0.25 0.045-0.504 0.072-0.764 0.072zM9.938 9c-1.672 0-3.031 1.346-3.031 3 0 0.391 0.1 0.729 0.287 1.217l0.207 0.569c0.115 0.328 0.23 0.657 0.375 0.975 0.334 0.731 0.797 1.212 1.379 1.428 0.080 0.029 0.162 0.050 0.244 0.070 0.523 0.117 0.683 0.085 0.945 0.034 0.215-0.055 0.295-0.075 0.373-0.104 0.584-0.217 1.049-0.697 1.381-1.43 0.146-0.321 0.264-0.652 0.381-0.982l0.205-0.562c0.186-0.487 0.285-0.825 0.285-1.216 0-1.654-1.359-3-3.031-3z"></path>
        <path d="M21.938 20.333c-0.262 0-0.514-0.027-0.762-0.071l-0.213-0.050c-0.193-0.048-0.354-0.092-0.506-0.149-1.082-0.4-1.949-1.257-2.502-2.475-0.168-0.369-0.305-0.751-0.439-1.133l-0.192-0.526c-0.203-0.531-0.418-1.16-0.418-1.929 0-2.757 2.258-5 5.031-5s5.031 2.243 5.031 5c0 0.769-0.215 1.397-0.416 1.928l-0.189 0.52c-0.137 0.385-0.275 0.771-0.445 1.143-0.553 1.216-1.42 2.072-2.504 2.474-0.15 0.057-0.309 0.101-0.469 0.139l-0.244 0.059c-0.25 0.045-0.504 0.072-0.763 0.072zM21.938 11c-1.672 0-3.031 1.346-3.031 3 0 0.391 0.1 0.729 0.287 1.217l0.207 0.569c0.115 0.328 0.23 0.657 0.375 0.975 0.334 0.731 0.797 1.212 1.379 1.428 0.080 0.029 0.162 0.050 0.244 0.070 0.523 0.117 0.684 0.084 0.945 0.034 0.215-0.055 0.295-0.075 0.373-0.104 0.584-0.217 1.049-0.697 1.381-1.43 0.146-0.321 0.264-0.652 0.381-0.982l0.205-0.562c0.185-0.487 0.285-0.825 0.285-1.216 0-1.654-1.359-3-3.031-3z"></path>
        <path d="M29 26h2c0-2.851-3.869-5-9-5s-9 2.149-9 5h2c0-1.416 2.994-3 7-3s7 1.584 7 3z"></path>
        <path d="M15.763 20.131c-1.543-0.701-3.518-1.131-5.763-1.131-5.131 0-9 2.149-9 5h2c0-1.416 2.994-3 7-3 1.303 0 2.481 0.179 3.502 0.454 0.656-0.505 1.392-0.963 2.261-1.324z"></path>
      </g>
      <g id="var">
        <path d="M6.511 12.661h1.463l1.697 4.943 1.625-4.943h1.428l-2.391 6.678h-1.43l-2.393-6.678zM17.276 19.339l-0.572-1.519h-2.676l-0.555 1.519h-1.43l2.609-6.678h1.426l2.68 6.678h-1.482zM14.438 16.694h1.838l-0.928-2.481-0.91 2.481zM23.864 12.839c0.32 0.125 0.59 0.34 0.785 0.645 0.195 0.301 0.285 0.66 0.285 1.051 0 0.5-0.143 0.91-0.445 1.232-0.285 0.34-0.732 0.537-1.32 0.625 0.303 0.178 0.535 0.357 0.73 0.553 0.18 0.215 0.445 0.572 0.77 1.090l0.82 1.305h-1.625l-0.965-1.447c-0.355-0.518-0.59-0.857-0.715-0.982-0.125-0.143-0.266-0.232-0.41-0.285-0.141-0.055-0.375-0.070-0.678-0.070h-0.268v2.785h-1.357v-6.678h2.838c0.715 0 1.235 0.053 1.555 0.178zM23.024 15.409c0.16-0.053 0.305-0.16 0.395-0.285 0.088-0.143 0.125-0.305 0.125-0.5 0-0.23-0.055-0.41-0.18-0.555-0.125-0.125-0.285-0.213-0.5-0.248-0.107-0.018-0.445-0.037-0.982-0.037h-1.053v1.697h1c0.642 0 1.035-0.018 1.195-0.072z"></path>
        <path d="M27.691 10.309v11.381h-23.381v-11.381h23.381zM30 8h-28v16h28v-16z"></path>
      </g>
      <g id="view">
        <path d="M16 10c6.23 0 10.083 4.055 11.573 6-1.493 1.949-5.345 6-11.573 6-6.23 0-10.083-4.055-11.573-6 1.493-1.949 5.345-6 11.573-6zM16 8c-9.333 0-14 8-14 8s4.667 8 14 8 14-8 14-8-4.667-8-14-8v0z"></path>
        <path d="M18 16c-1.105 0-2-0.895-2-2 0-0.805 0.482-1.489 1.167-1.807-0.372-0.114-0.758-0.193-1.167-0.193-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4c0-0.409-0.079-0.796-0.193-1.167-0.317 0.685-1.002 1.167-1.807 1.167z"></path>
      </g>
      <g id="warning_circle_fill">
        <path d="M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.627 0 12-5.373 12-12v0c0-6.627-5.373-12-12-12v0zM17.066 22.316c-0.278 0.285-0.666 0.462-1.095 0.462-0.844 0-1.528-0.684-1.528-1.528s0.684-1.528 1.528-1.528c0.844 0 1.528 0.684 1.528 1.528v0c0 0.010 0 0.021 0 0.032 0 0.405-0.166 0.771-0.434 1.034l-0 0zM17 17.25h-2l-0.753-6.022c-0.009-0.066-0.014-0.141-0.014-0.218 0-0.972 0.788-1.76 1.76-1.76h0.013c0.972 0 1.76 0.788 1.76 1.76 0 0.077-0.005 0.153-0.015 0.227l0.001-0.009z"></path>
      </g>
      <g id="warning_circle_outline">
        <path d="M16 19.25c-0.809 0.011-1.462 0.67-1.462 1.481 0 0.818 0.663 1.481 1.481 1.481s1.481-0.663 1.481-1.481c0-0.409-0.166-0.779-0.434-1.047v0c-0.263-0.268-0.629-0.434-1.034-0.434-0.011 0-0.023 0-0.034 0l0.002-0z"></path>
        <path d="M16.006 9.75h-0.013c-0.972 0-1.76 0.788-1.76 1.76 0 0.077 0.005 0.153 0.014 0.227l-0.001-0.009 0.753 6.022h2l0.753-6.022c0.009-0.066 0.014-0.141 0.014-0.218 0-0.972-0.788-1.76-1.76-1.76v0z"></path>
        <path d="M16 4c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.627 0 12-5.373 12-12v0c0-6.627-5.373-12-12-12v0zM16 26c-5.523 0-10-4.477-10-10s4.477-10 10-10c5.523 0 10 4.477 10 10v0c-0.006 5.52-4.48 9.994-9.999 10h-0.001z"></path>
      </g>
      <g id="warning_triangle_fill">
        <path d="M29.719 24.969l-12-20c-0.188-0.29-0.434-0.527-0.724-0.698l-0.010-0.005c-0.282-0.167-0.622-0.266-0.984-0.266s-0.702 0.099-0.994 0.271l0.009-0.005c-0.3 0.176-0.547 0.413-0.729 0.695l-0.005 0.008-12 20c-0.177 0.284-0.281 0.629-0.281 0.998 0 0.001 0 0.001 0 0.002v-0c0.001 0.377 0.093 0.732 0.256 1.044l-0.006-0.013c0.184 0.308 0.438 0.556 0.74 0.729l0.010 0.005c0.285 0.167 0.628 0.266 0.994 0.266 0.002 0 0.004 0 0.006 0h24c0.002 0 0.003 0 0.005 0 0.366 0 0.709-0.099 1.004-0.271l-0.009 0.005c0.312-0.178 0.566-0.427 0.745-0.725l0.005-0.009c0.157-0.3 0.249-0.655 0.25-1.031v-0c0-0.001 0-0.001 0-0.002 0-0.369-0.105-0.714-0.286-1.006l0.005 0.008zM17.066 23.066c-0.278 0.285-0.666 0.462-1.095 0.462-0.844 0-1.528-0.684-1.528-1.528s0.684-1.528 1.528-1.528c0.844 0 1.528 0.684 1.528 1.528v0c0 0.010 0 0.021 0 0.032 0 0.405-0.166 0.771-0.434 1.034l-0 0zM17 18h-2l-0.753-6.022c-0.009-0.066-0.014-0.141-0.014-0.218 0-0.972 0.788-1.76 1.76-1.76 0 0 0 0 0 0h0.013c0.972 0 1.76 0.788 1.76 1.76 0 0.077-0.005 0.153-0.015 0.227l0.001-0.009z"></path>
      </g>
      <g id="warning_triangle_outline">
        <path d="M29.719 24.969l-12-20c-0.188-0.29-0.434-0.527-0.724-0.698l-0.010-0.005c-0.282-0.167-0.622-0.266-0.984-0.266s-0.702 0.099-0.994 0.271l0.009-0.005c-0.3 0.176-0.547 0.413-0.729 0.695l-0.005 0.008-12 20c-0.177 0.284-0.281 0.629-0.281 0.998 0 0.001 0 0.001 0 0.002v-0c0.001 0.377 0.093 0.732 0.256 1.044l-0.006-0.013c0.184 0.308 0.438 0.556 0.74 0.729l0.010 0.005c0.285 0.167 0.628 0.266 0.994 0.266 0.002 0 0.004 0 0.006 0h24c0.002 0 0.003 0 0.005 0 0.366 0 0.709-0.099 1.004-0.271l-0.009 0.005c0.312-0.178 0.566-0.427 0.745-0.725l0.005-0.009c0.157-0.3 0.249-0.655 0.25-1.031v-0c0-0.001 0-0.001 0-0.002 0-0.369-0.105-0.714-0.286-1.006l0.005 0.008zM27.998 26l-23.986-0.029 11.992-19.973 11.996 19.971z"></path>
        <path d="M16 20.5c-0.809 0.011-1.462 0.67-1.462 1.481 0 0.818 0.663 1.481 1.481 1.481s1.481-0.663 1.481-1.481c0-0.409-0.166-0.779-0.434-1.047v0c-0.263-0.268-0.629-0.434-1.034-0.434-0.011 0-0.023 0-0.034 0l0.002-0z"></path>
        <path d="M14.247 12.978l0.753 6.022h2l0.753-6.022c0.009-0.066 0.014-0.141 0.014-0.218 0-0.972-0.788-1.76-1.76-1.76h-0.013c-0.972 0-1.76 0.788-1.76 1.76 0 0.077 0.005 0.153 0.014 0.227l-0.001-0.009z"></path>
      </g>
      <g id="waterfall_chart">
        <path d="M2 20h6v8h-6v-8z"></path>
        <path d="M10 16h4v4h-4v-4z"></path>
        <path d="M16 4h4v10h-4v-10z"></path>
        <path d="M22 4h6v24h-6v-24z"></path>
      </g>
      <g id="wordcloud_chart">
        <path d="M4 14h24v4h-24v-4z"></path>
        <path d="M8 10h10v2h-10v-2z"></path>
        <path d="M12 6h8v2h-8v-2z"></path>
        <path d="M20 10h4v2h-4v-2z"></path>
        <path d="M14 20h10v2h-10v-2z"></path>
        <path d="M12 24h8v2h-8v-2z"></path>
        <path d="M8 20h4v2h-4v-2z"></path>
      </g>
      <g id="zoom_in">
        <path d="M10.844 14h6v2h-6v-2z"></path>
        <path d="M26.956 26.712l-0.113-0.118-6-6c0.674-0.822 1.207-1.79 1.545-2.844l0.017-0.062c0.274-0.819 0.432-1.762 0.432-2.741 0-0.151-0.004-0.302-0.011-0.452l0.001 0.021c-0.124-2.298-1.098-4.348-2.609-5.859v0c-0.818-0.849-1.807-1.528-2.912-1.979l-0.057-0.021c-1.004-0.415-2.169-0.656-3.391-0.656s-2.387 0.241-3.451 0.678l0.061-0.022c-1.162 0.473-2.151 1.151-2.966 1.997l-0.003 0.003c-0.849 0.818-1.527 1.807-1.979 2.912l-0.021 0.057c-0.415 1.004-0.656 2.169-0.656 3.391s0.241 2.387 0.678 3.451l-0.022-0.061c0.473 1.162 1.151 2.151 1.997 2.966l0.003 0.003c1.511 1.512 3.561 2.485 5.837 2.608l0.023 0.001c0.129 0.007 0.279 0.010 0.431 0.010 0.98 0 1.922-0.158 2.804-0.45l-0.063 0.018c1.117-0.356 2.084-0.889 2.922-1.575l-0.015 0.012 6 6c0.182 0.19 0.438 0.308 0.721 0.308 0.551 0 0.997-0.447 0.997-0.997 0-0.226-0.075-0.434-0.202-0.601l0.002 0.003zM18.813 19.969c-0.648 0.635-1.415 1.152-2.264 1.513l-0.048 0.018c-0.788 0.314-1.7 0.497-2.655 0.5h-0.001c-0.945-0.001-1.847-0.184-2.673-0.517l0.048 0.017c-0.897-0.379-1.664-0.896-2.314-1.532l0.001 0.001c-0.65-0.639-1.169-1.409-1.515-2.268l-0.016-0.045c-0.333-0.785-0.528-1.697-0.531-2.655v-0.001c0.001-0.948 0.197-1.85 0.548-2.669l-0.017 0.044c0.723-1.755 2.089-3.121 3.798-3.827l0.046-0.017c0.775-0.335 1.677-0.53 2.624-0.531h0.001c0.959 0.003 1.871 0.198 2.702 0.549l-0.046-0.017c0.903 0.362 1.673 0.882 2.312 1.53l0.001 0.001c0.635 0.648 1.152 1.415 1.513 2.264l0.018 0.048c0.316 0.778 0.499 1.68 0.5 2.625v0c0 0.022 0 0.048 0 0.074 0 1.912-0.777 3.643-2.032 4.894l-0 0z"></path>
      </g>
      <g id="zoom_out">
        <path d="M14.844 14v-3h-2v3h-3v2h3v3h2v-3h3v-2h-3z"></path>
        <path d="M26.956 26.712l-0.113-0.118-6-6c0.674-0.822 1.207-1.79 1.545-2.844l0.017-0.062c0.274-0.819 0.432-1.762 0.432-2.741 0-0.151-0.004-0.302-0.011-0.452l0.001 0.021c-0.124-2.298-1.098-4.348-2.609-5.859v0c-0.818-0.849-1.807-1.528-2.912-1.979l-0.057-0.021c-1.004-0.415-2.169-0.656-3.391-0.656s-2.387 0.241-3.451 0.678l0.061-0.022c-1.162 0.473-2.151 1.151-2.966 1.997l-0.003 0.003c-0.849 0.818-1.527 1.807-1.979 2.912l-0.021 0.057c-0.415 1.004-0.656 2.169-0.656 3.391s0.241 2.387 0.678 3.451l-0.022-0.061c0.473 1.162 1.151 2.151 1.997 2.966l0.003 0.003c1.511 1.512 3.561 2.485 5.837 2.608l0.023 0.001c0.129 0.007 0.279 0.010 0.431 0.010 0.98 0 1.922-0.158 2.804-0.45l-0.063 0.018c1.117-0.356 2.084-0.889 2.922-1.575l-0.015 0.012 6 6c0.182 0.19 0.438 0.308 0.721 0.308 0.551 0 0.997-0.447 0.997-0.997 0-0.226-0.075-0.434-0.202-0.601l0.002 0.003zM18.813 19.969c-0.648 0.635-1.415 1.152-2.264 1.513l-0.048 0.018c-0.788 0.314-1.7 0.497-2.655 0.5h-0.001c-0.945-0.001-1.847-0.184-2.673-0.517l0.048 0.017c-0.897-0.379-1.664-0.896-2.314-1.532l0.001 0.001c-0.65-0.639-1.169-1.409-1.515-2.268l-0.016-0.045c-0.333-0.785-0.528-1.697-0.531-2.655v-0.001c0.001-0.948 0.197-1.85 0.548-2.669l-0.017 0.044c0.723-1.755 2.089-3.121 3.798-3.827l0.046-0.017c0.775-0.335 1.677-0.53 2.624-0.531h0.001c0.959 0.003 1.871 0.198 2.702 0.549l-0.046-0.017c0.903 0.362 1.673 0.882 2.312 1.53l0.001 0.001c0.635 0.648 1.152 1.415 1.513 2.264l0.018 0.048c0.316 0.778 0.499 1.68 0.5 2.625v0c0 0.022 0 0.048 0 0.074 0 1.912-0.777 3.643-2.032 4.894l-0 0z"></path>
      </g>
    </defs>
  </svg>
</iron-iconset-svg>`;
  document.head.appendChild(unitIconSet.content);

  /**
  * Renders an icon
  * @name UnityIcon
  * @param {string} icon, unity icon or iron icon to display. If defined along src, icon takes priority.
  * @param {string} src, use instead of icon, path to the image to display
  * @return {LitElement} returns a class extended from LitElement

  * @example
  * <unity-icon icon="unity:add"></unity-icon>
  * <unity-icon src="./star.png"></unity-icon>

   * CSS Vars:
   *   --unity-icon-height: height of the icon, defaults to 16px
   *   --unity-icon-width: width of the icon, defaults to 16px
  **/
  let UnityIcon = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityIcon, _LitElement);
    var _super = _createSuper(UnityIcon);
    function UnityIcon() {
      var _this;
      _classCallCheck(this, UnityIcon);
      _this = _super.call(this);
      _this.icon = '';
      _this.src = '';
      return _this;
    }
    _createClass(UnityIcon, [{
      key: "render",
      value: function render() {
        const {
          icon,
          src
        } = this;
        if (icon && src) console.warn("Both 'icon' and 'src' properties have been defined; 'src' will be ignored.");
        return html$1`
      <iron-icon
        icon=${this.icon}
        src=${this.src}
      ></iron-icon>    
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          icon: {
            type: String
          },
          src: {
            type: String
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          display: inline-block;
          --default-unity-icon-height: 16px;
          --default-unity-icon-width: 16px;
        }
        iron-icon {
          --iron-icon-height: var(--unity-icon-height, var(--default-unity-icon-height));
          --iron-icon-width: var(--unity-icon-width, var(--default-unity-icon-width));
        }
      `];
      }
    }]);
    return UnityIcon;
  }(LitElement);
  window.customElements.define('unity-icon', UnityIcon);

  /**
   * Tag with configurable styles
   * @name UnityTag
   * @param {string} value, value associated with the tag
   * @param {string} label, tag text
   * @param {boolean} withClose, controls if close button is shown
   * @param {function} onClose, function called on clicking close button, ignored if !withClose
   * @param {function} onClick, function called on clicking tag, non-close button area
   * @example
   * <unity-tag
   *   .value="test-value"
   *   label="example tag"
   *   withClose
   *   .onClose=${removetag}
   *   .onClick=${searchByLabel}
   * />
   *
   * CSS Variables:
   * --tag-color
   * --tag-text-color
   * --tag-font-size
   * --tag-padding
   * --tag-margin
   * --tag-border
   * --tag-hover-text-color
   */
  let UnityTag = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTag, _LitElement);
    var _super = _createSuper(UnityTag);
    function UnityTag() {
      var _this;
      _classCallCheck(this, UnityTag);
      _this = _super.call(this);
      _this.value = '';
      _this.label = '';
      _this.withClose = false;
      _this.onClose = null;
      _this.onClick = null;
      return _this;
    }
    _createClass(UnityTag, [{
      key: "handleClick",
      value: function handleClick(e) {
        if (this.onClick instanceof Function) {
          this.onClick(e, this.value);
        }
      }
    }, {
      key: "handleClose",
      value: function handleClose(e) {
        if (this.onClose instanceof Function) {
          e.stopImmediatePropagation();
          this.onClose(e, this.value);
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          label,
          withClose
        } = this;
        return html$1`
      <div class=${this.onClick instanceof Function ? 'clickable' : ''} id="tag" @click="${e => this.handleClick(e)}">
        <unity-typography class="label">${label}</unity-typography>
        ${!!withClose ? html$1`<unity-icon
            icon="unity:close"
            class="close"
            id="close-tag-button"
            @click="${e => this.handleClose(e)}"
          ></unity-icon>` : null}
      </div>
    `;
      }
    }], [{
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-tag-color: var(--light-gray-1-color, var(--default-light-gray-1-color));
          --default-tag-text-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
          --default-tag-font-size: var(--small-text-size, var(--default-small-text-size));
          --default-tag-padding: var(--padding-size-sm, var(--default-padding-size-sm));
          --default-tag-margin: 4px;
          --default-tag-border: none;
          --default-tag-hover-text-color: var(--gray-color, var(--default-gray-color));
          --icon-size: calc(var(--tag-font-size, var(--default-tag-font-size)) * 1.4);
          display: flex;
        }
        #tag {
          display: flex;
          align-items: center;
          background-color: var(--tag-color, var(--default-tag-color));
          border: var(--tag-border, var(--default-tag-border));
          border-radius: var(--tag-font-size, var(--default-tag-font-size));
          padding: 2px var(--tag-padding, var(--default-tag-padding));
          white-space: nowrap;
          user-select: none;
          margin: var(--tag-margin, var(--default-tag-margin));
        }
        #tag.clickable {
          cursor: pointer;
        }
        .label {
          display: flex;
          flex: 1;
          justify-content: center;
          --font-color: var(--tag-text-color, var(--default-tag-text-color));
          --font-size: var(--tag-font-size, var(--default-tag-font-size));
        }
        .close {
          display: flex;
          flex: 0;
          color: var(--tag-text-color, var(--default-tag-text-color));
          height: var(--icon-size);
          width: var(--icon-size);
          padding-left: 4px;
          --unity-icon-height: var(--icon-size);
          --unity-icon-width: var(--icon-size);
        }
        .close:hover {
          color: var(--tag-hover-text-color, var(--default-tag-hover-text-color));
          cursor: pointer;
        }
      `];
      }
    }, {
      key: "properties",
      get: function () {
        return {
          value: {
            type: String
          },
          label: {
            type: String
          },
          withClose: {
            type: Boolean
          },
          onClose: {
            type: Function
          },
          onClick: {
            type: Function
          }
        };
      }
    }]);
    return UnityTag;
  }(LitElement);
  window.customElements.define('unity-tag', UnityTag);

  /**
  * Renders a menu with optional submenus that display on hover.
  * @name UnitySelectMenu
  * @fileOverview A menu component with optional submenus
  * @param {Array} options, the list of menu options, option properties include: label, icon, comment (subtext), submenu, tag (flag), id (returned to onMenuClick), tagStyles (customizable tag styles only)
  * @param {Array} highlighted, an array of ids for the option(s) to highlight
  * @param {Function} onMenuClick, callback when a menu option is clicked
  * @param {Boolean} borderless, do not render list border or box shadow, default: false
  *
  * @example
  * <unity-select-menu
  *   .options=${dataMock.submenus}
  *   .onMenuClick=${this.onMenuClick}
  *   .highlighted={"1"}
  *   borderless
  * >
  * </unity-select-menu>
  **/
  let UnitySelectMenu = /*#__PURE__*/function (_LitElement) {
    _inherits(UnitySelectMenu, _LitElement);
    var _super = _createSuper(UnitySelectMenu);
    function UnitySelectMenu() {
      var _this;
      _classCallCheck(this, UnitySelectMenu);
      _this = _super.call(this);
      _this.onMenuClick = () => {};
      _this.borderless = false;
      _this._options = [];
      _this._highlighted = [];
      _this._horizontalOffset = 0;
      return _this;
    }
    _createClass(UnitySelectMenu, [{
      key: "highlighted",
      get: function () {
        return this._highlighted;
      },
      set: function (value) {
        const oldValue = this._highlighted;
        this._highlighted = value;
        this.requestUpdate('highlighted', oldValue);
      }
    }, {
      key: "options",
      get: function () {
        return this._options;
      },
      set: function (value) {
        const oldValue = this._options;
        this._options = value;
        this.requestUpdate('options', oldValue);
      }
    }, {
      key: "clickedMenu",
      value:
      // Call callback function only when the options has no submenu
      function clickedMenu(id, submenu, e) {
        e.stopPropagation();
        if (!submenu) {
          this.onMenuClick(id);
        }
      }
    }, {
      key: "getSubmenuPos",
      value: function getSubmenuPos() {
        const optionsList = this.shadowRoot.querySelector("#options-list");
        let offset = 0;
        if (!!optionsList) {
          // have to use getComputedStyle in case of sub-pixel values
          // css string values, slice to remove trailing px
          const size = Number(getComputedStyle(optionsList).width.slice(0, -2));
          const borderWidth = Number(getComputedStyle(optionsList).borderWidth.slice(0, -2));
          offset = size - 2 * borderWidth;
        }
        this._horizontalOffset = offset;
      }
    }, {
      key: "renderOption",
      value: function renderOption(option) {
        const {
          label,
          icon,
          comment,
          submenu,
          id,
          tag,
          tagStyles: {
            "--tag-color": tagColor,
            "--tag-text-color": tagTextColor,
            "--tag-font-size": tagFontSize,
            "--tag-padding": tagPadding,
            "--tag-margin": tagMargin,
            "--tag-border": tagBorder,
            "--tag-hover-text-color": tagHoverTextColor
          } = {}
        } = option;

        // tag height should be 2 * (font size + internal margin)
        let tagStyle = "height: calc( (var(--tag-font-size, var(--default-tag-font-size)) + var(--tag-margin, var(--default-tag-margin)) ) * 2 );";
        if (tag) {
          if (tagColor) tagStyle += `--tag-color: ${tagColor};`;
          if (tagTextColor) tagStyle += `--tag-text-color: ${tagTextColor};`;
          if (tagFontSize) tagStyle += `--tag-font-size: ${tagFontSize};`;
          if (tagPadding) tagStyle += `--tag-padding: ${tagPadding};`;
          if (tagMargin) tagStyle += `--tag-margin: ${tagMargin};`;
          if (tagBorder) tagStyle += `--tag-border: ${tagBorder};`;
          if (tagHoverTextColor) tagStyle += `--tag-hover-text-color: ${tagHoverTextColor};`;
        }
        const optionHighlighted = this.highlighted.includes(id);
        return html$1`
      <li
        @click=${e => this.clickedMenu(id, submenu, e)}
        @mouseenter="${!!submenu ? () => this.getSubmenuPos() : () => {}}"
        class="${optionHighlighted ? 'highlighted-option' : null}"
        id="select-menu-option-${id}"
      >
        ${tag ? html$1`
          <unity-tag
            .label="${label}"
            id="tag-option-${id}"
            style="${tagStyle}"
          ></unity-tag>
        ` : html$1`
          <div class="option-label-wrapper">
            ${!!icon ? html$1`
              <div class="icon-left-wrapper">
                <unity-icon class="inner-icon" icon="${icon}"></unity-icon>
              </div>` : null}
            <p class="option-label">${label}</p>
            ${!!option.submenu ? html$1`
              <div class="icon-right-wrapper">
                <unity-icon class="inner-icon" icon="unity:right_chevron"></unity-icon>
              </div>` : null}
          </div>
          ${!!comment ? html$1`<p class="option-comment">${comment}</p>` : null}
          ${!!submenu ? this.renderSubmenu(submenu) : null}
        `}
      </li>
    `;
      }

      // recursively render sub select-menus
    }, {
      key: "renderSubmenu",
      value: function renderSubmenu(submenu) {
        return html$1`<unity-select-menu
      class="submenu"
      .options=${submenu}
      .onMenuClick=${this.onMenuClick}
      style="margin-left:${this._horizontalOffset}px;"
    ></unity-select-menu>`;
      }
    }, {
      key: "renderList",
      value: function renderList(optionsList) {
        return optionsList.map(option => this.renderOption(option));
      }
    }, {
      key: "render",
      value: function render() {
        const className = this.borderless ? "borderless" : null;
        return html$1`
      <ul id="options-list" class=${className}>
        ${this.renderList(this.options)}
      </ul>`;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          options: {
            type: Array
          },
          highlighted: {
            type: Array
          },
          onMenuClick: {
            type: Function
          },
          borderless: {
            type: Boolean
          },
          _horizontalOffset: {
            attribute: false
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
          * {
            box-sizing: border-box;
          }
          :host {
            --input-font: var(--font-family, var(--default-font-family));
            --label-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
            --text-color: var(--black-text-rgb, var(--default-black-text-rgb));
            --text-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
            --border-color: var(--global-nav-border-color, var(--default-global-nav-border-color));
            --highlighted-option-color: var(--primary-tint-2-color, var(--default-primary-tint-2-color));
            --highlighted-option-hover-color: var(--primary-color, var(--default-primary-color));
            --default-menu-hover-color: var(--light-gray-2-color, var(--default-light-gray-2-color));
            --default-menu-options-list-max-height: 330px;
            font-family: var(--input-font);
            border-collapse: collapse;
            user-select: none;
            display: flex;
            width: fit-content;
            max-width: 300px;
            overflow: auto;
          }
        .borderless {
          border: none;
          box-shadow: none;
        }
        p {
          margin-block-start: 0.5em;
          margin-block-end: 0.5em;
          padding: 0 8px;
          box-sizing: border-box;
        }
        ul {
          padding: 0;
          margin: 0;
          list-style: none;
          border: 1px solid #9299A4;
          box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
          border-radius: 2px;
          width: 100%;
          max-height: var(--menu-options-list-max-height, var(--default-menu-options-list-max-height));
        }
        li {
          font-size: var(--text-size);
          font-family: var(--input-font);
          background-color: var(--background-color, var(--default-background-color));
          box-sizing: border-box;
          margin: 0;
          display: flex;
          flex-direction: column;
          position:relative;
        }
        li:hover {
          background-color: var(--menu-hover-color, var(--default-menu-hover-color));
        }
        li:hover > .submenu {
          display: block;
        }
        .highlighted-option {
          background-color: var(--highlighted-option-color);
        }
        .highlighted-option:hover {
          background-color: var(--highlighted-option-hover-color);
        }
        .icon-left-wrapper {
          padding-left: 8px;
        }
        .icon-right-wrapper {
          padding-right: 4px;
        }
        .inner-icon {
          max-height: 1.8em;
          max-width: 1.8em;
        }
        .option-label-wrapper {
          display: flex;
          align-items: center;
        }
        .option-label {
          flex: 1;
          align-items: center;
          width: 100%;
        }
        .option-comment {
          font-size: 0.9em;
          line-height: 1.2em;
          margin-top: 0;
        }
        .submenu {
          position: fixed;
          width: max-content;
          display:none;
          margin-top: -1px;
        }
      `];
      }
    }]);
    return UnitySelectMenu;
  }(LitElement);
  window.customElements.define('unity-select-menu', UnitySelectMenu);

  /**
   * @name UnityCard
   * @param {String} [title] the card title
   * @param {String} [description] the card description (note that if this attribute is provided, the "description" slot will not be available)
   * @param {String} [image] the source for the image (note that if this attribute is provided, the "image" slot will not be available)
   * @param {Boolean} [menuButton] show a menu button in the top-right corner; default: false
   * @param {Boolean} [closeButton] show a close button in the top-right corner; default: false (Note that this is superseded by `menuButton - both will not show`)
   * @param {Boolean} [hoverAnimation] show an animation on the border when the card is hovered over; default: false
   * @param {Boolean} [borderless] no border or shadow for the card; default: false
   * @param {Boolean} [centerContent] center the title and description in the content region; default: false
   * @param {Boolean} [showMenu] force the menu to show or hide
   * @param {Boolean} [closeOnMenuClick] close the menu once an option is selected; default: true
   * @param {Array} [menuOptions] options for the menu. See unity-select-menu for structure.
   * @param {Array} [highlightedMenuOptions] sets which options are highlighted. See unity-select-menu for structure.
   * @param {Function} [onMenuClick] callback for selecting a menu option. See unity-select-menu for structure.
   * @param {Function} [onClose] a callback for when the close button is clicked
   * @param {Function} [onClick] a callback for when the card is clicked
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *  <unity-card
   *    title="My Card"
   *    description="A very swell card"
   *    image="./path/to/image"
   *    closeButton
   *  >
   *  </unity-card>
   *  <unity-card
   *    title="Card with Slots"
   *    menuButton
   *  >
   *    <div slot="description">
   *      <unity-typography>This card has a button in the bottom</unity-typography>
   *      <unity-button>Click Me</unity-button>
   *    </div>
   *    <img slot="image" src="http://placekitten.com/200/200"
   *    <div slot="menu-content">
   *      <unity-select-menu>
   *        .options="${selectMenuOptions}"
   *      </unity-select-menu>
   *    </div>
   *  </unity-card>
   *
   *  CSS Vars:
   * @css --card-border - default value: 1px solid --gray-color
   * @css --card-border-radius - default value: 5px
   * @css --card-menu-border-radius - default value: 0
   * @css --card-hover-border - default value: 1px solid --primary-color
   * @css --card-height - default value: 240px
   * @css --card-width - default value: 180px
   * @css --card-icon-color - default value: --dark-gray-color
   * @css --card-no-image-background - default value: --gray-color
   * @css --card-image-flex - default value: 8
   * @css --card-content-flex - default value: 3
   */
  let UnityCard = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityCard, _LitElement);
    var _super = _createSuper(UnityCard);
    function UnityCard() {
      var _this;
      _classCallCheck(this, UnityCard);
      _this = _super.call(this);
      _this.title = '';
      _this.description = '';
      _this.image = '';
      _this.menuButton = false;
      _this.closeButton = false;
      _this.hoverAnimation = false;
      _this.borderless = false;
      _this.centerContent = false;
      _this.showMenu = false;
      _this.closeOnMenuClick = true;
      _this.menuOptions = [];
      _this.highlightedMenuOptions = [];
      _this.onMenuClick = () => {};
      _this.onClose = () => {};
      _this.onClick = () => {};
      _this._showMenu = false;
      _this._actionButtonRef = null;
      return _this;
    }
    _createClass(UnityCard, [{
      key: "updated",
      value: function updated() {
        this._actionButtonRef = this.shadowRoot.querySelector('#action-button-container');
      }
    }, {
      key: "_openMenu",
      value: function _openMenu() {
        this.showMenu = true;
      }
    }, {
      key: "_closeMenu",
      value: function _closeMenu() {
        this.showMenu = false;
      }
    }, {
      key: "_handleMenuButtonClick",
      value: function _handleMenuButtonClick(e) {
        e.stopPropagation();
        if (!this.showMenu) {
          this._openMenu();
        } else {
          this._closeMenu();
        }
      }
    }, {
      key: "_handleMenuItemClick",
      value: function _handleMenuItemClick(id) {
        this.onMenuClick(id);
        if (this.closeOnMenuClick) this._closeMenu();
      }
    }, {
      key: "render",
      value: function render() {
        const {
          title,
          description,
          image,
          menuButton,
          closeButton,
          hoverAnimation,
          borderless,
          showMenu,
          centerContent,
          menuOptions,
          highlightedMenuOptions,
          onClose,
          onClick
        } = this;
        return html$1`
      <div class="container ${borderless ? 'borderless' : hoverAnimation ? 'hoverable' : ''}" @click="${onClick.bind(this)}">
        <div id="image-container">
          ${!!image ? html$1`
              <div id="card-image" style="background-image: url(${image})"></div>
            ` : html$1`
              <slot name="card-image"></slot>
            `}
          ${menuButton || closeButton ? html$1`<div id="action-button-container">
            ${menuButton ? html$1`
                <unity-button
                  id="action-button"
                  type="borderless"
                  centerIcon="unity:ellipses_vertical"
                  @click="${this._handleMenuButtonClick.bind(this)}"
                ></unity-button>
              ` : closeButton ? html$1`
                  <unity-button
                    id="action-button"
                    type="borderless"
                    centerIcon="unity:close"
                    @click="${onClose}"
                  ></unity-button>
                ` : ''}
          </div>` : ''}
        </div>
        <div class="content-container ${centerContent ? 'center-content' : ''}">
          ${!!title ? html$1`<unity-typography
            id="title-text"
            size="header2"
            weight="header2"
          >
            ${title}
          </unity-typography>` : html$1`
            <slot name="title"></slot>
          `}
          ${!!description ? html$1`
              <unity-typography
                id="description-text"
                size="paragraph"
                weight="paragraph"
              >
                ${description}
              </unity-typography>
            ` : html$1`
              <slot name="description"></slot>
            `}
        </div>
      </div>
      ${menuButton ? html$1`
        <unity-popover
          id="popover"
          placement="auto-start"
          .show="${showMenu}"
          .onClose="${this._closeMenu.bind(this)}"
          .referenceElement="${this._actionButtonRef}"
          closeOnOutsideClick
          flip
        >
          <unity-select-menu
            id="menu-content"
            slot="popover-content"
            .options="${menuOptions}"
            .onMenuClick="${this._handleMenuItemClick.bind(this)}"
            .highlighted="${highlightedMenuOptions}"
            borderless
          ></unity-select-menu>
        </unity-popover>
      ` : ''}
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          title: {
            type: String
          },
          description: {
            type: String
          },
          image: {
            type: String
          },
          menuButton: {
            type: Boolean
          },
          closeButton: {
            type: Boolean
          },
          hoverAnimation: {
            type: Boolean
          },
          borderless: {
            type: Boolean
          },
          centerContent: {
            type: Boolean
          },
          showMenu: {
            type: Boolean
          },
          closeOnMenuClick: {
            type: Boolean
          },
          onMenuClick: {
            type: Function
          },
          onClose: {
            type: Function
          },
          onClick: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-card-border: 1px solid var(--gray-color, var(--default-gray-color));
          --default-card-border-radius: 5px;
          --default-card-menu-border-radius: 0;
          --default-card-hover-border: 1px solid var(--primary-color, var(--default-primary-color));
          --default-card-height: 240px;
          --default-card-width: 180px;
          --default-card-icon-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-card-no-image-background: var(--gray-color, var(--default-gray-color));
          --default-card-image-flex: 8;
          --default-card-content-flex: 4;
          --default-title-flex: unset;
          --default-card-color: white;
          --default-card-description-padding: 10px;
          max-height: var(--card-height, var(--default-card-height));
        }

        .container {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          border: var(--card-border, var(--default-card-border));
          box-shadow: var(--card-box-shadow, var(--default-card-box-shadow));
          border-radius: var(--card-border-radius, var(--default-card-border-radius));
          overflow: hidden;
          width: var(--card-width, var(--default-card-width));
          height: var(--card-height, var(--default-card-height));
          box-sizing: border-box;
        }

        .borderless {
          border: none;
          box-shadow: none;
        }

        .hoverable:hover {
          border: var(--card-hover-border, var(--default-card-hover-border));
        }

        .content-container {
          flex: var(--card-content-flex, var(--default-card-content-flex));
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: var(--card-color, var(--default-card-color));
          padding: var(--card-description-padding, var(--default-card-description-padding));
        }

        .center-content {
          align-items: center;
        }

        #image-container {
          background-color: var(--card-no-image-background, var(--default-card-no-image-background));
          position: relative;
          flex: var(--card-image-flex, var(--default-card-image-flex));
          overflow: hidden;
        }

        #card-image {
          position: absolute;
          background-size: cover;
          background-position: center center;
          width: 100%;
          height: 100%;
        }

        #action-button-container {
          z-index: 5;
          position: absolute;
          top: 5px;
          right: 5px;
        }

        #action-button {
          --unity-button-height: 27px;
          --background-color: rgba(0,0,0,0);
          --button-color: var(--card-icon-color, var(--default-card-icon-color));
        }

        #title-text {
          flex: var(--title-flex, var(--default-title-flex));
          margin-bottom: 12px;
        }

        #description-text {
          margin: 10px;
        }

        #popover {
          --popover-min-width: none;
          --popover-min-height: none;
          --popover-padding: 0;
        }

        #menu-content {
          width: 100%;
        }
      `];
      }
    }]);
    return UnityCard;
  }(LitElement);
  window.customElements.define('unity-card', UnityCard);

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  function __decorate(decorators, target, key, desc) {
    var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
  }

  const observedForElements = new Set();
  const updateRTL = () => {
    const dir = document.documentElement.dir === 'rtl' ? document.documentElement.dir : 'ltr';
    observedForElements.forEach(el => {
      el.setAttribute('dir', dir);
    });
  };
  const rtlObserver = new MutationObserver(updateRTL);
  rtlObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['dir']
  });
  const canManageContentDirection = el => typeof el.startManagingContentDirection === 'undefined';
  function SpectrumMixin(constructor) {
    let SlotTextObservingElement = /*#__PURE__*/function (_constructor) {
      _inherits(SlotTextObservingElement, _constructor);
      var _super = _createSuper(SlotTextObservingElement);
      function SlotTextObservingElement() {
        var _this;
        _classCallCheck(this, SlotTextObservingElement);
        _this = _super.apply(this, arguments);
        /**
         * @private
         */
        _this.dir = 'ltr';
        return _this;
      }
      /**
       * @private
       */
      _createClass(SlotTextObservingElement, [{
        key: "isLTR",
        get: function () {
          return this.dir === 'ltr';
        }
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          if (!this.hasAttribute('dir')) {
            let dirParent = this.assignedSlot || this.parentNode;
            while (dirParent !== document.documentElement && canManageContentDirection(dirParent)) {
              dirParent = dirParent.assignedSlot ||
              // step into the shadow DOM of the parent of a slotted node
              dirParent.parentNode ||
              // DOM Element detected
              dirParent.host;
            }
            this.dir = dirParent.dir === 'rtl' ? dirParent.dir : this.dir || 'ltr';
            if (dirParent === document.documentElement) {
              observedForElements.add(this);
            } else {
              dirParent.startManagingContentDirection(this);
            }
            this._dirParent = dirParent;
          }
          _get(_getPrototypeOf(SlotTextObservingElement.prototype), "connectedCallback", this).call(this);
        }
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          _get(_getPrototypeOf(SlotTextObservingElement.prototype), "disconnectedCallback", this).call(this);
          if (this._dirParent) {
            if (this._dirParent === document.documentElement) {
              observedForElements.delete(this);
            } else {
              this._dirParent.stopManagingContentDirection(this);
            }
            this.removeAttribute('dir');
          }
        }
      }]);
      return SlotTextObservingElement;
    }(constructor);
    __decorate([property({
      reflect: true
    })], SlotTextObservingElement.prototype, "dir", void 0);
    return SlotTextObservingElement;
  }
  let SpectrumElement = /*#__PURE__*/function (_SpectrumMixin) {
    _inherits(SpectrumElement, _SpectrumMixin);
    var _super2 = _createSuper(SpectrumElement);
    function SpectrumElement() {
      _classCallCheck(this, SpectrumElement);
      return _super2.apply(this, arguments);
    }
    return _createClass(SpectrumElement);
  }(SpectrumMixin(LitElement));

  /**
   * @license
   * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */
  const previousValues = new WeakMap();
  /**
   * For AttributeParts, sets the attribute if the value is defined and removes
   * the attribute if the value is undefined.
   *
   * For other part types, this directive is a no-op.
   */
  const ifDefined = directive(value => part => {
    const previousValue = previousValues.get(part);
    if (value === undefined && part instanceof AttributePart) {
      // If the value is undefined, remove the attribute, but only if the value
      // was previously defined.
      if (previousValue !== undefined || !previousValues.has(part)) {
        const name = part.committer.name;
        part.committer.element.removeAttribute(name);
      }
    } else if (value !== previousValue) {
      part.setValue(value);
    }
    previousValues.set(part, value);
  });

  /**
   * This mixin function is designed to be applied to a class that inherits
   * from HTMLElement. It makes it easy for a custom element to coordinate with
   * the :focus-visible polyfill.
   *
   * NOTE(cdata): The code here was adapted from an example proposed with the
   * introduction of ShadowDOM support in the :focus-visible polyfill.
   *
   * @see https://github.com/WICG/focus-visible/pull/196
   * @param {Function} SuperClass The base class implementation to decorate with
   * implementation that coordinates with the :focus-visible polyfill
   */
  const FocusVisiblePolyfillMixin = SuperClass => {
    var _a;
    const coordinateWithPolyfill = instance => {
      // If there is no shadow root, there is no need to coordinate with
      // the polyfill. If we already coordinated with the polyfill, we can
      // skip subsequent invokcations:
      if (instance.shadowRoot == null || instance.hasAttribute('data-js-focus-visible')) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => {};
      }
      // The polyfill might already be loaded. If so, we can apply it to
      // the shadow root immediately:
      if (self.applyFocusVisiblePolyfill) {
        self.applyFocusVisiblePolyfill(instance.shadowRoot);
      } else {
        const coordinationHandler = () => {
          if (self.applyFocusVisiblePolyfill && instance.shadowRoot) {
            self.applyFocusVisiblePolyfill(instance.shadowRoot);
          }
          if (instance.manageAutoFocus) {
            instance.manageAutoFocus();
          }
        };
        // Otherwise, wait for the polyfill to be loaded lazily. It might
        // never be loaded, but if it is then we can apply it to the
        // shadow root at the appropriate time by waiting for the ready
        // event:
        self.addEventListener('focus-visible-polyfill-ready', coordinationHandler, {
          once: true
        });
        return () => {
          self.removeEventListener('focus-visible-polyfill-ready', coordinationHandler);
        };
      }
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    };
    const $endPolyfillCoordination = Symbol('endPolyfillCoordination');
    // IE11 doesn't natively support custom elements or JavaScript class
    // syntax The mixin implementation assumes that the user will take the
    // appropriate steps to support both:
    let FocusVisibleCoordinator = /*#__PURE__*/function (_SuperClass) {
      _inherits(FocusVisibleCoordinator, _SuperClass);
      var _super = _createSuper(FocusVisibleCoordinator);
      function FocusVisibleCoordinator() {
        var _this;
        _classCallCheck(this, FocusVisibleCoordinator);
        _this = _super.apply(this, arguments);
        _this[_a] = null;
        return _this;
      }
      // Attempt to coordinate with the polyfill when connected to the
      // document:
      _createClass(FocusVisibleCoordinator, [{
        key: "connectedCallback",
        value: function connectedCallback() {
          _get(_getPrototypeOf(FocusVisibleCoordinator.prototype), "connectedCallback", this) && _get(_getPrototypeOf(FocusVisibleCoordinator.prototype), "connectedCallback", this).call(this);
          if (this[$endPolyfillCoordination] == null) {
            this[$endPolyfillCoordination] = coordinateWithPolyfill(this);
          }
        }
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          _get(_getPrototypeOf(FocusVisibleCoordinator.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(FocusVisibleCoordinator.prototype), "disconnectedCallback", this).call(this);
          // It's important to remove the polyfill event listener when we
          // disconnect, otherwise we will leak the whole element via window:
          if (this[$endPolyfillCoordination] != null) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this[$endPolyfillCoordination]();
            this[$endPolyfillCoordination] = null;
          }
        }
      }]);
      return FocusVisibleCoordinator;
    }(SuperClass);
    _a = $endPolyfillCoordination;
    return FocusVisibleCoordinator;
  };

  /**
   * Focusable base class handles tabindex setting into shadowed elements automatically.
   *
   * This implementation is based heavily on the aybolit delegate-focus-mixin at
   * https://github.com/web-padawan/aybolit/blob/master/packages/core/src/mixins/delegate-focus-mixin.js
   */
  let Focusable = /*#__PURE__*/function (_FocusVisiblePolyfill) {
    _inherits(Focusable, _FocusVisiblePolyfill);
    var _super = _createSuper(Focusable);
    function Focusable() {
      var _this;
      _classCallCheck(this, Focusable);
      _this = _super.apply(this, arguments);
      /**
       * Disable this control. It will not receive focus or events
       */
      _this.disabled = false;
      /**
       * When this control is rendered, focus it automatically
       */
      _this.autofocus = false;
      _this.manipulatingTabindex = false;
      return _this;
    }
    /**
     * The tab index to apply to this control. See general documentation about
     * the tabindex HTML property
     */
    _createClass(Focusable, [{
      key: "tabIndex",
      get: function () {
        const tabIndexAttribute = parseFloat(this.hasAttribute('tabindex') ? this.getAttribute('tabindex') || '0' : '0');
        // When `disabled` tabindex is -1.
        // When host tabindex -1, use that as the cache.
        if (this.disabled || tabIndexAttribute < 0) {
          return -1;
        }
        // When `focusElement` isn't available yet,
        // use host tabindex as the cache.
        if (!this.focusElement) {
          return tabIndexAttribute;
        }
        // All other times, use the tabindex of `focusElement`
        // as the cache for this value.
        return this.focusElement.tabIndex;
      },
      set: function (tabIndex) {
        // Flipping `manipulatingTabindex` to true before a change
        // allows for that change NOT to effect the cached value of tabindex
        if (this.manipulatingTabindex) {
          this.manipulatingTabindex = false;
          return;
        }
        // All code paths are about to address the host tabindex without side effect.
        this.manipulatingTabindex = true;
        if (tabIndex === -1 || this.disabled) {
          // Do not cange the tabindex of `focusElement` as it is the "old" value cache.
          // Make element NOT focusable.
          this.setAttribute('tabindex', '-1');
          this.removeAttribute('focusable');
          if (tabIndex !== -1) {
            // Cache all NON-`-1` values on the `focusElement`.
            this.manageFocusElementTabindex(tabIndex);
          }
          return;
        }
        this.setAttribute('focusable', '');
        if (this.hasAttribute('tabindex')) {
          this.removeAttribute('tabindex');
        } else {
          // You can't remove an attribute that isn't there,
          // manually end the `manipulatingTabindex` guard.
          this.manipulatingTabindex = false;
        }
        this.manageFocusElementTabindex(tabIndex);
      }
    }, {
      key: "manageFocusElementTabindex",
      value: async function manageFocusElementTabindex(tabIndex) {
        if (!this.focusElement) {
          // allow setting these values to be async when needed.
          await this.updateComplete;
        }
        if (tabIndex === null) {
          this.focusElement.removeAttribute('tabindex');
        } else {
          this.focusElement.tabIndex = tabIndex;
        }
      }
    }, {
      key: "focusElement",
      get: function () {
        throw new Error('Must implement focusElement getter!');
      }
    }, {
      key: "focus",
      value: function focus() {
        if (this.disabled || !this.focusElement) {
          return;
        }
        this.focusElement.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.focusElement.blur();
      }
    }, {
      key: "click",
      value: function click() {
        if (this.disabled) {
          return;
        }
        this.focusElement.click();
      }
    }, {
      key: "manageAutoFocus",
      value: function manageAutoFocus() {
        if (this.autofocus) {
          /* Trick :focus-visible polyfill into thinking keyboard based focus */
          this.dispatchEvent(new KeyboardEvent('keydown', {
            code: 'Tab'
          }));
          this.focusElement.focus();
        }
      }
    }, {
      key: "firstUpdated",
      value: function firstUpdated(changes) {
        _get(_getPrototypeOf(Focusable.prototype), "firstUpdated", this).call(this, changes);
        this.manageAutoFocus();
        if (!this.hasAttribute('tabindex') || this.getAttribute('tabindex') !== '-1') {
          this.setAttribute('focusable', '');
        }
      }
    }, {
      key: "update",
      value: function update(changedProperties) {
        if (changedProperties.has('disabled')) {
          this.handleDisabledChanged(this.disabled, changedProperties.get('disabled'));
        }
        _get(_getPrototypeOf(Focusable.prototype), "update", this).call(this, changedProperties);
      }
    }, {
      key: "updated",
      value: function updated(changedProperties) {
        _get(_getPrototypeOf(Focusable.prototype), "updated", this).call(this, changedProperties);
        if (changedProperties.has('disabled')) {
          if (this.disabled) {
            this.blur();
          }
        }
      }
    }, {
      key: "handleDisabledChanged",
      value: async function handleDisabledChanged(disabled, oldDisabled) {
        if (disabled) {
          this.manipulatingTabindex = true;
          this.setAttribute('tabindex', '-1');
          await this.updateComplete;
          if (typeof this.focusElement.disabled === 'undefined') {
            this.setAttribute('aria-disabled', 'true');
          } else {
            this.focusElement.disabled = true;
          }
        } else if (oldDisabled) {
          this.manipulatingTabindex = true;
          this.removeAttribute('tabindex');
          await this.updateComplete;
          if (typeof this.focusElement.disabled === 'undefined') {
            this.removeAttribute('aria-disabled');
          } else {
            this.focusElement.disabled = false;
          }
        }
      }
    }]);
    return Focusable;
  }(FocusVisiblePolyfillMixin(SpectrumElement));
  __decorate([property({
    type: Boolean,
    reflect: true
  })], Focusable.prototype, "disabled", void 0);
  __decorate([property({
    type: Boolean
  })], Focusable.prototype, "autofocus", void 0);
  __decorate([property({
    type: Number
  })], Focusable.prototype, "tabIndex", null);

  let CheckboxBase = /*#__PURE__*/function (_Focusable) {
    _inherits(CheckboxBase, _Focusable);
    var _super = _createSuper(CheckboxBase);
    function CheckboxBase() {
      var _this;
      _classCallCheck(this, CheckboxBase);
      _this = _super.apply(this, arguments);
      _this.checked = false;
      _this.quiet = false;
      return _this;
    }
    _createClass(CheckboxBase, [{
      key: "focusElement",
      get: function () {
        return this.inputElement;
      }
    }, {
      key: "handleChange",
      value: function handleChange(event) {
        this.checked = this.inputElement.checked;
        // Change events from the shadow DOM are not transmitted into
        // the parent light DOM
        const changeEvent = new CustomEvent('change', {
          detail: {
            sourceEvent: event
          },
          bubbles: event.bubbles,
          cancelable: event.cancelable
        });
        this.dispatchEvent(changeEvent);
      }
    }, {
      key: "render",
      value: function render() {
        return html$1`
            <input
                id="input"
                aria-labelledby="label"
                type="checkbox"
                .checked=${this.checked}
                @change=${this.handleChange}
            />
        `;
      }
    }]);
    return CheckboxBase;
  }(Focusable);
  __decorate([property({
    type: Boolean,
    reflect: true
  })], CheckboxBase.prototype, "checked", void 0);
  __decorate([property({
    type: Boolean,
    reflect: true
  })], CheckboxBase.prototype, "quiet", void 0);
  __decorate([query('#input')], CheckboxBase.prototype, "inputElement", void 0);

  let IconsetRegistry = /*#__PURE__*/function () {
    function IconsetRegistry() {
      _classCallCheck(this, IconsetRegistry);
      this.iconsetMap = new Map();
    }
    // singleton getter
    _createClass(IconsetRegistry, [{
      key: "addIconset",
      value: function addIconset(name, iconset) {
        this.iconsetMap.set(name, iconset);
        // dispatch a sp-iconset-added event on window to let everyone know we have a new iconset
        // note we're using window here for efficiency since we don't need to bubble through the dom since everyone
        // will know where to look for this event
        const event = new CustomEvent('sp-iconset-added', {
          bubbles: true,
          composed: true,
          detail: {
            name,
            iconset
          }
        });
        // we're dispatching this event in the next tick to allow the iconset to finish any slotchange or other event
        // listeners caused by connection to the dom and first render to complete, this way any icons listening for
        // this iconset will be able to access the completed iconset
        setTimeout(() => window.dispatchEvent(event), 0);
      }
    }, {
      key: "removeIconset",
      value: function removeIconset(name) {
        this.iconsetMap.delete(name);
        // dispatch a sp-iconset-removed event on window to let everyone know we have a new iconset
        // note we're using window here for efficiency since we don't need to bubble through the dom since everyone
        // will know where to look for this event
        const event = new CustomEvent('sp-iconset-removed', {
          bubbles: true,
          composed: true,
          detail: {
            name
          }
        });
        // we're dispatching this event in the next tick To keep the event model consistent with the added event
        setTimeout(() => window.dispatchEvent(event), 0);
      }
    }, {
      key: "getIconset",
      value: function getIconset(name) {
        return this.iconsetMap.get(name);
      }
    }], [{
      key: "getInstance",
      value: function getInstance() {
        if (!IconsetRegistry.instance) {
          IconsetRegistry.instance = new IconsetRegistry();
        }
        return IconsetRegistry.instance;
      }
    }]);
    return IconsetRegistry;
  }();

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const styles$4 = css$1`
:host{display:inline-block;color:inherit;fill:currentColor;pointer-events:none}:host(:not(:root)){overflow:hidden}:host([size=xxs]),:host([size=xxs]) img,:host([size=xxs]) svg{height:calc(var(--spectrum-alias-workflow-icon-size,
var(--spectrum-global-dimension-size-225))/2);width:calc(var(--spectrum-alias-workflow-icon-size,
var(--spectrum-global-dimension-size-225))/2)}:host([size=xs]),:host([size=xs]) img,:host([size=xs]) svg{height:calc(var(--spectrum-global-dimension-size-300)/2);width:calc(var(--spectrum-global-dimension-size-300)/2)}:host([size=s]),:host([size=s]) img,:host([size=s]) svg{height:var(--spectrum-alias-workflow-icon-size,var(--spectrum-global-dimension-size-225));width:var(--spectrum-alias-workflow-icon-size,var(--spectrum-global-dimension-size-225))}:host([size=m]),:host([size=m]) img,:host([size=m]) svg{height:var(--spectrum-global-dimension-size-300);width:var(--spectrum-global-dimension-size-300)}:host([size=l]),:host([size=l]) img,:host([size=l]) svg{height:calc(var(--spectrum-alias-workflow-icon-size,
var(--spectrum-global-dimension-size-225))*2);width:calc(var(--spectrum-alias-workflow-icon-size,
var(--spectrum-global-dimension-size-225))*2)}:host([size=xl]),:host([size=xl]) img,:host([size=xl]) svg{height:calc(var(--spectrum-global-dimension-size-300)*2);width:calc(var(--spectrum-global-dimension-size-300)*2)}:host([size=xxl]),:host([size=xxl]) img,:host([size=xxl]) svg{height:calc(var(--spectrum-global-dimension-size-300)*3);width:calc(var(--spectrum-global-dimension-size-300)*3)}#container{height:100%}img{height:auto}::slotted(*),img{width:100%;vertical-align:top}::slotted(*){height:100%}
`;
  var iconStyles = styles$4;

  let Icon = /*#__PURE__*/function (_SpectrumElement) {
    _inherits(Icon, _SpectrumElement);
    var _super = _createSuper(Icon);
    function Icon() {
      var _this;
      _classCallCheck(this, Icon);
      _this = _super.apply(this, arguments);
      _this.size = 'm';
      _this.iconsetListener = event => {
        if (!_this.name) {
          return;
        }
        // parse the icon name to get iconset name
        const icon = _this.parseIcon(_this.name);
        if (event.detail.name === icon.iconset) {
          _this.updateIconPromise = _this.updateIcon();
        }
      };
      return _this;
    }
    _createClass(Icon, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(Icon.prototype), "connectedCallback", this).call(this);
        window.addEventListener('sp-iconset-added', this.iconsetListener);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(Icon.prototype), "disconnectedCallback", this).call(this);
        window.removeEventListener('sp-iconset-added', this.iconsetListener);
      }
    }, {
      key: "firstUpdated",
      value: function firstUpdated() {
        this.updateIconPromise = this.updateIcon();
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, old, value) {
        _get(_getPrototypeOf(Icon.prototype), "attributeChangedCallback", this).call(this, name, old, value);
        this.updateIconPromise = this.updateIcon(); // any of our attributes change, update our icon
      }
    }, {
      key: "render",
      value: function render() {
        if (this.name) {
          return html$1`
                <div id="container"></div>
            `;
        } else if (this.src) {
          return html$1`
                <img src="${this.src}" alt=${ifDefined(this.label)} />
            `;
        }
        return html$1`
            <slot></slot>
        `;
      }
    }, {
      key: "updateIcon",
      value: async function updateIcon() {
        if (!this.name) {
          return Promise.resolve();
        }
        // parse the icon name to get iconset name
        const icon = this.parseIcon(this.name);
        // try to retrieve the iconset
        const iconset = IconsetRegistry.getInstance().getIconset(icon.iconset);
        if (!iconset) {
          // we can stop here as there's nothing to be done till we get the iconset
          return Promise.resolve();
        }
        if (!this.iconContainer) {
          return Promise.resolve();
        }
        this.iconContainer.innerHTML = '';
        return iconset.applyIconToElement(this.iconContainer, icon.icon, this.size, this.label ? this.label : '');
      }
    }, {
      key: "parseIcon",
      value: function parseIcon(icon) {
        const iconParts = icon.split(':');
        let iconsetName = 'default';
        let iconName = icon;
        if (iconParts.length > 1) {
          iconsetName = iconParts[0];
          iconName = iconParts[1];
        }
        return {
          iconset: iconsetName,
          icon: iconName
        };
      }
    }, {
      key: "_getUpdateComplete",
      value: async function _getUpdateComplete() {
        await _get(_getPrototypeOf(Icon.prototype), "_getUpdateComplete", this).call(this);
        await this.updateIconPromise;
      }
    }], [{
      key: "styles",
      get: function () {
        return [iconStyles];
      }
    }]);
    return Icon;
  }(SpectrumElement);
  Icon.is = 'sp-icon';
  __decorate([property()], Icon.prototype, "src", void 0);
  __decorate([property()], Icon.prototype, "name", void 0);
  __decorate([property({
    reflect: true
  })], Icon.prototype, "size", void 0);
  __decorate([property()], Icon.prototype, "label", void 0);
  __decorate([query('#container')], Icon.prototype, "iconContainer", void 0);

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  customElements.define('sp-icon', Icon);

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const tag$1 = function (strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }
    return values.reduce((acc, v, idx) => acc + v + strings[idx + 1], strings[0]);
  };

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const CheckmarkSmallIcon = function () {
    let {
      width = 24,
      height = 24,
      hidden = false,
      title = 'Checkmark Small'
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return tag$1`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
    viewBox="0 0 10 10"
  >
    <path
      d="M3.788 9A.999.999 0 013 8.615l-2.288-3a1 1 0 111.576-1.23l1.5 1.991 3.924-4.991a1 1 0 111.576 1.23l-4.712 6A.999.999 0 013.788 9z"
      viewBox="0 0 0 0"
    />
  </svg>`;
  };

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const DashSmallIcon = function () {
    let {
      width = 24,
      height = 24,
      hidden = false,
      title = 'Dash Small'
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return tag$1`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
    viewBox="0 0 10 10"
  >
    <path d="M8 4H2a1 1 0 000 2h6a1 1 0 000-2z" viewBox="0 0 0 0" />
  </svg>`;
  };

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const styles$3 = css$1`
:host([dir=ltr]){margin-right:calc(var(--spectrum-checkbox-cursor-hit-x,
var(--spectrum-global-dimension-size-100))*2)}:host([dir=rtl]){margin-left:calc(var(--spectrum-checkbox-cursor-hit-x,
var(--spectrum-global-dimension-size-100))*2)}:host{align-items:flex-start;position:relative;min-height:var(--spectrum-checkbox-height,var(--spectrum-global-dimension-size-400));max-width:100%;color:var(--spectrum-checkbox-text-color,var(--spectrum-alias-text-color));border-color:var(--spectrum-checkbox-emphasized-box-border-color,var(--spectrum-global-color-gray-600))}:host([dir=ltr]) #input{left:calc(var(--spectrum-checkbox-cursor-hit-x,
var(--spectrum-global-dimension-size-100))*-1)}:host([dir=rtl]) #input{right:calc(var(--spectrum-checkbox-cursor-hit-x,
var(--spectrum-global-dimension-size-100))*-1)}#input{font-family:inherit;font-size:100%;line-height:1.15;margin:0;overflow:visible;box-sizing:border-box;padding:0;position:absolute;top:0;width:calc(100% + var(--spectrum-checkbox-cursor-hit-x,
var(--spectrum-global-dimension-size-100))*2);height:100%;opacity:.0001;z-index:1;cursor:pointer}:host([disabled]) #input{cursor:default}#input:checked+#box:before{border-width:calc(var(--spectrum-checkbox-box-size,
var(--spectrum-global-dimension-size-175))/2)}#input:checked+#box #checkmark{transform:scale(1);opacity:1}#input.focus-visible+#box:after{margin:calc(var(--spectrum-alias-focus-ring-gap,
var(--spectrum-global-dimension-static-size-25))*-1);box-shadow:0 0 0 var(--spectrum-checkbox-focus-ring-size-key-focus,var(--spectrum-alias-focus-ring-size)) var(--spectrum-checkbox-focus-ring-color-key-focus,var(--spectrum-alias-focus-ring-color))}:host([indeterminate]) #box:before,:host([indeterminate]) #input:checked+#box:before{border-width:calc(var(--spectrum-checkbox-box-size,
var(--spectrum-global-dimension-size-175))/2)}:host([indeterminate]) #box #checkmark,:host([indeterminate]) #input:checked+#box #checkmark{display:none}:host([indeterminate]) #box #partialCheckmark,:host([indeterminate]) #input:checked+#box #partialCheckmark{display:block;transform:scale(1);opacity:1}:host([dir=ltr]) #label{text-align:left;margin-left:var(--spectrum-checkbox-text-gap,var(--spectrum-global-dimension-size-125))}:host([dir=rtl]) #label{text-align:right;margin-right:var(--spectrum-checkbox-text-gap,var(--spectrum-global-dimension-size-125))}#label{margin-top:var(--spectrum-global-dimension-size-65);font-size:var(--spectrum-checkbox-text-size,var(--spectrum-alias-font-size-default));font-weight:var(--spectrum-checkbox-text-font-weight,var(--spectrum-global-font-weight-regular));line-height:1.49;color:var(--spectrum-checkbox-emphasized-text-color,var(--spectrum-alias-text-color))}#box{position:relative;margin:calc((var(--spectrum-checkbox-height,
var(--spectrum-global-dimension-size-400)) - var(--spectrum-checkbox-box-size,
var(--spectrum-global-dimension-size-175)))/2) 0;flex-grow:0;flex-shrink:0}#box,#box:before{box-sizing:border-box;width:var(--spectrum-checkbox-box-size,var(--spectrum-global-dimension-size-175));height:var(--spectrum-checkbox-box-size,var(--spectrum-global-dimension-size-175))}#box:before{z-index:0;border-radius:var(--spectrum-checkbox-box-border-radius,var(--spectrum-alias-border-radius-small));transition:border var(--spectrum-global-animation-duration-100,.13s) ease-in-out,box-shadow var(--spectrum-global-animation-duration-100,.13s) ease-in-out;border:var(--spectrum-checkbox-box-border-size,var(--spectrum-alias-border-size-thick)) solid var(--spectrum-checkbox-emphasized-box-border-color,var(--spectrum-global-color-gray-600));background-color:var(--spectrum-checkbox-emphasized-box-background-color,var(--spectrum-global-color-gray-75))}#box:after,#box:before{display:block;content:"";position:absolute}#box:after{border-radius:calc(var(--spectrum-checkbox-box-border-radius,
var(--spectrum-alias-border-radius-small)) + var(--spectrum-alias-focus-ring-gap,
var(--spectrum-global-dimension-static-size-25)));left:0;right:0;bottom:0;top:0;margin:var(--spectrum-alias-focus-ring-gap,var(--spectrum-global-dimension-static-size-25));transition:box-shadow var(--spectrum-global-animation-duration-100,.13s) ease-out,margin var(--spectrum-global-animation-duration-100,.13s) ease-out;transform:translate(0)}:host([dir=ltr]) #checkmark,:host([dir=ltr]) #partialCheckmark{left:50%}:host([dir=rtl]) #checkmark,:host([dir=rtl]) #partialCheckmark{right:50%}:host([dir=ltr]) #checkmark,:host([dir=ltr]) #partialCheckmark{margin-left:calc(var(--spectrum-icon-checkmark-small-width)/-2)}:host([dir=rtl]) #checkmark,:host([dir=rtl]) #partialCheckmark{margin-right:calc(var(--spectrum-icon-checkmark-small-width)/-2)}#checkmark,#partialCheckmark{position:absolute;top:50%;margin-top:calc(var(--spectrum-icon-checkmark-small-height)/-2);opacity:0;transform:scale(0);transition:opacity var(--spectrum-global-animation-duration-100,.13s) ease-in-out,transform var(--spectrum-global-animation-duration-100,.13s) ease-in-out}#partialCheckmark{display:none}#checkmark,#partialCheckmark{color:var(--spectrum-checkbox-checkmark-color,var(--spectrum-global-color-gray-75))}#input:checked+#box:before,:host([indeterminate]) #box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-selected,var(--spectrum-global-color-blue-500))}:host(:hover) #input:checked+#box:before,:host(:hover[indeterminate]) #box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-selected-hover,var(--spectrum-global-color-blue-600))}:host(:active) #input:checked+#box:before,:host(:active[indeterminate]) #box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-selected-down,var(--spectrum-global-color-blue-700))}:host(:hover) #box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-hover,var(--spectrum-global-color-gray-700))}:host(:hover) #label{color:var(--spectrum-checkbox-emphasized-text-color-hover,var(--spectrum-alias-text-color-hover))}:host(:active) #box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-down,var(--spectrum-global-color-gray-800))}:host(:active) #label{color:var(--spectrum-checkbox-emphasized-text-color-down,var(--spectrum-alias-text-color-down))}:host([disabled]) #input+#box:before,:host([disabled]) #input:checked+#box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-disabled,var(--spectrum-global-color-gray-400));background-color:var(--spectrum-checkbox-emphasized-box-background-color-disabled,var(--spectrum-global-color-gray-75))}:host([disabled]) #input:checked~#label,:host([disabled]) #input~#label{color:var(--spectrum-checkbox-text-color-disabled,var(--spectrum-alias-text-color-disabled))}#input.focus-visible+#box:before{border-color:var(--spectrum-checkbox-box-border-color-key-focus,var(--spectrum-global-color-gray-700))}#input:checked.focus-visible+#box:before,:host([indeterminate]) #input.focus-visible+#box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-selected-hover,var(--spectrum-global-color-blue-600))}#input.focus-visible~#label{color:var(--spectrum-checkbox-emphasized-text-color-hover,var(--spectrum-alias-text-color-hover))}:host([quiet]) #input:checked+#box:before,:host([quiet][indeterminate]) #box:before,:host([quiet][indeterminate]) #input.focus-visible+#box:before{border-color:var(--spectrum-checkbox-quiet-box-border-color-selected,var(--spectrum-global-color-gray-700))}:host([quiet]:hover) #input:checked+#box:before,:host([quiet][indeterminate]:hover) #box:before{border-color:var(--spectrum-checkbox-quiet-box-border-color-selected-hover,var(--spectrum-global-color-gray-800))}:host([quiet]:active) #input:checked+#box:before,:host([quiet][indeterminate]:active) #box:before{border-color:var(--spectrum-checkbox-quiet-box-border-color-selected-down,var(--spectrum-global-color-gray-900))}:host([invalid]) #box:before,:host([invalid]) #input:checked+#box:before{border-color:var(--spectrum-checkbox-box-border-color-error,var(--spectrum-global-color-red-500))}:host([invalid]) #label{color:var(--spectrum-checkbox-text-color-error,var(--spectrum-global-color-red-600))}:host([invalid]) #input.focus-visible+#box:before,:host([invalid][indeterminate]) #input.focus-visible+#box:before{border-color:var(--spectrum-checkbox-box-border-color-error-hover,var(--spectrum-global-color-red-600))}:host([invalid]) #input.focus-visible~#label,:host([invalid][indeterminate]) #input.focus-visible~#label{color:var(--spectrum-checkbox-text-color-error-hover,var(--spectrum-global-color-red-700))}:host([invalid]:hover) #box:before,:host([invalid]:hover) #input:checked+#box:before{border-color:var(--spectrum-checkbox-box-border-color-error-hover,var(--spectrum-global-color-red-600))}:host([invalid]:hover) #label{color:var(--spectrum-checkbox-text-color-error-hover,var(--spectrum-global-color-red-700))}:host([invalid]:active) #box:before,:host([invalid]:active) #input:checked+#box:before{border-color:var(--spectrum-checkbox-box-border-color-error-down,var(--spectrum-global-color-red-700))}:host([invalid]:active) #label{color:var(--spectrum-checkbox-text-color-error-down,var(--spectrum-global-color-red-700))}:host{display:inline-flex;vertical-align:top}:host(:empty) label{display:none}:host([disabled][checked]) #input+#box:before,:host([disabled][checked]) #input:checked+#box:before{border-color:var(--spectrum-checkbox-emphasized-box-border-color-disabled,var(--spectrum-global-color-gray-400));background-color:var(--spectrum-checkbox-emphasized-box-background-color-disabled,var(--spectrum-global-color-gray-75))}:host([invalid][indeterminate]) #box:before,:host([invalid][indeterminate]) #input:checked+#box:before{border-color:var(--spectrum-checkbox-box-border-color-error,var(--spectrum-global-color-red-500))}
`;
  var checkboxStyles = styles$3;

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const styles$2 = css$1`
.checkmark-small{width:var(--spectrum-icon-checkmark-small-width);height:var(--spectrum-icon-checkmark-small-height)}
`;
  var checkmarkSmallStyles = styles$2;

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const styles$1 = css$1`
.dash-small{width:var(--spectrum-icon-dash-small-width);height:var(--spectrum-icon-dash-small-height)}
`;
  var dashSmallStyles = styles$1;

  let Checkbox = /*#__PURE__*/function (_CheckboxBase) {
    _inherits(Checkbox, _CheckboxBase);
    var _super = _createSuper(Checkbox);
    function Checkbox() {
      var _this;
      _classCallCheck(this, Checkbox);
      _this = _super.apply(this, arguments);
      _this.indeterminate = false;
      _this.invalid = false;
      return _this;
    }
    _createClass(Checkbox, [{
      key: "render",
      value: function render() {
        return html$1`
            ${_get(_getPrototypeOf(Checkbox.prototype), "render", this).call(this)}
            <span id="box">
                <sp-icon id="checkmark" size="s" class="checkmark-small">
                    ${CheckmarkSmallIcon({
        hidden: true
      })}
                </sp-icon>
                <sp-icon id="partialCheckmark" size="s" class="dash-small">
                    ${DashSmallIcon({
        hidden: true
      })}
                </sp-icon>
            </span>
            <label id="label"><slot></slot></label>
        `;
      }
    }, {
      key: "updated",
      value: function updated(changes) {
        _get(_getPrototypeOf(Checkbox.prototype), "updated", this).call(this, changes);
        if (changes.has('invalid')) {
          if (this.invalid) {
            this.inputElement.setAttribute('aria-invalid', 'true');
          } else {
            this.inputElement.removeAttribute('aria-invalid');
          }
        }
        if (changes.has('indeterminate')) {
          if (this.indeterminate) {
            this.inputElement.setAttribute('aria-checked', 'mixed');
          } else {
            this.inputElement.removeAttribute('aria-checked');
          }
        }
      }
    }], [{
      key: "styles",
      get: function () {
        return [checkboxStyles, checkmarkSmallStyles, dashSmallStyles];
      }
    }]);
    return Checkbox;
  }(CheckboxBase);
  __decorate([property({
    type: Boolean,
    reflect: true
  })], Checkbox.prototype, "indeterminate", void 0);
  __decorate([property({
    type: Boolean,
    reflect: true
  })], Checkbox.prototype, "invalid", void 0);

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  customElements.define('sp-checkbox', Checkbox);

  /**
   * Displays three state checkmark
   * @name UnityCheckbox
   * @param {string} label, label to render next to the checkbox
   * @param {boolean} checked, whether the checkbox is checked
   * @param {boolean} indeterminate, whether the checkbox is in the indeterminate state, overrides checked
   * @param {boolean} disabled, whether the checkbox is disabled
   * @param {boolean} controlled, whether the checkbox should ignore clicks and not change state internally.
   * @param {func} onChange, callback for returning the checkbox's new state
   * @return {LitElement} return s aclass extended from LitElement
   * @example
   *  <unity-checkbox
   *    label="Is Test?"
   *    checked
   *    indeterminate
   *  ></unity-checkbox>
   */
  let UnityCheckbox = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityCheckbox, _LitElement);
    var _super = _createSuper(UnityCheckbox);
    // internals
    function UnityCheckbox() {
      var _this;
      _classCallCheck(this, UnityCheckbox);
      _this = _super.call(this);
      // defaults
      _this.label = '';
      _this.checked = false;
      _this.indeterminate = false;
      _this.disabled = false;
      _this.controlled = false;
      _this.onChange = () => {};
      return _this;
    }

    // inputs
    _createClass(UnityCheckbox, [{
      key: "_handleClick",
      value: function _handleClick(e) {
        if (this.controlled) return;
        const {
          checked: priorChecked,
          indeterminate: priorIndeterminate
        } = this;
        this.checked = priorIndeterminate ? true : !priorChecked;
        this.indeterminate = false;
        this.onChange(e, this.checked);
      }
    }, {
      key: "render",
      value: function render() {
        const {
          label,
          checked,
          indeterminate,
          disabled
        } = this;
        const state = indeterminate ? 2 : checked ? 1 : 0;
        return html$1`
      <sp-checkbox
        class="checkbox${disabled ? " disabled" : ""}"
        ?disabled="${disabled ? true : null}"
        ?checked="${state === 1 ? true : null}"
        ?indeterminate="${state === 2 ? true : null}"
        @change="${this._handleClick}"
        onclick="event.stopPropagation()"
      >${label ? html$1`<unity-typography>${label}</unity-typography>` : ''}</sp-checkbox>
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          label: {
            type: String
          },
          checked: {
            type: Boolean
          },
          indeterminate: {
            type: Boolean
          },
          disabled: {
            type: Boolean
          },
          controlled: {
            type: Boolean
          },
          onChange: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          display: flex;
          --spectrum-checkbox-box-size: var(--unity-checkbox-size, var(--default-unity-checkbox-size));
          --spectrum-checkbox-box-border-size: var(--unity-checkbox-border-size, var(--default-unity-checkbox-border-size));
          --spectrum-checkbox-box-border-radius: var(--unity-checkbox-border-radius, var(--default-unity-checkbox-border-radius));
          --default-checkmark-size: calc(var(--spectrum-checkbox-box-size) * .625);
          --spectrum-icon-checkmark-small-height: var(--unity-checkbox-checkmark-size, var(--default-checkmark-size));
          --spectrum-icon-checkmark-small-width: var(--unity-checkbox-checkmark-size, var(--default-checkmark-size));
          --spectrum-icon-dash-small-height: var(--unity-checkbox-checkmark-size, var(--default-checkmark-size));
          --spectrum-icon-dash-small-width: var(--unity-checkbox-checkmark-size, var(--default-checkmark-size));
          --spectrum-checkbox-text-gap: var(--unity-checkbox-text-margin, var(--default-unity-checkbox-text-margin));

          --font-color: var(--unity-checkbox-text-color, var(--default-unity-checkbox-text-color));
          --font-size: var(--unity-checkbox-text-size, var(--default-unity-checkbox-text-size));

          /* Backgrounds */
          --spectrum-checkbox-emphasized-box-background-color: var(--unity-checkbox-background-color, var(--default-unity-checkbox-background-color));
          --spectrum-checkbox-emphasized-box-background-color-disabled: var(--unity-checkbox-background-color-disabled, var(--unity-checkbox-background-color-disabled));

          /* Borders */
          --spectrum-checkbox-emphasized-box-border-color: var(--unity-checkbox-border-color, var(--default-unity-checkbox-border-color));
          --spectrum-checkbox-emphasized-box-border-color-hover: var(--unity-checkbox-border-color, var(--default-unity-checkbox-border-color));
          --spectrum-checkbox-emphasized-box-border-color-down: var(--unity-checkbox-border-color, var(--default-unity-checkbox-border-color));
          --spectrum-checkbox-emphasized-box-border-color-selected: var(--unity-checkbox-color, var(--default-unity-checkbox-color));
          --spectrum-checkbox-emphasized-box-border-color-selected-hover: var(--unity-checkbox-color-hover, var(--default-unity-checkbox-color-hover));
          --spectrum-checkbox-emphasized-box-border-color-selected-down: var(--unity-checkbox-color-hover, var(--default-unity-checkbox-color-hover));
          --spectrum-checkbox-emphasized-box-border-color-disabled: var(--unity-checkbox-color-disabled, var(--default-unity-checkbox-color-disabled));

          /* Icon */
          --spectrum-checkbox-checkmark-color: var(--unity-checkbox-checkmark-color, var(--default-unity-checkbox-checkmark-color));
        }

        sp-checkbox.checkbox {
          outline: none;
        }

        sp-checkbox.checkbox.disabled {
          --spectrum-checkbox-checkmark-color: var(--unity-checkbox-checkmark-color-disabled, var(--default-unity-checkbox-checkmark-color-disabled));
        }

        sp-checkbox.checkbox:hover {
          --spectrum-checkbox-emphasized-box-background-color: var(--unity-checkbox-background-color-hover, var(--unity-checkbox-background-color-hover));
        }

        sp-checkbox.checkbox.disabled unity-typography {
          --font-color: var(--unity-checkbox-text-color-disabled, var(--default-unity-checkbox-text-color-disabled));
        }
      `];
      }
    }]);
    return UnityCheckbox;
  }(LitElement);
  window.customElements.define('unity-checkbox', UnityCheckbox);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$4 = html`
<custom-style>
  <style is="custom-style">
    html {
      /*
       * You can use these generic variables in your elements for easy theming.
       * For example, if all your elements use \`--primary-text-color\` as its main
       * color, then switching from a light to a dark theme is just a matter of
       * changing the value of \`--primary-text-color\` in your application.
       */
      --primary-text-color: var(--light-theme-text-color);
      --primary-background-color: var(--light-theme-background-color);
      --secondary-text-color: var(--light-theme-secondary-color);
      --disabled-text-color: var(--light-theme-disabled-color);
      --divider-color: var(--light-theme-divider-color);
      --error-color: var(--paper-deep-orange-a700);

      /*
       * Primary and accent colors. Also see color.js for more colors.
       */
      --primary-color: var(--paper-indigo-500);
      --light-primary-color: var(--paper-indigo-100);
      --dark-primary-color: var(--paper-indigo-700);

      --accent-color: var(--paper-pink-a200);
      --light-accent-color: var(--paper-pink-a100);
      --dark-accent-color: var(--paper-pink-a400);


      /*
       * Material Design Light background theme
       */
      --light-theme-background-color: #ffffff;
      --light-theme-base-color: #000000;
      --light-theme-text-color: var(--paper-grey-900);
      --light-theme-secondary-color: #737373;  /* for secondary text and icons */
      --light-theme-disabled-color: #9b9b9b;  /* disabled/hint text */
      --light-theme-divider-color: #dbdbdb;

      /*
       * Material Design Dark background theme
       */
      --dark-theme-background-color: var(--paper-grey-900);
      --dark-theme-base-color: #ffffff;
      --dark-theme-text-color: #ffffff;
      --dark-theme-secondary-color: #bcbcbc;  /* for secondary text and icons */
      --dark-theme-disabled-color: #646464;  /* disabled/hint text */
      --dark-theme-divider-color: #3c3c3c;

      /*
       * Deprecated values because of their confusing names.
       */
      --text-primary-color: var(--dark-theme-text-color);
      --default-primary-color: var(--primary-color);
    }
  </style>
</custom-style>`;
  template$4.setAttribute('style', 'display: none;');
  document.head.appendChild(template$4.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `PaperInkyFocusBehavior` implements a ripple when the element has keyboard
   * focus.
   *
   * @polymerBehavior PaperInkyFocusBehavior
   */
  const PaperInkyFocusBehaviorImpl = {
    observers: ['_focusedChanged(receivedFocusFromKeyboard)'],
    _focusedChanged: function (receivedFocusFromKeyboard) {
      if (receivedFocusFromKeyboard) {
        this.ensureRipple();
      }
      if (this.hasRipple()) {
        this._ripple.holdDown = receivedFocusFromKeyboard;
      }
    },
    _createRipple: function () {
      var ripple = PaperRippleBehavior._createRipple();
      ripple.id = 'ink';
      ripple.setAttribute('center', '');
      ripple.classList.add('circle');
      return ripple;
    }
  };

  /** @polymerBehavior */
  const PaperInkyFocusBehavior = [IronButtonState, IronControlState, PaperRippleBehavior, PaperInkyFocusBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  Material design: [Icon
  toggles](https://www.google.com/design/spec/components/buttons.html#buttons-toggle-buttons)

  `paper-icon-button` is a button with an image placed at the center. When the
  user touches the button, a ripple effect emanates from the center of the button.

  `paper-icon-button` does not include a default icon set. To use icons from the
  default set, include `PolymerElements/iron-icons/iron-icons.html`, and use the
  `icon` attribute to specify which icon from the icon set to use.

      <paper-icon-button icon="menu"></paper-icon-button>

  See [`iron-iconset`](iron-iconset) for more information about
  how to use a custom icon set.

  Example:

      <script type="module">
        import '@polymer/iron-icons/iron-icons.js';
      </script>

      <paper-icon-button icon="favorite"></paper-icon-button>
      <paper-icon-button src="star.png"></paper-icon-button>

  To use `paper-icon-button` as a link, wrap it in an anchor tag. Since
  `paper-icon-button` will already receive focus, you may want to prevent the
  anchor tag from receiving focus as well by setting its tabindex to -1.

      <a href="https://www.polymer-project.org" tabindex="-1">
        <paper-icon-button icon="polymer"></paper-icon-button>
      </a>

  ### Styling

  Style the button with CSS as you would a normal DOM element. If you are using
  the icons provided by `iron-icons`, they will inherit the foreground color of
  the button.

      /* make a red "favorite" button *\/
      <paper-icon-button icon="favorite" style="color: red;"></paper-icon-button>

  By default, the ripple is the same color as the foreground at 25% opacity. You
  may customize the color using the `--paper-icon-button-ink-color` custom
  property.

  The following custom properties and mixins are available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--paper-icon-button-disabled-text` | The color of the disabled button | `--disabled-text-color`
  `--paper-icon-button-ink-color` | Selected/focus ripple color | `--primary-text-color`
  `--paper-icon-button` | Mixin for a button | `{}`
  `--paper-icon-button-disabled` | Mixin for a disabled button | `{}`
  `--paper-icon-button-hover` | Mixin for button on hover | `{}`

  @group Paper Elements
  @element paper-icon-button
  @demo demo/index.html
  */
  Polymer({
    is: 'paper-icon-button',
    _template: html`
    <style>
      :host {
        display: inline-block;
        position: relative;
        padding: 8px;
        outline: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
        z-index: 0;
        line-height: 1;

        width: 40px;
        height: 40px;

        /*
          NOTE: Both values are needed, since some phones require the value to
          be \`transparent\`.
        */
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;

        /* Because of polymer/2558, this style has lower specificity than * */
        box-sizing: border-box !important;

        @apply --paper-icon-button;
      }

      :host #ink {
        color: var(--paper-icon-button-ink-color, var(--primary-text-color));
        opacity: 0.6;
      }

      :host([disabled]) {
        color: var(--paper-icon-button-disabled-text, var(--disabled-text-color));
        pointer-events: none;
        cursor: auto;

        @apply --paper-icon-button-disabled;
      }

      :host([hidden]) {
        display: none !important;
      }

      :host(:hover) {
        @apply --paper-icon-button-hover;
      }

      iron-icon {
        --iron-icon-width: 100%;
        --iron-icon-height: 100%;
      }
    </style>

    <iron-icon id="icon" src="[[src]]" icon="[[icon]]"
               alt$="[[alt]]"></iron-icon>
  `,
    hostAttributes: {
      role: 'button',
      tabindex: '0'
    },
    behaviors: [PaperInkyFocusBehavior],
    registered: function () {
      this._template.setAttribute('strip-whitespace', '');
    },
    properties: {
      /**
       * The URL of an image for the icon. If the src property is specified,
       * the icon property should not be.
       */
      src: {
        type: String
      },
      /**
       * Specifies the icon name or index in the set of icons available in
       * the icon's icon set. If the icon property is specified,
       * the src property should not be.
       */
      icon: {
        type: String
      },
      /**
       * Specifies the alternate text for the button, for accessibility.
       */
      alt: {
        type: String,
        observer: '_altChanged'
      }
    },
    _altChanged: function (newValue, oldValue) {
      var label = this.getAttribute('aria-label');

      // Don't stomp over a user-set aria-label.
      if (!label || oldValue == label) {
        this.setAttribute('aria-label', newValue);
      }
    }
  });

  /**!
   * Sortable 1.15.0
   * @author	RubaXa   <trash@rubaxa.org>
   * @author	owenm    <owen23355@gmail.com>
   * @license MIT
   */
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  var version = "1.15.0";
  function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) {
      return !! /*@__PURE__*/navigator.userAgent.match(pattern);
    }
  }
  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
  var Edge = userAgent(/Edge/i);
  var FireFox = userAgent(/firefox/i);
  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
  var IOS = userAgent(/iP(ad|od|hone)/i);
  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
  var captureMode = {
    capture: false,
    passive: false
  };
  function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
  }
  function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
  }
  function matches$1( /**HTMLElement*/
  el, /**String*/
  selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) {
      try {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        }
      } catch (_) {
        return false;
      }
    }
    return false;
  }
  function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
  }
  function closest( /**HTMLElement*/
  el, /**String*/
  selector, /**HTMLElement*/
  ctx, includeCTX) {
    if (el) {
      ctx = ctx || document;
      do {
        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches$1(el, selector) : matches$1(el, selector)) || includeCTX && el === ctx) {
          return el;
        }
        if (el === ctx) break;
        /* jshint boss:true */
      } while (el = getParentOrHost(el));
    }
    return null;
  }
  var R_SPACE = /\s+/g;
  function toggleClass(el, name, state) {
    if (el && name) {
      if (el.classList) {
        el.classList[state ? 'add' : 'remove'](name);
      } else {
        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
      }
    }
  }
  function css(el, prop, val) {
    var style = el && el.style;
    if (style) {
      if (val === void 0) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
          val = document.defaultView.getComputedStyle(el, '');
        } else if (el.currentStyle) {
          val = el.currentStyle;
        }
        return prop === void 0 ? val : val[prop];
      } else {
        if (!(prop in style) && prop.indexOf('webkit') === -1) {
          prop = '-webkit-' + prop;
        }
        style[prop] = val + (typeof val === 'string' ? '' : 'px');
      }
    }
  }
  function matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') {
      appliedTransforms = el;
    } else {
      do {
        var transform = css(el, 'transform');
        if (transform && transform !== 'none') {
          appliedTransforms = transform + ' ' + appliedTransforms;
        }
        /* jshint boss:true */
      } while (!selfOnly && (el = el.parentNode));
    }
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */

    return matrixFn && new matrixFn(appliedTransforms);
  }
  function find(ctx, tagName, iterator) {
    if (ctx) {
      var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;
      if (iterator) {
        for (; i < n; i++) {
          iterator(list[i], i);
        }
      }
      return list;
    }
    return [];
  }
  function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) {
      return scrollingElement;
    } else {
      return document.documentElement;
    }
  }
  /**
   * Returns the "bounding client rect" of given element
   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
   * @param  {[HTMLElement]} container              The parent the element will be placed in
   * @return {Object}                               The boundingClientRect of el, with specified adjustments
   */

  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
      elRect = el.getBoundingClientRect();
      top = elRect.top;
      left = elRect.left;
      bottom = elRect.bottom;
      right = elRect.right;
      height = elRect.height;
      width = elRect.width;
    } else {
      top = 0;
      left = 0;
      bottom = window.innerHeight;
      right = window.innerWidth;
      height = window.innerHeight;
      width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
      // Adjust for translate()
      container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
      // Not needed on <= IE11

      if (!IE11OrLess) {
        do {
          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
            var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
            bottom = top + elRect.height;
            right = left + elRect.width;
            break;
          }
          /* jshint boss:true */
        } while (container = container.parentNode);
      }
    }
    if (undoScale && el !== window) {
      // Adjust for scale()
      var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;
      if (elMatrix) {
        top /= scaleY;
        left /= scaleX;
        width /= scaleX;
        height /= scaleY;
        bottom = top + height;
        right = left + width;
      }
    }
    return {
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      width: width,
      height: height
    };
  }
  /**
   * Checks if a side of an element is scrolled past a side of its parents
   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
   */

  function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
    /* jshint boss:true */

    while (parent) {
      var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;
      if (parentSide === 'top' || parentSide === 'left') {
        visible = elSideVal >= parentSideVal;
      } else {
        visible = elSideVal <= parentSideVal;
      }
      if (!visible) return parent;
      if (parent === getWindowScrollingElement()) break;
      parent = getParentAutoScrollElement(parent, false);
    }
    return false;
  }
  /**
   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
   * and non-draggable elements
   * @param  {HTMLElement} el       The parent element
   * @param  {Number} childNum      The index of the child
   * @param  {Object} options       Parent Sortable's options
   * @return {HTMLElement}          The child at index childNum, or null if not found
   */

  function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0,
      i = 0,
      children = el.children;
    while (i < children.length) {
      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
        if (currentChild === childNum) {
          return children[i];
        }
        currentChild++;
      }
      i++;
    }
    return null;
  }
  /**
   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
   * @param  {HTMLElement} el       Parent element
   * @param  {selector} selector    Any other elements that should be ignored
   * @return {HTMLElement}          The last child, ignoring ghostEl
   */

  function lastChild(el, selector) {
    var last = el.lastElementChild;
    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches$1(last, selector))) {
      last = last.previousElementSibling;
    }
    return last || null;
  }
  /**
   * Returns the index of an element within its parent for a selected set of
   * elements
   * @param  {HTMLElement} el
   * @param  {selector} selector
   * @return {number}
   */

  function index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) {
      return -1;
    }
    /* jshint boss:true */

    while (el = el.previousElementSibling) {
      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches$1(el, selector))) {
        index++;
      }
    }
    return index;
  }
  /**
   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
   * The value is returned in real pixels.
   * @param  {HTMLElement} el
   * @return {Array}             Offsets in the format of [left, top]
   */

  function getRelativeScrollOffset(el) {
    var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();
    if (el) {
      do {
        var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
      } while (el !== winScroller && (el = el.parentNode));
    }
    return [offsetLeft, offsetTop];
  }
  /**
   * Returns the index of the object within the given array
   * @param  {Array} arr   Array that may or may not hold the object
   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
   * @return {Number}      The index of the object in the array, or -1
   */

  function indexOfObject(arr, obj) {
    for (var i in arr) {
      if (!arr.hasOwnProperty(i)) continue;
      for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
      }
    }
    return -1;
  }
  function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do {
      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
          if (gotSelf || includeSelf) return elem;
          gotSelf = true;
        }
      }
      /* jshint boss:true */
    } while (elem = elem.parentNode);
    return getWindowScrollingElement();
  }
  function extend(dst, src) {
    if (dst && src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) {
          dst[key] = src[key];
        }
      }
    }
    return dst;
  }
  function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
  }
  var _throttleTimeout;
  function throttle$1(callback, ms) {
    return function () {
      if (!_throttleTimeout) {
        var args = arguments,
          _this = this;
        if (args.length === 1) {
          callback.call(_this, args[0]);
        } else {
          callback.apply(_this, args);
        }
        _throttleTimeout = setTimeout(function () {
          _throttleTimeout = void 0;
        }, ms);
      }
    };
  }
  function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
  }
  function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) {
      return Polymer.dom(el).cloneNode(true);
    } else if ($) {
      return $(el).clone(true)[0];
    } else {
      return el.cloneNode(true);
    }
  }
  var expando = 'Sortable' + new Date().getTime();
  function AnimationStateManager() {
    var animationStates = [],
      animationCallbackId;
    return {
      captureAnimationState: function captureAnimationState() {
        animationStates = [];
        if (!this.options.animation) return;
        var children = [].slice.call(this.el.children);
        children.forEach(function (child) {
          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
          animationStates.push({
            target: child,
            rect: getRect(child)
          });
          var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation

          if (child.thisAnimationDuration) {
            var childMatrix = matrix(child, true);
            if (childMatrix) {
              fromRect.top -= childMatrix.f;
              fromRect.left -= childMatrix.e;
            }
          }
          child.fromRect = fromRect;
        });
      },
      addAnimationState: function addAnimationState(state) {
        animationStates.push(state);
      },
      removeAnimationState: function removeAnimationState(target) {
        animationStates.splice(indexOfObject(animationStates, {
          target: target
        }), 1);
      },
      animateAll: function animateAll(callback) {
        var _this = this;
        if (!this.options.animation) {
          clearTimeout(animationCallbackId);
          if (typeof callback === 'function') callback();
          return;
        }
        var animating = false,
          animationTime = 0;
        animationStates.forEach(function (state) {
          var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);
          if (targetMatrix) {
            // Compensate for current animation
            toRect.top -= targetMatrix.f;
            toRect.left -= targetMatrix.e;
          }
          target.toRect = toRect;
          if (target.thisAnimationDuration) {
            // Could also check if animatingRect is between fromRect and toRect
            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) &&
            // Make sure animatingRect is on line between toRect & fromRect
            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
              // If returning to same place as started from animation and on same axis
              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
            }
          } // if fromRect != toRect: animate

          if (!isRectEqual(toRect, fromRect)) {
            target.prevFromRect = fromRect;
            target.prevToRect = toRect;
            if (!time) {
              time = _this.options.animation;
            }
            _this.animate(target, animatingRect, toRect, time);
          }
          if (time) {
            animating = true;
            animationTime = Math.max(animationTime, time);
            clearTimeout(target.animationResetTimer);
            target.animationResetTimer = setTimeout(function () {
              target.animationTime = 0;
              target.prevFromRect = null;
              target.fromRect = null;
              target.prevToRect = null;
              target.thisAnimationDuration = null;
            }, time);
            target.thisAnimationDuration = time;
          }
        });
        clearTimeout(animationCallbackId);
        if (!animating) {
          if (typeof callback === 'function') callback();
        } else {
          animationCallbackId = setTimeout(function () {
            if (typeof callback === 'function') callback();
          }, animationTime);
        }
        animationStates = [];
      },
      animate: function animate(target, currentRect, toRect, duration) {
        if (duration) {
          css(target, 'transition', '');
          css(target, 'transform', '');
          var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
          target.animatingX = !!translateX;
          target.animatingY = !!translateY;
          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
          this.forRepaintDummy = repaint(target); // repaint

          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
          css(target, 'transform', 'translate3d(0,0,0)');
          typeof target.animated === 'number' && clearTimeout(target.animated);
          target.animated = setTimeout(function () {
            css(target, 'transition', '');
            css(target, 'transform', '');
            target.animated = false;
            target.animatingX = false;
            target.animatingY = false;
          }, duration);
        }
      }
    };
  }
  function repaint(target) {
    return target.offsetWidth;
  }
  function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
  }
  var plugins = [];
  var defaults = {
    initializeByDefault: true
  };
  var PluginManager = {
    mount: function mount(plugin) {
      // Set default static properties
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
          plugin[option] = defaults[option];
        }
      }
      plugins.forEach(function (p) {
        if (p.pluginName === plugin.pluginName) {
          throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        }
      });
      plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
      var _this = this;
      this.eventCanceled = false;
      evt.cancel = function () {
        _this.eventCanceled = true;
      };
      var eventNameGlobal = eventName + 'Global';
      plugins.forEach(function (plugin) {
        if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

        if (sortable[plugin.pluginName][eventNameGlobal]) {
          sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
            sortable: sortable
          }, evt));
        } // Only fire plugin event if plugin is enabled in this sortable,
        // and plugin has event defined

        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
          sortable[plugin.pluginName][eventName](_objectSpread2({
            sortable: sortable
          }, evt));
        }
      });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
      plugins.forEach(function (plugin) {
        var pluginName = plugin.pluginName;
        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
        var initialized = new plugin(sortable, el, sortable.options);
        initialized.sortable = sortable;
        initialized.options = sortable.options;
        sortable[pluginName] = initialized; // Add default options from plugin

        _extends(defaults, initialized.defaults);
      });
      for (var option in sortable.options) {
        if (!sortable.options.hasOwnProperty(option)) continue;
        var modified = this.modifyOption(sortable, option, sortable.options[option]);
        if (typeof modified !== 'undefined') {
          sortable.options[option] = modified;
        }
      }
    },
    getEventProperties: function getEventProperties(name, sortable) {
      var eventProperties = {};
      plugins.forEach(function (plugin) {
        if (typeof plugin.eventProperties !== 'function') return;
        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
      });
      return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
      var modifiedValue;
      plugins.forEach(function (plugin) {
        // Plugin must exist on the Sortable
        if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        }
      });
      return modifiedValue;
    }
  };
  function dispatchEvent(_ref) {
    var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
    for (var option in allEventProperties) {
      evt[option] = allEventProperties[option];
    }
    if (rootEl) {
      rootEl.dispatchEvent(evt);
    }
    if (options[onName]) {
      options[onName].call(sortable, evt);
    }
  }
  var _excluded$1 = ["evt"];
  var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, _excluded$1);
    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
      dragEl: dragEl,
      parentEl: parentEl,
      ghostEl: ghostEl,
      rootEl: rootEl,
      nextEl: nextEl,
      lastDownEl: lastDownEl,
      cloneEl: cloneEl,
      cloneHidden: cloneHidden,
      dragStarted: moved,
      putSortable: putSortable,
      activeSortable: Sortable.active,
      originalEvent: originalEvent,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex,
      hideGhostForTarget: _hideGhostForTarget,
      unhideGhostForTarget: _unhideGhostForTarget,
      cloneNowHidden: function cloneNowHidden() {
        cloneHidden = true;
      },
      cloneNowShown: function cloneNowShown() {
        cloneHidden = false;
      },
      dispatchSortableEvent: function dispatchSortableEvent(name) {
        _dispatchEvent({
          sortable: sortable,
          name: name,
          originalEvent: originalEvent
        });
      }
    }, data));
  };
  function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
      putSortable: putSortable,
      cloneEl: cloneEl,
      targetEl: dragEl,
      rootEl: rootEl,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex
    }, info));
  }
  var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
    ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
    _silent = false,
    savedInputChecked = [];
  /** @const */

  var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
    supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
      if (!documentExists) return; // false when <= IE11

      if (IE11OrLess) {
        return false;
      }
      var el = document.createElement('x');
      el.style.cssText = 'pointer-events:auto';
      return el.style.pointerEvents === 'auto';
    }(),
    _detectDirection = function _detectDirection(el, options) {
      var elCSS = css(el),
        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
        child1 = getChild(el, 0, options),
        child2 = getChild(el, 1, options),
        firstChildCSS = child1 && css(child1),
        secondChildCSS = child2 && css(child2),
        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
      if (elCSS.display === 'flex') {
        return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
      }
      if (elCSS.display === 'grid') {
        return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
      }
      if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
      }
      return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
    },
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
      var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
        dragElOppLength = vertical ? dragRect.width : dragRect.height,
        targetS1Opp = vertical ? targetRect.left : targetRect.top,
        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
        targetOppLength = vertical ? targetRect.width : targetRect.height;
      return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
    },
    /**
     * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
     * @param  {Number} x      X position
     * @param  {Number} y      Y position
     * @return {HTMLElement}   Element of the first found nearest Sortable
     */
    _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
      var ret;
      sortables.some(function (sortable) {
        var threshold = sortable[expando].options.emptyInsertThreshold;
        if (!threshold || lastChild(sortable)) return;
        var rect = getRect(sortable),
          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) {
          return ret = sortable;
        }
      });
      return ret;
    },
    _prepareGroup = function _prepareGroup(options) {
      function toFn(value, pull) {
        return function (to, from, dragEl, evt) {
          var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
          if (value == null && (pull || sameGroup)) {
            // Default pull value
            // Default pull and put value if same group
            return true;
          } else if (value == null || value === false) {
            return false;
          } else if (pull && value === 'clone') {
            return value;
          } else if (typeof value === 'function') {
            return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
          } else {
            var otherGroup = (pull ? to : from).options.group.name;
            return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
          }
        };
      }
      var group = {};
      var originalGroup = options.group;
      if (!originalGroup || _typeof(originalGroup) != 'object') {
        originalGroup = {
          name: originalGroup
        };
      }
      group.name = originalGroup.name;
      group.checkPull = toFn(originalGroup.pull, true);
      group.checkPut = toFn(originalGroup.put);
      group.revertClone = originalGroup.revertClone;
      options.group = group;
    },
    _hideGhostForTarget = function _hideGhostForTarget() {
      if (!supportCssPointerEvents && ghostEl) {
        css(ghostEl, 'display', 'none');
      }
    },
    _unhideGhostForTarget = function _unhideGhostForTarget() {
      if (!supportCssPointerEvents && ghostEl) {
        css(ghostEl, 'display', '');
      }
    }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position

  if (documentExists && !ChromeForAndroid) {
    document.addEventListener('click', function (evt) {
      if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
      }
    }, true);
  }
  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
      evt = evt.touches ? evt.touches[0] : evt;
      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
      if (nearest) {
        // Create imitation event
        var event = {};
        for (var i in evt) {
          if (evt.hasOwnProperty(i)) {
            event[i] = evt[i];
          }
        }
        event.target = event.rootEl = nearest;
        event.preventDefault = void 0;
        event.stopPropagation = void 0;
        nearest[expando]._onDragOver(event);
      }
    }
  };
  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) {
      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
    }
  };
  /**
   * @class  Sortable
   * @param  {HTMLElement}  el
   * @param  {Object}       [options]
   */

  function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) {
      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
    }
    this.el = el; // root element

    this.options = options = _extends({}, options); // Export instance

    el[expando] = this;
    var defaults = {
      group: null,
      sort: true,
      disabled: false,
      store: null,
      handle: null,
      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
      swapThreshold: 1,
      // percentage; 0 <= x <= 1
      invertSwap: false,
      // invert always
      invertedSwapThreshold: null,
      // will be set to same as swapThreshold if default
      removeCloneOnHide: true,
      direction: function direction() {
        return _detectDirection(el, this.options);
      },
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      ignore: 'a, img',
      filter: null,
      preventOnFilter: true,
      animation: 0,
      easing: null,
      setData: function setData(dataTransfer, dragEl) {
        dataTransfer.setData('Text', dragEl.textContent);
      },
      dropBubble: false,
      dragoverBubble: false,
      dataIdAttr: 'data-id',
      delay: 0,
      delayOnTouchOnly: false,
      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
      forceFallback: false,
      fallbackClass: 'sortable-fallback',
      fallbackOnBody: false,
      fallbackTolerance: 0,
      fallbackOffset: {
        x: 0,
        y: 0
      },
      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
      emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults); // Set default options

    for (var name in defaults) {
      !(name in options) && (options[name] = defaults[name]);
    }
    _prepareGroup(options); // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    } // Setup drag mode

    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
    if (this.nativeDraggable) {
      // Touch start threshold cannot be greater than the native dragstart threshold
      this.options.touchStartThreshold = 1;
    } // Bind events

    if (options.supportPointer) {
      on(el, 'pointerdown', this._onTapStart);
    } else {
      on(el, 'mousedown', this._onTapStart);
      on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
      on(el, 'dragover', this);
      on(el, 'dragenter', this);
    }
    sortables.push(this.el); // Restore sorting

    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

    _extends(this, AnimationStateManager());
  }
  Sortable.prototype = /** @lends Sortable.prototype */
  {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
      if (!this.el.contains(target) && target !== this.el) {
        lastTarget = null;
      }
    },
    _getDirection: function _getDirection(evt, target) {
      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart( /** Event|TouchEvent */
    evt) {
      if (!evt.cancelable) return;
      var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;
      _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.

      if (dragEl) {
        return;
      }
      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
        return; // only left button and enabled
      } // cancel dnd if original target is content editable

      if (originalTarget.isContentEditable) {
        return;
      } // Safari ignores further event handling after mousedown

      if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
        return;
      }
      target = closest(target, options.draggable, el, false);
      if (target && target.animated) {
        return;
      }
      if (lastDownEl === target) {
        // Ignoring duplicate `down`
        return;
      } // Get the index of the dragged element within its parent

      oldIndex = index(target);
      oldDraggableIndex = index(target, options.draggable); // Check filter

      if (typeof filter === 'function') {
        if (filter.call(this, evt, target, this)) {
          _dispatchEvent({
            sortable: _this,
            rootEl: originalTarget,
            name: 'filter',
            targetEl: target,
            toEl: el,
            fromEl: el
          });
          pluginEvent('filter', _this, {
            evt: evt
          });
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      } else if (filter) {
        filter = filter.split(',').some(function (criteria) {
          criteria = closest(originalTarget, criteria.trim(), el, false);
          if (criteria) {
            _dispatchEvent({
              sortable: _this,
              rootEl: criteria,
              name: 'filter',
              targetEl: target,
              fromEl: el,
              toEl: el
            });
            pluginEvent('filter', _this, {
              evt: evt
            });
            return true;
          }
        });
        if (filter) {
          preventOnFilter && evt.cancelable && evt.preventDefault();
          return; // cancel dnd
        }
      }

      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
        return;
      } // Prepare `dragstart`

      this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart( /** Event */
    evt, /** Touch */
    touch, /** HTMLElement */
    target) {
      var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;
      if (target && !dragEl && target.parentNode === el) {
        var dragRect = getRect(target);
        rootEl = el;
        dragEl = target;
        parentEl = dragEl.parentNode;
        nextEl = dragEl.nextSibling;
        lastDownEl = target;
        activeGroup = options.group;
        Sortable.dragged = dragEl;
        tapEvt = {
          target: dragEl,
          clientX: (touch || evt).clientX,
          clientY: (touch || evt).clientY
        };
        tapDistanceLeft = tapEvt.clientX - dragRect.left;
        tapDistanceTop = tapEvt.clientY - dragRect.top;
        this._lastX = (touch || evt).clientX;
        this._lastY = (touch || evt).clientY;
        dragEl.style['will-change'] = 'all';
        dragStartFn = function dragStartFn() {
          pluginEvent('delayEnded', _this, {
            evt: evt
          });
          if (Sortable.eventCanceled) {
            _this._onDrop();
            return;
          } // Delayed drag has been triggered
          // we can re-enable the events: touchmove/mousemove

          _this._disableDelayedDragEvents();
          if (!FireFox && _this.nativeDraggable) {
            dragEl.draggable = true;
          } // Bind the events: dragstart/dragend

          _this._triggerDragStart(evt, touch); // Drag start event

          _dispatchEvent({
            sortable: _this,
            name: 'choose',
            originalEvent: evt
          }); // Chosen item

          toggleClass(dragEl, options.chosenClass, true);
        }; // Disable "draggable"

        options.ignore.split(',').forEach(function (criteria) {
          find(dragEl, criteria.trim(), _disableDraggable);
        });
        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mouseup', _this._onDrop);
        on(ownerDocument, 'touchend', _this._onDrop);
        on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

        if (FireFox && this.nativeDraggable) {
          this.options.touchStartThreshold = 4;
          dragEl.draggable = true;
        }
        pluginEvent('delayStart', this, {
          evt: evt
        }); // Delay is impossible for native DnD in Edge or IE

        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
          if (Sortable.eventCanceled) {
            this._onDrop();
            return;
          } // If the user moves the pointer or let go the click or touch
          // before the delay has been reached:
          // disable the delayed drag

          on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
          on(ownerDocument, 'touchend', _this._disableDelayedDrag);
          on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
        } else {
          dragStartFn();
        }
      }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler( /** TouchEvent|PointerEvent **/
    e) {
      var touch = e.touches ? e.touches[0] : e;
      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
        this._disableDelayedDrag();
      }
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
      dragEl && _disableDraggable(dragEl);
      clearTimeout(this._dragStartTimer);
      this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
      off(ownerDocument, 'touchend', this._disableDelayedDrag);
      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart( /** Event */
    evt, /** Touch */
    touch) {
      touch = touch || evt.pointerType == 'touch' && evt;
      if (!this.nativeDraggable || touch) {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._onTouchMove);
        } else if (touch) {
          on(document, 'touchmove', this._onTouchMove);
        } else {
          on(document, 'mousemove', this._onTouchMove);
        }
      } else {
        on(dragEl, 'dragend', this);
        on(rootEl, 'dragstart', this._onDragStart);
      }
      try {
        if (document.selection) {
          // Timeout neccessary for IE9
          _nextTick(function () {
            document.selection.empty();
          });
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
      awaitingDragStarted = false;
      if (rootEl && dragEl) {
        pluginEvent('dragStarted', this, {
          evt: evt
        });
        if (this.nativeDraggable) {
          on(document, 'dragover', _checkOutsideTargetEl);
        }
        var options = this.options; // Apply effect

        !fallback && toggleClass(dragEl, options.dragClass, false);
        toggleClass(dragEl, options.ghostClass, true);
        Sortable.active = this;
        fallback && this._appendGhost(); // Drag start event

        _dispatchEvent({
          sortable: this,
          name: 'start',
          originalEvent: evt
        });
      } else {
        this._nulling();
      }
    },
    _emulateDragOver: function _emulateDragOver() {
      if (touchEvt) {
        this._lastX = touchEvt.clientX;
        this._lastY = touchEvt.clientY;
        _hideGhostForTarget();
        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        var parent = target;
        while (target && target.shadowRoot) {
          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
          if (target === parent) break;
          parent = target;
        }
        dragEl.parentNode[expando]._isOutsideThisEl(target);
        if (parent) {
          do {
            if (parent[expando]) {
              var inserted = void 0;
              inserted = parent[expando]._onDragOver({
                clientX: touchEvt.clientX,
                clientY: touchEvt.clientY,
                target: target,
                rootEl: parent
              });
              if (inserted && !this.options.dragoverBubble) {
                break;
              }
            }
            target = parent; // store last element
          }
          /* jshint boss:true */ while (parent = parent.parentNode);
        }
        _unhideGhostForTarget();
      }
    },
    _onTouchMove: function _onTouchMove( /**TouchEvent*/
    evt) {
      if (tapEvt) {
        var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

        if (!Sortable.active && !awaitingDragStarted) {
          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
            return;
          }
          this._onDragStart(evt, true);
        }
        if (ghostEl) {
          if (ghostMatrix) {
            ghostMatrix.e += dx - (lastDx || 0);
            ghostMatrix.f += dy - (lastDy || 0);
          } else {
            ghostMatrix = {
              a: 1,
              b: 0,
              c: 0,
              d: 1,
              e: dx,
              f: dy
            };
          }
          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
          css(ghostEl, 'webkitTransform', cssMatrix);
          css(ghostEl, 'mozTransform', cssMatrix);
          css(ghostEl, 'msTransform', cssMatrix);
          css(ghostEl, 'transform', cssMatrix);
          lastDx = dx;
          lastDy = dy;
          touchEvt = touch;
        }
        evt.cancelable && evt.preventDefault();
      }
    },
    _appendGhost: function _appendGhost() {
      // Bug if using scale(): https://stackoverflow.com/questions/2637058
      // Not being adjusted for
      if (!ghostEl) {
        var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

        if (PositionGhostAbsolutely) {
          // Get relatively positioned parent
          ghostRelativeParent = container;
          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
            ghostRelativeParent = ghostRelativeParent.parentNode;
          }
          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
            rect.top += ghostRelativeParent.scrollTop;
            rect.left += ghostRelativeParent.scrollLeft;
          } else {
            ghostRelativeParent = getWindowScrollingElement();
          }
          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
        }
        ghostEl = dragEl.cloneNode(true);
        toggleClass(ghostEl, options.ghostClass, false);
        toggleClass(ghostEl, options.fallbackClass, true);
        toggleClass(ghostEl, options.dragClass, true);
        css(ghostEl, 'transition', '');
        css(ghostEl, 'transform', '');
        css(ghostEl, 'box-sizing', 'border-box');
        css(ghostEl, 'margin', 0);
        css(ghostEl, 'top', rect.top);
        css(ghostEl, 'left', rect.left);
        css(ghostEl, 'width', rect.width);
        css(ghostEl, 'height', rect.height);
        css(ghostEl, 'opacity', '0.8');
        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
        css(ghostEl, 'zIndex', '100000');
        css(ghostEl, 'pointerEvents', 'none');
        Sortable.ghost = ghostEl;
        container.appendChild(ghostEl); // Set transform-origin

        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
      }
    },
    _onDragStart: function _onDragStart( /**Event*/
    evt, /**boolean*/
    fallback) {
      var _this = this;
      var dataTransfer = evt.dataTransfer;
      var options = _this.options;
      pluginEvent('dragStart', this, {
        evt: evt
      });
      if (Sortable.eventCanceled) {
        this._onDrop();
        return;
      }
      pluginEvent('setupClone', this);
      if (!Sortable.eventCanceled) {
        cloneEl = clone(dragEl);
        cloneEl.removeAttribute("id");
        cloneEl.draggable = false;
        cloneEl.style['will-change'] = '';
        this._hideClone();
        toggleClass(cloneEl, this.options.chosenClass, false);
        Sortable.clone = cloneEl;
      } // #1143: IFrame support workaround

      _this.cloneId = _nextTick(function () {
        pluginEvent('clone', _this);
        if (Sortable.eventCanceled) return;
        if (!_this.options.removeCloneOnHide) {
          rootEl.insertBefore(cloneEl, dragEl);
        }
        _this._hideClone();
        _dispatchEvent({
          sortable: _this,
          name: 'clone'
        });
      });
      !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

      if (fallback) {
        ignoreNextClick = true;
        _this._loopId = setInterval(_this._emulateDragOver, 50);
      } else {
        // Undo what was set in _prepareDragStart before drag started
        off(document, 'mouseup', _this._onDrop);
        off(document, 'touchend', _this._onDrop);
        off(document, 'touchcancel', _this._onDrop);
        if (dataTransfer) {
          dataTransfer.effectAllowed = 'move';
          options.setData && options.setData.call(_this, dataTransfer, dragEl);
        }
        on(document, 'drop', _this); // #1276 fix:

        css(dragEl, 'transform', 'translateZ(0)');
      }
      awaitingDragStarted = true;
      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
      on(document, 'selectstart', _this);
      moved = true;
      if (Safari) {
        css(document.body, 'user-select', 'none');
      }
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver( /**Event*/
    evt) {
      var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;
      if (_silent) return;
      function dragOverEvent(name, extra) {
        pluginEvent(name, _this, _objectSpread2({
          evt: evt,
          isOwner: isOwner,
          axis: vertical ? 'vertical' : 'horizontal',
          revert: revert,
          dragRect: dragRect,
          targetRect: targetRect,
          canSort: canSort,
          fromSortable: fromSortable,
          target: target,
          completed: completed,
          onMove: function onMove(target, after) {
            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
          },
          changed: changed
        }, extra));
      } // Capture animation state

      function capture() {
        dragOverEvent('dragOverAnimationCapture');
        _this.captureAnimationState();
        if (_this !== fromSortable) {
          fromSortable.captureAnimationState();
        }
      } // Return invocation when dragEl is inserted (or completed)

      function completed(insertion) {
        dragOverEvent('dragOverCompleted', {
          insertion: insertion
        });
        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          } else {
            activeSortable._showClone(_this);
          }
          if (_this !== fromSortable) {
            // Set ghost class to new sortable's ghost class
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
            toggleClass(dragEl, options.ghostClass, true);
          }
          if (putSortable !== _this && _this !== Sortable.active) {
            putSortable = _this;
          } else if (_this === Sortable.active && putSortable) {
            putSortable = null;
          } // Animation

          if (fromSortable === _this) {
            _this._ignoreWhileAnimating = target;
          }
          _this.animateAll(function () {
            dragOverEvent('dragOverAnimationComplete');
            _this._ignoreWhileAnimating = null;
          });
          if (_this !== fromSortable) {
            fromSortable.animateAll();
            fromSortable._ignoreWhileAnimating = null;
          }
        } // Null lastTarget if it is not inside a previously swapped element

        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
          lastTarget = null;
        } // no bubbling and not fallback

        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
          dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted

          !insertion && nearestEmptyInsertDetectEvent(evt);
        }
        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
        return completedFired = true;
      } // Call when dragEl has been inserted

      function changed() {
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);
        _dispatchEvent({
          sortable: _this,
          name: 'change',
          toEl: el,
          newIndex: newIndex,
          newDraggableIndex: newDraggableIndex,
          originalEvent: evt
        });
      }
      if (evt.preventDefault !== void 0) {
        evt.cancelable && evt.preventDefault();
      }
      target = closest(target, options.draggable, el, true);
      dragOverEvent('dragOver');
      if (Sortable.eventCanceled) return completedFired;
      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
        return completed(false);
      }
      ignoreNextClick = false;
      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
        vertical = this._getDirection(evt, target) === 'vertical';
        dragRect = getRect(dragEl);
        dragOverEvent('dragOverValid');
        if (Sortable.eventCanceled) return completedFired;
        if (revert) {
          parentEl = rootEl; // actualization

          capture();
          this._hideClone();
          dragOverEvent('revert');
          if (!Sortable.eventCanceled) {
            if (nextEl) {
              rootEl.insertBefore(dragEl, nextEl);
            } else {
              rootEl.appendChild(dragEl);
            }
          }
          return completed(true);
        }
        var elLastChild = lastChild(el, options.draggable);
        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
          // Insert to end of list
          // If already at end of list: Do not insert
          if (elLastChild === dragEl) {
            return completed(false);
          } // if there is a last element, it is the target

          if (elLastChild && el === evt.target) {
            target = elLastChild;
          }
          if (target) {
            targetRect = getRect(target);
          }
          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
            capture();
            if (elLastChild && elLastChild.nextSibling) {
              // the last draggable element is not the last node
              el.insertBefore(dragEl, elLastChild.nextSibling);
            } else {
              el.appendChild(dragEl);
            }
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
          // Insert to start of list
          var firstChild = getChild(el, 0, options, true);
          if (firstChild === dragEl) {
            return completed(false);
          }
          target = firstChild;
          targetRect = getRect(target);
          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
            capture();
            el.insertBefore(dragEl, firstChild);
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (target.parentNode === el) {
          targetRect = getRect(target);
          var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
          if (lastTarget !== target) {
            targetBeforeFirstSwap = targetRect[side1];
            pastFirstInvertThresh = false;
            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
          }
          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
          var sibling;
          if (direction !== 0) {
            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
            var dragIndex = index(dragEl);
            do {
              dragIndex -= direction;
              sibling = parentEl.children[dragIndex];
            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
          } // If dragEl is already beside target: Do not insert

          if (direction === 0 || sibling === target) {
            return completed(false);
          }
          lastTarget = target;
          lastDirection = direction;
          var nextSibling = target.nextElementSibling,
            after = false;
          after = direction === 1;
          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
          if (moveVector !== false) {
            if (moveVector === 1 || moveVector === -1) {
              after = moveVector === 1;
            }
            _silent = true;
            setTimeout(_unsilent, 30);
            capture();
            if (after && !nextSibling) {
              el.appendChild(dragEl);
            } else {
              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
            } // Undo chrome's scroll adjustment (has no effect on other browsers)

            if (scrolledPastTop) {
              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
            }
            parentEl = dragEl.parentNode; // actualization
            // must be done before animation

            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
            }
            changed();
            return completed(true);
          }
        }
        if (el.contains(dragEl)) {
          return completed(false);
        }
      }
      return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
      off(document, 'mousemove', this._onTouchMove);
      off(document, 'touchmove', this._onTouchMove);
      off(document, 'pointermove', this._onTouchMove);
      off(document, 'dragover', nearestEmptyInsertDetectEvent);
      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._onDrop);
      off(ownerDocument, 'touchend', this._onDrop);
      off(ownerDocument, 'pointerup', this._onDrop);
      off(ownerDocument, 'touchcancel', this._onDrop);
      off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop( /**Event*/
    evt) {
      var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      pluginEvent('drop', this, {
        evt: evt
      });
      parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      if (Sortable.eventCanceled) {
        this._nulling();
        return;
      }
      awaitingDragStarted = false;
      isCircumstantialInvert = false;
      pastFirstInvertThresh = false;
      clearInterval(this._loopId);
      clearTimeout(this._dragStartTimer);
      _cancelNextTick(this.cloneId);
      _cancelNextTick(this._dragStartId); // Unbind events

      if (this.nativeDraggable) {
        off(document, 'drop', this);
        off(el, 'dragstart', this._onDragStart);
      }
      this._offMoveEvents();
      this._offUpEvents();
      if (Safari) {
        css(document.body, 'user-select', '');
      }
      css(dragEl, 'transform', '');
      if (evt) {
        if (moved) {
          evt.cancelable && evt.preventDefault();
          !options.dropBubble && evt.stopPropagation();
        }
        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          // Remove clone(s)
          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
        }
        if (dragEl) {
          if (this.nativeDraggable) {
            off(dragEl, 'dragend', this);
          }
          _disableDraggable(dragEl);
          dragEl.style['will-change'] = ''; // Remove classes
          // ghostClass is added in dragStarted

          if (moved && !awaitingDragStarted) {
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
          }
          toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

          _dispatchEvent({
            sortable: this,
            name: 'unchoose',
            toEl: parentEl,
            newIndex: null,
            newDraggableIndex: null,
            originalEvent: evt
          });
          if (rootEl !== parentEl) {
            if (newIndex >= 0) {
              // Add event
              _dispatchEvent({
                rootEl: parentEl,
                name: 'add',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              }); // Remove event

              _dispatchEvent({
                sortable: this,
                name: 'remove',
                toEl: parentEl,
                originalEvent: evt
              }); // drag from one list and drop into another

              _dispatchEvent({
                rootEl: parentEl,
                name: 'sort',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
            putSortable && putSortable.save();
          } else {
            if (newIndex !== oldIndex) {
              if (newIndex >= 0) {
                // drag & drop within the same list
                _dispatchEvent({
                  sortable: this,
                  name: 'update',
                  toEl: parentEl,
                  originalEvent: evt
                });
                _dispatchEvent({
                  sortable: this,
                  name: 'sort',
                  toEl: parentEl,
                  originalEvent: evt
                });
              }
            }
          }
          if (Sortable.active) {
            /* jshint eqnull:true */
            if (newIndex == null || newIndex === -1) {
              newIndex = oldIndex;
              newDraggableIndex = oldDraggableIndex;
            }
            _dispatchEvent({
              sortable: this,
              name: 'end',
              toEl: parentEl,
              originalEvent: evt
            }); // Save sorting

            this.save();
          }
        }
      }
      this._nulling();
    },
    _nulling: function _nulling() {
      pluginEvent('nulling', this);
      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
      savedInputChecked.forEach(function (el) {
        el.checked = true;
      });
      savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent( /**Event*/
    evt) {
      switch (evt.type) {
        case 'drop':
        case 'dragend':
          this._onDrop(evt);
          break;
        case 'dragenter':
        case 'dragover':
          if (dragEl) {
            this._onDragOver(evt);
            _globalDragOver(evt);
          }
          break;
        case 'selectstart':
          evt.preventDefault();
          break;
      }
    },
    /**
     * Serializes the item into an array of string.
     * @returns {String[]}
     */
    toArray: function toArray() {
      var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;
      for (; i < n; i++) {
        el = children[i];
        if (closest(el, options.draggable, this.el, false)) {
          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
      }
      return order;
    },
    /**
     * Sorts the elements according to the array.
     * @param  {String[]}  order  order of the items
     */
    sort: function sort(order, useAnimation) {
      var items = {},
        rootEl = this.el;
      this.toArray().forEach(function (id, i) {
        var el = rootEl.children[i];
        if (closest(el, this.options.draggable, rootEl, false)) {
          items[id] = el;
        }
      }, this);
      useAnimation && this.captureAnimationState();
      order.forEach(function (id) {
        if (items[id]) {
          rootEl.removeChild(items[id]);
          rootEl.appendChild(items[id]);
        }
      });
      useAnimation && this.animateAll();
    },
    /**
     * Save the current sorting
     */
    save: function save() {
      var store = this.options.store;
      store && store.set && store.set(this);
    },
    /**
     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
     * @param   {HTMLElement}  el
     * @param   {String}       [selector]  default: `options.draggable`
     * @returns {HTMLElement|null}
     */
    closest: function closest$1(el, selector) {
      return closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
     * Set/get option
     * @param   {string} name
     * @param   {*}      [value]
     * @returns {*}
     */
    option: function option(name, value) {
      var options = this.options;
      if (value === void 0) {
        return options[name];
      } else {
        var modifiedValue = PluginManager.modifyOption(this, name, value);
        if (typeof modifiedValue !== 'undefined') {
          options[name] = modifiedValue;
        } else {
          options[name] = value;
        }
        if (name === 'group') {
          _prepareGroup(options);
        }
      }
    },
    /**
     * Destroy
     */
    destroy: function destroy() {
      pluginEvent('destroy', this);
      var el = this.el;
      el[expando] = null;
      off(el, 'mousedown', this._onTapStart);
      off(el, 'touchstart', this._onTapStart);
      off(el, 'pointerdown', this._onTapStart);
      if (this.nativeDraggable) {
        off(el, 'dragover', this);
        off(el, 'dragenter', this);
      } // Remove draggable attributes

      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
        el.removeAttribute('draggable');
      });
      this._onDrop();
      this._disableDelayedDragEvents();
      sortables.splice(sortables.indexOf(this.el), 1);
      this.el = el = null;
    },
    _hideClone: function _hideClone() {
      if (!cloneHidden) {
        pluginEvent('hideClone', this);
        if (Sortable.eventCanceled) return;
        css(cloneEl, 'display', 'none');
        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
          cloneEl.parentNode.removeChild(cloneEl);
        }
        cloneHidden = true;
      }
    },
    _showClone: function _showClone(putSortable) {
      if (putSortable.lastPutMode !== 'clone') {
        this._hideClone();
        return;
      }
      if (cloneHidden) {
        pluginEvent('showClone', this);
        if (Sortable.eventCanceled) return; // show clone at dragEl or original position

        if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
          rootEl.insertBefore(cloneEl, dragEl);
        } else if (nextEl) {
          rootEl.insertBefore(cloneEl, nextEl);
        } else {
          rootEl.appendChild(cloneEl);
        }
        if (this.options.group.revertClone) {
          this.animate(dragEl, cloneEl);
        }
        css(cloneEl, 'display', '');
        cloneHidden = false;
      }
    }
  };
  function _globalDragOver( /**Event*/
  evt) {
    if (evt.dataTransfer) {
      evt.dataTransfer.dropEffect = 'move';
    }
    evt.cancelable && evt.preventDefault();
  }
  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) {
      retVal = onMoveFn.call(sortable, evt, originalEvent);
    }
    return retVal;
  }
  function _disableDraggable(el) {
    el.draggable = false;
  }
  function _unsilent() {
    _silent = false;
  }
  function _ghostIsFirst(evt, vertical, sortable) {
    var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
  }
  function _ghostIsLast(evt, vertical, sortable) {
    var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
  }
  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;
    if (!invertSwap) {
      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
        // check if past first invert threshold on side opposite of lastDirection
        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
          pastFirstInvertThresh = true;
        }
        if (!pastFirstInvertThresh) {
          // dragEl shadow (target move distance shadow)
          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
          : mouseOnAxis > targetS2 - targetMoveDistance) {
            return -lastDirection;
          }
        } else {
          invert = true;
        }
      } else {
        // Regular
        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
          return _getInsertDirection(target);
        }
      }
    }
    invert = invert || invertSwap;
    if (invert) {
      // Invert of regular
      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
      }
    }
    return 0;
  }
  /**
   * Gets the direction dragEl must be swapped relative to target in order to make it
   * seem that dragEl has been "inserted" into that element's position
   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
   * @return {Number}                   Direction dragEl must be swapped
   */

  function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) {
      return 1;
    } else {
      return -1;
    }
  }
  /**
   * Generate id
   * @param   {HTMLElement} el
   * @returns {String}
   * @private
   */

  function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;
    while (i--) {
      sum += str.charCodeAt(i);
    }
    return sum.toString(36);
  }
  function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while (idx--) {
      var el = inputs[idx];
      el.checked && savedInputChecked.push(el);
    }
  }
  function _nextTick(fn) {
    return setTimeout(fn, 0);
  }
  function _cancelNextTick(id) {
    return clearTimeout(id);
  } // Fixed #973:

  if (documentExists) {
    on(document, 'touchmove', function (evt) {
      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
        evt.preventDefault();
      }
    });
  } // Export utils

  Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
      return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle$1,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild
  };
  /**
   * Get the Sortable instance of an element
   * @param  {HTMLElement} element The element
   * @return {Sortable|undefined}         The instance of Sortable
   */

  Sortable.get = function (element) {
    return element[expando];
  };
  /**
   * Mount a plugin to Sortable
   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
   */

  Sortable.mount = function () {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function (plugin) {
      if (!plugin.prototype || !plugin.prototype.constructor) {
        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
      }
      if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
      PluginManager.mount(plugin);
    });
  };
  /**
   * Create sortable instance
   * @param {HTMLElement}  el
   * @param {Object}      [options]
   */

  Sortable.create = function (el, options) {
    return new Sortable(el, options);
  }; // Export

  Sortable.version = version;
  var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
      dispatchSortableEvent('spill');
      this.onSpill({
        dragEl: dragEl,
        putSortable: putSortable
      });
    }
  };
  function Revert() {}
  Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
      var oldDraggableIndex = _ref2.oldDraggableIndex;
      this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
      var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
      this.sortable.captureAnimationState();
      if (putSortable) {
        putSortable.captureAnimationState();
      }
      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
      if (nextSibling) {
        this.sortable.el.insertBefore(dragEl, nextSibling);
      } else {
        this.sortable.el.appendChild(dragEl);
      }
      this.sortable.animateAll();
      if (putSortable) {
        putSortable.animateAll();
      }
    },
    drop: drop
  };
  _extends(Revert, {
    pluginName: 'revertOnSpill'
  });
  function Remove() {}
  Remove.prototype = {
    onSpill: function onSpill(_ref4) {
      var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
      var parentSortable = putSortable || this.sortable;
      parentSortable.captureAnimationState();
      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
      parentSortable.animateAll();
    },
    drop: drop
  };
  _extends(Remove, {
    pluginName: 'removeOnSpill'
  });

  /**
   * Modal element that can be passed a name, top buttons, body, and bottom buttons
   * @name UnityColumnEditor
   * @param {''} modalTitle, string for modal title
   * @param {bool} show, bool to control if modal is open or close
   * @param {func} toggle, callback that controls modals open/close
   * @param {bool} cancelOnOutsideClick, bool to control if clicking outside of modal will call toggle to close
   * @param {bool} noScroll, bool to control disabling scrolling on the modal body, defaults false
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *  <unity-modal
   *    .modalTitle="My Modal"
   *    ?show="${open}"
   *    .toggle="${()=> toggleClose()}"
   *  >
   *    <unity-button
   *      slot="top"
   *      label="Close"
   *      outline
   *      @click=${this.handleClose}>
   *    </unity-button>
   *    <div slot="body"/>
   *      This is the body of the modal
   *    </div>
   *    <unity-button
   *      slot="bottom"
   *      label="Clear"
   *      outline
   *      @click=${this.handleClear}>
   *    </unity-button>
   *    <unity-button
   *      slot="bottom"
   *      label="Save"
   *      gradient
   *      @click=${this.handleSave}>
   *    </unity-button>
   *  <unity-modal/>
   */

  const TOP_SLOT = "top";
  const BODY_SLOT = "body";
  const BOTTOM_SLOT = "bottom";
  let UnityModal = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityModal, _LitElement);
    var _super = _createSuper(UnityModal);
    function UnityModal() {
      var _this;
      _classCallCheck(this, UnityModal);
      _this = _super.call(this);
      _this.show = false;
      _this.modalTitle = '';
      _this.toggle = () => _this.show = !_this.show;
      _this.cancelOnOutsideClick = false;
      _this.noScroll = false;

      // this will set the opacity of the modal background to transparent
      // the backdrop is attached to the body, so it must be done this way or through the user's app's styles
      document.querySelector('body').style.setProperty('--iron-overlay-backdrop-opacity', 0);
      return _this;
    }
    _createClass(UnityModal, [{
      key: "resolveOpenChange",
      value: function resolveOpenChange(e) {
        if (this.show && (e.key === "Escape" || e.key === "Esc")) {
          this.toggle();
        }
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(UnityModal.prototype), "connectedCallback", this).call(this);
        this.resolveListener = this.resolveOpenChange.bind(this);
        document.addEventListener("keydown", this.resolveListener);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        document.removeEventListener('keydown', this.resolveListener);
        _get(_getPrototypeOf(UnityModal.prototype), "disconnectedCallback", this).call(this);
      }
    }, {
      key: "getSlots",
      value: function getSlots() {
        const slots = _toConsumableArray(this.shadowRoot.querySelectorAll('slot'));
        const slotContent = slots.map(slot => slot && slot.assignedNodes() || []);
        const [top, body, bottom] = slotContent.map(slot => trimWhitespace(slot));
        return {
          [TOP_SLOT]: top,
          [BODY_SLOT]: body,
          [BOTTOM_SLOT]: bottom
        };
      }
    }, {
      key: "handleBackdropClick",
      value: function handleBackdropClick() {
        const {
          cancelOnOutsideClick,
          toggle
        } = this;
        if (cancelOnOutsideClick) toggle();
      }
    }, {
      key: "renderModalTitle",
      value: function renderModalTitle(_ref) {
        let {
          [TOP_SLOT]: top = []
        } = _ref;
        const {
          modalTitle
        } = this;
        let topClasses = ["modal-title"];
        if (!modalTitle && top.length === 0) topClasses.push('hide');
        let buttonClasses = ["button-box"];
        if (top.length === 0) buttonClasses.push('hide');
        return html$1`
      <div class="${topClasses.join(' ')}">
        <unity-typography size="header2">${modalTitle}</unity-typography>
        <div class="${buttonClasses.join(' ')}">
          <div class="buttons">
            <slot name="${TOP_SLOT}"></slot>
          </div>
        </div>
      </div>
    `;
      }
    }, {
      key: "renderBottom",
      value: function renderBottom(_ref2) {
        let {
          [BOTTOM_SLOT]: bottom = []
        } = _ref2;
        const classes = ["button-box"];
        if (bottom.length === 0) classes.push('hide');
        return html$1`
      <div class="${classes.join(' ')}">
        <div class="buttons">
          <slot name="${BOTTOM_SLOT}"></slot>
        </div>
      </div>
    `;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          show,
          noScroll,
          modalTitle
        } = this;
        const slots = this.getSlots();
        return html$1`
      <div
        class="modal-backdrop${show ? '' : ' hide'}"
        @click="${this.handleBackdropClick}"
        tabindex="-1"
      >
        <div class="modal" >

          ${this.renderModalTitle(slots)}

          <div class="body-wrapper${noScroll ? ' no-scroll' : ''}">
            <slot name="${BODY_SLOT}"></slot>
          </div>

          ${this.renderBottom(slots)}
        </div>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          show: {
            type: Boolean
          },
          modalTitle: {
            type: String
          },
          toggle: {
            type: Function
          },
          cancelOnOutsideClick: {
            type: Boolean
          },
          noScroll: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-modal-backdrop-color: transparent;
          --default-modal-background-color: var(--background-color, var(--default-background-color));
          --default-title-border-color: var(--light-grey-text-color, var(--default-light-grey-text-color));
          --default-modal-box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        }
        .modal-backdrop {
          z-index: 100;
          background-color: var(--modal-backdrop-color, var(--default-modal-backdrop-color));
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          outline: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .modal {
          max-height: 90%;
          box-shadow: var(--modal-box-shadow, var(--default-modal-box-shadow));
          background-color: var(--modal-background-color, var(--default-modal-background-color));
          display: flex;
          flex-direction: column;
          flex: 0;
        }
        .modal-title {
          display: flex;
          border-bottom: 1px solid var(--title-border-color, var(--default-title-border-color));
          margin-top: 0;
          padding: 0 12px;
          height: 50px;
          flex-direction: row;
          align-items: center;
          align-content: center;
        }
        .body-wrapper {
          flex: 0;
          overflow: auto;
        }
        .body-wrapper.no-scroll {
          overflow: visible;
        }
        .button-box {
          flex: 1;
          width: auto;
          display: flex;
          flex-direction: row-reverse;
        }
        .buttons {
          flex: 0;
          display: flex;
          flex-direction: row;
          padding: 12px;
          box-sizing: border-box;
        }
        .hide {
          display: none;
        }
      `];
      }
    }]);
    return UnityModal;
  }(LitElement);
  window.customElements.define('unity-modal', UnityModal);

  /**
   * Displays button which will open column editor modal.
   * @name UnityColumnEditor
   * @param {{}} buttonProps, object defining properties of unity-button used to toggle Column Editor Modal.
   * @param {[]} columns, array of objects - same as what is passed into unity-table
   * @param {[]} selectedColumns, array of column keys from columns that are visible
   * @param {func} onUpdate, callback that is sent an array of sorted visible columns
   * @param {bool} modalOnly, if true, no button is displayed. Modal show/hide behavior is controlled with 'show' property
   * @param {bool} show, controls whether or not the column editor modal is displayed. Must be used in conjunction with modalOnly
   * @param {func} onClose, callback fired when modal is closed via save or close buttons. Must be used in conjunction with modalOnly
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *  <unity-column-editor
   *    .buttonProps="${{
          label: 'Edit Columns',
          leftIcon: 'settings',
          type: 'primary'
        }}"
   *    .columns="${[
   *      {
   *        key: 'column2',
   *        label: 'Column #2',
  *         format: (colValue, datum) => `Building: ${colValue}`
   *      },
   *      {
   *        key: 'columnN',
   *        label: 'Column #N',
   *        format: (colValue, datum) => html`<span style="${myStyle}">Room: ${colValue}</span>`
   *      },
   *      {
   *        key: 'column1',,
   *        label: 'Column #1'
   *        format: column1Handler
   *      }
   *    ]}"
   *    .selectedColumns="${[column1, column2]}"
   *    .onUpdate="${visibleColumns => console.log('These are the visible sorted columns: ', visibleColumns)}"
   *  />
   */

  //   UnityColumnEditor should be passed at a minimum an array of column data,
  //   and an onUpdate callback that will be called on save of the modal
  let UnityColumnEditor = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityColumnEditor, _LitElement);
    var _super = _createSuper(UnityColumnEditor);
    function UnityColumnEditor() {
      var _this;
      _classCallCheck(this, UnityColumnEditor);
      _this = _super.call(this);
      _this.columns = [];
      _this.buttonProps = {
        label: 'Edit Columns'
      };
      _this.onUpdate = columns => {};
      _this.modalOnly = false;
      _this.show = false;
      _this.onClose = undefined;
      _this._dialogVisible = false;
      _this._sortedColumns = [];
      _this._sortable;
      _this._selectedColumns = []; //internal variable to hold selectedColumns
      _this._formSelectedColumns = []; //internal varaible to hold selected columns in form (before save)
      return _this;
    }

    // inputs
    _createClass(UnityColumnEditor, [{
      key: "firstUpdated",
      value: function firstUpdated() {
        this.initSortable();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(UnityColumnEditor.prototype), "connectedCallback", this).call(this);
        this.resolveListener = this.resolveOpenChange.bind(this);
        document.addEventListener('iron-overlay-canceled', this.resolveListener);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        document.removeEventListener('iron-overlay-canceled', this.resolveListener);
        _get(_getPrototypeOf(UnityColumnEditor.prototype), "disconnectedCallback", this).call(this);
      }
    }, {
      key: "columns",
      get: function () {
        return this._columns;
      },
      set: function (columns) {
        const oldCols = this.columns;
        if (!this.selectedColumns || this.selectedColumns.length === 0) {
          this.selectedColumns = columns.map(col => col.key);
        }
        this._sortedColumns = columns; //NOTE: will this work?
        this._columns = columns;
        this.requestUpdate('columns', oldCols);
      }
    }, {
      key: "selectedColumns",
      get: function () {
        return this._selectedColumns;
      },
      set: function (selectedColumns) {
        const oldSelected = this._selectedColumns;
        const oldSelectedLib = new Set(oldSelected);
        //Check if selectedColumns has actually changed, otherwise do not update
        const hasChanged = !oldSelected || selectedColumns.length !== oldSelected.length || selectedColumns.some(columnKey => {
          return !oldSelectedLib.has(columnKey);
        });
        if (hasChanged) {
          this._selectedColumns = selectedColumns;

          //Also reset this._formSelectedColumns
          this._formSelectedColumns = selectedColumns;
          this.requestUpdate('selectedColumns', oldSelected);
        }
      }
    }, {
      key: "initSortable",
      value: function initSortable() {
        const listRef = this.shadowRoot.getElementById('column-list');
        this._sortable = new Sortable(listRef, {
          handle: '.drag-handle',
          ghostClass: "sortable-ghost",
          // Class name for the drop placeholder
          chosenClass: "sortable-chosen",
          // Class name for the chosen item
          dragClass: "sortable-drag",
          onUpdate: this.handleSort.bind(this)
        });
      }
    }, {
      key: "toggleDialog",
      value: function toggleDialog() {
        this._dialogVisible = !this._dialogVisible;

        //Fire onClose when closing dialog and modalOnly
        if (this.modalOnly && this.show && this.onClose instanceof Function) {
          this.onClose();
        }
      }
    }, {
      key: "handleColumnCheck",
      value: function handleColumnCheck(column) {
        const index = this._formSelectedColumns.findIndex(colKey => colKey === column.key);
        const isSelected = index > -1;
        if (isSelected) {
          const nextSelected = _toConsumableArray(this._formSelectedColumns);
          nextSelected.splice(index, 1);
          this._formSelectedColumns = nextSelected;
        } else {
          this._formSelectedColumns = [].concat(_toConsumableArray(this._formSelectedColumns), [column.key]);
        }
      }
    }, {
      key: "handleSort",
      value: function handleSort(e) {
        this._sortedColumns = this._sortable.toArray().map(key => this.columns.find(col => col.key === key));
      }
    }, {
      key: "handleCancel",
      value: function handleCancel(e) {
        //TODO: put list back the way it was - may need to unmount the component when modal is closed
        this._sortedColumns = this.columns;

        //Reset this._formSelectedColumns back to original selectedColumns
        this._formSelectedColumns = this.selectedColumns;
        this.toggleDialog();
      }
    }, {
      key: "resolveOpenChange",
      value: function resolveOpenChange(e) {
        if (this._dialogVisible) {
          this.toggleDialog();
        }
      }
    }, {
      key: "handleSave",
      value: function handleSave(e) {
        //prevent saving if no columns are selected
        if (this._formSelectedColumns.length === 0) return;
        const visibleColumns = this._sortedColumns.filter(col => this._formSelectedColumns.some(colKey => colKey === col.key));
        //Update internal selected Columns list
        this.selectedColumns = this._formSelectedColumns;
        this.onUpdate(visibleColumns);
        this.toggleDialog();
      }
    }, {
      key: "renderRow",
      value: function renderRow(col) {
        const isSelected = this._formSelectedColumns.some(colKey => colKey === col.key);
        return html$1`
      <div class="row" data-id="${col.key}">
        <div class="checkbox-container">
          <unity-checkbox
            .checked="${isSelected}"
            .onChange="${(e, v) => this.handleColumnCheck(col)}"
          ></unity-checkbox>
        </div>

        <div class="column-content">

          <div class="column-name">
            ${col.label}
          </div>

          <paper-icon-button
            class="drag-handle"
            icon="icons:menu"
            @click="${() => {}}"
          ></paper-icon-button>
        </div>
      </div>
    `;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          label = '',
          leftIcon = '',
          rightIcon = '',
          centerIcon = '',
          type = '',
          important,
          loading
        } = this.buttonProps;
        const showModal = this.modalOnly ? this.show : this._dialogVisible;
        return html$1`
      ${!this.modalOnly ? html$1`<unity-button
            label=${label}
            leftIcon=${leftIcon}
            rightIcon=${rightIcon}
            centerIcon=${centerIcon}
            type=${type}
            ?important=${important}
            ?loading=${loading}
            @click=${this.toggleDialog.bind(this)}
          >
          </unity-button>` : null}

      <unity-modal
        id="dialog"
        ?show="${showModal}"
        .title="${'Edit Columns'}"
        .toggle="${this.toggleDialog.bind(this)}"
      >
        <div class="list-container" id="column-list" slot="body">
          ${this.columns.map(this.renderRow.bind(this))}
        </div>

        <unity-button
          id="column-editor-cancel"
          label="Cancel"
          slot="bottom"
          type="secondary"
          @click=${this.handleCancel.bind(this)}
          class="modal-button"
        ></unity-button>
        <unity-button
          id="column-editor-save"
          label="Save"
          slot="bottom"
          autofocus
          type="primary"
          ?disabled=${this._formSelectedColumns.length === 0}
          @click=${this.handleSave.bind(this)}
          class="modal-button"
        ></unity-button>
      </unity-modal>
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          columns: {
            type: Array
          },
          selectedColumns: {
            type: Array
          },
          onUpdate: {
            type: Function
          },
          buttonProps: {
            type: Object
          },
          modalOnly: {
            type: Boolean
          },
          show: {
            type: Boolean
          },
          onClose: {
            type: Function
          },
          _dialogVisible: {
            type: Boolean
          },
          _selectedColumns: {
            type: Array
          },
          _formSelectedColumns: {
            type: Array
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          font-family: var(--font-family, var(--default-font-family));
          font-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          font-weight: var(--paragraph-font-weight, var(--default-paragraph-font-weight));
          color: var(--black-text-color, var(--default-black-text-color));
        }

        unity-checkbox {
          --unity-checkbox-size: 14px;
        }

        paper-dialog {
          min-width: 425px;
        }

        .dialog-title {
          font-size: var(--header2-selected-font-size, var(--default-header2-selected-font-size));
          font-weight: var(--header2-selected-font-weight, var(--default-header2-selected-font-weight));
          border-bottom: 1px solid var(--light-grey-text-color, var(--default-light-grey-text-color));
          margin-top: 0;
          padding: 0 12px;
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .list-container {
          margin: 0;
          height: 100%;
          max-height: 300px;
          overflow-y: auto;
        }

        .row {
          height: 40px;
          display: flex;
          flex-direction: row;
          align-items: stretch;
          border-bottom: 1px solid var(--light-grey-text-color, var(--default-light-grey-text-color));
        }

        .checkbox-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 12px;
          padding-right: 4px;
          border-right: 1px solid var(--light-grey-text-color, var(--default-light-grey-text-color));
        }

        paper-icon-button {
          color: var(--light-grey-text-color, var(--default-light-grey-text-color));
        }

        .column-content {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 12px;
        }

        .sortable-ghost {
          opacity: 0.5;
          background: #C8EBFB;
        }

        .sortable-drag {
          background-color: #FFF;
          opacity: 1;
        }

        .drag-handle {
          cursor: move;
        }
        .modal-button {
          margin-left: 8px;
        }
      `];
      }
    }]);
    return UnityColumnEditor;
  }(LitElement);
  window.customElements.define('unity-column-editor', UnityColumnEditor);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  // Give the user the choice to opt out of font loading.
  if (!window.polymerSkipLoadingFontRoboto) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.crossOrigin = 'anonymous';
    link.href = 'https://fonts.googleapis.com/css?family=Roboto+Mono:400,700|Roboto:400,300,300italic,400italic,500,500italic,700,700italic';
    document.head.appendChild(link);
  }

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$3 = html`<custom-style>
  <style is="custom-style">
    html {

      /* Shared Styles */
      --paper-font-common-base: {
        font-family: 'Roboto', 'Noto', sans-serif;
        -webkit-font-smoothing: antialiased;
      };

      --paper-font-common-code: {
        font-family: 'Roboto Mono', 'Consolas', 'Menlo', monospace;
        -webkit-font-smoothing: antialiased;
      };

      --paper-font-common-expensive-kerning: {
        text-rendering: optimizeLegibility;
      };

      --paper-font-common-nowrap: {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      };

      /* Material Font Styles */

      --paper-font-display4: {
        @apply --paper-font-common-base;
        @apply --paper-font-common-nowrap;

        font-size: 112px;
        font-weight: 300;
        letter-spacing: -.044em;
        line-height: 120px;
      };

      --paper-font-display3: {
        @apply --paper-font-common-base;
        @apply --paper-font-common-nowrap;

        font-size: 56px;
        font-weight: 400;
        letter-spacing: -.026em;
        line-height: 60px;
      };

      --paper-font-display2: {
        @apply --paper-font-common-base;

        font-size: 45px;
        font-weight: 400;
        letter-spacing: -.018em;
        line-height: 48px;
      };

      --paper-font-display1: {
        @apply --paper-font-common-base;

        font-size: 34px;
        font-weight: 400;
        letter-spacing: -.01em;
        line-height: 40px;
      };

      --paper-font-headline: {
        @apply --paper-font-common-base;

        font-size: 24px;
        font-weight: 400;
        letter-spacing: -.012em;
        line-height: 32px;
      };

      --paper-font-title: {
        @apply --paper-font-common-base;
        @apply --paper-font-common-nowrap;

        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
      };

      --paper-font-subhead: {
        @apply --paper-font-common-base;

        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      };

      --paper-font-body2: {
        @apply --paper-font-common-base;

        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
      };

      --paper-font-body1: {
        @apply --paper-font-common-base;

        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      };

      --paper-font-caption: {
        @apply --paper-font-common-base;
        @apply --paper-font-common-nowrap;

        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0.011em;
        line-height: 20px;
      };

      --paper-font-menu: {
        @apply --paper-font-common-base;
        @apply --paper-font-common-nowrap;

        font-size: 13px;
        font-weight: 500;
        line-height: 24px;
      };

      --paper-font-button: {
        @apply --paper-font-common-base;
        @apply --paper-font-common-nowrap;

        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.018em;
        line-height: 24px;
        text-transform: uppercase;
      };

      --paper-font-code2: {
        @apply --paper-font-common-code;

        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
      };

      --paper-font-code1: {
        @apply --paper-font-common-code;

        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      };

    }

  </style>
</custom-style>`;
  template$3.setAttribute('style', 'display: none;');
  document.head.appendChild(template$3.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const $_documentContainer = document.createElement('template');
  $_documentContainer.setAttribute('style', 'display: none;');
  $_documentContainer.innerHTML = `<dom-module id="paper-dialog-shared-styles">
  <template>
    <style>
      :host {
        display: block;
        margin: 24px 40px;

        background: var(--paper-dialog-background-color, var(--primary-background-color));
        color: var(--paper-dialog-color, var(--primary-text-color));

        @apply --paper-font-body1;
        @apply --shadow-elevation-16dp;
        @apply --paper-dialog;
      }

      :host > ::slotted(*) {
        margin-top: 20px;
        padding: 0 24px;
      }

      :host > ::slotted(.no-padding) {
        padding: 0;
      }

      
      :host > ::slotted(*:first-child) {
        margin-top: 24px;
      }

      :host > ::slotted(*:last-child) {
        margin-bottom: 24px;
      }

      /* In 1.x, this selector was \`:host > ::content h2\`. In 2.x <slot> allows
      to select direct children only, which increases the weight of this
      selector, so we have to re-define first-child/last-child margins below. */
      :host > ::slotted(h2) {
        position: relative;
        margin: 0;

        @apply --paper-font-title;
        @apply --paper-dialog-title;
      }

      /* Apply mixin again, in case it sets margin-top. */
      :host > ::slotted(h2:first-child) {
        margin-top: 24px;
        @apply --paper-dialog-title;
      }

      /* Apply mixin again, in case it sets margin-bottom. */
      :host > ::slotted(h2:last-child) {
        margin-bottom: 24px;
        @apply --paper-dialog-title;
      }

      :host > ::slotted(.paper-dialog-buttons),
      :host > ::slotted(.buttons) {
        position: relative;
        padding: 8px 8px 8px 24px;
        margin: 0;

        color: var(--paper-dialog-button-color, var(--primary-color));

        @apply --layout-horizontal;
        @apply --layout-end-justified;
      }
    </style>
  </template>
</dom-module>`;
  document.head.appendChild($_documentContainer.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `NeonAnimatableBehavior` is implemented by elements containing
   * animations for use with elements implementing
   * `NeonAnimationRunnerBehavior`.
   * @polymerBehavior
   */
  const NeonAnimatableBehavior = {
    properties: {
      /**
       * Animation configuration. See README for more info.
       */
      animationConfig: {
        type: Object
      },
      /**
       * Convenience property for setting an 'entry' animation. Do not set
       * `animationConfig.entry` manually if using this. The animated node is set
       * to `this` if using this property.
       */
      entryAnimation: {
        observer: '_entryAnimationChanged',
        type: String
      },
      /**
       * Convenience property for setting an 'exit' animation. Do not set
       * `animationConfig.exit` manually if using this. The animated node is set
       * to `this` if using this property.
       */
      exitAnimation: {
        observer: '_exitAnimationChanged',
        type: String
      }
    },
    _entryAnimationChanged: function () {
      this.animationConfig = this.animationConfig || {};
      this.animationConfig['entry'] = [{
        name: this.entryAnimation,
        node: this
      }];
    },
    _exitAnimationChanged: function () {
      this.animationConfig = this.animationConfig || {};
      this.animationConfig['exit'] = [{
        name: this.exitAnimation,
        node: this
      }];
    },
    _copyProperties: function (config1, config2) {
      // shallowly copy properties from config2 to config1
      for (var property in config2) {
        config1[property] = config2[property];
      }
    },
    _cloneConfig: function (config) {
      var clone = {
        isClone: true
      };
      this._copyProperties(clone, config);
      return clone;
    },
    _getAnimationConfigRecursive: function (type, map, allConfigs) {
      if (!this.animationConfig) {
        return;
      }
      if (this.animationConfig.value && typeof this.animationConfig.value === 'function') {
        this._warn(this._logf('playAnimation', 'Please put \'animationConfig\' inside of your components \'properties\' object instead of outside of it.'));
        return;
      }

      // type is optional
      var thisConfig;
      if (type) {
        thisConfig = this.animationConfig[type];
      } else {
        thisConfig = this.animationConfig;
      }
      if (!Array.isArray(thisConfig)) {
        thisConfig = [thisConfig];
      }

      // iterate animations and recurse to process configurations from child nodes
      if (thisConfig) {
        for (var config, index = 0; config = thisConfig[index]; index++) {
          if (config.animatable) {
            config.animatable._getAnimationConfigRecursive(config.type || type, map, allConfigs);
          } else {
            if (config.id) {
              var cachedConfig = map[config.id];
              if (cachedConfig) {
                // merge configurations with the same id, making a clone lazily
                if (!cachedConfig.isClone) {
                  map[config.id] = this._cloneConfig(cachedConfig);
                  cachedConfig = map[config.id];
                }
                this._copyProperties(cachedConfig, config);
              } else {
                // put any configs with an id into a map
                map[config.id] = config;
              }
            } else {
              allConfigs.push(config);
            }
          }
        }
      }
    },
    /**
     * An element implementing `NeonAnimationRunnerBehavior` calls this
     * method to configure an animation with an optional type. Elements
     * implementing `NeonAnimatableBehavior` should define the property
     * `animationConfig`, which is either a configuration object or a map of
     * animation type to array of configuration objects.
     */
    getAnimationConfig: function (type) {
      var map = {};
      var allConfigs = [];
      this._getAnimationConfigRecursive(type, map, allConfigs);
      // append the configurations saved in the map to the array
      for (var key in map) {
        allConfigs.push(map[key]);
      }
      return allConfigs;
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `NeonAnimationRunnerBehavior` adds a method to run animations.
   *
   * @polymerBehavior NeonAnimationRunnerBehavior
   */
  const NeonAnimationRunnerBehaviorImpl = {
    _configureAnimations: function (configs) {
      var results = [];
      var resultsToPlay = [];
      if (configs.length > 0) {
        for (let config, index = 0; config = configs[index]; index++) {
          let neonAnimation = document.createElement(config.name);
          // is this element actually a neon animation?
          if (neonAnimation.isNeonAnimation) {
            let result = null;
            // Closure compiler does not work well with a try / catch here.
            // .configure needs to be explicitly defined
            if (!neonAnimation.configure) {
              /**
               * @param {Object} config
               * @return {AnimationEffectReadOnly}
               */
              neonAnimation.configure = function (config) {
                return null;
              };
            }
            result = neonAnimation.configure(config);
            resultsToPlay.push({
              result: result,
              config: config,
              neonAnimation: neonAnimation
            });
          } else {
            console.warn(this.is + ':', config.name, 'not found!');
          }
        }
      }
      for (var i = 0; i < resultsToPlay.length; i++) {
        let result = resultsToPlay[i].result;
        let config = resultsToPlay[i].config;
        let neonAnimation = resultsToPlay[i].neonAnimation;
        // configuration or play could fail if polyfills aren't loaded
        try {
          // Check if we have an Effect rather than an Animation
          if (typeof result.cancel != 'function') {
            result = document.timeline.play(result);
          }
        } catch (e) {
          result = null;
          console.warn('Couldnt play', '(', config.name, ').', e);
        }
        if (result) {
          results.push({
            neonAnimation: neonAnimation,
            config: config,
            animation: result
          });
        }
      }
      return results;
    },
    _shouldComplete: function (activeEntries) {
      var finished = true;
      for (var i = 0; i < activeEntries.length; i++) {
        if (activeEntries[i].animation.playState != 'finished') {
          finished = false;
          break;
        }
      }
      return finished;
    },
    _complete: function (activeEntries) {
      for (var i = 0; i < activeEntries.length; i++) {
        activeEntries[i].neonAnimation.complete(activeEntries[i].config);
      }
      for (var i = 0; i < activeEntries.length; i++) {
        activeEntries[i].animation.cancel();
      }
    },
    /**
     * Plays an animation with an optional `type`.
     * @param {string=} type
     * @param {!Object=} cookie
     */
    playAnimation: function (type, cookie) {
      var configs = this.getAnimationConfig(type);
      if (!configs) {
        return;
      }
      this._active = this._active || {};
      if (this._active[type]) {
        this._complete(this._active[type]);
        delete this._active[type];
      }
      var activeEntries = this._configureAnimations(configs);
      if (activeEntries.length == 0) {
        this.fire('neon-animation-finish', cookie, {
          bubbles: false
        });
        return;
      }
      this._active[type] = activeEntries;
      for (var i = 0; i < activeEntries.length; i++) {
        activeEntries[i].animation.onfinish = function () {
          if (this._shouldComplete(activeEntries)) {
            this._complete(activeEntries);
            delete this._active[type];
            this.fire('neon-animation-finish', cookie, {
              bubbles: false
            });
          }
        }.bind(this);
      }
    },
    /**
     * Cancels the currently running animations.
     */
    cancelAnimation: function () {
      for (var k in this._active) {
        var entries = this._active[k];
        for (var j in entries) {
          entries[j].animation.cancel();
        }
      }
      this._active = {};
    }
  };

  /** @polymerBehavior */
  const NeonAnimationRunnerBehavior = [NeonAnimatableBehavior, NeonAnimationRunnerBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  // IE11 has a bug where an element with (1) `overflow: auto;`, (2) size based on
  // its content's natural size, (3) absolute positioning (either `absolute` or
  // `fixed`), and (4) use `max-width` to constrain its width will place its
  // vertical scrollbar outside the area constrained by `max-width`.
  //
  // Unlike other browsers, IE11 doesn't support changing the size of scrollbars
  // with CSS, so we don't need to read this value live from the element in
  // question when trying to work around the bug.
  let verticalScrollbarMaxWidthBugOffset = undefined;
  const getVerticalScrollbarMaxWidthBugOffset = () => {
    if (verticalScrollbarMaxWidthBugOffset !== undefined) {
      return verticalScrollbarMaxWidthBugOffset;
    }
    const container = document.createElement('div');
    Object.assign(container.style, {
      overflow: 'auto',
      position: 'fixed',
      left: '0px',
      top: '0px',
      maxWidth: '100px',
      maxHeight: '100px'
    });
    const content = document.createElement('div');
    content.style.width = '200px';
    content.style.height = '200px';
    container.appendChild(content);
    document.body.appendChild(container);
    verticalScrollbarMaxWidthBugOffset = Math.abs(container.offsetWidth - 100) > 1 ? container.offsetWidth - container.clientWidth : 0;
    document.body.removeChild(container);
    return verticalScrollbarMaxWidthBugOffset;
  };

  /**
  `Polymer.IronFitBehavior` fits an element in another element using `max-height`
  and `max-width`, and optionally centers it in the window or another element.

  The element will only be sized and/or positioned if it has not already been
  sized and/or positioned by CSS.

  CSS properties            | Action
  --------------------------|-------------------------------------------
  `position` set            | Element is not centered horizontally or vertically
  `top` or `bottom` set     | Element is not vertically centered
  `left` or `right` set     | Element is not horizontally centered
  `max-height` set          | Element respects `max-height`
  `max-width` set           | Element respects `max-width`

  `Polymer.IronFitBehavior` can position an element into another element using
  `verticalAlign` and `horizontalAlign`. This will override the element's css
  position.

      <div class="container">
        <iron-fit-impl vertical-align="top" horizontal-align="auto">
          Positioned into the container
        </iron-fit-impl>
      </div>

  Use `noOverlap` to position the element around another element without
  overlapping it.

      <div class="container">
        <iron-fit-impl no-overlap vertical-align="auto" horizontal-align="auto">
          Positioned around the container
        </iron-fit-impl>
      </div>

  Use `horizontalOffset, verticalOffset` to offset the element from its
  `positionTarget`; `Polymer.IronFitBehavior` will collapse these in order to
  keep the element within `fitInto` boundaries, while preserving the element's
  CSS margin values.

      <div class="container">
        <iron-fit-impl vertical-align="top" vertical-offset="20">
          With vertical offset
        </iron-fit-impl>
      </div>

  @demo demo/index.html
  @polymerBehavior
  */
  const IronFitBehavior = {
    properties: {
      /**
       * The element that will receive a `max-height`/`width`. By default it is
       * the same as `this`, but it can be set to a child element. This is useful,
       * for example, for implementing a scrolling region inside the element.
       * @type {!Element}
       */
      sizingTarget: {
        type: Object,
        value: function () {
          return this;
        }
      },
      /**
       * The element to fit `this` into.
       */
      fitInto: {
        type: Object,
        value: window
      },
      /**
       * Will position the element around the positionTarget without overlapping
       * it.
       */
      noOverlap: {
        type: Boolean
      },
      /**
       * The element that should be used to position the element. If not set, it
       * will default to the parent node.
       * @type {!Element}
       */
      positionTarget: {
        type: Element
      },
      /**
       * The orientation against which to align the element horizontally
       * relative to the `positionTarget`. Possible values are "left", "right",
       * "center", "auto".
       */
      horizontalAlign: {
        type: String
      },
      /**
       * The orientation against which to align the element vertically
       * relative to the `positionTarget`. Possible values are "top", "bottom",
       * "middle", "auto".
       */
      verticalAlign: {
        type: String
      },
      /**
       * If true, it will use `horizontalAlign` and `verticalAlign` values as
       * preferred alignment and if there's not enough space, it will pick the
       * values which minimize the cropping.
       */
      dynamicAlign: {
        type: Boolean
      },
      /**
       * A pixel value that will be added to the position calculated for the
       * given `horizontalAlign`, in the direction of alignment. You can think
       * of it as increasing or decreasing the distance to the side of the
       * screen given by `horizontalAlign`.
       *
       * If `horizontalAlign` is "left" or "center", this offset will increase or
       * decrease the distance to the left side of the screen: a negative offset
       * will move the dropdown to the left; a positive one, to the right.
       *
       * Conversely if `horizontalAlign` is "right", this offset will increase
       * or decrease the distance to the right side of the screen: a negative
       * offset will move the dropdown to the right; a positive one, to the left.
       */
      horizontalOffset: {
        type: Number,
        value: 0,
        notify: true
      },
      /**
       * A pixel value that will be added to the position calculated for the
       * given `verticalAlign`, in the direction of alignment. You can think
       * of it as increasing or decreasing the distance to the side of the
       * screen given by `verticalAlign`.
       *
       * If `verticalAlign` is "top" or "middle", this offset will increase or
       * decrease the distance to the top side of the screen: a negative offset
       * will move the dropdown upwards; a positive one, downwards.
       *
       * Conversely if `verticalAlign` is "bottom", this offset will increase
       * or decrease the distance to the bottom side of the screen: a negative
       * offset will move the dropdown downwards; a positive one, upwards.
       */
      verticalOffset: {
        type: Number,
        value: 0,
        notify: true
      },
      /**
       * Set to true to auto-fit on attach.
       */
      autoFitOnAttach: {
        type: Boolean,
        value: false
      },
      /**
       * If true and scrollbars are added to `sizingTarget` after it is
       * positioned, the size of the added scrollbars will be added to its
       * `maxWidth` and `maxHeight`.
       */
      expandSizingTargetForScrollbars: {
        type: Boolean,
        value: false
      },
      /** @type {?Object} */
      _fitInfo: {
        type: Object
      }
    },
    get _fitWidth() {
      var fitWidth;
      if (this.fitInto === window) {
        fitWidth = this.fitInto.innerWidth;
      } else {
        fitWidth = this.fitInto.getBoundingClientRect().width;
      }
      return fitWidth;
    },
    get _fitHeight() {
      var fitHeight;
      if (this.fitInto === window) {
        fitHeight = this.fitInto.innerHeight;
      } else {
        fitHeight = this.fitInto.getBoundingClientRect().height;
      }
      return fitHeight;
    },
    get _fitLeft() {
      var fitLeft;
      if (this.fitInto === window) {
        fitLeft = 0;
      } else {
        fitLeft = this.fitInto.getBoundingClientRect().left;
      }
      return fitLeft;
    },
    get _fitTop() {
      var fitTop;
      if (this.fitInto === window) {
        fitTop = 0;
      } else {
        fitTop = this.fitInto.getBoundingClientRect().top;
      }
      return fitTop;
    },
    /**
     * The element that should be used to position the element,
     * if no position target is configured.
     */
    get _defaultPositionTarget() {
      var parent = dom(this).parentNode;
      if (parent && parent.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        parent = parent.host;
      }
      return parent;
    },
    /**
     * The horizontal align value, accounting for the RTL/LTR text direction.
     */
    get _localeHorizontalAlign() {
      if (this._isRTL) {
        // In RTL, "left" becomes "right".
        if (this.horizontalAlign === 'right') {
          return 'left';
        }
        if (this.horizontalAlign === 'left') {
          return 'right';
        }
      }
      return this.horizontalAlign;
    },
    /**
     * True if the element should be positioned instead of centered.
     * @private
     */
    get __shouldPosition() {
      return (this.horizontalAlign || this.verticalAlign) && this.positionTarget;
    },
    /**
     * True if the component is RTL.
     * @private
     */
    get _isRTL() {
      // Memoize this to avoid expensive calculations & relayouts.
      // Make sure we do it only once
      if (typeof this._memoizedIsRTL === 'undefined') {
        this._memoizedIsRTL = window.getComputedStyle(this).direction == 'rtl';
      }
      return this._memoizedIsRTL;
    },
    /** @override */
    attached: function () {
      this.positionTarget = this.positionTarget || this._defaultPositionTarget;
      if (this.autoFitOnAttach) {
        if (window.getComputedStyle(this).display === 'none') {
          setTimeout(function () {
            this.fit();
          }.bind(this));
        } else {
          // NOTE: shadydom applies distribution asynchronously
          // for performance reasons webcomponents/shadydom#120
          // Flush to get correct layout info.
          window.ShadyDOM && ShadyDOM.flush();
          this.fit();
        }
      }
    },
    /** @override */
    detached: function () {
      if (this.__deferredFit) {
        clearTimeout(this.__deferredFit);
        this.__deferredFit = null;
      }
    },
    /**
     * Positions and fits the element into the `fitInto` element.
     */
    fit: function () {
      this.position();
      this.constrain();
      this.center();
    },
    /**
     * Memoize information needed to position and size the target element.
     * @suppress {deprecated}
     */
    _discoverInfo: function () {
      if (this._fitInfo) {
        return;
      }
      var target = window.getComputedStyle(this);
      var sizer = window.getComputedStyle(this.sizingTarget);
      this._fitInfo = {
        inlineStyle: {
          top: this.style.top || '',
          left: this.style.left || '',
          position: this.style.position || ''
        },
        sizerInlineStyle: {
          maxWidth: this.sizingTarget.style.maxWidth || '',
          maxHeight: this.sizingTarget.style.maxHeight || '',
          boxSizing: this.sizingTarget.style.boxSizing || ''
        },
        positionedBy: {
          vertically: target.top !== 'auto' ? 'top' : target.bottom !== 'auto' ? 'bottom' : null,
          horizontally: target.left !== 'auto' ? 'left' : target.right !== 'auto' ? 'right' : null
        },
        sizedBy: {
          height: sizer.maxHeight !== 'none',
          width: sizer.maxWidth !== 'none',
          minWidth: parseInt(sizer.minWidth, 10) || 0,
          minHeight: parseInt(sizer.minHeight, 10) || 0
        },
        margin: {
          top: parseInt(target.marginTop, 10) || 0,
          right: parseInt(target.marginRight, 10) || 0,
          bottom: parseInt(target.marginBottom, 10) || 0,
          left: parseInt(target.marginLeft, 10) || 0
        }
      };
    },
    /**
     * Resets the target element's position and size constraints, and clear
     * the memoized data.
     */
    resetFit: function () {
      var info = this._fitInfo || {};
      for (var property in info.sizerInlineStyle) {
        this.sizingTarget.style[property] = info.sizerInlineStyle[property];
      }
      for (var property in info.inlineStyle) {
        this.style[property] = info.inlineStyle[property];
      }
      this._fitInfo = null;
    },
    /**
     * Equivalent to calling `resetFit()` and `fit()`. Useful to call this after
     * the element or the `fitInto` element has been resized, or if any of the
     * positioning properties (e.g. `horizontalAlign, verticalAlign`) is updated.
     * It preserves the scroll position of the sizingTarget.
     */
    refit: function () {
      var scrollLeft = this.sizingTarget.scrollLeft;
      var scrollTop = this.sizingTarget.scrollTop;
      this.resetFit();
      this.fit();
      this.sizingTarget.scrollLeft = scrollLeft;
      this.sizingTarget.scrollTop = scrollTop;
    },
    /**
     * Positions the element according to `horizontalAlign, verticalAlign`.
     */
    position: function () {
      if (!this.__shouldPosition) {
        // needs to be centered, and it is done after constrain.
        return;
      }
      this._discoverInfo();
      window.ShadyDOM && window.ShadyDOM.flush();
      this.style.position = 'fixed';
      // Need border-box for margin/padding.
      this.sizingTarget.style.boxSizing = 'border-box';
      // Set to 0, 0 in order to discover any offset caused by parent stacking
      // contexts.
      this.style.left = '0px';
      this.style.top = '0px';
      var rect = this.getBoundingClientRect();
      var positionRect = this.__getNormalizedRect(this.positionTarget);
      var fitRect = this.__getNormalizedRect(this.fitInto);
      let unpositionedOffsetWidth;
      let unpositionedOffsetHeight;
      let unpositionedClientWidth;
      let unpositionedClientHeight;
      if (this.expandSizingTargetForScrollbars) {
        unpositionedOffsetWidth = this.sizingTarget.offsetWidth;
        unpositionedOffsetHeight = this.sizingTarget.offsetHeight;
        unpositionedClientWidth = this.sizingTarget.clientWidth;
        unpositionedClientHeight = this.sizingTarget.clientHeight;
      }
      var margin = this._fitInfo.margin;

      // Consider the margin as part of the size for position calculations.
      var size = {
        width: rect.width + margin.left + margin.right,
        height: rect.height + margin.top + margin.bottom
      };
      var position = this.__getPosition(this._localeHorizontalAlign, this.verticalAlign, size, rect, positionRect, fitRect);
      var left = position.left + margin.left;
      var top = position.top + margin.top;

      // We first limit right/bottom within fitInto respecting the margin,
      // then use those values to limit top/left.
      var right = Math.min(fitRect.right - margin.right, left + rect.width);
      var bottom = Math.min(fitRect.bottom - margin.bottom, top + rect.height);

      // Keep left/top within fitInto respecting the margin.
      left = Math.max(fitRect.left + margin.left, Math.min(left, right - this._fitInfo.sizedBy.minWidth));
      top = Math.max(fitRect.top + margin.top, Math.min(top, bottom - this._fitInfo.sizedBy.minHeight));

      // Use right/bottom to set maxWidth/maxHeight, and respect
      // minWidth/minHeight.
      const maxWidth = Math.max(right - left, this._fitInfo.sizedBy.minWidth);
      const maxHeight = Math.max(bottom - top, this._fitInfo.sizedBy.minHeight);
      this.sizingTarget.style.maxWidth = maxWidth + 'px';
      this.sizingTarget.style.maxHeight = maxHeight + 'px';

      // Remove the offset caused by any stacking context.
      const leftPosition = left - rect.left;
      const topPosition = top - rect.top;
      this.style.left = `${leftPosition}px`;
      this.style.top = `${topPosition}px`;
      if (this.expandSizingTargetForScrollbars) {
        // Expand the height first - i.e. in the typical block direction - in case
        // this expands the element enough to remove the vertical scrollbar.

        const positionedOffsetHeight = this.sizingTarget.offsetHeight;
        const positionedClientHeight = this.sizingTarget.clientHeight;
        const unpositionedHeightDelta = unpositionedOffsetHeight - unpositionedClientHeight;
        const positionedHeightDelta = positionedOffsetHeight - positionedClientHeight;
        const sizingTargetScrollbarHeight = positionedHeightDelta - unpositionedHeightDelta;
        if (sizingTargetScrollbarHeight > 0) {
          // Expand `maxHeight` by `sizingTargetScrollbarHeight` up to the overall
          // allowed height within `fitRect`.
          const fitRectMaxHeight = fitRect.height - margin.top - margin.bottom;
          const newMaxHeight = Math.min(fitRectMaxHeight, maxHeight + sizingTargetScrollbarHeight);
          this.sizingTarget.style.maxHeight = `${newMaxHeight}px`;

          // Measure the element's real change in height. This may not equal
          // `sizingTargetScrollbarHeight` if the overflow amount is less than the
          // scrollbar size.
          const offsetHeight = this.sizingTarget.offsetHeight;
          const addedHeight = offsetHeight - positionedOffsetHeight;

          // Adjust the top position if the alignment requires it.
          let newTopPosition;
          if (position.verticalAlign === 'top') {
            newTopPosition = topPosition;
          } else if (position.verticalAlign === 'middle') {
            newTopPosition = topPosition - addedHeight / 2;
          } else if (position.verticalAlign === 'bottom') {
            newTopPosition = topPosition - addedHeight;
          }

          // Constrain the new top position based on `fitRect` again.
          newTopPosition = Math.max(fitRect.top + margin.top, Math.min(newTopPosition, fitRect.bottom - margin.bottom - offsetHeight));
          this.style.top = `${newTopPosition}px`;
        }
        const positionedOffsetWidth = this.sizingTarget.offsetWidth;
        const positionedClientWidth = this.sizingTarget.clientWidth;
        const unpositionedWidthDelta = unpositionedOffsetWidth - unpositionedClientWidth;
        const positionedWidthDelta = positionedOffsetWidth - positionedClientWidth;
        const sizingTargetScrollbarWidth = positionedWidthDelta - unpositionedWidthDelta;
        if (sizingTargetScrollbarWidth > 0) {
          const maxWidthBugOffset = getVerticalScrollbarMaxWidthBugOffset();

          // Expand `maxWidth` by `sizingTargetScrollbarWidth` up to the overall
          // allowed width within `fitRect`.
          const fitRectMaxWidth = fitRect.width - margin.left - margin.right;
          const newMaxWidth = Math.min(fitRectMaxWidth, maxWidth + sizingTargetScrollbarWidth - maxWidthBugOffset);
          this.sizingTarget.style.maxWidth = `${newMaxWidth}px`;

          // Measure the element's real change in width. This may not equal
          // `sizingTargetScrollbarWidth` if the overflow amount is less than the
          // scrollbar size.
          const offsetWidth = this.sizingTarget.offsetWidth + maxWidthBugOffset;
          const addedWidth = offsetWidth - positionedOffsetWidth;

          // Adjust the left position if the alignment requires it.
          let newLeftPosition;
          if (position.horizontalAlign === 'left') {
            newLeftPosition = leftPosition;
          } else if (position.horizontalAlign === 'center') {
            newLeftPosition = leftPosition - addedWidth / 2;
          } else if (position.horizontalAlign === 'right') {
            newLeftPosition = leftPosition - addedWidth;
          }

          // Constrain the new left position based on `fitRect` again.
          newLeftPosition = Math.max(fitRect.left + margin.left, Math.min(newLeftPosition, fitRect.right - margin.right - offsetWidth));
          this.style.left = `${newLeftPosition}px`;
        }
      }
    },
    /**
     * Constrains the size of the element to `fitInto` by setting `max-height`
     * and/or `max-width`.
     */
    constrain: function () {
      if (this.__shouldPosition) {
        return;
      }
      this._discoverInfo();
      var info = this._fitInfo;
      // position at (0px, 0px) if not already positioned, so we can measure the
      // natural size.
      if (!info.positionedBy.vertically) {
        this.style.position = 'fixed';
        this.style.top = '0px';
      }
      if (!info.positionedBy.horizontally) {
        this.style.position = 'fixed';
        this.style.left = '0px';
      }

      // need border-box for margin/padding
      this.sizingTarget.style.boxSizing = 'border-box';
      // constrain the width and height if not already set
      var rect = this.getBoundingClientRect();
      if (!info.sizedBy.height) {
        this.__sizeDimension(rect, info.positionedBy.vertically, 'top', 'bottom', 'Height');
      }
      if (!info.sizedBy.width) {
        this.__sizeDimension(rect, info.positionedBy.horizontally, 'left', 'right', 'Width');
      }
    },
    /**
     * @protected
     * @deprecated
     */
    _sizeDimension: function (rect, positionedBy, start, end, extent) {
      this.__sizeDimension(rect, positionedBy, start, end, extent);
    },
    /**
     * @private
     */
    __sizeDimension: function (rect, positionedBy, start, end, extent) {
      var info = this._fitInfo;
      var fitRect = this.__getNormalizedRect(this.fitInto);
      var max = extent === 'Width' ? fitRect.width : fitRect.height;
      var flip = positionedBy === end;
      var offset = flip ? max - rect[end] : rect[start];
      var margin = info.margin[flip ? start : end];
      var offsetExtent = 'offset' + extent;
      var sizingOffset = this[offsetExtent] - this.sizingTarget[offsetExtent];
      this.sizingTarget.style['max' + extent] = max - margin - offset - sizingOffset + 'px';
    },
    /**
     * Centers horizontally and vertically if not already positioned. This also
     * sets `position:fixed`.
     */
    center: function () {
      if (this.__shouldPosition) {
        return;
      }
      this._discoverInfo();
      var positionedBy = this._fitInfo.positionedBy;
      if (positionedBy.vertically && positionedBy.horizontally) {
        // Already positioned.
        return;
      }
      // Need position:fixed to center
      this.style.position = 'fixed';
      // Take into account the offset caused by parents that create stacking
      // contexts (e.g. with transform: translate3d). Translate to 0,0 and
      // measure the bounding rect.
      if (!positionedBy.vertically) {
        this.style.top = '0px';
      }
      if (!positionedBy.horizontally) {
        this.style.left = '0px';
      }
      // It will take in consideration margins and transforms
      var rect = this.getBoundingClientRect();
      var fitRect = this.__getNormalizedRect(this.fitInto);
      if (!positionedBy.vertically) {
        var top = fitRect.top - rect.top + (fitRect.height - rect.height) / 2;
        this.style.top = top + 'px';
      }
      if (!positionedBy.horizontally) {
        var left = fitRect.left - rect.left + (fitRect.width - rect.width) / 2;
        this.style.left = left + 'px';
      }
    },
    __getNormalizedRect: function (target) {
      if (target === document.documentElement || target === window) {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight,
          right: window.innerWidth,
          bottom: window.innerHeight
        };
      }
      return target.getBoundingClientRect();
    },
    __getOffscreenArea: function (position, size, fitRect) {
      var verticalCrop = Math.min(0, position.top) + Math.min(0, fitRect.bottom - (position.top + size.height));
      var horizontalCrop = Math.min(0, position.left) + Math.min(0, fitRect.right - (position.left + size.width));
      return Math.abs(verticalCrop) * size.width + Math.abs(horizontalCrop) * size.height;
    },
    __getPosition: function (hAlign, vAlign, size, sizeNoMargins, positionRect, fitRect) {
      // All the possible configurations.
      // Ordered as top-left, top-right, bottom-left, bottom-right.
      var positions = [{
        verticalAlign: 'top',
        horizontalAlign: 'left',
        top: positionRect.top + this.verticalOffset,
        left: positionRect.left + this.horizontalOffset
      }, {
        verticalAlign: 'top',
        horizontalAlign: 'right',
        top: positionRect.top + this.verticalOffset,
        left: positionRect.right - size.width - this.horizontalOffset
      }, {
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        top: positionRect.bottom - size.height - this.verticalOffset,
        left: positionRect.left + this.horizontalOffset
      }, {
        verticalAlign: 'bottom',
        horizontalAlign: 'right',
        top: positionRect.bottom - size.height - this.verticalOffset,
        left: positionRect.right - size.width - this.horizontalOffset
      }];
      if (this.noOverlap) {
        // Duplicate.
        for (var i = 0, l = positions.length; i < l; i++) {
          var copy = {};
          for (var key in positions[i]) {
            copy[key] = positions[i][key];
          }
          positions.push(copy);
        }
        // Horizontal overlap only.
        positions[0].top = positions[1].top += positionRect.height;
        positions[2].top = positions[3].top -= positionRect.height;
        // Vertical overlap only.
        positions[4].left = positions[6].left += positionRect.width;
        positions[5].left = positions[7].left -= positionRect.width;
      }

      // Consider auto as null for coding convenience.
      vAlign = vAlign === 'auto' ? null : vAlign;
      hAlign = hAlign === 'auto' ? null : hAlign;
      if (!hAlign || hAlign === 'center') {
        positions.push({
          verticalAlign: 'top',
          horizontalAlign: 'center',
          top: positionRect.top + this.verticalOffset + (this.noOverlap ? positionRect.height : 0),
          left: positionRect.left - sizeNoMargins.width / 2 + positionRect.width / 2 + this.horizontalOffset
        });
        positions.push({
          verticalAlign: 'bottom',
          horizontalAlign: 'center',
          top: positionRect.bottom - size.height - this.verticalOffset - (this.noOverlap ? positionRect.height : 0),
          left: positionRect.left - sizeNoMargins.width / 2 + positionRect.width / 2 + this.horizontalOffset
        });
      }
      if (!vAlign || vAlign === 'middle') {
        positions.push({
          verticalAlign: 'middle',
          horizontalAlign: 'left',
          top: positionRect.top - sizeNoMargins.height / 2 + positionRect.height / 2 + this.verticalOffset,
          left: positionRect.left + this.horizontalOffset + (this.noOverlap ? positionRect.width : 0)
        });
        positions.push({
          verticalAlign: 'middle',
          horizontalAlign: 'right',
          top: positionRect.top - sizeNoMargins.height / 2 + positionRect.height / 2 + this.verticalOffset,
          left: positionRect.right - size.width - this.horizontalOffset - (this.noOverlap ? positionRect.width : 0)
        });
      }
      if (vAlign === 'middle' && hAlign === 'center') {
        positions.push({
          verticalAlign: 'middle',
          horizontalAlign: 'center',
          top: positionRect.top - sizeNoMargins.height / 2 + positionRect.height / 2 + this.verticalOffset,
          left: positionRect.left - sizeNoMargins.width / 2 + positionRect.width / 2 + this.horizontalOffset
        });
      }
      var position;
      for (var i = 0; i < positions.length; i++) {
        var candidate = positions[i];
        var vAlignOk = candidate.verticalAlign === vAlign;
        var hAlignOk = candidate.horizontalAlign === hAlign;

        // If both vAlign and hAlign are defined, return exact match.
        // For dynamicAlign and noOverlap we'll have more than one candidate, so
        // we'll have to check the offscreenArea to make the best choice.
        if (!this.dynamicAlign && !this.noOverlap && vAlignOk && hAlignOk) {
          position = candidate;
          break;
        }

        // Align is ok if alignment preferences are respected. If no preferences,
        // it is considered ok.
        var alignOk = (!vAlign || vAlignOk) && (!hAlign || hAlignOk);

        // Filter out elements that don't match the alignment (if defined).
        // With dynamicAlign, we need to consider all the positions to find the
        // one that minimizes the cropped area.
        if (!this.dynamicAlign && !alignOk) {
          continue;
        }
        candidate.offscreenArea = this.__getOffscreenArea(candidate, size, fitRect);
        // If not cropped and respects the align requirements, keep it.
        // This allows to prefer positions overlapping horizontally over the
        // ones overlapping vertically.
        if (candidate.offscreenArea === 0 && alignOk) {
          position = candidate;
          break;
        }
        position = position || candidate;
        var diff = candidate.offscreenArea - position.offscreenArea;
        // Check which crops less. If it crops equally, check if at least one
        // align setting is ok.
        if (diff < 0 || diff === 0 && (vAlignOk || hAlignOk)) {
          position = candidate;
        }
      }
      return position;
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  // Contains all connected resizables that do not have a parent.
  var ORPHANS = new Set();

  /**
   * `IronResizableBehavior` is a behavior that can be used in Polymer elements to
   * coordinate the flow of resize events between "resizers" (elements that
   *control the size or hidden state of their children) and "resizables" (elements
   *that need to be notified when they are resized or un-hidden by their parents
   *in order to take action on their new measurements).
   *
   * Elements that perform measurement should add the `IronResizableBehavior`
   *behavior to their element definition and listen for the `iron-resize` event on
   *themselves. This event will be fired when they become showing after having
   *been hidden, when they are resized explicitly by another resizable, or when
   *the window has been resized.
   *
   * Note, the `iron-resize` event is non-bubbling.
   *
   * @polymerBehavior
   * @demo demo/index.html
   **/
  const IronResizableBehavior = {
    properties: {
      /**
       * The closest ancestor element that implements `IronResizableBehavior`.
       */
      _parentResizable: {
        type: Object,
        observer: '_parentResizableChanged'
      },
      /**
       * True if this element is currently notifying its descendant elements of
       * resize.
       */
      _notifyingDescendant: {
        type: Boolean,
        value: false
      }
    },
    listeners: {
      'iron-request-resize-notifications': '_onIronRequestResizeNotifications'
    },
    created: function () {
      // We don't really need property effects on these, and also we want them
      // to be created before the `_parentResizable` observer fires:
      this._interestedResizables = [];
      this._boundNotifyResize = this.notifyResize.bind(this);
      this._boundOnDescendantIronResize = this._onDescendantIronResize.bind(this);
    },
    attached: function () {
      this._requestResizeNotifications();
    },
    detached: function () {
      if (this._parentResizable) {
        this._parentResizable.stopResizeNotificationsFor(this);
      } else {
        ORPHANS.delete(this);
        window.removeEventListener('resize', this._boundNotifyResize);
      }
      this._parentResizable = null;
    },
    /**
     * Can be called to manually notify a resizable and its descendant
     * resizables of a resize change.
     */
    notifyResize: function () {
      if (!this.isAttached) {
        return;
      }
      this._interestedResizables.forEach(function (resizable) {
        if (this.resizerShouldNotify(resizable)) {
          this._notifyDescendant(resizable);
        }
      }, this);
      this._fireResize();
    },
    /**
     * Used to assign the closest resizable ancestor to this resizable
     * if the ancestor detects a request for notifications.
     */
    assignParentResizable: function (parentResizable) {
      if (this._parentResizable) {
        this._parentResizable.stopResizeNotificationsFor(this);
      }
      this._parentResizable = parentResizable;
      if (parentResizable && parentResizable._interestedResizables.indexOf(this) === -1) {
        parentResizable._interestedResizables.push(this);
        parentResizable._subscribeIronResize(this);
      }
    },
    /**
     * Used to remove a resizable descendant from the list of descendants
     * that should be notified of a resize change.
     */
    stopResizeNotificationsFor: function (target) {
      var index = this._interestedResizables.indexOf(target);
      if (index > -1) {
        this._interestedResizables.splice(index, 1);
        this._unsubscribeIronResize(target);
      }
    },
    /**
     * Subscribe this element to listen to iron-resize events on the given target.
     *
     * Preferred over target.listen because the property renamer does not
     * understand to rename when the target is not specifically "this"
     *
     * @param {!HTMLElement} target Element to listen to for iron-resize events.
     */
    _subscribeIronResize: function (target) {
      target.addEventListener('iron-resize', this._boundOnDescendantIronResize);
    },
    /**
     * Unsubscribe this element from listening to to iron-resize events on the
     * given target.
     *
     * Preferred over target.unlisten because the property renamer does not
     * understand to rename when the target is not specifically "this"
     *
     * @param {!HTMLElement} target Element to listen to for iron-resize events.
     */
    _unsubscribeIronResize: function (target) {
      target.removeEventListener('iron-resize', this._boundOnDescendantIronResize);
    },
    /**
     * This method can be overridden to filter nested elements that should or
     * should not be notified by the current element. Return true if an element
     * should be notified, or false if it should not be notified.
     *
     * @param {HTMLElement} element A candidate descendant element that
     * implements `IronResizableBehavior`.
     * @return {boolean} True if the `element` should be notified of resize.
     */
    resizerShouldNotify: function (element) {
      return true;
    },
    _onDescendantIronResize: function (event) {
      if (this._notifyingDescendant) {
        event.stopPropagation();
        return;
      }

      // no need to use this during shadow dom because of event retargeting
      if (!useShadow) {
        this._fireResize();
      }
    },
    _fireResize: function () {
      this.fire('iron-resize', null, {
        node: this,
        bubbles: false
      });
    },
    _onIronRequestResizeNotifications: function (event) {
      var target = /** @type {!EventTarget} */dom(event).rootTarget;
      if (target === this) {
        return;
      }
      target.assignParentResizable(this);
      this._notifyDescendant(target);
      event.stopPropagation();
    },
    _parentResizableChanged: function (parentResizable) {
      if (parentResizable) {
        window.removeEventListener('resize', this._boundNotifyResize);
      }
    },
    _notifyDescendant: function (descendant) {
      // NOTE(cdata): In IE10, attached is fired on children first, so it's
      // important not to notify them if the parent is not attached yet (or
      // else they will get redundantly notified when the parent attaches).
      if (!this.isAttached) {
        return;
      }
      this._notifyingDescendant = true;
      descendant.notifyResize();
      this._notifyingDescendant = false;
    },
    _requestResizeNotifications: function () {
      if (!this.isAttached) {
        return;
      }
      if (document.readyState === 'loading') {
        var _requestResizeNotifications = this._requestResizeNotifications.bind(this);
        document.addEventListener('readystatechange', function readystatechanged() {
          document.removeEventListener('readystatechange', readystatechanged);
          _requestResizeNotifications();
        });
      } else {
        this._findParent();
        if (!this._parentResizable) {
          // If this resizable is an orphan, tell other orphans to try to find
          // their parent again, in case it's this resizable.
          ORPHANS.forEach(function (orphan) {
            if (orphan !== this) {
              orphan._findParent();
            }
          }, this);
          window.addEventListener('resize', this._boundNotifyResize);
          this.notifyResize();
        } else {
          // If this resizable has a parent, tell other child resizables of
          // that parent to try finding their parent again, in case it's this
          // resizable.
          this._parentResizable._interestedResizables.forEach(function (resizable) {
            if (resizable !== this) {
              resizable._findParent();
            }
          }, this);
        }
      }
    },
    _findParent: function () {
      this.assignParentResizable(null);
      this.fire('iron-request-resize-notifications', null, {
        node: this,
        bubbles: true,
        cancelable: true
      });
      if (!this._parentResizable) {
        ORPHANS.add(this);
      } else {
        ORPHANS.delete(this);
      }
    }
  };

  var p = Element.prototype;
  var matches = p.matches || p.matchesSelector || p.mozMatchesSelector || p.msMatchesSelector || p.oMatchesSelector || p.webkitMatchesSelector;
  let IronFocusablesHelperClass = /*#__PURE__*/function () {
    function IronFocusablesHelperClass() {
      _classCallCheck(this, IronFocusablesHelperClass);
    }
    _createClass(IronFocusablesHelperClass, [{
      key: "getTabbableNodes",
      value:
      /**
       * Returns a sorted array of tabbable nodes, including the root node.
       * It searches the tabbable nodes in the light and shadow dom of the chidren,
       * sorting the result by tabindex.
       * @param {!Node} node
       * @return {!Array<!HTMLElement>}
       */
      function getTabbableNodes(node) {
        var result = [];
        // If there is at least one element with tabindex > 0, we need to sort
        // the final array by tabindex.
        var needsSortByTabIndex = this._collectTabbableNodes(node, result);
        if (needsSortByTabIndex) {
          return this._sortByTabIndex(result);
        }
        return result;
      }

      /**
       * Returns if a element is focusable.
       * @param {!HTMLElement} element
       * @return {boolean}
       */
    }, {
      key: "isFocusable",
      value: function isFocusable(element) {
        // From http://stackoverflow.com/a/1600194/4228703:
        // There isn't a definite list, it's up to the browser. The only
        // standard we have is DOM Level 2 HTML
        // https://www.w3.org/TR/DOM-Level-2-HTML/html.html, according to which the
        // only elements that have a focus() method are HTMLInputElement,
        // HTMLSelectElement, HTMLTextAreaElement and HTMLAnchorElement. This
        // notably omits HTMLButtonElement and HTMLAreaElement. Referring to these
        // tests with tabbables in different browsers
        // http://allyjs.io/data-tables/focusable.html

        // Elements that cannot be focused if they have [disabled] attribute.
        if (matches.call(element, 'input, select, textarea, button, object')) {
          return matches.call(element, ':not([disabled])');
        }
        // Elements that can be focused even if they have [disabled] attribute.
        return matches.call(element, 'a[href], area[href], iframe, [tabindex], [contentEditable]');
      }

      /**
       * Returns if a element is tabbable. To be tabbable, a element must be
       * focusable, visible, and with a tabindex !== -1.
       * @param {!HTMLElement} element
       * @return {boolean}
       */
    }, {
      key: "isTabbable",
      value: function isTabbable(element) {
        return this.isFocusable(element) && matches.call(element, ':not([tabindex="-1"])') && this._isVisible(element);
      }

      /**
       * Returns the normalized element tabindex. If not focusable, returns -1.
       * It checks for the attribute "tabindex" instead of the element property
       * `tabIndex` since browsers assign different values to it.
       * e.g. in Firefox `<div contenteditable>` has `tabIndex = -1`
       * @param {!HTMLElement} element
       * @return {!number}
       * @private
       */
    }, {
      key: "_normalizedTabIndex",
      value: function _normalizedTabIndex(element) {
        if (this.isFocusable(element)) {
          var tabIndex = element.getAttribute('tabindex') || 0;
          return Number(tabIndex);
        }
        return -1;
      }

      /**
       * Searches for nodes that are tabbable and adds them to the `result` array.
       * Returns if the `result` array needs to be sorted by tabindex.
       * @param {!Node} node The starting point for the search; added to `result`
       * if tabbable.
       * @param {!Array<!HTMLElement>} result
       * @return {boolean}
       * @private
       */
    }, {
      key: "_collectTabbableNodes",
      value: function _collectTabbableNodes(node, result) {
        // If not an element or not visible, no need to explore children.
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return false;
        }
        var element = /** @type {!HTMLElement} */node;
        if (!this._isVisible(element)) {
          return false;
        }
        var tabIndex = this._normalizedTabIndex(element);
        var needsSort = tabIndex > 0;
        if (tabIndex >= 0) {
          result.push(element);
        }
        // In ShadowDOM v1, tab order is affected by the order of distrubution.
        // E.g. getTabbableNodes(#root) in ShadowDOM v1 should return [#A, #B];
        // in ShadowDOM v0 tab order is not affected by the distrubution order,
        // in fact getTabbableNodes(#root) returns [#B, #A].
        //  <div id="root">
        //   <!-- shadow -->
        //     <slot name="a">
        //     <slot name="b">
        //   <!-- /shadow -->
        //   <input id="A" slot="a">
        //   <input id="B" slot="b" tabindex="1">
        //  </div>
        // TODO(valdrin) support ShadowDOM v1 when upgrading to Polymer v2.0.
        var children;
        if (element.localName === 'content' || element.localName === 'slot') {
          children = dom(element).getDistributedNodes();
        } else {
          // Use shadow root if possible, will check for distributed nodes.
          children = dom(element.root || element).children;
        }
        for (var i = 0; i < children.length; i++) {
          // Ensure method is always invoked to collect tabbable children.
          needsSort = this._collectTabbableNodes(children[i], result) || needsSort;
        }
        return needsSort;
      }

      /**
       * Returns false if the element has `visibility: hidden` or `display: none`
       * @param {!HTMLElement} element
       * @return {boolean}
       * @private
       */
    }, {
      key: "_isVisible",
      value: function _isVisible(element) {
        // Check inline style first to save a re-flow. If looks good, check also
        // computed style.
        var style = element.style;
        if (style.visibility !== 'hidden' && style.display !== 'none') {
          style = window.getComputedStyle(element);
          return style.visibility !== 'hidden' && style.display !== 'none';
        }
        return false;
      }

      /**
       * Sorts an array of tabbable elements by tabindex. Returns a new array.
       * @param {!Array<!HTMLElement>} tabbables
       * @return {!Array<!HTMLElement>}
       * @private
       */
    }, {
      key: "_sortByTabIndex",
      value: function _sortByTabIndex(tabbables) {
        // Implement a merge sort as Array.prototype.sort does a non-stable sort
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
        var len = tabbables.length;
        if (len < 2) {
          return tabbables;
        }
        var pivot = Math.ceil(len / 2);
        var left = this._sortByTabIndex(tabbables.slice(0, pivot));
        var right = this._sortByTabIndex(tabbables.slice(pivot));
        return this._mergeSortByTabIndex(left, right);
      }

      /**
       * Merge sort iterator, merges the two arrays into one, sorted by tab index.
       * @param {!Array<!HTMLElement>} left
       * @param {!Array<!HTMLElement>} right
       * @return {!Array<!HTMLElement>}
       * @private
       */
    }, {
      key: "_mergeSortByTabIndex",
      value: function _mergeSortByTabIndex(left, right) {
        var result = [];
        while (left.length > 0 && right.length > 0) {
          if (this._hasLowerTabOrder(left[0], right[0])) {
            result.push(right.shift());
          } else {
            result.push(left.shift());
          }
        }
        return result.concat(left, right);
      }

      /**
       * Returns if element `a` has lower tab order compared to element `b`
       * (both elements are assumed to be focusable and tabbable).
       * Elements with tabindex = 0 have lower tab order compared to elements
       * with tabindex > 0.
       * If both have same tabindex, it returns false.
       * @param {!HTMLElement} a
       * @param {!HTMLElement} b
       * @return {boolean}
       * @private
       */
    }, {
      key: "_hasLowerTabOrder",
      value: function _hasLowerTabOrder(a, b) {
        // Normalize tabIndexes
        // e.g. in Firefox `<div contenteditable>` has `tabIndex = -1`
        var ati = Math.max(a.tabIndex, 0);
        var bti = Math.max(b.tabIndex, 0);
        return ati === 0 || bti === 0 ? bti > ati : ati > bti;
      }
    }]);
    return IronFocusablesHelperClass;
  }();
  const IronFocusablesHelper = new IronFocusablesHelperClass();

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /*
  `iron-overlay-backdrop` is a backdrop used by `Polymer.IronOverlayBehavior`. It
  should be a singleton.

  ### Styling

  The following custom properties and mixins are available for styling.

  Custom property | Description | Default
  -------------------------------------------|------------------------|---------
  `--iron-overlay-backdrop-background-color` | Backdrop background color | #000
  `--iron-overlay-backdrop-opacity`          | Backdrop opacity | 0.6
  `--iron-overlay-backdrop`                  | Mixin applied to `iron-overlay-backdrop`.                      | {}
  `--iron-overlay-backdrop-opened`           | Mixin applied to `iron-overlay-backdrop` when it is displayed | {}
  */
  Polymer({
    /** @override */
    _template: html`
    <style>
      :host {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--iron-overlay-backdrop-background-color, #000);
        opacity: 0;
        transition: opacity 0.2s;
        pointer-events: none;
        @apply --iron-overlay-backdrop;
      }

      :host(.opened) {
        opacity: var(--iron-overlay-backdrop-opacity, 0.6);
        pointer-events: auto;
        @apply --iron-overlay-backdrop-opened;
      }
    </style>

    <slot></slot>
`,
    is: 'iron-overlay-backdrop',
    properties: {
      /**
       * Returns true if the backdrop is opened.
       */
      opened: {
        reflectToAttribute: true,
        type: Boolean,
        value: false,
        observer: '_openedChanged'
      }
    },
    listeners: {
      'transitionend': '_onTransitionend'
    },
    /** @override */
    created: function () {
      // Used to cancel previous requestAnimationFrame calls when opened changes.
      this.__openedRaf = null;
    },
    /** @override */
    attached: function () {
      this.opened && this._openedChanged(this.opened);
    },
    /**
     * Appends the backdrop to document body if needed.
     */
    prepare: function () {
      if (this.opened && !this.parentNode) {
        dom(document.body).appendChild(this);
      }
    },
    /**
     * Shows the backdrop.
     */
    open: function () {
      this.opened = true;
    },
    /**
     * Hides the backdrop.
     */
    close: function () {
      this.opened = false;
    },
    /**
     * Removes the backdrop from document body if needed.
     */
    complete: function () {
      if (!this.opened && this.parentNode === document.body) {
        dom(this.parentNode).removeChild(this);
      }
    },
    _onTransitionend: function (event) {
      if (event && event.target === this) {
        this.complete();
      }
    },
    /**
     * @param {boolean} opened
     * @private
     */
    _openedChanged: function (opened) {
      if (opened) {
        // Auto-attach.
        this.prepare();
      } else {
        // Animation might be disabled via the mixin or opacity custom property.
        // If it is disabled in other ways, it's up to the user to call complete.
        var cs = window.getComputedStyle(this);
        if (cs.transitionDuration === '0s' || cs.opacity == 0) {
          this.complete();
        }
      }
      if (!this.isAttached) {
        return;
      }

      // Always cancel previous requestAnimationFrame.
      if (this.__openedRaf) {
        window.cancelAnimationFrame(this.__openedRaf);
        this.__openedRaf = null;
      }
      // Force relayout to ensure proper transitions.
      this.scrollTop = this.scrollTop;
      this.__openedRaf = window.requestAnimationFrame(function () {
        this.__openedRaf = null;
        this.toggleClass('opened', this.opened);
      }.bind(this));
    }
  });

  /**
   * @package
   */
  let IronOverlayManagerClass = /*#__PURE__*/function () {
    function IronOverlayManagerClass() {
      _classCallCheck(this, IronOverlayManagerClass);
      /**
       * Used to keep track of the opened overlays.
       * @private {!Array<!Element>}
       */
      this._overlays = [];

      /**
       * iframes have a default z-index of 100,
       * so this default should be at least that.
       * @private {number}
       */
      this._minimumZ = 101;

      /**
       * Memoized backdrop element.
       * @private {Element|null}
       */
      this._backdropElement = null;

      // Enable document-wide tap recognizer.
      // NOTE: Use useCapture=true to avoid accidentally prevention of the closing
      // of an overlay via event.stopPropagation(). The only way to prevent
      // closing of an overlay should be through its APIs.
      // NOTE: enable tap on <html> to workaround Polymer/polymer#4459
      // Pass no-op function because MSEdge 15 doesn't handle null as 2nd argument
      // https://github.com/Microsoft/ChakraCore/issues/3863
      addListener(document.documentElement, 'tap', function () {});
      document.addEventListener('tap', this._onCaptureClick.bind(this), true);
      document.addEventListener('focus', this._onCaptureFocus.bind(this), true);
      document.addEventListener('keydown', this._onCaptureKeyDown.bind(this), true);
    }

    /**
     * The shared backdrop element.
     * @return {!Element} backdropElement
     */
    _createClass(IronOverlayManagerClass, [{
      key: "backdropElement",
      get: function () {
        if (!this._backdropElement) {
          this._backdropElement = document.createElement('iron-overlay-backdrop');
        }
        return this._backdropElement;
      }

      /**
       * The deepest active element.
       * @return {!Element} activeElement the active element
       */
    }, {
      key: "deepActiveElement",
      get: function () {
        var active = document.activeElement;
        // document.activeElement can be null
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/activeElement
        // In IE 11, it can also be an object when operating in iframes.
        // In these cases, default it to document.body.
        if (!active || active instanceof Element === false) {
          active = document.body;
        }
        while (active.root && dom(active.root).activeElement) {
          active = dom(active.root).activeElement;
        }
        return active;
      }

      /**
       * Brings the overlay at the specified index to the front.
       * @param {number} i
       * @private
       */
    }, {
      key: "_bringOverlayAtIndexToFront",
      value: function _bringOverlayAtIndexToFront(i) {
        var overlay = this._overlays[i];
        if (!overlay) {
          return;
        }
        var lastI = this._overlays.length - 1;
        var currentOverlay = this._overlays[lastI];
        // Ensure always-on-top overlay stays on top.
        if (currentOverlay && this._shouldBeBehindOverlay(overlay, currentOverlay)) {
          lastI--;
        }
        // If already the top element, return.
        if (i >= lastI) {
          return;
        }
        // Update z-index to be on top.
        var minimumZ = Math.max(this.currentOverlayZ(), this._minimumZ);
        if (this._getZ(overlay) <= minimumZ) {
          this._applyOverlayZ(overlay, minimumZ);
        }

        // Shift other overlays behind the new on top.
        while (i < lastI) {
          this._overlays[i] = this._overlays[i + 1];
          i++;
        }
        this._overlays[lastI] = overlay;
      }

      /**
       * Adds the overlay and updates its z-index if it's opened, or removes it if
       * it's closed. Also updates the backdrop z-index.
       * @param {!Element} overlay
       */
    }, {
      key: "addOrRemoveOverlay",
      value: function addOrRemoveOverlay(overlay) {
        if (overlay.opened) {
          this.addOverlay(overlay);
        } else {
          this.removeOverlay(overlay);
        }
      }

      /**
       * Tracks overlays for z-index and focus management.
       * Ensures the last added overlay with always-on-top remains on top.
       * @param {!Element} overlay
       */
    }, {
      key: "addOverlay",
      value: function addOverlay(overlay) {
        var i = this._overlays.indexOf(overlay);
        if (i >= 0) {
          this._bringOverlayAtIndexToFront(i);
          this.trackBackdrop();
          return;
        }
        var insertionIndex = this._overlays.length;
        var currentOverlay = this._overlays[insertionIndex - 1];
        var minimumZ = Math.max(this._getZ(currentOverlay), this._minimumZ);
        var newZ = this._getZ(overlay);

        // Ensure always-on-top overlay stays on top.
        if (currentOverlay && this._shouldBeBehindOverlay(overlay, currentOverlay)) {
          // This bumps the z-index of +2.
          this._applyOverlayZ(currentOverlay, minimumZ);
          insertionIndex--;
          // Update minimumZ to match previous overlay's z-index.
          var previousOverlay = this._overlays[insertionIndex - 1];
          minimumZ = Math.max(this._getZ(previousOverlay), this._minimumZ);
        }

        // Update z-index and insert overlay.
        if (newZ <= minimumZ) {
          this._applyOverlayZ(overlay, minimumZ);
        }
        this._overlays.splice(insertionIndex, 0, overlay);
        this.trackBackdrop();
      }

      /**
       * @param {!Element} overlay
       */
    }, {
      key: "removeOverlay",
      value: function removeOverlay(overlay) {
        var i = this._overlays.indexOf(overlay);
        if (i === -1) {
          return;
        }
        this._overlays.splice(i, 1);
        this.trackBackdrop();
      }

      /**
       * Returns the current overlay.
       * @return {!Element|undefined}
       */
    }, {
      key: "currentOverlay",
      value: function currentOverlay() {
        var i = this._overlays.length - 1;
        return this._overlays[i];
      }

      /**
       * Returns the current overlay z-index.
       * @return {number}
       */
    }, {
      key: "currentOverlayZ",
      value: function currentOverlayZ() {
        return this._getZ(this.currentOverlay());
      }

      /**
       * Ensures that the minimum z-index of new overlays is at least `minimumZ`.
       * This does not effect the z-index of any existing overlays.
       * @param {number} minimumZ
       */
    }, {
      key: "ensureMinimumZ",
      value: function ensureMinimumZ(minimumZ) {
        this._minimumZ = Math.max(this._minimumZ, minimumZ);
      }
    }, {
      key: "focusOverlay",
      value: function focusOverlay() {
        var current = /** @type {?} */this.currentOverlay();
        if (current) {
          current._applyFocus();
        }
      }

      /**
       * Updates the backdrop z-index.
       */
    }, {
      key: "trackBackdrop",
      value: function trackBackdrop() {
        var overlay = this._overlayWithBackdrop();
        // Avoid creating the backdrop if there is no overlay with backdrop.
        if (!overlay && !this._backdropElement) {
          return;
        }
        this.backdropElement.style.zIndex = this._getZ(overlay) - 1;
        this.backdropElement.opened = !!overlay;
        // Property observers are not fired until element is attached
        // in Polymer 2.x, so we ensure element is attached if needed.
        // https://github.com/Polymer/polymer/issues/4526
        this.backdropElement.prepare();
      }

      /**
       * @return {!Array<!Element>}
       */
    }, {
      key: "getBackdrops",
      value: function getBackdrops() {
        var backdrops = [];
        for (var i = 0; i < this._overlays.length; i++) {
          if (this._overlays[i].withBackdrop) {
            backdrops.push(this._overlays[i]);
          }
        }
        return backdrops;
      }

      /**
       * Returns the z-index for the backdrop.
       * @return {number}
       */
    }, {
      key: "backdropZ",
      value: function backdropZ() {
        return this._getZ(this._overlayWithBackdrop()) - 1;
      }

      /**
       * Returns the top opened overlay that has a backdrop.
       * @return {!Element|undefined}
       * @private
       */
    }, {
      key: "_overlayWithBackdrop",
      value: function _overlayWithBackdrop() {
        for (var i = this._overlays.length - 1; i >= 0; i--) {
          if (this._overlays[i].withBackdrop) {
            return this._overlays[i];
          }
        }
      }

      /**
       * Calculates the minimum z-index for the overlay.
       * @param {Element=} overlay
       * @private
       */
    }, {
      key: "_getZ",
      value: function _getZ(overlay) {
        var z = this._minimumZ;
        if (overlay) {
          var z1 = Number(overlay.style.zIndex || window.getComputedStyle(overlay).zIndex);
          // Check if is a number
          // Number.isNaN not supported in IE 10+
          if (z1 === z1) {
            z = z1;
          }
        }
        return z;
      }

      /**
       * @param {!Element} element
       * @param {number|string} z
       * @private
       */
    }, {
      key: "_setZ",
      value: function _setZ(element, z) {
        element.style.zIndex = z;
      }

      /**
       * @param {!Element} overlay
       * @param {number} aboveZ
       * @private
       */
    }, {
      key: "_applyOverlayZ",
      value: function _applyOverlayZ(overlay, aboveZ) {
        this._setZ(overlay, aboveZ + 2);
      }

      /**
       * Returns the deepest overlay in the path.
       * @param {!Array<!Element>=} path
       * @return {!Element|undefined}
       * @suppress {missingProperties}
       * @private
       */
    }, {
      key: "_overlayInPath",
      value: function _overlayInPath(path) {
        path = path || [];
        for (var i = 0; i < path.length; i++) {
          if (path[i]._manager === this) {
            return path[i];
          }
        }
      }

      /**
       * Ensures the click event is delegated to the right overlay.
       * @param {!Event} event
       * @private
       */
    }, {
      key: "_onCaptureClick",
      value: function _onCaptureClick(event) {
        var i = this._overlays.length - 1;
        if (i === -1) return;
        var path = /** @type {!Array<!EventTarget>} */dom(event).path;
        var overlay;
        // Check if clicked outside of overlay.
        while ((overlay = /** @type {?} */this._overlays[i]) && this._overlayInPath(path) !== overlay) {
          overlay._onCaptureClick(event);
          if (overlay.allowClickThrough) {
            i--;
          } else {
            break;
          }
        }
      }

      /**
       * Ensures the focus event is delegated to the right overlay.
       * @param {!Event} event
       * @private
       */
    }, {
      key: "_onCaptureFocus",
      value: function _onCaptureFocus(event) {
        var overlay = /** @type {?} */this.currentOverlay();
        if (overlay) {
          overlay._onCaptureFocus(event);
        }
      }

      /**
       * Ensures TAB and ESC keyboard events are delegated to the right overlay.
       * @param {!Event} event
       * @private
       */
    }, {
      key: "_onCaptureKeyDown",
      value: function _onCaptureKeyDown(event) {
        var overlay = /** @type {?} */this.currentOverlay();
        if (overlay) {
          if (IronA11yKeysBehavior.keyboardEventMatchesKeys(event, 'esc')) {
            overlay._onCaptureEsc(event);
          } else if (IronA11yKeysBehavior.keyboardEventMatchesKeys(event, 'tab')) {
            overlay._onCaptureTab(event);
          }
        }
      }

      /**
       * Returns if the overlay1 should be behind overlay2.
       * @param {!Element} overlay1
       * @param {!Element} overlay2
       * @return {boolean}
       * @suppress {missingProperties}
       * @private
       */
    }, {
      key: "_shouldBeBehindOverlay",
      value: function _shouldBeBehindOverlay(overlay1, overlay2) {
        return !overlay1.alwaysOnTop && overlay2.alwaysOnTop;
      }
    }]);
    return IronOverlayManagerClass;
  }();
  const IronOverlayManager = new IronOverlayManagerClass();

  /**
  @license
  Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  /**
   * Used to calculate the scroll direction during touch events.
   * @type {!Object}
   */
  var lastTouchPosition = {
    pageX: 0,
    pageY: 0
  };
  /**
   * Used to avoid computing event.path and filter scrollable nodes (better perf).
   * @type {?EventTarget}
   */
  var lastRootTarget = null;
  /**
   * @type {!Array<!Node>}
   */
  var lastScrollableNodes = [];
  /**
   * @type {!Array<string>}
   */
  var scrollEvents = [
  // Modern `wheel` event for mouse wheel scrolling:
  'wheel',
  // Older, non-standard `mousewheel` event for some FF:
  'mousewheel',
  // IE:
  'DOMMouseScroll',
  // Touch enabled devices
  'touchstart', 'touchmove'];
  // must be defined for modulizer
  var _boundScrollHandler;

  /**
   * The current element that defines the DOM boundaries of the
   * scroll lock. This is always the most recently locking element.
   *
   * @type {!Node|undefined}
   */
  var currentLockingElement;

  /**
   * Push an element onto the current scroll lock stack. The most recently
   * pushed element and its children will be considered scrollable. All
   * other elements will not be scrollable.
   *
   * Scroll locking is implemented as a stack so that cases such as
   * dropdowns within dropdowns are handled well.
   *
   * @param {!HTMLElement} element The element that should lock scroll.
   */
  function pushScrollLock(element) {
    // Prevent pushing the same element twice
    if (_lockingElements.indexOf(element) >= 0) {
      return;
    }
    if (_lockingElements.length === 0) {
      _lockScrollInteractions();
    }
    _lockingElements.push(element);
    currentLockingElement = _lockingElements[_lockingElements.length - 1];
  }

  /**
   * Remove an element from the scroll lock stack. The element being
   * removed does not need to be the most recently pushed element. However,
   * the scroll lock constraints only change when the most recently pushed
   * element is removed.
   *
   * @param {!HTMLElement} element The element to remove from the scroll
   * lock stack.
   */
  function removeScrollLock(element) {
    var index = _lockingElements.indexOf(element);
    if (index === -1) {
      return;
    }
    _lockingElements.splice(index, 1);
    currentLockingElement = _lockingElements[_lockingElements.length - 1];
    if (_lockingElements.length === 0) {
      _unlockScrollInteractions();
    }
  }
  const _lockingElements = [];
  function _scrollInteractionHandler(event) {
    // Avoid canceling an event with cancelable=false, e.g. scrolling is in
    // progress and cannot be interrupted.
    if (event.cancelable && _shouldPreventScrolling(event)) {
      event.preventDefault();
    }
    // If event has targetTouches (touch event), update last touch position.
    if (event.targetTouches) {
      var touch = event.targetTouches[0];
      lastTouchPosition.pageX = touch.pageX;
      lastTouchPosition.pageY = touch.pageY;
    }
  }
  function _lockScrollInteractions() {
    _boundScrollHandler = _boundScrollHandler || _scrollInteractionHandler.bind(undefined);
    for (var i = 0, l = scrollEvents.length; i < l; i++) {
      // NOTE: browsers that don't support objects as third arg will
      // interpret it as boolean, hence useCapture = true in this case.
      document.addEventListener(scrollEvents[i], _boundScrollHandler, {
        capture: true,
        passive: false
      });
    }
  }
  function _unlockScrollInteractions() {
    for (var i = 0, l = scrollEvents.length; i < l; i++) {
      // NOTE: browsers that don't support objects as third arg will
      // interpret it as boolean, hence useCapture = true in this case.
      document.removeEventListener(scrollEvents[i], _boundScrollHandler, {
        capture: true,
        passive: false
      });
    }
  }

  /**
   * Returns true if the event causes scroll outside the current locking
   * element, e.g. pointer/keyboard interactions, or scroll "leaking"
   * outside the locking element when it is already at its scroll boundaries.
   * @param {!Event} event
   * @return {boolean}
   * @package
   */
  function _shouldPreventScrolling(event) {
    // Update if root target changed. For touch events, ensure we don't
    // update during touchmove.
    var target = dom(event).rootTarget;
    if (event.type !== 'touchmove' && lastRootTarget !== target) {
      lastRootTarget = target;
      lastScrollableNodes = _getScrollableNodes(dom(event).path);
    }

    // Prevent event if no scrollable nodes.
    if (!lastScrollableNodes.length) {
      return true;
    }
    // Don't prevent touchstart event inside the locking element when it has
    // scrollable nodes.
    if (event.type === 'touchstart') {
      return false;
    }
    // Get deltaX/Y.
    var info = _getScrollInfo(event);
    // Prevent if there is no child that can scroll.
    return !_getScrollingNode(lastScrollableNodes, info.deltaX, info.deltaY);
  }

  /**
   * Returns an array of scrollable nodes up to the current locking element,
   * which is included too if scrollable.
   * @param {!Array<!Node>} nodes
   * @return {!Array<!Node>} scrollables
   * @package
   */
  function _getScrollableNodes(nodes) {
    var scrollables = [];
    var lockingIndex = nodes.indexOf( /** @type {!Node} */currentLockingElement);
    // Loop from root target to locking element (included).
    for (var i = 0; i <= lockingIndex; i++) {
      // Skip non-Element nodes.
      if (nodes[i].nodeType !== Node.ELEMENT_NODE) {
        continue;
      }
      var node = /** @type {!Element} */nodes[i];
      // Check inline style before checking computed style.
      var style = node.style;
      if (style.overflow !== 'scroll' && style.overflow !== 'auto') {
        style = window.getComputedStyle(node);
      }
      if (style.overflow === 'scroll' || style.overflow === 'auto') {
        scrollables.push(node);
      }
    }
    return scrollables;
  }

  /**
   * Returns the node that is scrolling. If there is no scrolling,
   * returns undefined.
   * @param {!Array<!Node>} nodes
   * @param {number} deltaX Scroll delta on the x-axis
   * @param {number} deltaY Scroll delta on the y-axis
   * @return {!Node|undefined}
   * @package
   */
  function _getScrollingNode(nodes, deltaX, deltaY) {
    // No scroll.
    if (!deltaX && !deltaY) {
      return;
    }
    // Check only one axis according to where there is more scroll.
    // Prefer vertical to horizontal.
    var verticalScroll = Math.abs(deltaY) >= Math.abs(deltaX);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var canScroll = false;
      if (verticalScroll) {
        // delta < 0 is scroll up, delta > 0 is scroll down.
        canScroll = deltaY < 0 ? node.scrollTop > 0 : node.scrollTop < node.scrollHeight - node.clientHeight;
      } else {
        // delta < 0 is scroll left, delta > 0 is scroll right.
        canScroll = deltaX < 0 ? node.scrollLeft > 0 : node.scrollLeft < node.scrollWidth - node.clientWidth;
      }
      if (canScroll) {
        return node;
      }
    }
  }

  /**
   * Returns scroll `deltaX` and `deltaY`.
   * @param {!Event} event The scroll event
   * @return {{deltaX: number, deltaY: number}} Object containing the
   * x-axis scroll delta (positive: scroll right, negative: scroll left,
   * 0: no scroll), and the y-axis scroll delta (positive: scroll down,
   * negative: scroll up, 0: no scroll).
   * @package
   */
  function _getScrollInfo(event) {
    var info = {
      deltaX: event.deltaX,
      deltaY: event.deltaY
    };
    // Already available.
    if ('deltaX' in event) ;
    // Safari has scroll info in `wheelDeltaX/Y`.
    else if ('wheelDeltaX' in event && 'wheelDeltaY' in event) {
      info.deltaX = -event.wheelDeltaX;
      info.deltaY = -event.wheelDeltaY;
    }
    // IE10 has only vertical scroll info in `wheelDelta`.
    else if ('wheelDelta' in event) {
      info.deltaX = 0;
      info.deltaY = -event.wheelDelta;
    }
    // Firefox has scroll info in `detail` and `axis`.
    else if ('axis' in event) {
      info.deltaX = event.axis === 1 ? event.detail : 0;
      info.deltaY = event.axis === 2 ? event.detail : 0;
    }
    // On mobile devices, calculate scroll direction.
    else if (event.targetTouches) {
      var touch = event.targetTouches[0];
      // Touch moves from right to left => scrolling goes right.
      info.deltaX = lastTouchPosition.pageX - touch.pageX;
      // Touch moves from down to up => scrolling goes down.
      info.deltaY = lastTouchPosition.pageY - touch.pageY;
    }
    return info;
  }

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /** @polymerBehavior */
  const IronOverlayBehaviorImpl = {
    properties: {
      /**
       * True if the overlay is currently displayed.
       */
      opened: {
        observer: '_openedChanged',
        type: Boolean,
        value: false,
        notify: true
      },
      /**
       * True if the overlay was canceled when it was last closed.
       */
      canceled: {
        observer: '_canceledChanged',
        readOnly: true,
        type: Boolean,
        value: false
      },
      /**
       * Set to true to display a backdrop behind the overlay. It traps the focus
       * within the light DOM of the overlay.
       */
      withBackdrop: {
        observer: '_withBackdropChanged',
        type: Boolean
      },
      /**
       * Set to true to disable auto-focusing the overlay or child nodes with
       * the `autofocus` attribute` when the overlay is opened.
       */
      noAutoFocus: {
        type: Boolean,
        value: false
      },
      /**
       * Set to true to disable canceling the overlay with the ESC key.
       */
      noCancelOnEscKey: {
        type: Boolean,
        value: false
      },
      /**
       * Set to true to disable canceling the overlay by clicking outside it.
       */
      noCancelOnOutsideClick: {
        type: Boolean,
        value: false
      },
      /**
       * Contains the reason(s) this overlay was last closed (see
       * `iron-overlay-closed`). `IronOverlayBehavior` provides the `canceled`
       * reason; implementers of the behavior can provide other reasons in
       * addition to `canceled`.
       */
      closingReason: {
        // was a getter before, but needs to be a property so other
        // behaviors can override this.
        type: Object
      },
      /**
       * Set to true to enable restoring of focus when overlay is closed.
       */
      restoreFocusOnClose: {
        type: Boolean,
        value: false
      },
      /**
       * Set to true to allow clicks to go through overlays.
       * When the user clicks outside this overlay, the click may
       * close the overlay below.
       */
      allowClickThrough: {
        type: Boolean
      },
      /**
       * Set to true to keep overlay always on top.
       */
      alwaysOnTop: {
        type: Boolean
      },
      /**
       * Determines which action to perform when scroll outside an opened overlay
       * happens. Possible values: lock - blocks scrolling from happening, refit -
       * computes the new position on the overlay cancel - causes the overlay to
       * close
       */
      scrollAction: {
        type: String
      },
      /**
       * Shortcut to access to the overlay manager.
       * @private
       * @type {!IronOverlayManagerClass}
       */
      _manager: {
        type: Object,
        value: IronOverlayManager
      },
      /**
       * The node being focused.
       * @type {?Node}
       */
      _focusedChild: {
        type: Object
      }
    },
    listeners: {
      'iron-resize': '_onIronResize'
    },
    observers: ['__updateScrollObservers(isAttached, opened, scrollAction)'],
    /**
     * The backdrop element.
     * @return {!Element}
     */
    get backdropElement() {
      return this._manager.backdropElement;
    },
    /**
     * Returns the node to give focus to.
     * @return {!Node}
     */
    get _focusNode() {
      return this._focusedChild || dom(this).querySelector('[autofocus]') || this;
    },
    /**
     * Array of nodes that can receive focus (overlay included), ordered by
     * `tabindex`. This is used to retrieve which is the first and last focusable
     * nodes in order to wrap the focus for overlays `with-backdrop`.
     *
     * If you know what is your content (specifically the first and last focusable
     * children), you can override this method to return only `[firstFocusable,
     * lastFocusable];`
     * @return {!Array<!Node>}
     * @protected
     */
    get _focusableNodes() {
      return IronFocusablesHelper.getTabbableNodes(this);
    },
    /**
     * @return {void}
     */
    ready: function () {
      // Used to skip calls to notifyResize and refit while the overlay is
      // animating.
      this.__isAnimating = false;
      // with-backdrop needs tabindex to be set in order to trap the focus.
      // If it is not set, IronOverlayBehavior will set it, and remove it if
      // with-backdrop = false.
      this.__shouldRemoveTabIndex = false;
      // Used for wrapping the focus on TAB / Shift+TAB.
      this.__firstFocusableNode = this.__lastFocusableNode = null;
      // Used by to keep track of the RAF callbacks.
      this.__rafs = {};
      // Focused node before overlay gets opened. Can be restored on close.
      this.__restoreFocusNode = null;
      // Scroll info to be restored.
      this.__scrollTop = this.__scrollLeft = null;
      this.__onCaptureScroll = this.__onCaptureScroll.bind(this);
      // Root nodes hosting the overlay, used to listen for scroll events on them.
      this.__rootNodes = null;
      this._ensureSetup();
    },
    /** @override */
    attached: function () {
      // Call _openedChanged here so that position can be computed correctly.
      if (this.opened) {
        this._openedChanged(this.opened);
      }
      this._observer = dom(this).observeNodes(this._onNodesChange);
    },
    /** @override */
    detached: function () {
      // TODO(bicknellr): Per spec, checking `this._observer` should never be
      // necessary because `connectedCallback` and `disconnectedCallback` should
      // always be called in alternating order. However, the custom elements
      // polyfill doesn't implement the reactions stack, so this can sometimes
      // happen, particularly if ShadyDOM is in noPatch mode where the custom
      // elements polyfill is installed before ShadyDOM. We should investigate
      // whether or not we can either implement the reactions stack without major
      // performance implications or patch ShadyDOM's functions to restore the
      // typical ShadyDOM-then-custom-elements order and remove this workaround.
      if (this._observer) {
        dom(this).unobserveNodes(this._observer);
      }
      this._observer = null;
      for (var cb in this.__rafs) {
        if (this.__rafs[cb] !== null) {
          cancelAnimationFrame(this.__rafs[cb]);
        }
      }
      this.__rafs = {};
      this._manager.removeOverlay(this);

      // We got detached while animating, ensure we show/hide the overlay
      // and fire iron-overlay-opened/closed event!
      if (this.__isAnimating) {
        if (this.opened) {
          this._finishRenderOpened();
        } else {
          // Restore the focus if necessary.
          this._applyFocus();
          this._finishRenderClosed();
        }
      }
    },
    /**
     * Toggle the opened state of the overlay.
     */
    toggle: function () {
      this._setCanceled(false);
      this.opened = !this.opened;
    },
    /**
     * Open the overlay.
     */
    open: function () {
      this._setCanceled(false);
      this.opened = true;
    },
    /**
     * Close the overlay.
     */
    close: function () {
      this._setCanceled(false);
      this.opened = false;
    },
    /**
     * Cancels the overlay.
     * @param {Event=} event The original event
     */
    cancel: function (event) {
      var cancelEvent = this.fire('iron-overlay-canceled', event, {
        cancelable: true
      });
      if (cancelEvent.defaultPrevented) {
        return;
      }
      this._setCanceled(true);
      this.opened = false;
    },
    /**
     * Invalidates the cached tabbable nodes. To be called when any of the
     * focusable content changes (e.g. a button is disabled).
     */
    invalidateTabbables: function () {
      this.__firstFocusableNode = this.__lastFocusableNode = null;
    },
    _ensureSetup: function () {
      if (this._overlaySetup) {
        return;
      }
      this._overlaySetup = true;
      this.style.outline = 'none';
      this.style.display = 'none';
    },
    /**
     * Called when `opened` changes.
     * @param {boolean=} opened
     * @protected
     */
    _openedChanged: function (opened) {
      if (opened) {
        this.removeAttribute('aria-hidden');
      } else {
        this.setAttribute('aria-hidden', 'true');
      }

      // Defer any animation-related code on attached
      // (_openedChanged gets called again on attached).
      if (!this.isAttached) {
        return;
      }
      this.__isAnimating = true;

      // Deraf for non-blocking rendering.
      this.__deraf('__openedChanged', this.__openedChanged);
    },
    _canceledChanged: function () {
      this.closingReason = this.closingReason || {};
      this.closingReason.canceled = this.canceled;
    },
    _withBackdropChanged: function () {
      // If tabindex is already set, no need to override it.
      if (this.withBackdrop && !this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '-1');
        this.__shouldRemoveTabIndex = true;
      } else if (this.__shouldRemoveTabIndex) {
        this.removeAttribute('tabindex');
        this.__shouldRemoveTabIndex = false;
      }
      if (this.opened && this.isAttached) {
        this._manager.trackBackdrop();
      }
    },
    /**
     * tasks which must occur before opening; e.g. making the element visible.
     * @protected
     */
    _prepareRenderOpened: function () {
      // Store focused node.
      this.__restoreFocusNode = this._manager.deepActiveElement;

      // Needed to calculate the size of the overlay so that transitions on its
      // size will have the correct starting points.
      this._preparePositioning();
      this.refit();
      this._finishPositioning();

      // Safari will apply the focus to the autofocus element when displayed
      // for the first time, so we make sure to return the focus where it was.
      if (this.noAutoFocus && document.activeElement === this._focusNode) {
        this._focusNode.blur();
        this.__restoreFocusNode.focus();
      }
    },
    /**
     * Tasks which cause the overlay to actually open; typically play an
     * animation.
     * @protected
     */
    _renderOpened: function () {
      this._finishRenderOpened();
    },
    /**
     * Tasks which cause the overlay to actually close; typically play an
     * animation.
     * @protected
     */
    _renderClosed: function () {
      this._finishRenderClosed();
    },
    /**
     * Tasks to be performed at the end of open action. Will fire
     * `iron-overlay-opened`.
     * @protected
     */
    _finishRenderOpened: function () {
      this.notifyResize();
      this.__isAnimating = false;
      this.fire('iron-overlay-opened');
    },
    /**
     * Tasks to be performed at the end of close action. Will fire
     * `iron-overlay-closed`.
     * @protected
     */
    _finishRenderClosed: function () {
      // Hide the overlay.
      this.style.display = 'none';
      // Reset z-index only at the end of the animation.
      this.style.zIndex = '';
      this.notifyResize();
      this.__isAnimating = false;
      this.fire('iron-overlay-closed', this.closingReason);
    },
    _preparePositioning: function () {
      this.style.transition = this.style.webkitTransition = 'none';
      this.style.transform = this.style.webkitTransform = 'none';
      this.style.display = '';
    },
    _finishPositioning: function () {
      // First, make it invisible & reactivate animations.
      this.style.display = 'none';
      // Force reflow before re-enabling animations so that they don't start.
      // Set scrollTop to itself so that Closure Compiler doesn't remove this.
      this.scrollTop = this.scrollTop;
      this.style.transition = this.style.webkitTransition = '';
      this.style.transform = this.style.webkitTransform = '';
      // Now that animations are enabled, make it visible again
      this.style.display = '';
      // Force reflow, so that following animations are properly started.
      // Set scrollTop to itself so that Closure Compiler doesn't remove this.
      this.scrollTop = this.scrollTop;
    },
    /**
     * Applies focus according to the opened state.
     * @protected
     */
    _applyFocus: function () {
      if (this.opened) {
        if (!this.noAutoFocus) {
          this._focusNode.focus();
        }
      } else {
        // Restore focus.
        if (this.restoreFocusOnClose && this.__restoreFocusNode) {
          // If the activeElement is `<body>` or inside the overlay,
          // we are allowed to restore the focus. In all the other
          // cases focus might have been moved elsewhere by another
          // component or by an user interaction (e.g. click on a
          // button outside the overlay).
          var activeElement = this._manager.deepActiveElement;
          if (activeElement === document.body || composedContains(this, activeElement)) {
            this.__restoreFocusNode.focus();
          }
        }
        this.__restoreFocusNode = null;
        this._focusNode.blur();
        this._focusedChild = null;
      }
    },
    /**
     * Cancels (closes) the overlay. Call when click happens outside the overlay.
     * @param {!Event} event
     * @protected
     */
    _onCaptureClick: function (event) {
      if (!this.noCancelOnOutsideClick) {
        this.cancel(event);
      }
    },
    /**
     * Keeps track of the focused child. If withBackdrop, traps focus within
     * overlay.
     * @param {!Event} event
     * @protected
     */
    _onCaptureFocus: function (event) {
      if (!this.withBackdrop) {
        return;
      }
      var path = dom(event).path;
      if (path.indexOf(this) === -1) {
        event.stopPropagation();
        this._applyFocus();
      } else {
        this._focusedChild = /** @type {Node} */path[0];
      }
    },
    /**
     * Handles the ESC key event and cancels (closes) the overlay.
     * @param {!Event} event
     * @protected
     */
    _onCaptureEsc: function (event) {
      if (!this.noCancelOnEscKey) {
        this.cancel(event);
      }
    },
    /**
     * Handles TAB key events to track focus changes.
     * Will wrap focus for overlays withBackdrop.
     * @param {!Event} event
     * @protected
     */
    _onCaptureTab: function (event) {
      if (!this.withBackdrop) {
        return;
      }
      this.__ensureFirstLastFocusables();
      // TAB wraps from last to first focusable.
      // Shift + TAB wraps from first to last focusable.
      var shift = event.shiftKey;
      var nodeToCheck = shift ? this.__firstFocusableNode : this.__lastFocusableNode;
      var nodeToSet = shift ? this.__lastFocusableNode : this.__firstFocusableNode;
      var shouldWrap = false;
      if (nodeToCheck === nodeToSet) {
        // If nodeToCheck is the same as nodeToSet, it means we have an overlay
        // with 0 or 1 focusables; in either case we still need to trap the
        // focus within the overlay.
        shouldWrap = true;
      } else {
        // In dom=shadow, the manager will receive focus changes on the main
        // root but not the ones within other shadow roots, so we can't rely on
        // _focusedChild, but we should check the deepest active element.
        var focusedNode = this._manager.deepActiveElement;
        // If the active element is not the nodeToCheck but the overlay itself,
        // it means the focus is about to go outside the overlay, hence we
        // should prevent that (e.g. user opens the overlay and hit Shift+TAB).
        shouldWrap = focusedNode === nodeToCheck || focusedNode === this;
      }
      if (shouldWrap) {
        // When the overlay contains the last focusable element of the document
        // and it's already focused, pressing TAB would move the focus outside
        // the document (e.g. to the browser search bar). Similarly, when the
        // overlay contains the first focusable element of the document and it's
        // already focused, pressing Shift+TAB would move the focus outside the
        // document (e.g. to the browser search bar).
        // In both cases, we would not receive a focus event, but only a blur.
        // In order to achieve focus wrapping, we prevent this TAB event and
        // force the focus. This will also prevent the focus to temporarily move
        // outside the overlay, which might cause scrolling.
        event.preventDefault();
        this._focusedChild = nodeToSet;
        this._applyFocus();
      }
    },
    /**
     * Refits if the overlay is opened and not animating.
     * @protected
     */
    _onIronResize: function () {
      if (this.opened && !this.__isAnimating) {
        this.__deraf('refit', this.refit);
      }
    },
    /**
     * Will call notifyResize if overlay is opened.
     * Can be overridden in order to avoid multiple observers on the same node.
     * @protected
     */
    _onNodesChange: function () {
      if (this.opened && !this.__isAnimating) {
        // It might have added focusable nodes, so invalidate cached values.
        this.invalidateTabbables();
        this.notifyResize();
      }
    },
    /**
     * Updates the references to the first and last focusable nodes.
     * @private
     */
    __ensureFirstLastFocusables: function () {
      var focusableNodes = this._focusableNodes;
      this.__firstFocusableNode = focusableNodes[0];
      this.__lastFocusableNode = focusableNodes[focusableNodes.length - 1];
    },
    /**
     * Tasks executed when opened changes: prepare for the opening, move the
     * focus, update the manager, render opened/closed.
     * @private
     */
    __openedChanged: function () {
      if (this.opened) {
        // Make overlay visible, then add it to the manager.
        this._prepareRenderOpened();
        this._manager.addOverlay(this);
        // Move the focus to the child node with [autofocus].
        this._applyFocus();
        this._renderOpened();
      } else {
        // Remove overlay, then restore the focus before actually closing.
        this._manager.removeOverlay(this);
        this._applyFocus();
        this._renderClosed();
      }
    },
    /**
     * Debounces the execution of a callback to the next animation frame.
     * @param {!string} jobname
     * @param {!Function} callback Always bound to `this`
     * @private
     */
    __deraf: function (jobname, callback) {
      var rafs = this.__rafs;
      if (rafs[jobname] !== null) {
        cancelAnimationFrame(rafs[jobname]);
      }
      rafs[jobname] = requestAnimationFrame(function nextAnimationFrame() {
        rafs[jobname] = null;
        callback.call(this);
      }.bind(this));
    },
    /**
     * @param {boolean} isAttached
     * @param {boolean} opened
     * @param {string=} scrollAction
     * @private
     */
    __updateScrollObservers: function (isAttached, opened, scrollAction) {
      if (!isAttached || !opened || !this.__isValidScrollAction(scrollAction)) {
        removeScrollLock(this);
        this.__removeScrollListeners();
      } else {
        if (scrollAction === 'lock') {
          this.__saveScrollPosition();
          pushScrollLock(this);
        }
        this.__addScrollListeners();
      }
    },
    /**
     * @private
     */
    __addScrollListeners: function () {
      if (!this.__rootNodes) {
        this.__rootNodes = [];
        // Listen for scroll events in all shadowRoots hosting this overlay only
        // when in native ShadowDOM.
        if (useShadow) {
          var node = this;
          while (node) {
            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && node.host) {
              this.__rootNodes.push(node);
            }
            node = node.host || node.assignedSlot || node.parentNode;
          }
        }
        this.__rootNodes.push(document);
      }
      this.__rootNodes.forEach(function (el) {
        el.addEventListener('scroll', this.__onCaptureScroll, {
          capture: true,
          passive: true
        });
      }, this);
    },
    /**
     * @private
     */
    __removeScrollListeners: function () {
      if (this.__rootNodes) {
        this.__rootNodes.forEach(function (el) {
          el.removeEventListener('scroll', this.__onCaptureScroll, {
            capture: true,
            passive: true
          });
        }, this);
      }
      if (!this.isAttached) {
        this.__rootNodes = null;
      }
    },
    /**
     * @param {string=} scrollAction
     * @return {boolean}
     * @private
     */
    __isValidScrollAction: function (scrollAction) {
      return scrollAction === 'lock' || scrollAction === 'refit' || scrollAction === 'cancel';
    },
    /**
     * @private
     */
    __onCaptureScroll: function (event) {
      if (this.__isAnimating) {
        return;
      }
      // Check if scroll outside the overlay.
      if (dom(event).path.indexOf(this) >= 0) {
        return;
      }
      switch (this.scrollAction) {
        case 'lock':
          // NOTE: scrolling might happen if a scroll event is not cancellable, or
          // if user pressed keys that cause scrolling (they're not prevented in
          // order not to break a11y features like navigate with arrow keys).
          this.__restoreScrollPosition();
          break;
        case 'refit':
          this.__deraf('refit', this.refit);
          break;
        case 'cancel':
          this.cancel(event);
          break;
      }
    },
    /**
     * Memoizes the scroll position of the outside scrolling element.
     * @private
     */
    __saveScrollPosition: function () {
      if (document.scrollingElement) {
        this.__scrollTop = document.scrollingElement.scrollTop;
        this.__scrollLeft = document.scrollingElement.scrollLeft;
      } else {
        // Since we don't know if is the body or html, get max.
        this.__scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
        this.__scrollLeft = Math.max(document.documentElement.scrollLeft, document.body.scrollLeft);
      }
    },
    /**
     * Resets the scroll position of the outside scrolling element.
     * @private
     */
    __restoreScrollPosition: function () {
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = this.__scrollTop;
        document.scrollingElement.scrollLeft = this.__scrollLeft;
      } else {
        // Since we don't know if is the body or html, set both.
        document.documentElement.scrollTop = document.body.scrollTop = this.__scrollTop;
        document.documentElement.scrollLeft = document.body.scrollLeft = this.__scrollLeft;
      }
    }
  };
  const composedParent = node => node.assignedSlot || node.parentNode || node.host;
  const composedContains = (ancestor, descendant) => {
    for (let element = descendant; element; element = composedParent(element)) {
      if (element === ancestor) {
        return true;
      }
    }
    return false;
  };

  /**
    Use `Polymer.IronOverlayBehavior` to implement an element that can be hidden
    or shown, and displays on top of other content. It includes an optional
    backdrop, and can be used to implement a variety of UI controls including
    dialogs and drop downs. Multiple overlays may be displayed at once.

    See the [demo source
    code](https://github.com/PolymerElements/iron-overlay-behavior/blob/master/demo/simple-overlay.html)
    for an example.

    ### Closing and canceling

    An overlay may be hidden by closing or canceling. The difference between close
    and cancel is user intent. Closing generally implies that the user
    acknowledged the content on the overlay. By default, it will cancel whenever
    the user taps outside it or presses the escape key. This behavior is
    configurable with the `no-cancel-on-esc-key` and the
    `no-cancel-on-outside-click` properties. `close()` should be called explicitly
    by the implementer when the user interacts with a control in the overlay
    element. When the dialog is canceled, the overlay fires an
    'iron-overlay-canceled' event. Call `preventDefault` on this event to prevent
    the overlay from closing.

    ### Positioning

    By default the element is sized and positioned to fit and centered inside the
    window. You can position and size it manually using CSS. See
    `Polymer.IronFitBehavior`.

    ### Backdrop

    Set the `with-backdrop` attribute to display a backdrop behind the overlay.
    The backdrop is appended to `<body>` and is of type `<iron-overlay-backdrop>`.
    See its doc page for styling options.

    In addition, `with-backdrop` will wrap the focus within the content in the
    light DOM. Override the [`_focusableNodes`
    getter](#Polymer.IronOverlayBehavior:property-_focusableNodes) to achieve a
    different behavior.

    ### Limitations

    The element is styled to appear on top of other content by setting its
    `z-index` property. You must ensure no element has a stacking context with a
    higher `z-index` than its parent stacking context. You should place this
    element as a child of `<body>` whenever possible.

    @demo demo/index.html
    @polymerBehavior
   */
  const IronOverlayBehavior = [IronFitBehavior, IronResizableBehavior, IronOverlayBehaviorImpl];

  /**
   * Fired after the overlay opens.
   * @event iron-overlay-opened
   */

  /**
   * Fired when the overlay is canceled, but before it is closed.
   * @event iron-overlay-canceled
   * @param {Event} event The closing of the overlay can be prevented
   * by calling `event.preventDefault()`. The `event.detail` is the original event
   * that originated the canceling (e.g. ESC keyboard event or click event outside
   * the overlay).
   */

  /**
   * Fired after the overlay closes.
   * @event iron-overlay-closed
   * @param {Event} event The `event.detail` is the `closingReason` property
   * (contains `canceled`, whether the overlay was canceled).
   */

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
    Use `Polymer.PaperDialogBehavior` and `paper-dialog-shared-styles.html` to
    implement a Material Design dialog.

    For example, if `<paper-dialog-impl>` implements this behavior:

        <paper-dialog-impl>
            <h2>Header</h2>
            <div>Dialog body</div>
            <div class="buttons">
                <paper-button dialog-dismiss>Cancel</paper-button>
                <paper-button dialog-confirm>Accept</paper-button>
            </div>
        </paper-dialog-impl>

    `paper-dialog-shared-styles.html` provide styles for a header, content area,
    and an action area for buttons. Use the `<h2>` tag for the header and the
    `buttons` class for the action area. You can use the `paper-dialog-scrollable`
    element (in its own repository) if you need a scrolling content area.

    Use the `dialog-dismiss` and `dialog-confirm` attributes on interactive
    controls to close the dialog. If the user dismisses the dialog with
    `dialog-confirm`, the `closingReason` will update to include `confirmed:
    true`.

    ### Accessibility

    This element has `role="dialog"` by default. Depending on the context, it may
    be more appropriate to override this attribute with `role="alertdialog"`.

    If `modal` is set, the element will prevent the focus from exiting the
    element. It will also ensure that focus remains in the dialog.

    @hero hero.svg
    @demo demo/index.html
    @polymerBehavior PaperDialogBehavior
   */
  const PaperDialogBehaviorImpl = {
    hostAttributes: {
      'role': 'dialog',
      'tabindex': '-1'
    },
    properties: {
      /**
       * If `modal` is true, this implies `no-cancel-on-outside-click`,
       * `no-cancel-on-esc-key` and `with-backdrop`.
       */
      modal: {
        type: Boolean,
        value: false
      },
      __readied: {
        type: Boolean,
        value: false
      }
    },
    observers: ['_modalChanged(modal, __readied)'],
    listeners: {
      'tap': '_onDialogClick'
    },
    /**
     * @return {void}
     */
    ready: function () {
      // Only now these properties can be read.
      this.__prevNoCancelOnOutsideClick = this.noCancelOnOutsideClick;
      this.__prevNoCancelOnEscKey = this.noCancelOnEscKey;
      this.__prevWithBackdrop = this.withBackdrop;
      this.__readied = true;
    },
    _modalChanged: function (modal, readied) {
      // modal implies noCancelOnOutsideClick, noCancelOnEscKey and withBackdrop.
      // We need to wait for the element to be ready before we can read the
      // properties values.
      if (!readied) {
        return;
      }
      if (modal) {
        this.__prevNoCancelOnOutsideClick = this.noCancelOnOutsideClick;
        this.__prevNoCancelOnEscKey = this.noCancelOnEscKey;
        this.__prevWithBackdrop = this.withBackdrop;
        this.noCancelOnOutsideClick = true;
        this.noCancelOnEscKey = true;
        this.withBackdrop = true;
      } else {
        // If the value was changed to false, let it false.
        this.noCancelOnOutsideClick = this.noCancelOnOutsideClick && this.__prevNoCancelOnOutsideClick;
        this.noCancelOnEscKey = this.noCancelOnEscKey && this.__prevNoCancelOnEscKey;
        this.withBackdrop = this.withBackdrop && this.__prevWithBackdrop;
      }
    },
    _updateClosingReasonConfirmed: function (confirmed) {
      this.closingReason = this.closingReason || {};
      this.closingReason.confirmed = confirmed;
    },
    /**
     * Will dismiss the dialog if user clicked on an element with dialog-dismiss
     * or dialog-confirm attribute.
     */
    _onDialogClick: function (event) {
      // Search for the element with dialog-confirm or dialog-dismiss,
      // from the root target until this (excluded).
      var path = dom(event).path;
      for (var i = 0, l = path.indexOf(this); i < l; i++) {
        var target = path[i];
        if (target.hasAttribute && (target.hasAttribute('dialog-dismiss') || target.hasAttribute('dialog-confirm'))) {
          this._updateClosingReasonConfirmed(target.hasAttribute('dialog-confirm'));
          this.close();
          event.stopPropagation();
          break;
        }
      }
    }
  };

  /** @polymerBehavior */
  const PaperDialogBehavior = [IronOverlayBehavior, PaperDialogBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  Material design:
  [Dialogs](https://www.google.com/design/spec/components/dialogs.html)

  `<paper-dialog>` is a dialog with Material Design styling and optional
  animations when it is opened or closed. It provides styles for a header, content
  area, and an action area for buttons. You can use the
  `<paper-dialog-scrollable>` element (in its own repository) if you need a
  scrolling content area. To autofocus a specific child element after opening the
  dialog, give it the `autofocus` attribute. See `Polymer.PaperDialogBehavior` and
  `Polymer.IronOverlayBehavior` for specifics.

  For example, the following code implements a dialog with a header, scrolling
  content area and buttons. Focus will be given to the `dialog-confirm` button
  when the dialog is opened.

      <paper-dialog>
        <h2>Header</h2>
        <paper-dialog-scrollable>
          Lorem ipsum...
        </paper-dialog-scrollable>
        <div class="buttons">
          <paper-button dialog-dismiss>Cancel</paper-button>
          <paper-button dialog-confirm autofocus>Accept</paper-button>
        </div>
      </paper-dialog>

  ### Styling

  See the docs for `Polymer.PaperDialogBehavior` for the custom properties
  available for styling this element.

  ### Animations

  Set the `entry-animation` and/or `exit-animation` attributes to add an animation
  when the dialog is opened or closed. See the documentation in
  [PolymerElements/neon-animation](https://github.com/PolymerElements/neon-animation)
  for more info.

  For example:

      <script type="module">
        import '@polymer/neon-animation/animations/fade-out-animation.js';
        import '@polymer/neon-animation/animations/scale-up-animation.js';
      </script>

      <paper-dialog entry-animation="scale-up-animation"
                    exit-animation="fade-out-animation">
        <h2>Header</h2>
        <div>Dialog body</div>
      </paper-dialog>

  ### Accessibility

  See the docs for `Polymer.PaperDialogBehavior` for accessibility features
  implemented by this element.

  @group Paper Elements
  @element paper-dialog
  @hero hero.svg
  @demo demo/index.html
  */
  Polymer({
    _template: html`
    <style include="paper-dialog-shared-styles"></style>
    <slot></slot>
`,
    is: 'paper-dialog',
    behaviors: [PaperDialogBehavior, NeonAnimationRunnerBehavior],
    listeners: {
      'neon-animation-finish': '_onNeonAnimationFinish'
    },
    _renderOpened: function () {
      this.cancelAnimation();
      this.playAnimation('entry');
    },
    _renderClosed: function () {
      this.cancelAnimation();
      this.playAnimation('exit');
    },
    _onNeonAnimationFinish: function () {
      if (this.opened) {
        this._finishRenderOpened();
      } else {
        this._finishRenderClosed();
      }
    }
  });

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  `iron-a11y-announcer` is a singleton element that is intended to add a11y
  to features that require on-demand announcement from screen readers. In
  order to make use of the announcer, it is best to request its availability
  in the announcing element.

  Example:

      Polymer({

        is: 'x-chatty',

        attached: function() {
          // This will create the singleton element if it has not
          // been created yet:
          Polymer.IronA11yAnnouncer.requestAvailability();
        }
      });

  After the `iron-a11y-announcer` has been made available, elements can
  make announces by firing bubbling `iron-announce` events.

  Example:

      this.fire('iron-announce', {
        text: 'This is an announcement!'
      }, { bubbles: true });

  Note: announcements are only audible if you have a screen reader enabled.

  @demo demo/index.html
  */
  const IronA11yAnnouncer = Polymer({
    /** @override */
    _template: html`
    <style>
      :host {
        display: inline-block;
        position: fixed;
        clip: rect(0px,0px,0px,0px);
      }
    </style>
    <div aria-live$="[[mode]]">[[_text]]</div>
`,
    is: 'iron-a11y-announcer',
    properties: {
      /**
       * The value of mode is used to set the `aria-live` attribute
       * for the element that will be announced. Valid values are: `off`,
       * `polite` and `assertive`.
       */
      mode: {
        type: String,
        value: 'polite'
      },
      /**
       * The timeout on refreshing the announcement text. Larger timeouts are
       * needed for certain screen readers to re-announce the same message.
       */
      timeout: {
        type: Number,
        value: 150
      },
      _text: {
        type: String,
        value: ''
      }
    },
    /** @override */
    created: function () {
      if (!IronA11yAnnouncer.instance) {
        IronA11yAnnouncer.instance = this;
      }
      document.addEventListener('iron-announce', this._onIronAnnounce.bind(this));
    },
    /**
     * Cause a text string to be announced by screen readers.
     *
     * @param {string} text The text that should be announced.
     */
    announce: function (text) {
      this._text = '';
      this.async(function () {
        this._text = text;
      }, this.timeout);
    },
    _onIronAnnounce: function (event) {
      if (event.detail && event.detail.text) {
        this.announce(event.detail.text);
      }
    }
  });
  IronA11yAnnouncer.instance = null;
  IronA11yAnnouncer.requestAvailability = function () {
    if (!IronA11yAnnouncer.instance) {
      IronA11yAnnouncer.instance = document.createElement('iron-a11y-announcer');
    }
    if (document.body) {
      document.body.appendChild(IronA11yAnnouncer.instance);
    } else {
      document.addEventListener('load', function () {
        document.body.appendChild(IronA11yAnnouncer.instance);
      });
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * Singleton IronMeta instance.
   */
  let IronValidatableBehaviorMeta = null;

  /**
   * `Use IronValidatableBehavior` to implement an element that validates
   * user input. Use the related `IronValidatorBehavior` to add custom
   * validation logic to an iron-input.
   *
   * By default, an `<iron-form>` element validates its fields when the user
   * presses the submit button. To validate a form imperatively, call the form's
   * `validate()` method, which in turn will call `validate()` on all its
   * children. By using `IronValidatableBehavior`, your custom element
   * will get a public `validate()`, which will return the validity of the
   * element, and a corresponding `invalid` attribute, which can be used for
   * styling.
   *
   * To implement the custom validation logic of your element, you must override
   * the protected `_getValidity()` method of this behaviour, rather than
   * `validate()`. See
   * [this](https://github.com/PolymerElements/iron-form/blob/master/demo/simple-element.html)
   * for an example.
   *
   * ### Accessibility
   *
   * Changing the `invalid` property, either manually or by calling `validate()`
   * will update the `aria-invalid` attribute.
   *
   * @demo demo/index.html
   * @polymerBehavior
   */
  const IronValidatableBehavior = {
    properties: {
      /**
       * Name of the validator to use.
       */
      validator: {
        type: String
      },
      /**
       * True if the last call to `validate` is invalid.
       */
      invalid: {
        notify: true,
        reflectToAttribute: true,
        type: Boolean,
        value: false,
        observer: '_invalidChanged'
      }
    },
    registered: function () {
      IronValidatableBehaviorMeta = new IronMeta({
        type: 'validator'
      });
    },
    _invalidChanged: function () {
      if (this.invalid) {
        this.setAttribute('aria-invalid', 'true');
      } else {
        this.removeAttribute('aria-invalid');
      }
    },
    /* Recompute this every time it's needed, because we don't know if the
     * underlying IronValidatableBehaviorMeta has changed. */
    get _validator() {
      return IronValidatableBehaviorMeta && IronValidatableBehaviorMeta.byKey(this.validator);
    },
    /**
     * @return {boolean} True if the validator `validator` exists.
     */
    hasValidator: function () {
      return this._validator != null;
    },
    /**
     * Returns true if the `value` is valid, and updates `invalid`. If you want
     * your element to have custom validation logic, do not override this method;
     * override `_getValidity(value)` instead.
      * @param {Object} value Deprecated: The value to be validated. By default,
     * it is passed to the validator's `validate()` function, if a validator is
     set.
     * If this argument is not specified, then the element's `value` property
     * is used, if it exists.
     * @return {boolean} True if `value` is valid.
     */
    validate: function (value) {
      // If this is an element that also has a value property, and there was
      // no explicit value argument passed, use the element's property instead.
      if (value === undefined && this.value !== undefined) this.invalid = !this._getValidity(this.value);else this.invalid = !this._getValidity(value);
      return !this.invalid;
    },
    /**
     * Returns true if `value` is valid.  By default, it is passed
     * to the validator's `validate()` function, if a validator is set. You
     * should override this method if you want to implement custom validity
     * logic for your element.
     *
     * @param {Object} value The value to be validated.
     * @return {boolean} True if `value` is valid.
     */

    _getValidity: function (value) {
      if (this.hasValidator()) {
        return this._validator.validate(value);
      }
      return true;
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  `<iron-input>` is a wrapper to a native `<input>` element, that adds two-way
  binding and prevention of invalid input. To use it, you must distribute a native
  `<input>` yourself. You can continue to use the native `input` as you would
  normally:

      <iron-input>
        <input>
      </iron-input>

      <iron-input>
        <input type="email" disabled>
      </iron-input>

  ### Two-way binding

  By default you can only get notified of changes to a native `<input>`'s `value`
  due to user input:

      <input value="{{myValue::input}}">

  This means that if you imperatively set the value (i.e. `someNativeInput.value =
  'foo'`), no events will be fired and this change cannot be observed.

  `iron-input` adds the `bind-value` property that mirrors the native `input`'s
  '`value` property; this property can be used for two-way data binding.
  `bind-value` will notify if it is changed either by user input or by script.

      <iron-input bind-value="{{myValue}}">
        <input>
      </iron-input>

  Note: this means that if you want to imperatively set the native `input`'s, you
  _must_ set `bind-value` instead, so that the wrapper `iron-input` can be
  notified.

  ### Validation

  `iron-input` uses the native `input`'s validation. For simplicity, `iron-input`
  has a `validate()` method (which internally just checks the distributed
  `input`'s validity), which sets an `invalid` attribute that can also be used for
  styling.

  To validate automatically as you type, you can use the `auto-validate`
  attribute.

  `iron-input` also fires an `iron-input-validate` event after `validate()` is
  called. You can use it to implement a custom validator:

      var CatsOnlyValidator = {
        validate: function(ironInput) {
          var valid = !ironInput.bindValue || ironInput.bindValue === 'cat';
          ironInput.invalid = !valid;
          return valid;
        }
      }
      ironInput.addEventListener('iron-input-validate', function() {
        CatsOnly.validate(input2);
      });

  You can also use an element implementing an
  [`IronValidatorBehavior`](/element/PolymerElements/iron-validatable-behavior).
  This example can also be found in the demo for this element:

      <iron-input validator="cats-only">
        <input>
      </iron-input>

  ### Preventing invalid input

  It may be desirable to only allow users to enter certain characters. You can use
  the `allowed-pattern` attribute to accomplish this. This feature is separate
  from validation, and `allowed-pattern` does not affect how the input is
  validated.

      // Only allow typing digits, but a valid input has exactly 5 digits.
      <iron-input allowed-pattern="[0-9]">
        <input pattern="\d{5}">
      </iron-input>

  @demo demo/index.html
  */
  Polymer({
    _template: html`
    <style>
      :host {
        display: inline-block;
      }
    </style>
    <slot id="content"></slot>
`,
    is: 'iron-input',
    behaviors: [IronValidatableBehavior],
    /**
     * Fired whenever `validate()` is called.
     *
     * @event iron-input-validate
     */

    properties: {
      /**
       * Use this property instead of `value` for two-way data binding, or to
       * set a default value for the input. **Do not** use the distributed
       * input's `value` property to set a default value.
       */
      bindValue: {
        type: String,
        value: ''
      },
      /**
       * Computed property that echoes `bindValue` (mostly used for Polymer 1.0
       * backcompatibility, if you were one-way binding to the Polymer 1.0
       * `input is="iron-input"` value attribute).
       */
      value: {
        type: String,
        computed: '_computeValue(bindValue)'
      },
      /**
       * Regex-like list of characters allowed as input; all characters not in the
       * list will be rejected. The recommended format should be a list of allowed
       * characters, for example, `[a-zA-Z0-9.+-!;:]`.
       *
       * This pattern represents the allowed characters for the field; as the user
       * inputs text, each individual character will be checked against the
       * pattern (rather than checking the entire value as a whole). If a
       * character is not a match, it will be rejected.
       *
       * Pasted input will have each character checked individually; if any
       * character doesn't match `allowedPattern`, the entire pasted string will
       * be rejected.
       *
       * Note: if you were using `iron-input` in 1.0, you were also required to
       * set `prevent-invalid-input`. This is no longer needed as of Polymer 2.0,
       * and will be set automatically for you if an `allowedPattern` is provided.
       *
       */
      allowedPattern: {
        type: String
      },
      /**
       * Set to true to auto-validate the input value as you type.
       */
      autoValidate: {
        type: Boolean,
        value: false
      },
      /**
       * The native input element.
       */
      _inputElement: Object
    },
    observers: ['_bindValueChanged(bindValue, _inputElement)'],
    listeners: {
      'input': '_onInput',
      'keypress': '_onKeypress'
    },
    created: function () {
      IronA11yAnnouncer.requestAvailability();
      this._previousValidInput = '';
      this._patternAlreadyChecked = false;
    },
    attached: function () {
      // If the input is added at a later time, update the internal reference.
      this._observer = dom(this).observeNodes(function (info) {
        this._initSlottedInput();
      }.bind(this));
    },
    detached: function () {
      if (this._observer) {
        dom(this).unobserveNodes(this._observer);
        this._observer = null;
      }
    },
    /**
     * Returns the distributed input element.
     */
    get inputElement() {
      return this._inputElement;
    },
    _initSlottedInput: function () {
      this._inputElement = this.getEffectiveChildren()[0];
      if (this.inputElement && this.inputElement.value) {
        this.bindValue = this.inputElement.value;
      }
      this.fire('iron-input-ready');
    },
    get _patternRegExp() {
      var pattern;
      if (this.allowedPattern) {
        pattern = new RegExp(this.allowedPattern);
      } else {
        switch (this.inputElement.type) {
          case 'number':
            pattern = /[0-9.,e-]/;
            break;
        }
      }
      return pattern;
    },
    /**
     * @suppress {checkTypes}
     */
    _bindValueChanged: function (bindValue, inputElement) {
      // The observer could have run before attached() when we have actually
      // initialized this property.
      if (!inputElement) {
        return;
      }
      if (bindValue === undefined) {
        inputElement.value = null;
      } else if (bindValue !== inputElement.value) {
        this.inputElement.value = bindValue;
      }
      if (this.autoValidate) {
        this.validate();
      }

      // manually notify because we don't want to notify until after setting value
      this.fire('bind-value-changed', {
        value: bindValue
      });
    },
    _onInput: function () {
      // Need to validate each of the characters pasted if they haven't
      // been validated inside `_onKeypress` already.
      if (this.allowedPattern && !this._patternAlreadyChecked) {
        var valid = this._checkPatternValidity();
        if (!valid) {
          this._announceInvalidCharacter('Invalid string of characters not entered.');
          this.inputElement.value = this._previousValidInput;
        }
      }
      this.bindValue = this._previousValidInput = this.inputElement.value;
      this._patternAlreadyChecked = false;
    },
    _isPrintable: function (event) {
      // What a control/printable character is varies wildly based on the browser.
      // - most control characters (arrows, backspace) do not send a `keypress`
      // event
      //   in Chrome, but the *do* on Firefox
      // - in Firefox, when they do send a `keypress` event, control chars have
      //   a charCode = 0, keyCode = xx (for ex. 40 for down arrow)
      // - printable characters always send a keypress event.
      // - in Firefox, printable chars always have a keyCode = 0. In Chrome, the
      // keyCode
      //   always matches the charCode.
      // None of this makes any sense.

      // For these keys, ASCII code == browser keycode.
      var anyNonPrintable = event.keyCode == 8 ||
      // backspace
      event.keyCode == 9 ||
      // tab
      event.keyCode == 13 ||
      // enter
      event.keyCode == 27; // escape

      // For these keys, make sure it's a browser keycode and not an ASCII code.
      var mozNonPrintable = event.keyCode == 19 ||
      // pause
      event.keyCode == 20 ||
      // caps lock
      event.keyCode == 45 ||
      // insert
      event.keyCode == 46 ||
      // delete
      event.keyCode == 144 ||
      // num lock
      event.keyCode == 145 ||
      // scroll lock
      event.keyCode > 32 && event.keyCode < 41 ||
      // page up/down, end, home, arrows
      event.keyCode > 111 && event.keyCode < 124; // fn keys

      return !anyNonPrintable && !(event.charCode == 0 && mozNonPrintable);
    },
    _onKeypress: function (event) {
      if (!this.allowedPattern && this.inputElement.type !== 'number') {
        return;
      }
      var regexp = this._patternRegExp;
      if (!regexp) {
        return;
      }

      // Handle special keys and backspace
      if (event.metaKey || event.ctrlKey || event.altKey) {
        return;
      }

      // Check the pattern either here or in `_onInput`, but not in both.
      this._patternAlreadyChecked = true;
      var thisChar = String.fromCharCode(event.charCode);
      if (this._isPrintable(event) && !regexp.test(thisChar)) {
        event.preventDefault();
        this._announceInvalidCharacter('Invalid character ' + thisChar + ' not entered.');
      }
    },
    _checkPatternValidity: function () {
      var regexp = this._patternRegExp;
      if (!regexp) {
        return true;
      }
      for (var i = 0; i < this.inputElement.value.length; i++) {
        if (!regexp.test(this.inputElement.value[i])) {
          return false;
        }
      }
      return true;
    },
    /**
     * Returns true if `value` is valid. The validator provided in `validator`
     * will be used first, then any constraints.
     * @return {boolean} True if the value is valid.
     */
    validate: function () {
      if (!this.inputElement) {
        this.invalid = false;
        return true;
      }

      // Use the nested input's native validity.
      var valid = this.inputElement.checkValidity();

      // Only do extra checking if the browser thought this was valid.
      if (valid) {
        // Empty, required input is invalid
        if (this.required && this.bindValue === '') {
          valid = false;
        } else if (this.hasValidator()) {
          valid = IronValidatableBehavior.validate.call(this, this.bindValue);
        }
      }
      this.invalid = !valid;
      this.fire('iron-input-validate');
      return valid;
    },
    _announceInvalidCharacter: function (message) {
      this.fire('iron-announce', {
        text: message
      });
    },
    _computeValue: function (bindValue) {
      return bindValue;
    }
  });

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  `iron-autogrow-textarea` is an element containing a textarea that grows in
  height as more lines of input are entered. Unless an explicit height or the
  `maxRows` property is set, it will never scroll.

  Example:

      <iron-autogrow-textarea></iron-autogrow-textarea>

  ### Styling

  The following custom properties and mixins are available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--iron-autogrow-textarea` | Mixin applied to the textarea | `{}`
  `--iron-autogrow-textarea-placeholder` | Mixin applied to the textarea placeholder | `{}`

  @demo demo/index.html
  */
  Polymer({
    /** @override */
    _template: html`
    <style>
      :host {
        display: inline-block;
        position: relative;
        width: 400px;
        border: 1px solid;
        padding: 2px;
        -moz-appearance: textarea;
        -webkit-appearance: textarea;
        overflow: hidden;
      }

      .mirror-text {
        visibility: hidden;
        word-wrap: break-word;
        @apply --iron-autogrow-textarea;
      }

      .fit {
        @apply --layout-fit;
      }

      textarea {
        position: relative;
        outline: none;
        border: none;
        resize: none;
        background: inherit;
        color: inherit;
        /* see comments in template */
        width: 100%;
        height: 100%;
        font-size: inherit;
        font-family: inherit;
        line-height: inherit;
        text-align: inherit;
        @apply --iron-autogrow-textarea;
      }

      textarea::-webkit-input-placeholder {
        @apply --iron-autogrow-textarea-placeholder;
      }

      textarea:-moz-placeholder {
        @apply --iron-autogrow-textarea-placeholder;
      }

      textarea::-moz-placeholder {
        @apply --iron-autogrow-textarea-placeholder;
      }

      textarea:-ms-input-placeholder {
        @apply --iron-autogrow-textarea-placeholder;
      }
    </style>

    <!-- the mirror sizes the input/textarea so it grows with typing -->
    <!-- use &#160; instead &nbsp; of to allow this element to be used in XHTML -->
    <div id="mirror" class="mirror-text" aria-hidden="true">&nbsp;</div>

    <!-- size the input/textarea with a div, because the textarea has intrinsic size in ff -->
    <div class="textarea-container fit">
      <textarea id="textarea" name$="[[name]]" aria-label$="[[label]]" autocomplete$="[[autocomplete]]" autofocus$="[[autofocus]]" autocapitalize$="[[autocapitalize]]" inputmode$="[[inputmode]]" placeholder$="[[placeholder]]" readonly$="[[readonly]]" required$="[[required]]" disabled$="[[disabled]]" rows$="[[rows]]" minlength$="[[minlength]]" maxlength$="[[maxlength]]"></textarea>
    </div>
`,
    is: 'iron-autogrow-textarea',
    behaviors: [IronValidatableBehavior, IronControlState],
    properties: {
      /**
       * Use this property instead of `bind-value` for two-way data binding.
       * @type {string|number}
       */
      value: {
        observer: '_valueChanged',
        type: String,
        notify: true
      },
      /**
       * This property is deprecated, and just mirrors `value`. Use `value`
       * instead.
       * @type {string|number}
       */
      bindValue: {
        observer: '_bindValueChanged',
        type: String,
        notify: true
      },
      /**
       * The initial number of rows.
       *
       * @attribute rows
       * @type number
       * @default 1
       */
      rows: {
        type: Number,
        value: 1,
        observer: '_updateCached'
      },
      /**
       * The maximum number of rows this element can grow to until it
       * scrolls. 0 means no maximum.
       *
       * @attribute maxRows
       * @type number
       * @default 0
       */
      maxRows: {
        type: Number,
        value: 0,
        observer: '_updateCached'
      },
      /**
       * Bound to the textarea's `autocomplete` attribute.
       */
      autocomplete: {
        type: String,
        value: 'off'
      },
      /**
       * Bound to the textarea's `autofocus` attribute.
       *
       * @type {!boolean}
       */
      autofocus: {
        type: Boolean,
        value: false
      },
      /**
       * Bound to the textarea's `autocapitalize` attribute.
       */
      autocapitalize: {
        type: String,
        value: 'none'
      },
      /**
       * Bound to the textarea's `inputmode` attribute.
       */
      inputmode: {
        type: String
      },
      /**
       * Bound to the textarea's `placeholder` attribute.
       */
      placeholder: {
        type: String
      },
      /**
       * Bound to the textarea's `readonly` attribute.
       */
      readonly: {
        type: String
      },
      /**
       * Set to true to mark the textarea as required.
       */
      required: {
        type: Boolean
      },
      /**
       * The minimum length of the input value.
       */
      minlength: {
        type: Number
      },
      /**
       * The maximum length of the input value.
       */
      maxlength: {
        type: Number
      },
      /**
       * Bound to the textarea's `aria-label` attribute.
       */
      label: {
        type: String
      }
    },
    listeners: {
      'input': '_onInput'
    },
    /**
     * Returns the underlying textarea.
     * @return {!HTMLTextAreaElement}
     */
    get textarea() {
      return (/** @type {!HTMLTextAreaElement} */this.$.textarea
      );
    },
    /**
     * Returns textarea's selection start.
     * @return {number}
     */
    get selectionStart() {
      return this.$.textarea.selectionStart;
    },
    /**
     * Returns textarea's selection end.
     * @return {number}
     */
    get selectionEnd() {
      return this.$.textarea.selectionEnd;
    },
    /**
     * Sets the textarea's selection start.
     */
    set selectionStart(value) {
      this.$.textarea.selectionStart = value;
    },
    /**
     * Sets the textarea's selection end.
     */
    set selectionEnd(value) {
      this.$.textarea.selectionEnd = value;
    },
    /** @override */
    attached: function () {
      /* iOS has an arbitrary left margin of 3px that isn't present
       * in any other browser, and means that the paper-textarea's cursor
       * overlaps the label.
       * See https://github.com/PolymerElements/paper-input/issues/468.
       */
      var IS_IOS = navigator.userAgent.match(/iP(?:[oa]d|hone)/) && !navigator.userAgent.match(/OS 1[3456789]/);
      if (IS_IOS) {
        this.$.textarea.style.marginLeft = '-3px';
      }
    },
    /**
     * Returns true if `value` is valid. The validator provided in `validator`
     * will be used first, if it exists; otherwise, the `textarea`'s validity
     * is used.
     * @return {boolean} True if the value is valid.
     */
    validate: function () {
      // Use the nested input's native validity.
      var valid = this.$.textarea.validity.valid;

      // Only do extra checking if the browser thought this was valid.
      if (valid) {
        // Empty, required input is invalid
        if (this.required && this.value === '') {
          valid = false;
        } else if (this.hasValidator()) {
          valid = IronValidatableBehavior.validate.call(this, this.value);
        }
      }
      this.invalid = !valid;
      this.fire('iron-input-validate');
      return valid;
    },
    _bindValueChanged: function (bindValue) {
      this.value = bindValue;
    },
    _valueChanged: function (value) {
      var textarea = this.textarea;
      if (!textarea) {
        return;
      }

      // If the bindValue changed manually, then we need to also update
      // the underlying textarea's value. Otherwise this change was probably
      // generated from the _onInput handler, and the two values are already
      // the same.
      if (textarea.value !== value) {
        textarea.value = !(value || value === 0) ? '' : value;
      }
      this.bindValue = value;
      this.$.mirror.innerHTML = this._valueForMirror();

      // Manually notify because we don't want to notify until after setting
      // value.
      this.fire('bind-value-changed', {
        value: this.bindValue
      });
    },
    _onInput: function (event) {
      var eventPath = dom(event).path;
      this.value = eventPath ? eventPath[0].value : event.target.value;
    },
    _constrain: function (tokens) {
      var _tokens;
      tokens = tokens || [''];
      // Enforce the min and max heights for a multiline input to avoid
      // measurement
      if (this.maxRows > 0 && tokens.length > this.maxRows) {
        _tokens = tokens.slice(0, this.maxRows);
      } else {
        _tokens = tokens.slice(0);
      }
      while (this.rows > 0 && _tokens.length < this.rows) {
        _tokens.push('');
      }
      // Use &#160; instead &nbsp; of to allow this element to be used in XHTML.
      return _tokens.join('<br/>') + '&#160;';
    },
    _valueForMirror: function () {
      var input = this.textarea;
      if (!input) {
        return;
      }
      this.tokens = input && input.value ? input.value.replace(/&/gm, '&amp;').replace(/"/gm, '&quot;').replace(/'/gm, '&#39;').replace(/</gm, '&lt;').replace(/>/gm, '&gt;').split('\n') : [''];
      return this._constrain(this.tokens);
    },
    _updateCached: function () {
      this.$.mirror.innerHTML = this._constrain(this.tokens);
    }
  });

  /**
  * Renders a bordered text input
  * @name UnityTextInput
  * @param {''} value, the text defaulted text in the field
  * @param {func} onChange, function to handle changes to the field, receives current text value, and true/false if validation is in effect
  * @param {''} label, floating header label
  * @param {''} placeholder, initial text to be overwritten
  * @param {''} remark, text to render below input field
  * @param {bool} charCount, show current char count
  * @param {int} maxlength, maximum number of characters to allow
  * @param {bool} disabled, controls if field is enabled/disabled, defaults: false (enabled)
  * @param {bool} required, marks field as being required, defaults: false
  * @param {bool} readOnly, marks field as being readOnly, defaults: false
  * @param {''} units, right bound units
  * @param {''} hint, text to show when hovering over/clicked on hint icon
  * @param {bool} time, option to have input by type time, overriden by password
  * @param {bool} password, converts characters to dots/password field, overwrites rightIcon
  * @param {bool} hideErrors, do not display error messages below the input
  * @param {bool} wrapErrors, if the error text should be wrapped or not; needs 'hideErrors' to be false.
  * @param {''} error, error message for external error control or default forcing, can give true to not render remark error text, if validation is also sent it it will overwrite error's effects
  * @param {func} validation, func used to show if value is valid, return falsey or string for invalid, truth for valid.
  * @param {bool} showIcon, show/hide right-bound in/valid icon, only renders w/ validation func, defaults: false (hide)
  * @param {bool} rounded, if specified, makes the text input edges rounded, defaults: false (square corners)
  * @param {bool} hideBorder, hides the border of the element, defaults: false (show border)
  * @param {bool} borderEffects, apply styles (color and shadow) on hover/focus, default: true
  * @param {bool} area, field shows as text area with scrolling and multiline, disables many other features
  * @param {number} minLines, minimum number of lines to show in a text area, default 4
  * @param {number} maxLines, maximum number of lines to show in a text area before scrolling, default 12
  * @param {''} innerRightIcon, if defined, puts an icon (specified) from the unity icon set on the right side of the text input
  * @param {''} innerLeftIcon, if defined, puts an icon (specified) from the unity icon set on the left side of the text input
  * @param {bool} dirty, if true, will render left-side bar to show that the element has been changed from it's original contents
  * @param {bool} autofocus, focus input on load
  * @param {string} autocomplete, to define autocomplete behavior, defaults to "off"
  * @param {''} prefixedText, read-only text to include at the start of the input

  * @example
  * <unity-text-input>
  *   .label="${'Strong Validation'}"
  *   .value="${"astrongerpassword"}"
  *   .validation="${val=> {
  *     if (val.length < 8) return 'Password should be at least 8 characters'
  *     else if (val.length < 16) return 1
  *     else return 2
  *   }}"
  *   .onChange="${this.onInputChange}"
  *   password
  *   showIcon
  * </unity-text-input>

  css vars
    input-font
    input-label-color
    input-text-color
    input-text-size
    input-small-text-size
    input-dirty-color
    input-border-color
    input-border-hover-color
    input-border-focus-color
    input-border-readOnly-color
    input-border-error-color
    input-background-error-color
    input-border-disabled-color
    input-background-disabled-color
    input-icon-hint-color
    input-icon-valid-color
    input-icon-error-color
    input-prefixed-text-color
    input-prefixed-text-padding
    inner-icon-size
    bottom-height
  **/

  const MIN_LINES = 4;
  const MAX_LINES = 12;
  let UnityTextInput = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTextInput, _LitElement);
    var _super = _createSuper(UnityTextInput);
    function UnityTextInput() {
      var _this;
      _classCallCheck(this, UnityTextInput);
      _this = _super.call(this);
      _this._value = "";
      _this.label = "";
      _this.remark = "";
      _this.disabled = false;
      _this.required = false;
      _this.readOnly = false;
      _this.onChange = () => {};
      _this.time = false;
      _this.placeholder = "";
      _this.units = "";
      _this.charCount = false;
      _this._maxlength = 0;
      _this.showIcon = false;
      _this.hideBorder = false;
      _this.borderEffects = true;
      _this.rounded = false;
      _this.innerRightIcon = "";
      _this.innerLeftIcon = "";
      _this.area = false;
      _this.minLines = MIN_LINES;
      _this.maxLines = MAX_LINES;
      _this.dirty = false;
      _this.autofocus = false;
      _this.prefixedText = "";
      _this.autocomplete = "off";
      _this.hideErrors = false;
      _this.wrapErrors = false;

      // internals
      _this._error = '';
      _this._validation = null;
      _this._password = false;
      _this._valid = true;
      _this._strength = 0;
      _this._errorText = "";
      _this._showPassword = false;
      return _this;
    }
    _createClass(UnityTextInput, [{
      key: "error",
      get: function () {
        return this._error;
      }

      // these set/get are set to make sure that _validate is called
      // when value/password/validation is set or altered
      ,
      set:
      // this is to allow external control of errors/validity
      // if given validation and error, validation will overwrite error's message
      function (value) {
        const oldValue = this._error;
        this._error = value;
        if (value === true || value === 'true') this._valid = false;else if (!value) {
          this._valid = true;
          this._errorText = '';
        } else {
          this._valid = false;
          this._errorText = value;
        }
        this.requestUpdate('error', oldValue);
      }
    }, {
      key: "firstUpdated",
      value: function firstUpdated() {
        if (this.autofocus) this._focusInput();
      }
    }, {
      key: "value",
      get: function () {
        return this._value;
      },
      set: function (value) {
        const oldValue = this._value;
        this._value = value;
        this._validate();
        this.requestUpdate('value', oldValue);
      }
    }, {
      key: "password",
      get: function () {
        return this._password;
      },
      set: function (value) {
        const oldValue = this._password;
        this._password = value;
        this._validate();
        this.requestUpdate('password', oldValue);
      }
    }, {
      key: "validation",
      get: function () {
        return this._validation;
      },
      set: function (value) {
        const oldValue = this._validation;
        this._validation = value;
        this._validate();
        this.requestUpdate('validation', oldValue);
      }
    }, {
      key: "_onChange",
      value: function _onChange(e) {
        const report = this.onChange;
        const newValue = e.target.value;
        this.value = newValue;
        if (report instanceof Function) {
          if (this.validation instanceof Function) {
            report(e, this.value, this._valid);
          } else {
            report(e, this.value);
          }
        }
      }
    }, {
      key: "maxlength",
      get: function () {
        return this._maxlength;
      },
      set: function (value) {
        const oldValue = this._maxlength;
        this._maxlength = value;
        this._validate();
        this.requestUpdate('maxlength', oldValue);
      }
    }, {
      key: "_validate",
      value: function _validate() {
        const {
          validation,
          password,
          maxlength,
          value
        } = this;
        if (!!maxlength && value.length > maxlength) this.value = value.slice(0, maxlength);
        if (validation instanceof Function) {
          const isValid = validation(value);
          if (isValid === true) {
            this._valid = true;
            this._errorText = '';
            return;
          }
          this._valid = false;
          this._strength = 0;
          this._errorText = isValid || '';
        }
      }
    }, {
      key: "_focusInput",
      value: function _focusInput() {
        const input = this.shadowRoot.getElementById('input');
        if (!!input) {
          input.focus();
        } else {
          //If input is not found, look for textarea
          const textarea = this.shadowRoot.getElementById('textarea');
          if (!!textarea) {
            textarea.focus();
          }
        }
      }
    }, {
      key: "_clickRightIcon",
      value: function _clickRightIcon() {
        this._focusInput();
        // if password, toggles password
        if (!!this.password) {
          this.togglePassword();
        }
      }
    }, {
      key: "_renderIcon",
      value: function _renderIcon() {
        const {
          showIcon,
          value,
          _valid
        } = this;
        if (!!showIcon && !!value) {
          const validClass = !_valid ? 'icon-error' : 'icon-valid';
          const icon = !_valid ? 'unity:warning_circle_outline' : 'unity:circle_check';
          return html$1`
        <div class="icon-wrapper">
          <unity-icon class="icon ${validClass}" icon="${icon}"></unity-icon>
        </div>
      `;
        } else {
          return null;
        }
      }
    }, {
      key: "_renderInnerIcon",
      value: function _renderInnerIcon(icon, iconOnLeftSide) {
        const {
          password,
          _focusInput,
          _clickRightIcon
        } = this;
        if (!icon) return;
        return html$1`
      <div class="${!!iconOnLeftSide ? "icon-left-wrapper" : "icon-right-wrapper"}">
        <unity-icon class="inner-icon${password && !iconOnLeftSide ? ' password' : ''}" icon="${icon}" @click="${!iconOnLeftSide ? _clickRightIcon : _focusInput}"></unity-icon>
      </div>
    `;
      }
    }, {
      key: "_getInputWrapperClasses",
      value: function _getInputWrapperClasses() {
        const {
          area,
          _valid,
          units,
          disabled,
          readOnly,
          hideBorder,
          rounded,
          borderEffects
        } = this;
        let classes = ['input-wrapper'];
        if (!!area) {
          classes.push('area', 'showBorder', 'notRounded');
        } else {
          if (!!hideBorder) classes.push('hideBorder');else classes.push('showBorder');
          if (!!rounded) classes.push('rounded');else classes.push('notRounded');
        }
        if (!_valid) classes.push('invalid');else classes.push('valid');
        if (!!readOnly) classes.push('readOnly');
        if (!!disabled) classes.push('disabled');
        if (borderEffects) classes.push('border-effects');
        return classes.join(" ");
      }

      /**
       * Toggles whether password styled text is hidden or visible
       */
    }, {
      key: "togglePassword",
      value: function togglePassword() {
        this._showPassword = !this._showPassword;
      }

      /**
       * Render div with remark or input error message.
       */
    }, {
      key: "renderBottomDiv",
      value: function renderBottomDiv() {
        const {
          maxlength,
          _errorText,
          _valid,
          remark,
          value,
          charCount,
          wrapErrors
        } = this;
        let spanClasses = "remark";
        if (_errorText && !_valid) spanClasses += " invalid-text";
        if (wrapErrors) spanClasses += " wrapped";
        return html$1`
      <div class="bottom${wrapErrors ? " wrapped" : ""}">
        <span class=${spanClasses}>
        ${_errorText || remark}
      </span>
      ${!!charCount ? html$1`<span class="charCount">
          ${value.length}${!!maxlength ? `/${maxlength}` : null}
        </span>` : null}
      </div>`;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          value,
          label,
          remark,
          disabled,
          required,
          readOnly,
          units,
          charCount,
          maxlength,
          hideBorder,
          rounded,
          innerRightIcon: originalRightIcon,
          innerLeftIcon,
          area,
          minLines: givenMinLines,
          maxLines: givenMaxLines,
          time,
          password,
          placeholder,
          dirty,
          showIcon,
          autofocus,
          prefixedText,
          autocomplete,
          _onChange,
          _valid,
          _strength,
          _errorText,
          _focusInput,
          _showPassword,
          hideErrors
        } = this;
        const minLines = givenMinLines < 1 ? 1 : Math.floor(givenMinLines);
        const maxLines = givenMaxLines < minLines ? minLines : Math.floor(givenMaxLines);
        let innerRightIcon = originalRightIcon;
        let type = 'text';
        if (!area) {
          if (!!time) type = 'time';
          if (!!password) {
            type = 'password';
            // set icon to eye
            // closed if _showPassword
            if (!!_showPassword) {
              type = 'text';
              innerRightIcon = 'unity:hide';
            }
            // else open
            else innerRightIcon = 'unity:show';
          }
        }
        return html$1`
      <div>
        ${!!label ? html$1`<p class="label">
            ${label}${required ? html$1`<span class="required"> *</span>` : ''}
            </p>` : null}
        <div
          class="${this._getInputWrapperClasses()}"
          @click="${_focusInput}"
        >
          ${!area ? this._renderInnerIcon(innerLeftIcon, true) : null}

          ${!area && !!prefixedText ? html$1`<div
              class="prefixed-text ${!!disabled ? "disabled" : ""}"
            >
              ${prefixedText}
            </div>` : null}
          <iron-input
            bind-value="${value}"
            @input="${_onChange}"
            >

            ${!!area ? html$1`<iron-autogrow-textarea
                id="textarea"
                value="{{value::iron-autogrow-textarea}}"
                maxlength="${maxlength || null}"
                class="${!!disabled ? "disabled" : !!readOnly ? "readOnly" : ""}"
                ?disabled=${!!disabled || !!readOnly}
                placeholder="${!!placeholder ? placeholder : ''}"
                style="--area-min-lines: ${minLines}; --area-max-lines: ${maxLines}"
                ?autofocus=${autofocus}
              ></iron-autogrow-textarea>` : html$1`<input
                value="{{value::input}}"
                id="input"
                type="${type}"
                maxlength="${maxlength || null}"
                placeholder="${!!placeholder ? placeholder : ''}"
                class="${!!disabled ? "disabled" : ""}"
                ?disabled=${!!disabled || !!readOnly}
                ?autofocus=${autofocus}
                autocomplete="${autocomplete}"
                name="${label}"
              >`}
          </iron-input>
          ${!!dirty ? html$1`<div class="dirty" />` : null}
          ${!area && !!units ? html$1`<div
              class="units ${!!disabled ? "disabled" : ""}"
            >
              ${units}
            </div>` : null}
          ${!area ? this._renderInnerIcon(innerRightIcon, false) : null}

          ${!showIcon && required ? html$1`<span class="required field">*</span>` : null}
          ${!area ? this._renderIcon() : null}

        </div>
        ${!hideErrors || remark || charCount ? this.renderBottomDiv() : null}
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          value: {
            type: String
          },
          label: {
            type: String
          },
          remark: {
            type: String
          },
          disabled: {
            type: Boolean
          },
          required: {
            type: Boolean
          },
          readOnly: {
            type: Boolean
          },
          onChange: {
            type: Function
          },
          time: {
            type: Boolean
          },
          password: {
            type: Boolean
          },
          innerRightIcon: {
            type: String
          },
          innerLeftIcon: {
            type: String
          },
          placeholder: {
            type: String
          },
          units: {
            type: String
          },
          charCount: {
            type: Boolean
          },
          maxlength: {
            type: Number
          },
          error: {
            type: String
          },
          hideErrors: {
            type: Boolean
          },
          wrapErrors: {
            type: Boolean
          },
          validation: {
            type: Function
          },
          showIcon: {
            type: Boolean
          },
          hideBorder: {
            type: Boolean
          },
          borderEffects: {
            type: Boolean
          },
          rounded: {
            type: Boolean
          },
          area: {
            type: Boolean
          },
          minLines: {
            type: Number
          },
          maxLines: {
            type: Number
          },
          dirty: {
            type: Boolean
          },
          autofocus: {
            type: Boolean
          },
          prefixedText: {
            type: String
          },
          autocomplete: {
            type: String
          },
          // internals
          _valid: {
            type: Boolean
          },
          _strength: {
            type: Number
          },
          _errorText: {
            type: String
          },
          _showPassword: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-input-font: var(--font-family, var(--default-font-family));
          --default-input-label-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
          --default-input-text-color: var(--black-text-rgb, var(--default-black-text-rgb));
          --default-input-text-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          --default-input-small-text-size: var(--small-text-size, var(--default-small-text-size));
          --default-input-dirty-color: var(--primary-color, var(--defualt-primary-color));
          --default-input-border-color: var(--gray-color, var(--default-gray-color));
          --default-input-border-hover-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-input-border-focus-color: var(--primary-color, var(--default-primary-color));
          --default-input-border-readOnly-color: var(--light-gray-1-color, var(--default-light-gray-1-color));
          --default-input-border-error-color: var(--tertiary-1-color, var(--default-tertiary-1-color));
          --default-input-background-error-color: var(--tertiary-1-light-color, var(--default-tertiary-1-light-color));
          --default-input-border-disabled-color: var(--gray-color, var(--default-gray-color));
          --default-input-background-disabled-color: var(--light-gray-2-color, var(--default-light-gray-2-color));
          --default-input-icon-hint-color: var(--primary-color, var(--default-primary-color));
          --default-input-icon-valid-color: var(--primary-color, var(--default-primary-color));
          --default-input-icon-error-color: var(--tertiary-1-color, var(--default-tertiary-1-color));
          --default-input-prefixed-text-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-input-prefixed-text-padding: 0;
          --default-bottom-height: 16px;
          font-family: var(--input-font, var(--default-input-font));
          font-size: var(--input-text-size, var(--default-input-text-size));
          --default-inner-icon-size: calc(var(--input-text-size, var(--default-input-text-size)) * 4 / 3);
          --default-inner-icon-color: var(--black-color, var(--default-black-color));
          border-collapse: collapse;
          user-select: none;
        }
        p {
          margin-top: 0;
        }
        iron-input {
          display: flex;
          width: 100%;
        }
        .label {
          margin-bottom: 6px;
          padding: 0;
          color: var(--input-label-color, var(--default-input-label-color));
        }
        .bottom {
          margin: 0;
          padding-top: 4px;
          display: flex;
          flex-direction: row;
          height: var(--bottom-height, var(--default-bottom-height));
        }
        .bottom:not(.wrapped) {
          white-space: nowrap;
        }
        .remark {
          flex: 1;
          word-break: break-word;
          font-size: var(--input-small-text-size, var(--default-input-small-text-size));
          color: var(--input-label-color, var(--default-input-label-color));
          text-overflow: ellipsis;
        }
        .remark:not(.wrapped) {
          overflow: hidden;
        }
        .charCount {
          flex: 0;
          padding-left: 4px;
          text-align: right;
          font-size: var(--input-small-text-size, var(--default-input-small-text-size));
          color: var(--input-label-color, var(--default-input-label-color));
        }
        .input-wrapper {
          width: 100%;
          background-color: var(--background-color, var(--default-background-color));
          height: var(--unity-text-input-height, var(--default-unity-text-input-height));
          padding: 0 8px;
          box-sizing: border-box;
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .area {
          height: auto;
          padding: 6px 8px;
        }
        .invalid {
          background-color: var(--input-background-error-color, var(--default-input-background-error-color));
          border-color: var(--input-border-error-color, var(--default-input-border-error-color)) !important;
        }
        .invalid-text {
          color: var(--input-border-error-color, var(--default-input-border-error-color)) !important;
        }
        .input-wrapper.border-effects:hover {
          border-color: var(--input-border-hover-color, var(--default-input-border-hover-color));
        }
        .input-wrapper.border-effects:focus-within {
          border-color: var(--input-border-focus-color, var(--default-input-border-focus-color));
          outline: none;
          box-shadow: none;
        }
        .rounded {
          border-radius: calc(var(--unity-text-input-height, var(--default-unity-text-input-height)) * 0.5);
        }
        .notRounded {
          border-radius: 2px;
        }
        #input {
          padding: 0;
          margin: 0;
          align-self: center;
          flex: 1;
          font-family: var(--input-font, var(--default-input-font));
          font-size: var(--input-text-size, var(--default-input-text-size));
          color: var(--input-text-color, var(--default-input-text-color));
          border: 0;
          background-color: transparent;
          width: 100%;
          overflow: hidden;
        }
        #input:focus {
          outline: none;
        }
        #textarea {
          padding: 0;
          margin: 0;
          width: 100%;
          font-family: var(--input-font, var(--default-input-font));
          font-size: var(--input-text-size, var(--default-input-text-size));
          color: var(--input-text-color, var(--default-input-text-color));
          border: 0;
          background-color: transparent;
          resize: none;
          min-height: calc(var(--input-text-size, var(--default-input-text-size)) * 1.4545 * var(--area-min-lines, ${MIN_LINES}));
          max-height: calc(var(--input-text-size, var(--default-input-text-size)) * 1.4545 * var(--area-max-lines, ${MAX_LINES}));
          -webkit-appearance: none;
        }
        #textarea.readOnly {
          pointer-events: auto !important;
        }
        #textarea:focus {
          outline: none;
        }
        .units {
          flex: 0;
          padding-left: 8px;
          align-self: center;
          font-size: var(--input-small-text-size, var(--default-input-small-text-size));
          color: var(--input-text-color, var(--default-input-text-color));
          line-height: 2;
          white-space: nowrap;
        }
        .prefixed-text {
          flex: 0;
          padding-right: var(--input-prefixed-text-padding, var(--default-input-prefixed-text-padding));
          align-self: center;
          color: var(--input-prefixed-text-color, var(--default-input-prefixed-text-color));
          line-height: 2;
          white-space: nowrap;
        }
        .icon-wrapper {
          position: absolute;
          left: calc(100% + 4px);
          top: 50%;
          height: 24px;
          width: 24px;
          transform: translateY(-50%);
        }
        .icon-left-wrapper {
          height: 20px;
          width: 20px;
          margin-right: 2px;
        }
        .icon-right-wrapper {
          height: 20px;
          width: 20px;
          margin-left: 2px;
        }
        .showBorder {
          border-width: 1px;
          border-color: var(--input-border-color, var(--default-input-border-color));
          border-style: solid;
        }
        .hideBorder {
          border-width: 0px;
          height: 100%;
        }
        .hideBorder:focus-within {
          box-shadow: none;
        }
        .rect {
          width: 40px;
        }
        .icon-text {
          font-size: 11px;
          line-height: 16px;
          color: var(--input-label-color, var(--default-input-label-color));
        }
        .icon {
          --unity-icon-height: 24px;
          --unity-icon-width: 24px;
          color: var(--input-icon-valid-color, var(--default-input-icon-valid-color));
        }
        .inner-icon {
          --unity-icon-height: var(--inner-icon-size, var(--default-inner-icon-size));
          --unity-icon-width: var(--inner-icon-size, var(--default-inner-icon-size));
          color: var(--inner-icon-color, var(--default-inner-icon-color));
        }
        .inner-icon.password {
          cursor: pointer;
        }
        .icon-error {
          color: var(--input-icon-error-color, var(--default-input-icon-error-color));
        }
        .icon-valid {

        }
        .dirty {
          background-color: var(--input-dirty-color, var(--default-input-dirty-color));
          width: 5px;
          height: calc(100% + 2px);
          position: absolute;
          left: -10px;
          top: -1px;
        }

        .required {
          color: var(--tertiary-1-color, var(--default-tertiary-1-color));
          font-size: 12px;
          line-height: 12px;
        }
        .required.field {
          position: relative;
          top: 1px;
          left: 19px;
        }
        .readOnly {
          border-color: var(--light-gray-1-color, var(--default-light-gray-1-color)) !important;
        }
        .disabled {
          border-color: var(--dark-grey-background, var(--default-dark-grey-background)) !important;
          background-color: var(--light-grey-background-color, var(--default-light-grey-background-color));
          color: var(--input-text-color, var(--default-input-text-color));
        }
        input.disabled {
          opacity: 50%;
        }
      `];
      }
    }]);
    return UnityTextInput;
  }(LitElement);
  window.customElements.define('unity-text-input', UnityTextInput);

  const NO_MATCHES = "No matches";
  const SELECT_VISIBLE = "Select visible";
  const DESELECT_VISIBLE = "Deselect visible";

  /**
   * @name UnityDropdown
  * @description Renders a dropdown component that displays a list of options for selection.
  * @fileOverview A dropdown select input web component
  * @param {Boolean} [autofocus], focus input on load (only for boxType=search)
  * @param {Boolean} [disabled], controls if field is enabled/disabled, defaults: false (enabled)
  * @param {Boolean} [expanded], controls the expanded/collapsed state of the dropdown
  * @param {Boolean} [important], if the button should follow important styles, only works with buttons
  * @param {Boolean} [rightAlign], if the dropdown box should be aligned to the right
  * @param {Boolean} [searchBox], when expanded, include a search box that highlights the searched text
  * @param {Boolean} [selectIcon], show an icon to the right of the element when selected
  * @param {Boolean} [showCheckboxes], show checkboxes next to selected options (only for multi-select); default: false
  * @param {String} [remark], remark text to show under the dropdown box
  * @param {Boolean} [showTags], show tags insearch bar with selected options (only for multi-select); default: false
  * @param {Boolean} [preventUnselect], (single-select dropdowns only) prevent the user from removing the selected option by clicking on it again
  * @param {String} [boxType], type of the dropdown box. Possible values: "fixed", "label", "search", "button-primary", "button-secondary", "button-borderless", or "inline." Default value is "label."
  * @param {String} [helperText], a helper text to show below the options list
  * @param {String} inputType, type of the list of options that will be displayed. Possible values: "menu", "single-select" or "multi-select." Default is "menu."
  * @param {String} [label], floating header label
  * @param {String} [placeholder], initial text to be overwritten
  * @param {Array} options, data array with the options that will be displayed. ex: {id: '2', label: 'text to display', htmlId: 'option-2'}. id is option value, label is text to display in dropdown, htmlId is optional to set <li> ID.
  * @param {Array} [selected], array of selected elements
  * @param {Function} [onExpandedChange], callback when expanded/collapsed state changes
  * @param {Function} [onMenuClick], callback when a menu option is clicked
  * @param {Function} [onValueChange], callback on clicking a value that returns current seelcted for single select, and option and bool selected when multiselect
  * @example
  * <unity-dropdown
  *   label="Full example"
  *   inputType="single-select"
  *   placeholder="Choose an option"
  *   .options=${dataMock.withEverything}
  *   searchBox=${true}
  *   helperText="Choose any option"
  * >
  *   <!-- This content will appear in a custom content slot below the list of options -->
  *   <unity-button slot="bottom-content" label="Click Me"></unity-button>
  * </unity-dropdown>
  **/

  // === CONSTANTS ===
  // Box Types
  const BOX_TYPE_FIXED = "fixed";
  const BOX_TYPE_LABEL = "label";
  const BOX_TYPE_SEARCH = "search";
  const BOX_TYPE_PRIMARY = "button-primary";
  const BOX_TYPE_SECONDARY = "button-secondary";
  const BOX_TYPE_BORDERLESS = "button-borderless";
  const BOX_TYPE_INLINE = "inline";

  // Input Types
  const INPUT_TYPE_MENU = "menu";
  const INPUT_TYPE_SINGLE_SELECT = "single-select";
  const INPUT_TYPE_MULTI_SELECT = "multi-select";

  // === COMPONENT ===
  let UnityDropdown = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityDropdown, _LitElement);
    var _super = _createSuper(UnityDropdown);
    function UnityDropdown() {
      var _this;
      _classCallCheck(this, UnityDropdown);
      _this = _super.call(this);
      _this.autofocus = false;
      _this.disabled = false;
      _this.important = false;
      _this.rightAlign = false;
      _this.searchBox = false;
      _this.selectIcon = true;
      _this.showCheckboxes = false;
      _this.showTags = false;
      _this.preventUnselect = false;
      _this.remark = '';
      _this.boxType = BOX_TYPE_LABEL; // valid values: "label" | "search" | "button-primary" | "button-secondary" | "button-borderless" | "inline"
      _this.helperText = "";
      _this.inputType = INPUT_TYPE_MENU; // valid values: "menu" | "single-select" | "multi-select"
      _this.label = "";
      _this.placeholder = "Choose below";
      _this.onExpandedChange = () => {};
      _this.onMenuClick = () => {};
      _this.onValueChange = () => {};
      _this._expanded = false;
      _this._searchValue = "";
      _this._options = [];
      _this._selected = [];
      _this._visibleOptions = [];
      _this._offsetStyle = "";
      _this._verticalOffset = null;
      _this._horizontalOffset = null;
      _this._dropdown = () => _this.toggleShowDropdown();
      _this._changeValue = id => () => {
        _this.changeSelected(id);
      }; // this is here because arrow functions in lit can only be declared in the constructor
      _this._onInputSearchChange = e => {
        _this.updateSearchValue(e.target.value);
      };
      return _this;
    }
    _createClass(UnityDropdown, [{
      key: "updated",
      value: function updated(changedProperties) {
        if (changedProperties.has("expanded") && !changedProperties.get('expanded')) {
          setTimeout(() => {
            const searchBox = this.shadowRoot.getElementById("dropdown-inner-search-box");
            if (searchBox) {
              const input = searchBox.shadowRoot.getElementById("input");
              input.focus();
            }
          }, 0);
        }
      }
    }, {
      key: "clickedMenu",
      value: function clickedMenu(index) {
        this._searchValue = "";
        this.onMenuClick(index);
        this.toggleShowDropdown();
      }
    }, {
      key: "selected",
      get: function () {
        return this._selected;
      },
      set: function (value) {
        if (this._selected !== value) {
          const oldValue = this._selected;
          let newSelected = _toConsumableArray(value);

          // run parse selection only if there are options
          if (this.options.length > 0) newSelected = this.filterSelection(newSelected);
          this._selected = newSelected;
          this.requestUpdate('selected', oldValue);
        }
      }
    }, {
      key: "options",
      get: function () {
        return this._options;
      },
      set: function (value) {
        if (this._options !== value) {
          const oldValue = this._options;
          this._options = value;
          // Filter options by search text
          this._visibleOptions = this.filterOptionsBySearch(value);
          // run filterSelection to remove invalid options
          if (value.length > 0) this.selected = this.filterSelection(this.selected);
          this.requestUpdate('options', oldValue);
        }
      }
    }, {
      key: "expanded",
      get: function () {
        return this._expanded;
      }

      // takes the list of selected ids and parses out invalids
      // keeps only one if single-select
      ,
      set: function (value) {
        if (this._expanded !== value) {
          const oldValue = this._expanded;
          this._expanded = value;
          this.onExpandedChange(value);
          this.requestUpdate('expanded', oldValue);
          this.updateComplete.then(() => {
            this.getTextBoxSize();
          });
        }
      }
    }, {
      key: "filterSelection",
      value: function filterSelection(selected) {
        const {
          options,
          inputType
        } = this;
        return selected.reduce((newSelected, currentId) => {
          // single-select : keep first found
          if (inputType === INPUT_TYPE_SINGLE_SELECT && newSelected.length === 1) return newSelected;
          // find selection in options
          const found = options.find(_ref => {
            let {
              id
            } = _ref;
            return id === currentId;
          });
          // if valid, keep in selected
          if (!!found) return [].concat(_toConsumableArray(newSelected), [currentId]);
          // else remove from selected
          return newSelected;
        }, []);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(UnityDropdown.prototype), "connectedCallback", this).call(this);
        this._visibleOptions = this.options;
        this.addEventListener("iron-overlay-canceled", this._delayedClose); // collapse component when clicking outside options box
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(UnityDropdown.prototype), "disconnectedCallback", this).call(this);
        this.removeEventListener("iron-overlay-canceled", this._delayedClose);
      }
    }, {
      key: "_delayedClose",
      value: function _delayedClose() {
        setTimeout(this.collapse.bind(this), 0);
      }

      /**
       * Update array of selected values depending on select type.
       * @param {Number} value selected value
       */
    }, {
      key: "changeSelected",
      value: function changeSelected(value) {
        this.selected = this.inputType === INPUT_TYPE_SINGLE_SELECT ? this.handleSingleSelect(value) : this.handleMultiSelect(value);
      }

      /**
       * Substitute array of selected values for array with new value, or empty array if the value was already selected.
       * @param {String} id
       */
    }, {
      key: "handleSingleSelect",
      value: function handleSingleSelect(id) {
        this.expanded = false;
        if (!this.preventUnselect) {
          const newSelected = this.selected[0] === id ? [] : [id];
          this.onValueChange(newSelected[0]);
          return newSelected;
        }
        // Fall-through - maintain selection when clicking same element
        this.onValueChange(id);
        return [id];
      }

      /**
       * Update array of selected values by adding / removing the new value from the array.
       * @param {String} id
       */
    }, {
      key: "handleMultiSelect",
      value: function handleMultiSelect(id) {
        const {
          selected: priorSelected
        } = this;
        const selectedIndex = priorSelected.indexOf(id);
        const isSelected = selectedIndex !== -1;
        const newSelected = isSelected ? priorSelected.slice(0, selectedIndex).concat(priorSelected.slice(selectedIndex + 1)) : [].concat(_toConsumableArray(priorSelected), [id]);
        this.onValueChange([id], !isSelected);
        return newSelected;
      }
    }, {
      key: "updateSearchValue",
      value: function updateSearchValue(newValue) {
        this._searchValue = newValue;
        // expand options list when some text is written
        if (this.boxType === BOX_TYPE_SEARCH) {
          this.expanded = this._searchValue.length > 0;
        }
        // update visible values filtered by search text
        this._visibleOptions = this.filterOptionsBySearch();
      }

      //Can pass in list of options, which defaults to this.options
      //Filters by this._searchValue
    }, {
      key: "filterOptionsBySearch",
      value: function filterOptionsBySearch() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options;
        const searchRegex = new RegExp(this._searchValue, "i");
        return options.filter(option => searchRegex.test(option.label));
      }
    }, {
      key: "collapse",
      value: function collapse() {
        this.expanded = false;
      }
    }, {
      key: "toggleShowDropdown",
      value: function toggleShowDropdown() {
        if (!this.disabled) {
          this.expanded = !this.expanded;
        }
      }
    }, {
      key: "optionKeyDown",
      value: function optionKeyDown(event, id) {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.changeSelected(id);
        }
      }
    }, {
      key: "renderLeftIcon",
      value: function renderLeftIcon(icon) {
        return html$1`<div class="icon-left-wrapper">
      ${this.renderIcon(icon)}
    </div> `;
      }
    }, {
      key: "renderIcon",
      value: function renderIcon(icon) {
        return html$1`<iron-icon class="inner-icon" icon="${icon}"}"></iron-icon>`;
      }

      // TODO: extract the different conditions in another component
    }, {
      key: "renderOption",
      value: function renderOption(option) {
        const isSelected = this.selected.includes(option.id);
        let label = option.label;

        // highlight searched text
        if (this.searchBox) {
          const start = label.toString().toLowerCase().indexOf(this._searchValue.toLowerCase());
          let end = start + this._searchValue.length;
          if (start >= 0) {
            label = html$1`${label.slice(0, start)}<span class="text-highlight">${label.substring(start, end)}</span>${label.slice(end)}`;
          }
        }

        // emphasize selected option
        // index = this.options.indexOf(label)
        label = html$1`<span class="${isSelected ? 'bold-text' : ''}">${label}</span>`;
        if (this.inputType === INPUT_TYPE_MULTI_SELECT) {
          const isSelected = this.selected.includes(option.id);
          return html$1`
        <li id=${option.htmlId || option.id} class="selectable" @click=${this._changeValue(option.id)} tabindex=0 @keydown=${e => this.optionKeyDown(e, option.id)}>
          <div class="option-label-wrapper">
            ${this.showCheckboxes ? html$1`
              <unity-checkbox class="icon-left-wrapper custom-checkbox"
                id=${`checkbox-${option.id}`}
                ?checked="${isSelected ? true : null}"
                ?controlled="${true}"
              ></unity-checkbox>
            ` : html$1``}
            ${!!option.icon ? this.renderLeftIcon(option.icon) : null}
            <p>${label}</p>
          </div>
          ${!!option.comment ? html$1`<p class="option-comment">${option.comment}</p>` : null}
        </li>
      `;
        } else {
          return html$1`
        <li id=${option.htmlId || option.id} class="selectable" @click=${this._changeValue(option.id)} tabindex=0 @keydown=${e => this.optionKeyDown(e, option.id)}>
          <div class="option-label-wrapper">
            ${!!option.icon ? this.renderLeftIcon(option.icon) : null}
            <p class="option-label">${label}</p>
            ${this.selectIcon && option.id === this.selected[0] ? html$1`
              <div class="icon-right-wrapper selected-icon">
                <iron-icon class="inner-icon" icon="unity:check"}"></iron-icon>
              </div>` : null}
          </div>
          ${!!option.comment ? html$1`<p class="option-comment">${option.comment}</p>` : null}
        </li>
      `;
        }
      }

      /**
       * Get label to show in the input box.
       * @return {Object} Current selected value or or values, empty object if none
       */
    }, {
      key: "getSelectedOptions",
      value: function getSelectedOptions() {
        const {
          options,
          selected,
          inputType
        } = this;
        if (inputType === INPUT_TYPE_SINGLE_SELECT) {
          return options.find(_ref2 => {
            let {
              id
            } = _ref2;
            return id === selected[0];
          }) || {};
        }
        if (inputType === INPUT_TYPE_MULTI_SELECT) {
          const label = selected.reduce((selectedLabels, selection) => {
            const {
              label
            } = options.find(_ref3 => {
              let {
                id
              } = _ref3;
              return id === selection;
            }) || {};
            if (!label) return selectedLabels;
            if (!selectedLabels) return label;
            return `${selectedLabels}, ${label}`;
          }, '');
          return {
            label
          };
        }
        return {};
      }
    }, {
      key: "inputBoxKeyDown",
      value: function inputBoxKeyDown(e) {
        // don't close dropdown when space is pressed on a text input
        // also prevent event propagation if Tab is pressed for inner search box only to avoid losing the focus
        if (e.keyCode === 32 || e.key === 'Tab' && e.target.id === "dropdown-inner-search-box") {
          e.stopPropagation();
        }
      }
    }, {
      key: "renderSearchBox",
      value: function renderSearchBox() {
        return html$1`
      <div class="search-box">
        <unity-text-input
          id="dropdown-inner-search-box"
          @keydown=${this.inputBoxKeyDown}
          value="${this._searchValue}"
          .onChange="${this._onInputSearchChange}"
          .innerLeftIcon="${"unity:search"}"
          .borderEffects=${false}
          .hideErrors=${true}
        ></unity-text-input>
      </div>
    `;
      }
    }, {
      key: "renderTag",
      value: function renderTag(id) {
        const {
          label = '',
          icon
        } = this.options.find(option => option.id === id) || {};
        return html$1`
      <div class="tag">
        ${icon && this.renderIcon(icon)}
        <span class="tag-text">${label}</span>
        <div class="close-tag-button" @click="${() => this.changeSelected(id)}">
          <iron-icon class="inner-icon selectable" icon="unity:close"></iron-icon>
        </div>
      </div>
    `;
      }
    }, {
      key: "renderTags",
      value: function renderTags() {
        return html$1`
      <div class="tag-list">
        ${this.selected.map(id => this.renderTag(id))}
      </div>
    `;
      }
    }, {
      key: "handleDropdownKeydown",
      value: function handleDropdownKeydown(e) {
        const {
          key,
          keyCode
        } = e;

        // open/close dropdown with spacebar; also open with down arrow
        if (keyCode === 32 || key === 'ArrowDown' && !this._expanded) {
          e.preventDefault();
          this._dropdown();
          this.shadowRoot.querySelector('.dropdown-menu').focus(); // focus dropdown box again
          return;
        }

        // close dropdown before moving focus to next element
        if (this._expanded && key === "Tab") {
          this._dropdown();
        }

        // use down arrow to navigate through options
        if (this._expanded && (key === 'ArrowDown' || key === 'ArrowUp')) {
          e.preventDefault();
          const options = this.shadowRoot.querySelectorAll('li');
          const focusedOption = this.shadowRoot.querySelector('li:focus');
          let toFocus;
          if (focusedOption) {
            toFocus = key === 'ArrowDown' ? focusedOption.nextElementSibling : focusedOption.previousElementSibling;
          }
          // select first / last option depending on the direction
          // this also wraps navigation from first to last and viceversa, because nextElementSibling/previousElementSibling will be null in those situations
          if (!toFocus) {
            toFocus = key === 'ArrowDown' ? options[0] : options[options.length - 1];
          }
          toFocus.focus();
        }
      }

      // TODO: possibly needs refactoring
    }, {
      key: "getInputBox",
      value: function getInputBox() {
        const {
          boxType,
          important,
          selected,
          disabled,
          showTags,
          placeholder,
          inputType,
          _dropdown,
          expanded
        } = this;
        const anySelected = selected.length > 0;
        let label, icon;
        if (anySelected) {
          const option = this.getSelectedOptions();
          label = option.label;
          icon = option.icon;
        } else {
          label = icon = "";
        }
        const isMulti = inputType === INPUT_TYPE_MULTI_SELECT;
        const isButton = boxType === BOX_TYPE_PRIMARY || boxType === BOX_TYPE_SECONDARY || boxType === BOX_TYPE_BORDERLESS;
        const arrowIcon = !expanded ? "unity:down_chevron" : "unity:up_chevron";
        if (boxType === BOX_TYPE_FIXED) {
          return html$1`
        <div class="text-box input-box ${!!disabled ? 'disabled' : ''}">
          ${isMulti && showTags ? this.renderTags() : null}
          <div class="input-label-div${!showTags ? " no-tags" : ""}">
            <div class="displayed-wrapper">
              <p id="displayed">
                <b>${placeholder}</b>
              </p>
            </div>
          </div>
        </div>`;
        }
        if (boxType === BOX_TYPE_LABEL) {
          return html$1`
        <div class="text-box input-box ${!!disabled ? 'disabled' : ''}">
          ${anySelected && showTags ? this.renderTags() : null}
          <div class="input-label-div${!showTags ? " no-tags" : ""} selectable" @click="${_dropdown}">
            <div class="displayed-wrapper">
              ${!showTags && !isMulti && !!icon ? this.renderLeftIcon(icon) : null}
              ${showTags && anySelected ? null : html$1`
                <p id="displayed" class=${!anySelected && inputType !== INPUT_TYPE_MENU ? "placeholder" : ""}>
                  ${label || placeholder}
                </p>`}
            </div>
            <div class="icon-right-wrapper chevron">
              <iron-icon
                id="dropdown-expand-toggle-icon"
                class="inner-icon"
                icon="${arrowIcon}"
              ></iron-icon>
            </div>
          </div>
        </div>`;
        }
        if (boxType === BOX_TYPE_SEARCH) {
          return html$1`
        <div class="text-box input-box ${!!disabled ? 'disabled' : ''}">
          <unity-text-input
            id="search-input"
            @keydown=${this.inputBoxKeyDown}
            value="${this._searchValue}"
            hideBorder=${true}
            .onChange="${this._onInputSearchChange}"
            placeholder=${placeholder}
            .borderEffects=${false}
            .autofocus=${this.autofocus}
            .hideErrors=${true}
          ></unity-text-input>
          <div class="icon-right-wrapper chevron" @click="${_dropdown}">
            <iron-icon class="inner-icon" icon="${arrowIcon}"></iron-icon>
          </div>
        </div>
      `;
        }
        if (isButton) {
          return html$1`
        <unity-button
          class="dropdown-button"
          label="${label || placeholder}"
          rightIcon="${arrowIcon}"
          type="${boxType.slice(7)}"
          ?important="${important || null}"
          ?disabled=${disabled}
          @click="${_dropdown}"
        ></unity-button>
      `;
        }
        if (boxType === BOX_TYPE_INLINE) {
          return html$1`
        <div class="selectable text-box inline ${!!disabled ? 'disabled' : ''}" @click="${_dropdown}">
          <div class="displayed-wrapper">
            ${!isMulti && !!icon ? this.renderLeftIcon(icon) : null}
            ${label || placeholder}
          </div>
          <div class="icon-right-wrapper chevron">
            <iron-icon class="inner-icon" icon="${arrowIcon}"></iron-icon>
          </div>
        </div>
      `;
        }
      }

      /**
       * Get dropdown div class name.
       * @return {String}
       */
    }, {
      key: "getMenuClass",
      value: function getMenuClass() {
        let className = "dropdown-menu";
        if (this.expanded && (this.boxType === BOX_TYPE_LABEL || this.boxType === BOX_TYPE_SEARCH)) {
          className += " expanded"; // for box shadow and border
        }

        return className;
      }
    }, {
      key: "renderList",
      value: function renderList() {
        const optionsList = this._visibleOptions.map(option => this.renderOption(option));
        return optionsList.every(element => element === null) ? html$1`<p class="helper-text" id="no-matches-text">${NO_MATCHES}</p>` : this.inputType === INPUT_TYPE_MENU ? html$1`
          <unity-select-menu
            .highlighted=${this.selected}
            class="dropdown-select-menu"
            .options=${this._visibleOptions}
            .onMenuClick=${index => this.clickedMenu(index)}
            borderless
          ></unity-select-menu>
        ` : html$1`<ul id="options-list">${optionsList}</ul>`;
      }
    }, {
      key: "renderSelectAll",
      value: function renderSelectAll() {
        const visibleIds = this._visibleOptions.map(x => x.id);
        const select = !visibleIds.every(val => this.selected.includes(val));
        return html$1`
      <div id="select-all" class="text-box selectable" @click=${() => this.selectAll(select)}>
        ${this.renderLeftIcon("unity:box_minus")}
        <p>${select ? SELECT_VISIBLE : DESELECT_VISIBLE}</p>
      </div>
    `;
      }

      /**
       * Check / uncheck all checkboxes and update selected values.
       * @param {bool} select
       */
    }, {
      key: "selectAll",
      value: function selectAll(select) {
        const boxIds = this._visibleOptions.map(option => option.id);
        const selectedSet = new Set(this.selected);
        if (select) {
          boxIds.map(id => selectedSet.add(id));
          const difference = boxIds.filter(x => !this.selected.includes(x));
          this.onValueChange(difference, select);
        } else {
          boxIds.map(id => selectedSet.delete(id));
          const intersection = boxIds.filter(x => this.selected.includes(x));
          this.onValueChange(intersection, select);
        }
        this.selected = Array.from(selectedSet);
      }
    }, {
      key: "renderRemark",
      value: function renderRemark() {
        return html$1`
      <div class="bottom">
        <span class="remark" title="${this.remark}">
          ${this.remark}
        </span>
      </div>
    `;
      }
    }, {
      key: "getTextBoxSize",
      value: function getTextBoxSize() {
        const {
          boxType
        } = this;
        const isButton = boxType === BOX_TYPE_PRIMARY || boxType === BOX_TYPE_SECONDARY || boxType === BOX_TYPE_BORDERLESS;
        let style = "display: none;";
        let horz, vert;
        if (boxType === BOX_TYPE_INLINE) {
          // if inline, match to text length width
          const {
            offsetHeight = 20,
            offsetWidth = 100
          } = this.shadowRoot.querySelector('div.text-box') || {};
          style += `width: ${offsetWidth}px;`;
          horz = null;
          vert = offsetHeight;
        } else if (isButton) {
          // if button, match to button width and fix horz/vert offsets
          const unityButton = this.shadowRoot.querySelector('unity-button.dropdown-button') || {};
          const paperButton = !!unityButton.shadowRoot && unityButton.shadowRoot.querySelector('paper-button.unity-button') || {};
          const {
            offsetHeight = 27,
            offsetWidth = 125
          } = paperButton;
          style += `width: ${offsetWidth}px;`;
          horz = 0;
          vert = offsetHeight + 4;
        } else {
          const {
            offsetWidth = 150,
            offsetHeight = 27
          } = this.shadowRoot.querySelector('div.text-box') || {};
          style += `width: ${offsetWidth}px;`;
          horz = null;
          vert = offsetHeight - 1;
        }
        this._offsetStyle = style;
        this._horizontalOffset = horz;
        this._verticalOffset = vert;
      }
    }, {
      key: "render",
      value: function render() {
        let classes = '';
        if (this.rightAlign) classes = 'right-align';
        return html$1`
      <div>
        ${!!this.label ? html$1`
            <p class="label">
              ${this.label}
            </p>
          ` : null}
        <div class=${this.getMenuClass()} tabindex="0" @keydown="${this.handleDropdownKeydown}">
          ${this.getInputBox()}
            <paper-dialog
              .noAutoFocus="${true}"
              id="options-dialog"
              ?opened="${this.expanded ? true : null}"
              class=${classes}
              .dynamicAlign="${true}"
              .alwaysOnTop="${true}"
              .verticalAlign="${"auto"}"
              .verticalOffset="${this._verticalOffset}"
              .horizontalOffset="${this._horizontalOffset}"
              style="${this._offsetStyle}"
              .scrollAction="${"cancel"}"
            >
              ${this.searchBox ? this.renderSearchBox() : null}
              ${this.inputType === INPUT_TYPE_MULTI_SELECT ? this.renderSelectAll() : null}
              ${this.renderList()}
              ${!!this.helperText ? html$1`<p class="helper-text" id="helper-text">${this.helperText}</p>` : null}
              <slot name="bottom-content"></slot>
            </paper-dialog>
        </div>
        ${!!this.remark ? this.renderRemark() : null}
      </div>
    `;
      }
    }], [{
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --dropdown-background-color: var(--background-color, var(--default-background-color));
          --dropdown-background-color-disabled: var(--light-grey-background-color, var(--default-light-grey-background-color));
          --dropdown-border-color: var(--gray-color, var(--default-gray-color));
          --dropdown-border-color-disabled: var(--gray-color, var(--default-gray-color));
          --dropdown-color: var(--primary-brand-color, var(--default-primary-brand-color));
          --dropdown-color-dark: var(--primary-brand-color-dark, var(--default-primary-brand-color-dark));
          --dropdown-input-font: var(--font-family, var(--default-font-family));
          --dropdown-color-light: var(--light-gray-2-color, var(--default-light-gray-2-color));
          --dropdown-label-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
          --dropdown-line-height: var(--unity-text-input-height, var(--default-unity-text-input-height));
          --dropdown-text-color: var(--black-text-rgb, var(--default-black-text-rgb));
          --dropdown-text-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          --default-dropdown-small-text-size: var(--small-text-size, var(--default-small-text-size));
          --dropdown-button-color: var(--secondary-color, var(--default-secondary-color));
          --dropdown-button-pressed-color: var(--secondary-tint-color, var(--default-secondary-tint-color));
          --dropdown-button-font-color: var(--background-color, var(--default-background-color));
          --default-dropdown-border-radius: 2px;
          --default-dropdown-width: 100%;
          --default-dropdown-border-hover-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-dropdown-search-input-padding: 0;
          --default-dropdown-options-list-max-height: 330px;
          --default-dropdown-highlighted-option-color: var(--sky-blue-tint-1, var(--default-sky-blue-tint-1));
          --default-dropdown-highlighted-option-hover-color: var(--sky-blue-tint-2, var(--default-sky-blue-tint-2));

          font-family: var(--dropdown-input-font);
          border-collapse: collapse;
          user-select: none;
          display: inline-block;
          width: var(--dropdown-width, var(--default-dropdown-width));
        }
        * {
          -moz-box-sizing: border-box;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
        *:focus-visible {
          outline: 1px dotted black;
        }

        unity-checkbox.custom-checkbox {
          --unity-checkbox-size: 14px;
        }
        p {
          margin-block-start: 0.5em;
          margin-block-end: 0.5em;
          padding: 0 8px;
          white-space: normal;
        }
        .label {
          margin-top: 0;
          padding: 0;
          font-size: var(--dropdown-text-size);
          color: var(--dropdown-label-color);
        }
        .list-element-wrapper {
          margin: 0;
        }
        .icon-right-wrapper {
          display: flex;
          flex: 0;
          padding-right: 8px;
        }
        .icon-right-wrapper.chevron {
          padding-right: 4px;
        }
        .icon-left-wrapper {
          padding-left: 8px;
        }
        .inner-icon {
          max-height: 20px;
          max-width: 20px;
        }
        .selected-icon {
          color: var(--dropdown-color);
        }
        .option-label-wrapper {
          display: flex;
          align-items: center;
        }
        .option-label {
          flex: 1;
          overflow: visible;
          white-space: nowrap;
        }
        .text-box:not(.disabled) .icon-right-wrapper {
          cursor: pointer;
        }
        .selectable {
          cursor: pointer;
        }
        ul {
          padding: 0;
          margin: 0;
          list-style: none;
          overflow-y: auto;
          max-height: var(--dropdown-options-list-max-height, var(--default-dropdown-options-list-max-height));
        }
        .dropdown-select-menu {
          --menu-options-list-max-height: var(--dropdown-options-list-max-height, var(--default-dropdown-options-list-max-height));
        }
        #options-dialog {
          border: 1px solid var(--dropdown-border-color);
          border-radius: 0 0 var(--dropdown-border-radius, var(--default-dropdown-border-radius)) var(--dropdown-border-radius, var(--default-dropdown-border-radius));
          background-color: var(--dropdown-background-color);
          z-index: 10;
          position: absolute;
          overflow: hidden;
          width: var(--dropdown-width, var(--default-dropdown-width));
          box-shadow: 0px 2px 4px -1px var(--gray-color);
        }
        .right-align {
          right: 0;
        }
        li {
          font-size: var(--dropdown-text-size);
          font-family: var(--dropdown-input-font);
          background-color: var(--dropdown-background-color);
          box-sizing: border-box;
          margin: 0;
          display: flex;
          flex-direction: column;
        }
        li:hover {
          background-color: var(--dropdown-color-light);
        }
        li:focus {
          background-color: var(--dropdown-color-light);
        }
        li:hover:not(.disabled){
          cursor:pointer;
        }
        .list-element:hover {
          background-color: var(--dropdown-color-light);
        }
        .text-box {
          width: auto;
          background-color: var(--dropdown-background-color);
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-family: var(--dropdown-input-font);
          font-size: var(--dropdown-text-size);
        }
        .input-box {
          border: 1px solid var(--dropdown-border-color);
          border-radius: var(--dropdown-border-radius, var(--default-dropdown-border-radius));
          height: var(--dropdown-line-height);
          overflow: hidden;
        }
        div.dropdown-menu {
          position: relative;
        }
        .dropdown-menu.expanded .input-box{
          border: 1px solid var(--dropdown-border-hover-color, var(--default-dropdown-border-hover-color));
        }
        .input-box:not(.disabled):hover {
          border: 1px solid var(--dropdown-border-hover-color, var(--default-dropdown-border-hover-color));
        }
        .expanded .input-box {
          border-radius: var(--dropdown-border-radius, var(--default-dropdown-border-radius)) var(--dropdown-border-radius, var(--default-dropdown-border-radius)) 0 0;
        }
        .selectable:hover:not(.disabled){
          cursor:pointer;
        }
        .displayed-wrapper {
          display: flex;
          flex: 1;
          overflow: hidden;
        }
        #displayed {
          margin: 0;
          align-self: center;
          color: rgb(var(--dropdown-text-color));
          border: 0;
          background-color: transparent;
          white-space: nowrap;
        }
        .disabled {
          border-color: var(--dropdown-border-color-disabled);
          background-color: var(--dropdown-background-color-disabled);
          color: rgba(var(--dropdown-text-color), .4);
        }
        .disabled #displayed {
          color: var(--dark-grey-text-color);
        }
        .disabled .input-label-div {
          cursor: default !important;
        }
        .placeholder {
          color: var(--light-grey-text-color) !important;
        }
        .disabled .placeholder {
          color: var(--dropdown-border-color-disabled) !important;
        }
        .input-box:hover:not(.disabled) .placeholder {
          color: var(--dropdown-border-hover-color, var(--default-dropdown-border-hover-color)) !important;
        }
        .dropdown-menu.expanded .placeholder {
          color: var(--dropdown-border-hover-color, var(--default-dropdown-border-hover-color)) !important;
        }
        .option-comment {
          font-size: 0.9em;
          line-height: 1.2em;
          margin-top: 0;
        }
        .helper-text {
          font-size: 10px;
          text-align: center;
          background-color: var(--dropdown-background-color);
        }
        .search-box {
          margin: 2px;
          padding: 0;
        }
        .text-highlight {
          background-color: var(--dropdown-color-light);
        }
        .bold-text {
          font-weight: bold;
        }
        unity-text-input {
          width: 100%;
        }
        .tag {
          display: flex;
          flex: 0;
          align-items: center;
          background-color: #D8D8D8;
          width: auto;
          border-radius: 2px;
          margin: 2px;
          padding: 0 2px;
        }
        .tag-list {
          display: flex;
          flex: 1;
          flex-basis: auto;
          overflow: hidden;
        }
        .tag-text {
          padding: 0 4px;
          white-space: nowrap;
        }
        /* these two styles are required to get proper rendering
           of all tags and multi-select options */
        .input-label-div {
          display: flex;
          flex: 1;
          flex-basis: auto;
        }
        .input-label-div.no-tags {
          width: 100%;
        }
        .inline {
          width: max-content;
          color: var(--dropdown-color);
        }
        .inline:hover {
          color: var(--dropdown-color-dark);
        }
        #select-all {
          border-bottom: 1px solid var(--dropdown-border-color);
          margin: 0;
          padding: 0;
        }
        unity-select-menu {
          width: 100%;
          margin: 0;
          padding: 0;
          max-width: unset;
          --highlighted-option-color: var(--dropdown-highlighted-option-color, var(--default-dropdown-highlighted-option-color));
          --highlighted-option-hover-color: var(--dropdown-highlighted-option-hover-color, var(--default-dropdown-highlighted-option-hover-color));
        }
        paper-dialog {
          margin: 0;
          box-shadow: none;
          display: flex;
          flex-direction: column;
        }
        unity-button.dropdown-button {
          --button-color: var(--dropdown-button-color);
          --pressed-color: var(--dropdown-button-pressed-color);
          --font-color: var(--dropdown-button-font-color);
        }
        #search-input {
          padding: var(--dropdown-search-input-padding, var(--default-dropdown-search-input-padding));
        }
        .bottom {
          margin: 0;
          padding-top: 4px;
          display: flex;
          flex-direction: row;
          height: 20px;
          position: absolute;
        }
        .remark {
          flex: 1;
          word-break: break-word;
          font-size: var(--dropdown-small-text-size, var(--default-dropdown-small-text-size));
          color: var(--dropdown-label-color);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      `];
      }
    }, {
      key: "properties",
      get: function () {
        return {
          autofocus: {
            type: Boolean
          },
          disabled: {
            type: Boolean
          },
          expanded: {
            type: Boolean
          },
          important: {
            type: Boolean
          },
          rightAlign: {
            type: Boolean
          },
          searchBox: {
            type: Boolean
          },
          selectIcon: {
            type: Boolean
          },
          showCheckboxes: {
            type: Boolean
          },
          showTags: {
            type: Boolean
          },
          preventUnselect: {
            type: Boolean
          },
          remark: {
            type: String
          },
          boxType: {
            type: String
          },
          helperText: {
            type: String
          },
          inputType: {
            type: String
          },
          label: {
            type: String
          },
          placeholder: {
            type: String
          },
          options: {
            type: Array
          },
          selected: {
            type: Array
          },
          onExpandedChange: {
            type: Function
          },
          onMenuClick: {
            type: Function
          },
          onValueChange: {
            type: Function
          },
          _searchValue: {
            type: String
          },
          _dropdown: {
            type: Function
          },
          _changeValue: {
            type: Function
          },
          _onInputSearchChange: {
            type: Function
          },
          _offsetStyle: {
            attribute: false
          },
          _verticalOffset: {
            attribute: false
          },
          _horizontalOffset: {
            attribute: false
          }
        };
      }
    }]);
    return UnityDropdown;
  }(LitElement);
  window.customElements.define('unity-dropdown', UnityDropdown);

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const styles = css$1`
:host{text-align:center;border-radius:var(--spectrum-dropzone-border-radius,var(--spectrum-alias-border-radius-regular));padding:var(--spectrum-dropzone-padding,var(--spectrum-global-dimension-size-900));border:var(--spectrum-dropzone-border-width,var(--spectrum-alias-border-size-thick)) dashed var(--spectrum-dropzone-border-color,var(--spectrum-global-color-gray-300))}:host([dragged]){border-style:solid;border-color:var(--spectrum-dropzone-border-color-selected-hover,var(--spectrum-global-color-blue-400));background-color:var(--spectrum-dropzone-background-color-selected-hover,var(--spectrum-alias-highlight-selected))}:host(:focus){outline:0;border-style:dashed;border-color:var(--spectrum-dropzone-border-color,var(--spectrum-global-color-gray-300))}:host(:focus.focus-visible){border-style:solid;border-color:var(--spectrum-dropzone-border-color-selected-hover,var(--spectrum-global-color-blue-400))}:host([dragged]) ::slotted(*){color:var(--spectrum-global-color-blue-400)}:host(:focus) ::slotted(*){color:var(--spectrum-global-color-static-gray-500,#bcbcbc)}:host(:focus.focus-visible[dragged]) ::slotted(*){color:var(--spectrum-global-color-blue-400)}:host{display:block;--spectrum-dropzone-illustration-color:var(--spectrum-global-color-static-blue-400)}:host([dragged]) ::slotted(*){--spectrum-global-color-gray-500:var(--spectrum-dropzone-illustration-color)}
`;
  var dropzoneStyles = styles;

  /**
   * @slot default - This is the illustrated message slot
   */
  let Dropzone = /** @class */(() => {
    let Dropzone = /*#__PURE__*/function (_LitElement) {
      _inherits(Dropzone, _LitElement);
      var _super = _createSuper(Dropzone);
      function Dropzone() {
        var _this;
        _classCallCheck(this, Dropzone);
        _this = _super.apply(this, arguments);
        _this._dropEffect = 'copy';
        _this.isDragged = false;
        _this.debouncedDragLeave = null;
        return _this;
      }
      _createClass(Dropzone, [{
        key: "dropEffect",
        get: function () {
          return this._dropEffect;
        },
        set: function (value) {
          /* istanbul ignore else */
          if (['copy', 'move', 'link', 'none'].includes(value)) {
            this._dropEffect = value;
          }
        }
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          _get(_getPrototypeOf(Dropzone.prototype), "connectedCallback", this).call(this);
          this.addEventListener('drop', this.onDrop);
          this.addEventListener('dragover', this.onDragOver);
          this.addEventListener('dragleave', this.onDragLeave);
        }
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          _get(_getPrototypeOf(Dropzone.prototype), "disconnectedCallback", this).call(this);
          this.removeEventListener('drop', this.onDrop);
          this.removeEventListener('dragover', this.onDragOver);
          this.removeEventListener('dragleave', this.onDragLeave);
        }
      }, {
        key: "onDragOver",
        value: function onDragOver(event) {
          const shouldAcceptEvent = new CustomEvent('sp-dropzone-should-accept', {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: event
          });
          // dispatch event returns true if preventDefault() is not called
          const shouldAccept = this.dispatchEvent(shouldAcceptEvent);
          if (!event.dataTransfer) {
            return;
          }
          if (!shouldAccept) {
            event.dataTransfer.dropEffect = 'none';
            return;
          }
          event.preventDefault();
          this.clearDebouncedDragLeave();
          this.isDragged = true;
          event.dataTransfer.dropEffect = this.dropEffect;
          const dragOverEvent = new CustomEvent('sp-dropzone-dragover', {
            bubbles: true,
            composed: true,
            detail: event
          });
          this.dispatchEvent(dragOverEvent);
        }
      }, {
        key: "onDragLeave",
        value: function onDragLeave(event) {
          this.clearDebouncedDragLeave();
          this.debouncedDragLeave = window.setTimeout(() => {
            this.isDragged = false;
            const dragLeave = new CustomEvent('sp-dropzone-dragleave', {
              bubbles: true,
              composed: true,
              detail: event
            });
            this.dispatchEvent(dragLeave);
          }, 100);
        }
      }, {
        key: "onDrop",
        value: function onDrop(event) {
          event.preventDefault();
          this.clearDebouncedDragLeave();
          this.isDragged = false;
          const dropEvent = new CustomEvent('sp-dropzone-drop', {
            bubbles: true,
            composed: true,
            detail: event
          });
          this.dispatchEvent(dropEvent);
        }
      }, {
        key: "render",
        value: function render() {
          return html$1`
            <slot></slot>
        `;
        }
      }, {
        key: "clearDebouncedDragLeave",
        value: function clearDebouncedDragLeave() {
          if (this.debouncedDragLeave) {
            clearTimeout(this.debouncedDragLeave);
            this.debouncedDragLeave = null;
          }
        }
      }], [{
        key: "styles",
        get: function () {
          return [dropzoneStyles];
        }
      }]);
      return Dropzone;
    }(LitElement);
    Dropzone.is = 'sp-dropzone';
    __decorate([property({
      type: Boolean,
      reflect: true,
      attribute: 'dragged'
    })], Dropzone.prototype, "isDragged", void 0);
    return Dropzone;
  })();

  /*
  Copyright 2020 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  /* istanbul ignore else */
  if (!customElements.get('sp-dropzone')) {
    customElements.define('sp-dropzone', Dropzone);
  }

  /**
   * Dropzone for uploading files
   * @name UnityDropzone
   * @param {''} accept, filtype string to allow for the upload, supports regex, should match expected standards for best functionality, default: ''
   * @param {function} onUpload, callback function that receives the uploaded file
   * @param {bool} disabled, controls if dropzone should be disabled and not upload filed
   * @param {bool} hideIcon, controls if center icon should render, default: false
   * @param {''} dropzoneText, the text that makes up the main label, will be replaced with invalid text, default: 'Drag and Drop a file here'
   * @param {''} invalidText, the text that will show when an invalid file is given, defailt: 'Invalid file type'
   * @example
   * <unity-dropzone
   *   .onUpload="${file => async this.handleUpload(file)}"
   *   ?disabled="${zoneDisabled}"
   *   hideIcon
   *   accept="application/json"
   * />
   *
   * CSS Vars:
   *   --dropzone-color: changes the component color, uses --success-color for valid and --danger-color for invalid, defaults to dark-grey-text-color
   *   --dropzone-width: width of the dropzone, defaults to 300px
   *   --dropzone-height height of the dropzone, defaults to 200px
   *   --icon-size: the square size of the icon: defaults to 72px
   */
  let UnityDropzone = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityDropzone, _LitElement);
    var _super = _createSuper(UnityDropzone);
    function UnityDropzone(props) {
      var _this;
      _classCallCheck(this, UnityDropzone);
      _this = _super.call(this, props);
      _this.accept = '';
      _this.onUpload = () => {};
      _this.disabled = false;
      _this.hideIcon = false;
      _this.invalid = null;
      _this.dropzoneText = 'Drag and Drop a file here';
      _this.invalidText = 'Invalid file type';
      return _this;
    }
    _createClass(UnityDropzone, [{
      key: "firstUpdated",
      value: function firstUpdated() {
        this.initDropzoneRef();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(UnityDropzone.prototype), "connectedCallback", this).call(this);
        this.initDropzoneRef();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.removeEventListener('sp-dropzone-drop', this._handleUpload);
        this.removeEventListener('sp-dropzone-should-accept', this._handleAccept);
        this.removeEventListener('sp-dropzone-dragleave', this._cleanZone);
        if (!!this.inputRef) {
          this.inputRef.removeEventListener('change', this._handleUpload);
          this.inputRef = undefined;
        }
      }

      // these are the events that the dropzone uses
      // sp-dropzone-dragleave
      // sp-dropzone-dragover
      // sp-dropzone-drop
      // sp-dropzone-should-accept
    }, {
      key: "initDropzoneRef",
      value: function initDropzoneRef() {
        // bind
        this._handleUpload = this._handleUpload.bind(this);
        this._handleAccept = this._handleAccept.bind(this);
        // add event listeners
        this.addEventListener('sp-dropzone-drop', this._handleUpload);
        this.addEventListener('sp-dropzone-should-accept', this._handleAccept);
        this.addEventListener('sp-dropzone-dragleave', this._cleanZone);

        // get input ref
        if (!this.inputRef) {
          this.inputRef = this.shadowRoot.getElementById('file-input');
          if (!!this.inputRef) {
            window.inputref = this.shadowRoot;
            this.inputRef.addEventListener('change', this._handleUpload);
          }
        }
      }
    }, {
      key: "_handleUpload",
      value: function _handleUpload(e) {
        let {
          disabled,
          invalid,
          inputRef: {
            files: {
              [0]: selectedFile
            } = {}
          } = {}
        } = this;
        const {
          detail: {
            dataTransfer: {
              files: {
                [0]: droppedFile
              } = {}
            } = {}
          } = {}
        } = e || {};
        const upload = droppedFile || selectedFile;
        // invalid check for selected file w/ non-standard accept
        if (invalid === null) invalid = !this._checkType(upload.type);
        !disabled && !invalid && this.onUpload(upload);
        this._cleanZone();
      }
    }, {
      key: "_handleAccept",
      value: function _handleAccept() {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          detail: {
            dataTransfer: {
              items: {
                [0]: {
                  type: filetype
                } = {}
              } = {}
            } = {}
          } = {}
        } = e;
        // make this set by a passed in var
        if (!this._checkType(filetype)) {
          // disabled scroll over changes
          this.invalid = true;
        } else {
          this.invalid = false;
        }
      }
    }, {
      key: "_checkType",
      value: function _checkType(filetype) {
        if (!this.accept) return true;
        return filetype.match(new RegExp(this.accept, 'g'));
      }
    }, {
      key: "_cleanZone",
      value: function _cleanZone() {
        this.updateComplete.then(() => this.invalid = null);
      }
    }, {
      key: "_getClasses",
      value: function _getClasses() {
        const {
          disabled,
          invalid
        } = this;
        if (!!disabled) return 'disabled';
        if (invalid === true) return 'invalid';
        if (invalid === false) return 'valid';
        return '';
      }
    }, {
      key: "render",
      value: function render() {
        const {
          accept,
          disabled,
          invalid,
          hideIcon,
          dropzoneText,
          invalidText
        } = this;
        return html$1`
      <sp-dropzone
        id="dropzone"
        tabindex="1"
        dropEffect="copy"
        class="${this._getClasses()}"
      >
        <div class="drop-area">
          ${hideIcon ? null : html$1`<iron-icon
              icon="unity:file_upload"
              class="upload-icon ${this._getClasses()}"
            ></iron-icon>
          `}
          ${invalid === true ? html$1`
            <unity-typography class="dropzone-text invalid" size="header2">
              ${invalidText}
            </unity-typography>
            ` : html$1`
              <unity-typography class="dropzone-text" size="header2" color="${disabled ? 'light' : 'dark'}">
                ${dropzoneText}
              </unity-typography>
            `}
          <label for="file-input" class="labelText">
            <unity-typography size="paragraph" color="${disabled ? 'light' : 'dark'}">
              Or <span class="ul">Select a File</span>
              from your computer
            </unity-typography>
          </label>
            ${!disabled ? html$1`<input type="file"
              id="file-input"
              .accept="${accept}"
              style="display: none"
            />` : null}
          </div>
        </div>
      </sp-dropzone>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          accept: {
            type: String
          },
          onUpload: {
            type: Function
          },
          disabled: {
            type: Boolean
          },
          hideIcon: {
            type: Boolean
          },
          invalid: {
            attribute: false
          },
          dropzoneText: {
            type: String
          },
          invalidText: {
            type: String
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          display: flex;
          flex-direction: column;
          --dropzone-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
          --dropzone-width: 300px;
          --dropzone-height: 200px;
          --font-color: var(--dropzone-color);
          --icon-size: 72px;
        }
        .invalid {
          --dropzone-color: var(--danger-color, var(--default-danger-color));
          --font-color: var(--dropzone-color);
        }
        .valid {
          --dropzone-color: var(--success-color, var(--default-success-color));
          --font-color: var(--dropzone-color);
        }
        .disabled {
          --dropzone-color: var(--light-grey-text-color, var(--default-light-grey-text-color));
        }
        sp-dropzone {
          border-width: 2px;
          border-style: solid;
          border-color: var(--dropzone-color);
          padding: 1em;
          border-radius: 4px;
          box-sizing: border-box;
          width: var(--dropzone-width);
          height: var(--dropzone-height);
          flex-direction: column;
        }
        label {
          cursor: pointer;
        }
        span.ul {
          text-decoration: underline;
        }
        div.drop-area {
          flex: 1;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          display: flex;
          position: relative;
          height: 100%;
          width: 100%;
        }
        .upload-icon {
          color: var(--dropzone-color);
          margin: 1em;
          height: var(--icon-size);
          width: var(--icon-size);
        }
        .dropText {
          flex: 0;
        }
        .labelText {
          flex: 0;
        }
      `];
      }
    }]);
    return UnityDropzone;
  }(LitElement);
  window.customElements.define('unity-dropzone', UnityDropzone);

  /**
  * Tooltip with optional arrow
  * @name UnityTooltip
  * @param {string} label, the text of the tooltip
  * @param {string} arrow, direction of the tooltip arrow (top, bottom, right or left), optional
  * @param {bool} bottomAlign, if the tooltip should be aligned to the bottom of the reference point
  * @param {bool} rightAlign, if the tooltip should be aligned to the right of the reference point

  * @return {LitElement} returns a class extended from LitElement
  * @example
  * <unity-tooltip
  *   label="I am a tooltip"
  *   arrow="bottom"
  * ></unity-tooltip>
  **/
  let UnityTooltip = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTooltip, _LitElement);
    var _super = _createSuper(UnityTooltip);
    function UnityTooltip() {
      var _this;
      _classCallCheck(this, UnityTooltip);
      _this = _super.call(this);
      _this.label = '';
      _this.arrow = '';
      _this.bottomAlign = false;
      _this.rightAlign = false;
      return _this;
    }
    _createClass(UnityTooltip, [{
      key: "render",
      value: function render() {
        const {
          label,
          arrow,
          bottomAlign,
          rightAlign
        } = this;
        let classes = 'tooltip';
        if (!!arrow) classes += ` arrow ${arrow}`;
        if (bottomAlign) classes += ' bottom-align';
        if (rightAlign) classes += ' right-align';
        return html$1`<span class=${classes}><unity-typography size="paragraph">${label}</unity-typography></span>`;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          label: {
            type: String
          },
          arrow: {
            type: String
          },
          bottomAlign: {
            type: Boolean
          },
          rightAlign: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
      .tooltip {
        position: absolute;
        width: max-content;
        background-color: var(--medium-grey-background-color, var(--default-medium-grey-background-color));
        padding: 2px 8px;
        border-radius: 3px;
      }
      .arrow::after {
        content: " ";
        position: absolute;
        border-width: 5px;
        border-style: solid;
        border-color: var(--medium-grey-background-color, var(--default-medium-grey-background-color)) transparent transparent transparent;
      }
      .left::after {
        left: -8px;
        bottom: 50%;
        margin-bottom: -5px;
        transform: rotate(90deg);
      }
      .bottom::after {
        left: 50%;
        margin-left: -5px;
      }
      .top::after {
        left: 50%;
        margin-left: -5px;
        transform: rotate(180deg);
        top: 0;
        margin-top: -8px;
      }
      .right::after {
        bottom: 50%;
        margin-bottom: -5px;
        transform: rotate(-90deg);
        right: 0;
        margin-right: -8px;
      }
      unity-typography {
        line-height: normal;
      }
      .right-align {
        right: 0;
      }
      .bottom-align {
        bottom: 0;
      }
      `];
      }
    }]);
    return UnityTooltip;
  }(LitElement);
  window.customElements.define('unity-tooltip', UnityTooltip);

  /**
  * Renders a left-bound navigation bar
  * @name UnityGlobalNavInnerItem
  * @param {bool} selected, whether item shows primary-brand-color, ignored if children are passed in
  * @param {func} onSelect, action handler for clicking the element, sends (key, label), ignored if children are passed in
  * @param {''} icon, string unity-icon or iron-icon name, optional
  * @param {''} key, string key for referencing
  * @param {''} label, string label to render for item
  * @param {bool} collapsed,
  * @param {bool} disabled,
  * @param {css} --global-nav-inner-item-color, css var used for styling the component
  * @param {css} --global-nav-inner-item-highlight-color, css var used for styling the component
  * @param {css} --global-nav-inner-item-text-color, var, css var used for styling the component
  * @param {css} --global-nav-inner-item-font-size, css var used for styling the component
  * @param {css} --global-nav-inner-item-height, css var used for styling the component
  * @param {css} --global-nav-inner-item-margin-size, css var used for styling the component
  * @param {css} --global-nav-inner-item-padding-size, css var used for styling the component
  * @param {css} --font-family, css var used for font
  * @return {LitElement} returns a class extended from LitElement
  * @example
  * ${hasChildren && open ? children.map(({key, label, icon, onSelect, selected}) => html`
  * <unity-global-nav-inner-item
  *   .key="${key}"
  *   .onSelect="${onSelect}"
  *   .label="${label}"
  *   .icon="${icon}"
  *   .selected="${selected}"
  * ></unity-global-nav-inner-item>
  **/

  // Left-mounted Global Navigation Bar, only internal variable is bool 'gutter'
  // Has slots for top and bottom aligned items. They will be top or bottom mounted, but render in top-down order
  // To be used with 'unity-nav-top-item's. Others may be used, but may not have intended results.
  // This component is built into the unity-global-nav-top-item, but can be used on it's own
  let UnityGlobalNavInnerItem = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityGlobalNavInnerItem, _LitElement);
    var _super = _createSuper(UnityGlobalNavInnerItem);
    function UnityGlobalNavInnerItem() {
      var _this;
      _classCallCheck(this, UnityGlobalNavInnerItem);
      _this = _super.call(this);
      _this.selected = false;
      _this.label = '';
      _this.key = '';
      _this.icon = '';
      _this.onSelect = () => {};
      _this.collapsed = false;
      _this.disabled = false;
      return _this;
    }
    _createClass(UnityGlobalNavInnerItem, [{
      key: "_onSelect",
      value:
      // uses in onSelect
      function _onSelect(e) {
        const {
          onSelect
        } = this;
        e.stopPropagation();
        if (onSelect instanceof Function) {
          onSelect(this.key, this.label);
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          selected,
          _onSelect,
          key = '',
          label = key,
          icon = '',
          collapsed,
          disabled
        } = this;
        return html$1`
      <div class="container ${selected ? 'selected' : ''}" @click=${!disabled ? _onSelect : null}>
        <div class="label ${collapsed ? 'flex-center' : ''}">
          ${!!icon && icon !== 'undefined' ? html$1`<unity-icon class="icon ${selected ? 'selected' : ''}" icon="${icon}"></unity-icon>` : null}
          ${!collapsed ? html$1`<unity-typography size="paragraph" class="text">${label}</unity-typography>` : html$1`<unity-tooltip arrow="left" label=${label}></unity-tooltip>`}
        </div>
      </div>
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          selected: {
            type: Boolean
          },
          onSelect: {
            type: Function
          },
          label: {
            type: String
          },
          key: {
            type: String
          },
          icon: {
            type: String
          },
          collapsed: {
            type: Boolean
          },
          disabled: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        // CSS vars using the --global-nav-inner-item prefix follow the Unity 2020 designs. The rest are kept for backwards compatibility.
        return [UnityDefaultThemeStyles, css$1`
        :host {
          font-family: var(--font-family, var(--default-font-family));
          --default-global-nav-inner-item-color: var(--global-nav-item-secondary-color, var(--default-global-nav-item-secondary-color));
          --default-global-nav-inner-item-highlight-color: var(--global-nav-item-highlight-color, var(--default-global-nav-item-highlight-color));
          --default-global-nav-inner-item-text-color: var(--global-nav-item-text-color, var(--default-global-nav-item-text-color));
          --default-global-nav-inner-item-font-size: var(--global-nav-item-font-size, var(--default-global-nav-item-font-size));
          --default-global-nav-inner-item-height: var(--global-nav-item-short-height, var(--default-global-nav-item-short-height));
          --default-global-nav-inner-item-margin-size: var(--global-nav-item-margin-size, var(--default-global-nav-item-margin-size));
          --default-global-nav-inner-item-padding-size: var(--global-nav-item-padding-size, var(--default-global-nav-item-padding-size));
          --default-global-nav-inner-item-icon-size: var(--global-nav-item-icon-size, var(--default-global-nav-item-icon-size));
        }
        * {
          box-sizing: border-box;
        }
        .container {
          border-collapse: collapse;
          height: var(--global-nav-inner-item-height, var(--default-global-nav-inner-item-height));
          width: 100%;
          background-color: var(--global-nav-inner-item-color, var(--default-global-nav-inner-item-color));
          cursor: pointer;
          position: relative;
          --font-color: var(--global-nav-inner-item-text-color, var(--default-global-nav-inner-item-text-color));
        }
        .container.disabled {
          cursor: default;
        }
        .container.disabled .label unity-icon, .container.disabled .label unity-typography {
          opacity: 0.5;
        }
        .container:not(.disabled) .label:hover {
          background-color: var(--global-nav-hover-color, var(--default-global-nav-hover-color));
        }
        .selected {
          color: var(--global-nav-inner-item-highlight-color, var(--default-global-nav-inner-item-highlight-color)) !important;
          --font-color: var(--global-nav-inner-item-highlight-color, var(--default-global-nav-inner-item-highlight-color));
        }
        .label {
          display: flex;
          position: relative;
          flex-wrap: nowrap;
          align-items: center;
          height: 100%;
          padding: 0 calc(var(--global-nav-inner-item-padding-size, var(--default-global-nav-inner-item-padding-size)) * 2);
          min-height: var(--global-nav-inner-item-height, var(--default-global-nav-inner-item-height));
        }
        .selected.container::before {
          content: "";
          padding-right: 3px;
          background: var(--global-nav-inner-item-highlight-color, var(--default-global-nav-inner-item-highlight-color));
          display: block;
          height: 100%;
          position: absolute;
          z-index: 1;
        }
        .text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0 var(--global-nav-inner-item-margin-size, var(--default-global-nav-inner-item-margin-size));
          --font-size: var(--global-nav-inner-item-font-size, var(--default-global-nav-inner-item-font-size));
        }
        .icon {
          height: var(--global-nav-inner-item-icon-size, var(--default-global-nav-inner-item-icon-size));
          width: var(--global-nav-inner-item-icon-size, var(--default-global-nav-inner-item-icon-size));
          color: var(--global-nav-inner-item-text-color, var(--default-global-nav-inner-item-text-color));
          --layout-inline_-_display: initial;
        }
        unity-tooltip {
          position: absolute;
          display: none;
          right: -6px;
          top: 25%;
          --font-color: var(--global-nav-inner-item-text-color, var(--default-global-nav-inner-item-text-color));
        }
        .label:hover unity-tooltip {
          display: block;
        }
        .flex-center {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
        }
        .flex-center .text {
          flex: unset;
        }
      `];
      }
    }]);
    return UnityGlobalNavInnerItem;
  }(LitElement);
  window.customElements.define('unity-global-nav-inner-item', UnityGlobalNavInnerItem);

  /**
  * Renders a left-bound navigation bar
  * @name UnityGlobalNavTopItem
  * @param {bool} short, bool to control if element is short or tall
  * @param {bool} selected, whether item shows as selected. If children are passed in, this is ignored.
  * @param {func} onSelect, action handler for clicking the element, sends (key, label), ignored if children are passed in
  * @param {''} icon, string unity-icon or iron-icon name, optional
  * @param {''} key, string key for referencing
  * @param {''} label, string label to render for item
  * @param {bool} collapsed,
  * @param {bool} disabled,
  * @param {bool} open, if true, the top nav item is exapnded and child links are visible
  * @param {func} onOpen, action handler for when top nav item is opened or closed. Arguments are key and current open state
  * @param {bool} openNeighbor, if true, the next item is an open nav-top-item, so bottom border should be hidden
  * @param {bool} borderWhenClosed, if true, there will always be a border, even when the item is not expanded
  * @param {[]} children, list of child items
  * @param {css} --global-nav-background-color, css var used for coloring the component
  * @param {css} --global-nav-expanded-color, css var used for coloring the component
  * @param {css} --primary-brand-color, var, css var used for coloring the component
  * @param {css} --global-nav-border-color, css var used for coloring the component
  * @param {css} --global-nav-text-color, css var used for coloring the component
  * @param {css} --font-family, css var used for font
  * @return {LitElement} returns a class extended from LitElement
  * @example
  * <unity-global-nav gutter
  *   logo="../path/to/hosted/logo"
  * >
  *   <unity-global-nav-top-item
  *     slot="top"
  *     key="home"
  *     label="Home View">
  *     icon="home"
  *     .selected="${selectionTracker === 'home'}"
  *     .onSelect="${() => select('home')}"
  *   </unity-global-nav-top-item>
  *   ${menuItems.map(({slot, key, label, short, icon}) => html`
  *     <unity-global-nav-top-item
  *       slot="${slot}"
  *       .key="${key}"
  *       .label="${label}">
  *       .icon="${icon}"
  *       .selected="${selectionTracker === key}"
  *       .onSelect="${(key: itemKey, label) => select(itemKey)}"
  *     </unity-global-nav-top-item>
  *   `)}
  * </unity-global-nav>
  **/

  // Menu items designed to fit inside of left-bound Global Nav
  // Has properties for key, label, and icon that are always available.
  // Has bool selected and func onSelect, which are disabled when children is passed in (see below).
  // Can take array chidlren for sub items, array of objects {key, label, selected, onSelect}
  // Disables selected and replaces onSelect with own expand/contract control
  let UnityGlobalNavTopItem = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityGlobalNavTopItem, _LitElement);
    var _super = _createSuper(UnityGlobalNavTopItem);
    function UnityGlobalNavTopItem() {
      var _this;
      _classCallCheck(this, UnityGlobalNavTopItem);
      _this = _super.call(this);
      _this.selected = false;
      _this.short = false;
      _this.borderWhenClosed = false;
      _this.label = '';
      _this.key = '';
      _this.icon = '';
      _this.onSelect = () => {};
      _this.children = [];
      _this.collapsed = false;
      _this.disabled = false;
      _this.open = false;
      _this._open = false;
      _this.onOpen = () => {};
      _this.openNeighbor = false;
      return _this;
    }
    _createClass(UnityGlobalNavTopItem, [{
      key: "open",
      get: function () {
        return this._open;
      },
      set: function (value) {
        const oldValue = this._open;
        this._open = value;
        this.requestUpdate('open', oldValue);
      }

      // either uses passed in onSelect, or toggles open to show/hide children
    }, {
      key: "_onSelect",
      value: function _onSelect() {
        const {
          children,
          onSelect
        } = this;
        if (Array.isArray(children) && children.length > 1) {
          this.open = !this._open;
          this.onOpen(this.key, this._open, children);
        } else if (Array.isArray(children) && children.length === 1) {
          const {
            onSelect,
            key,
            label
          } = children[0];
          onSelect(key, label);
        } else if (onSelect instanceof Function) {
          onSelect(this.key, this.label);
        }
      }
    }, {
      key: "getLabel",
      value: function getLabel(hasIcon) {
        let {
          collapsed,
          label = this.key,
          short,
          children
        } = this;
        if (!label || collapsed && hasIcon) return '';
        // use child label if only one label
        if (Array.isArray(children) && children.length === 1) label = children[0].label;
        if (collapsed && !hasIcon) label = label[0];
        return html$1`<unity-typography size="paragraph" weight="medium" class="text">${label}</unity-typography>`;
      }
    }, {
      key: "render",
      value: function render() {
        let {
          short,
          selected,
          _onSelect,
          key = '',
          label = key,
          icon = '',
          children = [],
          open = false,
          collapsed,
          disabled,
          openNeighbor,
          borderWhenClosed
        } = this;
        let hasChildren = Array.isArray(children) && children.length > 0;
        if (hasChildren && children.length === 1) {
          const newItem = children[0];
          selected = newItem.selected;
          key = newItem.key;
          icon = newItem.icon;
          hasChildren = false;
        }
        const hasIcon = !!icon && icon !== String(undefined) && icon !== String(NaN) && icon !== String(null);

        // Show selected if (a) it has no children and is selected, or (b) it has a child that is selected and is collapsed
        const childIsSelected = hasChildren && children.some(child => child && !!child.selected);
        const styleAsSelected = !hasChildren && selected || !open && childIsSelected;
        return html$1`
      <div
        class="
          container
          ${borderWhenClosed && !open ? 'closed-with-border' : ''}
          ${hasChildren && open ? 'open' : ''}
          ${styleAsSelected ? 'selected' : ''}
          ${disabled ? 'disabled' : ''}
          ${openNeighbor ? 'no-bottom-border' : ''}
        "
        @click=${!disabled ? _onSelect : null}
      >
        <div class="label ${short ? 'short' : 'tall'} ${collapsed ? 'flex-center' : ''}">
          ${hasIcon ? html$1`<unity-icon class="icon ${selected ? 'selected' : ''}" icon="${icon}"></unity-icon>` : null}
          ${this.getLabel(hasIcon)}
          ${collapsed ? html$1`<unity-tooltip arrow="left" label=${label}></unity-tooltip>` : ''}
          ${!collapsed && hasChildren ? html$1`<unity-icon class="icon" icon="${open ? 'unity:down_chevron' : 'unity:right_chevron'}"></unity-icon>` : null}
        </div>
        ${hasChildren && open ? children.map(_ref => {
        let {
          key,
          label,
          icon,
          onSelect,
          selected,
          disabled,
          style
        } = _ref;
        return html$1`
          <unity-global-nav-inner-item
            id="${key}"
            .key="${key}"
            .onSelect="${onSelect}"
            .label="${label}"
            .icon="${icon}"
            .selected="${selected}"
            ?collapsed=${collapsed}
            ?disabled=${disabled}
            style=${styleToString(style)}
          ></unity-global-nav-inner-item>
        `;
      }) : null}
      </div>
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          short: {
            type: Boolean
          },
          borderWhenClosed: {
            type: Boolean
          },
          selected: {
            type: Boolean
          },
          onSelect: {
            type: Function
          },
          label: {
            type: String
          },
          key: {
            type: String
          },
          icon: {
            type: String
          },
          children: {
            type: Array
          },
          collapsed: {
            type: Boolean
          },
          disabled: {
            type: Boolean
          },
          open: {
            type: Boolean
          },
          onOpen: {
            type: Function
          },
          openNeighbor: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        // CSS vars using the --global-nav-item prefix follow the Unity 2020 designs. The rest are kept for backwards compatibility.
        return [UnityDefaultThemeStyles, css$1`
        :host {
          font-family: var(--font-family, var(--default-font-family));
          --border-breakers: var(--global-nav-border-color, var(--default-global-nav-border-color));
          --tall-height: 40px;
          --short-height: 32px;
          --default-global-nav-item-primary-color: var(--global-nav-background-color, var(--default-global-nav-background-color));
          --default-global-nav-item-secondary-color: var(--global-nav-background-color, var(--default-global-nav-background-color));
          --default-global-nav-item-highlight-color: var(--global-nav-highlight-color, var(--default-global-nav-highlight-color));
          --default-global-nav-item-text-color: var(--global-nav-text-color, var(--default-global-nav-text-color));
          --default-global-nav-item-border-color: var(--global-nav-border-color, var(--default-global-nav-border-color));
          --default-global-nav-item-tall-height: var(--global-nav-large-row, var(--tall-height));
          --default-global-nav-item-short-height: var(--global-nav-short-row, var(--short-height));
          --default-global-nav-item-margin-size: var(--global-nav-margin-size, var(--default-global-nav-margin-size));
          --default-global-nav-item-font-size: var(--global-nav-font-size, var(--default-global-nav-font-size));
          --default-global-nav-item-padding-size: var(--global-nav-padding-size, var(--default-global-nav-padding-size));
          --default-global-nav-item-padding-size-sm: var(--global-nav-padding-size-sm, var(--default-global-nav-padding-size-sm));
          --default-global-nav-item-icon-size: 16px;
          border-collapse: collapse;
          user-select: none;
        }
        * {
          box-sizing: border-box;
        }
        .container {
          border-collapse: collapse;
          height: auto;
          min-height: var(--global-nav-item-short-height, var(--default-global-nav-item-short-height));
          width: 100%;
          background-color: var(--global-nav-item-primary-color, var(--default-global-nav-item-primary-color));
          position: relative;
          cursor: pointer;
          --font-color: var(--global-nav-item-text-color, var(--default-global-nav-item-text-color));
        }
        .container.disabled {
          cursor: default;
        }
        .container.disabled .label unity-icon, .container.disabled .label unity-typography {
          opacity: 0.5;
        }
        .container:not(.disabled) .label:hover {
          background-color: var(--global-nav-hover-color, var(--default-global-nav-hover-color));
        }
        .selected {
          color: var(--global-nav-item-highlight-color, var(--default-global-nav-item-highlight-color)) !important;
          --font-color: var(--global-nav-item-highlight-color, var(--default-global-nav-item-highlight-color));
        }
        .selected.container::before {
          content: "";
          padding-right: 3px;
          background: var(--global-nav-item-highlight-color, var(--default-global-nav-item-highlight-color));
          display: block;
          height: 100%;
          position: absolute;
          z-index: 1;
        }
        .closed-with-border {
          border-bottom: 1px solid var(--global-nav-item-border-color, var(--border-breakers));
        }
        .open {
          background-color: var(--global-nav-item-secondary-color, var(--default-global-nav-item-secondary-color));
          border-top: 1px solid var(--global-nav-item-border-color, var(--border-breakers));
          border-bottom: 1px solid var(--global-nav-item-border-color, var(--border-breakers));
          padding-bottom: var(--global-nav-item-padding-size-sm, var(--defauult-global-nav-item-padding-size-sm));
        }
        .open.no-bottom-border {
          border-bottom: none;
        }
        .label {
          display: flex;
          position: relative;
          flex-wrap: nowrap;
          min-height: var(--global-nav-item-short-height, var(--default-global-nav-item-short-height));
          font-weight: 500;
          align-items: center;
          height: 100%;
          padding: 0 var(--global-nav-item-padding-size, var(--default-global-nav-item-padding-size));
        }
        .open .label {
          min-height: var(--global-nav-item-tall-height, var(--default-global-nav-item-tall-height));
        }
        .text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          --font-size: var(--global-nav-item-font-size, var(--default-global-nav-item-font-size));
          --medium-weight: bold;
        }
        unity-icon + .text {
          margin: 0 var(--global-nav-item-margin-size, var(--default-global-nav-item-margin-size));
        }
        .icon {
          height: var(--global-nav-item-icon-size, var(--default-global-nav-item-icon-size));
          width: var(--global-nav-item-icon-size, var(--default-global-nav-item-icon-size));
          color: var(--global-nav-item-text-color, var(--default-global-nav-item-text-color));
          --layout-inline_-_display: initial;
        }
        .short {
          min-height: var(--global-nav-item-short-height, var(--default-global-nav-item-short-height));
        }
        .tall {
          min-height: var(--global-nav-item-tall-height, var(--default-global-nav-item-tall-height));
        }
        unity-tooltip {
          position: absolute;
          display: none;
          right: -6px;
          top: 25%;
          --font-color: var(--global-nav-item-text-color, var(--default-global-nav-item-text-color));
        }
        .label:hover unity-tooltip {
          display: block;
        }
        .flex-center {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
        }
        .flex-center .text {
          flex: unset;
        }
      `];
      }
    }]);
    return UnityGlobalNavTopItem;
  }(LitElement);
  window.customElements.define('unity-global-nav-top-item', UnityGlobalNavTopItem);

  /**
  * Renders a left-bound navigation bar
  * @name UnityGlobalNavBase
  * @param {bool} [gutter], show or hide the side gutter
  * @param {string} [logo], path to hosted logo image. If not specified, the unity:app_menu icon will be used
  * @param {string} [header], text to display in the header (e.g., product name). Overwritten by headerImg
  * @param {string} [headerImg], image to display in the header (e.g., product name logo) instead of the header text
  * @param {bool} [collapsible], render button at the bottom to collapse bar
  * @param {bool} [collapsed], if the bar is collapsed or not
  * @param {bool} [grid], if clicking the logo should open the grid menu
  * @param {Object} items, object containing the menu items
  * @param {string} [selected], indicates the key of the item that is selected
  * @param {Function} [onSelect], callback for when a menu item is selected
  * @param {bool} [selectFirstChildOnExpand], determine whether, when expanding an item, the first child will be selected
  * @param {Function} [onToggleCollapse], callback for when the Side Nav is collapsed or expanded. Callback argument is the current collapsed state.
  * @param {Function} [onOpenStateChange], callback for when item openState(s) are set. Arguments are:
  *   - newOpenStates, updated dictionary of open states by key, as in the openStates property
  *   - key, the key of the item that changed open state, if applicable
  *   - openState, the new open state of the element that changed, if applicable
  * @param {object} [openStates], dictionary of item keys with a boolean value for whether that item is "open" (children are visible)
  * @param {bool} [alwaysShowBordersTop], if true, top items will have borders even when closed
  * @param {bool} [alwaysShowBordersBottom], if true, bottom items will have borders even when closed
  * @param {bool} [bubbleBottomItems], if true, bottom items will appear in a "bubble"
  * @param {bool} [subHeaderBorder], add a bordered area below the header for the subHeader slot. If no subHeader content, this just doubles the width of the border below the header
  * @param {css} --global-nav-background-color, css var used for coloring the component
  * @param {css} --global-nav-expanded-color, css var used for coloring the component
  * @param {css} --primary-brand-color, var, css var used for coloring the component
  * @param {css} --global-nav-text-color, css var used for coloring the component
  * @param {css} --global-nav-border-color, css var used for coloring the component
  * @param {slot} customHeader, slot for entire header content, intended to be used in lieu of logo and header image
  * @param {slot} customExpandedHeader, slot for header content that is visible only when expanded, intended to be used in lieu of header image
  * @param {slot} subHeader, slot for content below the header, used in conjunction with subHeaderBorder
  * @param {slot} collapsedSubHeader, slot for content below the header when the nav bar is in collapsed state, to use in conjunction with subHeader and only if collapsible=true

  * @return {LitElement} returns a class extended from LitElement
  * @example
  * <unity-global-nav gutter
  *   logo="../path/to/hosted/image"
  *   header="ProductName"
  *   items={{
        top: [
        {
          key: 'item-0',
          label: 'Top Item 0',
          short: false,
          icon: 'account-balance'
        }]
      }}
  * >
  * </unity-global-nav>
  **/

  // Left-mounted Global Navigation Bar, only internal variable is bool 'gutter'
  // Has slots for top and bottom aligned items. They will be top or bottom mounted, but render in top-down order
  // To be used with 'unity-nav-top-item's. Others may be used, but may not have intended results.
  let UnityGlobalNavBase = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityGlobalNavBase, _LitElement);
    var _super = _createSuper(UnityGlobalNavBase);
    function UnityGlobalNavBase() {
      var _this;
      _classCallCheck(this, UnityGlobalNavBase);
      _this = _super.call(this);
      _this.gutter = false;
      _this.subHeaderBorder = false;
      _this.logo = '';
      _this.collapsible = false;
      _this.collapsed = false;
      _this.items = {};
      _this.onSelect = () => {};
      _this.selected = '';
      _this.header = '';
      _this.headerImg = '';
      _this.grid = false;
      _this.onToggleCollapse = () => {};
      _this.onOpenStateChange = () => {};
      _this.openStates = {};
      _this.alwaysShowBordersTop = false;
      _this.alwaysShowBordersBottom = false;
      _this.bubbleBottomItems = false;
      _this.selectFirstChildOnExpand = false;
      _this._itemClicked = key => {
        _this._changeSelection(key);
      };
      _this._showGrid = false;
      _this._openStates = {};
      _this._items = {};
      return _this;
    }
    _createClass(UnityGlobalNavBase, [{
      key: "items",
      get: function () {
        return this._items;
      },
      set: function (value) {
        const oldValue = this._items;
        this._items = value;
        this.constructOpenStatesDictionary(value);
        this.requestUpdate('items', oldValue);
      }
    }, {
      key: "openStates",
      get: function () {
        return this._openStates;
      },
      set: function (value) {
        const oldValue = this._openStates;
        this._openStates = value;
        this.requestUpdate('openStates', oldValue);
      }
    }, {
      key: "constructOpenStatesDictionary",
      value: function constructOpenStatesDictionary(items) {
        if (!items) return;
        if (!Array.isArray(items)) {
          // We received a top level items object
          this.constructOpenStatesDictionary(items.top);
          this.constructOpenStatesDictionary(items.bottom);
          return;
        }
        const newOpenStateDict = items.reduce((openStateDict, item) => {
          const {
            key
          } = item;
          if (!key) return openStateDict;
          return _objectSpread2$1(_objectSpread2$1({}, openStateDict), {}, {
            [key]: false
          });
        }, {});
        this._openStates = _objectSpread2$1(_objectSpread2$1({}, newOpenStateDict), this._openStates);
        this.onOpenStateChange(this._openStates);
      }
    }, {
      key: "_changeSelection",
      value: function _changeSelection(key) {
        this.onSelect(key);
      }
    }, {
      key: "_toggleCollapse",
      value: function _toggleCollapse() {
        this.collapsed = !this.collapsed;
        this.onToggleCollapse(this.collapsed);
      }
    }, {
      key: "_toggleGrid",
      value: function _toggleGrid() {
        this._showGrid = !this._showGrid;
      }
    }, {
      key: "_onOpenTopItem",
      value: function _onOpenTopItem(key, openState, children) {
        this._setOpenState(key, openState);
        if (this.selectFirstChildOnExpand && !!openState) {
          const [{
            key: firstChildKey
          } = {}] = children || [];
          if (this.selected !== firstChildKey) this._changeSelection(firstChildKey);
        }
      }
    }, {
      key: "_setOpenState",
      value: function _setOpenState(key, open) {
        this._openStates = _objectSpread2$1(_objectSpread2$1({}, this._openStates), {}, {
          [key]: open
        });
        this.onOpenStateChange(this._openStates, key, open);
      }
    }, {
      key: "renderItems",
      value: function renderItems(items, alwaysShowBorders) {
        return items.map((_ref, index) => {
          let {
            key,
            label,
            short,
            icon,
            children,
            disabled,
            style,
            borderWhenClosed
          } = _ref;
          // Determine if next item is open, if so, set openNeighbor to true
          const isLast = index === items.length - 1;
          const nextKey = !isLast && items[index + 1].key;
          const nextOpenState = !isLast && this._openStates[nextKey];
          const hasOpenNeighbor = !isLast && nextOpenState === undefined || !!nextOpenState;
          return html$1`
        <unity-global-nav-top-item
          id="${key}"
          .key="${key}"
          .onSelect="${this._itemClicked}"
          .label="${label}"
          .icon="${icon}"
          .short="${short}"
          .selected="${this.selected === key}"
          .children="${children && children.map(child => _objectSpread2$1(_objectSpread2$1({}, child), {}, {
          onSelect: this._itemClicked,
          selected: this.selected === child.key
        }))}"
          ?collapsed=${this.collapsed}
          ?disabled=${disabled}
          ?open=${this._openStates[key]}
          .onOpen=${this._onOpenTopItem.bind(this)}
          ?openNeighbor=${hasOpenNeighbor}
          ?borderWhenClosed=${!hasOpenNeighbor && (alwaysShowBorders || borderWhenClosed)}
          style=${styleToString(style)}
        ></unity-global-nav-top-item>
      `;
        });
      }
    }, {
      key: "render",
      value: function render() {
        const {
          gutter,
          logo,
          collapsible,
          collapsed,
          items,
          headerImg,
          header,
          grid,
          bubbleBottomItems,
          subHeaderBorder,
          _showGrid
        } = this;
        const {
          bottom,
          top
        } = items;
        return html$1`
        <div class="menu text${collapsed ? ' collapsed' : ''}${gutter ? ' gutter' : ''}${_showGrid ? ' shadowless' : ''}">
          <div class="header-container">
            <slot name="customHeader">
              <div class="logo-container flex-center ${grid ? 'clickable' : ''}" @click=${grid ? this._toggleGrid : null}>
                <div class="logo">
                  <img src=${logo}>
                </div>
              </div>
              ${!collapsed ? headerImg ? html$1`<img style="padding: 0 var(--global-nav-padding-size-sm, var(--default-global-nav-padding-size-sm));" src=${headerImg}>` : html$1`<unity-typography class="header" size="header1" weight="header1" color="dark">${header}</unity-typography>` : ''}
            </slot> 
             ${!collapsed ? html$1`<slot name="customExpandedHeader"></slot>` : ''}
          </div>
          ${!collapsed ? html$1`<slot name="subHeader" class="${subHeaderBorder ? 'header-container' : ''}"></slot>` : collapsible ? html$1`<slot name="collapsedSubHeader" class="${subHeaderBorder ? 'header-container' : ''}"></slot>` : ''}

          <div class="menu-box">
            <div class="top-container">
              ${top ? this.renderItems(top, this.alwaysShowBordersTop) : ''}
            </div>
            <div class="bottom-container">
              ${!bubbleBottomItems && bottom ? this.renderItems(bottom, this.alwaysShowBordersBottom) : ''}
            </div>
          </div>
          ${bubbleBottomItems ? html$1`
            <div class="bubble-items-container">
              ${bottom ? this.renderItems(bottom, this.alwaysShowBordersBottom) : ''}
            </div>
          ` : ''}
          ${collapsible ? html$1`
            <div>
              <div class="collapse-button flex-center" @click="${this._toggleCollapse}">
                <unity-icon .icon=${collapsed ? "unity:double_right_chevron" : "unity:double_left_chevron"}></unity-icon>
              </div>
            </div>
          ` : ''}
        </div>
      ${grid && _showGrid ? html$1`<div class="grid"></div>` : ''}
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          gutter: {
            type: Boolean
          },
          subHeaderBorder: {
            type: Boolean
          },
          logo: {
            type: String
          },
          collapsible: {
            type: Boolean
          },
          collapsed: {
            type: Boolean
          },
          items: {
            type: Object
          },
          onSelect: {
            type: Function
          },
          selected: {
            type: String
          },
          header: {
            type: String
          },
          headerImg: {
            type: String
          },
          grid: {
            type: Boolean
          },
          onToggleCollapse: {
            type: Function
          },
          alwaysShowBordersTop: {
            type: Boolean
          },
          alwaysShowBordersBottom: {
            type: Boolean
          },
          bubbleBottomItems: {
            type: Boolean
          },
          selectFirstChildOnExpand: {
            type: Boolean
          },
          _itemClicked: {
            type: Function
          },
          _showGrid: {
            type: Boolean
          },
          _openStates: {
            type: Object
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        // CSS vars using the --global-nav prefix follow the Unity 2020 designs. The rest are kept for backwards compatibility.
        return [UnityDefaultThemeStyles, css$1`
        :host {
          display: flex;
          height: 100%;
          width: max-content;
          --default-gutter-color: var(--primary-brand-color, var(--default-primary-brand-color));
          --default-global-nav-background-color: var(--white-color, var(--default-white-color));
          --default-global-nav-border-color: var(--gray-color, var(--default-gray-color));
          --default-global-nav-margin-size: var(--margin-size-md, var(--default-margin-size-md, 12px));
          --default-global-nav-padding-size: var(--padding-size-md, var(--default-padding-size-md, 12px));
          --default-global-nav-padding-size-sm: var(--padding-size-sm, var(--default-padding-size-sm, 8px));
          --default-global-nav-highlight-color: var(--secondary-color, var(--default-secondary-color));
          --default-global-nav-hover-color: var(--light-gray-2-color, var(--default-light-gray-2-color));
          --default-global-nav-text-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-global-nav-light-text-color: var(--light-gray-1-color, var(--default-light-gray-1-color));
          --default-global-nav-gutter-color: var(--primary-color, var(--default-primary-color));
          --default-global-nav-header-font-size: 14px;
          --default-global-nav-font-size: 12px;
          --default-global-nav-short-row: 32px;
          --default-global-nav-large-row: 40px;
          --default-global-nav-expanded-width: 192px;
          --default-global-nav-collapsed-width: 32px;
          --default-global-nav-logo-size: 12px;
          --default-global-nav-logo-padding: 8px;
          --default-global-nav-menu-shadow: 0 0 4px 0;
        }
        * {
          box-sizing: border-box;
          scrollbar-width: none;
        }
        *::-webkit-scrollbar {
          width: 0px;
        }
        .gutter {
          border-right: 5px solid var(--global-nav-gutter-color, var(--gutter-color));
        }
        .menu {
          display: flex;
          flex-direction: column;
          width: var(--global-nav-expanded-width, var(--default-global-nav-expanded-width));
          height: 100%;
          background-color: var(--global-nav-background-color, var(--default-global-nav-background-color));
          box-shadow: var(--global-nav-menu-shadow, var(--default-global-nav-menu-shadow));
          border-right: 1px solid var(--global-nav-border-color, var(--default-global-nav-border-color));
        }
        .menu.shadowless {
          box-shadow: none;
        }
        .text {
          color: var(--global-nav-text-color, var(--default-global-nav-text-color));
        }
        .collapsed {
          width: var(--global-nav-collapsed-width, var(--default-global-nav-collapsed-width));
        }
        .logo-container {
          height: var(--global-nav-short-row, var(--default-global-nav-short-row));
          width: var(--global-nav-short-row, var(--default-global-nav-short-row));
          min-height: var(--global-nav-short-row, var(--default-global-nav-short-row));
          min-width: var(--global-nav-short-row, var(--default-global-nav-short-row));
          border-right: 1px solid var(--global-nav-border-color, var(--default-global-nav-border-color));
          padding: var(--global-nav-logo-padding, var(--default-global-nav-logo-padding));
        }
        .logo-container.clickable {
          cursor: pointer;
        }
        .header-container {
          display: flex;
          border-bottom: 1px solid var(--global-nav-border-color, var(--default-global-nav-border-color));
          align-items: center;
        }
        .logo {
          display: flex;
          color: var(--global-nav-highlight-color, var(--default-global-nav-highlight-color));
          height: var(--global-nav-logo-size, var(--default-global-nav-logo-size));
          width: var(--global-nav-logo-size, var(--default-global-nav-logo-size));
          --layout-inline_-_display: initial;
        }
        .menu-box {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          justify-content: space-between;
          height: 100%;
          width: 100%;
          overflow-y: auto;
          overflow-x: hidden;
        }
        .top-container {
          width: 100%;
          border-collapse: collapse;
        }
        .bottom-container {
          min-height: min-content;
          width: 100%;
          border-collapse: collapse;
        }
        .bubble-items-container {
          margin: 4px;
          border: 1px solid var(--global-nav-light-text-color, var(--default-global-nav-light-text-color));
          border-radius: 2px;
          min-height: min-content;
        }
        unity-icon {
          color: var(--global-nav-highlight-color, var(--default-global-nav-highlight-color));
          height: var(--global-nav-logo-size, var(--default-global-nav-logo-size));
          width: var(--global-nav-logo-size, var(--default-global-nav-logo-size));
          --layout-inline_-_display: initial;
        }
        .collapse-button {
          height: 24px;
          border: 1px solid var(--global-nav-light-text-color, var(--default-global-nav-light-text-color));
          margin: 4px;
          border-radius: 2px;
          cursor: pointer;
        }
        .collapse-button unity-icon {
          height: 16px;
          width: 16px;
          color: var(--global-nav-text-color, var(--defaultglobal-nav-text-color));
        }
        .flex-center {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        unity-typography {
          margin: 0 var(--global-nav-margin-size, var(--default-global-nav-margin-size));
          --header1-font-size: var(--global-nav-header-font-size, --default-global-nav-header-font-size);
          --header1-font-weight: bold;
          --font-color: var(--global-nav-text-color, var(--default-global-nav-text-color));
        }
        .grid{
          height: 100%;
          width: 320px;
          background-color: var(--global-nav-background-color, var(--default-global-nav-background-color));
          box-shadow: 0 1px 10px 4px rgba(0, 0, 0, 0.25);
          z-index: -1;
        }
        img {
          min-width: 0;
          flex: 1;
          max-width: 100%;
          height: auto;
          object-fit: contain;
        }
      `];
      }
    }]);
    return UnityGlobalNavBase;
  }(LitElement);
  window.customElements.define('unity-global-nav-base', UnityGlobalNavBase);

  const MIN_PANE_WIDTH$1 = 20; // %
  /**
   * A container to hold two views:
   *   1) one which will hold main content to always be rendered and fit to the full view
   *   2) and one to act in a modal-like fashion, to hold contextual information, and cause
   *      the other view to shrink in view but not in function
   * @name UnityMultiPane
   * @param {Boolean} closeButton, controls if the overlapping close button is rendered
   * @param {Boolean} collapseButton, controls whether the collapse button is rendered
   * @param {Object} labels, text to show inside the bars when the main pane is collapsed, {paneKey: label, ...}
   * @param {Function} onClose, function to call when the close button is clicked
   * @param {Function} onCollapseChange, function to call when the collapse changes, true for collapsed, false for expanded
   * @param {Array} visiblePanes, list of panes to be visible, first pane is always visible
   * @param {Array} collapsedPanes, list of panes to be collapsed

   * @example
   *   <unity-multi-pane
   *     closeButton
   *     collapseButton
   *     labels={main: "Multi Pane"}
   *     show=${showDetails}
   *     onClose="${toggleShowDetails}"
   *   >
   *     <div slot="main">
   *       Content
   *     </div>
   *     <div slot="pane">
   *       Details
   *     </div>
   *   </unity-multi-pane>
   *
   * CSS variables:
   *   --border-color       -
   *   --bar-border-color
   *   --background
   *   --bar-background
   *   --pane-border-width
   *   --pane-border-color
   *   --pane-z-index
   *   --bar-width
   *   --header-border
   *   --collapse-button-padding
   *   --close-button-padding
   */

  const shouldUpdateSet = (one, two) => {
    if (one.size !== two.size) return true;
    for (let key of two) {
      if (!one.has(key)) return true;
    }
    return false;
  };
  const clipPaneWidth = width => {
    if (width < MIN_PANE_WIDTH$1) {
      return MIN_PANE_WIDTH$1;
    } else if (width > 100 - MIN_PANE_WIDTH$1) {
      return 100 - MIN_PANE_WIDTH$1;
    } else {
      return width;
    }
  };
  let UnityMultiPane = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityMultiPane, _LitElement);
    var _super = _createSuper(UnityMultiPane);
    function UnityMultiPane() {
      var _this;
      _classCallCheck(this, UnityMultiPane);
      _this = _super.call(this);
      _this._labels = {};
      _this.closeButton = false;
      _this.collapseButton = false;
      _this._visiblePanes = new Set();
      _this._collapsedPanes = new Set();
      _this.paneWidths = {};
      _this.onClose = () => {};
      _this.onCollapseChange = () => {};

      // internals
      _this._startingX = 0;
      _this._paneKeys = new Set();
      return _this;
    }
    _createClass(UnityMultiPane, [{
      key: "paneKeys",
      get: function () {
        return this._paneKeys;
      },
      set:
      // when paneKeys is updated, it will set it's value before checking visiblePanes, labels, or paneWidths,
      // but it won't consider it an update until after the other three have finished
      function (value) {
        const {
          visiblePanes,
          collapsedPanes,
          _paneKeys: oldValue,
          labels
          // paneWidths
        } = this;
        this._paneKeys = value;

        // trigger set to make sure defaults are set
        this.visiblePanes = visiblePanes;
        this.labels = labels;
        this.processWidths();
        this.requestUpdate('paneKeys', oldValue);
      }
    }, {
      key: "visiblePanes",
      get: function () {
        return this._visiblePanes;
      },
      set: function (value) {
        const {
          visiblePanes: oldValue,
          paneKeys
        } = this;
        let unorderedValue = value;
        if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Set)) {
          unorderedValue = Object.entries(value).reduce((list, _ref) => {
            let [key, value] = _ref;
            return !!value ? [].concat(_toConsumableArray(list), [key]) : list;
          }, []);
        }
        unorderedValue = new Set(unorderedValue);
        // order values into new set, starting with first value, just use unorderedValue if paneKeys aren't set
        let newValue = paneKeys.size !== 0 ? new Set([paneKeys.values().next().value]) : unorderedValue;
        for (let pane of paneKeys) {
          if (unorderedValue.has(pane) && paneKeys.has(pane)) newValue.add(pane);
        }
        if (shouldUpdateSet(oldValue, newValue)) {
          this._visiblePanes = newValue;
          this.requestUpdate('visiblePanes', oldValue);
          this.collapsedPanes = this.collapsedPanes;
          this.processWidths();
        }
      }
    }, {
      key: "collapsedPanes",
      get: function () {
        return this._collapsedPanes;
      },
      set: function (value) {
        const {
          visiblePanes
        } = this;
        const oldValue = this.collapsedPanes;
        let uncheckedValue = value;
        if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Set)) {
          uncheckedValue = Object.entries(value).reduce((list, _ref2) => {
            let [key, value] = _ref2;
            return !!value ? [].concat(_toConsumableArray(list), [key]) : list;
          }, []);
        }
        uncheckedValue = new Set(uncheckedValue);

        // check that collapsedPanes are in visiblePanes
        let newValue = new Set();
        for (let pane of uncheckedValue) {
          const isLast = _toConsumableArray(visiblePanes)[visiblePanes.size - 1] === pane;
          if (!isLast && visiblePanes.has(pane)) newValue.add(pane);else if (isLast) this.onCollapseChange({
            key: pane,
            collapsed: false
          });
        }
        if (shouldUpdateSet(oldValue, newValue)) {
          this._collapsedPanes = newValue;
          this.requestUpdate('collapsedPanes', oldValue);
          this.processWidths();
        }
      }
    }, {
      key: "labels",
      get: function () {
        return this._labels;
      },
      set: function (value) {
        const {
          labels: oldValue,
          paneKeys
        } = this;
        let newValue = _objectSpread2$1({}, value);
        let shouldUpdate = false;
        if (paneKeys.size === 0) {
          this._labels = newValue;
          this.requestUpdate('labels', oldValue);
          return;
        }
        // iterate paneKeys to make sure a default label is set, and check for needed update
        for (let key of paneKeys) {
          if (!newValue[key]) newValue[key] = key;
          if (!shouldUpdate && oldValue[key] !== newValue[key]) shouldUpdate = true;
        }
        if (shouldUpdate) {
          this._labels = newValue;
          this.requestUpdate('labels', oldValue);
        }
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(UnityMultiPane.prototype), "connectedCallback", this).call(this);
        this.processSlots();
        this.shadowRoot.addEventListener('slotchange', event => this.processSlots(event));
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.shadowRoot.removeEventListener('slotchange', event => this.processSlots(event));
        _get(_getPrototypeOf(UnityMultiPane.prototype), "disconnectedCallback", this).call(this);
      }

      // gets all slots passed into template, processes to get keys to make slots from
      // skips any ending with ::header or ::footer
    }, {
      key: "processSlots",
      value: function processSlots() {
        // get all slots
        const slottedContent = _toConsumableArray(this.children);
        // iterate to get the keys of just the panes
        const slotKeys = slottedContent.reduce((keys, slottedNodes) => {
          const node = slottedNodes;
          // skip if empty
          if (!node) return keys;
          // skip if slot has ::header || ::footer
          if (/(::header$)|(::footer$)/.test(node.slot)) return keys;
          keys.push(node.slot);
          return keys;
        }, []);
        // make into set
        let newPaneKeys = new Set(slotKeys);
        // compare to current paneKeys to see if update is needed
        const {
          paneKeys
        } = this;
        if (shouldUpdateSet(paneKeys, newPaneKeys)) this.paneKeys = newPaneKeys;
      }
    }, {
      key: "processWidths",
      value: function processWidths() {
        const {
          visiblePanes,
          collapsedPanes
        } = this;

        // get number of visible panes
        // remove factor for each collapsed
        const numPanes = visiblePanes.size - collapsedPanes.size;
        const evenWidth = 100 / numPanes;
        let newPaneWidths = {};
        for (let pane of visiblePanes) {
          if (!collapsedPanes.has(pane)) newPaneWidths[pane] = evenWidth > MIN_PANE_WIDTH$1 ? evenWidth : MIN_PANE_WIDTH$1;
        }
        this.paneWidths = newPaneWidths;
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(e, paneKey, nextPaneKey) {
        this._startingX = e.clientX;
        this.mouseMoveListener = this.handleMouseMove.bind(this, paneKey, nextPaneKey);
        this.mouseUpListener = this.handleMouseUp.bind(this);
        document.addEventListener('mousemove', this.mouseMoveListener);
        document.addEventListener('mouseup', this.mouseUpListener);
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(paneKey, nextPaneKey, e) {
        const {
          shadowRoot,
          paneWidths,
          paneWidths: {
            [nextPaneKey]: nextPaneWidth,
            [paneKey]: paneWidth
          } = {}
        } = this;
        const pane = shadowRoot.getElementById(paneKey);
        const multiPaneWidth = pane.clientWidth * 100 / paneWidth; // get multipane total width
        const deltaX = e.clientX - this._startingX;
        const newWidth = paneWidth + deltaX * 100 / multiPaneWidth; // curent % - increment %

        let newPaneWidth = clipPaneWidth(newWidth);
        const newNextPaneWidth = nextPaneWidth + (paneWidth - newPaneWidth);
        if (newNextPaneWidth <= MIN_PANE_WIDTH$1) newPaneWidth = newPaneWidth - (20 - newNextPaneWidth);
        this.paneWidths = _objectSpread2$1(_objectSpread2$1({}, paneWidths), {}, {
          [nextPaneKey]: clipPaneWidth(newNextPaneWidth),
          [paneKey]: newPaneWidth
        });
        this._startingX = e.clientX;
        e && e.preventDefault && e.preventDefault();
      }

      //clean up event listener
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp() {
        document.removeEventListener('mousemove', this.mouseMoveListener);
        document.removeEventListener('mouseup', this.mouseUpListener);
      }
    }, {
      key: "toggleCollapse",
      value: function toggleCollapse() {
        let paneKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !this.collapsedPanes.has(paneKey);
        // create a new set to avoid unwanted mutations
        let newCollapsedPanes = new Set(this.collapsedPanes);
        if (newCollapsedPanes.has(paneKey) || value === false) newCollapsedPanes.delete(paneKey);else newCollapsedPanes.add(paneKey);
        this.collapsedPanes = newCollapsedPanes;
        this.onCollapseChange({
          key: paneKey,
          collapsed: value
        });
      }
    }, {
      key: "closePane",
      value: function closePane(e, paneKey) {
        let {
          paneKeys,
          visiblePanes
        } = this;
        if (paneKeys.values().next().value !== paneKey) {
          // create a new set to avoid unwanted mutations
          let newVisiblePanes = new Set(visiblePanes);
          newVisiblePanes.delete(paneKey);
          this.visiblePanes = newVisiblePanes;
          this.onClose(paneKey);
        }
      }
    }, {
      key: "handleBarClick",
      value: function handleBarClick(e, paneKey) {
        this.toggleCollapse(paneKey, false);
      }
    }, {
      key: "renderBar",
      value: function renderBar(paneKey) {
        const {
          labels: {
            [paneKey]: label
          }
        } = this;
        return html$1`
      <unity-typography id="collapse-bar" style="display: flex;">
        <div class="bar" @click=${e => this.handleBarClick(e, paneKey)}>
          <div class="bar-icon-wrapper">
            <unity-icon icon="unity:expand_horizontal"></unity-icon>
          </div>
          <div class="bar-label-wrapper">
            <p class="bar-label">${label}</p>
          </div>
        </div>
      </unity-typography>
    `;
      }
    }, {
      key: "renderPane",
      value: function renderPane(paneKey, order) {
        const {
          visiblePanes,
          collapsedPanes,
          collapseButton,
          paneKeys,
          paneWidths: {
            [paneKey]: paneWidth
          } = {},
          closeButton
        } = this;
        const first = order === 0;
        const last = order + 1 === visiblePanes.size;
        const show = first || visiblePanes.has(paneKey);
        const collapsed = !last && collapsedPanes.has(paneKey);
        const paneList = _toConsumableArray(visiblePanes);
        let nextPaneKey = paneKey;
        // iterate over paneKeys, starting at order
        for (let i = order + 1; i < paneList.length && nextPaneKey === paneKey; i++) {
          // if not collapsed, that's next pane
          const key = paneList[i];
          if (!collapsedPanes.has(key)) nextPaneKey = key;
        }
        if (!show) return null;
        return html$1`
      <div
        class="wrapper"
        id="${paneKey}"
        style="width: ${!!paneWidth ? paneWidth : 'unset'}%;"
      >
        ${show && collapsed ? this.renderBar(paneKey) : ''}
        <div class="content${collapsed ? ' hide' : ''}" >
          ${collapseButton && order !== paneKeys.size - 1 ? html$1`
            <unity-button
              class="collapse-button"
              centerIcon="unity:compress"
              @click=${() => this.toggleCollapse(paneKey)}
              type="borderless"
              ?disabled="${last}"
              ></unity-button>
              ` : ''}
          <div class="header">
            <slot name="${paneKey}::header"></slot>
          </div>
          <div class="scroller">
            <slot name="${paneKey}"></slot>
            ${!first && !!closeButton ? html$1`
              <unity-button
                type="borderless"
                class="close-button"
                centerIcon="close"
                @click=${e => this.closePane(e, paneKey)}
              ></unity-button>` : null}
          </div>
          <div class="footer">
            <slot name="${paneKey}::footer"></slot>
          </div>
        </div>
        ${!last ? html$1`<div
          class="resize-handle"
          @mousedown="${e => !collapsed && this.handleMouseDown(e, paneKey, nextPaneKey)}"
        ></div>` : null}
      </div>
    `;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          paneKeys
        } = this;
        return html$1`
      <div class="container">
        ${_toConsumableArray(paneKeys).map((key, i) => this.renderPane(key, i))}
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          labels: {
            type: Object
          },
          closeButton: {
            type: Boolean
          },
          collapseButton: {
            type: Boolean
          },
          onClose: {
            type: Function
          },
          onCollapseChange: {
            type: Function
          },
          visiblePanes: {
            type: Array
          },
          collapsedPanes: {
            type: Array
          },
          paneWidths: {
            type: Object
          },
          paneKeys: {
            attribute: false
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --border-color: var(--gray-color, var(--default-gray-color));
          --bar-border-color: var(--gray-color, var(--default-gray-color));
          --background: var(--white-color, var(--default-white-color));
          --bar-background: var(--background);
          --pane-border-width: 1px;
          --pane-border-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-pane-z-index: 3;
          --bar-width: 40px;
          --header-border: none;
          --collapse-button-padding: var(--padding-size-sm, var(--default-padding-size-sm));
          --close-button-padding: var(--padding-size-sm, var(--default-padding-size-sm));
          background-color: var(--background);
          display: flex;
          flex-direction: row;
          height: 100%;
          width: 100%;
          position: relative;
        }
        .container {
          display: flex;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          flex-direction: row;
          flex: 1;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          overflow-y: hidden;
          position: relative;
        }
        .content {
          height: 100%;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
        }
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: var(--header-border);
        }
        .footer {
          flex: 0;
        }
        slot {
          overflow-wrap: anywhere;
        }
        .scroller {
          flex: 1;
          display: flex;
          overflow-x: auto;
        }
        .scroller ::slotted(*) {
          flex: 1;
          display: flex;
        }
        .main {
          height: 100%;
          width: 100%;
          overflow: auto;
          flex: 1;
          display: flex;
        }
        .main ::slotted(*) {
          width: 100%;
        }
        .pane {
          position: relative;
          border-left: var(--pane-border-width) solid var(--pane-border-color);
          box-sizing: border-box;
          z-index: var(--pane-z-index, var(--default-pane-z-index));
        }
        .hide {
          display: none;
        }
        .collapse-button {
          position: absolute;
          z-index: 10;
          top: 0;
          left: 0;
          padding: var(--collapse-button-padding);
          --unity-button-height: 27px;
        }
        unity-button.close-button {
          position: absolute;
          z-index: 10;
          top: 0;
          right: 0;
          padding: var(--collapse-button-padding);
        }
        .bar {
          width: var(--bar-width);
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          border-right: 1px solid var(--bar-border-color);
          background-color: var(--bar-background);
        }
        .bar-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          height: var(--bar-width);
          width: var(--bar-width);
        }
        .bar-label-wrapper {
          flex: 1;
          display: flex;
          align-items: flex-start;
          white-space: nowrap;
        }
        .bar-label {
          transform: rotate(-90deg) translate(-50%);
          margin: 0;
        }
        .resize-handle {
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          width: 8px;
          cursor: col-resize;
          z-index: 5;
          border-right: var(--pane-border-width) solid var(--pane-border-color);
        }
        unity-icon {
          --unity-icon-height: var(--medium-icon-size, var(--default-medium-icon-size));
          --unity-icon-width: var(--medium-icon-size, var(--default-medium-icon-size));
        }
        #collapse-bar {
          height: 100%;
        }
      `];
      }
    }]);
    return UnityMultiPane;
  }(LitElement);
  window.customElements.define('unity-multi-pane', UnityMultiPane);

  /**
   * Component to display notifications
   * @name UnityNotification
   * @param {string} text, main notification text
   * @param {string} subtext, text to display below the main text
   * @param {string} icon, icon to show in the left side of the notification
   * @param {Function} onClose, callback function to call when clicking the close button
   *
   * CSS vars:
   * --notification-color: color for icon and left bar. Defaults to primary brand color.
   * --notification-height: height of the notification. Defaults to 60px.
   * --notification-width: width of the notification. Defaults to 450px.
   * --notification-button-padding: padding applied to the close button.
   * --notification-z-index: the z-index of the notification. Defaults to 10.
   *
   * @example
   *   <unity-notification
   *     text='This is the main text'
   *     subtext='Some explanatory text, or when was this sent'
   *     icon='unity:share'
   *     .onClose=${()=>console.log('closed')}
   *   >
   *   </unity-notification>
  */
  let UnityNotification = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityNotification, _LitElement);
    var _super = _createSuper(UnityNotification);
    function UnityNotification() {
      var _this;
      _classCallCheck(this, UnityNotification);
      _this = _super.call(this);
      _this.onClose = () => {};
      _this.text = '';
      _this.subtext = '';
      _this.icon = '';
      return _this;
    }
    _createClass(UnityNotification, [{
      key: "render",
      value: function render() {
        const {
          icon,
          onClose,
          subtext,
          text
        } = this;
        const visible = !!text || !!subtext;
        return html$1`
      <div class='notification'>
        <unity-icon icon=${icon}></unity-icon>
        <div class='text-wrapper'>
          <div class="main-text">
            <unity-typography>${text}</unity-typography>
          </div>
          <div class="subtext">
            <unity-typography color='dark' size='small'>${subtext}</unity-typography>
          </div>
        </div>
        ${visible ? html$1`
          <unity-button
            id='close-notification-button'
            type='borderless'
            centerIcon='unity:close'
            @click=${onClose}
          </unity-button>` : html$1`
          <unity-button
            tabindex="-1"
            type='borderless'
            centerIcon='unity:close'
            @click=${onClose}
          </unity-button>
        `}
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          icon: {
            type: String
          },
          text: {
            type: String
          },
          subtext: {
            type: String
          },
          onClose: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --notification-color: var(--primary-brand-color, var(--default-primary-brand-color));
          --notification-height: 60px;
          --notification-width: 450px;
          --default-notification-button-padding: var(--padding-size-sm, var(--default-padding-size-sm));
          --default-notification-z-index: 10;
        }
        .notification {
          display: flex;
          align-items: center;
          width: var(--notification-width);
          height: var(--notification-height);
          background: var(--background-color, var(--default-background-color));
          box-shadow: 0 0 5px 1px rgba(0,0,0,0.25);
          z-index: var(--notification-z-index, var(--default-notification-z-index));
        }
        .notification::before {
          content: "";
          background: var(--notification-color);
          display: block;
          width: 4px;
          height: 100%;
        }
        .text-wrapper {
          flex: 1;
          padding: 12px 0;
          overflow: hidden;
          white-space: nowrap;
        }
        .subtext {
          margin-top: 4px;
        }
        unity-icon {
          color: var(--notification-color);
          margin: 16px;
        }
        unity-button {
          --button-color: var(--default-dark-grey-text-color);
          padding: var(--notification-button-padding, var(--default-notification-button-padding));
        }
      `];
      }
    }]);
    return UnityNotification;
  }(LitElement);
  window.customElements.define('unity-notification', UnityNotification);

  /**
   * Component to control notifications
   * @name UnityNotificationsHandler
   * @param {String} target, (required) a unique name for use with the addNotification function. No two unity-notifications-handler components should share this within one app. Name must be alphanumeric and can contain hyphens (but no other special character).
   * @param {String} position, (optional) position in the container; options are 'top-right', 'top-left', 'bottom-right', and 'bottom-left'. Defaults to 'top-right'.
   * @param {Object} icons, (optional) an object with entries for each type ('success', 'warning', 'error', 'help', 'tip') and the corresponding icons you want for each.
   * @param {Object} colors (optional) an object with entries for each type ('success', 'warning', 'error', 'help', 'tip') and the corresponding colors you want for each.
   * @param {Object} customTypes, (optional) an object with values being new types you want to add and entries
   * @param {Boolean} allowDuplicates, stipulate whether duplicate messages should be allowed
   * @param {Boolean} noAnimation, removes animation for the notifications
   * @param {Function} onClose, callback function to call when clicking the close button
   *
   * CSS vars:
   * --notification-height: height of the notification. Defaults to 60px.
   * --notification-width: width of the notification. Defaults to 450px.
   *
   * @example
   *  // to import addNotification
   *  import { addNotification } from 'smartworks.unity.unity-core/unity-notifications-handler'
   *  // also available in export are closeNotification and clearNotifications
   *
   *  // to add a notification
   *  addNotification({
   *    target: 'foo-notifications',
   *    notification: {
   *      id: 'custom-notification'
   *      text:  'Notification Main Text',
   *      subtext:  'Extra notification information',
   *      // EITHER
   *      type:  'help', // default types are 'success', 'warning', 'error', 'help', 'tip'; you can also add custom types (see below)
   *      // OR
   *      icon: 'unity:help',
   *      color: 'olive' // must be rgb[a], hsl[a], hex, color name, or a css variable
   *    }
   *  })
   *
   *  // in render method
   *    <unity-notifications-handler
   *      target='foo-notifications'
   *      .onClose=${()=>console.log('closed')}
   *      .customTypes=${{
   *        'my-custom-type': {
   *          icon: 'unity:double_right_chevron',
   *          color: 'magenta'
   *        }
   *      }}
   *    >
   *      ${/* ...other content }
   *    </unity-notifications-handler>
  */

  const defaultColors = {
    error: css$1`var(--danger-color, var(--default-error-color))`,
    warning: css$1`var(--danger-lite-color, var(--default-danger-color))`,
    success: css$1`var(--success-color, var(--default-success-color))`,
    tip: css$1`var(--secondary-brand-color, var(--default-secondary-brand-color))`,
    help: css$1`var(--primary-brand-color, var(--default-primary-brand-color))`
  };
  const testValidTarget = target => /^[A-z0-9\-]+$/.test(target);
  const testValidColor = color => /^[A-z0-9\#\(\), \-\.]+$/.test(color);
  let UnityNotificationsHandler = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityNotificationsHandler, _LitElement);
    var _super = _createSuper(UnityNotificationsHandler);
    function UnityNotificationsHandler() {
      var _this;
      _classCallCheck(this, UnityNotificationsHandler);
      _this = _super.call(this);
      _this.position = '';
      _this.target = '';
      _this.icons = {};
      _this.colors = {};
      _this.customTypes = {};
      _this.allowDuplicates = false;
      _this.noAnimation = false;
      _this.onClose = () => {};
      _this._queuedNotifications = [];
      _this._showNotification = false;
      _this._notificationStyle = '';
      _this._topBottomPosition = 'top';
      _this._leftRightPosition = 'right';
      _this._notificationTimeout = null;
      _this._handleAddNotification = _this._handleAddNotification.bind(_assertThisInitialized(_this));
      _this._handleNextNotification = _this._handleNextNotification.bind(_assertThisInitialized(_this));
      _this._handleCloseNotification = _this._handleCloseNotification.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(UnityNotificationsHandler, [{
      key: "firstUpdated",
      value: function firstUpdated() {
        var _this2 = this;
        const {
          target
        } = this;
        if (!target) throw `Target not provided for unity-notifications-handler`;
        if (!testValidTarget(target)) throw `Target ${target} may contain only alphanumeric characters and hyphens`;
        document.addEventListener(`${target}-add`, function () {
          let {
            detail: notification = {}
          } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          _this2._handleAddNotification(notification);
        });
        document.addEventListener(`${target}-close`, this._handleCloseNotification);
        document.addEventListener(`${target}-clear`, this._handleClearNotifications);
        this._calculateStyles();
      }
    }, {
      key: "updated",
      value: function updated(changedProps) {
        if (changedProps.has('_queuedNotifications') || changedProps.has('_showNotification')) this._calculateStyles();
        if (changedProps.has('position')) {
          const {
            position
          } = this;
          const [vertPos, horzPos] = (typeof position === 'string' ? position : '').split('-');
          // only allow 'top' and 'bottom', defaulting to 'top'
          this._topBottomPosition = vertPos !== 'bottom' ? `top` : `bottom`;

          // only allow 'left' 'center', and 'right', defaulting to 'right'
          switch (horzPos) {
            case 'left':
              this._leftRightPosition = 'left';
              break;
            case 'center':
              this._leftRightPosition = 'center';
              break;
            default:
              this._leftRightPosition = 'right';
          }
          this._calculateStyles();
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var _this3 = this;
        const {
          target
        } = this;
        document.removeEventListener(target, function () {
          let {
            detail: notification = {}
          } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          _this3._handleAddNotification(notification);
        });
        document.removeEventListener(`${target}-close`, this._handleCloseNotification);
        document.removeEventListener(`${target}-clear`, this._handleClearNotifications);
      }
    }, {
      key: "_calculateStyles",
      value: function _calculateStyles() {
        const {
          _topBottomPosition,
          _showNotification,
          noAnimation
        } = this;
        const currentNotification = this._queuedNotifications[0];
        if (!currentNotification) {
          this._notificationStyle = `
        ${_topBottomPosition}: calc(-20px - var(--notification-height, 60px));
        opacity: 0;
      `;
          return;
        }

        // prevent css injection:
        const {
          color
        } = currentNotification;
        if (!testValidColor(color)) throw `Color value "${color}" does not pass secure color values test.`;
        this._notificationStyle = `
      --notification-color: ${color};
      ${_topBottomPosition}: ${_showNotification ? `0px` : `calc(-20px - var(--notification-height, 60px))`};
      opacity: ${_showNotification ? `1` : `0`};
    `;
      }
    }, {
      key: "_getIconAndColorFromType",
      value: function _getIconAndColorFromType(type) {
        const options = _objectSpread2$1({
          error: {
            icon: this.icons.error || 'unity:error',
            color: this.colors.error || defaultColors.error
          },
          warning: {
            icon: this.icons.warning || 'unity:error',
            color: this.colors.warning || defaultColors.warning
          },
          success: {
            icon: this.icons.success || 'unity:circle_check',
            color: this.colors.success || defaultColors.success
          },
          tip: {
            icon: this.icons.tip || 'unity:hand_right',
            color: this.colors.tip || defaultColors.tip
          },
          help: {
            icon: this.icons.help || 'unity:help',
            color: this.colors.help || defaultColors.help
          }
        }, this.customTypes);
        return options[type];
      }
    }, {
      key: "_handleAddNotification",
      value: function _handleAddNotification() {
        let notification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          id,
          text,
          subtext,
          type,
          timeout
        } = notification;
        const {
          icon,
          color
        } = this._getIconAndColorFromType(type) || notification;
        if (!icon) throw `Could not retrieve icon.`;
        if (!color) throw `Could not retrieve color.`;

        // Ignore duplicates
        const lastNotification = this._queuedNotifications[0];
        if (!this.allowDuplicates && !!lastNotification && lastNotification.text === text && lastNotification.subtext === subtext && lastNotification.icon === icon) return;
        const newNotification = {
          text,
          subtext,
          icon,
          color,
          timeout,
          id,
          onClose: async () => {
            const closeResult = await this.onClose();
            if (closeResult !== false) this._handleCloseNotification(); // if user returns false, don't close notification (but accept undefined)
          }
        };

        this._queuedNotifications = [].concat(_toConsumableArray(this._queuedNotifications), [newNotification]);
        this._showNotification = true;
        if (!this._queuedNotifications[1] && !!timeout) {
          clearTimeout(this._notificationTimeout);
          this._notificationTimeout = setTimeout(() => {
            this._handleCloseNotification();
          }, timeout);
        }
      }
    }, {
      key: "_handleCloseNotification",
      value: function _handleCloseNotification() {
        if (!this._showNotification) return; // notification is already closed or closing currently
        this._showNotification = false;
        clearTimeout(this._notificationTimeout);
        this._notificationTimeout = setTimeout(this._handleNextNotification, 500); // go to next notification, after animation
      }
    }, {
      key: "_handleNextNotification",
      value: function _handleNextNotification() {
        this._queuedNotifications = this._queuedNotifications.slice(1);
        const nextNotification = this._queuedNotifications[0];
        if (!!nextNotification) {
          this._showNotification = true;
          clearTimeout(this._notificationTimeout);
          this._notificationTimeout = !!nextNotification.timeout ? setTimeout(this._handleCloseNotification, nextNotification.timeout) : null;
        }
      }
    }, {
      key: "_handleClearNotifications",
      value: function _handleClearNotifications() {
        this._showNotification = false;
        this._queuedNotifications = [];
        clearTimeout(this._notificationTimeout);
        this._notificationTimeout = null;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          id = '',
          text = '',
          subtext = '',
          icon = '',
          onClose = () => {}
        } = this._queuedNotifications[0] || {};
        return html$1`
      <div id='container'>
        <unity-notification
          class="${this._topBottomPosition} ${this._leftRightPosition}"
          id=${id}
          .text=${text}
          .subtext=${subtext}
          .icon=${icon}
          .onClose=${onClose}
          style=${this._notificationStyle}
        ></unity-notification>
        <slot></slot>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          // Props/Attributes
          position: {
            type: String
          },
          target: {
            type: String
          },
          icons: {
            type: Object
          },
          colors: {
            type: Object
          },
          customTypes: {
            type: Object
          },
          allowDuplicates: {
            type: Boolean
          },
          noAnimation: {
            type: Boolean
          },
          onClose: {
            type: Function
          },
          // Internals
          _queuedNotifications: false,
          _showNotification: false,
          _notificationStyle: false,
          _topBottomPosition: false,
          _leftRightPosition: false
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --notification-height: 60px;
          --notification-width: 450px;
          --notification-z-index: 10;
          --internal-notification-height: var(--notification-height);
          --internal-notification-width: var(--notification-width);
          --internal-notification-z-index: var(--notification-z-index);

          width: 100%;
        }

        #container {
          overflow-y: hidden;
          overflow-x: visible;
          position: relative;
          height: 100%;
          width: 100%;
        }

        unity-notification {
          display: flex;
          flex-direction: row;
          position: absolute;
          margin: 12px;
          transition: top 500ms, bottom 500ms, opacity 500ms;
          transition-timing-function: ease-out ease-out ease-out;
          z-index: 10;
          --notification-height: var(--internal-notification-height, 60px);
          --notification-width: var(--internal-notification-width, 450px);
          --notification-z-index: var(--internal-notification-z-index, 10);
        }

        .top {
          top: 0;
        }

        .bottom {
          bottom: 0;
        }

        .left {
          left: 0;
        }

        .center {
          left: 50%;
          transform: translateX(-50%);
        }

        .right {
          right: 0;
        }
      `];
      }
    }, {
      key: "addNotification",
      value: function addNotification() {
        let {
          target,
          notification = {}
        } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!target || !testValidTarget(target)) throw `Error: Invalid target: ${target}`;
        const addNotificationEvent = new CustomEvent(`${target}-add`, {
          bubbles: true,
          detail: _objectSpread2$1({}, notification)
        });
        document.dispatchEvent(addNotificationEvent);
      }
    }, {
      key: "closeNotification",
      value: function closeNotification(target) {
        if (!target || !testValidTarget(target)) throw `Error: Invalid target: ${target}`;
        const closeNotificationEvent = new CustomEvent(`${target}-close`, {
          bubbles: true
        });
        document.dispatchEvent(closeNotificationEvent);
      }
    }, {
      key: "clearNotifications",
      value: function clearNotifications(target) {
        if (!target || !testValidTarget(target)) throw `Error: Invalid target: ${target}`;
        const clearNotificationsEvent = new CustomEvent(`${target}-clear`, {
          bubbles: true
        });
        document.dispatchEvent(clearNotificationsEvent);
      }
    }]);
    return UnityNotificationsHandler;
  }(LitElement);
  window.customElements.define('unity-notifications-handler', UnityNotificationsHandler);
  const addNotification = UnityNotificationsHandler.addNotification;
  const closeNotification = UnityNotificationsHandler.closeNotification;
  const clearNotifications = UnityNotificationsHandler.clearNotifications;

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */
  const template$2 = html`<iron-iconset-svg name="paper-tabs" size="24">
<svg><defs>
<g id="chevron-left"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path></g>
<g id="chevron-right"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template$2.content);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /*
  `paper-tab` is styled to look like a tab. It should be used in conjunction with
  `paper-tabs`.

  Example:

      <paper-tabs selected="0">
        <paper-tab>TAB 1</paper-tab>
        <paper-tab>TAB 2</paper-tab>
        <paper-tab>TAB 3</paper-tab>
      </paper-tabs>

  ### Styling

  The following custom properties and mixins are available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--paper-tab-ink` | Ink color | `--paper-yellow-a100`
  `--paper-tab` | Mixin applied to the tab | `{}`
  `--paper-tab-content` | Mixin applied to the tab content | `{}`
  `--paper-tab-content-focused` | Mixin applied to the tab content when the tab is focused | `{}`
  `--paper-tab-content-unselected` | Mixin applied to the tab content when the tab is not selected | `{}`

  This element applies the mixin `--paper-font-common-base` but does not import
  `paper-styles/typography.html`. In order to apply the `Roboto` font to this
  element, make sure you've imported `paper-styles/typography.html`.
  */
  Polymer({
    _template: html`
    <style>
      :host {
        @apply --layout-inline;
        @apply --layout-center;
        @apply --layout-center-justified;
        @apply --layout-flex-auto;

        position: relative;
        padding: 0 12px;
        overflow: hidden;
        cursor: pointer;
        vertical-align: middle;

        @apply --paper-font-common-base;
        @apply --paper-tab;
      }

      :host(:focus) {
        outline: none;
      }

      :host([link]) {
        padding: 0;
      }

      .tab-content {
        height: 100%;
        transform: translateZ(0);
          -webkit-transform: translateZ(0);
        transition: opacity 0.1s cubic-bezier(0.4, 0.0, 1, 1);
        @apply --layout-horizontal;
        @apply --layout-center-center;
        @apply --layout-flex-auto;
        @apply --paper-tab-content;
      }

      :host(:not(.iron-selected)) > .tab-content {
        opacity: 0.8;

        @apply --paper-tab-content-unselected;
      }

      :host(:focus) .tab-content {
        opacity: 1;
        font-weight: 700;

        @apply --paper-tab-content-focused;
      }

      paper-ripple {
        color: var(--paper-tab-ink, var(--paper-yellow-a100));
      }

      .tab-content > ::slotted(a) {
        @apply --layout-flex-auto;

        height: 100%;
      }
    </style>

    <div class="tab-content">
      <slot></slot>
    </div>
`,
    is: 'paper-tab',
    behaviors: [IronControlState, IronButtonState, PaperRippleBehavior],
    properties: {
      /**
       * If true, the tab will forward keyboard clicks (enter/space) to
       * the first anchor element found in its descendants
       */
      link: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      }
    },
    /** @private */
    hostAttributes: {
      role: 'tab'
    },
    listeners: {
      down: '_updateNoink',
      tap: '_onTap'
    },
    attached: function () {
      this._updateNoink();
    },
    get _parentNoink() {
      var parent = dom(this).parentNode;
      return !!parent && !!parent.noink;
    },
    _updateNoink: function () {
      this.noink = !!this.noink || !!this._parentNoink;
    },
    _onTap: function (event) {
      if (this.link) {
        var anchor = this.queryEffectiveChildren('a');
        if (!anchor) {
          return;
        }

        // Don't get stuck in a loop delegating
        // the listener from the child anchor
        if (event.target === anchor) {
          return;
        }
        anchor.click();
      }
    }
  });

  let IronSelection = /*#__PURE__*/function () {
    /**
     * @param {!Function} selectCallback
     * @suppress {missingProvide}
     */
    function IronSelection(selectCallback) {
      _classCallCheck(this, IronSelection);
      this.selection = [];
      this.selectCallback = selectCallback;
    }

    /**
     * Retrieves the selected item(s).
     *
     * @returns Returns the selected item(s). If the multi property is true,
     * `get` will return an array, otherwise it will return
     * the selected item or undefined if there is no selection.
     */
    _createClass(IronSelection, [{
      key: "get",
      value: function get() {
        return this.multi ? this.selection.slice() : this.selection[0];
      }

      /**
       * Clears all the selection except the ones indicated.
       *
       * @param {Array} excludes items to be excluded.
       */
    }, {
      key: "clear",
      value: function clear(excludes) {
        this.selection.slice().forEach(function (item) {
          if (!excludes || excludes.indexOf(item) < 0) {
            this.setItemSelected(item, false);
          }
        }, this);
      }

      /**
       * Indicates if a given item is selected.
       *
       * @param {*} item The item whose selection state should be checked.
       * @return {boolean} Returns true if `item` is selected.
       */
    }, {
      key: "isSelected",
      value: function isSelected(item) {
        return this.selection.indexOf(item) >= 0;
      }

      /**
       * Sets the selection state for a given item to either selected or deselected.
       *
       * @param {*} item The item to select.
       * @param {boolean} isSelected True for selected, false for deselected.
       */
    }, {
      key: "setItemSelected",
      value: function setItemSelected(item, isSelected) {
        if (item != null) {
          if (isSelected !== this.isSelected(item)) {
            // proceed to update selection only if requested state differs from
            // current
            if (isSelected) {
              this.selection.push(item);
            } else {
              var i = this.selection.indexOf(item);
              if (i >= 0) {
                this.selection.splice(i, 1);
              }
            }
            if (this.selectCallback) {
              this.selectCallback(item, isSelected);
            }
          }
        }
      }

      /**
       * Sets the selection state for a given item. If the `multi` property
       * is true, then the selected state of `item` will be toggled; otherwise
       * the `item` will be selected.
       *
       * @param {*} item The item to select.
       */
    }, {
      key: "select",
      value: function select(item) {
        if (this.multi) {
          this.toggle(item);
        } else if (this.get() !== item) {
          this.setItemSelected(this.get(), false);
          this.setItemSelected(item, true);
        }
      }

      /**
       * Toggles the selection state for `item`.
       *
       * @param {*} item The item to toggle.
       */
    }, {
      key: "toggle",
      value: function toggle(item) {
        this.setItemSelected(item, !this.isSelected(item));
      }
    }]);
    return IronSelection;
  }();

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @polymerBehavior
   */
  const IronSelectableBehavior = {
    /**
     * Fired when iron-selector is activated (selected or deselected).
     * It is fired before the selected items are changed.
     * Cancel the event to abort selection.
     *
     * @event iron-activate
     */

    /**
     * Fired when an item is selected
     *
     * @event iron-select
     */

    /**
     * Fired when an item is deselected
     *
     * @event iron-deselect
     */

    /**
     * Fired when the list of selectable items changes (e.g., items are
     * added or removed). The detail of the event is a mutation record that
     * describes what changed.
     *
     * @event iron-items-changed
     */

    properties: {
      /**
       * If you want to use an attribute value or property of an element for
       * `selected` instead of the index, set this to the name of the attribute
       * or property. Hyphenated values are converted to camel case when used to
       * look up the property of a selectable element. Camel cased values are
       * *not* converted to hyphenated values for attribute lookup. It's
       * recommended that you provide the hyphenated form of the name so that
       * selection works in both cases. (Use `attr-or-property-name` instead of
       * `attrOrPropertyName`.)
       */
      attrForSelected: {
        type: String,
        value: null
      },
      /**
       * Gets or sets the selected element. The default is to use the index of the
       * item.
       * @type {string|number}
       */
      selected: {
        type: String,
        notify: true
      },
      /**
       * Returns the currently selected item.
       *
       * @type {?Object}
       */
      selectedItem: {
        type: Object,
        readOnly: true,
        notify: true
      },
      /**
       * The event that fires from items when they are selected. Selectable
       * will listen for this event from items and update the selection state.
       * Set to empty string to listen to no events.
       */
      activateEvent: {
        type: String,
        value: 'tap',
        observer: '_activateEventChanged'
      },
      /**
       * This is a CSS selector string.  If this is set, only items that match the
       * CSS selector are selectable.
       */
      selectable: String,
      /**
       * The class to set on elements when selected.
       */
      selectedClass: {
        type: String,
        value: 'iron-selected'
      },
      /**
       * The attribute to set on elements when selected.
       */
      selectedAttribute: {
        type: String,
        value: null
      },
      /**
       * Default fallback if the selection based on selected with
       * `attrForSelected` is not found.
       */
      fallbackSelection: {
        type: String,
        value: null
      },
      /**
       * The list of items from which a selection can be made.
       */
      items: {
        type: Array,
        readOnly: true,
        notify: true,
        value: function () {
          return [];
        }
      },
      /**
       * The set of excluded elements where the key is the `localName`
       * of the element that will be ignored from the item list.
       *
       * @default {template: 1}
       */
      _excludedLocalNames: {
        type: Object,
        value: function () {
          return {
            'template': 1,
            'dom-bind': 1,
            'dom-if': 1,
            'dom-repeat': 1
          };
        }
      }
    },
    observers: ['_updateAttrForSelected(attrForSelected)', '_updateSelected(selected)', '_checkFallback(fallbackSelection)'],
    created: function () {
      this._bindFilterItem = this._filterItem.bind(this);
      this._selection = new IronSelection(this._applySelection.bind(this));
    },
    attached: function () {
      this._observer = this._observeItems(this);
      this._addListener(this.activateEvent);
    },
    detached: function () {
      if (this._observer) {
        dom(this).unobserveNodes(this._observer);
      }
      this._removeListener(this.activateEvent);
    },
    /**
     * Returns the index of the given item.
     *
     * @method indexOf
     * @param {Object} item
     * @returns Returns the index of the item
     */
    indexOf: function (item) {
      return this.items ? this.items.indexOf(item) : -1;
    },
    /**
     * Selects the given value.
     *
     * @method select
     * @param {string|number} value the value to select.
     */
    select: function (value) {
      this.selected = value;
    },
    /**
     * Selects the previous item.
     *
     * @method selectPrevious
     */
    selectPrevious: function () {
      var length = this.items.length;
      var index = length - 1;
      if (this.selected !== undefined) {
        index = (Number(this._valueToIndex(this.selected)) - 1 + length) % length;
      }
      this.selected = this._indexToValue(index);
    },
    /**
     * Selects the next item.
     *
     * @method selectNext
     */
    selectNext: function () {
      var index = 0;
      if (this.selected !== undefined) {
        index = (Number(this._valueToIndex(this.selected)) + 1) % this.items.length;
      }
      this.selected = this._indexToValue(index);
    },
    /**
     * Selects the item at the given index.
     *
     * @method selectIndex
     */
    selectIndex: function (index) {
      this.select(this._indexToValue(index));
    },
    /**
     * Force a synchronous update of the `items` property.
     *
     * NOTE: Consider listening for the `iron-items-changed` event to respond to
     * updates to the set of selectable items after updates to the DOM list and
     * selection state have been made.
     *
     * WARNING: If you are using this method, you should probably consider an
     * alternate approach. Synchronously querying for items is potentially
     * slow for many use cases. The `items` property will update asynchronously
     * on its own to reflect selectable items in the DOM.
     */
    forceSynchronousItemUpdate: function () {
      if (this._observer && typeof this._observer.flush === 'function') {
        // NOTE(bicknellr): `dom.flush` above is no longer sufficient to trigger
        // `observeNodes` callbacks. Polymer 2.x returns an object from
        // `observeNodes` with a `flush` that synchronously gives the callback any
        // pending MutationRecords (retrieved with `takeRecords`). Any case where
        // ShadyDOM flushes were expected to synchronously trigger item updates
        // will now require calling `forceSynchronousItemUpdate`.
        this._observer.flush();
      } else {
        this._updateItems();
      }
    },
    // UNUSED, FOR API COMPATIBILITY
    get _shouldUpdateSelection() {
      return this.selected != null;
    },
    _checkFallback: function () {
      this._updateSelected();
    },
    _addListener: function (eventName) {
      this.listen(this, eventName, '_activateHandler');
    },
    _removeListener: function (eventName) {
      this.unlisten(this, eventName, '_activateHandler');
    },
    _activateEventChanged: function (eventName, old) {
      this._removeListener(old);
      this._addListener(eventName);
    },
    _updateItems: function () {
      var nodes = dom(this).queryDistributedElements(this.selectable || '*');
      nodes = Array.prototype.filter.call(nodes, this._bindFilterItem);
      this._setItems(nodes);
    },
    _updateAttrForSelected: function () {
      if (this.selectedItem) {
        this.selected = this._valueForItem(this.selectedItem);
      }
    },
    _updateSelected: function () {
      this._selectSelected(this.selected);
    },
    _selectSelected: function (selected) {
      if (!this.items) {
        return;
      }
      var item = this._valueToItem(this.selected);
      if (item) {
        this._selection.select(item);
      } else {
        this._selection.clear();
      }
      // Check for items, since this array is populated only when attached
      // Since Number(0) is falsy, explicitly check for undefined
      if (this.fallbackSelection && this.items.length && this._selection.get() === undefined) {
        this.selected = this.fallbackSelection;
      }
    },
    _filterItem: function (node) {
      return !this._excludedLocalNames[node.localName];
    },
    _valueToItem: function (value) {
      return value == null ? null : this.items[this._valueToIndex(value)];
    },
    _valueToIndex: function (value) {
      if (this.attrForSelected) {
        for (var i = 0, item; item = this.items[i]; i++) {
          if (this._valueForItem(item) == value) {
            return i;
          }
        }
      } else {
        return Number(value);
      }
    },
    _indexToValue: function (index) {
      if (this.attrForSelected) {
        var item = this.items[index];
        if (item) {
          return this._valueForItem(item);
        }
      } else {
        return index;
      }
    },
    _valueForItem: function (item) {
      if (!item) {
        return null;
      }
      if (!this.attrForSelected) {
        var i = this.indexOf(item);
        return i === -1 ? null : i;
      }
      var propValue = item[dashToCamelCase(this.attrForSelected)];
      return propValue != undefined ? propValue : item.getAttribute(this.attrForSelected);
    },
    _applySelection: function (item, isSelected) {
      if (this.selectedClass) {
        this.toggleClass(this.selectedClass, isSelected, item);
      }
      if (this.selectedAttribute) {
        this.toggleAttribute(this.selectedAttribute, isSelected, item);
      }
      this._selectionChange();
      this.fire('iron-' + (isSelected ? 'select' : 'deselect'), {
        item: item
      });
    },
    _selectionChange: function () {
      this._setSelectedItem(this._selection.get());
    },
    // observe items change under the given node.
    _observeItems: function (node) {
      return dom(node).observeNodes(function (mutation) {
        this._updateItems();
        this._updateSelected();

        // Let other interested parties know about the change so that
        // we don't have to recreate mutation observers everywhere.
        this.fire('iron-items-changed', mutation, {
          bubbles: false,
          cancelable: false
        });
      });
    },
    _activateHandler: function (e) {
      var t = e.target;
      var items = this.items;
      while (t && t != this) {
        var i = items.indexOf(t);
        if (i >= 0) {
          var value = this._indexToValue(i);
          this._itemActivate(value, t);
          return;
        }
        t = t.parentNode;
      }
    },
    _itemActivate: function (value, item) {
      if (!this.fire('iron-activate', {
        selected: value,
        item: item
      }, {
        cancelable: true
      }).defaultPrevented) {
        this.select(value);
      }
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * @polymerBehavior IronMultiSelectableBehavior
   */
  const IronMultiSelectableBehaviorImpl = {
    properties: {
      /**
       * If true, multiple selections are allowed.
       */
      multi: {
        type: Boolean,
        value: false,
        observer: 'multiChanged'
      },
      /**
       * Gets or sets the selected elements. This is used instead of `selected`
       * when `multi` is true.
       */
      selectedValues: {
        type: Array,
        notify: true,
        value: function () {
          return [];
        }
      },
      /**
       * Returns an array of currently selected items.
       */
      selectedItems: {
        type: Array,
        readOnly: true,
        notify: true,
        value: function () {
          return [];
        }
      }
    },
    observers: ['_updateSelected(selectedValues.splices)'],
    /**
     * Selects the given value. If the `multi` property is true, then the selected
     * state of the `value` will be toggled; otherwise the `value` will be
     * selected.
     *
     * @method select
     * @param {string|number} value the value to select.
     */
    select: function (value) {
      if (this.multi) {
        this._toggleSelected(value);
      } else {
        this.selected = value;
      }
    },
    multiChanged: function (multi) {
      this._selection.multi = multi;
      this._updateSelected();
    },
    // UNUSED, FOR API COMPATIBILITY
    get _shouldUpdateSelection() {
      return this.selected != null || this.selectedValues != null && this.selectedValues.length;
    },
    _updateAttrForSelected: function () {
      if (!this.multi) {
        IronSelectableBehavior._updateAttrForSelected.apply(this);
      } else if (this.selectedItems && this.selectedItems.length > 0) {
        this.selectedValues = this.selectedItems.map(function (selectedItem) {
          return this._indexToValue(this.indexOf(selectedItem));
        }, this).filter(function (unfilteredValue) {
          return unfilteredValue != null;
        }, this);
      }
    },
    _updateSelected: function () {
      if (this.multi) {
        this._selectMulti(this.selectedValues);
      } else {
        this._selectSelected(this.selected);
      }
    },
    _selectMulti: function (values) {
      values = values || [];
      var selectedItems = (this._valuesToItems(values) || []).filter(function (item) {
        return item !== null && item !== undefined;
      });

      // clear all but the current selected items
      this._selection.clear(selectedItems);

      // select only those not selected yet
      for (var i = 0; i < selectedItems.length; i++) {
        this._selection.setItemSelected(selectedItems[i], true);
      }

      // Check for items, since this array is populated only when attached
      if (this.fallbackSelection && !this._selection.get().length) {
        var fallback = this._valueToItem(this.fallbackSelection);
        if (fallback) {
          this.select(this.fallbackSelection);
        }
      }
    },
    _selectionChange: function () {
      var s = this._selection.get();
      if (this.multi) {
        this._setSelectedItems(s);
        this._setSelectedItem(s.length ? s[0] : null);
      } else {
        if (s !== null && s !== undefined) {
          this._setSelectedItems([s]);
          this._setSelectedItem(s);
        } else {
          this._setSelectedItems([]);
          this._setSelectedItem(null);
        }
      }
    },
    _toggleSelected: function (value) {
      var i = this.selectedValues.indexOf(value);
      var unselected = i < 0;
      if (unselected) {
        this.push('selectedValues', value);
      } else {
        this.splice('selectedValues', i, 1);
      }
    },
    _valuesToItems: function (values) {
      return values == null ? null : values.map(function (value) {
        return this._valueToItem(value);
      }, this);
    }
  };

  /** @polymerBehavior */
  const IronMultiSelectableBehavior = [IronSelectableBehavior, IronMultiSelectableBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `IronMenuBehavior` implements accessible menu behavior.
   *
   * @demo demo/index.html
   * @polymerBehavior IronMenuBehavior
   */
  const IronMenuBehaviorImpl = {
    properties: {
      /**
       * Returns the currently focused item.
       * @type {?Object}
       */
      focusedItem: {
        observer: '_focusedItemChanged',
        readOnly: true,
        type: Object
      },
      /**
       * The attribute to use on menu items to look up the item title. Typing the
       * first letter of an item when the menu is open focuses that item. If
       * unset, `textContent` will be used.
       */
      attrForItemTitle: {
        type: String
      },
      /**
       * @type {boolean}
       */
      disabled: {
        type: Boolean,
        value: false,
        observer: '_disabledChanged'
      }
    },
    /**
     * The list of keys has been taken from
     * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/getModifierState
     * @private
     */
    _MODIFIER_KEYS: ['Alt', 'AltGraph', 'CapsLock', 'Control', 'Fn', 'FnLock', 'Hyper', 'Meta', 'NumLock', 'OS', 'ScrollLock', 'Shift', 'Super', 'Symbol', 'SymbolLock'],
    /** @private */
    _SEARCH_RESET_TIMEOUT_MS: 1000,
    /** @private */
    _previousTabIndex: 0,
    hostAttributes: {
      'role': 'menu'
    },
    observers: ['_updateMultiselectable(multi)'],
    listeners: {
      'focus': '_onFocus',
      'keydown': '_onKeydown',
      'iron-items-changed': '_onIronItemsChanged'
    },
    /**
     * @type {!Object}
     */
    keyBindings: {
      'up': '_onUpKey',
      'down': '_onDownKey',
      'esc': '_onEscKey',
      'shift+tab:keydown': '_onShiftTabDown'
    },
    attached: function () {
      this._resetTabindices();
    },
    /**
     * Selects the given value. If the `multi` property is true, then the selected
     * state of the `value` will be toggled; otherwise the `value` will be
     * selected.
     *
     * @param {string|number} value the value to select.
     */
    select: function (value) {
      // Cancel automatically focusing a default item if the menu received focus
      // through a user action selecting a particular item.
      if (this._defaultFocusAsync) {
        this.cancelAsync(this._defaultFocusAsync);
        this._defaultFocusAsync = null;
      }
      var item = this._valueToItem(value);
      if (item && item.hasAttribute('disabled')) return;
      this._setFocusedItem(item);
      IronMultiSelectableBehaviorImpl.select.apply(this, arguments);
    },
    /**
     * Resets all tabindex attributes to the appropriate value based on the
     * current selection state. The appropriate value is `0` (focusable) for
     * the default selected item, and `-1` (not keyboard focusable) for all
     * other items. Also sets the correct initial values for aria-selected
     * attribute, true for default selected item and false for others.
     */
    _resetTabindices: function () {
      var firstSelectedItem = this.multi ? this.selectedItems && this.selectedItems[0] : this.selectedItem;
      this.items.forEach(function (item) {
        item.setAttribute('tabindex', item === firstSelectedItem ? '0' : '-1');
        item.setAttribute('aria-selected', this._selection.isSelected(item));
      }, this);
    },
    /**
     * Sets appropriate ARIA based on whether or not the menu is meant to be
     * multi-selectable.
     *
     * @param {boolean} multi True if the menu should be multi-selectable.
     */
    _updateMultiselectable: function (multi) {
      if (multi) {
        this.setAttribute('aria-multiselectable', 'true');
      } else {
        this.removeAttribute('aria-multiselectable');
      }
    },
    /**
     * Given a KeyboardEvent, this method will focus the appropriate item in the
     * menu (if there is a relevant item, and it is possible to focus it).
     *
     * @param {KeyboardEvent} event A KeyboardEvent.
     */
    _focusWithKeyboardEvent: function (event) {
      // Make sure that the key pressed is not a modifier key.
      // getModifierState is not being used, as it is not available in Safari
      // earlier than 10.0.2 (https://trac.webkit.org/changeset/206725/webkit)
      if (this._MODIFIER_KEYS.indexOf(event.key) !== -1) return;
      this.cancelDebouncer('_clearSearchText');
      var searchText = this._searchText || '';
      var key = event.key && event.key.length == 1 ? event.key : String.fromCharCode(event.keyCode);
      searchText += key.toLocaleLowerCase();
      var searchLength = searchText.length;
      for (var i = 0, item; item = this.items[i]; i++) {
        if (item.hasAttribute('disabled')) {
          continue;
        }
        var attr = this.attrForItemTitle || 'textContent';
        var title = (item[attr] || item.getAttribute(attr) || '').trim();
        if (title.length < searchLength) {
          continue;
        }
        if (title.slice(0, searchLength).toLocaleLowerCase() == searchText) {
          this._setFocusedItem(item);
          break;
        }
      }
      this._searchText = searchText;
      this.debounce('_clearSearchText', this._clearSearchText, this._SEARCH_RESET_TIMEOUT_MS);
    },
    _clearSearchText: function () {
      this._searchText = '';
    },
    /**
     * Focuses the previous item (relative to the currently focused item) in the
     * menu, disabled items will be skipped.
     * Loop until length + 1 to handle case of single item in menu.
     */
    _focusPrevious: function () {
      var length = this.items.length;
      var curFocusIndex = Number(this.indexOf(this.focusedItem));
      for (var i = 1; i < length + 1; i++) {
        var item = this.items[(curFocusIndex - i + length) % length];
        if (!item.hasAttribute('disabled')) {
          var owner = dom(item).getOwnerRoot() || document;
          this._setFocusedItem(item);

          // Focus might not have worked, if the element was hidden or not
          // focusable. In that case, try again.
          if (dom(owner).activeElement == item) {
            return;
          }
        }
      }
    },
    /**
     * Focuses the next item (relative to the currently focused item) in the
     * menu, disabled items will be skipped.
     * Loop until length + 1 to handle case of single item in menu.
     */
    _focusNext: function () {
      var length = this.items.length;
      var curFocusIndex = Number(this.indexOf(this.focusedItem));
      for (var i = 1; i < length + 1; i++) {
        var item = this.items[(curFocusIndex + i) % length];
        if (!item.hasAttribute('disabled')) {
          var owner = dom(item).getOwnerRoot() || document;
          this._setFocusedItem(item);

          // Focus might not have worked, if the element was hidden or not
          // focusable. In that case, try again.
          if (dom(owner).activeElement == item) {
            return;
          }
        }
      }
    },
    /**
     * Mutates items in the menu based on provided selection details, so that
     * all items correctly reflect selection state.
     *
     * @param {Element} item An item in the menu.
     * @param {boolean} isSelected True if the item should be shown in a
     * selected state, otherwise false.
     */
    _applySelection: function (item, isSelected) {
      if (isSelected) {
        item.setAttribute('aria-selected', 'true');
      } else {
        item.setAttribute('aria-selected', 'false');
      }
      IronSelectableBehavior._applySelection.apply(this, arguments);
    },
    /**
     * Discretely updates tabindex values among menu items as the focused item
     * changes.
     *
     * @param {Element} focusedItem The element that is currently focused.
     * @param {?Element} old The last element that was considered focused, if
     * applicable.
     */
    _focusedItemChanged: function (focusedItem, old) {
      old && old.setAttribute('tabindex', '-1');
      if (focusedItem && !focusedItem.hasAttribute('disabled') && !this.disabled) {
        focusedItem.setAttribute('tabindex', '0');
        focusedItem.focus();
      }
    },
    /**
     * A handler that responds to mutation changes related to the list of items
     * in the menu.
     *
     * @param {CustomEvent} event An event containing mutation records as its
     * detail.
     */
    _onIronItemsChanged: function (event) {
      if (event.detail.addedNodes.length) {
        this._resetTabindices();
      }
    },
    /**
     * Handler that is called when a shift+tab keypress is detected by the menu.
     *
     * @param {CustomEvent} event A key combination event.
     */
    _onShiftTabDown: function (event) {
      var oldTabIndex = this.getAttribute('tabindex');
      IronMenuBehaviorImpl._shiftTabPressed = true;
      this._setFocusedItem(null);
      this.setAttribute('tabindex', '-1');
      this.async(function () {
        this.setAttribute('tabindex', oldTabIndex);
        IronMenuBehaviorImpl._shiftTabPressed = false;
        // NOTE(cdata): polymer/polymer#1305
      }, 1);
    },
    /**
     * Handler that is called when the menu receives focus.
     *
     * @param {FocusEvent} event A focus event.
     */
    _onFocus: function (event) {
      if (IronMenuBehaviorImpl._shiftTabPressed) {
        // do not focus the menu itself
        return;
      }

      // Do not focus the selected tab if the deepest target is part of the
      // menu element's local DOM and is focusable.
      var rootTarget = /** @type {?HTMLElement} */dom(event).rootTarget;
      if (rootTarget !== this && typeof rootTarget.tabIndex !== 'undefined' && !this.isLightDescendant(rootTarget)) {
        return;
      }

      // clear the cached focus item
      this._defaultFocusAsync = this.async(function () {
        // focus the selected item when the menu receives focus, or the first item
        // if no item is selected
        var firstSelectedItem = this.multi ? this.selectedItems && this.selectedItems[0] : this.selectedItem;
        this._setFocusedItem(null);
        if (firstSelectedItem) {
          this._setFocusedItem(firstSelectedItem);
        } else if (this.items[0]) {
          // We find the first none-disabled item (if one exists)
          this._focusNext();
        }
      });
    },
    /**
     * Handler that is called when the up key is pressed.
     *
     * @param {CustomEvent} event A key combination event.
     */
    _onUpKey: function (event) {
      // up and down arrows moves the focus
      this._focusPrevious();
      event.detail.keyboardEvent.preventDefault();
    },
    /**
     * Handler that is called when the down key is pressed.
     *
     * @param {CustomEvent} event A key combination event.
     */
    _onDownKey: function (event) {
      this._focusNext();
      event.detail.keyboardEvent.preventDefault();
    },
    /**
     * Handler that is called when the esc key is pressed.
     *
     * @param {CustomEvent} event A key combination event.
     */
    _onEscKey: function (event) {
      var focusedItem = this.focusedItem;
      if (focusedItem) {
        focusedItem.blur();
      }
    },
    /**
     * Handler that is called when a keydown event is detected.
     *
     * @param {KeyboardEvent} event A keyboard event.
     */
    _onKeydown: function (event) {
      if (!this.keyboardEventMatchesKeys(event, 'up down esc')) {
        // all other keys focus the menu item starting with that character
        this._focusWithKeyboardEvent(event);
      }
      event.stopPropagation();
    },
    // override _activateHandler
    _activateHandler: function (event) {
      IronSelectableBehavior._activateHandler.call(this, event);
      event.stopPropagation();
    },
    /**
     * Updates this element's tab index when it's enabled/disabled.
     * @param {boolean} disabled
     */
    _disabledChanged: function (disabled) {
      if (disabled) {
        this._previousTabIndex = this.hasAttribute('tabindex') ? this.tabIndex : 0;
        this.removeAttribute('tabindex'); // No tabindex means not tab-able or select-able.
      } else if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', this._previousTabIndex);
      }
    }
  };
  IronMenuBehaviorImpl._shiftTabPressed = false;

  /** @polymerBehavior */
  const IronMenuBehavior = [IronMultiSelectableBehavior, IronA11yKeysBehavior, IronMenuBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `IronMenubarBehavior` implements accessible menubar behavior.
   *
   * @polymerBehavior IronMenubarBehavior
   */
  const IronMenubarBehaviorImpl = {
    hostAttributes: {
      'role': 'menubar'
    },
    /**
     * @type {!Object}
     */
    keyBindings: {
      'left': '_onLeftKey',
      'right': '_onRightKey'
    },
    _onUpKey: function (event) {
      this.focusedItem.click();
      event.detail.keyboardEvent.preventDefault();
    },
    _onDownKey: function (event) {
      this.focusedItem.click();
      event.detail.keyboardEvent.preventDefault();
    },
    get _isRTL() {
      return window.getComputedStyle(this)['direction'] === 'rtl';
    },
    _onLeftKey: function (event) {
      if (this._isRTL) {
        this._focusNext();
      } else {
        this._focusPrevious();
      }
      event.detail.keyboardEvent.preventDefault();
    },
    _onRightKey: function (event) {
      if (this._isRTL) {
        this._focusPrevious();
      } else {
        this._focusNext();
      }
      event.detail.keyboardEvent.preventDefault();
    },
    _onKeydown: function (event) {
      if (this.keyboardEventMatchesKeys(event, 'up down left right esc')) {
        return;
      }

      // all other keys focus the menu item starting with that character
      this._focusWithKeyboardEvent(event);
    }
  };

  /** @polymerBehavior */
  const IronMenubarBehavior = [IronMenuBehavior, IronMenubarBehaviorImpl];

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
  The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
  The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
  Code distributed by Google as part of the polymer project is also
  subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
  */

  /**
  Material design: [Tabs](https://www.google.com/design/spec/components/tabs.html)

  `paper-tabs` makes it easy to explore and switch between different views or
  functional aspects of an app, or to browse categorized data sets.

  Use `selected` property to get or set the selected tab.

  Example:

      <paper-tabs selected="0">
        <paper-tab>TAB 1</paper-tab>
        <paper-tab>TAB 2</paper-tab>
        <paper-tab>TAB 3</paper-tab>
      </paper-tabs>

  See <a href="?active=paper-tab">paper-tab</a> for more information about
  `paper-tab`.

  A common usage for `paper-tabs` is to use it along with `iron-pages` to switch
  between different views.

      <paper-tabs selected="{{selected}}">
        <paper-tab>Tab 1</paper-tab>
        <paper-tab>Tab 2</paper-tab>
        <paper-tab>Tab 3</paper-tab>
      </paper-tabs>

      <iron-pages selected="{{selected}}">
        <div>Page 1</div>
        <div>Page 2</div>
        <div>Page 3</div>
      </iron-pages>

  To use links in tabs, add `link` attribute to `paper-tab` and put an `<a>`
  element in `paper-tab` with a `tabindex` of -1.

  Example:

  <pre><code>
  &lt;style is="custom-style">
    .link {
      &#64;apply --layout-horizontal;
      &#64;apply --layout-center-center;
    }
  &lt;/style>

  &lt;paper-tabs selected="0">
    &lt;paper-tab link>
      &lt;a href="#link1" class="link" tabindex="-1">TAB ONE&lt;/a>
    &lt;/paper-tab>
    &lt;paper-tab link>
      &lt;a href="#link2" class="link" tabindex="-1">TAB TWO&lt;/a>
    &lt;/paper-tab>
    &lt;paper-tab link>
      &lt;a href="#link3" class="link" tabindex="-1">TAB THREE&lt;/a>
    &lt;/paper-tab>
  &lt;/paper-tabs>
  </code></pre>

  ### Styling

  The following custom properties and mixins are available for styling:

  Custom property | Description | Default
  ----------------|-------------|----------
  `--paper-tabs-selection-bar-color` | Color for the selection bar | `--paper-yellow-a100`
  `--paper-tabs-selection-bar` | Mixin applied to the selection bar | `{}`
  `--paper-tabs` | Mixin applied to the tabs | `{}`
  `--paper-tabs-content` | Mixin applied to the content container of tabs | `{}`
  `--paper-tabs-container` | Mixin applied to the layout container of tabs | `{}`

  @demo demo/index.html
  */
  Polymer({
    _template: html`
    <style>
      :host {
        @apply --layout;
        @apply --layout-center;

        height: 48px;
        font-size: 14px;
        font-weight: 500;
        overflow: hidden;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-user-select: none;
        user-select: none;

        /* NOTE: Both values are needed, since some phones require the value to be \`transparent\`. */
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;

        @apply --paper-tabs;
      }

      :host(:dir(rtl)) {
        @apply --layout-horizontal-reverse;
      }

      #tabsContainer {
        position: relative;
        height: 100%;
        white-space: nowrap;
        overflow: hidden;
        @apply --layout-flex-auto;
        @apply --paper-tabs-container;
      }

      #tabsContent {
        height: 100%;
        -moz-flex-basis: auto;
        -ms-flex-basis: auto;
        flex-basis: auto;
        @apply --paper-tabs-content;
      }

      #tabsContent.scrollable {
        position: absolute;
        white-space: nowrap;
      }

      #tabsContent:not(.scrollable),
      #tabsContent.scrollable.fit-container {
        @apply --layout-horizontal;
      }

      #tabsContent.scrollable.fit-container {
        min-width: 100%;
      }

      #tabsContent.scrollable.fit-container > ::slotted(*) {
        /* IE - prevent tabs from compressing when they should scroll. */
        -ms-flex: 1 0 auto;
        -webkit-flex: 1 0 auto;
        flex: 1 0 auto;
      }

      .hidden {
        display: none;
      }

      .not-visible {
        opacity: 0;
        cursor: default;
      }

      paper-icon-button {
        width: 48px;
        height: 48px;
        padding: 12px;
        margin: 0 4px;
      }

      #selectionBar {
        position: absolute;
        height: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 2px solid var(--paper-tabs-selection-bar-color, var(--paper-yellow-a100));
          -webkit-transform: scale(0);
        transform: scale(0);
          -webkit-transform-origin: left center;
        transform-origin: left center;
          transition: -webkit-transform;
        transition: transform;

        @apply --paper-tabs-selection-bar;
      }

      #selectionBar.align-bottom {
        top: 0;
        bottom: auto;
      }

      #selectionBar.expand {
        transition-duration: 0.15s;
        transition-timing-function: cubic-bezier(0.4, 0.0, 1, 1);
      }

      #selectionBar.contract {
        transition-duration: 0.18s;
        transition-timing-function: cubic-bezier(0.0, 0.0, 0.2, 1);
      }

      #tabsContent > ::slotted(:not(#selectionBar)) {
        height: 100%;
      }
    </style>

    <paper-icon-button icon="paper-tabs:chevron-left" class$="[[_computeScrollButtonClass(_leftHidden, scrollable, hideScrollButtons)]]" on-up="_onScrollButtonUp" on-down="_onLeftScrollButtonDown" tabindex="-1"></paper-icon-button>

    <div id="tabsContainer" on-track="_scroll" on-down="_down">
      <div id="tabsContent" class$="[[_computeTabsContentClass(scrollable, fitContainer)]]">
        <div id="selectionBar" class$="[[_computeSelectionBarClass(noBar, alignBottom)]]" on-transitionend="_onBarTransitionEnd"></div>
        <slot></slot>
      </div>
    </div>

    <paper-icon-button icon="paper-tabs:chevron-right" class$="[[_computeScrollButtonClass(_rightHidden, scrollable, hideScrollButtons)]]" on-up="_onScrollButtonUp" on-down="_onRightScrollButtonDown" tabindex="-1"></paper-icon-button>
`,
    is: 'paper-tabs',
    behaviors: [IronResizableBehavior, IronMenubarBehavior],
    properties: {
      /**
       * If true, ink ripple effect is disabled. When this property is changed,
       * all descendant `<paper-tab>` elements have their `noink` property
       * changed to the new value as well.
       */
      noink: {
        type: Boolean,
        value: false,
        observer: '_noinkChanged'
      },
      /**
       * If true, the bottom bar to indicate the selected tab will not be shown.
       */
      noBar: {
        type: Boolean,
        value: false
      },
      /**
       * If true, the slide effect for the bottom bar is disabled.
       */
      noSlide: {
        type: Boolean,
        value: false
      },
      /**
       * If true, tabs are scrollable and the tab width is based on the label
       * width.
       */
      scrollable: {
        type: Boolean,
        value: false
      },
      /**
       * If true, tabs expand to fit their container. This currently only applies
       * when scrollable is true.
       */
      fitContainer: {
        type: Boolean,
        value: false
      },
      /**
       * If true, dragging on the tabs to scroll is disabled.
       */
      disableDrag: {
        type: Boolean,
        value: false
      },
      /**
       * If true, scroll buttons (left/right arrow) will be hidden for scrollable
       * tabs.
       */
      hideScrollButtons: {
        type: Boolean,
        value: false
      },
      /**
       * If true, the tabs are aligned to bottom (the selection bar appears at the
       * top).
       */
      alignBottom: {
        type: Boolean,
        value: false
      },
      selectable: {
        type: String,
        value: 'paper-tab'
      },
      /**
       * If true, tabs are automatically selected when focused using the
       * keyboard.
       */
      autoselect: {
        type: Boolean,
        value: false
      },
      /**
       * The delay (in milliseconds) between when the user stops interacting
       * with the tabs through the keyboard and when the focused item is
       * automatically selected (if `autoselect` is true).
       */
      autoselectDelay: {
        type: Number,
        value: 0
      },
      _step: {
        type: Number,
        value: 10
      },
      _holdDelay: {
        type: Number,
        value: 1
      },
      _leftHidden: {
        type: Boolean,
        value: false
      },
      _rightHidden: {
        type: Boolean,
        value: false
      },
      _previousTab: {
        type: Object
      }
    },
    /** @private */
    hostAttributes: {
      role: 'tablist'
    },
    listeners: {
      'iron-resize': '_onTabSizingChanged',
      'iron-items-changed': '_onTabSizingChanged',
      'iron-select': '_onIronSelect',
      'iron-deselect': '_onIronDeselect'
    },
    /**
     * @type {!Object}
     */
    keyBindings: {
      'left:keyup right:keyup': '_onArrowKeyup'
    },
    created: function () {
      this._holdJob = null;
      this._pendingActivationItem = undefined;
      this._pendingActivationTimeout = undefined;
      this._bindDelayedActivationHandler = this._delayedActivationHandler.bind(this);
      this.addEventListener('blur', this._onBlurCapture.bind(this), true);
    },
    ready: function () {
      this.setScrollDirection('y', this.$.tabsContainer);
    },
    detached: function () {
      this._cancelPendingActivation();
    },
    _noinkChanged: function (noink) {
      var childTabs = dom(this).querySelectorAll('paper-tab');
      childTabs.forEach(noink ? this._setNoinkAttribute : this._removeNoinkAttribute);
    },
    _setNoinkAttribute: function (element) {
      element.setAttribute('noink', '');
    },
    _removeNoinkAttribute: function (element) {
      element.removeAttribute('noink');
    },
    _computeScrollButtonClass: function (hideThisButton, scrollable, hideScrollButtons) {
      if (!scrollable || hideScrollButtons) {
        return 'hidden';
      }
      if (hideThisButton) {
        return 'not-visible';
      }
      return '';
    },
    _computeTabsContentClass: function (scrollable, fitContainer) {
      return scrollable ? 'scrollable' + (fitContainer ? ' fit-container' : '') : ' fit-container';
    },
    _computeSelectionBarClass: function (noBar, alignBottom) {
      if (noBar) {
        return 'hidden';
      } else if (alignBottom) {
        return 'align-bottom';
      }
      return '';
    },
    // TODO(cdata): Add `track` response back in when gesture lands.

    _onTabSizingChanged: function () {
      this.debounce('_onTabSizingChanged', function () {
        this._scroll();
        this._tabChanged(this.selectedItem);
      }, 10);
    },
    _onIronSelect: function (event) {
      this._tabChanged(event.detail.item, this._previousTab);
      this._previousTab = event.detail.item;
      this.cancelDebouncer('tab-changed');
    },
    _onIronDeselect: function (event) {
      this.debounce('tab-changed', function () {
        this._tabChanged(null, this._previousTab);
        this._previousTab = null;
        // See polymer/polymer#1305
      }, 1);
    },
    _activateHandler: function () {
      // Cancel item activations scheduled by keyboard events when any other
      // action causes an item to be activated (e.g. clicks).
      this._cancelPendingActivation();
      IronMenuBehaviorImpl._activateHandler.apply(this, arguments);
    },
    /**
     * Activates an item after a delay (in milliseconds).
     */
    _scheduleActivation: function (item, delay) {
      this._pendingActivationItem = item;
      this._pendingActivationTimeout = this.async(this._bindDelayedActivationHandler, delay);
    },
    /**
     * Activates the last item given to `_scheduleActivation`.
     */
    _delayedActivationHandler: function () {
      var item = this._pendingActivationItem;
      this._pendingActivationItem = undefined;
      this._pendingActivationTimeout = undefined;
      item.fire(this.activateEvent, null, {
        bubbles: true,
        cancelable: true
      });
    },
    /**
     * Cancels a previously scheduled item activation made with
     * `_scheduleActivation`.
     */
    _cancelPendingActivation: function () {
      if (this._pendingActivationTimeout !== undefined) {
        this.cancelAsync(this._pendingActivationTimeout);
        this._pendingActivationItem = undefined;
        this._pendingActivationTimeout = undefined;
      }
    },
    _onArrowKeyup: function (event) {
      if (this.autoselect) {
        this._scheduleActivation(this.focusedItem, this.autoselectDelay);
      }
    },
    _onBlurCapture: function (event) {
      // Cancel a scheduled item activation (if any) when that item is
      // blurred.
      if (event.target === this._pendingActivationItem) {
        this._cancelPendingActivation();
      }
    },
    get _tabContainerScrollSize() {
      return Math.max(0, this.$.tabsContainer.scrollWidth - this.$.tabsContainer.offsetWidth);
    },
    _scroll: function (e, detail) {
      if (!this.scrollable) {
        return;
      }
      var ddx = detail && -detail.ddx || 0;
      this._affectScroll(ddx);
    },
    _down: function (e) {
      // go one beat async to defeat IronMenuBehavior
      // autorefocus-on-no-selection timeout
      this.async(function () {
        if (this._defaultFocusAsync) {
          this.cancelAsync(this._defaultFocusAsync);
          this._defaultFocusAsync = null;
        }
      }, 1);
    },
    _affectScroll: function (dx) {
      this.$.tabsContainer.scrollLeft += dx;
      var scrollLeft = this.$.tabsContainer.scrollLeft;
      this._leftHidden = scrollLeft === 0;
      this._rightHidden = scrollLeft === this._tabContainerScrollSize;
    },
    _onLeftScrollButtonDown: function () {
      this._scrollToLeft();
      this._holdJob = setInterval(this._scrollToLeft.bind(this), this._holdDelay);
    },
    _onRightScrollButtonDown: function () {
      this._scrollToRight();
      this._holdJob = setInterval(this._scrollToRight.bind(this), this._holdDelay);
    },
    _onScrollButtonUp: function () {
      clearInterval(this._holdJob);
      this._holdJob = null;
    },
    _scrollToLeft: function () {
      this._affectScroll(-this._step);
    },
    _scrollToRight: function () {
      this._affectScroll(this._step);
    },
    _tabChanged: function (tab, old) {
      if (!tab) {
        // Remove the bar without animation.
        this.$.selectionBar.classList.remove('expand');
        this.$.selectionBar.classList.remove('contract');
        this._positionBar(0, 0);
        return;
      }
      var r = this.$.tabsContent.getBoundingClientRect();
      var w = r.width;
      var tabRect = tab.getBoundingClientRect();
      var tabOffsetLeft = tabRect.left - r.left;
      this._pos = {
        width: this._calcPercent(tabRect.width, w),
        left: this._calcPercent(tabOffsetLeft, w)
      };
      if (this.noSlide || old == null) {
        // Position the bar without animation.
        this.$.selectionBar.classList.remove('expand');
        this.$.selectionBar.classList.remove('contract');
        this._positionBar(this._pos.width, this._pos.left);
        return;
      }
      var oldRect = old.getBoundingClientRect();
      var oldIndex = this.items.indexOf(old);
      var index = this.items.indexOf(tab);
      var m = 5;

      // bar animation: expand
      this.$.selectionBar.classList.add('expand');
      var moveRight = oldIndex < index;
      var isRTL = this._isRTL;
      if (isRTL) {
        moveRight = !moveRight;
      }
      if (moveRight) {
        this._positionBar(this._calcPercent(tabRect.left + tabRect.width - oldRect.left, w) - m, this._left);
      } else {
        this._positionBar(this._calcPercent(oldRect.left + oldRect.width - tabRect.left, w) - m, this._calcPercent(tabOffsetLeft, w) + m);
      }
      if (this.scrollable) {
        this._scrollToSelectedIfNeeded(tabRect.width, tabOffsetLeft);
      }
    },
    _scrollToSelectedIfNeeded: function (tabWidth, tabOffsetLeft) {
      var l = tabOffsetLeft - this.$.tabsContainer.scrollLeft;
      if (l < 0) {
        this.$.tabsContainer.scrollLeft += l;
      } else {
        l += tabWidth - this.$.tabsContainer.offsetWidth;
        if (l > 0) {
          this.$.tabsContainer.scrollLeft += l;
        }
      }
    },
    _calcPercent: function (w, w0) {
      return 100 * w / w0;
    },
    _positionBar: function (width, left) {
      width = width || 0;
      left = left || 0;
      this._width = width;
      this._left = left;
      this.transform('translateX(' + left + '%) scaleX(' + width / 100 + ')', this.$.selectionBar);
    },
    _onBarTransitionEnd: function (e) {
      var cl = this.$.selectionBar.classList;
      // bar animation: expand -> contract
      if (cl.contains('expand')) {
        cl.remove('expand');
        cl.add('contract');
        this._positionBar(this._pos.width, this._pos.left);
        // bar animation done
      } else if (cl.contains('contract')) {
        cl.remove('contract');
      }
    }
  });

  /**
   * Displays a Top level Page Header.
   * @name UnityPageHeader
   * @param {''} header
   * @param {[]} tabs
   * @param {''} selectedTab
   * @param {css} --page-header-font-family, css var used for styling the component
   * @param {css} --page-header-left-wrapper-overflow, css var used for styling the component
   * @param {css} --page-header-title-white-space, css var used for styling the component
   * @param {css} --page-header-padding-size, css var used for styling the component
   * @param {css} --page-header-padding, css var used for styling the component (overrides --page-header-padding-size)
   * @param {css} --page-header-border-color, css var used for styling the component
   * @param {css} --page-header-border-width, css var used for styling the component
   * @param {css} --page-header-border, css var used for styling the component
   * @param {css} --page-header-font-size, css var used for styling the component
   * @param {css} --page-header-font-weight, css var used for styling the component
   * @param {css} --page-header-icon-size, css var used for styling the component
   * @param {css} --page-header-tab-height, css var used for styling the component
   * @param {css} --page-header-tab-color, css var used for styling the component
   * @param {css} --page-header-tab-font-size, css var used for styling the component
   * @param {css} --page-header-tab-padding-size, css var used for styling the component
   * @param {css} --page-header-tab-padding, css var used for styling the component (overrides --page-header-tab-padding-size)
   * @param {css} --page-header-z-index, css var used for styling the component
   * @param {css} --page-header-background-color, css var used for styling the component
   * @param {css} --separator-color, css var used for styling the separator color
   * @param {css} --left-content-flex, css var used for defining flex of left content.
   * @param {css} --left-content-max-width, css var used for defining max-width of left content. Default is `unset`.
   * @param {css} --left-content-min-width, css var used for defining min-width of left content. Default is `unset`.
   * @param {css} --left-content-text-overflow, css var for determining behavior of header text when max-width is reached. `ellipses` by default.
   * @param {css} --button-container-flex, css var used for defining flex of the button container.
   * @returns {LitElement} returns a a class extended from LitElement
   * @example
   *  <unity-page-header
   *    header="MOCC2 Title (header)"
   *    ?showBackBtn=${true}
   *    .tabs=${[
   *      {
   *        label: 'Users',
   *        onClick: (e) => {
   *          console.log("Users tab clicked")
   *        }
   *      },
   *      {
   *        label: 'Rules',
   *        onClick: (e) => {
   *          console.log("Rules tab clicked")
   *        }
   *      },
   *      {
   *        label: 'API Keys',
   *        onClick: (e) => {
   *          console.log("API Keys tab clicked")
   *        }
   *      }
   *    ]}
   *    .selectedTab=${1}
   *  >
   *    <div slot="right-content">
   *      <unity-button
   *        label="my button"
   *        ?gradient=${true}
   *        ?disabled=${false}
   *        @click=${e => console.log("unity-button clicked! e: ", e)}
   *      />
   *    </div>
   *  </unity-page-header>
   */

  //This component will render a page header
  // It will display a Title, a back arrow (optional), Right aligned action content (optional), and tabs (optional). These action buttons will be added as named splits to the component

  const LEFT_CONTENT = "left-content";
  const CENTER_CONTENT = "center-content";
  const LEFT_ACTION = "left-action";
  const RIGHT_ACTION = "right-action";
  let UnityPageHeader = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityPageHeader, _LitElement);
    var _super = _createSuper(UnityPageHeader);
    function UnityPageHeader() {
      var _this;
      _classCallCheck(this, UnityPageHeader);
      _this = _super.call(this);
      _this.header = '';
      _this._tabs = [];
      _this._selectedTab = 0;
      _this.onTabSelect = () => {
        console.log("onTabSelect default");
      };
      return _this;
    }
    _createClass(UnityPageHeader, [{
      key: "tabs",
      get: function () {
        return this._tabs;
      }

      // when tabs array changes, make selectedTab be within bounds, NaN goes to 0
      // if no selectedTab set, would still default 0 and be fine
      // when selectedTab changes, make selectedTab be within tabs bounds, NaN goes to 0
      // if no tabs when selectedTab changes, update with no change
      ,
      set: function (value) {
        const oldValue = this._tabs;
        if (value === oldValue) return;
        this._findSelectedTab();
        this._tabs = value;
        this.requestUpdate('tabs', oldValue);
      }
    }, {
      key: "selectedTab",
      get: function () {
        return this._selectedTab;
      }

      // if newValue exists, then updateing selectedTab
      // otherwise, using oldValue
      ,
      set: function (value) {
        this._findSelectedTab(value);
      }
    }, {
      key: "_findSelectedTab",
      value: function _findSelectedTab(newValue) {
        const oldValue = this._selectedTab;
        // use newValue as long as not undefine
        let tabToSelect = newValue !== undefined ? newValue : oldValue;
        // check tabToSelect to make sure within bounds
        // if tabs not set or empty array, just update selectedTab
        if (Array.isArray(this.tabs) && this.tabs.length > 0) {
          // check tabToSelect within bounds
          if (!tabToSelect || Number(tabToSelect) < 0) tabToSelect = 0;
          if (Number(tabToSelect) >= this.tabs.length) tabToSelect = this.tabs.length - 1;
        }
        // only update if value actually changes
        this._selectedTab = tabToSelect;
        this.requestUpdate('selectedTab', oldValue);
      }
    }, {
      key: "_handleTabSelect",
      value: function _handleTabSelect(tab, index) {
        this.onTabSelect(tab, index);
      }
    }, {
      key: "getActionSlots",
      value: function getActionSlots() {
        const slots = _toConsumableArray(this.shadowRoot.querySelectorAll('slot'));
        const slotContent = slots.map(slot => slot && slot.assignedNodes() || []);
        // destructured array is in written order of the component
        const [leftContent, centerContent, leftAction, rightAction] = slotContent.map(slot => trimWhitespace(slot));
        return {
          [LEFT_ACTION]: leftAction,
          [RIGHT_ACTION]: rightAction
        };
      }
    }, {
      key: "updated",
      value: function updated(oldProps) {
        if (!oldProps.has('showSeparator')) {
          const {
            [LEFT_ACTION]: leftAction = [],
            [RIGHT_ACTION]: rightAction = []
          } = this.getActionSlots();
          this.showSeparator = leftAction.length > 0 && rightAction.length > 0;
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          header,
          tabs = [],
          showSeparator,
          selectedTab
        } = this;
        const hasTabs = tabs.length > 0;
        return html$1`
      <div class="bottom">
        <div id="header">
          <div id="left-wrapper">
            <slot name="${LEFT_CONTENT}" class="left-container"></slot>
            <slot name="${CENTER_CONTENT}" class="center-container">
              <unity-typography size="header1" id="title">${header}</unity-typography>
            </slot>
          </div>
          <div class="button-container">
            <slot name="${LEFT_ACTION}" class="left-action"></slot>
            <div class="separator${!showSeparator ? ' hide' : ''}">
              <div class="inner-separator"></div>
            </div>
            <slot name="${RIGHT_ACTION}" class="right-action"></slot>
          </div>
        </div>
        ${hasTabs ? html$1`
            <paper-tabs selected="${selectedTab}" id="header-tabs" noink>
              ${tabs.map((tab, index) => {
        const {
          label,
          id
        } = tab;
        return html$1`
                  <paper-tab id="${id}" @click=${e => this._handleTabSelect(tab, index)}>
                    <unity-typography>${label}</unity-typography>
                  </paper-tab>`;
      })}
            </paper-tabs>` : ''}
      </div>
    `;
      }
    }], [{
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-page-header-font-family: var(--font-family, var(--default-font-family));
          --default-page-header-left-wrapper-overflow: hidden;
          --default-page-header-title-white-space: nowrap;
          --default-page-header-padding-size: var(--padding-size-md, var(--default-padding-size-md));
          --default-page-header-padding: 0 var(--page-header-padding-size, var(--default-page-header-padding-size));
          --default-page-header-border-color: var(--gray-color, var(--default-gray-color));
          --default-page-header-border-width: 1px;
          --default-page-header-border: var(--page-header-border-width, var(--default-page-header-border-width)) solid var(--default-page-header-border-color);
          --default-page-header-font-size: var(--header1-font-size, var(--default-header1-font-size));
          --default-page-header-font-weight: var(--header1-font-weight, var(--default-header1-font-weight));
          --default-page-header-icon-size: var(--unity-button-height, var(--default-unity-button-height));
          --default-page-header-background-color: var(--default-background-color);
          --default-page-header-z-index: 4;

          --default-page-header-tab-height: 28px;
          --default-page-header-tab-color: var(--secondary-color, var(--default-secondary-color));
          --default-page-header-tab-font-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          --default-page-header-tab-padding-size: var(--page-header-padding-size, var(--default-page-header-padding-size));
          --default-page-header-tab-padding: 0 var(--page-header-tab-padding-size, var(--default-page-header-tab-padding-size));
          --default-separator-color: var(--light-gray-1-color, var(--default-light-gray-1-color));
          --default-left-content-flex: unset;
          --default-button-container-flex: unset;
          --default-left-content-max-width: unset;
          --default-left-content-min-width: unset;
          --default-left-content-text-overflow: ellipses;

          width: 100%;
          display: flex;
          flex-direction: column;
          font-family: var(--page-header-font-family, var(--default-page-header-font-family));
        }

        #header {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: stretch;
          padding: var(--page-header-padding, var(--default-page-header-padding));
        }

        .bottom {
          border-bottom: var(--page-header-border, var(--default-page-header-border));
          z-index: var(--page-header-z-index, var(--default-page-header-z-index));
          background-color: var(--page-header-background-color, var(--default-page-header-background-color));
        }

        #left-wrapper {
          display: flex;
          flex-direction: row;
          align-items: center;
          overflow: var(--page-header-left-wrapper-overflow, var(--default-page-header-left-wrapper-overflow));
          flex: var(--left-content-flex, var(--default-left-content-flex));
          max-width: var(--left-content-max-width, var(--default-left-content-max-width));
          min-width: var(--left-content-min-width, var(--default-left-content-min-width));
          text-overflow: var(--left-content-text-overflow, var(--default-left-content-text-overflow));
        }

        .left-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        #title {
          overflow: var(--page-header-left-wrapper-overflow, var(--default-page-header-left-wrapper-overflow));
          white-space: var(--page-header-title-white-space, var(--default-page-header-title-white-space));
          --header1-size: var(--page-header-font-size, var(--default-page-header-font-size));
          --header1-weight: var(--page-header-font-weight, var(--default-page-header-font-weight));
          text-overflow: inherit;
          display: contents;
        }

        paper-tabs {
          font-size: var(--page-header-tab-font-size, var(--default-page-header-tab-font-size));
          height: var(--page-header-tab-height, var(--default-page-header-tab-height));
          width: min-content;
          align-self: flex-start;
          --paper-tabs-selection-bar-color: var(--page-header-tab-color, var(--default-page-header-tab-color));
        }

        paper-tabs paper-tab.iron-selected {
          --font-color: var(--page-header-tab-color, var(--default-page-header-tab-color));
        }

        .separator {
          height: 100%;
          align-self: stretch;
          display: flex;
        }

        .inner-separator {
          flex: 1;
          align-self: center;
          height: 12px;
          border-right: 1px solid var(--separator-color, var(--default-separator-color));
        }

        .button-container, ::slotted(*) {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex: var(--button-container-flex, var(--default-button-container-flex))
        }

        .right-action::slotted(*) {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .left-action::slotted(*) {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        paper-tab {
          padding: var(--page-header-tab-padding, var(--default-page-header-tab-padding));
          font-family: var(--page-header-font-family, var(--default-page-header-font-family));
        }

        .hide {
          display: none;
        }
      `];
      }
    }, {
      key: "properties",
      get: function () {
        return {
          header: {
            type: String
          },
          tabs: {
            type: Array
          },
          selectedTab: {
            type: Number
          },
          onTabSelect: {
            type: Function
          },
          showSeparator: {
            type: false
          }
        };
      }
    }]);
    return UnityPageHeader;
  }(LitElement);
  window.customElements.define('unity-page-header', UnityPageHeader);

  /**
   * @name UnityPaginationControls
  * @description Renders a control bar for navigating through a set of paginated results.
  * @param {String} [id], id of controls used for accessing in DOM
  * @param {Number} [itemsPerPage], number of items to be displayed per page.
  * @param {Number} [currentPage], page number of current page. If not defined, will not be displayed.
  * @param {Number} [pageCount], total number of pages. If currentPage or pageCount is not defined, will not be displayed.
  * @param {Boolean} [hasPrevPage], indicates if there is a previous page to fetch
  * @param {Boolean} [hasNextPage], indicates if there is a next page to fetch
  * @param {Boolean} [showLastPage], indicates if the button to navigate to last page is visible, defaults to false.
  * @param {Function} [onFirstPageClick], callback when first page button is clicked. Typically used to trigger an api request.
  * @param {Function} [onPrevPageClick], callback when previous page button is clicked. Typically used to trigger an api request.
  * @param {Function} [onNextPageClick], callback when next page button is clicked. Typically used to trigger an api request.
  * @param {Function} [onLastPageClick], callback when last page button is clicked. Typically used to trigger an api request.
  * @param {Function} [onItemsPerPageUpdate], callback when number of items per page is updated.
  * @example
  * <unity-pagination-controls
  *   id="things-list-controls"
  *   itemsPerPage="25"
  *   hasNextPage
  *   .onFirstPageClick="${e => console.log("TODO: fetch first page of results")}"
  *   .onPrevPageClick="${e => console.log("TODO: fetch previous page of results")}"
  *   .onNextPageClick="${e => console.log("TODO: fetch next page of results")}"
  *   .onItemsPerPageUpdate="${itemsPerPage => console.log("Items per page has been updated: ", {itemsPerPage})}"
  * >
  * </unity-pagination-controls>
  **/

  // === CONSTANTS ===
  const itemsPerPageOptions = [{
    label: "15",
    id: "15"
  }, {
    label: "25",
    id: "25"
  }, {
    label: "50",
    id: "50"
  }, {
    label: "100",
    id: "100"
  }];

  // === COMPONENT ===
  let UnityPaginationControls = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityPaginationControls, _LitElement);
    var _super = _createSuper(UnityPaginationControls);
    function UnityPaginationControls() {
      var _this;
      _classCallCheck(this, UnityPaginationControls);
      _this = _super.call(this);
      _this.id = "";
      _this.itemsPerPage = 25;
      _this.hasPrevPage = false;
      _this.hasNextPage = false;
      _this.showLastPage = false;
      _this.currentPage = undefined;
      _this.pageCount = undefined;

      //TODO: track pagination cursor
      _this.onFirstPageClick = () => {};
      _this.onPrevPageClick = () => {};
      _this.onNextPageClick = () => {};
      _this.onItemsPerPageUpdate = () => {};
      _this.onLastPageClick = () => {};
      _this._isResultsPerPageExanded = false;
      return _this;
    }
    _createClass(UnityPaginationControls, [{
      key: "handleItemsPerPageSelect",
      value: function handleItemsPerPageSelect(itemsPerPage) {
        const itemsNum = Number(itemsPerPage);
        this.onItemsPerPageUpdate(itemsNum);
        this.itemsPerPage = itemsPerPage;
        this._isResultsPerPageExanded = false;
      }
    }, {
      key: "toggleMenuExpand",
      value: function toggleMenuExpand(expanded) {
        this._isResultsPerPageExanded = typeof expanded === 'boolean' ? expanded : !this._isResultsPerPageExanded;
      }
    }, {
      key: "handleFirst",
      value: function handleFirst() {
        if (!this.hasPrevPage) return;
        this.onFirstPageClick({
          itemsPerPage: this.itemsPerPage
        });
      }
    }, {
      key: "handlePrev",
      value: function handlePrev() {
        if (!this.hasPrevPage) return;
        this.onPrevPageClick({
          itemsPerPage: this.itemsPerPage
        });
      }
    }, {
      key: "handleNext",
      value: function handleNext() {
        if (!this.hasNextPage) return;
        this.onNextPageClick({
          itemsPerPage: this.itemsPerPage
        });
      }
    }, {
      key: "handleLast",
      value: function handleLast() {
        if (!this.showLastPage || !this.hasNextPage) return;
        this.onLastPageClick({
          itemsPerPage: this.itemsPerPage
        });
      }
    }, {
      key: "render",
      value: function render() {
        return html$1`
      <div id="${this.id}" class="unity-pagination-controls">
        <div id="results-per-page-control">
          <unity-typography id="results-per-page-title">
            Results per page
          </unity-typography>

          <unity-popover
            id="results-per-page-menu"
            closeOnOutsideClick="${true}"
            ?show="${this._isResultsPerPageExanded}"
            .onClose="${e => this.toggleMenuExpand(false)}"
          >

            <unity-button
              slot="on-page-content"
              label="${this.itemsPerPage}"
              rightIcon="unity:up_chevron"
              @click="${this.toggleMenuExpand}"
              type="borderless"
            >
            </unity-button>
            <unity-select-menu
              slot="popover-content"
              .options="${itemsPerPageOptions}"
              .onMenuClick="${this.handleItemsPerPageSelect.bind(this)}"
              .highlighted="${[this.itemsPerPage]}"
              borderless
            >
            </unity-select-menu>
          </unity-popover>
        </div>

        <unity-button
          id="first-page-button"
          class="pagination-btn"
          title="First page"
          centerIcon="icons:first-page"
          type="borderless"
          ?disabled="${!this.hasPrevPage}"
          @click=${this.handleFirst}
        ></unity-button>
        <unity-button
          id="previous-page-button"
          class="pagination-btn"
          title="Previous"
          centerIcon="chevron-left"
          type="borderless"
          ?disabled="${!this.hasPrevPage}"
          @click=${this.handlePrev}
        ></unity-button>
        ${this.currentPage ? html$1`<unity-typography id="page-number">
              ${this.currentPage} ${this.pageCount ? `/${this.pageCount}` : null}
            </unity-typography>` : null}
        <unity-button
          id="next-page-button"
          class="pagination-btn"
          title="Next"
          centerIcon="chevron-right"
          type="borderless"
          ?disabled="${!this.hasNextPage}"
          @click=${this.handleNext}
        ></unity-button>
        ${this.showLastPage ? html$1`<unity-button
              id="last-page-button"
              class="pagination-btn"
              title="Last"
              centerIcon="icons:last-page"
              type="borderless"
              ?disabled="${!this.hasNextPage}"
              @click=${this.handleLast}
            ></unity-button>` : null}
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          id: {
            type: String
          },
          itemsPerPage: {
            type: Number
          },
          currentPage: {
            type: Number
          },
          pageCount: {
            type: Number
          },
          hasPrevPage: {
            type: Boolean
          },
          hasNextPage: {
            type: Boolean
          },
          showLastPage: {
            type: Boolean
          },
          onFirstPageClick: {
            type: Function
          },
          onPrevPageClick: {
            type: Function
          },
          onNextPageClick: {
            type: Function
          },
          onItemsPerPageUpdate: {
            type: Function
          },
          onLastPageClick: {
            type: Function
          },
          _isResultsPerPageExanded: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          /*flex: 0;*/
          width: 100%;
          --popover-padding: 0;
          --popover-z-index: 200;
        }
        .unity-pagination-controls {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: stretch;
        }
        #results-per-page-control {
          display: flex;
          align-items: center;
        }
        #results-per-page-title {
          white-space: nowrap;
        }

        unity-select-menu {
          width: 100%;

        }
        .pagination-btn {
          margin-right: 12px;
        }
        #page-number {
          height: 30px;
          line-height: 30px;
          margin-right: 12px;
        }
        unity-typography {
          white-space: nowrap;
        }
      `];
      }
    }]);
    return UnityPaginationControls;
  }(LitElement);
  window.customElements.define('unity-pagination-controls', UnityPaginationControls);

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `iron-range-behavior` provides the behavior for something with a minimum to
   * maximum range.
   *
   * @demo demo/index.html
   * @polymerBehavior
   */
  const IronRangeBehavior = {
    properties: {
      /**
       * The number that represents the current value.
       */
      value: {
        type: Number,
        value: 0,
        notify: true,
        reflectToAttribute: true
      },
      /**
       * The number that indicates the minimum value of the range.
       */
      min: {
        type: Number,
        value: 0,
        notify: true
      },
      /**
       * The number that indicates the maximum value of the range.
       */
      max: {
        type: Number,
        value: 100,
        notify: true
      },
      /**
       * Specifies the value granularity of the range's value.
       */
      step: {
        type: Number,
        value: 1,
        notify: true
      },
      /**
       * Returns the ratio of the value.
       */
      ratio: {
        type: Number,
        value: 0,
        readOnly: true,
        notify: true
      }
    },
    observers: ['_update(value, min, max, step)'],
    _calcRatio: function (value) {
      return (this._clampValue(value) - this.min) / (this.max - this.min);
    },
    _clampValue: function (value) {
      return Math.min(this.max, Math.max(this.min, this._calcStep(value)));
    },
    _calcStep: function (value) {
      // polymer/issues/2493
      value = parseFloat(value);
      if (!this.step) {
        return value;
      }
      var numSteps = Math.round((value - this.min) / this.step);
      if (this.step < 1) {
        /**
         * For small values of this.step, if we calculate the step using
         * `Math.round(value / step) * step` we may hit a precision point issue
         * eg. 0.1 * 0.2 =  0.020000000000000004
         * http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
         *
         * as a work around we can divide by the reciprocal of `step`
         */
        return numSteps / (1 / this.step) + this.min;
      } else {
        return numSteps * this.step + this.min;
      }
    },
    _validateValue: function () {
      var v = this._clampValue(this.value);
      this.value = this.oldValue = isNaN(v) ? this.oldValue : v;
      return this.value !== v;
    },
    _update: function () {
      this._validateValue();
      this._setRatio(this._calcRatio(this.value) * 100);
    }
  };

  /**
  @license
  Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  Material design: [Progress &
  activity](https://www.google.com/design/spec/components/progress-activity.html)

  The progress bars are for situations where the percentage completed can be
  determined. They give users a quick sense of how much longer an operation
  will take.

  Example:

      <paper-progress value="10"></paper-progress>

  There is also a secondary progress which is useful for displaying intermediate
  progress, such as the buffer level during a streaming playback progress bar.

  Example:

      <paper-progress value="10" secondary-progress="30"></paper-progress>

  ### Styling progress bar:

  To change the active progress bar color:

      paper-progress {
         --paper-progress-active-color: #e91e63;
      }

  To change the secondary progress bar color:

      paper-progress {
        --paper-progress-secondary-color: #f8bbd0;
      }

  To change the progress bar background color:

      paper-progress {
        --paper-progress-container-color: #64ffda;
      }

  Add the class `transiting` to a paper-progress to animate the progress bar when
  the value changed. You can also customize the transition:

      paper-progress {
        --paper-progress-transition-duration: 0.08s;
        --paper-progress-transition-timing-function: ease;
        --paper-progress-transition-delay: 0s;
      }

  To change the duration of the indeterminate cycle:

      paper-progress {
        --paper-progress-indeterminate-cycle-duration: 2s;
      }

  The following mixins are available for styling:

  Custom property | Description | Default
  ----------------|-------------|---------
  `--paper-progress-container` | Mixin applied to container | `{}`
  `--paper-progress-transition-duration` | Duration of the transition | `0.08s`
  `--paper-progress-transition-timing-function` | The timing function for the transition | `ease`
  `--paper-progress-transition-delay` | delay for the transition | `0s`
  `--paper-progress-container-color` | Color of the container | `--google-grey-300`
  `--paper-progress-active-color` | The color of the active bar | `--google-green-500`
  `--paper-progress-secondary-color` | The color of the secondary bar | `--google-green-100`
  `--paper-progress-disabled-active-color` | The color of the active bar if disabled | `--google-grey-500`
  `--paper-progress-disabled-secondary-color` | The color of the secondary bar if disabled  | `--google-grey-300`
  `--paper-progress-height` | The height of the progress bar | `4px`
  `--paper-progress-indeterminate-cycle-duration` | Duration of an indeterminate cycle | `2s`

  @group Paper Elements
  @element paper-progress
  @demo demo/index.html
  */
  Polymer({
    _template: html`
    <style>
      :host {
        display: block;
        width: 200px;
        position: relative;
        overflow: hidden;
      }

      :host([hidden]), [hidden] {
        display: none !important;
      }

      #progressContainer {
        @apply --paper-progress-container;
        position: relative;
      }

      #progressContainer,
      /* the stripe for the indeterminate animation*/
      .indeterminate::after {
        height: var(--paper-progress-height, 4px);
      }

      #primaryProgress,
      #secondaryProgress,
      .indeterminate::after {
        @apply --layout-fit;
      }

      #progressContainer,
      .indeterminate::after {
        background: var(--paper-progress-container-color, var(--google-grey-300));
      }

      :host(.transiting) #primaryProgress,
      :host(.transiting) #secondaryProgress {
        -webkit-transition-property: -webkit-transform;
        transition-property: transform;

        /* Duration */
        -webkit-transition-duration: var(--paper-progress-transition-duration, 0.08s);
        transition-duration: var(--paper-progress-transition-duration, 0.08s);

        /* Timing function */
        -webkit-transition-timing-function: var(--paper-progress-transition-timing-function, ease);
        transition-timing-function: var(--paper-progress-transition-timing-function, ease);

        /* Delay */
        -webkit-transition-delay: var(--paper-progress-transition-delay, 0s);
        transition-delay: var(--paper-progress-transition-delay, 0s);
      }

      #primaryProgress,
      #secondaryProgress {
        @apply --layout-fit;
        -webkit-transform-origin: left center;
        transform-origin: left center;
        -webkit-transform: scaleX(0);
        transform: scaleX(0);
        will-change: transform;
      }

      #primaryProgress {
        background: var(--paper-progress-active-color, var(--google-green-500));
      }

      #secondaryProgress {
        background: var(--paper-progress-secondary-color, var(--google-green-100));
      }

      :host([disabled]) #primaryProgress {
        background: var(--paper-progress-disabled-active-color, var(--google-grey-500));
      }

      :host([disabled]) #secondaryProgress {
        background: var(--paper-progress-disabled-secondary-color, var(--google-grey-300));
      }

      :host(:not([disabled])) #primaryProgress.indeterminate {
        -webkit-transform-origin: right center;
        transform-origin: right center;
        -webkit-animation: indeterminate-bar var(--paper-progress-indeterminate-cycle-duration, 2s) linear infinite;
        animation: indeterminate-bar var(--paper-progress-indeterminate-cycle-duration, 2s) linear infinite;
      }

      :host(:not([disabled])) #primaryProgress.indeterminate::after {
        content: "";
        -webkit-transform-origin: center center;
        transform-origin: center center;

        -webkit-animation: indeterminate-splitter var(--paper-progress-indeterminate-cycle-duration, 2s) linear infinite;
        animation: indeterminate-splitter var(--paper-progress-indeterminate-cycle-duration, 2s) linear infinite;
      }

      @-webkit-keyframes indeterminate-bar {
        0% {
          -webkit-transform: scaleX(1) translateX(-100%);
        }
        50% {
          -webkit-transform: scaleX(1) translateX(0%);
        }
        75% {
          -webkit-transform: scaleX(1) translateX(0%);
          -webkit-animation-timing-function: cubic-bezier(.28,.62,.37,.91);
        }
        100% {
          -webkit-transform: scaleX(0) translateX(0%);
        }
      }

      @-webkit-keyframes indeterminate-splitter {
        0% {
          -webkit-transform: scaleX(.75) translateX(-125%);
        }
        30% {
          -webkit-transform: scaleX(.75) translateX(-125%);
          -webkit-animation-timing-function: cubic-bezier(.42,0,.6,.8);
        }
        90% {
          -webkit-transform: scaleX(.75) translateX(125%);
        }
        100% {
          -webkit-transform: scaleX(.75) translateX(125%);
        }
      }

      @keyframes indeterminate-bar {
        0% {
          transform: scaleX(1) translateX(-100%);
        }
        50% {
          transform: scaleX(1) translateX(0%);
        }
        75% {
          transform: scaleX(1) translateX(0%);
          animation-timing-function: cubic-bezier(.28,.62,.37,.91);
        }
        100% {
          transform: scaleX(0) translateX(0%);
        }
      }

      @keyframes indeterminate-splitter {
        0% {
          transform: scaleX(.75) translateX(-125%);
        }
        30% {
          transform: scaleX(.75) translateX(-125%);
          animation-timing-function: cubic-bezier(.42,0,.6,.8);
        }
        90% {
          transform: scaleX(.75) translateX(125%);
        }
        100% {
          transform: scaleX(.75) translateX(125%);
        }
      }
    </style>

    <div id="progressContainer">
      <div id="secondaryProgress" hidden\$="[[_hideSecondaryProgress(secondaryRatio)]]"></div>
      <div id="primaryProgress"></div>
    </div>
`,
    is: 'paper-progress',
    behaviors: [IronRangeBehavior],
    properties: {
      /**
       * The number that represents the current secondary progress.
       */
      secondaryProgress: {
        type: Number,
        value: 0
      },
      /**
       * The secondary ratio
       */
      secondaryRatio: {
        type: Number,
        value: 0,
        readOnly: true
      },
      /**
       * Use an indeterminate progress indicator.
       */
      indeterminate: {
        type: Boolean,
        value: false,
        observer: '_toggleIndeterminate'
      },
      /**
       * True if the progress is disabled.
       */
      disabled: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        observer: '_disabledChanged'
      }
    },
    observers: ['_progressChanged(secondaryProgress, value, min, max, indeterminate)'],
    hostAttributes: {
      role: 'progressbar'
    },
    _toggleIndeterminate: function (indeterminate) {
      // If we use attribute/class binding, the animation sometimes doesn't
      // translate properly on Safari 7.1. So instead, we toggle the class here in
      // the update method.
      this.toggleClass('indeterminate', indeterminate, this.$.primaryProgress);
    },
    _transformProgress: function (progress, ratio) {
      var transform = 'scaleX(' + ratio / 100 + ')';
      progress.style.transform = progress.style.webkitTransform = transform;
    },
    _mainRatioChanged: function (ratio) {
      this._transformProgress(this.$.primaryProgress, ratio);
    },
    _progressChanged: function (secondaryProgress, value, min, max, indeterminate) {
      secondaryProgress = this._clampValue(secondaryProgress);
      value = this._clampValue(value);
      var secondaryRatio = this._calcRatio(secondaryProgress) * 100;
      var mainRatio = this._calcRatio(value) * 100;
      this._setSecondaryRatio(secondaryRatio);
      this._transformProgress(this.$.secondaryProgress, secondaryRatio);
      this._transformProgress(this.$.primaryProgress, mainRatio);
      this.secondaryProgress = secondaryProgress;
      if (indeterminate) {
        this.removeAttribute('aria-valuenow');
      } else {
        this.setAttribute('aria-valuenow', value);
      }
      this.setAttribute('aria-valuemin', min);
      this.setAttribute('aria-valuemax', max);
    },
    _disabledChanged: function (disabled) {
      this.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    },
    _hideSecondaryProgress: function (secondaryRatio) {
      return secondaryRatio === 0;
    }
  });

  /**
   * Progress bar with configurable styles. Accepts main and secondary progresses. May be set as indeterminate, showing a
   * progress animation in a loop.
   * @name UnityProgress
   * @param {string} label, text above the progress bar
   * @param {string} remark, text below the progress bar
   * @param {number} max, maximum progress value, defaults to 1
   * @param {number} value, current progress value, defaults to 0
   * @param {number} secondaryValue, value for secondary progress, defaults to 0
   * @param {bool} indeterminate, use progress animation instead of controlled values, defaults to false
   * @param {string} completionType, type for text inside progress showing completion. May be a percentage, ratio (value/max), or
   * an empty string. Defaults to ''
  *  @example
      <unity-progress
        style="width: 300px"
        max=100
        value=25
        secondaryValue=60
        label='Progress'
        remark='Remark
        ?indeterminate=${false}
        completionType='percentage'
      </unity-progress>
  */
  let UnityProgress = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityProgress, _LitElement);
    var _super = _createSuper(UnityProgress);
    function UnityProgress() {
      var _this;
      _classCallCheck(this, UnityProgress);
      _this = _super.call(this);
      _this.label = '';
      _this.remark = '';
      _this.max = 1;
      _this.value = 0;
      _this.secondaryValue = 0;
      _this.indeterminate = false;
      _this.completionType = '';
      return _this;
    }
    _createClass(UnityProgress, [{
      key: "getCompletion",
      value: function getCompletion(type, value, max) {
        switch (type) {
          case 'percentage':
            return `${value / max * 100} %`;
          case 'ratio':
            return `${value} / ${max}`;
          default:
            return '';
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          completionType,
          label,
          indeterminate,
          max,
          remark,
          value,
          secondaryValue
        } = this;
        const completion = this.getCompletion(completionType, value, max);
        return html$1`
      <div class='progressContainer'>
        ${label ? html$1`
          <unity-typography class='label' size='paragraph' color='dark'>
            ${label}
          </unity-typography>
        ` : ''}
        <div class='progress-wrapper'>
          <paper-progress ?indeterminate=${indeterminate} max="${max}" value="${value}" secondary-progress="${secondaryValue}"></paper-progress>
          ${completion && !indeterminate ? html$1`
            <div class='completion'>
              <unity-typography class='completion-text' size='paragraph' color='dark'>
                ${completion}
              </unity-typography>  
            </div>
            ` : ''}
        </div>
        ${remark ? html$1`
          <unity-typography class='remark' size='paragraph' color='dark'>
            ${remark}
          </unity-typography>
        ` : ''}
      </div> 
      `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          label: {
            type: String
          },
          remark: {
            type: String
          },
          max: {
            type: Number
          },
          value: {
            type: Number
          },
          secondaryValue: {
            type: Number
          },
          indeterminate: {
            type: Boolean
          },
          completionType: {
            type: String
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --progress-color: var(--default-primary-brand-color);
          --progress-secondary-color: var(--default-primary-brand-color-light);
          --progress-height: 20px;
          --progress-indeterminate-cycle-duration: 3s;
          --remark-position: start;
          --completion-position: center;
          --completion-color: black;
          display: block;
        }
        .label {
          padding: 0;
        }
        .remark {
          width: 100%;
          text-align: var(--remark-position);
        }
        .completion {
          position: absolute;
          width: 96%;
          left: 2%;
          text-align: var(--completion-position);
          top: 50%;
          transform: translate(0, -50%);
        }
        .progress-wrapper {
          position: relative;
          width: 100%;
        }
        paper-progress {
          --paper-progress-active-color: var(--progress-color);
          --paper-progress-secondary-color: var(--progress-secondary-color);
          --paper-progress-height: var(--progress-height);
          --paper-progress-indeterminate-cycle-duration: var(--progress-indeterminate-cycle-duration);
          width: 100%;
          margin: 6px 0;
        }
        .progressContainer {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          position: relative;
        }
        .completion-text {
          --font-color-dark: var(--completion-color);
        }
      `];
      }
    }]);
    return UnityProgress;
  }(LitElement);
  window.customElements.define('unity-progress', UnityProgress);

  /* eslint-disable no-undefined,no-param-reassign,no-shadow */

  /**
   * Throttle execution of a function. Especially useful for rate limiting
   * execution of handlers on events like resize and scroll.
   *
   * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
   * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
   *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
   *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
   *                                    the internal counter is reset).
   * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
   *                                    to `callback` when the throttled-function is executed.
   * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
   *                                    schedule `callback` to execute after `delay` ms.
   *
   * @returns {Function}  A new, throttled, function.
   */
  function throttle(delay, noTrailing, callback, debounceMode) {
    /*
     * After wrapper has stopped being called, this timeout ensures that
     * `callback` is executed at the proper times in `throttle` and `end`
     * debounce modes.
     */
    var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.

    var lastExec = 0; // Function to clear existing timeout

    function clearExistingTimeout() {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
    } // Function to cancel next exec

    function cancel() {
      clearExistingTimeout();
      cancelled = true;
    } // `noTrailing` defaults to falsy.

    if (typeof noTrailing !== 'boolean') {
      debounceMode = callback;
      callback = noTrailing;
      noTrailing = undefined;
    }
    /*
     * The `wrapper` function encapsulates all of the throttling / debouncing
     * functionality and when executed will limit the rate at which `callback`
     * is executed.
     */

    function wrapper() {
      for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
        arguments_[_key] = arguments[_key];
      }
      var self = this;
      var elapsed = Date.now() - lastExec;
      if (cancelled) {
        return;
      } // Execute `callback` and update the `lastExec` timestamp.

      function exec() {
        lastExec = Date.now();
        callback.apply(self, arguments_);
      }
      /*
       * If `debounceMode` is true (at begin) this is used to clear the flag
       * to allow future `callback` executions.
       */

      function clear() {
        timeoutID = undefined;
      }
      if (debounceMode && !timeoutID) {
        /*
         * Since `wrapper` is being called for the first time and
         * `debounceMode` is true (at begin), execute `callback`.
         */
        exec();
      }
      clearExistingTimeout();
      if (debounceMode === undefined && elapsed > delay) {
        /*
         * In throttle mode, if `delay` time has been exceeded, execute
         * `callback`.
         */
        exec();
      } else if (noTrailing !== true) {
        /*
         * In trailing throttle mode, since `delay` time has not been
         * exceeded, schedule `callback` to execute `delay` ms after most
         * recent execution.
         *
         * If `debounceMode` is true (at begin), schedule `clear` to execute
         * after `delay` ms.
         *
         * If `debounceMode` is false (at end), schedule `callback` to
         * execute after `delay` ms.
         */
        timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
      }
    }
    wrapper.cancel = cancel; // Return the wrapper function.

    return wrapper;
  }

  /* eslint-disable no-undefined */
  /**
   * Debounce execution of a function. Debouncing, unlike throttling,
   * guarantees that a function is only executed a single time, either at the
   * very beginning of a series of calls, or at the very end.
   *
   * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
   * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
   *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
   *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
   * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
   *                                  to `callback` when the debounced-function is executed.
   *
   * @returns {Function} A new, debounced function.
   */

  function debounce(delay, atBegin, callback) {
    return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
  }

  /**
   * @name UnitySearchBar
   * @param {''} search, the initial value of the search field
   * @param {[]} tags, the initial tags applied to the search, obj w/ value and label
   * @param {func} onChange, the callback to return the current list of terms to search by
   * @param {[]} textSeed, the list of keywords to seed the autocomplete, array of strings, not implemented
   * @param {[]} tagSeed, the list of tags to seed the autocomplete, array of str or obj as above
   * @param {number} debounceTime, the ms value to debounce input changes by, defaults to 300
   * @param {string} placeholder, the placeholder text inside the text input.
   * @example
   * <unity-search-bar
   *   .search="${searchFromCookie}"
   *   .tags="${tagsFromCookie}"
   *   .textSeed="${[...listOfThingNames, ...listOfThingActions, ...listOfThingProperties]}"
   *   .tagSeed="${[...listOfThingTags, "Online", { label: "Offline", value: "disconnected" }]}"
   *   .debounceTime="${500}"
   * />
   *
   * css vars
   *   input-font
   *   input-text-color
   *   input-text-size
   *   input-icon-color
   *   input-border-color
   *   input-border-hover-color
   *   input-border-focus-color
   *   input-border-radius
   *   search-tag-color
   *   search-tag-text-color
   *   search-tag-border
   **/
  let UnitySearchBar = /*#__PURE__*/function (_LitElement) {
    _inherits(UnitySearchBar, _LitElement);
    var _super = _createSuper(UnitySearchBar);
    function UnitySearchBar() {
      var _this;
      _classCallCheck(this, UnitySearchBar);
      _this = _super.call(this);
      _this._search = "";
      _this._tags = new Map();
      // this.textSeed = []
      _this._tagSeed = new Map();
      _this._onChange = () => {};
      _this._debounceTime = 300;
      _this.placeholder = 'Search';

      // will track off of input, component will render off of this and if _currentOptions has matches
      _this._showOptions = false;
      _this._currentOptions = {};
      _this._debouncedOnChange = () => {};
      _this._menuWidth = 0;
      _this._showPopover = false;
      _this._excludedTags = [];
      _this._availableTags = new Map();
      _this._oversized = false;
      _this._ellipsisRight = 0;
      _this._popoverWidth = 0;
      _this._makeDebounced();
      return _this;
    }
    _createClass(UnitySearchBar, [{
      key: "search",
      get: function () {
        return this._search;
      },
      set: function (value) {
        const oldValue = this._search;
        this._search = value;
        this.getMatches();
        this.requestUpdate('search', oldValue);
      }
    }, {
      key: "tags",
      get: function () {
        return this._tags;
      },
      set: function (value) {
        const oldValue = this._tags;
        let newValue = value;
        // if not a map, make it into a map
        if (!(value instanceof Map)) {
          // if not an array, make an empty map
          if (!Array.isArray(value)) {
            newValue = new Map();
          } else {
            // get array of tag strings to exclude
            newValue = new Map(value.map(tag => [tag.value, tag]));
          }
        }
        this._tags = newValue;
        // all [tag values and labels]
        let excluded = [];
        newValue.forEach(_ref => {
          let {
            value,
            label
          } = _ref;
          if (value) excluded.push(value);else if (label) excluded.push(label);
        });
        this._excludedTags = excluded;
        this.getMatches();
        this.requestUpdate('tags', oldValue);
      }
    }, {
      key: "tagSeed",
      get: function () {
        return this._tagSeed;
      },
      set: function (value) {
        const oldValue = this._tagSeed;
        this._tagSeed = value;
        this._availableTags = new Map(value.map(tag => [tag.value, tag]));
        this.getMatches();
        this.requestUpdate('tagSeed', oldValue);
      }
    }, {
      key: "onChange",
      get: function () {
        return this._onChange;
      },
      set: function (value) {
        const oldValue = this._onChange;
        this._onChange = value;
        this._makeDebounced();
        this.requestUpdate('onChange', oldValue);
      }
    }, {
      key: "debounceTime",
      get: function () {
        return this._debounceTime;
      },
      set: function (value) {
        const oldValue = this._debounceTime;
        this._debounceTime = value;
        this._makeDebounced();
        this.requestUpdate('debounceTime', oldValue);
      }
    }, {
      key: "_makeDebounced",
      value: function _makeDebounced() {
        this._debouncedOnChange = debounce(this.debounceTime, v => this.onInputChange(v));
      }
    }, {
      key: "report",
      value: function report() {
        this.onChange({
          tags: Array.from(this.tags.values()),
          text: this.search
        });
      }
    }, {
      key: "onInputChange",
      value: function onInputChange(value) {
        this.search = value;
        this.report(); // should return {tags, text: search}
      }
    }, {
      key: "getMatches",
      value: function getMatches() {
        const {
          tagSeed,
          // textSeed,
          search,
          _excludedTags: exclude
        } = this;
        const matches = findMatches({
          tagSeed,
          /*textSeed,*/search,
          exclude
        });
        const {
          tags: tagOptions = [],
          text: textOptions = []
        } = matches;
        this._showOptions = tagOptions.length > 0 || textOptions.length > 0;
        this._currentOptions = matches;
      }
    }, {
      key: "selectTag",
      value: function selectTag(tagValue) {
        let {
          search,
          _availableTags,
          tags
        } = this;
        const newTag = _availableTags.get(tagValue);
        tags.set(tagValue, newTag);
        this.tags = tags;
        // clear input of matching chars or first from end
        const trimmedSearch = search.trim();
        // see if can remove whole tag
        const valueRegex = RegExp(newTag.value, 'i');
        const labelRegex = RegExp(newTag.label, 'i');
        let newSearch;
        if (newTag.value && valueRegex.test(trimmedSearch)) {
          let removed = trimmedSearch.split(valueRegex);
          newSearch = removed.map(term => term.trim());
        } else if (newTag.label && labelRegex.test(trimmedSearch)) {
          let removed = trimmedSearch.split(labelRegex);
          newSearch = removed.map(term => term.trim());
        } else {
          // split input on spaces
          const terms = trimmedSearch.split(/\s+/);
          // check from back to remove only last-most possible tag
          let found = false;
          for (let i = terms.length - 1; i >= 0 && found === false; i--) {
            let term = RegExp(terms[i], 'i');
            found = term.test(newTag.value) || term.test(newTag.label) ? i : false;
          }
          newSearch = [].concat(_toConsumableArray(terms.slice(0, found)), _toConsumableArray(terms.slice(found + 1)));
        }
        // filter out anything that is included in tagValue
        this.search = newSearch.join(" ");
        // call report to onChange
        this.report();
        // keep focus on input
        this.shadowRoot.querySelector('.input').shadowRoot.querySelector('#input').focus();
      }

      // TODO: add selectText, selecting text option from menu would remove all terms that match and add selected text to the search
      // term would need to be saved in a list to make sure it's included in the match exclude
      // careful around terms that include spaces
      // need to make sure to update said lib when term is entered manually or removed
    }, {
      key: "removeTag",
      value: function removeTag(tagValue) {
        const {
          tags
        } = this;
        tags.delete(tagValue);
        this.tags = tags;
        this.getMatches();
        this.report();
        if (tags.size === 0) this.togglePopover(false);
      }
    }, {
      key: "clearInput",
      value: function clearInput() {
        this.tags = [];
        this.search = "";
        this._showOptions = false;
        this._currentOptions = {};
        // report to onChange
        this.report();
      }
    }, {
      key: "renderTags",
      value: function renderTags() {
        const {
          tags,
          _showPopover,
          _oversized,
          _popoverWidth
        } = this;
        if (tags.size === 0) return null;

        // get element to act as root for popover
        const popoverRoot = this.shadowRoot.querySelector('div.tag-list');
        if (!popoverRoot) return html$1`<div class="tag-list"></div>`;
        // get height offset for popover
        const popoverOffset = popoverRoot && popoverRoot.clientHeight * -1 + 1 || 0;
        // iterate over tags
        let tagsToRender = [];
        tags.forEach(_ref2 => {
          let {
            label,
            value,
            styles
          } = _ref2;
          // make style str from tag.styles
          let tagStyles = '';
          if (styles instanceof Object) {
            tagStyles = Object.entries(styles).reduce((a, _ref3) => {
              let [key, value] = _ref3;
              return `${a}${key}: ${value};`;
            }, '');
          }
          tagsToRender.push(html$1`
        <unity-tag
          id="search-bar-tag-${value}"
          class="search-bar-tag"
          withClose
          .label="${label || value}"
          .value="${value}"
          .onClose="${(e, v) => this.removeTag(v)}"
          style="${tagStyles}"
        ></unity-tag>
      `);
        });
        return html$1`
      <div class="tag-list" @mouseover="${() => this.handleHover()}">
        <unity-popover
          .show="${_showPopover}"
          .flip="${false}"
          closeOnOutsideClick
          .onClose="${() => this.togglePopover(false)}"
          placement="bottom-start"
          .distance="${popoverOffset}"
          .referenceElement="${popoverRoot}"
          id="tag-popover"
          style="--popover-max-width: ${_popoverWidth}px"
        >
          <div class="popover-list" slot="on-page-content" >${tagsToRender}</div>
          <div class="popover-content" slot="popover-content">${tagsToRender}</div>
        </unity-popover>
      </div>
    `;
      }
    }, {
      key: "handleHover",
      value: function handleHover() {
        if (this._oversized) this.togglePopover(true);
      }
    }, {
      key: "togglePopover",
      value: function togglePopover(show) {
        this._showPopover = typeof show === 'boolean' ? show : !this._showPopover;
      }
    }, {
      key: "renderMenu",
      value: function renderMenu() {
        const {
          _showOptions,
          _currentOptions: {
            tags = [],
            text = []
          } = {},
          _menuWidth
        } = this;
        if (!_showOptions || tags.length === 0 && text.length === 0) return null;
        const tagOptions = tags.map((_ref4, i) => {
          let {
            label,
            value,
            styles
          } = _ref4;
          let tagStyles = {
            "--tag-text-color": "var(--dark-gray-color, var(--default-dark-gray-color))",
            "--tag-color": "transparent",
            "--tag-border": "1px solid var(--dark-gray-color, var(--default-dark-gray-color))"
          };
          if (styles instanceof Object) {
            Object.entries(styles).forEach(_ref5 => {
              let [key, value] = _ref5;
              tagStyles[key] = value;
            });
          }
          return {
            label: label || value,
            tag: true,
            id: value,
            tagStyles
          };
        });
        return html$1`
      <unity-select-menu
        .options="${[].concat(_toConsumableArray(tagOptions), _toConsumableArray(text))}"
        .onMenuClick="${tag => this.selectTag(tag)}"
        style="max-width: ${_menuWidth}px;"
      ></unity-select-menu>
    `;
      }
    }, {
      key: "updated",
      value: function updated() {
        // setting position for autocomplet menu
        const search = this.shadowRoot.querySelector('div#search-bar');
        const input = this.shadowRoot.querySelector('unity-text-input.input');
        const searchRects = search.getClientRects();
        if (searchRects.length) {
          const {
            [0]: {
              left: outerLeft = 0,
              width = 0
            } = []
          } = !!search ? search.getClientRects() : {};
          const {
            [0]: {
              left: innerLeft = 0,
              width: inputWidth = 0
            } = []
          } = !!input ? input.getClientRects() : {};
          const leftPos = Math.abs(outerLeft - innerLeft);
          this._menuWidth = width - leftPos;
          this._ellipsisRight = inputWidth;

          // controls if popover and tag ellipsis should show
          this.updateComplete.then(() => {
            const tagList = this.shadowRoot.querySelector('div.tag-list');
            const popover = this.shadowRoot.querySelector('unity-popover');
            const {
              [0]: {
                height: tagListHeight = 0,
                width: tagListWidth = 0
              } = []
            } = !!tagList ? tagList.getClientRects() : {};
            this._popoverWidth = tagListWidth - 16; // account for popover's padding

            const {
              [1]: {
                height: popoverHeight = 0
              } = []
            } = !!popover ? popover.getClientRects() : {};

            // open if needed, otherwise delete tag
            const overbounds = tagListHeight * 1.25 < popoverHeight;
            if (this.tags.size > 0 && overbounds && !this._showPopover) this._oversized = true;else this._oversized = false;
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          search,
          _oversized,
          _ellipsisRight
        } = this;
        return html$1`
      <div id="search-bar" class="showBorder">
        <unity-icon icon="unity:search"></unity-icon>
        ${this.renderTags()}
        <div class="input-wrapper">
          ${!!_oversized ? html$1`<unity-typography style="right: ${_ellipsisRight}px;" class="ellipsis">...</unity-typography>` : null}
          <unity-text-input
            id="search-bar-text-input"
            class="input"
            hideBorder
            .value="${search}"
            .onChange="${(e, v) => this._debouncedOnChange(v)}"
            placeholder="${this.placeholder}"
            .hideErrors=${true}
          ></unity-text-input>
          ${this.renderMenu()}
        </div>
        <div id="search-bar-clear-button" class="clear-button" @click="${() => this.clearInput()}">CLEAR</div>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          search: {
            type: String
          },
          tags: {
            type: Array
          },
          // textSeed: { type: Array },
          tagSeed: {
            type: Array
          },
          onChange: {
            type: Function
          },
          debounceTime: {
            type: Number
          },
          placeholder: {
            type: String
          },
          // internals
          _excludedTags: {
            type: false
          },
          _showOptions: {
            type: false
          },
          _currentOptions: {
            type: false
          },
          _matches: {
            type: false
          },
          _menuWidth: {
            type: false
          },
          _showPopover: {
            type: false
          },
          _availableTags: {
            type: false
          },
          _oversized: {
            type: false
          },
          _ellipsisRight: {
            type: false
          },
          _popoverWidth: {
            type: false
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-input-font: var(--font-family, var(--default-font-family));
          --default-input-text-color: var(--black-text-rgb, var(--default-black-text-rgb));
          --default-input-text-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          --default-input-icon-color: var(--black-text-rgb, var(--default-black-text-rgb));
          --default-input-border-color: var(--gray-color, var(--default-gray-color));
          --default-input-border-hover-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-input-border-focus-color: var(--primary-color, var(--default-primary-color));
          --default-input-border-radius: 2px;
          --search-bar-height: var(--unity-text-input-height, var(--default-unity-text-input-height));
          --default-search-tag-color: transparent;
          --default-search-tag-text-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-search-tag-border: 1px solid var(--dark-gray-color, var(--default-dark-gray-color));
          font-family: var(--input-font, var(--default-input-font));
          flex: 1;
        }
        #search-bar {
          display: flex;
          flex: 1;
          flex-direction: row;
          align-items: center;
          box-sizing: border-box;
          height: var(--search-bar-height);
        }
        #search-bar.showBorder {
          border-width: 1px;
          border-color: var(--input-border-color, var(--default-input-border-color));
          border-style: solid;
          border-radius: var(--input-border-radius, var(--default-input-border-radius));
        }
        unity-icon {
          flex: 0;
          margin: 0 var(--padding-size-sm, var(--default-padding-size-sm));
          color: var(--input-icon-color, var(--default-input-icon-color));
        }
        div.tag-list {
          max-width: 50%;
          max-height: var(--search-bar-height);
          overflow-x: hidden;
          overflow-y: hidden;
          z-index: 2;
        }
        unity-popover#tag-popover {
          height: 100%;
          width: 100%;
          --popover-content-overflow: visible;
          --popover-max-height: unset;
        }
        div.popover-list {
          display: flex;
          flex-wrap: wrap;
          height: 100%;
          width: 100%;
          mask-image: linear-gradient(to right, black, calc(100% - 4px), transparent);
        }
        div.popover-content {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          height: 100%;
          width: 100%;
        }
        unity-typography.ellipsis {
          position: absolute;
          bottom: 0;
          z-index: 1;
        }
        div.input-wrapper {
          position: relative;
          flex: 1;
          display: flex;
          height: 100%;
          align-items: center;
        }
        .input {
          flex: 1;
        }
        div.clear-button {
          font-size: var(--small-text-selected-size, var(--default-small-text-selected-size));
          color: var(--dark-gray-color, var(--default-dark-gray-color));
          margin: 0 var(--padding-size-sm, var(--default-padding-size-sm));
          cursor: pointer;
          white-space: nowrap;
        }
        unity-select-menu {
          position: absolute;
          top: calc(var(--search-bar-height) - 2px);
          white-space: nowrap;
          overflow-x: auto;
        }
        unity-tag {
          --tag-color: var(--search-tag-color, var(--default-search-tag-color));
          --tag-text-color: var(--search-tag-text-color, var(--default-search-tag-text-color));
          --tag-border: var(--search-tag-border, var(--default-search-tag-border));
          --tag-margin: 3px;
        }
      `];
      }
    }]);
    return UnitySearchBar;
  }(LitElement);
  window.customElements.define('unity-search-bar', UnitySearchBar);

  /**
   * A container that will horizontally or vertically with siblings of the same component
   * Intended to be used nested within eachother to form rows and auto adjusting columns.
   * @name UnitySection
   * @param {bool} nowrap, on row, control if column sections should wrap
   * @param {bool} bordered, on column, control if section pieces should have stacking borders
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *   <unity-section
   *   >
   *     <unity-table ...></unity-table>
   *   </unity-section>
   */

  const unity_section = 'unity-section';
  let UnitySection = /*#__PURE__*/function (_LitElement) {
    _inherits(UnitySection, _LitElement);
    var _super = _createSuper(UnitySection);
    function UnitySection() {
      var _this;
      _classCallCheck(this, UnitySection);
      _this = _super.call(this);
      _this.nowrap = false;
      _this.bordered = false;
      return _this;
    }
    _createClass(UnitySection, [{
      key: "getClasses",
      value: function getClasses() {
        const {
          nowrap,
          bordered
        } = this;
        let classes = ['section'];
        if (!!nowrap) classes.push('no-wrap');
        // parent is a section
        const hasParent = getParent(this).localName === unity_section;
        if (hasParent && !!bordered) classes.push('bordered');
        if (!hasParent) classes.push('row');
        return classes.join(' ');
      }
    }, {
      key: "render",
      value: function render() {
        const classes = this.getClasses();
        return html$1`
      <div class="${classes}">
        <slot></slot>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          nowrap: {
            type: Boolean
          },
          bordered: {
            type: Boolean
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --section-color: var(--background-color, var(--default-background-color));
          --border-color: var(--medium-grey-background-color, var(--default-medium-grey-background-color));
          --vert-pos: var(--vertical-position, center);
          --horz-pos: var(--horizontal-position, center);
          align-self: stretch;
          flex: 1;
          display: flex;
          overflow: visible;
        }
        .section {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: var(--vert-pos);
          justify-content: var(--horz-pos);
          flex-wrap: wrap;
          background-color: var(--section-color);
        }
        .no-wrap {
          flex-wrap: nowrap;
        }
        .bordered {
          border-top: 1px solid var(--border-color);
          border-right: 1px solid var(--border-color);
        }
        .row {
          margin-right: -1px;
        }
      `];
      }
    }]);
    return UnitySection;
  }(LitElement);
  window.customElements.define(unity_section, UnitySection);

  const MIN_PANE_WIDTH = 20; // %
  /**
   * A container to hold two views:
   *   1) one which will hold main content to always be rendered and fit to the full view
   *   2) and one to act in a modal-like fashion, to hold contextual information, and cause
   *      the other view to shrink in view but not in function
   * @name UnitySplitPane
   * @param {Boolean} show, controls if the right pane should be visible or not
   * @param {Boolean} collapsed, controls if the left pane is collapsed or not
   * @param {Boolean} closeButton, controls if the overlapping close button is rendered
   * @param {Boolean} collapseButton, controls whether the collapse button is rendered
   * @param {String} label, text to show inside the bar when the main pane is collapsed
   * @param {Number} paneWidth, width for the pane in percentage
   * @param {Number} minPaneWidth, minimum width of pane in percentage, defaults to 20%
   * @param {Function} onClose, function to call when the close button is clicked, sends new pane width in %
   * @param {Function} onCollapseChange, function to call when the collapse changes, true for collapsed, false for expanded
   * @param {Function} onResize, function to call when panel is being resized
   * @example
   *   <unity-split-pane
   *     closeButton
   *     collapseButton
   *     label="Split Pane"
   *     show=${showDetails}
   *     onClose="${toggleShowDetails}"
   *   >
   *     <div slot="main">
   *       Content
   *     </div>
   *     <div slot="pane">
   *       Details
   *     </div>
   *   </unity-split-pane>
   *
   * CSS variables:
   *   --border-color       -
   *   --bar-border-color
   *   --background
   *   --bar-background
   *   --pane-border-width
   *   --pane-border-color
   *   --pane-z-index
   *   --bar-width
   *   --header-border
   *   --collapse-button-padding
   */

  const stretch = overlapPercent => 100 - overlapPercent;
  let UnitySplitPane = /*#__PURE__*/function (_LitElement) {
    _inherits(UnitySplitPane, _LitElement);
    var _super = _createSuper(UnitySplitPane);
    function UnitySplitPane() {
      var _this;
      _classCallCheck(this, UnitySplitPane);
      _this = _super.call(this);
      _this._show = false;
      _this.label = '';
      _this.collapsed = false;
      _this.closeButton = false;
      _this.collapseButton = false;
      _this.onClose = () => {};
      _this.onCollapseChange = () => {};
      _this.paneWidth = 50;
      _this.minPaneWidth = MIN_PANE_WIDTH;
      _this.onResize = () => {};
      _this._startingX = 0;
      return _this;
    }
    _createClass(UnitySplitPane, [{
      key: "show",
      get: function () {
        return this._show;
      },
      set: function (value) {
        const newValue = Boolean(value);
        const oldValue = this._show;
        if (oldValue === true && newValue === false) this.onClose(this.paneWidth);
        this._show = newValue;
        this.requestUpdate('show', newValue);
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(e) {
        this._startingX = e.clientX;
        this.mouseMoveListener = this.handleMouseMove.bind(this);
        this.mouseUpListener = this.handleMouseUp.bind(this);
        document.addEventListener('mousemove', this.mouseMoveListener);
        document.addEventListener('mouseup', this.mouseUpListener);
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        const pane = this.shadowRoot.getElementById('pane');
        const splitPaneWidth = pane.clientWidth * 100 / this.paneWidth; // get splitpane total width

        const deltaX = e.clientX - this._startingX;
        const newWidth = this.paneWidth - deltaX * 100 / splitPaneWidth; // curent % - increment %

        this.paneWidth = this._clipPaneWidth(newWidth);
        this._startingX = e.clientX;
        this.onResize(this.paneWidth); // callback
        this.requestUpdate('paneWidth');
      }

      //clean up event listener
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp() {
        document.removeEventListener('mousemove', this.mouseMoveListener);
        document.removeEventListener('mouseup', this.mouseUpListener);
      }
    }, {
      key: "_clipPaneWidth",
      value: function _clipPaneWidth(width) {
        if (width < this.minPaneWidth) {
          return this.minPaneWidth;
        } else if (width > 100 - this.minPaneWidth) {
          return 100 - this.minPaneWidth;
        } else {
          return width;
        }
      }
    }, {
      key: "toggleCollapse",
      value: function toggleCollapse() {
        let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.collapsed;
        this.collapsed = value;
        this.onCollapseChange(value);
      }
    }, {
      key: "closePane",
      value: function closePane() {
        this.show = false;
        this.toggleCollapse(false);
      }
    }, {
      key: "handleBarClick",
      value: function handleBarClick(e) {
        this.toggleCollapse(false);
      }
    }, {
      key: "renderBar",
      value: function renderBar() {
        const {
          label
        } = this;
        return html$1`
      <unity-typography style="display: flex;">
        <div class="bar" @click=${this.handleBarClick}>
          <div class="bar-icon-wrapper">
            <unity-icon icon="unity:expand_horizontal"></unity-icon>
          </div>
          <div class="bar-label-wrapper">
            <p class="bar-label">${label}</p>
          </div>
        </div>
      </unity-typography>
    `;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          show,
          closeButton,
          collapseButton,
          collapsed,
          paneWidth
        } = this;
        return html$1`
      ${show && collapsed ? this.renderBar() : ''}
      <div class="wrapper ${show && collapsed ? 'hide' : ''}">
        <div class="header">
          <slot name="header"></slot>
          ${collapseButton ? html$1`
            <unity-button
              class="collapse-button"
              centerIcon="unity:compress"
              @click=${() => this.toggleCollapse()}
              type="borderless"
              ?disabled="${!show}"
            ></unity-button>
          ` : ''}
        </div>
        <div class="scroller">
          <div class="main" style="width: ${show ? stretch(paneWidth) : "100"}%;">
            <slot name="main"></slot>
          </div>
        </div>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
      <div id="pane" class="pane ${!show ? 'hide' : ''}" style="width: ${collapsed ? '100' : paneWidth}%;">
        <div
          class="resize-handle"
          @mousedown="${this.handleMouseDown}"
        ></div>
        ${!!closeButton ? html$1`
            <unity-button
              type="borderless"
              class="close-button"
              centerIcon="close"
              @click=${this.closePane}
            ></unity-button>` : null}

        <slot name="pane"></slot>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          show: {
            type: Boolean
          },
          label: {
            type: String
          },
          collapsed: {
            type: Boolean
          },
          closeButton: {
            type: Boolean
          },
          collapseButton: {
            type: Boolean
          },
          onClose: {
            type: Function
          },
          onCollapseChange: {
            type: Function
          },
          paneWidth: {
            type: Number
          },
          minPaneWidth: {
            type: Number
          },
          onResize: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --border-color: var(--gray-color, var(--default-gray-color));
          --bar-border-color: var(--gray-color, var(--default-gray-color));
          --background: var(--white-color, var(--default-white-color));
          --bar-background: var(--background);
          --pane-border-width: 1px;
          --pane-border-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-pane-z-index: 3;
          --bar-width: 40px;
          --header-border: none;
          --collapse-button-padding: var(--padding-size-sm, var(--default-padding-size-sm));
          background-color: var(--background);
          display: flex;
          flex-direction: row;
          height: 100%;
          width: 100%;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          flex: 1;
          overflow: hidden;
          position: relative;
        }
        .wrapper.hide {
          display: none;
        }
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: var(--header-border);
        }
        .footer {
          flex: 0;
        }
        .scroller {
          flex: 1;
          display: flex;
          overflow-x: auto;
        }
        .scroller ::slotted(*) {
          flex: 1;
          display: flex;
        }
        .main {
          height: 100%;
          width: 100%;
          overflow: auto;
          flex: 1;
          display: flex;
        }
        .main ::slotted(*) {
          width: 100%;
        }
        .pane {
          position: relative;
          border-left: var(--pane-border-width) solid var(--pane-border-color);
          box-sizing: border-box;
          z-index: var(--pane-z-index, var(--default-pane-z-index));
        }
        .hide {
          display: none;
        }
        unity-button.close-button {
          position: absolute;
          z-index: 10;
          top: 0;
          right: 0;
        }
        .bar {
          width: var(--bar-width);
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          border-right: 1px solid var(--bar-border-color);
          background-color: var(--bar-background);
        }
        .bar-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          height: var(--bar-width);
          width: var(--bar-width);
        }
        .bar-label-wrapper {
          flex: 1;
          display: flex;
          align-items: flex-start;
          white-space: nowrap;
        }
        .bar-label {
          transform: rotate(-90deg) translate(-50%);
          margin: 0;
        }
        .resize-handle {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 8px;
          cursor: col-resize;
          z-index: 5;
        }
        unity-icon {
          --unity-icon-height: var(--medium-icon-size, var(--default-medium-icon-size));
          --unity-icon-width: var(--medium-icon-size, var(--default-medium-icon-size));
        }
        .collapse-button {
          padding: var(--collapse-button-padding);
          --unity-button-height: 27px;
        }
      `];
      }
    }]);
    return UnitySplitPane;
  }(LitElement);
  window.customElements.define('unity-split-pane', UnitySplitPane);

  /**
   * @name UnityStepper
   * @param {[]} steps, the steps to be tracked, string of step name to be rendered or obj{name, key(opt), buttonText(opt), cancelText(opt)}, buttonText defaults to "Next"/"Finish", cancelText defaults to "Cancel"
   * @param {number} totalSteps, total number of steps, not needed if given steps
   * @param {number} currentStep, override the current step to the one given, should be used carefully
   * @param {bool} valid, if the current step is valid, enables next button
   * @param {bool} hideButton, flag for having no button
   * @param {bool} backtrack, controls if the user can backtrack through the steps using the step buttons
   * @param {bool} cancelButton, controls if the invalid button will have a cancel/back state
   * @param {string} cancelText, controls the text of the cancel button, defaults to "Cancel", step object overrides this setting
   * @param {func} onChangeStep, the callback to return the current step
   * @param {func} onCancel, the callback for pressing cancel on the first step
   * @example
   * <unity-stepper
   *   .onChangeStep="${step => reportStep(step)}"
   *   .valid="${formValid}"
   *   .textSeed="${[
   *     {name: 'Step 1', buttonText: "Authorize"},
   *     'Step 2',
   *     {name: 'Step 3', key: 'step3', buttonText: "Start"}
   *   ]}"
   * />
   *
   * css vars
   *   unity-stepper-step-active-color
   *   unity-stepper-step-inactive-color
   *   unity-stepper-button-color
   *   unity-stepper-button-text-color
   *   unity-stepper-spacer-color
   *   unity-stepper-step-text-color
   *   unity-stepper-step-icon-color
   *   unity-stepper-button-text-color
   *   unity-stepper-step-size
   *   unity-stepper-step-text-size
   *   unity-stepper-button-size
   *   unity-stepper-button-text-size
   **/
  let UnityStepper = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityStepper, _LitElement);
    var _super = _createSuper(UnityStepper);
    function UnityStepper() {
      var _this;
      _classCallCheck(this, UnityStepper);
      _this = _super.call(this);
      _this._steps = [];
      _this.totalSteps = 0;
      _this.valid = false;
      _this.hideButton = false;
      _this.cancelButton = false;
      _this.backtrack = false;
      _this.cancelText = "Cancel";
      _this.onChangeStep = () => {};
      _this.onCancel = () => {};
      _this.currentStep = undefined;
      _this._trackedStep = 1;
      _this.advance = _this.advance.bind(_assertThisInitialized(_this));
      _this.backup = _this.backup.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(UnityStepper, [{
      key: "checkTrackedStep",
      value: function checkTrackedStep(value) {
        const oldValue = this._trackedStep;
        const {
          steps,
          totalSteps: givenSteps
        } = this;
        const totalSteps = Math.max(steps.length, givenSteps);
        if (value < 1) this._trackedStep = 1;else if (value > totalSteps) this._trackedStep = totalSteps;else this._trackedStep = value;
        this.requestUpdate('trackedStep', oldValue);
      }
    }, {
      key: "trackedStep",
      get: function () {
        return this.currentStep || this._trackedStep;
      },
      set: function (value) {
        if (this.steps.length > 0) this.checkTrackedStep(value);else this._trackedStep = value;
      }
    }, {
      key: "steps",
      get: function () {
        return this._steps;
      }

      // this will create the bubble and the text
      ,
      set: function (value) {
        const oldValue = this._steps;
        // check if all steps are valid
        // if step is not a string and not an object with a name field, then it's invalid
        const valid = value.reduce((valid, step) => !valid ? false : typeof step === 'string' || step instanceof Object, true);
        if (valid) {
          this._steps = value;
          // check trackedStep
          this.checkTrackedStep(this.trackedStep);
        } else {
          this._steps = [];
        }
        this.requestUpdate('steps', oldValue);
      }
    }, {
      key: "createStep",
      value: function createStep(_ref) {
        let {
          name,
          key,
          pos
        } = _ref;
        const {
          trackedStep,
          backtrack,
          valid
        } = this;
        const active = trackedStep === pos;
        const done = trackedStep > pos;
        const icon = trackedStep > pos || active && valid ? html$1`<unity-icon class="icon" icon="unity:check"></unity-icon>` : html$1`<unity-typography>${pos}</unity-typography>`;
        return html$1`
      <div
        class="step${active ? " active" : ""}${done ? " done" : ""}${backtrack ? " clickable" : ""}"
        @click="${done && backtrack ? () => this.advance(pos) : () => {}}"
      >
        <div class="bubble">${icon}</div>
        ${!name ? null : html$1`
          <unity-typography class="step-name">
            ${name}
          </unity-typography>
        `}
      </div>
    `;
      }
    }, {
      key: "createBar",
      value: function createBar() {
        return html$1`<hr>`;
      }

      // this will order the bubbles and make the lines
    }, {
      key: "orderSteps",
      value: function orderSteps() {
        const {
          steps = [],
          totalSteps: givenSteps
        } = this;
        const totalSteps = steps.length < givenSteps ? givenSteps : steps.length;
        let renderedSteps = [];
        steps.forEach((step, pos, list) => {
          const stepToRender = typeof step === 'string' ? {
            name: step
          } : step;
          renderedSteps.push(this.createStep(_objectSpread2$1(_objectSpread2$1({}, stepToRender), {}, {
            pos: pos + 1
          })));
          if (pos < totalSteps - 1) renderedSteps.push(this.createBar());
        });
        const emptySteps = totalSteps - steps.length;
        if (emptySteps > 0) {
          for (let i = 1; i <= emptySteps; i++) {
            renderedSteps.push(this.createStep({
              pos: steps.length + i
            }));
            if (i < emptySteps) renderedSteps.push(this.createBar());
          }
        }
        return renderedSteps;
      }
    }, {
      key: "advance",
      value: function advance(targetStep) {
        const {
          steps,
          trackedStep
        } = this;
        const nextStep = typeof targetStep === 'number' ? targetStep : trackedStep + 1;
        this.trackedStep = nextStep;
        this.onChangeStep(steps[nextStep - 1] || trackedStep);
      }
    }, {
      key: "backup",
      value: function backup() {
        const {
          trackedStep,
          steps
        } = this;
        const prevStep = trackedStep - 1;
        if (prevStep < 1) this.onCancel(steps[0] || 1);else this.advance(prevStep);
      }
    }, {
      key: "makeClick",
      value: function makeClick() {
        const {
          valid,
          cancelButton
        } = this;
        let handler = () => {};
        if (!valid && cancelButton) {
          handler = this.backup;
        } else if (valid) {
          handler = this.advance;
        }
        return handler;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          steps = [],
          totalSteps: givenSteps,
          trackedStep: trackedPos,
          hideButton,
          valid,
          cancelButton,
          cancelText
        } = this;
        if (!steps.length && !givenSteps) return;
        const totalSteps = Math.max(steps.length, givenSteps);
        const trackedStep = steps[trackedPos - 1] || {};
        const defaultButtonText = trackedPos === totalSteps ? "Finish" : "Next";
        const cancelButtonText = trackedStep.cancelText || cancelText;
        const disabled = !valid && !cancelButton;
        const buttonText = cancelButton && !valid ? cancelButtonText : trackedStep.buttonText || defaultButtonText;
        return html$1`
      <div class="stepper">
        ${this.orderSteps()}
      </div>
      ${hideButton ? null : html$1`
        <div class="button-box">
          <unity-button
            id="stepper-button"
            ?disabled="${disabled || null}"
            label="${buttonText}"
            @click="${this.makeClick()}"
            type="${cancelButton && !valid ? "secondary" : "primary"}"
          ></unity-button>
        </div>
      `}
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          steps: {
            type: Array
          },
          totalSteps: {
            type: Number
          },
          valid: {
            type: Boolean
          },
          hideButton: {
            type: Boolean
          },
          cancelButton: {
            type: Boolean
          },
          backtrack: {
            type: Boolean
          },
          cancelText: {
            type: String
          },
          onChangeStep: {
            type: Function
          },
          onCancel: {
            type: Function
          },
          currentStep: {
            type: Number
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-unity-stepper-step-active-color: var(--primary-color, var(--default-primary-color));
          --default-unity-stepper-step-inactive-color: var(--dark-gray-2-color, var(--default-dark-gray-2-color));
          --default-unity-stepper-spacer-color: var(--dark-gray-2-color, var(--default-dark-gray-2-color));
          --default-unity-stepper-step-text-color: var(--dark-gray-color, var(--default-dark-gray-color));
          --default-unity-stepper-text-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          --default-unity-stepper-step-icon-color: var(--white-color, var(--default-white-color));
          --default-unity-stepper-step-size: 24px;
          --default-unity-stepper-button-min-width: 85px;
          --step-icon-size: calc(var(--default-unity-stepper-step-size, var(--default-unity-stepper-step-size)) * 5 / 6);

          --bubble-margin: calc(var(--padding-size-sm, var(--default-padding-size-sm)) / 2);

          display: flex;
          flex: 0;
          width: 100%;
          flex-direction: row;
          user-select: none;
          justify-content: center;
          align-items: center;
          height: calc(var(--unity-stepper-step-size, var(--default-unity-stepper-step-size)) + (2 * var(--bubble-margin)))
        }
        .stepper {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }
        .step {
          flex: 0;
          display: flex;
          flex-direction: row;
          white-space: nowrap;
          justify-content: center;
          align-items: center;
        }
        .step.done.clickable {
          cursor: pointer;
        }
        .step unity-typography.step-name {
          flex: 0;
          --font-size: var(--unity-stepper-text-size, var(--default-unity-stepper-text-size));
        }
        .step.active unity-typography.step-name {
          --font-weight: var(--bold-text-weight, var(--default-bold-text-weight));
          text-align: center;
        }

        .step.active unity-typography.step-name::before {
          display: block;
          content: attr(title);
          font-weight: bold;
          height: 0;
          overflow: hidden;
          visibility: hidden;
          text-align: center;
        }
        .step.active unity-typography.step-name::after {
          display: block;
          content: attr(title);
          font-weight: bold;
          height: 0;
          overflow: hidden;
          visibility: hidden;
          text-align: center;
        }

        .step .bubble {
          color: var(--unity-stepper-step-icon-color, var(--default-unity-stepper-step-icon-color));
          background-color: var(--unity-stepper-step-inactive-color, var(--default-unity-stepper-step-inactive-color));
          height: var(--unity-stepper-step-size, var(--default-unity-stepper-step-size));
          width: var(--unity-stepper-step-size, var(--default-unity-stepper-step-size));
          border-radius: calc(var(--unity-stepper-step-size, var(--default-unity-stepper-step-size)) / 2);
          display: flex;
          justify-content: center;
          align-items: center;
          margin: var(--bubble-margin);
        }
        .step.done .bubble, .step.active .bubble {
          background-color: var(--unity-stepper-step-active-color, var(--default-unity-stepper-step-active-color))
        }
        .step .bubble .icon {
          --unity-icon-height: var(--unity-stepper-step-size, var(--default-unity-stepper-step-size));
          --unity-icon-width: var(--unity-stepper-step-size, var(--default-unity-stepper-step-size));
        }
        .step .bubble unity-typography {
          --font-color: var(--unity-stepper-step-icon-color, var(--default-unity-stepper-step-icon-color));
          --font-weight: var(--header2-selected-font-weight, var(--default-header2-selected-font-weight));
          flex: 0;
        }
        .step .bubble unity-icon {
          --unity-icon-height: var(--step-icon-size);
          --unity-icon-width: var(--step-icon-size);
          flex: 0;
        }
        .bar{}
        div.button-box {
          margin-left: var(--padding-size-xl, var(--default-padding-size-xl));
          min-width: var(--unity-stepper-button-min-width, var(--default-unity-stepper-button-min-width));
          text-align: center;
        }
        unity-button {
          flex: 0;
        }
        hr {
          flex: 1;
          --hr-side-margin: calc(var(--margin-size-md, var(--default-margin-size-md)) / 2);
          margin-right: var(--hr-side-margin);
          margin-left: var(--hr-side-margin);
          margin-bottom: calc(var(--step-icon-size) / 2);
          width: 100%;
          border: none;
          background-color: var(--unity-stepper-spacer-color, var(--default-unity-stepper-spacer-color));
          height: 1px;
        }
      `];
      }
    }]);
    return UnityStepper;
  }(LitElement);
  window.customElements.define('unity-stepper', UnityStepper);

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template$1 = html`<iron-iconset-svg name="social" size="24">
<svg><defs>
<g id="cake"><path d="M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"></path></g>
<g id="domain"><path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"></path></g>
<g id="group"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></g>
<g id="group-add"><path d="M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"></path></g>
<g id="location-city"><path d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"></path></g>
<g id="mood"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"></path></g>
<g id="mood-bad"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"></path></g>
<g id="notifications"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"></path></g>
<g id="notifications-active"><path d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"></path></g>
<g id="notifications-none"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"></path></g>
<g id="notifications-off"><path d="M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"></path></g>
<g id="notifications-paused"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"></path></g>
<g id="pages"><path d="M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"></path></g>
<g id="party-mode"><path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"></path></g>
<g id="people"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"></path></g>
<g id="people-outline"><path d="M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"></path></g>
<g id="person"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path></g>
<g id="person-add"><path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path></g>
<g id="person-outline"><path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"></path></g>
<g id="plus-one"><path d="M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"></path></g>
<g id="poll"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"></path></g>
<g id="public"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"></path></g>
<g id="school"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"></path></g>
<g id="sentiment-dissatisfied"><circle cx="15.5" cy="9.5" r="1.5"></circle><circle cx="8.5" cy="9.5" r="1.5"></circle><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"></path></g>
<g id="sentiment-neutral"><path d="M9 14h6v1.5H9z"></path><circle cx="15.5" cy="9.5" r="1.5"></circle><circle cx="8.5" cy="9.5" r="1.5"></circle><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></g>
<g id="sentiment-satisfied"><circle cx="15.5" cy="9.5" r="1.5"></circle><circle cx="8.5" cy="9.5" r="1.5"></circle><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z"></path></g>
<g id="sentiment-very-dissatisfied"><path d="M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"></path></g>
<g id="sentiment-very-satisfied"><path d="M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"></path></g>
<g id="share"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"></path></g>
<g id="whatshot"><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template$1.content);

  /**
  @license
  Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  const template = html`<iron-iconset-svg name="hardware" size="24">
<svg><defs>
<g id="cast"><path d="M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"></path></g>
<g id="cast-connected"><path d="M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></g>
<g id="computer"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"></path></g>
<g id="desktop-mac"><path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"></path></g>
<g id="desktop-windows"><path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"></path></g>
<g id="developer-board"><path d="M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"></path></g>
<g id="device-hub"><path d="M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"></path></g>
<g id="devices-other"><path d="M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"></path></g>
<g id="dock"><path d="M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"></path></g>
<g id="gamepad"><path d="M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"></path></g>
<g id="headset"><path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"></path></g>
<g id="headset-mic"><path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"></path></g>
<g id="keyboard"><path d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"></path></g>
<g id="keyboard-arrow-down"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path></g>
<g id="keyboard-arrow-left"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path></g>
<g id="keyboard-arrow-right"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path></g>
<g id="keyboard-arrow-up"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path></g>
<g id="keyboard-backspace"><path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"></path></g>
<g id="keyboard-capslock"><path d="M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"></path></g>
<g id="keyboard-hide"><path d="M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"></path></g>
<g id="keyboard-return"><path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"></path></g>
<g id="keyboard-tab"><path d="M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"></path></g>
<g id="keyboard-voice"><path d="M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"></path></g>
<g id="laptop"><path d="M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"></path></g>
<g id="laptop-chromebook"><path d="M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"></path></g>
<g id="laptop-mac"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path></g>
<g id="laptop-windows"><path d="M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"></path></g>
<g id="memory"><path d="M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"></path></g>
<g id="mouse"><path d="M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"></path></g>
<g id="phone-android"><path d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"></path></g>
<g id="phone-iphone"><path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"></path></g>
<g id="phonelink"><path d="M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"></path></g>
<g id="phonelink-off"><path d="M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"></path></g>
<g id="power-input"><path d="M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"></path></g>
<g id="router"><path d="M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"></path></g>
<g id="scanner"><path d="M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"></path></g>
<g id="security"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"></path></g>
<g id="sim-card"><path d="M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"></path></g>
<g id="smartphone"><path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"></path></g>
<g id="speaker"><path d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></g>
<g id="speaker-group"><path d="M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"></path><circle cx="14" cy="12.5" r="2.5"></circle><path d="M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"></path></g>
<g id="tablet"><path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"></path></g>
<g id="tablet-android"><path d="M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"></path></g>
<g id="tablet-mac"><path d="M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"></path></g>
<g id="toys"><path d="M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"></path></g>
<g id="tv"><path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"></path></g>
<g id="videogame-asset"><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></g>
<g id="watch"><path d="M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"></path></g>
</defs></svg>
</iron-iconset-svg>`;
  document.head.appendChild(template.content);

  const TAB_ICON = 22;
  const TAB_ARROW = 20;
  function getIndent(_ref) {
    let {
      icon,
      expandable,
      tabIndex
    } = _ref;
    let width = !!icon ? TAB_ICON : TAB_ARROW;
    return tabIndex * width + (expandable ? 0 : TAB_ARROW);
  }

  /**
   * Displays table of data.
   * @name UnityTableCell
   * @param {string} icon, iron-icon to display in the cell
   * @param {string} id, relational id to the data, used in selection
   * @param {string} slotId, slot name of custom cell content
   * @param {integer} tabIndex, level of indentation required between checkbox and icon
   * @param {bool} selectable
   * @param {bool} selected
   * @param {function} onSelect, action handler on being selected
   * @slot {HTML}, named slot passed in as child, used to display cell content
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *  <unity-table-cell
   *    .icon="${index === 0 && 'work'}"
   *    .id="${1}"
   *    .tabIndex="${0}"
   *    selectable
   *    ?selected="${false}"
   *    .onSelect="${reportSelected}"
   *  >
   *    <slot name="${slotId}">
   *      <span class="text">Cell content</span>
   *    </slot>
   *  </unity-table-cell>
   */

  //   Table Cell to be used with Unity Table. Could be used elsewhere, matching styleguides
  //
  //   icon:        string of the name of the iron-icon to show in the cell
  //   id:          the id related to the row/cell/datum being displayed, used with select functions
  //   selectable:  bool to control if cell is selectable
  //   selected:    bool to render cell as selected
  //   onSelect:    callback for selection functions
  let UnityTableCell = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTableCell, _LitElement);
    var _super = _createSuper(UnityTableCell);
    function UnityTableCell() {
      var _this;
      _classCallCheck(this, UnityTableCell);
      _this = _super.call(this);
      _this.icon = '';
      _this.image = '';
      _this.selectable = false;
      _this.selected = false;
      _this.id = undefined;
      _this.slotId = undefined;
      _this.tabIndex = 0;
      _this.expandable = false;
      _this.expanded = false;
      _this.resizable = false;
      _this.onSelect = () => {};
      _this.onExpand = () => {};
      _this.onResizeStart = () => {};
      _this.onResize = () => {};
      _this.onResizeComplete = () => {};
      return _this;
    }
    _createClass(UnityTableCell, [{
      key: "handleExpand",
      value: function handleExpand(e) {
        e.stopPropagation();
        this.onExpand(e);
      }
    }, {
      key: "render",
      value: function render() {
        // if img > icon > nothing
        const imgUrl = this.image;
        const icon = this.icon;
        const tabIndex = this.tabIndex;
        const expandable = this.expandable;
        const expanded = this.expanded;
        const totalIndent = getIndent({
          icon,
          expandable,
          tabIndex
        });
        return html$1`
      <table-cell-base
        .resizable="${this.resizable}"
        .onResizeStart="${this.onResizeStart.bind(this)}"
        .onResize="${this.onResize.bind(this)}"
        .onResizeComplete="${this.onResizeComplete.bind(this)}"
      >
        <div class="cell">
          ${this.selectable ? html$1`
              <unity-checkbox
                class="selection-checkbox"
                ?checked="${this.selected ? true : null}"
                .onChange="${(e, v) => this.onSelect(e, v)}"
              ></unity-checkbox>` : null}
          ${tabIndex > 0 ? html$1`<div class="tab-indent" style="width:${totalIndent}px"></div>` : ''}
          ${expandable ? html$1`<paper-icon-button
                noink
                class="expand-control ${expanded ? 'expanded' : 'collapsed'}"
                icon="unity:down"
                @click="${this.handleExpand}"
              ></paper-icon-button>` : ''}
          ${!!imgUrl ? html$1`<iron-icon class="item-icon" icon="image:broken-image"></iron-icon>` : !!icon ? html$1`<iron-icon class="item-icon" icon="${icon}"></iron-icon>` : null}

          <slot name="${this.slotId}"></slot>
        </div>
      </table-cell-base>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          // need to separate between img and icon
          icon: {
            type: String
          },
          // term with util handler? url to img?
          image: {
            type: String
          },
          selectable: {
            type: Boolean
          },
          selected: {
            type: Boolean
          },
          id: {
            type: Number
          },
          slotId: {
            type: String
          },
          tabIndex: {
            type: Number
          },
          expandable: {
            type: Boolean
          },
          expanded: {
            type: Boolean
          },
          resizable: {
            type: Boolean
          },
          onSelect: {
            type: Function
          },
          onExpand: {
            type: Function
          },
          onResizeStart: {
            type: Function
          },
          onResize: {
            type: Function
          },
          onResizeComplete: {
            type: Function
          }
          // hierarchy stuff
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          min-width: 0;
          font-family: var(--font-family, var(--default-font-family));
          font-size: var(--paragraph-text-size, var(--default-paragraph-text-size));
          font-weight: var(--small-text-weight, var(--default-small-text-weight));
          /* Might have to change this as header needs to be black */
          color: var(--dark-gray-color, var(--default-dark-gray-color));
          --paper-icon-button-ink-color: transparent;
          --padding-small: var(--padding-size-sm, var(--default-padding-size-sm));
          --padding-medium: var(--padding-size-md, var(--default-padding-size-md));
          --padding-large: var(--padding-size-lg, var(--default-padding-size-lg));
          --padding-extra-large: var(--padding-size-xl, var(--default-padding-size-xl));
          --margin-medium: var(--margin-size-md, var(--default-margin-size-md));
          --cell-text-color: var(--dark-grey-text-color, var(--default-dark-grey-text-color));
        }
        unity-checkbox {
          margin-right: var(--margin-medium);
          z-index: 2;
        }
        .cell {
          padding: 0 13px;
          border-spacing: 0;
          display: flex;
          flex-direction: row;
          align-items: center;
          min-width: 0;
          flex-shrink: 0;
        }
        .text {
          position: relative;
          padding-top: 1px;
          line-height: 38px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        iron-icon.item-icon {
          color: var(--cell-text-color);
          height: 18px;
          width: 18px;
          margin-right: 4px;
          flex-shrink: 0;
        }
        .tab-indent {
          display: inline-block;
          height: 0;
          flex-shrink: 0;
        }
        .expand-control {
          color: black;
          padding: 0;
          height: 16px;
          width: 16px;
          margin-right: 4px;
          flex-shrink: 0;
        }
        .expand-control.collapsed {
          transform: rotate(-90deg);
        }
      `];
      }
    }]);
    return UnityTableCell;
  }(LitElement);
  window.customElements.define('unity-table-cell', UnityTableCell);

  /**
   * Displays button which will download a csv file when pressed.
   * @name UnityTableExport
   * @param {ref} tableRef, a reference object to a unity-table element that will define the data to be exported
   * @param {func} beforeExport, function called before export. Passed parameter is "tableData" (an array of rows, each being an array of cells). The function, if provided, should return a two dimensional object in the same format (later called in onExport as "exportData")
   * @param {func} onExport, function that is called after export. Passed parameter is an object with properties "success," "tableData," "exportData," "clickEvent," and "error"
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *  <unity-table-export
   *    .tableRef="${tableRef}"
   *    .beforeExport="${(data) => {
   *      console.log(data)
   *      return data
   *    }}"
   *    .onExport="${({ success, exportedData, clickEvent }) => !!success && console.log('CSV Exported Successfully!')}"
   *  >
   *    <unity-button // or any other element
   *      // whatever unity-button props you require
   *    ></unity-button>
   *  </unity-table-export>
   */

  const ignoreHeaders = ['_childCount', '_parents', '_rowId', '_tabIndex'];
  let UnityTableExport = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTableExport, _LitElement);
    var _super = _createSuper(UnityTableExport);
    function UnityTableExport() {
      var _this;
      _classCallCheck(this, UnityTableExport);
      _this = _super.call(this);
      _this.beforeExport = data => data;
      _this.onExport = () => {};
      _this.tableRef = null;
      _this._headers = [];
      _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
      _this.buildDataToExport = _this.buildDataToExport.bind(_assertThisInitialized(_this));
      _this.makeRow = _this.makeRow.bind(_assertThisInitialized(_this));
      _this.addHeaders = _this.addHeaders.bind(_assertThisInitialized(_this));
      return _this;
    }

    // inputs
    _createClass(UnityTableExport, [{
      key: "tableRef",
      get: function () {
        return this._tableRef;
      },
      set: function (ref) {
        const oldRef = this._tableRef;
        this._tableRef = ref;
        this.requestUpdate('tableRef', oldRef);
      }
    }, {
      key: "handleClick",
      value: function handleClick(clickEvent) {
        let success;
        let csvData = [];
        let error = null;
        let tableData = null;
        let exportData = null;
        try {
          tableData = this.buildDataToExport();
          exportData = this.beforeExport(tableData);
          csvData = exportData.map(row => {
            return row.map(cell => {
              return `"${cell.replace(/"/g, '""')}"`;
            }).join(",");
          }).join("\n") || '';
          const anchorElement = this.shadowRoot.querySelector('a');
          anchorElement.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURI(csvData));
          if (!!exportData && Array.isArray(exportData) && !!csvData && !!anchorElement && anchorElement.hasAttribute('href')) success = true;
        } catch (e) {
          success = false;
          error = e;
        }
        this.onExport({
          success,
          tableData,
          exportData,
          clickEvent,
          error
        });
        return success;
      }
    }, {
      key: "buildDataToExport",
      value: function buildDataToExport() {
        const {
          current: {
            _flattenedData: tableData = []
          } = {}
        } = this._tableRef || {};
        if (!Array.isArray(tableData)) throw `ERROR: TableData is not an array (actual type: ${typeof tableData}). Received: ${tableData}`;
        const rowsData = tableData.map(this.makeRow);
        const headers = this._headers;
        return [headers].concat(_toConsumableArray(rowsData));
      }
    }, {
      key: "makeRow",
      value: function makeRow(row) {
        if (Array.isArray(row)) return row;
        if (!row || !(row instanceof Object)) {
          // TODO: Handle this better
          console.error(`invalid row passed to makeRowArrayFromObject: `, row);
          return [];
        }
        this.addHeaders(row);
        return this._headers.map(header => row.hasOwnProperty(header) ? row[header].toString() : '');
      }
    }, {
      key: "addHeaders",
      value: function addHeaders(row) {
        const oldHeaders = this._headers;
        const newHeaders = Object.keys(row).filter(header => !ignoreHeaders.includes(header) && !this._headers.includes(header));
        [].concat(_toConsumableArray(oldHeaders), _toConsumableArray(newHeaders));
        this._headers = [].concat(_toConsumableArray(oldHeaders), _toConsumableArray(newHeaders));
      }
    }, {
      key: "render",
      value: function render() {
        return html$1`
      <a
        id='export-wrapper'
        @click="${this.handleClick}"
        target='_blank'
        download='export.csv'
      >
        <slot></slot>
      </a>
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          tableRef: {
            type: Object
          },
          onExport: {
            type: Function
          },
          beforeExport: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles];
      }
    }]);
    return UnityTableExport;
  }(LitElement);
  window.customElements.define('unity-table-export', UnityTableExport);

  /**
  @license
  Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
   * `Polymer.IronScrollTargetBehavior` allows an element to respond to scroll
   * events from a designated scroll target.
   *
   * Elements that consume this behavior can override the `_scrollHandler`
   * method to add logic on the scroll event.
   *
   * @demo demo/scrolling-region.html Scrolling Region
   * @demo demo/document.html Document Element
   * @polymerBehavior
   */
  const IronScrollTargetBehavior = {
    properties: {
      /**
       * Specifies the element that will handle the scroll event
       * on the behalf of the current element. This is typically a reference to an
       *element, but there are a few more posibilities:
       *
       * ### Elements id
       *
       *```html
       * <div id="scrollable-element" style="overflow: auto;">
       *  <x-element scroll-target="scrollable-element">
       *    <!-- Content-->
       *  </x-element>
       * </div>
       *```
       * In this case, the `scrollTarget` will point to the outer div element.
       *
       * ### Document scrolling
       *
       * For document scrolling, you can use the reserved word `document`:
       *
       *```html
       * <x-element scroll-target="document">
       *   <!-- Content -->
       * </x-element>
       *```
       *
       * ### Elements reference
       *
       *```js
       * appHeader.scrollTarget = document.querySelector('#scrollable-element');
       *```
       *
       * @type {HTMLElement}
       * @default document
       */
      scrollTarget: {
        type: HTMLElement,
        value: function () {
          return this._defaultScrollTarget;
        }
      }
    },
    observers: ['_scrollTargetChanged(scrollTarget, isAttached)'],
    /**
     * True if the event listener should be installed.
     */
    _shouldHaveListener: true,
    _scrollTargetChanged: function (scrollTarget, isAttached) {
      if (this._oldScrollTarget) {
        this._toggleScrollListener(false, this._oldScrollTarget);
        this._oldScrollTarget = null;
      }
      if (!isAttached) {
        return;
      }
      // Support element id references
      if (scrollTarget === 'document') {
        this.scrollTarget = this._doc;
      } else if (typeof scrollTarget === 'string') {
        var domHost = this.domHost;
        this.scrollTarget = domHost && domHost.$ ? domHost.$[scrollTarget] : dom(this.ownerDocument).querySelector('#' + scrollTarget);
      } else if (this._isValidScrollTarget()) {
        this._oldScrollTarget = scrollTarget;
        this._toggleScrollListener(this._shouldHaveListener, scrollTarget);
      }
    },
    /**
     * Runs on every scroll event. Consumer of this behavior may override this
     * method.
     *
     * @protected
     */
    _scrollHandler: function scrollHandler() {},
    /**
     * The default scroll target. Consumers of this behavior may want to customize
     * the default scroll target.
     *
     * @type {Element}
     */
    get _defaultScrollTarget() {
      return this._doc;
    },
    /**
     * Shortcut for the document element
     *
     * @type {Element}
     */
    get _doc() {
      return this.ownerDocument.documentElement;
    },
    /**
     * Gets the number of pixels that the content of an element is scrolled
     * upward.
     *
     * @type {number}
     */
    get _scrollTop() {
      if (this._isValidScrollTarget()) {
        return this.scrollTarget === this._doc ? window.pageYOffset : this.scrollTarget.scrollTop;
      }
      return 0;
    },
    /**
     * Gets the number of pixels that the content of an element is scrolled to the
     * left.
     *
     * @type {number}
     */
    get _scrollLeft() {
      if (this._isValidScrollTarget()) {
        return this.scrollTarget === this._doc ? window.pageXOffset : this.scrollTarget.scrollLeft;
      }
      return 0;
    },
    /**
     * Sets the number of pixels that the content of an element is scrolled
     * upward.
     *
     * @type {number}
     */
    set _scrollTop(top) {
      if (this.scrollTarget === this._doc) {
        window.scrollTo(window.pageXOffset, top);
      } else if (this._isValidScrollTarget()) {
        this.scrollTarget.scrollTop = top;
      }
    },
    /**
     * Sets the number of pixels that the content of an element is scrolled to the
     * left.
     *
     * @type {number}
     */
    set _scrollLeft(left) {
      if (this.scrollTarget === this._doc) {
        window.scrollTo(left, window.pageYOffset);
      } else if (this._isValidScrollTarget()) {
        this.scrollTarget.scrollLeft = left;
      }
    },
    /**
     * Scrolls the content to a particular place.
     *
     * @method scroll
     * @param {number|!{left: number, top: number}} leftOrOptions The left position or scroll options
     * @param {number=} top The top position
     * @return {void}
     */
    scroll: function (leftOrOptions, top) {
      var left;
      if (typeof leftOrOptions === 'object') {
        left = leftOrOptions.left;
        top = leftOrOptions.top;
      } else {
        left = leftOrOptions;
      }
      left = left || 0;
      top = top || 0;
      if (this.scrollTarget === this._doc) {
        window.scrollTo(left, top);
      } else if (this._isValidScrollTarget()) {
        this.scrollTarget.scrollLeft = left;
        this.scrollTarget.scrollTop = top;
      }
    },
    /**
     * Gets the width of the scroll target.
     *
     * @type {number}
     */
    get _scrollTargetWidth() {
      if (this._isValidScrollTarget()) {
        return this.scrollTarget === this._doc ? window.innerWidth : this.scrollTarget.offsetWidth;
      }
      return 0;
    },
    /**
     * Gets the height of the scroll target.
     *
     * @type {number}
     */
    get _scrollTargetHeight() {
      if (this._isValidScrollTarget()) {
        return this.scrollTarget === this._doc ? window.innerHeight : this.scrollTarget.offsetHeight;
      }
      return 0;
    },
    /**
     * Returns true if the scroll target is a valid HTMLElement.
     *
     * @return {boolean}
     */
    _isValidScrollTarget: function () {
      return this.scrollTarget instanceof HTMLElement;
    },
    _toggleScrollListener: function (yes, scrollTarget) {
      var eventTarget = scrollTarget === this._doc ? window : scrollTarget;
      if (yes) {
        if (!this._boundScrollHandler) {
          this._boundScrollHandler = this._scrollHandler.bind(this);
          eventTarget.addEventListener('scroll', this._boundScrollHandler);
        }
      } else {
        if (this._boundScrollHandler) {
          eventTarget.removeEventListener('scroll', this._boundScrollHandler);
          this._boundScrollHandler = null;
        }
      }
    },
    /**
     * Enables or disables the scroll event listener.
     *
     * @param {boolean} yes True to add the event, False to remove it.
     */
    toggleScrollListener: function (yes) {
      this._shouldHaveListener = yes;
      this._toggleScrollListener(yes, this.scrollTarget);
    }
  };

  /**
  @license
  Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */

  /**
  `iron-scroll-threshold` is a utility element that listens for `scroll` events
  from a scrollable region and fires events to indicate when the scroller has
  reached a pre-defined limit, specified in pixels from the upper and lower bounds
  of the scrollable region. This element may wrap a scrollable region and will
  listen for `scroll` events bubbling through it from its children.  In this case,
  care should be taken that only one scrollable region with the same orientation
  as this element is contained within. Alternatively, the `scrollTarget` property
  can be set/bound to a non-child scrollable region, from which it will listen for
  events.

  Once a threshold has been reached, a `lower-threshold` or `upper-threshold`
  event will be fired, at which point the user may perform actions such as
  lazily-loading more data to be displayed. After any work is done, the user must
  then clear the threshold by calling the `clearTriggers` method on this element,
  after which it will begin listening again for the scroll position to reach the
  threshold again assuming the content in the scrollable region has grown. If the
  user no longer wishes to receive events (e.g. all data has been exhausted), the
  threshold property in question (e.g. `lowerThreshold`) may be set to a falsy
  value to disable events and clear the associated triggered property.

  ### Example

  ```html
  <iron-scroll-threshold on-lower-threshold="loadMoreData">
    <div>content</div>
  </iron-scroll-threshold>
  ```

  ```js
    loadMoreData: function() {
      // load async stuff. e.g. XHR
      asyncStuff(function done() {
        ironScrollTheshold.clearTriggers();
      });
    }
  ```

  ### Using dom-repeat

  ```html
  <iron-scroll-threshold on-lower-threshold="loadMoreData">
    <template is="dom-repeat" items="[[items]]">
      <div>[[index]]</div>
    </template>
  </iron-scroll-threshold>
  ```

  ### Using iron-list

  ```html
  <iron-scroll-threshold on-lower-threshold="loadMoreData" id="threshold">
    <iron-list scroll-target="threshold" items="[[items]]">
      <template>
        <div>[[index]]</div>
      </template>
    </iron-list>
  </iron-scroll-threshold>
  ```

  @group Iron Element
  @element iron-scroll-threshold
  @demo demo/scrolling-region.html Scrolling Region
  @demo demo/document.html Document Element
  */
  Polymer({
    _template: html`
    <style>
      :host {
        display: block;
      }
    </style>

    <slot></slot>
`,
    is: 'iron-scroll-threshold',
    properties: {
      /**
       * Distance from the top (or left, for horizontal) bound of the scroller
       * where the "upper trigger" will fire.
       */
      upperThreshold: {
        type: Number,
        value: 100
      },
      /**
       * Distance from the bottom (or right, for horizontal) bound of the scroller
       * where the "lower trigger" will fire.
       */
      lowerThreshold: {
        type: Number,
        value: 100
      },
      /**
       * Read-only value that tracks the triggered state of the upper threshold.
       */
      upperTriggered: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true
      },
      /**
       * Read-only value that tracks the triggered state of the lower threshold.
       */
      lowerTriggered: {
        type: Boolean,
        value: false,
        notify: true,
        readOnly: true
      },
      /**
       * True if the orientation of the scroller is horizontal.
       */
      horizontal: {
        type: Boolean,
        value: false
      }
    },
    behaviors: [IronScrollTargetBehavior],
    observers: ['_setOverflow(scrollTarget)', '_initCheck(horizontal, isAttached)'],
    get _defaultScrollTarget() {
      return this;
    },
    _setOverflow: function (scrollTarget) {
      this.style.overflow = scrollTarget === this ? 'auto' : '';
      this.style.webkitOverflowScrolling = scrollTarget === this ? 'touch' : '';
    },
    _scrollHandler: function () {
      // throttle the work on the scroll event
      var THROTTLE_THRESHOLD = 200;
      if (!this.isDebouncerActive('_checkTheshold')) {
        this.debounce('_checkTheshold', function () {
          this.checkScrollThresholds();
        }, THROTTLE_THRESHOLD);
      }
    },
    _initCheck: function (horizontal, isAttached) {
      if (isAttached) {
        this.debounce('_init', function () {
          this.clearTriggers();
          this.checkScrollThresholds();
        });
      }
    },
    /**
     * Checks the scroll thresholds.
     * This method is automatically called by iron-scroll-threshold.
     *
     * @method checkScrollThresholds
     */
    checkScrollThresholds: function () {
      if (!this.scrollTarget || this.lowerTriggered && this.upperTriggered) {
        return;
      }
      var upperScrollValue = this.horizontal ? this._scrollLeft : this._scrollTop;
      var lowerScrollValue = this.horizontal ? this.scrollTarget.scrollWidth - this._scrollTargetWidth - this._scrollLeft : this.scrollTarget.scrollHeight - this._scrollTargetHeight - this._scrollTop;

      // Detect upper threshold
      if (upperScrollValue <= this.upperThreshold && !this.upperTriggered) {
        this._setUpperTriggered(true);
        this.fire('upper-threshold');
      }
      // Detect lower threshold
      if (lowerScrollValue <= this.lowerThreshold && !this.lowerTriggered) {
        this._setLowerTriggered(true);
        this.fire('lower-threshold');
      }
    },
    checkScrollThesholds: function () {
      // iron-scroll-threshold/issues/16
      this.checkScrollThresholds();
    },
    /**
     * Clear the upper and lower threshold states.
     *
     * @method clearTriggers
     */
    clearTriggers: function () {
      this._setUpperTriggered(false);
      this._setLowerTriggered(false);
    }

    /**
     * Fires when the lower threshold has been reached.
     *
     * @event lower-threshold
     */

    /**
     * Fires when the upper threshold has been reached.
     *
     * @event upper-threshold
     */
  });

  let QueryFilter = /*#__PURE__*/function (_LitElement) {
    _inherits(QueryFilter, _LitElement);
    var _super = _createSuper(QueryFilter);
    function QueryFilter() {
      var _this;
      _classCallCheck(this, QueryFilter);
      _this = _super.call(this);
      _this.operator = "";
      _this.operators = [];
      _this.value = "";
      _this.onValueChange = () => {};
      _this.onDelete = () => {};
      _this._valueError = '';
      _this._valueTouched = false;
      return _this;
    }
    _createClass(QueryFilter, [{
      key: "onOperationSelect",
      value: function onOperationSelect(operator) {
        this.operator = operator;
        this.handleFilterChange();
      }
    }, {
      key: "handleValueBlur",
      value: function handleValueBlur(e) {
        this.value = e.target.value;
        this._valueTouched = true;
        this.handleFilterChange();
      }
    }, {
      key: "handleDelete",
      value: function handleDelete() {
        this.onDelete();
      }
    }, {
      key: "validate",
      value: function validate() {
        if (/gt|gte|lt|lte/.test(this.operator)) {
          if (!this.value || isNaN(this.value)) {
            this._valueError = 'Number needed';
            return false;
          }
        }
        this._valueError = '';
        return true;
      }
    }, {
      key: "handleFilterChange",
      value: function handleFilterChange() {
        this.validate();
        this.onValueChange({
          operator: this.operator,
          value: this.value
        });
      }
    }, {
      key: "handleInputKeyDown",
      value: function handleInputKeyDown(e) {
        // fire handleValueBlur callback to update filter in query-filter-dropdown before it is closed
        if (e.key === 'Enter' || e.keyCode === 13) {
          this.handleValueBlur(e);
        }
      }
    }, {
      key: "render",
      value: function render() {
        const showValueError = this._valueTouched && this._valueError;
        return html$1`
      <div class="query-filter">
        <unity-dropdown
          class="filter-field${showValueError ? ' field-with-error' : ''}"
          id="query-filter-dropdown"
          label=""
          inputType="single-select"
          placeholder="oper"
          .options="${this.operators}"
          .selected="${[this.operator]}"
          .onValueChange=${this.onOperationSelect.bind(this)}
        >
        </unity-dropdown>

        <unity-text-input
          ?hideErrors=${!showValueError}
          class="filter-field"
          id="query-filter-value"
          placeholder="value"
          value="${this.value}"
          @blur="${this.handleValueBlur}"
          error="${this._valueTouched ? this._valueError : ''}"
          @keydown=${this.handleInputKeyDown}
        ></unity-text-input>
        <unity-button
          class="filter-delete-button"
          id="query-filter-delete-button"
          centerIcon="unity:trash_can"
          type="borderless"
          @click="${this.handleDelete}"
        ></unity-button>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          operator: {
            type: String
          },
          value: {
            type: String
          },
          operators: {
            type: Array
          },
          _valueError: {
            type: String
          },
          onValueChange: {
            type: Function
          },
          onDelete: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          line-height: initial;
        }
        .query-filter {
          width: 100%;
          min-width: 0;
          display: flex;
          align-items: flex-start;
        }

        unity-dropdown {
          --dropdown-width: var(--query-filter-dropdown-width, 60px);
          margin-right:4px;
        }
        unity-text-input {
          width: 100px;
        }
        .filter-field {
          margin-bottom: 4px;
        }
        .filter-delete-button {
          margin-right: -2px;
        }

        .field-with-error {
          padding-bottom: 20px;
        }
      `];
      }
    }]);
    return QueryFilter;
  }(LitElement);
  window.customElements.define('query-filter', QueryFilter);

  const initFilter = {
    operator: undefined,
    value: ''
  };
  const initOperators = [{
    "label": "==",
    "id": "eq"
  }, {
    "label": "!=",
    "id": "neq"
  }, {
    "label": ">",
    "id": "gt"
  }, {
    "label": ">=",
    "id": "gte"
  }, {
    "label": "<",
    "id": "lt"
  }, {
    "label": "<=",
    "id": "lte"
  }];
  let QueryFilterDropdown = /*#__PURE__*/function (_LitElement) {
    _inherits(QueryFilterDropdown, _LitElement);
    var _super = _createSuper(QueryFilterDropdown);
    function QueryFilterDropdown() {
      var _this;
      _classCallCheck(this, QueryFilterDropdown);
      _this = _super.call(this);
      _this.show = false;
      _this.onValueChange = () => {};
      _this.singleFilter = false;
      _this._filters = [initFilter];
      _this._operators = initOperators;
      _this.disabled = false;
      _this.tooltip = '';
      return _this;
    }
    _createClass(QueryFilterDropdown, [{
      key: "filters",
      get: function () {
        return this._filters;
      },
      set: function () {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this._filters = filters.length > 0 ? filters : [initFilter];
      }
    }, {
      key: "operators",
      get: function () {
        return this._operators;
      },
      set: function () {
        let operators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this._operators = operators.length > 0 ? operators : initOperators;
      }
    }, {
      key: "toggleDropdown",
      value: function toggleDropdown(show) {
        this.show = typeof show === 'boolean' ? show : !this.show;
      }
    }, {
      key: "handleAddFilter",
      value: function handleAddFilter() {
        this.filters = [].concat(_toConsumableArray(this.filters), [initFilter]);
      }
    }, {
      key: "handleFilterChange",
      value: function handleFilterChange(_ref, index) {
        let {
          operator,
          value
        } = _ref;
        this.filters = this.filters.map((filter, i) => {
          return index === i ? {
            operator,
            value
          } : filter;
        });
      }
    }, {
      key: "handleFilterDelete",
      value: function handleFilterDelete(index) {
        this.filters = [].concat(_toConsumableArray(this.filters.slice(0, index)), _toConsumableArray(this.filters.slice(index + 1)));
      }
    }, {
      key: "handleClearFilters",
      value: function handleClearFilters() {
        this.filters = [initFilter];
      }
    }, {
      key: "handleClose",
      value: function handleClose() {
        this.toggleDropdown(false);
        const validFilters = this.filters.filter(_ref2 => {
          let {
            operator,
            value
          } = _ref2;
          //remove empty queries
          if (!operator) return false;

          //remove filters with gt or lt operator and a non-numerical value
          if (/gt|gte|lt|lte/.test(operator)) {
            if (!value || isNaN(value)) {
              return false;
            }
          }
          return true;
        });

        //remove invalid filters
        this.filters = validFilters.length === 0 ? [initFilter] : validFilters;

        //Alert table of filter change
        this.onValueChange(validFilters);
      }
    }, {
      key: "hasAppliedFilters",
      value: function hasAppliedFilters() {
        const {
          filters = []
        } = this;
        if (filters.length > 1) return true;
        if (filters.length === 1 && filters[0] !== initFilter) return true;
        return false;
      }
    }, {
      key: "handleInputKeyDown",
      value: function handleInputKeyDown(e) {
        // Close dropdown and fire onValueChange callback
        if (e.key === 'Enter' || e.keyCode === 13) {
          //&& e.target.id === "filter-value-field") ) {
          this.handleClose();
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          disabled,
          filters = [],
          tooltip
        } = this;
        let filterButtonClass = 'column-filter-button';
        if (this.hasAppliedFilters()) filterButtonClass += ' filtered';
        if (disabled) filterButtonClass += ' disabled';
        return html$1`<unity-popover
        id="column-filter-query"
        closeOnOutsideClick="${true}"
        ?show="${this.show}"
        .onClose="${this.handleClose.bind(this)}"
        .offsetModifier="${[0, 10]}"
      >
        <unity-button
          slot="on-page-content"
          centerIcon="unity:filter"
          type="borderless"
          @click=${() => disabled ? {} : this.toggleDropdown()}
          id="filter-header-button"
          class="${filterButtonClass}"
          ?disabled=${disabled}
          title=${tooltip ? tooltip : ''}
        ></unity-button>
        <div
          slot="popover-content"
          id="popover-content"
        >
          <unity-typography>Column Filters</unity-typography>
          ${filters.map((filter, index) => html$1`<query-filter
              .operator="${filter.operator}"
              .value="${filter.value}"
              .operators="${this.operators}"
              .onValueChange=${filter => this.handleFilterChange(filter, index)}
              .onDelete=${() => this.handleFilterDelete(index)}
              @keydown=${this.handleInputKeyDown}
            >
            </query-filter>`)}

          <div class="controls">
            ${this.singleFilter ? null : html$1`<unity-button
                id="add-filter-button"
                centerIcon="unity:add"
                type="borderless"
                @click=${this.handleAddFilter.bind(this)}
              >
              </unity-button>`}
            <div class="lower-controls">
              <unity-button
                label="Clear"
                id="clear-filter-button"
                type="borderless"
                @click=${this.handleClearFilters.bind(this)}
              >
              </unity-button>
              <unity-button
                label="Apply"
                id="apply-filter-button"
                type="primary"
                @click=${this.handleClose.bind(this)}
              >
              </unity-button>
            </div>
          </div>
        </div>
      </unity-popover>      
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          show: {
            type: Boolean
          },
          disabled: {
            type: Boolean
          },
          filters: {
            type: Array
          },
          onValueChange: {
            type: Function
          },
          operators: {
            type: Array
          },
          singleFilter: {
            type: Boolean
          },
          tooltip: {
            type: String
          },
          _filters: {
            type: Array
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        * {
          -moz-box-sizing: border-box;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
        :host {
          display: flex;
          align-items: center;
          --filter-button-color: var(--black-color, var(--default-black-color));
        }
        #filter-header-button {
          display: flex;
          align-items: center;
          align-self: center;
          height: 22px;
          margin-right: 2px;
          --button-color: var(--filter-button-color);
          --paper-button-ink-color: transparent;
        }
        #filter-header-button.disabled {
          cursor: default;
        }
        #add-filter-button {
          width: 22px;
          height: 22px;
          margin-right: 2px;
          margin-top: -2px;
          margin-bottom: 2px;
        }
        .filtered {
          --button-borderless-text-color: var(--primary-brand-color, var(--default-primary-brand-color));
          --button-color: var(--primary-brand-color, var(--default-primary-brand-color));
          --pressed-color: var(--primary-brand-color, var(--default-primary-brand-color));
        }

        unity-popover {
          --popover-z-index: 200;
          --popover-content-overflow: visible;
        }
        #popover-content {
          cursor: initial;
          position: relative;
          margin-bottom: 4px;
        }
        .controls {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }
        .lower-controls {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-top: 4px;
        }
      `];
      }
    }]);
    return QueryFilterDropdown;
  }(LitElement);
  window.customElements.define('query-filter-dropdown', QueryFilterDropdown);

  const defaultChildKey = '_rootChildren';
  const DES$1 = 'Descending';
  const UNS$1 = 'Unsorted';

  //accept data array which may have nested children
  //filter nodes that match filter test, while maintaining hierarchy structure
  function filterData(_ref) {
    let {
      filter = '',
      data = [],
      columns = [],
      childKeys = ['children'],
      //attribute names containing nested array of nodes
      columnKeys = ['name'] //attribute names to apply filter to
    } = _ref;
    //Create root node and pass data in as children
    const originalHierarchy = {
      [defaultChildKey]: data
    };
    const filteredHierarchy = _filterHierarchy({
      filter,
      node: originalHierarchy,
      columns,
      path: [],
      filteredHierarchy: {},
      originalHierarchy,
      childKeys: [defaultChildKey].concat(_toConsumableArray(childKeys)),
      columnKeys
    });
    return !!filteredHierarchy ? filteredHierarchy[defaultChildKey] : [];
  }
  function _escapeSpecialCharacters(str) {
    return str.replaceAll(/[\W]/g, function (match) {
      return `\\${match}`;
    });
  }

  //Called recursively
  function _filterHierarchy(_ref2) {
    let {
      filter = '',
      node = {},
      columns = [],
      path = [],
      filteredHierarchy = {},
      originalHierarchy = {},
      childKeys = [],
      //Array of attribute names that hold children
      columnKeys = [] //Array of column keys to sort on
    } = _ref2;
    //Depth first recursion down node
    childKeys.forEach((childKey, index) => {
      const children = node[childKey];
      if (Array.isArray(children)) {
        children.forEach((child, childIndex) => {
          _filterHierarchy({
            filter,
            node: child,
            columns,
            path: [].concat(_toConsumableArray(path), [childKey, childIndex]),
            filteredHierarchy,
            originalHierarchy,
            childKeys,
            columnKeys
          });
        });
      }
    });

    //TODO: also build up expanded map
    //Find nodes that match searchText
    if (columnKeys.some((colKey, colIndex) => {
      const {
        key,
        format = val => val,
        customFilter
      } = columns[colIndex] || {};
      const cellValue = format(node[key], node);
      if (customFilter && typeof customFilter === 'function') {
        return customFilter(filter, cellValue);
      }
      let searchRegex = new RegExp();
      try {
        const formattedFilter = _escapeSpecialCharacters(filter);
        searchRegex = new RegExp(formattedFilter, 'i');
        return searchRegex.test(cellValue);
      } catch (e) {
        console.error('error in table-utils.js -> _filterHierarchy(): ', e);
        return false;
      }
    })) {
      let filterNode = filteredHierarchy;
      let originalNode = originalHierarchy;

      //build up filteredHierarchy with matching nodes
      path.forEach(pathKey => {
        //If it does not already exist add originalNode to filteredHierarchy, reset childKeys
        if (!filterNode[pathKey]) {
          filterNode[pathKey] = childKeys.includes(pathKey) ? [] : Array.isArray(originalNode[pathKey]) ? _toConsumableArray(originalNode[pathKey]) : _objectSpread2$1({}, originalNode[pathKey]);

          //reset childKeys to empty array (if they exist in originalNode)
          childKeys.forEach(childKey => {
            if (!!filterNode[pathKey][childKey]) {
              filterNode[pathKey][childKey] = [];
            }
          });
        }
        filterNode = filterNode[pathKey];
        originalNode = originalNode[pathKey];
      });
    }
    return filteredHierarchy;
  }

  //accept data array which may have nested children
  //Sort nodes at each hierarchy level, preserving hierarchy structure
  function sortData(_ref3) {
    let {
      data = [],
      sortBy = '',
      direction = UNS$1,
      childKeys = []
    } = _ref3;
    //traverse hierarchy data
    //sort each set of children
    const originalHierarchy = {
      [defaultChildKey]: data
    };
    const sortedHieararchy = _sortNode({
      node: originalHierarchy,
      sortBy,
      direction,
      childKeys: [defaultChildKey].concat(_toConsumableArray(childKeys))
    });
    return !!sortedHieararchy ? sortedHieararchy[defaultChildKey] : [];
  }

  //recursively sort hierarchy
  const _sortNode = _ref4 => {
    let {
      node = {},
      sortBy = '',
      direction = UNS$1,
      childKeys = [] //Array of attribute names that hold children
    } = _ref4;
    const sortedNode = Array.isArray(node) ? _toConsumableArray(node) : _objectSpread2$1({}, node);
    childKeys.forEach((childKey, index) => {
      const children = sortedNode[childKey];
      if (Array.isArray(children)) {
        sortedNode[childKey] = _sortList(children, sortBy, direction).map((child, childIndex) => {
          return _sortNode({
            node: child,
            sortBy,
            direction,
            childKeys
          });
        });
      }
    });
    return sortedNode;
  };

  //Pass in data array, sortBy key and direction
  const _sortList = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let sortBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : UNS$1;
    return _toConsumableArray(data).sort((datum1, datum2) => {
      //check if number or string
      const valA = datum1[sortBy];
      const valB = datum2[sortBy];
      const a = (valA || valA === 0) && !isNaN(valA) ? Number(valA) : valA && typeof valA === 'string' ? String(valA).toLowerCase() : '';
      const b = (valB || valB === 0) && !isNaN(valB) ? Number(valB) : valB && typeof valB === 'string' ? String(valB).toLowerCase() : '';
      return compare(a, b, direction);
    });
  };
  function compare(a, b) {
    let direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : UNS$1;
    if (a < b) {
      // return < 0, a first
      return direction === DES$1 ? 1 : -1;
    } else if (b < a) {
      // return < 0, a first
      return direction === DES$1 ? -1 : 1;
    } else {
      return 0;
    }
  }

  const _excluded = ["_rowId", "_tabIndex", "_childCount"];

  /**
   * Displays table of data.
   * @name UnityTable
   * @param {[]} data, array of objects
   * @param {[]} columns, array of objects, relates to data's object keys
   * @param {[]} selected, array of strings, each a cell identifier to be selected ('this.selected' is only set in table when attribute changes)
   * @param {object} columnFilters, array of filters for each column key, scructure {columnKey: {operation: 'eq', value: 'valueToMatch'}}
   * @param {func} keyExtractor, func with row datum and row index as arguments. Retuns unique row identifier.
   * @param {func} slotIdExtractor, func with row datum and column datum as arguments. Returns unique cell identifier.
   * @param {bool} headless, controls if the table has a header row
   * @param {bool} compact, controls if the rows should be shorter
   * @param {bool} startExpanded, controls if the table data begins as expanded (true) or collapsed (false / default)
   * @param {bool} selectable, controls if rows are selectable
   * @param {bool} isLoading, shows spinner instead of table
   * @param {bool} disableColumnResize, controls if column resize should be disabled
   * @param {bool} disableInternalSort, controls if internal sort should be disabled
   * @param {string} emptyDisplay, string to show when table is empty
   * @param {string} highlightedRow, id of row to highlight
   * @param {number} endReachedThreshold, number of px before scroll boundary to update this._rowOffset
   * @param {object} initialSortBy, sortBy object to initialize table column sorting.
   * @param {func} onClickRow, func that is sent the data of the element clicked, the key of the row as defined by keyExtractor, and the event of the click
   * @param {func} onHighlight, func that is sent the data of the highlighted element if it is found
   * @param {func} onSelectionChange, func that is sent the currently selected elements as an array
   * @param {func} onEndReached, func that is fired when bottom of table has been reached. useful for external pagination.
   * @param {func} onColumnSort, func that is fired when column sorting changes.
   * @param {func} onColumnFilter, func that is fired when column filters change.
   * @returns {LitElement} returns a class extended from LitElement
   * @example
   *  <unity-table
   *    ?headless="${false}"
   *    ?startExpanded="${false}"
   *    ?isLoading="${false}"
   *    emptyDisplay="No information found."
   *    .data="${[
   *      {
   *        column1: 'item 1 col1',
   *        column2: 'item 1 col2',
   *        column3: 'item 1 col3',
   *        columnN: 'item 1 colN',
   *        icon: 'iron-iconName',
   *        backgroundColor: '#454545' //define row background color
   *        rowOpacity: 0.5 //define row opacity
   *      },
   *      {
   *        column1: 'item 2 col1',
   *        column2: 'item 2 col2',
   *        column3: 'item 2 col3',
   *        columnN: 'item 2 colN',
   *        icon: 'iron-iconName'
   *      },
   *      {
   *        column1: 'item n col1',
   *        column2: 'item n col2',
   *        column3: 'item n col3',
   *        columnN: 'item n colN',
   *        icon: 'iron-iconName'
   *      }
   *    ]}"
   *    .columns="${[
   *      {
   *        key: 'column2',
   *        label: 'Column #2'
   *        formatLabel: (colValue, datum) => `Building: ${colValue}`
   *        width: 50,
   *      },
   *      {
   *        key: 'columnN',
   *        label: 'Column #N'
   *        formatLabel: (colValue, datum) => colValue
   *      },
   *      {
   *        key: 'column1',
   *        label: 'Column #1'
   *        formatLabel: column1Handler,
   *        hideSort: true,
   *        showFilter: true
   *      }
   *    ]}"
   *    ?selectable="${true}"
   *    .onSelectionChange="${selected => console.log('These elements are selected: ', selected')}"
   *    .columnFilters=${{deviceType: [{operation: 'eq', value: 'thermostat'}, {operation: 'neq', value: 'heater'}]}}

   *  />
   */

  //   Table, at minimum, takes an array of the data being passed in. Each data index
  //   should be an object with uniform keys. Actions are handled outside of table,
  //   but are dependant on what's selected. As such, if outside source wants access
  //   to the selected elements, a function should be passed in to process the
  //   selected data. In addition, a predefined column array can be passed in to
  //   determine order and size of columns in the table. If not passed in, then a
  //   default will be made from each key on the data object.
  //
  //   data:                   array of datum objects, non-uniform shape
  //                           each key is a viable column, with icon available for rendering leading row icon
  //   columns:                array of column objects, can contain formatLabel function (returns string)
  //                           structure: {
  //                             key (related to datum keys),
  //                             label (label rendered)
  //                             width (integer tp determine column width)
  //                             formatLabel (function that takes `value` and returns new value for cell)
  //                             customFilter (a function that takes `filter` and `value` and returns `true` if the element should appear in search results)
  //                           }
  //   selected
  //   headless:               bool to control head render, include to have no table header
  //   startExpanded:          bool to control whether data starts as expanded or collapsed
  //   selectable:             bool to control if rows should be selectable
  //   onSelectionChange:      callback function, recieves selected array when it changes
  //   emptyDisplay:           String to display when data array is empty
  //   isLoading:              Boolean to show spinner instead of table
  //   disableColumnResize:    controls if column resize should be disabled
  //   keyExtractor         :  Function to define a unique key on each data element
  //   slotIdExtractor      :  Function to define a unique slot name for each table cell. Used for adding custom content to specific table cells.
  //   childKeys            :  Array of attribute names that contain list of child nodes, listed in the order that they should be displayed
  //   filter               :  String to find in any column, used to set internal _filter
  //   endReachedThreshold  :  Number of px before scroll boundary to update this._rowOffset
  //   onExpandedChange     :  On Change Callback Function for expanded array
  //   onEndReached         :  Callback fired when bottom of table has been reached. useful for external pagination.
  //
  //   Internals for creating/editing
  //   _data:                  data marked w/ rowId for uniq references
  //   _selected:              Set of keys of elements that are selected, sent to onSelectionChange
  //   _sortBy:                object with column to sort by and direction, default all unsorted
  //                           sorting is done off of data's values, which can cause disconnect if format changes rendered values too much
  //   _filter:                string to find in any column
  //   _filteredList:          filtered list of indicies from _data
  //   _sortedList:            sorted version of _filteredList, this is what the displayed table is built from
  //   _tableId:               Unique identifier for table instance, defined via Date.now()
  //   _visibleRowCount      :  Maximum number of rows to render at once

  //   Features to be implemented
  //   controls:               determines use of internal filter and sort, exclude if using internal sort/filter
  //   onSearchFilter:         function to be called when filter changes if controls are EXT
  //                           sends in string to filter by
  //   filterDebounceTimeout:  TBD
  //   filterThrottleTimeout:  TBD
  //   onColumnSort:           function to be called when sortBy changes if controls are EXT
  //                           sends string of column name and string for ascending or descending
  //   onColumnFilter:         Callback to update when column filters change
  //   onColumnChange:         Callback to update changes to the rendered columns
  //   onEndReached:           Callback fired when Scroll to within threshold of lower bound.
  //                           Useful for server side pagination to support infiniscroll
  //                           Only call when reached the end of the input data array
  const ASC = 'Ascending';
  const DES = 'Descending';
  const UNS = 'Unsorted';
  const MIN_CELL_WIDTH = 60; //minimum pixel width of each table cell
  const MOUSE_MOVE_THRESHOLD = 5; //pixels mouse is able to move horizontally before rowClick is cancelled
  const ROW_HEIGHT = 40; //used to set scroll offset
  const THRESHOLD_TIMEOUT = 60; //Timeout after scroll boundry is reached before callback can be fired again
  const END_REACHED_TIMEOUT = 2000; //Timeout after true end is reached before callback can be fired again
  const MIN_VISIBLE_ROWS = 50; //Minimum number of rows to render at once
  const CELL_PLACEHOLDER = "-"; //Consider adding this as a table property

  const getSortedIcon = direction => {
    switch (direction) {
      case ASC:
        return 'unity:up';
      case DES:
        return 'unity:down';
      default:
        return 'unity:sort';
    }
  };
  let UnityTable = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityTable, _LitElement);
    var _super = _createSuper(UnityTable);
    // internals
    function UnityTable() {
      var _this;
      _classCallCheck(this, UnityTable);
      _this = _super.call(this);
      // defaults of input
      _this._data = [];
      _this.columns = [];
      _this.selected = [];
      _this.selectable = false;
      _this.headless = false;
      _this.compact = false;
      _this.startExpanded = false;
      _this.isLoading = false;
      _this.disableColumnResize = false;
      _this.disableInternalSort = false;
      _this.emptyDisplay = 'No information found.';
      _this.childKeys = ['children'];
      _this.filter = '';
      _this.columnFilters = {};
      _this.endReachedThreshold = 200; //distance in px to fire onEndReached before getting to bottom
      _this.slotIdExtractor = function () {
        let row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let column = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return `${row._rowId}-${column.key}`;
      };
      _this._highlightedRow = '';

      // action handlers
      _this.onClickRow = null;
      _this.onSelectionChange = () => {};
      _this.onExpandedChange = () => {};
      _this.onDisplayColumnsChange = () => {};
      _this.onHighlight = () => {};
      _this.onColumnFilter = () => {};

      // action handlers, to be implemented later
      // this.controls = false
      // this.onSearchFilter = ()=>{}
      // this.onColumnSort = ()=>{}
      _this.onEndReached = async () => {};
      _this._onColumnChange = () => {};

      // defaults of internal references
      _this._filter = '';
      _this._columnOffset = null;
      _this._sortBy = {
        column: '',
        direction: UNS
      };
      _this._filteredData = [];
      _this._sortedData = [];
      _this._flattenedData = [];
      _this._allSelected = false;
      _this._dataMap = new Map();
      _this._selected = new Set();
      _this._expanded = new Set();
      _this._keyExtractor = (datum, index) => index;
      _this._columns = [];
      _this._rowOffset = 0; //used to track for infinite scroll
      _this._tableId = Date.now(); //unique identifier for table element
      _this._visibleRowCount = MIN_VISIBLE_ROWS;
      _this.isFlat = true;
      _this.hasIcons = false;
      return _this;
    }

    // inputs
    _createClass(UnityTable, [{
      key: "firstUpdated",
      value:
      //NOTE: #unity-table-container element is not mounted in intial connectedCallback, only after firstUpdated
      function firstUpdated(changedProperties) {
        this.initTableRef();
        this._setVisibleRowsArray();
        this.updateComplete.then(() => {
          this.scrollToHighlightedRow.bind(this);
        });
      }
    }, {
      key: "updated",
      value: function updated(changedProps) {
        // TODO: This should also apply to columnFiltering and column sorting
        if (changedProps.has('filter') && !!this.tableRef) {
          this.tableRef.scrollTop = 0;
        }
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(UnityTable.prototype), "connectedCallback", this).call(this);
        this.initTableRef();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        if (!!this.tableRef) {
          this.tableRef.removeEventListener('lower-threshold', this.boundLowerHandle);
          this.tableRef.removeEventListener('upper-threshold', this.boundUpperHandle);
          this.tableRef = undefined;
        }
        _get(_getPrototypeOf(UnityTable.prototype), "disconnectedCallback", this).call(this);
      }
    }, {
      key: "initTableRef",
      value: function initTableRef() {
        //Only define tableRef and its boundary threshold events if not already defined.
        if (!this.tableRef) {
          this.tableRef = this.shadowRoot.getElementById(`unity-table-${this._tableId}`);
          if (!!this.tableRef) {
            this.tableRef.upperThreshold = this.endReachedThreshold;
            this.tableRef.lowerThreshold = this.endReachedThreshold;
            this.boundLowerHandle = this.handleLowerThreshold.bind(this);
            this.boundUpperHandle = this.handleUpperThreshold.bind(this);
            this.tableRef.addEventListener('lower-threshold', this.boundLowerHandle);
            this.tableRef.addEventListener('upper-threshold', this.boundUpperHandle);

            //Automatically set this._visibleRowCount to fill 200% of container height, or MIN_VISIBLE_ROWS rows, which ever is greater
            this._visibleRowCount = Math.max(Math.ceil(this.tableRef.offsetHeight / ROW_HEIGHT) * 2, MIN_VISIBLE_ROWS);
          }
        }
      }
    }, {
      key: "handleLowerThreshold",
      value: async function handleLowerThreshold(e) {
        let dataLength = this._flattenedData.length;
        const nextOffset = this._rowOffset + this._visibleRowCount;
        if (nextOffset + this._visibleRowCount >= dataLength && typeof this.onEndReached === 'function') {
          //NOTE: this is throttled via END_REACHED_TIMEOUT
          await this.onEndReached();
          dataLength = this._flattenedData.length;
          setTimeout(() => {
            this.tableRef && this.tableRef.clearTriggers();
          }, END_REACHED_TIMEOUT);
        } else {
          setTimeout(() => {
            this.tableRef && this.tableRef.clearTriggers();
          }, THRESHOLD_TIMEOUT);
        }
        let maxOffset = Math.max(dataLength - this._visibleRowCount, 0);
        this._rowOffset = Math.min(maxOffset, nextOffset);
      }

      //NOTE: this should only be fired when at the very top
    }, {
      key: "handleUpperThreshold",
      value: function handleUpperThreshold(e) {
        this._rowOffset = 0;
        setTimeout(() => {
          this.tableRef && this.tableRef.clearTriggers();
        }, THRESHOLD_TIMEOUT);
      }

      //TODO: move into table utils
      //depth first search of hieararchy node, apply callback to each node
      //NOTE: callback called with node, tabIndex, and childCount
    }, {
      key: "dfsTraverse",
      value: function dfsTraverse(_ref) {
        let {
          node = {},
          callback = (node, tabIndex, childCount, parents) => {},
          tabIndex = 0,
          //this is internally managed
          parents = []
        } = _ref;
        //If node is an array, loop over it
        if (tabIndex > 0) this.isFlat = false;
        if (Array.isArray(node)) {
          node.forEach(nodeElement => {
            this.dfsTraverse({
              node: nodeElement,
              callback,
              tabIndex,
              parents
            });
          });
        } else {
          const rowId = this.keyExtractor(node, tabIndex);
          const nextTabIndex = tabIndex + 1;
          let childCount = 0;
          let childNodes = [];
          if (!!node.icon) this.hasIcons = true;
          this.childKeys.forEach(childKey => {
            const children = node[childKey];
            if (Array.isArray(children)) {
              childCount += children.length;
              childNodes = [].concat(_toConsumableArray(childNodes), _toConsumableArray(children));
            }
          });

          //NOTE: this may need to be called before iterating down children
          callback(node, tabIndex, childCount, parents);
          childNodes.forEach(child => {
            this.dfsTraverse({
              node: child,
              callback,
              tabIndex: nextTabIndex,
              parents: [].concat(_toConsumableArray(parents), [rowId])
            });
          });
        }
      }

      // Data passed in as array
      // Also updates this._dataMap, and this._selected
    }, {
      key: "data",
      get: function () {
        return this._data;
      },
      set: function (value) {
        const oldValue = this._data;
        const columns = this.columns;
        const childKeys = this.childKeys || [];
        const originalDataMap = this._dataMap;

        // default catcher for missing columns
        // exclude childKeys from columns list
        if ((!columns || !columns.length) && !!value && value.length > 0) {
          const nextCols = Object.keys(value[0]).filter(attrKey => !childKeys.some(childKey => childKey === attrKey)).map(name => ({
            key: name,
            label: name
          }));
          this.columns = nextCols;
        }
        this._data = value;
        this.setDataMap(value);

        //Update this.selectied.
        //Add new children of selected nodes to this.selected
        //Remove nodes from that are no longer present
        this.updateSelected(originalDataMap);

        // Expand all nodes if the User has indicated to do so, but not if changes to the expansion of nodes have already been made
        // NOTE: this assumes this.expanded is undefined initially
        if (this.startExpanded && (!this.expanded || this.expanded.size === 0)) this._expandAll();
        this._process();
        this.requestUpdate('data', oldValue);
      }
    }, {
      key: "columns",
      get: function () {
        return this._columns;
      },
      set: function (cols) {
        const oldVal = this._columns;
        //Clear saved column widths when a new column is added to allow column widths to adjust to fit
        const clearColumnWidths = !cols || !oldVal || cols.length > oldVal.length;
        this._columns = clearColumnWidths ? cols : cols.map(col => {
          const {
            width: oldWidth
          } = oldVal.find(oldColumn => oldColumn.key === col.key) || {};
          const nextCol = _objectSpread2$1({}, col);
          //preserve old column width if defined
          if (oldWidth) {
            nextCol.width = nextCol.width || oldWidth;
          }
          return nextCol;
        });
        if (!!this.onColumnChange) {
          this.onColumnChange(this._columns);
        }
        this.requestUpdate('columns', oldVal);
      }
    }, {
      key: "initialSortBy",
      set: function (value) {
        this.sortBy = value;
      }

      // sortBy will be cyclical: UNS -> ASC -> DES -> UNS
    }, {
      key: "sortBy",
      get: function () {
        return this._sortBy;
      },
      set: function (value) {
        // should always receive object
        // should save value as expected
        // call process on new values
        // update
        const oldValue = this._sortBy;
        let column, direction;
        if (value instanceof Object) {
          column = value.column;
          direction = value.direction;
        } else {
          column = value;
          direction = oldValue.direction;
          const changed = oldValue.column !== column;
          // check direction is to update to next in cycle
          if (changed || !direction) {
            direction = ASC;
          } else if (direction === ASC) {
            direction = DES;
          } else if (direction === DES) {
            direction = false;
          }
        }
        // check that column is in list
        const columns = this.columns;
        const exists = columns.some(_ref2 => {
          let {
            key
          } = _ref2;
          return key === column;
        });
        if (!exists && columns.length > 0) {
          return false;
        }
        this._sortBy = {
          column,
          direction
        };
        this._sortData();
        this._setVisibleRowsArray();
        this.requestUpdate('sortBy', oldValue);
        if (this.onColumnSort instanceof Function) {
          this.onColumnSort(this._sortBy);
        }
      }
    }, {
      key: "selected",
      get: function () {
        return this._selected;
      }

      //NOTE: if setting from attribute, may need to pass in as Array
      ,
      set: function (selectedSet) {
        var _this2 = this;
        const oldValue = this._selected;
        const newValue = new Set(selectedSet); // ensure that value is an iterable array of keys
        // checks if sets are equal
        if (!!oldValue && oldValue.size === newValue.size && _toConsumableArray(newValue).every(id => oldValue.has(id))) return;
        this._selected = newValue;

        // Array of selected data elements
        const selectedData = Array.from(this._selected).reduce(function (out) {
          let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
          const newVal = _this2._dataMap.get(id.toString());
          if (newVal !== undefined) out.push(newVal);
          return out;
        }, []);
        if (!!this.onSelectionChange) this.onSelectionChange(selectedData);
        if (selectedData.length === 0) {
          this._allSelected = false;
        } else {
          //Determine if any table row is unselected
          const unselectedMap = new Set(this._flattenedData.map((datum, index) => datum._rowId));
          this._selected.forEach(id => {
            unselectedMap.delete(id);
          });
          const hasUnselected = unselectedMap.size > 0;
          this._allSelected = !hasUnselected;
        }
        this._dataMap || new Map();
        this.requestUpdate('selected', oldValue);
      }
    }, {
      key: "expanded",
      get: function () {
        return this._expanded;
      },
      set: function (expandedSet) {
        var _this3 = this;
        const oldValue = this._expanded;
        this._expanded = new Set(expandedSet);

        //Notify user expanded has changed
        if (!!this.onExpandedChange) {
          const expandedNodes = Array.from(this._expanded).map(function () {
            let rowId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            return _this3._dataMap.get(rowId.toString());
          });
          this.onExpandedChange(expandedNodes);
        }
        this._setVisibleRowsArray();
        this.requestUpdate('expanded', oldValue);
      }
    }, {
      key: "filter",
      get: function () {
        return this._filter;
      },
      set: function (value) {
        const oldValue = this._filter;
        this._filter = value;
        this._expandAll();
        this._process();
        this.requestUpdate('filter', oldValue);
      }
    }, {
      key: "keyExtractor",
      get: function () {
        return this._keyExtractor;
      }

      // when the highlightedRow changes, run onHighlight
      ,
      set: function (value) {
        const oldExtractor = this._keyExtractor;
        this._keyExtractor = value;
        this.requestUpdate('keyExtractor', oldExtractor);

        //Update this.data to use new keyExtractor
        this.data = _toConsumableArray(this.data);
      }
    }, {
      key: "highlightedRow",
      get: function () {
        return this._highlightedRow;
      },
      set: function (value) {
        const oldHighlight = this._highlightedRow;
        this._highlightedRow = value;
        this.requestUpdate('highlightedRow', oldHighlight);
        // this is to make sure that updates happen at a pace to trigger
        // proper outer updates. without this, the pane would be one update
        // behind or the pane's wrapper would have to have it
        this.updateComplete.then(() => this._findHighlight(value.toString()));
      }
    }, {
      key: "setDataMap",
      value: function setDataMap(value) {
        const dataMap = new Map();
        this.dfsTraverse({
          node: value,
          callback: (node, tabIndex, childCount, parents) => {
            const key = this.keyExtractor(node, tabIndex) || '';
            dataMap.set(key.toString(), _objectSpread2$1(_objectSpread2$1({}, node), {}, {
              parents
            }));
          }
        });
        this._dataMap = dataMap;
      }
    }, {
      key: "updateSelected",
      value: function updateSelected(originalDataMap) {
        this._selected;
        this.addSelectedChildren(originalDataMap);
        this.removeDeletedSelections();
      }

      //If datum does not exist in original data map, AND it has a parent that is selected, add to this.selected
    }, {
      key: "addSelectedChildren",
      value: function addSelectedChildren(originalDataMap) {
        var _this4 = this;
        const originalSelected = this._selected;
        const nextSelected = new Set(originalSelected);
        let selectionHasChanged = false;
        this.dfsTraverse({
          node: this.data,
          callback: function (node, tabIndex, childCount) {
            let parents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
            const key = _this4.keyExtractor(node, tabIndex);
            if (!originalDataMap.has(key) && _this4.includesSelectedNode(parents)) {
              nextSelected.add(key);
              selectionHasChanged = true;
            }
          }
        });
        if (selectionHasChanged) {
          this.selected = nextSelected;
        }
      }

      //remove rowId's in this.selection that are no longer present in this.dataMap
    }, {
      key: "removeDeletedSelections",
      value: function removeDeletedSelections() {
        var _this5 = this;
        const originalSelected = this._selected;
        if (!originalSelected) return;
        const nextSelected = new Set(originalSelected);
        let selectionHasChanged = false;
        Array.from(this._selected).forEach(function () {
          let rowId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          if (!_this5._dataMap.has(rowId.toString())) {
            nextSelected.delete(rowId);
            selectionHasChanged = true;
          }
        });
        if (selectionHasChanged) {
          this.selected = nextSelected;
        }
      }

      //pass in array of node IDs, returns true if any are selected
    }, {
      key: "includesSelectedNode",
      value: function includesSelectedNode(nodeIds) {
        return nodeIds.some(nodeId => {
          return this._selected.has(nodeId);
        });
      }

      // possibly use setters for dynamic sort/filter update?
      /*
        if filter updates when changed, then _data can change
        Will data and filter ever change at the same time?
         actually, should sort after filtering, as sorting takes longer than filtering
        and filtering will remove elements which will make sorting faster
      */
    }, {
      key: "_selectAll",
      value: function _selectAll() {
        // all data are selected, make selected from all visible data

        //NOTE: this is selecting all visible rows - including nested rows
        this.selected = new Set(this._flattenedData.map(datum => datum._rowId));
      }
    }, {
      key: "_selectNone",
      value: function _selectNone() {
        // none selected, so replace with empty
        this.selected = new Set();
      }

      // If node is selected, all its children are also selected
      // If node is unselected, all its parents are also unselected
    }, {
      key: "_selectOne",
      value: function _selectOne() {
        let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        const nextSelected = new Set(this.selected);
        const node = this._dataMap.get(id.toString());
        const nodeAndChildren = this._getAllChildren(node);
        if (nextSelected.has(id)) {
          //Delete node and all its children from nextSelected
          nodeAndChildren.forEach(childId => {
            nextSelected.delete(childId);
          });

          //Unselect parents
          node.parents.forEach(parentId => {
            nextSelected.delete(parentId);
          });
        } else {
          //Add node and all its children to nextSelected
          nodeAndChildren.forEach(childId => {
            nextSelected.add(childId);
          });
        }
        this.selected = nextSelected;
      }

      //returns flat list of all children
    }, {
      key: "_getAllChildren",
      value: function _getAllChildren(node) {
        let children = [];
        this.dfsTraverse({
          node,
          callback: (node, tabIndex, childCount, parents) => {
            const rowId = this.keyExtractor(node, tabIndex);
            children.push(rowId);
          }
        });
        return children;
      }

      //Return filtered hierarchy array - same nested structure as original hierarchy
      //NOTE: this filter goes from the leaf nodes up (that way if a leaf node matches, then its parents are kept too)
    }, {
      key: "_filterData",
      value: function _filterData() {
        const searchFor = this.filter || '';
        // if controls are external, callback and quit
        // if (this.controls) {
        //   this.onSearchFilter(searchFor)
        //   this._filteredData = [...this.data]
        //   return
        // }

        if (!searchFor) {
          this._filteredData = this.data;
          return;
        }
        const filteredData = filterData({
          filter: searchFor,
          data: this.data,
          columns: this.columns,
          childKeys: this.childKeys,
          columnKeys: this.columns.map(col => col.key)
        });
        this._filteredData = filteredData;
      }
    }, {
      key: "_sortData",
      value: function _sortData() {
        const {
          column: sortBy = '',
          direction = UNS
        } = this.sortBy || {};
        if (this.disableInternalSort || !sortBy || direction === UNS) {
          this._sortedData = this._filteredData;
          return;
        }
        const sortedData = sortData({
          sortBy,
          direction,
          data: this._filteredData,
          childKeys: this.childKeys
        });
        this._sortedData = sortedData;
      }

      // sees if the requested highlighted row exists
      // passes highlighted row data if it does, undefined if it doesn't
    }, {
      key: "_findHighlight",
      value: function _findHighlight(value) {
        const rowObject = this._dataMap.get(value);
        if (!rowObject) return;
        if (!this._flattenedData.some(_ref3 => {
          let {
            id = ''
          } = _ref3;
          return id === value;
        })) {
          // highlighted row is not being shown
          const {
            parents = []
          } = rowObject;
          // expand parents
          parents.forEach(parentId => {
            this._toggleExpand(parentId, true);
          });
        }
        this.onHighlight(rowObject);
      }

      //This function flattens hierarchy data, adds internal values such as _rowId and _tabIndex
      //This should also remove children of non-expanded rows
    }, {
      key: "_setVisibleRowsArray",
      value: function _setVisibleRowsArray() {
        this._flattenedData = this.removeCollapsedChildren(this._flattenData(this._sortedData));
        this.requestUpdate();
      }
    }, {
      key: "_flattenData",
      value: function _flattenData(data) {
        let flatList = [];
        if (!this.keyExtractor) {
          return flatList;
        }
        this.dfsTraverse({
          node: data,
          callback: (node, tabIndex, childCount, parents) => {
            flatList.push(_objectSpread2$1(_objectSpread2$1({}, node), {}, {
              _tabIndex: tabIndex,
              _rowId: this.keyExtractor(node, tabIndex),
              _childCount: childCount,
              _parents: parents
            }));
          }
        });
        return flatList;
      }
    }, {
      key: "removeCollapsedChildren",
      value: function removeCollapsedChildren(data) {
        var _this6 = this;
        let toRemove = false;
        let currentTabIndex = 0;
        data = data.filter(function () {
          let node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (toRemove) {
            if (currentTabIndex < node._tabIndex) {
              return false;
            } else {
              toRemove = false;
            }
          }
          if (node._childCount > 0 && !_this6.expanded.has(node._rowId)) {
            toRemove = true;
            currentTabIndex = node._tabIndex;
          }

          //remove rows with undefined _rowId
          if (node._rowId === undefined) {
            return false;
          }
          return true;
        });
        return data;
      }
    }, {
      key: "_process",
      value: function _process() {
        this._filterData();
        this._sortData();
        this._setVisibleRowsArray();
      }
    }, {
      key: "_handleHeaderSelect",
      value: function _handleHeaderSelect() {
        const _allSelected = this._allSelected;
        // if _allSelected, select none
        if (!!_allSelected) this._selectNone();
        // if !_allSelected, select all
        else if (!_allSelected) this._selectAll();
      }

      //shouldExpand - optional boolean argument to explicitly set expanded state of rowId
    }, {
      key: "_toggleExpand",
      value: function _toggleExpand(rowId, shouldExpand) {
        const nextExpanded = new Set(this.expanded);
        const isExpanded = this.expanded.has(rowId);
        if (shouldExpand === true) {
          //Explicitly set Expanded state
          nextExpanded.add(rowId);
        } else if (shouldExpand === false) {
          nextExpanded.delete(rowId);
        } else if (isExpanded) {
          //Toggle Expanded state
          nextExpanded.delete(rowId);
        } else {
          nextExpanded.add(rowId);
        }
        this.expanded = nextExpanded;
      }
    }, {
      key: "_expandAll",
      value: function _expandAll() {
        let nextExpanded = new Set();
        this.dfsTraverse({
          node: this._data,
          callback: (node, tabIndex, childCount, parents) => {
            const rowId = this.keyExtractor(node, tabIndex);
            if (childCount > 0) {
              nextExpanded.add(rowId);
            }
          }
        });
        this.expanded = nextExpanded;
      }

      //call onColumnFilter callback with new column filters
    }, {
      key: "_handleColumnFilter",
      value: function _handleColumnFilter(key, filters) {
        //TODO: update set of column filters for entire table, report all col filters back to user
        this.columnFilters = _objectSpread2$1(_objectSpread2$1({}, this.columnFilters), {}, {
          [key]: filters
        });
        if (this.onColumnFilter instanceof Function) {
          this.onColumnFilter(this.columnFilters);
        }
      }
    }, {
      key: "_renderTableHeader",
      value: function _renderTableHeader(columns, offsets) {
        const {
          column,
          direction: dir
        } = this._sortBy;
        const direction = !!dir ? dir : UNS;
        const trClass = `sticky-header-row${this.compact ? ' compact' : ''}`;
        const colLength = columns.length;
        return html$1`
      <thead>
        <tr class="${trClass}">
          ${this.selectable ? html$1`
              <th
                class="cell select-row-wrapper"
              >
                <div class="header centered">
                  <unity-checkbox
                    id="select-all-rows-checkbox"
                    class="select-row-checkbox"
                    ?checked="${this._allSelected ? true : null}"
                    .onChange="${(e, v) => this._handleHeaderSelect(e, v)}"
                  ></unity-checkbox>
                </div>
              </th>` : null}
          ${columns.map((_ref4, i) => {
        let {
          key,
          label,
          width: rootWidth = 0,
          centered = false,
          showFilter = false,
          singleFilter = false,
          operators = [],
          hideSort = false,
          selectable: selectableColumn = false,
          onSelect: onColumnSelect = () => {},
          isSelected = false,
          filterDisabled = false,
          filterTooltip = ''
        } = _ref4;
        const isColSorted = column === key && direction !== UNS;
        const sortIcon = isColSorted ? getSortedIcon(direction) : 'unity:sort';
        const {
          startingWidth,
          xOffset = 0
        } = offsets && offsets[i] || {};

        //NOTE: only working with px
        const width = !!startingWidth ? `${startingWidth + xOffset}px` : !!rootWidth ? `${rootWidth}px` : 'auto';
        return html$1`
              <th
                class="cell"
                id="col-header-${key}"
                name="header-column-${key}"
                style="width: ${width};"
              >
                <table-cell-base
                  .resizable=${!this.disableColumnResize && i < columns.length - 1}
                  .onResizeStart="${() => {
          this._handleColumnResizeStart(key, i);
        }}"
                  .onResize="${xOffset => {
          this._handleColumnResize(key, xOffset);
        }}"
                  .onResizeComplete="${xOffset => {
          this._handleColumnResizeComplete(key);
        }}"
                >
                  <div class="header ${centered ? 'centered' : ''}">
                    <div class="header-content ${centered ? 'centered' : ''}">
                      ${selectableColumn ? html$1`<unity-checkbox
                          id="select-all-${key}-checkbox"
                          ?checked=${isSelected}
                          .onChange=${onColumnSelect}
                        ></unity-checkbox>` : ''}
                      <span
                        class="header-label"
                        @click="${() => {
          if (!hideSort) this.sortBy = key;
        }}"
                      ><b>${label || name}</b></span>

                      ${showFilter ? html$1`<query-filter-dropdown
                          .onValueChange="${filters => this._handleColumnFilter(key, filters)}"
                          .filters="${this.columnFilters[key]}"
                          .operators="${operators}"
                          ?singleFilter=${singleFilter}
                          ?disabled=${filterDisabled}
                          .tooltip="${filterTooltip}"
                        >
                        </query-filter-dropdown>` : null}

                      ${isColSorted && !hideSort ? html$1`<paper-icon-button
                            noink
                            icon="${sortIcon}"
                            title="${direction}"
                            class="header-sort-icon"
                            @click="${() => {
          this.sortBy = key;
        }}"
                          ></paper-icon-button>` : null}
                    </div>

                    ${i === colLength - 1 ? html$1`<slot class="header-right-actions" name="right-actions"></slot>` : null}
                  </div>
                </table-cell-base>
              </th>
            `;
      })}
        </tr>
      </thead>
    `;
      }
    }, {
      key: "getAllTreeValues",
      value: function getAllTreeValues(row, key, formatLabel) {
        let value = [this.getFormattedValue(row[key], formatLabel)];
        // if children, get value of every children recursively
        const childKey = this.childKeys.find(key => row[key]);
        if (!!childKey) {
          for (const child of row[childKey]) {
            value.push.apply(value, _toConsumableArray(this.getAllTreeValues(child, key, formatLabel)));
          }
        }
        return value;
      }
    }, {
      key: "getFormattedValue",
      value: function getFormattedValue(value, formatLabel) {
        let formattedValue;
        try {
          try {
            const formatted = formatLabel(value);
            if (typeof formatted === 'string') {
              formattedValue = formatted;
            } else {
              throw TypeError;
            }
          } catch (error) {
            formattedValue = value.toString();
          } finally {
            if (!formattedValue) throw TypeError;
          }
        } catch (error) {
          formattedValue = CELL_PLACEHOLDER;
        }
        return formattedValue;
      }
    }, {
      key: "_renderRow",
      value: function _renderRow() {
        let row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
            _rowId: rowId,
            _tabIndex: tabIndex,
            _childCount: childCount
          } = row,
          datum = _objectWithoutProperties$1(row, _excluded);
        // returns a row element
        const columns = this.columns;
        const {
          icon,
          image,
          backgroundColor,
          rowOpacity
        } = datum;
        const expandable = childCount > 0;
        const expanded = this.expanded.has(rowId);
        // check if highlightedRow matches keyExtractor
        let rowClasses = ['row'];
        let rowStyle = "";

        //NOTE: using == so that rowId can be number or string
        if (rowId == this.highlightedRow) {
          rowClasses.push('highlight');
        } else if (backgroundColor) {
          //if row is not highlighted, and datum has backgroundColor defined, set style
          rowStyle = `background-color: ${backgroundColor};`;
        }
        if (rowOpacity) {
          rowStyle += ` opacity: ${rowOpacity};`;
        }
        if (this.compact) rowClasses.push('compact');
        if (this.onClickRow instanceof Function) rowClasses.push('clickable');
        // if index is 0, add check-all button
        // need to add handler for icon/img and label
        return html$1`
      <tr
        class="${rowClasses.join(' ')}"
        key="row-${rowId}"
        id="row-${rowId}"
        @mousedown="${e => {
        this.startingX = e.screenX;
      }}"
        @click="${e => {
        //Compare screenY on mouseDown and this event. Dont call onClickRow if dragged
        const deltaX = Math.abs(e.screenX - this.startingX);
        if (deltaX < MOUSE_MOVE_THRESHOLD && this.onClickRow instanceof Function) {
          this.onClickRow(datum, rowId, e);
        }
      }}"
        style="${rowStyle}"
      >
        ${this.selectable ? html$1`<td class='centered select-row-wrapper'>
            <unity-checkbox
              id="select-row-${rowId}-checkbox"
              class="select-row-checkbox"
              ?checked="${this.selected.has(rowId)}"
              .onChange="${e => {
        e.stopPropagation();
        this._selectOne(rowId);
      }}"
            >
            </unity-checkbox>
          </td>` : ''}
        ${columns.map((column, i) => {
        const {
          key: columnKey,
          formatLabel,
          width
        } = column;
        const value = columnKey.split('.').reduce((accumulator, key) => {
          if (typeof accumulator === "object" && accumulator.hasOwnProperty(key)) {
            return accumulator[key];
          } else return "";
        }, datum);
        const label = formatLabel instanceof Function ? formatLabel(value, datum) : value;
        const slotId = this.slotIdExtractor(row, column);
        return html$1`
            <td class="cell" key="${slotId}">
              <unity-table-cell
                .icon="${i === 0 && icon}"
                .image="${i === 0 && image}"
                .id="${rowId}"
                .slotId="${slotId}"
                .tabIndex="${i === 0 ? tabIndex : 0}"
                ?expandable="${i === 0 && expandable}"
                ?expanded="${i === 0 && expanded}"
                .onExpand="${e => {
          this._toggleExpand(rowId);
        }}"
                .resizable=${i < columns.length - 1}
                .onResizeStart="${() => {
          this._handleColumnResizeStart(columnKey, i);
        }}"
                .onResize="${xOffset => {
          this._handleColumnResize(columnKey, xOffset);
        }}"
                .onResizeComplete="${xOffset => {
          this._handleColumnResizeComplete(columnKey);
        }}"
              >
                <slot name="${slotId}" slot="${slotId}">
                  <span class="text">${label}</span>
                </slot>
              </unity-table-cell>
            </td>`;
      })}
      </tr>
    `;
      }
    }, {
      key: "_handleColumnResizeStart",
      value: function _handleColumnResizeStart(colKey, colIndex) {
        this._columnOffset = this._columns.map(col => {
          const cell = this.shadowRoot.getElementById(`col-header-${col.key}`);
          const cellWidth = !!cell ? cell.offsetWidth : 0;
          return {
            startingWidth: cellWidth
          };
        });
      }
    }, {
      key: "_handleColumnResize",
      value: function _handleColumnResize(colKey, xOffset) {
        const colIndex = this.columns.findIndex(col => col.key === colKey);
        const nextOffset = _toConsumableArray(this._columnOffset);
        const {
          startingWidth: currentWidth = 0
        } = nextOffset[colIndex];
        const {
          startingWidth: nextWidth = 0
        } = nextOffset[colIndex + 1];

        //Determine how much to offset column
        const totalOffset = nextWidth - xOffset <= MIN_CELL_WIDTH ? nextWidth - MIN_CELL_WIDTH : currentWidth + xOffset <= MIN_CELL_WIDTH ? MIN_CELL_WIDTH - currentWidth : xOffset;

        //Update offsets of col to resize, and the following col
        nextOffset[colIndex].xOffset = totalOffset;
        nextOffset[colIndex + 1].xOffset = -totalOffset;
        this._columnOffset = nextOffset;
      }
    }, {
      key: "_handleColumnResizeComplete",
      value: function _handleColumnResizeComplete(colKey) {
        const nextColumns = this._columnOffset.map((offset, i) => {
          const col = this.columns[i];
          const nextCol = _objectSpread2$1(_objectSpread2$1({}, col), {}, {
            width: offset.startingWidth + (offset.xOffset || 0)
          });
          return nextCol;
        });
        this._columnOffset = null;
        this.columns = nextColumns;
      }
    }, {
      key: "_renderTableData",
      value: function _renderTableData(data) {
        return data.map(datum => this._renderRow(datum));
      }

      // this is written as a separate function in the case we want to scroll-to in the future
    }, {
      key: "scrollToHighlightedRow",
      value: function scrollToHighlightedRow() {
        const row = this.shadowRoot.querySelector(`#row-${this.highlightedRow}`);
        if (!!row) row.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }, {
      key: "render",
      value: function render() {
        const data = this._flattenedData.slice(0, this._rowOffset + this._visibleRowCount) || [];
        const hasData = data.length > 0;
        const isLoading = this.isLoading;
        const fill = isLoading || !hasData;
        // if isLoading, show spinner
        // if !hasData, show empty message
        // show data
        return html$1`
      <iron-scroll-threshold
        id="${`unity-table-${this._tableId}`}"
        class="container"
      >
        <table>
          ${!this.headless ? this._renderTableHeader(this.columns, this._columnOffset) : null}
          ${fill ? isLoading ? html$1`<paper-spinner-lite active class="spinner center" />` : html$1`<div class="center">${this.emptyDisplay}</div>` : this._renderTableData(data)}
        </table>
      </iron-scroll-threshold>
    `;
      }

      // styles
    }], [{
      key: "properties",
      get: function () {
        return {
          keyExtractor: {
            type: Function
          },
          slotIdExtractor: {
            type: Function
          },
          data: {
            type: Array
          },
          columns: {
            type: Array
          },
          headless: {
            type: Boolean
          },
          compact: {
            type: Boolean
          },
          selectable: {
            type: Boolean
          },
          isLoading: {
            type: Boolean
          },
          emptyDisplay: {
            type: String
          },
          childKeys: {
            type: Array
          },
          filter: {
            type: String
          },
          onSelectionChange: {
            type: Function
          },
          selected: {
            type: Array
          },
          onClickRow: {
            type: Function
          },
          onExpandedChange: {
            type: Function
          },
          onDisplayColumnsChange: {
            type: Function
          },
          onHighlight: {
            type: Function
          },
          highlightedRow: {
            type: String
          },
          startExpanded: {
            type: Boolean
          },
          disableColumnResize: {
            type: Boolean
          },
          disableInternalSort: {
            type: Boolean
          },
          initialSortBy: {
            type: Object
          },
          // internals, tracking for change
          _allSelected: {
            type: Boolean
          },
          _rowOffset: {
            type: Number
          },
          isFlat: {
            type: false
          },
          hasIcons: {
            type: false
          },
          _columnOffset: {
            type: false
          },
          // TBI
          // controls: { type: Boolean },
          // onSearchFilter: { type: Function },
          onColumnSort: {
            type: Function
          },
          onEndReached: {
            type: Function
          },
          onColumnChange: {
            type: Function
          },
          onColumnFilter: {
            type: Function
          },
          //Expose this internal variable as a property for the table csv downloader to access
          _flattenedData: {
            type: Array
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          height: 100%;
          width: 100%;
          font-family: var(--font-family, var(--default-font-family));
          font-size: var(--paragraph-font-size, var(--default-paragraph-font-size));
          font-weight: var(--paragraph-font-weight, var(--default-paragraph-font-weight));
          color: var(--dark-gray-color, var(--default-dark-gray-color));
          border-collapse: collapse;
          --paper-spinner-color: var(--primary-color, var(--default-primary-color));
          --thead-height: 36px;
          --thead-compact-height: 24px;
          --trow-height: 36px;
          --trow-compact-height:  24px;
          --default-hover-color: var(--primary-tint-1-color, var(--default-primary-tint-1-color));
          --default-highlight-color: var(--default-primary-tint-1-color, var(--default-primary-tint-1-color));
          --default-hover-highlight-color: var(--primary-tint-2-color, var(--default-primary-tint-2-color));
          --paper-icon-button-ink-color: transparent;
          --padding-small: var(--padding-size-sm, var(--default-padding-size-sm));
          --padding-medium: var(--padding-size-md, var(--default-padding-size-md));
          --padding-large: var(--padding-size-lg, var(--default-padding-size-lg));
          --padding-extra-large: var(--padding-size-xl, var(--default-padding-size-xl));
          --margin-medium: var(--margin-size-md, var(--default-margin-size-md));
          --header-text-color: var(--black-color, var(--default-black-color));
          --separator-color: var(--light-gray-1-color, var(--default-light-gray-1-color));
          --filter-button-color: var(--black-color, var(--default-black-color));
          --sort-button-color: var(--black-color, var(--default-black-color));
          display: flex;
          height: 100%;
          flex: 1;
          min-height: 0;
        }
        .container {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        table {
          flex: 0 1 auto;
          min-height: 0;
          width: 100%;
          max-width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
          border-spacing: 0;
          box-sizing: border-box;
          overflow: auto;
          border-bottom: 1px solid var(--separator-color);
        }
        .fullspace {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          overflow: hidden;
          bottom: 0;
        }
        .center {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        paper-spinner-lite {
          width: 56px;
          height: 56px;
        }
        thead {
          width: 100%;
          z-index: 3;
        }
        th {
          position: sticky;
          top: 0;
          font-weight: var(--paragraph-font-weight, var(--default-paragraph-font-weight));
          text-align: left;
          padding: 0;
          margin: 0;
          border-collapse: collapse;
          z-index: 3;
          background-color: inherit;
          color: var(--header-text-color);
        }
        th.cell {
          overflow: visible;
        }
        .header {
          display: flex;
          width: 100%;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin: 0;
          padding-left: var(--padding-medium);
          box-sizing: border-box;
          border-collapse: collapse;
          border-bottom: 1px solid var(--separator-color);
          height: var(--thead-height);
        }
        .header.compact {
          height: var(--thead-compact-height);
        }
        .header.centered {
          padding-left: 0;
        }
        .header-right-actions::slotted(*){
          position: absolute;
          right: 0;
          background-color: var(--background-color, var(--default-background-color));
        }
        tr {
          width: 100%;
          table-layout: fixed;
        }
        td {
          padding: 0;
          border-top: 0;
          border-collapse: collapse;
        }
        .cell {
          border-collapse: collapse;
          white-space: nowrap;
        }
        .text {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .header-content {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          flex: 1;
        }
        .header-content.centered {
          justify-content: center;
        }
        .header-label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        unity-checkbox {
          margin-right: var(--margin-medium);
          z-index: 2;
        }
        .select-row-wrapper {
          width: 28px;
        }
        .select-row-checkbox {
          margin: auto;
          width: 16px;
          margin-left: var(--margin-medium);
        }
        paper-icon-button {
          width: 33px;
          height: 33px;
        }
        .flipped {
          transform: rotate(180deg);
        }
        .row {
          height: var(--trow-height);
          line-height: var(--trow-height);
          border-collapse: collapse;
          background-color: var(--background-color, var(--default-background-color));
          border-bottom: 1px solid var(--separator-color);
        }
        .row.clickable {
          cursor: pointer;
        }
        .row.compact {
          height: var(--trow-compact-height);
          line-height: var(--trow-compact-height);
        }
        .row:hover {
          background-color: var(--hover-color, var(--default-hover-color));
        }
        .row.highlight {
          background-color: var(--highlight-color, var(--default-highlight-color));
        }
        .row.highlight:hover {
          background-color: var(--hover-highlight-color, var(--default-hover-highlight-color));
        }
        .sticky-header-row {
          height: var(--thead-height);
          line-height: var(--thead-height);
          border-collapse: collapse;
          cursor: pointer;
          background-color: var(--background-color, var(--default-background-color));
        }
        .sticky-header-row.compact {
          height: var(--thead-compact-height);
          line-height: var(--thead-compact-height);
        }
        paper-icon-button.header-sort-icon {
          position: relative;
          height: 18px;
          width: 18px;
          padding: 0;
          color: var(--sort-button-color);
        }
        .active-filters {
          text-align: right;
          margin-right: 8px;
          overflow: auto;
          min-height: 49px;
          max-height: 49px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .filter-container {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 8px;
        }
      `];
      }
    }]);
    return UnityTable;
  }(LitElement);
  window.customElements.define('unity-table', UnityTable);

  /**
   * Renders a clickable switch icon that toggles between on and off / true and false
   * @name UnityToggleSwitch
   * @param {bool} value, true/false value of the switch
   * @param {''} label, string label above switch
   * @param {''} onLabel, string for label on 'on' side, right
   * @param {''} offLabel, string for label on 'off' side, left
   * @param {''} remark, string for comment under the switch
   * @param {bool} disabled, whether the switch should be disabled or not
   * @param {func} onChange, function for responding to change, receives true/false
   * @example
   * <unity-toggle-switch
   *   .label="${"Valve"}"
   *   ?value="${true}"
   *   .onLabel="${"Open"}"
   *   .offLabel="${"Closed"}"
   *   .onChange="${report}"
   *   .remark="${Whether water is running through the valve.}"
   * ></unity-toggle-switch>
   *
   * CSS variables:
   * --color: switch color
   * --size: switch size, used for both width and height to maintain proportions
   * --on-color: color for 'on' label
   * --off-color: color for 'off' label
   **/
  let UnityToggleSwitch = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityToggleSwitch, _LitElement);
    var _super = _createSuper(UnityToggleSwitch);
    function UnityToggleSwitch() {
      var _this;
      _classCallCheck(this, UnityToggleSwitch);
      _this = _super.call(this);
      _this.value = false;
      _this.label = '';
      _this.onLabel = '';
      _this.offLabel = '';
      _this.remark = '';
      _this.disabled = false;
      _this.onChange = () => {};
      return _this;
    }
    _createClass(UnityToggleSwitch, [{
      key: "toggle",
      value: function toggle() {
        if (!this.disabled) {
          const next = !this.value;
          this.onChange(next);
          this.value = next;
        }
      }
    }, {
      key: "render",
      value: function render() {
        const {
          value,
          label,
          onLabel,
          offLabel,
          remark,
          disabled,
          toggle
        } = this;
        const switchMode = `unity:toggle_${value ? 'on' : 'off'}`;
        return html$1`
      <div class="wrapper">
        ${label ? html$1`<unity-typography size="paragraph" color="dark" class="label">
          ${label}
        </unity-typography>` : null}
        <div class="switch-container">
          ${offLabel ? html$1`<unity-typography size="paragraph" class="off-label switch">
            ${offLabel}
          </unity-typography>` : null}
          <iron-icon class="switch toggle${disabled ? ' disabled' : ''}" icon="${switchMode}" @click="${toggle}"></iron-icon>
          ${onLabel ? html$1`<unity-typography size="paragraph" class="on-label switch">
            ${onLabel}
          </unity-typography>` : null}
        </div>
        ${remark ? html$1`<unity-typography size="paragraph" color="dark" class="remark">
          ${remark}
        </unity-typography>` : null}
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          value: {
            type: Boolean
          },
          label: {
            type: String
          },
          onLabel: {
            type: String
          },
          offLabel: {
            type: String
          },
          remark: {
            type: String
          },
          disabled: {
            type: Boolean
          },
          onChange: {
            type: Function
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --color: var(--switch-color, var(--default-primary-brand-color));
          --size: var(--switch-size, 24px);
          --on-color: var(--on-label-color, var(--default-black-text-color));
          --off-color: var(--off-label-color, var(--default-black-text-color));
          display: inline-block;
          user-select: none;
        }
        .wrapper {
          display: flex;
          flex: 1;
          flex-direction: column;
        }
        .switch-container {
          white-space: nowrap;
        }
        .switch {
          display: inline-block;
          align-self: center;
        }
        .off-label {
          --font-color: var(--off-color);
        }
        .on-label {
          --font-color: var(--on-color);
        }
        .toggle {
          flex: 0;
          flex-basis: auto;
          padding: 0 6px;
          height: var(--size);
          width: var(--size);
          cursor: pointer;
          color: var(--color);
        }
        iron-icon.disabled {
          color: var(--dark-grey-background-color, var(--default-dark-grey-background-color));
        }
      `];
      }
    }]);
    return UnityToggleSwitch;
  }(LitElement);
  window.customElements.define('unity-toggle-switch', UnityToggleSwitch);

  /**
  * Renders a utility belt tab for use inside utility belt component
  * @name UnityUtilityBelt
  * @param {''} name - title of tab
  * @param {false} selected - boolean if tab is selected
  * @param {0} index - index of tab in utility-belt



  * @example
  * <utility-belt-tab>
  *   name="tab name"
  *   id="tabId"
  *.  index=0
  * ></utility-belt-tab>

  css vars
    tab-width
    tab-height
    selected-tab-background
  **/
  let UtilityBeltTab = /*#__PURE__*/function (_LitElement) {
    _inherits(UtilityBeltTab, _LitElement);
    var _super = _createSuper(UtilityBeltTab);
    function UtilityBeltTab() {
      var _this;
      _classCallCheck(this, UtilityBeltTab);
      _this = _super.call(this);
      _this.name = '';
      _this.id = '';
      _this.selected = false;
      _this.icon = '';
      _this.index = 0;
      _this.onClose = () => {};
      return _this;
    }
    _createClass(UtilityBeltTab, [{
      key: "handleClose",
      value: function handleClose(e) {
        //Prevent tab @click event from firing
        e.stopPropagation();
        this.onClose(this.id);
      }
    }, {
      key: "getTabClasses",
      value: function getTabClasses() {
        const {
          index,
          selected
        } = this;
        let tabClasses = 'utility-belt-tab';
        if (selected) {
          tabClasses = `${tabClasses} selected-tab`;
        }
        return tabClasses;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          name,
          id,
          icon,
          index
        } = this;
        const tabClass = this.getTabClasses();
        return html$1`
      <div class="${tabClass}" id="utility-belt-tab-${index}">
        <div class="title-container">
          ${icon ? html$1`<unity-icon icon="${icon}"></unity-icon>` : null}
          <unity-typography class="tab-name">${name}</unity-typography>
        </div>
        <unity-button
          title="Close"
          class="utility-belt-tab-close-button"
          id="utility-belt-tab-close-button-${index}"
          centerIcon="close"
          type="borderless"
          @click=${this.handleClose}
        ></unity-button>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          name: {
            type: String
          },
          id: {
            type: String
          },
          selected: {
            type: Boolean
          },
          icon: {
            type: String
          },
          index: {
            type: Number
          },
          onClose: {
            type: Function
          }
          // internals
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          --default-tab-width: 140px;
          --default-tab-height: 20px;
          --default-selected-tab-background: var(--default-light-gray-1-color);
          --default-tab-border-color: var(--default-dark-gray-2-color);
        }
        .utility-belt-tab {
          width: var(--tab-width, var(--default-tab-width));
          height: var(--tab-height, var(--default-tab-height));
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 0 0 8px;
          border-right: 1px solid var(--tab-border-color, var(--default-tab-border-color));
          overflow: hidden;
          cursor: pointer;
        }
        .selected-tab {
          background-color: var(--selected-tab-background, var(--default-selected-tab-background));
        }
        .title-container {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .tab-name {

        }
        unity-button {
          --background-color: none;
        }

      `];
      }
    }]);
    return UtilityBeltTab;
  }(LitElement);
  window.customElements.define('utility-belt-tab', UtilityBeltTab);

  // import '@bit/smartworks.unity.unity-icon'

  /**
  * Renders a utility belt UI for managing persistent tabs
  * @name UnityUtilityBelt
  * @param {[{name: '', id=''}]} tabs - array of tab config objects
  * @param {''} selectedTab - id of selected tab
  * @param {Function} onTabSelect - callback for when tab selection changes, selected tab id is argument
  * @param {Function} onTabClose - callback for when tab close button is clicked, closed tab id is argument


  * @example
  * <unity-utility-belt>
  *   .tabs="[{name: 'tab 1', id: 'tab1'}, {name: 'tab 2', id: 'tab2'}]"
  *   .selectedTab="tab1"
  * >
  *   <div slot="tab1">Content for tab 1</div>
  *   <div slot="tab2">Content for tab 2</div>
  *
  *   <div slot="right-actions">
  *     <unity-button label="Add"><unity-button>
  *   </div>
  * </unity-text-input>

  css vars
    --panel-z-index: z-index of panel divs
  **/
  let UnityUtilityBelt = /*#__PURE__*/function (_LitElement) {
    _inherits(UnityUtilityBelt, _LitElement);
    var _super = _createSuper(UnityUtilityBelt);
    function UnityUtilityBelt() {
      var _this;
      _classCallCheck(this, UnityUtilityBelt);
      _this = _super.call(this);
      _this.tabs = [];
      _this.selectedTab = '';
      _this.onTabSelect = () => {};
      _this.onTabClose = () => {};
      _this.resizable = true;

      // internals
      _this._selectedTab = '';
      _this._panelHeight = Math.floor(window.innerHeight / 3);
      _this._originalPaneHeight = _this._panelHeight;
      _this._startingY = 0;
      _this._headerHeight = 0;
      _this._footerHeight = 0;
      return _this;
    }
    _createClass(UnityUtilityBelt, [{
      key: "selectedTab",
      get: function () {
        return this._selectedTab;
      },
      set: function (selectedTab) {
        if (selectedTab !== this._selectedTab) {
          const oldValue = this._selectedTab;
          this._selectedTab = selectedTab;
          this.requestUpdate('selectedTab', oldValue);
          if (this.onTabSelect) {
            this.onTabSelect(selectedTab);
          }
        }
      }
    }, {
      key: "connectedCallback",
      value: async function connectedCallback() {
        _get(_getPrototypeOf(UnityUtilityBelt.prototype), "connectedCallback", this).call(this);
        await this.updateComplete;
        this.startObserver();
      }
    }, {
      key: "startObserver",
      value: function startObserver() {
        this.stopObserver();
        const referenceElement = this.shadowRoot.querySelector('.unity-utility-toolbelt');
        if (!!referenceElement) {
          this._observer = new ResizeObserver(_ref => {
            this._totalHeight = referenceElement.offsetHeight;
          });
          this._observer.observe(referenceElement);
        }
      }
    }, {
      key: "stopObserver",
      value: function stopObserver() {
        if (this._observer) this._observer.disconnect();
      }
    }, {
      key: "handleTabClick",
      value: async function handleTabClick(tab) {
        //if tab is already selected, unselect
        if (tab.id === this.selectedTab) {
          this.selectedTab = '';
        } else {
          this.selectedTab = tab.id;
        }
        await this.updateComplete;
        //reset panel height
        this.handleOneThirdOpen();
      }
    }, {
      key: "handleTabClose",
      value: function handleTabClose(id) {
        if (this.onTabClose) {
          this.onTabClose(id);
        }
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(e) {
        //Ignore right click
        if (e.button !== 0) return;
        this._startingY = e.clientY;
        this._originalPaneHeight = this._panelHeight || 0;
        this.mouseMoveListener = this.handleMouseMove.bind(this);
        this.mouseUpListener = this.handleMouseUp.bind(this);
        document.addEventListener('mousemove', this.mouseMoveListener);
        document.addEventListener('mouseup', this.mouseUpListener);
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        const deltaY = e.clientY - this._startingY;
        this._panelHeight;
        const MINIMUM_PANEL_HEIGHT = 0; //height of page header
        const MAXIMUM_PANEL_HEIGHT = this.getMaxPanelHeight();
        let nextHeight = this._originalPaneHeight - deltaY;
        if (nextHeight < MINIMUM_PANEL_HEIGHT) nextHeight = MINIMUM_PANEL_HEIGHT;
        if (nextHeight > MAXIMUM_PANEL_HEIGHT) nextHeight = MAXIMUM_PANEL_HEIGHT;
        this._panelHeight = nextHeight;

        //Prevent text highlighting while dragging
        e.preventDefault();
      }

      //clean up event listener
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp(e) {
        this._originalPaneHeight = this._panelHeight;
        document.removeEventListener('mousemove', this.mouseMoveListener);
        document.removeEventListener('mouseup', this.mouseUpListener);
      }
    }, {
      key: "handleExpand",
      value: function handleExpand() {
        this._panelHeight = this.getMaxPanelHeight();
      }
    }, {
      key: "handleOneThirdOpen",
      value: function handleOneThirdOpen() {
        this._panelHeight = Math.floor(this.getMaxPanelHeight() / 3);
      }
    }, {
      key: "setHeaderFooterHeights",
      value: function setHeaderFooterHeights() {
        const header = this.shadowRoot.querySelector('unity-page-header');
        const footer = this.shadowRoot.querySelector('.footer');
        if (header) this._headerHeight = header.offsetHeight || 32;
        if (footer) this._footerHeight = footer.offsetHeight || 22;
      }
    }, {
      key: "getMaxPanelHeight",
      value: function getMaxPanelHeight() {
        if (!this._headerHeight || !this._footerHeight) {
          this.setHeaderFooterHeights();
        }
        return this._totalHeight - this._headerHeight - this._footerHeight;
      }
    }, {
      key: "render",
      value: function render() {
        const {
          tabs = [],
          selectedTab = '',
          _panelHeight
        } = this;
        const selectedTabObj = selectedTab && tabs.find(tab => tab.id === selectedTab);
        const isPanelExpanded = this._panelHeight === this.getMaxPanelHeight();
        return html$1`
      <style>
        .panel-container {
          height: ${_panelHeight}px;
        }
        unity-page-header {
          border-top: ${isPanelExpanded ? 'none' : '1px solid var(--default-dark-gray-2-color)'};
        }
      </style>
      <div class="unity-utility-toolbelt" id="unity-utility-toolbelt">
        <div class="main">
          <slot name="main"></slot>
        </div>
        ${selectedTabObj ? html$1`
          <div id="panel" class="panel">
            <unity-page-header
              header="${selectedTabObj.header || ''}"
              @mousedown="${this.handleMouseDown}"
            >
              <slot name="left-content-${selectedTab}" slot="left-content"></slot>
              <slot name="left-action-${selectedTab}" slot="left-action"></slot>
              <unity-button
                title="${isPanelExpanded ? 'Shrink' : 'Expand'}"
                slot="right-action"
                id="utility-belt-panel-expand-collapse-button"
                type="borderless"
                centerIcon="${isPanelExpanded ? 'fullscreen-exit' : 'fullscreen'}"
                @click=${isPanelExpanded ? this.handleOneThirdOpen : this.handleExpand}
              ></unity-button>
              <unity-button
                title="Minimize"
                slot="right-action"
                id="utility-belt-panel-minimize-button"
                type="borderless"
                centerIcon="remove"
                @click=${e => this.handleTabClick(selectedTabObj)}
              ></unity-button>
              <unity-button
                title="Close"
                slot="right-action"
                id="utility-belt-panel-close-button"
                centerIcon="close"
                type="borderless"
                @click=${e => this.handleTabClose(selectedTab)}
              ></unity-button>
            </unity-page-header>
            <div class="panel-container">
              <slot name="pane-${selectedTab}"></slot>
            </div>
          </div>` : null}

        <div class="footer">
          <div class="tab-bar">
            ${tabs.map((tab, index) => {
        const isSelected = selectedTab === tab.id;
        return html$1`
                <utility-belt-tab
                  name="${tab.name}"
                  id="${tab.id}"
                  index=${index}
                  ?selected=${isSelected}
                  @click=${e => this.handleTabClick(tab)}
                  .onClose=${id => this.handleTabClose(id)}
                ></utility-belt-tab>`;
      })}
          </div>

          <slot name="right-actions"></slot>
        </div>
      </div>
    `;
      }
    }], [{
      key: "properties",
      get: function () {
        return {
          tabs: {
            type: Array
          },
          selectedTab: {
            type: String
          },
          onTabSelect: {
            type: Function
          },
          onTabClose: {
            type: Function
          },
          resizable: {
            type: Boolean
          },
          _panelHeight: {
            type: Number
          },
          // internals
          _selectedTab: {
            type: String
          }
        };
      }
    }, {
      key: "styles",
      get: function () {
        return [UnityDefaultThemeStyles, css$1`
        :host {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
          height: 100%;
          --default-bar-border-color: var(--default-dark-gray-2-color);
          --default-footer-background-color: var(--default-background-color);
          --default-panel-z-index: 5;
        }
        .unity-utility-toolbelt {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-height: 0;
        }
        .main {
          flex: 1;
          min-height: 0;
          display: flex;
          flex-direction: column;
        }

        .main ::slotted(*) {
          flex: 1;
          min-height: 0;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }
        .panel-container {
          overflow-y: auto;
        }

        .panel {
          z-index: var(--panel-z-index, var(--default-panel-z-index));
          background-color: var(--footer-background-color, var(--default-footer-background-color));
        }
        .footer {
          display: flex;
          z-index: 5;
          flex-direction: row;
          align-items: center;
          min-height: 0;
          border-top: 1px solid var(--bar-border-color, var(--default-bar-border-color));
          background-color: var(--footer-background-color, var(--default-footer-background-color));
        }
        .tab-bar {
          display: flex;
          overflow-y: auto;
          flex: 1;
        }

        unity-page-header {
          --page-header-font-size: 12px;
          cursor: ns-resize;
        }
      `];
      }
    }]);
    return UnityUtilityBelt;
  }(LitElement);
  window.customElements.define('unity-utility-belt', UnityUtilityBelt);

  exports.UnityDefaultThemeStyles = UnityDefaultThemeStyles;
  exports.addNotification = addNotification;
  exports.clearNotifications = clearNotifications;
  exports.closeNotification = closeNotification;
  exports.findMatches = findMatches;
  exports.getNextSibling = getNextSibling;
  exports.getNode = getNode;
  exports.getParent = getParent;
  exports.getPrevSibling = getPrevSibling;
  exports.isElement = isElement;
  exports.isWhitespace = isWhitespace;
  exports.styleToString = styleToString;
  exports.trimWhitespace = trimWhitespace;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
